/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 444);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(655);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(34);
var hide = __webpack_require__(25);
var redefine = __webpack_require__(26);
var ctx = __webpack_require__(35);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module, process) {/* unused harmony export Accordion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* unused harmony export AlertCircleIcon */
/* unused harmony export AlertCircleIconV2 */
/* unused harmony export AlertTriangleIcon */
/* unused harmony export AppSelectIconV2 */
/* unused harmony export ArchiveIcon */
/* unused harmony export ArrowIcon */
/* unused harmony export Autocomplete */
/* unused harmony export Avatar */
/* unused harmony export Badge */
/* unused harmony export BellFillIcon */
/* unused harmony export BellIcon */
/* unused harmony export BookmarkIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Box; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Button$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonLink; });
/* unused harmony export CalendarIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Cancel$2; });
/* unused harmony export CaretIcon */
/* unused harmony export ChatIcon */
/* unused harmony export CheckCircleIcon */
/* unused harmony export CheckIcon */
/* unused harmony export Checkbox */
/* unused harmony export ChevronIcon */
/* unused harmony export ChevronV2 */
/* unused harmony export CloseButton */
/* unused harmony export Code */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Col; });
/* unused harmony export Collapse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Container$h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CookieBanner; });
/* unused harmony export CopyIcon */
/* unused harmony export DatePicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DefaultCookiePolicy; });
/* unused harmony export DiagonalDividerHorizontal */
/* unused harmony export DiagonalDividerVertical */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Dialog$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DigitalDiariesLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DigitalInterviewsLogo; });
/* unused harmony export DiscIcon */
/* unused harmony export DownloadIcon */
/* unused harmony export Drawer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Dropdown; });
/* unused harmony export DropdownMenu */
/* unused harmony export EditIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ExternalButtonLink; });
/* unused harmony export ExternalLinkIcon */
/* unused harmony export ExternalLinkIconV2 */
/* unused harmony export FeatherSVG */
/* unused harmony export FileIcon */
/* unused harmony export FilePlusIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return index$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ForstaLogo; });
/* unused harmony export GlobalHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Grid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return Hamburger; });
/* unused harmony export HashIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return HeaderAvatar; });
/* unused harmony export HelpIcon */
/* unused harmony export HelpIconV2 */
/* unused harmony export HomeIcon */
/* unused harmony export ImageIcon */
/* unused harmony export InfoIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return Input$1; });
/* unused harmony export InterVuLogo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return Key; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LayoutSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LayoutWithStandardHeader; });
/* unused harmony export LayoutWithVertical */
/* unused harmony export ListBox */
/* unused harmony export LiveVideoLogo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return Loader$2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return Lock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return Lock$1; });
/* unused harmony export MaximizeIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MediaQuery; });
/* unused harmony export MinimizeIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MobileFiendly; });
/* unused harmony export Modal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return Modal; });
/* unused harmony export MoreIcon */
/* unused harmony export Navbar */
/* unused harmony export NavbarSecondary */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return Notifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return NotificationsProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PanelManagementLogo; });
/* unused harmony export PlayIcon */
/* unused harmony export PlusIcon */
/* unused harmony export Popover */
/* unused harmony export QuestionMarkCircleIcon */
/* unused harmony export RadioButton */
/* unused harmony export RefreshIcon */
/* unused harmony export RotateIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return Row$2; });
/* unused harmony export SaveIcon */
/* unused harmony export SearchIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SecondaryLink; });
/* unused harmony export SettingsIcon */
/* unused harmony export ShareIcon */
/* unused harmony export SlashIcon */
/* unused harmony export SortIcon */
/* unused harmony export StarIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SurveysLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SwitchInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return Table$1; });
/* unused harmony export TableV2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return Tabs; });
/* unused harmony export Tag */
/* unused harmony export TagInput */
/* unused harmony export Textarea */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return Theme; });
/* unused harmony export ThumbIcon */
/* unused harmony export Tooltip */
/* unused harmony export TrashIcon */
/* unused harmony export UploadIcon */
/* unused harmony export Uploader */
/* unused harmony export UserIcon */
/* unused harmony export UserPlusIcon */
/* unused harmony export UsersIcon */
/* unused harmony export VIStreamlineLogo */
/* unused harmony export VideoInsightsLegacyLogo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return VideoInsightsLogo; });
/* unused harmony export WithBadge */
/* unused harmony export borderBottomLeftRadius */
/* unused harmony export borderBottomRightRadius */
/* unused harmony export borderRadius */
/* unused harmony export borderTopLeftRadius */
/* unused harmony export borderTopRightRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return color; });
/* unused harmony export createStaticDataSource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return fontWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return global$1; });
/* unused harmony export gradientEnd */
/* unused harmony export gradientStart */
/* unused harmony export margin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return mediaDn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return mediaUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return padding; });
/* unused harmony export rem */
/* unused harmony export responsiveContainer */
/* unused harmony export shadow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return spacer; });
/* unused harmony export style */
/* unused harmony export theme */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return transparentize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return typography$1; });
/* unused harmony export useCombobox */
/* unused harmony export useMultipleSelection */
/* unused harmony export useNotifications */
/* unused harmony export usePopper */
/* unused harmony export useSelect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return withNotifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion_theming__ = __webpack_require__(341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dropzone__ = __webpack_require__(733);
var _templateObject;function _toArray(r){return _arrayWithHoles(r)||_iterableToArray(r)||_unsupportedIterableToArray(r)||_nonIterableRest();}function _superPropGet(t,o,e,r){var p=_get(_getPrototypeOf(1&r?t.prototype:t),o,e);return 2&r&&"function"==typeof p?function(t){return p.apply(e,t);}:p;}function _get(){return _get="undefined"!=typeof Reflect&&Reflect.get?Reflect.get.bind():function(e,t,r){var p=_superPropBase(e,t);if(p){var n=Object.getOwnPropertyDescriptor(p,t);return n.get?n.get.call(arguments.length<3?e:r):n.value;}},_get.apply(null,arguments);}function _superPropBase(t,o){for(;!{}.hasOwnProperty.call(t,o)&&null!==(t=_getPrototypeOf(t)););return t;}function _defineProperty2(e,r,t){return(r=_toPropertyKey(r))in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e;}function _readOnlyError(r){throw new TypeError('"'+r+'" is read-only');}function _regeneratorRuntime(){"use strict";var r=_regenerator(),e=r.m(_regeneratorRuntime),t=(Object.getPrototypeOf?Object.getPrototypeOf(e):e.__proto__).constructor;function n(r){var e="function"==typeof r&&r.constructor;return!!e&&(e===t||"GeneratorFunction"===(e.displayName||e.name));}var o={"throw":1,"return":2,"break":3,"continue":3};function a(r){var e,t;return function(n){e||(e={stop:function stop(){return t(n.a,2);},"catch":function _catch(){return n.v;},abrupt:function abrupt(r,e){return t(n.a,o[r],e);},delegateYield:function delegateYield(r,o,a){return e.resultName=o,t(n.d,_regeneratorValues(r),a);},finish:function finish(r){return t(n.f,r);}},t=function t(r,_t3,o){n.p=e.prev,n.n=e.next;try{return r(_t3,o);}finally{e.next=n.n;}}),e.resultName&&(e[e.resultName]=n.v,e.resultName=void 0),e.sent=n.v,e.next=n.n;try{return r.call(this,e);}finally{n.p=e.prev,n.n=e.next;}};}return(_regeneratorRuntime=function _regeneratorRuntime(){return{wrap:function wrap(e,t,n,o){return r.w(a(e),t,n,o&&o.reverse());},isGeneratorFunction:n,mark:r.m,awrap:function awrap(r,e){return new _OverloadYield(r,e);},AsyncIterator:_regeneratorAsyncIterator,async:function async(r,e,t,o,u){return(n(e)?_regeneratorAsyncGen:_regeneratorAsync)(a(r),e,t,o,u);},keys:_regeneratorKeys,values:_regeneratorValues};})();}function _regeneratorValues(e){if(null!=e){var t=e["function"==typeof Symbol&&Symbol.iterator||"@@iterator"],r=0;if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length))return{next:function next(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e};}};}throw new TypeError(_typeof2(e)+" is not iterable");}function _regeneratorKeys(e){var n=Object(e),r=[];for(var t in n)r.unshift(t);return function e(){for(;r.length;)if((t=r.pop())in n)return e.value=t,e.done=!1,e;return e.done=!0,e;};}function _regeneratorAsync(n,e,r,t,o){var a=_regeneratorAsyncGen(n,e,r,t,o);return a.next().then(function(n){return n.done?n.value:a.next();});}function _regeneratorAsyncGen(r,e,t,o,n){return new _regeneratorAsyncIterator(_regenerator().w(r,e,t,o),n||Promise);}function _regeneratorAsyncIterator(t,e){function n(r,o,i,f){try{var c=t[r](o),u=c.value;return u instanceof _OverloadYield?e.resolve(u.v).then(function(t){n("next",t,i,f);},function(t){n("throw",t,i,f);}):e.resolve(u).then(function(t){c.value=t,i(c);},function(t){return n("throw",t,i,f);});}catch(t){f(t);}}var r;this.next||(_regeneratorDefine2(_regeneratorAsyncIterator.prototype),_regeneratorDefine2(_regeneratorAsyncIterator.prototype,"function"==typeof Symbol&&Symbol.asyncIterator||"@asyncIterator",function(){return this;})),_regeneratorDefine2(this,"_invoke",function(t,o,i){function f(){return new e(function(e,r){n(t,i,e,r);});}return r=r?r.then(f,f):f();},!0);}function _regenerator(){/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,t,r="function"==typeof Symbol?Symbol:{},n=r.iterator||"@@iterator",o=r.toStringTag||"@@toStringTag";function i(r,n,o,i){var c=n&&n.prototype instanceof Generator?n:Generator,u=Object.create(c.prototype);return _regeneratorDefine2(u,"_invoke",function(r,n,o){var i,c,u,f=0,p=o||[],y=!1,G={p:0,n:0,v:e,a:d,f:d.bind(e,4),d:function d(t,r){return i=t,c=0,u=e,G.n=r,a;}};function d(r,n){for(c=r,u=n,t=0;!y&&f&&!o&&t<p.length;t++){var o,i=p[t],d=G.p,l=i[2];r>3?(o=l===n)&&(u=i[(c=i[4])?5:(c=3,3)],i[4]=i[5]=e):i[0]<=d&&((o=r<2&&d<i[1])?(c=0,G.v=n,G.n=i[1]):d<l&&(o=r<3||i[0]>n||n>l)&&(i[4]=r,i[5]=n,G.n=l,c=0));}if(o||r>1)return a;throw y=!0,n;}return function(o,p,l){if(f>1)throw TypeError("Generator is already running");for(y&&1===p&&d(p,l),c=p,u=l;(t=c<2?e:u)||!y;){i||(c?c<3?(c>1&&(G.n=-1),d(c,u)):G.n=u:G.v=u);try{if(f=2,i){if(c||(o="next"),t=i[o]){if(!(t=t.call(i,u)))throw TypeError("iterator result is not an object");if(!t.done)return t;u=t.value,c<2&&(c=0);}else 1===c&&(t=i["return"])&&t.call(i),c<2&&(u=TypeError("The iterator does not provide a '"+o+"' method"),c=1);i=e;}else if((t=(y=G.n<0)?u:r.call(n,G))!==a)break;}catch(t){i=e,c=1,u=t;}finally{f=1;}}return{value:t,done:y};};}(r,o,i),!0),u;}var a={};function Generator(){}function GeneratorFunction(){}function GeneratorFunctionPrototype(){}t=Object.getPrototypeOf;var c=[][n]?t(t([][n]())):(_regeneratorDefine2(t={},n,function(){return this;}),t),u=GeneratorFunctionPrototype.prototype=Generator.prototype=Object.create(c);function f(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,GeneratorFunctionPrototype):(e.__proto__=GeneratorFunctionPrototype,_regeneratorDefine2(e,o,"GeneratorFunction")),e.prototype=Object.create(u),e;}return GeneratorFunction.prototype=GeneratorFunctionPrototype,_regeneratorDefine2(u,"constructor",GeneratorFunctionPrototype),_regeneratorDefine2(GeneratorFunctionPrototype,"constructor",GeneratorFunction),GeneratorFunction.displayName="GeneratorFunction",_regeneratorDefine2(GeneratorFunctionPrototype,o,"GeneratorFunction"),_regeneratorDefine2(u),_regeneratorDefine2(u,o,"Generator"),_regeneratorDefine2(u,n,function(){return this;}),_regeneratorDefine2(u,"toString",function(){return"[object Generator]";}),(_regenerator=function _regenerator(){return{w:i,m:f};})();}function _regeneratorDefine2(e,r,n,t){var i=Object.defineProperty;try{i({},"",{});}catch(e){i=0;}_regeneratorDefine2=function _regeneratorDefine(e,r,n,t){function o(r,n){_regeneratorDefine2(e,r,function(e){return this._invoke(r,n,e);});}r?i?i(e,r,{value:n,enumerable:!t,configurable:!t,writable:!t}):e[r]=n:(o("next",0),o("throw",1),o("return",2));},_regeneratorDefine2(e,r,n,t);}function _OverloadYield(e,d){this.v=e,this.k=d;}function _classCallCheck3(a,n){if(!(a instanceof n))throw new TypeError("Cannot call a class as a function");}function _defineProperties(e,r){for(var t=0;t<r.length;t++){var o=r[t];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,_toPropertyKey(o.key),o);}}function _createClass3(e,r,t){return r&&_defineProperties(e.prototype,r),t&&_defineProperties(e,t),Object.defineProperty(e,"prototype",{writable:!1}),e;}function _toPropertyKey(t){var i=_toPrimitive(t,"string");return"symbol"==_typeof2(i)?i:i+"";}function _toPrimitive(t,r){if("object"!=_typeof2(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof2(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===r?String:Number)(t);}function _callSuper(t,o,e){return o=_getPrototypeOf(o),_possibleConstructorReturn3(t,_isNativeReflectConstruct()?Reflect.construct(o,e||[],_getPrototypeOf(t).constructor):o.apply(t,e));}function _possibleConstructorReturn3(t,e){if(e&&("object"==_typeof2(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return _assertThisInitialized2(t);}function _assertThisInitialized2(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;}function _isNativeReflectConstruct(){try{var t=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));}catch(t){}return(_isNativeReflectConstruct=function _isNativeReflectConstruct(){return!!t;})();}function _getPrototypeOf(t){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t);},_getPrototypeOf(t);}function _inherits3(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&_setPrototypeOf(t,e);}function _setPrototypeOf(t,e){return _setPrototypeOf=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t;},_setPrototypeOf(t,e);}function _slicedToArray(r,e){return _arrayWithHoles(r)||_iterableToArrayLimit(r,e)||_unsupportedIterableToArray(r,e)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _iterableToArrayLimit(r,l){var t=null==r?null:"undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(null!=t){var e,n,i,u,a=[],f=!0,o=!1;try{if(i=(t=t.call(r)).next,0===l){if(Object(t)!==t)return;f=!1;}else for(;!(f=(e=i.call(t)).done)&&(a.push(e.value),a.length!==l);f=!0);}catch(r){o=!0,n=r;}finally{try{if(!f&&null!=t["return"]&&(u=t["return"](),Object(u)!==u))return;}finally{if(o)throw n;}}return a;}}function _arrayWithHoles(r){if(Array.isArray(r))return r;}function _taggedTemplateLiteral(e,t){return t||(t=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}));}function _toConsumableArray(r){return _arrayWithoutHoles(r)||_iterableToArray(r)||_unsupportedIterableToArray(r)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _iterableToArray(r){if("undefined"!=typeof Symbol&&null!=r[Symbol.iterator]||null!=r["@@iterator"])return Array.from(r);}function _arrayWithoutHoles(r){if(Array.isArray(r))return _arrayLikeToArray(r);}function _typeof2(o){"@babel/helpers - typeof";return _typeof2="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof2(o);}function _createForOfIteratorHelper(r,e){var t="undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(!t){if(Array.isArray(r)||(t=_unsupportedIterableToArray(r))||e&&r&&"number"==typeof r.length){t&&(r=t);var _n2=0,F=function F(){};return{s:F,n:function n(){return _n2>=r.length?{done:!0}:{done:!1,value:r[_n2++]};},e:function e(r){throw r;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var o,a=!0,u=!1;return{s:function s(){t=t.call(r);},n:function n(){var r=t.next();return a=r.done,r;},e:function e(r){u=!0,o=r;},f:function f(){try{a||null==t["return"]||t["return"]();}finally{if(u)throw o;}}};}function _unsupportedIterableToArray(r,a){if(r){if("string"==typeof r)return _arrayLikeToArray(r,a);var t={}.toString.call(r).slice(8,-1);return"Object"===t&&r.constructor&&(t=r.constructor.name),"Map"===t||"Set"===t?Array.from(r):"Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)?_arrayLikeToArray(r,a):void 0;}}function _arrayLikeToArray(r,a){(null==a||a>r.length)&&(a=r.length);for(var e=0,n=Array(a);e<a;e++)n[e]=r[e];return n;}var __defProp=Object.defineProperty;var __defProps=Object.defineProperties;var __getOwnPropDescs=Object.getOwnPropertyDescriptors;var __getOwnPropSymbols=Object.getOwnPropertySymbols;var __hasOwnProp=Object.prototype.hasOwnProperty;var __propIsEnum=Object.prototype.propertyIsEnumerable;var __defNormalProp=function __defNormalProp(obj,key2,value){return key2 in obj?__defProp(obj,key2,{enumerable:true,configurable:true,writable:true,value:value}):obj[key2]=value;};var __spreadValues=function __spreadValues(a,b2){for(var prop2 in b2||(b2={}))if(__hasOwnProp.call(b2,prop2))__defNormalProp(a,prop2,b2[prop2]);if(__getOwnPropSymbols){var _iterator=_createForOfIteratorHelper(__getOwnPropSymbols(b2)),_step;try{for(_iterator.s();!(_step=_iterator.n()).done;){var prop2=_step.value;if(__propIsEnum.call(b2,prop2))__defNormalProp(a,prop2,b2[prop2]);}}catch(err){_iterator.e(err);}finally{_iterator.f();}}return a;};var __spreadProps=function __spreadProps(a,b2){return __defProps(a,__getOwnPropDescs(b2));};var __objRest=function __objRest(source,exclude){var target={};for(var prop2 in source)if(__hasOwnProp.call(source,prop2)&&exclude.indexOf(prop2)<0)target[prop2]=source[prop2];if(source!=null&&__getOwnPropSymbols){var _iterator2=_createForOfIteratorHelper(__getOwnPropSymbols(source)),_step2;try{for(_iterator2.s();!(_step2=_iterator2.n()).done;){var prop2=_step2.value;if(exclude.indexOf(prop2)<0&&__propIsEnum.call(source,prop2))target[prop2]=source[prop2];}}catch(err){_iterator2.e(err);}finally{_iterator2.f();}}return target;};var __publicField=function __publicField(obj,key2,value){__defNormalProp(obj,_typeof2(key2)!=="symbol"?key2+"":key2,value);return value;};var commonjsGlobal=typeof globalThis!=="undefined"?globalThis:typeof window!=="undefined"?window:typeof global!=="undefined"?global:typeof self!=="undefined"?self:{};function getDefaultExportFromCjs(x){return x&&x.__esModule&&Object.prototype.hasOwnProperty.call(x,"default")?x["default"]:x;}(function(module2,exports){(function(global2,factory){factory();})(commonjsGlobal,function(){function applyFocusVisiblePolyfill(scope){var hadKeyboardEvent=true;var hadFocusVisibleRecently=false;var hadFocusVisibleRecentlyTimeout=null;var inputTypesAllowlist={text:true,search:true,url:true,tel:true,email:true,password:true,number:true,date:true,month:true,week:true,time:true,datetime:true,"datetime-local":true};function isValidFocusTarget(el){if(el&&el!==document&&el.nodeName!=="HTML"&&el.nodeName!=="BODY"&&"classList"in el&&"contains"in el.classList){return true;}return false;}function focusTriggersKeyboardModality(el){var type=el.type;var tagName=el.tagName;if(tagName==="INPUT"&&inputTypesAllowlist[type]&&!el.readOnly){return true;}if(tagName==="TEXTAREA"&&!el.readOnly){return true;}if(el.isContentEditable){return true;}return false;}function addFocusVisibleClass(el){if(el.classList.contains("focus-visible")){return;}el.classList.add("focus-visible");el.setAttribute("data-focus-visible-added","");}function removeFocusVisibleClass(el){if(!el.hasAttribute("data-focus-visible-added")){return;}el.classList.remove("focus-visible");el.removeAttribute("data-focus-visible-added");}function onKeyDown(e2){if(e2.metaKey||e2.altKey||e2.ctrlKey){return;}if(isValidFocusTarget(scope.activeElement)){addFocusVisibleClass(scope.activeElement);}hadKeyboardEvent=true;}function onPointerDown(e2){hadKeyboardEvent=false;}function onFocus(e2){if(!isValidFocusTarget(e2.target)){return;}if(hadKeyboardEvent||focusTriggersKeyboardModality(e2.target)){addFocusVisibleClass(e2.target);}}function onBlur(e2){if(!isValidFocusTarget(e2.target)){return;}if(e2.target.classList.contains("focus-visible")||e2.target.hasAttribute("data-focus-visible-added")){hadFocusVisibleRecently=true;window.clearTimeout(hadFocusVisibleRecentlyTimeout);hadFocusVisibleRecentlyTimeout=window.setTimeout(function(){hadFocusVisibleRecently=false;},100);removeFocusVisibleClass(e2.target);}}function onVisibilityChange(e2){if(document.visibilityState==="hidden"){if(hadFocusVisibleRecently){hadKeyboardEvent=true;}addInitialPointerMoveListeners();}}function addInitialPointerMoveListeners(){document.addEventListener("mousemove",onInitialPointerMove);document.addEventListener("mousedown",onInitialPointerMove);document.addEventListener("mouseup",onInitialPointerMove);document.addEventListener("pointermove",onInitialPointerMove);document.addEventListener("pointerdown",onInitialPointerMove);document.addEventListener("pointerup",onInitialPointerMove);document.addEventListener("touchmove",onInitialPointerMove);document.addEventListener("touchstart",onInitialPointerMove);document.addEventListener("touchend",onInitialPointerMove);}function removeInitialPointerMoveListeners(){document.removeEventListener("mousemove",onInitialPointerMove);document.removeEventListener("mousedown",onInitialPointerMove);document.removeEventListener("mouseup",onInitialPointerMove);document.removeEventListener("pointermove",onInitialPointerMove);document.removeEventListener("pointerdown",onInitialPointerMove);document.removeEventListener("pointerup",onInitialPointerMove);document.removeEventListener("touchmove",onInitialPointerMove);document.removeEventListener("touchstart",onInitialPointerMove);document.removeEventListener("touchend",onInitialPointerMove);}function onInitialPointerMove(e2){if(e2.target.nodeName&&e2.target.nodeName.toLowerCase()==="html"){return;}hadKeyboardEvent=false;removeInitialPointerMoveListeners();}document.addEventListener("keydown",onKeyDown,true);document.addEventListener("mousedown",onPointerDown,true);document.addEventListener("pointerdown",onPointerDown,true);document.addEventListener("touchstart",onPointerDown,true);document.addEventListener("visibilitychange",onVisibilityChange,true);addInitialPointerMoveListeners();scope.addEventListener("focus",onFocus,true);scope.addEventListener("blur",onBlur,true);if(scope.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&scope.host){scope.host.setAttribute("data-js-focus-visible","");}else if(scope.nodeType===Node.DOCUMENT_NODE){document.documentElement.classList.add("js-focus-visible");document.documentElement.setAttribute("data-js-focus-visible","");}}if(typeof window!=="undefined"&&typeof document!=="undefined"){window.applyFocusVisiblePolyfill=applyFocusVisiblePolyfill;var event;try{event=new CustomEvent("focus-visible-polyfill-ready");}catch(error){event=document.createEvent("CustomEvent");event.initCustomEvent("focus-visible-polyfill-ready",false,false,{});}window.dispatchEvent(event);}if(typeof document!=="undefined"){applyFocusVisiblePolyfill(document);}});})();function _defineProperty(obj,key2,value){if(key2 in obj){Object.defineProperty(obj,key2,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key2]=value;}return obj;}var defineProperty$1=_defineProperty;function memoize$3(fn2){var cache={};return function(arg){if(cache[arg]===void 0)cache[arg]=fn2(arg);return cache[arg];};}var reactPropsRegex=/^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;var index$2=memoize$3(function(prop2){return reactPropsRegex.test(prop2)||prop2.charCodeAt(0)===111&&prop2.charCodeAt(1)===110&&prop2.charCodeAt(2)<91;});var isBrowser=true;function getRegisteredStyles(registered,registeredStyles,classNames){var rawClassName="";classNames.split(" ").forEach(function(className){if(registered[className]!==void 0){registeredStyles.push(registered[className]);}else{rawClassName+=className+" ";}});return rawClassName;}var insertStyles=function insertStyles2(cache,serialized,isStringTag){var className=cache.key+"-"+serialized.name;if((isStringTag===false||isBrowser===false)&&cache.registered[className]===void 0){cache.registered[className]=serialized.styles;}if(cache.inserted[serialized.name]===void 0){var current=serialized;do{cache.insert("."+className,current,cache.sheet,true);current=current.next;}while(current!==void 0);}};function murmur2(str){var h2=0;var k2,i=0,len=str.length;for(;len>=4;++i,len-=4){k2=str.charCodeAt(i)&255|(str.charCodeAt(++i)&255)<<8|(str.charCodeAt(++i)&255)<<16|(str.charCodeAt(++i)&255)<<24;k2=(k2&65535)*1540483477+((k2>>>16)*59797<<16);k2^=k2>>>24;h2=(k2&65535)*1540483477+((k2>>>16)*59797<<16)^(h2&65535)*1540483477+((h2>>>16)*59797<<16);}switch(len){case 3:h2^=(str.charCodeAt(i+2)&255)<<16;case 2:h2^=(str.charCodeAt(i+1)&255)<<8;case 1:h2^=str.charCodeAt(i)&255;h2=(h2&65535)*1540483477+((h2>>>16)*59797<<16);}h2^=h2>>>13;h2=(h2&65535)*1540483477+((h2>>>16)*59797<<16);return((h2^h2>>>15)>>>0).toString(36);}var unitlessKeys={animationIterationCount:1,borderImageOutset:1,borderImageSlice:1,borderImageWidth:1,boxFlex:1,boxFlexGroup:1,boxOrdinalGroup:1,columnCount:1,columns:1,flex:1,flexGrow:1,flexPositive:1,flexShrink:1,flexNegative:1,flexOrder:1,gridRow:1,gridRowEnd:1,gridRowSpan:1,gridRowStart:1,gridColumn:1,gridColumnEnd:1,gridColumnSpan:1,gridColumnStart:1,msGridRow:1,msGridRowSpan:1,msGridColumn:1,msGridColumnSpan:1,fontWeight:1,lineHeight:1,opacity:1,order:1,orphans:1,tabSize:1,widows:1,zIndex:1,zoom:1,WebkitLineClamp:1,fillOpacity:1,floodOpacity:1,stopOpacity:1,strokeDasharray:1,strokeDashoffset:1,strokeMiterlimit:1,strokeOpacity:1,strokeWidth:1};var hyphenateRegex=/[A-Z]|^ms/g;var animationRegex=/_EMO_([^_]+?)_([^]*?)_EMO_/g;var isCustomProperty=function isCustomProperty2(property){return property.charCodeAt(1)===45;};var isProcessableValue=function isProcessableValue2(value){return value!=null&&typeof value!=="boolean";};var processStyleName=memoize$3(function(styleName){return isCustomProperty(styleName)?styleName:styleName.replace(hyphenateRegex,"-$&").toLowerCase();});var processStyleValue=function processStyleValue2(key2,value){switch(key2){case"animation":case"animationName":{if(typeof value==="string"){return value.replace(animationRegex,function(match,p1,p2){cursor={name:p1,styles:p2,next:cursor};return p1;});}}}if(unitlessKeys[key2]!==1&&!isCustomProperty(key2)&&typeof value==="number"&&value!==0){return value+"px";}return value;};function handleInterpolation(mergedProps,registered,interpolation,couldBeSelectorInterpolation){if(interpolation==null){return"";}if(interpolation.__emotion_styles!==void 0){return interpolation;}switch(_typeof2(interpolation)){case"boolean":{return"";}case"object":{if(interpolation.anim===1){cursor={name:interpolation.name,styles:interpolation.styles,next:cursor};return interpolation.name;}if(interpolation.styles!==void 0){var next=interpolation.next;if(next!==void 0){while(next!==void 0){cursor={name:next.name,styles:next.styles,next:cursor};next=next.next;}}var styles2=interpolation.styles+";";return styles2;}return createStringFromObject(mergedProps,registered,interpolation);}case"function":{if(mergedProps!==void 0){var previousCursor=cursor;var result=interpolation(mergedProps);cursor=previousCursor;return handleInterpolation(mergedProps,registered,result,couldBeSelectorInterpolation);}break;}}if(registered==null){return interpolation;}var cached=registered[interpolation];return cached!==void 0&&!couldBeSelectorInterpolation?cached:interpolation;}function createStringFromObject(mergedProps,registered,obj){var string="";if(Array.isArray(obj)){for(var i=0;i<obj.length;i++){string+=handleInterpolation(mergedProps,registered,obj[i],false);}}else{for(var _key in obj){var value=obj[_key];if(_typeof2(value)!=="object"){if(registered!=null&&registered[value]!==void 0){string+=_key+"{"+registered[value]+"}";}else if(isProcessableValue(value)){string+=processStyleName(_key)+":"+processStyleValue(_key,value)+";";}}else{if(_key==="NO_COMPONENT_SELECTOR"&&false){throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");}if(Array.isArray(value)&&typeof value[0]==="string"&&(registered==null||registered[value[0]]===void 0)){for(var _i=0;_i<value.length;_i++){if(isProcessableValue(value[_i])){string+=processStyleName(_key)+":"+processStyleValue(_key,value[_i])+";";}}}else{var interpolated=handleInterpolation(mergedProps,registered,value,false);switch(_key){case"animation":case"animationName":{string+=processStyleName(_key)+":"+interpolated+";";break;}default:{string+=_key+"{"+interpolated+"}";}}}}}}return string;}var labelPattern=/label:\s*([^\s;\n{]+)\s*;/g;var cursor;var serializeStyles=function serializeStyles2(args,registered,mergedProps){if(args.length===1&&_typeof2(args[0])==="object"&&args[0]!==null&&args[0].styles!==void 0){return args[0];}var stringMode=true;var styles2="";cursor=void 0;var strings=args[0];if(strings==null||strings.raw===void 0){stringMode=false;styles2+=handleInterpolation(mergedProps,registered,strings,false);}else{styles2+=strings[0];}for(var i=1;i<args.length;i++){styles2+=handleInterpolation(mergedProps,registered,args[i],styles2.charCodeAt(styles2.length-1)===46);if(stringMode){styles2+=strings[i];}}labelPattern.lastIndex=0;var identifierName="";var match;while((match=labelPattern.exec(styles2))!==null){identifierName+="-"+match[1];}var name=murmur2(styles2)+identifierName;return{name:name,styles:styles2,next:cursor};};var testOmitPropsOnStringTag=index$2;var testOmitPropsOnComponent=function testOmitPropsOnComponent2(key2){return key2!=="theme"&&key2!=="innerRef";};var getDefaultShouldForwardProp=function getDefaultShouldForwardProp2(tag){return typeof tag==="string"&&tag.charCodeAt(0)>96?testOmitPropsOnStringTag:testOmitPropsOnComponent;};function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key2){defineProperty$1(target,key2,source[key2]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key2){Object.defineProperty(target,key2,Object.getOwnPropertyDescriptor(source,key2));});}}return target;}var createStyled=function createStyled2(tag,options){var identifierName;var shouldForwardProp;var targetClassName;if(options!==void 0){identifierName=options.label;targetClassName=options.target;shouldForwardProp=tag.__emotion_forwardProp&&options.shouldForwardProp?function(propName){return tag.__emotion_forwardProp(propName)&&options.shouldForwardProp(propName);}:options.shouldForwardProp;}var isReal=tag.__emotion_real===tag;var baseTag=isReal&&tag.__emotion_base||tag;if(typeof shouldForwardProp!=="function"&&isReal){shouldForwardProp=tag.__emotion_forwardProp;}var defaultShouldForwardProp=shouldForwardProp||getDefaultShouldForwardProp(baseTag);var shouldUseAs=!defaultShouldForwardProp("as");return function(){var args=arguments;var styles2=isReal&&tag.__emotion_styles!==void 0?tag.__emotion_styles.slice(0):[];if(identifierName!==void 0){styles2.push("label:"+identifierName+";");}if(args[0]==null||args[0].raw===void 0){styles2.push.apply(styles2,args);}else{styles2.push(args[0][0]);var len=args.length;var i=1;for(;i<len;i++){styles2.push(args[i],args[0][i]);}}var Styled=Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["f" /* withEmotionCache */])(function(props,context,ref){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["c" /* ThemeContext */].Consumer,null,function(theme){var finalTag=shouldUseAs&&props.as||baseTag;var className="";var classInterpolations=[];var mergedProps=props;if(props.theme==null){mergedProps={};for(var key2 in props){mergedProps[key2]=props[key2];}mergedProps.theme=theme;}if(typeof props.className==="string"){className=getRegisteredStyles(context.registered,classInterpolations,props.className);}else if(props.className!=null){className=props.className+" ";}var serialized=serializeStyles(styles2.concat(classInterpolations),context.registered,mergedProps);insertStyles(context,serialized,typeof finalTag==="string");className+=context.key+"-"+serialized.name;if(targetClassName!==void 0){className+=" "+targetClassName;}var finalShouldForwardProp=shouldUseAs&&shouldForwardProp===void 0?getDefaultShouldForwardProp(finalTag):defaultShouldForwardProp;var newProps={};for(var _key in props){if(shouldUseAs&&_key==="as")continue;if(finalShouldForwardProp(_key)){newProps[_key]=props[_key];}}newProps.className=className;newProps.ref=ref||props.innerRef;var ele=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(finalTag,newProps);return ele;});});Styled.displayName=identifierName!==void 0?identifierName:"Styled("+(typeof baseTag==="string"?baseTag:baseTag.displayName||baseTag.name||"Component")+")";Styled.defaultProps=tag.defaultProps;Styled.__emotion_real=Styled;Styled.__emotion_base=baseTag;Styled.__emotion_styles=styles2;Styled.__emotion_forwardProp=shouldForwardProp;Object.defineProperty(Styled,"toString",{value:function value(){if(targetClassName===void 0&&false){return"NO_COMPONENT_SELECTOR";}return"."+targetClassName;}});Styled.withComponent=function(nextTag,nextOptions){return createStyled2(nextTag,nextOptions!==void 0?_objectSpread({},options||{},{},nextOptions):options).apply(void 0,styles2);};return Styled;};};var curry=function curry(fn2){var _curried=function curried(){for(var _len8=arguments.length,args=new Array(_len8),_key8=0;_key8<_len8;_key8++){args[_key8]=arguments[_key8];}if(args.length>=fn2.length){return fn2.apply(void 0,args);}return function(){for(var _len9=arguments.length,args2=new Array(_len9),_key9=0;_key9<_len9;_key9++){args2[_key9]=arguments[_key9];}return _curried.apply(void 0,_toConsumableArray(args.concat(args2)));};};return _curried;};var BREAKPOINTS={sm:576,md:768,lg:992,xl:1200};var mediaUp=function mediaUp(size2){return"@media (min-width: ".concat(BREAKPOINTS[size2],"px)");};var mediaDn=function mediaDn(size2){return"@media (max-width: ".concat(BREAKPOINTS[size2],"px)");};function endsWith(string,suffix2){return string.substr(-suffix2.length)===suffix2;}function stripUnit(value){var unitlessValue=parseFloat(value);if(isNaN(unitlessValue))return value;return unitlessValue;}var pxtoFactory=function pxtoFactory2(to){return function(pxval){var base2=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"16px";var newPxval=pxval;var newBase=base2;if(typeof pxval==="string"){if(!endsWith(pxval,"px")){throw new Error('Expected a string ending in "px" or a number passed as the first argument to '+to+'(), got "'+pxval+'" instead.');}newPxval=stripUnit(pxval);}if(typeof base2==="string"){if(!endsWith(base2,"px")){throw new Error('Expected a string ending in "px" or a number passed as the second argument to '+to+'(), got "'+base2+'" instead.');}newBase=stripUnit(base2);}if(typeof newPxval==="string"){throw new Error('Passed invalid pixel value ("'+pxval+'") to '+to+'(), please pass a value like "12px" or 12.');}if(typeof newBase==="string"){throw new Error('Passed invalid base value ("'+base2+'") to '+to+'(), please pass a value like "12px" or 12.');}return""+newPxval/newBase+to;};};var rem$1=/* @__PURE__ */pxtoFactory("rem");var _opinionatedRules;var _abbrTitle;var _unopinionatedRules;_opinionatedRules={html:{fontFamily:"sans-serif"},body:{margin:"0"}},_opinionatedRules["a:active,\n  a:hover"]={outlineWidth:"0"},_opinionatedRules["button,\n  input,\n  optgroup,\n  select,\n  textarea"]={fontFamily:"sans-serif",fontSize:"100%",lineHeight:"1.15"},_opinionatedRules;_unopinionatedRules={html:{lineHeight:"1.15",textSizeAdjust:"100%"}},_unopinionatedRules["article,\n  aside,\n  footer,\n  header,\n  nav,\n  section"]={display:"block"},_unopinionatedRules.h1={fontSize:"2em",margin:"0.67em 0"},_unopinionatedRules["figcaption,\n  figure,\n  main"]={display:"block"},_unopinionatedRules.figure={margin:"1em 40px"},_unopinionatedRules.hr={boxSizing:"content-box",height:"0",overflow:"visible"},_unopinionatedRules.pre={fontFamily:"monospace, monospace",fontSize:"1em"},_unopinionatedRules.a={"background-color":"transparent","-webkit-text-decoration-skip":"objects"},_unopinionatedRules["abbr[title]"]=(_abbrTitle={borderBottom:"none",textDecoration:"underline"},_abbrTitle["textDecoration"]="underline dotted",_abbrTitle),_unopinionatedRules["b,\n  strong"]={fontWeight:"inherit"},_unopinionatedRules["code,\n  kbd,\n  samp"]={fontFamily:"monospace, monospace",fontSize:"1em"},_unopinionatedRules.dfn={fontStyle:"italic"},_unopinionatedRules.mark={backgroundColor:"#ff0",color:"#000"},_unopinionatedRules.small={fontSize:"80%"},_unopinionatedRules["sub,\n  sup"]={fontSize:"75%",lineHeight:"0",position:"relative",verticalAlign:"baseline"},_unopinionatedRules.sub={bottom:"-0.25em"},_unopinionatedRules.sup={top:"-0.5em"},_unopinionatedRules["audio,\n  video"]={display:"inline-block"},_unopinionatedRules["audio:not([controls])"]={display:"none",height:"0"},_unopinionatedRules.img={borderStyle:"none"},_unopinionatedRules["svg:not(:root)"]={overflow:"hidden"},_unopinionatedRules["button,\n  input,\n  optgroup,\n  select,\n  textarea"]={margin:"0"},_unopinionatedRules["button,\n  input"]={overflow:"visible"},_unopinionatedRules["button,\n  select"]={textTransform:"none"},_unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]']={"-webkit-appearance":"button"},_unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner']={borderStyle:"none",padding:"0"},_unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring']={outline:"1px dotted ButtonText"},_unopinionatedRules.fieldset={border:"1px solid #c0c0c0",margin:"0 2px",padding:"0.35em 0.625em 0.75em"},_unopinionatedRules.legend={boxSizing:"border-box",color:"inherit",display:"table",maxWidth:"100%",padding:"0",whiteSpace:"normal"},_unopinionatedRules.progress={display:"inline-block",verticalAlign:"baseline"},_unopinionatedRules.textarea={overflow:"auto"},_unopinionatedRules['[type="checkbox"],\n  [type="radio"]']={boxSizing:"border-box",padding:"0"},_unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button']={height:"auto"},_unopinionatedRules['[type="search"]']={"-webkit-appearance":"textfield",outlineOffset:"-2px"},_unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration']={"-webkit-appearance":"none"},_unopinionatedRules["::-webkit-file-upload-button"]={"-webkit-appearance":"button",font:"inherit"},_unopinionatedRules["details,\n  menu"]={display:"block"},_unopinionatedRules.summary={display:"list-item"},_unopinionatedRules.canvas={display:"inline-block"},_unopinionatedRules.template={display:"none"},_unopinionatedRules["[hidden]"]={display:"none"},_unopinionatedRules;function colorToInt(color2){return Math.round(color2*255);}function convertToInt(red,green,blue){return colorToInt(red)+","+colorToInt(green)+","+colorToInt(blue);}function hslToRgb(hue,saturation,lightness){var convert=arguments.length>3&&arguments[3]!==void 0?arguments[3]:convertToInt;if(saturation===0){return convert(lightness,lightness,lightness);}var huePrime=hue%360/60;var chroma=(1-Math.abs(2*lightness-1))*saturation;var secondComponent=chroma*(1-Math.abs(huePrime%2-1));var red=0;var green=0;var blue=0;if(huePrime>=0&&huePrime<1){red=chroma;green=secondComponent;}else if(huePrime>=1&&huePrime<2){red=secondComponent;green=chroma;}else if(huePrime>=2&&huePrime<3){green=chroma;blue=secondComponent;}else if(huePrime>=3&&huePrime<4){green=secondComponent;blue=chroma;}else if(huePrime>=4&&huePrime<5){red=secondComponent;blue=chroma;}else if(huePrime>=5&&huePrime<6){red=chroma;blue=secondComponent;}var lightnessModification=lightness-chroma/2;var finalRed=red+lightnessModification;var finalGreen=green+lightnessModification;var finalBlue=blue+lightnessModification;return convert(finalRed,finalGreen,finalBlue);}var namedColorMap={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"639",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"};function nameToHex(color2){if(typeof color2!=="string")return color2;var normalizedColorName=color2.toLowerCase();return namedColorMap[normalizedColorName]?"#"+namedColorMap[normalizedColorName]:color2;}var hexRegex=/^#[a-fA-F0-9]{6}$/;var reducedHexRegex=/^#[a-fA-F0-9]{3}$/;var rgbRegex=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;var rgbaRegex=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;var hslRegex=/^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;var hslaRegex=/^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;function parseToRgb(color2){if(typeof color2!=="string"){throw new Error("Passed an incorrect argument to a color function, please pass a string representation of a color.");}var normalizedColor=nameToHex(color2);if(normalizedColor.match(hexRegex)){return{red:parseInt(""+normalizedColor[1]+normalizedColor[2],16),green:parseInt(""+normalizedColor[3]+normalizedColor[4],16),blue:parseInt(""+normalizedColor[5]+normalizedColor[6],16)};}if(normalizedColor.match(reducedHexRegex)){return{red:parseInt(""+normalizedColor[1]+normalizedColor[1],16),green:parseInt(""+normalizedColor[2]+normalizedColor[2],16),blue:parseInt(""+normalizedColor[3]+normalizedColor[3],16)};}var rgbMatched=rgbRegex.exec(normalizedColor);if(rgbMatched){return{red:parseInt(""+rgbMatched[1],10),green:parseInt(""+rgbMatched[2],10),blue:parseInt(""+rgbMatched[3],10)};}var rgbaMatched=rgbaRegex.exec(normalizedColor);if(rgbaMatched){return{red:parseInt(""+rgbaMatched[1],10),green:parseInt(""+rgbaMatched[2],10),blue:parseInt(""+rgbaMatched[3],10),alpha:parseFloat(""+rgbaMatched[4])};}var hslMatched=hslRegex.exec(normalizedColor);if(hslMatched){var hue=parseInt(""+hslMatched[1],10);var saturation=parseInt(""+hslMatched[2],10)/100;var lightness=parseInt(""+hslMatched[3],10)/100;var rgbColorString="rgb("+hslToRgb(hue,saturation,lightness)+")";var hslRgbMatched=rgbRegex.exec(rgbColorString);return{red:parseInt(""+hslRgbMatched[1],10),green:parseInt(""+hslRgbMatched[2],10),blue:parseInt(""+hslRgbMatched[3],10)};}var hslaMatched=hslaRegex.exec(normalizedColor);if(hslaMatched){var _hue=parseInt(""+hslaMatched[1],10);var _saturation=parseInt(""+hslaMatched[2],10)/100;var _lightness=parseInt(""+hslaMatched[3],10)/100;var _rgbColorString="rgb("+hslToRgb(_hue,_saturation,_lightness)+")";var _hslRgbMatched=rgbRegex.exec(_rgbColorString);return{red:parseInt(""+_hslRgbMatched[1],10),green:parseInt(""+_hslRgbMatched[2],10),blue:parseInt(""+_hslRgbMatched[3],10),alpha:parseFloat(""+hslaMatched[4])};}throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");}var reduceHexValue=function reduceHexValue2(value){if(value.length===7&&value[1]===value[2]&&value[3]===value[4]&&value[5]===value[6]){return"#"+value[1]+value[3]+value[5];}return value;};function numberToHex(value){var hex=value.toString(16);return hex.length===1?"0"+hex:hex;}function rgb(value,green,blue){if(typeof value==="number"&&typeof green==="number"&&typeof blue==="number"){return reduceHexValue("#"+numberToHex(value)+numberToHex(green)+numberToHex(blue));}else if(_typeof2(value)==="object"&&green===void 0&&blue===void 0){return reduceHexValue("#"+numberToHex(value.red)+numberToHex(value.green)+numberToHex(value.blue));}throw new Error("Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).");}function rgba(firstValue,secondValue,thirdValue,fourthValue){if(typeof firstValue==="string"&&typeof secondValue==="number"){var rgbValue=parseToRgb(firstValue);return"rgba("+rgbValue.red+","+rgbValue.green+","+rgbValue.blue+","+secondValue+")";}else if(typeof firstValue==="number"&&typeof secondValue==="number"&&typeof thirdValue==="number"&&typeof fourthValue==="number"){return fourthValue>=1?rgb(firstValue,secondValue,thirdValue):"rgba("+firstValue+","+secondValue+","+thirdValue+","+fourthValue+")";}else if(_typeof2(firstValue)==="object"&&secondValue===void 0&&thirdValue===void 0&&fourthValue===void 0){return firstValue.alpha>=1?rgb(firstValue.red,firstValue.green,firstValue.blue):"rgba("+firstValue.red+","+firstValue.green+","+firstValue.blue+","+firstValue.alpha+")";}throw new Error("Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).");}var isArray$5=Array.isArray;var isArray_1=isArray$5;var freeGlobal$2=_typeof2(commonjsGlobal)=="object"&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal;var _freeGlobal=freeGlobal$2;var freeGlobal$1=_freeGlobal;var freeSelf$1=(typeof self==="undefined"?"undefined":_typeof2(self))=="object"&&self&&self.Object===Object&&self;var root$6=freeGlobal$1||freeSelf$1||Function("return this")();var _root=root$6;var root$5=_root;var Symbol$5=root$5.Symbol;var _Symbol=Symbol$5;var Symbol$4=_Symbol;var objectProto$5=Object.prototype;var hasOwnProperty$6=objectProto$5.hasOwnProperty;var nativeObjectToString$1=objectProto$5.toString;var symToStringTag$1=Symbol$4?Symbol$4.toStringTag:void 0;function getRawTag$1(value){var isOwn=hasOwnProperty$6.call(value,symToStringTag$1),tag=value[symToStringTag$1];try{value[symToStringTag$1]=void 0;var unmasked=true;}catch(e2){}var result=nativeObjectToString$1.call(value);if(unmasked){if(isOwn){value[symToStringTag$1]=tag;}else{delete value[symToStringTag$1];}}return result;}var _getRawTag=getRawTag$1;var objectProto$4=Object.prototype;var nativeObjectToString=objectProto$4.toString;function objectToString$2(value){return nativeObjectToString.call(value);}var _objectToString=objectToString$2;var Symbol$3=_Symbol,getRawTag=_getRawTag,objectToString$1=_objectToString;var nullTag="[object Null]",undefinedTag="[object Undefined]";var symToStringTag=Symbol$3?Symbol$3.toStringTag:void 0;function baseGetTag$2(value){if(value==null){return value===void 0?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString$1(value);}var _baseGetTag=baseGetTag$2;function isObjectLike$2(value){return value!=null&&_typeof2(value)=="object";}var isObjectLike_1=isObjectLike$2;var baseGetTag$1=_baseGetTag,isObjectLike$1=isObjectLike_1;var symbolTag$1="[object Symbol]";function isSymbol$4(value){return _typeof2(value)=="symbol"||isObjectLike$1(value)&&baseGetTag$1(value)==symbolTag$1;}var isSymbol_1=isSymbol$4;var isArray$4=isArray_1,isSymbol$3=isSymbol_1;var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/;function isKey$1(value,object){if(isArray$4(value)){return false;}var type=_typeof2(value);if(type=="number"||type=="symbol"||type=="boolean"||value==null||isSymbol$3(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}var _isKey=isKey$1;function isObject$4(value){var type=_typeof2(value);return value!=null&&(type=="object"||type=="function");}var isObject_1=isObject$4;var baseGetTag=_baseGetTag,isObject$3=isObject_1;var asyncTag="[object AsyncFunction]",funcTag$1="[object Function]",genTag$1="[object GeneratorFunction]",proxyTag="[object Proxy]";function isFunction$3(value){if(!isObject$3(value)){return false;}var tag=baseGetTag(value);return tag==funcTag$1||tag==genTag$1||tag==asyncTag||tag==proxyTag;}var isFunction_1=isFunction$3;var root$4=_root;var coreJsData$2=root$4["__core-js_shared__"];var _coreJsData=coreJsData$2;var coreJsData$1=_coreJsData;var maskSrcKey$1=function(){var uid=/[^.]+$/.exec(coreJsData$1&&coreJsData$1.keys&&coreJsData$1.keys.IE_PROTO||"");return uid?"Symbol(src)_1."+uid:"";}();function isMasked$2(func){return!!maskSrcKey$1&&maskSrcKey$1 in func;}var _isMasked=isMasked$2;var funcProto$2=Function.prototype;var funcToString$2=funcProto$2.toString;function toSource$2(func){if(func!=null){try{return funcToString$2.call(func);}catch(e2){}try{return func+"";}catch(e2){}}return"";}var _toSource=toSource$2;var isFunction$2=isFunction_1,isMasked$1=_isMasked,isObject$2=isObject_1,toSource$1=_toSource;var reRegExpChar$1=/[\\^$.*+?()[\]{}|]/g;var reIsHostCtor$1=/^\[object .+?Constructor\]$/;var funcProto$1=Function.prototype,objectProto$3=Object.prototype;var funcToString$1=funcProto$1.toString;var hasOwnProperty$5=objectProto$3.hasOwnProperty;var reIsNative$1=RegExp("^"+funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar$1,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");function baseIsNative$2(value){if(!isObject$2(value)||isMasked$1(value)){return false;}var pattern=isFunction$2(value)?reIsNative$1:reIsHostCtor$1;return pattern.test(toSource$1(value));}var _baseIsNative=baseIsNative$2;function getValue$2(object,key2){return object==null?void 0:object[key2];}var _getValue=getValue$2;var baseIsNative$1=_baseIsNative,getValue$1=_getValue;function getNative$3(object,key2){var value=getValue$1(object,key2);return baseIsNative$1(value)?value:void 0;}var _getNative=getNative$3;var getNative$2=_getNative;var nativeCreate$5=getNative$2(Object,"create");var _nativeCreate=nativeCreate$5;var nativeCreate$4=_nativeCreate;function hashClear$2(){this.__data__=nativeCreate$4?nativeCreate$4(null):{};this.size=0;}var _hashClear=hashClear$2;function hashDelete$2(key2){var result=this.has(key2)&&delete this.__data__[key2];this.size-=result?1:0;return result;}var _hashDelete=hashDelete$2;var nativeCreate$3=_nativeCreate;var HASH_UNDEFINED$2="__lodash_hash_undefined__";var objectProto$2=Object.prototype;var hasOwnProperty$4=objectProto$2.hasOwnProperty;function hashGet$2(key2){var data=this.__data__;if(nativeCreate$3){var result=data[key2];return result===HASH_UNDEFINED$2?void 0:result;}return hasOwnProperty$4.call(data,key2)?data[key2]:void 0;}var _hashGet=hashGet$2;var nativeCreate$2=_nativeCreate;var objectProto$1=Object.prototype;var hasOwnProperty$3=objectProto$1.hasOwnProperty;function hashHas$2(key2){var data=this.__data__;return nativeCreate$2?data[key2]!==void 0:hasOwnProperty$3.call(data,key2);}var _hashHas=hashHas$2;var nativeCreate$1=_nativeCreate;var HASH_UNDEFINED$1="__lodash_hash_undefined__";function hashSet$2(key2,value){var data=this.__data__;this.size+=this.has(key2)?0:1;data[key2]=nativeCreate$1&&value===void 0?HASH_UNDEFINED$1:value;return this;}var _hashSet=hashSet$2;var hashClear$1=_hashClear,hashDelete$1=_hashDelete,hashGet$1=_hashGet,hashHas$1=_hashHas,hashSet$1=_hashSet;function Hash$3(entries){var index2=-1,length=entries==null?0:entries.length;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}Hash$3.prototype.clear=hashClear$1;Hash$3.prototype["delete"]=hashDelete$1;Hash$3.prototype.get=hashGet$1;Hash$3.prototype.has=hashHas$1;Hash$3.prototype.set=hashSet$1;var _Hash=Hash$3;function listCacheClear$2(){this.__data__=[];this.size=0;}var _listCacheClear=listCacheClear$2;function eq$2(value,other){return value===other||value!==value&&other!==other;}var eq_1=eq$2;var eq$1=eq_1;function assocIndexOf$5(array,key2){var length=array.length;while(length--){if(eq$1(array[length][0],key2)){return length;}}return-1;}var _assocIndexOf=assocIndexOf$5;var assocIndexOf$4=_assocIndexOf;var arrayProto$1=Array.prototype;var splice$1=arrayProto$1.splice;function listCacheDelete$2(key2){var data=this.__data__,index2=assocIndexOf$4(data,key2);if(index2<0){return false;}var lastIndex=data.length-1;if(index2==lastIndex){data.pop();}else{splice$1.call(data,index2,1);}--this.size;return true;}var _listCacheDelete=listCacheDelete$2;var assocIndexOf$3=_assocIndexOf;function listCacheGet$2(key2){var data=this.__data__,index2=assocIndexOf$3(data,key2);return index2<0?void 0:data[index2][1];}var _listCacheGet=listCacheGet$2;var assocIndexOf$2=_assocIndexOf;function listCacheHas$2(key2){return assocIndexOf$2(this.__data__,key2)>-1;}var _listCacheHas=listCacheHas$2;var assocIndexOf$1=_assocIndexOf;function listCacheSet$2(key2,value){var data=this.__data__,index2=assocIndexOf$1(data,key2);if(index2<0){++this.size;data.push([key2,value]);}else{data[index2][1]=value;}return this;}var _listCacheSet=listCacheSet$2;var listCacheClear$1=_listCacheClear,listCacheDelete$1=_listCacheDelete,listCacheGet$1=_listCacheGet,listCacheHas$1=_listCacheHas,listCacheSet$1=_listCacheSet;function ListCache$2(entries){var index2=-1,length=entries==null?0:entries.length;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}ListCache$2.prototype.clear=listCacheClear$1;ListCache$2.prototype["delete"]=listCacheDelete$1;ListCache$2.prototype.get=listCacheGet$1;ListCache$2.prototype.has=listCacheHas$1;ListCache$2.prototype.set=listCacheSet$1;var _ListCache=ListCache$2;var getNative$1=_getNative,root$3=_root;var Map$3=getNative$1(root$3,"Map");var _Map=Map$3;var Hash$2=_Hash,ListCache$1=_ListCache,Map$2=_Map;function mapCacheClear$2(){this.size=0;this.__data__={"hash":new Hash$2(),"map":new(Map$2||ListCache$1)(),"string":new Hash$2()};}var _mapCacheClear=mapCacheClear$2;function isKeyable$2(value){var type=_typeof2(value);return type=="string"||type=="number"||type=="symbol"||type=="boolean"?value!=="__proto__":value===null;}var _isKeyable=isKeyable$2;var isKeyable$1=_isKeyable;function getMapData$5(map,key2){var data=map.__data__;return isKeyable$1(key2)?data[typeof key2=="string"?"string":"hash"]:data.map;}var _getMapData=getMapData$5;var getMapData$4=_getMapData;function mapCacheDelete$2(key2){var result=getMapData$4(this,key2)["delete"](key2);this.size-=result?1:0;return result;}var _mapCacheDelete=mapCacheDelete$2;var getMapData$3=_getMapData;function mapCacheGet$2(key2){return getMapData$3(this,key2).get(key2);}var _mapCacheGet=mapCacheGet$2;var getMapData$2=_getMapData;function mapCacheHas$2(key2){return getMapData$2(this,key2).has(key2);}var _mapCacheHas=mapCacheHas$2;var getMapData$1=_getMapData;function mapCacheSet$2(key2,value){var data=getMapData$1(this,key2),size2=data.size;data.set(key2,value);this.size+=data.size==size2?0:1;return this;}var _mapCacheSet=mapCacheSet$2;var mapCacheClear$1=_mapCacheClear,mapCacheDelete$1=_mapCacheDelete,mapCacheGet$1=_mapCacheGet,mapCacheHas$1=_mapCacheHas,mapCacheSet$1=_mapCacheSet;function MapCache$2(entries){var index2=-1,length=entries==null?0:entries.length;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}MapCache$2.prototype.clear=mapCacheClear$1;MapCache$2.prototype["delete"]=mapCacheDelete$1;MapCache$2.prototype.get=mapCacheGet$1;MapCache$2.prototype.has=mapCacheHas$1;MapCache$2.prototype.set=mapCacheSet$1;var _MapCache=MapCache$2;var MapCache$1=_MapCache;var FUNC_ERROR_TEXT$1="Expected a function";function memoize$2(func,resolver){if(typeof func!="function"||resolver!=null&&typeof resolver!="function"){throw new TypeError(FUNC_ERROR_TEXT$1);}var _memoized=function memoized(){var args=arguments,key2=resolver?resolver.apply(this,args):args[0],cache=_memoized.cache;if(cache.has(key2)){return cache.get(key2);}var result=func.apply(this,args);_memoized.cache=cache.set(key2,result)||cache;return result;};_memoized.cache=new(memoize$2.Cache||MapCache$1)();return _memoized;}memoize$2.Cache=MapCache$1;var memoize_1=memoize$2;var memoize$1=memoize_1;var MAX_MEMOIZE_SIZE=500;function memoizeCapped$1(func){var result=memoize$1(func,function(key2){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key2;});var cache=result.cache;return result;}var _memoizeCapped=memoizeCapped$1;var memoizeCapped=_memoizeCapped;var rePropName$1=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;var reEscapeChar$1=/\\(\\)?/g;var stringToPath$2=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46){result.push("");}string.replace(rePropName$1,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar$1,"$1"):number||match);});return result;});var _stringToPath=stringToPath$2;function arrayMap$2(array,iteratee){var index2=-1,length=array==null?0:array.length,result=Array(length);while(++index2<length){result[index2]=iteratee(array[index2],index2,array);}return result;}var _arrayMap=arrayMap$2;var Symbol$2=_Symbol,arrayMap$1=_arrayMap,isArray$3=isArray_1,isSymbol$2=isSymbol_1;var INFINITY$2=1/0;var symbolProto$1=Symbol$2?Symbol$2.prototype:void 0,symbolToString$1=symbolProto$1?symbolProto$1.toString:void 0;function baseToString$2(value){if(typeof value=="string"){return value;}if(isArray$3(value)){return arrayMap$1(value,baseToString$2)+"";}if(isSymbol$2(value)){return symbolToString$1?symbolToString$1.call(value):"";}var result=value+"";return result=="0"&&1/value==-INFINITY$2?"-0":result;}var _baseToString=baseToString$2;var baseToString$1=_baseToString;function toString$2(value){return value==null?"":baseToString$1(value);}var toString_1=toString$2;var isArray$2=isArray_1,isKey=_isKey,stringToPath$1=_stringToPath,toString$1=toString_1;function castPath$1(value,object){if(isArray$2(value)){return value;}return isKey(value,object)?[value]:stringToPath$1(toString$1(value));}var _castPath=castPath$1;var isSymbol$1=isSymbol_1;var INFINITY$1=1/0;function toKey$2(value){if(typeof value=="string"||isSymbol$1(value)){return value;}var result=value+"";return result=="0"&&1/value==-INFINITY$1?"-0":result;}var _toKey=toKey$2;var castPath=_castPath,toKey$1=_toKey;function baseGet$1(object,path){path=castPath(path,object);var index2=0,length=path.length;while(object!=null&&index2<length){object=object[toKey$1(path[index2++])];}return index2&&index2==length?object:void 0;}var _baseGet=baseGet$1;var baseGet=_baseGet;function get(object,path,defaultValue){var result=object==null?void 0:baseGet(object,path);return result===void 0?defaultValue:result;}var get_1=get;var borderRadiusProperty=curry(function(property,size2,_ref0){var theme=_ref0.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(property,":",theme.borderRadius[size2],";");});var borderRadius$1=borderRadiusProperty("border-radius");var borderTopLeftRadius=borderRadiusProperty("border-top-left-radius");var borderTopRightRadius=borderRadiusProperty("border-top-right-radius");var borderBottomRightRadius=borderRadiusProperty("border-bottom-right-radius");var borderBottomLeftRadius=borderRadiusProperty("border-bottom-left-radius");var color=curry(function(name,_ref1){var theme=_ref1.theme;return theme.brand[name];});var gradientStart=curry(function(name,_ref12){var theme=_ref12.theme;return theme.brand["".concat(name,"Gradient")].start;});var gradientEnd=curry(function(name,_ref13){var theme=_ref13.theme;return theme.brand["".concat(name,"Gradient")].end;});var rem=curry(function(px,_ref14){var theme=_ref14.theme;return rem$1(px,theme.font.base);});var fontSize=curry(function(size2,_ref15){var theme=_ref15.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("font-size:",theme.font.size[size2],";line-height:",theme.font.lineHeight[size2],";");});var fontWeight=curry(function(weight2,_ref16){var theme=_ref16.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("font-weight:",theme.font.weight[weight2],";");});var margin$1=curry(function(size2,_ref17){var theme=_ref17.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("margin:",theme.spacing[size2].y," ",theme.spacing[size2].x,";");});var padding=curry(function(size2,_ref18){var theme=_ref18.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding:",theme.spacing[size2].y," ",theme.spacing[size2].x,";");});var shadow$1=curry(function(kind2,_ref19){var theme=_ref19.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("box-shadow:",theme.shadow[kind2],";");});var spacer=curry(function(variant2,_ref20){var theme=_ref20.theme;return theme.spacing.size["spacer".concat(variant2)];});var transparentize=curry(function(colorName,amount,_ref21){var theme=_ref21.theme;var colorString=color(colorName,{theme:theme});if(!colorString)return;return rgba(colorString,amount);});var typography$1=curry(function(style2,_ref23){var theme=_ref23.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(theme.typography[style2],"");});var _ref$i={name:"8atqhb",styles:"width:100%;"};var responsiveContainer=function responsiveContainer(_ref24){var fluid=_ref24.fluid;return fluid?_ref$i:/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(mediaUp("xl"),"{width:",BREAKPOINTS.xl,"px;}",mediaDn("xl"),"{width:",BREAKPOINTS.lg,"px;}",mediaDn("lg"),"{width:",BREAKPOINTS.md,"px;}",mediaDn("md"),"{width:",BREAKPOINTS.sm,"px;}",mediaDn("sm"),"{width:100%;}");};var style=curry(function(styleName,_ref25){var theme=_ref25.theme;return get_1(theme.styles,styleName);});var lib$1={};Object.defineProperty(lib$1,"__esModule",{value:true});lib$1.createChangeEmitter=function createChangeEmitter(){var currentListeners=[];var nextListeners=currentListeners;function ensureCanMutateNextListeners(){if(nextListeners===currentListeners){nextListeners=currentListeners.slice();}}function listen(listener){if(typeof listener!=="function"){throw new Error("Expected listener to be a function.");}var isSubscribed=true;ensureCanMutateNextListeners();nextListeners.push(listener);return function(){if(!isSubscribed){return;}isSubscribed=false;ensureCanMutateNextListeners();var index2=nextListeners.indexOf(listener);nextListeners.splice(index2,1);};}function emit(){currentListeners=nextListeners;var listeners=currentListeners;for(var i=0;i<listeners.length;i++){listeners[i].apply(listeners,arguments);}}return{listen:listen,emit:emit};};function symbolObservablePonyfill(root2){var result;var Symbol2=root2.Symbol;if(typeof Symbol2==="function"){if(Symbol2.observable){result=Symbol2.observable;}else{result=Symbol2("observable");Symbol2.observable=result;}}else{result="@@observable";}return result;}var root$2;if(typeof self!=="undefined"){root$2=self;}else if(typeof window!=="undefined"){root$2=window;}else if(typeof global!=="undefined"){root$2=global;}else if(true){root$2=module;}else{root$2=Function("return this")();}symbolObservablePonyfill(root$2);var mapProps$2=function mapProps(propsMapper){return function(BaseComponent){var factory=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);var MapProps=function MapProps2(props){return factory(propsMapper(props));};return MapProps;};};var classCallCheck$1=function classCallCheck$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}};var _extends$3=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var inherits$1=function inherits$1(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;};var possibleConstructorReturn$1=function possibleConstructorReturn$1(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;};var withProps$1=function withProps(input){var hoc=mapProps$2(function(props){return _extends$3({},props,typeof input==="function"?input(props):input);});return hoc;};var defaultProps$4=function defaultProps(props){return function(BaseComponent){var factory=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);var DefaultProps=function DefaultProps2(ownerProps){return factory(ownerProps);};DefaultProps.defaultProps=props;return DefaultProps;};};(function(_Component){inherits$1(Nothing,_Component);function Nothing(){classCallCheck$1(this,Nothing);return possibleConstructorReturn$1(this,_Component.apply(this,arguments));}Nothing.prototype.render=function render3(){return null;};return Nothing;})(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function compose(){for(var _len=arguments.length,funcs=Array(_len),_key=0;_key<_len;_key++){funcs[_key]=arguments[_key];}if(funcs.length===0){return function(arg){return arg;};}if(funcs.length===1){return funcs[0];}return funcs.reduce(function(a,b2){return function(){return a(b2.apply(void 0,arguments));};});}var prop=curry(function(name,obj){return obj[name];});var defaultTo=curry(function(fallback,obj){return obj==null?fallback:obj;});function sheetForTag(tag){if(tag.sheet){return tag.sheet;}for(var i=0;i<document.styleSheets.length;i++){if(document.styleSheets[i].ownerNode===tag){return document.styleSheets[i];}}}function createStyleElement(options){var tag=document.createElement("style");tag.setAttribute("data-emotion",options.key);if(options.nonce!==void 0){tag.setAttribute("nonce",options.nonce);}tag.appendChild(document.createTextNode(""));return tag;}var StyleSheet=/* @__PURE__ */function(){function StyleSheet2(options){this.isSpeedy=options.speedy===void 0?true:options.speedy;this.tags=[];this.ctr=0;this.nonce=options.nonce;this.key=options.key;this.container=options.container;this.before=null;}var _proto=StyleSheet2.prototype;_proto.insert=function insert2(rule){if(this.ctr%(this.isSpeedy?65e3:1)===0){var _tag=createStyleElement(this);var before;if(this.tags.length===0){before=this.before;}else{before=this.tags[this.tags.length-1].nextSibling;}this.container.insertBefore(_tag,before);this.tags.push(_tag);}var tag=this.tags[this.tags.length-1];if(this.isSpeedy){var sheet=sheetForTag(tag);try{var isImportRule=rule.charCodeAt(1)===105&&rule.charCodeAt(0)===64;sheet.insertRule(rule,isImportRule?0:sheet.cssRules.length);}catch(e2){}}else{tag.appendChild(document.createTextNode(rule));}this.ctr++;};_proto.flush=function flush(){this.tags.forEach(function(tag){return tag.parentNode.removeChild(tag);});this.tags=[];this.ctr=0;};return StyleSheet2;}();function stylis_min(W){function M(d2,c2,e2,h2,a){for(var m2=0,b2=0,v2=0,n2=0,q2,g2,x=0,K=0,k2,u2=k2=q2=0,l2=0,r2=0,I2=0,t2=0,B3=e2.length,J=B3-1,y2,f2="",p2="",F3="",G3="",C2;l2<B3;){g2=e2.charCodeAt(l2);l2===J&&b2+n2+v2+m2!==0&&(b2!==0&&(g2=b2===47?10:47),n2=v2=m2=0,B3++,J++);if(b2+n2+v2+m2===0){if(l2===J&&(0<r2&&(f2=f2.replace(N,"")),0<f2.trim().length)){switch(g2){case 32:case 9:case 59:case 13:case 10:break;default:f2+=e2.charAt(l2);}g2=59;}switch(g2){case 123:f2=f2.trim();q2=f2.charCodeAt(0);k2=1;for(t2=++l2;l2<B3;){switch(g2=e2.charCodeAt(l2)){case 123:k2++;break;case 125:k2--;break;case 47:switch(g2=e2.charCodeAt(l2+1)){case 42:case 47:a:{for(u2=l2+1;u2<J;++u2){switch(e2.charCodeAt(u2)){case 47:if(g2===42&&e2.charCodeAt(u2-1)===42&&l2+2!==u2){l2=u2+1;break a;}break;case 10:if(g2===47){l2=u2+1;break a;}}}l2=u2;}}break;case 91:g2++;case 40:g2++;case 34:case 39:for(;l2++<J&&e2.charCodeAt(l2)!==g2;){}}if(k2===0)break;l2++;}k2=e2.substring(t2,l2);q2===0&&(q2=(f2=f2.replace(ca,"").trim()).charCodeAt(0));switch(q2){case 64:0<r2&&(f2=f2.replace(N,""));g2=f2.charCodeAt(1);switch(g2){case 100:case 109:case 115:case 45:r2=c2;break;default:r2=O;}k2=M(c2,r2,k2,g2,a+1);t2=k2.length;0<A2&&(r2=X(O,f2,I2),C2=H2(3,k2,r2,c2,D2,z2,t2,g2,a,h2),f2=r2.join(""),C2!==void 0&&(t2=(k2=C2.trim()).length)===0&&(g2=0,k2=""));if(0<t2)switch(g2){case 115:f2=f2.replace(da,ea);case 100:case 109:case 45:k2=f2+"{"+k2+"}";break;case 107:f2=f2.replace(fa,"$1 $2");k2=f2+"{"+k2+"}";k2=w2===1||w2===2&&L("@"+k2,3)?"@-webkit-"+k2+"@"+k2:"@"+k2;break;default:k2=f2+k2,h2===112&&(k2=(p2+=k2,""));}else k2="";break;default:k2=M(c2,X(c2,f2,I2),k2,h2,a+1);}F3+=k2;k2=I2=r2=u2=q2=0;f2="";g2=e2.charCodeAt(++l2);break;case 125:case 59:f2=(0<r2?f2.replace(N,""):f2).trim();if(1<(t2=f2.length))switch(u2===0&&(q2=f2.charCodeAt(0),q2===45||96<q2&&123>q2)&&(t2=(f2=f2.replace(" ",":")).length),0<A2&&(C2=H2(1,f2,c2,d2,D2,z2,p2.length,h2,a,h2))!==void 0&&(t2=(f2=C2.trim()).length)===0&&(f2="\0\0"),q2=f2.charCodeAt(0),g2=f2.charCodeAt(1),q2){case 0:break;case 64:if(g2===105||g2===99){G3+=f2+e2.charAt(l2);break;}default:f2.charCodeAt(t2-1)!==58&&(p2+=P(f2,q2,g2,f2.charCodeAt(2)));}I2=r2=u2=q2=0;f2="";g2=e2.charCodeAt(++l2);}}switch(g2){case 13:case 10:b2===47?b2=0:1+q2===0&&h2!==107&&0<f2.length&&(r2=1,f2+="\0");0<A2*Y&&H2(0,f2,c2,d2,D2,z2,p2.length,h2,a,h2);z2=1;D2++;break;case 59:case 125:if(b2+n2+v2+m2===0){z2++;break;}default:z2++;y2=e2.charAt(l2);switch(g2){case 9:case 32:if(n2+m2+b2===0)switch(x){case 44:case 58:case 9:case 32:y2="";break;default:g2!==32&&(y2=" ");}break;case 0:y2="\\0";break;case 12:y2="\\f";break;case 11:y2="\\v";break;case 38:n2+b2+m2===0&&(r2=I2=1,y2="\f"+y2);break;case 108:if(n2+b2+m2+E2===0&&0<u2)switch(l2-u2){case 2:x===112&&e2.charCodeAt(l2-3)===58&&(E2=x);case 8:K===111&&(E2=K);}break;case 58:n2+b2+m2===0&&(u2=l2);break;case 44:b2+v2+n2+m2===0&&(r2=1,y2+="\r");break;case 34:case 39:b2===0&&(n2=n2===g2?0:n2===0?g2:n2);break;case 91:n2+b2+v2===0&&m2++;break;case 93:n2+b2+v2===0&&m2--;break;case 41:n2+b2+m2===0&&v2--;break;case 40:if(n2+b2+m2===0){if(q2===0)switch(2*x+3*K){case 533:break;default:q2=1;}v2++;}break;case 64:b2+v2+n2+m2+u2+k2===0&&(k2=1);break;case 42:case 47:if(!(0<n2+m2+v2))switch(b2){case 0:switch(2*g2+3*e2.charCodeAt(l2+1)){case 235:b2=47;break;case 220:t2=l2,b2=42;}break;case 42:g2===47&&x===42&&t2+2!==l2&&(e2.charCodeAt(t2+2)===33&&(p2+=e2.substring(t2,l2+1)),y2="",b2=0);}}b2===0&&(f2+=y2);}K=x;x=g2;l2++;}t2=p2.length;if(0<t2){r2=c2;if(0<A2&&(C2=H2(2,p2,r2,d2,D2,z2,t2,h2,a,h2),C2!==void 0&&(p2=C2).length===0))return G3+p2+F3;p2=r2.join(",")+"{"+p2+"}";if(w2*E2!==0){w2!==2||L(p2,2)||(E2=0);switch(E2){case 111:p2=p2.replace(ha,":-moz-$1")+p2;break;case 112:p2=p2.replace(Q,"::-webkit-input-$1")+p2.replace(Q,"::-moz-$1")+p2.replace(Q,":-ms-input-$1")+p2;}E2=0;}}return G3+p2+F3;}function X(d2,c2,e2){var h2=c2.trim().split(ia);c2=h2;var a=h2.length,m2=d2.length;switch(m2){case 0:case 1:var b2=0;for(d2=m2===0?"":d2[0]+" ";b2<a;++b2){c2[b2]=Z(d2,c2[b2],e2).trim();}break;default:var v2=b2=0;for(c2=[];b2<a;++b2){for(var n2=0;n2<m2;++n2){c2[v2++]=Z(d2[n2]+" ",h2[b2],e2).trim();}}}return c2;}function Z(d2,c2,e2){var h2=c2.charCodeAt(0);33>h2&&(h2=(c2=c2.trim()).charCodeAt(0));switch(h2){case 38:return c2.replace(F2,"$1"+d2.trim());case 58:return d2.trim()+c2.replace(F2,"$1"+d2.trim());default:if(0<1*e2&&0<c2.indexOf("\f"))return c2.replace(F2,(d2.charCodeAt(0)===58?"":"$1")+d2.trim());}return d2+c2;}function P(d2,c2,e2,h2){var a=d2+";",m2=2*c2+3*e2+4*h2;if(m2===944){d2=a.indexOf(":",9)+1;var b2=a.substring(d2,a.length-1).trim();b2=a.substring(0,d2).trim()+b2+";";return w2===1||w2===2&&L(b2,1)?"-webkit-"+b2+b2:b2;}if(w2===0||w2===2&&!L(a,1))return a;switch(m2){case 1015:return a.charCodeAt(10)===97?"-webkit-"+a+a:a;case 951:return a.charCodeAt(3)===116?"-webkit-"+a+a:a;case 963:return a.charCodeAt(5)===110?"-webkit-"+a+a:a;case 1009:if(a.charCodeAt(4)!==100)break;case 969:case 942:return"-webkit-"+a+a;case 978:return"-webkit-"+a+"-moz-"+a+a;case 1019:case 983:return"-webkit-"+a+"-moz-"+a+"-ms-"+a+a;case 883:if(a.charCodeAt(8)===45)return"-webkit-"+a+a;if(0<a.indexOf("image-set(",11))return a.replace(ja,"$1-webkit-$2")+a;break;case 932:if(a.charCodeAt(4)===45)switch(a.charCodeAt(5)){case 103:return"-webkit-box-"+a.replace("-grow","")+"-webkit-"+a+"-ms-"+a.replace("grow","positive")+a;case 115:return"-webkit-"+a+"-ms-"+a.replace("shrink","negative")+a;case 98:return"-webkit-"+a+"-ms-"+a.replace("basis","preferred-size")+a;}return"-webkit-"+a+"-ms-"+a+a;case 964:return"-webkit-"+a+"-ms-flex-"+a+a;case 1023:if(a.charCodeAt(8)!==99)break;b2=a.substring(a.indexOf(":",15)).replace("flex-","").replace("space-between","justify");return"-webkit-box-pack"+b2+"-webkit-"+a+"-ms-flex-pack"+b2+a;case 1005:return ka.test(a)?a.replace(aa,":-webkit-")+a.replace(aa,":-moz-")+a:a;case 1e3:b2=a.substring(13).trim();c2=b2.indexOf("-")+1;switch(b2.charCodeAt(0)+b2.charCodeAt(c2)){case 226:b2=a.replace(G2,"tb");break;case 232:b2=a.replace(G2,"tb-rl");break;case 220:b2=a.replace(G2,"lr");break;default:return a;}return"-webkit-"+a+"-ms-"+b2+a;case 1017:if(a.indexOf("sticky",9)===-1)break;case 975:c2=(a=d2).length-10;b2=(a.charCodeAt(c2)===33?a.substring(0,c2):a).substring(d2.indexOf(":",7)+1).trim();switch(m2=b2.charCodeAt(0)+(b2.charCodeAt(7)|0)){case 203:if(111>b2.charCodeAt(8))break;case 115:a=a.replace(b2,"-webkit-"+b2)+";"+a;break;case 207:case 102:a=a.replace(b2,"-webkit-"+(102<m2?"inline-":"")+"box")+";"+a.replace(b2,"-webkit-"+b2)+";"+a.replace(b2,"-ms-"+b2+"box")+";"+a;}return a+";";case 938:if(a.charCodeAt(5)===45)switch(a.charCodeAt(6)){case 105:return b2=a.replace("-items",""),"-webkit-"+a+"-webkit-box-"+b2+"-ms-flex-"+b2+a;case 115:return"-webkit-"+a+"-ms-flex-item-"+a.replace(ba,"")+a;default:return"-webkit-"+a+"-ms-flex-line-pack"+a.replace("align-content","").replace(ba,"")+a;}break;case 973:case 989:if(a.charCodeAt(3)!==45||a.charCodeAt(4)===122)break;case 931:case 953:if(la.test(d2)===true)return(b2=d2.substring(d2.indexOf(":")+1)).charCodeAt(0)===115?P(d2.replace("stretch","fill-available"),c2,e2,h2).replace(":fill-available",":stretch"):a.replace(b2,"-webkit-"+b2)+a.replace(b2,"-moz-"+b2.replace("fill-",""))+a;break;case 962:if(a="-webkit-"+a+(a.charCodeAt(5)===102?"-ms-"+a:"")+a,e2+h2===211&&a.charCodeAt(13)===105&&0<a.indexOf("transform",10))return a.substring(0,a.indexOf(";",27)+1).replace(ma,"$1-webkit-$2")+a;}return a;}function L(d2,c2){var e2=d2.indexOf(c2===1?":":"{"),h2=d2.substring(0,c2!==3?e2:10);e2=d2.substring(e2+1,d2.length-1);return R(c2!==2?h2:h2.replace(na,"$1"),e2,c2);}function ea(d2,c2){var e2=P(c2,c2.charCodeAt(0),c2.charCodeAt(1),c2.charCodeAt(2));return e2!==c2+";"?e2.replace(oa," or ($1)").substring(4):"("+c2+")";}function H2(d2,c2,e2,h2,a,m2,b2,v2,n2,q2){for(var g2=0,x=c2,w3;g2<A2;++g2){switch(w3=S[g2].call(B2,d2,x,e2,h2,a,m2,b2,v2,n2,q2)){case void 0:case false:case true:case null:break;default:x=w3;}}if(x!==c2)return x;}function T(d2){switch(d2){case void 0:case null:A2=S.length=0;break;default:if(typeof d2==="function")S[A2++]=d2;else if(_typeof2(d2)==="object")for(var c2=0,e2=d2.length;c2<e2;++c2){T(d2[c2]);}else Y=!!d2|0;}return T;}function U(d2){d2=d2.prefix;d2!==void 0&&(R=null,d2?typeof d2!=="function"?w2=1:(w2=2,R=d2):w2=0);return U;}function B2(d2,c2){var e2=d2;33>e2.charCodeAt(0)&&(e2=e2.trim());V=e2;e2=[V];if(0<A2){var h2=H2(-1,c2,e2,e2,D2,z2,0,0,0,0);h2!==void 0&&typeof h2==="string"&&(c2=h2);}var a=M(O,e2,c2,0,0);0<A2&&(h2=H2(-2,a,e2,e2,D2,z2,a.length,0,0,0),h2!==void 0&&(a=h2));V="";E2=0;z2=D2=1;return a;}var ca=/^\0+/g,N=/[\0\r\f]/g,aa=/: */g,ka=/zoo|gra/,ma=/([,: ])(transform)/g,ia=/,\r+?/g,F2=/([\t\r\n ])*\f?&/g,fa=/@(k\w+)\s*(\S*)\s*/,Q=/::(place)/g,ha=/:(read-only)/g,G2=/[svh]\w+-[tblr]{2}/,da=/\(\s*(.*)\s*\)/g,oa=/([\s\S]*?);/g,ba=/-self|flex-/g,na=/[^]*?(:[rp][el]a[\w-]+)[^]*/,la=/stretch|:\s*\w+\-(?:conte|avail)/,ja=/([^-])(image-set\()/,z2=1,D2=1,E2=0,w2=1,O=[],S=[],A2=0,R=null,Y=0,V="";B2.use=T;B2.set=U;W!==void 0&&U(W);return B2;}var delimiter="/*|*/";var needle=delimiter+"}";function toSheet(block2){if(block2){Sheet.current.insert(block2+"}");}}var Sheet={current:null};var ruleSheet=function ruleSheet2(context,content,selectors,parents,line,column,length,ns,depth,at){switch(context){case 1:{switch(content.charCodeAt(0)){case 64:{Sheet.current.insert(content+";");return"";}case 108:{if(content.charCodeAt(2)===98){return"";}}}break;}case 2:{if(ns===0)return content+delimiter;break;}case 3:{switch(ns){case 102:case 112:{Sheet.current.insert(selectors[0]+content);return"";}default:{return content+(at===0?delimiter:"");}}}case-2:{content.split(needle).forEach(toSheet);}}};var createCache=function createCache2(options){if(options===void 0)options={};var key2=options.key||"css";var stylisOptions;if(options.prefix!==void 0){stylisOptions={prefix:options.prefix};}var stylis=new stylis_min(stylisOptions);var inserted={};var container;{container=options.container||document.head;var nodes=document.querySelectorAll("style[data-emotion-"+key2+"]");Array.prototype.forEach.call(nodes,function(node){var attrib=node.getAttribute("data-emotion-"+key2);attrib.split(" ").forEach(function(id){inserted[id]=true;});if(node.parentNode!==container){container.appendChild(node);}});}var _insert;{stylis.use(options.stylisPlugins)(ruleSheet);_insert=function insert2(selector,serialized,sheet,shouldCache){var name=serialized.name;Sheet.current=sheet;stylis(selector,serialized.styles);if(shouldCache){cache.inserted[name]=true;}};}var cache={key:key2,sheet:new StyleSheet({key:key2,container:container,nonce:options.nonce,speedy:options.speedy}),nonce:options.nonce,inserted:inserted,registered:{},insert:_insert};return cache;};var hasOwnProperty$2=Object.prototype.hasOwnProperty;var EmotionCacheContext=/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(typeof HTMLElement!=="undefined"?createCache():null);var ThemeContext=/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});EmotionCacheContext.Provider;var withEmotionCache=function withEmotionCache2(func){var render3=function render4(props,ref){return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(EmotionCacheContext.Consumer,null,function(cache){return func(props,cache,ref);});};return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(render3);};var typePropName="__EMOTION_TYPE_PLEASE_DO_NOT_USE__";var createEmotionProps=function createEmotionProps2(type,props){var newProps={};for(var key2 in props){if(hasOwnProperty$2.call(props,key2)){newProps[key2]=props[key2];}}newProps[typePropName]=type;return newProps;};var render=function render2(cache,props,theme,ref){var cssProp=theme===null?props.css:props.css(theme);if(typeof cssProp==="string"&&cache.registered[cssProp]!==void 0){cssProp=cache.registered[cssProp];}var type=props[typePropName];var registeredStyles=[cssProp];var className="";if(typeof props.className==="string"){className=getRegisteredStyles(cache.registered,registeredStyles,props.className);}else if(props.className!=null){className=props.className+" ";}var serialized=serializeStyles(registeredStyles);insertStyles(cache,serialized,typeof type==="string");className+=cache.key+"-"+serialized.name;var newProps={};for(var key2 in props){if(hasOwnProperty$2.call(props,key2)&&key2!=="css"&&key2!==typePropName&&true){newProps[key2]=props[key2];}}newProps.ref=ref;newProps.className=className;var ele=/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(type,newProps);return ele;};var Emotion=/* @__PURE__ */withEmotionCache(function(props,cache,ref){if(typeof props.css==="function"){return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ThemeContext.Consumer,null,function(theme){return render(cache,props,theme,ref);});}return render(cache,props,null,ref);});var jsxRuntime={exports:{}};var reactJsxRuntime_production_min={};/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var f$1=__WEBPACK_IMPORTED_MODULE_0_react___default.a,g$1=60103;reactJsxRuntime_production_min.Fragment=60107;if(typeof Symbol==="function"&&Symbol["for"]){var h$1=Symbol["for"];g$1=h$1("react.element");reactJsxRuntime_production_min.Fragment=h$1("react.fragment");}var m$1=f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n$2=Object.prototype.hasOwnProperty,p$1={key:true,ref:true,__self:true,__source:true};function q$1(c2,a,k2){var b2,d2={},e2=null,l2=null;k2!==void 0&&(e2=""+k2);a.key!==void 0&&(e2=""+a.key);a.ref!==void 0&&(l2=a.ref);for(b2 in a)n$2.call(a,b2)&&!p$1.hasOwnProperty(b2)&&(d2[b2]=a[b2]);if(c2&&c2.defaultProps)for(b2 in a=c2.defaultProps,a)d2[b2]===void 0&&(d2[b2]=a[b2]);return{$$typeof:g$1,type:c2,key:e2,ref:l2,props:d2,_owner:m$1.current};}reactJsxRuntime_production_min.jsx=q$1;reactJsxRuntime_production_min.jsxs=q$1;{jsxRuntime.exports=reactJsxRuntime_production_min;}var jsx$1=jsxRuntime.exports.jsx;var jsxs$1=jsxRuntime.exports.jsxs;var Fragment$1=jsxRuntime.exports.Fragment;var Fragment=Fragment$1;function jsx(type,props,key2){if(!hasOwnProperty$2.call(props,"css")){return jsx$1(type,props,key2);}return jsx$1(Emotion,createEmotionProps(type,props),key2);}function jsxs(type,props,key2){if(!hasOwnProperty$2.call(props,"css")){return jsxs$1(type,props,key2);}return jsxs$1(Emotion,createEmotionProps(type,props),key2);}var FILTERED_PROPS=["size","ref"];var namedColor=function namedColor(colorName,fallback){return function(_a2){var _b=_a2,theme=_b.theme,props=__objRest(_b,["theme"]);return color(props[colorName],{theme:theme})||props[colorName]||fallback;};};var size$d=function size$d(_ref26){var theme=_ref26.theme,size2=_ref26.size;return theme.font.size[size2]||size2||"1.5rem";};var SVGIcon=/* @__PURE__ */createStyled("svg",{shouldForwardProp:function shouldForwardProp(prop2){return FILTERED_PROPS.indexOf(prop2)===-1;},target:"ejdg20h0"})("color:",namedColor("color","currentColor"),";fill:",namedColor("fill","none"),";width:",size$d,";height:",size$d,";cursor:",prop("cursor"),";stroke:currentColor;pointer-events:",prop("pointerEvents"),";vertical-align:middle;");var SVGIconWithDefaults=function SVGIconWithDefaults(_a2){var _b=_a2,_b$viewBox=_b.viewBox,viewBox2=_b$viewBox===void 0?"0 0 24 24":_b$viewBox,_b$xmlns=_b.xmlns,xmlns=_b$xmlns===void 0?"http://www.w3.org/2000/svg":_b$xmlns,props=__objRest(_b,["viewBox","xmlns"]);return/* @__PURE__ */jsx(SVGIcon,__spreadProps(__spreadValues({},props),{viewBox:viewBox2,xmlns:xmlns}));};var FeatherSVG=/* @__PURE__ */createStyled(SVGIconWithDefaults,{target:"enr5cwd0"})("stroke-width:",compose(defaultTo(2),prop("strokeWidth")),";stroke-linecap:round;stroke-linejoin:round;");var AlertCircle=function AlertCircle(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"alert-circle"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"10"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"8",x2:"12",y2:"12"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"16",x2:"12",y2:"16"})]}));};var AlertTriangle=function AlertTriangle(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"warning"}),/* @__PURE__ */jsx("path",{d:"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"9",x2:"12",y2:"13"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"17",x2:"12",y2:"17"})]}));};var Archive=function Archive(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"archive"}),/* @__PURE__ */jsx("polyline",{points:"21 8 21 21 3 21 3 8"}),/* @__PURE__ */jsx("rect",{x:"1",y:"3",width:"22",height:"5"}),/* @__PURE__ */jsx("line",{x1:"10",y1:"12",x2:"14",y2:"12"})]}));};var DIRECTIONS$1={up:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("line",{x1:"12",y1:"19",x2:"12",y2:"5"}),/* @__PURE__ */jsx("polyline",{points:"5 12 12 5 19 12"})]}),down:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("line",{x1:"12",y1:"5",x2:"12",y2:"19"}),/* @__PURE__ */jsx("polyline",{points:"19 12 12 19 5 12"})]}),left:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("line",{x1:"19",y1:"12",x2:"5",y2:"12"}),/* @__PURE__ */jsx("polyline",{points:"12 19 5 12 12 5"})]}),right:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("line",{x1:"5",y1:"12",x2:"19",y2:"12"}),/* @__PURE__ */jsx("polyline",{points:"12 5 19 12 12 19"})]})};var Arrow=function Arrow(_c){var _d=_c,direction=_d.direction,props=__objRest(_d,["direction"]);return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsxs("title",{children:["arrow-",direction]}),DIRECTIONS$1[direction]]}));};var Bookmark=function Bookmark(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"bookmark"}),/* @__PURE__ */jsx("path",{d:"M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"})]}));};var Calendar$1=function Calendar$1(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("rect",{x:"3",y:"4",width:"18",height:"18",rx:"2",ry:"2"}),/* @__PURE__ */jsx("line",{x1:"16",y1:"2",x2:"16",y2:"6"}),/* @__PURE__ */jsx("line",{x1:"8",y1:"2",x2:"8",y2:"6"}),/* @__PURE__ */jsx("line",{x1:"3",y1:"10",x2:"21",y2:"10"})]}));};var Cancel$2=function Cancel$2(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"cancel"}),/* @__PURE__ */jsx("line",{x1:"18",y1:"6",x2:"6",y2:"18"}),/* @__PURE__ */jsx("line",{x1:"6",y1:"6",x2:"18",y2:"18"})]}));};var Caret$2=function Caret$2(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({fill:"currentColor",strokeWidth:0},props),{children:[/* @__PURE__ */jsx("title",{children:"caret"}),/* @__PURE__ */jsx("path",{d:"M0 6h24L12 18z"})]}));};var Chat=function Chat(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"chat"}),/* @__PURE__ */jsx("path",{d:"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"})]}));};var CheckCircle=function CheckCircle(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"check-circle"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"10"}),/* @__PURE__ */jsx("polyline",{points:"17 9 11 16.01 8 13.01"})]}));};var Check=function Check(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"check"}),/* @__PURE__ */jsx("polyline",{points:"20 6 9 17 4 12"})]}));};var pathFor$1=function pathFor$1(direction){switch(direction){case"down":return/* @__PURE__ */jsx("polyline",{points:"6 9 12 15 18 9"});case"left":return/* @__PURE__ */jsx("polyline",{points:"15 18 9 12 15 6"});case"up":return/* @__PURE__ */jsx("polyline",{points:"18 15 12 9 6 15"});case"right":return/* @__PURE__ */jsx("polyline",{points:"9 18 15 12 9 6"});default:throw new Error("invalid direction");}};var Chevron$1=function Chevron$1(_e){var _f=_e,direction=_f.direction,props=__objRest(_f,["direction"]);return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsxs("title",{children:["chevron-",direction]}),pathFor$1(direction)]}));};var Copy=function Copy(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"copy"}),/* @__PURE__ */jsx("rect",{x:"9",y:"9",width:"13",height:"13",rx:"2",ry:"2"}),/* @__PURE__ */jsx("path",{d:"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"})]}));};var Disc=function Disc(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"disc"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"10"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"3"})]}));};var Download=function Download(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"download"}),/* @__PURE__ */jsx("path",{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}),/* @__PURE__ */jsx("polyline",{points:"7 10 12 15 17 10"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"15",x2:"12",y2:"3"})]}));};var Edit=function Edit(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"edit"}),/* @__PURE__ */jsx("polygon",{points:"16 3 21 8 8 21 3 21 3 16 16 3"})]}));};var ExternalLink=function ExternalLink(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"external-link"}),/* @__PURE__ */jsx("path",{d:"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"}),/* @__PURE__ */jsx("polyline",{points:"15 3 21 3 21 9"}),/* @__PURE__ */jsx("line",{x1:"10",y1:"14",x2:"21",y2:"3"})]}));};var File=function File(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"file"}),/* @__PURE__ */jsx("path",{d:"M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"}),/* @__PURE__ */jsx("polyline",{points:"13 2 13 9 20 9"})]}));};var FilePlus=function FilePlus(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"file-plus"}),/* @__PURE__ */jsx("path",{d:"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"}),/* @__PURE__ */jsx("polyline",{points:"14 2 14 8 20 8"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"18",x2:"12",y2:"12"}),/* @__PURE__ */jsx("line",{x1:"9",y1:"15",x2:"15",y2:"15"})]}));};var Hamburger=function Hamburger(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"hamburger"}),/* @__PURE__ */jsx("line",{x1:"3",y1:"12",x2:"21",y2:"12"}),/* @__PURE__ */jsx("line",{x1:"3",y1:"6",x2:"21",y2:"6"}),/* @__PURE__ */jsx("line",{x1:"3",y1:"18",x2:"21",y2:"18"})]}));};Hamburger.defaultProps={cursor:"pointer"};var Hash$1=function Hash$1(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"hash"}),/* @__PURE__ */jsx("line",{x1:"4",y1:"9",x2:"20",y2:"9"}),/* @__PURE__ */jsx("line",{x1:"4",y1:"15",x2:"20",y2:"15"}),/* @__PURE__ */jsx("line",{x1:"10",y1:"3",x2:"8",y2:"21"}),/* @__PURE__ */jsx("line",{x1:"16",y1:"3",x2:"14",y2:"21"})]}));};var Help=function Help(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"help"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"10"}),/* @__PURE__ */jsx("path",{d:"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"17",x2:"12",y2:"17"})]}));};var Home=function Home(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"home"}),/* @__PURE__ */jsx("path",{d:"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"}),/* @__PURE__ */jsx("polyline",{points:"9 22 9 12 15 12 15 22"})]}));};var Image$1=function Image$1(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"image"}),/* @__PURE__ */jsx("rect",{x:"3",y:"3",width:"18",height:"18",rx:"2",ry:"2"}),/* @__PURE__ */jsx("circle",{cx:"8.5",cy:"8.5",r:"1.5"}),/* @__PURE__ */jsx("polyline",{points:"21 15 16 10 5 21"})]}));};var Info=function Info(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"info"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"10"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"16",x2:"12",y2:"12"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"8",x2:"12",y2:"8"})]}));};var Lock$1=function Lock$1(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"lock"}),/* @__PURE__ */jsx("rect",{x:"3",y:"11",width:"18",height:"11",rx:"2",ry:"2"}),/* @__PURE__ */jsx("path",{d:"M7 11V7a5 5 0 0 1 10 0v4"})]}));};var Maximize=function Maximize(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"maximize"}),/* @__PURE__ */jsx("polyline",{points:"15 3 21 3 21 9"}),/* @__PURE__ */jsx("polyline",{points:"9 21 3 21 3 15"}),/* @__PURE__ */jsx("line",{x1:"21",y1:"3",x2:"14",y2:"10"}),/* @__PURE__ */jsx("line",{x1:"3",y1:"21",x2:"10",y2:"14"})]}));};var Minimize=function Minimize(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"minimize"}),/* @__PURE__ */jsx("polyline",{points:"4 14 10 14 10 20"}),/* @__PURE__ */jsx("polyline",{points:"20 10 14 10 14 4"}),/* @__PURE__ */jsx("line",{x1:"14",y1:"10",x2:"21",y2:"3"}),/* @__PURE__ */jsx("line",{x1:"3",y1:"21",x2:"10",y2:"14"})]}));};var DIRECTIONS={horizontal:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"1"}),/* @__PURE__ */jsx("circle",{cx:"19",cy:"12",r:"1"}),/* @__PURE__ */jsx("circle",{cx:"5",cy:"12",r:"1"})]}),vertical:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"1"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"5",r:"1"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"19",r:"1"})]})};var More=function More(_g){var _h=_g,direction=_h.direction,title=_h.title,props=__objRest(_h,["direction","title"]);return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),DIRECTIONS[direction]]}));};More.defaultProps={direction:"horizontal",title:"More"};var Play=function Play(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"play"}),/* @__PURE__ */jsx("polygon",{points:"5 3 19 12 5 21 5 3"})]}));};var Plus=function Plus(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"plus"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"5",x2:"12",y2:"19"}),/* @__PURE__ */jsx("line",{x1:"5",y1:"12",x2:"19",y2:"12"})]}));};var svgFor$1=function svgFor$1(direction){switch(direction){case"cw":return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("polyline",{points:"23 4 23 10 17 10"}),/* @__PURE__ */jsx("polyline",{points:"1 20 1 14 7 14"}),/* @__PURE__ */jsx("path",{d:"M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"})]});case"ccw":return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("polyline",{points:"1 4 1 10 7 10"}),/* @__PURE__ */jsx("polyline",{points:"23 20 23 14 17 14"}),/* @__PURE__ */jsx("path",{d:"M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"})]});default:throw new Error("invalid direction. Valid options are 'cw', 'ccw'");}};var Refresh=function Refresh(_i){var _j=_i,direction=_j.direction,props=__objRest(_j,["direction"]);return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsxs("title",{children:["refresh-",direction]}),svgFor$1(direction)]}));};var svgFor=function svgFor(direction){switch(direction){case"cw":return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("polyline",{points:"23 4 23 10 17 10"}),/* @__PURE__ */jsx("path",{d:"M20.49 15a9 9 0 1 1-2.12-9.36L23 10"})]});case"ccw":return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx("polyline",{points:"1 4 1 10 7 10"}),/* @__PURE__ */jsx("path",{d:"M3.51 15a9 9 0 1 0 2.13-9.36L1 10"})]});default:throw new Error("invalid direction. Valid options are 'cw', 'ccw'");}};var Rotate=function Rotate(_k){var _l=_k,direction=_l.direction,props=__objRest(_l,["direction"]);return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsxs("title",{children:["rotate-",direction]}),svgFor(direction)]}));};var Save=function Save(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"save"}),/* @__PURE__ */jsx("path",{d:"M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"}),/* @__PURE__ */jsx("polyline",{points:"17 21 17 13 7 13 7 21"}),/* @__PURE__ */jsx("polyline",{points:"7 3 7 8 15 8"})]}));};var Search=function Search(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"search"}),/* @__PURE__ */jsx("circle",{cx:"11",cy:"11",r:"8"}),/* @__PURE__ */jsx("line",{x1:"21",y1:"21",x2:"16.65",y2:"16.65"})]}));};var Settings=function Settings(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"settings"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"3"}),/* @__PURE__ */jsx("path",{d:"M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"})]}));};var Share=function Share(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"share"}),/* @__PURE__ */jsx("circle",{cx:"18",cy:"5",r:"3"}),/* @__PURE__ */jsx("circle",{cx:"6",cy:"12",r:"3"}),/* @__PURE__ */jsx("circle",{cx:"18",cy:"19",r:"3"}),/* @__PURE__ */jsx("line",{x1:"8.59",y1:"13.51",x2:"15.42",y2:"17.49"}),/* @__PURE__ */jsx("line",{x1:"15.41",y1:"6.51",x2:"8.59",y2:"10.49"})]}));};var Slash=function Slash(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"slash"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"12",r:"10"}),/* @__PURE__ */jsx("line",{x1:"4.93",y1:"4.93",x2:"19.07",y2:"19.07"})]}));};var Sort=function Sort(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"sort"}),/* @__PURE__ */jsx("polyline",{points:"10 6 6 2 2 6"}),/* @__PURE__ */jsx("line",{x1:"6",y1:"2",x2:"6",y2:"18"}),/* @__PURE__ */jsx("polyline",{points:"22 18 18 22 14 18"}),/* @__PURE__ */jsx("line",{x1:"18",y1:"22",x2:"18",y2:"6"})]}));};var Star=function Star(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"star"}),/* @__PURE__ */jsx("polygon",{points:"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"})]}));};var pathFor=function pathFor(direction){switch(direction){case"up":return"M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3";case"down":return"M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17";default:throw new Error('invalid direction. Supported values are ["up", "down"]');}};var Thumb=function Thumb(_m){var _n=_m,direction=_n.direction,props=__objRest(_n,["direction"]);return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsxs("title",{children:["thumbs-",direction]}),/* @__PURE__ */jsx("path",{d:pathFor(direction)})]}));};var Trash=function Trash(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"trash"}),/* @__PURE__ */jsx("polyline",{points:"3 6 5 6 21 6"}),/* @__PURE__ */jsx("path",{d:"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"}),/* @__PURE__ */jsx("line",{x1:"10",y1:"11",x2:"10",y2:"17"}),/* @__PURE__ */jsx("line",{x1:"14",y1:"11",x2:"14",y2:"17"})]}));};var Upload=function Upload(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"upload"}),/* @__PURE__ */jsx("path",{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}),/* @__PURE__ */jsx("polyline",{points:"17 8 12 3 7 8"}),/* @__PURE__ */jsx("line",{x1:"12",y1:"3",x2:"12",y2:"15"})]}));};var User=function User(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"user"}),/* @__PURE__ */jsx("path",{d:"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"}),/* @__PURE__ */jsx("circle",{cx:"12",cy:"7",r:"4"})]}));};var UserPlus=function UserPlus(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"user-plus"}),/* @__PURE__ */jsx("path",{d:"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"}),/* @__PURE__ */jsx("circle",{cx:"8.5",cy:"7",r:"4"}),/* @__PURE__ */jsx("line",{x1:"20",y1:"8",x2:"20",y2:"14"}),/* @__PURE__ */jsx("line",{x1:"23",y1:"11",x2:"17",y2:"11"})]}));};var Users=function Users(props){return/* @__PURE__ */jsxs(FeatherSVG,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:"users"}),/* @__PURE__ */jsx("path",{d:"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"}),/* @__PURE__ */jsx("circle",{cx:"9",cy:"7",r:"4"}),/* @__PURE__ */jsx("path",{d:"M23 21v-2a4 4 0 0 0-3-3.87"}),/* @__PURE__ */jsx("path",{d:"M16 3.13a4 4 0 0 1 0 7.75"})]}));};var SVGIconV2=/* @__PURE__ */createStyled(SVGIconWithDefaults,{target:"e1snhfbx0"})("fill:initial;",function(_ref27){var fill=_ref27.fill;return fill&&"\n  fill: ".concat(fill," !important;\n");}," stroke:initial;");var AlertCircleV2=function AlertCircleV2(_o){var _p=_o,_p$title=_p.title,title=_p$title===void 0?"alert-circle":_p$title,props=__objRest(_p,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",fill:"#16263B"})]}));};var AppSelect=function AppSelect(_q){var _r=_q,_r$title=_r.title,title=_r$title===void 0?"app-select":_r$title,props=__objRest(_r,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z",fill:"#16263B"})]}));};var _ref$h={name:"1qx34im",styles:"transform:rotate(90deg);"};var _ref2$b={name:"4ky835",styles:"transform:rotate(180deg);"};var _ref3$2={name:"jbc4oa",styles:"transform:rotate(270deg);"};var directionCss=function directionCss(_ref28){var direction=_ref28.direction;switch(direction){case"left":return _ref$h;case"up":return _ref2$b;case"right":return _ref3$2;case"down":default:return null;}};var RotatedSvg=/* @__PURE__ */createStyled(SVGIconV2,{target:"ecswwxs0"})(directionCss,";");var Chevron=function Chevron(_s){var _t=_s,_t$title=_t.title,title=_t$title===void 0?"chevron":_t$title,props=__objRest(_t,["title"]);return/* @__PURE__ */jsxs(RotatedSvg,__spreadProps(__spreadValues({},props),{viewBox:"0 0 8 6",size:"8px",children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M7.06 0.726685L4 3.78002L0.94 0.726685L0 1.66668L4 5.66668L8 1.66668L7.06 0.726685Z"})]}));};var BellFill=function BellFill(_u){var _v=_u,_v$title=_v.title,title=_v$title===void 0?"bell-fill":_v$title,props=__objRest(_v,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"})]}));};var ExternalLinkIconV2=function ExternalLinkIconV2(_w){var _x=_w,_x$title=_x.title,title=_x$title===void 0?"external-link":_x$title,props=__objRest(_x,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"})]}));};var HelpIconV2=function HelpIconV2(_y){var _z=_y,_z$title=_z.title,title=_z$title===void 0?"help-icon":_z$title,props=__objRest(_z,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",fill:"#16263B"})]}));};var QuestionMarkCircleIcon=function QuestionMarkCircleIcon(_A){var _B=_A,_B$title=_B.title,title=_B$title===void 0?"question-mark-circle":_B$title,_B$viewBox=_B.viewBox,viewBox2=_B$viewBox===void 0?"0 0 20 20":_B$viewBox,_B$size=_B.size,size2=_B$size===void 0?"1.25rem":_B$size,props=__objRest(_B,["title","viewBox","size"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({viewBox:viewBox2,size:size2},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"})]}));};var Bell=function Bell(_C){var _D=_C,_D$title=_D.title,title=_D$title===void 0?"bell":_D$title,_D$viewBox=_D.viewBox,viewBox2=_D$viewBox===void 0?"0 0 40 40":_D$viewBox,_D$size=_D.size,size2=_D$size===void 0?"2.5rem":_D$size,props=__objRest(_D,["title","viewBox","size"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({viewBox:viewBox2,size:size2},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M20 30C21.1 30 22 29.1 22 28H18C18 29.1 18.9 30 20 30ZM26 24V19C26 15.93 24.37 13.36 21.5 12.68V12C21.5 11.17 20.83 10.5 20 10.5C19.17 10.5 18.5 11.17 18.5 12V12.68C15.64 13.36 14 15.92 14 19V24L12 26V27H28V26L26 24ZM24 25H16V19C16 16.52 17.51 14.5 20 14.5C22.49 14.5 24 16.52 24 19V25Z"})]}));};var Key=function Key(_E){var _F=_E,_F$title=_F.title,title=_F$title===void 0?"key":_F$title,props=__objRest(_F,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"})]}));};var Lock=function Lock(_G){var _H=_G,_H$title=_H.title,title=_H$title===void 0?"lock":_H$title,props=__objRest(_H,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"})]}));};var MobileFiendly=function MobileFiendly(_I){var _J=_I,_J$title=_J.title,title=_J$title===void 0?"mobile-friendly":_J$title,props=__objRest(_J,["title"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z",fill:"#16263B"})]}));};var COLORS={success:"lightGreen",error:"lightRed",warning:"lightOrange",info:"lightBlue"};var Container$k=createStyled("div",{target:"egbmxq40"})("display:flex;align-items:center;color:",color("slate"),";background:",function(_ref29){var kind2=_ref29.kind,theme=_ref29.theme;return color(COLORS[kind2],{theme:theme});},";",padding("xs"),";",borderRadius$1("sm"),";svg{margin-right:",spacer(3),";vertical-align:middle;width:1.5rem;height:1.5rem;}");Container$k.displayName="Alert.Container";var Icon$2=function Icon$2(_ref30){var kind2=_ref30.kind;switch(kind2){case"error":return/* @__PURE__ */jsx(AlertCircle,{color:"red"});case"info":return/* @__PURE__ */jsx(Info,{color:"blue"});case"success":return/* @__PURE__ */jsx(CheckCircle,{color:"green"});case"warning":return/* @__PURE__ */jsx(AlertTriangle,{color:"orange"});default:return null;}};Icon$2.displayName="Alert.Icon";var Message$1=createStyled("span",{target:"e1samq100"})(typography$1("body2Medium"),";");Message$1.displayName="Alert.Message";var Alert=function Alert(_ref31){var className=_ref31.className,kind2=_ref31.kind,message=_ref31.message,hideIcon=_ref31.hideIcon;return/* @__PURE__ */jsxs(Container$k,{className:className,kind:kind2,role:"alert",children:[!hideIcon&&/* @__PURE__ */jsx(Icon$2,{kind:kind2}),/* @__PURE__ */jsx(Message$1,{children:message})]});};var size$c=function size$c(_ref33){var size2=_ref33.size,theme=_ref33.theme;switch(size2){case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("right:",spacer(4,{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("right:",spacer(3,{theme:theme}),";");}};var Caret$1=/* @__PURE__ */createStyled(Caret$2,{target:"ei2xlo60"})("position:absolute;top:50%;transform:translateY(-50%);pointer-events:none;",size$c,";");var Container$j=createStyled("div",{target:"e1oo41l70"})("position:relative;width:",function(_ref34){var width=_ref34.width;return width;},";");Container$j.displayName="Dropdown.Container";Container$j.defaultProps={width:"auto"};function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key2,i;for(i=0;i<sourceKeys.length;i++){key2=sourceKeys[i];if(excluded.indexOf(key2)>=0)continue;target[key2]=source[key2];}return target;}function _extends$2(){_extends$2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};return _extends$2.apply(this,arguments);}function _assertThisInitialized(self2){if(self2===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self2;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}var propTypes$3={exports:{}};var ReactPropTypesSecret$6="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";var ReactPropTypesSecret_1$3=ReactPropTypesSecret$6;var ReactPropTypesSecret$5=ReactPropTypesSecret_1$3;function emptyFunction$5(){}function emptyFunctionWithReset$1(){}emptyFunctionWithReset$1.resetWarningCache=emptyFunction$5;var factoryWithThrowingShims$3=function factoryWithThrowingShims$3(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret$5){return;}var err=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");err.name="Invariant Violation";throw err;}shim.isRequired=shim;function getShim(){return shim;}var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,elementType:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim,checkPropTypes:emptyFunctionWithReset$1,resetWarningCache:emptyFunction$5};ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};{propTypes$3.exports=factoryWithThrowingShims$3();}var PropTypes$3=propTypes$3.exports;var reactIs_production_min={};/** @license React v17.0.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var b=60103,c=60106,d=60107,e$1=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n$1=60115,p=60116,q=60121,r$2=60122,u=60117,v=60129,w=60131;if(typeof Symbol==="function"&&Symbol["for"]){var x=Symbol["for"];b=x("react.element");c=x("react.portal");d=x("react.fragment");e$1=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n$1=x("react.memo");p=x("react.lazy");q=x("react.block");r$2=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}function y(a){if(_typeof2(a)==="object"&&a!==null){var t2=a.$$typeof;switch(t2){case b:switch(a=a.type,a){case d:case f:case e$1:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n$1:case g:return a;default:return t2;}}case c:return t2;}}}var z=g,A=b,B=k,C=d,D=p,E=n$1,F=c,G=f,H=e$1,I=l;reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=z;reactIs_production_min.Element=A;reactIs_production_min.ForwardRef=B;reactIs_production_min.Fragment=C;reactIs_production_min.Lazy=D;reactIs_production_min.Memo=E;reactIs_production_min.Portal=F;reactIs_production_min.Profiler=G;reactIs_production_min.StrictMode=H;reactIs_production_min.Suspense=I;reactIs_production_min.isAsyncMode=function(){return false;};reactIs_production_min.isConcurrentMode=function(){return false;};reactIs_production_min.isContextConsumer=function(a){return y(a)===h;};reactIs_production_min.isContextProvider=function(a){return y(a)===g;};reactIs_production_min.isElement=function(a){return _typeof2(a)==="object"&&a!==null&&a.$$typeof===b;};reactIs_production_min.isForwardRef=function(a){return y(a)===k;};reactIs_production_min.isFragment=function(a){return y(a)===d;};reactIs_production_min.isLazy=function(a){return y(a)===p;};reactIs_production_min.isMemo=function(a){return y(a)===n$1;};reactIs_production_min.isPortal=function(a){return y(a)===c;};reactIs_production_min.isProfiler=function(a){return y(a)===f;};reactIs_production_min.isStrictMode=function(a){return y(a)===e$1;};reactIs_production_min.isSuspense=function(a){return y(a)===l;};reactIs_production_min.isValidElementType=function(a){return typeof a==="string"||typeof a==="function"||a===d||a===f||a===v||a===e$1||a===l||a===m||a===w||_typeof2(a)==="object"&&a!==null&&(a.$$typeof===p||a.$$typeof===n$1||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r$2)?true:false;};reactIs_production_min.typeOf=y;function t(t2){return t2!=null&&_typeof2(t2)=="object"&&t2.nodeType===1;}function e(t2,e2){return(!e2||t2!=="hidden")&&t2!=="visible"&&t2!=="clip";}function n(t2,n2){if(t2.clientHeight<t2.scrollHeight||t2.clientWidth<t2.scrollWidth){var r2=getComputedStyle(t2,null);return e(r2.overflowY,n2)||e(r2.overflowX,n2)||function(t3){var e2=function(t4){if(!t4.ownerDocument||!t4.ownerDocument.defaultView)return null;try{return t4.ownerDocument.defaultView.frameElement;}catch(t5){return null;}}(t3);return!!e2&&(e2.clientHeight<t3.scrollHeight||e2.clientWidth<t3.scrollWidth);}(t2);}return false;}function r$1(t2,e2,n2,r2,i,o,l2,d2){return o<t2&&l2>e2||o>t2&&l2<e2?0:o<=t2&&d2<=n2||l2>=e2&&d2>=n2?o-t2-r2:l2>e2&&d2<n2||o<t2&&d2>n2?l2-e2+i:0;}function computeScrollIntoView(e2,i){var o=window,l2=i.scrollMode,d2=i.block,u2=i.inline,h2=i.boundary,a=i.skipOverflowHiddenElements,c2=typeof h2=="function"?h2:function(t2){return t2!==h2;};if(!t(e2))throw new TypeError("Invalid target");for(var f2=document.scrollingElement||document.documentElement,s=[],p2=e2;t(p2)&&c2(p2);){if((p2=p2.parentNode)===f2){s.push(p2);break;}p2===document.body&&n(p2)&&!n(document.documentElement)||n(p2,a)&&s.push(p2);}for(var g2=o.visualViewport?o.visualViewport.width:innerWidth,m2=o.visualViewport?o.visualViewport.height:innerHeight,w2=window.scrollX||pageXOffset,v2=window.scrollY||pageYOffset,W=e2.getBoundingClientRect(),b2=W.height,H2=W.width,y2=W.top,M=W.right,E2=W.bottom,V=W.left,x=d2==="start"||d2==="nearest"?y2:d2==="end"?E2:y2+b2/2,I2=u2==="center"?V+H2/2:u2==="end"?M:V,C2=[],T=0;T<s.length;T++){var k2=s[T],B2=k2.getBoundingClientRect(),D2=B2.height,O=B2.width,R=B2.top,X=B2.right,Y=B2.bottom,L=B2.left;if(l2==="if-needed"&&y2>=0&&V>=0&&E2<=m2&&M<=g2&&y2>=R&&E2<=Y&&V>=L&&M<=X)return C2;var S=getComputedStyle(k2),j=parseInt(S.borderLeftWidth,10),N=parseInt(S.borderTopWidth,10),q2=parseInt(S.borderRightWidth,10),z2=parseInt(S.borderBottomWidth,10),A2=0,F2=0,G2="offsetWidth"in k2?k2.offsetWidth-k2.clientWidth-j-q2:0,J="offsetHeight"in k2?k2.offsetHeight-k2.clientHeight-N-z2:0;if(f2===k2)A2=d2==="start"?x:d2==="end"?x-m2:d2==="nearest"?r$1(v2,v2+m2,m2,N,z2,v2+x,v2+x+b2,b2):x-m2/2,F2=u2==="start"?I2:u2==="center"?I2-g2/2:u2==="end"?I2-g2:r$1(w2,w2+g2,g2,j,q2,w2+I2,w2+I2+H2,H2),A2=Math.max(0,A2+v2),F2=Math.max(0,F2+w2);else{A2=d2==="start"?x-R-N:d2==="end"?x-Y+z2+J:d2==="nearest"?r$1(R,Y,D2,N,z2+J,x,x+b2,b2):x-(R+D2/2)+J/2,F2=u2==="start"?I2-L-j:u2==="center"?I2-(L+O/2)+G2/2:u2==="end"?I2-X+q2+G2:r$1(L,X,O,j,q2+G2,I2,I2+H2,H2);var K=k2.scrollLeft,P=k2.scrollTop;x+=P-(A2=Math.max(0,Math.min(P+A2,k2.scrollHeight-D2+J))),I2+=K-(F2=Math.max(0,Math.min(K+F2,k2.scrollWidth-O+G2)));}C2.push({el:k2,top:A2,left:F2});}return C2;}var idCounter=0;function cbToCb(cb){return typeof cb==="function"?cb:noop$2;}function noop$2(){}function scrollIntoView(node,menuNode){if(!node){return;}var actions=computeScrollIntoView(node,{boundary:menuNode,block:"nearest",scrollMode:"if-needed"});actions.forEach(function(_ref6){var el=_ref6.el,top2=_ref6.top,left2=_ref6.left;el.scrollTop=top2;el.scrollLeft=left2;});}function isOrContainsNode(parent,child){return parent===child||child instanceof Node&&parent.contains&&parent.contains(child);}function debounce$1(fn2,time){var timeoutId;function cancel(){if(timeoutId){clearTimeout(timeoutId);}}function wrapper(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}cancel();timeoutId=setTimeout(function(){timeoutId=null;fn2.apply(void 0,args);},time);}wrapper.cancel=cancel;return wrapper;}function callAllEventHandlers(){for(var _len2=arguments.length,fns=new Array(_len2),_key2=0;_key2<_len2;_key2++){fns[_key2]=arguments[_key2];}return function(event){for(var _len3=arguments.length,args=new Array(_len3>1?_len3-1:0),_key3=1;_key3<_len3;_key3++){args[_key3-1]=arguments[_key3];}return fns.some(function(fn2){if(fn2){fn2.apply(void 0,[event].concat(args));}return event.preventDownshiftDefault||event.hasOwnProperty("nativeEvent")&&event.nativeEvent.preventDownshiftDefault;});};}function handleRefs(){for(var _len4=arguments.length,refs=new Array(_len4),_key4=0;_key4<_len4;_key4++){refs[_key4]=arguments[_key4];}return function(node){refs.forEach(function(ref){if(typeof ref==="function"){ref(node);}else if(ref){ref.current=node;}});};}function generateId$2(){return String(idCounter++);}function getA11yStatusMessage(_ref22){var isOpen=_ref22.isOpen,resultCount=_ref22.resultCount,previousResultCount=_ref22.previousResultCount;if(!isOpen){return"";}if(!resultCount){return"No results are available.";}if(resultCount!==previousResultCount){return resultCount+" result"+(resultCount===1?" is":"s are")+" available, use up and down arrow keys to navigate. Press Enter key to select.";}return"";}function unwrapArray$1(arg,defaultValue){arg=Array.isArray(arg)?arg[0]:arg;if(!arg&&defaultValue){return defaultValue;}else{return arg;}}function isDOMElement(element){return typeof element.type==="string";}function getElementProps(element){return element.props;}var stateKeys=["highlightedIndex","inputValue","isOpen","selectedItem","type"];function pickState(state){if(state===void 0){state={};}var result={};stateKeys.forEach(function(k2){if(state.hasOwnProperty(k2)){result[k2]=state[k2];}});return result;}function getState(state,props){return Object.keys(state).reduce(function(prevState,key2){prevState[key2]=isControlledProp(props,key2)?props[key2]:state[key2];return prevState;},{});}function isControlledProp(props,key2){return props[key2]!==void 0;}function normalizeArrowKey(event){var key2=event.key,keyCode=event.keyCode;if(keyCode>=37&&keyCode<=40&&key2.indexOf("Arrow")!==0){return"Arrow"+key2;}return key2;}function getNextWrappingIndex(moveAmount,baseIndex,itemCount,getItemNodeFromIndex,circular){if(circular===void 0){circular=true;}if(itemCount===0){return-1;}var itemsLastIndex=itemCount-1;if(typeof baseIndex!=="number"||baseIndex<0||baseIndex>=itemCount){baseIndex=moveAmount>0?-1:itemsLastIndex+1;}var newIndex=baseIndex+moveAmount;if(newIndex<0){newIndex=circular?itemsLastIndex:0;}else if(newIndex>itemsLastIndex){newIndex=circular?0:itemsLastIndex;}var nonDisabledNewIndex=getNextNonDisabledIndex(moveAmount,newIndex,itemCount,getItemNodeFromIndex,circular);if(nonDisabledNewIndex===-1){return baseIndex>=itemCount?-1:baseIndex;}return nonDisabledNewIndex;}function getNextNonDisabledIndex(moveAmount,baseIndex,itemCount,getItemNodeFromIndex,circular){var currentElementNode=getItemNodeFromIndex(baseIndex);if(!currentElementNode||!currentElementNode.hasAttribute("disabled")){return baseIndex;}if(moveAmount>0){for(var index2=baseIndex+1;index2<itemCount;index2++){if(!getItemNodeFromIndex(index2).hasAttribute("disabled")){return index2;}}}else{for(var _index=baseIndex-1;_index>=0;_index--){if(!getItemNodeFromIndex(_index).hasAttribute("disabled")){return _index;}}}if(circular){return moveAmount>0?getNextNonDisabledIndex(1,0,itemCount,getItemNodeFromIndex,false):getNextNonDisabledIndex(-1,itemCount-1,itemCount,getItemNodeFromIndex,false);}return-1;}function targetWithinDownshift(target,downshiftElements,document2,checkActiveElement){if(checkActiveElement===void 0){checkActiveElement=true;}return downshiftElements.some(function(contextNode){return contextNode&&(isOrContainsNode(contextNode,target)||checkActiveElement&&isOrContainsNode(contextNode,document2.activeElement));});}var cleanupStatus=debounce$1(function(documentProp){getStatusDiv(documentProp).textContent="";},500);function setStatus(status,documentProp){var div=getStatusDiv(documentProp);if(!status){return;}div.textContent=status;cleanupStatus(documentProp);}function getStatusDiv(documentProp){if(documentProp===void 0){documentProp=document;}var statusDiv=documentProp.getElementById("a11y-status-message");if(statusDiv){return statusDiv;}statusDiv=documentProp.createElement("div");statusDiv.setAttribute("id","a11y-status-message");statusDiv.setAttribute("role","status");statusDiv.setAttribute("aria-live","polite");statusDiv.setAttribute("aria-relevant","additions text");Object.assign(statusDiv.style,{border:"0",clip:"rect(0 0 0 0)",height:"1px",margin:"-1px",overflow:"hidden",padding:"0",position:"absolute",width:"1px"});documentProp.body.appendChild(statusDiv);return statusDiv;}var unknown=0;var mouseUp=1;var itemMouseEnter=2;var keyDownArrowUp=3;var keyDownArrowDown=4;var keyDownEscape=5;var keyDownEnter=6;var keyDownHome=7;var keyDownEnd=8;var clickItem=9;var blurInput=10;var changeInput=11;var keyDownSpaceButton=12;var clickButton=13;var blurButton=14;var controlledPropUpdatedSelectedItem=15;var touchEnd=16;var stateChangeTypes=/* @__PURE__ */Object.freeze({__proto__:null,unknown:unknown,mouseUp:mouseUp,itemMouseEnter:itemMouseEnter,keyDownArrowUp:keyDownArrowUp,keyDownArrowDown:keyDownArrowDown,keyDownEscape:keyDownEscape,keyDownEnter:keyDownEnter,keyDownHome:keyDownHome,keyDownEnd:keyDownEnd,clickItem:clickItem,blurInput:blurInput,changeInput:changeInput,keyDownSpaceButton:keyDownSpaceButton,clickButton:clickButton,blurButton:blurButton,controlledPropUpdatedSelectedItem:controlledPropUpdatedSelectedItem,touchEnd:touchEnd});var Downshift=/* @__PURE__ */function(){var Downshift2=/* @__PURE__ */function(_Component){_inheritsLoose(Downshift3,_Component);function Downshift3(_props){var _this;_this=_Component.call(this,_props)||this;_this.id=_this.props.id||"downshift-"+generateId$2();_this.menuId=_this.props.menuId||_this.id+"-menu";_this.labelId=_this.props.labelId||_this.id+"-label";_this.inputId=_this.props.inputId||_this.id+"-input";_this.getItemId=_this.props.getItemId||function(index2){return _this.id+"-item-"+index2;};_this.input=null;_this.items=[];_this.itemCount=null;_this.previousResultCount=0;_this.timeoutIds=[];_this.internalSetTimeout=function(fn2,time){var id=setTimeout(function(){_this.timeoutIds=_this.timeoutIds.filter(function(i){return i!==id;});fn2();},time);_this.timeoutIds.push(id);};_this.setItemCount=function(count){_this.itemCount=count;};_this.unsetItemCount=function(){_this.itemCount=null;};_this.setHighlightedIndex=function(highlightedIndex,otherStateToSet){if(highlightedIndex===void 0){highlightedIndex=_this.props.defaultHighlightedIndex;}if(otherStateToSet===void 0){otherStateToSet={};}otherStateToSet=pickState(otherStateToSet);_this.internalSetState(_extends$2({highlightedIndex:highlightedIndex},otherStateToSet));};_this.clearSelection=function(cb){_this.internalSetState({selectedItem:null,inputValue:"",highlightedIndex:_this.props.defaultHighlightedIndex,isOpen:_this.props.defaultIsOpen},cb);};_this.selectItem=function(item,otherStateToSet,cb){otherStateToSet=pickState(otherStateToSet);_this.internalSetState(_extends$2({isOpen:_this.props.defaultIsOpen,highlightedIndex:_this.props.defaultHighlightedIndex,selectedItem:item,inputValue:_this.props.itemToString(item)},otherStateToSet),cb);};_this.selectItemAtIndex=function(itemIndex,otherStateToSet,cb){var item=_this.items[itemIndex];if(item==null){return;}_this.selectItem(item,otherStateToSet,cb);};_this.selectHighlightedItem=function(otherStateToSet,cb){return _this.selectItemAtIndex(_this.getState().highlightedIndex,otherStateToSet,cb);};_this.internalSetState=function(stateToSet,cb){var isItemSelected,onChangeArg;var onStateChangeArg={};var isStateToSetFunction=typeof stateToSet==="function";if(!isStateToSetFunction&&stateToSet.hasOwnProperty("inputValue")){_this.props.onInputValueChange(stateToSet.inputValue,_extends$2({},_this.getStateAndHelpers(),stateToSet));}return _this.setState(function(state){state=_this.getState(state);var newStateToSet=isStateToSetFunction?stateToSet(state):stateToSet;newStateToSet=_this.props.stateReducer(state,newStateToSet);isItemSelected=newStateToSet.hasOwnProperty("selectedItem");var nextState={};if(isItemSelected&&newStateToSet.selectedItem!==state.selectedItem){onChangeArg=newStateToSet.selectedItem;}newStateToSet.type=newStateToSet.type||unknown;Object.keys(newStateToSet).forEach(function(key2){if(state[key2]!==newStateToSet[key2]){onStateChangeArg[key2]=newStateToSet[key2];}if(key2==="type"){return;}newStateToSet[key2];if(!isControlledProp(_this.props,key2)){nextState[key2]=newStateToSet[key2];}});if(isStateToSetFunction&&newStateToSet.hasOwnProperty("inputValue")){_this.props.onInputValueChange(newStateToSet.inputValue,_extends$2({},_this.getStateAndHelpers(),newStateToSet));}return nextState;},function(){cbToCb(cb)();var hasMoreStateThanType=Object.keys(onStateChangeArg).length>1;if(hasMoreStateThanType){_this.props.onStateChange(onStateChangeArg,_this.getStateAndHelpers());}if(isItemSelected){_this.props.onSelect(stateToSet.selectedItem,_this.getStateAndHelpers());}if(onChangeArg!==void 0){_this.props.onChange(onChangeArg,_this.getStateAndHelpers());}_this.props.onUserAction(onStateChangeArg,_this.getStateAndHelpers());});};_this.rootRef=function(node){return _this._rootNode=node;};_this.getRootProps=function(_temp,_temp2){var _extends2;var _ref6=_temp===void 0?{}:_temp,_ref$refKey=_ref6.refKey,refKey=_ref$refKey===void 0?"ref":_ref$refKey,ref=_ref6.ref,rest=_objectWithoutPropertiesLoose(_ref6,["refKey","ref"]);var _ref22=_temp2===void 0?{}:_temp2,_ref2$suppressRefErro=_ref22.suppressRefError,suppressRefError=_ref2$suppressRefErro===void 0?false:_ref2$suppressRefErro;_this.getRootProps.called=true;_this.getRootProps.refKey=refKey;_this.getRootProps.suppressRefError=suppressRefError;var _this$getState=_this.getState(),isOpen=_this$getState.isOpen;return _extends$2((_extends2={},_extends2[refKey]=handleRefs(ref,_this.rootRef),_extends2.role="combobox",_extends2["aria-expanded"]=isOpen,_extends2["aria-haspopup"]="listbox",_extends2["aria-owns"]=isOpen?_this.menuId:null,_extends2["aria-labelledby"]=_this.labelId,_extends2),rest);};_this.keyDownHandlers={ArrowDown:function ArrowDown(event){var _this2=this;event.preventDefault();if(this.getState().isOpen){var amount=event.shiftKey?5:1;this.moveHighlightedIndex(amount,{type:keyDownArrowDown});}else{this.internalSetState({isOpen:true,type:keyDownArrowDown},function(){var itemCount=_this2.getItemCount();if(itemCount>0){var _this2$getState=_this2.getState(),highlightedIndex=_this2$getState.highlightedIndex;var nextHighlightedIndex=getNextWrappingIndex(1,highlightedIndex,itemCount,function(index2){return _this2.getItemNodeFromIndex(index2);});_this2.setHighlightedIndex(nextHighlightedIndex,{type:keyDownArrowDown});}});}},ArrowUp:function ArrowUp(event){var _this3=this;event.preventDefault();if(this.getState().isOpen){var amount=event.shiftKey?-5:-1;this.moveHighlightedIndex(amount,{type:keyDownArrowUp});}else{this.internalSetState({isOpen:true,type:keyDownArrowUp},function(){var itemCount=_this3.getItemCount();if(itemCount>0){var _this3$getState=_this3.getState(),highlightedIndex=_this3$getState.highlightedIndex;var nextHighlightedIndex=getNextWrappingIndex(-1,highlightedIndex,itemCount,function(index2){return _this3.getItemNodeFromIndex(index2);});_this3.setHighlightedIndex(nextHighlightedIndex,{type:keyDownArrowUp});}});}},Enter:function Enter(event){if(event.which===229){return;}var _this$getState2=this.getState(),isOpen=_this$getState2.isOpen,highlightedIndex=_this$getState2.highlightedIndex;if(isOpen&&highlightedIndex!=null){event.preventDefault();var item=this.items[highlightedIndex];var itemNode=this.getItemNodeFromIndex(highlightedIndex);if(item==null||itemNode&&itemNode.hasAttribute("disabled")){return;}this.selectHighlightedItem({type:keyDownEnter});}},Escape:function Escape(event){event.preventDefault();this.reset(_extends$2({type:keyDownEscape},!this.state.isOpen&&{selectedItem:null,inputValue:""}));}};_this.buttonKeyDownHandlers=_extends$2({},_this.keyDownHandlers,{" ":function _(event){event.preventDefault();this.toggleMenu({type:keyDownSpaceButton});}});_this.inputKeyDownHandlers=_extends$2({},_this.keyDownHandlers,{Home:function Home2(event){var _this4=this;var _this$getState3=this.getState(),isOpen=_this$getState3.isOpen;if(!isOpen){return;}event.preventDefault();var itemCount=this.getItemCount();if(itemCount<=0||!isOpen){return;}var newHighlightedIndex=getNextNonDisabledIndex(1,0,itemCount,function(index2){return _this4.getItemNodeFromIndex(index2);},false);this.setHighlightedIndex(newHighlightedIndex,{type:keyDownHome});},End:function End(event){var _this5=this;var _this$getState4=this.getState(),isOpen=_this$getState4.isOpen;if(!isOpen){return;}event.preventDefault();var itemCount=this.getItemCount();if(itemCount<=0||!isOpen){return;}var newHighlightedIndex=getNextNonDisabledIndex(-1,itemCount-1,itemCount,function(index2){return _this5.getItemNodeFromIndex(index2);},false);this.setHighlightedIndex(newHighlightedIndex,{type:keyDownEnd});}});_this.getToggleButtonProps=function(_temp3){var _ref32=_temp3===void 0?{}:_temp3,onClick=_ref32.onClick;_ref32.onPress;var onKeyDown=_ref32.onKeyDown,onKeyUp=_ref32.onKeyUp,onBlur=_ref32.onBlur,rest=_objectWithoutPropertiesLoose(_ref32,["onClick","onPress","onKeyDown","onKeyUp","onBlur"]);var _this$getState5=_this.getState(),isOpen=_this$getState5.isOpen;var enabledEventHandlers={onClick:callAllEventHandlers(onClick,_this.buttonHandleClick),onKeyDown:callAllEventHandlers(onKeyDown,_this.buttonHandleKeyDown),onKeyUp:callAllEventHandlers(onKeyUp,_this.buttonHandleKeyUp),onBlur:callAllEventHandlers(onBlur,_this.buttonHandleBlur)};var eventHandlers=rest.disabled?{}:enabledEventHandlers;return _extends$2({type:"button",role:"button","aria-label":isOpen?"close menu":"open menu","aria-haspopup":true,"data-toggle":true},eventHandlers,rest);};_this.buttonHandleKeyUp=function(event){event.preventDefault();};_this.buttonHandleKeyDown=function(event){var key2=normalizeArrowKey(event);if(_this.buttonKeyDownHandlers[key2]){_this.buttonKeyDownHandlers[key2].call(_assertThisInitialized(_this),event);}};_this.buttonHandleClick=function(event){event.preventDefault();if(_this.props.environment.document.activeElement===_this.props.environment.document.body){event.target.focus();}{_this.internalSetTimeout(function(){return _this.toggleMenu({type:clickButton});});}};_this.buttonHandleBlur=function(event){var blurTarget=event.target;_this.internalSetTimeout(function(){if(!_this.isMouseDown&&(_this.props.environment.document.activeElement==null||_this.props.environment.document.activeElement.id!==_this.inputId)&&_this.props.environment.document.activeElement!==blurTarget){_this.reset({type:blurButton});}});};_this.getLabelProps=function(props){return _extends$2({htmlFor:_this.inputId,id:_this.labelId},props);};_this.getInputProps=function(_temp4){var _ref42=_temp4===void 0?{}:_temp4,onKeyDown=_ref42.onKeyDown,onBlur=_ref42.onBlur,onChange=_ref42.onChange,onInput=_ref42.onInput;_ref42.onChangeText;var rest=_objectWithoutPropertiesLoose(_ref42,["onKeyDown","onBlur","onChange","onInput","onChangeText"]);var onChangeKey;var eventHandlers={};{onChangeKey="onChange";}var _this$getState6=_this.getState(),inputValue=_this$getState6.inputValue,isOpen=_this$getState6.isOpen,highlightedIndex=_this$getState6.highlightedIndex;if(!rest.disabled){var _eventHandlers;eventHandlers=(_eventHandlers={},_eventHandlers[onChangeKey]=callAllEventHandlers(onChange,onInput,_this.inputHandleChange),_eventHandlers.onKeyDown=callAllEventHandlers(onKeyDown,_this.inputHandleKeyDown),_eventHandlers.onBlur=callAllEventHandlers(onBlur,_this.inputHandleBlur),_eventHandlers);}return _extends$2({"aria-autocomplete":"list","aria-activedescendant":isOpen&&typeof highlightedIndex==="number"&&highlightedIndex>=0?_this.getItemId(highlightedIndex):null,"aria-controls":isOpen?_this.menuId:null,"aria-labelledby":_this.labelId,autoComplete:"off",value:inputValue,id:_this.inputId},eventHandlers,rest);};_this.inputHandleKeyDown=function(event){var key2=normalizeArrowKey(event);if(key2&&_this.inputKeyDownHandlers[key2]){_this.inputKeyDownHandlers[key2].call(_assertThisInitialized(_this),event);}};_this.inputHandleChange=function(event){_this.internalSetState({type:changeInput,isOpen:true,inputValue:event.target.value,highlightedIndex:_this.props.defaultHighlightedIndex});};_this.inputHandleBlur=function(){_this.internalSetTimeout(function(){var downshiftButtonIsActive=_this.props.environment.document&&!!_this.props.environment.document.activeElement&&!!_this.props.environment.document.activeElement.dataset&&_this.props.environment.document.activeElement.dataset.toggle&&_this._rootNode&&_this._rootNode.contains(_this.props.environment.document.activeElement);if(!_this.isMouseDown&&!downshiftButtonIsActive){_this.reset({type:blurInput});}});};_this.menuRef=function(node){_this._menuNode=node;};_this.getMenuProps=function(_temp5,_temp6){var _extends3;var _ref52=_temp5===void 0?{}:_temp5,_ref5$refKey=_ref52.refKey,refKey=_ref5$refKey===void 0?"ref":_ref5$refKey,ref=_ref52.ref,props=_objectWithoutPropertiesLoose(_ref52,["refKey","ref"]);var _ref6=_temp6===void 0?{}:_temp6,_ref6$suppressRefErro=_ref6.suppressRefError,suppressRefError=_ref6$suppressRefErro===void 0?false:_ref6$suppressRefErro;_this.getMenuProps.called=true;_this.getMenuProps.refKey=refKey;_this.getMenuProps.suppressRefError=suppressRefError;return _extends$2((_extends3={},_extends3[refKey]=handleRefs(ref,_this.menuRef),_extends3.role="listbox",_extends3["aria-labelledby"]=props&&props["aria-label"]?null:_this.labelId,_extends3.id=_this.menuId,_extends3),props);};_this.getItemProps=function(_temp7){var _enabledEventHandlers;var _ref7=_temp7===void 0?{}:_temp7,onMouseMove=_ref7.onMouseMove,onMouseDown=_ref7.onMouseDown,onClick=_ref7.onClick;_ref7.onPress;var index2=_ref7.index,_ref7$item=_ref7.item,item=_ref7$item===void 0?void 0:_ref7$item,rest=_objectWithoutPropertiesLoose(_ref7,["onMouseMove","onMouseDown","onClick","onPress","index","item"]);if(index2===void 0){_this.items.push(item);index2=_this.items.indexOf(item);}else{_this.items[index2]=item;}var onSelectKey="onClick";var customClickHandler=onClick;var enabledEventHandlers=(_enabledEventHandlers={onMouseMove:callAllEventHandlers(onMouseMove,function(){if(index2===_this.getState().highlightedIndex){return;}_this.setHighlightedIndex(index2,{type:itemMouseEnter});_this.avoidScrolling=true;_this.internalSetTimeout(function(){return _this.avoidScrolling=false;},250);}),onMouseDown:callAllEventHandlers(onMouseDown,function(event){event.preventDefault();})},_enabledEventHandlers[onSelectKey]=callAllEventHandlers(customClickHandler,function(){_this.selectItemAtIndex(index2,{type:clickItem});}),_enabledEventHandlers);var eventHandlers=rest.disabled?{onMouseDown:enabledEventHandlers.onMouseDown}:enabledEventHandlers;return _extends$2({id:_this.getItemId(index2),role:"option","aria-selected":_this.getState().highlightedIndex===index2},eventHandlers,rest);};_this.clearItems=function(){_this.items=[];};_this.reset=function(otherStateToSet,cb){if(otherStateToSet===void 0){otherStateToSet={};}otherStateToSet=pickState(otherStateToSet);_this.internalSetState(function(_ref8){var selectedItem=_ref8.selectedItem;return _extends$2({isOpen:_this.props.defaultIsOpen,highlightedIndex:_this.props.defaultHighlightedIndex,inputValue:_this.props.itemToString(selectedItem)},otherStateToSet);},cb);};_this.toggleMenu=function(otherStateToSet,cb){if(otherStateToSet===void 0){otherStateToSet={};}otherStateToSet=pickState(otherStateToSet);_this.internalSetState(function(_ref9){var isOpen=_ref9.isOpen;return _extends$2({isOpen:!isOpen},isOpen&&{highlightedIndex:_this.props.defaultHighlightedIndex},otherStateToSet);},function(){var _this$getState7=_this.getState(),isOpen=_this$getState7.isOpen,highlightedIndex=_this$getState7.highlightedIndex;if(isOpen){if(_this.getItemCount()>0&&typeof highlightedIndex==="number"){_this.setHighlightedIndex(highlightedIndex,otherStateToSet);}}cbToCb(cb)();});};_this.openMenu=function(cb){_this.internalSetState({isOpen:true},cb);};_this.closeMenu=function(cb){_this.internalSetState({isOpen:false},cb);};_this.updateStatus=debounce$1(function(){var state=_this.getState();var item=_this.items[state.highlightedIndex];var resultCount=_this.getItemCount();var status=_this.props.getA11yStatusMessage(_extends$2({itemToString:_this.props.itemToString,previousResultCount:_this.previousResultCount,resultCount:resultCount,highlightedItem:item},state));_this.previousResultCount=resultCount;setStatus(status,_this.props.environment.document);},200);var _this$props=_this.props,defaultHighlightedIndex=_this$props.defaultHighlightedIndex,_this$props$initialHi=_this$props.initialHighlightedIndex,_highlightedIndex=_this$props$initialHi===void 0?defaultHighlightedIndex:_this$props$initialHi,defaultIsOpen=_this$props.defaultIsOpen,_this$props$initialIs=_this$props.initialIsOpen,_isOpen=_this$props$initialIs===void 0?defaultIsOpen:_this$props$initialIs,_this$props$initialIn=_this$props.initialInputValue,_inputValue=_this$props$initialIn===void 0?"":_this$props$initialIn,_this$props$initialSe=_this$props.initialSelectedItem,_selectedItem=_this$props$initialSe===void 0?null:_this$props$initialSe;var _state=_this.getState({highlightedIndex:_highlightedIndex,isOpen:_isOpen,inputValue:_inputValue,selectedItem:_selectedItem});if(_state.selectedItem!=null&&_this.props.initialInputValue===void 0){_state.inputValue=_this.props.itemToString(_state.selectedItem);}_this.state=_state;return _this;}var _proto=Downshift3.prototype;_proto.internalClearTimeouts=function internalClearTimeouts(){this.timeoutIds.forEach(function(id){clearTimeout(id);});this.timeoutIds=[];};_proto.getState=function getState$1(stateToMerge){if(stateToMerge===void 0){stateToMerge=this.state;}return getState(stateToMerge,this.props);};_proto.getItemCount=function getItemCount(){var itemCount=this.items.length;if(this.itemCount!=null){itemCount=this.itemCount;}else if(this.props.itemCount!==void 0){itemCount=this.props.itemCount;}return itemCount;};_proto.getItemNodeFromIndex=function getItemNodeFromIndex(index2){return this.props.environment.document.getElementById(this.getItemId(index2));};_proto.scrollHighlightedItemIntoView=function scrollHighlightedItemIntoView(){{var node=this.getItemNodeFromIndex(this.getState().highlightedIndex);this.props.scrollIntoView(node,this._menuNode);}};_proto.moveHighlightedIndex=function moveHighlightedIndex(amount,otherStateToSet){var _this6=this;var itemCount=this.getItemCount();var _this$getState8=this.getState(),highlightedIndex=_this$getState8.highlightedIndex;if(itemCount>0){var nextHighlightedIndex=getNextWrappingIndex(amount,highlightedIndex,itemCount,function(index2){return _this6.getItemNodeFromIndex(index2);});this.setHighlightedIndex(nextHighlightedIndex,otherStateToSet);}};_proto.getStateAndHelpers=function getStateAndHelpers(){var _this$getState9=this.getState(),highlightedIndex=_this$getState9.highlightedIndex,inputValue=_this$getState9.inputValue,selectedItem=_this$getState9.selectedItem,isOpen=_this$getState9.isOpen;var itemToString2=this.props.itemToString;var id=this.id;var getRootProps=this.getRootProps,getToggleButtonProps=this.getToggleButtonProps,getLabelProps=this.getLabelProps,getMenuProps=this.getMenuProps,getInputProps=this.getInputProps,getItemProps=this.getItemProps,openMenu=this.openMenu,closeMenu=this.closeMenu,toggleMenu=this.toggleMenu,selectItem=this.selectItem,selectItemAtIndex=this.selectItemAtIndex,selectHighlightedItem=this.selectHighlightedItem,setHighlightedIndex=this.setHighlightedIndex,clearSelection=this.clearSelection,clearItems=this.clearItems,reset=this.reset,setItemCount=this.setItemCount,unsetItemCount=this.unsetItemCount,setState=this.internalSetState;return{getRootProps:getRootProps,getToggleButtonProps:getToggleButtonProps,getLabelProps:getLabelProps,getMenuProps:getMenuProps,getInputProps:getInputProps,getItemProps:getItemProps,reset:reset,openMenu:openMenu,closeMenu:closeMenu,toggleMenu:toggleMenu,selectItem:selectItem,selectItemAtIndex:selectItemAtIndex,selectHighlightedItem:selectHighlightedItem,setHighlightedIndex:setHighlightedIndex,clearSelection:clearSelection,clearItems:clearItems,setItemCount:setItemCount,unsetItemCount:unsetItemCount,setState:setState,itemToString:itemToString2,id:id,highlightedIndex:highlightedIndex,inputValue:inputValue,isOpen:isOpen,selectedItem:selectedItem};};_proto.componentDidMount=function componentDidMount(){var _this7=this;{var onMouseDown=function onMouseDown2(){_this7.isMouseDown=true;};var onMouseUp=function onMouseUp2(event){_this7.isMouseDown=false;var contextWithinDownshift=targetWithinDownshift(event.target,[_this7._rootNode,_this7._menuNode],_this7.props.environment.document);if(!contextWithinDownshift&&_this7.getState().isOpen){_this7.reset({type:mouseUp},function(){return _this7.props.onOuterClick(_this7.getStateAndHelpers());});}};var onTouchStart=function onTouchStart2(){_this7.isTouchMove=false;};var onTouchMove=function onTouchMove2(){_this7.isTouchMove=true;};var onTouchEnd=function onTouchEnd2(event){var contextWithinDownshift=targetWithinDownshift(event.target,[_this7._rootNode,_this7._menuNode],_this7.props.environment.document,false);if(!_this7.isTouchMove&&!contextWithinDownshift&&_this7.getState().isOpen){_this7.reset({type:touchEnd},function(){return _this7.props.onOuterClick(_this7.getStateAndHelpers());});}};var environment=this.props.environment;environment.addEventListener("mousedown",onMouseDown);environment.addEventListener("mouseup",onMouseUp);environment.addEventListener("touchstart",onTouchStart);environment.addEventListener("touchmove",onTouchMove);environment.addEventListener("touchend",onTouchEnd);this.cleanup=function(){_this7.internalClearTimeouts();_this7.updateStatus.cancel();environment.removeEventListener("mousedown",onMouseDown);environment.removeEventListener("mouseup",onMouseUp);environment.removeEventListener("touchstart",onTouchStart);environment.removeEventListener("touchmove",onTouchMove);environment.removeEventListener("touchend",onTouchEnd);};}};_proto.shouldScroll=function shouldScroll(prevState,prevProps){var _ref10=this.props.highlightedIndex===void 0?this.getState():this.props,currentHighlightedIndex=_ref10.highlightedIndex;var _ref11=prevProps.highlightedIndex===void 0?prevState:prevProps,prevHighlightedIndex=_ref11.highlightedIndex;var scrollWhenOpen=currentHighlightedIndex&&this.getState().isOpen&&!prevState.isOpen;var scrollWhenNavigating=currentHighlightedIndex!==prevHighlightedIndex;return scrollWhenOpen||scrollWhenNavigating;};_proto.componentDidUpdate=function componentDidUpdate(prevProps,prevState){if(isControlledProp(this.props,"selectedItem")&&this.props.selectedItemChanged(prevProps.selectedItem,this.props.selectedItem)){this.internalSetState({type:controlledPropUpdatedSelectedItem,inputValue:this.props.itemToString(this.props.selectedItem)});}if(!this.avoidScrolling&&this.shouldScroll(prevState,prevProps)){this.scrollHighlightedItemIntoView();}{this.updateStatus();}};_proto.componentWillUnmount=function componentWillUnmount(){this.cleanup();};_proto.render=function render3(){var children=unwrapArray$1(this.props.children,noop$2);this.clearItems();this.getRootProps.called=false;this.getRootProps.refKey=void 0;this.getRootProps.suppressRefError=void 0;this.getMenuProps.called=false;this.getMenuProps.refKey=void 0;this.getMenuProps.suppressRefError=void 0;this.getLabelProps.called=false;this.getInputProps.called=false;var element=unwrapArray$1(children(this.getStateAndHelpers()));if(!element){return null;}if(this.getRootProps.called||this.props.suppressRefError){return element;}else if(isDOMElement(element)){return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(element,this.getRootProps(getElementProps(element)));}return void 0;};return Downshift3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Downshift2.defaultProps={defaultHighlightedIndex:null,defaultIsOpen:false,getA11yStatusMessage:getA11yStatusMessage,itemToString:function itemToString2(i){if(i==null){return"";}return String(i);},onStateChange:noop$2,onInputValueChange:noop$2,onUserAction:noop$2,onChange:noop$2,onSelect:noop$2,onOuterClick:noop$2,selectedItemChanged:function selectedItemChanged(prevItem,item){return prevItem!==item;},environment:typeof window==="undefined"?{}:window,stateReducer:function stateReducer2(state,stateToSet){return stateToSet;},suppressRefError:false,scrollIntoView:scrollIntoView};Downshift2.stateChangeTypes=stateChangeTypes;return Downshift2;}();var dropdownDefaultStateValues={highlightedIndex:-1,isOpen:false,selectedItem:null,inputValue:""};function callOnChangeProps(action,state,newState){var props=action.props,type=action.type;var changes={};Object.keys(state).forEach(function(key2){invokeOnChangeHandler(key2,action,state,newState);if(newState[key2]!==state[key2]){changes[key2]=newState[key2];}});if(props.onStateChange&&Object.keys(changes).length){props.onStateChange(_extends$2({type:type},changes));}}function invokeOnChangeHandler(key2,action,state,newState){var props=action.props,type=action.type;var handler="on"+capitalizeString(key2)+"Change";if(props[handler]&&newState[key2]!==void 0&&newState[key2]!==state[key2]){props[handler](_extends$2({type:type},newState));}}function stateReducer(s,a){return a.changes;}function getA11ySelectionMessage(selectionParameters){var selectedItem=selectionParameters.selectedItem,itemToStringLocal=selectionParameters.itemToString;return selectedItem?itemToStringLocal(selectedItem)+" has been selected.":"";}var updateA11yStatus=debounce$1(function(getA11yMessage,document2){setStatus(getA11yMessage(),document2);},200);var useIsomorphicLayoutEffect$1=typeof window!=="undefined"&&typeof window.document!=="undefined"&&typeof window.document.createElement!=="undefined"?__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"]:__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];function useElementIds(_ref6){var _ref$id=_ref6.id,id=_ref$id===void 0?"downshift-"+generateId$2():_ref$id,labelId=_ref6.labelId,menuId=_ref6.menuId,getItemId=_ref6.getItemId,toggleButtonId=_ref6.toggleButtonId,inputId=_ref6.inputId;var elementIdsRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({labelId:labelId||id+"-label",menuId:menuId||id+"-menu",getItemId:getItemId||function(index2){return id+"-item-"+index2;},toggleButtonId:toggleButtonId||id+"-toggle-button",inputId:inputId||id+"-input"});return elementIdsRef.current;}function getItemIndex(index2,item,items){if(index2!==void 0){return index2;}if(items.length===0){return-1;}return items.indexOf(item);}function itemToString(item){return item?String(item):"";}function isAcceptedCharacterKey(key2){return /^\S{1}$/.test(key2);}function capitalizeString(string){return""+string.slice(0,1).toUpperCase()+string.slice(1);}function useLatestRef(val){var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(val);ref.current=val;return ref;}function useEnhancedReducer(reducer2,initialState,props){var prevStateRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var actionRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var enhancedReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(state2,action2){actionRef.current=action2;state2=getState(state2,action2.props);var changes=reducer2(state2,action2);var newState=action2.props.stateReducer(state2,_extends$2({},action2,{changes:changes}));return newState;},[reducer2]);var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(enhancedReducer,initialState),state=_useReducer[0],dispatch=_useReducer[1];var propsRef=useLatestRef(props);var dispatchWithProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(action2){return dispatch(_extends$2({props:propsRef.current},action2));},[propsRef]);var action=actionRef.current;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(action&&prevStateRef.current&&prevStateRef.current!==state){callOnChangeProps(action,getState(prevStateRef.current,action.props),state);}prevStateRef.current=state;},[state,props,action]);return[state,dispatchWithProps];}function useControlledReducer(reducer2,initialState,props){var _useEnhancedReducer=useEnhancedReducer(reducer2,initialState,props),state=_useEnhancedReducer[0],dispatch=_useEnhancedReducer[1];return[getState(state,props),dispatch];}var defaultProps2={itemToString:itemToString,stateReducer:stateReducer,getA11ySelectionMessage:getA11ySelectionMessage,scrollIntoView:scrollIntoView,circularNavigation:false,environment:typeof window==="undefined"?{}:window};function getDefaultValue(props,propKey,defaultStateValues2){if(defaultStateValues2===void 0){defaultStateValues2=dropdownDefaultStateValues;}var defaultPropKey="default"+capitalizeString(propKey);if(defaultPropKey in props){return props[defaultPropKey];}return defaultStateValues2[propKey];}function getInitialValue(props,propKey,defaultStateValues2){if(defaultStateValues2===void 0){defaultStateValues2=dropdownDefaultStateValues;}if(propKey in props){return props[propKey];}var initialPropKey="initial"+capitalizeString(propKey);if(initialPropKey in props){return props[initialPropKey];}return getDefaultValue(props,propKey,defaultStateValues2);}function getInitialState(props){var selectedItem=getInitialValue(props,"selectedItem");var isOpen=getInitialValue(props,"isOpen");var highlightedIndex=getInitialValue(props,"highlightedIndex");var inputValue=getInitialValue(props,"inputValue");return{highlightedIndex:highlightedIndex<0&&selectedItem&&isOpen?props.items.indexOf(selectedItem):highlightedIndex,isOpen:isOpen,selectedItem:selectedItem,inputValue:inputValue};}function getHighlightedIndexOnOpen(props,state,offset2,getItemNodeFromIndex){var items=props.items,initialHighlightedIndex=props.initialHighlightedIndex,defaultHighlightedIndex=props.defaultHighlightedIndex;var selectedItem=state.selectedItem,highlightedIndex=state.highlightedIndex;if(items.length===0){return-1;}if(initialHighlightedIndex!==void 0&&highlightedIndex===initialHighlightedIndex){return initialHighlightedIndex;}if(defaultHighlightedIndex!==void 0){return defaultHighlightedIndex;}if(selectedItem){if(offset2===0){return items.indexOf(selectedItem);}return getNextWrappingIndex(offset2,items.indexOf(selectedItem),items.length,getItemNodeFromIndex,false);}if(offset2===0){return-1;}return offset2<0?items.length-1:0;}function useMouseAndTouchTracker(isOpen,downshiftElementRefs,environment,handleBlur){var mouseAndTouchTrackersRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({isMouseDown:false,isTouchMove:false});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var onMouseDown=function onMouseDown2(){mouseAndTouchTrackersRef.current.isMouseDown=true;};var onMouseUp=function onMouseUp2(event){mouseAndTouchTrackersRef.current.isMouseDown=false;if(isOpen&&!targetWithinDownshift(event.target,downshiftElementRefs.map(function(ref){return ref.current;}),environment.document)){handleBlur();}};var onTouchStart=function onTouchStart2(){mouseAndTouchTrackersRef.current.isTouchMove=false;};var onTouchMove=function onTouchMove2(){mouseAndTouchTrackersRef.current.isTouchMove=true;};var onTouchEnd=function onTouchEnd2(event){if(isOpen&&!mouseAndTouchTrackersRef.current.isTouchMove&&!targetWithinDownshift(event.target,downshiftElementRefs.map(function(ref){return ref.current;}),environment.document,false)){handleBlur();}};environment.addEventListener("mousedown",onMouseDown);environment.addEventListener("mouseup",onMouseUp);environment.addEventListener("touchstart",onTouchStart);environment.addEventListener("touchmove",onTouchMove);environment.addEventListener("touchend",onTouchEnd);return function cleanup(){environment.removeEventListener("mousedown",onMouseDown);environment.removeEventListener("mouseup",onMouseUp);environment.removeEventListener("touchstart",onTouchStart);environment.removeEventListener("touchmove",onTouchMove);environment.removeEventListener("touchend",onTouchEnd);};},[isOpen,environment]);return mouseAndTouchTrackersRef;}var useGetterPropsCalledChecker=function useGetterPropsCalledChecker2(){return noop$2;};function useA11yMessageSetter(getA11yMessage,dependencyArray,_ref22){var isInitialMount=_ref22.isInitialMount,highlightedIndex=_ref22.highlightedIndex,items=_ref22.items,environment=_ref22.environment,rest=_objectWithoutPropertiesLoose(_ref22,["isInitialMount","highlightedIndex","items","environment"]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMount){return;}updateA11yStatus(function(){return getA11yMessage(_extends$2({highlightedIndex:highlightedIndex,highlightedItem:items[highlightedIndex],resultCount:items.length},rest));},environment.document);},dependencyArray);}function useScrollIntoView(_ref32){var highlightedIndex=_ref32.highlightedIndex,isOpen=_ref32.isOpen,itemRefs=_ref32.itemRefs,getItemNodeFromIndex=_ref32.getItemNodeFromIndex,menuElement=_ref32.menuElement,scrollIntoViewProp=_ref32.scrollIntoView;var shouldScrollRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);useIsomorphicLayoutEffect$1(function(){if(highlightedIndex<0||!isOpen||!Object.keys(itemRefs.current).length){return;}if(shouldScrollRef.current===false){shouldScrollRef.current=true;}else{scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex),menuElement);}},[highlightedIndex]);return shouldScrollRef;}var useControlPropsValidator=noop$2;function downshiftCommonReducer(state,action,stateChangeTypes2){var type=action.type,props=action.props;var changes;switch(type){case stateChangeTypes2.ItemMouseMove:changes={highlightedIndex:action.index};break;case stateChangeTypes2.MenuMouseLeave:changes={highlightedIndex:-1};break;case stateChangeTypes2.ToggleButtonClick:case stateChangeTypes2.FunctionToggleMenu:changes={isOpen:!state.isOpen,highlightedIndex:state.isOpen?-1:getHighlightedIndexOnOpen(props,state,0)};break;case stateChangeTypes2.FunctionOpenMenu:changes={isOpen:true,highlightedIndex:getHighlightedIndexOnOpen(props,state,0)};break;case stateChangeTypes2.FunctionCloseMenu:changes={isOpen:false};break;case stateChangeTypes2.FunctionSetHighlightedIndex:changes={highlightedIndex:action.highlightedIndex};break;case stateChangeTypes2.FunctionSetInputValue:changes={inputValue:action.inputValue};break;case stateChangeTypes2.FunctionReset:changes={highlightedIndex:getDefaultValue(props,"highlightedIndex"),isOpen:getDefaultValue(props,"isOpen"),selectedItem:getDefaultValue(props,"selectedItem"),inputValue:getDefaultValue(props,"inputValue")};break;default:throw new Error("Reducer called without proper action type.");}return _extends$2({},state,changes);}function getItemIndexByCharacterKey(keysSoFar,highlightedIndex,items,itemToString2,getItemNodeFromIndex){var lowerCasedKeysSoFar=keysSoFar.toLowerCase();for(var index2=0;index2<items.length;index2++){var offsetIndex=(index2+highlightedIndex+1)%items.length;if(itemToString2(items[offsetIndex]).toLowerCase().startsWith(lowerCasedKeysSoFar)){var element=getItemNodeFromIndex(offsetIndex);if(!(element&&element.hasAttribute("disabled"))){return offsetIndex;}}}return highlightedIndex;}({items:PropTypes$3.array.isRequired,itemToString:PropTypes$3.func,getA11yStatusMessage:PropTypes$3.func,getA11ySelectionMessage:PropTypes$3.func,circularNavigation:PropTypes$3.bool,highlightedIndex:PropTypes$3.number,defaultHighlightedIndex:PropTypes$3.number,initialHighlightedIndex:PropTypes$3.number,isOpen:PropTypes$3.bool,defaultIsOpen:PropTypes$3.bool,initialIsOpen:PropTypes$3.bool,selectedItem:PropTypes$3.any,initialSelectedItem:PropTypes$3.any,defaultSelectedItem:PropTypes$3.any,id:PropTypes$3.string,labelId:PropTypes$3.string,menuId:PropTypes$3.string,getItemId:PropTypes$3.func,toggleButtonId:PropTypes$3.string,stateReducer:PropTypes$3.func,onSelectedItemChange:PropTypes$3.func,onHighlightedIndexChange:PropTypes$3.func,onStateChange:PropTypes$3.func,onIsOpenChange:PropTypes$3.func,environment:PropTypes$3.shape({addEventListener:PropTypes$3.func,removeEventListener:PropTypes$3.func,document:PropTypes$3.shape({getElementById:PropTypes$3.func,activeElement:PropTypes$3.any,body:PropTypes$3.any})})});function getA11yStatusMessage$1(_ref6){var isOpen=_ref6.isOpen,resultCount=_ref6.resultCount,previousResultCount=_ref6.previousResultCount;if(!isOpen){return"";}if(!resultCount){return"No results are available.";}if(resultCount!==previousResultCount){return resultCount+" result"+(resultCount===1?" is":"s are")+" available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.";}return"";}var defaultProps$1=_extends$2({},defaultProps2,{getA11yStatusMessage:getA11yStatusMessage$1});var MenuKeyDownArrowDown=0;var MenuKeyDownArrowUp=1;var MenuKeyDownEscape=2;var MenuKeyDownHome=3;var MenuKeyDownEnd=4;var MenuKeyDownEnter=5;var MenuKeyDownSpaceButton=6;var MenuKeyDownCharacter=7;var MenuBlur=8;var MenuMouseLeave=9;var ItemMouseMove=10;var ItemClick=11;var ToggleButtonClick=12;var ToggleButtonKeyDownArrowDown=13;var ToggleButtonKeyDownArrowUp=14;var ToggleButtonKeyDownCharacter=15;var FunctionToggleMenu=16;var FunctionOpenMenu=17;var FunctionCloseMenu=18;var FunctionSetHighlightedIndex=19;var FunctionSelectItem=20;var FunctionSetInputValue=21;var FunctionReset=22;var stateChangeTypes$1=/* @__PURE__ */Object.freeze({__proto__:null,MenuKeyDownArrowDown:MenuKeyDownArrowDown,MenuKeyDownArrowUp:MenuKeyDownArrowUp,MenuKeyDownEscape:MenuKeyDownEscape,MenuKeyDownHome:MenuKeyDownHome,MenuKeyDownEnd:MenuKeyDownEnd,MenuKeyDownEnter:MenuKeyDownEnter,MenuKeyDownSpaceButton:MenuKeyDownSpaceButton,MenuKeyDownCharacter:MenuKeyDownCharacter,MenuBlur:MenuBlur,MenuMouseLeave:MenuMouseLeave,ItemMouseMove:ItemMouseMove,ItemClick:ItemClick,ToggleButtonClick:ToggleButtonClick,ToggleButtonKeyDownArrowDown:ToggleButtonKeyDownArrowDown,ToggleButtonKeyDownArrowUp:ToggleButtonKeyDownArrowUp,ToggleButtonKeyDownCharacter:ToggleButtonKeyDownCharacter,FunctionToggleMenu:FunctionToggleMenu,FunctionOpenMenu:FunctionOpenMenu,FunctionCloseMenu:FunctionCloseMenu,FunctionSetHighlightedIndex:FunctionSetHighlightedIndex,FunctionSelectItem:FunctionSelectItem,FunctionSetInputValue:FunctionSetInputValue,FunctionReset:FunctionReset});function downshiftSelectReducer(state,action){var type=action.type,props=action.props,shiftKey=action.shiftKey;var changes;switch(type){case ItemClick:changes={isOpen:getDefaultValue(props,"isOpen"),highlightedIndex:getDefaultValue(props,"highlightedIndex"),selectedItem:props.items[action.index]};break;case ToggleButtonKeyDownCharacter:{var lowercasedKey=action.key;var inputValue=""+state.inputValue+lowercasedKey;var itemIndex=getItemIndexByCharacterKey(inputValue,state.selectedItem?props.items.indexOf(state.selectedItem):-1,props.items,props.itemToString,action.getItemNodeFromIndex);changes=_extends$2({inputValue:inputValue},itemIndex>=0&&{selectedItem:props.items[itemIndex]});}break;case ToggleButtonKeyDownArrowDown:changes={highlightedIndex:getHighlightedIndexOnOpen(props,state,1,action.getItemNodeFromIndex),isOpen:true};break;case ToggleButtonKeyDownArrowUp:changes={highlightedIndex:getHighlightedIndexOnOpen(props,state,-1,action.getItemNodeFromIndex),isOpen:true};break;case MenuKeyDownEnter:case MenuKeyDownSpaceButton:changes=_extends$2({isOpen:getDefaultValue(props,"isOpen"),highlightedIndex:getDefaultValue(props,"highlightedIndex")},state.highlightedIndex>=0&&{selectedItem:props.items[state.highlightedIndex]});break;case MenuKeyDownHome:changes={highlightedIndex:getNextNonDisabledIndex(1,0,props.items.length,action.getItemNodeFromIndex,false)};break;case MenuKeyDownEnd:changes={highlightedIndex:getNextNonDisabledIndex(-1,props.items.length-1,props.items.length,action.getItemNodeFromIndex,false)};break;case MenuKeyDownEscape:changes={isOpen:false,highlightedIndex:-1};break;case MenuBlur:changes={isOpen:false,highlightedIndex:-1};break;case MenuKeyDownCharacter:{var _lowercasedKey=action.key;var _inputValue=""+state.inputValue+_lowercasedKey;var highlightedIndex=getItemIndexByCharacterKey(_inputValue,state.highlightedIndex,props.items,props.itemToString,action.getItemNodeFromIndex);changes=_extends$2({inputValue:_inputValue},highlightedIndex>=0&&{highlightedIndex:highlightedIndex});}break;case MenuKeyDownArrowDown:changes={highlightedIndex:getNextWrappingIndex(shiftKey?5:1,state.highlightedIndex,props.items.length,action.getItemNodeFromIndex,props.circularNavigation)};break;case MenuKeyDownArrowUp:changes={highlightedIndex:getNextWrappingIndex(shiftKey?-5:-1,state.highlightedIndex,props.items.length,action.getItemNodeFromIndex,props.circularNavigation)};break;case FunctionSelectItem:changes={selectedItem:action.selectedItem};break;default:return downshiftCommonReducer(state,action,stateChangeTypes$1);}return _extends$2({},state,changes);}useSelect.stateChangeTypes=stateChangeTypes$1;function useSelect(userProps){if(userProps===void 0){userProps={};}var props=_extends$2({},defaultProps$1,userProps);var items=props.items,scrollIntoView2=props.scrollIntoView,environment=props.environment,initialIsOpen=props.initialIsOpen,defaultIsOpen=props.defaultIsOpen,itemToString2=props.itemToString,getA11ySelectionMessage2=props.getA11ySelectionMessage,getA11yStatusMessage2=props.getA11yStatusMessage;var initialState=getInitialState(props);var _useControlledReducer=useControlledReducer(downshiftSelectReducer,initialState,props),state=_useControlledReducer[0],dispatch=_useControlledReducer[1];var isOpen=state.isOpen,highlightedIndex=state.highlightedIndex,selectedItem=state.selectedItem,inputValue=state.inputValue;var toggleButtonRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var menuRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var itemRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});var shouldBlurRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);var clearTimeoutRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var elementIds=useElementIds(props);var previousResultCountRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var isInitialMountRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);var latest=useLatestRef({state:state,props:props});var getItemNodeFromIndex=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index2){return itemRefs.current[elementIds.getItemId(index2)];},[elementIds]);useA11yMessageSetter(getA11yStatusMessage2,[isOpen,highlightedIndex,inputValue,items],_extends$2({isInitialMount:isInitialMountRef.current,previousResultCount:previousResultCountRef.current,items:items,environment:environment,itemToString:itemToString2},state));useA11yMessageSetter(getA11ySelectionMessage2,[selectedItem],_extends$2({isInitialMount:isInitialMountRef.current,previousResultCount:previousResultCountRef.current,items:items,environment:environment,itemToString:itemToString2},state));var shouldScrollRef=useScrollIntoView({menuElement:menuRef.current,highlightedIndex:highlightedIndex,isOpen:isOpen,itemRefs:itemRefs,scrollIntoView:scrollIntoView2,getItemNodeFromIndex:getItemNodeFromIndex});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMountRef.current){clearTimeoutRef.current=debounce$1(function(outerDispatch){outerDispatch({type:FunctionSetInputValue,inputValue:""});},500);}if(!inputValue){return;}clearTimeoutRef.current(dispatch);},[dispatch,inputValue]);useControlPropsValidator({isInitialMount:isInitialMountRef.current,props:props,state:state});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMountRef.current){if((initialIsOpen||defaultIsOpen||isOpen)&&menuRef.current){menuRef.current.focus();}return;}if(isOpen){if(menuRef.current){menuRef.current.focus();}return;}if(environment.document.activeElement===menuRef.current){if(toggleButtonRef.current){shouldBlurRef.current=false;toggleButtonRef.current.focus();}}},[isOpen]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMountRef.current){return;}previousResultCountRef.current=items.length;});var mouseAndTouchTrackersRef=useMouseAndTouchTracker(isOpen,[menuRef,toggleButtonRef],environment,function(){dispatch({type:MenuBlur});});var setGetterPropCallInfo=useGetterPropsCalledChecker();Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){isInitialMountRef.current=false;},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!isOpen){itemRefs.current={};}},[isOpen]);var toggleButtonKeyDownHandlers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{ArrowDown:function ArrowDown(event){event.preventDefault();dispatch({type:ToggleButtonKeyDownArrowDown,getItemNodeFromIndex:getItemNodeFromIndex,shiftKey:event.shiftKey});},ArrowUp:function ArrowUp(event){event.preventDefault();dispatch({type:ToggleButtonKeyDownArrowUp,getItemNodeFromIndex:getItemNodeFromIndex,shiftKey:event.shiftKey});}};},[dispatch,getItemNodeFromIndex]);var menuKeyDownHandlers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{ArrowDown:function ArrowDown(event){event.preventDefault();dispatch({type:MenuKeyDownArrowDown,getItemNodeFromIndex:getItemNodeFromIndex,shiftKey:event.shiftKey});},ArrowUp:function ArrowUp(event){event.preventDefault();dispatch({type:MenuKeyDownArrowUp,getItemNodeFromIndex:getItemNodeFromIndex,shiftKey:event.shiftKey});},Home:function Home2(event){event.preventDefault();dispatch({type:MenuKeyDownHome,getItemNodeFromIndex:getItemNodeFromIndex});},End:function End(event){event.preventDefault();dispatch({type:MenuKeyDownEnd,getItemNodeFromIndex:getItemNodeFromIndex});},Escape:function Escape(){dispatch({type:MenuKeyDownEscape});},Enter:function Enter(event){event.preventDefault();dispatch({type:MenuKeyDownEnter});}," ":function _(event){event.preventDefault();dispatch({type:MenuKeyDownSpaceButton});}};},[dispatch,getItemNodeFromIndex]);var toggleMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionToggleMenu});},[dispatch]);var closeMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionCloseMenu});},[dispatch]);var openMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionOpenMenu});},[dispatch]);var setHighlightedIndex=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newHighlightedIndex){dispatch({type:FunctionSetHighlightedIndex,highlightedIndex:newHighlightedIndex});},[dispatch]);var selectItem=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newSelectedItem){dispatch({type:FunctionSelectItem,selectedItem:newSelectedItem});},[dispatch]);var reset=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionReset});},[dispatch]);var setInputValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newInputValue){dispatch({type:FunctionSetInputValue,inputValue:newInputValue});},[dispatch]);var getLabelProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(labelProps){return _extends$2({id:elementIds.labelId,htmlFor:elementIds.toggleButtonId},labelProps);},[elementIds]);var getMenuProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp,_temp2){var _extends2;var _ref6=_temp===void 0?{}:_temp,onMouseLeave=_ref6.onMouseLeave,_ref$refKey=_ref6.refKey,refKey=_ref$refKey===void 0?"ref":_ref$refKey,onKeyDown=_ref6.onKeyDown,onBlur=_ref6.onBlur,ref=_ref6.ref,rest=_objectWithoutPropertiesLoose(_ref6,["onMouseLeave","refKey","onKeyDown","onBlur","ref"]);var _ref22=_temp2===void 0?{}:_temp2;_ref22.suppressRefError;var latestState=latest.current.state;var menuHandleKeyDown=function menuHandleKeyDown2(event){var key2=normalizeArrowKey(event);if(key2&&menuKeyDownHandlers[key2]){menuKeyDownHandlers[key2](event);}else if(isAcceptedCharacterKey(key2)){dispatch({type:MenuKeyDownCharacter,key:key2,getItemNodeFromIndex:getItemNodeFromIndex});}};var menuHandleBlur=function menuHandleBlur2(){if(shouldBlurRef.current===false){shouldBlurRef.current=true;return;}var shouldBlur=!mouseAndTouchTrackersRef.current.isMouseDown;if(shouldBlur){dispatch({type:MenuBlur});}};var menuHandleMouseLeave=function menuHandleMouseLeave2(){dispatch({type:MenuMouseLeave});};return _extends$2((_extends2={},_extends2[refKey]=handleRefs(ref,function(menuNode){menuRef.current=menuNode;}),_extends2.id=elementIds.menuId,_extends2.role="listbox",_extends2["aria-labelledby"]=elementIds.labelId,_extends2.tabIndex=-1,_extends2),latestState.isOpen&&latestState.highlightedIndex>-1&&{"aria-activedescendant":elementIds.getItemId(latestState.highlightedIndex)},{onMouseLeave:callAllEventHandlers(onMouseLeave,menuHandleMouseLeave),onKeyDown:callAllEventHandlers(onKeyDown,menuHandleKeyDown),onBlur:callAllEventHandlers(onBlur,menuHandleBlur)},rest);},[dispatch,latest,menuKeyDownHandlers,mouseAndTouchTrackersRef,setGetterPropCallInfo,elementIds,getItemNodeFromIndex]);var getToggleButtonProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp3,_temp4){var _extends3;var _ref32=_temp3===void 0?{}:_temp3,onClick=_ref32.onClick,onKeyDown=_ref32.onKeyDown,_ref3$refKey=_ref32.refKey,refKey=_ref3$refKey===void 0?"ref":_ref3$refKey,ref=_ref32.ref,rest=_objectWithoutPropertiesLoose(_ref32,["onClick","onKeyDown","refKey","ref"]);var _ref42=_temp4===void 0?{}:_temp4;_ref42.suppressRefError;var toggleButtonHandleClick=function toggleButtonHandleClick2(){dispatch({type:ToggleButtonClick});};var toggleButtonHandleKeyDown=function toggleButtonHandleKeyDown2(event){var key2=normalizeArrowKey(event);if(key2&&toggleButtonKeyDownHandlers[key2]){toggleButtonKeyDownHandlers[key2](event);}else if(isAcceptedCharacterKey(key2)){dispatch({type:ToggleButtonKeyDownCharacter,key:key2,getItemNodeFromIndex:getItemNodeFromIndex});}};var toggleProps=_extends$2((_extends3={},_extends3[refKey]=handleRefs(ref,function(toggleButtonNode){toggleButtonRef.current=toggleButtonNode;}),_extends3.id=elementIds.toggleButtonId,_extends3["aria-haspopup"]="listbox",_extends3["aria-expanded"]=latest.current.state.isOpen,_extends3["aria-labelledby"]=elementIds.labelId+" "+elementIds.toggleButtonId,_extends3),rest);if(!rest.disabled){toggleProps.onClick=callAllEventHandlers(onClick,toggleButtonHandleClick);toggleProps.onKeyDown=callAllEventHandlers(onKeyDown,toggleButtonHandleKeyDown);}return toggleProps;},[dispatch,latest,toggleButtonKeyDownHandlers,setGetterPropCallInfo,elementIds,getItemNodeFromIndex]);var getItemProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp5){var _extends4;var _ref52=_temp5===void 0?{}:_temp5,item=_ref52.item,index2=_ref52.index,onMouseMove=_ref52.onMouseMove,onClick=_ref52.onClick,_ref5$refKey=_ref52.refKey,refKey=_ref5$refKey===void 0?"ref":_ref5$refKey,ref=_ref52.ref,rest=_objectWithoutPropertiesLoose(_ref52,["item","index","onMouseMove","onClick","refKey","ref"]);var _latest$current=latest.current,latestState=_latest$current.state,latestProps=_latest$current.props;var itemHandleMouseMove=function itemHandleMouseMove2(){if(index2===latestState.highlightedIndex){return;}shouldScrollRef.current=false;dispatch({type:ItemMouseMove,index:index2});};var itemHandleClick=function itemHandleClick2(){dispatch({type:ItemClick,index:index2});};var itemIndex=getItemIndex(index2,item,latestProps.items);if(itemIndex<0){throw new Error("Pass either item or item index in getItemProps!");}var itemProps=_extends$2((_extends4={role:"option","aria-selected":""+(itemIndex===latestState.highlightedIndex),id:elementIds.getItemId(itemIndex)},_extends4[refKey]=handleRefs(ref,function(itemNode){if(itemNode){itemRefs.current[elementIds.getItemId(itemIndex)]=itemNode;}}),_extends4),rest);if(!rest.disabled){itemProps.onMouseMove=callAllEventHandlers(onMouseMove,itemHandleMouseMove);itemProps.onClick=callAllEventHandlers(onClick,itemHandleClick);}return itemProps;},[dispatch,latest,shouldScrollRef,elementIds]);return{getToggleButtonProps:getToggleButtonProps,getLabelProps:getLabelProps,getMenuProps:getMenuProps,getItemProps:getItemProps,toggleMenu:toggleMenu,openMenu:openMenu,closeMenu:closeMenu,setHighlightedIndex:setHighlightedIndex,selectItem:selectItem,reset:reset,setInputValue:setInputValue,highlightedIndex:highlightedIndex,isOpen:isOpen,selectedItem:selectedItem,inputValue:inputValue};}var InputKeyDownArrowDown=0;var InputKeyDownArrowUp=1;var InputKeyDownEscape=2;var InputKeyDownHome=3;var InputKeyDownEnd=4;var InputKeyDownEnter=5;var InputChange=6;var InputBlur=7;var MenuMouseLeave$1=8;var ItemMouseMove$1=9;var ItemClick$1=10;var ToggleButtonClick$1=11;var FunctionToggleMenu$1=12;var FunctionOpenMenu$1=13;var FunctionCloseMenu$1=14;var FunctionSetHighlightedIndex$1=15;var FunctionSelectItem$1=16;var FunctionSetInputValue$1=17;var FunctionReset$1=18;var ControlledPropUpdatedSelectedItem=19;var stateChangeTypes$2=/* @__PURE__ */Object.freeze({__proto__:null,InputKeyDownArrowDown:InputKeyDownArrowDown,InputKeyDownArrowUp:InputKeyDownArrowUp,InputKeyDownEscape:InputKeyDownEscape,InputKeyDownHome:InputKeyDownHome,InputKeyDownEnd:InputKeyDownEnd,InputKeyDownEnter:InputKeyDownEnter,InputChange:InputChange,InputBlur:InputBlur,MenuMouseLeave:MenuMouseLeave$1,ItemMouseMove:ItemMouseMove$1,ItemClick:ItemClick$1,ToggleButtonClick:ToggleButtonClick$1,FunctionToggleMenu:FunctionToggleMenu$1,FunctionOpenMenu:FunctionOpenMenu$1,FunctionCloseMenu:FunctionCloseMenu$1,FunctionSetHighlightedIndex:FunctionSetHighlightedIndex$1,FunctionSelectItem:FunctionSelectItem$1,FunctionSetInputValue:FunctionSetInputValue$1,FunctionReset:FunctionReset$1,ControlledPropUpdatedSelectedItem:ControlledPropUpdatedSelectedItem});function getInitialState$1(props){var initialState=getInitialState(props);var selectedItem=initialState.selectedItem;var inputValue=initialState.inputValue;if(inputValue===""&&selectedItem&&props.defaultInputValue===void 0&&props.initialInputValue===void 0&&props.inputValue===void 0){inputValue=props.itemToString(selectedItem);}return _extends$2({},initialState,{inputValue:inputValue});}({items:PropTypes$3.array.isRequired,itemToString:PropTypes$3.func,getA11yStatusMessage:PropTypes$3.func,getA11ySelectionMessage:PropTypes$3.func,circularNavigation:PropTypes$3.bool,highlightedIndex:PropTypes$3.number,defaultHighlightedIndex:PropTypes$3.number,initialHighlightedIndex:PropTypes$3.number,isOpen:PropTypes$3.bool,defaultIsOpen:PropTypes$3.bool,initialIsOpen:PropTypes$3.bool,selectedItem:PropTypes$3.any,initialSelectedItem:PropTypes$3.any,defaultSelectedItem:PropTypes$3.any,inputValue:PropTypes$3.string,defaultInputValue:PropTypes$3.string,initialInputValue:PropTypes$3.string,id:PropTypes$3.string,labelId:PropTypes$3.string,menuId:PropTypes$3.string,getItemId:PropTypes$3.func,inputId:PropTypes$3.string,toggleButtonId:PropTypes$3.string,stateReducer:PropTypes$3.func,onSelectedItemChange:PropTypes$3.func,onHighlightedIndexChange:PropTypes$3.func,onStateChange:PropTypes$3.func,onIsOpenChange:PropTypes$3.func,onInputValueChange:PropTypes$3.func,environment:PropTypes$3.shape({addEventListener:PropTypes$3.func,removeEventListener:PropTypes$3.func,document:PropTypes$3.shape({getElementById:PropTypes$3.func,activeElement:PropTypes$3.any,body:PropTypes$3.any})})});function useControlledReducer$1(reducer2,initialState,props){var previousSelectedItemRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var _useEnhancedReducer=useEnhancedReducer(reducer2,initialState,props),state=_useEnhancedReducer[0],dispatch=_useEnhancedReducer[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isControlledProp(props,"selectedItem")){if(previousSelectedItemRef.current!==props.selectedItem){dispatch({type:ControlledPropUpdatedSelectedItem,inputValue:props.itemToString(props.selectedItem)});}previousSelectedItemRef.current=state.selectedItem===previousSelectedItemRef.current?props.selectedItem:state.selectedItem;}});return[getState(state,props),dispatch];}var defaultProps$2=_extends$2({},defaultProps2,{getA11yStatusMessage:getA11yStatusMessage,circularNavigation:true});function downshiftUseComboboxReducer(state,action){var type=action.type,props=action.props,shiftKey=action.shiftKey;var changes;switch(type){case ItemClick$1:changes={isOpen:getDefaultValue(props,"isOpen"),highlightedIndex:getDefaultValue(props,"highlightedIndex"),selectedItem:props.items[action.index],inputValue:props.itemToString(props.items[action.index])};break;case InputKeyDownArrowDown:if(state.isOpen){changes={highlightedIndex:getNextWrappingIndex(shiftKey?5:1,state.highlightedIndex,props.items.length,action.getItemNodeFromIndex,props.circularNavigation)};}else{changes={highlightedIndex:getHighlightedIndexOnOpen(props,state,1,action.getItemNodeFromIndex),isOpen:props.items.length>=0};}break;case InputKeyDownArrowUp:if(state.isOpen){changes={highlightedIndex:getNextWrappingIndex(shiftKey?-5:-1,state.highlightedIndex,props.items.length,action.getItemNodeFromIndex,props.circularNavigation)};}else{changes={highlightedIndex:getHighlightedIndexOnOpen(props,state,-1,action.getItemNodeFromIndex),isOpen:props.items.length>=0};}break;case InputKeyDownEnter:changes=_extends$2({},state.isOpen&&state.highlightedIndex>=0&&{selectedItem:props.items[state.highlightedIndex],isOpen:getDefaultValue(props,"isOpen"),highlightedIndex:getDefaultValue(props,"highlightedIndex"),inputValue:props.itemToString(props.items[state.highlightedIndex])});break;case InputKeyDownEscape:changes=_extends$2({isOpen:false,highlightedIndex:-1},!state.isOpen&&{selectedItem:null,inputValue:""});break;case InputKeyDownHome:changes={highlightedIndex:getNextNonDisabledIndex(1,0,props.items.length,action.getItemNodeFromIndex,false)};break;case InputKeyDownEnd:changes={highlightedIndex:getNextNonDisabledIndex(-1,props.items.length-1,props.items.length,action.getItemNodeFromIndex,false)};break;case InputBlur:changes=_extends$2({isOpen:false,highlightedIndex:-1},state.highlightedIndex>=0&&action.selectItem&&{selectedItem:props.items[state.highlightedIndex],inputValue:props.itemToString(props.items[state.highlightedIndex])});break;case InputChange:changes={isOpen:true,highlightedIndex:getDefaultValue(props,"highlightedIndex"),inputValue:action.inputValue};break;case FunctionSelectItem$1:changes={selectedItem:action.selectedItem,inputValue:props.itemToString(action.selectedItem)};break;case ControlledPropUpdatedSelectedItem:changes={inputValue:action.inputValue};break;default:return downshiftCommonReducer(state,action,stateChangeTypes$2);}return _extends$2({},state,changes);}useCombobox.stateChangeTypes=stateChangeTypes$2;function useCombobox(userProps){if(userProps===void 0){userProps={};}var props=_extends$2({},defaultProps$2,userProps);var initialIsOpen=props.initialIsOpen,defaultIsOpen=props.defaultIsOpen,items=props.items,scrollIntoView2=props.scrollIntoView,environment=props.environment,getA11yStatusMessage2=props.getA11yStatusMessage,getA11ySelectionMessage2=props.getA11ySelectionMessage,itemToString2=props.itemToString;var initialState=getInitialState$1(props);var _useControlledReducer=useControlledReducer$1(downshiftUseComboboxReducer,initialState,props),state=_useControlledReducer[0],dispatch=_useControlledReducer[1];var isOpen=state.isOpen,highlightedIndex=state.highlightedIndex,selectedItem=state.selectedItem,inputValue=state.inputValue;var menuRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var itemRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});var inputRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var toggleButtonRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var comboboxRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var isInitialMountRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);var elementIds=useElementIds(props);var previousResultCountRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var latest=useLatestRef({state:state,props:props});var getItemNodeFromIndex=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index2){return itemRefs.current[elementIds.getItemId(index2)];},[elementIds]);useA11yMessageSetter(getA11yStatusMessage2,[isOpen,highlightedIndex,inputValue,items],_extends$2({isInitialMount:isInitialMountRef.current,previousResultCount:previousResultCountRef.current,items:items,environment:environment,itemToString:itemToString2},state));useA11yMessageSetter(getA11ySelectionMessage2,[selectedItem],_extends$2({isInitialMount:isInitialMountRef.current,previousResultCount:previousResultCountRef.current,items:items,environment:environment,itemToString:itemToString2},state));var shouldScrollRef=useScrollIntoView({menuElement:menuRef.current,highlightedIndex:highlightedIndex,isOpen:isOpen,itemRefs:itemRefs,scrollIntoView:scrollIntoView2,getItemNodeFromIndex:getItemNodeFromIndex});useControlPropsValidator({isInitialMount:isInitialMountRef.current,props:props,state:state});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var focusOnOpen=initialIsOpen||defaultIsOpen||isOpen;if(focusOnOpen&&inputRef.current){inputRef.current.focus();}},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMountRef.current){return;}previousResultCountRef.current=items.length;});var mouseAndTouchTrackersRef=useMouseAndTouchTracker(isOpen,[comboboxRef,menuRef,toggleButtonRef],environment,function(){dispatch({type:InputBlur,selectItem:false});});var setGetterPropCallInfo=useGetterPropsCalledChecker();Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){isInitialMountRef.current=false;},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!isOpen){itemRefs.current={};}},[isOpen]);var inputKeyDownHandlers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{ArrowDown:function ArrowDown(event){event.preventDefault();dispatch({type:InputKeyDownArrowDown,shiftKey:event.shiftKey,getItemNodeFromIndex:getItemNodeFromIndex});},ArrowUp:function ArrowUp(event){event.preventDefault();dispatch({type:InputKeyDownArrowUp,shiftKey:event.shiftKey,getItemNodeFromIndex:getItemNodeFromIndex});},Home:function Home2(event){if(!latest.current.state.isOpen){return;}event.preventDefault();dispatch({type:InputKeyDownHome,getItemNodeFromIndex:getItemNodeFromIndex});},End:function End(event){if(!latest.current.state.isOpen){return;}event.preventDefault();dispatch({type:InputKeyDownEnd,getItemNodeFromIndex:getItemNodeFromIndex});},Escape:function Escape(){var latestState=latest.current.state;if(latestState.isOpen||latestState.inputValue||latestState.selectedItem||latestState.highlightedIndex>-1){dispatch({type:InputKeyDownEscape});}},Enter:function Enter(event){var latestState=latest.current.state;if(!latestState.isOpen||latestState.highlightedIndex<0||event.which===229){return;}event.preventDefault();dispatch({type:InputKeyDownEnter,getItemNodeFromIndex:getItemNodeFromIndex});}};},[dispatch,latest,getItemNodeFromIndex]);var getLabelProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(labelProps){return _extends$2({id:elementIds.labelId,htmlFor:elementIds.inputId},labelProps);},[elementIds]);var getMenuProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp,_temp2){var _extends2;var _ref6=_temp===void 0?{}:_temp,onMouseLeave=_ref6.onMouseLeave,_ref$refKey=_ref6.refKey,refKey=_ref$refKey===void 0?"ref":_ref$refKey,ref=_ref6.ref,rest=_objectWithoutPropertiesLoose(_ref6,["onMouseLeave","refKey","ref"]);var _ref22=_temp2===void 0?{}:_temp2;_ref22.suppressRefError;return _extends$2((_extends2={},_extends2[refKey]=handleRefs(ref,function(menuNode){menuRef.current=menuNode;}),_extends2.id=elementIds.menuId,_extends2.role="listbox",_extends2["aria-labelledby"]=elementIds.labelId,_extends2.onMouseLeave=callAllEventHandlers(onMouseLeave,function(){dispatch({type:MenuMouseLeave$1});}),_extends2),rest);},[dispatch,setGetterPropCallInfo,elementIds]);var getItemProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp3){var _extends3,_ref42;var _ref32=_temp3===void 0?{}:_temp3,item=_ref32.item,index2=_ref32.index,_ref3$refKey=_ref32.refKey,refKey=_ref3$refKey===void 0?"ref":_ref3$refKey,ref=_ref32.ref,onMouseMove=_ref32.onMouseMove,onClick=_ref32.onClick;_ref32.onPress;var rest=_objectWithoutPropertiesLoose(_ref32,["item","index","refKey","ref","onMouseMove","onClick","onPress"]);var _latest$current=latest.current,latestProps=_latest$current.props,latestState=_latest$current.state;var itemIndex=getItemIndex(index2,item,latestProps.items);if(itemIndex<0){throw new Error("Pass either item or item index in getItemProps!");}var onSelectKey="onClick";var customClickHandler=onClick;var itemHandleMouseMove=function itemHandleMouseMove2(){if(index2===latestState.highlightedIndex){return;}shouldScrollRef.current=false;dispatch({type:ItemMouseMove$1,index:index2});};var itemHandleClick=function itemHandleClick2(){dispatch({type:ItemClick$1,index:index2});if(inputRef.current){inputRef.current.focus();}};return _extends$2((_extends3={},_extends3[refKey]=handleRefs(ref,function(itemNode){if(itemNode){itemRefs.current[elementIds.getItemId(itemIndex)]=itemNode;}}),_extends3.role="option",_extends3["aria-selected"]=""+(itemIndex===latestState.highlightedIndex),_extends3.id=elementIds.getItemId(itemIndex),_extends3),!rest.disabled&&(_ref42={onMouseMove:callAllEventHandlers(onMouseMove,itemHandleMouseMove)},_ref42[onSelectKey]=callAllEventHandlers(customClickHandler,itemHandleClick),_ref42),rest);},[dispatch,latest,shouldScrollRef,elementIds]);var getToggleButtonProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp4){var _extends4;var _ref52=_temp4===void 0?{}:_temp4,onClick=_ref52.onClick;_ref52.onPress;var _ref5$refKey=_ref52.refKey,refKey=_ref5$refKey===void 0?"ref":_ref5$refKey,ref=_ref52.ref,rest=_objectWithoutPropertiesLoose(_ref52,["onClick","onPress","refKey","ref"]);var toggleButtonHandleClick=function toggleButtonHandleClick2(){dispatch({type:ToggleButtonClick$1});if(!latest.current.state.isOpen&&inputRef.current){inputRef.current.focus();}};return _extends$2((_extends4={},_extends4[refKey]=handleRefs(ref,function(toggleButtonNode){toggleButtonRef.current=toggleButtonNode;}),_extends4.id=elementIds.toggleButtonId,_extends4.tabIndex=-1,_extends4),!rest.disabled&&_extends$2({},{onClick:callAllEventHandlers(onClick,toggleButtonHandleClick)}),rest);},[dispatch,latest,elementIds]);var getInputProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp5,_temp6){var _extends5;var _ref6=_temp5===void 0?{}:_temp5,onKeyDown=_ref6.onKeyDown,onChange=_ref6.onChange,onInput=_ref6.onInput,onBlur=_ref6.onBlur;_ref6.onChangeText;var _ref6$refKey=_ref6.refKey,refKey=_ref6$refKey===void 0?"ref":_ref6$refKey,ref=_ref6.ref,rest=_objectWithoutPropertiesLoose(_ref6,["onKeyDown","onChange","onInput","onBlur","onChangeText","refKey","ref"]);var _ref7=_temp6===void 0?{}:_temp6;_ref7.suppressRefError;var latestState=latest.current.state;var inputHandleKeyDown=function inputHandleKeyDown2(event){var key2=normalizeArrowKey(event);if(key2&&inputKeyDownHandlers[key2]){inputKeyDownHandlers[key2](event);}};var inputHandleChange=function inputHandleChange2(event){dispatch({type:InputChange,inputValue:event.target.value});};var inputHandleBlur=function inputHandleBlur2(){if(latestState.isOpen&&!mouseAndTouchTrackersRef.current.isMouseDown){dispatch({type:InputBlur,selectItem:true});}};var onChangeKey="onChange";var eventHandlers={};if(!rest.disabled){var _eventHandlers;eventHandlers=(_eventHandlers={},_eventHandlers[onChangeKey]=callAllEventHandlers(onChange,onInput,inputHandleChange),_eventHandlers.onKeyDown=callAllEventHandlers(onKeyDown,inputHandleKeyDown),_eventHandlers.onBlur=callAllEventHandlers(onBlur,inputHandleBlur),_eventHandlers);}return _extends$2((_extends5={},_extends5[refKey]=handleRefs(ref,function(inputNode){inputRef.current=inputNode;}),_extends5.id=elementIds.inputId,_extends5["aria-autocomplete"]="list",_extends5["aria-controls"]=elementIds.menuId,_extends5),latestState.isOpen&&latestState.highlightedIndex>-1&&{"aria-activedescendant":elementIds.getItemId(latestState.highlightedIndex)},{"aria-labelledby":elementIds.labelId,autoComplete:"off",value:latestState.inputValue},eventHandlers,rest);},[dispatch,inputKeyDownHandlers,latest,mouseAndTouchTrackersRef,setGetterPropCallInfo,elementIds]);var getComboboxProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp7,_temp8){var _extends6;var _ref8=_temp7===void 0?{}:_temp7,_ref8$refKey=_ref8.refKey,refKey=_ref8$refKey===void 0?"ref":_ref8$refKey,ref=_ref8.ref,rest=_objectWithoutPropertiesLoose(_ref8,["refKey","ref"]);var _ref9=_temp8===void 0?{}:_temp8;_ref9.suppressRefError;return _extends$2((_extends6={},_extends6[refKey]=handleRefs(ref,function(comboboxNode){comboboxRef.current=comboboxNode;}),_extends6.role="combobox",_extends6["aria-haspopup"]="listbox",_extends6["aria-owns"]=elementIds.menuId,_extends6["aria-expanded"]=latest.current.state.isOpen,_extends6),rest);},[latest,setGetterPropCallInfo,elementIds]);var toggleMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionToggleMenu$1});},[dispatch]);var closeMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionCloseMenu$1});},[dispatch]);var openMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionOpenMenu$1});},[dispatch]);var setHighlightedIndex=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newHighlightedIndex){dispatch({type:FunctionSetHighlightedIndex$1,highlightedIndex:newHighlightedIndex});},[dispatch]);var selectItem=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newSelectedItem){dispatch({type:FunctionSelectItem$1,selectedItem:newSelectedItem});},[dispatch]);var setInputValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newInputValue){dispatch({type:FunctionSetInputValue$1,inputValue:newInputValue});},[dispatch]);var reset=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionReset$1});},[dispatch]);return{getItemProps:getItemProps,getLabelProps:getLabelProps,getMenuProps:getMenuProps,getInputProps:getInputProps,getComboboxProps:getComboboxProps,getToggleButtonProps:getToggleButtonProps,toggleMenu:toggleMenu,openMenu:openMenu,closeMenu:closeMenu,setHighlightedIndex:setHighlightedIndex,setInputValue:setInputValue,selectItem:selectItem,reset:reset,highlightedIndex:highlightedIndex,isOpen:isOpen,selectedItem:selectedItem,inputValue:inputValue};}var defaultStateValues={activeIndex:-1,selectedItems:[]};function getInitialValue$1(props,propKey){return getInitialValue(props,propKey,defaultStateValues);}function getDefaultValue$1(props,propKey){return getDefaultValue(props,propKey,defaultStateValues);}function getInitialState$2(props){var activeIndex=getInitialValue$1(props,"activeIndex");var selectedItems=getInitialValue$1(props,"selectedItems");return{activeIndex:activeIndex,selectedItems:selectedItems};}function isKeyDownOperationPermitted(event){if(event.shiftKey||event.metaKey||event.ctrlKey||event.altKey){return false;}var element=event.target;if(element instanceof HTMLInputElement&&element.value!==""&&(element.selectionStart!==0||element.selectionEnd!==0)){return false;}return true;}function getA11yRemovalMessage(selectionParameters){var removedSelectedItem=selectionParameters.removedSelectedItem,itemToStringLocal=selectionParameters.itemToString;return itemToStringLocal(removedSelectedItem)+" has been removed.";}({selectedItems:PropTypes$3.array,initialSelectedItems:PropTypes$3.array,defaultSelectedItems:PropTypes$3.array,itemToString:PropTypes$3.func,getA11yRemovalMessage:PropTypes$3.func,stateReducer:PropTypes$3.func,activeIndex:PropTypes$3.number,initialActiveIndex:PropTypes$3.number,defaultActiveIndex:PropTypes$3.number,onActiveIndexChange:PropTypes$3.func,onSelectedItemsChange:PropTypes$3.func,keyNavigationNext:PropTypes$3.string,keyNavigationPrevious:PropTypes$3.string,environment:PropTypes$3.shape({addEventListener:PropTypes$3.func,removeEventListener:PropTypes$3.func,document:PropTypes$3.shape({getElementById:PropTypes$3.func,activeElement:PropTypes$3.any,body:PropTypes$3.any})})});var defaultProps$3={itemToString:defaultProps2.itemToString,stateReducer:defaultProps2.stateReducer,environment:defaultProps2.environment,getA11yRemovalMessage:getA11yRemovalMessage,keyNavigationNext:"ArrowRight",keyNavigationPrevious:"ArrowLeft"};var SelectedItemClick=0;var SelectedItemKeyDownDelete=1;var SelectedItemKeyDownBackspace=2;var SelectedItemKeyDownNavigationNext=3;var SelectedItemKeyDownNavigationPrevious=4;var DropdownKeyDownNavigationPrevious=5;var DropdownKeyDownBackspace=6;var DropdownClick=7;var FunctionAddSelectedItem=8;var FunctionRemoveSelectedItem=9;var FunctionSetSelectedItems=10;var FunctionSetActiveIndex=11;var FunctionReset$2=12;var stateChangeTypes$3=/* @__PURE__ */Object.freeze({__proto__:null,SelectedItemClick:SelectedItemClick,SelectedItemKeyDownDelete:SelectedItemKeyDownDelete,SelectedItemKeyDownBackspace:SelectedItemKeyDownBackspace,SelectedItemKeyDownNavigationNext:SelectedItemKeyDownNavigationNext,SelectedItemKeyDownNavigationPrevious:SelectedItemKeyDownNavigationPrevious,DropdownKeyDownNavigationPrevious:DropdownKeyDownNavigationPrevious,DropdownKeyDownBackspace:DropdownKeyDownBackspace,DropdownClick:DropdownClick,FunctionAddSelectedItem:FunctionAddSelectedItem,FunctionRemoveSelectedItem:FunctionRemoveSelectedItem,FunctionSetSelectedItems:FunctionSetSelectedItems,FunctionSetActiveIndex:FunctionSetActiveIndex,FunctionReset:FunctionReset$2});function downshiftMultipleSelectionReducer(state,action){var type=action.type,index2=action.index,props=action.props,selectedItem=action.selectedItem;var activeIndex=state.activeIndex,selectedItems=state.selectedItems;var changes;switch(type){case SelectedItemClick:changes={activeIndex:index2};break;case SelectedItemKeyDownNavigationPrevious:changes={activeIndex:activeIndex-1<0?0:activeIndex-1};break;case SelectedItemKeyDownNavigationNext:changes={activeIndex:activeIndex+1>=selectedItems.length?-1:activeIndex+1};break;case SelectedItemKeyDownBackspace:case SelectedItemKeyDownDelete:{var newActiveIndex=activeIndex;if(selectedItems.length===1){newActiveIndex=-1;}else if(activeIndex===selectedItems.length-1){newActiveIndex=selectedItems.length-2;}changes=_extends$2({selectedItems:[].concat(selectedItems.slice(0,activeIndex),selectedItems.slice(activeIndex+1))},{activeIndex:newActiveIndex});break;}case DropdownKeyDownNavigationPrevious:changes={activeIndex:selectedItems.length-1};break;case DropdownKeyDownBackspace:changes={selectedItems:selectedItems.slice(0,selectedItems.length-1)};break;case FunctionAddSelectedItem:changes={selectedItems:[].concat(selectedItems,[selectedItem])};break;case DropdownClick:changes={activeIndex:-1};break;case FunctionRemoveSelectedItem:{var _newActiveIndex=activeIndex;var selectedItemIndex=selectedItems.indexOf(selectedItem);if(selectedItems.length===1){_newActiveIndex=-1;}else if(selectedItemIndex===selectedItems.length-1){_newActiveIndex=selectedItems.length-2;}changes=_extends$2({selectedItems:[].concat(selectedItems.slice(0,selectedItemIndex),selectedItems.slice(selectedItemIndex+1))},{activeIndex:_newActiveIndex});break;}case FunctionSetSelectedItems:{var newSelectedItems=action.selectedItems;changes={selectedItems:newSelectedItems};break;}case FunctionSetActiveIndex:{var _newActiveIndex2=action.activeIndex;changes={activeIndex:_newActiveIndex2};break;}case FunctionReset$2:changes={activeIndex:getDefaultValue$1(props,"activeIndex"),selectedItems:getDefaultValue$1(props,"selectedItems")};break;default:throw new Error("Reducer called without proper action type.");}return _extends$2({},state,changes);}useMultipleSelection.stateChangeTypes=stateChangeTypes$3;function useMultipleSelection(userProps){if(userProps===void 0){userProps={};}var props=_extends$2({},defaultProps$3,userProps);var getA11yRemovalMessage2=props.getA11yRemovalMessage,itemToString2=props.itemToString,environment=props.environment,keyNavigationNext=props.keyNavigationNext,keyNavigationPrevious=props.keyNavigationPrevious;var _useControlledReducer=useControlledReducer(downshiftMultipleSelectionReducer,getInitialState$2(props),props),state=_useControlledReducer[0],dispatch=_useControlledReducer[1];var activeIndex=state.activeIndex,selectedItems=state.selectedItems;var isInitialMountRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);var dropdownRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var previousSelectedItemsRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(selectedItems);var selectedItemRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();selectedItemRefs.current=[];var latest=useLatestRef({state:state,props:props});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMountRef.current){return;}if(selectedItems.length<previousSelectedItemsRef.current.length){var removedSelectedItem=previousSelectedItemsRef.current.find(function(item){return selectedItems.indexOf(item)<0;});setStatus(getA11yRemovalMessage2({itemToString:itemToString2,resultCount:selectedItems.length,removedSelectedItem:removedSelectedItem,activeIndex:activeIndex,activeSelectedItem:selectedItems[activeIndex]}),environment.document);}previousSelectedItemsRef.current=selectedItems;},[selectedItems.length]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isInitialMountRef.current){return;}if(activeIndex===-1&&dropdownRef.current){dropdownRef.current.focus();}else if(selectedItemRefs.current[activeIndex]){selectedItemRefs.current[activeIndex].focus();}},[activeIndex]);useControlPropsValidator({isInitialMount:isInitialMountRef.current,props:props,state:state});var setGetterPropCallInfo=useGetterPropsCalledChecker();Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){isInitialMountRef.current=false;},[]);var selectedItemKeyDownHandlers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var _ref6;return _ref6={},_ref6[keyNavigationPrevious]=function(){dispatch({type:SelectedItemKeyDownNavigationPrevious});},_ref6[keyNavigationNext]=function(){dispatch({type:SelectedItemKeyDownNavigationNext});},_ref6.Delete=function Delete(){dispatch({type:SelectedItemKeyDownDelete});},_ref6.Backspace=function Backspace(){dispatch({type:SelectedItemKeyDownBackspace});},_ref6;},[dispatch,keyNavigationNext,keyNavigationPrevious]);var dropdownKeyDownHandlers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var _ref22;return _ref22={},_ref22[keyNavigationPrevious]=function(event){if(isKeyDownOperationPermitted(event)){dispatch({type:DropdownKeyDownNavigationPrevious});}},_ref22.Backspace=function Backspace(event){if(isKeyDownOperationPermitted(event)){dispatch({type:DropdownKeyDownBackspace});}},_ref22;},[dispatch,keyNavigationPrevious]);var getSelectedItemProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp){var _extends2;var _ref32=_temp===void 0?{}:_temp,_ref3$refKey=_ref32.refKey,refKey=_ref3$refKey===void 0?"ref":_ref3$refKey,ref=_ref32.ref,onClick=_ref32.onClick,onKeyDown=_ref32.onKeyDown,selectedItem=_ref32.selectedItem,index2=_ref32.index,rest=_objectWithoutPropertiesLoose(_ref32,["refKey","ref","onClick","onKeyDown","selectedItem","index"]);var latestState=latest.current.state;var itemIndex=getItemIndex(index2,selectedItem,latestState.selectedItems);if(itemIndex<0){throw new Error("Pass either selectedItem or index in getSelectedItemProps!");}var selectedItemHandleClick=function selectedItemHandleClick2(){dispatch({type:SelectedItemClick,index:index2});};var selectedItemHandleKeyDown=function selectedItemHandleKeyDown2(event){var key2=normalizeArrowKey(event);if(key2&&selectedItemKeyDownHandlers[key2]){selectedItemKeyDownHandlers[key2](event);}};return _extends$2((_extends2={},_extends2[refKey]=handleRefs(ref,function(selectedItemNode){if(selectedItemNode){selectedItemRefs.current.push(selectedItemNode);}}),_extends2.tabIndex=index2===latestState.activeIndex?0:-1,_extends2.onClick=callAllEventHandlers(onClick,selectedItemHandleClick),_extends2.onKeyDown=callAllEventHandlers(onKeyDown,selectedItemHandleKeyDown),_extends2),rest);},[dispatch,latest,selectedItemKeyDownHandlers]);var getDropdownProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_temp2,_temp3){var _extends3;var _ref42=_temp2===void 0?{}:_temp2,_ref4$refKey=_ref42.refKey,refKey=_ref4$refKey===void 0?"ref":_ref4$refKey,ref=_ref42.ref,onKeyDown=_ref42.onKeyDown,onClick=_ref42.onClick,_ref4$preventKeyActio=_ref42.preventKeyAction,preventKeyAction=_ref4$preventKeyActio===void 0?false:_ref4$preventKeyActio,rest=_objectWithoutPropertiesLoose(_ref42,["refKey","ref","onKeyDown","onClick","preventKeyAction"]);var _ref52=_temp3===void 0?{}:_temp3;_ref52.suppressRefError;var dropdownHandleKeyDown=function dropdownHandleKeyDown2(event){var key2=normalizeArrowKey(event);if(key2&&dropdownKeyDownHandlers[key2]){dropdownKeyDownHandlers[key2](event);}};var dropdownHandleClick=function dropdownHandleClick2(){dispatch({type:DropdownClick});};return _extends$2((_extends3={},_extends3[refKey]=handleRefs(ref,function(dropdownNode){if(dropdownNode){dropdownRef.current=dropdownNode;}}),_extends3),!preventKeyAction&&{onKeyDown:callAllEventHandlers(onKeyDown,dropdownHandleKeyDown),onClick:callAllEventHandlers(onClick,dropdownHandleClick)},rest);},[dispatch,dropdownKeyDownHandlers,setGetterPropCallInfo]);var addSelectedItem=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(selectedItem){dispatch({type:FunctionAddSelectedItem,selectedItem:selectedItem});},[dispatch]);var removeSelectedItem=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(selectedItem){dispatch({type:FunctionRemoveSelectedItem,selectedItem:selectedItem});},[dispatch]);var setSelectedItems=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newSelectedItems){dispatch({type:FunctionSetSelectedItems,selectedItems:newSelectedItems});},[dispatch]);var setActiveIndex=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(newActiveIndex){dispatch({type:FunctionSetActiveIndex,activeIndex:newActiveIndex});},[dispatch]);var reset=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){dispatch({type:FunctionReset$2});},[dispatch]);return{getSelectedItemProps:getSelectedItemProps,getDropdownProps:getDropdownProps,addSelectedItem:addSelectedItem,removeSelectedItem:removeSelectedItem,setSelectedItems:setSelectedItems,setActiveIndex:setActiveIndex,reset:reset,selectedItems:selectedItems,activeIndex:activeIndex};}var size$b=function size$b(_ref35){var size2=_ref35.size,theme=_ref35.theme;switch(size2){case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(typography$1("body3",{theme:theme}),";",padding("xs",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(typography$1("body2",{theme:theme}),";",padding("xxs",{theme:theme}),";");}};var kind$5=function kind$5(_ref36){var kind2=_ref36.kind,theme=_ref36.theme,valid2=_ref36.valid;switch(kind2){case"ghost":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border:none;color:",color("pewter",{theme:theme}),";",fontWeight("medium",{theme:theme}),";&:hover{background-color:",transparentize("slate",0.08,{theme:theme}),";}");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border:1px solid ",color(valid2?"silver":"red",{theme:theme}),";[aria-expanded='true'] &{border:1px solid ",color("slate",{theme:theme}),";}");}};var Input$2=createStyled("input",{target:"evzis1c0"})("width:100%;transition:all 0.3s ease 0s;outline-color:",color("slate"),";",borderRadius$1("default"),";",typography$1("body2"),";",size$b,";",kind$5,";[aria-expanded='true'] &{color:",color("white"),";background-color:",color("slate"),";outline:none;&::placeholder{color:",color("white"),";}}&:active{border-color:",color("slate"),";}&:focus{outline-color:",color("slate"),";outline-offset:-2px;}&:not([disabled]){cursor:pointer;&:focus{cursor:text;}}&[disabled]{cursor:not-allowed;color:",color("cadet"),";background:",color("offWhite"),";border:1px solid ",color("paleGrey"),";}&::placeholder{color:",color("cadet"),";opacity:1;",fontWeight("regular"),";}");var InputContainer=createStyled("div",{target:"et7fkz0"})({name:"79elbk",styles:"position:relative;"});var stopStart=function stopStart(_ref37){var dark2=_ref37.dark,size2=_ref37.size,theme=_ref37.theme;switch(size2){case"sm":return{stopColor:color(dark2?"white":"pewter",{theme:theme})};default:return{stopColor:gradientEnd("green",{theme:theme})};}};var stopEnd=function stopEnd(_ref38){var dark2=_ref38.dark,size2=_ref38.size,theme=_ref38.theme;switch(size2){case"sm":return{stopColor:color(dark2?"white":"pewter",{theme:theme}),stopOpacity:0.75};default:return{stopColor:gradientStart("green",{theme:theme})};}};var properties=function properties(bar){return bar?{x1:"0%",y1:"0%",x2:"100%",y2:"0%",gradientUnits:"userSpaceOnUse"}:{x1:"15.996%",y1:"100%",y2:"15.004%"};};var Gradient=function Gradient(_K){var _L=_K,dark2=_L.dark,size2=_L.size,bar=_L.bar,theme=_L.theme,rest=__objRest(_L,["dark","size","bar","theme"]);return/* @__PURE__ */jsxs("linearGradient",__spreadProps(__spreadValues(__spreadValues({},properties(bar)),rest),{children:[/* @__PURE__ */jsx("stop",__spreadValues({offset:"0%"},stopStart({dark:dark2,size:size2,theme:theme}))),/* @__PURE__ */jsx("stop",__spreadValues({offset:"100%"},stopEnd({dark:dark2,size:size2,theme:theme})))]}));};Gradient.displayName="Loader.Gradient";var dimensions=function dimensions(_ref39){var size2=_ref39.size,bar=_ref39.bar;if(bar){return{preserveAspectRatio:"none",width:"100%"};}switch(size2){case"sm":return{width:24,height:24};case"lg":return{width:56,height:56};default:return{width:36,height:36};}};var viewBox=function viewBox(bar){return bar?"0 0 100 1":"0 0 36 36";};var SVG=function SVG(_M){var _N=_M,children=_N.children,size2=_N.size,bar=_N.bar,props=__objRest(_N,["children","size","bar"]);return/* @__PURE__ */jsx("svg",__spreadProps(__spreadValues(__spreadValues({xmlns:"http://www.w3.org/2000/svg",viewBox:viewBox(bar)},dimensions({size:size2,bar:bar})),props),{children:children}));};SVG.displayName="Loader.SVG";var BarRail=function BarRail(props){return/* @__PURE__ */jsx("path",__spreadValues({d:"M 0,0.5 L 100,0.5",strokeWidth:"1"},props));};var RadialRail=function RadialRail(props){return/* @__PURE__ */jsx("circle",__spreadValues({cx:"18",cy:"18",r:"16.5",strokeWidth:"3"},props));};var Rail=function Rail(_ref40){var dark2=_ref40.dark,size2=_ref40.size,bar=_ref40.bar,theme=_ref40.theme;var props={};if(size2==="sm"){props.stroke=color(dark2?"white":"pewter",{theme:theme});props.opacity=0.3;}else{props.stroke=color(dark2?"slate":"paleGrey",{theme:theme});}return bar?/* @__PURE__ */jsx(BarRail,__spreadValues({},props)):/* @__PURE__ */jsx(RadialRail,__spreadValues({},props));};Rail.displayName="Loader.Rail";var Indefinite=function Indefinite(_O){var _P=_O,bar=_P.bar,rest=__objRest(_P,["bar"]);return bar?/* @__PURE__ */jsxs("path",__spreadProps(__spreadValues({d:"M 0,0.5 L 100,0.5",strokeWidth:"3"},rest),{children:[/* @__PURE__ */jsx("animateTransform",{attributeType:"xml",attributeName:"transform",type:"translate",dur:"1.2s",values:"0,0.5; 25,0.5; 100,0.5",repeatCount:"indefinite"}),/* @__PURE__ */jsx("animateTransform",{attributeType:"xml",attributeName:"transform",type:"scale",dur:"1.2s",values:"0.1;0.75;0.1",repeatCount:"indefinite",additive:"sum"})]})):/* @__PURE__ */jsx("path",__spreadProps(__spreadValues({d:"M 18,18 m 0,-16.5 a 16.5,16.5 0 1 1 0,33",strokeWidth:"3"},rest),{children:/* @__PURE__ */jsx("animateTransform",{attributeName:"transform",type:"rotate",dur:"1.4s",repeatCount:"indefinite",from:"0 18 18",to:"360 18 18"})}));};var radialLength=104;var Percentage=function Percentage(_Q){var _R=_Q,bar=_R.bar,percentage=_R.percentage,rest=__objRest(_R,["bar","percentage"]);var ratio=percentage/100;var dashLength=bar?100:radialLength;var path=bar?"M 0,0.5 L 100,0.5":"M 18,18 m 0,-16.5 a 16.5,16.5 0 1 1 0,33 a 16.5,16.5 0 1 1 0,-33";return/* @__PURE__ */jsx("path",__spreadValues({d:path,strokeWidth:"3",strokeDasharray:dashLength,strokeDashoffset:dashLength-dashLength*ratio},rest));};var counter=0;var LoaderImage=function LoaderImage(_S){var _T=_S,dark2=_T.dark,theme=_T.theme,size2=_T.size,bar=_T.bar,_T$percentage=_T.percentage,percentage=_T$percentage===void 0?null:_T$percentage,props=__objRest(_T,["dark","theme","size","bar","percentage"]);var loaderGradientId="stylist-loader-gradient-".concat(++counter);return/* @__PURE__ */jsxs(SVG,__spreadProps(__spreadValues({size:size2,bar:bar,role:"img","data-testid":"loader"},props),{children:[/* @__PURE__ */jsx(Gradient,{id:loaderGradientId,dark:dark2,size:size2,bar:bar,theme:theme}),/* @__PURE__ */jsxs("g",{fill:"none",children:[/* @__PURE__ */jsx(Rail,{theme:theme,dark:dark2,size:size2,bar:bar}),percentage!==null?/* @__PURE__ */jsx(Percentage,{stroke:"url(#".concat(loaderGradientId,")"),bar:bar,percentage:percentage}):/* @__PURE__ */jsx(Indefinite,{stroke:"url(#".concat(loaderGradientId,")"),bar:bar})]})]}));};var CenteredContainer=createStyled("div",{target:"e1elcccw0"})({name:"r20d3a",styles:"height:100%;display:flex;align-items:center;justify-content:center;"});var Loader$1=function Loader$1(_U){var _V=_U,centered=_V.centered,props=__objRest(_V,["centered"]);return centered?/* @__PURE__ */jsx(CenteredContainer,{children:/* @__PURE__ */jsx(LoaderImage,__spreadValues({},props))}):/* @__PURE__ */jsx(LoaderImage,__spreadValues({},props));};var Loader$2=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(Loader$1);var _ref$g={name:"1rgczi2",styles:"width:24px;height:24px;right:2.5rem;"};var _ref2$a={name:"1it4r02",styles:"width:20px;height:20px;right:2rem;"};var size$a=function size$a(_ref41){var loaderSize=_ref41.loaderSize;switch(loaderSize){case"lg":return _ref$g;default:return _ref2$a;}};var AutocompleteLoader=/* @__PURE__ */createStyled(function(_W){var _X=_W,_=_X.loaderSize,props=__objRest(_X,["loaderSize"]);return/* @__PURE__ */jsx(Loader$2,__spreadValues({},props));},{target:"e1o12l2m0"})("position:absolute;top:50%;transform:translateY(-50%);",size$a,";");var Loader=withProps$1(function(_ref43){var size2=_ref43.size;return{loaderSize:size2,size:"sm"};})(AutocompleteLoader);var selectedCss=function selectedCss(_ref44){var selected=_ref44.selected,theme=_ref44.theme;return selected&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",style("listbox.selectedBackground",{theme:theme}),";",fontWeight("medium",{theme:theme}),"");};var focusedCss=function focusedCss(_ref45){var focused=_ref45.focused,theme=_ref45.theme;return focused&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",style("listbox.focusedBackground",{theme:theme}),";");};var disabledCss=function disabledCss(_ref46){var disabled=_ref46.disabled,theme=_ref46.theme;return disabled&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("pointer-events:none;color:",style("listbox.disabledColor",{theme:theme}),";");};var _ref$f={name:"4g6ai3",styles:"cursor:pointer;"};var pointerCss=function pointerCss(_ref47){var pointer=_ref47.pointer;return pointer&&_ref$f;};var sizeCss=function sizeCss(_ref48){var size2=_ref48.size,theme=_ref48.theme;switch(size2){case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(typography$1("body3",{theme:theme}),";",padding("xs",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xxs",{theme:theme}),";");}};var Item$4=/* @__PURE__ */createStyled("li",{target:"e158onab0"})("display:block;padding:",spacer(2)," ",spacer(3),";&:hover{background-color:",style("listbox.hoverBackground"),";}",selectedCss," ",focusedCss," ",disabledCss," ",pointerCss," ",sizeCss,"");var maxHeightCss=function maxHeightCss(_ref49){var maxHeight=_ref49.maxHeight;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("max-height:",maxHeight||"275px",";");};var minWidthCss=function minWidthCss(_ref50){var minWidth=_ref50.minWidth;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("min-width:",minWidth||"200px",";");};var _ref$e={name:"gyp8mm",styles:"visibility:hidden;"};var closedCss=function closedCss(_ref51){var closed=_ref51.closed;return closed&&_ref$e;};var ListBox=/* @__PURE__ */createStyled("ul",{target:"egoxznv0"})("list-style:none;background-color:",color("white"),";margin:",spacer(1)," 0 0 0;padding:",spacer(1)," 0;overflow-y:auto;",maxHeightCss," ",minWidthCss," ",closedCss," ",shadow$1("distant"),";",borderRadius$1("default"),";");ListBox.Item=Item$4;var Item$3=/* @__PURE__ */createStyled(ListBox.Item,{target:"enfxk1o0"})({name:"1lekzkb",styles:"display:flex;align-items:center;justify-content:space-between;"});var iconSize=function iconSize(size2){switch(size2){case"lg":return"25px";default:return"16px";}};var Option=__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function(_Y,ref){var _Z=_Y,children=_Z.children,selected=_Z.selected,size2=_Z.size,props=__objRest(_Z,["children","selected","size"]);var theme=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["b" /* useTheme */])();return/* @__PURE__ */jsxs(Item$3,__spreadProps(__spreadValues({ref:ref,selected:selected,size:size2,pointer:true},props),{children:[children,selected&&/* @__PURE__ */jsx(Check,{style:{flexShrink:0},size:iconSize(size2),color:style("dropdown.checkIconColor",{theme:theme})})]}));});Option.displayName="Dropdown.Option";var Autocomplete=function Autocomplete(_ref53){var DataSource=_ref53.dataSource,disabled=_ref53.disabled,idValue=_ref53.idValue,kind2=_ref53.kind,name=_ref53.name,onChange=_ref53.onChange,formatItem=_ref53.formatItem,placeholder=_ref53.placeholder,size2=_ref53.size,valid2=_ref53.valid,value=_ref53.value,width=_ref53.width;return/* @__PURE__ */jsx(Downshift,{itemToString:function itemToString(item){return item?formatItem(item):"";},onChange:onChange,selectedItem:value,inputId:name,children:function children(_ref54){var getRootProps=_ref54.getRootProps,getInputProps=_ref54.getInputProps,getItemProps=_ref54.getItemProps,getMenuProps=_ref54.getMenuProps,highlightedIndex=_ref54.highlightedIndex,isOpen=_ref54.isOpen,inputValue=_ref54.inputValue,openMenu=_ref54.openMenu,selectedItem=_ref54.selectedItem;return/* @__PURE__ */jsx(Container$j,__spreadProps(__spreadValues({width:width},getRootProps()),{children:/* @__PURE__ */jsx(DataSource,{inputValue:inputValue,children:function children(_ref55){var loading=_ref55.loading,items=_ref55.items;return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsxs(InputContainer,{children:[/* @__PURE__ */jsx(Input$2,__spreadValues({type:"text",placeholder:placeholder,size:size2,kind:kind2,valid:valid2},getInputProps({disabled:disabled,autoComplete:"off",onFocus:openMenu}))),loading&&/* @__PURE__ */jsx(Loader,{dark:isOpen,size:size2}),/* @__PURE__ */jsx(Caret$1,{size:"8px",fill:"cadet"})]}),isOpen&&/* @__PURE__ */jsx(ListBox,__spreadProps(__spreadValues({"data-testid":"autocomplete-menu"},getMenuProps()),{children:loading?/* @__PURE__ */jsx(Option,{disabled:true,size:size2,children:"Loading..."}):!inputValue&&items.length===0?/* @__PURE__ */jsx(Option,{disabled:true,size:size2,children:"Type to search"}):inputValue&&items.length===0?/* @__PURE__ */jsx(Option,{disabled:true,size:size2,children:"No items"}):items.map(function(item,idx){return/* @__PURE__ */jsx(Option,__spreadProps(__spreadValues({size:size2,selected:selectedItem===item,focused:highlightedIndex===idx},getItemProps({key:idValue(item),item:item})),{children:formatItem(item)}),idx);})}))]});}})}));}});};Autocomplete.defaultProps={idValue:function idValue(item){return item.id;},placeholder:"Select...",valid:true};var size$9="29px";var avatarUrlCss=function avatarUrlCss(_ref56){var avatarUrl=_ref56.avatarUrl;return avatarUrl?/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background:url(",avatarUrl,");background-repeat:no-repeat;background-size:cover;"):null;};var Container$i=createStyled("div",{target:"eq6oc840"})("display:flex;justify-content:center;align-items:center;border-radius:50%;width:",size$9,";height:",size$9,";",typography$1("body2Medium"),";",function(_ref57){var light=_ref57.light,theme=_ref57.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",light?color("paleGrey",{theme:theme}):color("slate",{theme:theme}),";color:",light?transparentize("cadet",0.5,{theme:theme}):color("cadet",{theme:theme}),";border:1px solid ",light?color("paleGrey",{theme:theme}):color("slate",{theme:theme}),";");},";",avatarUrlCss,";");Container$i.displayName="Avatar.Container";var propTypes$2={exports:{}};function makeEmptyFunction$1(arg){return function(){return arg;};}var emptyFunction$4=function emptyFunction(){};emptyFunction$4.thatReturns=makeEmptyFunction$1;emptyFunction$4.thatReturnsFalse=makeEmptyFunction$1(false);emptyFunction$4.thatReturnsTrue=makeEmptyFunction$1(true);emptyFunction$4.thatReturnsNull=makeEmptyFunction$1(null);emptyFunction$4.thatReturnsThis=function(){return this;};emptyFunction$4.thatReturnsArgument=function(arg){return arg;};var emptyFunction_1$1=emptyFunction$4;function invariant$4(condition,format,a,b2,c2,d2,e2,f2){if(!condition){var error;if(format===void 0){error=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");}else{var args=[a,b2,c2,d2,e2,f2];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++];}));error.name="Invariant Violation";}error.framesToPop=1;throw error;}}var invariant_1$1=invariant$4;var ReactPropTypesSecret$4="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";var ReactPropTypesSecret_1$2=ReactPropTypesSecret$4;var emptyFunction$3=emptyFunction_1$1;var invariant$2=invariant_1$1;var ReactPropTypesSecret$3=ReactPropTypesSecret_1$2;var factoryWithThrowingShims$2=function factoryWithThrowingShims$2(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret$3){return;}invariant$2(false,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}shim.isRequired=shim;function getShim(){return shim;}var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim};ReactPropTypes.checkPropTypes=emptyFunction$3;ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};{propTypes$2.exports=factoryWithThrowingShims$2();}var PropTypes$2=propTypes$2.exports;var nameOrEmailInitials=function nameOrEmailInitials(_ref58){var firstName=_ref58.firstName,lastName=_ref58.lastName,email=_ref58.email;if(firstName||lastName){return[firstName,lastName].filter(function(val){return Boolean(val);}).map(function(val){return val[0];}).join("").toUpperCase();}if(email){return email[0].toUpperCase();}return"?";};var Avatar$1=function Avatar$1(_ref59){var firstName=_ref59.firstName,lastName=_ref59.lastName,email=_ref59.email,light=_ref59.light,avatarUrl=_ref59.avatarUrl;return/* @__PURE__ */jsx(Container$i,{light:light,avatarUrl:avatarUrl,children:avatarUrl?null:nameOrEmailInitials({firstName:firstName,lastName:lastName,email:email})});};Avatar$1.propTypes={firstName:PropTypes$2.string,lastName:PropTypes$2.string,light:PropTypes$2.bool,email:PropTypes$2.string,avatarUrl:PropTypes$2.string};Avatar$1.defaultProps={firstName:"",lastName:"",email:"",light:false,avatarUrl:""};var variant=function variant(colorName,theme){return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color(colorName,{theme:theme}),";background-color:",transparentize(colorName,0.1,{theme:theme}),";");};var solidVariant=function solidVariant(colorName,theme){return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color("white",{theme:theme}),";background-color:",color(colorName,{theme:theme}),";");};var kind$4=function kind$4(_ref60){var kind2=_ref60.kind,theme=_ref60.theme;switch(kind2){case"draft":return variant("darkPurple",theme);case"live":return variant("forest",theme);case"closed":return variant("ocean",theme);case"archived":return variant("pewter",theme);case"pro":return solidVariant("darkOcean",theme);}};var colorStyles=function colorStyles(_ref61){var kind2=_ref61.kind,color2=_ref61.color,solid=_ref61.solid,theme=_ref61.theme;return kind2?"":solid?solidVariant(color2,theme):variant(color2,theme);};var Badge$1=createStyled("span",{target:"eafkk460"})("display:inline-block;border-radius:10rem;vertical-align:middle;",padding("xxxs"),";",typography$1("subheading1"),";",colorStyles,";",kind$4,";");Badge$1.defaultProps={color:"slate"};var kind$3=function kind$3(_ref62){var dark2=_ref62.dark,kind2=_ref62.kind,theme=_ref62.theme;var styles2;if(dark2){styles2=style("button.".concat(kind2,"Dark"),{theme:theme});}if(!styles2){styles2=style("button.".concat(kind2),{theme:theme});}if(!styles2)return;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",styles2.color,";background:",styles2.background,";border-color:",styles2.border,";&:hover,&:focus-visible,&.focus-visible{color:",styles2.hoverColor,";background:",styles2.hoverBackground,";border-color:",styles2.hoverBorder,";}&:active{color:",styles2.activeColor,";background:",styles2.activeBackground,";border-color:",styles2.activeBorder,";}&:disabled{color:",styles2.disabledColor,";background:",styles2.disabledBackground,";border-color:",styles2.disabledBorder,";}");};var size$8=function size$8(_ref63){var size2=_ref63.size,theme=_ref63.theme;switch(size2){case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xs",{theme:theme}),";",fontSize("s",{theme:theme}),";");case"sm":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xxxs",{theme:theme}),";",fontSize("xxs",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xxs",{theme:theme}),";",fontSize("xs",{theme:theme}),";");}};var _ref$d={name:"8atqhb",styles:"width:100%;"};var block=function block(_ref64){var block2=_ref64.block;return block2&&_ref$d;};var margin=function margin(_ref65){var marginLeft=_ref65.marginLeft,marginRight=_ref65.marginRight,marginTop=_ref65.marginTop,marginBottom=_ref65.marginBottom,withMargins=_ref65.withMargins,theme=_ref65.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])((marginLeft||withMargins)&&"margin-left: ".concat(spacer(2,{theme:theme})),";",(marginRight||withMargins)&&"margin-right: ".concat(spacer(2,{theme:theme})),";",(marginTop||withMargins)&&"margin-top: ".concat(spacer(2,{theme:theme})),";",(marginBottom||withMargins)&&"margin-bottom: ".concat(spacer(2,{theme:theme})),";");};var Button$1=createStyled("button",{target:"e6bdun80"})("display:inline-block;text-align:center;white-space:nowrap;vertical-align:middle;user-select:none;color:currentColor;font-family:inherit;border-width:1px;border-style:solid;flex-shrink:0;transition:color 0.1s ease-in-out,background-color 0.1s ease-in-out,border-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out 0s;",fontWeight("bold"),";",borderRadius$1("default"),";&:enabled{cursor:pointer;}&:hover,&:focus{text-decoration:none;outline:0;}&:hover,&:focus{cursor:pointer;}&:disabled{cursor:not-allowed;}",kind$3,";",size$8,";",block,";",margin,";");var ButtonLink=Button$1.withComponent(function(__){var _$=__,_block=_$.block,_dark=_$.dark,_withMargins=_$.withMargins,_marginLeft=_$.marginLeft,_marginRight=_$.marginRight,_marginTop=_$.marginTop,_marginBottom=_$.marginBottom,rest=__objRest(_$,["block","dark","withMargins","marginLeft","marginRight","marginTop","marginBottom"]);return/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],__spreadValues({},rest));},{target:"e1h0fkrt0"});var CheckboxHidden=withProps$1({type:"checkbox"})(createStyled("input",{target:"e1gbmuf90"})({name:"sz9j72",styles:"opacity:0;position:absolute;z-index:-1;"}));var checkboxBackgroundStyle=function checkboxBackgroundStyle(_ref66){var checked=_ref66.checked,disabled=_ref66.disabled;if(disabled){return checked?"checkedDisabledBackground":"disabledBackground";}return checked&&"checkedBackground";};var checkboxBorderStyle=function checkboxBorderStyle(_ref67){var checked=_ref67.checked,disabled=_ref67.disabled,valid2=_ref67.valid;if(disabled){return"disabledBorder";}else if(!valid2){return"invalidBorder";}return!checked&&"border";};var findStyle$1=function findStyle$1(props){var fn2=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(key2){return key2;};var stylePath=fn2(props);if(stylePath){return style("checkbox.".concat(stylePath))({theme:props.theme});}return"transparent";};var CheckboxDisplay=createStyled("div",{target:"eowapib0"})("background-color:",function(props){return findStyle$1(props,checkboxBackgroundStyle);},";border:solid 0.0675rem ",function(props){return findStyle$1(props,checkboxBorderStyle);},";border-radius:0.125rem;height:",spacer(4),";width:",spacer(4),";display:inline-block;margin-right:",spacer(3),";margin-left:-1px;vertical-align:middle;");var Label$3=createStyled("label",{target:"e10oht130"})("display:flex;align-items:center;margin-bottom:0;cursor:",function(_ref68){var disabled=_ref68.disabled;return disabled?"not-allowed":"pointer";},";");var LabelText$1=createStyled("span",{target:"e10oht131"})("margin-bottom:0;color:",color("slate"),";vertical-align:middle;");var CheckboxContainer=createStyled("div",{target:"e10oht132"})({name:"79elbk",styles:"position:relative;"});var Checkbox=function Checkbox(_aa){var _ba=_aa,checked=_ba.checked,label=_ba.label,disabled=_ba.disabled,valid2=_ba.valid,id=_ba.id,theme=_ba.theme,rest=__objRest(_ba,["checked","label","disabled","valid","id","theme"]);return/* @__PURE__ */jsxs(CheckboxContainer,{children:[/* @__PURE__ */jsx(CheckboxHidden,__spreadValues({checked:checked,disabled:disabled,id:id},rest)),/* @__PURE__ */jsxs(Label$3,{disabled:disabled,htmlFor:id,children:[/* @__PURE__ */jsx(CheckboxDisplay,{checked:checked,disabled:disabled,valid:valid2,children:/* @__PURE__ */jsx("svg",{viewBox:"-4 -6 20 20",children:/* @__PURE__ */jsx("g",{fill:"none",children:checked&&/* @__PURE__ */jsx("path",{stroke:color("white")({theme:theme}),strokeWidth:"2",d:"M1.5 3.75l3 3 6-6"})})})}),/* @__PURE__ */jsx(LabelText$1,{children:label})]})]});};Checkbox.propTypes={checked:PropTypes$2.bool,disabled:PropTypes$2.bool,label:PropTypes$2.node,valid:PropTypes$2.bool,id:PropTypes$2.string.isRequired,onChange:PropTypes$2.func};Checkbox.defaultProps={onChange:function onChange(){},checked:false,disabled:false,valid:true};var Checkbox$1=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(Checkbox);var sizeWithDefault=compose(defaultTo("1.75rem"),prop("size"));var CloseButton=/* @__PURE__ */createStyled(withProps$1({kind:"ghost",size:"sm",children:/* @__PURE__ */jsx(Cancel$2,{size:"80%"})})(Button$1),{target:"e1gk30m00"})("padding:0;display:flex;align-items:center;justify-content:center;border-radius:50%;width:",sizeWithDefault,";height:",sizeWithDefault,";svg{fill:",transparentize("slate",0.5),";transition:fill 0.1s ease-out;}&:hover{svg{opacity:1;fill:",color("slate"),";}}");var Code=createStyled("code",{target:"e148cfz20"})("background:",color("paleGrey"),";padding:0.1rem ",spacer(1),";");var Container$h=createStyled("div",{target:"e15uhf6q0"})("padding-left:",spacer(4),";padding-right:",spacer(4),";",responsiveContainer,";");var PolicyContainer=createStyled("div",{target:"eqsta2c0"})("position:fixed;bottom:0;left:0;width:100%;background:",style("cookieBanner.background"),";z-index:9999;");var PolicyText=createStyled("div",{target:"eqsta2c1"})("flex:1;color:",color("white"),";padding-right:",spacer(3),";",fontSize("xs"),";",mediaDn("sm"),"{padding-right:0;margin-bottom:",spacer(3),";}");var Content$3=/* @__PURE__ */createStyled(Container$h,{target:"eqsta2c2"})("display:flex;justify-content:center;margin:0 auto;",padding("md"),";",mediaUp("sm"),"{align-items:center;}",mediaDn("sm"),"{flex-direction:column;}");var shake=Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["e" /* keyframes */])(_templateObject||(_templateObject=_taggedTemplateLiteral(["\n  0%, 24% {\n    transform: rotate(0deg) scale(1);\n  }\n  3% {\n    transform: rotate(8deg) scale(1.12);\n  }\n  9% {\n    transform: rotate(-8deg) scale(1.16);\n  }\n  15% {\n    transform: rotate(8deg) scale(1.16);\n  }\n  21% {\n    transform: rotate(-8deg) scale(1.12);\n  }\n"])));var shakeAnimation=/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("animation:",shake," 5s ease-in-out;transform-origin:center;animation-iteration-count:infinite;");var AcceptButton=/* @__PURE__ */createStyled(Button$1,{target:"eqsta2c3"})(function(_ref69){var highlighted=_ref69.highlighted;return highlighted&&shakeAnimation;},";");var CookieBanner=function CookieBanner(_ref70){var children=_ref70.children,onAccept=_ref70.onAccept,highlighted=_ref70.highlighted;return/* @__PURE__ */jsx(PolicyContainer,{children:/* @__PURE__ */jsxs(Content$3,{children:[/* @__PURE__ */jsx(PolicyText,{children:children}),/* @__PURE__ */jsx(AcceptButton,{kind:"primary",onClick:onAccept,highlighted:highlighted,dark:true,children:"Accept"})]})});};var _ref$c={name:"r2ff5g",styles:"visibility:visible;opacity:1;"};var _ref2$9={name:"ge94et",styles:"visibility:hidden;opacity:0;"};var Backdrop$2=createStyled("div",{target:"e185c9qu0"})("position:fixed;left:0;right:0;bottom:0;background:",transparentize("pewter",0.6),";transition:all 0.3s;z-index:1049;",function(_ref71){var _ref71$top=_ref71.top,top2=_ref71$top===void 0?"0":_ref71$top;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("top:",top2,";");}," ",function(_ref72){var open=_ref72.open;return open?_ref$c:_ref2$9;},"");Backdrop$2.displayName="Drawer.Backdrop";var MenuItem=createStyled("li",{target:"e1phcyas0"})("display:block;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;",padding("xxs"),";",typography$1("body2"),";&:hover{background-color:",transparentize("green",0.15),";}");var Menu$1=createStyled("ul",{target:"ea6pm9d0"})("list-style:none;margin:0;padding:",spacer(1)," 0;color:",color("black"),";background-color:",color("white"),";overflow:hidden;width:100%;");var Section$1=createStyled("div",{target:"ecegfim0"})("&:not(:last-of-type){margin-bottom:",spacer(1),";padding-bottom:",spacer(1),";border-bottom:1px solid ",color("paleGrey"),";}");Section$1.displayName="Drawer.Section";var _ref$b={name:"19zs6va",styles:"right:0;"};var _ref2$8={name:"260zpl",styles:"left:0;"};var _ref3$1={name:"ws9i0x",styles:"transform:translate(0);"};var _ref4$1={name:"1wognfu",styles:"transform:translate(100%);"};var _ref5={name:"ehbdog",styles:"transform:translate(-100%);"};var StyledDrawer=createStyled("div",{target:"e2b7js20"})("transition:all 0.3s ease-in-out;position:fixed;box-shadow:0 3px 8px 0 rgba(22,38,59,0.2);z-index:1015;overflow:hidden;background:white;",function(_ref73){var _ref73$width=_ref73.width,width=_ref73$width===void 0?"200px":_ref73$width;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("width:",width,";");}," ",function(_ref74){var _ref74$height=_ref74.height,height=_ref74$height===void 0?"100vh":_ref74$height;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("height:",height,";");}," ",function(_ref75){var _ref75$top=_ref75.top,top2=_ref75$top===void 0?"0":_ref75$top;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("top:",top2,";");}," ",function(_ref76){var side=_ref76.side;return side==="right"?_ref$b:_ref2$8;}," ",function(_ref77){var open=_ref77.open,side=_ref77.side;return open?_ref3$1:side==="right"?_ref4$1:_ref5;},"");var Drawer=function Drawer(_ca){var _da=_ca,openProp=_da.open,props=__objRest(_da,["open"]);var drawerRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(openProp),_useState2=_slicedToArray(_useState,2),open=_useState2[0],setOpen=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setOpen(openProp);},[openProp]);return/* @__PURE__ */jsx(StyledDrawer,__spreadValues({ref:drawerRef,open:open},props));};Drawer.Backdrop=Backdrop$2;Drawer.MenuItem=MenuItem;Drawer.Menu=Menu$1;Drawer.Section=Section$1;var SecondaryLink=/* @__PURE__ */createStyled(function(_ea){var _fa=_ea,_dark=_fa.dark,external=_fa.external,_disabled=_fa.disabled,rest=__objRest(_fa,["dark","external","disabled"]);return external?/* @__PURE__ */jsx("a",__spreadValues({},rest)):/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],__spreadValues({},rest));},{target:"en9l87d0"})("text-decoration:underline;",typography$1("body2Medium"),";",function(_ref78){var dark2=_ref78.dark,disabled=_ref78.disabled,theme=_ref78.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color(disabled?"silver":dark2?"silver":"pewter",{theme:theme}),";cursor:",disabled?"not-allowed":"pointer",";&:hover{color:",color(disabled?"silver":dark2?"white":"black",{theme:theme}),";}");},";");var DefaultCookiePolicy=function DefaultCookiePolicy(){return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:["This application uses cookies to store information on your computer. Some are essential for the session performance, others help us to improve your user experience. Click"," ",/* @__PURE__ */jsx(SecondaryLink,{external:true,dark:true,href:"https://www.focusvision.com/privacy-statement/",target:"_blank",rel:"noopener noreferrer",children:"Privacy Policy"})," ","to learn more."]});};var _ref$a={name:"v2kfba",styles:"height:100%;width:100%;"};var size$7=function size$7(_ref79){var size2=_ref79.size,theme=_ref79.theme;switch(size2){case"fullscreen":return _ref$a;case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("margin-top:",spacer(5,{theme:theme}),";margin-bottom:",spacer(5,{theme:theme}),";width:720px;",borderRadius$1("default",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("margin-top:",spacer(5,{theme:theme}),";margin-bottom:",spacer(5,{theme:theme}),";width:480px;",borderRadius$1("default",{theme:theme}),";");}};var _ref2$7={name:"1uwx7m9",styles:"background:none;border-color:transparent;box-shadow:unset;"};var kind$2=function kind$2(_ref80){var kind2=_ref80.kind;return kind2==="ghost"&&_ref2$7;};var Content$2=createStyled("div",{target:"eprbwij0"})("background:",color("white"),";display:flex;flex-direction:column;max-width:100%;",shadow$1("raised"),";",size$7,";",kind$2,";");Content$2.displayName="Dialog.Content";var Container$g=createStyled("header",{target:"em5aw9y0"})("display:flex;justify-content:space-between;align-items:top;> h4:first-of-type{flex:1;margin-bottom:0;}",padding("md"),";");Container$g.displayName="Dialog.Header.Container";var Header$4=function Header$4(_ref81){var children=_ref81.children,onClose=_ref81.onClose;return/* @__PURE__ */jsxs(Container$g,{children:[children,onClose&&/* @__PURE__ */jsx(CloseButton,{onClick:onClose})]});};Header$4.propTypes={onClose:PropTypes$2.func};Header$4.displayName="Dialog.Header";var Title$4=function Title$4(props){return/* @__PURE__ */jsx("h4",__spreadValues({},props));};Title$4.displayName="Dialog.Title";var Body$3=createStyled("div",{target:"e1bp2hzv0"})("padding-left:",spacer(6),";padding-right:",spacer(6),";flex:1;");Body$3.displayName="Dialog.Body";var Footer$3=createStyled("footer",{target:"ec8s5pr0"})("display:flex;justify-content:flex-end;",padding("md"),";",Button$1," + ",Button$1,"{margin-left:",spacer(2),";}");Footer$3.displayName="Dialog.Footer";var CancelButton$1=function CancelButton$1(_ref82){var children=_ref82.children,onClose=_ref82.onClose;return/* @__PURE__ */jsx(Button$1,{kind:"ghost",type:"button",onClick:onClose,children:children});};CancelButton$1.defaultProps={children:"Cancel"};var Dialog$1=function Dialog$1(props){return/* @__PURE__ */jsx(Content$2,__spreadValues({onClick:function onClick(e2){return e2.stopPropagation();}},props));};Dialog$1.Body=Body$3;Dialog$1.Footer=Footer$3;Dialog$1.Header=Header$4;Dialog$1.Title=Title$4;Dialog$1.CancelButton=CancelButton$1;var Placeholder=createStyled("span",{target:"eg84shh0"})("color:",color("cadet"),";",fontWeight("regular"),";[aria-expanded='true'] &{color:",color("white"),";}");var TruncateText=createStyled("span",{target:"eu6c9as0"})({name:"1h2ruwl",styles:"white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"});var size$6=function size$6(_ref83){var size2=_ref83.size,theme=_ref83.theme;switch(size2){case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(typography$1("body3",{theme:theme}),";",padding("xs",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(typography$1("body2",{theme:theme}),";",padding("xxs",{theme:theme}),";");}};var kind$1=function kind$1(_ref84){var kind2=_ref84.kind,theme=_ref84.theme,valid2=_ref84.valid;switch(kind2){case"ghost":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border:none;color:",color("pewter",{theme:theme}),";",fontWeight("medium",{theme:theme}),";&:hover{background-color:",transparentize("slate",0.08,{theme:theme}),";}");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border:1px solid ",color(valid2?"silver":"red",{theme:theme}),";[aria-expanded='true'] &{border:1px solid ",color("slate",{theme:theme}),";}");}};var Button=createStyled("button",{target:"eykpz9h0"})("display:flex;justify-content:space-between;align-items:center;transition:all 0.3s ease 0s;outline-color:",color("slate"),";width:100%;font-family:inherit;user-select:none;background-color:",color("white"),";text-align:left;",borderRadius$1("default"),";",size$6,";",kind$1,";&::-moz-focus-inner{border:0;}[aria-expanded='true'] &{color:",color("white"),";background-color:",color("slate"),";outline:none;}&:active{border-color:",color("slate"),";}&:focus{outline-color:",color("slate"),";outline-offset:-2px;}&:not([disabled]){cursor:pointer;}&[disabled]{cursor:not-allowed;color:",color("cadet"),";background:",color("offWhite"),";border:1px solid ",color("paleGrey"),";}svg{&:first-of-type{margin-right:",spacer(2),";}&:last-of-type{margin-left:",spacer(2),";}}@supports (-moz-appearance:none){&:focus{outline-width:1px;outline-style:dotted;}}",TruncateText,",",Placeholder,"{flex:1;}");Button.displayName="Dropdown.Button";var ManagerReferenceNodeContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();var ManagerReferenceNodeSetterContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();function Manager(_ref6){var children=_ref6.children;var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),referenceNode=_React$useState[0],setReferenceNode=_React$useState[1];__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){return function(){setReferenceNode(null);};},[setReferenceNode]);return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ManagerReferenceNodeContext.Provider,{value:referenceNode},/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ManagerReferenceNodeSetterContext.Provider,{value:setReferenceNode},children));}var unwrapArray=function unwrapArray2(arg){return Array.isArray(arg)?arg[0]:arg;};var safeInvoke=function safeInvoke2(fn2){if(typeof fn2==="function"){for(var _len=arguments.length,args=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}return fn2.apply(void 0,args);}};var setRef=function setRef2(ref,node){if(typeof ref==="function"){return safeInvoke(ref,node);}else if(ref!=null){ref.current=node;}};var fromEntries=function fromEntries2(entries){return entries.reduce(function(acc,_ref6){var key2=_ref6[0],value=_ref6[1];acc[key2]=value;return acc;},{});};var useIsomorphicLayoutEffect=typeof window!=="undefined"&&window.document&&window.document.createElement?__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"]:__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];function getBoundingClientRect(element){var rect=element.getBoundingClientRect();return{width:rect.width,height:rect.height,top:rect.top,right:rect.right,bottom:rect.bottom,left:rect.left,x:rect.left,y:rect.top};}function getWindow(node){if(node.toString()!=="[object Window]"){var ownerDocument=node.ownerDocument;return ownerDocument?ownerDocument.defaultView:window;}return node;}function getWindowScroll(node){var win=getWindow(node);var scrollLeft=win.pageXOffset;var scrollTop=win.pageYOffset;return{scrollLeft:scrollLeft,scrollTop:scrollTop};}function isElement(node){var OwnElement=getWindow(node).Element;return node instanceof OwnElement||node instanceof Element;}function isHTMLElement(node){var OwnElement=getWindow(node).HTMLElement;return node instanceof OwnElement||node instanceof HTMLElement;}function getHTMLElementScroll(element){return{scrollLeft:element.scrollLeft,scrollTop:element.scrollTop};}function getNodeScroll(node){if(node===getWindow(node)||!isHTMLElement(node)){return getWindowScroll(node);}else{return getHTMLElementScroll(node);}}function getNodeName(element){return element?(element.nodeName||"").toLowerCase():null;}function getDocumentElement(element){return(isElement(element)?element.ownerDocument:element.document).documentElement;}function getWindowScrollBarX(element){return getBoundingClientRect(getDocumentElement(element)).left+getWindowScroll(element).scrollLeft;}function getComputedStyle$1(element){return getWindow(element).getComputedStyle(element);}function isScrollParent(element){var _getComputedStyle=getComputedStyle$1(element),overflow=_getComputedStyle.overflow,overflowX=_getComputedStyle.overflowX,overflowY=_getComputedStyle.overflowY;return /auto|scroll|overlay|hidden/.test(overflow+overflowY+overflowX);}function getCompositeRect(elementOrVirtualElement,offsetParent,isFixed){if(isFixed===void 0){isFixed=false;}var documentElement=getDocumentElement(offsetParent);var rect=getBoundingClientRect(elementOrVirtualElement);var isOffsetParentAnElement=isHTMLElement(offsetParent);var scroll={scrollLeft:0,scrollTop:0};var offsets={x:0,y:0};if(isOffsetParentAnElement||!isOffsetParentAnElement&&!isFixed){if(getNodeName(offsetParent)!=="body"||isScrollParent(documentElement)){scroll=getNodeScroll(offsetParent);}if(isHTMLElement(offsetParent)){offsets=getBoundingClientRect(offsetParent);offsets.x+=offsetParent.clientLeft;offsets.y+=offsetParent.clientTop;}else if(documentElement){offsets.x=getWindowScrollBarX(documentElement);}}return{x:rect.left+scroll.scrollLeft-offsets.x,y:rect.top+scroll.scrollTop-offsets.y,width:rect.width,height:rect.height};}function getLayoutRect(element){return{x:element.offsetLeft,y:element.offsetTop,width:element.offsetWidth,height:element.offsetHeight};}function getParentNode(element){if(getNodeName(element)==="html"){return element;}return element.assignedSlot||element.parentNode||element.host||getDocumentElement(element);}function getScrollParent(node){if(["html","body","#document"].indexOf(getNodeName(node))>=0){return node.ownerDocument.body;}if(isHTMLElement(node)&&isScrollParent(node)){return node;}return getScrollParent(getParentNode(node));}function listScrollParents(element,list){if(list===void 0){list=[];}var scrollParent=getScrollParent(element);var isBody=getNodeName(scrollParent)==="body";var win=getWindow(scrollParent);var target=isBody?[win].concat(win.visualViewport||[],isScrollParent(scrollParent)?scrollParent:[]):scrollParent;var updatedList=list.concat(target);return isBody?updatedList:updatedList.concat(listScrollParents(getParentNode(target)));}function isTableElement(element){return["table","td","th"].indexOf(getNodeName(element))>=0;}function getTrueOffsetParent(element){if(!isHTMLElement(element)||getComputedStyle$1(element).position==="fixed"){return null;}var offsetParent=element.offsetParent;if(offsetParent){var html=getDocumentElement(offsetParent);if(getNodeName(offsetParent)==="body"&&getComputedStyle$1(offsetParent).position==="static"&&getComputedStyle$1(html).position!=="static"){return html;}}return offsetParent;}function getContainingBlock(element){var currentNode=getParentNode(element);while(isHTMLElement(currentNode)&&["html","body"].indexOf(getNodeName(currentNode))<0){var css2=getComputedStyle$1(currentNode);if(css2.transform!=="none"||css2.perspective!=="none"||css2.willChange&&css2.willChange!=="auto"){return currentNode;}else{currentNode=currentNode.parentNode;}}return null;}function getOffsetParent(element){var window2=getWindow(element);var offsetParent=getTrueOffsetParent(element);while(offsetParent&&isTableElement(offsetParent)&&getComputedStyle$1(offsetParent).position==="static"){offsetParent=getTrueOffsetParent(offsetParent);}if(offsetParent&&getNodeName(offsetParent)==="body"&&getComputedStyle$1(offsetParent).position==="static"){return window2;}return offsetParent||getContainingBlock(element)||window2;}var top="top";var bottom="bottom";var right="right";var left="left";var auto="auto";var basePlacements=[top,bottom,right,left];var start="start";var end="end";var clippingParents="clippingParents";var viewport="viewport";var popper="popper";var reference="reference";var variationPlacements=/* @__PURE__ */basePlacements.reduce(function(acc,placement){return acc.concat([placement+"-"+start,placement+"-"+end]);},[]);var placements$1=/* @__PURE__ */[].concat(basePlacements,[auto]).reduce(function(acc,placement){return acc.concat([placement,placement+"-"+start,placement+"-"+end]);},[]);var beforeRead="beforeRead";var read="read";var afterRead="afterRead";var beforeMain="beforeMain";var main="main";var afterMain="afterMain";var beforeWrite="beforeWrite";var write="write";var afterWrite="afterWrite";var modifierPhases=[beforeRead,read,afterRead,beforeMain,main,afterMain,beforeWrite,write,afterWrite];function order(modifiers){var map=/* @__PURE__ */new Map();var visited=/* @__PURE__ */new Set();var result=[];modifiers.forEach(function(modifier){map.set(modifier.name,modifier);});function sort(modifier){visited.add(modifier.name);var requires=[].concat(modifier.requires||[],modifier.requiresIfExists||[]);requires.forEach(function(dep){if(!visited.has(dep)){var depModifier=map.get(dep);if(depModifier){sort(depModifier);}}});result.push(modifier);}modifiers.forEach(function(modifier){if(!visited.has(modifier.name)){sort(modifier);}});return result;}function orderModifiers(modifiers){var orderedModifiers=order(modifiers);return modifierPhases.reduce(function(acc,phase){return acc.concat(orderedModifiers.filter(function(modifier){return modifier.phase===phase;}));},[]);}function debounce(fn2){var pending;return function(){if(!pending){pending=new Promise(function(resolve){Promise.resolve().then(function(){pending=void 0;resolve(fn2());});});}return pending;};}function getBasePlacement(placement){return placement.split("-")[0];}function mergeByName(modifiers){var merged=modifiers.reduce(function(merged2,current){var existing=merged2[current.name];merged2[current.name]=existing?Object.assign(Object.assign(Object.assign({},existing),current),{},{options:Object.assign(Object.assign({},existing.options),current.options),data:Object.assign(Object.assign({},existing.data),current.data)}):current;return merged2;},{});return Object.keys(merged).map(function(key2){return merged[key2];});}function getViewportRect(element){var win=getWindow(element);var html=getDocumentElement(element);var visualViewport=win.visualViewport;var width=html.clientWidth;var height=html.clientHeight;var x=0;var y2=0;if(visualViewport){width=visualViewport.width;height=visualViewport.height;if(!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){x=visualViewport.offsetLeft;y2=visualViewport.offsetTop;}}return{width:width,height:height,x:x+getWindowScrollBarX(element),y:y2};}function getDocumentRect(element){var html=getDocumentElement(element);var winScroll=getWindowScroll(element);var body=element.ownerDocument.body;var width=Math.max(html.scrollWidth,html.clientWidth,body?body.scrollWidth:0,body?body.clientWidth:0);var height=Math.max(html.scrollHeight,html.clientHeight,body?body.scrollHeight:0,body?body.clientHeight:0);var x=-winScroll.scrollLeft+getWindowScrollBarX(element);var y2=-winScroll.scrollTop;if(getComputedStyle$1(body||html).direction==="rtl"){x+=Math.max(html.clientWidth,body?body.clientWidth:0)-width;}return{width:width,height:height,x:x,y:y2};}function contains(parent,child){var isShadow=Boolean(child.getRootNode&&child.getRootNode().host);if(parent.contains(child)){return true;}else if(isShadow){var next=child;do{if(next&&parent.isSameNode(next)){return true;}next=next.parentNode||next.host;}while(next);}return false;}function rectToClientRect(rect){return Object.assign(Object.assign({},rect),{},{left:rect.x,top:rect.y,right:rect.x+rect.width,bottom:rect.y+rect.height});}function getInnerBoundingClientRect(element){var rect=getBoundingClientRect(element);rect.top=rect.top+element.clientTop;rect.left=rect.left+element.clientLeft;rect.bottom=rect.top+element.clientHeight;rect.right=rect.left+element.clientWidth;rect.width=element.clientWidth;rect.height=element.clientHeight;rect.x=rect.left;rect.y=rect.top;return rect;}function getClientRectFromMixedType(element,clippingParent){return clippingParent===viewport?rectToClientRect(getViewportRect(element)):isHTMLElement(clippingParent)?getInnerBoundingClientRect(clippingParent):rectToClientRect(getDocumentRect(getDocumentElement(element)));}function getClippingParents(element){var clippingParents2=listScrollParents(getParentNode(element));var canEscapeClipping=["absolute","fixed"].indexOf(getComputedStyle$1(element).position)>=0;var clipperElement=canEscapeClipping&&isHTMLElement(element)?getOffsetParent(element):element;if(!isElement(clipperElement)){return[];}return clippingParents2.filter(function(clippingParent){return isElement(clippingParent)&&contains(clippingParent,clipperElement)&&getNodeName(clippingParent)!=="body";});}function getClippingRect(element,boundary,rootBoundary){var mainClippingParents=boundary==="clippingParents"?getClippingParents(element):[].concat(boundary);var clippingParents2=[].concat(mainClippingParents,[rootBoundary]);var firstClippingParent=clippingParents2[0];var clippingRect=clippingParents2.reduce(function(accRect,clippingParent){var rect=getClientRectFromMixedType(element,clippingParent);accRect.top=Math.max(rect.top,accRect.top);accRect.right=Math.min(rect.right,accRect.right);accRect.bottom=Math.min(rect.bottom,accRect.bottom);accRect.left=Math.max(rect.left,accRect.left);return accRect;},getClientRectFromMixedType(element,firstClippingParent));clippingRect.width=clippingRect.right-clippingRect.left;clippingRect.height=clippingRect.bottom-clippingRect.top;clippingRect.x=clippingRect.left;clippingRect.y=clippingRect.top;return clippingRect;}function getVariation(placement){return placement.split("-")[1];}function getMainAxisFromPlacement(placement){return["top","bottom"].indexOf(placement)>=0?"x":"y";}function computeOffsets(_ref6){var reference2=_ref6.reference,element=_ref6.element,placement=_ref6.placement;var basePlacement=placement?getBasePlacement(placement):null;var variation=placement?getVariation(placement):null;var commonX=reference2.x+reference2.width/2-element.width/2;var commonY=reference2.y+reference2.height/2-element.height/2;var offsets;switch(basePlacement){case top:offsets={x:commonX,y:reference2.y-element.height};break;case bottom:offsets={x:commonX,y:reference2.y+reference2.height};break;case right:offsets={x:reference2.x+reference2.width,y:commonY};break;case left:offsets={x:reference2.x-element.width,y:commonY};break;default:offsets={x:reference2.x,y:reference2.y};}var mainAxis=basePlacement?getMainAxisFromPlacement(basePlacement):null;if(mainAxis!=null){var len=mainAxis==="y"?"height":"width";switch(variation){case start:offsets[mainAxis]=Math.floor(offsets[mainAxis])-Math.floor(reference2[len]/2-element[len]/2);break;case end:offsets[mainAxis]=Math.floor(offsets[mainAxis])+Math.ceil(reference2[len]/2-element[len]/2);break;}}return offsets;}function getFreshSideObject(){return{top:0,right:0,bottom:0,left:0};}function mergePaddingObject(paddingObject){return Object.assign(Object.assign({},getFreshSideObject()),paddingObject);}function expandToHashMap(value,keys){return keys.reduce(function(hashMap,key2){hashMap[key2]=value;return hashMap;},{});}function detectOverflow(state,options){if(options===void 0){options={};}var _options=options,_options$placement=_options.placement,placement=_options$placement===void 0?state.placement:_options$placement,_options$boundary=_options.boundary,boundary=_options$boundary===void 0?clippingParents:_options$boundary,_options$rootBoundary=_options.rootBoundary,rootBoundary=_options$rootBoundary===void 0?viewport:_options$rootBoundary,_options$elementConte=_options.elementContext,elementContext=_options$elementConte===void 0?popper:_options$elementConte,_options$altBoundary=_options.altBoundary,altBoundary=_options$altBoundary===void 0?false:_options$altBoundary,_options$padding=_options.padding,padding2=_options$padding===void 0?0:_options$padding;var paddingObject=mergePaddingObject(typeof padding2!=="number"?padding2:expandToHashMap(padding2,basePlacements));var altContext=elementContext===popper?reference:popper;var referenceElement=state.elements.reference;var popperRect=state.rects.popper;var element=state.elements[altBoundary?altContext:elementContext];var clippingClientRect=getClippingRect(isElement(element)?element:element.contextElement||getDocumentElement(state.elements.popper),boundary,rootBoundary);var referenceClientRect=getBoundingClientRect(referenceElement);var popperOffsets2=computeOffsets({reference:referenceClientRect,element:popperRect,strategy:"absolute",placement:placement});var popperClientRect=rectToClientRect(Object.assign(Object.assign({},popperRect),popperOffsets2));var elementClientRect=elementContext===popper?popperClientRect:referenceClientRect;var overflowOffsets={top:clippingClientRect.top-elementClientRect.top+paddingObject.top,bottom:elementClientRect.bottom-clippingClientRect.bottom+paddingObject.bottom,left:clippingClientRect.left-elementClientRect.left+paddingObject.left,right:elementClientRect.right-clippingClientRect.right+paddingObject.right};var offsetData=state.modifiersData.offset;if(elementContext===popper&&offsetData){var offset2=offsetData[placement];Object.keys(overflowOffsets).forEach(function(key2){var multiply=[right,bottom].indexOf(key2)>=0?1:-1;var axis=[top,bottom].indexOf(key2)>=0?"y":"x";overflowOffsets[key2]+=offset2[axis]*multiply;});}return overflowOffsets;}var DEFAULT_OPTIONS={placement:"bottom",modifiers:[],strategy:"absolute"};function areValidElements(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return!args.some(function(element){return!(element&&typeof element.getBoundingClientRect==="function");});}function popperGenerator(generatorOptions){if(generatorOptions===void 0){generatorOptions={};}var _generatorOptions=generatorOptions,_generatorOptions$def=_generatorOptions.defaultModifiers,defaultModifiers2=_generatorOptions$def===void 0?[]:_generatorOptions$def,_generatorOptions$def2=_generatorOptions.defaultOptions,defaultOptions=_generatorOptions$def2===void 0?DEFAULT_OPTIONS:_generatorOptions$def2;return function createPopper2(reference2,popper2,options){if(options===void 0){options=defaultOptions;}var state={placement:"bottom",orderedModifiers:[],options:Object.assign(Object.assign({},DEFAULT_OPTIONS),defaultOptions),modifiersData:{},elements:{reference:reference2,popper:popper2},attributes:{},styles:{}};var effectCleanupFns=[];var isDestroyed=false;var instance={state:state,setOptions:function setOptions(options2){cleanupModifierEffects();state.options=Object.assign(Object.assign(Object.assign({},defaultOptions),state.options),options2);state.scrollParents={reference:isElement(reference2)?listScrollParents(reference2):reference2.contextElement?listScrollParents(reference2.contextElement):[],popper:listScrollParents(popper2)};var orderedModifiers=orderModifiers(mergeByName([].concat(defaultModifiers2,state.options.modifiers)));state.orderedModifiers=orderedModifiers.filter(function(m2){return m2.enabled;});runModifierEffects();return instance.update();},forceUpdate:function forceUpdate(){if(isDestroyed){return;}var _state$elements=state.elements,reference3=_state$elements.reference,popper3=_state$elements.popper;if(!areValidElements(reference3,popper3)){return;}state.rects={reference:getCompositeRect(reference3,getOffsetParent(popper3),state.options.strategy==="fixed"),popper:getLayoutRect(popper3)};state.reset=false;state.placement=state.options.placement;state.orderedModifiers.forEach(function(modifier){return state.modifiersData[modifier.name]=Object.assign({},modifier.data);});for(var index2=0;index2<state.orderedModifiers.length;index2++){if(state.reset===true){state.reset=false;index2=-1;continue;}var _state$orderedModifie=state.orderedModifiers[index2],fn2=_state$orderedModifie.fn,_state$orderedModifie2=_state$orderedModifie.options,_options=_state$orderedModifie2===void 0?{}:_state$orderedModifie2,name=_state$orderedModifie.name;if(typeof fn2==="function"){state=fn2({state:state,options:_options,name:name,instance:instance})||state;}}},update:debounce(function(){return new Promise(function(resolve){instance.forceUpdate();resolve(state);});}),destroy:function destroy(){cleanupModifierEffects();isDestroyed=true;}};if(!areValidElements(reference2,popper2)){return instance;}instance.setOptions(options).then(function(state2){if(!isDestroyed&&options.onFirstUpdate){options.onFirstUpdate(state2);}});function runModifierEffects(){state.orderedModifiers.forEach(function(_ref32){var name=_ref32.name,_ref3$options=_ref32.options,options2=_ref3$options===void 0?{}:_ref3$options,effect2=_ref32.effect;if(typeof effect2==="function"){var cleanupFn=effect2({state:state,name:name,instance:instance,options:options2});var noopFn=function noopFn2(){};effectCleanupFns.push(cleanupFn||noopFn);}});}function cleanupModifierEffects(){effectCleanupFns.forEach(function(fn2){return fn2();});effectCleanupFns=[];}return instance;};}var passive={passive:true};function effect$2(_ref6){var state=_ref6.state,instance=_ref6.instance,options=_ref6.options;var _options$scroll=options.scroll,scroll=_options$scroll===void 0?true:_options$scroll,_options$resize=options.resize,resize=_options$resize===void 0?true:_options$resize;var window2=getWindow(state.elements.popper);var scrollParents=[].concat(state.scrollParents.reference,state.scrollParents.popper);if(scroll){scrollParents.forEach(function(scrollParent){scrollParent.addEventListener("scroll",instance.update,passive);});}if(resize){window2.addEventListener("resize",instance.update,passive);}return function(){if(scroll){scrollParents.forEach(function(scrollParent){scrollParent.removeEventListener("scroll",instance.update,passive);});}if(resize){window2.removeEventListener("resize",instance.update,passive);}};}var eventListeners={name:"eventListeners",enabled:true,phase:"write",fn:function fn(){},effect:effect$2,data:{}};function popperOffsets(_ref6){var state=_ref6.state,name=_ref6.name;state.modifiersData[name]=computeOffsets({reference:state.rects.reference,element:state.rects.popper,strategy:"absolute",placement:state.placement});}var popperOffsets$1={name:"popperOffsets",enabled:true,phase:"read",fn:popperOffsets,data:{}};var unsetSides={top:"auto",right:"auto",bottom:"auto",left:"auto"};function roundOffsets(_ref6){var x=_ref6.x,y2=_ref6.y;var win=window;var dpr=win.devicePixelRatio||1;return{x:Math.round(x*dpr)/dpr||0,y:Math.round(y2*dpr)/dpr||0};}function mapToStyles(_ref22){var _Object$assign2;var popper2=_ref22.popper,popperRect=_ref22.popperRect,placement=_ref22.placement,offsets=_ref22.offsets,position2=_ref22.position,gpuAcceleration=_ref22.gpuAcceleration,adaptive=_ref22.adaptive;var _roundOffsets=roundOffsets(offsets),x=_roundOffsets.x,y2=_roundOffsets.y;var hasX=offsets.hasOwnProperty("x");var hasY=offsets.hasOwnProperty("y");var sideX=left;var sideY=top;var win=window;if(adaptive){var offsetParent=getOffsetParent(popper2);if(offsetParent===getWindow(popper2)){offsetParent=getDocumentElement(popper2);}if(placement===top){sideY=bottom;y2-=offsetParent.clientHeight-popperRect.height;y2*=gpuAcceleration?1:-1;}if(placement===left){sideX=right;x-=offsetParent.clientWidth-popperRect.width;x*=gpuAcceleration?1:-1;}}var commonStyles2=Object.assign({position:position2},adaptive&&unsetSides);if(gpuAcceleration){var _Object$assign;return Object.assign(Object.assign({},commonStyles2),{},(_Object$assign={},_Object$assign[sideY]=hasY?"0":"",_Object$assign[sideX]=hasX?"0":"",_Object$assign.transform=(win.devicePixelRatio||1)<2?"translate("+x+"px, "+y2+"px)":"translate3d("+x+"px, "+y2+"px, 0)",_Object$assign));}return Object.assign(Object.assign({},commonStyles2),{},(_Object$assign2={},_Object$assign2[sideY]=hasY?y2+"px":"",_Object$assign2[sideX]=hasX?x+"px":"",_Object$assign2.transform="",_Object$assign2));}function computeStyles(_ref32){var state=_ref32.state,options=_ref32.options;var _options$gpuAccelerat=options.gpuAcceleration,gpuAcceleration=_options$gpuAccelerat===void 0?true:_options$gpuAccelerat,_options$adaptive=options.adaptive,adaptive=_options$adaptive===void 0?true:_options$adaptive;var commonStyles2={placement:getBasePlacement(state.placement),popper:state.elements.popper,popperRect:state.rects.popper,gpuAcceleration:gpuAcceleration};if(state.modifiersData.popperOffsets!=null){state.styles.popper=Object.assign(Object.assign({},state.styles.popper),mapToStyles(Object.assign(Object.assign({},commonStyles2),{},{offsets:state.modifiersData.popperOffsets,position:state.options.strategy,adaptive:adaptive})));}if(state.modifiersData.arrow!=null){state.styles.arrow=Object.assign(Object.assign({},state.styles.arrow),mapToStyles(Object.assign(Object.assign({},commonStyles2),{},{offsets:state.modifiersData.arrow,position:"absolute",adaptive:false})));}state.attributes.popper=Object.assign(Object.assign({},state.attributes.popper),{},{"data-popper-placement":state.placement});}var computeStyles$1={name:"computeStyles",enabled:true,phase:"beforeWrite",fn:computeStyles,data:{}};function applyStyles(_ref6){var state=_ref6.state;Object.keys(state.elements).forEach(function(name){var style2=state.styles[name]||{};var attributes=state.attributes[name]||{};var element=state.elements[name];if(!isHTMLElement(element)||!getNodeName(element)){return;}Object.assign(element.style,style2);Object.keys(attributes).forEach(function(name2){var value=attributes[name2];if(value===false){element.removeAttribute(name2);}else{element.setAttribute(name2,value===true?"":value);}});});}function effect$1(_ref22){var state=_ref22.state;var initialStyles={popper:{position:state.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};Object.assign(state.elements.popper.style,initialStyles.popper);if(state.elements.arrow){Object.assign(state.elements.arrow.style,initialStyles.arrow);}return function(){Object.keys(state.elements).forEach(function(name){var element=state.elements[name];var attributes=state.attributes[name]||{};var styleProperties=Object.keys(state.styles.hasOwnProperty(name)?state.styles[name]:initialStyles[name]);var style2=styleProperties.reduce(function(style3,property){style3[property]="";return style3;},{});if(!isHTMLElement(element)||!getNodeName(element)){return;}Object.assign(element.style,style2);Object.keys(attributes).forEach(function(attribute){element.removeAttribute(attribute);});});};}var applyStyles$1={name:"applyStyles",enabled:true,phase:"write",fn:applyStyles,effect:effect$1,requires:["computeStyles"]};function distanceAndSkiddingToXY(placement,rects,offset2){var basePlacement=getBasePlacement(placement);var invertDistance=[left,top].indexOf(basePlacement)>=0?-1:1;var _ref6=typeof offset2==="function"?offset2(Object.assign(Object.assign({},rects),{},{placement:placement})):offset2,skidding=_ref6[0],distance=_ref6[1];skidding=skidding||0;distance=(distance||0)*invertDistance;return[left,right].indexOf(basePlacement)>=0?{x:distance,y:skidding}:{x:skidding,y:distance};}function offset(_ref22){var state=_ref22.state,options=_ref22.options,name=_ref22.name;var _options$offset=options.offset,offset2=_options$offset===void 0?[0,0]:_options$offset;var data=placements$1.reduce(function(acc,placement){acc[placement]=distanceAndSkiddingToXY(placement,state.rects,offset2);return acc;},{});var _data$state$placement=data[state.placement],x=_data$state$placement.x,y2=_data$state$placement.y;if(state.modifiersData.popperOffsets!=null){state.modifiersData.popperOffsets.x+=x;state.modifiersData.popperOffsets.y+=y2;}state.modifiersData[name]=data;}var offset$1={name:"offset",enabled:true,phase:"main",requires:["popperOffsets"],fn:offset};var hash$1={left:"right",right:"left",bottom:"top",top:"bottom"};function getOppositePlacement(placement){return placement.replace(/left|right|bottom|top/g,function(matched){return hash$1[matched];});}var hash={start:"end",end:"start"};function getOppositeVariationPlacement(placement){return placement.replace(/start|end/g,function(matched){return hash[matched];});}function computeAutoPlacement(state,options){if(options===void 0){options={};}var _options=options,placement=_options.placement,boundary=_options.boundary,rootBoundary=_options.rootBoundary,padding2=_options.padding,flipVariations=_options.flipVariations,_options$allowedAutoP=_options.allowedAutoPlacements,allowedAutoPlacements=_options$allowedAutoP===void 0?placements$1:_options$allowedAutoP;var variation=getVariation(placement);var placements2=variation?flipVariations?variationPlacements:variationPlacements.filter(function(placement2){return getVariation(placement2)===variation;}):basePlacements;var allowedPlacements=placements2.filter(function(placement2){return allowedAutoPlacements.indexOf(placement2)>=0;});if(allowedPlacements.length===0){allowedPlacements=placements2;}var overflows=allowedPlacements.reduce(function(acc,placement2){acc[placement2]=detectOverflow(state,{placement:placement2,boundary:boundary,rootBoundary:rootBoundary,padding:padding2})[getBasePlacement(placement2)];return acc;},{});return Object.keys(overflows).sort(function(a,b2){return overflows[a]-overflows[b2];});}function getExpandedFallbackPlacements(placement){if(getBasePlacement(placement)===auto){return[];}var oppositePlacement=getOppositePlacement(placement);return[getOppositeVariationPlacement(placement),oppositePlacement,getOppositeVariationPlacement(oppositePlacement)];}function flip(_ref6){var state=_ref6.state,options=_ref6.options,name=_ref6.name;if(state.modifiersData[name]._skip){return;}var _options$mainAxis=options.mainAxis,checkMainAxis=_options$mainAxis===void 0?true:_options$mainAxis,_options$altAxis=options.altAxis,checkAltAxis=_options$altAxis===void 0?true:_options$altAxis,specifiedFallbackPlacements=options.fallbackPlacements,padding2=options.padding,boundary=options.boundary,rootBoundary=options.rootBoundary,altBoundary=options.altBoundary,_options$flipVariatio=options.flipVariations,flipVariations=_options$flipVariatio===void 0?true:_options$flipVariatio,allowedAutoPlacements=options.allowedAutoPlacements;var preferredPlacement=state.options.placement;var basePlacement=getBasePlacement(preferredPlacement);var isBasePlacement=basePlacement===preferredPlacement;var fallbackPlacements=specifiedFallbackPlacements||(isBasePlacement||!flipVariations?[getOppositePlacement(preferredPlacement)]:getExpandedFallbackPlacements(preferredPlacement));var placements2=[preferredPlacement].concat(fallbackPlacements).reduce(function(acc,placement2){return acc.concat(getBasePlacement(placement2)===auto?computeAutoPlacement(state,{placement:placement2,boundary:boundary,rootBoundary:rootBoundary,padding:padding2,flipVariations:flipVariations,allowedAutoPlacements:allowedAutoPlacements}):placement2);},[]);var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var checksMap=/* @__PURE__ */new Map();var makeFallbackChecks=true;var firstFittingPlacement=placements2[0];for(var i=0;i<placements2.length;i++){var placement=placements2[i];var _basePlacement=getBasePlacement(placement);var isStartVariation=getVariation(placement)===start;var isVertical=[top,bottom].indexOf(_basePlacement)>=0;var len=isVertical?"width":"height";var overflow=detectOverflow(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,altBoundary:altBoundary,padding:padding2});var mainVariationSide=isVertical?isStartVariation?right:left:isStartVariation?bottom:top;if(referenceRect[len]>popperRect[len]){mainVariationSide=getOppositePlacement(mainVariationSide);}var altVariationSide=getOppositePlacement(mainVariationSide);var checks=[];if(checkMainAxis){checks.push(overflow[_basePlacement]<=0);}if(checkAltAxis){checks.push(overflow[mainVariationSide]<=0,overflow[altVariationSide]<=0);}if(checks.every(function(check){return check;})){firstFittingPlacement=placement;makeFallbackChecks=false;break;}checksMap.set(placement,checks);}if(makeFallbackChecks){var numberOfChecks=flipVariations?3:1;var _loop=function _loop2(_i2){var fittingPlacement=placements2.find(function(placement2){var checks2=checksMap.get(placement2);if(checks2){return checks2.slice(0,_i2).every(function(check){return check;});}});if(fittingPlacement){firstFittingPlacement=fittingPlacement;return"break";}};for(var _i=numberOfChecks;_i>0;_i--){var _ret=_loop(_i);if(_ret==="break")break;}}if(state.placement!==firstFittingPlacement){state.modifiersData[name]._skip=true;state.placement=firstFittingPlacement;state.reset=true;}}var flip$1={name:"flip",enabled:true,phase:"main",fn:flip,requiresIfExists:["offset"],data:{_skip:false}};function getAltAxis(axis){return axis==="x"?"y":"x";}function within(min,value,max){return Math.max(min,Math.min(value,max));}function preventOverflow(_ref6){var state=_ref6.state,options=_ref6.options,name=_ref6.name;var _options$mainAxis=options.mainAxis,checkMainAxis=_options$mainAxis===void 0?true:_options$mainAxis,_options$altAxis=options.altAxis,checkAltAxis=_options$altAxis===void 0?false:_options$altAxis,boundary=options.boundary,rootBoundary=options.rootBoundary,altBoundary=options.altBoundary,padding2=options.padding,_options$tether=options.tether,tether=_options$tether===void 0?true:_options$tether,_options$tetherOffset=options.tetherOffset,tetherOffset=_options$tetherOffset===void 0?0:_options$tetherOffset;var overflow=detectOverflow(state,{boundary:boundary,rootBoundary:rootBoundary,padding:padding2,altBoundary:altBoundary});var basePlacement=getBasePlacement(state.placement);var variation=getVariation(state.placement);var isBasePlacement=!variation;var mainAxis=getMainAxisFromPlacement(basePlacement);var altAxis=getAltAxis(mainAxis);var popperOffsets2=state.modifiersData.popperOffsets;var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var tetherOffsetValue=typeof tetherOffset==="function"?tetherOffset(Object.assign(Object.assign({},state.rects),{},{placement:state.placement})):tetherOffset;var data={x:0,y:0};if(!popperOffsets2){return;}if(checkMainAxis){var mainSide=mainAxis==="y"?top:left;var altSide=mainAxis==="y"?bottom:right;var len=mainAxis==="y"?"height":"width";var offset2=popperOffsets2[mainAxis];var min=popperOffsets2[mainAxis]+overflow[mainSide];var max=popperOffsets2[mainAxis]-overflow[altSide];var additive=tether?-popperRect[len]/2:0;var minLen=variation===start?referenceRect[len]:popperRect[len];var maxLen=variation===start?-popperRect[len]:-referenceRect[len];var arrowElement=state.elements.arrow;var arrowRect=tether&&arrowElement?getLayoutRect(arrowElement):{width:0,height:0};var arrowPaddingObject=state.modifiersData["arrow#persistent"]?state.modifiersData["arrow#persistent"].padding:getFreshSideObject();var arrowPaddingMin=arrowPaddingObject[mainSide];var arrowPaddingMax=arrowPaddingObject[altSide];var arrowLen=within(0,referenceRect[len],arrowRect[len]);var minOffset=isBasePlacement?referenceRect[len]/2-additive-arrowLen-arrowPaddingMin-tetherOffsetValue:minLen-arrowLen-arrowPaddingMin-tetherOffsetValue;var maxOffset=isBasePlacement?-referenceRect[len]/2+additive+arrowLen+arrowPaddingMax+tetherOffsetValue:maxLen+arrowLen+arrowPaddingMax+tetherOffsetValue;var arrowOffsetParent=state.elements.arrow&&getOffsetParent(state.elements.arrow);var clientOffset=arrowOffsetParent?mainAxis==="y"?arrowOffsetParent.clientTop||0:arrowOffsetParent.clientLeft||0:0;var offsetModifierValue=state.modifiersData.offset?state.modifiersData.offset[state.placement][mainAxis]:0;var tetherMin=popperOffsets2[mainAxis]+minOffset-offsetModifierValue-clientOffset;var tetherMax=popperOffsets2[mainAxis]+maxOffset-offsetModifierValue;var preventedOffset=within(tether?Math.min(min,tetherMin):min,offset2,tether?Math.max(max,tetherMax):max);popperOffsets2[mainAxis]=preventedOffset;data[mainAxis]=preventedOffset-offset2;}if(checkAltAxis){var _mainSide=mainAxis==="x"?top:left;var _altSide=mainAxis==="x"?bottom:right;var _offset=popperOffsets2[altAxis];var _min=_offset+overflow[_mainSide];var _max=_offset-overflow[_altSide];var _preventedOffset=within(_min,_offset,_max);popperOffsets2[altAxis]=_preventedOffset;data[altAxis]=_preventedOffset-_offset;}state.modifiersData[name]=data;}var preventOverflow$1={name:"preventOverflow",enabled:true,phase:"main",fn:preventOverflow,requiresIfExists:["offset"]};function arrow(_ref6){var _state$modifiersData$;var state=_ref6.state,name=_ref6.name;var arrowElement=state.elements.arrow;var popperOffsets2=state.modifiersData.popperOffsets;var basePlacement=getBasePlacement(state.placement);var axis=getMainAxisFromPlacement(basePlacement);var isVertical=[left,right].indexOf(basePlacement)>=0;var len=isVertical?"height":"width";if(!arrowElement||!popperOffsets2){return;}var paddingObject=state.modifiersData[name+"#persistent"].padding;var arrowRect=getLayoutRect(arrowElement);var minProp=axis==="y"?top:left;var maxProp=axis==="y"?bottom:right;var endDiff=state.rects.reference[len]+state.rects.reference[axis]-popperOffsets2[axis]-state.rects.popper[len];var startDiff=popperOffsets2[axis]-state.rects.reference[axis];var arrowOffsetParent=getOffsetParent(arrowElement);var clientSize=arrowOffsetParent?axis==="y"?arrowOffsetParent.clientHeight||0:arrowOffsetParent.clientWidth||0:0;var centerToReference=endDiff/2-startDiff/2;var min=paddingObject[minProp];var max=clientSize-arrowRect[len]-paddingObject[maxProp];var center=clientSize/2-arrowRect[len]/2+centerToReference;var offset2=within(min,center,max);var axisProp=axis;state.modifiersData[name]=(_state$modifiersData$={},_state$modifiersData$[axisProp]=offset2,_state$modifiersData$.centerOffset=offset2-center,_state$modifiersData$);}function effect(_ref22){var state=_ref22.state,options=_ref22.options,name=_ref22.name;var _options$element=options.element,arrowElement=_options$element===void 0?"[data-popper-arrow]":_options$element,_options$padding=options.padding,padding2=_options$padding===void 0?0:_options$padding;if(arrowElement==null){return;}if(typeof arrowElement==="string"){arrowElement=state.elements.popper.querySelector(arrowElement);if(!arrowElement){return;}}if(!contains(state.elements.popper,arrowElement)){return;}state.elements.arrow=arrowElement;state.modifiersData[name+"#persistent"]={padding:mergePaddingObject(typeof padding2!=="number"?padding2:expandToHashMap(padding2,basePlacements))};}var arrow$1={name:"arrow",enabled:true,phase:"main",fn:arrow,effect:effect,requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function getSideOffsets(overflow,rect,preventedOffsets){if(preventedOffsets===void 0){preventedOffsets={x:0,y:0};}return{top:overflow.top-rect.height-preventedOffsets.y,right:overflow.right-rect.width+preventedOffsets.x,bottom:overflow.bottom-rect.height+preventedOffsets.y,left:overflow.left-rect.width-preventedOffsets.x};}function isAnySideFullyClipped(overflow){return[top,right,bottom,left].some(function(side){return overflow[side]>=0;});}function hide(_ref6){var state=_ref6.state,name=_ref6.name;var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var preventedOffsets=state.modifiersData.preventOverflow;var referenceOverflow=detectOverflow(state,{elementContext:"reference"});var popperAltOverflow=detectOverflow(state,{altBoundary:true});var referenceClippingOffsets=getSideOffsets(referenceOverflow,referenceRect);var popperEscapeOffsets=getSideOffsets(popperAltOverflow,popperRect,preventedOffsets);var isReferenceHidden=isAnySideFullyClipped(referenceClippingOffsets);var hasPopperEscaped=isAnySideFullyClipped(popperEscapeOffsets);state.modifiersData[name]={referenceClippingOffsets:referenceClippingOffsets,popperEscapeOffsets:popperEscapeOffsets,isReferenceHidden:isReferenceHidden,hasPopperEscaped:hasPopperEscaped};state.attributes.popper=Object.assign(Object.assign({},state.attributes.popper),{},{"data-popper-reference-hidden":isReferenceHidden,"data-popper-escaped":hasPopperEscaped});}var hide$1={name:"hide",enabled:true,phase:"main",requiresIfExists:["preventOverflow"],fn:hide};var defaultModifiers=[eventListeners,popperOffsets$1,computeStyles$1,applyStyles$1,offset$1,flip$1,preventOverflow$1,arrow$1,hide$1];var createPopper=/* @__PURE__ */popperGenerator({defaultModifiers:defaultModifiers});var hasElementType=typeof Element!=="undefined";var hasMap=typeof Map==="function";var hasSet=typeof Set==="function";var hasArrayBuffer=typeof ArrayBuffer==="function"&&!!ArrayBuffer.isView;function equal$1(a,b2){if(a===b2)return true;if(a&&b2&&_typeof2(a)=="object"&&_typeof2(b2)=="object"){if(a.constructor!==b2.constructor)return false;var length,i,keys;if(Array.isArray(a)){length=a.length;if(length!=b2.length)return false;for(i=length;i--!==0;)if(!equal$1(a[i],b2[i]))return false;return true;}var it;if(hasMap&&a instanceof Map&&b2 instanceof Map){if(a.size!==b2.size)return false;it=a.entries();while(!(i=it.next()).done)if(!b2.has(i.value[0]))return false;it=a.entries();while(!(i=it.next()).done)if(!equal$1(i.value[1],b2.get(i.value[0])))return false;return true;}if(hasSet&&a instanceof Set&&b2 instanceof Set){if(a.size!==b2.size)return false;it=a.entries();while(!(i=it.next()).done)if(!b2.has(i.value[0]))return false;return true;}if(hasArrayBuffer&&ArrayBuffer.isView(a)&&ArrayBuffer.isView(b2)){length=a.length;if(length!=b2.length)return false;for(i=length;i--!==0;)if(a[i]!==b2[i])return false;return true;}if(a.constructor===RegExp)return a.source===b2.source&&a.flags===b2.flags;if(a.valueOf!==Object.prototype.valueOf)return a.valueOf()===b2.valueOf();if(a.toString!==Object.prototype.toString)return a.toString()===b2.toString();keys=Object.keys(a);length=keys.length;if(length!==Object.keys(b2).length)return false;for(i=length;i--!==0;)if(!Object.prototype.hasOwnProperty.call(b2,keys[i]))return false;if(hasElementType&&a instanceof Element)return false;for(i=length;i--!==0;){if((keys[i]==="_owner"||keys[i]==="__v"||keys[i]==="__o")&&a.$$typeof){continue;}if(!equal$1(a[keys[i]],b2[keys[i]]))return false;}return true;}return a!==a&&b2!==b2;}var reactFastCompare$1=function isEqual(a,b2){try{return equal$1(a,b2);}catch(error){if((error.message||"").match(/stack|recursion/i)){console.warn("react-fast-compare cannot handle circular refs");return false;}throw error;}};var EMPTY_MODIFIERS$1=[];var usePopper$1=function usePopper(referenceElement,popperElement,options){if(options===void 0){options={};}var prevOptions=__WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);var optionsWithDefaults={onFirstUpdate:options.onFirstUpdate,placement:options.placement||"bottom",strategy:options.strategy||"absolute",modifiers:options.modifiers||EMPTY_MODIFIERS$1};var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"]({styles:{popper:{position:optionsWithDefaults.strategy,left:"0",top:"0"}},attributes:{}}),state=_React$useState[0],setState=_React$useState[1];var updateStateModifier=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return{name:"updateState",enabled:true,phase:"write",fn:function fn2(_ref6){var state2=_ref6.state;var elements=Object.keys(state2.elements);setState({styles:fromEntries(elements.map(function(element){return[element,state2.styles[element]||{}];})),attributes:fromEntries(elements.map(function(element){return[element,state2.attributes[element]];}))});},requires:["computeStyles"]};},[]);var popperOptions=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){var newOptions={onFirstUpdate:optionsWithDefaults.onFirstUpdate,placement:optionsWithDefaults.placement,strategy:optionsWithDefaults.strategy,modifiers:[].concat(optionsWithDefaults.modifiers,[updateStateModifier,{name:"applyStyles",enabled:false}])};if(reactFastCompare$1(prevOptions.current,newOptions)){return prevOptions.current||newOptions;}else{prevOptions.current=newOptions;return newOptions;}},[optionsWithDefaults.onFirstUpdate,optionsWithDefaults.placement,optionsWithDefaults.strategy,optionsWithDefaults.modifiers,updateStateModifier]);var popperInstanceRef=__WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();useIsomorphicLayoutEffect(function(){if(popperInstanceRef.current){popperInstanceRef.current.setOptions(popperOptions);}},[popperOptions]);useIsomorphicLayoutEffect(function(){if(referenceElement==null||popperElement==null){return;}var createPopper$1=options.createPopper||createPopper;var popperInstance=createPopper$1(referenceElement,popperElement,popperOptions);popperInstanceRef.current=popperInstance;return function(){popperInstance.destroy();popperInstanceRef.current=null;};},[referenceElement,popperElement,options.createPopper]);return{state:popperInstanceRef.current?popperInstanceRef.current.state:null,styles:state.styles,attributes:state.attributes,update:popperInstanceRef.current?popperInstanceRef.current.update:null,forceUpdate:popperInstanceRef.current?popperInstanceRef.current.forceUpdate:null};};var NOOP=function NOOP2(){return void 0;};var NOOP_PROMISE=function NOOP_PROMISE2(){return Promise.resolve(null);};var EMPTY_MODIFIERS=[];function Popper(_ref6){var _ref$placement=_ref6.placement,placement=_ref$placement===void 0?"bottom":_ref$placement,_ref$strategy=_ref6.strategy,strategy=_ref$strategy===void 0?"absolute":_ref$strategy,_ref$modifiers=_ref6.modifiers,modifiers=_ref$modifiers===void 0?EMPTY_MODIFIERS:_ref$modifiers,referenceElement=_ref6.referenceElement,onFirstUpdate=_ref6.onFirstUpdate,innerRef=_ref6.innerRef,children=_ref6.children;var referenceNode=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](ManagerReferenceNodeContext);var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),popperElement=_React$useState[0],setPopperElement=_React$useState[1];var _React$useState2=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),arrowElement=_React$useState2[0],setArrowElement=_React$useState2[1];__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){return setRef(innerRef,popperElement);},[innerRef,popperElement]);var options=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return{placement:placement,strategy:strategy,onFirstUpdate:onFirstUpdate,modifiers:[].concat(modifiers,[{name:"arrow",enabled:arrowElement!=null,options:{element:arrowElement}}])};},[placement,strategy,onFirstUpdate,modifiers,arrowElement]);var _usePopper=usePopper$1(referenceElement||referenceNode,popperElement,options),state=_usePopper.state,styles2=_usePopper.styles,forceUpdate=_usePopper.forceUpdate,update=_usePopper.update;var childrenProps=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return{ref:setPopperElement,style:styles2.popper,placement:state?state.placement:placement,hasPopperEscaped:state&&state.modifiersData.hide?state.modifiersData.hide.hasPopperEscaped:null,isReferenceHidden:state&&state.modifiersData.hide?state.modifiersData.hide.isReferenceHidden:null,arrowProps:{style:styles2.arrow,ref:setArrowElement},forceUpdate:forceUpdate||NOOP,update:update||NOOP_PROMISE};},[setPopperElement,setArrowElement,placement,state,styles2,update,forceUpdate]);return unwrapArray(children)(childrenProps);}function Reference(_ref6){var children=_ref6.children,innerRef=_ref6.innerRef;var setReferenceNode=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](ManagerReferenceNodeSetterContext);var refHandler=__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function(node){setRef(innerRef,node);safeInvoke(setReferenceNode,node);},[innerRef,setReferenceNode]);__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){return function(){return setRef(innerRef,null);};});__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){},[setReferenceNode]);return unwrapArray(children)({ref:refHandler});}function makeOptions(enableEvents){return{placement:"bottom-start",modifiers:[{name:"eventListeners",enabled:enableEvents},{name:"sameWidth",enabled:true,phase:"beforeWrite",requires:["computeStyles"],fn:function fn(_ref85){var state=_ref85.state;state.styles.popper.width="".concat(state.rects.reference.width,"px");},effect:function effect(_ref86){var state=_ref86.state;state.elements.popper.style.width="".concat(state.elements.reference.offsetWidth,"px");}}]};}function usePopper2(referenceElement,popperElement,enableEvents){var options=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return makeOptions(enableEvents);},[enableEvents]);return usePopper$1(referenceElement,popperElement,options);}var invariant$1=function invariant$1(condition,format,a,b2,c2,d2,e2,f2){if(!condition){var error;if(format===void 0){error=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");}else{var args=[a,b2,c2,d2,e2,f2];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++];}));error.name="Invariant Violation";}error.framesToPop=1;throw error;}};var browser$1=invariant$1;var getRoot$1=function getRoot$1(kind2){var root2=document.getElementById("".concat(kind2,"-root"));return root2;};var noop$1=function noop$1(){};function useMultiDropdown(useMultipleSelectionOptions){var _useMultipleSelection=useMultipleSelection(useMultipleSelectionOptions),getSelectedItemProps=_useMultipleSelection.getSelectedItemProps,getDropdownProps=_useMultipleSelection.getDropdownProps,addSelectedItem=_useMultipleSelection.addSelectedItem,removeSelectedItem=_useMultipleSelection.removeSelectedItem,setActiveIndex=_useMultipleSelection.setActiveIndex,selectedItems=_useMultipleSelection.selectedItems;var stateReducer2=function stateReducer2(_state,changes){switch(changes.type){case Downshift.stateChangeTypes.keyDownEnter:case Downshift.stateChangeTypes.clickItem:return __spreadProps(__spreadValues({},changes),{highlightedIndex:_state.highlightedIndex,isOpen:true});}return changes;};var onStateChange=function onStateChange(_ref87){var type=_ref87.type,selectedItem=_ref87.selectedItem;switch(type){case Downshift.stateChangeTypes.keyDownEnter:case Downshift.stateChangeTypes.keyDownSpaceButton:case Downshift.stateChangeTypes.clickItem:if(selectedItem){if(selectedItems.includes(selectedItem)){removeSelectedItem(selectedItem);setActiveIndex(-1);}else{addSelectedItem(selectedItem);}}break;}};return{getSelectedItemProps:getSelectedItemProps,getDropdownProps:getDropdownProps,selectedItems:selectedItems,stateReducer:stateReducer2,onStateChange:onStateChange};}var Dropdown=function Dropdown(_ref88){var _children=_ref88.children,Icon2=_ref88.icon,itemToString2=_ref88.itemToString,disabled=_ref88.disabled,kind2=_ref88.kind,onChange=_ref88.onChange,placeholder=_ref88.placeholder,size2=_ref88.size,valid2=_ref88.valid,value=_ref88.value,width=_ref88.width,portal=_ref88.portal,portalContainer=_ref88.portalContainer,menuStyles=_ref88.menuStyles,multi=_ref88.multi;var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),buttonEl=_useState4[0],setButtonEl=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),menuEl=_useState6[0],setMenuEl=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),enableEvents=_useState8[0],setEnableEvents=_useState8[1];var _usePopper2=usePopper2(buttonEl,menuEl,enableEvents),styles2=_usePopper2.styles,attributes=_usePopper2.attributes;var portalRoot=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!portal)return null;return portalContainer?portalContainer:getRoot$1("menu");},[portal,portalContainer]);var _useMultiDropdown=useMultiDropdown(multi?{initialSelectedItems:value||[]}:{}),getSelectedItemProps=_useMultiDropdown.getSelectedItemProps,getDropdownProps=_useMultiDropdown.getDropdownProps,selectedItems=_useMultiDropdown.selectedItems,multiHookStateReducer=_useMultiDropdown.stateReducer,multiHookOnStateChange=_useMultiDropdown.onStateChange;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(multi)onChange(selectedItems);},[multi,selectedItems]);return/* @__PURE__ */jsx(Downshift,{onChange:multi?noop$1:onChange,stateReducer:multi&&multiHookStateReducer,onStateChange:function onStateChange(changes){if("isOpen"in changes)setEnableEvents(changes.isOpen);if(multi)multiHookOnStateChange(changes);},selectedItem:multi?null:value,itemToString:itemToString2,children:function children(_ref89){var getToggleButtonProps=_ref89.getToggleButtonProps,getItemProps=_ref89.getItemProps,getMenuProps=_ref89.getMenuProps,getRootProps=_ref89.getRootProps,highlightedIndex=_ref89.highlightedIndex,isOpen=_ref89.isOpen,selectedItem=_ref89.selectedItem;var options=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(_children).filter(Boolean);var menu=/* @__PURE__ */jsx(ListBox,__spreadProps(__spreadValues({"data-testid":"dropdown-menu"},getMenuProps(__spreadValues({ref:setMenuEl,closed:!isOpen,style:__spreadValues(__spreadValues({},styles2.popper),menuStyles)},attributes.popper))),{children:isOpen&&options.map(function(child,idx){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child,__spreadValues({},getItemProps(__spreadValues({key:child.props.value,item:child.props.value,size:size2,focused:highlightedIndex===idx,selected:multi?selectedItems.includes(child.props.value):selectedItem===child.props.value},multi&&selectedItems.includes(child.props.value)&&getSelectedItemProps({index:selectedItems.indexOf(child.props.value)})))));})}));return/* @__PURE__ */jsxs(Container$j,__spreadProps(__spreadValues({width:width},getRootProps()),{children:[/* @__PURE__ */jsxs(Button,__spreadProps(__spreadValues({},getToggleButtonProps(getDropdownProps({ref:setButtonEl,disabled:disabled,size:size2,kind:kind2,valid:valid2}))),{children:[Icon2&&/* @__PURE__ */jsx(Icon2,{size:"m"}),selectedItem?/* @__PURE__ */jsx(TruncateText,{children:options.find(function(_ref90){var props=_ref90.props;return props.value===selectedItem;}).props.children}):selectedItems.length?/* @__PURE__ */jsxs(TruncateText,{children:[selectedItems.length," selected"]}):/* @__PURE__ */jsx(Placeholder,{children:placeholder}),/* @__PURE__ */jsx(Caret$2,{size:"8px",color:"cadet"})]})),portalRoot?Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["createPortal"])(menu,portalRoot):menu]}));}});};Dropdown.propTypes={children:PropTypes$2.node,kind:PropTypes$2.oneOf(["ghost"]),name:PropTypes$2.string.isRequired,onChange:PropTypes$2.func.isRequired,placeholder:PropTypes$2.string,size:PropTypes$2.oneOf(["lg"]),valid:PropTypes$2.bool,value:PropTypes$2.any,portal:PropTypes$2.bool,portalContainer:PropTypes$2.instanceOf(Element),menuStyles:PropTypes$2.object};Dropdown.defaultProps={itemToString:function itemToString(value){return value==null?"":value;},placeholder:"Select...",valid:true};Dropdown.Option=Option;var ExternalButtonLink=Button$1.withComponent("a",{target:"e9fi2zi0"});/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */var _extendStatics=function extendStatics(d2,b2){_extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d3,b3){d3.__proto__=b3;}||function(d3,b3){for(var p2 in b3)if(b3.hasOwnProperty(p2))d3[p2]=b3[p2];};return _extendStatics(d2,b2);};function __extends(d2,b2){_extendStatics(d2,b2);function __(){this.constructor=d2;}d2.prototype=b2===null?Object.create(b2):(__.prototype=b2.prototype,new __());}var _assign=function __assign(){_assign=Object.assign||function __assign2(t2){for(var s,i=1,n2=arguments.length;i<n2;i++){s=arguments[i];for(var p2 in s)if(Object.prototype.hasOwnProperty.call(s,p2))t2[p2]=s[p2];}return t2;};return _assign.apply(this,arguments);};function __rest(s,e2){var t2={};for(var p2 in s)if(Object.prototype.hasOwnProperty.call(s,p2)&&e2.indexOf(p2)<0)t2[p2]=s[p2];if(s!=null&&typeof Object.getOwnPropertySymbols==="function"){for(var i=0,p2=Object.getOwnPropertySymbols(s);i<p2.length;i++)if(e2.indexOf(p2[i])<0)t2[p2[i]]=s[p2[i]];}return t2;}var REACT_STATICS={childContextTypes:true,contextTypes:true,defaultProps:true,displayName:true,getDefaultProps:true,getDerivedStateFromProps:true,mixins:true,propTypes:true,type:true};var KNOWN_STATICS={name:true,length:true,prototype:true,caller:true,callee:true,arguments:true,arity:true};var defineProperty=Object.defineProperty;var getOwnPropertyNames=Object.getOwnPropertyNames;var getOwnPropertySymbols$1=Object.getOwnPropertySymbols;var getOwnPropertyDescriptor=Object.getOwnPropertyDescriptor;var getPrototypeOf=Object.getPrototypeOf;var objectPrototype=getPrototypeOf&&getPrototypeOf(Object);function hoistNonReactStatics(targetComponent,sourceComponent,blacklist){if(typeof sourceComponent!=="string"){if(objectPrototype){var inheritedComponent=getPrototypeOf(sourceComponent);if(inheritedComponent&&inheritedComponent!==objectPrototype){hoistNonReactStatics(targetComponent,inheritedComponent,blacklist);}}var keys=getOwnPropertyNames(sourceComponent);if(getOwnPropertySymbols$1){keys=keys.concat(getOwnPropertySymbols$1(sourceComponent));}for(var i=0;i<keys.length;++i){var key2=keys[i];if(!REACT_STATICS[key2]&&!KNOWN_STATICS[key2]&&(!blacklist||!blacklist[key2])){var descriptor=getOwnPropertyDescriptor(sourceComponent,key2);try{defineProperty(targetComponent,key2,descriptor);}catch(e2){}}}return targetComponent;}return targetComponent;}var hoistNonReactStatics_cjs=hoistNonReactStatics;var lib={exports:{}};var implementation={exports:{}};var propTypes$1={exports:{}};var ReactPropTypesSecret$2="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";var ReactPropTypesSecret_1$1=ReactPropTypesSecret$2;var ReactPropTypesSecret$1=ReactPropTypesSecret_1$1;function emptyFunction$2(){}function emptyFunctionWithReset(){}emptyFunctionWithReset.resetWarningCache=emptyFunction$2;var factoryWithThrowingShims$1=function factoryWithThrowingShims$1(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret$1){return;}var err=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");err.name="Invariant Violation";throw err;}shim.isRequired=shim;function getShim(){return shim;}var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,elementType:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim,checkPropTypes:emptyFunctionWithReset,resetWarningCache:emptyFunction$2};ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};{propTypes$1.exports=factoryWithThrowingShims$1();}var key="__global_unique_id__";var gud=function gud(){return commonjsGlobal[key]=(commonjsGlobal[key]||0)+1;};var emptyFunction$1=emptyFunction_1$1;var warning$1=emptyFunction$1;var warning_1=warning$1;(function(module2,exports){exports.__esModule=true;var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;_interopRequireDefault2(_react3);var _propTypes3=propTypes$1.exports;var _propTypes22=_interopRequireDefault2(_propTypes3);var _gud=gud;var _gud2=_interopRequireDefault2(_gud);var _warning=warning_1;_interopRequireDefault2(_warning);function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn2(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_SIGNED_31_BIT_INT=1073741823;function objectIs(x,y2){if(x===y2){return x!==0||1/x===1/y2;}else{return x!==x&&y2!==y2;}}function createEventEmitter(value){var handlers=[];return{on:function on(handler){handlers.push(handler);},off:function off(handler){handlers=handlers.filter(function(h2){return h2!==handler;});},get:function get2(){return value;},set:function set(newValue,changedBits){value=newValue;handlers.forEach(function(handler){return handler(value,changedBits);});}};}function onlyChild(children){return Array.isArray(children)?children[0]:children;}function createReactContext(defaultValue,calculateChangedBits){var _Provider$childContex,_Consumer$contextType;var contextProp="__create-react-context-"+(0,_gud2["default"])()+"__";var Provider2=function(_Component){_inherits2(Provider3,_Component);function Provider3(){var _temp,_this,_ret;_classCallCheck2(this,Provider3);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn2(this,_Component.call.apply(_Component,[this].concat(args))),_this),_this.emitter=createEventEmitter(_this.props.value),_temp),_possibleConstructorReturn2(_this,_ret);}Provider3.prototype.getChildContext=function getChildContext(){var _ref6;return _ref6={},_ref6[contextProp]=this.emitter,_ref6;};Provider3.prototype.componentWillReceiveProps=function componentWillReceiveProps(nextProps){if(this.props.value!==nextProps.value){var oldValue=this.props.value;var newValue=nextProps.value;var changedBits=void 0;if(objectIs(oldValue,newValue)){changedBits=0;}else{changedBits=typeof calculateChangedBits==="function"?calculateChangedBits(oldValue,newValue):MAX_SIGNED_31_BIT_INT;changedBits|=0;if(changedBits!==0){this.emitter.set(nextProps.value,changedBits);}}}};Provider3.prototype.render=function render3(){return this.props.children;};return Provider3;}(_react3.Component);Provider2.childContextTypes=(_Provider$childContex={},_Provider$childContex[contextProp]=_propTypes22["default"].object.isRequired,_Provider$childContex);var Consumer2=function(_Component2){_inherits2(Consumer3,_Component2);function Consumer3(){var _temp2,_this2,_ret2;_classCallCheck2(this,Consumer3);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn2(this,_Component2.call.apply(_Component2,[this].concat(args))),_this2),_this2.state={value:_this2.getValue()},_this2.onUpdate=function(newValue,changedBits){var observedBits=_this2.observedBits|0;if((observedBits&changedBits)!==0){_this2.setState({value:_this2.getValue()});}},_temp2),_possibleConstructorReturn2(_this2,_ret2);}Consumer3.prototype.componentWillReceiveProps=function componentWillReceiveProps(nextProps){var observedBits=nextProps.observedBits;this.observedBits=observedBits===void 0||observedBits===null?MAX_SIGNED_31_BIT_INT:observedBits;};Consumer3.prototype.componentDidMount=function componentDidMount(){if(this.context[contextProp]){this.context[contextProp].on(this.onUpdate);}var observedBits=this.props.observedBits;this.observedBits=observedBits===void 0||observedBits===null?MAX_SIGNED_31_BIT_INT:observedBits;};Consumer3.prototype.componentWillUnmount=function componentWillUnmount(){if(this.context[contextProp]){this.context[contextProp].off(this.onUpdate);}};Consumer3.prototype.getValue=function getValue2(){if(this.context[contextProp]){return this.context[contextProp].get();}else{return defaultValue;}};Consumer3.prototype.render=function render3(){return onlyChild(this.props.children)(this.state.value);};return Consumer3;}(_react3.Component);Consumer2.contextTypes=(_Consumer$contextType={},_Consumer$contextType[contextProp]=_propTypes22["default"].object,_Consumer$contextType);return{Provider:Provider2,Consumer:Consumer2};}exports["default"]=createReactContext;module2.exports=exports["default"];})(implementation,implementation.exports);(function(module2,exports){exports.__esModule=true;var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _implementation=implementation.exports;var _implementation2=_interopRequireDefault2(_implementation);function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}exports["default"]=_react22["default"].createContext||_implementation2["default"];module2.exports=exports["default"];})(lib,lib.exports);var createContext=/* @__PURE__ */getDefaultExportFromCjs(lib.exports);var lodash_clonedeep={exports:{}};(function(module2,exports){var LARGE_ARRAY_SIZE=200;var HASH_UNDEFINED2="__lodash_hash_undefined__";var MAX_SAFE_INTEGER=9007199254740991;var argsTag="[object Arguments]",arrayTag="[object Array]",boolTag="[object Boolean]",dateTag="[object Date]",errorTag="[object Error]",funcTag2="[object Function]",genTag2="[object GeneratorFunction]",mapTag="[object Map]",numberTag="[object Number]",objectTag="[object Object]",promiseTag="[object Promise]",regexpTag="[object RegExp]",setTag="[object Set]",stringTag="[object String]",symbolTag2="[object Symbol]",weakMapTag="[object WeakMap]";var arrayBufferTag="[object ArrayBuffer]",dataViewTag="[object DataView]",float32Tag="[object Float32Array]",float64Tag="[object Float64Array]",int8Tag="[object Int8Array]",int16Tag="[object Int16Array]",int32Tag="[object Int32Array]",uint8Tag="[object Uint8Array]",uint8ClampedTag="[object Uint8ClampedArray]",uint16Tag="[object Uint16Array]",uint32Tag="[object Uint32Array]";var reRegExpChar2=/[\\^$.*+?()[\]{}|]/g;var reFlags=/\w*$/;var reIsHostCtor2=/^\[object .+?Constructor\]$/;var reIsUint=/^(?:0|[1-9]\d*)$/;var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag2]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag2]=cloneableTags[weakMapTag]=false;var freeGlobal2=_typeof2(commonjsGlobal)=="object"&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal;var freeSelf2=(typeof self==="undefined"?"undefined":_typeof2(self))=="object"&&self&&self.Object===Object&&self;var root2=freeGlobal2||freeSelf2||Function("return this")();var freeExports=exports&&!exports.nodeType&&exports;var freeModule=freeExports&&true&&module2&&!module2.nodeType&&module2;var moduleExports=freeModule&&freeModule.exports===freeExports;function addMapEntry(map,pair){map.set(pair[0],pair[1]);return map;}function addSetEntry(set,value){set.add(value);return set;}function arrayEach(array,iteratee){var index2=-1,length=array?array.length:0;while(++index2<length){if(iteratee(array[index2],index2,array)===false){break;}}return array;}function arrayPush(array,values){var index2=-1,length=values.length,offset2=array.length;while(++index2<length){array[offset2+index2]=values[index2];}return array;}function arrayReduce(array,iteratee,accumulator,initAccum){var index2=-1,length=array?array.length:0;if(initAccum&&length){accumulator=array[++index2];}while(++index2<length){accumulator=iteratee(accumulator,array[index2],index2,array);}return accumulator;}function baseTimes(n2,iteratee){var index2=-1,result=Array(n2);while(++index2<n2){result[index2]=iteratee(index2);}return result;}function getValue2(object,key2){return object==null?void 0:object[key2];}function isHostObject2(value){var result=false;if(value!=null&&typeof value.toString!="function"){try{result=!!(value+"");}catch(e2){}}return result;}function mapToArray(map){var index2=-1,result=Array(map.size);map.forEach(function(value,key2){result[++index2]=[key2,value];});return result;}function overArg(func,transform){return function(arg){return func(transform(arg));};}function setToArray(set){var index2=-1,result=Array(set.size);set.forEach(function(value){result[++index2]=value;});return result;}var arrayProto2=Array.prototype,funcProto2=Function.prototype,objectProto2=Object.prototype;var coreJsData2=root2["__core-js_shared__"];var maskSrcKey2=function(){var uid=/[^.]+$/.exec(coreJsData2&&coreJsData2.keys&&coreJsData2.keys.IE_PROTO||"");return uid?"Symbol(src)_1."+uid:"";}();var funcToString2=funcProto2.toString;var hasOwnProperty2=objectProto2.hasOwnProperty;var objectToString2=objectProto2.toString;var reIsNative2=RegExp("^"+funcToString2.call(hasOwnProperty2).replace(reRegExpChar2,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");var Buffer2=moduleExports?root2.Buffer:void 0,Symbol2=root2.Symbol,Uint8Array2=root2.Uint8Array,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto2.propertyIsEnumerable,splice2=arrayProto2.splice;var nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer2?Buffer2.isBuffer:void 0,nativeKeys=overArg(Object.keys,Object);var DataView=getNative2(root2,"DataView"),Map2=getNative2(root2,"Map"),Promise2=getNative2(root2,"Promise"),Set2=getNative2(root2,"Set"),WeakMap2=getNative2(root2,"WeakMap"),nativeCreate2=getNative2(Object,"create");var dataViewCtorString=toSource2(DataView),mapCtorString=toSource2(Map2),promiseCtorString=toSource2(Promise2),setCtorString=toSource2(Set2),weakMapCtorString=toSource2(WeakMap2);var symbolProto2=Symbol2?Symbol2.prototype:void 0,symbolValueOf=symbolProto2?symbolProto2.valueOf:void 0;function Hash2(entries){var index2=-1,length=entries?entries.length:0;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}function hashClear2(){this.__data__=nativeCreate2?nativeCreate2(null):{};}function hashDelete2(key2){return this.has(key2)&&delete this.__data__[key2];}function hashGet2(key2){var data=this.__data__;if(nativeCreate2){var result=data[key2];return result===HASH_UNDEFINED2?void 0:result;}return hasOwnProperty2.call(data,key2)?data[key2]:void 0;}function hashHas2(key2){var data=this.__data__;return nativeCreate2?data[key2]!==void 0:hasOwnProperty2.call(data,key2);}function hashSet2(key2,value){var data=this.__data__;data[key2]=nativeCreate2&&value===void 0?HASH_UNDEFINED2:value;return this;}Hash2.prototype.clear=hashClear2;Hash2.prototype["delete"]=hashDelete2;Hash2.prototype.get=hashGet2;Hash2.prototype.has=hashHas2;Hash2.prototype.set=hashSet2;function ListCache2(entries){var index2=-1,length=entries?entries.length:0;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}function listCacheClear2(){this.__data__=[];}function listCacheDelete2(key2){var data=this.__data__,index2=assocIndexOf2(data,key2);if(index2<0){return false;}var lastIndex=data.length-1;if(index2==lastIndex){data.pop();}else{splice2.call(data,index2,1);}return true;}function listCacheGet2(key2){var data=this.__data__,index2=assocIndexOf2(data,key2);return index2<0?void 0:data[index2][1];}function listCacheHas2(key2){return assocIndexOf2(this.__data__,key2)>-1;}function listCacheSet2(key2,value){var data=this.__data__,index2=assocIndexOf2(data,key2);if(index2<0){data.push([key2,value]);}else{data[index2][1]=value;}return this;}ListCache2.prototype.clear=listCacheClear2;ListCache2.prototype["delete"]=listCacheDelete2;ListCache2.prototype.get=listCacheGet2;ListCache2.prototype.has=listCacheHas2;ListCache2.prototype.set=listCacheSet2;function MapCache2(entries){var index2=-1,length=entries?entries.length:0;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}function mapCacheClear2(){this.__data__={"hash":new Hash2(),"map":new(Map2||ListCache2)(),"string":new Hash2()};}function mapCacheDelete2(key2){return getMapData2(this,key2)["delete"](key2);}function mapCacheGet2(key2){return getMapData2(this,key2).get(key2);}function mapCacheHas2(key2){return getMapData2(this,key2).has(key2);}function mapCacheSet2(key2,value){getMapData2(this,key2).set(key2,value);return this;}MapCache2.prototype.clear=mapCacheClear2;MapCache2.prototype["delete"]=mapCacheDelete2;MapCache2.prototype.get=mapCacheGet2;MapCache2.prototype.has=mapCacheHas2;MapCache2.prototype.set=mapCacheSet2;function Stack(entries){this.__data__=new ListCache2(entries);}function stackClear(){this.__data__=new ListCache2();}function stackDelete(key2){return this.__data__["delete"](key2);}function stackGet(key2){return this.__data__.get(key2);}function stackHas(key2){return this.__data__.has(key2);}function stackSet(key2,value){var cache=this.__data__;if(cache instanceof ListCache2){var pairs=cache.__data__;if(!Map2||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key2,value]);return this;}cache=this.__data__=new MapCache2(pairs);}cache.set(key2,value);return this;}Stack.prototype.clear=stackClear;Stack.prototype["delete"]=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;function arrayLikeKeys(value,inherited){var result=isArray2(value)||isArguments(value)?baseTimes(value.length,String):[];var length=result.length,skipIndexes=!!length;for(var key2 in value){if((inherited||hasOwnProperty2.call(value,key2))&&!(skipIndexes&&(key2=="length"||isIndex(key2,length)))){result.push(key2);}}return result;}function assignValue(object,key2,value){var objValue=object[key2];if(!(hasOwnProperty2.call(object,key2)&&eq2(objValue,value))||value===void 0&&!(key2 in object)){object[key2]=value;}}function assocIndexOf2(array,key2){var length=array.length;while(length--){if(eq2(array[length][0],key2)){return length;}}return-1;}function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}function baseClone(value,isDeep,isFull,customizer,key2,object,stack){var result;if(customizer){result=object?customizer(value,key2,object,stack):customizer(value);}if(result!==void 0){return result;}if(!isObject2(value)){return value;}var isArr=isArray2(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray2(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag2||tag==genTag2;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){if(isHostObject2(value)){return object?value:{};}result=initCloneObject(isFunc?{}:value);if(!isDeep){return copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,baseClone,isDeep);}}stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(!isArr){var props=isFull?getAllKeys(value):keys(value);}arrayEach(props||value,function(subValue,key3){if(props){key3=subValue;subValue=value[key3];}assignValue(result,key3,baseClone(subValue,isDeep,isFull,customizer,key3,value,stack));});return result;}function baseCreate(proto){return isObject2(proto)?objectCreate(proto):{};}function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray2(object)?result:arrayPush(result,symbolsFunc(object));}function baseGetTag2(value){return objectToString2.call(value);}function baseIsNative2(value){if(!isObject2(value)||isMasked2(value)){return false;}var pattern=isFunction2(value)||isHostObject2(value)?reIsNative2:reIsHostCtor2;return pattern.test(toSource2(value));}function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key2 in Object(object)){if(hasOwnProperty2.call(object,key2)&&key2!="constructor"){result.push(key2);}}return result;}function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var result=new buffer.constructor(buffer.length);buffer.copy(result);return result;}function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));return result;}function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}function cloneMap(map,isDeep,cloneFunc){var array=isDeep?cloneFunc(mapToArray(map),true):mapToArray(map);return arrayReduce(array,addMapEntry,new map.constructor());}function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}function cloneSet(set,isDeep,cloneFunc){var array=isDeep?cloneFunc(setToArray(set),true):setToArray(set);return arrayReduce(array,addSetEntry,new set.constructor());}function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}function copyArray2(source,array){var index2=-1,length=source.length;array||(array=Array(length));while(++index2<length){array[index2]=source[index2];}return array;}function copyObject(source,props,object,customizer){object||(object={});var index2=-1,length=props.length;while(++index2<length){var key2=props[index2];var newValue=customizer?customizer(object[key2],source[key2],key2,object,source):void 0;assignValue(object,key2,newValue===void 0?source[key2]:newValue);}return object;}function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}function getMapData2(map,key2){var data=map.__data__;return isKeyable2(key2)?data[typeof key2=="string"?"string":"hash"]:data.map;}function getNative2(object,key2){var value=getValue2(object,key2);return baseIsNative2(value)?value:void 0;}var getSymbols=nativeGetSymbols?overArg(nativeGetSymbols,Object):stubArray;var getTag=baseGetTag2;if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map2&&getTag(new Map2())!=mapTag||Promise2&&getTag(Promise2.resolve())!=promiseTag||Set2&&getTag(new Set2())!=setTag||WeakMap2&&getTag(new WeakMap2())!=weakMapTag){getTag=function getTag(value){var result=objectToString2.call(value),Ctor=result==objectTag?value.constructor:void 0,ctorString=Ctor?toSource2(Ctor):void 0;if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}function initCloneArray(array){var length=array.length,result=array.constructor(length);if(length&&typeof array[0]=="string"&&hasOwnProperty2.call(array,"index")){result.index=array.index;result.input=array.input;}return result;}function initCloneObject(object){return typeof object.constructor=="function"&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}function initCloneByTag(object,tag,cloneFunc,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return cloneMap(object,isDeep,cloneFunc);case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return cloneSet(object,isDeep,cloneFunc);case symbolTag2:return cloneSymbol(object);}}function isIndex(value,length){length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(typeof value=="number"||reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}function isKeyable2(value){var type=_typeof2(value);return type=="string"||type=="number"||type=="symbol"||type=="boolean"?value!=="__proto__":value===null;}function isMasked2(func){return!!maskSrcKey2&&maskSrcKey2 in func;}function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=="function"&&Ctor.prototype||objectProto2;return value===proto;}function toSource2(func){if(func!=null){try{return funcToString2.call(func);}catch(e2){}try{return func+"";}catch(e2){}}return"";}function cloneDeep2(value){return baseClone(value,true,true);}function eq2(value,other){return value===other||value!==value&&other!==other;}function isArguments(value){return isArrayLikeObject(value)&&hasOwnProperty2.call(value,"callee")&&(!propertyIsEnumerable.call(value,"callee")||objectToString2.call(value)==argsTag);}var isArray2=Array.isArray;function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction2(value);}function isArrayLikeObject(value){return isObjectLike2(value)&&isArrayLike(value);}var isBuffer=nativeIsBuffer||stubFalse;function isFunction2(value){var tag=isObject2(value)?objectToString2.call(value):"";return tag==funcTag2||tag==genTag2;}function isLength(value){return typeof value=="number"&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}function isObject2(value){var type=_typeof2(value);return!!value&&(type=="object"||type=="function");}function isObjectLike2(value){return!!value&&_typeof2(value)=="object";}function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}function stubArray(){return[];}function stubFalse(){return false;}module2.exports=cloneDeep2;})(lodash_clonedeep,lodash_clonedeep.exports);var cloneDeep=lodash_clonedeep.exports;var FUNC_ERROR_TEXT="Expected a function";var HASH_UNDEFINED="__lodash_hash_undefined__";var INFINITY=1/0;var funcTag="[object Function]",genTag="[object GeneratorFunction]",symbolTag="[object Symbol]";var reLeadingDot=/^\./,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;var reRegExpChar=/[\\^$.*+?()[\]{}|]/g;var reEscapeChar=/\\(\\)?/g;var reIsHostCtor=/^\[object .+?Constructor\]$/;var freeGlobal=_typeof2(commonjsGlobal)=="object"&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal;var freeSelf=(typeof self==="undefined"?"undefined":_typeof2(self))=="object"&&self&&self.Object===Object&&self;var root$1=freeGlobal||freeSelf||Function("return this")();function arrayMap(array,iteratee){var index2=-1,length=array?array.length:0,result=Array(length);while(++index2<length){result[index2]=iteratee(array[index2],index2,array);}return result;}function getValue(object,key2){return object==null?void 0:object[key2];}function isHostObject(value){var result=false;if(value!=null&&typeof value.toString!="function"){try{result=!!(value+"");}catch(e2){}}return result;}var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;var coreJsData=root$1["__core-js_shared__"];var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||"");return uid?"Symbol(src)_1."+uid:"";}();var funcToString=funcProto.toString;var hasOwnProperty$1=objectProto.hasOwnProperty;var objectToString=objectProto.toString;var reIsNative=RegExp("^"+funcToString.call(hasOwnProperty$1).replace(reRegExpChar,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");var Symbol$1=root$1.Symbol,splice=arrayProto.splice;var Map$1=getNative(root$1,"Map"),nativeCreate=getNative(Object,"create");var symbolProto=Symbol$1?Symbol$1.prototype:void 0,symbolToString=symbolProto?symbolProto.toString:void 0;function Hash(entries){var index2=-1,length=entries?entries.length:0;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};}function hashDelete(key2){return this.has(key2)&&delete this.__data__[key2];}function hashGet(key2){var data=this.__data__;if(nativeCreate){var result=data[key2];return result===HASH_UNDEFINED?void 0:result;}return hasOwnProperty$1.call(data,key2)?data[key2]:void 0;}function hashHas(key2){var data=this.__data__;return nativeCreate?data[key2]!==void 0:hasOwnProperty$1.call(data,key2);}function hashSet(key2,value){var data=this.__data__;data[key2]=nativeCreate&&value===void 0?HASH_UNDEFINED:value;return this;}Hash.prototype.clear=hashClear;Hash.prototype["delete"]=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;function ListCache(entries){var index2=-1,length=entries?entries.length:0;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}function listCacheClear(){this.__data__=[];}function listCacheDelete(key2){var data=this.__data__,index2=assocIndexOf(data,key2);if(index2<0){return false;}var lastIndex=data.length-1;if(index2==lastIndex){data.pop();}else{splice.call(data,index2,1);}return true;}function listCacheGet(key2){var data=this.__data__,index2=assocIndexOf(data,key2);return index2<0?void 0:data[index2][1];}function listCacheHas(key2){return assocIndexOf(this.__data__,key2)>-1;}function listCacheSet(key2,value){var data=this.__data__,index2=assocIndexOf(data,key2);if(index2<0){data.push([key2,value]);}else{data[index2][1]=value;}return this;}ListCache.prototype.clear=listCacheClear;ListCache.prototype["delete"]=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;function MapCache(entries){var index2=-1,length=entries?entries.length:0;this.clear();while(++index2<length){var entry=entries[index2];this.set(entry[0],entry[1]);}}function mapCacheClear(){this.__data__={"hash":new Hash(),"map":new(Map$1||ListCache)(),"string":new Hash()};}function mapCacheDelete(key2){return getMapData(this,key2)["delete"](key2);}function mapCacheGet(key2){return getMapData(this,key2).get(key2);}function mapCacheHas(key2){return getMapData(this,key2).has(key2);}function mapCacheSet(key2,value){getMapData(this,key2).set(key2,value);return this;}MapCache.prototype.clear=mapCacheClear;MapCache.prototype["delete"]=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;function assocIndexOf(array,key2){var length=array.length;while(length--){if(eq(array[length][0],key2)){return length;}}return-1;}function baseIsNative(value){if(!isObject$1(value)||isMasked(value)){return false;}var pattern=isFunction$1(value)||isHostObject(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}function baseToString(value){if(typeof value=="string"){return value;}if(isSymbol(value)){return symbolToString?symbolToString.call(value):"";}var result=value+"";return result=="0"&&1/value==-INFINITY?"-0":result;}function copyArray(source,array){var index2=-1,length=source.length;array||(array=Array(length));while(++index2<length){array[index2]=source[index2];}return array;}function getMapData(map,key2){var data=map.__data__;return isKeyable(key2)?data[typeof key2=="string"?"string":"hash"]:data.map;}function getNative(object,key2){var value=getValue(object,key2);return baseIsNative(value)?value:void 0;}function isKeyable(value){var type=_typeof2(value);return type=="string"||type=="number"||type=="symbol"||type=="boolean"?value!=="__proto__":value===null;}function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}var stringToPath=memoize(function(string){string=toString(string);var result=[];if(reLeadingDot.test(string)){result.push("");}string.replace(rePropName,function(match,number,quote,string2){result.push(quote?string2.replace(reEscapeChar,"$1"):number||match);});return result;});function toKey(value){if(typeof value=="string"||isSymbol(value)){return value;}var result=value+"";return result=="0"&&1/value==-INFINITY?"-0":result;}function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e2){}try{return func+"";}catch(e2){}}return"";}function memoize(func,resolver){if(typeof func!="function"||resolver&&typeof resolver!="function"){throw new TypeError(FUNC_ERROR_TEXT);}var _memoized2=function memoized(){var args=arguments,key2=resolver?resolver.apply(this,args):args[0],cache=_memoized2.cache;if(cache.has(key2)){return cache.get(key2);}var result=func.apply(this,args);_memoized2.cache=cache.set(key2,result);return result;};_memoized2.cache=new(memoize.Cache||MapCache)();return _memoized2;}memoize.Cache=MapCache;function eq(value,other){return value===other||value!==value&&other!==other;}var isArray$1=Array.isArray;function isFunction$1(value){var tag=isObject$1(value)?objectToString.call(value):"";return tag==funcTag||tag==genTag;}function isObject$1(value){var type=_typeof2(value);return!!value&&(type=="object"||type=="function");}function isObjectLike(value){return!!value&&_typeof2(value)=="object";}function isSymbol(value){return _typeof2(value)=="symbol"||isObjectLike(value)&&objectToString.call(value)==symbolTag;}function toString(value){return value==null?"":baseToString(value);}function toPath(value){if(isArray$1(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(value));}var lodash_topath=toPath;var isArray=Array.isArray;var keyList=Object.keys;var hasProp=Object.prototype.hasOwnProperty;function equal(a,b2){if(a===b2)return true;var arrA=isArray(a),arrB=isArray(b2),i,length,key2;if(arrA&&arrB){length=a.length;if(length!=b2.length)return false;for(i=0;i<length;i++)if(!equal(a[i],b2[i]))return false;return true;}if(arrA!=arrB)return false;var dateA=a instanceof Date,dateB=b2 instanceof Date;if(dateA!=dateB)return false;if(dateA&&dateB)return a.getTime()==b2.getTime();var regexpA=a instanceof RegExp,regexpB=b2 instanceof RegExp;if(regexpA!=regexpB)return false;if(regexpA&&regexpB)return a.toString()==b2.toString();if(a instanceof Object&&b2 instanceof Object){var keys=keyList(a);length=keys.length;if(length!==keyList(b2).length)return false;for(i=0;i<length;i++)if(!hasProp.call(b2,keys[i]))return false;for(i=0;i<length;i++){key2=keys[i];if(key2==="_owner"&&a.$$typeof&&a._store){continue;}else{if(!equal(a[key2],b2[key2]))return false;}}return true;}return false;}var reactFastCompare=function exportedEqual(a,b2){try{return equal(a,b2);}catch(error){if(error.message&&error.message.match(/stack|recursion/i)){console.warn("Warning: react-fast-compare does not handle circular references.",error.name,error.message);return false;}throw error;}};var warning=function warning(){};var browser=warning;var isMergeableObject=function isMergeableObject2(value){return isNonNullObject(value)&&!isSpecial(value);};function isNonNullObject(value){return!!value&&_typeof2(value)==="object";}function isSpecial(value){var stringValue=Object.prototype.toString.call(value);return stringValue==="[object RegExp]"||stringValue==="[object Date]"||isReactElement(value);}var canUseSymbol=typeof Symbol==="function"&&Symbol["for"];var REACT_ELEMENT_TYPE=canUseSymbol?Symbol["for"]("react.element"):60103;function isReactElement(value){return value.$$typeof===REACT_ELEMENT_TYPE;}function emptyTarget(val){return Array.isArray(val)?[]:{};}function cloneUnlessOtherwiseSpecified(value,options){return options.clone!==false&&options.isMergeableObject(value)?deepmerge(emptyTarget(value),value,options):value;}function defaultArrayMerge(target,source,options){return target.concat(source).map(function(element){return cloneUnlessOtherwiseSpecified(element,options);});}function mergeObject(target,source,options){var destination={};if(options.isMergeableObject(target)){Object.keys(target).forEach(function(key2){destination[key2]=cloneUnlessOtherwiseSpecified(target[key2],options);});}Object.keys(source).forEach(function(key2){if(!options.isMergeableObject(source[key2])||!target[key2]){destination[key2]=cloneUnlessOtherwiseSpecified(source[key2],options);}else{destination[key2]=deepmerge(target[key2],source[key2],options);}});return destination;}function deepmerge(target,source,options){options=options||{};options.arrayMerge=options.arrayMerge||defaultArrayMerge;options.isMergeableObject=options.isMergeableObject||isMergeableObject;var sourceIsArray=Array.isArray(source);var targetIsArray=Array.isArray(target);var sourceAndTargetTypesMatch=sourceIsArray===targetIsArray;if(!sourceAndTargetTypesMatch){return cloneUnlessOtherwiseSpecified(source,options);}else if(sourceIsArray){return options.arrayMerge(target,source,options);}else{return mergeObject(target,source,options);}}deepmerge.all=function deepmergeAll(array,options){if(!Array.isArray(array)){throw new Error("first argument should be an array");}return array.reduce(function(prev,next){return deepmerge(prev,next,options);},{});};var deepmerge_1=deepmerge;var _a;var FormikProvider=(_a=createContext({}),_a.Provider),FormikConsumer=_a.Consumer;function connect(Comp){var C2=function C2(props){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormikConsumer,null,function(formik){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp,_assign({},props,{formik:formik}));});};C2.WrappedComponent=Comp;return hoistNonReactStatics_cjs(C2,Comp);}function getIn(obj,key2,def,p2){if(p2===void 0){p2=0;}var path=lodash_topath(key2);while(obj&&p2<path.length){obj=obj[path[p2++]];}return obj===void 0?def:obj;}function setIn(obj,path,value){var res={};var resVal=res;var i=0;var pathArray=lodash_topath(path);for(;i<pathArray.length-1;i++){var currentPath=pathArray[i];var currentObj=getIn(obj,pathArray.slice(0,i+1));if(resVal[currentPath]){resVal=resVal[currentPath];}else if(currentObj){resVal=resVal[currentPath]=cloneDeep(currentObj);}else{var nextPath=pathArray[i+1];resVal=resVal[currentPath]=isInteger(nextPath)&&Number(nextPath)>=0?[]:{};}}resVal[pathArray[i]]=value;return _assign({},obj,res);}function setNestedObjectValues(object,value,visited,response){if(visited===void 0){visited=/* @__PURE__ */new WeakMap();}if(response===void 0){response={};}for(var _i=0,_a2=Object.keys(object);_i<_a2.length;_i++){var k2=_a2[_i];var val=object[k2];if(isObject(val)){if(!visited.get(val)){visited.set(val,true);response[k2]=Array.isArray(val)?[]:{};setNestedObjectValues(val,value,visited,response[k2]);}}else{response[k2]=value;}}return response;}var isFunction=function isFunction(obj){return typeof obj==="function";};var isObject=function isObject(obj){return obj!==null&&_typeof2(obj)==="object";};var isInteger=function isInteger(obj){return String(Math.floor(Number(obj)))===obj;};var isString=function isString(obj){return Object.prototype.toString.call(obj)==="[object String]";};var isNaN$1=function isNaN$1(obj){return obj!==obj;};var isEmptyChildren=function isEmptyChildren(children){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children)===0;};var isPromise=function isPromise(value){return isObject(value)&&isFunction(value.then);};var Formik=function(_super){__extends(Formik2,_super);function Formik2(props){var _this=_super.call(this,props)||this;_this.hcCache={};_this.hbCache={};_this.registerField=function(name,fns){_this.fields[name]=fns;};_this.unregisterField=function(name){delete _this.fields[name];};_this.setErrors=function(errors){_this.setState({errors:errors});};_this.setTouched=function(touched){_this.setState({touched:touched},function(){if(_this.props.validateOnBlur){_this.runValidations(_this.state.values);}});};_this.setValues=function(values){_this.setState({values:values},function(){if(_this.props.validateOnChange){_this.runValidations(values);}});};_this.setStatus=function(status){_this.setState({status:status});};_this.setError=function(error){_this.setState({error:error});};_this.setSubmitting=function(isSubmitting){_this.setState({isSubmitting:isSubmitting});};_this.validateField=function(field){_this.setState({isValidating:true});_this.runSingleFieldLevelValidation(field,getIn(_this.state.values,field)).then(function(error){if(!!error&&_this.didMount){_this.setState({errors:setIn(_this.state.errors,field,error),isValidating:false});}});};_this.runSingleFieldLevelValidation=function(field,value){return new Promise(function(resolve){return resolve(_this.fields[field].validate(value));});};_this.runValidationSchema=function(values){return new Promise(function(resolve){var validationSchema=_this.props.validationSchema;var schema=isFunction(validationSchema)?validationSchema():validationSchema;validateYupSchema(values,schema).then(function(){resolve({});},function(err){resolve(yupToFormErrors(err));});});};_this.runValidations=function(values){if(values===void 0){values=_this.state.values;}_this.setState({isValidating:true});return Promise.all([_this.runFieldLevelValidations(values),_this.props.validationSchema?_this.runValidationSchema(values):{},_this.props.validate?_this.runValidateHandler(values):{}]).then(function(_a2){var fieldErrors=_a2[0],schemaErrors=_a2[1],handlerErrors=_a2[2];var combinedErrors=deepmerge_1.all([fieldErrors,schemaErrors,handlerErrors]);if(_this.didMount){_this.setState({isValidating:false,errors:combinedErrors});}return combinedErrors;});};_this.handleChange=function(eventOrPath){var executeChange=function executeChange(eventOrTextValue,maybePath){var field=maybePath;var val=eventOrTextValue;var parsed;if(!isString(eventOrTextValue)){if(eventOrTextValue.persist){eventOrTextValue.persist();}var _a2=eventOrTextValue.target,type=_a2.type,name_1=_a2.name,id=_a2.id,value=_a2.value,checked=_a2.checked,outerHTML=_a2.outerHTML;field=maybePath?maybePath:name_1?name_1:id;if(!field&&false){warnAboutMissingIdentifier({htmlContent:outerHTML,documentationAnchorLink:"handlechange-e-reactchangeeventany--void",handlerName:"handleChange"});}val=/number|range/.test(type)?(parsed=parseFloat(value),isNaN$1(parsed)?"":parsed):/checkbox/.test(type)?checked:value;}if(field){_this.setState(function(prevState){return _assign({},prevState,{values:setIn(prevState.values,field,val)});});if(_this.props.validateOnChange){_this.runValidations(setIn(_this.state.values,field,val));}}};if(isString(eventOrPath)){return isFunction(_this.hcCache[eventOrPath])?_this.hcCache[eventOrPath]:_this.hcCache[eventOrPath]=function(event){return executeChange(event,eventOrPath);};}else{executeChange(eventOrPath);}};_this.setFieldValue=function(field,value,shouldValidate){if(shouldValidate===void 0){shouldValidate=true;}_this.setState(function(prevState){return _assign({},prevState,{values:setIn(prevState.values,field,value)});},function(){if(_this.props.validateOnChange&&shouldValidate){_this.runValidations(_this.state.values);}});};_this.handleSubmit=function(e2){if(e2&&e2.preventDefault){e2.preventDefault();}_this.submitForm();};_this.submitForm=function(){_this.setState(function(prevState){return{touched:setNestedObjectValues(prevState.values,true),isSubmitting:true,submitCount:prevState.submitCount+1};});return _this.runValidations().then(function(combinedErrors){var isValid=Object.keys(combinedErrors).length===0;if(isValid){_this.executeSubmit();}else{_this.setState({isSubmitting:false});}});};_this.executeSubmit=function(){_this.props.onSubmit(_this.state.values,_this.getFormikActions());};_this.handleBlur=function(eventOrString){var executeBlur=function executeBlur(e2,path){if(e2.persist){e2.persist();}var _a2=e2.target,name=_a2.name,id=_a2.id,outerHTML=_a2.outerHTML;var field=path?path:name?name:id;if(!field&&false){warnAboutMissingIdentifier({htmlContent:outerHTML,documentationAnchorLink:"handleblur-e-any--void",handlerName:"handleBlur"});}_this.setState(function(prevState){return{touched:setIn(prevState.touched,field,true)};});if(_this.props.validateOnBlur){_this.runValidations(_this.state.values);}};if(isString(eventOrString)){return isFunction(_this.hbCache[eventOrString])?_this.hbCache[eventOrString]:_this.hbCache[eventOrString]=function(event){return executeBlur(event,eventOrString);};}else{executeBlur(eventOrString);}};_this.setFieldTouched=function(field,touched,shouldValidate){if(touched===void 0){touched=true;}if(shouldValidate===void 0){shouldValidate=true;}_this.setState(function(prevState){return _assign({},prevState,{touched:setIn(prevState.touched,field,touched)});},function(){if(_this.props.validateOnBlur&&shouldValidate){_this.runValidations(_this.state.values);}});};_this.setFieldError=function(field,message){_this.setState(function(prevState){return _assign({},prevState,{errors:setIn(prevState.errors,field,message)});});};_this.resetForm=function(nextValues){var values=nextValues?nextValues:_this.props.initialValues;_this.initialValues=values;_this.setState({isSubmitting:false,isValidating:false,errors:{},touched:{},error:void 0,status:void 0,values:values,submitCount:0});};_this.handleReset=function(){if(_this.props.onReset){var maybePromisedOnReset=_this.props.onReset(_this.state.values,_this.getFormikActions());if(isPromise(maybePromisedOnReset)){maybePromisedOnReset.then(_this.resetForm);}else{_this.resetForm();}}else{_this.resetForm();}};_this.setFormikState=function(s,callback){return _this.setState(s,callback);};_this.getFormikActions=function(){return{resetForm:_this.resetForm,submitForm:_this.submitForm,validateForm:_this.runValidations,validateField:_this.validateField,setError:_this.setError,setErrors:_this.setErrors,setFieldError:_this.setFieldError,setFieldTouched:_this.setFieldTouched,setFieldValue:_this.setFieldValue,setStatus:_this.setStatus,setSubmitting:_this.setSubmitting,setTouched:_this.setTouched,setValues:_this.setValues,setFormikState:_this.setFormikState};};_this.getFormikComputedProps=function(){var isInitialValid=_this.props.isInitialValid;var dirty=!reactFastCompare(_this.initialValues,_this.state.values);return{dirty:dirty,isValid:dirty?_this.state.errors&&Object.keys(_this.state.errors).length===0:isInitialValid!==false&&isFunction(isInitialValid)?isInitialValid(_this.props):isInitialValid,initialValues:_this.initialValues};};_this.getFormikBag=function(){return _assign({},_this.state,_this.getFormikActions(),_this.getFormikComputedProps(),{registerField:_this.registerField,unregisterField:_this.unregisterField,handleBlur:_this.handleBlur,handleChange:_this.handleChange,handleReset:_this.handleReset,handleSubmit:_this.handleSubmit,validateOnChange:_this.props.validateOnChange,validateOnBlur:_this.props.validateOnBlur});};_this.getFormikContext=function(){return _assign({},_this.getFormikBag(),{validationSchema:_this.props.validationSchema,validate:_this.props.validate});};_this.state={values:props.initialValues||{},errors:{},touched:{},isSubmitting:false,isValidating:false,submitCount:0};_this.didMount=false;_this.fields={};_this.initialValues=props.initialValues||{};browser(!(props.component&&props.render));browser(!(props.component&&props.children&&!isEmptyChildren(props.children)));browser(!(props.render&&props.children&&!isEmptyChildren(props.children)));return _this;}Formik2.prototype.componentDidMount=function(){this.didMount=true;};Formik2.prototype.componentWillUnmount=function(){this.didMount=false;};Formik2.prototype.componentDidUpdate=function(prevProps){if(this.props.enableReinitialize&&!reactFastCompare(prevProps.initialValues,this.props.initialValues)){this.initialValues=this.props.initialValues;this.resetForm(this.props.initialValues);}};Formik2.prototype.runFieldLevelValidations=function(values){var _this=this;var fieldKeysWithValidation=Object.keys(this.fields).filter(function(f2){return _this.fields&&_this.fields[f2]&&_this.fields[f2].validate&&isFunction(_this.fields[f2].validate);});var fieldValidations=fieldKeysWithValidation.length>0?fieldKeysWithValidation.map(function(f2){return _this.runSingleFieldLevelValidation(f2,getIn(values,f2)).then(function(x){return x;},function(e2){return e2;});}):[Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];return Promise.all(fieldValidations).then(function(fieldErrorsList){return fieldErrorsList.reduce(function(prev,curr,index2){if(curr==="DO_NOT_DELETE_YOU_WILL_BE_FIRED"){return prev;}if(!!curr){prev=setIn(prev,fieldKeysWithValidation[index2],curr);}return prev;},{});});};Formik2.prototype.runValidateHandler=function(values){var _this=this;return new Promise(function(resolve){var maybePromisedErrors=_this.props.validate(values);if(maybePromisedErrors===void 0){resolve({});}else if(isPromise(maybePromisedErrors)){maybePromisedErrors.then(function(){resolve({});},function(errors){resolve(errors);});}else{resolve(maybePromisedErrors);}});};Formik2.prototype.render=function(){var _a2=this.props,component=_a2.component,render3=_a2.render,children=_a2.children;var props=this.getFormikBag();var ctx=this.getFormikContext();return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormikProvider,{value:ctx},component?Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component,props):render3?render3(props):children?typeof children==="function"?children(props):!isEmptyChildren(children)?__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children):null:null);};Formik2.defaultProps={validateOnChange:true,validateOnBlur:true,isInitialValid:false,enableReinitialize:false};return Formik2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function warnAboutMissingIdentifier(_a2){var htmlContent=_a2.htmlContent,documentationAnchorLink=_a2.documentationAnchorLink,handlerName=_a2.handlerName;console.error("Warning: Formik called `"+handlerName+"`, but you forgot to pass an `id` or `name` attribute to your input:\n\n    "+htmlContent+"\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#"+documentationAnchorLink+"\n  ");}function yupToFormErrors(yupError){var errors={};for(var _i=0,_a2=yupError.inner;_i<_a2.length;_i++){var err=_a2[_i];if(!errors[err.path]){errors=setIn(errors,err.path,err.message);}}return errors;}function validateYupSchema(values,schema,sync,context){if(sync===void 0){sync=false;}if(context===void 0){context={};}var validateData={};for(var k2 in values){if(values.hasOwnProperty(k2)){var key2=String(k2);validateData[key2]=values[key2]!==""?values[key2]:void 0;}}return schema[sync?"validateSync":"validate"](validateData,{abortEarly:false,context:context});}var FieldInner=function(_super){__extends(FieldInner2,_super);function FieldInner2(props){var _this=_super.call(this,props)||this;_this.handleChange=function(e2){var _a2=_this.props.formik,handleChange=_a2.handleChange,validateOnChange=_a2.validateOnChange;handleChange(e2);if(!!validateOnChange&&!!_this.props.validate){_this.runFieldValidations(e2.target.value);}};_this.handleBlur=function(e2){var _a2=_this.props.formik,handleBlur=_a2.handleBlur,validateOnBlur=_a2.validateOnBlur;handleBlur(e2);if(!!validateOnBlur&&!!_this.props.validate){_this.runFieldValidations(e2.target.value);}};_this.runFieldValidations=function(value){var setFieldError=_this.props.formik.setFieldError;var _a2=_this.props,name=_a2.name,validate=_a2.validate;var maybePromise=validate(value);if(isPromise(maybePromise)){maybePromise.then(function(){return setFieldError(name,void 0);},function(error){return setFieldError(name,error);});}else{setFieldError(name,maybePromise);}};var render3=props.render,children=props.children;props.component;var formik=props.formik;browser(!(render3&&children&&!isEmptyChildren(children)));formik.registerField(props.name,{validate:props.validate});return _this;}FieldInner2.prototype.componentDidUpdate=function(prevProps){if(this.props.name!==prevProps.name){this.props.formik.unregisterField(prevProps.name);this.props.formik.registerField(this.props.name,{validate:this.props.validate});}if(this.props.validate!==prevProps.validate){this.props.formik.registerField(this.props.name,{validate:this.props.validate});}};FieldInner2.prototype.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name);};FieldInner2.prototype.render=function(){var _a2=this.props,validate=_a2.validate,name=_a2.name,render3=_a2.render,children=_a2.children,_b=_a2.component,component=_b===void 0?"input":_b,formik=_a2.formik,props=__rest(_a2,["validate","name","render","children","component","formik"]);formik.validate;formik.validationSchema;var restOfFormik=__rest(formik,["validate","validationSchema"]);var field={value:props.type==="radio"||props.type==="checkbox"?props.value:getIn(formik.values,name),name:name,onChange:validate?this.handleChange:formik.handleChange,onBlur:validate?this.handleBlur:formik.handleBlur};var bag={field:field,form:restOfFormik};if(render3){return render3(bag);}if(isFunction(children)){return children(bag);}if(typeof component==="string"){var innerRef=props.innerRef,rest=__rest(props,["innerRef"]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component,_assign({ref:innerRef},field,rest,{children:children}));}return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component,_assign({},bag,props,{children:children}));};return FieldInner2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Field$1=connect(FieldInner);var Form$1=connect(function(_a2){var handleSubmit=_a2.formik.handleSubmit,props=__rest(_a2,["formik"]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("form",_assign({onSubmit:handleSubmit},props));});Form$1.displayName="Form";var move=function move(array,from,to){var copy=(array||[]).slice();var value=copy[from];copy.splice(from,1);copy.splice(to,0,value);return copy;};var swap=function swap(array,indexA,indexB){var copy=(array||[]).slice();var a=copy[indexA];copy[indexA]=copy[indexB];copy[indexB]=a;return copy;};var insert=function insert(array,index2,value){var copy=(array||[]).slice();copy.splice(index2,0,value);return copy;};var replace=function replace(array,index2,value){var copy=(array||[]).slice();copy[index2]=value;return copy;};var FieldArrayInner=function(_super){__extends(FieldArrayInner2,_super);function FieldArrayInner2(props){var _this=_super.call(this,props)||this;_this.updateArrayField=function(fn2,alterTouched,alterErrors){var _a2=_this.props,name=_a2.name,validateOnChange=_a2.validateOnChange,_b=_a2.formik,setFormikState=_b.setFormikState,validateForm=_b.validateForm,values=_b.values,touched=_b.touched,errors=_b.errors;setFormikState(function(prevState){return _assign({},prevState,{values:setIn(prevState.values,name,fn2(getIn(values,name))),errors:alterErrors?setIn(prevState.errors,name,fn2(getIn(errors,name))):prevState.errors,touched:alterTouched?setIn(prevState.touched,name,fn2(getIn(touched,name))):prevState.touched});},function(){if(validateOnChange){validateForm();}});};_this.push=function(value){return _this.updateArrayField(function(array){return(array||[]).concat([value]);},false,false);};_this.handlePush=function(value){return function(){return _this.push(value);};};_this.swap=function(indexA,indexB){return _this.updateArrayField(function(array){return swap(array,indexA,indexB);},false,false);};_this.handleSwap=function(indexA,indexB){return function(){return _this.swap(indexA,indexB);};};_this.move=function(from,to){return _this.updateArrayField(function(array){return move(array,from,to);},false,false);};_this.handleMove=function(from,to){return function(){return _this.move(from,to);};};_this.insert=function(index2,value){return _this.updateArrayField(function(array){return insert(array,index2,value);},false,false);};_this.handleInsert=function(index2,value){return function(){return _this.insert(index2,value);};};_this.replace=function(index2,value){return _this.updateArrayField(function(array){return replace(array,index2,value);},false,false);};_this.handleReplace=function(index2,value){return function(){return _this.replace(index2,value);};};_this.unshift=function(value){var arr=[];_this.updateArrayField(function(array){arr=array?[value].concat(array):[value];return arr;},false,false);return arr.length;};_this.handleUnshift=function(value){return function(){return _this.unshift(value);};};_this.handleRemove=function(index2){return function(){return _this.remove(index2);};};_this.handlePop=function(){return function(){return _this.pop();};};_this.remove=_this.remove.bind(_this);_this.pop=_this.pop.bind(_this);return _this;}FieldArrayInner2.prototype.remove=function(index2){var result;this.updateArrayField(function(array){var copy=array?array.slice():[];if(!result){result=copy[index2];}if(isFunction(copy.splice)){copy.splice(index2,1);}return copy;},true,true);return result;};FieldArrayInner2.prototype.pop=function(){var result;this.updateArrayField(function(array){var tmp=array;if(!result){result=tmp&&tmp.pop&&tmp.pop();}return tmp;},true,true);return result;};FieldArrayInner2.prototype.render=function(){var arrayHelpers={push:this.push,pop:this.pop,swap:this.swap,move:this.move,insert:this.insert,replace:this.replace,unshift:this.unshift,remove:this.remove,handlePush:this.handlePush,handlePop:this.handlePop,handleSwap:this.handleSwap,handleMove:this.handleMove,handleInsert:this.handleInsert,handleReplace:this.handleReplace,handleUnshift:this.handleUnshift,handleRemove:this.handleRemove};var _a2=this.props,component=_a2.component,render3=_a2.render,children=_a2.children,name=_a2.name,_b=_a2.formik;_b.validate;_b.validationSchema;var restOfFormik=__rest(_b,["validate","validationSchema"]);var props=_assign({},arrayHelpers,{form:restOfFormik,name:name});return component?Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component,props):render3?render3(props):children?typeof children==="function"?children(props):!isEmptyChildren(children)?__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children):null:null;};FieldArrayInner2.defaultProps={validateOnChange:true};return FieldArrayInner2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);connect(FieldArrayInner);function isEqualExceptForKey(a,b2,path){return reactFastCompare(setIn(a,path,void 0),setIn(b2,path,void 0));}var FastFieldInner=function(_super){__extends(FastFieldInner2,_super);function FastFieldInner2(props){var _this=_super.call(this,props)||this;_this.handleChange=function(e2){e2.persist();var _a2=_this.props.formik,validateOnChange=_a2.validateOnChange,validate=_a2.validate,values=_a2.values,validationSchema=_a2.validationSchema,errors=_a2.errors,setFormikState=_a2.setFormikState;var _b=e2.target,type=_b.type,value=_b.value,checked=_b.checked;var val=/number|range/.test(type)?parseFloat(value):/checkbox/.test(type)?checked:value;if(validateOnChange){if(_this.props.validate){var maybePromise=_this.props.validate(value);if(isPromise(maybePromise)){_this.setState({value:val});maybePromise.then(function(){return _this.setState({error:void 0});},function(error){return _this.setState({error:error});});}else{_this.setState({value:val,error:maybePromise});}}else if(validate){var maybePromise_1=validate(setIn(values,_this.props.name,val));if(isPromise(maybePromise_1)){_this.setState({value:val});maybePromise_1.then(function(){return _this.setState({error:void 0});},function(error){if(isEqualExceptForKey(maybePromise_1,errors,_this.props.name)){_this.setState({error:getIn(error,_this.props.name)});}else{setFormikState(function(prevState){return _assign({},prevState,{errors:error});});}});}else{if(isEqualExceptForKey(maybePromise_1,errors,_this.props.name)){_this.setState({value:val,error:getIn(maybePromise_1,_this.props.name)});}else{_this.setState({value:val});setFormikState(function(prevState){return _assign({},prevState,{errors:maybePromise_1});});}}}else if(validationSchema){var schema=isFunction(validationSchema)?validationSchema():validationSchema;var mergedValues=setIn(values,_this.props.name,val);try{validateYupSchema(mergedValues,schema,true);_this.setState({value:val,error:void 0});}catch(e3){if(e3.name==="ValidationError"){_this.setState({value:val,error:getIn(yupToFormErrors(e3),_this.props.name)});}else{_this.setState({value:val});validateYupSchema(mergedValues,schema).then(function(){return _this.setState({error:void 0});},function(err){return _this.setState(function(s){return _assign({},s,{error:getIn(yupToFormErrors(err),_this.props.name)});});});}}}else{_this.setState({value:val});}}else{_this.setState({value:val});}};_this.handleBlur=function(){var _a2=_this.props.formik,validateOnBlur=_a2.validateOnBlur,setFormikState=_a2.setFormikState;var _b=_this.props,name=_b.name,validate=_b.validate;if(validateOnBlur&&validate){var maybePromise_2=validate(_this.state.value);if(isPromise(maybePromise_2)){maybePromise_2.then(function(){return setFormikState(function(prevState){return _assign({},prevState,{values:setIn(prevState.values,name,_this.state.value),errors:setIn(prevState.errors,name,void 0),touched:setIn(prevState.touched,name,true)});});},function(error){return setFormikState(function(prevState){return _assign({},prevState,{values:setIn(prevState.values,name,_this.state.value),errors:setIn(prevState.errors,name,error),touched:setIn(prevState.touched,name,true)});});});}else{setFormikState(function(prevState){return _assign({},prevState,{values:setIn(prevState.values,name,_this.state.value),errors:setIn(prevState.errors,name,maybePromise_2),touched:setIn(prevState.touched,name,true)});});}}else{setFormikState(function(prevState){return _assign({},prevState,{errors:setIn(prevState.errors,name,_this.state.error),values:setIn(prevState.values,name,_this.state.value),touched:setIn(prevState.touched,name,true)});});}};_this.state={value:getIn(props.formik.values,props.name),error:getIn(props.formik.errors,props.name)};var render3=props.render,children=props.children;props.component;var formik=props.formik;browser(!(props.component&&children&&isFunction(children)));browser(!(render3&&children&&!isEmptyChildren(children)));formik.registerField(props.name,{validate:props.validate});return _this;}FastFieldInner2.prototype.componentDidUpdate=function(prevProps,_state){var nextFieldValue=getIn(this.props.formik.values,this.props.name);var nextFieldError=getIn(this.props.formik.errors,this.props.name);var prevFieldValue=getIn(prevProps.formik.values,prevProps.name);var prevFieldError=getIn(prevProps.formik.errors,prevProps.name);if(!reactFastCompare(nextFieldValue,prevFieldValue)){this.setState({value:nextFieldValue});}if(!reactFastCompare(nextFieldError,prevFieldError)){this.setState({error:nextFieldError});}if(this.props.name!==prevProps.name){this.props.formik.unregisterField(prevProps.name);this.props.formik.registerField(this.props.name,{validate:this.props.validate});}if(this.props.validate!==prevProps.validate){this.props.formik.registerField(this.props.name,{validate:this.props.validate});}};FastFieldInner2.prototype.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name);};FastFieldInner2.prototype.render=function(){var _a2=this.props;_a2.validate;var name=_a2.name,render3=_a2.render,children=_a2.children,_b=_a2.component,component=_b===void 0?"input":_b,formik=_a2.formik,props=__rest(_a2,["validate","name","render","children","component","formik"]);formik.validate;formik.validationSchema;var restOfFormik=__rest(formik,["validate","validationSchema"]);var field={value:props.type==="radio"||props.type==="checkbox"?props.value:this.state.value,name:name,onChange:this.handleChange,onBlur:this.handleBlur};var bag={field:field,form:restOfFormik,meta:{touched:getIn(formik.touched,name),error:this.state.error}};if(render3){return render3(bag);}if(isFunction(children)){return children(bag);}if(typeof component==="string"){var innerRef=props.innerRef,rest=__rest(props,["innerRef"]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component,_assign({ref:innerRef},field,rest,{children:children}));}return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component,_assign({},bag,props,{children:children}));};return FastFieldInner2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);connect(FastFieldInner);var Actions=function Actions(_ref91){var children=_ref91.children,_ref91$formik=_ref91.formik,handleReset=_ref91$formik.handleReset,submitForm=_ref91$formik.submitForm;return children({reset:handleReset,submit:submitForm});};var Actions$1=connect(Actions);var FormAlert=/* @__PURE__ */createStyled(Alert,{target:"e9da2b30"})("margin-top:",spacer(4),";margin-bottom:",spacer(4),";& + &{margin-top:0;}");FormAlert.displayName="Form.FormAlert";var Errors=function Errors(_ref92){var errors=_ref92.formik.errors,name=_ref92.name;if(name){return errors[name]?/* @__PURE__ */jsx(FormAlert,{kind:"error",message:errors[name]}):null;}return Array.isArray(errors.form)?errors.form.map(function(message,idx){return/* @__PURE__ */jsx(FormAlert,{kind:"error",message:message},idx);}):errors.form?/* @__PURE__ */jsx(FormAlert,{kind:"error",message:errors.form}):null;};var Errors$1=connect(Errors);var FieldAlert=/* @__PURE__ */createStyled(Alert,{target:"e1jlgw2w0"})("margin-top:",spacer(2),";");FieldAlert.displayName="Form.FieldAlert";var Field=function Field(_ref93){var name=_ref93.name,render3=_ref93.render;return/* @__PURE__ */jsx(Field$1,{name:name,render:function render(_ref94){var field=_ref94.field,_ref94$form=_ref94.form,errors=_ref94$form.errors,setFieldError=_ref94$form.setFieldError,setFieldValue=_ref94$form.setFieldValue,values=_ref94$form.values;return render3(__spreadProps(__spreadValues({},field),{form:{values:values},setFieldError:setFieldError,setValue:function setValue(value){return setFieldValue(name,value);},error:errors[field.name],valid:!errors[field.name],renderError:function renderError(){return errors[field.name]?/* @__PURE__ */jsx(FieldAlert,{kind:"error",message:errors[field.name]}):null;}}));}});};var hover=function hover(theme){return"\n  && {\n    border-color: ".concat(style("uploader.hoverBorder",{theme:theme}),";\n    background-color: ").concat(style("uploader.hoverBackground",{theme:theme}),";\n  }\n");};var disabledStyle=function disabledStyle(theme){return"\n  && {\n    border-color: ".concat(color("paleGrey",{theme:theme}),";\n    background-color: ").concat(color("offWhite",{theme:theme}),";\n    color: ").concat(color("silver",{theme:theme}),";\n    cursor: not-allowed;\n  }\n");};var valid=function valid(_ref95){var valid2=_ref95.valid,theme=_ref95.theme;return valid2||"\n    && {\n      border-color: ".concat(color("red",{theme:theme}),";\n      background-color: ").concat(transparentize("lightRed",0.5,{theme:theme}),";\n    }\n  ");};var Dropzone=/* @__PURE__ */createStyled(__WEBPACK_IMPORTED_MODULE_5_react_dropzone__["a" /* default */],{shouldForwardProp:function shouldForwardProp(prop2){return["valid","height"].indexOf(prop2)===-1;},target:"e1n3t1f00"})("display:flex;flex-direction:column;align-items:center;justify-content:center;color:",color("pewter"),";border:2px dashed ",color("silver"),";cursor:pointer;height:",prop("height"),";width:100%;overflow:hidden;padding:",spacer(4)," 0;text-align:center;transition:all 0.3s cubic-bezier(0.25,0.8,0.25,1);",borderRadius$1("default"),";",valid,";&:hover{",function(_ref96){var disabled=_ref96.disabled,theme=_ref96.theme;return disabled||hover(theme);},";}");var DropLabel=createStyled("div",{target:"e1n3t1f01"})(typography$1("body2Medium"),";margin-top:",spacer(2),";margin-bottom:",spacer(2),";");var SubLabel=createStyled("div",{target:"e1n3t1f02"})(typography$1("body1Medium"),";",SecondaryLink,"{",typography$1("body1Medium"),";}");var Uploader=function Uploader(_ref97){var accept=_ref97.accept,disabled=_ref97.disabled,height=_ref97.height,multiple=_ref97.multiple,name=_ref97.name,onChange=_ref97.onChange,theme=_ref97.theme,valid2=_ref97.valid,value=_ref97.value,label=_ref97.label,subLabel=_ref97.subLabel;var files=Array.isArray(value)?value:[value].filter(Boolean);return/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["a" /* ClassNames */],{children:function children(_ref98){var css2=_ref98.css;return/* @__PURE__ */jsx(Dropzone,{accept:accept,activeClassName:css2(hover(theme)),disabledClassName:css2(disabledStyle(theme)),height:height,multiple:multiple,name:name,disabled:disabled,onDrop:function onDrop(files2){return multiple?onChange(files2):onChange(files2[0]);},valid:valid2,children:files.length>0?/* @__PURE__ */jsx(DropLabel,{children:files.map(prop("name")).join(", ")}):/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx(Upload,{size:"1.5rem",color:disabled?"silver":"pewter"}),/* @__PURE__ */jsx(DropLabel,{children:label||"Drag and Drop ".concat(multiple?"files":"a file"," here")}),/* @__PURE__ */jsx(SubLabel,{children:subLabel||/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:["or ",/* @__PURE__ */jsx(SecondaryLink,{external:true,disabled:disabled,children:"Browse"})]})})]})});}});};Uploader.defaultProps={multiple:false,onChange:function onChange(){},valid:true};var Uploader$1=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(Uploader);var composeHandlers=function composeHandlers(){for(var _len0=arguments.length,fns=new Array(_len0),_key0=0;_key0<_len0;_key0++){fns[_key0]=arguments[_key0];}return function(){for(var _len1=arguments.length,args=new Array(_len1),_key1=0;_key1<_len1;_key1++){args[_key1]=arguments[_key1];}return fns.filter(Boolean).forEach(function(fn2){return fn2.apply(void 0,args);});};};var FileUpload=function FileUpload(_ga){var _ha=_ga,name=_ha.name,onChange=_ha.onChange,multiple=_ha.multiple,props=__objRest(_ha,["name","onChange","multiple"]);return/* @__PURE__ */jsx(Field,{name:name,render:function render(_ref99){var renderError=_ref99.renderError,setValue=_ref99.setValue,valid2=_ref99.valid,value=_ref99.value;return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx(Uploader$1,__spreadProps(__spreadValues({},props),{name:name,onChange:composeHandlers(setValue,onChange),valid:valid2,value:value,multiple:multiple})),renderError()]});}});};var buttons=function buttons(_ref100){var buttons2=_ref100.buttons,theme=_ref100.theme;return buttons2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("flex-direction:row;justify-content:flex-end;",Button$1," + ",Button$1,",",ButtonLink," + ",ButtonLink,",",Button$1," + ",ButtonLink,",",ButtonLink," + ",Button$1,"{margin-left:",spacer(2,{theme:theme}),";}");};var Group=createStyled("div",{target:"e1vek0r40"})("display:flex;width:100%;margin-bottom:",spacer(6),";flex-direction:column;",buttons,";&:last-of-type{margin-bottom:0;}");Group.displayName="Form.Group";var size$5=function size$5(_ref101){var size2=_ref101.size,theme=_ref101.theme;switch(size2){case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xs",{theme:theme}),";",fontSize("s",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xxs",{theme:theme}),";",fontSize("xs",{theme:theme}),";");}};var Input$1=createStyled("input",{target:"ecq071p0"})("display:",function(_ref102){var inline=_ref102.inline;return inline?"inline-block":"block";},";width:auto;background-clip:padding-box;transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;color:",color("black"),";background-color:",color("white"),";",borderRadius$1("default"),";",size$5,";&:disabled{border-color:",color("paleGrey"),";background-color:",color("offWhite"),";cursor:not-allowed;}",function(_ref103){var valid2=_ref103.valid,theme=_ref103.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border:1px solid ",style("input.".concat(valid2?"valid":"invalid",".border"),{theme:theme}),";&:focus{outline:0;border-color:",style("input.".concat(valid2?"valid":"invalid",".focusBorder"),{theme:theme}),";}");},";");Input$1.defaultProps={valid:true,inline:false};var FormInput=function FormInput(_ia){var _ja=_ia,type=_ja.type,label=_ja.label,name=_ja.name,_onChange=_ja.onChange,onBlur=_ja.onBlur,formatValue=_ja.formatValue,props=__objRest(_ja,["type","label","name","onChange","onBlur","formatValue"]);return/* @__PURE__ */jsx(Field,{name:name,render:function render(_a2){var _b=_a2,fieldOnBlur=_b.onBlur,fieldOnChange=_b.onChange,renderError=_b.renderError,setValue=_b.setValue,valid2=_b.valid,_=_b.form,field=__objRest(_b,["onBlur","onChange","renderError","setValue","valid","form"]);return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[type==="checkbox"?/* @__PURE__ */jsx(Checkbox$1,__spreadProps(__spreadValues(__spreadValues({},props),field),{onBlur:composeHandlers(fieldOnBlur,onBlur),onChange:composeHandlers(fieldOnChange,_onChange),id:field.name,label:label,checked:field.value,valid:valid2})):/* @__PURE__ */jsx(Input$1,__spreadProps(__spreadValues(__spreadValues({},props),field),{onBlur:composeHandlers(fieldOnBlur,onBlur),onChange:function onChange(e2){_onChange&&_onChange(e2);formatValue?setValue(formatValue(e2.target.value)):fieldOnChange(e2);},type:type,valid:valid2})),renderError()]});}});};FormInput.displayName="Form.Input";var Select=function Select(_ka){var _la=_ka,name=_la.name,onChange=_la.onChange,props=__objRest(_la,["name","onChange"]);return/* @__PURE__ */jsx(Field,{name:name,render:function render(_ref104){var renderError=_ref104.renderError,setValue=_ref104.setValue,valid2=_ref104.valid,value=_ref104.value;return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx(Dropdown,__spreadProps(__spreadValues({},props),{name:name,onChange:composeHandlers(setValue,onChange),valid:valid2,value:value})),renderError()]});}});};Select.Option=Dropdown.Option;var SubmitButton=function SubmitButton(_ma){var _na=_ma,isSubmitting=_na.formik.isSubmitting,props=__objRest(_na,["formik"]);return/* @__PURE__ */jsx(Button$1,__spreadProps(__spreadValues({},props),{disabled:isSubmitting,type:"submit"}));};SubmitButton.defaultProps={kind:"primary"};var SubmitButton$1=connect(SubmitButton);var Icon$1=createStyled("svg",{target:"ettd42n0"})("position:absolute;width:1.25rem;z-index:1;left:",function(_ref105){var left2=_ref105.left;return left2;},";");Icon$1.displayName="SwitchInput.Icon";var Cancel=function Cancel(_ref106){var disabled=_ref106.disabled,theme=_ref106.theme;return/* @__PURE__ */jsx(Icon$1,{left:"1.25rem",viewBox:"0 -3 27 27",children:/* @__PURE__ */jsx("path",{fill:color(disabled?"white":"slate",{theme:theme}),d:"M8.6,10l-3.3,3.3l1.4,1.4l3.3-3.3l3.3,3.3l1.4-1.4L11.4,10l3.3-3.3l-1.4-1.4L10,8.6L6.7,5.3L5.3,6.7L8.6,10z"})});};Cancel.displayName="SwitchInput.Cancel";var Cancel$1=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(Cancel);var Container$f=createStyled("div",{target:"e1v30lfu0"})({name:"1umqlch",styles:"position:relative;padding-left:3.375rem;height:20px;"});Container$f.displayName="SwitchInput.Container";var Checkmark=function Checkmark(_ref107){var disabled=_ref107.disabled,theme=_ref107.theme;return/* @__PURE__ */jsx(Icon$1,{left:0,viewBox:"-7 -7.5 23 23",children:/* @__PURE__ */jsx("g",{fill:"none",children:/* @__PURE__ */jsx("path",{stroke:color(disabled?"white":"silver",{theme:theme}),strokeWidth:"1.5",d:"M1.5 3.75l3 3 6-6"})})});};Checkmark.displayName="SwitchInput.Checkmark";var Checkmark$1=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(Checkmark);var Input=createStyled("input",{target:"e8qi8ky0"})({name:"w9pj7n",styles:"z-index:-1;opacity:0;position:absolute;"});Input.displayName="SwitchInput.Input";var Label$2=createStyled("label",{target:"e1y96odq0"})("margin-bottom:0;",typography$1("body2"),";",function(_ref108){var disabled=_ref108.disabled,theme=_ref108.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color(disabled?"pewter":"slate",{theme:theme}),";cursor:",disabled?"default":"pointer",";");},";&::before{content:'';width:1.25rem;height:1.25rem;border-radius:50%;user-select:none;pointer-events:none;position:absolute;left:0;z-index:2;transition:0.4s;",function(_ref109){var checked=_ref109.checked,disabled=_ref109.disabled,theme=_ref109.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",color(disabled?"offWhite":"white",{theme:theme}),";border:1px solid ",color(disabled||!checked?"silver":"slate",{theme:theme}),";transform:translateX(",checked?"1.25rem":0,");");},";}");Label$2.displayName="SwitchInput.Label";var Slider=createStyled("span",{target:"e1sdw5680"})("width:2.5rem;height:1.25rem;position:absolute;left:0;border-radius:0.825rem;transition:0.4s;",function(_ref110){var checked=_ref110.checked,disabled=_ref110.disabled,theme=_ref110.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",color(disabled?"silver":checked?"slate":"paleGrey",{theme:theme}),";border:1px solid ",color(disabled||!checked?"silver":"slate",{theme:theme}),";");},";");Slider.displayName="SwitchInput.Slider";var SwitchInput=function SwitchInput(_oa){var _pa=_oa,checked=_pa.checked,disabled=_pa.disabled,id=_pa.id,label=_pa.label,_=_pa.type,rest=__objRest(_pa,["checked","disabled","id","label","type"]);return/* @__PURE__ */jsxs(Container$f,{children:[/* @__PURE__ */jsx(Input,__spreadValues({type:"checkbox",checked:checked,disabled:disabled,id:id},rest)),/* @__PURE__ */jsxs(Label$2,{checked:checked,disabled:disabled,htmlFor:id,children:[/* @__PURE__ */jsx(Slider,{checked:checked,disabled:disabled}),/* @__PURE__ */jsx(Checkmark$1,{disabled:disabled}),/* @__PURE__ */jsx(Cancel$1,{disabled:disabled}),/* @__PURE__ */jsx("span",{children:label})]})]});};var Switch=function Switch(_qa){var _ra=_qa,label=_ra.label,name=_ra.name,onChange=_ra.onChange,_=_ra.onBlur,props=__objRest(_ra,["label","name","onChange","onBlur"]);return/* @__PURE__ */jsx(Field,{name:name,render:function render(_a2){var _b=_a2,_2=_b.onBlur,fieldOnChange=_b.onChange,renderError=_b.renderError,valid2=_b.valid,value=_b.value,field=__objRest(_b,["onBlur","onChange","renderError","valid","value"]);return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx(SwitchInput,__spreadProps(__spreadValues(__spreadValues({},props),field),{id:field.name,label:label,checked:value,valid:valid2,onChange:composeHandlers(fieldOnChange,onChange)})),renderError()]});}});};var Textarea=Input$1.withComponent("textarea",{target:"e1bspcwv0"});Textarea.defaultProps={valid:true};var FormTextarea=function FormTextarea(_sa){var _ta=_sa,name=_ta.name,onBlur=_ta.onBlur,onChange=_ta.onChange,props=__objRest(_ta,["name","onBlur","onChange"]);return/* @__PURE__ */jsx(Field,{name:name,render:function render(_a2){var _b=_a2,fieldOnBlur=_b.onBlur,fieldOnChange=_b.onChange,renderError=_b.renderError,valid2=_b.valid,field=__objRest(_b,["onBlur","onChange","renderError","valid"]);return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[/* @__PURE__ */jsx(Textarea,__spreadProps(__spreadValues(__spreadValues({},props),field),{onBlur:composeHandlers(fieldOnBlur,onBlur),onChange:composeHandlers(fieldOnChange,onChange),valid:valid2})),renderError()]});}});};var Label$1=createStyled("label",{target:"e14wxeiq0"})("display:inline-block;margin-bottom:",spacer(2),";");Label$1.displayName="Form.Label";var Title$3=createStyled("h5",{target:"e16e5j0v0"})("margin-bottom:",spacer(5),";");var Value=function Value(_ref111){var children=_ref111.children,name=_ref111.name,_ref111$formik=_ref111.formik,setFieldValue=_ref111$formik.setFieldValue,values=_ref111$formik.values;return children({value:values[name],setValue:function setValue(value){return setFieldValue(name,value);}});};var Value$1=connect(Value);var Form=function Form(_ua){var _va=_ua,children=_va.children,className=_va.className,_onSubmit=_va.onSubmit,redirect=_va.redirect,history=_va.history,serializeErrors=_va.serializeErrors,props=__objRest(_va,["children","className","onSubmit","redirect","history","serializeErrors"]);return/* @__PURE__ */jsx(Formik,__spreadProps(__spreadValues({},props),{onSubmit:function onSubmit(values,_ref112){var setSubmitting=_ref112.setSubmitting,setErrors=_ref112.setErrors;Promise.resolve(_onSubmit(values)).then(function(){redirect?history.replace(redirect):setSubmitting(false);})["catch"](function(error){setSubmitting(false);setErrors({form:serializeErrors?serializeErrors(error):error});});},render:function render(_a2){var _b=_a2,handleSubmit=_b.handleSubmit,otherFormikRenderProps=__objRest(_b,["handleSubmit"]);return/* @__PURE__ */jsx("form",{onSubmit:handleSubmit,className:className,children:typeof children==="function"?children(__spreadValues({handleSubmit:handleSubmit},otherFormikRenderProps)):children});}}));};Form.displayName="Form";Form.defaultProps={validateOnBlur:false,validateOnChange:false};Form.Actions=Actions$1;Form.Errors=Errors$1;Form.Field=Field;Form.FileUpload=FileUpload;Form.Group=Group;Form.Input=FormInput;Form.Select=Select;Form.SubmitButton=SubmitButton$1;Form.Textarea=FormTextarea;Form.Title=Title$3;Form.SwitchInput=Switch;Form.Label=Label$1;Form.Value=Value$1;var index$1=Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Form);var LogoPath=createStyled("path",{target:"eaxovec0"})("fill:",style("logoPath.fill"),";");var TextPath=createStyled("path",{target:"eo0lggr0"})("fill:",function(_ref113){var theme=_ref113.theme,dark2=_ref113.dark;return color(dark2?"white":"ink",{theme:theme});},";");var wrapDisplayName$1={};var getDisplayName$1={};getDisplayName$1.__esModule=true;var getDisplayName=function getDisplayName2(Component2){if(typeof Component2==="string"){return Component2;}if(!Component2){return void 0;}return Component2.displayName||Component2.name||"Component";};getDisplayName$1["default"]=getDisplayName;wrapDisplayName$1.__esModule=true;var _getDisplayName=getDisplayName$1;var _getDisplayName2=_interopRequireDefault$7(_getDisplayName);function _interopRequireDefault$7(obj){return obj&&obj.__esModule?obj:{"default":obj};}var wrapDisplayName=function wrapDisplayName2(BaseComponent,hocName){return hocName+"("+(0,_getDisplayName2["default"])(BaseComponent)+")";};wrapDisplayName$1["default"]=wrapDisplayName;var setDisplayName$1={};var setStatic$1={};setStatic$1.__esModule=true;var setStatic=function setStatic2(key2,value){return function(BaseComponent){BaseComponent[key2]=value;return BaseComponent;};};setStatic$1["default"]=setStatic;setDisplayName$1.__esModule=true;var _setStatic=setStatic$1;var _setStatic2=_interopRequireDefault$6(_setStatic);function _interopRequireDefault$6(obj){return obj&&obj.__esModule?obj:{"default":obj};}var setDisplayName=function setDisplayName2(displayName){return(0,_setStatic2["default"])("displayName",displayName);};setDisplayName$1["default"]=setDisplayName;var mapProps$1={};mapProps$1.__esModule=true;var _react$3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _setDisplayName$1=setDisplayName$1;_interopRequireDefault$5(_setDisplayName$1);var _wrapDisplayName$1=wrapDisplayName$1;_interopRequireDefault$5(_wrapDisplayName$1);function _interopRequireDefault$5(obj){return obj&&obj.__esModule?obj:{"default":obj};}var mapProps2=function mapProps3(propsMapper){return function(BaseComponent){var factory=(0,_react$3.createFactory)(BaseComponent);var MapProps=function MapProps2(props){return factory(propsMapper(props));};return MapProps;};};mapProps$1["default"]=mapProps2;var _extends$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _wrapDisplayName=wrapDisplayName$1;_interopRequireDefault$4(_wrapDisplayName);var _setDisplayName=setDisplayName$1;_interopRequireDefault$4(_setDisplayName);var _mapProps=mapProps$1;var _mapProps2=_interopRequireDefault$4(_mapProps);function _interopRequireDefault$4(obj){return obj&&obj.__esModule?obj:{"default":obj};}var withProps2=function withProps3(input){var hoc=(0,_mapProps2["default"])(function(props){return _extends$1({},props,typeof input==="function"?input(props):input);});return hoc;};var _default$2=withProps2;var size$4=function size$4(_ref114){var ieWidths=_ref114.ieWidths,size2=_ref114.size,oneLineHeight=_ref114.oneLineHeight;var height;switch(size2){case"sm":height="60px";break;case"lg":height="80px";break;default:height="72px";}if(oneLineHeight)height="".concat(oneLineHeight[size2||"default"],"px");return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("height:",height,";width:auto;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:",ieWidths[size2||"default"],"px;}");};var Svg$2=_default$2({xmlns:"http://www.w3.org/2000/svg"})(createStyled("svg",{target:"ey50q3l0"})(size$4,""));var DigitalDiariesLogo=function DigitalDiariesLogo(_wa){var _xa=_wa,dark2=_xa.dark,rest=__objRest(_xa,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 1585.58 204.98",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M17.34,16.83V41h68.78V16.83H17.34z M17.34,86.38h45.53v36.47h23.24v-60.4H17.34V86.38z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M260.65,55.6c-3.88-3.46-8.41-6.12-13.31-7.85c-10.44-3.63-21.79-3.63-32.23,0 c-4.91,1.71-9.42,4.38-13.28,7.85c-3.84,3.5-6.91,7.77-9,12.53c-2.27,5.23-3.41,10.89-3.32,16.6c-0.06,5.73,1.09,11.4,3.37,16.65 c2.09,4.8,5.16,9.12,9,12.68c3.86,3.53,8.37,6.28,13.28,8.08c10.4,3.83,21.83,3.83,32.23,0c4.89-1.84,9.4-4.58,13.28-8.08 c3.87-3.54,6.95-7.86,9.04-12.68c2.27-5.26,3.4-10.95,3.32-16.68c0.09-5.71-1.04-11.37-3.32-16.6 C267.6,63.35,264.51,59.09,260.65,55.6z M248.04,91.82c-0.74,2.28-1.89,4.4-3.4,6.26c-1.52,1.87-3.42,3.39-5.58,4.45 c-4.89,2.21-10.51,2.21-15.4,0c-2.16-1.06-4.06-2.58-5.58-4.45c-1.51-1.86-2.67-3.98-3.4-6.26c-1.51-4.61-1.51-9.57,0-14.18 c0.71-2.23,1.83-4.3,3.32-6.11c5.28-5.86,13.75-7.6,20.91-4.3c2.13,1.04,4.03,2.51,5.59,4.3c1.53,1.8,2.71,3.87,3.47,6.11 c0.8,2.28,1.21,4.68,1.21,7.09C249.18,87.14,248.79,89.54,248.04,91.82z M108.67,122.97H135l0.09-36.57h45.38V62.46h-45.38V40.99 h52.79V16.83h-79.21V122.97z M551.34,45.96v5.08c-5.22-3.4-11.23-5.39-17.45-5.77c-11.84-0.83-21.94,3-30.06,11.61 c-11.77,12.46-14.3,31.75-6.28,47.35c10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77L551.34,45.96z M525.54,100.38 c-5.7-4-7.91-9.7-7.69-16.42c0.31-9.26,6.59-16.24,15.78-17.34c6.59-0.73,13.15,1.67,17.71,6.49c0,7.31,0,17.53,0,23.92 C545.34,103.96,533.1,105.67,525.54,100.38z M471.68,101.79c-7.26-0.12-11.18-3.82-11.34-11c-0.15-7.07-0.06-20.66-0.06-20.66 h25.68v-24h-25.71V21.52h-25.28v24.54h-14.75v24.07h14.77c0,0,0,13.82,0,21.11c0.02,2.83,0.3,5.65,0.81,8.43 c2.26,12.93,10.93,22,23.78,24.57c9.3,1.9,20,0.3,28.92-2.8c-0.17-1.27-2.75-20.18-3.06-22.62c-4.34,1.93-9.02,2.95-13.76,3.01 L471.68,101.79z M307.41,45.99h-25.43v77h25.43v-43.4c5.93-5.78,13.73-9,26.06-9.52v-24c-11.24,0-19.35,3.59-26.06,9.36V45.99z M388.64,76.73l-14-2.35c-6.08-1.1-8-3.44-8-6.1c0-2.82,3-5.16,9.52-5.16c6.4,0,11.5,2.32,12.7,7h22.45 c-1.77-18.9-17.64-25-35.15-25c-20.13,0-33.7,9.39-33.7,25.34c0,13.3,9.21,20.65,22.16,22.84l15.29,2.66c5,0.78,8,2.66,8,5.32 c0,3.28-4.21,5.16-10.92,5.16s-12-2.25-14.11-6.83h-23c3,18,18.39,25.45,36.91,25.45c19.82,0,35.42-7.82,35.42-25.34 C412.2,86.27,402.68,79.38,388.64,76.73z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M665.87,16.77h-40.93v106.12h40.93c29.26,0,50-23.8,50-53.06S695.13,16.77,665.87,16.77z M665.87,112.89 h-30.32V26.78h30.32c23.65,0,39.72,19.25,39.72,43.05S689.52,112.89,665.87,112.89L665.87,112.89z M737.58,16.47 c-4.02,0-7.28,3.26-7.28,7.28s3.26,7.28,7.28,7.28c4.02,0,7.28-3.26,7.28-7.28C744.85,19.74,741.59,16.48,737.58,16.47 L737.58,16.47z M732.58,122.89h10v-75.8h-10V122.89z M828.99,61.95c-6.37-10.16-17.13-16.68-30.65-16.68 c-21.94,0-39.72,17.78-39.72,39.72s17.78,39.72,39.72,39.72c13.49,0,24.25-6.52,30.62-16.68v11.83c0,15.46-10.46,25.47-28,25.47 c-16.38,0-23.35-6.07-27.14-13.8l-8.79,5c5.91,11.83,18.49,18.5,35.93,18.5c19.55,0,38-12.13,38-35.17V47.09h-10L828.99,61.95z M799.13,115.01c-16.57,0.08-30.06-13.29-30.14-29.86s13.29-30.06,29.86-30.14c16.57-0.08,30.06,13.29,30.14,29.86 c0,0.05,0,0.09,0,0.14c0.23,16.33-12.82,29.77-29.16,30C799.6,115.02,799.36,115.02,799.13,115.01L799.13,115.01z M865.22,16.47 c-4.02,0-7.28,3.26-7.28,7.28s3.26,7.28,7.28,7.28c4.02,0,7.28-3.26,7.28-7.28C872.5,19.73,869.24,16.47,865.22,16.47 C865.22,16.47,865.22,16.47,865.22,16.47z M860.22,122.89h10v-75.8h-10V122.89z M909.79,25.89l-10,3v18.2h-15.92v9.71h15.92v45.93 c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7,0.6-21.83,1.67-21.83-11.37V56.8h21.83v-9.71h-21.83V25.89z M1008.94,61.95 c-6.37-10.16-17.13-16.68-30.6-16.68c-21.94,0-39.72,17.78-39.72,39.72s17.78,39.72,39.72,39.72c13.5,0,24.26-6.52,30.63-16.68 v14.86h10v-75.8h-10L1008.94,61.95z M979.07,115.01c-16.57,0.07-30.06-13.3-30.13-29.87c-0.07-16.57,13.3-30.06,29.87-30.13 s30.06,13.3,30.13,29.87c0,0.04,0,0.09,0,0.13c0.23,16.33-12.82,29.77-29.16,30C979.54,115.02,979.3,115.02,979.07,115.01z M1040.17,122.89h10V12.23h-10V122.89z M1151.74,16.77h-40.93v106.12h40.93c29.26,0,50-23.8,50-53.06S1181,16.77,1151.74,16.77z M1151.74,112.89h-30.32V26.78h30.32c23.65,0,39.72,19.25,39.72,43.05S1175.39,112.89,1151.74,112.89L1151.74,112.89z M1218.44,122.89h10v-75.8h-10V122.89z M1223.44,16.47c-4.02-0.01-7.28,3.25-7.29,7.27c-0.01,4.02,3.25,7.28,7.27,7.29 s7.28-3.25,7.29-7.27c0,0,0-0.01,0-0.01c0-4.01-3.25-7.27-7.26-7.28L1223.44,16.47z M1314.85,61.95 c-6.37-10.16-17.13-16.68-30.62-16.68c-21.94,0-39.72,17.78-39.72,39.72s17.78,39.72,39.72,39.72c13.49,0,24.25-6.52,30.62-16.68 v14.86h10v-75.8h-10V61.95z M1284.98,115.01c-16.57,0.07-30.06-13.3-30.13-29.87s13.3-30.06,29.87-30.13s30.06,13.3,30.13,29.87 c0,0.04,0,0.09,0,0.13c0.23,16.33-12.82,29.77-29.16,30c-0.23,0-0.47,0-0.7,0H1284.98z M1356.08,59.68V47.09h-10v75.8h10V80.75 c0-18.8,11.83-25.17,24-25.17v-9.7c-9.74,0-18.68,3.18-23.99,13.8H1356.08z M1393.68,122.89h10v-75.8h-10V122.89z M1398.68,16.47 c-4.02,0-7.28,3.26-7.28,7.28c0,4.02,3.26,7.28,7.28,7.28c4.02,0,7.28-3.26,7.28-7.28c0-4.02-3.25-7.27-7.27-7.28L1398.68,16.47z M1459.93,45.27c-23.5,0-39.57,17.44-39.57,39.72c0,22.89,16.37,39.72,40.32,39.72c15.32,0,27-7.12,33.36-17.43l-8.8-5.16 c-4.09,7.28-12.43,12.89-24.4,12.89c-16.07,0-28-9.55-30.17-25h66.55c0.15-1.51,0.3-3.18,0.3-4.69 c0.01-20.79-14.39-40.05-37.58-40.05L1459.93,45.27z M1430.67,80.27c2-14.85,13.34-25.31,29.26-25.31c13,0,25.16,8.64,27.28,25.31 H1430.67z M1518.34,66.95c0-8.18,8-12,15.92-12c7.28,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47 c-15.16,0-25.92,9.56-25.92,21.68c0,27.9,44.27,17.13,44.27,35.93c0,8.95-8.49,12.13-17.44,12.13c-10.16,0-18-5-20.77-12.74 l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43c16.22,0,27.44-8.94,27.44-21.83C1562.57,74.99,1518.34,85.75,1518.34,66.95z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M86.33,172.9H70.31l-3.83,8.67H62.6l14-31.02h3.42l14,31.02h-3.88L86.33,172.9z M84.87,169.66l-6.57-14.87 l-6.57,14.87H84.87z M132.49,153.88h-11.45v27.69h-3.6v-27.69h-11.41v-3.33h26.46V153.88z M151.47,172.04h-17.7c0.41,3.92,3.1,6.98,7.53,6.98c2.69,0,4.74-0.96,5.66-2.74h3.88 c-1.32,3.65-4.97,5.84-9.53,5.84c-6.52,0-11.04-4.88-11.04-11.13c0-6.25,4.47-11.13,10.86-11.13 C147.91,159.86,152.15,165.1,151.47,172.04z M133.81,169.57H148c-0.18-4.2-2.87-6.71-6.89-6.71 C136.91,162.87,134.31,165.83,133.81,169.57z M174.32,174.36h3.6c-0.82,4.61-4.88,7.76-9.99,7.76c-6.43,0-11.09-4.88-11.09-11.13 c0-6.25,4.65-11.13,11.09-11.13c5.11,0,9.17,3.15,9.99,7.8h-3.6c-0.64-2.78-3.1-4.61-6.39-4.61c-4.61,0-7.62,3.56-7.62,7.94 c0,4.43,3.01,7.94,7.62,7.94C171.22,178.92,173.68,177.14,174.32,174.36z M204.15,169.44v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 v-32.39h3.47v13.59c1.96-1.87,4.56-2.92,7.57-2.92C200.46,159.86,204.15,163.46,204.15,169.44z M230.89,169.44v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 V160.4h3.47v2.37c1.96-1.87,4.56-2.92,7.57-2.92C227.19,159.86,230.89,163.46,230.89,169.44z M258.89,170.99c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C254.11,159.86,258.89,164.6,258.89,170.99z M255.38,170.99c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C252.1,178.92,255.38,175.55,255.38,170.99z M268.47,149.18v32.39h-3.47v-32.39H268.47z M297.17,170.99c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C292.38,159.86,297.17,164.6,297.17,170.99z M293.65,170.99c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C290.37,178.92,293.65,175.55,293.65,170.99z M323.85,160.4v22.22c0,6.2-4.24,9.99-10.54,9.99c-5.84,0-10.04-3.28-10.77-7.98h3.56 c0.59,2.87,3.24,4.84,7.21,4.84c4.24,0,7.07-2.56,7.07-6.84v-3.97c-1.96,1.73-4.61,2.74-7.66,2.74c-6.07,0-10.67-4.84-10.67-10.67 c0-6.25,4.61-10.86,10.67-10.86c3.06,0,5.7,1,7.66,2.74v-2.19H323.85z M320.39,174.59v-7.94c-1.78-2.6-4.42-3.74-7.21-3.74 c-4.47,0-7.66,3.33-7.66,7.8c0,4.06,3.19,7.62,7.66,7.62C315.96,178.33,318.61,177.19,320.39,174.59z M353.6,160.4l-14.32,31.7h-3.7l4.43-9.81l-10.9-21.9h3.74l8.85,18.2l8.21-18.2H353.6z M394.97,170.48h3.74c-1.46,6.98-7.16,11.68-14.78,11.68c-8.94,0-16.15-6.93-16.15-16.1 c0-9.17,7.21-16.06,16.15-16.06c7.62,0,13.32,4.65,14.78,11.63h-3.74c-1.28-5.06-5.38-8.26-11.04-8.26 c-7.02,0-12.5,5.43-12.5,12.68c0,7.25,5.47,12.73,12.5,12.73C389.59,178.79,393.69,175.5,394.97,170.48z M425.94,170.99c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C421.15,159.86,425.94,164.6,425.94,170.99z M422.43,170.99c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C419.15,178.92,422.43,175.55,422.43,170.99z M466.41,169.07v12.5h-3.47v-12.5c0-4.2-2.19-6.02-5.66-6.02c-2.56,0-4.93,1.05-6.61,3.6 c0.14,0.68,0.18,1.41,0.18,2.24v12.68h-3.47v-12.68c0-4.15-2.24-5.84-5.47-5.84c-2.65,0-4.97,1.09-6.61,3.56v14.96h-3.47V160.4 h3.47v2.28c1.73-1.78,3.92-2.83,6.98-2.83c3.24,0,5.75,1.19,7.21,3.51c2.05-2.24,4.65-3.51,8.03-3.51 C462.89,159.86,466.41,163,466.41,169.07z M494.82,170.99c0,6.2-4.84,11.09-10.9,11.09c-3.01,0-5.57-1-7.44-2.74v12.82h-3.47V160.4h3.47v2.24 c1.87-1.73,4.43-2.74,7.44-2.74C489.99,159.9,494.82,164.83,494.82,170.99z M491.36,170.99c0-4.38-3.42-8.03-7.89-8.03 c-2.78,0-5.25,1.14-6.98,3.7v8.67c1.73,2.55,4.2,3.7,6.98,3.7C487.94,179.02,491.36,175.37,491.36,170.99z M521.92,160.4v21.17h-3.47v-2.19c-1.87,1.73-4.42,2.74-7.44,2.74c-6.07,0-10.9-4.93-10.9-11.13 c0-6.16,4.84-11.13,10.9-11.13c3.01,0,5.57,1,7.44,2.74v-2.19H521.92z M518.45,175.32v-8.67c-1.73-2.55-4.2-3.6-6.98-3.6 c-4.47,0-7.89,3.56-7.89,7.94s3.42,7.94,7.89,7.94C514.26,178.92,516.72,177.87,518.45,175.32z M549.52,169.44v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 V160.4h3.47v2.37c1.96-1.87,4.56-2.92,7.57-2.92C545.82,159.86,549.52,163.46,549.52,169.44z M577.48,160.4l-14.32,31.7h-3.7l4.43-9.81l-10.9-21.9h3.74l8.85,18.2l8.21-18.2H577.48z"})]}));};var DigitalInterviewsLogo=function DigitalInterviewsLogo(_ya){var _za=_ya,dark2=_za.dark,rest=__objRest(_za,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 1244 328",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M69.78,34V58.18H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M244.31,72.77A39.81,39.81,0,0,0,231,64.93a48.93,48.93,0,0,0-32.23,0,38.84,38.84,0,0,0-13.28,7.84,37.28,37.28,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.94,36.94,0,0,0,244.31,72.77ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.48h45.38v23.93H118.75l-.09,36.57H92.33ZM535,63.14v5.07a36.08,36.08,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.45c-5.7-4-7.91-9.7-7.69-16.41.31-9.27,6.59-16.25,15.78-17.35A21.17,21.17,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.14,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.45,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.61,48.61,0,0,1-.81-8.42c0-7.3,0-21.12,0-21.12l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.6.06,20.66c.16,7.23,4.08,10.94,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.38H265.64v-77h25.43Zm104.8,44.32c0,17.53-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.53-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.35-9.52,5.16s1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M212.23,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,212.23,195.39Zm120.37-7.28a7.28,7.28,0,1,0,7.27,7.28A7.28,7.28,0,0,0,332.6,188.11Zm634.28,0a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,966.88,188.11ZM183.27,241.47c0,29.26-20.77,53.06-50,53.06H92.32V188.41h40.93C162.5,188.41,183.27,212.22,183.27,241.47Zm-10.31,0c0-23.8-16.07-43.05-39.71-43.05H102.93v86.11h30.32C156.89,284.53,173,265.27,173,241.47Zm27,53.06h10v-75.8H200Zm96.41-75.8h10V291.5c0,23-18.5,35.17-38.05,35.17-17.44,0-30-6.67-35.93-18.49l8.79-5C245,310.9,252,317,268.32,317c17.58,0,28-10,28-25.47V279.68c-6.36,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.44c13.49,0,24.26,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.56,29.56,0,0,0,296.36,256.63Zm31.23,37.9h10v-75.8h-10Zm49.57-97-10,3v18.19H351.24v9.71h15.92v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.71.61-21.84,1.67-21.84-11.37V228.44H399v-9.71H377.16Zm99.15,21.22h10v75.8h-10V279.68c-6.37,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.44c13.49,0,24.25,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.57,29.57,0,0,0,476.31,256.63Zm31.23,37.9h10V183.87h-10Zm70.64,0h10.61V188.41H578.18ZM647,216.91c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C676.72,229,665.5,216.91,647,216.91Zm67.46-19.4-10,3v18.19H688.55v9.71h15.91v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44H736.3v-9.71H714.47ZM821,256.94c0,1.51-.15,3.18-.3,4.7H754.19c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C806.64,216.91,821,236.17,821,256.94Zm-10.3-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31ZM847,231.32V218.73H837v75.8h10V252.39c0-18.8,11.82-25.17,23.95-25.17v-9.7C861.22,217.52,852.27,220.71,847,231.32Zm65.64,52.75-26.53-65.34H875.47l31.08,75.8h12.12l31.08-75.8H939.14Zm49.27,10.46h10v-75.8h-10Zm103.84-37.59c0,1.51-.15,3.18-.3,4.7H998.87c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C1051.32,216.91,1065.72,236.17,1065.72,256.94Zm-10.31-5c-2.12-16.67-14.25-25.31-27.28-25.31-15.92,0-27.29,10.46-29.26,25.31Zm95.82,29.72-19.86-62.92h-10l-19.86,62.92-18.64-62.92h-10.31l23.34,75.8h10.92l19.56-61.09,19.55,61.09h10.92l23.34-75.8h-10.31Zm47.45-43.06c0-8.18,8-12,15.92-12,7.27,0,15,2.88,18.19,10.61l8.33-4.85c-4.39-9.4-14.09-15.47-26.52-15.47-15.16,0-25.93,9.56-25.93,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.43-8.94,27.43-21.83C1242.94,246.63,1198.68,257.39,1198.68,238.59Z"})]}));};var ForstaLogo=function ForstaLogo(_Aa){var _Ba=_Aa,dark2=_Ba.dark,rest=__objRest(_Ba,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 420 420",ieWidths:{sm:65,lg:80,"default":72},oneLineHeight:{sm:65,lg:80,"default":72}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M30.5,27.1L175.4,27.1 175.4,78.1 30.5,78.1z"}),/* @__PURE__ */jsx(LogoPath,{d:"M175.4,123.4L30.5 123.4 30.5 173.7 126.3 173.7 126.3 250.6 175.4 250.6z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M222.7,250.8L278.3 250.8 278.3 173.7 373.9 173.7 373.9 123.4 278.3 123.4 278.3 78.1 389.5 78.1 389.5 27.1 222.7 27.1z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M66,306.5H47l-4.5,10.3h-4.6L54.5,280h4l16.6,36.7h-4.6L66,306.5z M64.3,302.6L56.5,285l-7.8,17.6H64.3z M120.6,284H107v32.7h-4.3V284H89.3V280h31.3V284z M143,305.4h-20.9c0.5,4.6,3.7,8.3,8.9,8.3c3.2,0,5.6-1.1,6.7-3.2h4.6c-1.6,4.3-5.9,6.9-11.3,6.9 c-7.7,0-13.1-5.8-13.1-13.2c0-7.4,5.3-13.2,12.8-13.2C138.8,291,143.8,297.2,143,305.4z M122.1,302.5h16.8c-0.2-5-3.4-7.9-8.1-7.9 C125.8,294.6,122.7,298.1,122.1,302.5z M170.1,308.2h4.3c-1,5.4-5.8,9.2-11.8,9.2c-7.6,0-13.1-5.8-13.1-13.2c0-7.4,5.5-13.2,13.1-13.2 c6,0,10.8,3.7,11.8,9.2h-4.3c-0.8-3.3-3.7-5.4-7.6-5.4c-5.4,0-9,4.2-9,9.4c0,5.2,3.6,9.4,9,9.4 C166.4,313.6,169.3,311.5,170.1,308.2z M205.3,302.4v14.4h-4.1v-14.1c0-5.1-3-7.8-7.4-7.8c-3,0-6,1.5-8.2,4.3v17.6h-4.1v-38.3h4.1v16.1 c2.3-2.2,5.4-3.5,9-3.5C201,291,205.3,295.3,205.3,302.4z M236.9,302.4v14.4h-4.1v-14.1c0-5.1-3-7.8-7.4-7.8c-3,0-6,1.5-8.2,4.3v17.6h-4.1v-25h4.1v2.8 c2.3-2.2,5.4-3.5,9-3.5C232.6,291,236.9,295.3,236.9,302.4z M270.1,304.2c0,7.6-5.7,13.2-13.3,13.2c-7.7,0-13.3-5.6-13.3-13.2c0-7.6,5.7-13.2,13.3-13.2 C264.4,291,270.1,296.6,270.1,304.2z M265.9,304.2c0-5.4-3.9-9.4-9.1-9.4c-5.3,0-9.2,4-9.2,9.4c0,5.4,3.9,9.4,9.2,9.4 C262,313.6,265.9,309.6,265.9,304.2z M281.4,278.4v38.3h-4.1v-38.3H281.4z M315.3,304.2c0,7.6-5.7,13.2-13.3,13.2c-7.7,0-13.3-5.6-13.3-13.2c0-7.6,5.7-13.2,13.3-13.2 C309.7,291,315.3,296.6,315.3,304.2z M311.2,304.2c0-5.4-3.9-9.4-9.1-9.4c-5.3,0-9.2,4-9.2,9.4c0,5.4,3.9,9.4,9.2,9.4 C307.3,313.6,311.2,309.6,311.2,304.2z M346.9,291.7V318c0,7.3-5,11.8-12.5,11.8c-6.9,0-11.9-3.9-12.7-9.4h4.2c0.7,3.4,3.8,5.7,8.5,5.7 c5,0,8.4-3,8.4-8.1v-4.7c-2.3,2.1-5.4,3.2-9.1,3.2c-7.2,0-12.6-5.7-12.6-12.6c0-7.4,5.4-12.8,12.6-12.8c3.6,0,6.7,1.2,9.1,3.2v-2.6 H346.9z M342.8,308.5v-9.4c-2.1-3.1-5.2-4.4-8.5-4.4c-5.3,0-9.1,3.9-9.1,9.2c0,4.8,3.8,9,9.1,9 C337.6,312.9,340.7,311.5,342.8,308.5z M382.1,291.7l-16.9,37.5h-4.4l5.2-11.6l-12.9-25.9h4.4l10.5,21.5l9.7-21.5H382.1z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M118.2,365.4h4.4c-1.7,8.3-8.5,13.8-17.5,13.8c-10.6,0-19.1-8.2-19.1-19s8.5-19,19.1-19 c9,0,15.8,5.5,17.5,13.8h-4.4c-1.5-6-6.4-9.8-13.1-9.8c-8.3,0-14.8,6.4-14.8,15c0,8.6,6.5,15.1,14.8,15.1 C111.8,375.2,116.6,371.4,118.2,365.4z M154.8,366c0,7.6-5.7,13.2-13.3,13.2c-7.7,0-13.3-5.6-13.3-13.2s5.7-13.2,13.3-13.2 C149.1,352.8,154.8,358.5,154.8,366z M150.6,366c0-5.4-3.9-9.4-9.1-9.4c-5.3,0-9.2,4-9.2,9.4c0,5.4,3.9,9.4,9.2,9.4 C146.7,375.4,150.6,371.4,150.6,366z M202.6,363.7v14.8h-4.1v-14.8c0-5-2.6-7.1-6.7-7.1c-3,0-5.8,1.2-7.8,4.3c0.2,0.8,0.2,1.7,0.2,2.6v15h-4.1v-15 c0-4.9-2.6-6.9-6.5-6.9c-3.1,0-5.9,1.3-7.8,4.2v17.7h-4.1v-25h4.1v2.7c2-2.1,4.6-3.3,8.3-3.3c3.8,0,6.8,1.4,8.5,4.2 c2.4-2.6,5.5-4.2,9.5-4.2C198.5,352.8,202.6,356.6,202.6,363.7z M236.2,366c0,7.3-5.7,13.1-12.9,13.1c-3.6,0-6.6-1.2-8.8-3.2V391h-4.1v-37.6h4.1v2.6c2.2-2.1,5.2-3.2,8.8-3.2 C230.5,352.9,236.2,358.7,236.2,366z M232.1,366c0-5.2-4-9.5-9.3-9.5c-3.3,0-6.2,1.3-8.3,4.4v10.3c2.1,3,5,4.4,8.3,4.4 C228.1,375.5,232.1,371.2,232.1,366z M268.3,353.5v25h-4.1v-2.6c-2.2,2.1-5.2,3.2-8.8,3.2c-7.2,0-12.9-5.8-12.9-13.2c0-7.3,5.7-13.2,12.9-13.2 c3.6,0,6.6,1.2,8.8,3.2v-2.6H268.3z M264.2,371.1v-10.3c-2-3-5-4.3-8.3-4.3c-5.3,0-9.3,4.2-9.3,9.4c0,5.2,4,9.4,9.3,9.4 C259.2,375.4,262.1,374.2,264.2,371.1z M300.9,364.2v14.4h-4.1v-14.1c0-5.1-3-7.8-7.4-7.8c-3,0-6,1.5-8.2,4.3v17.6h-4.1v-25h4.1v2.8 c2.3-2.2,5.4-3.5,9-3.5C296.6,352.8,300.9,357.1,300.9,364.2z M334,353.5L317.1,391h-4.4l5.2-11.6L305,353.5h4.4l10.5,21.5l9.7-21.5H334z"})]}));};var InterVuLogo=function InterVuLogo(_Ca){var _Da=_Ca,dark2=_Da.dark,rest=__objRest(_Da,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 561 328",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.22,37.22,0,0,0-9,12.54,40.06,40.06,0,0,0-3.32,16.59,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40,40,0,0,0-3.32-16.59A36.88,36.88,0,0,0,244.31,72.77ZM231.7,109a19.42,19.42,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v24H118.75l-.09,36.56H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.62-11.77,12.45-14.3,31.75-6.28,47.34,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.71,48.71,0,0,1-.81-8.42c0-7.29,0-21.12,0-21.12l-14.77.06V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.65-3-4.54-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.33,33.7-25.33,17.51,0,33.38,6.06,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.67,1.88,5,8,6.11l14,2.34C386.34,96.56,395.86,103.44,395.87,116.9Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M92.31,188.41h10.62V294.53H92.31Zm68.83,28.5c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C190.85,229,179.63,216.91,161.14,216.91Zm67.46-19.4-10,3v18.19H202.68v9.71H218.6v45.93c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44h21.83v-9.71H228.6Zm106.58,59.43c0,1.51-.16,3.18-.31,4.7H268.32c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.41-12.89l8.79,5.16c-6.37,10.31-18,17.43-33.35,17.43-23.95,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C320.77,216.91,335.18,236.17,335.18,256.94Zm-10.31-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31Zm36.23-20.61V218.73h-10v75.8h10V252.39c0-18.8,11.83-25.17,23.95-25.17v-9.7C375.35,217.52,366.41,220.7,361.1,231.32Zm73.07,49.11-33.05-92H389.6l39.11,106.12h10.92l39.11-106.12H467.22Zm105.51-61.7v39.72c0,20.32-11.22,28.2-24.56,28.2-13.18,0-20.61-7.88-20.61-21.38V218.73h-10v46.54c0,19,11.22,31.08,29.71,31.08,10.77,0,19.56-4.09,25.47-13.64v11.82h10v-75.8Z"})]}));};var LiveVideoLogo=function LiveVideoLogo(_Ea){var _Fa=_Ea,dark2=_Fa.dark,rest=__objRest(_Fa,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 741 328",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M69.78,34V58.17H1V34ZM1,103.59H46.53v36.48H69.77V79.63H1Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.38,37.38,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.73,40.73,0,0,0,3.32,16.69,37.76,37.76,0,0,0,9,12.67,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.13,37.13,0,0,0,9.06-12.67,40.73,40.73,0,0,0,3.32-16.69,40.11,40.11,0,0,0-3.32-16.6A37,37,0,0,0,244.31,72.77ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,17.2,17.2,0,0,1-26.56,0,19.13,19.13,0,0,1-3.4-6.26,22.78,22.78,0,0,1,0-14.17,18.3,18.3,0,0,1,3.32-6.12,16.9,16.9,0,0,1,5.51-4.3,18.69,18.69,0,0,1,15.4,0,17.66,17.66,0,0,1,5.59,4.3,18.8,18.8,0,0,1,3.47,6.12,21.2,21.2,0,0,1,1.21,7.08A22.53,22.53,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.83-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.33A21.13,21.13,0,0,1,535,90.28c0,7.31,0,17.54,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.36,3.06,22.63-8.92,3.09-19.62,4.69-28.92,2.79-12.85-2.62-21.52-11.64-23.78-24.56a48.93,48.93,0,0,1-.81-8.44c0-7.29,0-21.11,0-21.11l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.06s-.09,13.58.06,20.65c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.35c6.71-5.77,14.82-9.37,26.06-9.37v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.31c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.44h23c2.13,4.57,7.39,6.82,14.11,6.82s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.66c-12.95-2.18-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.08,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.33-9.52,5.15,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M177.36,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,177.36,195.39Zm275.91-7.28a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,453.27,188.11Zm-350.34.31H92.31V294.53h59.13v-10H102.93Zm62.15,30.31h10v75.8h-10Zm85.8,0H261.5l-31.08,75.8H218.29l-31.08-75.8h10.62l26.53,65.34Zm54.73-1.81c-23.49,0-39.56,17.43-39.56,39.71,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.07,0-28-9.55-30.16-25h66.55c.15-1.52.3-3.19.3-4.7C343.21,236.17,328.81,216.92,305.61,216.92Zm-29.25,35c2-14.85,13.34-25.31,29.25-25.31,13,0,25.17,8.64,27.29,25.31Zm151.29-63.51h11.52L400.06,294.53H389.14L350,188.42h11.52l33.05,92Zm20.62,30.31h10v75.8h-10Zm96.41,14.86c-6.36-10.16-17.13-16.67-30.62-16.67a39.72,39.72,0,0,0,0,79.43c13.49,0,24.26-6.52,30.62-16.67v14.85h10V188.42h-10Zm-29.86,53.06a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,514.82,286.65Zm96.11-69.73c-23.5,0-39.56,17.43-39.56,39.71,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.07,0-28-9.55-30.17-25h66.55a46.54,46.54,0,0,0,.31-4.7C648.53,236.17,634.13,216.92,610.93,216.92Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.17,8.64,27.29,25.31Zm118.1-35a39.72,39.72,0,1,0,39.87,39.71A39.41,39.41,0,0,0,699.77,216.92Zm0,69.73a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,699.77,286.65Z"})]}));};var PanelManagementLogo=function PanelManagementLogo(_Ga){var _Ha=_Ga,dark2=_Ha.dark,rest=__objRest(_Ha,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 1441 328",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M244.31,72.78A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.86,37.24,37.24,0,0,0-9,12.52,40.17,40.17,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.53,46.53,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.9,36.9,0,0,0,244.31,72.78ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.69,16.69,0,0,1-5.58,4.45,18.69,18.69,0,0,1-15.4,0,16.67,16.67,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.44,18.44,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.8,17.8,0,0,1,5.59,4.3,19,19,0,0,1,3.47,6.11,21.3,21.3,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.09a35.77,35.77,0,0,0-17.45-5.77c-11.84-.84-21.94,3-30.06,11.6-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59ZM469.09,116c.31,2.43,2.89,21.34,3.06,22.61-8.92,3.1-19.62,4.7-28.92,2.8-12.85-2.62-21.52-11.64-23.78-24.57a48.63,48.63,0,0,1-.81-8.43c0-7.29,0-21.11,0-21.11l-14.77,0V63.24h14.75V38.7h25.28V63.24h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35.27,35.27,0,0,0,469.09,116Zm-178-43.37c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.72,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.65c-12.95-2.2-22.16-9.54-22.16-22.85,0-15.94,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.45,395.87,116.9Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M130.21,188.41H92.32V294.53h10.61V255.12h27.28c19.11,0,33.36-14.4,33.36-33.35C163.57,202.66,149.32,188.41,130.21,188.41Zm0,56.7H102.93V198.42h27.28c13.19,0,22.74,9.7,22.74,23.35C153,235.26,143.4,245.11,130.21,245.11Zm109.16-11.52c-6.37-10.16-17.14-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.63-16.67v14.85h10v-75.8h-10ZM209.5,286.65a30,30,0,1,1,29.87-30A29.57,29.57,0,0,1,209.5,286.65ZM335.78,248v46.54h-10V248c0-13.49-7.43-21.37-20.62-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.7-13.65,25.47-13.65C324.56,216.91,335.78,229,335.78,248Zm54.43-31.08c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.32,39.72,15.32,0,27-7.12,33.36-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28.05-9.55-30.17-25H427.5c.15-1.52.3-3.19.3-4.7C427.8,236.17,413.4,216.91,390.21,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.28,25.31Zm82.77-68.06h10V294.53h-10Zm154.48,4.54h13.19V294.53H600.78v-90l-37.14,62.16h-1.52L525,204.48v90H514.37V188.41h13.19l35.32,59.13Zm101.12,45.18c-6.37-10.16-17.13-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.5,0,24.26-6.52,30.63-16.67v14.85h10v-75.8h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.57,29.57,0,0,1,669.45,286.65ZM795.73,248v46.54h-10V248c0-13.49-7.43-21.37-20.62-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.71-13.65,25.47-13.65C784.51,216.91,795.73,229,795.73,248Zm84.59-14.4c-6.36-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.62-16.67v14.85h10v-75.8h-10Zm-29.86,53.06a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,850.46,286.65Zm126.28-53.06c-6.37-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.25-6.52,30.62-16.67V291.5c0,15.46-10.46,25.47-28,25.47-16.37,0-23.34-6.07-27.13-13.8l-8.79,5c5.91,11.82,18.49,18.49,35.92,18.49,19.56,0,38-12.13,38-35.17V218.73h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,946.87,286.65ZM1043,216.91c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.33,39.72,15.31,0,27-7.12,33.35-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28.05-9.55-30.17-25h66.55c.15-1.52.3-3.19.3-4.7C1080.58,236.17,1066.18,216.91,1043,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.29,25.31Zm191.92-4.7v47.3h-10v-47.3c0-13.49-7.73-20.61-18.5-20.61-11.67,0-21.07,7.12-21.07,25.92v42h-10v-47.3c0-13.49-7-20.61-17.73-20.61-10.92,0-21.83,7.12-21.83,25.92v42h-10v-75.8h10V229.8c5.91-9.25,14.1-12.89,23.19-12.89,10.61,0,18.8,5,23,13.8a27.83,27.83,0,0,1,24.56-13.8C1194,216.91,1205.65,228.28,1205.65,247.23Zm54.43-30.32c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.33,39.72,15.31,0,27-7.12,33.35-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28-9.55-30.17-25h66.55c.15-1.52.3-3.19.3-4.7C1297.67,236.17,1283.27,216.91,1260.08,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.28,25.31Zm148-3.94v46.54h-10V248c0-13.49-7.42-21.37-20.61-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.7-13.65,25.47-13.65C1367.56,216.91,1378.78,229,1378.78,248Zm37.75-19.55v45.93c0,13,7.12,12,21.83,11.37v8.79c-20.47,3-31.84-2-31.84-20.16V228.44h-15.91v-9.71h15.91V200.54l10-3v21.22h21.83v9.71Z"})]}));};var SurveysLogo=function SurveysLogo(_Ia){var _Ja=_Ia,dark2=_Ja.dark,rest=__objRest(_Ja,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 575 160",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M83.41,30.68v14.99h-44.97v-14.99h44.97ZM38.44,60.66v14.99h29.98v29.98h14.99v-44.97h-44.98Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M152.31,37.42c-4.11-3.45-9.13-5.56-15.07-6.32-1.74-.21-3.53-.33-5.39-.36-1.86-.03-3.1-.05-3.72-.05h-23.89v74.96h23.89c.62,0,1.87-.02,3.75-.05,1.87-.03,3.66-.16,5.36-.36,5.93-.76,10.96-2.87,15.07-6.33,4.11-3.45,7.23-7.85,9.34-13.2,2.12-5.34,3.18-11.19,3.18-17.54s-1.06-12.2-3.18-17.54c-2.12-5.34-5.23-9.74-9.34-13.2ZM149.96,79.4c-1.06,3.58-2.7,6.61-4.92,9.11-2.22,2.5-5.1,4.08-8.64,4.74-1.25.24-2.68.4-4.29.47s-2.94.1-3.98.1h-11.14v-51.32h11.14c1.04,0,2.37.03,3.98.08,1.61.05,3.04.22,4.29.49,3.47.66,6.33,2.2,8.56,4.63,2.24,2.43,3.89,5.43,4.97,9.01,1.08,3.57,1.61,7.39,1.61,11.45s-.53,7.67-1.59,11.24Z M214.02,51.94c-4.08-2.72-9.03-4.09-14.86-4.09-5.52,0-10.38,1.25-14.58,3.75-4.2,2.5-7.48,6.01-9.84,10.54-2.36,4.53-3.54,9.86-3.54,16.01,0,5.69,1.21,10.72,3.62,15.1,2.41,4.37,5.77,7.79,10.07,10.25,4.3,2.46,9.3,3.7,14.99,3.7s10.37-1.41,14.86-4.22c4.49-2.81,7.82-6.75,9.97-11.82l-12.39-3.75c-1.21,2.6-2.94,4.59-5.18,5.96-2.24,1.37-4.9,2.06-7.99,2.06-4.79,0-8.43-1.56-10.93-4.69-1.96-2.45-3.14-5.7-3.56-9.73h40.68c.49-6.73-.26-12.58-2.24-17.54-1.98-4.96-5.01-8.81-9.08-11.53ZM199.68,58.84c4.55,0,7.88,1.41,9.99,4.22,1.5,1.99,2.47,4.83,2.92,8.48h-27.63c.57-3.25,1.66-5.9,3.26-7.94,2.5-3.18,6.32-4.76,11.45-4.76Z M251.48,61.94c2.12-1.54,4.81-2.32,8.07-2.32,2.88,0,5.45.84,7.7,2.52,2.26,1.68,3.87,4.03,4.84,7.05l12.49-3.38c-1.35-5.55-4.24-9.93-8.67-13.14-4.42-3.21-9.83-4.81-16.21-4.81-5.69,0-10.6,1.28-14.73,3.83-4.13,2.55-7.31,6.06-9.55,10.52-2.24,4.46-3.38,9.57-3.41,15.33.03,5.66,1.14,10.72,3.31,15.2,2.17,4.48,5.3,8.01,9.4,10.59s9.04,3.88,14.83,3.88c6.28,0,11.59-1.54,15.93-4.61s7.37-7.47,9.11-13.2l-12.81-2.86c-.97,2.88-2.42,5.08-4.35,6.61-1.93,1.53-4.55,2.29-7.89,2.29-4.72,0-8.28-1.65-10.67-4.95s-3.59-7.62-3.59-12.96c0-3.44.5-6.51,1.51-9.21,1.01-2.71,2.57-4.83,4.68-6.38Z M293.37 49.42 H305.91 V105.64 H293.37 Z M293.37 29.38 H305.91 V40.88 H293.37 Z M359.13,51.74c-3.9-2.58-8.51-3.88-13.82-3.88s-9.83,1.29-13.46,3.88c-.74.53-1.44,1.11-2.11,1.72v-4.03h-11.09v81.2h12.65v-27.84c.23.17.44.35.68.51,3.71,2.6,8.31,3.9,13.79,3.9,5.17,0,9.68-1.3,13.53-3.9,3.85-2.6,6.84-6.14,8.95-10.62,2.12-4.48,3.18-9.53,3.18-15.15s-1.08-10.77-3.23-15.23c-2.15-4.46-5.18-7.98-9.08-10.57ZM356.63,86.87c-1.02,2.79-2.59,5.01-4.71,6.64-2.12,1.63-4.81,2.45-8.07,2.45s-6.08-.77-8.15-2.32-3.57-3.7-4.53-6.48c-.96-2.78-1.43-5.99-1.43-9.63s.48-6.9,1.43-9.66c.95-2.76,2.44-4.91,4.45-6.45,2.01-1.54,4.62-2.32,7.81-2.32,3.37,0,6.14.82,8.33,2.47,2.19,1.65,3.8,3.87,4.84,6.66,1.04,2.79,1.56,5.89,1.56,9.29s-.51,6.55-1.54,9.34Z M430.74,62.07c-.76-2.43-1.94-4.72-3.54-6.87-1.6-2.15-3.75-3.92-6.45-5.31-2.71-1.39-6.14-2.08-10.31-2.08-5.28,0-9.72,1.15-13.33,3.46-1.94,1.24-3.62,2.72-5.05,4.41v-25h-11.19v74.96h12.7v-28.89c0-3.44.38-6.25,1.14-8.46.76-2.2,1.78-3.94,3.05-5.21,1.27-1.27,2.68-2.16,4.24-2.68s3.14-.78,4.74-.78c2.98,0,5.35.64,7.11,1.93,1.75,1.28,3.07,2.92,3.96,4.92.88,2,1.45,4.07,1.69,6.22.24,2.15.37,4.11.37,5.88v27.07h12.7v-31.39c0-1.35-.11-3.11-.34-5.28-.23-2.17-.72-4.47-1.48-6.9Z M483.97,51.94c-4.08-2.72-9.03-4.09-14.86-4.09-5.52,0-10.38,1.25-14.58,3.75-4.2,2.5-7.48,6.01-9.84,10.54-2.36,4.53-3.54,9.86-3.54,16.01,0,5.69,1.21,10.72,3.62,15.1,2.41,4.37,5.77,7.79,10.07,10.25,4.3,2.46,9.3,3.7,14.99,3.7s10.37-1.41,14.86-4.22c4.49-2.81,7.82-6.75,9.97-11.82l-12.39-3.75c-1.21,2.6-2.94,4.59-5.18,5.96-2.24,1.37-4.9,2.06-7.99,2.06-4.79,0-8.43-1.56-10.93-4.69-1.96-2.45-3.14-5.7-3.56-9.73h40.68c.49-6.73-.26-12.58-2.24-17.54-1.98-4.96-5.01-8.81-9.08-11.53ZM469.63,58.84c4.55,0,7.88,1.41,9.99,4.22,1.5,1.99,2.47,4.83,2.92,8.48h-27.63c.57-3.25,1.66-5.9,3.26-7.94,2.5-3.18,6.32-4.76,11.45-4.76Z M531.41,49.18c-1.77.12-3.5.45-5.18.99-1.68.54-3.22,1.28-4.61,2.21-1.63,1.01-3.03,2.28-4.19,3.83-.53.7-1,1.44-1.43,2.21v-9h-11.09v56.22h12.6v-28.58c0-2.15.26-4.16.78-6.01.52-1.86,1.33-3.51,2.42-4.97,1.09-1.46,2.51-2.65,4.24-3.59,1.73-1.04,3.69-1.65,5.86-1.82,2.17-.17,4.09-.02,5.75.47v-11.71c-1.67-.28-3.38-.36-5.15-.23Z"})]}));};var VideoInsightsLogo=function VideoInsightsLogo(_Ka){var _La=_Ka,dark2=_La.dark,rest=__objRest(_La,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({viewBox:"0 0 1032 328",ieWidths:{sm:531,lg:707,"default":637}},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M1,34V58.17H69.78V34Zm0,69.59H46.53v36.47H69.77V79.62H1Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.22,37.22,0,0,0-9,12.54,40.06,40.06,0,0,0-3.32,16.59,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40,40,0,0,0-3.32-16.59A36.88,36.88,0,0,0,244.31,72.77ZM231.7,109a19.42,19.42,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,140.14h26.33l.09-36.56h45.38v-24H118.75l0-21.47h52.79V34H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.62-11.77,12.45-14.3,31.75-6.28,47.34,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59ZM455.34,119c-7.26-.12-11.18-3.82-11.34-11-.15-7.07-.06-20.66-.06-20.66l25.68-.05v-24H443.91V38.69H418.63V63.23H403.88V87.31l14.77-.06s0,13.83,0,21.12a48.71,48.71,0,0,0,.81,8.42c2.26,12.93,10.93,22,23.78,24.58,9.3,1.89,20,.29,28.92-2.81-.17-1.27-2.75-20.18-3.06-22.62A35,35,0,0,1,455.34,119ZM291.07,63.16H265.64v77h25.43V96.76C297,91,304.8,87.71,317.13,87.24v-24c-11.24,0-19.35,3.59-26.06,9.36ZM372.3,93.9l-14-2.34c-6.08-1.11-8-3.44-8-6.11,0-2.82,3-5.16,9.52-5.16,6.4,0,11.5,2.33,12.7,7l22.45,0c-1.77-18.9-17.64-25-35.15-25-20.13,0-33.7,9.38-33.7,25.33,0,13.3,9.21,20.65,22.16,22.84l15.29,2.66c5,.78,8,2.67,8,5.32,0,3.28-4.21,5.16-10.92,5.16s-12-2.25-14.11-6.83h-23c3,18,18.39,25.45,36.91,25.45,19.82,0,35.42-7.82,35.42-25.34C395.86,103.44,386.34,96.56,372.3,93.9Z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M126.27,280.43l-33-92H81.71l39.11,106.12h10.91l39.11-106.12H159.32Zm53.67,14.1h10v-75.8h-10Zm5-106.42a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,184.94,188.11Zm91.42,45.48c-6.37-10.16-17.13-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.5,0,24.26-6.52,30.63-16.68v14.86h10V188.41h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,246.49,286.65Zm96.11-69.74c-23.49,0-39.56,17.44-39.56,39.72,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.06,0-28-9.55-30.16-25H379.9c.15-1.52.3-3.19.3-4.7C380.2,236.17,365.8,216.91,342.6,216.91Zm-29.25,35c2-14.85,13.34-25.31,29.25-25.31,13,0,25.17,8.64,27.29,25.31Zm118.09-35a39.72,39.72,0,1,0,39.87,39.72A39.41,39.41,0,0,0,431.44,216.91Zm0,69.74a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,431.44,286.65Zm96,7.88H538V188.41H527.4Zm68.83-77.62c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C625.94,229,614.72,216.91,596.23,216.91Zm57,21.68c0-8.18,8-12,15.92-12,7.28,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16,0-25.92,9.56-25.92,21.68,0,27.9,44.26,17.13,44.26,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.44-8.94,27.44-21.83C697.5,246.63,653.23,257.39,653.23,238.59Zm60.19,55.94h10v-75.8h-10Zm5-106.42a7.28,7.28,0,1,0,7.28,7.28A7.29,7.29,0,0,0,718.42,188.11Zm91.41,45.48c-6.36-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.62-16.68V291.5c0,15.46-10.46,25.47-28,25.47-16.37,0-23.35-6.07-27.14-13.8l-8.79,5c5.91,11.83,18.49,18.5,35.93,18.5,19.55,0,38.05-12.13,38.05-35.17V218.73h-10ZM780,286.65a30,30,0,1,1,29.86-30A29.58,29.58,0,0,1,780,286.65Zm96.56-69.74c-10.76,0-19.55,4.1-25.46,13.65V188.41h-10V294.53h10V254.81c0-20.31,11.21-28.19,24.56-28.19,13.18,0,20.61,7.88,20.61,21.37v46.54h10V248C906.25,229,895,216.91,876.53,216.91ZM944,197.51l-10,3v18.19H918.07v9.71H934v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.71.6-21.83,1.67-21.83-11.37V228.44h21.83v-9.71H944Zm41.84,41.08c0-8.18,8-12,15.92-12,7.27,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16,0-25.93,9.56-25.93,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.43-8.94,27.43-21.83C1030.1,246.63,985.84,257.39,985.84,238.59Z"})]}));};var VIStreamlineLogo=function VIStreamlineLogo(_Ma){var _Na=_Ma,dark2=_Na.dark,rest=__objRest(_Na,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({ieWidths:{sm:531,lg:707,"default":637},viewBox:"0 0 1552.53 173"},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M1 33.45v24.17h68.78V33.45zM1 103h45.53v36.47h23.24v-60.4H1z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M244.31 72.22A40 40 0 00231 64.37a49.1 49.1 0 00-32.23 0 39 39 0 00-13.28 7.85 37.28 37.28 0 00-9 12.53 40.14 40.14 0 00-3.32 16.6 40.69 40.69 0 003.37 16.65 37.9 37.9 0 009 12.68 40.2 40.2 0 0013.28 8.08 46.68 46.68 0 0032.23 0 41.71 41.71 0 0013.28-8.08 37.27 37.27 0 009.04-12.68 40.69 40.69 0 003.32-16.68 40.11 40.11 0 00-3.32-16.6 36.94 36.94 0 00-9.06-12.5zm-12.61 36.22a19.52 19.52 0 01-3.4 6.26 16.69 16.69 0 01-5.58 4.45 18.69 18.69 0 01-15.4 0 16.67 16.67 0 01-5.58-4.45 19.23 19.23 0 01-3.4-6.26 22.81 22.81 0 010-14.18 18.34 18.34 0 013.32-6.11 18 18 0 0120.91-4.3 17.66 17.66 0 015.59 4.3 18.86 18.86 0 013.47 6.11 21.26 21.26 0 011.21 7.09 22.58 22.58 0 01-1.14 7.09zM92.33 139.59h26.33l.09-36.57h45.38V79.08h-45.38V57.61h52.79V33.45H92.33zM535 62.58v5.08a36 36 0 00-17.45-5.77c-11.84-.83-21.94 3-30.06 11.61-11.77 12.46-14.3 31.75-6.28 47.35 10.91 21.24 36.28 25.7 53.76 14.8v3.94h25.25v-77zM509.2 117c-5.7-4-7.91-9.7-7.69-16.42.31-9.26 6.59-16.24 15.78-17.34A21.17 21.17 0 01535 89.73v23.92c-6 6.93-18.24 8.64-25.8 3.35zm-53.86 1.41c-7.26-.12-11.18-3.82-11.34-11-.15-7.07-.06-20.66-.06-20.66h25.68v-24h-25.71V38.14h-25.28v24.54h-14.75v24.07h14.77v21.11a48.73 48.73 0 00.81 8.43c2.26 12.93 10.93 22 23.78 24.57 9.3 1.9 20 .3 28.92-2.8-.17-1.27-2.75-20.18-3.06-22.62a35 35 0 01-13.76 3.01zm-164.27-55.8h-25.43v77h25.43v-43.4c5.93-5.78 13.73-9 26.06-9.52v-24c-11.24 0-19.35 3.59-26.06 9.36zm81.23 30.74l-14-2.35c-6.08-1.1-8-3.44-8-6.1 0-2.82 3-5.16 9.52-5.16 6.4 0 11.5 2.32 12.7 7h22.45c-1.77-18.9-17.64-25-35.15-25-20.13 0-33.7 9.39-33.7 25.34 0 13.3 9.21 20.65 22.16 22.84l15.29 2.66c5 .78 8 2.66 8 5.32 0 3.28-4.21 5.16-10.92 5.16s-12-2.25-14.11-6.83h-23c3 18 18.39 25.45 36.91 25.45 19.82 0 35.42-7.82 35.42-25.34-.01-13.45-9.53-20.34-23.57-22.99zM642.56 125.41l-33-92H598l39.1 106.1H648l39.13-106.12h-11.52zm58.67-92.32a7.28 7.28 0 107.28 7.28 7.29 7.29 0 00-7.28-7.28zm-5 106.42h10v-75.8h-10zm96.41-60.94c-6.37-10.16-17.13-16.68-30.64-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v14.86h10V33.39h-10zm-29.86 53.06a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96.11-69.74c-23.5 0-39.57 17.44-39.57 39.72 0 22.89 16.38 39.72 40.33 39.72 15.31 0 27-7.13 33.35-17.43l-8.79-5.16c-4.1 7.28-12.43 12.89-24.41 12.89-16.07 0-28-9.55-30.17-25h66.55c.15-1.51.31-3.18.31-4.7 0-20.78-14.41-40.04-37.6-40.04zm-29.26 35c2-14.85 13.34-25.31 29.26-25.31 13 0 25.16 8.64 27.29 25.31zm118.1-35a39.72 39.72 0 1039.87 39.72 39.41 39.41 0 00-39.87-39.72zm0 69.74a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96 7.88h10.61V33.39h-10.61zm68.82-77.62c-10.76 0-19.55 4.1-25.46 13.65V63.71h-10v75.8h10V99.79c0-20.31 11.21-28.19 24.55-28.19s20.62 7.88 20.62 21.37v46.54h10V93c-.03-19-11.26-31.11-29.75-31.11zm57 21.68c0-8.18 8-12 15.91-12 7.28 0 15 2.88 18.2 10.61l8.33-4.85c-4.39-9.4-14.1-15.47-26.53-15.47-15.16 0-25.92 9.55-25.92 21.68 0 27.9 44.27 17.13 44.27 35.93 0 8.94-8.49 12.13-17.44 12.13-10.15 0-18-5-20.77-12.74l-8.48 5c3.79 9.7 14.09 17.43 29.25 17.43 16.22 0 27.44-8.94 27.44-21.83-.03-27.85-44.29-17.09-44.29-35.89zm65.19-50.48a7.28 7.28 0 107.27 7.28 7.28 7.28 0 00-7.3-7.28zm-5 106.42h10v-75.8h-10zm96.42-60.94c-6.37-10.16-17.13-16.68-30.62-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v11.83c0 15.46-10.46 25.47-28 25.47-16.37 0-23.34-6.07-27.13-13.8l-8.8 5c5.92 11.83 18.5 18.5 35.93 18.5 19.56 0 38-12.13 38-35.17V63.71h-10zm-29.87 53.06a30 30 0 1129.87-30 29.58 29.58 0 01-29.91 30zm96.57-69.74c-10.76 0-19.56 4.1-25.47 13.65V33.39h-10v106.12h10V99.79c0-20.31 11.22-28.19 24.56-28.19 13.19 0 20.62 7.88 20.62 21.37v46.54h10V93c-.04-19-11.26-31.11-29.75-31.11zm67.46-19.4l-10 3v18.22h-15.92v9.7h15.92v45.94c0 18.19 11.37 23.19 31.83 20.16v-8.79c-14.7.6-21.83 1.67-21.83-11.37V73.41h21.83v-9.7h-21.83zm41.84 41.08c0-8.18 8-12 15.92-12 7.28 0 15 2.88 18.19 10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16 0-25.92 9.55-25.92 21.68 0 27.9 44.26 17.13 44.26 35.93 0 8.94-8.49 12.13-17.43 12.13-10.16 0-18-5-20.77-12.74l-8.49 5c3.79 9.7 14.1 17.43 29.26 17.43 16.22 0 27.44-8.94 27.44-21.83-.04-27.85-44.31-17.09-44.31-35.89z"})]}));};var VideoInsightsLegacyLogo=function VideoInsightsLegacyLogo(_Oa){var _Pa=_Oa,dark2=_Pa.dark,rest=__objRest(_Pa,["dark"]);return/* @__PURE__ */jsxs(Svg$2,__spreadProps(__spreadValues({ieWidths:{sm:531,lg:707,"default":637},viewBox:"0 0 1162 173"},rest),{children:[/* @__PURE__ */jsx(LogoPath,{d:"M1 33.45v24.17h68.78V33.45zM1 103h45.53v36.47h23.24v-60.4H1z"}),/* @__PURE__ */jsx(TextPath,{dark:dark2,d:"M92.33 139.59h26.33l.09-36.57h45.38V79.08h-45.38l-.03-21.47h52.79V33.45H92.33v106.14zM253.85 125.41l-33-92h-11.57l39.11 106.12h10.92l39.11-106.14H286.9zm58.67-92.32a7.28 7.28 0 107.28 7.28 7.28 7.28 0 00-7.28-7.28zm-5 106.42h10v-75.8h-10zm96.41-60.94c-6.36-10.16-17.13-16.68-30.62-16.68a39.72 39.72 0 000 79.44c13.49 0 24.26-6.52 30.62-16.68v14.86h10V33.39h-10zm-29.86 53.06a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96.11-69.74c-23.5 0-39.57 17.44-39.57 39.72 0 22.89 16.38 39.72 40.33 39.72 15.31 0 27-7.13 33.35-17.44l-8.79-5.15c-4.1 7.28-12.43 12.89-24.41 12.89-16.07 0-28-9.55-30.17-25h66.55c.15-1.51.31-3.18.31-4.7 0-20.79-14.41-40.04-37.6-40.04zm-29.26 35c2-14.86 13.34-25.32 29.26-25.32 13 0 25.16 8.64 27.29 25.32zm118.1-35a39.72 39.72 0 1039.87 39.72A39.41 39.41 0 00559 61.89zm0 69.74a30 30 0 1129.86-30 29.58 29.58 0 01-29.88 30zm96 7.88h10.61V33.39H655zm68.78-77.62c-10.76 0-19.55 4.09-25.46 13.65V63.71h-10v75.8h10V99.79c0-20.31 11.21-28.2 24.55-28.2s20.62 7.89 20.62 21.41v46.54h10V93c.01-19-11.21-31.11-29.71-31.11zm57 21.68c0-8.19 8-12 15.91-12 7.28 0 15 2.88 18.2 10.62l8.33-4.86c-4.39-9.39-14.1-15.46-26.53-15.46-15.16 0-25.92 9.55-25.92 21.68 0 27.89 44.27 17.13 44.27 35.93 0 8.94-8.49 12.13-17.44 12.13-10.15 0-18-5-20.77-12.74l-8.48 5c3.79 9.71 14.09 17.44 29.25 17.44 16.22 0 27.44-9 27.44-21.83.01-27.88-44.25-17.11-44.25-35.91zM846 33.09a7.28 7.28 0 107.27 7.28 7.27 7.27 0 00-7.27-7.28zm-5 106.42h10v-75.8h-10zm96.42-60.94c-6.42-10.16-17.14-16.68-30.63-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v11.83c0 15.46-10.46 25.47-28 25.47-16.37 0-23.34-6.07-27.13-13.8l-8.8 5c5.92 11.83 18.5 18.5 35.93 18.5 19.56 0 38-12.13 38-35.17V63.71h-10zm-29.87 53.06a30 30 0 1129.87-30 29.58 29.58 0 01-29.88 30zm96.57-69.74c-10.76 0-19.56 4.09-25.47 13.65V33.39h-10v106.12h10V99.79c0-20.31 11.22-28.2 24.56-28.2 13.19 0 20.62 7.89 20.62 21.38v46.54h10V93c-.01-19-11.23-31.11-29.72-31.11zm67.46-19.4l-10 3v18.22h-15.92v9.7h15.92v45.94c0 18.19 11.37 23.19 31.83 20.16v-8.79c-14.7.6-21.83 1.66-21.83-11.37V73.41h21.83v-9.7h-21.83zm41.84 41.08c0-8.19 8-12 15.92-12 7.28 0 15 2.88 18.19 10.62l8.34-4.86c-4.4-9.39-14.1-15.46-26.53-15.46-15.16 0-25.92 9.55-25.92 21.68 0 27.89 44.27 17.13 44.27 35.93 0 8.94-8.5 12.13-17.44 12.13-10.16 0-18-5-20.77-12.74l-8.49 5c3.79 9.71 14.1 17.44 29.26 17.44 16.22 0 27.44-9 27.44-21.83-.01-27.88-44.28-17.11-44.28-35.91z"})]}));};var SmallSvg=/* @__PURE__ */createStyled(Svg$2,{target:"e16c9rea0"})({name:"fs1x93",styles:"width:24px;height:20px;"});var FVLogoSmall=function FVLogoSmall(_Qa){var rest=__objRest(_Qa,[]);return/* @__PURE__ */jsx(SmallSvg,__spreadProps(__spreadValues({viewBox:"0 0 24 20",ieWidths:{sm:24,lg:24,"default":24}},rest),{children:/* @__PURE__ */jsx(LogoPath,{d:"M13.9929 13.3636L18.7473 0H23.3524L16.2955 19.831L13.9929 13.3636ZM3.79494 10.6749H13.0336L11.598 6.64182H2.3594L3.79494 10.6749ZM10.6742 4.03305L9.23862 0.00726679H0L1.43554 4.03305H10.6742Z",fill:"#00CC52"})}));};var Container$e=createStyled("div",{target:"e13borb40"})({name:"79vkaf",styles:"display:flex;align-items:center;flex:1;min-width:0;"});var AppName=createStyled("div",{target:"e13borb41"})("flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-left:0.25em;font-size:0.875em;line-height:1.25;",fontWeight("bold"),";");var Logo=function Logo(_Ra){var _Sa=_Ra,appName=_Sa.appName,_Sa$renderLogo=_Sa.renderLogo,renderLogo=_Sa$renderLogo===void 0?function(){return/* @__PURE__ */jsx(FVLogoSmall,{});}:_Sa$renderLogo,rest=__objRest(_Sa,["appName","renderLogo"]);return/* @__PURE__ */jsxs(Container$e,__spreadProps(__spreadValues({},rest),{children:[renderLogo(),appName&&/* @__PURE__ */jsx(AppName,{children:appName})]}));};var _ref$9={name:"x8h6hl",styles:"margin-left:0.5em;"};var extraMarginLeftCss=function extraMarginLeftCss(_ref115){var extraMarginLeft=_ref115.extraMarginLeft;return extraMarginLeft?_ref$9:"";};var NavItem$1=createStyled("div",{target:"eddmrad0"})("display:flex;align-items:center;justify-content:center;margin-left:0.25em;",extraMarginLeftCss,";");var lightBlue="#d4e7fa";var activeCss$1=function activeCss$1(_ref116){var active=_ref116.active;return active?/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",lightBlue,";svg{fill:",color("ink"),";}"):"";};var NavItemButton=createStyled("button",{target:"e1q8g0n00"})("display:flex;align-items:center;justify-content:center;user-select:none;color:currentColor;font-family:inherit;border:1px solid transparent;transition:color 0.1s ease-in-out,background-color 0.1s ease-in-out,border-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out 0s;border-radius:50%;font-size:1em;width:2.5em;height:2.5em;box-sizing:border-box;background:none;padding:0;&:enabled{cursor:pointer;}&:hover,&:focus{text-decoration:none;outline:0;}&:hover,&:focus{cursor:pointer;}&:disabled{cursor:not-allowed;}&:hover{background-color:",transparentize("slate",0.08),";}&:active{background-color:",lightBlue,";svg{fill:",color("ink"),";}}",activeCss$1,";svg{fill:",color("pewter"),";}");var Container$d=createStyled("div",{target:"eeq1e3t0"})({name:"b3pn3b",styles:"display:inline-block;position:relative;"});Container$d.displayName="DropdownMenu.Container";var ItemLink=/* @__PURE__ */createStyled(function(_Ta){var _Ua=_Ta,external=_Ua.external,to=_Ua.to,props=__objRest(_Ua,["external","to"]);return external?/* @__PURE__ */jsx("a",__spreadValues({href:to},props)):/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],__spreadValues({to:to},props));},{target:"e1c8vofb0"})("display:block;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;",padding("xxs"),";",typography$1("body2"),";&:hover{background-color:",transparentize("green",0.15),";}");ItemLink.displayName="DropdownMenu.ItemLink";var ItemAction=ItemLink.withComponent("a",{target:"enbxdro0"});ItemAction.displayName="DropdownMenu.ItemAction";var Item$2=function Item$2(props){return/* @__PURE__ */jsx("li",{children:props.to?/* @__PURE__ */jsx(ItemLink,__spreadValues({},props)):/* @__PURE__ */jsx(ItemAction,__spreadValues({},props))});};Item$2.displayName="DropdownMenu.Item";var _ref$8={name:"19zs6va",styles:"right:0;"};var _ref2$6={name:"260zpl",styles:"left:0;"};var Menu=createStyled("ul",{target:"e149lc4r0"})("display:",function(_ref117){var open=_ref117.open;return open?"block":"none";},";position:absolute;top:100%;z-index:1000;min-width:10rem;list-style:none;margin:",spacer(1)," 0;padding:",spacer(1)," 0;color:",color("black"),";background-color:",color("white"),";max-height:",compose(defaultTo("275px"),prop("maxHeight")),";overflow-y:auto;line-height:",compose(defaultTo("24px"),prop("lineHeight")),";",borderRadius$1("default"),";",shadow$1("distant"),";",function(_ref118){var align=_ref118.align;return align==="right"?_ref$8:_ref2$6;},";",function(_ref119){var width=_ref119.width;return width&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("width:",width,";");},";&[data-popper-reference-hidden='true']{opacity:0;pointer-events:none;}");Menu.displayName="DropdownMenu.Menu";var Section=createStyled("div",{target:"eagalar0"})("&:not(:last-of-type){margin-bottom:",spacer(1),";padding-bottom:",spacer(1),";border-bottom:1px solid ",color("paleGrey"),";}");Section.displayName="DropdownMenu.Section";function DropdownMenu(_ref120){var align=_ref120.align,children=_ref120.children,lineHeight2=_ref120.lineHeight,maxHeight=_ref120.maxHeight,trigger=_ref120.trigger,width=_ref120.width,popperOptions=_ref120.popperOptions,controlledOpen=_ref120.open,onToggle=_ref120.onToggle;var isControlled=controlledOpen!==void 0;var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState0=_slicedToArray(_useState9,2),open=_useState0[0],setOpen=_useState0[1];var toggle=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(isControlled){if(onToggle){onToggle(!controlledOpen);}}else{setOpen(!open);}},[isControlled,onToggle,controlledOpen,open]);var menuRoot=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(popperOptions?function(){return getRoot$1("menu");}:function(){},[]);var _useState1=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState1,2),menuRef=_useState10[0],setMenuRef=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),triggerRef=_useState12[0],setTriggerRef=_useState12[1];var _usePopper$=usePopper$1(triggerRef,menuRef,popperOptions?popperOptions:{}),styles2=_usePopper$.styles,attributes=_usePopper$.attributes,update=_usePopper$.update;var trueOpen=isControlled?controlledOpen:open;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(function(){update&&update();var maybeClose=function maybeClose(evt){if(trueOpen&&!menuRef.contains(evt.target)){toggle();}};document.addEventListener("click",maybeClose);return function(){return document.removeEventListener("click",maybeClose);};},[trueOpen,menuRef]);var triggerEl=popperOptions?trigger(toggle,setTriggerRef,trueOpen):trigger(toggle,trueOpen);var popperProps=popperOptions?__spreadValues({style:styles2.popper},attributes.popper):{};var menu=/* @__PURE__ */jsx(Menu,__spreadProps(__spreadValues({align:align,width:width,open:trueOpen,maxHeight:maxHeight,lineHeight:lineHeight2,ref:setMenuRef},popperProps),{children:children}));return/* @__PURE__ */jsxs(Container$d,{children:[triggerEl,popperOptions?Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["createPortal"])(menu,menuRoot):menu]});}DropdownMenu.Item=Item$2;DropdownMenu.Section=Section;DropdownMenu.propTypes={align:PropTypes$2.string,children:PropTypes$2.node,maxHeight:PropTypes$2.oneOf([PropTypes$2.string,PropTypes$2.number]),trigger:PropTypes$2.func,width:PropTypes$2.oneOf([PropTypes$2.string,PropTypes$2.number]),popperOptions:PropTypes$2.shape({placement:PropTypes$2.string,modifiers:PropTypes$2.arrayOf(PropTypes$2.object),strategy:PropTypes$2.string,onFirstUpdate:PropTypes$2.func}),open:PropTypes$2.bool,onToggle:PropTypes$2.func};var Carets=function Carets(_Va){var _Wa=_Va,_Wa$title=_Wa.title,title=_Wa$title===void 0?"carets":_Wa$title,_Wa$viewBox=_Wa.viewBox,viewBox2=_Wa$viewBox===void 0?"0 0 16 24":_Wa$viewBox,_Wa$size=_Wa.size,size2=_Wa$size===void 0?"1.5rem":_Wa$size,props=__objRest(_Wa,["title","viewBox","size"]);return/* @__PURE__ */jsxs(SVGIconV2,__spreadProps(__spreadValues({viewBox:viewBox2,size:size2},props),{children:[/* @__PURE__ */jsx("title",{children:title}),/* @__PURE__ */jsx("path",{d:"M7.72833 6.99652L10.315 9.58318C10.575 9.84318 11.0017 9.83652 11.2617 9.58318C11.5217 9.32318 11.5217 8.90318 11.2617 8.64318L8.20167 5.58318C7.94167 5.32318 7.52167 5.32318 7.26167 5.58318L4.20167 8.64318C3.94167 8.90318 3.94167 9.32318 4.20167 9.58318C4.46167 9.84318 4.88167 9.84318 5.14167 9.58318L7.72833 6.99652ZM7.72833 16.5565L5.14167 13.9698C4.88167 13.7098 4.455 13.7165 4.195 13.9698C3.935 14.2298 3.935 14.6498 4.195 14.9098L7.255 17.9698C7.515 18.2298 7.935 18.2298 8.195 17.9698L11.255 14.9098C11.515 14.6498 11.515 14.2298 11.255 13.9698C10.995 13.7098 10.575 13.7098 10.315 13.9698L7.72833 16.5565Z"})]}));};var Divider=createStyled("div",{target:"e1izd4200"})("margin:0.25em 0;border-bottom:1px solid ",color("paleGrey"),";");Divider.displayName="GlobalHeader.DropdownMenu.Divider";var baseCss={name:"3mmjyd",styles:"display:flex;align-items:center;justify-content:space-between;padding:0.75em 1em;font-size:0.875em;"};var Link=createStyled("a",{target:"e1r1zg5x0"})(baseCss,";cursor:pointer;&:hover{background-color:",transparentize("silver",0.3),";text-decoration:none;}");var StyledItem=createStyled("li",{target:"e1r1zg5x1"})(baseCss,";");var Item$1=function Item$1(props){return props.to?/* @__PURE__ */jsx("li",{children:/* @__PURE__ */jsx(Link,__spreadValues({href:props.to},props))}):/* @__PURE__ */jsx(StyledItem,__spreadValues({},props));};Item$1.displayName="GlobalHeader.DropdownMenu.Item";var _ref$7={name:"b6deu8",styles:"background:rgba(0,0,0,0.04);border:1px solid #e4e8eb;border-radius:4px;"};var PlaceholderButton=createStyled("button",{target:"e1g2nuyf0"})("font-size:1em;display:flex;align-items:center;height:3.25em;padding:0.5em;border:0;box-sizing:border-box;background:",color("white"),";min-width:8.25em;max-width:16.25em;border:1px solid transparent;cursor:pointer;outline:0;",function(_ref121){var open=_ref121.open;return open?_ref$7:"";},"");var ChevronsContainer=createStyled("div",{target:"e1g2nuyf1"})({name:"mhgpyg",styles:"display:flex;flex-direction:column;margin-left:0.5em;"});var Chevrons=function Chevrons(){return/* @__PURE__ */jsx(ChevronsContainer,{children:/* @__PURE__ */jsx(Carets,{})});};var ButtonLabel=createStyled("span",{target:"e1g2nuyf2"})({name:"mtbf91",styles:"font-size:0.875em;font-weight:500;flex:1;text-align:left;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"});var Image=createStyled("img",{target:"e1g2nuyf3"})({name:"1l4k18e",styles:"width:2em;max-height:2em;margin-right:0.5em;"});var GlobalHeaderDropdownMenu=function GlobalHeaderDropdownMenu(_ref122){var children=_ref122.children,placeholder=_ref122.placeholder,width=_ref122.width,align=_ref122.align,imageSrc=_ref122.imageSrc,renderTrigger=_ref122.renderTrigger,maxHeight=_ref122.maxHeight,lineHeight2=_ref122.lineHeight;return/* @__PURE__ */jsx(DropdownMenu,{align:align,width:width,maxHeight:maxHeight,lineHeight:lineHeight2,trigger:function trigger(toggle,open){return renderTrigger?renderTrigger({toggle:toggle,open:open}):/* @__PURE__ */jsxs(PlaceholderButton,{open:open,onClick:toggle,children:[/* @__PURE__ */jsx(Image,{src:imageSrc}),/* @__PURE__ */jsx(ButtonLabel,{children:placeholder}),/* @__PURE__ */jsx(Chevrons,{})]});},children:children});};GlobalHeaderDropdownMenu.Divider=Divider;GlobalHeaderDropdownMenu.Item=Item$1;GlobalHeaderDropdownMenu.Image=Image;GlobalHeaderDropdownMenu.PlaceholderButton=PlaceholderButton;GlobalHeaderDropdownMenu.ButtonLabel=ButtonLabel;GlobalHeaderDropdownMenu.Chevrons=Chevrons;var Avatar=createStyled("div",{target:"e1bvlp6s0"})("display:flex;justify-content:center;align-items:center;border-radius:50%;width:2em;height:2em;background-color:",color("slate"),";color:",color("cadet"),";img{width:100%;pointer-events:none;}");Avatar.displayName="GlobalHeader.Avatar";var GlobalHeader=createStyled("nav",{target:"eyhvzj80"})("display:flex;justify-content:center;align-items:center;width:100%;padding:0.375em;box-sizing:border-box;height:4.375em;color:",color("ink"),";background-color:",color("white"),";border-top:2px solid ",style("globalHeader.topBorderColor"),";border-bottom:1px solid ",color("silver"),";",function(_ref123){var _ref123$baseFontSize=_ref123.baseFontSize,baseFontSize=_ref123$baseFontSize===void 0?"16px":_ref123$baseFontSize;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("font-size:",baseFontSize,";");},";",function(_ref124){var borderTopColor=_ref124.borderTopColor;return borderTopColor?/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border-top-color:",borderTopColor,";"):"";},";",function(_ref125){var borderBottomColor=_ref125.borderBottomColor;return borderBottomColor?/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border-bottom-color:",borderBottomColor,";"):"";},";");var Main$2=createStyled("div",{target:"eyhvzj81"})({name:"1n3p764",styles:"flex:1;min-width:0;display:flex;align-items:center;height:2.5em;"});var Side=createStyled("div",{target:"eyhvzj82"})({name:"j212vf",styles:"display:flex;flex-direction:row;align-items:center;justify-content:center;height:2.5em;"});GlobalHeader.Logo=Logo;GlobalHeader.Main=Main$2;GlobalHeader.Side=Side;GlobalHeader.NavItem=NavItem$1;GlobalHeader.NavItemButton=NavItemButton;GlobalHeader.DropdownMenu=GlobalHeaderDropdownMenu;GlobalHeader.Avatar=Avatar;var userNameColor=function userNameColor(_ref126){var fontColor=_ref126.fontColor;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",transparentize(fontColor,0.5),";");};var UserName=createStyled("span",{target:"eer6lf80"})("margin-left:",spacer(2),";",typography$1("body1"),";",userNameColor,";");UserName.displayName="HeaderAvatar.UserName";var AvatarButton=/* @__PURE__ */createStyled(Button$1,{target:"ee8r3in0"})("display:flex;justify-content:center;align-items:center;background:none;padding:0;border:none;&::after{content:'';color:",color("cadet"),";margin-left:0.625rem;width:0;height:0;vertical-align:0.255em;border-top:0.3em solid;border-right:0.3em solid transparent;border-bottom:0;border-left:0.3em solid transparent;}&:hover{",UserName,"{color:",color("offWhite"),";}}");AvatarButton.displayName="HeaderAvatar.Button";var HeaderAvatar=function HeaderAvatar(_ref127){var align=_ref127.align,children=_ref127.children,firstName=_ref127.firstName,lastName=_ref127.lastName,email=_ref127.email,hideUserName=_ref127.hideUserName,avatarUrl=_ref127.avatarUrl,fontColor=_ref127.fontColor;return/* @__PURE__ */jsx(DropdownMenu,{align:align,trigger:function trigger(toggle){return/* @__PURE__ */jsxs(AvatarButton,{onClick:toggle,children:[/* @__PURE__ */jsx(Avatar$1,{firstName:firstName,lastName:lastName,email:email,avatarUrl:avatarUrl}),!hideUserName&&/* @__PURE__ */jsx(UserName,{fontColor:fontColor,children:"".concat(firstName," ").concat(lastName).trim()})]});},children:children});};HeaderAvatar.MenuItem=DropdownMenu.Item;HeaderAvatar.MenuSection=DropdownMenu.Section;HeaderAvatar.propTypes={align:PropTypes$2.string,children:PropTypes$2.node,firstName:PropTypes$2.string,lastName:PropTypes$2.string,hideUserName:PropTypes$2.bool,avatarUrl:PropTypes$2.string,fontColor:PropTypes$2.string};HeaderAvatar.defaultProps={align:"left",firstName:"",lastName:"",hideUserName:false,avatarUrl:"",fontColor:"offWhite"};function createCommonjsModule(fn2,module2){return module2={exports:{}},fn2(module2,module2.exports),module2.exports;}function makeEmptyFunction(arg){return function(){return arg;};}var emptyFunction2=function emptyFunction3(){};emptyFunction2.thatReturns=makeEmptyFunction;emptyFunction2.thatReturnsFalse=makeEmptyFunction(false);emptyFunction2.thatReturnsTrue=makeEmptyFunction(true);emptyFunction2.thatReturnsNull=makeEmptyFunction(null);emptyFunction2.thatReturnsThis=function(){return this;};emptyFunction2.thatReturnsArgument=function(arg){return arg;};var emptyFunction_1=emptyFunction2;function invariant(condition,format,a,b2,c2,d2,e2,f2){if(!condition){var error;if(format===void 0){error=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");}else{var args=[a,b2,c2,d2,e2,f2];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++];}));error.name="Invariant Violation";}error.framesToPop=1;throw error;}}var invariant_1=invariant;/*
object-assign
(c) Sindre Sorhus
@license MIT
*/var getOwnPropertySymbols=Object.getOwnPropertySymbols;var hasOwnProperty=Object.prototype.hasOwnProperty;var propIsEnumerable=Object.prototype.propertyIsEnumerable;function toObject(val){if(val===null||val===void 0){throw new TypeError("Object.assign cannot be called with null or undefined");}return Object(val);}function shouldUseNative(){try{if(!Object.assign){return false;}var test1=new String("abc");test1[5]="de";if(Object.getOwnPropertyNames(test1)[0]==="5"){return false;}var test2={};for(var i=0;i<10;i++){test2["_"+String.fromCharCode(i)]=i;}var order2=Object.getOwnPropertyNames(test2).map(function(n2){return test2[n2];});if(order2.join("")!=="0123456789"){return false;}var test3={};"abcdefghijklmnopqrst".split("").forEach(function(letter){test3[letter]=letter;});if(Object.keys(Object.assign({},test3)).join("")!=="abcdefghijklmnopqrst"){return false;}return true;}catch(err){return false;}}shouldUseNative()?Object.assign:function(target,source){var from;var to=toObject(target);var symbols;for(var s=1;s<arguments.length;s++){from=Object(arguments[s]);for(var key2 in from){if(hasOwnProperty.call(from,key2)){to[key2]=from[key2];}}if(getOwnPropertySymbols){symbols=getOwnPropertySymbols(from);for(var i=0;i<symbols.length;i++){if(propIsEnumerable.call(from,symbols[i])){to[symbols[i]]=from[symbols[i]];}}}}return to;};var ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";var ReactPropTypesSecret_1=ReactPropTypesSecret;var factoryWithThrowingShims=function factoryWithThrowingShims(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret_1){return;}invariant_1(false,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}shim.isRequired=shim;function getShim(){return shim;}var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim};ReactPropTypes.checkPropTypes=emptyFunction_1;ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};var propTypes=createCommonjsModule(function(module2){{module2.exports=factoryWithThrowingShims();}});var invariant$3=function invariant$3(condition,format,a,b2,c2,d2,e2,f2){if(!condition){var error;if(format===void 0){error=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");}else{var args=[a,b2,c2,d2,e2,f2];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++];}));error.name="Invariant Violation";}error.framesToPop=1;throw error;}};var invariant_1$2=invariant$3;var camel2hyphen=function camel2hyphen(str){return str.replace(/[A-Z]/g,function(match){return"-"+match.toLowerCase();}).toLowerCase();};var camel2hyphen_1=camel2hyphen;var isDimension=function isDimension(feature){var re=/[height|width]$/;return re.test(feature);};var obj2mq=function obj2mq(obj){var mq="";var features=Object.keys(obj);features.forEach(function(feature,index2){var value=obj[feature];feature=camel2hyphen_1(feature);if(isDimension(feature)&&typeof value==="number"){value=value+"px";}if(value===true){mq+=feature;}else if(value===false){mq+="not "+feature;}else{mq+="("+feature+": "+value+")";}if(index2<features.length-1){mq+=" and ";}});return mq;};var json2mq=function json2mq(query){var mq="";if(typeof query==="string"){return query;}if(query instanceof Array){query.forEach(function(q2,index2){mq+=obj2mq(q2);if(index2<query.length-1){mq+=", ";}});return mq;}return obj2mq(query);};var json2mq_1=json2mq;var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return _typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":_typeof2(obj);};var classCallCheck=function classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}};var inherits=function inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;};var possibleConstructorReturn=function possibleConstructorReturn(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;};var Media=function(_React$Component){inherits(Media2,_React$Component);function Media2(){var _temp,_this,_ret;classCallCheck(this,Media2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn(this,_React$Component.call.apply(_React$Component,[this].concat(args))),_this),_this.state={matches:_this.props.defaultMatches},_this.updateMatches=function(){return _this.setState({matches:_this.mediaQueryList.matches});},_temp),possibleConstructorReturn(_this,_ret);}Media2.prototype.componentWillMount=function componentWillMount(){if((typeof window==="undefined"?"undefined":_typeof(window))!=="object")return;var targetWindow=this.props.targetWindow||window;invariant_1$2(typeof targetWindow.matchMedia==="function","<Media targetWindow> does not support `matchMedia`.");var query=this.props.query;if(typeof query!=="string")query=json2mq_1(query);this.mediaQueryList=targetWindow.matchMedia(query);this.mediaQueryList.addListener(this.updateMatches);this.updateMatches();};Media2.prototype.componentWillUnmount=function componentWillUnmount(){this.mediaQueryList.removeListener(this.updateMatches);};Media2.prototype.render=function render3(){var _props=this.props,children=_props.children,render4=_props.render;var matches=this.state.matches;return render4?matches?render4():null:children?typeof children==="function"?children(matches):!Array.isArray(children)||children.length?matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children):null:null:null;};return Media2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Media.propTypes={defaultMatches:propTypes.bool,query:propTypes.oneOfType([propTypes.string,propTypes.object,propTypes.arrayOf(propTypes.object.isRequired)]).isRequired,render:propTypes.func,children:propTypes.oneOfType([propTypes.node,propTypes.func]),targetWindow:propTypes.object};Media.defaultProps={defaultMatches:true};var breakpointAt=function breakpointAt(size2){browser$1(size2,"No breakpoint exists for '".concat(size2,"'"));return BREAKPOINTS[size2];};var MediaQuery=function MediaQuery(_ref128){var above=_ref128.above,below=_ref128.below,children=_ref128.children,render3=_ref128.render;var query={};if(above){query.minWidth=breakpointAt(above);}if(below){query.maxWidth=breakpointAt(below);}return/* @__PURE__ */jsx(Media,{query:query,render:render3,children:children});};MediaQuery.propTypes={above:PropTypes$2.oneOf(Object.keys(BREAKPOINTS)),below:PropTypes$2.oneOf(Object.keys(BREAKPOINTS)),children:PropTypes$2.func,render:PropTypes$2.func};var _ref$6={name:"r2ff5g",styles:"visibility:visible;opacity:1;"};var _ref2$5={name:"ge94et",styles:"visibility:hidden;opacity:0;"};var animationState$3=function animationState$3(_ref129){var animationState2=_ref129.animationState;switch(animationState2){case"entering":case"entered":return _ref$6;case"exiting":case"exited":return _ref2$5;}};var Backdrop$1=createStyled("div",{target:"e14nskod0"})("position:fixed;top:0;left:0;right:0;bottom:0;background:",transparentize("pewter",0.6),";transition:all 0.3s;z-index:1049;",animationState$3,";");Backdrop$1.displayName="Modal.Backdrop";var Body$2=createStyled("div",{target:"eljh5ud0"})("padding-left:",spacer(6),";padding-right:",spacer(6),";flex:1;");Body$2.displayName="Modal.Body";var _createContext$=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(),Provider=_createContext$.Provider,Consumer=_createContext$.Consumer;var CancelButton=function CancelButton(_ref130){var _children2=_ref130.children;return/* @__PURE__ */jsx(Consumer,{children:function children(_ref131){var onClose=_ref131.onClose;return/* @__PURE__ */jsx(Button$1,{kind:"ghost",type:"button",onClick:onClose,children:_children2});}});};CancelButton.defaultProps={children:"Cancel"};var _ref$5={name:"8l3sia",styles:"visiblity:visible;opacity:1;transform:scale(1);"};var _ref2$4={name:"19mr2x1",styles:"visibility:hidden;opacity:0;transform:scale(1.15);"};var animationState$2=function animationState$2(_ref132){var animationState2=_ref132.animationState;switch(animationState2){case"entering":case"entered":return _ref$5;case"exiting":case"exited":return _ref2$4;}};var Container$c=createStyled("div",{target:"e1gcs83a0"})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center;transition:all 0.3s;",animationState$2,";");Container$c.displayName="Modal.Container";var _ref$4={name:"v2kfba",styles:"height:100%;width:100%;"};var size$3=function size$3(_ref133){var size2=_ref133.size,theme=_ref133.theme;switch(size2){case"fullscreen":return _ref$4;case"lg":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("margin-top:",spacer(5,{theme:theme}),";margin-bottom:",spacer(5,{theme:theme}),";width:720px;",borderRadius$1("default",{theme:theme}),";");default:return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("margin-top:",spacer(5,{theme:theme}),";margin-bottom:",spacer(5,{theme:theme}),";width:480px;",borderRadius$1("default",{theme:theme}),";");}};var _ref2$3={name:"1uwx7m9",styles:"background:none;border-color:transparent;box-shadow:unset;"};var kind=function kind(_ref134){var kind2=_ref134.kind;return kind2==="ghost"&&_ref2$3;};var Content$1=createStyled("div",{target:"e1v6o49d0"})("background:",color("white"),";display:flex;flex-direction:column;max-width:100%;",shadow$1("raised"),";",size$3,";",kind,";");Content$1.displayName="Modal.Content";var Footer$2=createStyled("footer",{target:"e1wlngrb0"})("display:flex;justify-content:flex-end;",padding("md"),";",Button$1," + ",Button$1,"{margin-left:",spacer(2),";}");Footer$2.displayName="Modal.Footer";var Container$b=createStyled("header",{target:"e1a0t32x0"})("display:flex;justify-content:space-between;align-items:center;> h3:first-of-type{flex:1;margin-bottom:0;}",padding("md"),";");Container$b.displayName="Modal.Header.Container";var Header$3=function Header$3(_ref135){var _children3=_ref135.children;return/* @__PURE__ */jsx(Consumer,{children:function children(_ref136){var dismissable=_ref136.dismissable,onClose=_ref136.onClose;return/* @__PURE__ */jsxs(Container$b,{children:[_children3,dismissable&&/* @__PURE__ */jsx(CloseButton,{onClick:onClose})]});}});};Header$3.displayName="Modal.Header";var Title$2=function Title$2(props){return/* @__PURE__ */jsx("h3",__spreadValues({},props));};Title$2.displayName="Modal.Title";var Transition$1={};var PropTypes$1={};PropTypes$1.__esModule=true;PropTypes$1.classNamesShape=PropTypes$1.timeoutsShape=void 0;PropTypes$1.transitionTimeout=transitionTimeout;var _propTypes$2=propTypes$2.exports;var _propTypes2$1=_interopRequireDefault$3(_propTypes$2);function _interopRequireDefault$3(obj){return obj&&obj.__esModule?obj:{"default":obj};}function transitionTimeout(transitionType){var timeoutPropName="transition"+transitionType+"Timeout";var enabledPropName="transition"+transitionType;return function(props){if(props[enabledPropName]){if(props[timeoutPropName]==null){return new Error(timeoutPropName+" wasn't supplied to CSSTransitionGroup: this can cause unreliable animations and won't be supported in a future version of React. See https://fb.me/react-animation-transition-group-timeout for more information.");}else if(typeof props[timeoutPropName]!=="number"){return new Error(timeoutPropName+" must be a number (in milliseconds)");}}return null;};}PropTypes$1.timeoutsShape=_propTypes2$1["default"].oneOfType([_propTypes2$1["default"].number,_propTypes2$1["default"].shape({enter:_propTypes2$1["default"].number,exit:_propTypes2$1["default"].number}).isRequired]);PropTypes$1.classNamesShape=_propTypes2$1["default"].oneOfType([_propTypes2$1["default"].string,_propTypes2$1["default"].shape({enter:_propTypes2$1["default"].string,exit:_propTypes2$1["default"].string,active:_propTypes2$1["default"].string}),_propTypes2$1["default"].shape({enter:_propTypes2$1["default"].string,enterDone:_propTypes2$1["default"].string,enterActive:_propTypes2$1["default"].string,exit:_propTypes2$1["default"].string,exitDone:_propTypes2$1["default"].string,exitActive:_propTypes2$1["default"].string})]);Transition$1.__esModule=true;Transition$1.EXITING=Transition$1.ENTERED=Transition$1.ENTERING=Transition$1.EXITED=Transition$1.UNMOUNTED=void 0;var _propTypes$1=propTypes$2.exports;var PropTypes=_interopRequireWildcard(_propTypes$1);var _react$2=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react2$1=_interopRequireDefault$2(_react$2);var _reactDom=__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a;var _reactDom2=_interopRequireDefault$2(_reactDom);function _interopRequireDefault$2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key2 in obj){if(Object.prototype.hasOwnProperty.call(obj,key2))newObj[key2]=obj[key2];}}newObj["default"]=obj;return newObj;}}function _objectWithoutProperties$1(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn$1(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;}function _inherits$1(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UNMOUNTED=Transition$1.UNMOUNTED="unmounted";var EXITED=Transition$1.EXITED="exited";var ENTERING=Transition$1.ENTERING="entering";var ENTERED=Transition$1.ENTERED="entered";var EXITING=Transition$1.EXITING="exiting";var Transition=function(_React$Component){_inherits$1(Transition2,_React$Component);function Transition2(props,context){_classCallCheck$1(this,Transition2);var _this=_possibleConstructorReturn$1(this,_React$Component.call(this,props,context));var parentGroup=context.transitionGroup;var appear=parentGroup&&!parentGroup.isMounting?props.enter:props.appear;var initialStatus=void 0;_this.nextStatus=null;if(props["in"]){if(appear){initialStatus=EXITED;_this.nextStatus=ENTERING;}else{initialStatus=ENTERED;}}else{if(props.unmountOnExit||props.mountOnEnter){initialStatus=UNMOUNTED;}else{initialStatus=EXITED;}}_this.state={status:initialStatus};_this.nextCallback=null;return _this;}Transition2.prototype.getChildContext=function getChildContext(){return{transitionGroup:null};};Transition2.prototype.componentDidMount=function componentDidMount(){this.updateStatus(true);};Transition2.prototype.componentWillReceiveProps=function componentWillReceiveProps(nextProps){var _ref6=this.pendingState||this.state,status=_ref6.status;if(nextProps["in"]){if(status===UNMOUNTED){this.setState({status:EXITED});}if(status!==ENTERING&&status!==ENTERED){this.nextStatus=ENTERING;}}else{if(status===ENTERING||status===ENTERED){this.nextStatus=EXITING;}}};Transition2.prototype.componentDidUpdate=function componentDidUpdate(){this.updateStatus();};Transition2.prototype.componentWillUnmount=function componentWillUnmount(){this.cancelNextCallback();};Transition2.prototype.getTimeouts=function getTimeouts(){var timeout=this.props.timeout;var exit=void 0,enter=void 0,appear=void 0;exit=enter=appear=timeout;if(timeout!=null&&typeof timeout!=="number"){exit=timeout.exit;enter=timeout.enter;appear=timeout.appear;}return{exit:exit,enter:enter,appear:appear};};Transition2.prototype.updateStatus=function updateStatus(){var mounting=arguments.length>0&&arguments[0]!==void 0?arguments[0]:false;var nextStatus=this.nextStatus;if(nextStatus!==null){this.nextStatus=null;this.cancelNextCallback();var node=_reactDom2["default"].findDOMNode(this);if(nextStatus===ENTERING){this.performEnter(node,mounting);}else{this.performExit(node);}}else if(this.props.unmountOnExit&&this.state.status===EXITED){this.setState({status:UNMOUNTED});}};Transition2.prototype.performEnter=function performEnter(node,mounting){var _this2=this;var enter=this.props.enter;var appearing=this.context.transitionGroup?this.context.transitionGroup.isMounting:mounting;var timeouts=this.getTimeouts();if(!mounting&&!enter){this.safeSetState({status:ENTERED},function(){_this2.props.onEntered(node);});return;}this.props.onEnter(node,appearing);this.safeSetState({status:ENTERING},function(){_this2.props.onEntering(node,appearing);_this2.onTransitionEnd(node,timeouts.enter,function(){_this2.safeSetState({status:ENTERED},function(){_this2.props.onEntered(node,appearing);});});});};Transition2.prototype.performExit=function performExit(node){var _this3=this;var exit=this.props.exit;var timeouts=this.getTimeouts();if(!exit){this.safeSetState({status:EXITED},function(){_this3.props.onExited(node);});return;}this.props.onExit(node);this.safeSetState({status:EXITING},function(){_this3.props.onExiting(node);_this3.onTransitionEnd(node,timeouts.exit,function(){_this3.safeSetState({status:EXITED},function(){_this3.props.onExited(node);});});});};Transition2.prototype.cancelNextCallback=function cancelNextCallback(){if(this.nextCallback!==null){this.nextCallback.cancel();this.nextCallback=null;}};Transition2.prototype.safeSetState=function safeSetState(nextState,callback){var _this4=this;this.pendingState=nextState;callback=this.setNextCallback(callback);this.setState(nextState,function(){_this4.pendingState=null;callback();});};Transition2.prototype.setNextCallback=function setNextCallback(callback){var _this5=this;var active=true;this.nextCallback=function(event){if(active){active=false;_this5.nextCallback=null;callback(event);}};this.nextCallback.cancel=function(){active=false;};return this.nextCallback;};Transition2.prototype.onTransitionEnd=function onTransitionEnd(node,timeout,handler){this.setNextCallback(handler);if(node){if(this.props.addEndListener){this.props.addEndListener(node,this.nextCallback);}if(timeout!=null){setTimeout(this.nextCallback,timeout);}}else{setTimeout(this.nextCallback,0);}};Transition2.prototype.render=function render3(){var status=this.state.status;if(status===UNMOUNTED){return null;}var _props=this.props,children=_props.children,childProps=_objectWithoutProperties$1(_props,["children"]);delete childProps["in"];delete childProps.mountOnEnter;delete childProps.unmountOnExit;delete childProps.appear;delete childProps.enter;delete childProps.exit;delete childProps.timeout;delete childProps.addEndListener;delete childProps.onEnter;delete childProps.onEntering;delete childProps.onEntered;delete childProps.onExit;delete childProps.onExiting;delete childProps.onExited;if(typeof children==="function"){return children(status,childProps);}var child=_react2$1["default"].Children.only(children);return _react2$1["default"].cloneElement(child,childProps);};return Transition2;}(_react2$1["default"].Component);Transition.contextTypes={transitionGroup:PropTypes.object};Transition.childContextTypes={transitionGroup:function transitionGroup(){}};Transition.propTypes={};function noop(){}Transition.defaultProps={"in":false,mountOnEnter:false,unmountOnExit:false,appear:false,enter:true,exit:true,onEnter:noop,onEntering:noop,onEntered:noop,onExit:noop,onExiting:noop,onExited:noop};Transition.UNMOUNTED=0;Transition.EXITED=1;Transition.ENTERING=2;Transition.ENTERED=3;Transition.EXITING=4;var _default$1=Transition$1["default"]=Transition;var ESC=27;var blurBodyStyle$1={name:"1y5smrt",styles:"body > *:not(#modal-root){filter:blur(3px);}"};var Modal$1=/*#__PURE__*/function(_Component3){function Modal$1(){var _this8;_classCallCheck3(this,Modal$1);_this8=_callSuper(this,Modal$1);__publicField(_this8,"container",document.createElement("div"));__publicField(_this8,"modalRoot",document.getElementById("modal-root"));__publicField(_this8,"freezeScrolling",function(){_this8.initialBodyOverflow=document.body.style.overflow;document.body.style.overflow="hidden";});__publicField(_this8,"resetScrolling",function(){document.body.style.overflow=_this8.initialBodyOverflow;});__publicField(_this8,"handleKeydown",function(e2){var _this8$props=_this8.props,dismissable=_this8$props.dismissable,open=_this8$props.open,onClose=_this8$props.onClose;if(!dismissable||!open){return;}switch(e2.keyCode){case ESC:onClose();break;}});return _this8;}_inherits3(Modal$1,_Component3);return _createClass3(Modal$1,[{key:"componentDidMount",value:function componentDidMount(){this.modalRoot.appendChild(this.container);document.addEventListener("keydown",this.handleKeydown);if(this.props.open){this.freezeScrolling();}}},{key:"componentDidUpdate",value:function componentDidUpdate(_ref137){var prevOpen=_ref137.open;var open=this.props.open;if(!prevOpen&&open){this.freezeScrolling();}if(prevOpen&&!open){this.resetScrolling();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.modalRoot.removeChild(this.container);this.resetScrolling();document.removeEventListener("keydown",this.handleKeydown);}},{key:"render",value:function render(){var _this$props2=this.props,dismissable=_this$props2.dismissable,_children4=_this$props2.children,onClose=_this$props2.onClose,open=_this$props2.open,size2=_this$props2.size,kind2=_this$props2.kind,blurBackground=_this$props2.blurBackground;return Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["createPortal"])(/* @__PURE__ */jsx(Provider,{value:{dismissable:dismissable,onClose:onClose},children:/* @__PURE__ */jsx(_default$1,{"in":open,timeout:300,children:function children(state){return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[open&&blurBackground&&/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["b" /* Global */],{styles:blurBodyStyle$1}),/* @__PURE__ */jsx(Backdrop$1,{animationState:state}),/* @__PURE__ */jsx(Container$c,{animationState:state,onClick:dismissable?onClose:null,children:/* @__PURE__ */jsx(Content$1,{onClick:function onClick(e2){return e2.stopPropagation();},size:size2,kind:kind2,children:_children4})})]});}})}),this.container);}}]);}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);__publicField(Modal$1,"Body",Body$2);__publicField(Modal$1,"CancelButton",CancelButton);__publicField(Modal$1,"Footer",Footer$2);__publicField(Modal$1,"Header",Header$3);__publicField(Modal$1,"Title",Title$2);__publicField(Modal$1,"propTypes",{dismissable:PropTypes$2.bool.isRequired,onClose:PropTypes$2.func.isRequired,open:PropTypes$2.bool.isRequired,size:PropTypes$2.oneOf(["lg","fullscreen"])});__publicField(Modal$1,"defaultProps",{dismissable:true});var _ref$3={name:"r2ff5g",styles:"visibility:visible;opacity:1;"};var _ref2$2={name:"ge94et",styles:"visibility:hidden;opacity:0;"};var animationState$1=function animationState$1(_ref138){var animationState2=_ref138.animationState;switch(animationState2){case"entering":case"entered":return _ref$3;case"exiting":case"exited":return _ref2$2;}};var Backdrop=createStyled("div",{target:"e1xrlb030"})("position:fixed;top:0;left:0;right:0;bottom:0;background:",transparentize("pewter",0.6),";transition:all 0.3s;z-index:1049;",animationState$1,";");Backdrop.displayName="Modal.Backdrop";var _ref$2={name:"8l3sia",styles:"visiblity:visible;opacity:1;transform:scale(1);"};var _ref2$1={name:"19mr2x1",styles:"visibility:hidden;opacity:0;transform:scale(1.15);"};var animationState=function animationState(_ref139){var animationState2=_ref139.animationState;switch(animationState2){case"entering":case"entered":return _ref$2;case"exiting":case"exited":return _ref2$1;}};var Container$a=createStyled("div",{target:"euhwfy0"})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center;transition:all 0.3s;",animationState,";");Container$a.displayName="Modal.Container";var blurBodyStyle={name:"1y5smrt",styles:"body > *:not(#modal-root){filter:blur(3px);}"};var Modal=/*#__PURE__*/function(_Component4){function Modal(){var _this9;_classCallCheck3(this,Modal);_this9=_callSuper(this,Modal);__publicField(_this9,"state",{open:false,transitioning:false});__publicField(_this9,"show",function(){return _this9.setState({open:true});});__publicField(_this9,"hide",function(){return _this9.setState({open:false});});__publicField(_this9,"setTransitioning",function(transitioning){return _this9.setState({transitioning:transitioning});});__publicField(_this9,"container",document.createElement("div"));__publicField(_this9,"modalRoot",document.getElementById("modal-root"));__publicField(_this9,"freezeScrolling",function(){_this9.initialBodyOverflow=document.body.style.overflow;document.body.style.overflow="hidden";});__publicField(_this9,"resetScrolling",function(){document.body.style.overflow=_this9.initialBodyOverflow;});__publicField(_this9,"handleKeydown",function(e2){var dismissable=_this9.props.dismissable;var open=_this9.state.open;if(!dismissable||!open){return;}switch(e2.keyCode){case ESC:_this9.hide();_this9.props.onDismiss&&_this9.props.onDismiss();break;}});return _this9;}_inherits3(Modal,_Component4);return _createClass3(Modal,[{key:"componentDidMount",value:function componentDidMount(){this.modalRoot.appendChild(this.container);document.addEventListener("keydown",this.handleKeydown);if(this.props.open){this.freezeScrolling();}}},{key:"componentDidUpdate",value:function componentDidUpdate(_prevProps,_ref140){var prevOpen=_ref140.open;var open=this.state.open;if(!prevOpen&&open){this.freezeScrolling();}if(prevOpen&&!open){this.resetScrolling();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.modalRoot.removeChild(this.container);this.resetScrolling();document.removeEventListener("keydown",this.handleKeydown);}},{key:"renderPortal",value:function renderPortal(){var _this0=this;var _this$props3=this.props,dismissable=_this$props3.dismissable,render3=_this$props3.render,lazyRender=_this$props3.lazyRender,blurBackground=_this$props3.blurBackground;var _this$state=this.state,open=_this$state.open,transitioning=_this$state.transitioning;var shouldRender=!lazyRender||open||transitioning;return Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["createPortal"])(/* @__PURE__ */jsx(_default$1,{"in":open,timeout:300,onEnter:function onEnter(){return _this0.setTransitioning(true);},onExited:function onExited(){return _this0.setTransitioning(false);},children:function children(state){return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[open&&blurBackground&&/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["b" /* Global */],{styles:blurBodyStyle}),/* @__PURE__ */jsx(Backdrop,{animationState:state}),/* @__PURE__ */jsx(Container$a,{animationState:state,onClick:dismissable?function(){_this0.hide();_this0.props.onDismiss&&_this0.props.onDismiss();}:null,children:shouldRender&&render3({hide:_this0.hide})})]});}}),this.container);}},{key:"render",value:function render(){var children=this.props.children;var open=this.state.open;return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[this.renderPortal(),children({show:this.show,open:open})]});}}]);}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);__publicField(Modal,"propTypes",{dismissable:PropTypes$2.bool.isRequired,onDismiss:PropTypes$2.func});__publicField(Modal,"defaultProps",{dismissable:true,onDismiss:noop$1});var Container$9=createStyled("div",{target:"eshyuc20"})("position:fixed;z-index:1200;display:flex;flex-direction:column-reverse;flex-flow:column-reverse;top:",spacer(4),";right:",spacer(5),";");Container$9.displayName="Notifications.Container";var Close=/* @__PURE__ */createStyled(CloseButton,{target:"eep1ne80"})("margin-left:",spacer(2),";margin-right:",spacer(2),";");Close.displayName="Notification.CloseButton";var Container$8=createStyled("div",{target:"e1r181jo0"})("color:",color("black"),";background:",color("white"),";width:375px;display:flex;align-items:center;overflow:hidden;",borderRadius$1("default"),";",shadow$1("raised"),";",typography$1("body2"),";");Container$8.displayName="Notification.Container";var ICON_SIZE="1.75rem";var PADDING_SIZE="xs";var IconContainer=createStyled("div",{target:"e1gvdc1a0"})(padding(PADDING_SIZE),";padding-right:0;svg{vertical-align:middle;}");IconContainer.displayName="Notification.IconContainer";var Icon=function Icon(_ref141){var kind2=_ref141.kind,renderIcon=_ref141.renderIcon;var props={width:ICON_SIZE,height:ICON_SIZE};var theme=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["b" /* useTheme */])();var iconColor=style("notifications.".concat(kind2,"IconColor"),{theme:theme});if(typeof renderIcon==="function"){return/* @__PURE__ */jsx(IconContainer,{children:renderIcon(props)});}switch(kind2){case"success":return/* @__PURE__ */jsx(IconContainer,{children:/* @__PURE__ */jsx(CheckCircle,__spreadProps(__spreadValues({},props),{color:iconColor}))});case"warning":return/* @__PURE__ */jsx(IconContainer,{children:/* @__PURE__ */jsx(AlertTriangle,__spreadProps(__spreadValues({},props),{color:iconColor}))});case"info":return/* @__PURE__ */jsx(IconContainer,{children:/* @__PURE__ */jsx(Info,__spreadProps(__spreadValues({},props),{color:iconColor}))});case"danger":return/* @__PURE__ */jsx(IconContainer,{children:/* @__PURE__ */jsx(AlertCircle,__spreadProps(__spreadValues({},props),{color:iconColor}))});default:return null;}};Icon.displayName="Notification.Icon";var Message=createStyled("div",{target:"e1sm55va0"})("flex:1;",padding("xs"),";");Message.displayName="Notification.Message";var NOTIFY="NOTIFY";var REMOVE_NOTIFICATION="REMOVE_NOTIFICATION";var id$1=1;var generateId$1=function generateId$1(){return String(id$1++);};var notify=function notify(type,message){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return{type:NOTIFY,payload:__spreadValues({type:type,message:message,sticky:false,timeout:3e3,dismissable:true,id:generateId$1(),onClick:function onClick(){},onClose:function onClose(){}},options)};};var removeNotification=function removeNotification(id){return{type:REMOVE_NOTIFICATION,payload:{id:id}};};var reducer$1=function reducer$1(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case NOTIFY:return[].concat(_toConsumableArray(state),[action.payload]);case REMOVE_NOTIFICATION:return state.filter(function(notification){return notification.id!==action.payload.id;});default:return state;}};var NotificationsContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({notifications:[],dispatch:function dispatch(){},notify:noop$1,removeNotification:noop$1});var NotificationsProvider=function NotificationsProvider(_ref142){var children=_ref142.children;var _useReducer2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(reducer$1,[]),_useReducer3=_slicedToArray(_useReducer2,2),notifications=_useReducer3[0],dispatch=_useReducer3[1];var notifyCallback=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){var action=notify.apply(void 0,arguments);dispatch(action);return action.payload.id;},[]);var removeNotificationCallback=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(id){return dispatch(removeNotification(id));},[]);return/* @__PURE__ */jsx(NotificationsContext.Provider,{value:{notify:notifyCallback,removeNotification:removeNotificationCallback,notifications:notifications},children:children});};var withNotifier=function withNotifier(Component2){return function(props){var value=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(NotificationsContext);return/* @__PURE__ */jsx(Component2,__spreadValues(__spreadValues({},props),value));};};var Notification=function Notification(_ref143){var notification=_ref143.notification,removeNotification2=_ref143.removeNotification,style2=_ref143.style;var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),timer=_useState14[0],setTimer=_useState14[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!notification.sticky){scheduleHide();}return function(){cancelHide();notification.onClose(notification);};},[]);var scheduleHide=function scheduleHide(){setTimer(setTimeout(remove,notification.timeout));};var cancelHide=function cancelHide(){clearTimeout(timer);};var handleOnClick=function handleOnClick(){notification.onClick(notification);};var handleDismiss=function handleDismiss(e2){e2.stopPropagation();remove();};var remove=function remove(){removeNotification2(notification.id);};return/* @__PURE__ */jsxs(Container$8,{onMouseOver:cancelHide,onMouseOut:notification.sticky?null:scheduleHide,onClick:handleOnClick,style:{minHeight:style2.minHeight,marginBottom:"".concat(style2.spacing,"rem"),opacity:style2.opacity,transform:"translate3d(".concat(style2.translate,"%, 0, 0) scaleY(").concat(style2.scaleY,")")},children:[/* @__PURE__ */jsx(Icon,{kind:notification.type,renderIcon:notification.renderIcon}),/* @__PURE__ */jsx(Message,{children:notification.message}),notification.dismissable&&/* @__PURE__ */jsx(Close,{onClick:handleDismiss})]});};var Notification$1=withNotifier(Notification);var Motion={exports:{}};var mapToZero={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]=mapToZero2;function mapToZero2(obj){var ret={};for(var key2 in obj){if(Object.prototype.hasOwnProperty.call(obj,key2)){ret[key2]=0;}}return ret;}module2.exports=exports["default"];})(mapToZero,mapToZero.exports);var stripStyle={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]=stripStyle2;function stripStyle2(style2){var ret={};for(var key2 in style2){if(!Object.prototype.hasOwnProperty.call(style2,key2)){continue;}ret[key2]=typeof style2[key2]==="number"?style2[key2]:style2[key2].val;}return ret;}module2.exports=exports["default"];})(stripStyle,stripStyle.exports);var stepper={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]=stepper2;var reusedTuple=[0,0];function stepper2(secondPerFrame,x,v2,destX,k2,b2,precision){var Fspring=-k2*(x-destX);var Fdamper=-b2*v2;var a=Fspring+Fdamper;var newV=v2+a*secondPerFrame;var newX=x+newV*secondPerFrame;if(Math.abs(newV)<precision&&Math.abs(newX-destX)<precision){reusedTuple[0]=destX;reusedTuple[1]=0;return reusedTuple;}reusedTuple[0]=newX;reusedTuple[1]=newV;return reusedTuple;}module2.exports=exports["default"];})(stepper,stepper.exports);var performanceNow$1={exports:{}};(function(){var getNanoSeconds,hrtime,loadTime;if(typeof performance!=="undefined"&&performance!==null&&performance.now){performanceNow$1.exports=function(){return performance.now();};}else if(typeof process!=="undefined"&&process!==null&&process.hrtime){performanceNow$1.exports=function(){return(getNanoSeconds()-loadTime)/1e6;};hrtime=process.hrtime;getNanoSeconds=function getNanoSeconds(){var hr;hr=hrtime();return hr[0]*1e9+hr[1];};loadTime=getNanoSeconds();}else if(Date.now){performanceNow$1.exports=function(){return Date.now()-loadTime;};loadTime=Date.now();}else{performanceNow$1.exports=function(){return new Date().getTime()-loadTime;};loadTime=new Date().getTime();}}).call(commonjsGlobal);var raf$1={exports:{}};var performanceNow={exports:{}};(function(){var getNanoSeconds,hrtime,loadTime,moduleLoadTime,nodeLoadTime,upTime;if(typeof performance!=="undefined"&&performance!==null&&performance.now){performanceNow.exports=function(){return performance.now();};}else if(typeof process!=="undefined"&&process!==null&&process.hrtime){performanceNow.exports=function(){return(getNanoSeconds()-nodeLoadTime)/1e6;};hrtime=process.hrtime;getNanoSeconds=function getNanoSeconds(){var hr;hr=hrtime();return hr[0]*1e9+hr[1];};moduleLoadTime=getNanoSeconds();upTime=process.uptime()*1e9;nodeLoadTime=moduleLoadTime-upTime;}else if(Date.now){performanceNow.exports=function(){return Date.now()-loadTime;};loadTime=Date.now();}else{performanceNow.exports=function(){return new Date().getTime()-loadTime;};loadTime=new Date().getTime();}}).call(commonjsGlobal);var now=performanceNow.exports,root=typeof window==="undefined"?commonjsGlobal:window,vendors=["moz","webkit"],suffix="AnimationFrame",raf=root["request"+suffix],caf=root["cancel"+suffix]||root["cancelRequest"+suffix];for(var i=0;!raf&&i<vendors.length;i++){raf=root[vendors[i]+"Request"+suffix];caf=root[vendors[i]+"Cancel"+suffix]||root[vendors[i]+"CancelRequest"+suffix];}if(!raf||!caf){var last=0,id=0,queue=[],frameDuration=1e3/60;raf=function raf(callback){if(queue.length===0){var _now=now(),next=Math.max(0,frameDuration-(_now-last));last=next+_now;setTimeout(function(){var cp=queue.slice(0);queue.length=0;var _loop3=function _loop3(){if(!cp[i].cancelled){try{cp[i].callback(last);}catch(e2){setTimeout(function(){throw e2;},0);}}};for(var i=0;i<cp.length;i++){_loop3();}},Math.round(next));}queue.push({handle:++id,callback:callback,cancelled:false});return id;};caf=function caf(handle){for(var i=0;i<queue.length;i++){if(queue[i].handle===handle){queue[i].cancelled=true;}}};}raf$1.exports=function(fn2){return raf.call(root,fn2);};raf$1.exports.cancel=function(){caf.apply(root,arguments);};raf$1.exports.polyfill=function(object){if(!object){object=root;}object.requestAnimationFrame=raf;object.cancelAnimationFrame=caf;};var shouldStopAnimation={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]=shouldStopAnimation2;function shouldStopAnimation2(currentStyle,style2,currentVelocity){for(var key2 in style2){if(!Object.prototype.hasOwnProperty.call(style2,key2)){continue;}if(currentVelocity[key2]!==0){return false;}var styleValue=typeof style2[key2]==="number"?style2[key2]:style2[key2].val;if(currentStyle[key2]!==styleValue){return false;}}return true;}module2.exports=exports["default"];})(shouldStopAnimation,shouldStopAnimation.exports);(function(module2,exports){exports.__esModule=true;var _extends2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _createClass2=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _mapToZero=mapToZero.exports;var _mapToZero2=_interopRequireDefault2(_mapToZero);var _stripStyle2=stripStyle.exports;var _stripStyle22=_interopRequireDefault2(_stripStyle2);var _stepper3=stepper.exports;var _stepper4=_interopRequireDefault2(_stepper3);var _performanceNow=performanceNow$1.exports;var _performanceNow2=_interopRequireDefault2(_performanceNow);var _raf=raf$1.exports;var _raf2=_interopRequireDefault2(_raf);var _shouldStopAnimation=shouldStopAnimation.exports;var _shouldStopAnimation2=_interopRequireDefault2(_shouldStopAnimation);var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _propTypes3=propTypes$2.exports;var _propTypes22=_interopRequireDefault2(_propTypes3);var msPerFrame=1e3/60;var Motion2=function(_React$Component){_inherits2(Motion3,_React$Component);_createClass2(Motion3,null,[{key:"propTypes",value:{defaultStyle:_propTypes22["default"].objectOf(_propTypes22["default"].number),style:_propTypes22["default"].objectOf(_propTypes22["default"].oneOfType([_propTypes22["default"].number,_propTypes22["default"].object])).isRequired,children:_propTypes22["default"].func.isRequired,onRest:_propTypes22["default"].func},enumerable:true}]);function Motion3(props){var _this=this;_classCallCheck2(this,Motion3);_React$Component.call(this,props);this.wasAnimating=false;this.animationID=null;this.prevTime=0;this.accumulatedTime=0;this.unreadPropStyle=null;this.clearUnreadPropStyle=function(destStyle){var dirty=false;var _state=_this.state;var currentStyle=_state.currentStyle;var currentVelocity=_state.currentVelocity;var lastIdealStyle=_state.lastIdealStyle;var lastIdealVelocity=_state.lastIdealVelocity;for(var key2 in destStyle){if(!Object.prototype.hasOwnProperty.call(destStyle,key2)){continue;}var styleValue=destStyle[key2];if(typeof styleValue==="number"){if(!dirty){dirty=true;currentStyle=_extends2({},currentStyle);currentVelocity=_extends2({},currentVelocity);lastIdealStyle=_extends2({},lastIdealStyle);lastIdealVelocity=_extends2({},lastIdealVelocity);}currentStyle[key2]=styleValue;currentVelocity[key2]=0;lastIdealStyle[key2]=styleValue;lastIdealVelocity[key2]=0;}}if(dirty){_this.setState({currentStyle:currentStyle,currentVelocity:currentVelocity,lastIdealStyle:lastIdealStyle,lastIdealVelocity:lastIdealVelocity});}};this.startAnimationIfNecessary=function(){_this.animationID=_raf2["default"](function(timestamp){var propsStyle=_this.props.style;if(_shouldStopAnimation2["default"](_this.state.currentStyle,propsStyle,_this.state.currentVelocity)){if(_this.wasAnimating&&_this.props.onRest){_this.props.onRest();}_this.animationID=null;_this.wasAnimating=false;_this.accumulatedTime=0;return;}_this.wasAnimating=true;var currentTime=timestamp||_performanceNow2["default"]();var timeDelta=currentTime-_this.prevTime;_this.prevTime=currentTime;_this.accumulatedTime=_this.accumulatedTime+timeDelta;if(_this.accumulatedTime>msPerFrame*10){_this.accumulatedTime=0;}if(_this.accumulatedTime===0){_this.animationID=null;_this.startAnimationIfNecessary();return;}var currentFrameCompletion=(_this.accumulatedTime-Math.floor(_this.accumulatedTime/msPerFrame)*msPerFrame)/msPerFrame;var framesToCatchUp=Math.floor(_this.accumulatedTime/msPerFrame);var newLastIdealStyle={};var newLastIdealVelocity={};var newCurrentStyle={};var newCurrentVelocity={};for(var key2 in propsStyle){if(!Object.prototype.hasOwnProperty.call(propsStyle,key2)){continue;}var styleValue=propsStyle[key2];if(typeof styleValue==="number"){newCurrentStyle[key2]=styleValue;newCurrentVelocity[key2]=0;newLastIdealStyle[key2]=styleValue;newLastIdealVelocity[key2]=0;}else{var newLastIdealStyleValue=_this.state.lastIdealStyle[key2];var newLastIdealVelocityValue=_this.state.lastIdealVelocity[key2];for(var i=0;i<framesToCatchUp;i++){var _stepper=_stepper4["default"](msPerFrame/1e3,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);newLastIdealStyleValue=_stepper[0];newLastIdealVelocityValue=_stepper[1];}var _stepper2=_stepper4["default"](msPerFrame/1e3,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);var nextIdealX=_stepper2[0];var nextIdealV=_stepper2[1];newCurrentStyle[key2]=newLastIdealStyleValue+(nextIdealX-newLastIdealStyleValue)*currentFrameCompletion;newCurrentVelocity[key2]=newLastIdealVelocityValue+(nextIdealV-newLastIdealVelocityValue)*currentFrameCompletion;newLastIdealStyle[key2]=newLastIdealStyleValue;newLastIdealVelocity[key2]=newLastIdealVelocityValue;}}_this.animationID=null;_this.accumulatedTime-=framesToCatchUp*msPerFrame;_this.setState({currentStyle:newCurrentStyle,currentVelocity:newCurrentVelocity,lastIdealStyle:newLastIdealStyle,lastIdealVelocity:newLastIdealVelocity});_this.unreadPropStyle=null;_this.startAnimationIfNecessary();});};this.state=this.defaultState();}Motion3.prototype.defaultState=function defaultState(){var _props=this.props;var defaultStyle2=_props.defaultStyle;var style2=_props.style;var currentStyle=defaultStyle2||_stripStyle22["default"](style2);var currentVelocity=_mapToZero2["default"](currentStyle);return{currentStyle:currentStyle,currentVelocity:currentVelocity,lastIdealStyle:currentStyle,lastIdealVelocity:currentVelocity};};Motion3.prototype.componentDidMount=function componentDidMount(){this.prevTime=_performanceNow2["default"]();this.startAnimationIfNecessary();};Motion3.prototype.componentWillReceiveProps=function componentWillReceiveProps(props){if(this.unreadPropStyle!=null){this.clearUnreadPropStyle(this.unreadPropStyle);}this.unreadPropStyle=props.style;if(this.animationID==null){this.prevTime=_performanceNow2["default"]();this.startAnimationIfNecessary();}};Motion3.prototype.componentWillUnmount=function componentWillUnmount(){if(this.animationID!=null){_raf2["default"].cancel(this.animationID);this.animationID=null;}};Motion3.prototype.render=function render3(){var renderedChildren=this.props.children(this.state.currentStyle);return renderedChildren&&_react22["default"].Children.only(renderedChildren);};return Motion3;}(_react22["default"].Component);exports["default"]=Motion2;module2.exports=exports["default"];})(Motion,Motion.exports);var StaggeredMotion={exports:{}};(function(module2,exports){exports.__esModule=true;var _extends2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _createClass2=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _mapToZero=mapToZero.exports;var _mapToZero2=_interopRequireDefault2(_mapToZero);var _stripStyle2=stripStyle.exports;var _stripStyle22=_interopRequireDefault2(_stripStyle2);var _stepper3=stepper.exports;var _stepper4=_interopRequireDefault2(_stepper3);var _performanceNow=performanceNow$1.exports;var _performanceNow2=_interopRequireDefault2(_performanceNow);var _raf=raf$1.exports;var _raf2=_interopRequireDefault2(_raf);var _shouldStopAnimation=shouldStopAnimation.exports;var _shouldStopAnimation2=_interopRequireDefault2(_shouldStopAnimation);var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _propTypes3=propTypes$2.exports;var _propTypes22=_interopRequireDefault2(_propTypes3);var msPerFrame=1e3/60;function shouldStopAnimationAll(currentStyles,styles2,currentVelocities){for(var i=0;i<currentStyles.length;i++){if(!_shouldStopAnimation2["default"](currentStyles[i],styles2[i],currentVelocities[i])){return false;}}return true;}var StaggeredMotion2=function(_React$Component){_inherits2(StaggeredMotion3,_React$Component);_createClass2(StaggeredMotion3,null,[{key:"propTypes",value:{defaultStyles:_propTypes22["default"].arrayOf(_propTypes22["default"].objectOf(_propTypes22["default"].number)),styles:_propTypes22["default"].func.isRequired,children:_propTypes22["default"].func.isRequired},enumerable:true}]);function StaggeredMotion3(props){var _this=this;_classCallCheck2(this,StaggeredMotion3);_React$Component.call(this,props);this.animationID=null;this.prevTime=0;this.accumulatedTime=0;this.unreadPropStyles=null;this.clearUnreadPropStyle=function(unreadPropStyles){var _state=_this.state;var currentStyles=_state.currentStyles;var currentVelocities=_state.currentVelocities;var lastIdealStyles=_state.lastIdealStyles;var lastIdealVelocities=_state.lastIdealVelocities;var someDirty=false;for(var i=0;i<unreadPropStyles.length;i++){var unreadPropStyle=unreadPropStyles[i];var dirty=false;for(var key2 in unreadPropStyle){if(!Object.prototype.hasOwnProperty.call(unreadPropStyle,key2)){continue;}var styleValue=unreadPropStyle[key2];if(typeof styleValue==="number"){if(!dirty){dirty=true;someDirty=true;currentStyles[i]=_extends2({},currentStyles[i]);currentVelocities[i]=_extends2({},currentVelocities[i]);lastIdealStyles[i]=_extends2({},lastIdealStyles[i]);lastIdealVelocities[i]=_extends2({},lastIdealVelocities[i]);}currentStyles[i][key2]=styleValue;currentVelocities[i][key2]=0;lastIdealStyles[i][key2]=styleValue;lastIdealVelocities[i][key2]=0;}}}if(someDirty){_this.setState({currentStyles:currentStyles,currentVelocities:currentVelocities,lastIdealStyles:lastIdealStyles,lastIdealVelocities:lastIdealVelocities});}};this.startAnimationIfNecessary=function(){_this.animationID=_raf2["default"](function(timestamp){var destStyles=_this.props.styles(_this.state.lastIdealStyles);if(shouldStopAnimationAll(_this.state.currentStyles,destStyles,_this.state.currentVelocities)){_this.animationID=null;_this.accumulatedTime=0;return;}var currentTime=timestamp||_performanceNow2["default"]();var timeDelta=currentTime-_this.prevTime;_this.prevTime=currentTime;_this.accumulatedTime=_this.accumulatedTime+timeDelta;if(_this.accumulatedTime>msPerFrame*10){_this.accumulatedTime=0;}if(_this.accumulatedTime===0){_this.animationID=null;_this.startAnimationIfNecessary();return;}var currentFrameCompletion=(_this.accumulatedTime-Math.floor(_this.accumulatedTime/msPerFrame)*msPerFrame)/msPerFrame;var framesToCatchUp=Math.floor(_this.accumulatedTime/msPerFrame);var newLastIdealStyles=[];var newLastIdealVelocities=[];var newCurrentStyles=[];var newCurrentVelocities=[];for(var i=0;i<destStyles.length;i++){var destStyle=destStyles[i];var newCurrentStyle={};var newCurrentVelocity={};var newLastIdealStyle={};var newLastIdealVelocity={};for(var key2 in destStyle){if(!Object.prototype.hasOwnProperty.call(destStyle,key2)){continue;}var styleValue=destStyle[key2];if(typeof styleValue==="number"){newCurrentStyle[key2]=styleValue;newCurrentVelocity[key2]=0;newLastIdealStyle[key2]=styleValue;newLastIdealVelocity[key2]=0;}else{var newLastIdealStyleValue=_this.state.lastIdealStyles[i][key2];var newLastIdealVelocityValue=_this.state.lastIdealVelocities[i][key2];for(var j=0;j<framesToCatchUp;j++){var _stepper=_stepper4["default"](msPerFrame/1e3,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);newLastIdealStyleValue=_stepper[0];newLastIdealVelocityValue=_stepper[1];}var _stepper2=_stepper4["default"](msPerFrame/1e3,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);var nextIdealX=_stepper2[0];var nextIdealV=_stepper2[1];newCurrentStyle[key2]=newLastIdealStyleValue+(nextIdealX-newLastIdealStyleValue)*currentFrameCompletion;newCurrentVelocity[key2]=newLastIdealVelocityValue+(nextIdealV-newLastIdealVelocityValue)*currentFrameCompletion;newLastIdealStyle[key2]=newLastIdealStyleValue;newLastIdealVelocity[key2]=newLastIdealVelocityValue;}}newCurrentStyles[i]=newCurrentStyle;newCurrentVelocities[i]=newCurrentVelocity;newLastIdealStyles[i]=newLastIdealStyle;newLastIdealVelocities[i]=newLastIdealVelocity;}_this.animationID=null;_this.accumulatedTime-=framesToCatchUp*msPerFrame;_this.setState({currentStyles:newCurrentStyles,currentVelocities:newCurrentVelocities,lastIdealStyles:newLastIdealStyles,lastIdealVelocities:newLastIdealVelocities});_this.unreadPropStyles=null;_this.startAnimationIfNecessary();});};this.state=this.defaultState();}StaggeredMotion3.prototype.defaultState=function defaultState(){var _props=this.props;var defaultStyles=_props.defaultStyles;var styles2=_props.styles;var currentStyles=defaultStyles||styles2().map(_stripStyle22["default"]);var currentVelocities=currentStyles.map(function(currentStyle){return _mapToZero2["default"](currentStyle);});return{currentStyles:currentStyles,currentVelocities:currentVelocities,lastIdealStyles:currentStyles,lastIdealVelocities:currentVelocities};};StaggeredMotion3.prototype.componentDidMount=function componentDidMount(){this.prevTime=_performanceNow2["default"]();this.startAnimationIfNecessary();};StaggeredMotion3.prototype.componentWillReceiveProps=function componentWillReceiveProps(props){if(this.unreadPropStyles!=null){this.clearUnreadPropStyle(this.unreadPropStyles);}this.unreadPropStyles=props.styles(this.state.lastIdealStyles);if(this.animationID==null){this.prevTime=_performanceNow2["default"]();this.startAnimationIfNecessary();}};StaggeredMotion3.prototype.componentWillUnmount=function componentWillUnmount(){if(this.animationID!=null){_raf2["default"].cancel(this.animationID);this.animationID=null;}};StaggeredMotion3.prototype.render=function render3(){var renderedChildren=this.props.children(this.state.currentStyles);return renderedChildren&&_react22["default"].Children.only(renderedChildren);};return StaggeredMotion3;}(_react22["default"].Component);exports["default"]=StaggeredMotion2;module2.exports=exports["default"];})(StaggeredMotion,StaggeredMotion.exports);var TransitionMotion$1={exports:{}};var mergeDiff={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]=mergeDiff2;function mergeDiff2(prev,next,onRemove){var prevKeyIndex={};for(var i=0;i<prev.length;i++){prevKeyIndex[prev[i].key]=i;}var nextKeyIndex={};for(var i=0;i<next.length;i++){nextKeyIndex[next[i].key]=i;}var ret=[];for(var i=0;i<next.length;i++){ret[i]=next[i];}for(var i=0;i<prev.length;i++){if(!Object.prototype.hasOwnProperty.call(nextKeyIndex,prev[i].key)){var fill=onRemove(i,prev[i]);if(fill!=null){ret.push(fill);}}}return ret.sort(function(a,b2){var nextOrderA=nextKeyIndex[a.key];var nextOrderB=nextKeyIndex[b2.key];var prevOrderA=prevKeyIndex[a.key];var prevOrderB=prevKeyIndex[b2.key];if(nextOrderA!=null&&nextOrderB!=null){return nextKeyIndex[a.key]-nextKeyIndex[b2.key];}else if(prevOrderA!=null&&prevOrderB!=null){return prevKeyIndex[a.key]-prevKeyIndex[b2.key];}else if(nextOrderA!=null){for(var i2=0;i2<next.length;i2++){var pivot=next[i2].key;if(!Object.prototype.hasOwnProperty.call(prevKeyIndex,pivot)){continue;}if(nextOrderA<nextKeyIndex[pivot]&&prevOrderB>prevKeyIndex[pivot]){return-1;}else if(nextOrderA>nextKeyIndex[pivot]&&prevOrderB<prevKeyIndex[pivot]){return 1;}}return 1;}for(var i2=0;i2<next.length;i2++){var pivot=next[i2].key;if(!Object.prototype.hasOwnProperty.call(prevKeyIndex,pivot)){continue;}if(nextOrderB<nextKeyIndex[pivot]&&prevOrderA>prevKeyIndex[pivot]){return 1;}else if(nextOrderB>nextKeyIndex[pivot]&&prevOrderA<prevKeyIndex[pivot]){return-1;}}return-1;});}module2.exports=exports["default"];})(mergeDiff,mergeDiff.exports);(function(module2,exports){exports.__esModule=true;var _extends2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _createClass2=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _mapToZero=mapToZero.exports;var _mapToZero2=_interopRequireDefault2(_mapToZero);var _stripStyle2=stripStyle.exports;var _stripStyle22=_interopRequireDefault2(_stripStyle2);var _stepper3=stepper.exports;var _stepper4=_interopRequireDefault2(_stepper3);var _mergeDiff=mergeDiff.exports;var _mergeDiff2=_interopRequireDefault2(_mergeDiff);var _performanceNow=performanceNow$1.exports;var _performanceNow2=_interopRequireDefault2(_performanceNow);var _raf=raf$1.exports;var _raf2=_interopRequireDefault2(_raf);var _shouldStopAnimation=shouldStopAnimation.exports;var _shouldStopAnimation2=_interopRequireDefault2(_shouldStopAnimation);var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _propTypes3=propTypes$2.exports;var _propTypes22=_interopRequireDefault2(_propTypes3);var msPerFrame=1e3/60;function rehydrateStyles(mergedPropsStyles,unreadPropStyles,plainStyles){var cUnreadPropStyles=unreadPropStyles;if(cUnreadPropStyles==null){return mergedPropsStyles.map(function(mergedPropsStyle,i){return{key:mergedPropsStyle.key,data:mergedPropsStyle.data,style:plainStyles[i]};});}return mergedPropsStyles.map(function(mergedPropsStyle,i){for(var j=0;j<cUnreadPropStyles.length;j++){if(cUnreadPropStyles[j].key===mergedPropsStyle.key){return{key:cUnreadPropStyles[j].key,data:cUnreadPropStyles[j].data,style:plainStyles[i]};}}return{key:mergedPropsStyle.key,data:mergedPropsStyle.data,style:plainStyles[i]};});}function shouldStopAnimationAll(currentStyles,destStyles,currentVelocities,mergedPropsStyles){if(mergedPropsStyles.length!==destStyles.length){return false;}for(var i=0;i<mergedPropsStyles.length;i++){if(mergedPropsStyles[i].key!==destStyles[i].key){return false;}}for(var i=0;i<mergedPropsStyles.length;i++){if(!_shouldStopAnimation2["default"](currentStyles[i],destStyles[i].style,currentVelocities[i])){return false;}}return true;}function mergeAndSync(willEnter,willLeave,didLeave,oldMergedPropsStyles,destStyles,oldCurrentStyles,oldCurrentVelocities,oldLastIdealStyles,oldLastIdealVelocities){var newMergedPropsStyles=_mergeDiff2["default"](oldMergedPropsStyles,destStyles,function(oldIndex,oldMergedPropsStyle){var leavingStyle=willLeave(oldMergedPropsStyle);if(leavingStyle==null){didLeave({key:oldMergedPropsStyle.key,data:oldMergedPropsStyle.data});return null;}if(_shouldStopAnimation2["default"](oldCurrentStyles[oldIndex],leavingStyle,oldCurrentVelocities[oldIndex])){didLeave({key:oldMergedPropsStyle.key,data:oldMergedPropsStyle.data});return null;}return{key:oldMergedPropsStyle.key,data:oldMergedPropsStyle.data,style:leavingStyle};});var newCurrentStyles=[];var newCurrentVelocities=[];var newLastIdealStyles=[];var newLastIdealVelocities=[];for(var i=0;i<newMergedPropsStyles.length;i++){var newMergedPropsStyleCell=newMergedPropsStyles[i];var foundOldIndex=null;for(var j=0;j<oldMergedPropsStyles.length;j++){if(oldMergedPropsStyles[j].key===newMergedPropsStyleCell.key){foundOldIndex=j;break;}}if(foundOldIndex==null){var plainStyle=willEnter(newMergedPropsStyleCell);newCurrentStyles[i]=plainStyle;newLastIdealStyles[i]=plainStyle;var velocity=_mapToZero2["default"](newMergedPropsStyleCell.style);newCurrentVelocities[i]=velocity;newLastIdealVelocities[i]=velocity;}else{newCurrentStyles[i]=oldCurrentStyles[foundOldIndex];newLastIdealStyles[i]=oldLastIdealStyles[foundOldIndex];newCurrentVelocities[i]=oldCurrentVelocities[foundOldIndex];newLastIdealVelocities[i]=oldLastIdealVelocities[foundOldIndex];}}return[newMergedPropsStyles,newCurrentStyles,newCurrentVelocities,newLastIdealStyles,newLastIdealVelocities];}var TransitionMotion2=function(_React$Component){_inherits2(TransitionMotion3,_React$Component);_createClass2(TransitionMotion3,null,[{key:"propTypes",value:{defaultStyles:_propTypes22["default"].arrayOf(_propTypes22["default"].shape({key:_propTypes22["default"].string.isRequired,data:_propTypes22["default"].any,style:_propTypes22["default"].objectOf(_propTypes22["default"].number).isRequired})),styles:_propTypes22["default"].oneOfType([_propTypes22["default"].func,_propTypes22["default"].arrayOf(_propTypes22["default"].shape({key:_propTypes22["default"].string.isRequired,data:_propTypes22["default"].any,style:_propTypes22["default"].objectOf(_propTypes22["default"].oneOfType([_propTypes22["default"].number,_propTypes22["default"].object])).isRequired}))]).isRequired,children:_propTypes22["default"].func.isRequired,willEnter:_propTypes22["default"].func,willLeave:_propTypes22["default"].func,didLeave:_propTypes22["default"].func},enumerable:true},{key:"defaultProps",value:{willEnter:function willEnter(styleThatEntered){return _stripStyle22["default"](styleThatEntered.style);},willLeave:function willLeave(){return null;},didLeave:function didLeave(){}},enumerable:true}]);function TransitionMotion3(props){var _this=this;_classCallCheck2(this,TransitionMotion3);_React$Component.call(this,props);this.unmounting=false;this.animationID=null;this.prevTime=0;this.accumulatedTime=0;this.unreadPropStyles=null;this.clearUnreadPropStyle=function(unreadPropStyles){var _mergeAndSync=mergeAndSync(_this.props.willEnter,_this.props.willLeave,_this.props.didLeave,_this.state.mergedPropsStyles,unreadPropStyles,_this.state.currentStyles,_this.state.currentVelocities,_this.state.lastIdealStyles,_this.state.lastIdealVelocities);var mergedPropsStyles=_mergeAndSync[0];var currentStyles=_mergeAndSync[1];var currentVelocities=_mergeAndSync[2];var lastIdealStyles=_mergeAndSync[3];var lastIdealVelocities=_mergeAndSync[4];for(var i=0;i<unreadPropStyles.length;i++){var unreadPropStyle=unreadPropStyles[i].style;var dirty=false;for(var key2 in unreadPropStyle){if(!Object.prototype.hasOwnProperty.call(unreadPropStyle,key2)){continue;}var styleValue=unreadPropStyle[key2];if(typeof styleValue==="number"){if(!dirty){dirty=true;currentStyles[i]=_extends2({},currentStyles[i]);currentVelocities[i]=_extends2({},currentVelocities[i]);lastIdealStyles[i]=_extends2({},lastIdealStyles[i]);lastIdealVelocities[i]=_extends2({},lastIdealVelocities[i]);mergedPropsStyles[i]={key:mergedPropsStyles[i].key,data:mergedPropsStyles[i].data,style:_extends2({},mergedPropsStyles[i].style)};}currentStyles[i][key2]=styleValue;currentVelocities[i][key2]=0;lastIdealStyles[i][key2]=styleValue;lastIdealVelocities[i][key2]=0;mergedPropsStyles[i].style[key2]=styleValue;}}}_this.setState({currentStyles:currentStyles,currentVelocities:currentVelocities,mergedPropsStyles:mergedPropsStyles,lastIdealStyles:lastIdealStyles,lastIdealVelocities:lastIdealVelocities});};this.startAnimationIfNecessary=function(){if(_this.unmounting){return;}_this.animationID=_raf2["default"](function(timestamp){if(_this.unmounting){return;}var propStyles=_this.props.styles;var destStyles=typeof propStyles==="function"?propStyles(rehydrateStyles(_this.state.mergedPropsStyles,_this.unreadPropStyles,_this.state.lastIdealStyles)):propStyles;if(shouldStopAnimationAll(_this.state.currentStyles,destStyles,_this.state.currentVelocities,_this.state.mergedPropsStyles)){_this.animationID=null;_this.accumulatedTime=0;return;}var currentTime=timestamp||_performanceNow2["default"]();var timeDelta=currentTime-_this.prevTime;_this.prevTime=currentTime;_this.accumulatedTime=_this.accumulatedTime+timeDelta;if(_this.accumulatedTime>msPerFrame*10){_this.accumulatedTime=0;}if(_this.accumulatedTime===0){_this.animationID=null;_this.startAnimationIfNecessary();return;}var currentFrameCompletion=(_this.accumulatedTime-Math.floor(_this.accumulatedTime/msPerFrame)*msPerFrame)/msPerFrame;var framesToCatchUp=Math.floor(_this.accumulatedTime/msPerFrame);var _mergeAndSync2=mergeAndSync(_this.props.willEnter,_this.props.willLeave,_this.props.didLeave,_this.state.mergedPropsStyles,destStyles,_this.state.currentStyles,_this.state.currentVelocities,_this.state.lastIdealStyles,_this.state.lastIdealVelocities);var newMergedPropsStyles=_mergeAndSync2[0];var newCurrentStyles=_mergeAndSync2[1];var newCurrentVelocities=_mergeAndSync2[2];var newLastIdealStyles=_mergeAndSync2[3];var newLastIdealVelocities=_mergeAndSync2[4];for(var i=0;i<newMergedPropsStyles.length;i++){var newMergedPropsStyle=newMergedPropsStyles[i].style;var newCurrentStyle={};var newCurrentVelocity={};var newLastIdealStyle={};var newLastIdealVelocity={};for(var key2 in newMergedPropsStyle){if(!Object.prototype.hasOwnProperty.call(newMergedPropsStyle,key2)){continue;}var styleValue=newMergedPropsStyle[key2];if(typeof styleValue==="number"){newCurrentStyle[key2]=styleValue;newCurrentVelocity[key2]=0;newLastIdealStyle[key2]=styleValue;newLastIdealVelocity[key2]=0;}else{var newLastIdealStyleValue=newLastIdealStyles[i][key2];var newLastIdealVelocityValue=newLastIdealVelocities[i][key2];for(var j=0;j<framesToCatchUp;j++){var _stepper=_stepper4["default"](msPerFrame/1e3,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);newLastIdealStyleValue=_stepper[0];newLastIdealVelocityValue=_stepper[1];}var _stepper2=_stepper4["default"](msPerFrame/1e3,newLastIdealStyleValue,newLastIdealVelocityValue,styleValue.val,styleValue.stiffness,styleValue.damping,styleValue.precision);var nextIdealX=_stepper2[0];var nextIdealV=_stepper2[1];newCurrentStyle[key2]=newLastIdealStyleValue+(nextIdealX-newLastIdealStyleValue)*currentFrameCompletion;newCurrentVelocity[key2]=newLastIdealVelocityValue+(nextIdealV-newLastIdealVelocityValue)*currentFrameCompletion;newLastIdealStyle[key2]=newLastIdealStyleValue;newLastIdealVelocity[key2]=newLastIdealVelocityValue;}}newLastIdealStyles[i]=newLastIdealStyle;newLastIdealVelocities[i]=newLastIdealVelocity;newCurrentStyles[i]=newCurrentStyle;newCurrentVelocities[i]=newCurrentVelocity;}_this.animationID=null;_this.accumulatedTime-=framesToCatchUp*msPerFrame;_this.setState({currentStyles:newCurrentStyles,currentVelocities:newCurrentVelocities,lastIdealStyles:newLastIdealStyles,lastIdealVelocities:newLastIdealVelocities,mergedPropsStyles:newMergedPropsStyles});_this.unreadPropStyles=null;_this.startAnimationIfNecessary();});};this.state=this.defaultState();}TransitionMotion3.prototype.defaultState=function defaultState(){var _props=this.props;var defaultStyles=_props.defaultStyles;var styles2=_props.styles;var willEnter=_props.willEnter;var willLeave=_props.willLeave;var didLeave=_props.didLeave;var destStyles=typeof styles2==="function"?styles2(defaultStyles):styles2;var oldMergedPropsStyles=void 0;if(defaultStyles==null){oldMergedPropsStyles=destStyles;}else{oldMergedPropsStyles=defaultStyles.map(function(defaultStyleCell){for(var i=0;i<destStyles.length;i++){if(destStyles[i].key===defaultStyleCell.key){return destStyles[i];}}return defaultStyleCell;});}var oldCurrentStyles=defaultStyles==null?destStyles.map(function(s){return _stripStyle22["default"](s.style);}):defaultStyles.map(function(s){return _stripStyle22["default"](s.style);});var oldCurrentVelocities=defaultStyles==null?destStyles.map(function(s){return _mapToZero2["default"](s.style);}):defaultStyles.map(function(s){return _mapToZero2["default"](s.style);});var _mergeAndSync3=mergeAndSync(willEnter,willLeave,didLeave,oldMergedPropsStyles,destStyles,oldCurrentStyles,oldCurrentVelocities,oldCurrentStyles,oldCurrentVelocities);var mergedPropsStyles=_mergeAndSync3[0];var currentStyles=_mergeAndSync3[1];var currentVelocities=_mergeAndSync3[2];var lastIdealStyles=_mergeAndSync3[3];var lastIdealVelocities=_mergeAndSync3[4];return{currentStyles:currentStyles,currentVelocities:currentVelocities,lastIdealStyles:lastIdealStyles,lastIdealVelocities:lastIdealVelocities,mergedPropsStyles:mergedPropsStyles};};TransitionMotion3.prototype.componentDidMount=function componentDidMount(){this.prevTime=_performanceNow2["default"]();this.startAnimationIfNecessary();};TransitionMotion3.prototype.componentWillReceiveProps=function componentWillReceiveProps(props){if(this.unreadPropStyles){this.clearUnreadPropStyle(this.unreadPropStyles);}var styles2=props.styles;if(typeof styles2==="function"){this.unreadPropStyles=styles2(rehydrateStyles(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.lastIdealStyles));}else{this.unreadPropStyles=styles2;}if(this.animationID==null){this.prevTime=_performanceNow2["default"]();this.startAnimationIfNecessary();}};TransitionMotion3.prototype.componentWillUnmount=function componentWillUnmount(){this.unmounting=true;if(this.animationID!=null){_raf2["default"].cancel(this.animationID);this.animationID=null;}};TransitionMotion3.prototype.render=function render3(){var hydratedStyles=rehydrateStyles(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.currentStyles);var renderedChildren=this.props.children(hydratedStyles);return renderedChildren&&_react22["default"].Children.only(renderedChildren);};return TransitionMotion3;}(_react22["default"].Component);exports["default"]=TransitionMotion2;module2.exports=exports["default"];})(TransitionMotion$1,TransitionMotion$1.exports);var spring$1={exports:{}};var presets={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]={noWobble:{stiffness:170,damping:26},gentle:{stiffness:120,damping:14},wobbly:{stiffness:180,damping:12},stiff:{stiffness:210,damping:20}};module2.exports=exports["default"];})(presets,presets.exports);(function(module2,exports){exports.__esModule=true;var _extends2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};exports["default"]=spring2;function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}var _presets2=presets.exports;var _presets22=_interopRequireDefault2(_presets2);var defaultConfig=_extends2({},_presets22["default"].noWobble,{precision:0.01});function spring2(val,config){return _extends2({},defaultConfig,config,{val:val});}module2.exports=exports["default"];})(spring$1,spring$1.exports);var reorderKeys={exports:{}};(function(module2,exports){exports.__esModule=true;exports["default"]=reorderKeys2;function reorderKeys2(){}module2.exports=exports["default"];})(reorderKeys,reorderKeys.exports);function _interopRequire(obj){return obj&&obj.__esModule?obj["default"]:obj;}var _Motion=Motion.exports;_interopRequire(_Motion);var _StaggeredMotion=StaggeredMotion.exports;_interopRequire(_StaggeredMotion);var _TransitionMotion=TransitionMotion$1.exports;var TransitionMotion=_interopRequire(_TransitionMotion);var _spring=spring$1.exports;var spring=_interopRequire(_spring);var _presets=presets.exports;_interopRequire(_presets);var _stripStyle=stripStyle.exports;_interopRequire(_stripStyle);var _reorderKeys=reorderKeys.exports;_interopRequire(_reorderKeys);var springConfig={stiffness:120,damping:15};var Notifications=function Notifications(){var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(NotificationsContext),notifications=_useContext2.notifications;return/* @__PURE__ */jsx(TransitionMotion,{styles:notifications.map(function(notification){return{key:notification.id,data:notification,style:{spacing:spring(1,springConfig),minHeight:spring(56,springConfig),scaleY:spring(1,springConfig),translate:spring(0,springConfig),opacity:spring(1)}};}),willEnter:function willEnter(){return{spacing:0,minHeight:0,scaleY:0,opacity:0,translate:100};},willLeave:function willLeave(){return{spacing:spring(0,springConfig),minHeight:spring(0),scaleY:spring(0),opacity:spring(0),translate:spring(100,springConfig)};},children:function children(styles2){return/* @__PURE__ */jsx(Container$9,{children:styles2.map(function(_ref144){var key2=_ref144.key,data=_ref144.data,style2=_ref144.style;return/* @__PURE__ */jsx(Notification$1,{notification:data,style:style2},key2);})});}});};var visibility=function visibility(_ref145){var open=_ref145.open;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("visibility:",open?"visible":"hidden",";");};var Container$7=createStyled("div",{target:"e1tb1c8o0"})("display:flex;justify-content:center;align-items:center;max-width:100%;z-index:1020;",visibility,";");Container$7.displayName="Popover.Container";var Popover$1=/*#__PURE__*/function(_Component5){function Popover$1(props){var _this1;_classCallCheck3(this,Popover$1);_this1=_callSuper(this,Popover$1,[props]);__publicField(_this1,"state",{open:false});__publicField(_this1,"popoverRoot",document.getElementById("popover-root"));__publicField(_this1,"show",function(){return _this1.setState({open:true});});__publicField(_this1,"hide",function(){return _this1.setState({open:false});});__publicField(_this1,"toggle",function(){return _this1.setState({open:!_this1.state.open});});return _this1;}_inherits3(Popover$1,_Component5);return _createClass3(Popover$1,[{key:"render",value:function render(){var _this10=this;var _this$props4=this.props,placement=_this$props4.placement,_children5=_this$props4.children;var open=this.state.open;var popover=/* @__PURE__ */jsx(Popper,{placement:placement,children:function children(_ref146){var ref=_ref146.ref,placement2=_ref146.placement,style2=_ref146.style;return/* @__PURE__ */jsx(Container$7,{ref:ref,style:style2,"data-placement":placement2,open:open,children:_this10.props.render({hide:_this10.hide})});}});var reference2=/* @__PURE__ */jsx(Reference,{children:function children(_ref147){var ref=_ref147.ref;return _children5({ref:ref,hide:_this10.hide,show:_this10.show,toggle:_this10.toggle});}});return/* @__PURE__ */jsx(Manager,{children:/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[reference2,Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["createPortal"])(popover,this.popoverRoot)]})});}}]);}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);__publicField(Popover$1,"defaultProps",{placement:"top",render:noop$1});var RadioButtonHidden=withProps$1({type:"radio"})(createStyled("input",{target:"e18d846u0"})({name:"sxypit",styles:"position:absolute;opacity:0;z-index:-1;"}));var radioButtonBackgroundStyle=function radioButtonBackgroundStyle(_ref148){var disabled=_ref148.disabled,dark2=_ref148.dark;if(disabled){return dark2?"disabledDarkBackground":"disabledBackground";}return dark2?"darkBackground":"background";};var radioButtonBorderStyle=function radioButtonBorderStyle(_ref149){var checked=_ref149.checked,disabled=_ref149.disabled,valid2=_ref149.valid,dark2=_ref149.dark;if(disabled){return dark2?"disabledDarkColor":"disabledColor";}else if(!valid2){return"invalidBorder";}return checked?"checkedColor":"border";};var hoverBorderStyle=function hoverBorderStyle(_ref150){var disabled=_ref150.disabled,valid2=_ref150.valid,dark2=_ref150.dark;if(disabled){return dark2?"disabledDarkColor":"disabledColor";}else if(!valid2){return"invalidBorder";}else{return"hoverBorder";}};var findStyle=function findStyle(props){var fn2=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(key2){return key2;};var styleKey=fn2(props);if(styleKey){return style("radio.".concat(styleKey))({theme:props.theme});}return"transparent";};var RadioButtonDisplay=createStyled("div",{target:"e1wsahgu0"})("background-color:",function(props){return findStyle(props,radioButtonBackgroundStyle);},";border:solid 0.0675rem ",function(props){return findStyle(props,radioButtonBorderStyle);},";border-radius:50%;height:",spacer(4),";width:",spacer(4),";display:inline-block;margin-right:",spacer(3),";margin-left:-1px;vertical-align:middle;&:hover{border-color:",function(props){return findStyle(props,hoverBorderStyle);},";}");var Label=createStyled("label",{target:"e1og91dm0"})("display:grid;grid-auto-flow:column;grid-template-columns:auto 1fr;align-items:center;justify-items:start;cursor:",function(_ref151){var disabled=_ref151.disabled;return disabled?"not-allowed":"pointer";},";");var LabelText=createStyled("span",{target:"e1og91dm1"})("margin-bottom:0;color:",function(_ref152){var disabled=_ref152.disabled,dark2=_ref152.dark;return disabled?dark2?color("slate"):transparentize("slate",0.5):dark2?color("silver"):color("slate");},";vertical-align:middle;");var RadioButtonContainer=createStyled("div",{target:"e1og91dm2"})({name:"79elbk",styles:"position:relative;"});var fillStyle=function fillStyle(disabled,dark2){return!disabled?"checkedColor":dark2?"disabledDarkColor":"disabledColor";};var RadioButton=function RadioButton(_Xa){var _Ya=_Xa,checked=_Ya.checked,label=_Ya.label,disabled=_Ya.disabled,valid2=_Ya.valid,id=_Ya.id,theme=_Ya.theme,dark2=_Ya.dark,rest=__objRest(_Ya,["checked","label","disabled","valid","id","theme","dark"]);return/* @__PURE__ */jsxs(RadioButtonContainer,{children:[/* @__PURE__ */jsx(RadioButtonHidden,__spreadValues({checked:checked,disabled:disabled,id:id},rest)),/* @__PURE__ */jsxs(Label,{disabled:disabled,htmlFor:id,children:[/* @__PURE__ */jsx(RadioButtonDisplay,{checked:checked,disabled:disabled,valid:valid2,dark:dark2,children:/* @__PURE__ */jsx("svg",{viewBox:"-10 -10 20 20",children:/* @__PURE__ */jsx("g",{fill:"none",children:checked&&/* @__PURE__ */jsx("circle",{r:"6",fill:style("radio.".concat(fillStyle(disabled,dark2)))({theme:theme})})})})}),/* @__PURE__ */jsx(LabelText,{dark:dark2,disabled:disabled,children:label})]})]});};RadioButton.propTypes={checked:PropTypes$2.bool,disabled:PropTypes$2.bool,label:PropTypes$2.node,valid:PropTypes$2.bool,id:PropTypes$2.string.isRequired,onChange:PropTypes$2.func};RadioButton.defaultProps={onChange:function onChange(){},checked:false,disabled:false,valid:true};var index=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(RadioButton);var Row$2=createStyled("section",{target:"eza7hn50"})("width:100%;display:flex;flex-direction:column;align-items:center;@supports (display:grid){display:grid;justify-items:center;justify-content:unset;align-items:unset;grid-auto-flow:row;grid-gap:",spacer(4),";}");var deletable=function deletable(_ref153){var deletable2=_ref153.deletable,theme=_ref153.theme;return deletable2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding-right:",spacer(2,{theme:theme}),";");};var selectable=function selectable(_ref154){var selectable2=_ref154.selectable,selected=_ref154.selected,theme=_ref154.theme;return selectable2?/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("cursor:pointer;color:",color(selected?"white":"slate",{theme:theme}),";background-color:",color(selected?"slate":"paleGrey",{theme:theme}),";&:hover{background-color:",!selected&&style("tag.selectable.hoverBackground",{theme:theme}),";}"):/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color("slate",{theme:theme}),";background-color:",color("paleGrey",{theme:theme}),";");};var Container$6=createStyled("span",{target:"e161cj430"})("display:inline-block;border-radius:2rem;padding:",spacer(1)," ",spacer(3),";transition:margin-right 0.3s ease 0s;",typography$1("body1Medium"),";",selectable,";",deletable,";&.stylist-tag:not(:last-of-type){margin-right:",spacer(2),";}");var InnerContainer=createStyled("div",{target:"e161cj431"})("display:flex;flex-direction:justify-content;align-items:center;button{margin-left:",spacer(1),";}");var Tag=function Tag(_ref155){var children=_ref155.children,deletable2=_ref155.deletable,id=_ref155.id,selectable2=_ref155.selectable,selected=_ref155.selected,onDelete=_ref155.onDelete,onSelect=_ref155.onSelect;return/* @__PURE__ */jsx(Container$6,{className:"stylist-tag",deletable:deletable2,selectable:selectable2,selected:selected,onClick:selectable2?function(){return onSelect(id);}:null,children:/* @__PURE__ */jsxs(InnerContainer,{children:[children,deletable2&&/* @__PURE__ */jsx(CloseButton,{size:"1rem",onClick:function onClick(){return onDelete(id);}})]})});};var brand$1={brandGreen:"#00cc52",lightBrandGreen:"#5ae070",lighterBrandGreen:"#82eb7f",brandMain:"#FF00FF",ink:"#00253B",slate:"#3e5467",pewter:"#627585",cadet:"#8394a3",silver:"#cbd2d6",paleGrey:"#e4e8eb",offWhite:"#F7F9FA",white:"#fff",black:"#2e3033",green:"#39a84c",lightGreen:"#CEF5D4",red:"#f5496c",lightRed:"#FFDBE2",darkRed:"#F21945",orange:"#e07a04",lightOrange:"#FFEAD1",blue:"#428fdb",lightBlue:"#D4E7FA",royalBlue:"#62a1f3",darkPurple:"#5641cc",purple:"#725ee0",ocean:"#1B73B3",forest:"#1A825F",darkOcean:"#07558c",greenGradient:{start:"#00c753",end:"#00d4e8"},blueGradient:{start:"#00d4e8",end:"#786ce9"},purpleGradient:{start:"#a379ff",end:"#786ce9"},bluePinkGradient:{start:"#3023ae",end:"#c86dd7"}};var borderRadius={sm:"2px","default":"4px",lg:"6px"};var base="16px";var font={base:base,lineHeight:{xxxl:rem$1("64px",base),xxl:rem$1("48px",base),xl:rem$1("36px",base),l:rem$1("30px",base),m:rem$1("24px",base),s:rem$1("22px",base),xs:rem$1("20px",base),xxs:rem$1("17px",base),xxxs:rem$1("15px",base)},size:{xxxl:rem$1("48px",base),xxl:rem$1("36px",base),xl:rem$1("28px",base),l:rem$1("22px",base),m:rem$1("18px",base),s:rem$1("16px",base),xs:rem$1("14px",base),xxs:rem$1("12px",base),xxxs:rem$1("11px",base)},weight:{regular:400,medium:500,bold:700,black:900}};var shadow={subtle:"0 1px 3px 0 rgba(22, 38, 59, 0.08)",close:"0 2px 6px 0 rgba(22, 38, 59, 0.14)",raised:"0 3px 8px 0 rgba(22, 38, 59, 0.2)",distant:"0 4px 12px 0 rgba(22, 38, 59, 0.28)"};var size$2={spacer1:rem$1("4px",font.base),spacer2:rem$1("8px",font.base),spacer3:rem$1("14px",font.base),spacer4:rem$1("20px",font.base),spacer5:rem$1("28px",font.base),spacer6:rem$1("36px",font.base),spacer7:rem$1("48px",font.base),spacer8:rem$1("60px",font.base)};var spacing={size:size$2,xxxs:{x:size$2.spacer2,y:size$2.spacer1},xxs:{x:size$2.spacer3,y:size$2.spacer2},xs:{x:size$2.spacer4,y:size$2.spacer3},sm:{x:size$2.spacer5,y:size$2.spacer4},md:{x:size$2.spacer6,y:size$2.spacer5},lg:{x:size$2.spacer7,y:size$2.spacer6},xl:{x:size$2.spacer8,y:size$2.spacer7}};var lineHeight=font.lineHeight,size$1=font.size,weight=font.weight;var typography={headline3:{lineHeight:lineHeight.xxxl,fontSize:size$1.xxxl,fontWeight:weight.regular},headline2:{lineHeight:lineHeight.xxl,fontSize:size$1.xxl,fontWeight:weight.regular},headline1:{lineHeight:lineHeight.xl,fontSize:size$1.xl,fontWeight:weight.medium},title3:{lineHeight:lineHeight.l,fontSize:size$1.l,fontWeight:weight.medium},title2:{lineHeight:lineHeight.m,fontSize:size$1.m,fontWeight:weight.bold},title1:{lineHeight:lineHeight.s,fontSize:size$1.s,fontWeight:weight.bold},subheading3:{lineHeight:lineHeight.xs,fontSize:size$1.xs,fontWeight:weight.black,textTransform:"uppercase",letterSpacing:"0.8px"},subheading2:{lineHeight:lineHeight.xxs,fontSize:size$1.xxs,fontWeight:weight.black,textTransform:"uppercase",letterSpacing:"0.8px"},subheading1:{lineHeight:lineHeight.xxxs,fontSize:size$1.xxxs,fontWeight:weight.black,textTransform:"uppercase",letterSpacing:"0.8px"},body4:{lineHeight:lineHeight.m,fontSize:size$1.m,fontWeight:weight.regular},body4Medium:{lineHeight:lineHeight.m,fontSize:size$1.m,fontWeight:weight.medium},body3:{lineHeight:lineHeight.s,fontSize:size$1.s,fontWeight:weight.regular},body3Medium:{lineHeight:lineHeight.s,fontSize:size$1.s,fontWeight:weight.medium},body2:{lineHeight:lineHeight.xs,fontSize:size$1.xs,fontWeight:weight.regular},body2Medium:{lineHeight:lineHeight.xs,fontSize:size$1.xs,fontWeight:weight.medium},body1:{lineHeight:lineHeight.xxs,fontSize:size$1.xxs,fontWeight:weight.regular},body1Medium:{lineHeight:lineHeight.xxs,fontSize:size$1.xxs,fontWeight:weight.medium},numeral6:{lineHeight:lineHeight.xxxl,fontSize:size$1.xxxl,fontWeight:weight.regular},numeral5:{lineHeight:lineHeight.xxl,fontSize:size$1.xxl,fontWeight:weight.regular},numeral4:{lineHeight:lineHeight.xl,fontSize:size$1.xl,fontWeight:weight.regular},numeral3:{lineHeight:lineHeight.l,fontSize:size$1.l,fontWeight:weight.medium},numeral2:{lineHeight:lineHeight.m,fontSize:size$1.m,fontWeight:weight.medium},numeral1:{lineHeight:lineHeight.s,fontSize:size$1.s,fontWeight:weight.medium}};var fvStyles={cookieBanner:{background:brand$1.slate},globalHeader:{topBorderColor:brand$1.brandGreen},logoPath:{fill:brand$1.brandMain},dropdown:{checkIconColor:brand$1.brandGreen},input:{valid:{border:brand$1.paleGrey,focusBorder:brand$1.brandGreen},invalid:{border:brand$1.red,focusBorder:brand$1.red}},tabs:{navLink:{underlineColor:brand$1.brandGreen,hoverUnderlineColor:"transparent"}},tag:{selectable:{hoverBackground:rgba(brand$1.brandGreen,0.25)}},table:{row:{hoverBackground:rgba(brand$1.brandGreen,0.15)}},uploader:{hoverBorder:brand$1.brandGreen,hoverBackground:rgba(brand$1.lightGreen,0.5)},checkbox:{border:brand$1.cadet,invalidBorder:brand$1.red,disabledBorder:brand$1.silver,disabledBackground:brand$1.offWhite,checkedBackground:brand$1.brandGreen,checkedDisabledBackground:brand$1.silver},radio:{checkedColor:brand$1.brandGreen,disabledColor:brand$1.silver,disabledDarkColor:brand$1.pewter,border:brand$1.cadet,hoverBorder:brand$1.brandGreen,invalidBorder:brand$1.red,background:brand$1.white,darkBackground:"transparent",disabledBackground:brand$1.offWhite,disabledDarkBackground:"transparent"},listbox:{hoverBackground:rgba(brand$1.brandGreen,0.15),focusedBackground:rgba(brand$1.brandGreen,0.15),selectedBackground:rgba(brand$1.brandGreen,0.15),disabledColor:rgba(brand$1.slate,0.4)},notifications:{successIconColor:brand$1.brandGreen,warningIconColor:brand$1.orange,infoIconColor:brand$1.blue,dangerIconColor:brand$1.red},button:{primary:{color:brand$1.ink,background:brand$1.lightBrandGreen,border:brand$1.lightBrandGreen,hoverBackground:brand$1.lighterBrandGreen,hoverBorder:brand$1.lighterBrandGreen,disabledColor:brand$1.white,disabledBackground:brand$1.silver,disabledBorder:brand$1.silver},standardDark:{color:brand$1.white,background:brand$1.ink,border:rgba(brand$1.offWhite,0.5),hoverColor:brand$1.ink,hoverBackground:brand$1.white,hoverBorder:brand$1.white,disabledColor:rgba(brand$1.offWhite,0.3),disabledBackground:rgba(brand$1.offWhite,0.2),disabledBorder:"transparent"},standard:{color:brand$1.slate,background:brand$1.white,border:rgba(brand$1.slate,0.5),hoverColor:brand$1.white,hoverBackground:brand$1.slate,hoverBorder:brand$1.slate,disabledColor:rgba(brand$1.slate,0.3),disabledBackground:rgba(brand$1.slate,0.1),disabledBorder:"transparent"},utilityDark:{color:brand$1.offWhite,background:rgba(brand$1.offWhite,0.2),border:"transparent",hoverBackground:rgba(brand$1.offWhite,0.3),disabledColor:rgba(brand$1.offWhite,0.3),disabledBackground:rgba(brand$1.offWhite,0.2)},utility:{color:brand$1.slate,background:rgba(brand$1.slate,0.08),border:"transparent",hoverBackground:rgba(brand$1.slate,0.16),disabledColor:rgba(brand$1.slate,0.3),disabledBackground:rgba(brand$1.slate,0.1)},ghostDark:{color:brand$1.offWhite,background:"none",border:"transparent",hoverBackground:rgba(brand$1.offWhite,0.16),disabledColor:rgba(brand$1.offWhite,0.3),disabledBackground:"none"},ghost:{color:brand$1.slate,background:"none",border:"transparent",hoverBackground:rgba(brand$1.slate,0.08),disabledColor:rgba(brand$1.slate,0.3),disabledBackground:"inherit"},danger:{color:brand$1.offWhite,background:brand$1.red,border:brand$1.red,hoverBackground:brand$1.darkRed,hoverBorder:brand$1.darkRed,disabledColor:brand$1.white,disabledBackground:brand$1.silver,disabledBorder:brand$1.silver}}};var fvStyle=/* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({__proto__:null,brand:brand$1,borderRadius:borderRadius,font:font,shadow:shadow,spacing:spacing,typography:typography,styles:fvStyles},Symbol.toStringTag,{value:"Module"}));var brand={brandMagenta:"#FF00FF",brandBlue:"#007DB8",darkBrandBlue:"#006CA1",darkerBrandBlue:"#005B87",ink:"#00253B",slate:"#3e5467",pewter:"#627585",cadet:"#8394a3",darkGrey:"#b8babd",silver:"#cbd2d6",grey:"#e2e3e4",paleGrey:"#e4e8eb",offWhite:"#F7F9FA",white:"#fff",black:"#2e3033",green:"#39a84c",lightGreen:"#CEF5D4",red:"#f5496c",lightRed:"#FFDBE2",darkRed:"#F21945",orange:"#e07a04",lightOrange:"#FFEAD1",blue:"#428fdb",lightBlue:"#D4E7FA",royalBlue:"#62a1f3",darkPurple:"#5641cc",purple:"#725ee0",ocean:"#1B73B3",forest:"#1A825F",darkOcean:"#07558c",greenGradient:{start:"#00c753",end:"#00d4e8"},blueGradient:{start:"#00d4e8",end:"#786ce9"},purpleGradient:{start:"#a379ff",end:"#786ce9"},bluePinkGradient:{start:"#3023ae",end:"#c86dd7"}};var styles={cookieBanner:{background:brand.ink},globalHeader:fvStyles.globalHeader,logoPath:{fill:brand.brandMagenta},dropdown:{checkIconColor:brand.brandBlue},input:{valid:{border:brand.paleGrey,focusBorder:brand.brandBlue},invalid:{border:brand.red,focusBorder:brand.red}},tabs:{navLink:{underlineColor:brand.brandBlue,hoverUnderlineColor:"transparent"}},tag:fvStyles.tag,table:fvStyles.table,uploader:{hoverBorder:brand.brandBlue,hoverBackground:rgba(brand.brandBlue,0.08)},checkbox:{border:brand.cadet,invalidBorder:brand.red,disabledBorder:brand.silver,disabledBackground:brand.offWhite,checkedBackground:brand.brandBlue,checkedDisabledBackground:brand.silver},radio:{checkedColor:brand.brandBlue,disabledColor:brand.silver,disabledDarkColor:brand.pewter,border:brand.cadet,hoverBorder:brand.brandBlue,invalidBorder:brand.red,background:brand.white,darkBackground:"transparent",disabledBackground:brand.offWhite,disabledDarkBackground:"transparent"},listbox:{hoverBackground:rgba(brand.brandBlue,0.16),focusedBackground:rgba(brand.brandBlue,0.16),selectedBackground:rgba(brand.brandBlue,0.16),disabledColor:rgba(brand.slate,0.4)},notifications:{successIconColor:brand.green,warningIconColor:brand.orange,infoIconColor:brand.blue,dangerIconColor:brand.red},button:{primary:{color:brand.white,background:brand.brandBlue,border:brand.brandBlue,hoverBackground:brand.darkBrandBlue,hoverBorder:brand.darkBrandBlue,activeBackground:brand.darkerBrandBlue,activeBorder:brand.darkerBrandBlue,disabledColor:brand.darkGrey,disabledBackground:brand.grey,disabledBorder:brand.grey},primaryDark:{color:brand.ink,background:brand.silver,border:"transparent",hoverBackground:brand.white,activeBackground:brand.white,disabledColor:brand.darkGrey,disabledBackground:brand.grey,disabledBorder:brand.grey},standardDark:{color:brand.white,background:brand.ink,border:rgba(brand.offWhite,0.5),hoverColor:brand.ink,hoverBackground:brand.white,hoverBorder:brand.white,disabledColor:rgba(brand.offWhite,0.3),disabledBackground:rgba(brand.offWhite,0.2),disabledBorder:"transparent"},standard:{color:brand.slate,background:brand.white,border:rgba(brand.slate,0.5),hoverColor:brand.white,hoverBackground:brand.slate,hoverBorder:brand.slate,disabledColor:rgba(brand.slate,0.3),disabledBackground:rgba(brand.slate,0.1),disabledBorder:"transparent"},utilityDark:{color:brand.offWhite,background:rgba(brand.offWhite,0.2),border:"transparent",hoverBackground:rgba(brand.offWhite,0.3),disabledColor:rgba(brand.offWhite,0.3),disabledBackground:rgba(brand.offWhite,0.2)},utility:{color:brand.slate,background:rgba(brand.slate,0.08),border:"transparent",hoverBackground:rgba(brand.slate,0.16),disabledColor:rgba(brand.slate,0.3),disabledBackground:rgba(brand.slate,0.1)},ghostDark:{color:brand.offWhite,background:"none",border:"transparent",hoverBackground:rgba(brand.offWhite,0.16),disabledColor:rgba(brand.offWhite,0.3),disabledBackground:"none"},ghost:{color:brand.slate,background:"none",border:"transparent",hoverBackground:rgba(brand.slate,0.08),disabledColor:rgba(brand.slate,0.3),disabledBackground:"inherit"},danger:{color:brand.offWhite,background:brand.red,border:brand.red,hoverBackground:brand.darkRed,hoverBorder:brand.darkRed,disabledColor:brand.white,disabledBackground:brand.silver,disabledBorder:brand.silver}}};var forsta=/* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({__proto__:null,borderRadius:borderRadius,font:font,shadow:shadow,spacing:spacing,typography:typography,brand:brand,styles:styles},Symbol.toStringTag,{value:"Module"}));var themes={fvStyle:fvStyle,forsta:forsta};var Theme=function Theme(_ref156){var children=_ref156.children,include=_ref156.include,_ref156$theme=_ref156.theme,theme=_ref156$theme===void 0?"fvStyle":_ref156$theme;return/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["a" /* ThemeProvider */],{theme:__spreadValues(__spreadValues({},include),themes[theme]),children:children});};var recolorButton=function recolorButton(_ref157){var colorName=_ref157.colorName,theme=_ref157.theme;var buttonColor=color(colorName,{theme:theme});return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("button{background-color:",buttonColor,";}");};var backgroundColor=function backgroundColor(_ref158){var colorName=_ref158.colorName,transparency=_ref158.transparency,theme=_ref158.theme;return transparentize(colorName,transparency,{theme:theme});};var position=function position(_ref159){var position2=_ref159.position,theme=_ref159.theme,colorName=_ref159.colorName;var borderColor=transparentize(colorName,0.85,{theme:theme});var solidColor=color(colorName,{theme:theme});switch(position2){case"bottom":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&::after{left:50%;bottom:100%;transform:translateX(-50%);border-bottom-color:",borderColor,";}");case"top":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&::after{left:50%;top:100%;transform:translateX(-50%);border-top-color:",borderColor,";}");case"left":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&::after{top:50%;left:100%;transform:translateY(-50%);border-left-color:",borderColor,";}");case"right":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&::after{top:50%;right:100%;transform:translateY(-50%);border-right-color:",borderColor,";}");case"bottom-left":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&::after{left:90%;bottom:100%;transform:translateX(-50%);border-bottom-color:",solidColor,";}");case"bottom-right":return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&::after{left:10%;bottom:100%;transform:translateX(-50%);border-bottom-color:",solidColor,";}");}};var Container$5=createStyled("div",{target:"eys06t10"})("pointer-events:",function(_ref160){var open=_ref160.open;return open?"auto":"none";},";transition:all 0.2s ease-out;max-width:",function(_ref161){var wide=_ref161.wide;return wide?"325px":"250px";},";text-align:left;opacity:",function(_ref162){var open=_ref162.open;return open?0.8:0;},";color:",color("white"),";background:",backgroundColor,";z-index:1020;",function(_ref163){var portal=_ref163.portal;return!portal&&"white-space: nowrap;";},";",borderRadius$1("default"),";",padding("xxs"),";",typography$1("body2"),";&::after{content:'';position:absolute;border:5px solid transparent;}",recolorButton,";",position,";");Container$5.displayName="Tooltip.Container";var Title$1=createStyled("div",{target:"e1c6oli30"})("margin-bottom:",spacer(1),";color:",color("white"),";",typography$1("body2Medium"),";");Title$1.displayName="Tooltip.Title";var Wrapper=createStyled("div",{target:"e151dz0d0"})({name:"79elbk",styles:"position:relative;"});Wrapper.displayName="Tooltip.Wrapper";var OFFSET=12;var placements={"bottom-left":"bottom-end","bottom-right":"bottom-start"};var getRoot=function getRoot(){var root2=document.getElementById("tooltip-root");return root2;};var renderTooltip=function renderTooltip(){return null;};var Tooltip=function Tooltip(_ref164){var _ref164$delay=_ref164.delay,delay=_ref164$delay===void 0?0:_ref164$delay,_ref164$position=_ref164.position,position2=_ref164$position===void 0?"top":_ref164$position,_ref164$containerOpen=_ref164.containerOpenOnHover,containerOpenOnHover=_ref164$containerOpen===void 0?false:_ref164$containerOpen,_ref164$wide=_ref164.wide,wide=_ref164$wide===void 0?false:_ref164$wide,_ref164$color=_ref164.color,color2=_ref164$color===void 0?"black":_ref164$color,_ref164$transparency=_ref164.transparency,transparency=_ref164$transparency===void 0?0.85:_ref164$transparency,render3=_ref164.render,portal=_ref164.portal,label=_ref164.label,title=_ref164.title,wrapperClassName=_ref164.wrapperClassName,className=_ref164.className;var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),open=_useState16[0],setOpen=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState18=_slicedToArray(_useState17,2),forceUpdate=_useState18[1];var timer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var containerHoverOver=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var tooltipRoot=getRoot();var popperElement=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var referenceElement=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var modifiers=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return[{name:"preventOverflow",enabled:false},{name:"hide",enabled:false},{name:"offset",options:{offset:function offset(){return[0,OFFSET];}}}];},[]);var _usePopper$2=usePopper$1(referenceElement.current,popperElement.current,{placement:placements[position2]||position2,modifiers:modifiers}),styles2=_usePopper$2.styles,attributes=_usePopper$2.attributes;var show=function show(){timer.current=setTimeout(function(){setOpen(true);},delay);};var hide2=function hide2(){clearTimeout(timer.current);setTimeout(function(){containerOpenOnHover&&containerHoverOver.current?null:setOpen(false);},containerOpenOnHover?200:0);};var containerEnter=function containerEnter(){if(open&&containerOpenOnHover){containerHoverOver.current=true;setOpen(true);}};var containerOut=function containerOut(){if(containerOpenOnHover){containerHoverOver.current=false;setOpen(false);}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(function(){forceUpdate(new Date().getTime());return function(){return clearTimeout(timer.current);};},[]);var tooltip=/* @__PURE__ */jsxs(Container$5,__spreadProps(__spreadValues({open:open,wide:wide,ref:popperElement,portal:portal,colorName:color2,transparency:transparency,position:position2,className:className,onMouseEnter:containerEnter,onMouseLeave:containerOut,style:styles2.popper},attributes.popper),{children:[title&&/* @__PURE__ */jsx(Title$1,{children:title}),label]}));var reference2=render3({hide:hide2,show:show,ref:referenceElement,renderTooltip:renderTooltip});return/* @__PURE__ */jsx(Fragment,{children:portal?/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[reference2,Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["createPortal"])(tooltip,tooltipRoot)]}):/* @__PURE__ */jsxs(Wrapper,{className:wrapperClassName,children:[reference2,tooltip]})});};Tooltip.propTypes={position:PropTypes$2.string,delay:PropTypes$2.number,containerOpenOnHover:PropTypes$2.bool,wide:PropTypes$2.bool,color:PropTypes$2.string,transparency:PropTypes$2.number,render:PropTypes$2.func,portal:PropTypes$2.bool,label:PropTypes$2.oneOfType([PropTypes$2.string,PropTypes$2.element]),title:PropTypes$2.string,wrapperClassName:PropTypes$2.string,className:PropTypes$2.string};function ConsumeTheme(_ref165){var children=_ref165.children;var theme=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["b" /* useTheme */])();return children({theme:theme});}var global$1=function global$1(styles2){return/* @__PURE__ */jsx(ConsumeTheme,{children:function children(_ref166){var theme=_ref166.theme;return/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["b" /* Global */],{styles:/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("html{box-sizing:border-box;font-size:",theme.font.base,";-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;}*,*:before,*:after{box-sizing:inherit;}body{font-family:'Roboto',sans-serif;color:",color("black",{theme:theme}),";",typography$1("body2",{theme:theme}),";}a{text-decoration:none;color:currentColor;transition:all 0.1s ease-in-out;touch-action:manipulation;}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:",spacer(2,{theme:theme}),";}h1{",typography$1("headline3",{theme:theme}),";}h2{",typography$1("headline2",{theme:theme}),";}h3{",typography$1("headline1",{theme:theme}),";}h4{",typography$1("title3",{theme:theme}),";}h5{",typography$1("title2",{theme:theme}),";}h6{",typography$1("title1",{theme:theme}),";}strong{",fontWeight("bold",{theme:theme}),";}p{margin-top:0;margin-bottom:",spacer(2,{theme:theme}),";}label{color:",color("pewter",{theme:theme}),";margin-bottom:",spacer(2,{theme:theme}),";touch-action:manipulation;",typography$1("body1Medium",{theme:theme}),";}",styles2&&styles2(theme),";")});}});};var grid=function grid(_ref167){var grid2=_ref167.grid;return grid2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid:",grid2,";");};var gridArea=function gridArea(_ref168){var gridArea2=_ref168.gridArea;return gridArea2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-area:",gridArea2,";");};var gridGap=function gridGap(_ref169){var gridGap2=_ref169.gridGap;return gridGap2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-gap:",gridGap2,";");};var gridRow=function gridRow(_ref170){var gridRow2=_ref170.gridRow;return gridRow2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-row:",gridRow2,";");};var gridColumn=function gridColumn(_ref171){var gridColumn2=_ref171.gridColumn;return gridColumn2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-column:",gridColumn2,";");};var gridTemplate=function gridTemplate(_ref172){var gridTemplate2=_ref172.gridTemplate;return gridTemplate2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-template:",gridTemplate2,";");};var gridTemplateColumns=function gridTemplateColumns(_ref173){var gridTemplateColumns2=_ref173.gridTemplateColumns;return gridTemplateColumns2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-template-columns:",gridTemplateColumns2,";");};var gridTemplateRows=function gridTemplateRows(_ref174){var gridTemplateRows2=_ref174.gridTemplateRows;return gridTemplateRows2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-template-rows:",gridTemplateRows2,";");};var gridAutoFlow=function gridAutoFlow(_ref175){var gridAutoFlow2=_ref175.gridAutoFlow;return gridAutoFlow2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-auto-flow:",gridAutoFlow2,";");};var gridAutoRows=function gridAutoRows(_ref176){var gridAutoRows2=_ref176.gridAutoRows;return gridAutoRows2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-auto-rows:",gridAutoRows2,";");};var gridAutoColumns=function gridAutoColumns(_ref177){var gridAutoColumns2=_ref177.gridAutoColumns;return gridAutoColumns2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("grid-auto-columns:",gridAutoColumns2,";");};var justifyItems=function justifyItems(_ref178){var justifyItems2=_ref178.justifyItems;return justifyItems2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("justify-items:",justifyItems2,";");};var justifyContent=function justifyContent(_ref179){var justifyContent2=_ref179.justifyContent;return justifyContent2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("justify-content:",justifyContent2,";");};var alignItems=function alignItems(_ref180){var alignItems2=_ref180.alignItems;return alignItems2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("align-items:",alignItems2,";");};var alignContent=function alignContent(_ref181){var alignContent2=_ref181.alignContent;return alignContent2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("align-content:",alignContent2,";");};var Grid=createStyled("div",{target:"esh5g1l0"})("display:grid;",grid,";",gridArea,";",gridGap,";",gridTemplate,";",gridTemplateColumns,";",gridTemplateRows,";",gridRow,";",gridColumn,";",gridAutoFlow,";",gridAutoColumns,";",gridAutoRows,";",justifyItems,";",justifyContent,";",alignItems,";",alignContent,";");var NavContainer=createStyled("div",{target:"e1myrn810"})("display:flex;justify-content:center;width:100%;",function(_ref182){var theme=_ref182.theme,dark2=_ref182.dark;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",color(dark2?"ink":"white",{theme:theme}),";a:not(",ItemLink,"){&,&:hover{color:",color(dark2?"white":"ink",{theme:theme}),";}}");},";");var Nav=createStyled("nav",{target:"e1myrn811"})("display:flex;align-items:center;padding-left:",spacer(4),";padding-right:",spacer(4),";height:70px;",responsiveContainer,";@supports (display:grid){display:grid;grid-template-columns:auto 1fr;grid-template-rows:70px;height:auto;}");var NavItem=createStyled("div",{target:"e1myrn812"})({name:"4mjo1p",styles:"&:nth-of-type(2){display:flex;justify-content:flex-end;flex:1;}@supports (display:grid){&:nth-of-type(2){display:grid;justify-content:end;grid-auto-flow:column;}}"});var Navbar=function Navbar(_ref183){var children=_ref183.children,dark2=_ref183.dark,fluid=_ref183.fluid,homeRoute=_ref183.homeRoute;return/* @__PURE__ */jsx(NavContainer,{dark:dark2,children:/* @__PURE__ */jsxs(Nav,{fluid:fluid,children:[/* @__PURE__ */jsx(NavItem,{children:/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:homeRoute,children:/* @__PURE__ */jsx(ForstaLogo,{size:"sm",dark:dark2})})}),/* @__PURE__ */jsx(NavItem,{children:children})]})});};var Container$4=createStyled("ul",{target:"e1gsimm80"})({name:"dlxhph",styles:"border-bottom:0;display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none;"});Container$4.displayName="Tabs.Container";var TabContainer=createStyled("li",{target:"eli5iaa0"})("padding:0 ",spacer(4),";&:first-of-type{padding-left:0;}&:last-of-type{padding-right:0;}");var activeCss=function activeCss(_ref184){var dark2=_ref184.dark,theme=_ref184.theme;return"\n  && {\n    color: ".concat(color(dark2?"white":"ink",{theme:theme}),";\n    border-bottom-color: ").concat(style("tabs.navLink.underlineColor",{theme:theme}),";\n    &:hover {\n      border-bottom-color: ").concat(style("tabs.navLink.hoverUnderlineColor",{theme:theme}),";\n    }\n  }\n");};var StyledNavLink=/* @__PURE__ */createStyled(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* NavLink */],{shouldForwardProp:function shouldForwardProp(prop2){return prop2!=="dark";},target:"e1c3zrec0"})("color:",function(_ref185){var dark2=_ref185.dark;return dark2?transparentize("offWhite",0.5):color("pewter");},";padding:",spacer(2)," 0;border-bottom:2px solid transparent;display:block;cursor:pointer;transition:all 0.1s ease-in-out;",typography$1("subheading2"),";&:hover{color:",function(_ref186){var dark2=_ref186.dark;return color(dark2?"white":"ink");},";}");var TabsNavLink=function TabsNavLink(_Za){var __a=_Za,dark2=__a.dark,theme=__a.theme,rest=__objRest(__a,["dark","theme"]);return/* @__PURE__ */jsx(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["a" /* ClassNames */],{children:function children(_ref187){var css2=_ref187.css;return/* @__PURE__ */jsx(StyledNavLink,__spreadValues({activeClassName:css2(activeCss({dark:dark2,theme:theme})),dark:dark2},rest));}});};var TabNavLink=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(TabsNavLink);var Caret=/* @__PURE__ */createStyled(Caret$2,{target:"e1xdruu40"})("margin-left:",spacer(1),";");var isActive=function isActive(children){return function(match,location){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children).filter(Boolean).some(function(_ref188){var props=_ref188.props;return props.to===location.pathname;});};};var DropdownItem=function DropdownItem(_$a){var _ab=_$a,children=_ab.children,dark2=_ab.dark,text=_ab.text,props=__objRest(_ab,["children","dark","text"]);return/* @__PURE__ */jsx(TabContainer,{children:/* @__PURE__ */jsx(DropdownMenu,__spreadProps(__spreadValues({},props),{trigger:function trigger(toggle){return/* @__PURE__ */jsxs(TabNavLink,{to:"",dark:dark2,onClick:function onClick(e2){e2.preventDefault();toggle();},isActive:isActive(children),children:[text,/* @__PURE__ */jsx(Caret,{size:"0.5rem"})]});},children:children}))});};var TabsItem=function TabsItem(_bb){var _cb=_bb,children=_cb.children,dark2=_cb.dark,props=__objRest(_cb,["children","dark"]);return/* @__PURE__ */jsx(TabContainer,{children:/* @__PURE__ */jsx(TabNavLink,__spreadProps(__spreadValues({},props),{dark:dark2,children:children}))});};var Tabs=function Tabs(_db){var _eb=_db,children=_eb.children,dark2=_eb.dark,props=__objRest(_eb,["children","dark"]);return/* @__PURE__ */jsx(Container$4,__spreadProps(__spreadValues({},props),{children:__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)?Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child,{dark:dark2}):child;})}));};Tabs.Item=TabsItem;Tabs.DropdownItem=DropdownItem;var Col=defaultProps$4({gridAutoRows:"min-content",gridAutoFlow:"row"})(Grid);var StyledRow=/* @__PURE__ */createStyled(Row$2,{target:"e15pjogz0"})("background-color:",function(_ref189){var dark2=_ref189.dark;return color(dark2?"ink":"white");},";");var NavbarSecondary=function NavbarSecondary(_fb){var _gb=_fb,children=_gb.children,fluid=_gb.fluid,dark2=_gb.dark,rest=__objRest(_gb,["children","fluid","dark"]);return/* @__PURE__ */jsx(StyledRow,__spreadProps(__spreadValues({dark:dark2},rest),{children:/* @__PURE__ */jsx(Container$h,{fluid:fluid,children:/* @__PURE__ */jsx(Col,{gridAutoFlow:"column",children:/* @__PURE__ */jsx("nav",{children:/* @__PURE__ */jsx(Tabs,{dark:dark2,children:children})})})})}));};NavbarSecondary.NavItem=Tabs.Item;NavbarSecondary.DropdownItem=Tabs.DropdownItem;var withClass=function withClass(klassName){return _default$2(function(_ref190){var className=_ref190.className;return{className:"".concat(className||""," ").concat(klassName)};});};var Header$2=/* @__PURE__ */createStyled("div",{target:"eit9lgv0"})(padding("xs"),";h6{margin-bottom:0;}");var withPadding=function withPadding(_ref191){var theme=_ref191.theme,pad=_ref191.pad;return pad&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xs",{theme:theme}),";");};var withPaddingY=function withPaddingY(_ref192){var theme=_ref192.theme,padY=_ref192.padY;return padY&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding-top:",spacer(3,{theme:theme}),";padding-bottom:",spacer(3,{theme:theme}),";");};var Item=/* @__PURE__ */createStyled("div",{target:"e1syg7gj0"})(withPadding,";",withPaddingY,";");var Empty=/* @__PURE__ */createStyled(Item,{target:"eez0h5t0"})("text-align:center;color:",color("cadet"),";");var Footer$1=/* @__PURE__ */createStyled("div",{target:"efhavok0"})(padding("xs"),";");var dividers=function dividers(_ref193){var dividers2=_ref193.dividers,theme=_ref193.theme;return dividers2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(".box-item + .box-item,.box-header + .box-item,.box-item + .box-footer{border-top:1px solid ",color("paleGrey",{theme:theme}),";}");};var ghost=function ghost(_ref194){var ghost2=_ref194.ghost,theme=_ref194.theme;return!ghost2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background:",color("white",{theme:theme}),";",shadow$1("subtle",{theme:theme}),";",borderRadius$1("sm",{theme:theme}),";");};var dark=function dark(_ref195){var dark2=_ref195.dark,theme=_ref195.theme;return dark2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color("white",{theme:theme}),";.box-item + .box-item,.box-header + .box-item,.box-item + .box-footer{border-top-color:",color("pewter",{theme:theme}),";}");};var Box=/* @__PURE__ */createStyled("div",{target:"e1olaiqj0"})("& + &{margin-top:",spacer("sm"),";}",ghost,";",dividers,";",dark,";");Box.Header=withClass("box-header")(Header$2);Box.Item=withClass("box-item")(Item);Box.Empty=withClass("box-item")(Empty);Box.Footer=withClass("box-footer")(Footer$1);var Column=function Column(){throw new Error("Column should never render. You may be using this outside of a <Table /> component.");};var Row$1=function Row$1(){throw new Error("Row should never render. You may be using this outside of a <Table /> component.");};Row$1.defaultProps={collapsible:false};var commonStyles=function commonStyles(_ref196){var onClick=_ref196.onClick,theme=_ref196.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border-collapse:collapse;width:100%;max-width:100%;thead{th{color:",color("slate",{theme:theme}),";border:none;}}tbody{background-color:",color("white",{theme:theme}),";tr{transition:all 0.3s ease 0s;",onClick?"&:hover { cursor: pointer; }":"",";}}");};var simple=function simple(_hb){var _ib=_hb,theme=_ib.theme,rest=__objRest(_ib,["theme"]);return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(commonStyles(__spreadValues({theme:theme},rest)),";",shadow$1("subtle",{theme:theme}),";th{text-align:inherit;}thead{background-color:",color("paleGrey",{theme:theme}),";th{",typography$1("body2Medium",{theme:theme}),";",padding("xxs",{theme:theme}),";&:first-of-type{padding-left:",spacer(4,{theme:theme}),";}}}tbody{tr{&:hover{background-color:",style("table.row.hoverBackground",{theme:theme}),";}&:first-of-type td{padding-top:",spacer(3,{theme:theme}),";}&:last-of-type td{padding-bottom:",spacer(3,{theme:theme}),";}}td{color:",color("slate",{theme:theme}),";",typography$1("body2Medium",{theme:theme}),";",padding("xxs",{theme:theme}),";&:first-of-type{padding-left:",spacer(4,{theme:theme}),";}&:not(:last-of-type){border-right:1px solid ",color("paleGrey",{theme:theme}),";}}}");};var multiline=function multiline(_jb){var _kb=_jb,theme=_kb.theme,rest=__objRest(_kb,["theme"]);return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(commonStyles(__spreadValues({theme:theme},rest)),";margin-bottom:",spacer(4,{theme:theme}),";background-color:transparent;thead{background-color:transparent;th{position:relative;padding:",spacer(3,{theme:theme})," ",spacer(5,{theme:theme}),";vertical-align:bottom;",fontSize("xxs",{theme:theme}),";",fontWeight("medium",{theme:theme}),";}}tbody{",shadow$1("subtle",{theme:theme}),";tr{&:not(:last-of-type){border-bottom:1px solid ",color("paleGrey",{theme:theme}),";}&:hover{",shadow$1("raised",{theme:theme}),";background-color:transparent;}}td{&:first-of-type{padding-left:",spacer(5,{theme:theme}),";display:flex;align-items:center;}position:relative;",fontSize("xs",{theme:theme}),";",fontWeight("regular",{theme:theme}),";height:79px;padding:0 ",spacer(3.5,{theme:theme}),";border:none;vertical-align:middle;}}");};var flatCellPadding=function flatCellPadding(theme){return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding:",spacer(3,{theme:theme}),";&:first-of-type{padding-left:",spacer(5,{theme:theme}),";}&:last-of-type{padding-right:",spacer(5,{theme:theme}),";}");};var flat=function flat(_lb){var _mb=_lb,theme=_mb.theme,rest=__objRest(_mb,["theme"]);return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(commonStyles(__spreadValues({theme:theme},rest)),";margin-bottom:",spacer(4,{theme:theme}),";background-color:transparent;thead{background-color:transparent;th{text-align:inherit;position:relative;",flatCellPadding(theme),";vertical-align:bottom;",fontSize("s",{theme:theme}),";",fontWeight("body",{theme:theme}),";}}tbody{border:1px solid ",color("paleGrey",{theme:theme}),";tr{&:not(:last-of-type){border-bottom:1px solid ",color("paleGrey",{theme:theme}),";}&:hover{background-color:",color("offWhite",{theme:theme}),";}}td{",flatCellPadding(theme),";position:relative;",fontSize("xs",{theme:theme}),";",fontWeight("regular",{theme:theme}),";height:60px;border:none;vertical-align:middle;}}");};var TR=createStyled("tr",{target:"ezaimx50"})(function(_ref197){var collapsible=_ref197.collapsible,expanded=_ref197.expanded,theme=_ref197.theme;return collapsible&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(shadow$1("close",{theme:theme}),";display:",expanded?"table-row":"none",";");},";");var TD=createStyled("td",{target:"ezaimx51"})(function(props){return props.width&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("width:",props.width,"px;");},";");var StyledTable=createStyled("table",{target:"ezaimx52"})(function(_nb){var _ob=_nb,type=_ob.type,rest=__objRest(_ob,["type"]);return(type==="multi"?multiline:type==="flat"?flat:simple)(rest);},";");var firstChild=function firstChild(children){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children)[0];};var nestedChildren=function nestedChildren(_ref198){var props=_ref198.props;return props.children;};var isCollapsible=function isCollapsible(children){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children).some(function(_ref199){var props=_ref199.props;return props.collapsible;});};var normalizedData=function normalizedData(data){return typeof data==="boolean"?data.toString():data;};var Table$1=/*#__PURE__*/function(_Component6){function Table$1(){var _this11;_classCallCheck3(this,Table$1);_this11=_callSuper(this,Table$1,arguments);__publicField(_this11,"state",{expandedRows:[]});__publicField(_this11,"toggle",function(idx){_this11.setState(function(_ref200){var expandedRows=_ref200.expandedRows;return{expandedRows:expandedRows.includes(idx)?expandedRows.filter(function(i){return i!==idx;}):[].concat(_toConsumableArray(expandedRows),[idx])};});});__publicField(_this11,"renderColumns",function(columns,data){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(columns,function(_a2){var _b=_a2.props,_c=_b,render3=_c.render,dataKey=_c.dataKey,rest=__objRest(_c,["render","dataKey"]);return/* @__PURE__ */jsx(TD,__spreadProps(__spreadValues({},rest),{children:render3?render3(data):normalizedData(data[dataKey])}),dataKey);});});return _this11;}_inherits3(Table$1,_Component6);return _createClass3(Table$1,[{key:"render",value:function render(){var _this12=this;var _a2=this.props,children=_a2.children,data=_a2.data,type=_a2.type,rest=__objRest(_a2,["children","data","type"]);var expandedRows=this.state.expandedRows;var collapsible=isCollapsible(children);var rows=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children);var regularRows=rows.filter(function(child){return!child.props.collapsible;});var collapsibleRows=rows.filter(function(child){return child.props.collapsible;});return/* @__PURE__ */jsxs(StyledTable,__spreadProps(__spreadValues({type:type},rest),{children:[/* @__PURE__ */jsx("thead",{children:/* @__PURE__ */jsxs("tr",{children:[__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(nestedChildren(firstChild(children)),function(_ref201){var props=_ref201.props;return/* @__PURE__ */jsx("th",{children:props.label},props.dataKey);}),collapsible&&/* @__PURE__ */jsx("th",{})]})}),/* @__PURE__ */jsx("tbody",{children:data.map(function(row,idx){return/* @__PURE__ */jsxs(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{children:[regularRows.map(function(_ref202){var props=_ref202.props;return/* @__PURE__ */jsxs(TR,__spreadProps(__spreadValues({},props),{onClick:function onClick(e2){return props.onClick&&props.onClick(e2,row);},children:[_this12.renderColumns(props.children,row),collapsible&&/* @__PURE__ */jsx(TD,{width:50,children:/* @__PURE__ */jsx(Button$1,{kind:"utility",size:"sm",onClick:function onClick(){return _this12.toggle(idx);},children:/* @__PURE__ */jsx(Chevron$1,{size:"1.25rem",direction:expandedRows.includes(idx)?"up":"down"})})})]}),"row:".concat(idx));}),collapsibleRows.map(function(_ref203){var props=_ref203.props;return/* @__PURE__ */jsx(TR,__spreadProps(__spreadValues({expanded:expandedRows.includes(idx)},props),{children:_this12.renderColumns(props.children,row)}),"collapsible:".concat(idx));})]},"fragment-row-".concat(idx));})})]}));}}]);}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);__publicField(Table$1,"Column",Column);__publicField(Table$1,"Row",Row$1);__publicField(Table$1,"defaultProps",{onClick:null});var LayoutWithStandardHeader=withProps$1({gridTemplateRows:"auto 1fr auto",gridAutoFlow:"row"})(/* @__PURE__ */createStyled(Grid,{target:"e75x4a40"})("min-height:100vh;background:",color("offWhite"),";"));var Footer=createStyled("footer",{target:"e75x4a41"})("background:",function(_pb){var _qb=_pb,theme=_qb.theme,props=__objRest(_qb,["theme"]);return color(props.dark?"ink":"offWhite")(__spreadValues({theme:theme},props));},";");Footer.propTypes={dark:PropTypes$2.bool};LayoutWithStandardHeader.Header=Navbar;LayoutWithStandardHeader.Main=function(_rb){var _sb=_rb,children=_sb.children,props=__objRest(_sb,["children"]);return/* @__PURE__ */jsx("main",__spreadProps(__spreadValues({},props),{children:children}));};LayoutWithStandardHeader.Footer=function(_tb){var _ub=_tb,children=_ub.children,props=__objRest(_ub,["children"]);return/* @__PURE__ */jsx(Footer,__spreadProps(__spreadValues({},props),{children:children}));};LayoutWithStandardHeader.SecondaryHeader=NavbarSecondary;var LayoutSidebar=/* @__PURE__ */createStyled(Grid,{target:"eujmokn0"})("grid-template-columns:",function(_ref204){var _ref204$sidebarWidth=_ref204.sidebarWidth,sidebarWidth=_ref204$sidebarWidth===void 0?"200px":_ref204$sidebarWidth;return sidebarWidth;}," 1fr;grid-auto-flow:column;grid-column-gap:",spacer(4),";padding:",spacer(4),";background:",color("offWhite"),";");LayoutSidebar.Content=function(_vb){var _wb=_vb,children=_wb.children,rest=__objRest(_wb,["children"]);return/* @__PURE__ */jsx("div",__spreadProps(__spreadValues({},rest),{children:children}));};LayoutSidebar.Sidebar=function(_xb){var _yb=_xb,children=_yb.children,rest=__objRest(_yb,["children"]);return/* @__PURE__ */jsx("div",__spreadProps(__spreadValues({},rest),{children:children}));};var Svg=createStyled("svg",{target:"ee2ddif0"})({name:"9y6172",styles:"user-select:none;"});var Svg$1=withProps$1({xmlns:"http://www.w3.org/2000/svg"})(Svg);var DiagonalDividerVertical=function DiagonalDividerVertical(_zb){var _Ab=_zb,theme=_Ab.theme,props=__objRest(_Ab,["theme"]);return/* @__PURE__ */jsxs(Svg$1,__spreadProps(__spreadValues({viewBox:"0 0 115 801",preserveAspectRatio:"none"},props),{children:[/* @__PURE__ */jsx("title",{children:"brand diagonal"}),/* @__PURE__ */jsx("rect",{fill:color("white",{theme:theme}),width:"104.6",height:"801"}),/* @__PURE__ */jsxs("linearGradient",{id:"greenGradient",gradientUnits:"userSpaceOnUse",x1:"25.8617",y1:"-249.8779",x2:"158.2286",y2:"432.3206",gradientTransform:"matrix(1 0 0 1 0 130)",children:[/* @__PURE__ */jsx("stop",{offset:"0",stopColor:gradientStart("green",{theme:theme})}),/* @__PURE__ */jsx("stop",{offset:"1",stopColor:gradientEnd("green",{theme:theme})})]}),/* @__PURE__ */jsx("polygon",{fill:"url(#greenGradient)",points:"0,0 64.6,419.3 115,0 "}),/* @__PURE__ */jsx("polygon",{fill:color("ink",{theme:theme}),points:"115,0 64.6,419.3 18.7,801 115,801 "})]}));};var DiagonalDivider=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(DiagonalDividerVertical);var Header$1=createStyled("header",{target:"e1ssdd840"})("display:flex;align-items:center;padding-left:",spacer(4),";padding-right:",spacer(4),";");var Main$1=createStyled("main",{target:"e1ssdd841"})("display:flex;justify-content:center;align-items:center;width:100%;padding-left:",spacer(4),";padding-right:",spacer(4),";>:first-of-type{width:400px;}@supports (display:grid){display:grid;justify-content:center;align-content:center;align-items:unset;grid-template-columns:400px;width:auto;>:first-of-type{width:auto;}",mediaDn("sm"),"{grid-template-columns:1fr;}}");var StyledLayoutWithVertical=createStyled("div",{target:"e1ssdd842"})("display:flex;height:100vh;background:",color("white"),";@supports (display:grid){display:grid;grid-template-columns:1fr;grid-auto-flow:column;",mediaUp("lg"),"{grid-template-columns:repeat(2,1fr);}}");var Left=createStyled("div",{target:"e1ssdd843"})("display:flex;flex-direction:column;width:100%;header{height:70px;}main{flex:1;}",mediaUp("lg"),"{width:50%;}@supports (display:grid){display:grid;grid-template-rows:70px 1fr;header{height:auto;}main{align-self:center;}",mediaUp("lg"),"{width:100%;}}");var Right=createStyled("div",{target:"e1ssdd844"})("width:50%;background:",color("ink"),";position:relative;> svg{position:absolute;display:block;left:0;height:100%;width:80px;}@supports (display:grid){width:auto;}");var LayoutWithVertical=function LayoutWithVertical(_Bb){var _Cb=_Bb,_children6=_Cb.children,props=__objRest(_Cb,["children"]);return/* @__PURE__ */jsx(MediaQuery,{above:"lg",children:function children(matches){return/* @__PURE__ */jsxs(StyledLayoutWithVertical,__spreadProps(__spreadValues({},props),{children:[/* @__PURE__ */jsx(Left,{children:_children6}),matches&&/* @__PURE__ */jsx(Right,{children:/* @__PURE__ */jsx(DiagonalDivider,{})})]}));}});};LayoutWithVertical.Header=Header$1;LayoutWithVertical.Main=Main$1;LayoutWithVertical.Footer=function(props){return/* @__PURE__ */jsx("footer",__spreadValues({},props));};var DiagonalDividerHorizontal=function DiagonalDividerHorizontal(_ref205){var theme=_ref205.theme;return/* @__PURE__ */jsxs(Svg$1,{viewBox:"0 0 1280 156",preserveAspectRatio:"none",children:[/* @__PURE__ */jsx("path",{fill:color("ink",{theme:theme}),d:"M0 0v80h1280V0z"}),/* @__PURE__ */jsxs("linearGradient",{id:"greenGradient",gradientUnits:"userSpaceOnUse",y1:"81",x2:"1280",y2:"81",gradientTransform:"matrix(1 0 0 -1 0 156)",children:[/* @__PURE__ */jsx("stop",{offset:"0",stopColor:gradientEnd("green",{theme:theme})}),/* @__PURE__ */jsx("stop",{offset:"1",stopColor:gradientStart("green",{theme:theme})})]}),/* @__PURE__ */jsx("path",{fill:"url(#greenGradient)",d:"M1280 0L0 148v2h1280z"}),/* @__PURE__ */jsx("path",{fill:color("white",{theme:theme}),d:"M0 0l1280 148v8H0z"})]});};var DiagonalDividerHorizontal$1=Object(__WEBPACK_IMPORTED_MODULE_2_emotion_theming__["c" /* withTheme */])(DiagonalDividerHorizontal);var _ref$1={name:"hu0xcq",styles:"bottom:0;left:0;transform:translate(-50%,50%);"};var _ref2={name:"1p8meti",styles:"bottom:0;right:0;transform:translate(50%,50%);"};var _ref3={name:"1t40x28",styles:"top:0;left:0;transform:translate(-50%,-50%);"};var _ref4={name:"46kkzh",styles:"top:0;right:0;transform:translate(50%,-50%);"};var diagonalPositioning=function diagonalPositioning(_ref206){var _ref206$position=_ref206.position,position2=_ref206$position===void 0?"top-right":_ref206$position;switch(position2){case"bottom-left":return _ref$1;case"bottom-right":return _ref2;case"top-left":return _ref3;case"top-right":default:return _ref4;}};var BadgeWrapper=createStyled("div",{target:"e36rf120"})("position:absolute;",diagonalPositioning,";");var badgeOptions=function badgeOptions(_ref207){var theme=_ref207.theme,_ref207$fill=_ref207.fill,fill=_ref207$fill===void 0?"red":_ref207$fill,_ref207$background=_ref207.background,background=_ref207$background===void 0?"white":_ref207$background,_ref207$color=_ref207.color,textColor=_ref207$color===void 0?"white":_ref207$color;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("color:",color(textColor,{theme:theme}),";background-color:",color(fill,{theme:theme}),";border-color:",color(background,{theme:theme}),";");};var Badge=createStyled("div",{target:"e36rf121"})("display:flex;align-items:ceneter;justify-content:center;border-width:2px;border-style:solid;border-radius:50%;box-sizing:content-box;width:0.4rem;height:0.4rem;",fontSize("xs"),";",fontWeight("bold"),";",badgeOptions,";");var Container$3=createStyled("div",{target:"e36rf122"})({name:"1gomreu",styles:"position:relative;display:inline-block;"});var WithBadge=function WithBadge(_ref208){var children=_ref208.children,_ref208$on=_ref208.on,on=_ref208$on===void 0?true:_ref208$on,_ref208$position=_ref208.position,position2=_ref208$position===void 0?"top-right":_ref208$position,badgeStyle=_ref208.badgeStyle;return/* @__PURE__ */jsxs(Container$3,{children:[children,/* @__PURE__ */jsx(BadgeWrapper,{position:position2,children:on&&/* @__PURE__ */jsx(Badge,{style:badgeStyle})})]});};var Body$1=createStyled("tbody",{target:"e16wweyx0"})("&&{background-color:",color("white"),";}");var highlightedStyle=function highlightedStyle(_ref209){var _ref209$highlighted=_ref209.highlighted,highlighted=_ref209$highlighted===void 0?false:_ref209$highlighted,theme=_ref209.theme;return highlighted&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",transparentize("black",0.07,{theme:theme}),";");};var highlightOnHoverStyle=function highlightOnHoverStyle(_ref210){var _ref210$highlightOnHo=_ref210.highlightOnHover,highlightOnHover=_ref210$highlightOnHo===void 0?false:_ref210$highlightOnHo,theme=_ref210.theme;return highlightOnHover&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("&:hover{",highlightedStyle({highlighted:true,theme:theme}),"}");};var vertPadding={"default":2,compact:1,comfortable:3};var paddingStyle=function paddingStyle(_ref211){var _ref211$spacing=_ref211.spacing,spacing2=_ref211$spacing===void 0?"default":_ref211$spacing,theme=_ref211.theme;var y2=spacer(vertPadding[spacing2],{theme:theme});var x=spacer(3,{theme:theme});return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding:",y2," ",x,";");};var _ref={name:"y8yffq",styles:"hyphens:auto;"};var hyphensStyle=function hyphensStyle(_ref212){var hyphens=_ref212.hyphens;return hyphens&&_ref;};var Cell$2=createStyled("td",{target:"ebw1p4q0"})("&&{",fontWeight("regular")," text-align:",function(_ref213){var _ref213$textAlign=_ref213.textAlign,textAlign=_ref213$textAlign===void 0?"left":_ref213$textAlign;return textAlign;},";",highlightedStyle," ",paddingStyle," ",highlightOnHoverStyle," ",hyphensStyle,"}");Cell$2.propTypes={highlightOnHover:PropTypes$2.bool,highlighted:PropTypes$2.bool,noBorder:PropTypes$2.bool,hyphens:PropTypes$2.bool,textAlign:PropTypes$2.oneOf(["left","center","right"]),spacing:PropTypes$2.oneOf(["default","compact","comfortable"]),children:PropTypes$2.node};var Container$2=createStyled("div",{target:"e4td5cg0"})({name:"17xotax",styles:"&&{width:100%;overflow-x:auto;}"});var borderStyle=function borderStyle(_ref214){var _ref214$noBorder=_ref214.noBorder,noBorder=_ref214$noBorder===void 0?false:_ref214$noBorder,theme=_ref214.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border-width:1px 1px 0 1px;border-style:solid;border-color:",noBorder?"transparent":color("silver",{theme:theme}),";tbody > &:last-child{border-bottom-width:1px;}");};var selectableStyle=function selectableStyle(_ref215){var _ref215$selectable=_ref215.selectable,selectable2=_ref215$selectable===void 0?false:_ref215$selectable,theme=_ref215.theme;return selectable2&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("cursor:pointer;&:hover{background-color:",transparentize("black",0.07,{theme:theme}),";}");};var selectedStyle=function selectedStyle(_ref216){var _ref216$selected=_ref216.selected,selected=_ref216$selected===void 0?false:_ref216$selected,theme=_ref216.theme;return selected&&/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("background-color:",transparentize("blue",0.2,{theme:theme}),";&:hover{background-color:",transparentize("blue",0.3,{theme:theme}),";}");};var Row=createStyled("tr",{target:"e1g3m1c50"})("&&{",selectableStyle," ",selectedStyle," ",borderStyle,"}");var FlexedDiv=createStyled("div",{target:"e1xit7ds0"})("&&{display:flex;& > div{display:flex;align-items:center;flex:1;& > * + *{margin-left:",spacer(2),";}}}");var FootCell=/* @__PURE__ */createStyled(Cell$2,{target:"e1xit7ds1"})("&&{padding:",spacer(2)," 0;}");var defaultPaginatedRenderResultCounts$1=function defaultPaginatedRenderResultCounts$1(_ref217){var pageStartRow=_ref217.pageStartRow,pageEndRow=_ref217.pageEndRow,totalNumRows=_ref217.totalNumRows;return"Showing ".concat(pageStartRow,"\u2013").concat(pageEndRow," of ").concat(totalNumRows);};var defaultRenderResultCounts$1=function defaultRenderResultCounts$1(_ref218){var totalNumRows=_ref218.totalNumRows;return"Showing ".concat(totalNumRows," records");};var defaultRenderPageNavigationText=function defaultRenderPageNavigationText(_ref219){var currentPage=_ref219.currentPage,pageCount=_ref219.pageCount;return"\n  ".concat(currentPage," of ").concat(pageCount,"\n");};var defaultRenderPageJumpToText=function defaultRenderPageJumpToText(){return"Go to page:";};var defaultRenderPageJumpToButtonText=function defaultRenderPageJumpToButtonText(){return"Go";};function Foot(props){var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(void 0),_useState20=_slicedToArray(_useState19,2),gotoPageValue=_useState20[0],setGotoPageValue=_useState20[1];var _a2=props,numCols=_a2.numCols,_a2$totalNumRows=_a2.totalNumRows,totalNumRows=_a2$totalNumRows===void 0?0:_a2$totalNumRows,_a2$pageIndex=_a2.pageIndex,pageIndex=_a2$pageIndex===void 0?0:_a2$pageIndex,_a2$pageSize=_a2.pageSize,pageSize=_a2$pageSize===void 0?0:_a2$pageSize,_a2$pageCount=_a2.pageCount,pageCount=_a2$pageCount===void 0?0:_a2$pageCount,_a2$gotoPage=_a2.gotoPage,gotoPage=_a2$gotoPage===void 0?function(){}:_a2$gotoPage,_a2$canPreviousPage=_a2.canPreviousPage,canPreviousPage=_a2$canPreviousPage===void 0?false:_a2$canPreviousPage,_a2$previousPage=_a2.previousPage,previousPage=_a2$previousPage===void 0?function(){}:_a2$previousPage,_a2$canNextPage=_a2.canNextPage,canNextPage=_a2$canNextPage===void 0?false:_a2$canNextPage,_a2$nextPage=_a2.nextPage,nextPage=_a2$nextPage===void 0?function(){}:_a2$nextPage,_a2$renderResultCount=_a2.renderResultCounts,renderResultCounts=_a2$renderResultCount===void 0?pageCount>0?defaultPaginatedRenderResultCounts$1:defaultRenderResultCounts$1:_a2$renderResultCount,_a2$renderPageNavigat=_a2.renderPageNavigationText,renderPageNavigationText=_a2$renderPageNavigat===void 0?defaultRenderPageNavigationText:_a2$renderPageNavigat,_a2$renderPageJumpToT=_a2.renderPageJumpToText,renderPageJumpToText=_a2$renderPageJumpToT===void 0?defaultRenderPageJumpToText:_a2$renderPageJumpToT,_a2$renderPageJumpToB=_a2.renderPageJumpToButtonText,renderPageJumpToButtonText=_a2$renderPageJumpToB===void 0?defaultRenderPageJumpToButtonText:_a2$renderPageJumpToB,rest=__objRest(_a2,["numCols","totalNumRows","pageIndex","pageSize","pageCount","gotoPage","canPreviousPage","previousPage","canNextPage","nextPage","renderResultCounts","renderPageNavigationText","renderPageJumpToText","renderPageJumpToButtonText"]);var pageStartRow=pageIndex*pageSize+1;var pageEndRow=Math.min(pageStartRow+pageSize-1,totalNumRows);var handleInputChange=function handleInputChange(e2){setGotoPageValue(e2.target.value===""?void 0:Math.floor(e2.target.value));};var callGotoPage=function callGotoPage(){var maxIndex=pageCount-1;var newIndex=gotoPageValue-1;var clampedIndex=Math.min(maxIndex,Math.max(0,newIndex));setGotoPageValue(clampedIndex+1);gotoPage(clampedIndex);};var maybeRenderPagination=function maybeRenderPagination(){if(pageCount<=0)return null;return/* @__PURE__ */jsxs(Fragment,{children:[/* @__PURE__ */jsxs("div",{style:{justifyContent:"center"},children:[/* @__PURE__ */jsx(Button$1,{kind:"ghost",onClick:previousPage,disabled:!canPreviousPage,children:/* @__PURE__ */jsx(Chevron$1,{size:"s",direction:"left"})}),/* @__PURE__ */jsx("div",{children:renderPageNavigationText({currentPage:pageIndex+1,pageCount:pageCount})}),/* @__PURE__ */jsx(Button$1,{kind:"ghost",onClick:nextPage,disabled:!canNextPage,children:/* @__PURE__ */jsx(Chevron$1,{size:"s",direction:"right"})})]}),/* @__PURE__ */jsxs("div",{style:{justifyContent:"flex-end"},children:[/* @__PURE__ */jsx("div",{children:renderPageJumpToText()}),/* @__PURE__ */jsx(Input$1,{min:"0",max:pageCount,type:"number",value:gotoPageValue,onChange:handleInputChange,onKeyPress:function onKeyPress(e2){return e2.key==="Enter"&&callGotoPage();}}),/* @__PURE__ */jsxs(Button$1,{kind:"utility",onClick:callGotoPage,children:[renderPageJumpToButtonText()," ",/* @__PURE__ */jsx(Chevron$1,{size:"s",direction:"right"})]})]})]});};return/* @__PURE__ */jsx("tfoot",__spreadProps(__spreadValues({},rest),{children:/* @__PURE__ */jsx(Row,{noBorder:true,children:/* @__PURE__ */jsx(FootCell,{colSpan:numCols,children:/* @__PURE__ */jsxs(FlexedDiv,{children:[/* @__PURE__ */jsx("div",{children:renderResultCounts({pageStartRow:pageStartRow,pageEndRow:pageEndRow,totalNumRows:totalNumRows})}),maybeRenderPagination()]})})})}));}Foot.propTypes={numCols:PropTypes$2.number,totalNumRows:PropTypes$2.number,pageCount:PropTypes$2.number,canPreviousPage:PropTypes$2.bool,canNextPage:PropTypes$2.bool,pageIndex:PropTypes$2.number,pageSize:PropTypes$2.number,gotoPage:PropTypes$2.func,previousPage:PropTypes$2.func,nextPage:PropTypes$2.func,renderResultCounts:PropTypes$2.func,renderPageNavigationText:PropTypes$2.func,renderPageJumpToText:PropTypes$2.func,renderPageJumpToButtonText:PropTypes$2.func};var Head$1=createStyled("thead",{target:"e1aga6d30"})("background-color:",transparentize("black",0.07),";",fontSize("xxs"),"");var AscendingSortPath=function AscendingSortPath(props){return/* @__PURE__ */jsx("path",__spreadProps(__spreadValues({},props),{d:"M4,5H1.5C1.1,5,0.9,4.5,1.1,4.2l1.1-1.3l1.4-1.7C3.8,1,4.2,1,4.4,1.2l1.4,1.7l1.1,1.3C7.1,4.5,6.9,5,6.5,5H4z"}));};var DescendingSortPath=function DescendingSortPath(props){return/* @__PURE__ */jsx("path",__spreadProps(__spreadValues({},props),{d:"M4,7h2.5c0.4,0,0.7,0.5,0.4,0.8L5.8,9.1l-1.4,1.7c-0.2,0.2-0.6,0.2-0.8,0L2.2,9.1L1.1,7.8C0.9,7.5,1.1,7,1.5,7H4z"}));};var UnsortedPath=function UnsortedPath(props){return/* @__PURE__ */jsxs(Fragment,{children:[/* @__PURE__ */jsx(DescendingSortPath,__spreadValues({},props)),/* @__PURE__ */jsx(AscendingSortPath,__spreadValues({},props))]});};var getViewBox={asc:"0 0 8 8",desc:"0 4 8 12",unsorted:"0 0 8 12"};var SortIconV2=function SortIconV2(_Db){var _Eb=_Db,sort=_Eb.sort,fill=_Eb.fill,_Eb$size=_Eb.size,size2=_Eb$size===void 0?"s":_Eb$size,props=__objRest(_Eb,["sort","fill","size"]);return/* @__PURE__ */jsx(SVGIconV2,__spreadProps(__spreadValues({},props),{size:size2,viewBox:getViewBox[sort]||getViewBox["unsorted"],children:sort==="asc"?/* @__PURE__ */jsx(AscendingSortPath,{fill:fill||"#626263"}):sort==="desc"?/* @__PURE__ */jsx(DescendingSortPath,{fill:fill||"#626263"}):/* @__PURE__ */jsx(UnsortedPath,{fill:fill||"#c9cbcc"})}));};var SortLabel=/* @__PURE__ */createStyled(SortIconV2,{target:"ef5yhke0"})({name:"14bp983",styles:"&&{flex-shrink:0;}"});var sortLabelCss=function sortLabelCss(_ref220){var textAlign=_ref220.textAlign,theme=_ref220.theme;return textAlign==="right"?/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding-right:",spacer(2,{theme:theme}),";"):/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("padding-left:",spacer(2,{theme:theme}),";");};var Cell$1=/* @__PURE__ */createStyled(Cell$2,{target:"ebrr12g0"})("&&{",fontWeight("medium")," color:#626262;",SortLabel,"{",sortLabelCss,"}}");var CellContentFlexed=createStyled("div",{target:"ebrr12g1"})("&&{display:flex;justify-content:",function(_ref221){var alignedRight=_ref221.alignedRight;return alignedRight?"flex-end":"flex-start";},";}");var CellTextWrapper=createStyled("div",{target:"ebrr12g2"})({name:"9n0386",styles:"&&{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"});function HeadCell(props){var _a2=props,_a2$isSorted=_a2.isSorted,isSorted=_a2$isSorted===void 0?false:_a2$isSorted,_a2$isSortedDesc=_a2.isSortedDesc,isSortedDesc=_a2$isSortedDesc===void 0?false:_a2$isSortedDesc,_a2$canSort=_a2.canSort,canSort=_a2$canSort===void 0?false:_a2$canSort,_a2$children=_a2.children,children=_a2$children===void 0?null:_a2$children,rest=__objRest(_a2,["isSorted","isSortedDesc","canSort","children"]);var maybeRenderSortLabel=function maybeRenderSortLabel(){if(!canSort)return null;return/* @__PURE__ */jsx(SortLabel,{sort:isSorted?isSortedDesc?"desc":"asc":false});};var alignedRight=rest.textAlign==="right";return/* @__PURE__ */jsx(Cell$1,__spreadProps(__spreadValues({highlightOnHover:canSort,highlighted:isSorted},rest),{as:"th",children:/* @__PURE__ */jsxs(CellContentFlexed,{alignedRight:alignedRight,children:[alignedRight&&maybeRenderSortLabel(),/* @__PURE__ */jsx(CellTextWrapper,{children:children}),!alignedRight&&maybeRenderSortLabel()]})}));}HeadCell.propTypes=__spreadProps(__spreadValues({},Cell$1.propTypes),{isSorted:PropTypes$2.bool,isSortedDesc:PropTypes$2.bool,canSort:PropTypes$2.bool});function RowSpacer(_Fb){var _Gb=_Fb,_Gb$numRows=_Gb.numRows,numRows=_Gb$numRows===void 0?0:_Gb$numRows,_Gb$numCols=_Gb.numCols,numCols=_Gb$numCols===void 0?0:_Gb$numCols,rest=__objRest(_Gb,["numRows","numCols"]);var blankRows=[];for(var _i3=0;_i3<numRows;_i3++){blankRows.push(/* @__PURE__ */jsx(Row,{style:_i3!==numRows-1?{borderBottomColor:"transparent"}:{},children:/* @__PURE__ */jsx(Cell$2,__spreadProps(__spreadValues({},rest),{colSpan:numCols,children:"\xA0"}))},_i3));}return blankRows;}RowSpacer.propTypes=__spreadProps(__spreadValues({},Cell$2.propTypes),{numRows:PropTypes$2.number,numCols:PropTypes$2.number});var ToolbarContainer=createStyled("div",{target:"ekul8yh0"})({name:"1lekzkb",styles:"display:flex;align-items:center;justify-content:space-between;"});var ToolbarButtons=createStyled("div",{target:"ekul8yh1"})("background-color:#2473db;button{background:0;border:0;padding:",spacer(2)," ",spacer(3),";color:white;",fontSize("xs")," &:hover{background-color:rgba(255,255,255,0.1);cursor:pointer;}&:focus,&:active{outline:0;}&.focus-visible{outline:1;}}");var defaultPaginatedRenderResultCounts=function defaultPaginatedRenderResultCounts(_ref222){var pageStartRow=_ref222.pageStartRow,pageEndRow=_ref222.pageEndRow,totalNumRows=_ref222.totalNumRows;return"Showing ".concat(pageStartRow,"\u2013").concat(pageEndRow," of ").concat(totalNumRows);};var defaultRenderResultCounts=function defaultRenderResultCounts(_ref223){var totalNumRows=_ref223.totalNumRows;return"Showing ".concat(totalNumRows," records");};function Toolbar(_ref224){var _ref224$buttonContent=_ref224.buttonContent,buttonContent=_ref224$buttonContent===void 0?"DEFAULT":_ref224$buttonContent,_ref224$buttonOnClick=_ref224.buttonOnClick,buttonOnClick=_ref224$buttonOnClick===void 0?function(){}:_ref224$buttonOnClick,_ref224$pageIndex=_ref224.pageIndex,pageIndex=_ref224$pageIndex===void 0?0:_ref224$pageIndex,_ref224$pageSize=_ref224.pageSize,pageSize=_ref224$pageSize===void 0?0:_ref224$pageSize,_ref224$pageCount=_ref224.pageCount,pageCount=_ref224$pageCount===void 0?0:_ref224$pageCount,_ref224$totalNumRows=_ref224.totalNumRows,totalNumRows=_ref224$totalNumRows===void 0?0:_ref224$totalNumRows,_ref224$renderResultC=_ref224.renderResultCounts,renderResultCounts=_ref224$renderResultC===void 0?pageCount>0?defaultPaginatedRenderResultCounts:defaultRenderResultCounts:_ref224$renderResultC;var pageStartRow=pageIndex*pageSize+1;var pageEndRow=Math.min(pageStartRow+pageSize-1,totalNumRows);return/* @__PURE__ */jsxs(ToolbarContainer,{children:[renderResultCounts({pageStartRow:pageStartRow,pageEndRow:pageEndRow,totalNumRows:totalNumRows}),/* @__PURE__ */jsx(ToolbarButtons,{children:/* @__PURE__ */jsx("button",{onClick:buttonOnClick,children:buttonContent})})]});}Toolbar.propTypes={buttonContent:PropTypes$2.string,buttonOnClick:PropTypes$2.func,pageIndex:PropTypes$2.number,pageSize:PropTypes$2.number,pageCount:PropTypes$2.number,totalNumRows:PropTypes$2.number,renderResultCounts:PropTypes$2.func};var reactTable={exports:{}};var reactTable_production_min={exports:{}};(function(module2,exports){!function(e2,t2){t2(exports,__WEBPACK_IMPORTED_MODULE_0_react___default.a);}(commonjsGlobal,function(e2,t2){function n2(e3,t3,n3,o2,r3,i2,u3){try{var l3=e3[i2](u3),s2=l3.value;}catch(e4){return void n3(e4);}l3.done?t3(s2):Promise.resolve(s2).then(o2,r3);}function o(e3){return function(){var t3=this,o2=arguments;return new Promise(function(r3,i2){var u3=e3.apply(t3,o2);function l3(e4){n2(u3,r3,i2,l3,s2,"next",e4);}function s2(e4){n2(u3,r3,i2,l3,s2,"throw",e4);}l3(void 0);});};}function r2(){return(r2=Object.assign||function(e3){for(var t3=1;t3<arguments.length;t3++){var n3=arguments[t3];for(var o2 in n3)Object.prototype.hasOwnProperty.call(n3,o2)&&(e3[o2]=n3[o2]);}return e3;}).apply(this,arguments);}function i(e3,t3){if(e3==null)return{};var n3,o2,r3={},i2=Object.keys(e3);for(o2=0;o2<i2.length;o2++)n3=i2[o2],t3.indexOf(n3)>=0||(r3[n3]=e3[n3]);return r3;}function u2(e3){var t3=function(e4,t4){if(_typeof2(e4)!="object"||e4===null)return e4;var n3=e4[Symbol.toPrimitive];if(n3!==void 0){var o2=n3.call(e4,t4||"default");if(_typeof2(o2)!="object")return o2;throw new TypeError("@@toPrimitive must return a primitive value.");}return(t4==="string"?String:Number)(e4);}(e3,"string");return _typeof2(t3)=="symbol"?t3:String(t3);}t2=t2&&Object.prototype.hasOwnProperty.call(t2,"default")?t2["default"]:t2;var l2={init:"init"},s=function s(e3){var t3=e3.value;return t3===void 0?"":t3;},a=function a(){return t2.createElement(t2.Fragment,null,"\xA0");},c2={Cell:s,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d2(){for(var e3=arguments.length,t3=new Array(e3),n3=0;n3<e3;n3++)t3[n3]=arguments[n3];return t3.reduce(function(e4,t4){var n4=t4.style,o2=t4.className;return e4=r2({},e4,{},i(t4,["style","className"])),n4&&(e4.style=e4.style?r2({},e4.style||{},{},n4||{}):n4),o2&&(e4.className=e4.className?e4.className+" "+o2:o2),e4.className===""&&delete e4.className,e4;},{});}var f2=function f2(e3,t3){return t3===void 0&&(t3={}),function(n3){return n3===void 0&&(n3={}),[].concat(e3,[n3]).reduce(function(e4,o2){return function e5(t4,n4,o3){return typeof n4=="function"?e5({},n4(t4,o3)):Array.isArray(n4)?d2.apply(void 0,[t4].concat(n4)):d2(t4,n4);}(e4,o2,r2({},t3,{userProps:n3}));},{});};},p2=function p2(e3,t3,n3,o2){return n3===void 0&&(n3={}),e3.reduce(function(e4,t4){return t4(e4,n3);},t3);},g2=function g2(e3,t3,n3){return n3===void 0&&(n3={}),e3.forEach(function(e4){e4(t3,n3);});};function v2(e3,t3,n3,o2){e3.findIndex(function(e4){return e4.pluginName===n3;});t3.forEach(function(t4){e3.findIndex(function(e4){return e4.pluginName===t4;});});}function m2(e3,t3){return typeof e3=="function"?e3(t3):e3;}function h2(e3){var n3=t2.useRef();return n3.current=e3,t2.useCallback(function(){return n3.current;},[]);}var y2=typeof document!="undefined"?t2.useLayoutEffect:t2.useEffect;function w2(e3,n3){var o2=t2.useRef(false);y2(function(){o2.current&&e3(),o2.current=true;},n3);}function R(e3,t3,n3){return n3===void 0&&(n3={}),function(o2,i2){i2===void 0&&(i2={});var u3=typeof o2=="string"?t3[o2]:o2;if(u3===void 0)throw console.info(t3),new Error("Renderer Error \u261D\uFE0F");return b2(u3,r2({},e3,{column:t3},n3,{},i2));};}function b2(e3,n3){return function(e4){return typeof e4=="function"&&(t3=Object.getPrototypeOf(e4)).prototype&&t3.prototype.isReactComponent;var t3;}(o2=e3)||typeof o2=="function"||function(e4){return _typeof2(e4)=="object"&&_typeof2(e4.$$typeof)=="symbol"&&["react.memo","react.forward_ref"].includes(e4.$$typeof.description);}(o2)?t2.createElement(e3,n3):e3;var o2;}function S(e3,t3,n3){return n3===void 0&&(n3=0),e3.map(function(e4){return P(e4=r2({},e4,{parent:t3,depth:n3})),e4.columns&&(e4.columns=S(e4.columns,e4,n3+1)),e4;});}function C2(e3){return G2(e3,"columns");}function P(e3){var t3=e3.id,n3=e3.accessor,o2=e3.Header;if(typeof n3=="string"){t3=t3||n3;var r3=n3.split(".");n3=function n3(e4){return function(e5,t4,n4){if(!t4)return e5;var o3,r4=typeof t4=="function"?t4:JSON.stringify(t4),i2=E2.get(r4)||function(){var e6=function(e7){return function e8(t5,n5){n5===void 0&&(n5=[]);if(Array.isArray(t5))for(var o4=0;o4<t5.length;o4+=1)e8(t5[o4],n5);else n5.push(t5);return n5;}(e7).map(function(e8){return String(e8).replace(".","_");}).join(".").replace(z2,".").replace(W,"").split(".");}(t4);return E2.set(r4,e6),e6;}();try{o3=i2.reduce(function(e6,t5){return e6[t5];},e5);}catch(e6){}return o3!==void 0?o3:n4;}(e4,r3);};}if(!t3&&typeof o2=="string"&&o2&&(t3=o2),!t3&&e3.columns)throw console.error(e3),new Error('A column ID (or unique "Header" value) is required!');if(!t3)throw console.error(e3),new Error("A column ID (or string accessor) is required!");return Object.assign(e3,{id:t3,accessor:n3}),e3;}function x(e3,t3){if(!t3)throw new Error();return Object.assign(e3,r2({Header:a,Footer:a},c2,{},t3,{},e3)),Object.assign(e3,{originalWidth:e3.width}),e3;}function B2(e3,t3,n3){n3===void 0&&(n3=function n3(){return{};});for(var o2=[],i2=e3,u3=0,l3=function l3(){return u3++;},s2=function s2(){var e4={headers:[]},u4=[],s3=i2.some(function(e5){return e5.parent;});i2.forEach(function(o3){var i3,a2=[].concat(u4).reverse()[0];if(s3){if(o3.parent)i3=r2({},o3.parent,{originalId:o3.parent.id,id:o3.parent.id+"_"+l3(),headers:[o3]},n3(o3));else i3=x(r2({originalId:o3.id+"_placeholder",id:o3.id+"_placeholder_"+l3(),placeholderOf:o3,headers:[o3]},n3(o3)),t3);a2&&a2.originalId===i3.originalId?a2.headers.push(o3):u4.push(i3);}e4.headers.push(o3);}),o2.push(e4),i2=u4;};i2.length;)s2();return o2.reverse();}var E2=/* @__PURE__ */new Map();function I2(){for(var e3=arguments.length,t3=new Array(e3),n3=0;n3<e3;n3++)t3[n3]=arguments[n3];for(var o2=0;o2<t3.length;o2+=1)if(t3[o2]!==void 0)return t3[o2];}function F2(e3){if(typeof e3=="function")return e3;}function G2(e3,t3){var n3=[];return function e4(o2){o2.forEach(function(o3){o3[t3]?e4(o3[t3]):n3.push(o3);});}(e3),n3;}function A2(e3,t3){var n3=t3.manualExpandedKey,o2=t3.expanded,r3=t3.expandSubRows,i2=r3===void 0||r3,u3=[];return e3.forEach(function e4(t4){t4.isExpanded=t4.original&&t4.original[n3]||o2[t4.id],t4.canExpand=t4.subRows&&!!t4.subRows.length,u3.push(t4),i2&&t4.subRows&&t4.subRows.length&&t4.isExpanded&&t4.subRows.forEach(e4);}),u3;}function k2(e3,t3,n3){return F2(e3)||t3[e3]||n3[e3]||n3.text;}function H2(e3,t3,n3){return e3?e3(t3,n3):t3===void 0;}function T(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");}var O=null;var z2=/\[/g,W=/\]/g;var M=function M(e3){return r2({role:"table"},e3);},j=function j(e3){return r2({role:"rowgroup"},e3);},N=function N(e3,t3){var n3=t3.column;return r2({key:"header_"+n3.id,colSpan:n3.totalVisibleHeaderCount,role:"columnheader"},e3);},D2=function D2(e3,t3){var n3=t3.column;return r2({key:"footer_"+n3.id,colSpan:n3.totalVisibleHeaderCount},e3);},V=function V(e3,t3){return r2({key:"headerGroup_"+t3.index,role:"row"},e3);},_=function _(e3,t3){return r2({key:"footerGroup_"+t3.index},e3);},L=function L(e3,t3){return r2({key:"row_"+t3.row.id,role:"row"},e3);},X=function X(e3,t3){var n3=t3.cell;return r2({key:"cell_"+n3.row.id+"_"+n3.column.id,role:"cell"},e3);};function q2(){return{useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[M],getTableBodyProps:[j],getHeaderGroupProps:[V],getFooterGroupProps:[_],getHeaderProps:[N],getFooterProps:[D2],getRowProps:[L],getCellProps:[X],useFinalInstance:[]};}l2.resetHiddenColumns="resetHiddenColumns",l2.toggleHideColumn="toggleHideColumn",l2.setHiddenColumns="setHiddenColumns",l2.toggleHideAllColumns="toggleHideAllColumns";var K=function K(e3){e3.getToggleHiddenProps=[U],e3.getToggleHideAllColumnsProps=[$],e3.stateReducers.push(J),e3.useInstanceBeforeDimensions.push(Y),e3.headerGroupsDeps.push(function(e4,t3){var n3=t3.instance;return[].concat(e4,[n3.state.hiddenColumns]);}),e3.useInstance.push(Q);};K.pluginName="useColumnVisibility";var U=function U(e3,t3){var n3=t3.column;return[e3,{onChange:function onChange(e4){n3.toggleHidden(!e4.target.checked);},style:{cursor:"pointer"},checked:n3.isVisible,title:"Toggle Column Visible"}];},$=function $(e3,t3){var n3=t3.instance;return[e3,{onChange:function onChange(e4){n3.toggleHideAllColumns(!e4.target.checked);},style:{cursor:"pointer"},checked:!n3.allColumnsHidden&&!n3.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n3.allColumnsHidden&&n3.state.hiddenColumns.length}];};function J(e3,t3,n3,o2){if(t3.type===l2.init)return r2({hiddenColumns:[]},e3);if(t3.type===l2.resetHiddenColumns)return r2({},e3,{hiddenColumns:o2.initialState.hiddenColumns||[]});if(t3.type===l2.toggleHideColumn){var i2=(t3.value!==void 0?t3.value:!e3.hiddenColumns.includes(t3.columnId))?[].concat(e3.hiddenColumns,[t3.columnId]):e3.hiddenColumns.filter(function(e4){return e4!==t3.columnId;});return r2({},e3,{hiddenColumns:i2});}return t3.type===l2.setHiddenColumns?r2({},e3,{hiddenColumns:m2(t3.value,e3.hiddenColumns)}):t3.type===l2.toggleHideAllColumns?r2({},e3,{hiddenColumns:(t3.value!==void 0?t3.value:!e3.hiddenColumns.length)?o2.allColumns.map(function(e4){return e4.id;}):[]}):void 0;}function Y(e3){var n3=e3.headers,o2=e3.state.hiddenColumns;t2.useRef(false).current;var r3=0;n3.forEach(function(e4){return r3+=function e5(t3,n4){t3.isVisible=n4&&!o2.includes(t3.id);var r4=0;return t3.headers&&t3.headers.length?t3.headers.forEach(function(n5){return r4+=e5(n5,t3.isVisible);}):r4=t3.isVisible?1:0,t3.totalVisibleHeaderCount=r4,r4;}(e4,true);});}function Q(e3){var n3=e3.columns,o2=e3.flatHeaders,r3=e3.dispatch,i2=e3.allColumns,u3=e3.getHooks,s2=e3.state.hiddenColumns,a2=e3.autoResetHiddenColumns,c3=a2===void 0||a2,d3=h2(e3),p3=i2.length===s2.length,g3=t2.useCallback(function(e4,t3){return r3({type:l2.toggleHideColumn,columnId:e4,value:t3});},[r3]),v3=t2.useCallback(function(e4){return r3({type:l2.setHiddenColumns,value:e4});},[r3]),m3=t2.useCallback(function(e4){return r3({type:l2.toggleHideAllColumns,value:e4});},[r3]),y3=f2(u3().getToggleHideAllColumnsProps,{instance:d3()});o2.forEach(function(e4){e4.toggleHidden=function(t3){r3({type:l2.toggleHideColumn,columnId:e4.id,value:t3});},e4.getToggleHiddenProps=f2(u3().getToggleHiddenProps,{instance:d3(),column:e4});});var R2=h2(c3);w2(function(){R2()&&r3({type:l2.resetHiddenColumns});},[r3,n3]),Object.assign(e3,{allColumnsHidden:p3,toggleHideColumn:g3,setHiddenColumns:v3,toggleHideAllColumns:m3,getToggleHideAllColumnsProps:y3});}var Z={},ee={},te=function te(e3,t3,n3){return e3;},ne=function ne(e3,t3){return e3.subRows||[];},oe=function oe(e3,t3,n3){return""+(n3?[n3.id,t3].join("."):t3);},re=function re(e3){return e3;};function ie(e3){var t3=e3.initialState,n3=t3===void 0?Z:t3,o2=e3.defaultColumn,u3=o2===void 0?ee:o2,l3=e3.getSubRows,s2=l3===void 0?ne:l3,a2=e3.getRowId,c3=a2===void 0?oe:a2,d3=e3.stateReducer,f3=d3===void 0?te:d3,p3=e3.useControlledState,g3=p3===void 0?re:p3;return r2({},i(e3,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n3,defaultColumn:u3,getSubRows:s2,getRowId:c3,stateReducer:f3,useControlledState:g3});}function ue(e3,t3){t3===void 0&&(t3=0);var n3=0,o2=0,r3=0,i2=0;return e3.forEach(function(e4){var u3=e4.headers;if(e4.totalLeft=t3,u3&&u3.length){var l3=ue(u3,t3),s2=l3[0],a2=l3[1],c3=l3[2],d3=l3[3];e4.totalMinWidth=s2,e4.totalWidth=a2,e4.totalMaxWidth=c3,e4.totalFlexWidth=d3;}else e4.totalMinWidth=e4.minWidth,e4.totalWidth=Math.min(Math.max(e4.minWidth,e4.width),e4.maxWidth),e4.totalMaxWidth=e4.maxWidth,e4.totalFlexWidth=e4.canResize?e4.totalWidth:0;e4.isVisible&&(t3+=e4.totalWidth,n3+=e4.totalMinWidth,o2+=e4.totalWidth,r3+=e4.totalMaxWidth,i2+=e4.totalFlexWidth);}),[n3,o2,r3,i2];}function le(e3){var t3=e3.data,n3=e3.rows,o2=e3.flatRows,r3=e3.rowsById,i2=e3.column,u3=e3.getRowId,l3=e3.getSubRows,s2=e3.accessValueHooks,a2=e3.getInstance;t3.forEach(function(e4,t4){return function e5(t5,n4,c3,d3,f3){c3===void 0&&(c3=0);var g3=t5,v3=u3(t5,n4,d3),m3=r3[v3];if(m3)m3.subRows&&m3.originalSubRows.forEach(function(t6,n5){return e5(t6,n5,c3+1,m3);});else if((m3={id:v3,original:g3,index:n4,depth:c3,cells:[{}]}).cells.map=T,m3.cells.filter=T,m3.cells.forEach=T,m3.cells[0].getCellProps=T,m3.values={},f3.push(m3),o2.push(m3),r3[v3]=m3,m3.originalSubRows=l3(t5,n4),m3.originalSubRows){var h3=[];m3.originalSubRows.forEach(function(t6,n5){return e5(t6,n5,c3+1,m3,h3);}),m3.subRows=h3;}i2.accessor&&(m3.values[i2.id]=i2.accessor(t5,n4,m3)),m3.values[i2.id]=p2(s2,m3.values[i2.id],{row:m3,column:i2,instance:a2()});}(e4,t4,0,void 0,n3);});}l2.resetExpanded="resetExpanded",l2.toggleRowExpanded="toggleRowExpanded",l2.toggleAllRowsExpanded="toggleAllRowsExpanded";var se=function se(e3){e3.getToggleAllRowsExpandedProps=[ae],e3.getToggleRowExpandedProps=[ce],e3.stateReducers.push(de),e3.useInstance.push(fe),e3.prepareRow.push(pe);};se.pluginName="useExpanded";var ae=function ae(e3,t3){var n3=t3.instance;return[e3,{onClick:function onClick(e4){n3.toggleAllRowsExpanded();},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}];},ce=function ce(e3,t3){var n3=t3.row;return[e3,{onClick:function onClick(){n3.toggleRowExpanded();},style:{cursor:"pointer"},title:"Toggle Row Expanded"}];};function de(e3,t3,n3,o2){if(t3.type===l2.init)return r2({expanded:{}},e3);if(t3.type===l2.resetExpanded)return r2({},e3,{expanded:o2.initialState.expanded||{}});if(t3.type===l2.toggleAllRowsExpanded){var s2=t3.value,a2=o2.isAllRowsExpanded,c3=o2.rowsById;if(s2!==void 0?s2:!a2){var d3={};return Object.keys(c3).forEach(function(e4){d3[e4]=true;}),r2({},e3,{expanded:d3});}return r2({},e3,{expanded:{}});}if(t3.type===l2.toggleRowExpanded){var f3,p3=t3.id,g3=t3.value,v3=e3.expanded[p3],m3=g3!==void 0?g3:!v3;if(!v3&&m3)return r2({},e3,{expanded:r2({},e3.expanded,(f3={},f3[p3]=true,f3))});if(v3&&!m3){var h3=e3.expanded;h3[p3];return r2({},e3,{expanded:i(h3,[p3].map(u2))});}return e3;}}function fe(e3){var n3=e3.data,o2=e3.rows,r3=e3.rowsById,i2=e3.manualExpandedKey,u3=i2===void 0?"expanded":i2,s2=e3.paginateExpandedRows,a2=s2===void 0||s2,c3=e3.expandSubRows,d3=c3===void 0||c3,p3=e3.autoResetExpanded,g3=p3===void 0||p3,m3=e3.getHooks,y3=e3.plugins,R2=e3.state.expanded,b3=e3.dispatch;v2(y3,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var S2=h2(g3),C3=Boolean(Object.keys(r3).length&&Object.keys(R2).length);C3&&Object.keys(r3).some(function(e4){return!R2[e4];})&&(C3=false),w2(function(){S2()&&b3({type:l2.resetExpanded});},[b3,n3]);var P2=t2.useCallback(function(e4,t3){b3({type:l2.toggleRowExpanded,id:e4,value:t3});},[b3]),x2=t2.useCallback(function(e4){return b3({type:l2.toggleAllRowsExpanded,value:e4});},[b3]),B3=t2.useMemo(function(){return a2?A2(o2,{manualExpandedKey:u3,expanded:R2,expandSubRows:d3}):o2;},[a2,o2,u3,R2,d3]),E3=t2.useMemo(function(){return function(e4){var t3=0;return Object.keys(e4).forEach(function(e5){var n4=e5.split(".");t3=Math.max(t3,n4.length);}),t3;}(R2);},[R2]),I3=h2(e3),F3=f2(m3().getToggleAllRowsExpandedProps,{instance:I3()});Object.assign(e3,{preExpandedRows:o2,expandedRows:B3,rows:B3,expandedDepth:E3,isAllRowsExpanded:C3,toggleRowExpanded:P2,toggleAllRowsExpanded:x2,getToggleAllRowsExpandedProps:F3});}function pe(e3,t3){var n3=t3.instance.getHooks,o2=t3.instance;e3.toggleRowExpanded=function(t4){return o2.toggleRowExpanded(e3.id,t4);},e3.getToggleRowExpandedProps=f2(n3().getToggleRowExpandedProps,{instance:o2,row:e3});}var ge=function ge(e3,t3,n3){return e3=e3.filter(function(e4){return t3.some(function(t4){var o2=e4.values[t4];return String(o2).toLowerCase().includes(String(n3).toLowerCase());});});};ge.autoRemove=function(e3){return!e3;};var ve=function ve(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){var o2=e4.values[t4];return o2===void 0||String(o2).toLowerCase()===String(n3).toLowerCase();});});};ve.autoRemove=function(e3){return!e3;};var me=function me(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){var o2=e4.values[t4];return o2===void 0||String(o2)===String(n3);});});};me.autoRemove=function(e3){return!e3;};var he=function he(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){return e4.values[t4].includes(n3);});});};he.autoRemove=function(e3){return!e3||!e3.length;};var ye=function ye(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){var o2=e4.values[t4];return o2&&o2.length&&n3.every(function(e5){return o2.includes(e5);});});});};ye.autoRemove=function(e3){return!e3||!e3.length;};var we=function we(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){var o2=e4.values[t4];return o2&&o2.length&&n3.some(function(e5){return o2.includes(e5);});});});};we.autoRemove=function(e3){return!e3||!e3.length;};var Re=function Re(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){var o2=e4.values[t4];return n3.includes(o2);});});};Re.autoRemove=function(e3){return!e3||!e3.length;};var be=function be(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){return e4.values[t4]===n3;});});};be.autoRemove=function(e3){return e3===void 0;};var Se=function Se(e3,t3,n3){return e3.filter(function(e4){return t3.some(function(t4){return e4.values[t4]==n3;});});};Se.autoRemove=function(e3){return e3==null;};var Ce=function Ce(e3,t3,n3){var o2=n3||[],r3=o2[0],i2=o2[1];if((r3=typeof r3=="number"?r3:-1/0)>(i2=typeof i2=="number"?i2:1/0)){var u3=r3;r3=i2,i2=u3;}return e3.filter(function(e4){return t3.some(function(t4){var n4=e4.values[t4];return n4>=r3&&n4<=i2;});});};Ce.autoRemove=function(e3){return!e3||typeof e3[0]!="number"&&typeof e3[1]!="number";};var Pe=Object.freeze({__proto__:null,text:ge,exactText:ve,exactTextCase:me,includes:he,includesAll:ye,includesSome:we,includesValue:Re,exact:be,equals:Se,between:Ce});l2.resetFilters="resetFilters",l2.setFilter="setFilter",l2.setAllFilters="setAllFilters";var xe=function xe(e3){e3.stateReducers.push(Be),e3.useInstance.push(Ee);};function Be(e3,t3,n3,o2){if(t3.type===l2.init)return r2({filters:[]},e3);if(t3.type===l2.resetFilters)return r2({},e3,{filters:o2.initialState.filters||[]});if(t3.type===l2.setFilter){var i2=t3.columnId,u3=t3.filterValue,s2=o2.allColumns,a2=o2.filterTypes,c3=s2.find(function(e4){return e4.id===i2;});if(!c3)throw new Error("React-Table: Could not find a column with id: "+i2);var d3=k2(c3.filter,a2||{},Pe),f3=e3.filters.find(function(e4){return e4.id===i2;}),p3=m2(u3,f3&&f3.value);return H2(d3.autoRemove,p3,c3)?r2({},e3,{filters:e3.filters.filter(function(e4){return e4.id!==i2;})}):r2({},e3,f3?{filters:e3.filters.map(function(e4){return e4.id===i2?{id:i2,value:p3}:e4;})}:{filters:[].concat(e3.filters,[{id:i2,value:p3}])});}if(t3.type===l2.setAllFilters){var g3=t3.filters,v3=o2.allColumns,h3=o2.filterTypes;return r2({},e3,{filters:m2(g3,e3.filters).filter(function(e4){var t4=v3.find(function(t5){return t5.id===e4.id;});return!H2(k2(t4.filter,h3||{},Pe).autoRemove,e4.value,t4);})});}}function Ee(e3){var n3=e3.data,o2=e3.rows,r3=e3.flatRows,i2=e3.rowsById,u3=e3.allColumns,s2=e3.filterTypes,a2=e3.manualFilters,c3=e3.defaultCanFilter,d3=c3!==void 0&&c3,f3=e3.disableFilters,p3=e3.state.filters,g3=e3.dispatch,v3=e3.autoResetFilters,m3=v3===void 0||v3,y3=t2.useCallback(function(e4,t3){g3({type:l2.setFilter,columnId:e4,filterValue:t3});},[g3]),R2=t2.useCallback(function(e4){g3({type:l2.setAllFilters,filters:e4});},[g3]);u3.forEach(function(e4){var t3=e4.id,n4=e4.accessor,o3=e4.defaultCanFilter,r4=e4.disableFilters;e4.canFilter=n4?I2(r4!==true&&void 0,f3!==true&&void 0,true):I2(o3,d3,false),e4.setFilter=function(t4){return y3(e4.id,t4);};var i3=p3.find(function(e5){return e5.id===t3;});e4.filterValue=i3&&i3.value;});var b3=t2.useMemo(function(){if(a2||!p3.length)return[o2,r3,i2];var e4=[],t3={};return[function n4(o3,r4){r4===void 0&&(r4=0);var i3=o3;return(i3=p3.reduce(function(e5,t4){var n5=t4.id,o4=t4.value,i4=u3.find(function(e6){return e6.id===n5;});if(!i4)return e5;r4===0&&(i4.preFilteredRows=e5);var l3=k2(i4.filter,s2||{},Pe);return l3?(i4.filteredRows=l3(e5,[n5],o4),i4.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i4.id+"."),e5);},o3)).forEach(function(o4){e4.push(o4),t3[o4.id]=o4,o4.subRows&&(o4.subRows=o4.subRows&&o4.subRows.length>0?n4(o4.subRows,r4+1):o4.subRows);}),i3;}(o2),e4,t3];},[a2,p3,o2,r3,i2,u3,s2]),S2=b3[0],C3=b3[1],P2=b3[2];t2.useMemo(function(){u3.filter(function(e4){return!p3.find(function(t3){return t3.id===e4.id;});}).forEach(function(e4){e4.preFilteredRows=S2,e4.filteredRows=S2;});},[S2,p3,u3]);var x2=h2(m3);w2(function(){x2()&&g3({type:l2.resetFilters});},[g3,a2?null:n3]),Object.assign(e3,{preFilteredRows:o2,preFilteredFlatRows:r3,preFilteredRowsById:i2,filteredRows:S2,filteredFlatRows:C3,filteredRowsById:P2,rows:S2,flatRows:C3,rowsById:P2,setFilter:y3,setAllFilters:R2});}xe.pluginName="useFilters",l2.resetGlobalFilter="resetGlobalFilter",l2.setGlobalFilter="setGlobalFilter";var Ie=function Ie(e3){e3.stateReducers.push(Fe),e3.useInstance.push(Ge);};function Fe(e3,t3,n3,o2){if(t3.type===l2.resetGlobalFilter)return r2({},e3,{globalFilter:o2.initialState.globalFilter||void 0});if(t3.type===l2.setGlobalFilter){var u3=t3.filterValue,s2=o2.userFilterTypes,a2=k2(o2.globalFilter,s2||{},Pe),c3=m2(u3,e3.globalFilter);if(H2(a2.autoRemove,c3)){e3.globalFilter;return i(e3,["globalFilter"]);}return r2({},e3,{globalFilter:c3});}}function Ge(e3){var n3=e3.data,o2=e3.rows,r3=e3.flatRows,i2=e3.rowsById,u3=e3.allColumns,s2=e3.filterTypes,a2=e3.globalFilter,c3=e3.manualGlobalFilter,d3=e3.state.globalFilter,f3=e3.dispatch,p3=e3.autoResetGlobalFilter,g3=p3===void 0||p3,v3=e3.disableGlobalFilter,m3=t2.useCallback(function(e4){f3({type:l2.setGlobalFilter,filterValue:e4});},[f3]),y3=t2.useMemo(function(){if(c3||d3===void 0)return[o2,r3,i2];var e4=[],t3={},n4=k2(a2,s2||{},Pe);if(!n4)return console.warn("Could not find a valid 'globalFilter' option."),o2;u3.forEach(function(e5){var t4=e5.disableGlobalFilter;e5.canFilter=I2(t4!==true&&void 0,v3!==true&&void 0,true);});var l3=u3.filter(function(e5){return e5.canFilter===true;});return[function o3(r4){return(r4=n4(r4,l3.map(function(e5){return e5.id;}),d3)).forEach(function(n5){e4.push(n5),t3[n5.id]=n5,n5.subRows=n5.subRows&&n5.subRows.length?o3(n5.subRows):n5.subRows;}),r4;}(o2),e4,t3];},[c3,d3,a2,s2,u3,o2,r3,i2,v3]),R2=y3[0],b3=y3[1],S2=y3[2],C3=h2(g3);w2(function(){C3()&&f3({type:l2.resetGlobalFilter});},[f3,c3?null:n3]),Object.assign(e3,{preGlobalFilteredRows:o2,preGlobalFilteredFlatRows:r3,preGlobalFilteredRowsById:i2,globalFilteredRows:R2,globalFilteredFlatRows:b3,globalFilteredRowsById:S2,rows:R2,flatRows:b3,rowsById:S2,setGlobalFilter:m3,disableGlobalFilter:v3});}function Ae(e3,t3){return t3.reduce(function(e4,t4){return e4+(typeof t4=="number"?t4:0);},0);}Ie.pluginName="useGlobalFilter";var ke=Object.freeze({__proto__:null,sum:Ae,min:function min(e3){var t3=0;return e3.forEach(function(e4){typeof e4=="number"&&(t3=Math.min(t3,e4));}),t3;},max:function max(e3){var t3=0;return e3.forEach(function(e4){typeof e4=="number"&&(t3=Math.max(t3,e4));}),t3;},minMax:function minMax(e3){var t3=0,n3=0;return e3.forEach(function(e4){typeof e4=="number"&&(t3=Math.min(t3,e4),n3=Math.max(n3,e4));}),t3+".."+n3;},average:function average(e3){return Ae(0,e3)/e3.length;},median:function median(e3){if(!e3.length)return null;var t3=Math.floor(e3.length/2),n3=[].concat(e3).sort(function(e4,t4){return e4-t4;});return e3.length%2!=0?n3[t3]:(n3[t3-1]+n3[t3])/2;},unique:function unique(e3){return Array.from(new Set(e3).values());},uniqueCount:function uniqueCount(e3){return new Set(e3).size;},count:function count(e3){return e3.length;}}),He=[],Te={};l2.resetGroupBy="resetGroupBy",l2.setGroupBy="setGroupBy",l2.toggleGroupBy="toggleGroupBy";var Oe=function Oe(e3){e3.getGroupByToggleProps=[ze],e3.stateReducers.push(We),e3.visibleColumnsDeps.push(function(e4,t3){var n3=t3.instance;return[].concat(e4,[n3.state.groupBy]);}),e3.visibleColumns.push(Me),e3.useInstance.push(Ne),e3.prepareRow.push(De);};Oe.pluginName="useGroupBy";var ze=function ze(e3,t3){var n3=t3.header;return[e3,{onClick:n3.canGroupBy?function(e4){e4.persist(),n3.toggleGroupBy();}:void 0,style:{cursor:n3.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}];};function We(e3,t3,n3,o2){if(t3.type===l2.init)return r2({groupBy:[]},e3);if(t3.type===l2.resetGroupBy)return r2({},e3,{groupBy:o2.initialState.groupBy||[]});if(t3.type===l2.setGroupBy)return r2({},e3,{groupBy:t3.value});if(t3.type===l2.toggleGroupBy){var i2=t3.columnId,u3=t3.value,s2=u3!==void 0?u3:!e3.groupBy.includes(i2);return r2({},e3,s2?{groupBy:[].concat(e3.groupBy,[i2])}:{groupBy:e3.groupBy.filter(function(e4){return e4!==i2;})});}}function Me(e3,t3){var n3=t3.instance.state.groupBy,o2=n3.map(function(t4){return e3.find(function(e4){return e4.id===t4;});}).filter(Boolean),r3=e3.filter(function(e4){return!n3.includes(e4.id);});return(e3=[].concat(o2,r3)).forEach(function(e4){e4.isGrouped=n3.includes(e4.id),e4.groupedIndex=n3.indexOf(e4.id);}),e3;}var je={};function Ne(e3){var n3=e3.data,o2=e3.rows,r3=e3.flatRows,i2=e3.rowsById,u3=e3.allColumns,s2=e3.flatHeaders,a2=e3.groupByFn,c3=a2===void 0?Ve:a2,d3=e3.manualGroupBy,p3=e3.aggregations,g3=p3===void 0?je:p3,m3=e3.plugins,y3=e3.state.groupBy,R2=e3.dispatch,b3=e3.autoResetGroupBy,S2=b3===void 0||b3,C3=e3.disableGroupBy,P2=e3.defaultCanGroupBy,x2=e3.getHooks;v2(m3,["useColumnOrder","useFilters"],"useGroupBy");var B3=h2(e3);u3.forEach(function(t3){var n4=t3.accessor,o3=t3.defaultGroupBy,r4=t3.disableGroupBy;t3.canGroupBy=n4?I2(t3.canGroupBy,r4!==true&&void 0,C3!==true&&void 0,true):I2(t3.canGroupBy,o3,P2,false),t3.canGroupBy&&(t3.toggleGroupBy=function(){return e3.toggleGroupBy(t3.id);}),t3.Aggregated=t3.Aggregated||t3.Cell;});var E3=t2.useCallback(function(e4,t3){R2({type:l2.toggleGroupBy,columnId:e4,value:t3});},[R2]),F3=t2.useCallback(function(e4){R2({type:l2.setGroupBy,value:e4});},[R2]);s2.forEach(function(e4){e4.getGroupByToggleProps=f2(x2().getGroupByToggleProps,{instance:B3(),header:e4});});var A3=t2.useMemo(function(){if(d3||!y3.length)return[o2,r3,i2,He,Te,r3,i2];var e4=y3.filter(function(e5){return u3.find(function(t4){return t4.id===e5;});}),t3=[],n4={},l3=[],s3={},a3=[],f3={},p4=function o3(r4,i3,d4){if(i3===void 0&&(i3=0),i3===e4.length)return r4;var p5=e4[i3],v3=c3(r4,p5);return Object.entries(v3).map(function(r5,c4){var v4=r5[0],m4=r5[1],h3=p5+":"+v4,y4=o3(m4,i3+1,h3=d4?d4+">"+h3:h3),w3=i3?G2(m4,"leafRows"):m4,R3=function(t4,n5,o4){var r6={};return u3.forEach(function(i4){if(e4.includes(i4.id))r6[i4.id]=n5[0]?n5[0].values[i4.id]:null;else{var u4=n5.map(function(e5){return e5.values[i4.id];}),l4=t4.map(function(e5){var t5=e5.values[i4.id];if(!o4&&i4.aggregateValue){var n6=typeof i4.aggregateValue=="function"?i4.aggregateValue:g3[i4.aggregateValue]||ke[i4.aggregateValue];if(!n6)throw console.info({column:i4}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t5=n6(t5,e5,i4);}return t5;}),s4=typeof i4.aggregate=="function"?i4.aggregate:g3[i4.aggregate]||ke[i4.aggregate];if(s4)r6[i4.id]=s4(l4,u4);else{if(i4.aggregate)throw console.info({column:i4}),new Error("React Table: Invalid column.aggregate option for column listed above");r6[i4.id]=null;}}}),r6;}(w3,m4,i3),b4={id:h3,isGrouped:true,groupByID:p5,groupByVal:v4,values:R3,subRows:y4,leafRows:w3,depth:i3,index:c4};return y4.forEach(function(e5){t3.push(e5),n4[e5.id]=e5,e5.isGrouped?(l3.push(e5),s3[e5.id]=e5):(a3.push(e5),f3[e5.id]=e5);}),b4;});}(o2);return p4.forEach(function(e5){t3.push(e5),n4[e5.id]=e5,e5.isGrouped?(l3.push(e5),s3[e5.id]=e5):(a3.push(e5),f3[e5.id]=e5);}),[p4,t3,n4,l3,s3,a3,f3];},[d3,y3,o2,r3,i2,u3,g3,c3]),k3=A3[0],H3=A3[1],T2=A3[2],O2=A3[3],z3=A3[4],W2=A3[5],M2=A3[6],j2=h2(S2);w2(function(){j2()&&R2({type:l2.resetGroupBy});},[R2,d3?null:n3]),Object.assign(e3,{preGroupedRows:o2,preGroupedFlatRow:r3,preGroupedRowsById:i2,groupedRows:k3,groupedFlatRows:H3,groupedRowsById:T2,onlyGroupedFlatRows:O2,onlyGroupedRowsById:z3,nonGroupedFlatRows:W2,nonGroupedRowsById:M2,rows:k3,flatRows:H3,rowsById:T2,toggleGroupBy:E3,setGroupBy:F3});}function De(e3){e3.allCells.forEach(function(t3){var n3;t3.isGrouped=t3.column.isGrouped&&t3.column.id===e3.groupByID,t3.isPlaceholder=!t3.isGrouped&&t3.column.isGrouped,t3.isAggregated=!t3.isGrouped&&!t3.isPlaceholder&&((n3=e3.subRows)==null?void 0:n3.length);});}function Ve(e3,t3){return e3.reduce(function(e4,n3,o2){var r3=""+n3.values[t3];return e4[r3]=Array.isArray(e4[r3])?e4[r3]:[],e4[r3].push(n3),e4;},{});}var _e=/([0-9]+)/gm;function Le(e3,t3){return e3===t3?0:e3>t3?1:-1;}function Xe(e3,t3){return e3.values[t3];}function qe(e3){return typeof e3=="number"?isNaN(e3)||e3===1/0||e3===-1/0?"":String(e3):typeof e3=="string"?e3:"";}var Ke=Object.freeze({__proto__:null,alphanumeric:function alphanumeric(e3,t3,n3){var o2=Xe(e3,n3),r3=Xe(t3,n3);for(o2=qe(o2),r3=qe(r3),o2=o2.split(_e).filter(Boolean),r3=r3.split(_e).filter(Boolean);o2.length&&r3.length;){var i2=o2.shift(),u3=r3.shift(),l3=parseInt(i2,10),s2=parseInt(u3,10),a2=[l3,s2].sort();if(isNaN(a2[0])){if(i2>u3)return 1;if(u3>i2)return-1;}else{if(isNaN(a2[1]))return isNaN(l3)?-1:1;if(l3>s2)return 1;if(s2>l3)return-1;}}return o2.length-r3.length;},datetime:function datetime(e3,t3,n3){var o2=Xe(e3,n3),r3=Xe(t3,n3);return Le(o2=o2.getTime(),r3=r3.getTime());},basic:function basic(e3,t3,n3){return Le(Xe(e3,n3),Xe(t3,n3));}});l2.resetSortBy="resetSortBy",l2.setSortBy="setSortBy",l2.toggleSortBy="toggleSortBy",l2.clearSortBy="clearSortBy",c2.sortType="alphanumeric",c2.sortDescFirst=false;var Ue=function Ue(e3){e3.getSortByToggleProps=[$e],e3.stateReducers.push(Je),e3.useInstance.push(Ye);};Ue.pluginName="useSortBy";var $e=function $e(e3,t3){var n3=t3.instance,o2=t3.column,r3=n3.isMultiSortEvent,i2=r3===void 0?function(e4){return e4.shiftKey;}:r3;return[e3,{onClick:o2.canSort?function(e4){e4.persist(),o2.toggleSortBy(void 0,!n3.disableMultiSort&&i2(e4));}:void 0,style:{cursor:o2.canSort?"pointer":void 0},title:o2.canSort?"Toggle SortBy":void 0}];};function Je(e3,t3,n3,o2){if(t3.type===l2.init)return r2({sortBy:[]},e3);if(t3.type===l2.resetSortBy)return r2({},e3,{sortBy:o2.initialState.sortBy||[]});if(t3.type===l2.clearSortBy)return r2({},e3,{sortBy:e3.sortBy.filter(function(e4){return e4.id!==t3.columnId;})});if(t3.type===l2.setSortBy)return r2({},e3,{sortBy:t3.sortBy});if(t3.type===l2.toggleSortBy){var i2,u3=t3.columnId,s2=t3.desc,a2=t3.multi,c3=o2.allColumns,d3=o2.disableMultiSort,f3=o2.disableSortRemove,p3=o2.disableMultiRemove,g3=o2.maxMultiSortColCount,v3=g3===void 0?Number.MAX_SAFE_INTEGER:g3,m3=e3.sortBy,h3=c3.find(function(e4){return e4.id===u3;}).sortDescFirst,y3=m3.find(function(e4){return e4.id===u3;}),w3=m3.findIndex(function(e4){return e4.id===u3;}),R2=s2!=null,b3=[];return(i2=!d3&&a2?y3?"toggle":"add":w3!==m3.length-1||m3.length!==1?"replace":y3?"toggle":"replace")!=="toggle"||f3||R2||a2&&p3||!(y3&&y3.desc&&!h3||!y3.desc&&h3)||(i2="remove"),i2==="replace"?b3=[{id:u3,desc:R2?s2:h3}]:i2==="add"?(b3=[].concat(m3,[{id:u3,desc:R2?s2:h3}])).splice(0,b3.length-v3):i2==="toggle"?b3=m3.map(function(e4){return e4.id===u3?r2({},e4,{desc:R2?s2:!y3.desc}):e4;}):i2==="remove"&&(b3=m3.filter(function(e4){return e4.id!==u3;})),r2({},e3,{sortBy:b3});}}function Ye(e3){var n3=e3.data,o2=e3.rows,r3=e3.flatRows,i2=e3.allColumns,u3=e3.orderByFn,s2=u3===void 0?Qe:u3,a2=e3.sortTypes,c3=e3.manualSortBy,d3=e3.defaultCanSort,p3=e3.disableSortBy,g3=e3.flatHeaders,m3=e3.state.sortBy,y3=e3.dispatch,R2=e3.plugins,b3=e3.getHooks,S2=e3.autoResetSortBy,C3=S2===void 0||S2;v2(R2,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var P2=t2.useCallback(function(e4){y3({type:l2.setSortBy,sortBy:e4});},[y3]),x2=t2.useCallback(function(e4,t3,n4){y3({type:l2.toggleSortBy,columnId:e4,desc:t3,multi:n4});},[y3]),B3=h2(e3);g3.forEach(function(e4){var t3=e4.accessor,n4=e4.canSort,o3=e4.disableSortBy,r4=e4.id,i3=t3?I2(o3!==true&&void 0,p3!==true&&void 0,true):I2(d3,n4,false);e4.canSort=i3,e4.canSort&&(e4.toggleSortBy=function(t4,n5){return x2(e4.id,t4,n5);},e4.clearSortBy=function(){y3({type:l2.clearSortBy,columnId:e4.id});}),e4.getSortByToggleProps=f2(b3().getSortByToggleProps,{instance:B3(),column:e4});var u4=m3.find(function(e5){return e5.id===r4;});e4.isSorted=!!u4,e4.sortedIndex=m3.findIndex(function(e5){return e5.id===r4;}),e4.isSortedDesc=e4.isSorted?u4.desc:void 0;});var E3=t2.useMemo(function(){if(c3||!m3.length)return[o2,r3];var e4=[],t3=m3.filter(function(e5){return i2.find(function(t4){return t4.id===e5.id;});});return[function n4(o3){var r4=s2(o3,t3.map(function(e5){var t4=i2.find(function(t5){return t5.id===e5.id;});if(!t4)throw new Error("React-Table: Could not find a column with id: "+e5.id+" while sorting");var n5=t4.sortType,o4=F2(n5)||(a2||{})[n5]||Ke[n5];if(!o4)throw new Error("React-Table: Could not find a valid sortType of '"+n5+"' for column '"+e5.id+"'.");return function(t5,n6){return o4(t5,n6,e5.id,e5.desc);};}),t3.map(function(e5){var t4=i2.find(function(t5){return t5.id===e5.id;});return t4&&t4.sortInverted?e5.desc:!e5.desc;}));return r4.forEach(function(t4){e4.push(t4),t4.subRows&&(t4.subRows.length!==1?t4.subRows=n4(t4.subRows):e4.push(t4.subRows[0]));}),r4;}(o2),e4];},[c3,m3,o2,r3,i2,s2,a2]),G3=E3[0],A3=E3[1],k3=h2(C3);w2(function(){k3()&&y3({type:l2.resetSortBy});},[c3?null:n3]),Object.assign(e3,{preSortedRows:o2,preSortedFlatRows:r3,sortedRows:G3,sortedFlatRows:A3,rows:G3,flatRows:A3,setSortBy:P2,toggleSortBy:x2});}function Qe(e3,t3,n3){return[].concat(e3).sort(function(e4,o2){for(var r3=0;r3<t3.length;r3+=1){var i2=t3[r3],u3=n3[r3]===false||n3[r3]==="desc",l3=i2(e4,o2);if(l3!==0)return u3?-l3:l3;}return n3[0]?e4.index-o2.index:o2.index-e4.index;});}l2.resetPage="resetPage",l2.gotoPage="gotoPage",l2.setPageSize="setPageSize";var Ze=function Ze(e3){e3.stateReducers.push(et),e3.useInstance.push(tt);};function et(e3,t3,n3,o2){if(t3.type===l2.init)return r2({pageSize:10,pageIndex:0},e3);if(t3.type===l2.resetPage)return r2({},e3,{pageIndex:o2.initialState.pageIndex||0});if(t3.type===l2.gotoPage){var i2=o2.pageCount,u3=o2.page,s2=m2(t3.pageIndex,e3.pageIndex),a2=false;return s2>e3.pageIndex?a2=i2===-1?u3.length>=e3.pageSize:s2<=i2:s2<e3.pageIndex&&(a2=s2>-1),a2?r2({},e3,{pageIndex:s2}):e3;}if(t3.type===l2.setPageSize){var c3=t3.pageSize,d3=e3.pageSize*e3.pageIndex;return r2({},e3,{pageIndex:Math.floor(d3/c3),pageSize:c3});}}function tt(e3){var n3=e3.rows,o2=e3.autoResetPage,r3=o2===void 0||o2,i2=e3.manualExpandedKey,u3=i2===void 0?"expanded":i2,s2=e3.plugins,a2=e3.pageCount,c3=e3.paginateExpandedRows,d3=c3===void 0||c3,f3=e3.expandSubRows,p3=f3===void 0||f3,g3=e3.state,m3=g3.pageSize,y3=g3.pageIndex,R2=g3.expanded,b3=g3.globalFilter,S2=g3.filters,C3=g3.groupBy,P2=g3.sortBy,x2=e3.dispatch,B3=e3.data,E3=e3.manualPagination;v2(s2,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var I3=h2(r3);w2(function(){I3()&&x2({type:l2.resetPage});},[x2,E3?null:B3,b3,S2,C3,P2]);var F3=E3?a2:Math.ceil(n3.length/m3),G3=t2.useMemo(function(){return F3>0?[].concat(new Array(F3)).fill(null).map(function(e4,t3){return t3;}):[];},[F3]),k3=t2.useMemo(function(){var e4;if(E3)e4=n3;else{var t3=m3*y3,o3=t3+m3;e4=n3.slice(t3,o3);}return d3?e4:A2(e4,{manualExpandedKey:u3,expanded:R2,expandSubRows:p3});},[p3,R2,u3,E3,y3,m3,d3,n3]),H3=y3>0,T2=F3===-1?k3.length>=m3:y3<F3-1,O2=t2.useCallback(function(e4){x2({type:l2.gotoPage,pageIndex:e4});},[x2]),z3=t2.useCallback(function(){return O2(function(e4){return e4-1;});},[O2]),W2=t2.useCallback(function(){return O2(function(e4){return e4+1;});},[O2]),M2=t2.useCallback(function(e4){x2({type:l2.setPageSize,pageSize:e4});},[x2]);Object.assign(e3,{pageOptions:G3,pageCount:F3,page:k3,canPreviousPage:H3,canNextPage:T2,gotoPage:O2,previousPage:z3,nextPage:W2,setPageSize:M2});}Ze.pluginName="usePagination",l2.resetPivot="resetPivot",l2.togglePivot="togglePivot";var nt=function nt(e3){e3.getPivotToggleProps=[rt],e3.stateReducers.push(it),e3.useInstanceAfterData.push(ut),e3.allColumns.push(lt),e3.accessValue.push(st),e3.materializedColumns.push(at),e3.materializedColumnsDeps.push(ct),e3.visibleColumns.push(dt),e3.visibleColumnsDeps.push(ft),e3.useInstance.push(pt),e3.prepareRow.push(gt);};nt.pluginName="usePivotColumns";var ot=[],rt=function rt(e3,t3){var n3=t3.header;return[e3,{onClick:n3.canPivot?function(e4){e4.persist(),n3.togglePivot();}:void 0,style:{cursor:n3.canPivot?"pointer":void 0},title:"Toggle Pivot"}];};function it(e3,t3,n3,o2){if(t3.type===l2.init)return r2({pivotColumns:ot},e3);if(t3.type===l2.resetPivot)return r2({},e3,{pivotColumns:o2.initialState.pivotColumns||ot});if(t3.type===l2.togglePivot){var i2=t3.columnId,u3=t3.value,s2=u3!==void 0?u3:!e3.pivotColumns.includes(i2);return r2({},e3,s2?{pivotColumns:[].concat(e3.pivotColumns,[i2])}:{pivotColumns:e3.pivotColumns.filter(function(e4){return e4!==i2;})});}}function ut(e3){e3.allColumns.forEach(function(t3){t3.isPivotSource=e3.state.pivotColumns.includes(t3.id);});}function lt(e3,t3){var n3=t3.instance;return e3.forEach(function(e4){e4.isPivotSource=n3.state.pivotColumns.includes(e4.id),e4.uniqueValues=/* @__PURE__ */new Set();}),e3;}function st(e3,t3){var n3=t3.column;return n3.uniqueValues&&e3!==void 0&&n3.uniqueValues.add(e3),e3;}function at(e3,t3){var n3=t3.instance,o2=n3.allColumns,i2=n3.state;if(!i2.pivotColumns.length||!i2.groupBy||!i2.groupBy.length)return e3;var u3=i2.pivotColumns.map(function(e4){return o2.find(function(t4){return t4.id===e4;});}).filter(Boolean),l3=o2.filter(function(e4){return!e4.isPivotSource&&!i2.groupBy.includes(e4.id)&&!i2.pivotColumns.includes(e4.id);}),s2=C2(function e4(t4,n4,o3){t4===void 0&&(t4=0),o3===void 0&&(o3=[]);var i3=u3[t4];return i3?Array.from(i3.uniqueValues).sort().map(function(u4){var l4=r2({},i3,{Header:i3.PivotHeader||typeof i3.header=="string"?i3.Header+": "+u4:u4,isPivotGroup:true,parent:n4,depth:t4,id:n4?n4.id+"."+i3.id+"."+u4:i3.id+"."+u4,pivotValue:u4});return l4.columns=e4(t4+1,l4,[].concat(o3,[function(e5){return e5.values[i3.id]===u4;}])),l4;}):l3.map(function(e5){return r2({},e5,{canPivot:false,isPivoted:true,parent:n4,depth:t4,id:""+(n4?n4.id+"."+e5.id:e5.id),accessor:function accessor(t5,n5,r3){if(o3.every(function(e6){return e6(r3);}))return r3.values[e5.id];}});});}());return[].concat(e3,s2);}function ct(e3,t3){var n3=t3.instance.state,o2=n3.pivotColumns,r3=n3.groupBy;return[].concat(e3,[o2,r3]);}function dt(e3,t3){var n3=t3.instance.state;return e3=e3.filter(function(e4){return!e4.isPivotSource;}),n3.pivotColumns.length&&n3.groupBy&&n3.groupBy.length&&(e3=e3.filter(function(e4){return e4.isGrouped||e4.isPivoted;})),e3;}function ft(e3,t3){var n3=t3.instance;return[].concat(e3,[n3.state.pivotColumns,n3.state.groupBy]);}function pt(e3){var t3=e3.columns,n3=e3.allColumns,o2=e3.flatHeaders,r3=e3.getHooks,i2=e3.plugins,u3=e3.dispatch,s2=e3.autoResetPivot,a2=s2===void 0||s2,c3=e3.manaulPivot,d3=e3.disablePivot,p3=e3.defaultCanPivot;v2(i2,["useGroupBy"],"usePivotColumns");var g3=h2(e3);n3.forEach(function(t4){var n4=t4.accessor,o3=t4.defaultPivot,r4=t4.disablePivot;t4.canPivot=n4?I2(t4.canPivot,r4!==true&&void 0,d3!==true&&void 0,true):I2(t4.canPivot,o3,p3,false),t4.canPivot&&(t4.togglePivot=function(){return e3.togglePivot(t4.id);}),t4.Aggregated=t4.Aggregated||t4.Cell;});o2.forEach(function(e4){e4.getPivotToggleProps=f2(r3().getPivotToggleProps,{instance:g3(),header:e4});});var m3=h2(a2);w2(function(){m3()&&u3({type:l2.resetPivot});},[u3,c3?null:t3]),Object.assign(e3,{togglePivot:function togglePivot(e4,t4){u3({type:l2.togglePivot,columnId:e4,value:t4});}});}function gt(e3){e3.allCells.forEach(function(e4){e4.isPivoted=e4.column.isPivoted;});}l2.resetSelectedRows="resetSelectedRows",l2.toggleAllRowsSelected="toggleAllRowsSelected",l2.toggleRowSelected="toggleRowSelected",l2.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var vt=function vt(e3){e3.getToggleRowSelectedProps=[mt],e3.getToggleAllRowsSelectedProps=[ht],e3.getToggleAllPageRowsSelectedProps=[yt],e3.stateReducers.push(wt),e3.useInstance.push(Rt),e3.prepareRow.push(bt);};vt.pluginName="useRowSelect";var mt=function mt(e3,t3){var n3=t3.instance,o2=t3.row,r3=n3.manualRowSelectedKey,i2=r3===void 0?"isSelected":r3;return[e3,{onChange:function onChange(e4){o2.toggleRowSelected(e4.target.checked);},style:{cursor:"pointer"},checked:!(!o2.original||!o2.original[i2])||o2.isSelected,title:"Toggle Row Selected",indeterminate:o2.isSomeSelected}];},ht=function ht(e3,t3){var n3=t3.instance;return[e3,{onChange:function onChange(e4){n3.toggleAllRowsSelected(e4.target.checked);},style:{cursor:"pointer"},checked:n3.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n3.isAllRowsSelected&&Object.keys(n3.state.selectedRowIds).length)}];},yt=function yt(e3,t3){var n3=t3.instance;return[e3,{onChange:function onChange(e4){n3.toggleAllPageRowsSelected(e4.target.checked);},style:{cursor:"pointer"},checked:n3.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n3.isAllPageRowsSelected&&n3.page.some(function(e4){var t4=e4.id;return n3.state.selectedRowIds[t4];}))}];};function wt(e3,t3,n3,o2){if(t3.type===l2.init)return r2({selectedRowIds:{}},e3);if(t3.type===l2.resetSelectedRows)return r2({},e3,{selectedRowIds:o2.initialState.selectedRowIds||{}});if(t3.type===l2.toggleAllRowsSelected){var i2=t3.value,u3=o2.isAllRowsSelected,s2=o2.rowsById,a2=o2.nonGroupedRowsById,c3=a2===void 0?s2:a2,d3=i2!==void 0?i2:!u3,f3=Object.assign({},e3.selectedRowIds);return d3?Object.keys(c3).forEach(function(e4){f3[e4]=true;}):Object.keys(c3).forEach(function(e4){delete f3[e4];}),r2({},e3,{selectedRowIds:f3});}if(t3.type===l2.toggleRowSelected){var p3=t3.id,g3=t3.value,v3=o2.rowsById,m3=o2.selectSubRows,h3=m3===void 0||m3,y3=o2.getSubRows,w3=v3[p3].isSelected,R2=g3!==void 0?g3:!w3;if(w3===R2)return e3;var b3=r2({},e3.selectedRowIds);return function e4(t4){var n4=v3[t4];if(n4.isGrouped||(R2?b3[t4]=true:delete b3[t4]),h3&&y3(n4))return y3(n4).forEach(function(t5){return e4(t5.id);});}(p3),r2({},e3,{selectedRowIds:b3});}if(t3.type===l2.toggleAllPageRowsSelected){var S2=t3.value,C3=o2.page,P2=o2.rowsById,x2=o2.selectSubRows,B3=x2===void 0||x2,E3=o2.isAllPageRowsSelected,I3=o2.getSubRows,F3=S2!==void 0?S2:!E3,G3=r2({},e3.selectedRowIds);return C3.forEach(function(e4){return function e5(t4){var n4=P2[t4];if(n4.isGrouped||(F3?G3[t4]=true:delete G3[t4]),B3&&I3(n4))return I3(n4).forEach(function(t5){return e5(t5.id);});}(e4.id);}),r2({},e3,{selectedRowIds:G3});}return e3;}function Rt(e3){var n3=e3.data,o2=e3.rows,r3=e3.getHooks,i2=e3.plugins,u3=e3.rowsById,s2=e3.nonGroupedRowsById,a2=s2===void 0?u3:s2,c3=e3.autoResetSelectedRows,d3=c3===void 0||c3,p3=e3.state.selectedRowIds,g3=e3.selectSubRows,m3=g3===void 0||g3,y3=e3.dispatch,R2=e3.page,b3=e3.getSubRows;v2(i2,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var S2=t2.useMemo(function(){var e4=[];return o2.forEach(function(t3){var n4=m3?function e5(t4,n5,o3){if(n5[t4.id])return true;var r4=o3(t4);if(r4&&r4.length){var i3=true,u4=false;return r4.forEach(function(t5){u4&&!i3||(e5(t5,n5,o3)?u4=true:i3=false);}),!!i3||!!u4&&null;}return false;}(t3,p3,b3):!!p3[t3.id];t3.isSelected=!!n4,t3.isSomeSelected=n4===null,n4&&e4.push(t3);}),e4;},[o2,m3,p3,b3]),C3=Boolean(Object.keys(a2).length&&Object.keys(p3).length),P2=C3;C3&&Object.keys(a2).some(function(e4){return!p3[e4];})&&(C3=false),C3||R2&&R2.length&&R2.some(function(e4){var t3=e4.id;return!p3[t3];})&&(P2=false);var x2=h2(d3);w2(function(){x2()&&y3({type:l2.resetSelectedRows});},[y3,n3]);var B3=t2.useCallback(function(e4){return y3({type:l2.toggleAllRowsSelected,value:e4});},[y3]),E3=t2.useCallback(function(e4){return y3({type:l2.toggleAllPageRowsSelected,value:e4});},[y3]),I3=t2.useCallback(function(e4,t3){return y3({type:l2.toggleRowSelected,id:e4,value:t3});},[y3]),F3=h2(e3),G3=f2(r3().getToggleAllRowsSelectedProps,{instance:F3()}),A3=f2(r3().getToggleAllPageRowsSelectedProps,{instance:F3()});Object.assign(e3,{selectedFlatRows:S2,isAllRowsSelected:C3,isAllPageRowsSelected:P2,toggleRowSelected:I3,toggleAllRowsSelected:B3,getToggleAllRowsSelectedProps:G3,getToggleAllPageRowsSelectedProps:A3,toggleAllPageRowsSelected:E3});}function bt(e3,t3){var n3=t3.instance;e3.toggleRowSelected=function(t4){return n3.toggleRowSelected(e3.id,t4);},e3.getToggleRowSelectedProps=f2(n3.getHooks().getToggleRowSelectedProps,{instance:n3,row:e3});}var St=function St(e3){return{};},Ct=function Ct(e3){return{};};l2.setRowState="setRowState",l2.setCellState="setCellState",l2.resetRowState="resetRowState";var Pt=function Pt(e3){e3.stateReducers.push(xt),e3.useInstance.push(Bt),e3.prepareRow.push(Et);};function xt(e3,t3,n3,o2){var i2=o2.initialRowStateAccessor,u3=i2===void 0?St:i2,s2=o2.initialCellStateAccessor,a2=s2===void 0?Ct:s2,c3=o2.rowsById;if(t3.type===l2.init)return r2({rowState:{}},e3);if(t3.type===l2.resetRowState)return r2({},e3,{rowState:o2.initialState.rowState||{}});if(t3.type===l2.setRowState){var d3,f3=t3.rowId,p3=t3.value,g3=e3.rowState[f3]!==void 0?e3.rowState[f3]:u3(c3[f3].original);return r2({},e3,{rowState:r2({},e3.rowState,(d3={},d3[f3]=m2(p3,g3),d3))});}if(t3.type===l2.setCellState){var v3,h3,y3,w3=t3.rowId,R2=t3.columnId,b3=t3.value,S2=e3.rowState[w3]!==void 0?e3.rowState[w3]:u3(c3[w3].original),C3=(S2==null?void 0:(v3=S2.cellState)==null?void 0:v3[R2])!==void 0?S2.cellState[R2]:a2(c3[w3].original);return r2({},e3,{rowState:r2({},e3.rowState,(y3={},y3[w3]=r2({},S2,{cellState:r2({},S2.cellState||{},(h3={},h3[R2]=m2(b3,C3),h3))}),y3))});}}function Bt(e3){var n3=e3.autoResetRowState,o2=n3===void 0||n3,r3=e3.data,i2=e3.dispatch,u3=t2.useCallback(function(e4,t3){return i2({type:l2.setRowState,rowId:e4,value:t3});},[i2]),s2=t2.useCallback(function(e4,t3,n4){return i2({type:l2.setCellState,rowId:e4,columnId:t3,value:n4});},[i2]),a2=h2(o2);w2(function(){a2()&&i2({type:l2.resetRowState});},[r3]),Object.assign(e3,{setRowState:u3,setCellState:s2});}function Et(e3,t3){var n3=t3.instance,o2=n3.initialRowStateAccessor,r3=o2===void 0?St:o2,i2=n3.initialCellStateAccessor,u3=i2===void 0?Ct:i2,l3=n3.state.rowState;e3.original&&(e3.state=l3[e3.id]!==void 0?l3[e3.id]:r3(e3.original),e3.setState=function(t4){return n3.setRowState(e3.id,t4);},e3.cells.forEach(function(t4){e3.state.cellState||(e3.state.cellState={}),t4.state=e3.state.cellState[t4.column.id]!==void 0?e3.state.cellState[t4.column.id]:u3(e3.original),t4.setState=function(o3){return n3.setCellState(e3.id,t4.column.id,o3);};}));}Pt.pluginName="useRowState",l2.resetColumnOrder="resetColumnOrder",l2.setColumnOrder="setColumnOrder";var It=function It(e3){e3.stateReducers.push(Ft),e3.visibleColumnsDeps.push(function(e4,t3){var n3=t3.instance;return[].concat(e4,[n3.state.columnOrder]);}),e3.visibleColumns.push(Gt),e3.useInstance.push(At);};function Ft(e3,t3,n3,o2){return t3.type===l2.init?r2({columnOrder:[]},e3):t3.type===l2.resetColumnOrder?r2({},e3,{columnOrder:o2.initialState.columnOrder||[]}):t3.type===l2.setColumnOrder?r2({},e3,{columnOrder:m2(t3.columnOrder,e3.columnOrder)}):void 0;}function Gt(e3,t3){var n3=t3.instance.state.columnOrder;if(!n3||!n3.length)return e3;for(var o2=[].concat(n3),r3=[].concat(e3),i2=[],u3=function u3(){var e4=o2.shift(),t4=r3.findIndex(function(t5){return t5.id===e4;});t4>-1&&i2.push(r3.splice(t4,1)[0]);};r3.length&&o2.length;)u3();return[].concat(i2,r3);}function At(e3){var n3=e3.dispatch;e3.setColumnOrder=t2.useCallback(function(e4){return n3({type:l2.setColumnOrder,columnOrder:e4});},[n3]);}It.pluginName="useColumnOrder",c2.canResize=true,l2.columnStartResizing="columnStartResizing",l2.columnResizing="columnResizing",l2.columnDoneResizing="columnDoneResizing",l2.resetResize="resetResize";var kt=function kt(e3){e3.getResizerProps=[Ht],e3.getHeaderProps.push({style:{position:"relative"}}),e3.stateReducers.push(Tt),e3.useInstance.push(zt),e3.useInstanceBeforeDimensions.push(Ot);},Ht=function Ht(e3,t3){var n3=t3.instance,o2=t3.header,r3=n3.dispatch,i2=function i2(e4,t4){var n4=false;if(e4.type==="touchstart"){if(e4.touches&&e4.touches.length>1)return;n4=true;}var o3=function(e5){var t5=[];return function e6(n5){n5.columns&&n5.columns.length&&n5.columns.map(e6);t5.push(n5);}(e5),t5;}(t4).map(function(e5){return[e5.id,e5.totalWidth];}),i3=n4?Math.round(e4.touches[0].clientX):e4.clientX,u3=function u3(e5){r3({type:l2.columnResizing,clientX:e5});},s2=function s2(){return r3({type:l2.columnDoneResizing});},a2={mouse:{moveEvent:"mousemove",moveHandler:function moveHandler(e5){return u3(e5.clientX);},upEvent:"mouseup",upHandler:function upHandler(e5){document.removeEventListener("mousemove",a2.mouse.moveHandler),document.removeEventListener("mouseup",a2.mouse.upHandler),s2();}},touch:{moveEvent:"touchmove",moveHandler:function moveHandler(e5){return e5.cancelable&&(e5.preventDefault(),e5.stopPropagation()),u3(e5.touches[0].clientX),false;},upEvent:"touchend",upHandler:function upHandler(e5){document.removeEventListener(a2.touch.moveEvent,a2.touch.moveHandler),document.removeEventListener(a2.touch.upEvent,a2.touch.moveHandler),s2();}}},c3=n4?a2.touch:a2.mouse,d3=!!function(){if(typeof O=="boolean")return O;var e5=false;try{var t5={get passive(){return e5=true,false;}};window.addEventListener("test",null,t5),window.removeEventListener("test",null,t5);}catch(t6){e5=false;}return O=e5;}()&&{passive:false};document.addEventListener(c3.moveEvent,c3.moveHandler,d3),document.addEventListener(c3.upEvent,c3.upHandler,d3),r3({type:l2.columnStartResizing,columnId:t4.id,columnWidth:t4.totalWidth,headerIdWidths:o3,clientX:i3});};return[e3,{onMouseDown:function onMouseDown(e4){return e4.persist()||i2(e4,o2);},onTouchStart:function onTouchStart(e4){return e4.persist()||i2(e4,o2);},style:{cursor:"ew-resize"},draggable:false,role:"separator"}];};function Tt(e3,t3){if(t3.type===l2.init)return r2({columnResizing:{columnWidths:{}}},e3);if(t3.type===l2.resetResize)return r2({},e3,{columnResizing:{columnWidths:{}}});if(t3.type===l2.columnStartResizing){var n3=t3.clientX,o2=t3.columnId,i2=t3.columnWidth,u3=t3.headerIdWidths;return r2({},e3,{columnResizing:r2({},e3.columnResizing,{startX:n3,headerIdWidths:u3,columnWidth:i2,isResizingColumn:o2})});}if(t3.type===l2.columnResizing){var s2=t3.clientX,a2=e3.columnResizing,c3=a2.startX,d3=a2.columnWidth,f3=a2.headerIdWidths,p3=(s2-c3)/d3,g3={};return f3.forEach(function(e4){var t4=e4[0],n4=e4[1];g3[t4]=Math.max(n4+n4*p3,0);}),r2({},e3,{columnResizing:r2({},e3.columnResizing,{columnWidths:r2({},e3.columnResizing.columnWidths,{},g3)})});}return t3.type===l2.columnDoneResizing?r2({},e3,{columnResizing:r2({},e3.columnResizing,{startX:null,isResizingColumn:null})}):void 0;}kt.pluginName="useResizeColumns";var Ot=function Ot(e3){var t3=e3.flatHeaders,n3=e3.disableResizing,o2=e3.getHooks,r3=e3.state.columnResizing,i2=h2(e3);t3.forEach(function(e4){var t4=I2(e4.disableResizing!==true&&void 0,n3!==true&&void 0,true);e4.canResize=t4,e4.width=r3.columnWidths[e4.id]||e4.originalWidth||e4.width,e4.isResizing=r3.isResizingColumn===e4.id,t4&&(e4.getResizerProps=f2(o2().getResizerProps,{instance:i2(),header:e4}));});};function zt(e3){var n3=e3.plugins,o2=e3.dispatch,r3=e3.autoResetResize,i2=r3===void 0||r3,u3=e3.columns;v2(n3,["useAbsoluteLayout"],"useResizeColumns");var s2=h2(i2);w2(function(){s2()&&o2({type:l2.resetResize});},[u3]);var a2=t2.useCallback(function(){return o2({type:l2.resetResize});},[o2]);Object.assign(e3,{resetResizing:a2});}var Wt={position:"absolute",top:0},Mt=function Mt(e3){e3.getTableBodyProps.push(jt),e3.getRowProps.push(jt),e3.getHeaderGroupProps.push(jt),e3.getFooterGroupProps.push(jt),e3.getHeaderProps.push(function(e4,t3){var n3=t3.column;return[e4,{style:r2({},Wt,{left:n3.totalLeft+"px",width:n3.totalWidth+"px"})}];}),e3.getCellProps.push(function(e4,t3){var n3=t3.cell;return[e4,{style:r2({},Wt,{left:n3.column.totalLeft+"px",width:n3.column.totalWidth+"px"})}];}),e3.getFooterProps.push(function(e4,t3){var n3=t3.column;return[e4,{style:r2({},Wt,{left:n3.totalLeft+"px",width:n3.totalWidth+"px"})}];});};Mt.pluginName="useAbsoluteLayout";var jt=function jt(e3,t3){return[e3,{style:{position:"relative",width:t3.instance.totalColumnsWidth+"px"}}];},Nt={display:"inline-block",boxSizing:"border-box"},Dt=function Dt(e3,t3){return[e3,{style:{display:"flex",width:t3.instance.totalColumnsWidth+"px"}}];},Vt=function Vt(e3){e3.getRowProps.push(Dt),e3.getHeaderGroupProps.push(Dt),e3.getFooterGroupProps.push(Dt),e3.getHeaderProps.push(function(e4,t3){var n3=t3.column;return[e4,{style:r2({},Nt,{width:n3.totalWidth+"px"})}];}),e3.getCellProps.push(function(e4,t3){var n3=t3.cell;return[e4,{style:r2({},Nt,{width:n3.column.totalWidth+"px"})}];}),e3.getFooterProps.push(function(e4,t3){var n3=t3.column;return[e4,{style:r2({},Nt,{width:n3.totalWidth+"px"})}];});};function _t(e3){e3.getTableProps.push(Lt),e3.getRowProps.push(Xt),e3.getHeaderGroupProps.push(Xt),e3.getFooterGroupProps.push(Xt),e3.getHeaderProps.push(qt),e3.getCellProps.push(Kt),e3.getFooterProps.push(Ut);}Vt.pluginName="useBlockLayout",_t.pluginName="useFlexLayout";var Lt=function Lt(e3,t3){return[e3,{style:{minWidth:t3.instance.totalColumnsWidth+"px"}}];},Xt=function Xt(e3,t3){return[e3,{style:{display:"flex",flex:"1 0 auto",minWidth:t3.instance.totalColumnsMinWidth+"px"}}];},qt=function qt(e3,t3){var n3=t3.column;return[e3,{style:{boxSizing:"border-box",flex:n3.totalFlexWidth?n3.totalFlexWidth+" 0 auto":void 0,minWidth:n3.totalMinWidth+"px",width:n3.totalWidth+"px"}}];},Kt=function Kt(e3,t3){var n3=t3.cell;return[e3,{style:{boxSizing:"border-box",flex:n3.column.totalFlexWidth+" 0 auto",minWidth:n3.column.totalMinWidth+"px",width:n3.column.totalWidth+"px"}}];},Ut=function Ut(e3,t3){var n3=t3.column;return[e3,{style:{boxSizing:"border-box",flex:n3.totalFlexWidth?n3.totalFlexWidth+" 0 auto":void 0,minWidth:n3.totalMinWidth+"px",width:n3.totalWidth+"px"}}];};e2._UNSTABLE_usePivotColumns=nt,e2.actions=l2,e2.defaultColumn=c2,e2.defaultGroupByFn=Ve,e2.defaultOrderByFn=Qe,e2.defaultRenderer=s,e2.emptyRenderer=a,e2.ensurePluginOrder=v2,e2.flexRender=b2,e2.functionalUpdate=m2,e2.loopHooks=g2,e2.makePropGetter=f2,e2.makeRenderer=R,e2.reduceHooks=p2,e2.safeUseLayoutEffect=y2,e2.useAbsoluteLayout=Mt,e2.useAsyncDebounce=function(e3,n3){n3===void 0&&(n3=0);var r3=t2.useRef({}),i2=h2(e3),u3=h2(n3);return t2.useCallback(function(){var e4=o(_regeneratorRuntime().mark(function e5(){var t3,n4,l3,s2=arguments;return _regeneratorRuntime().wrap(function(e6){for(;;)switch(e6.prev=e6.next){case 0:for(t3=s2.length,n4=new Array(t3),l3=0;l3<t3;l3++)n4[l3]=s2[l3];return r3.current.promise||(r3.current.promise=new Promise(function(e7,t4){r3.current.resolve=e7,r3.current.reject=t4;})),r3.current.timeout&&clearTimeout(r3.current.timeout),r3.current.timeout=setTimeout(o(_regeneratorRuntime().mark(function e7(){return _regeneratorRuntime().wrap(function(e8){for(;;)switch(e8.prev=e8.next){case 0:return delete r3.current.timeout,e8.prev=1,e8.t0=r3.current,e8.next=5,i2().apply(void 0,n4);case 5:e8.t1=e8.sent,e8.t0.resolve.call(e8.t0,e8.t1),e8.next=12;break;case 9:e8.prev=9,e8.t2=e8["catch"](1),r3.current.reject(e8.t2);case 12:return e8.prev=12,delete r3.current.promise,e8.finish(12);case 15:case"end":return e8.stop();}},e7,null,[[1,9,12,15]]);})),u3()),e6.abrupt("return",r3.current.promise);case 5:case"end":return e6.stop();}},e5);}));return function(){return e4.apply(this,arguments);};}(),[i2,u3]);},e2.useBlockLayout=Vt,e2.useColumnOrder=It,e2.useExpanded=se,e2.useFilters=xe,e2.useFlexLayout=_t,e2.useGetLatest=h2,e2.useGlobalFilter=Ie,e2.useGroupBy=Oe,e2.useMountedLayoutEffect=w2,e2.usePagination=Ze,e2.useResizeColumns=kt,e2.useRowSelect=vt,e2.useRowState=Pt,e2.useSortBy=Ue,e2.useTable=function(e3){for(var n3=arguments.length,o2=new Array(n3>1?n3-1:0),i2=1;i2<n3;i2++)o2[i2-1]=arguments[i2];e3=ie(e3),o2=[K].concat(o2);var u3=t2.useRef({}),s2=h2(u3.current);Object.assign(s2(),r2({},e3,{plugins:o2,hooks:q2()})),o2.filter(Boolean).forEach(function(e4){e4(s2().hooks);});var a2=h2(s2().hooks);s2().getHooks=a2,delete s2().hooks,Object.assign(s2(),p2(a2().useOptions,ie(e3)));var c3=s2(),d3=c3.data,v3=c3.columns,m3=c3.initialState,y3=c3.defaultColumn,w3=c3.getSubRows,b3=c3.getRowId,E3=c3.stateReducer,I3=c3.useControlledState,F3=h2(E3),G3=t2.useCallback(function(e4,t3){if(!t3.type)throw console.info({action:t3}),new Error("Unknown Action \uD83D\uDC46");return[].concat(a2().stateReducers,Array.isArray(F3())?F3():[F3()]).reduce(function(n4,o3){return o3(n4,t3,e4,s2())||n4;},e4);},[a2,F3,s2]),A3=t2.useReducer(G3,void 0,function(){return G3(m3,{type:l2.init});}),k3=A3[0],H3=A3[1],T2=p2([].concat(a2().useControlledState,[I3]),k3,{instance:s2()});Object.assign(s2(),{state:T2,dispatch:H3});var O2=t2.useMemo(function(){return S(p2(a2().columns,v3,{instance:s2()}));},[a2,s2,v3].concat(p2(a2().columnsDeps,[],{instance:s2()})));s2().columns=O2;var z3=t2.useMemo(function(){return p2(a2().allColumns,C2(O2),{instance:s2()}).map(P);},[O2,a2,s2].concat(p2(a2().allColumnsDeps,[],{instance:s2()})));s2().allColumns=z3;var W2=t2.useMemo(function(){for(var e4=[],t3=[],n4={},o3=[].concat(z3);o3.length;){var r3=o3.shift();le({data:d3,rows:e4,flatRows:t3,rowsById:n4,column:r3,getRowId:b3,getSubRows:w3,accessValueHooks:a2().accessValue,getInstance:s2});}return[e4,t3,n4];},[z3,d3,b3,w3,a2,s2]),M2=W2[0],j2=W2[1],N2=W2[2];Object.assign(s2(),{rows:M2,initialRows:[].concat(M2),flatRows:j2,rowsById:N2}),g2(a2().useInstanceAfterData,s2());var D3=t2.useMemo(function(){return p2(a2().visibleColumns,z3,{instance:s2()}).map(function(e4){return x(e4,y3);});},[a2,z3,s2,y3].concat(p2(a2().visibleColumnsDeps,[],{instance:s2()})));z3=t2.useMemo(function(){var e4=[].concat(D3);return z3.forEach(function(t3){e4.find(function(e5){return e5.id===t3.id;})||e4.push(t3);}),e4;},[z3,D3]),s2().allColumns=z3;var V2=t2.useMemo(function(){return p2(a2().headerGroups,B2(D3,y3),s2());},[a2,D3,y3,s2].concat(p2(a2().headerGroupsDeps,[],{instance:s2()})));s2().headerGroups=V2;var _2=t2.useMemo(function(){return V2.length?V2[0].headers:[];},[V2]);s2().headers=_2,s2().flatHeaders=V2.reduce(function(e4,t3){return[].concat(e4,t3.headers);},[]),g2(a2().useInstanceBeforeDimensions,s2());var L2=D3.filter(function(e4){return e4.isVisible;}).map(function(e4){return e4.id;}).sort().join("_");D3=t2.useMemo(function(){return D3.filter(function(e4){return e4.isVisible;});},[D3,L2]),s2().visibleColumns=D3;var X2=ue(_2),U2=X2[0],$2=X2[1],J2=X2[2];return s2().totalColumnsMinWidth=U2,s2().totalColumnsWidth=$2,s2().totalColumnsMaxWidth=J2,g2(a2().useInstance,s2()),[].concat(s2().flatHeaders,s2().allColumns).forEach(function(e4){e4.render=R(s2(),e4),e4.getHeaderProps=f2(a2().getHeaderProps,{instance:s2(),column:e4}),e4.getFooterProps=f2(a2().getFooterProps,{instance:s2(),column:e4});}),s2().headerGroups=t2.useMemo(function(){return V2.filter(function(e4,t3){return e4.headers=e4.headers.filter(function(e5){return e5.headers?function e6(t4){return t4.filter(function(t5){return t5.headers?e6(t5.headers):t5.isVisible;}).length;}(e5.headers):e5.isVisible;}),!!e4.headers.length&&(e4.getHeaderGroupProps=f2(a2().getHeaderGroupProps,{instance:s2(),headerGroup:e4,index:t3}),e4.getFooterGroupProps=f2(a2().getFooterGroupProps,{instance:s2(),headerGroup:e4,index:t3}),true);});},[V2,s2,a2]),s2().footerGroups=[].concat(s2().headerGroups).reverse(),s2().prepareRow=t2.useCallback(function(e4){e4.getRowProps=f2(a2().getRowProps,{instance:s2(),row:e4}),e4.allCells=z3.map(function(t3){var n4=e4.values[t3.id],o3={column:t3,row:e4,value:n4};return o3.getCellProps=f2(a2().getCellProps,{instance:s2(),cell:o3}),o3.render=R(s2(),t3,{row:e4,cell:o3,value:n4}),o3;}),e4.cells=D3.map(function(t3){return e4.allCells.find(function(e5){return e5.column.id===t3.id;});}),g2(a2().prepareRow,e4,{instance:s2()});},[a2,s2,z3,D3]),s2().getTableProps=f2(a2().getTableProps,{instance:s2()}),s2().getTableBodyProps=f2(a2().getTableBodyProps,{instance:s2()}),g2(a2().useFinalInstance,s2()),s2();},Object.defineProperty(e2,"__esModule",{value:true});});})(reactTable_production_min,reactTable_production_min.exports);{reactTable.exports=reactTable_production_min.exports;}var COLUMN_ID$1="SELECTION";var COLUMN_WIDTH$1=50;var reducer=function reducer(newState,action){if(action.type==="deselectAllRows"){return __spreadProps(__spreadValues({},newState),{selectedRowIds:{}});}return newState;};function addEntireRowSelectionProps(props,_ref225){var instance=_ref225.instance,row=_ref225.row;var toggleRowSelected=row.toggleRowSelected;var dispatch=instance.dispatch;return[__spreadProps(__spreadValues({},props),{onClick:function onClick(){dispatch({type:"deselectAllRows"});toggleRowSelected();}})];}function adaptGetToggleRowSelectedProps(props,_ref226){var instance=_ref226.instance;var _a2=props,wrappedOnChange=_a2.onChange,rest=__objRest(_a2,["onChange"]);var dispatch=instance.dispatch;return[__spreadProps(__spreadValues({},rest),{onChange:function onChange(e2){dispatch({type:"deselectAllRows"});wrappedOnChange(e2);}})];}function getHeaderProps$1(props,_ref227){var column=_ref227.column;if(column.id===COLUMN_ID$1){return[props,{style:{maxWidth:COLUMN_WIDTH$1,width:COLUMN_WIDTH$1}}];}return[props];}function getCellProps$1(props,_ref228){var cell=_ref228.cell;if(cell.column.id===COLUMN_ID$1){return[props,{style:{textAlign:"right",maxWidth:COLUMN_WIDTH$1,width:COLUMN_WIDTH$1}}];}return[props];}function prependSelectionColumn(columns){return[{id:COLUMN_ID$1,Cell:function Cell(_ref229){var row=_ref229.row;var _a2=row.getToggleRowSelectedProps(),_=_a2.indeterminate,rest=__objRest(_a2,["indeterminate"]);return/* @__PURE__ */jsx("div",{children:/* @__PURE__ */jsx("input",__spreadValues({type:"radio"},rest))});}}].concat(_toConsumableArray(columns));}function useRowSingleSelect(hooks){reactTable.exports.useRowSelect(hooks);hooks.getRowProps.push(addEntireRowSelectionProps);hooks.getToggleRowSelectedProps.push(adaptGetToggleRowSelectedProps);hooks.getHeaderProps.push(getHeaderProps$1);hooks.getCellProps.push(getCellProps$1);hooks.visibleColumns.push(prependSelectionColumn);hooks.stateReducers.push(reducer);}useRowSingleSelect.pluginName=reactTable.exports.useRowSelect.pluginName;var COLUMN_ID="ACTION_MENU";var COLUMN_WIDTH=70;function getHeaderProps(props,_ref230){var column=_ref230.column;if(column.id===COLUMN_ID){return[props,{style:{maxWidth:COLUMN_WIDTH,width:COLUMN_WIDTH}}];}return[props];}function getCellProps(props,_ref231){var cell=_ref231.cell;if(cell.column.id===COLUMN_ID){return[props,{style:{textAlign:"right",maxWidth:COLUMN_WIDTH,width:COLUMN_WIDTH}}];}return[props];}function appendActionMenuColumn(columns,_ref232){var instance=_ref232.instance;var _instance$actionMenuI=instance.actionMenuItems,actionMenuItems=_instance$actionMenuI===void 0?[]:_instance$actionMenuI;return[].concat(_toConsumableArray(columns),[{id:COLUMN_ID,maxWidth:70,Cell:function Cell(_ref233){var row=_ref233.row;var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),open=_useState22[0],setOpen=_useState22[1];return/* @__PURE__ */jsx(DropdownMenu,{open:open,onToggle:setOpen,popperOptions:{placement:"bottom-end",modifiers:[{name:"eventListeners",enabled:open}]},trigger:function trigger(toggle,ref,open2){return/* @__PURE__ */jsx(Button$1,{size:"sm",kind:open2?"utility":"ghost",ref:ref,onClick:toggle,children:/* @__PURE__ */jsx(More,{})});},children:actionMenuItems.map(function(_ref234,i){var text=_ref234.text,handler=_ref234.handler;return/* @__PURE__ */jsx(DropdownMenu.Item,{onClick:function onClick(){return handler(row);},children:text},i);})});}}]);}function useActionMenu(hooks){hooks.getCellProps.push(getCellProps);hooks.getHeaderProps.push(getHeaderProps);hooks.visibleColumns.push(appendActionMenuColumn);}useActionMenu.pluginName="useActionMenu";var TableV2=createStyled("table",{target:"e1k145800"})({name:"1f2zpi4",styles:"&&{width:100%;border-spacing:0;border-collapse:collapse;}"});TableV2.Body=Body$1;TableV2.Cell=Cell$2;TableV2.Container=Container$2;TableV2.Foot=Foot;TableV2.Head=Head$1;TableV2.HeadCell=HeadCell;TableV2.Row=Row;TableV2.RowSpacer=RowSpacer;TableV2.SortLabel=SortLabel;TableV2.Toolbar=Toolbar;TableV2.useTable=reactTable.exports.useTable;TableV2.useFilters=reactTable.exports.useFilters;TableV2.useGlobalFilter=reactTable.exports.useGlobalFilter;TableV2.useSortBy=reactTable.exports.useSortBy;TableV2.usePagination=reactTable.exports.usePagination;TableV2.useRowState=reactTable.exports.useRowState;TableV2.useRowSingleSelect=useRowSingleSelect;TableV2.useActionMenu=useActionMenu;TableV2.useFlexLayout=reactTable.exports.useFlexLayout;TableV2.useBlockLayout=reactTable.exports.useBlockLayout;TableV2.useAbsoluteLayout=reactTable.exports.useAbsoluteLayout;var AutosizeInput$1={};Object.defineProperty(AutosizeInput$1,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react$1=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react2=_interopRequireDefault$1(_react$1);var _propTypes=propTypes$2.exports;var _propTypes2=_interopRequireDefault$1(_propTypes);function _interopRequireDefault$1(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sizerStyle={position:"absolute",top:0,left:0,visibility:"hidden",height:0,overflow:"scroll",whiteSpace:"pre"};var INPUT_PROPS_BLACKLIST=["extraWidth","injectStyles","inputClassName","inputRef","inputStyle","minWidth","onAutosize","placeholderIsMinWidth"];var cleanInputProps=function cleanInputProps2(inputProps){INPUT_PROPS_BLACKLIST.forEach(function(field){return delete inputProps[field];});return inputProps;};var copyStyles=function copyStyles2(styles2,node){node.style.fontSize=styles2.fontSize;node.style.fontFamily=styles2.fontFamily;node.style.fontWeight=styles2.fontWeight;node.style.fontStyle=styles2.fontStyle;node.style.letterSpacing=styles2.letterSpacing;node.style.textTransform=styles2.textTransform;};var isIE=typeof window!=="undefined"&&window.navigator?/MSIE |Trident\/|Edge\//.test(window.navigator.userAgent):false;var generateId=function generateId2(){return isIE?"_"+Math.random().toString(36).substr(2,12):void 0;};var AutosizeInput=function(_Component){_inherits(AutosizeInput2,_Component);_createClass(AutosizeInput2,null,[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(props,state){var id=props.id;return id!==state.prevId?{inputId:id||generateId(),prevId:id}:null;}}]);function AutosizeInput2(props){_classCallCheck(this,AutosizeInput2);var _this=_possibleConstructorReturn(this,(AutosizeInput2.__proto__||Object.getPrototypeOf(AutosizeInput2)).call(this,props));_this.inputRef=function(el){_this.input=el;if(typeof _this.props.inputRef==="function"){_this.props.inputRef(el);}};_this.placeHolderSizerRef=function(el){_this.placeHolderSizer=el;};_this.sizerRef=function(el){_this.sizer=el;};_this.state={inputWidth:props.minWidth,inputId:props.id||generateId(),prevId:props.id};return _this;}_createClass(AutosizeInput2,[{key:"componentDidMount",value:function componentDidMount(){this.mounted=true;this.copyInputStyles();this.updateInputWidth();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(prevState.inputWidth!==this.state.inputWidth){if(typeof this.props.onAutosize==="function"){this.props.onAutosize(this.state.inputWidth);}}this.updateInputWidth();}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.mounted=false;}},{key:"copyInputStyles",value:function copyInputStyles(){if(!this.mounted||!window.getComputedStyle){return;}var inputStyles=this.input&&window.getComputedStyle(this.input);if(!inputStyles){return;}copyStyles(inputStyles,this.sizer);if(this.placeHolderSizer){copyStyles(inputStyles,this.placeHolderSizer);}}},{key:"updateInputWidth",value:function updateInputWidth(){if(!this.mounted||!this.sizer||typeof this.sizer.scrollWidth==="undefined"){return;}var newInputWidth=void 0;if(this.props.placeholder&&(!this.props.value||this.props.value&&this.props.placeholderIsMinWidth)){newInputWidth=Math.max(this.sizer.scrollWidth,this.placeHolderSizer.scrollWidth)+2;}else{newInputWidth=this.sizer.scrollWidth+2;}var extraWidth=this.props.type==="number"&&this.props.extraWidth===void 0?16:parseInt(this.props.extraWidth)||0;newInputWidth+=extraWidth;if(newInputWidth<this.props.minWidth){newInputWidth=this.props.minWidth;}if(newInputWidth!==this.state.inputWidth){this.setState({inputWidth:newInputWidth});}}},{key:"getInput",value:function getInput(){return this.input;}},{key:"focus",value:function focus(){this.input.focus();}},{key:"blur",value:function blur(){this.input.blur();}},{key:"select",value:function select(){this.input.select();}},{key:"renderStyles",value:function renderStyles(){var injectStyles=this.props.injectStyles;return isIE&&injectStyles?_react2["default"].createElement("style",{dangerouslySetInnerHTML:{__html:"input#"+this.state.inputId+"::-ms-clear {display: none;}"}}):null;}},{key:"render",value:function render3(){var sizerValue=[this.props.defaultValue,this.props.value,""].reduce(function(previousValue,currentValue){if(previousValue!==null&&previousValue!==void 0){return previousValue;}return currentValue;});var wrapperStyle=_extends({},this.props.style);if(!wrapperStyle.display)wrapperStyle.display="inline-block";var inputStyle=_extends({boxSizing:"content-box",width:this.state.inputWidth+"px"},this.props.inputStyle);var inputProps=_objectWithoutProperties(this.props,[]);cleanInputProps(inputProps);inputProps.className=this.props.inputClassName;inputProps.id=this.state.inputId;inputProps.style=inputStyle;return _react2["default"].createElement("div",{className:this.props.className,style:wrapperStyle},this.renderStyles(),_react2["default"].createElement("input",_extends({},inputProps,{ref:this.inputRef})),_react2["default"].createElement("div",{ref:this.sizerRef,style:sizerStyle},sizerValue),this.props.placeholder?_react2["default"].createElement("div",{ref:this.placeHolderSizerRef,style:sizerStyle},this.props.placeholder):null);}}]);return AutosizeInput2;}(_react$1.Component);AutosizeInput.propTypes={className:_propTypes2["default"].string,defaultValue:_propTypes2["default"].any,extraWidth:_propTypes2["default"].oneOfType([_propTypes2["default"].number,_propTypes2["default"].string]),id:_propTypes2["default"].string,injectStyles:_propTypes2["default"].bool,inputClassName:_propTypes2["default"].string,inputRef:_propTypes2["default"].func,inputStyle:_propTypes2["default"].object,minWidth:_propTypes2["default"].oneOfType([_propTypes2["default"].number,_propTypes2["default"].string]),onAutosize:_propTypes2["default"].func,onChange:_propTypes2["default"].func,placeholder:_propTypes2["default"].string,placeholderIsMinWidth:_propTypes2["default"].bool,style:_propTypes2["default"].object,value:_propTypes2["default"].any};AutosizeInput.defaultProps={minWidth:1,injectStyles:true};var _default=AutosizeInput$1["default"]=AutosizeInput;var Truncated=createStyled("span",{target:"ejgjitx0"})({name:"o3idik",styles:"&&{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"});var Container$1=/* @__PURE__ */createStyled(Input$1,{target:"ejgjitx1"})("&&{cursor:text;padding:0;&:focus-within{border-color:",style("input.valid.focusBorder"),";}&.disabled{border-color:",color("paleGrey"),";background-color:",color("offWhite"),";cursor:not-allowed;}& > div{pointer-events:none;max-width:100%;",padding("xxs"),";input{background:transparent;font-size:inherit;line-height:inherit;outline:0;border:0;padding:0;max-width:100%;}}&& .stylist-tag{vertical-align:top;transform:translateY(25%);margin:0 0 ",spacer(1)," ",spacer(1),";max-width:98%;}}");function TagInput(_ref235){var _ref235$value=_ref235.value,value=_ref235$value===void 0?[]:_ref235$value,_ref235$onChange=_ref235.onChange,onChange=_ref235$onChange===void 0?function(){}:_ref235$onChange,_ref235$placeholder=_ref235.placeholder,placeholder=_ref235$placeholder===void 0?"":_ref235$placeholder,_ref235$disabled=_ref235.disabled,disabled=_ref235$disabled===void 0?false:_ref235$disabled;var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),inputValue=_useState24[0],setInputValue=_useState24[1];var inputEl=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var containerEl=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var handleContainerClick=function handleContainerClick(e2){var _a2;if(e2.target===containerEl.current){(_a2=inputEl.current)==null?void 0:_a2.focus();}};var handleInputChange=function handleInputChange(e2){if(e2.target.value.includes(",")){if(!value.includes(e2.target.value)){onChange([].concat(_toConsumableArray(value),_toConsumableArray(e2.target.value.split(",").filter(Boolean))));}setInputValue("");}else{setInputValue(e2.target.value);}};var handleInputKeyDown=function handleInputKeyDown(e2){if(e2.key==="Enter"&&inputValue.length){if(!value.includes(inputValue)){onChange([].concat(_toConsumableArray(value),[inputValue]));}setInputValue("");}else if(e2.key==="Backspace"&&!inputValue.length&&value.length){onChange(value.slice(0,value.length-1));}};var handleTagDelete=function handleTagDelete(tag){return onChange(value.filter(function(t2){return t2!==tag;}));};var handleClickOutside=function handleClickOutside(){if(containerEl.current&&inputValue.length){if(!value.includes(inputValue)){onChange([].concat(_toConsumableArray(value),[inputValue]));}setInputValue("");}};return/* @__PURE__ */jsxs(Container$1,{as:"div",onClick:handleContainerClick,ref:containerEl,className:disabled?"disabled":"",children:[value.map(function(tag){return/* @__PURE__ */jsx(Tag,{id:tag,deletable:!disabled,onDelete:handleTagDelete,children:/* @__PURE__ */jsx(Truncated,{children:tag})},tag);}),/* @__PURE__ */jsx(_default,{inputRef:function inputRef(ref){return inputEl.current=ref;},value:inputValue,placeholder:(value==null?void 0:value.length)?"":placeholder,onChange:handleInputChange,onKeyDown:handleInputKeyDown,disabled:disabled,onBlur:handleClickOutside})]});}var CSSTransition={exports:{}};var addClass={exports:{}};var hasClass={exports:{}};(function(module2,exports){Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=hasClass2;function hasClass2(element,className){if(element.classList)return!!className&&element.classList.contains(className);else return(" "+(element.className.baseVal||element.className)+" ").indexOf(" "+className+" ")!==-1;}module2.exports=exports["default"];})(hasClass,hasClass.exports);(function(module2,exports){Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=addClass2;var _hasClass=hasClass.exports;var _hasClass2=_interopRequireDefault2(_hasClass);function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function addClass2(element,className){if(element.classList)element.classList.add(className);else if(!(0,_hasClass2["default"])(element,className))if(typeof element.className==="string")element.className=element.className+" "+className;else element.setAttribute("class",(element.className&&element.className.baseVal||"")+" "+className);}module2.exports=exports["default"];})(addClass,addClass.exports);function replaceClassName(origClass,classToRemove){return origClass.replace(new RegExp("(^|\\s)"+classToRemove+"(?:\\s|$)","g"),"$1").replace(/\s+/g," ").replace(/^\s*|\s*$/g,"");}var removeClass=function removeClass2(element,className){if(element.classList)element.classList.remove(className);else if(typeof element.className==="string")element.className=replaceClassName(element.className,className);else element.setAttribute("class",replaceClassName(element.className&&element.className.baseVal||"",className));};(function(module2,exports){exports.__esModule=true;var _extends2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _propTypes3=propTypes$2.exports;var PropTypes2=_interopRequireWildcard2(_propTypes3);var _addClass=addClass.exports;var _addClass2=_interopRequireDefault2(_addClass);var _removeClass=removeClass;var _removeClass2=_interopRequireDefault2(_removeClass);var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _Transition3=Transition$1;var _Transition22=_interopRequireDefault2(_Transition3);var _PropTypes=PropTypes$1;function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _interopRequireWildcard2(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key2 in obj){if(Object.prototype.hasOwnProperty.call(obj,key2))newObj[key2]=obj[key2];}}newObj["default"]=obj;return newObj;}}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn2(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var addClass$1=function addClass2(node,classes){return node&&classes&&classes.split(" ").forEach(function(c2){return(0,_addClass2["default"])(node,c2);});};var removeClass$1=function removeClass3(node,classes){return node&&classes&&classes.split(" ").forEach(function(c2){return(0,_removeClass2["default"])(node,c2);});};_extends2({},_Transition22["default"].propTypes,{classNames:_PropTypes.classNamesShape,onEnter:PropTypes2.func,onEntering:PropTypes2.func,onEntered:PropTypes2.func,onExit:PropTypes2.func,onExiting:PropTypes2.func,onExited:PropTypes2.func});var CSSTransition2=function(_React$Component){_inherits2(CSSTransition3,_React$Component);function CSSTransition3(){var _temp,_this,_ret;_classCallCheck2(this,CSSTransition3);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn2(this,_React$Component.call.apply(_React$Component,[this].concat(args))),_this),_this.onEnter=function(node,appearing){var _this$getClassNames=_this.getClassNames(appearing?"appear":"enter"),className=_this$getClassNames.className;_this.removeClasses(node,"exit");addClass$1(node,className);if(_this.props.onEnter){_this.props.onEnter(node);}},_this.onEntering=function(node,appearing){var _this$getClassNames2=_this.getClassNames(appearing?"appear":"enter"),activeClassName=_this$getClassNames2.activeClassName;_this.reflowAndAddClass(node,activeClassName);if(_this.props.onEntering){_this.props.onEntering(node);}},_this.onEntered=function(node,appearing){var _this$getClassNames3=_this.getClassNames("enter"),doneClassName=_this$getClassNames3.doneClassName;_this.removeClasses(node,appearing?"appear":"enter");addClass$1(node,doneClassName);if(_this.props.onEntered){_this.props.onEntered(node);}},_this.onExit=function(node){var _this$getClassNames4=_this.getClassNames("exit"),className=_this$getClassNames4.className;_this.removeClasses(node,"appear");_this.removeClasses(node,"enter");addClass$1(node,className);if(_this.props.onExit){_this.props.onExit(node);}},_this.onExiting=function(node){var _this$getClassNames5=_this.getClassNames("exit"),activeClassName=_this$getClassNames5.activeClassName;_this.reflowAndAddClass(node,activeClassName);if(_this.props.onExiting){_this.props.onExiting(node);}},_this.onExited=function(node){var _this$getClassNames6=_this.getClassNames("exit"),doneClassName=_this$getClassNames6.doneClassName;_this.removeClasses(node,"exit");addClass$1(node,doneClassName);if(_this.props.onExited){_this.props.onExited(node);}},_this.getClassNames=function(type){var classNames=_this.props.classNames;var className=typeof classNames!=="string"?classNames[type]:classNames+"-"+type;var activeClassName=typeof classNames!=="string"?classNames[type+"Active"]:className+"-active";var doneClassName=typeof classNames!=="string"?classNames[type+"Done"]:className+"-done";return{className:className,activeClassName:activeClassName,doneClassName:doneClassName};},_temp),_possibleConstructorReturn2(_this,_ret);}CSSTransition3.prototype.removeClasses=function removeClasses(node,type){var _getClassNames=this.getClassNames(type),className=_getClassNames.className,activeClassName=_getClassNames.activeClassName,doneClassName=_getClassNames.doneClassName;className&&removeClass$1(node,className);activeClassName&&removeClass$1(node,activeClassName);doneClassName&&removeClass$1(node,doneClassName);};CSSTransition3.prototype.reflowAndAddClass=function reflowAndAddClass(node,className){node&&node.scrollTop;addClass$1(node,className);};CSSTransition3.prototype.render=function render3(){var props=_extends2({},this.props);delete props.classNames;return _react22["default"].createElement(_Transition22["default"],_extends2({},props,{onEnter:this.onEnter,onEntered:this.onEntered,onEntering:this.onEntering,onExit:this.onExit,onExiting:this.onExiting,onExited:this.onExited}));};return CSSTransition3;}(_react22["default"].Component);CSSTransition2.propTypes={};exports["default"]=CSSTransition2;module2.exports=exports["default"];})(CSSTransition,CSSTransition.exports);var ReplaceTransition={exports:{}};var TransitionGroup={exports:{}};var ChildMapping={};ChildMapping.__esModule=true;ChildMapping.getChildMapping=getChildMapping;ChildMapping.mergeChildMappings=mergeChildMappings;var _react=__WEBPACK_IMPORTED_MODULE_0_react___default.a;function getChildMapping(children,mapFn){var mapper=function mapper2(child){return mapFn&&(0,_react.isValidElement)(child)?mapFn(child):child;};var result=/* @__PURE__ */Object.create(null);if(children)_react.Children.map(children,function(c2){return c2;}).forEach(function(child){result[child.key]=mapper(child);});return result;}function mergeChildMappings(prev,next){prev=prev||{};next=next||{};function getValueForKey(key2){return key2 in next?next[key2]:prev[key2];}var nextKeysPending=/* @__PURE__ */Object.create(null);var pendingKeys=[];for(var prevKey in prev){if(prevKey in next){if(pendingKeys.length){nextKeysPending[prevKey]=pendingKeys;pendingKeys=[];}}else{pendingKeys.push(prevKey);}}var i=void 0;var childMapping={};for(var nextKey in next){if(nextKeysPending[nextKey]){for(i=0;i<nextKeysPending[nextKey].length;i++){var pendingNextKey=nextKeysPending[nextKey][i];childMapping[nextKeysPending[nextKey][i]]=getValueForKey(pendingNextKey);}}childMapping[nextKey]=getValueForKey(nextKey);}for(i=0;i<pendingKeys.length;i++){childMapping[pendingKeys[i]]=getValueForKey(pendingKeys[i]);}return childMapping;}(function(module2,exports){exports.__esModule=true;var _extends2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key2 in source){if(Object.prototype.hasOwnProperty.call(source,key2)){target[key2]=source[key2];}}}return target;};var _propTypes3=propTypes$2.exports;var _propTypes22=_interopRequireDefault2(_propTypes3);var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _ChildMapping=ChildMapping;function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _objectWithoutProperties2(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn2(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var values=Object.values||function(obj){return Object.keys(obj).map(function(k2){return obj[k2];});};({component:_propTypes22["default"].any,children:_propTypes22["default"].node,appear:_propTypes22["default"].bool,enter:_propTypes22["default"].bool,exit:_propTypes22["default"].bool,childFactory:_propTypes22["default"].func});var defaultProps3={component:"div",childFactory:function childFactory(child){return child;}};var TransitionGroup2=function(_React$Component){_inherits2(TransitionGroup3,_React$Component);function TransitionGroup3(props,context){_classCallCheck2(this,TransitionGroup3);var _this=_possibleConstructorReturn2(this,_React$Component.call(this,props,context));_this.state={children:(0,_ChildMapping.getChildMapping)(props.children,function(child){return(0,_react3.cloneElement)(child,{onExited:_this.handleExited.bind(_this,child),"in":true,appear:_this.getProp(child,"appear"),enter:_this.getProp(child,"enter"),exit:_this.getProp(child,"exit")});})};return _this;}TransitionGroup3.prototype.getChildContext=function getChildContext(){return{transitionGroup:{isMounting:!this.appeared}};};TransitionGroup3.prototype.getProp=function getProp(child,prop2){var props=arguments.length>2&&arguments[2]!==void 0?arguments[2]:this.props;return props[prop2]!=null?props[prop2]:child.props[prop2];};TransitionGroup3.prototype.componentDidMount=function componentDidMount(){this.appeared=true;};TransitionGroup3.prototype.componentWillReceiveProps=function componentWillReceiveProps(nextProps){var _this2=this;var prevChildMapping=this.state.children;var nextChildMapping=(0,_ChildMapping.getChildMapping)(nextProps.children);var children=(0,_ChildMapping.mergeChildMappings)(prevChildMapping,nextChildMapping);Object.keys(children).forEach(function(key2){var child=children[key2];if(!(0,_react3.isValidElement)(child))return;var hasPrev=key2 in prevChildMapping;var hasNext=key2 in nextChildMapping;var prevChild=prevChildMapping[key2];var isLeaving=(0,_react3.isValidElement)(prevChild)&&!prevChild.props["in"];if(hasNext&&(!hasPrev||isLeaving)){children[key2]=(0,_react3.cloneElement)(child,{onExited:_this2.handleExited.bind(_this2,child),"in":true,exit:_this2.getProp(child,"exit",nextProps),enter:_this2.getProp(child,"enter",nextProps)});}else if(!hasNext&&hasPrev&&!isLeaving){children[key2]=(0,_react3.cloneElement)(child,{"in":false});}else if(hasNext&&hasPrev&&(0,_react3.isValidElement)(prevChild)){children[key2]=(0,_react3.cloneElement)(child,{onExited:_this2.handleExited.bind(_this2,child),"in":prevChild.props["in"],exit:_this2.getProp(child,"exit",nextProps),enter:_this2.getProp(child,"enter",nextProps)});}});this.setState({children:children});};TransitionGroup3.prototype.handleExited=function handleExited(child,node){var currentChildMapping=(0,_ChildMapping.getChildMapping)(this.props.children);if(child.key in currentChildMapping)return;if(child.props.onExited){child.props.onExited(node);}this.setState(function(state){var children=_extends2({},state.children);delete children[child.key];return{children:children};});};TransitionGroup3.prototype.render=function render3(){var _props=this.props,Component2=_props.component,childFactory=_props.childFactory,props=_objectWithoutProperties2(_props,["component","childFactory"]);var children=values(this.state.children).map(childFactory);delete props.appear;delete props.enter;delete props.exit;if(Component2===null){return children;}return _react22["default"].createElement(Component2,props,children);};return TransitionGroup3;}(_react22["default"].Component);TransitionGroup2.childContextTypes={transitionGroup:_propTypes22["default"].object.isRequired};TransitionGroup2.propTypes={};TransitionGroup2.defaultProps=defaultProps3;exports["default"]=TransitionGroup2;module2.exports=exports["default"];})(TransitionGroup,TransitionGroup.exports);(function(module2,exports){exports.__esModule=true;var _propTypes3=propTypes$2.exports;var _propTypes22=_interopRequireDefault2(_propTypes3);var _react3=__WEBPACK_IMPORTED_MODULE_0_react___default.a;var _react22=_interopRequireDefault2(_react3);var _reactDom3=__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a;var _TransitionGroup3=TransitionGroup.exports;var _TransitionGroup22=_interopRequireDefault2(_TransitionGroup3);function _interopRequireDefault2(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _objectWithoutProperties2(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn2(self2,call){if(!self2){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof2(call)==="object"||typeof call==="function")?call:self2;}function _inherits2(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof2(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}({"in":_propTypes22["default"].bool.isRequired,children:function children(props,propName){if(_react22["default"].Children.count(props[propName])!==2)return new Error('"'+propName+'" must be exactly two transition components.');return null;}});var ReplaceTransition2=function(_React$Component){_inherits2(ReplaceTransition3,_React$Component);function ReplaceTransition3(){var _temp,_this,_ret;_classCallCheck2(this,ReplaceTransition3);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn2(this,_React$Component.call.apply(_React$Component,[this].concat(args))),_this),_initialiseProps.call(_this),_temp),_possibleConstructorReturn2(_this,_ret);}ReplaceTransition3.prototype.handleLifecycle=function handleLifecycle(handler,idx,originalArgs){var _child$props;var children=this.props.children;var child=_react22["default"].Children.toArray(children)[idx];if(child.props[handler])(_child$props=child.props)[handler].apply(_child$props,originalArgs);if(this.props[handler])this.props[handler]((0,_reactDom3.findDOMNode)(this));};ReplaceTransition3.prototype.render=function render3(){var _props=this.props,children=_props.children,inProp=_props["in"],props=_objectWithoutProperties2(_props,["children","in"]);var _React$Children$toArr=_react22["default"].Children.toArray(children),first=_React$Children$toArr[0],second=_React$Children$toArr[1];delete props.onEnter;delete props.onEntering;delete props.onEntered;delete props.onExit;delete props.onExiting;delete props.onExited;return _react22["default"].createElement(_TransitionGroup22["default"],props,inProp?_react22["default"].cloneElement(first,{key:"first",onEnter:this.handleEnter,onEntering:this.handleEntering,onEntered:this.handleEntered}):_react22["default"].cloneElement(second,{key:"second",onEnter:this.handleExit,onEntering:this.handleExiting,onEntered:this.handleExited}));};return ReplaceTransition3;}(_react22["default"].Component);var _initialiseProps=function _initialiseProps2(){var _this2=this;this.handleEnter=function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _this2.handleLifecycle("onEnter",0,args);};this.handleEntering=function(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _this2.handleLifecycle("onEntering",0,args);};this.handleEntered=function(){for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return _this2.handleLifecycle("onEntered",0,args);};this.handleExit=function(){for(var _len5=arguments.length,args=Array(_len5),_key5=0;_key5<_len5;_key5++){args[_key5]=arguments[_key5];}return _this2.handleLifecycle("onExit",1,args);};this.handleExiting=function(){for(var _len6=arguments.length,args=Array(_len6),_key6=0;_key6<_len6;_key6++){args[_key6]=arguments[_key6];}return _this2.handleLifecycle("onExiting",1,args);};this.handleExited=function(){for(var _len7=arguments.length,args=Array(_len7),_key7=0;_key7<_len7;_key7++){args[_key7]=arguments[_key7];}return _this2.handleLifecycle("onExited",1,args);};};ReplaceTransition2.propTypes={};exports["default"]=ReplaceTransition2;module2.exports=exports["default"];})(ReplaceTransition,ReplaceTransition.exports);var _CSSTransition=CSSTransition.exports;var _CSSTransition2=_interopRequireDefault(_CSSTransition);var _ReplaceTransition=ReplaceTransition.exports;var _ReplaceTransition2=_interopRequireDefault(_ReplaceTransition);var _TransitionGroup=TransitionGroup.exports;var _TransitionGroup2=_interopRequireDefault(_TransitionGroup);var _Transition=Transition$1;var _Transition2=_interopRequireDefault(_Transition);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}var reactTransitionGroup={Transition:_Transition2["default"],TransitionGroup:_TransitionGroup2["default"],ReplaceTransition:_ReplaceTransition2["default"],CSSTransition:_CSSTransition2["default"]};var defaultStyle=function defaultStyle(height,timeout){return{height:height,transition:"height ".concat(timeout,"ms linear 0s"),overflow:"hidden"};};var transitionStyles={entering:{},entered:{overflow:"auto"},exiting:{height:0},exited:{height:0}};var Collapse=function Collapse(_Hb){var _Ib=_Hb,_children7=_Ib.children,expandedHeight=_Ib.expandedHeight,isOpen=_Ib.isOpen,_Ib$timeout=_Ib.timeout,timeout=_Ib$timeout===void 0?200:_Ib$timeout,props=__objRest(_Ib,["children","expandedHeight","isOpen","timeout"]);var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState26=_slicedToArray(_useState25,2),containerRef=_useState26[0],setRef3=_useState26[1];if(!expandedHeight){expandedHeight=containerRef==null?void 0:containerRef.scrollHeight;}return/* @__PURE__ */jsx(reactTransitionGroup.Transition,{"in":isOpen,timeout:timeout,children:function children(state){return/* @__PURE__ */jsx("div",__spreadProps(__spreadValues({},props),{ref:setRef3,style:__spreadValues(__spreadValues({},defaultStyle(expandedHeight,timeout)),transitionStyles[state]),children:_children7}));}});};Collapse.propTypes={isOpen:PropTypes$2.bool,expandedHeight:PropTypes$2.number,timeout:PropTypes$2.number,children:PropTypes$2.node};var HeadingButton=createStyled("div",{target:"eu8k2ui0"})(borderRadius$1("default"),";background-color:",color("offWhite"),";",padding("xs"),";font-weight:bold;cursor:pointer;&:hover{background-color:",color("paleGrey"),";border-color:",color("paleGrey"),";}");var ChevronWithMargin=/* @__PURE__ */createStyled(Chevron$1,{target:"eu8k2ui1"})("margin-right:",spacer(3),";");var TOGGLE_KEYS=["Enter"," "];var Summary=function Summary(_Jb){var _Kb=_Jb,children=_Kb.children,isOpen=_Kb.isOpen,_Kb$ariaLevel=_Kb.ariaLevel,ariaLevel=_Kb$ariaLevel===void 0?3:_Kb$ariaLevel,_Kb$onChange=_Kb.onChange,onChange=_Kb$onChange===void 0?function(){}:_Kb$onChange,props=__objRest(_Kb,["children","isOpen","ariaLevel","onChange"]);var handleKeyboard=function handleKeyboard(event){return TOGGLE_KEYS.includes(event.key)&&onChange(!isOpen);};return/* @__PURE__ */jsx("div",{role:"heading","aria-level":ariaLevel,children:/* @__PURE__ */jsxs(HeadingButton,__spreadProps(__spreadValues({role:"button","aria-expanded":isOpen,tabIndex:0,onKeyDown:handleKeyboard,onClick:function onClick(){return onChange(!isOpen);}},props),{children:[/* @__PURE__ */jsx(ChevronWithMargin,{size:"xs",direction:isOpen?"up":"down"}),children]}))});};Summary.propTypes={isOpen:PropTypes$2.bool,onChange:PropTypes$2.func,ariaLevel:PropTypes$2.number,children:PropTypes$2.node};var Content=createStyled("div",{target:"eotoo5d0"})(padding("sm"),";");var Details=function Details(_Lb){var _Mb=_Lb,children=_Mb.children,props=__objRest(_Mb,["children"]);return/* @__PURE__ */jsx(Collapse,__spreadProps(__spreadValues({},props),{children:/* @__PURE__ */jsx(Content,{children:children})}));};Details.propTypes={isOpen:PropTypes$2.bool,expandedHeight:PropTypes$2.number,timeout:PropTypes$2.number,children:PropTypes$2.node};var Container=createStyled("div",{target:"e102jfws0"})(borderRadius$1("default"),";background-color:",color("offWhite"),";");var Accordion=function Accordion(_Nb){var _Ob=_Nb,children=_Ob.children,isOpen=_Ob.isOpen,expandedHeight=_Ob.expandedHeight,timeout=_Ob.timeout,props=__objRest(_Ob,["children","isOpen","expandedHeight","timeout"]);return/* @__PURE__ */jsx(Container,__spreadProps(__spreadValues({},props),{children:__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)?Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child,{isOpen:isOpen,expandedHeight:expandedHeight,timeout:timeout}):child;})}));};Accordion.propTypes={isOpen:PropTypes$2.bool,expandedHeight:PropTypes$2.number,timeout:PropTypes$2.number,children:PropTypes$2.node};Accordion.Summary=Summary;Accordion.Details=Details;var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c=typeof document!=="undefined"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.useLayoutEffect:function(){};var $8ae05eaa5c114e9c$var$_React_useInsertionEffect;var $8ae05eaa5c114e9c$var$useEarlyEffect=($8ae05eaa5c114e9c$var$_React_useInsertionEffect=__WEBPACK_IMPORTED_MODULE_0_react___default.a["useInsertionEffect"])!==null&&$8ae05eaa5c114e9c$var$_React_useInsertionEffect!==void 0?$8ae05eaa5c114e9c$var$_React_useInsertionEffect:$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c;function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn2){var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);$8ae05eaa5c114e9c$var$useEarlyEffect(function(){ref.current=fn2;},[fn2]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){var f2=ref.current;return f2===null||f2===void 0?void 0:f2.apply(void 0,arguments);},[]);}function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue){var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultValue),_useState28=_slicedToArray(_useState27,2),value=_useState28[0],setValue=_useState28[1];var effect2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var nextRef=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(){if(!effect2.current)return;var newValue=effect2.current.next();if(newValue.done){effect2.current=null;return;}if(value===newValue.value)nextRef();else setValue(newValue.value);});$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){if(effect2.current)nextRef();});var queue=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(fn2){effect2.current=fn2(value);nextRef();});return[value,queue];}var $b5e257d569688ac6$var$defaultContext={prefix:String(Math.round(Math.random()*1e10)),current:0};var $b5e257d569688ac6$var$SSRContext=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext($b5e257d569688ac6$var$defaultContext);var $b5e257d569688ac6$var$IsSSRContext=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(false);var $b5e257d569688ac6$var$canUseDOM=Boolean(typeof window!=="undefined"&&window.document&&window.document.createElement);var $b5e257d569688ac6$var$componentIds=/* @__PURE__ */new WeakMap();function $b5e257d569688ac6$var$useCounter(){var isDisabled=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var ctx=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($b5e257d569688ac6$var$SSRContext);var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);if(ref.current===null&&!isDisabled){var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner,_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;var currentOwner=(_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=__WEBPACK_IMPORTED_MODULE_0_react___default.a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED)===null||_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED===void 0?void 0:(_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner=_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner)===null||_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner===void 0?void 0:_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;if(currentOwner){var prevComponentValue=$b5e257d569688ac6$var$componentIds.get(currentOwner);if(prevComponentValue==null)$b5e257d569688ac6$var$componentIds.set(currentOwner,{id:ctx.current,state:currentOwner.memoizedState});else if(currentOwner.memoizedState!==prevComponentValue.state){ctx.current=prevComponentValue.id;$b5e257d569688ac6$var$componentIds["delete"](currentOwner);}}ref.current=++ctx.current;}return ref.current;}function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId){var ctx=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($b5e257d569688ac6$var$SSRContext);if(ctx===$b5e257d569688ac6$var$defaultContext&&!$b5e257d569688ac6$var$canUseDOM&&false)console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");var counter2=$b5e257d569688ac6$var$useCounter(!!defaultId);var prefix=ctx===$b5e257d569688ac6$var$defaultContext&&false?"react-aria":"react-aria".concat(ctx.prefix);return defaultId||"".concat(prefix,"-").concat(counter2);}function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId){var id=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useId();var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])($b5e257d569688ac6$export$535bd6ca7f90a273()),_useState30=_slicedToArray(_useState29,1),didSSR=_useState30[0];var prefix=didSSR||false?"react-aria":"react-aria".concat($b5e257d569688ac6$var$defaultContext.prefix);return defaultId||"".concat(prefix,"-").concat(id);}var $b5e257d569688ac6$export$619500959fc48b26=typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a["useId"]==="function"?$b5e257d569688ac6$var$useModernSSRSafeId:$b5e257d569688ac6$var$useLegacySSRSafeId;function $b5e257d569688ac6$var$getSnapshot(){return false;}function $b5e257d569688ac6$var$getServerSnapshot(){return true;}function $b5e257d569688ac6$var$subscribe(onStoreChange){return function(){};}function $b5e257d569688ac6$export$535bd6ca7f90a273(){if(typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a["useSyncExternalStore"]==="function")return __WEBPACK_IMPORTED_MODULE_0_react___default.a["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe,$b5e257d569688ac6$var$getSnapshot,$b5e257d569688ac6$var$getServerSnapshot);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($b5e257d569688ac6$var$IsSSRContext);}var $bdb11010cef70236$var$canUseDOM=Boolean(typeof window!=="undefined"&&window.document&&window.document.createElement);var $bdb11010cef70236$export$d41a04c74483c6ef=/* @__PURE__ */new Map();var $bdb11010cef70236$var$registry;if(typeof FinalizationRegistry!=="undefined")$bdb11010cef70236$var$registry=new FinalizationRegistry(function(heldValue){$bdb11010cef70236$export$d41a04c74483c6ef["delete"](heldValue);});function $bdb11010cef70236$export$f680877a34711e37(defaultId){var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultId),_useState32=_slicedToArray(_useState31,2),value=_useState32[0],setValue=_useState32[1];var nextId=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var res=$b5e257d569688ac6$export$619500959fc48b26(value);var cleanupRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);if($bdb11010cef70236$var$registry)$bdb11010cef70236$var$registry.register(cleanupRef,res);if($bdb11010cef70236$var$canUseDOM){var cacheIdRef=$bdb11010cef70236$export$d41a04c74483c6ef.get(res);if(cacheIdRef&&!cacheIdRef.includes(nextId))cacheIdRef.push(nextId);else $bdb11010cef70236$export$d41a04c74483c6ef.set(res,[nextId]);}$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var r2=res;return function(){if($bdb11010cef70236$var$registry)$bdb11010cef70236$var$registry.unregister(cleanupRef);$bdb11010cef70236$export$d41a04c74483c6ef["delete"](r2);};},[res]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var newId=nextId.current;if(newId)setValue(newId);return function(){if(newId)nextId.current=null;};});return res;}function $bdb11010cef70236$export$cd8c9cb68f842629(idA,idB){if(idA===idB)return idA;var setIdsA=$bdb11010cef70236$export$d41a04c74483c6ef.get(idA);if(setIdsA){setIdsA.forEach(function(ref){return ref.current=idB;});return idB;}var setIdsB=$bdb11010cef70236$export$d41a04c74483c6ef.get(idB);if(setIdsB){setIdsB.forEach(function(ref){return ref.current=idA;});return idA;}return idB;}function $bdb11010cef70236$export$b4cc09c592e8fdb8(){var depArray=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var id=$bdb11010cef70236$export$f680877a34711e37();var _$1dbecbe27a04f9af$ex=$1dbecbe27a04f9af$export$14d238f342723f25(id),_$1dbecbe27a04f9af$ex2=_slicedToArray(_$1dbecbe27a04f9af$ex,2),resolvedId=_$1dbecbe27a04f9af$ex2[0],setResolvedId=_$1dbecbe27a04f9af$ex2[1];var updateId=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){setResolvedId(/*#__PURE__*/_regenerator().m(function _callee(){return _regenerator().w(function(_context){while(1)switch(_context.n){case 0:_context.n=1;return id;case 1:_context.n=2;return document.getElementById(id)?id:void 0;case 2:return _context.a(2);}},_callee);}));},[id,setResolvedId]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId,[id,updateId].concat(_toConsumableArray(depArray)));return resolvedId;}function $ff5963eb1fccf552$export$e08e3b67e392101e(){for(var _len10=arguments.length,callbacks=new Array(_len10),_key10=0;_key10<_len10;_key10++){callbacks[_key10]=arguments[_key10];}return function(){for(var _i4=0,_callbacks=callbacks;_i4<_callbacks.length;_i4++){var callback=_callbacks[_i4];if(typeof callback==="function")callback.apply(void 0,arguments);}};}var $431fbd86ca7dc216$export$b204af158042fbac=function $431fbd86ca7dc216$export$b204af158042fbac(el){var _el_ownerDocument;return(_el_ownerDocument=el===null||el===void 0?void 0:el.ownerDocument)!==null&&_el_ownerDocument!==void 0?_el_ownerDocument:document;};var $431fbd86ca7dc216$export$f21a1ffae260145a=function $431fbd86ca7dc216$export$f21a1ffae260145a(el){if(el&&"window"in el&&el.window===el)return el;var doc=$431fbd86ca7dc216$export$b204af158042fbac(el);return doc.defaultView||window;};function $431fbd86ca7dc216$var$isNode(value){return value!==null&&_typeof2(value)==="object"&&"nodeType"in value&&typeof value.nodeType==="number";}function $431fbd86ca7dc216$export$af51f0f06c0f328a(node){return $431fbd86ca7dc216$var$isNode(node)&&node.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&"host"in node;}var $f4e2df6bd15f8569$var$_shadowDOM=false;function $f4e2df6bd15f8569$export$98658e8c59125e6a(){return $f4e2df6bd15f8569$var$_shadowDOM;}function $d4ee10de306f2510$export$4282f70798064fe0(node,otherNode){if(!$f4e2df6bd15f8569$export$98658e8c59125e6a())return otherNode&&node?node.contains(otherNode):false;if(!node||!otherNode)return false;var currentNode=otherNode;while(currentNode!==null){if(currentNode===node)return true;if(currentNode.tagName==="SLOT"&&currentNode.assignedSlot)currentNode=currentNode.assignedSlot.parentNode;else if($431fbd86ca7dc216$export$af51f0f06c0f328a(currentNode))currentNode=currentNode.host;else currentNode=currentNode.parentNode;}return false;}var $d4ee10de306f2510$export$cd4e5573fbe2b576=function $d4ee10de306f2510$export$cd4e5573fbe2b576(){var doc=arguments.length>0&&arguments[0]!==undefined?arguments[0]:document;var _activeElement_shadowRoot;if(!$f4e2df6bd15f8569$export$98658e8c59125e6a())return doc.activeElement;var activeElement=doc.activeElement;while(activeElement&&"shadowRoot"in activeElement&&((_activeElement_shadowRoot=activeElement.shadowRoot)===null||_activeElement_shadowRoot===void 0?void 0:_activeElement_shadowRoot.activeElement))activeElement=activeElement.shadowRoot.activeElement;return activeElement;};function $d4ee10de306f2510$export$e58f029f0fbfdb29(event){if($f4e2df6bd15f8569$export$98658e8c59125e6a()&&event.target.shadowRoot){if(event.composedPath)return event.composedPath()[0];}return event.target;}var $dfc540311bf7f109$export$63eb3ababa9c55c4=/*#__PURE__*/function(){function $dfc540311bf7f109$export$63eb3ababa9c55c4(doc,root2,whatToShow,filter){var _this13=this;_classCallCheck3(this,$dfc540311bf7f109$export$63eb3ababa9c55c4);this._walkerStack=[];this._currentSetFor=/* @__PURE__ */new Set();this._acceptNode=function(node){if(node.nodeType===Node.ELEMENT_NODE){var shadowRoot2=node.shadowRoot;if(shadowRoot2){var walker=_this13._doc.createTreeWalker(shadowRoot2,_this13.whatToShow,{acceptNode:_this13._acceptNode});_this13._walkerStack.unshift(walker);return NodeFilter.FILTER_ACCEPT;}else{var _this_filter;if(typeof _this13.filter==="function")return _this13.filter(node);else if((_this_filter=_this13.filter)===null||_this_filter===void 0?void 0:_this_filter.acceptNode)return _this13.filter.acceptNode(node);else if(_this13.filter===null)return NodeFilter.FILTER_ACCEPT;}}return NodeFilter.FILTER_SKIP;};this._doc=doc;this.root=root2;this.filter=filter!==null&&filter!==void 0?filter:null;this.whatToShow=whatToShow!==null&&whatToShow!==void 0?whatToShow:NodeFilter.SHOW_ALL;this._currentNode=root2;this._walkerStack.unshift(doc.createTreeWalker(root2,whatToShow,this._acceptNode));var shadowRoot=root2.shadowRoot;if(shadowRoot){var walker=this._doc.createTreeWalker(shadowRoot,this.whatToShow,{acceptNode:this._acceptNode});this._walkerStack.unshift(walker);}}return _createClass3($dfc540311bf7f109$export$63eb3ababa9c55c4,[{key:"currentNode",get:function get(){return this._currentNode;},set:function set(node){if(!$d4ee10de306f2510$export$4282f70798064fe0(this.root,node))throw new Error("Cannot set currentNode to a node that is not contained by the root node.");var walkers=[];var curNode=node;var currentWalkerCurrentNode=node;this._currentNode=node;while(curNode&&curNode!==this.root)if(curNode.nodeType===Node.DOCUMENT_FRAGMENT_NODE){var shadowRoot=curNode;var walker2=this._doc.createTreeWalker(shadowRoot,this.whatToShow,{acceptNode:this._acceptNode});walkers.push(walker2);walker2.currentNode=currentWalkerCurrentNode;this._currentSetFor.add(walker2);curNode=currentWalkerCurrentNode=shadowRoot.host;}else curNode=curNode.parentNode;var walker=this._doc.createTreeWalker(this.root,this.whatToShow,{acceptNode:this._acceptNode});walkers.push(walker);walker.currentNode=currentWalkerCurrentNode;this._currentSetFor.add(walker);this._walkerStack=walkers;}},{key:"doc",get:function get(){return this._doc;}},{key:"firstChild",value:function firstChild(){var currentNode=this.currentNode;var newNode=this.nextNode();if(!$d4ee10de306f2510$export$4282f70798064fe0(currentNode,newNode)){this.currentNode=currentNode;return null;}if(newNode)this.currentNode=newNode;return newNode;}},{key:"lastChild",value:function lastChild(){var walker=this._walkerStack[0];var newNode=walker.lastChild();if(newNode)this.currentNode=newNode;return newNode;}},{key:"nextNode",value:function nextNode(){var nextNode=this._walkerStack[0].nextNode();if(nextNode){var shadowRoot=nextNode.shadowRoot;if(shadowRoot){var _this_filter;var nodeResult;if(typeof this.filter==="function")nodeResult=this.filter(nextNode);else if((_this_filter=this.filter)===null||_this_filter===void 0?void 0:_this_filter.acceptNode)nodeResult=this.filter.acceptNode(nextNode);if(nodeResult===NodeFilter.FILTER_ACCEPT){this.currentNode=nextNode;return nextNode;}var newNode=this.nextNode();if(newNode)this.currentNode=newNode;return newNode;}if(nextNode)this.currentNode=nextNode;return nextNode;}else{if(this._walkerStack.length>1){this._walkerStack.shift();var _newNode=this.nextNode();if(_newNode)this.currentNode=_newNode;return _newNode;}else return null;}}},{key:"previousNode",value:function previousNode(){var currentWalker=this._walkerStack[0];if(currentWalker.currentNode===currentWalker.root){if(this._currentSetFor.has(currentWalker)){this._currentSetFor["delete"](currentWalker);if(this._walkerStack.length>1){this._walkerStack.shift();var newNode=this.previousNode();if(newNode)this.currentNode=newNode;return newNode;}else return null;}return null;}var previousNode=currentWalker.previousNode();if(previousNode){var shadowRoot=previousNode.shadowRoot;if(shadowRoot){var _this_filter;var nodeResult;if(typeof this.filter==="function")nodeResult=this.filter(previousNode);else if((_this_filter=this.filter)===null||_this_filter===void 0?void 0:_this_filter.acceptNode)nodeResult=this.filter.acceptNode(previousNode);if(nodeResult===NodeFilter.FILTER_ACCEPT){if(previousNode)this.currentNode=previousNode;return previousNode;}var _newNode2=this.lastChild();if(_newNode2)this.currentNode=_newNode2;return _newNode2;}if(previousNode)this.currentNode=previousNode;return previousNode;}else{if(this._walkerStack.length>1){this._walkerStack.shift();var _newNode3=this.previousNode();if(_newNode3)this.currentNode=_newNode3;return _newNode3;}else return null;}}},{key:"nextSibling",value:function nextSibling(){return null;}},{key:"previousSibling",value:function previousSibling(){return null;}},{key:"parentNode",value:function parentNode(){return null;}}]);}();function $dfc540311bf7f109$export$4d0f8be8b12a7ef6(doc,root2,whatToShow,filter){if($f4e2df6bd15f8569$export$98658e8c59125e6a())return new $dfc540311bf7f109$export$63eb3ababa9c55c4(doc,root2,whatToShow,filter);return doc.createTreeWalker(root2,whatToShow,filter);}function r(e2){var t2,f2,n2="";if(typeof e2=="string"||typeof e2=="number")n2+=e2;else if(_typeof2(e2)=="object")if(Array.isArray(e2)){var o=e2.length;for(t2=0;t2<o;t2++)e2[t2]&&(f2=r(e2[t2]))&&(n2&&(n2+=" "),n2+=f2);}else for(f2 in e2)e2[f2]&&(n2&&(n2+=" "),n2+=f2);return n2;}function clsx(){for(var e2,t2,f2=0,n2="",o=arguments.length;f2<o;f2++)(e2=arguments[f2])&&(t2=r(e2))&&(n2&&(n2+=" "),n2+=t2);return n2;}function $3ef42575df84b30b$export$9d1611c77c2fe928(){var result=__spreadValues({},arguments.length<=0?undefined:arguments[0]);for(var _i5=1;_i5<arguments.length;_i5++){var props=_i5<0||arguments.length<=_i5?undefined:arguments[_i5];for(var key2 in props){var a=result[key2];var b2=props[key2];if(typeof a==="function"&&typeof b2==="function"&&key2[0]==="o"&&key2[1]==="n"&&key2.charCodeAt(2)>=65&&key2.charCodeAt(2)<=90)result[key2]=$ff5963eb1fccf552$export$e08e3b67e392101e(a,b2);else if((key2==="className"||key2==="UNSAFE_className")&&typeof a==="string"&&typeof b2==="string")result[key2]=clsx(a,b2);else if(key2==="id"&&a&&b2)result.id=$bdb11010cef70236$export$cd8c9cb68f842629(a,b2);else result[key2]=b2!==void 0?b2:a;}}return result;}var $65484d02dcb7eb3e$var$DOMPropNames=/* @__PURE__ */new Set(["id"]);var $65484d02dcb7eb3e$var$labelablePropNames=/* @__PURE__ */new Set(["aria-label","aria-labelledby","aria-describedby","aria-details"]);var $65484d02dcb7eb3e$var$linkPropNames=/* @__PURE__ */new Set(["href","hrefLang","target","rel","download","ping","referrerPolicy"]);var $65484d02dcb7eb3e$var$globalAttrs=/* @__PURE__ */new Set(["dir","lang","hidden","inert","translate"]);var $65484d02dcb7eb3e$var$globalEvents=/* @__PURE__ */new Set(["onClick","onAuxClick","onContextMenu","onDoubleClick","onMouseDown","onMouseEnter","onMouseLeave","onMouseMove","onMouseOut","onMouseOver","onMouseUp","onTouchCancel","onTouchEnd","onTouchMove","onTouchStart","onPointerDown","onPointerMove","onPointerUp","onPointerCancel","onPointerEnter","onPointerLeave","onPointerOver","onPointerOut","onGotPointerCapture","onLostPointerCapture","onScroll","onWheel","onAnimationStart","onAnimationEnd","onAnimationIteration","onTransitionCancel","onTransitionEnd","onTransitionRun","onTransitionStart"]);var $65484d02dcb7eb3e$var$propRe=/^(data-.*)$/;function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props){var opts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var labelable=opts.labelable,isLink=opts.isLink,global2=opts.global,_opts$events=opts.events,events=_opts$events===void 0?global2:_opts$events,propNames=opts.propNames;var filteredProps={};for(var prop2 in props)if(Object.prototype.hasOwnProperty.call(props,prop2)&&($65484d02dcb7eb3e$var$DOMPropNames.has(prop2)||labelable&&$65484d02dcb7eb3e$var$labelablePropNames.has(prop2)||isLink&&$65484d02dcb7eb3e$var$linkPropNames.has(prop2)||global2&&$65484d02dcb7eb3e$var$globalAttrs.has(prop2)||events&&$65484d02dcb7eb3e$var$globalEvents.has(prop2)||prop2.endsWith("Capture")&&$65484d02dcb7eb3e$var$globalEvents.has(prop2.slice(0,-7))||(propNames===null||propNames===void 0?void 0:propNames.has(prop2))||$65484d02dcb7eb3e$var$propRe.test(prop2)))filteredProps[prop2]=props[prop2];return filteredProps;}function $7215afc6de606d6b$export$de79e2c695e052f3(element){if($7215afc6de606d6b$var$supportsPreventScroll())element.focus({preventScroll:true});else{var scrollableElements=$7215afc6de606d6b$var$getScrollableElements(element);element.focus();$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);}}var $7215afc6de606d6b$var$supportsPreventScrollCached=null;function $7215afc6de606d6b$var$supportsPreventScroll(){if($7215afc6de606d6b$var$supportsPreventScrollCached==null){$7215afc6de606d6b$var$supportsPreventScrollCached=false;try{var focusElem=document.createElement("div");focusElem.focus({get preventScroll(){$7215afc6de606d6b$var$supportsPreventScrollCached=true;return true;}});}catch(_unused){}}return $7215afc6de606d6b$var$supportsPreventScrollCached;}function $7215afc6de606d6b$var$getScrollableElements(element){var parent=element.parentNode;var scrollableElements=[];var rootScrollingElement=document.scrollingElement||document.documentElement;while(parent instanceof HTMLElement&&parent!==rootScrollingElement){if(parent.offsetHeight<parent.scrollHeight||parent.offsetWidth<parent.scrollWidth)scrollableElements.push({element:parent,scrollTop:parent.scrollTop,scrollLeft:parent.scrollLeft});parent=parent.parentNode;}if(rootScrollingElement instanceof HTMLElement)scrollableElements.push({element:rootScrollingElement,scrollTop:rootScrollingElement.scrollTop,scrollLeft:rootScrollingElement.scrollLeft});return scrollableElements;}function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements){var _iterator3=_createForOfIteratorHelper(scrollableElements),_step3;try{for(_iterator3.s();!(_step3=_iterator3.n()).done;){var _step3$value=_step3.value,element=_step3$value.element,scrollTop=_step3$value.scrollTop,scrollLeft=_step3$value.scrollLeft;element.scrollTop=scrollTop;element.scrollLeft=scrollLeft;}}catch(err){_iterator3.e(err);}finally{_iterator3.f();}}function $c87311424ea30a05$var$testUserAgent(re){var _window_navigator_userAgentData;if(typeof window==="undefined"||window.navigator==null)return false;var brands=(_window_navigator_userAgentData=window.navigator["userAgentData"])===null||_window_navigator_userAgentData===void 0?void 0:_window_navigator_userAgentData.brands;return Array.isArray(brands)&&brands.some(function(brand2){return re.test(brand2.brand);})||re.test(window.navigator.userAgent);}function $c87311424ea30a05$var$testPlatform(re){var _window_navigator_userAgentData;return typeof window!=="undefined"&&window.navigator!=null?re.test(((_window_navigator_userAgentData=window.navigator["userAgentData"])===null||_window_navigator_userAgentData===void 0?void 0:_window_navigator_userAgentData.platform)||window.navigator.platform):false;}function $c87311424ea30a05$var$cached(fn2){var res=null;return function(){if(res==null)res=fn2();return res;};}var $c87311424ea30a05$export$9ac100e40613ea10=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testPlatform(/^Mac/i);});var $c87311424ea30a05$export$186c6964ca17d99=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testPlatform(/^iPhone/i);});var $c87311424ea30a05$export$7bef049ce92e4224=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testPlatform(/^iPad/i)||$c87311424ea30a05$export$9ac100e40613ea10()&&navigator.maxTouchPoints>1;});var $c87311424ea30a05$export$fedb369cb70207f1=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$export$186c6964ca17d99()||$c87311424ea30a05$export$7bef049ce92e4224();});var $c87311424ea30a05$export$78551043582a6a98=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i)&&!$c87311424ea30a05$export$6446a186d09e379e();});var $c87311424ea30a05$export$6446a186d09e379e=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testUserAgent(/Chrome/i);});var $c87311424ea30a05$export$a11b0059900ceec8=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testUserAgent(/Android/i);});var $c87311424ea30a05$export$b7d78993b74f766d=$c87311424ea30a05$var$cached(function(){return $c87311424ea30a05$var$testUserAgent(/Firefox/i);});function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(target,modifiers){var setOpening=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var _window_event_type,_window_event;var metaKey=modifiers.metaKey,ctrlKey=modifiers.ctrlKey,altKey=modifiers.altKey,shiftKey=modifiers.shiftKey;if($c87311424ea30a05$export$b7d78993b74f766d()&&((_window_event=window.event)===null||_window_event===void 0?void 0:(_window_event_type=_window_event.type)===null||_window_event_type===void 0?void 0:_window_event_type.startsWith("key"))&&target.target==="_blank"){if($c87311424ea30a05$export$9ac100e40613ea10())metaKey=true;else ctrlKey=true;}var event=$c87311424ea30a05$export$78551043582a6a98()&&$c87311424ea30a05$export$9ac100e40613ea10()&&!$c87311424ea30a05$export$7bef049ce92e4224()&&true?new KeyboardEvent("keydown",{keyIdentifier:"Enter",metaKey:metaKey,ctrlKey:ctrlKey,altKey:altKey,shiftKey:shiftKey}):new MouseEvent("click",{metaKey:metaKey,ctrlKey:ctrlKey,altKey:altKey,shiftKey:shiftKey,bubbles:true,cancelable:true});$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening=setOpening;$7215afc6de606d6b$export$de79e2c695e052f3(target);target.dispatchEvent(event);$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening=false;}$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening=false;var $bbed8b41f857bcc0$var$transitionsByElement=/* @__PURE__ */new Map();var $bbed8b41f857bcc0$var$transitionCallbacks=/* @__PURE__ */new Set();function $bbed8b41f857bcc0$var$setupGlobalEvents(){if(typeof window==="undefined")return;function isTransitionEvent(event){return"propertyName"in event;}var onTransitionStart=function onTransitionStart(e2){if(!isTransitionEvent(e2)||!e2.target)return;var transitions=$bbed8b41f857bcc0$var$transitionsByElement.get(e2.target);if(!transitions){transitions=/* @__PURE__ */new Set();$bbed8b41f857bcc0$var$transitionsByElement.set(e2.target,transitions);e2.target.addEventListener("transitioncancel",_onTransitionEnd,{once:true});}transitions.add(e2.propertyName);};var _onTransitionEnd=function onTransitionEnd(e2){if(!isTransitionEvent(e2)||!e2.target)return;var properties2=$bbed8b41f857bcc0$var$transitionsByElement.get(e2.target);if(!properties2)return;properties2["delete"](e2.propertyName);if(properties2.size===0){e2.target.removeEventListener("transitioncancel",_onTransitionEnd);$bbed8b41f857bcc0$var$transitionsByElement["delete"](e2.target);}if($bbed8b41f857bcc0$var$transitionsByElement.size===0){var _iterator4=_createForOfIteratorHelper($bbed8b41f857bcc0$var$transitionCallbacks),_step4;try{for(_iterator4.s();!(_step4=_iterator4.n()).done;){var cb=_step4.value;cb();}}catch(err){_iterator4.e(err);}finally{_iterator4.f();}$bbed8b41f857bcc0$var$transitionCallbacks.clear();}};document.body.addEventListener("transitionrun",onTransitionStart);document.body.addEventListener("transitionend",_onTransitionEnd);}if(typeof document!=="undefined"){if(document.readyState!=="loading")$bbed8b41f857bcc0$var$setupGlobalEvents();else document.addEventListener("DOMContentLoaded",$bbed8b41f857bcc0$var$setupGlobalEvents);}function $bbed8b41f857bcc0$var$cleanupDetachedElements(){var _iterator5=_createForOfIteratorHelper($bbed8b41f857bcc0$var$transitionsByElement),_step5;try{for(_iterator5.s();!(_step5=_iterator5.n()).done;){var _step5$value=_slicedToArray(_step5.value,1),eventTarget=_step5$value[0];if("isConnected"in eventTarget&&!eventTarget.isConnected)$bbed8b41f857bcc0$var$transitionsByElement["delete"](eventTarget);}}catch(err){_iterator5.e(err);}finally{_iterator5.f();}}function $bbed8b41f857bcc0$export$24490316f764c430(fn2){requestAnimationFrame(function(){$bbed8b41f857bcc0$var$cleanupDetachedElements();if($bbed8b41f857bcc0$var$transitionsByElement.size===0)fn2();else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn2);});}function $03deb23ff14920c4$export$4eaf04e54aa8eed6(){var globalListeners=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(/* @__PURE__ */new Map());var addGlobalListener=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(eventTarget,type,listener,options){var fn2=(options===null||options===void 0?void 0:options.once)?function(){globalListeners.current["delete"](listener);listener.apply(void 0,arguments);}:listener;globalListeners.current.set(listener,{type:type,eventTarget:eventTarget,fn:fn2,options:options});eventTarget.addEventListener(type,fn2,options);},[]);var removeGlobalListener=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(eventTarget,type,listener,options){var _globalListeners_current_get;var fn2=((_globalListeners_current_get=globalListeners.current.get(listener))===null||_globalListeners_current_get===void 0?void 0:_globalListeners_current_get.fn)||listener;eventTarget.removeEventListener(type,fn2,options);globalListeners.current["delete"](listener);},[]);var removeAllGlobalListeners=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){globalListeners.current.forEach(function(value,key2){removeGlobalListener(value.eventTarget,value.type,key2,value.options);});},[removeGlobalListener]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return removeAllGlobalListeners;},[removeAllGlobalListeners]);return{addGlobalListener:addGlobalListener,removeGlobalListener:removeGlobalListener,removeAllGlobalListeners:removeAllGlobalListeners};}function $313b98861ee5dd6c$export$d6875122194c7b44(props,defaultLabel){var id=props.id,label=props["aria-label"],labelledBy=props["aria-labelledby"];id=$bdb11010cef70236$export$f680877a34711e37(id);if(labelledBy&&label){var ids=/* @__PURE__ */new Set([id].concat(_toConsumableArray(labelledBy.trim().split(/\s+/))));labelledBy=_toConsumableArray(ids).join(" ");}else if(labelledBy)labelledBy=labelledBy.trim().split(/\s+/).join(" ");if(!label&&!labelledBy&&defaultLabel)label=defaultLabel;return{id:id,"aria-label":label,"aria-labelledby":labelledBy};}function $4f58c5f72bcf79f7$export$496315a1608d9602(effect2,dependencies){var isInitialMount=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);var lastDeps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){isInitialMount.current=true;return function(){isInitialMount.current=false;};},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var prevDeps=lastDeps.current;if(isInitialMount.current)isInitialMount.current=false;else if(!prevDeps||dependencies.some(function(dep,i){return!Object.is(dep,prevDeps[i]);}))effect2();lastDeps.current=dependencies;},dependencies);}function $9daab02d461809db$var$hasResizeObserver(){return typeof window.ResizeObserver!=="undefined";}function $9daab02d461809db$export$683480f191c0e3ea(options){var ref=options.ref,box=options.box,onResize=options.onResize;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var element=ref===null||ref===void 0?void 0:ref.current;if(!element)return;if(!$9daab02d461809db$var$hasResizeObserver()){window.addEventListener("resize",onResize,false);return function(){window.removeEventListener("resize",onResize,false);};}else{var resizeObserverInstance=new window.ResizeObserver(function(entries){if(!entries.length)return;onResize();});resizeObserverInstance.observe(element,{box:box});return function(){if(element)resizeObserverInstance.unobserve(element);};}},[onResize,ref,box]);}function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context,ref){$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){if(context&&context.ref&&ref){context.ref.current=ref.current;return function(){if(context.ref)context.ref.current=null;};}});}function $cc38e7bd3fc7b213$export$2bb74740c4e19def(node,checkForOverflow){if(!node)return false;var style2=window.getComputedStyle(node);var isScrollable=/(auto|scroll)/.test(style2.overflow+style2.overflowX+style2.overflowY);if(isScrollable&&checkForOverflow)isScrollable=node.scrollHeight!==node.clientHeight||node.scrollWidth!==node.clientWidth;return isScrollable;}function $62d8ded9296f3872$export$cfa2225e87938781(node,checkForOverflow){var scrollableNode=node;if($cc38e7bd3fc7b213$export$2bb74740c4e19def(scrollableNode,checkForOverflow))scrollableNode=scrollableNode.parentElement;while(scrollableNode&&!$cc38e7bd3fc7b213$export$2bb74740c4e19def(scrollableNode,checkForOverflow))scrollableNode=scrollableNode.parentElement;return scrollableNode||document.scrollingElement||document.documentElement;}function $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(node,checkForOverflow){var scrollParents=[];while(node&&node!==document.documentElement){if($cc38e7bd3fc7b213$export$2bb74740c4e19def(node,checkForOverflow))scrollParents.push(node);node=node.parentElement;}return scrollParents;}var $21f1aa98acb08317$var$nonTextInputTypes=/* @__PURE__ */new Set(["checkbox","radio","range","color","file","image","button","submit","reset"]);function $21f1aa98acb08317$export$c57958e35f31ed73(target){return target instanceof HTMLInputElement&&!$21f1aa98acb08317$var$nonTextInputTypes.has(target.type)||target instanceof HTMLTextAreaElement||target instanceof HTMLElement&&target.isContentEditable;}var $ef06256079686ba0$var$descriptionId=0;var $ef06256079686ba0$var$descriptionNodes=/* @__PURE__ */new Map();function $ef06256079686ba0$export$f8aeda7b10753fa1(description){var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),_useState34=_slicedToArray(_useState33,2),id=_useState34[0],setId=_useState34[1];$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){if(!description)return;var desc=$ef06256079686ba0$var$descriptionNodes.get(description);if(!desc){var id2="react-aria-description-".concat($ef06256079686ba0$var$descriptionId++);setId(id2);var node=document.createElement("div");node.id=id2;node.style.display="none";node.textContent=description;document.body.appendChild(node);desc={refCount:0,element:node};$ef06256079686ba0$var$descriptionNodes.set(description,desc);}else setId(desc.element.id);desc.refCount++;return function(){if(desc&&--desc.refCount===0){desc.element.remove();$ef06256079686ba0$var$descriptionNodes["delete"](description);}};},[description]);return{"aria-describedby":description?id:void 0};}function $e9faafb641e167db$export$90fc3a17d93f704c(ref,event,handler,options){var handleEvent=$8ae05eaa5c114e9c$export$7f54fc3180508a52(handler);var isDisabled=handler==null;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isDisabled||!ref.current)return;var element=ref.current;element.addEventListener(event,handleEvent,options);return function(){element.removeEventListener(event,handleEvent,options);};},[ref,event,options,isDisabled,handleEvent]);}function $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollView,element){var offsetX=$2f04cbc44ee30ce0$var$relativeOffset(scrollView,element,"left");var offsetY=$2f04cbc44ee30ce0$var$relativeOffset(scrollView,element,"top");var width=element.offsetWidth;var height=element.offsetHeight;var x=scrollView.scrollLeft;var y2=scrollView.scrollTop;var _getComputedStyle2=getComputedStyle(scrollView),borderTopWidth=_getComputedStyle2.borderTopWidth,borderLeftWidth=_getComputedStyle2.borderLeftWidth,scrollPaddingTop=_getComputedStyle2.scrollPaddingTop,scrollPaddingRight=_getComputedStyle2.scrollPaddingRight,scrollPaddingBottom=_getComputedStyle2.scrollPaddingBottom,scrollPaddingLeft=_getComputedStyle2.scrollPaddingLeft;var _getComputedStyle3=getComputedStyle(element),scrollMarginTop=_getComputedStyle3.scrollMarginTop,scrollMarginRight=_getComputedStyle3.scrollMarginRight,scrollMarginBottom=_getComputedStyle3.scrollMarginBottom,scrollMarginLeft=_getComputedStyle3.scrollMarginLeft;var borderAdjustedX=x+parseInt(borderLeftWidth,10);var borderAdjustedY=y2+parseInt(borderTopWidth,10);var maxX=borderAdjustedX+scrollView.clientWidth;var maxY=borderAdjustedY+scrollView.clientHeight;var scrollPaddingTopNumber=parseInt(scrollPaddingTop,10)||0;var scrollPaddingBottomNumber=parseInt(scrollPaddingBottom,10)||0;var scrollPaddingRightNumber=parseInt(scrollPaddingRight,10)||0;var scrollPaddingLeftNumber=parseInt(scrollPaddingLeft,10)||0;var scrollMarginTopNumber=parseInt(scrollMarginTop,10)||0;var scrollMarginBottomNumber=parseInt(scrollMarginBottom,10)||0;var scrollMarginRightNumber=parseInt(scrollMarginRight,10)||0;var scrollMarginLeftNumber=parseInt(scrollMarginLeft,10)||0;var targetLeft=offsetX-scrollMarginLeftNumber;var targetRight=offsetX+width+scrollMarginRightNumber;var targetTop=offsetY-scrollMarginTopNumber;var targetBottom=offsetY+height+scrollMarginBottomNumber;var scrollPortLeft=x+parseInt(borderLeftWidth,10)+scrollPaddingLeftNumber;var scrollPortRight=maxX-scrollPaddingRightNumber;var scrollPortTop=y2+parseInt(borderTopWidth,10)+scrollPaddingTopNumber;var scrollPortBottom=maxY-scrollPaddingBottomNumber;if(targetLeft>scrollPortLeft||targetRight<scrollPortRight){if(targetLeft<=x+scrollPaddingLeftNumber)x=targetLeft-parseInt(borderLeftWidth,10)-scrollPaddingLeftNumber;else if(targetRight>maxX-scrollPaddingRightNumber)x+=targetRight-maxX+scrollPaddingRightNumber;}if(targetTop>scrollPortTop||targetBottom<scrollPortBottom){if(targetTop<=borderAdjustedY+scrollPaddingTopNumber)y2=targetTop-parseInt(borderTopWidth,10)-scrollPaddingTopNumber;else if(targetBottom>maxY-scrollPaddingBottomNumber)y2+=targetBottom-maxY+scrollPaddingBottomNumber;}scrollView.scrollTo({left:x,top:y2});}function $2f04cbc44ee30ce0$var$relativeOffset(ancestor,child,axis){var prop2=axis==="left"?"offsetLeft":"offsetTop";var sum=0;while(child.offsetParent){sum+=child[prop2];if(child.offsetParent===ancestor)break;else if(child.offsetParent.contains(ancestor)){sum-=ancestor[prop2];break;}child=child.offsetParent;}return sum;}function $2f04cbc44ee30ce0$export$c826860796309d1b(targetElement,opts){if(targetElement&&document.contains(targetElement)){var root2=document.scrollingElement||document.documentElement;var isScrollPrevented=window.getComputedStyle(root2).overflow==="hidden";if(!isScrollPrevented&&!$c87311424ea30a05$export$6446a186d09e379e()){var _targetElement_scrollIntoView;var _targetElement$getBou=targetElement.getBoundingClientRect(),originalLeft=_targetElement$getBou.left,originalTop=_targetElement$getBou.top;targetElement===null||targetElement===void 0?void 0:(_targetElement_scrollIntoView=targetElement.scrollIntoView)===null||_targetElement_scrollIntoView===void 0?void 0:_targetElement_scrollIntoView.call(targetElement,{block:"nearest"});var _targetElement$getBou2=targetElement.getBoundingClientRect(),newLeft=_targetElement$getBou2.left,newTop=_targetElement$getBou2.top;if(Math.abs(originalLeft-newLeft)>1||Math.abs(originalTop-newTop)>1){var _opts_containingElement_scrollIntoView,_opts_containingElement,_targetElement_scrollIntoView1;opts===null||opts===void 0?void 0:(_opts_containingElement=opts.containingElement)===null||_opts_containingElement===void 0?void 0:(_opts_containingElement_scrollIntoView=_opts_containingElement.scrollIntoView)===null||_opts_containingElement_scrollIntoView===void 0?void 0:_opts_containingElement_scrollIntoView.call(_opts_containingElement,{block:"center",inline:"center"});(_targetElement_scrollIntoView1=targetElement.scrollIntoView)===null||_targetElement_scrollIntoView1===void 0?void 0:_targetElement_scrollIntoView1.call(targetElement,{block:"nearest"});}}else{var scrollParents=$a40c673dc9f6d9c7$export$94ed1c92c7beeb22(targetElement);var _iterator6=_createForOfIteratorHelper(scrollParents),_step6;try{for(_iterator6.s();!(_step6=_iterator6.n()).done;){var scrollParent=_step6.value;$2f04cbc44ee30ce0$export$53a0910f038337bd(scrollParent,targetElement);}}catch(err){_iterator6.e(err);}finally{_iterator6.f();}}}}function $6a7db85432448f7f$export$60278871457622de(event){if(event.pointerType===""&&event.isTrusted)return true;if($c87311424ea30a05$export$a11b0059900ceec8()&&event.pointerType)return event.type==="click"&&event.buttons===1;return event.detail===0&&!event.pointerType;}function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event){return!$c87311424ea30a05$export$a11b0059900ceec8()&&event.width===0&&event.height===0||event.width===1&&event.height===1&&event.pressure===0&&event.detail===0&&event.pointerType==="mouse";}function $5a387cc49350e6db$export$722debc0e56fea39(value,isEqual2){var lastValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);if(value&&lastValue.current&&isEqual2(value,lastValue.current))value=lastValue.current;lastValue.current=value;return value;}function $99facab73266f662$export$5add1d006293d136(ref,initialValue,onReset){var handleReset=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(){if(onReset)onReset(initialValue);});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var _ref_current;var form=ref===null||ref===void 0?void 0:(_ref_current=ref.current)===null||_ref_current===void 0?void 0:_ref_current.form;form===null||form===void 0?void 0:form.addEventListener("reset",handleReset);return function(){form===null||form===void 0?void 0:form.removeEventListener("reset",handleReset);};},[ref,handleReset]);}var $7d2416ea0959daaa$var$supportsCheckVisibility=typeof Element!=="undefined"&&"checkVisibility"in Element.prototype;function $7d2416ea0959daaa$var$isStyleVisible(element){var windowObject=$431fbd86ca7dc216$export$f21a1ffae260145a(element);if(!(element instanceof windowObject.HTMLElement)&&!(element instanceof windowObject.SVGElement))return false;var _element$style=element.style,display=_element$style.display,visibility2=_element$style.visibility;var isVisible=display!=="none"&&visibility2!=="hidden"&&visibility2!=="collapse";if(isVisible){var getComputedStyle2=element.ownerDocument.defaultView.getComputedStyle;var _getComputedStyle4=getComputedStyle2(element),computedDisplay=_getComputedStyle4.display,computedVisibility=_getComputedStyle4.visibility;isVisible=computedDisplay!=="none"&&computedVisibility!=="hidden"&&computedVisibility!=="collapse";}return isVisible;}function $7d2416ea0959daaa$var$isAttributeVisible(element,childElement){return!element.hasAttribute("hidden")&&!element.hasAttribute("data-react-aria-prevent-focus")&&(element.nodeName==="DETAILS"&&childElement&&childElement.nodeName!=="SUMMARY"?element.hasAttribute("open"):true);}function $7d2416ea0959daaa$export$e989c0fffaa6b27a(element,childElement){if($7d2416ea0959daaa$var$supportsCheckVisibility)return element.checkVisibility({visibilityProperty:true})&&!element.closest("[data-react-aria-prevent-focus]");return element.nodeName!=="#comment"&&$7d2416ea0959daaa$var$isStyleVisible(element)&&$7d2416ea0959daaa$var$isAttributeVisible(element,childElement)&&(!element.parentElement||$7d2416ea0959daaa$export$e989c0fffaa6b27a(element.parentElement,element));}var $b4b717babfbb907b$var$focusableElements=["input:not([disabled]):not([type=hidden])","select:not([disabled])","textarea:not([disabled])","button:not([disabled])","a[href]","area[href]","summary","iframe","object","embed","audio[controls]","video[controls]",'[contenteditable]:not([contenteditable^="false"])',"permission"];var $b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR=$b4b717babfbb907b$var$focusableElements.join(":not([hidden]),")+",[tabindex]:not([disabled]):not([hidden])";$b4b717babfbb907b$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');var $b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR=$b4b717babfbb907b$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');function $b4b717babfbb907b$export$4c063cf1350e6fed(element){return element.matches($b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR)&&$7d2416ea0959daaa$export$e989c0fffaa6b27a(element)&&!$b4b717babfbb907b$var$isInert(element);}function $b4b717babfbb907b$export$bebd5a1431fec25d(element){return element.matches($b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR)&&$7d2416ea0959daaa$export$e989c0fffaa6b27a(element)&&!$b4b717babfbb907b$var$isInert(element);}function $b4b717babfbb907b$var$isInert(element){var node=element;while(node!=null){if(node instanceof node.ownerDocument.defaultView.HTMLElement&&node.inert)return true;node=node.parentElement;}return false;}function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value,defaultValue,onChange){var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(value||defaultValue),_useState36=_slicedToArray(_useState35,2),stateValue=_useState36[0],setStateValue=_useState36[1];var isControlledRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(value!==void 0);var isControlled=value!==void 0;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var wasControlled=isControlledRef.current;if(wasControlled!==isControlled&&false)console.warn("WARN: A component changed from ".concat(wasControlled?"controlled":"uncontrolled"," to ").concat(isControlled?"controlled":"uncontrolled","."));isControlledRef.current=isControlled;},[isControlled]);var currentValue=isControlled?value:stateValue;var setValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(value2){for(var _len11=arguments.length,args=new Array(_len11>1?_len11-1:0),_key11=1;_key11<_len11;_key11++){args[_key11-1]=arguments[_key11];}var onChangeCaller=function onChangeCaller(value3){if(onChange){for(var _len12=arguments.length,onChangeArgs=new Array(_len12>1?_len12-1:0),_key12=1;_key12<_len12;_key12++){onChangeArgs[_key12-1]=arguments[_key12];}if(!Object.is(currentValue,value3))onChange.apply(void 0,[value3].concat(onChangeArgs));}if(!isControlled)currentValue=value3;};if(typeof value2==="function"){var updateFunction=function updateFunction(oldValue){for(var _len13=arguments.length,functionArgs=new Array(_len13>1?_len13-1:0),_key13=1;_key13<_len13;_key13++){functionArgs[_key13-1]=arguments[_key13];}var interceptedValue=value2.apply(void 0,[isControlled?currentValue:oldValue].concat(functionArgs));onChangeCaller.apply(void 0,[interceptedValue].concat(args));if(!isControlled)return interceptedValue;return oldValue;};setStateValue(updateFunction);}else{if(!isControlled)setStateValue(value2);onChangeCaller.apply(void 0,[value2].concat(args));}},[isControlled,currentValue,onChange]);return[currentValue,setValue];}function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value){var min=arguments.length>1&&arguments[1]!==undefined?arguments[1]:-Infinity;var max=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Infinity;var newValue=Math.min(Math.max(value,min),max);return newValue;}function $8a9cb279dc87e130$export$525bc4921d56d4a(nativeEvent){var event=nativeEvent;event.nativeEvent=nativeEvent;event.isDefaultPrevented=function(){return event.defaultPrevented;};event.isPropagationStopped=function(){return event.cancelBubble;};event.persist=function(){};return event;}function $8a9cb279dc87e130$export$c2b7abe5d61ec696(event,target){Object.defineProperty(event,"target",{value:target});Object.defineProperty(event,"currentTarget",{value:target});}function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur){var stateRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({isFocused:false,observer:null});$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var state=stateRef.current;return function(){if(state.observer){state.observer.disconnect();state.observer=null;}};},[]);var dispatchBlur=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){onBlur===null||onBlur===void 0?void 0:onBlur(e2);});return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e2){if(e2.target instanceof HTMLButtonElement||e2.target instanceof HTMLInputElement||e2.target instanceof HTMLTextAreaElement||e2.target instanceof HTMLSelectElement){stateRef.current.isFocused=true;var target=e2.target;var onBlurHandler=function onBlurHandler(e3){stateRef.current.isFocused=false;if(target.disabled){var event=$8a9cb279dc87e130$export$525bc4921d56d4a(e3);dispatchBlur(event);}if(stateRef.current.observer){stateRef.current.observer.disconnect();stateRef.current.observer=null;}};target.addEventListener("focusout",onBlurHandler,{once:true});stateRef.current.observer=new MutationObserver(function(){if(stateRef.current.isFocused&&target.disabled){var _stateRef_current_observer;(_stateRef_current_observer=stateRef.current.observer)===null||_stateRef_current_observer===void 0?void 0:_stateRef_current_observer.disconnect();var relatedTargetEl=target===document.activeElement?null:document.activeElement;target.dispatchEvent(new FocusEvent("blur",{relatedTarget:relatedTargetEl}));target.dispatchEvent(new FocusEvent("focusout",{bubbles:true,relatedTarget:relatedTargetEl}));}});stateRef.current.observer.observe(target,{attributes:true,attributeFilter:["disabled"]});}},[dispatchBlur]);}var $8a9cb279dc87e130$export$fda7da73ab5d4c48=false;function $8a9cb279dc87e130$export$cabe61c495ee3649(target){while(target&&!$b4b717babfbb907b$export$4c063cf1350e6fed(target))target=target.parentElement;var window2=$431fbd86ca7dc216$export$f21a1ffae260145a(target);var activeElement=window2.document.activeElement;if(!activeElement||activeElement===target)return;$8a9cb279dc87e130$export$fda7da73ab5d4c48=true;var isRefocusing=false;var onBlur=function onBlur(e2){if(e2.target===activeElement||isRefocusing)e2.stopImmediatePropagation();};var onFocusOut=function onFocusOut(e2){if(e2.target===activeElement||isRefocusing){e2.stopImmediatePropagation();if(!target&&!isRefocusing){isRefocusing=true;$7215afc6de606d6b$export$de79e2c695e052f3(activeElement);cleanup();}}};var onFocus=function onFocus(e2){if(e2.target===target||isRefocusing)e2.stopImmediatePropagation();};var onFocusIn=function onFocusIn(e2){if(e2.target===target||isRefocusing){e2.stopImmediatePropagation();if(!isRefocusing){isRefocusing=true;$7215afc6de606d6b$export$de79e2c695e052f3(activeElement);cleanup();}}};window2.addEventListener("blur",onBlur,true);window2.addEventListener("focusout",onFocusOut,true);window2.addEventListener("focusin",onFocusIn,true);window2.addEventListener("focus",onFocus,true);var cleanup=function cleanup(){cancelAnimationFrame(raf2);window2.removeEventListener("blur",onBlur,true);window2.removeEventListener("focusout",onFocusOut,true);window2.removeEventListener("focusin",onFocusIn,true);window2.removeEventListener("focus",onFocus,true);$8a9cb279dc87e130$export$fda7da73ab5d4c48=false;isRefocusing=false;};var raf2=requestAnimationFrame(cleanup);return cleanup;}var $14c0b72509d70225$var$state="default";var $14c0b72509d70225$var$savedUserSelect="";var $14c0b72509d70225$var$modifiedElementMap=/* @__PURE__ */new WeakMap();function $14c0b72509d70225$export$16a4697467175487(target){if($c87311424ea30a05$export$fedb369cb70207f1()){if($14c0b72509d70225$var$state==="default"){var documentObject=$431fbd86ca7dc216$export$b204af158042fbac(target);$14c0b72509d70225$var$savedUserSelect=documentObject.documentElement.style.webkitUserSelect;documentObject.documentElement.style.webkitUserSelect="none";}$14c0b72509d70225$var$state="disabled";}else if(target instanceof HTMLElement||target instanceof SVGElement){var property="userSelect"in target.style?"userSelect":"webkitUserSelect";$14c0b72509d70225$var$modifiedElementMap.set(target,target.style[property]);target.style[property]="none";}}function $14c0b72509d70225$export$b0d6fa1ab32e3295(target){if($c87311424ea30a05$export$fedb369cb70207f1()){if($14c0b72509d70225$var$state!=="disabled")return;$14c0b72509d70225$var$state="restoring";setTimeout(function(){$bbed8b41f857bcc0$export$24490316f764c430(function(){if($14c0b72509d70225$var$state==="restoring"){var documentObject=$431fbd86ca7dc216$export$b204af158042fbac(target);if(documentObject.documentElement.style.webkitUserSelect==="none")documentObject.documentElement.style.webkitUserSelect=$14c0b72509d70225$var$savedUserSelect||"";$14c0b72509d70225$var$savedUserSelect="";$14c0b72509d70225$var$state="default";}});},300);}else if(target instanceof HTMLElement||target instanceof SVGElement){if(target&&$14c0b72509d70225$var$modifiedElementMap.has(target)){var targetOldUserSelect=$14c0b72509d70225$var$modifiedElementMap.get(target);var property="userSelect"in target.style?"userSelect":"webkitUserSelect";if(target.style[property]==="none")target.style[property]=targetOldUserSelect;if(target.getAttribute("style")==="")target.removeAttribute("style");$14c0b72509d70225$var$modifiedElementMap["delete"](target);}}}var $ae1eeba8b9eafd08$export$5165eccb35aaadb5=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({register:function register(){}});$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName="PressResponderContext";function _class_apply_descriptor_get(receiver,descriptor){if(descriptor.get)return descriptor.get.call(receiver);return descriptor.value;}function _class_extract_field_descriptor(receiver,privateMap,action){if(!privateMap.has(receiver))throw new TypeError("attempted to "+action+" private field on non-instance");return privateMap.get(receiver);}function _class_private_field_get(receiver,privateMap){var descriptor=_class_extract_field_descriptor(receiver,privateMap,"get");return _class_apply_descriptor_get(receiver,descriptor);}function _check_private_redeclaration(obj,privateCollection){if(privateCollection.has(obj)){throw new TypeError("Cannot initialize the same private elements twice on an object");}}function _class_private_field_init(obj,privateMap,value){_check_private_redeclaration(obj,privateMap);privateMap.set(obj,value);}function _class_apply_descriptor_set(receiver,descriptor,value){if(descriptor.set)descriptor.set.call(receiver,value);else{if(!descriptor.writable){throw new TypeError("attempted to set read only private field");}descriptor.value=value;}}function _class_private_field_set(receiver,privateMap,value){var descriptor=_class_extract_field_descriptor(receiver,privateMap,"set");_class_apply_descriptor_set(receiver,descriptor,value);return value;}function $f6c31cce2adf654f$var$usePressResponderContext(props){var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($ae1eeba8b9eafd08$export$5165eccb35aaadb5);if(context){var _a2=context,register=_a2.register,contextProps=__objRest(_a2,["register"]);props=$3ef42575df84b30b$export$9d1611c77c2fe928(contextProps,props);register();}$e7801be82b4b2a53$export$4debdb1a3f0fa79e(context,props.ref);return props;}var $f6c31cce2adf654f$var$_shouldStopPropagation=/* @__PURE__ */new WeakMap();var $f6c31cce2adf654f$var$PressEvent=/*#__PURE__*/function(){function $f6c31cce2adf654f$var$PressEvent(type,pointerType,originalEvent,state){_classCallCheck3(this,$f6c31cce2adf654f$var$PressEvent);_class_private_field_init(this,$f6c31cce2adf654f$var$_shouldStopPropagation,{writable:true,value:void 0});_class_private_field_set(this,$f6c31cce2adf654f$var$_shouldStopPropagation,true);var _state_target;var currentTarget=(_state_target=state===null||state===void 0?void 0:state.target)!==null&&_state_target!==void 0?_state_target:originalEvent.currentTarget;var rect=currentTarget===null||currentTarget===void 0?void 0:currentTarget.getBoundingClientRect();var x,y2=0;var clientX,clientY=null;if(originalEvent.clientX!=null&&originalEvent.clientY!=null){clientX=originalEvent.clientX;clientY=originalEvent.clientY;}if(rect){if(clientX!=null&&clientY!=null){x=clientX-rect.left;y2=clientY-rect.top;}else{x=rect.width/2;y2=rect.height/2;}}this.type=type;this.pointerType=pointerType;this.target=originalEvent.currentTarget;this.shiftKey=originalEvent.shiftKey;this.metaKey=originalEvent.metaKey;this.ctrlKey=originalEvent.ctrlKey;this.altKey=originalEvent.altKey;this.x=x;this.y=y2;}return _createClass3($f6c31cce2adf654f$var$PressEvent,[{key:"continuePropagation",value:function continuePropagation(){_class_private_field_set(this,$f6c31cce2adf654f$var$_shouldStopPropagation,false);}},{key:"shouldStopPropagation",get:function get(){return _class_private_field_get(this,$f6c31cce2adf654f$var$_shouldStopPropagation);}}]);}();var $f6c31cce2adf654f$var$LINK_CLICKED=Symbol("linkClicked");var $f6c31cce2adf654f$var$STYLE_ID="react-aria-pressable-style";var $f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE="data-react-aria-pressable";function $f6c31cce2adf654f$export$45712eceda6fad21(props){var _a2=$f6c31cce2adf654f$var$usePressResponderContext(props),onPress=_a2.onPress,onPressChange=_a2.onPressChange,onPressStart=_a2.onPressStart,onPressEnd=_a2.onPressEnd,onPressUp=_a2.onPressUp,onClick=_a2.onClick,isDisabled=_a2.isDisabled,isPressedProp=_a2.isPressed,preventFocusOnPress=_a2.preventFocusOnPress,shouldCancelOnPointerExit=_a2.shouldCancelOnPointerExit,allowTextSelectionOnPress=_a2.allowTextSelectionOnPress,domRef=_a2.ref,domProps=__objRest(_a2,["onPress","onPressChange","onPressStart","onPressEnd","onPressUp","onClick","isDisabled","isPressed","preventFocusOnPress","shouldCancelOnPointerExit","allowTextSelectionOnPress","ref"]);var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),isPressed=_useState38[0],setPressed=_useState38[1];var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({isPressed:false,ignoreEmulatedMouseEvents:false,didFirePressStart:false,isTriggeringEvent:false,activePointerId:null,target:null,isOverTarget:false,pointerType:null,disposables:[]});var _$03deb23ff14920c4$ex=$03deb23ff14920c4$export$4eaf04e54aa8eed6(),addGlobalListener=_$03deb23ff14920c4$ex.addGlobalListener,removeAllGlobalListeners=_$03deb23ff14920c4$ex.removeAllGlobalListeners;var triggerPressStart=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(originalEvent,pointerType){var state=ref.current;if(isDisabled||state.didFirePressStart)return false;var shouldStopPropagation=true;state.isTriggeringEvent=true;if(onPressStart){var event=new $f6c31cce2adf654f$var$PressEvent("pressstart",pointerType,originalEvent);onPressStart(event);shouldStopPropagation=event.shouldStopPropagation;}if(onPressChange)onPressChange(true);state.isTriggeringEvent=false;state.didFirePressStart=true;setPressed(true);return shouldStopPropagation;});var triggerPressEnd=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(originalEvent,pointerType){var wasPressed=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var state=ref.current;if(!state.didFirePressStart)return false;state.didFirePressStart=false;state.isTriggeringEvent=true;var shouldStopPropagation=true;if(onPressEnd){var event=new $f6c31cce2adf654f$var$PressEvent("pressend",pointerType,originalEvent);onPressEnd(event);shouldStopPropagation=event.shouldStopPropagation;}if(onPressChange)onPressChange(false);setPressed(false);if(onPress&&wasPressed&&!isDisabled){var _event=new $f6c31cce2adf654f$var$PressEvent("press",pointerType,originalEvent);onPress(_event);shouldStopPropagation&&(shouldStopPropagation=_event.shouldStopPropagation);}state.isTriggeringEvent=false;return shouldStopPropagation;});var triggerPressUp=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(originalEvent,pointerType){var state=ref.current;if(isDisabled)return false;if(onPressUp){state.isTriggeringEvent=true;var event=new $f6c31cce2adf654f$var$PressEvent("pressup",pointerType,originalEvent);onPressUp(event);state.isTriggeringEvent=false;return event.shouldStopPropagation;}return true;});var cancel=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){var state=ref.current;if(state.isPressed&&state.target){if(state.didFirePressStart&&state.pointerType!=null)triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target,e2),state.pointerType,false);state.isPressed=false;state.isOverTarget=false;state.activePointerId=null;state.pointerType=null;removeAllGlobalListeners();if(!allowTextSelectionOnPress)$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);var _iterator7=_createForOfIteratorHelper(state.disposables),_step7;try{for(_iterator7.s();!(_step7=_iterator7.n()).done;){var dispose=_step7.value;dispose();}}catch(err){_iterator7.e(err);}finally{_iterator7.f();}state.disposables=[];}});var cancelOnPointerExit=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){if(shouldCancelOnPointerExit)cancel(e2);});var triggerClick=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){if(isDisabled)return;onClick===null||onClick===void 0?void 0:onClick(e2);});var triggerSyntheticClick=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2,target){if(isDisabled)return;if(onClick){var event=new MouseEvent("click",e2);$8a9cb279dc87e130$export$c2b7abe5d61ec696(event,target);onClick($8a9cb279dc87e130$export$525bc4921d56d4a(event));}});var pressProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var state=ref.current;var pressProps2={onKeyDown:function onKeyDown(e2){if($f6c31cce2adf654f$var$isValidKeyboardEvent(e2.nativeEvent,e2.currentTarget)&&$d4ee10de306f2510$export$4282f70798064fe0(e2.currentTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent))){var _state_metaKeyEvents;if($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard($d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent),e2.key))e2.preventDefault();var shouldStopPropagation=true;if(!state.isPressed&&!e2.repeat){state.target=e2.currentTarget;state.isPressed=true;state.pointerType="keyboard";shouldStopPropagation=triggerPressStart(e2,"keyboard");var originalTarget=e2.currentTarget;var pressUp=function pressUp(e3){if($f6c31cce2adf654f$var$isValidKeyboardEvent(e3,originalTarget)&&!e3.repeat&&$d4ee10de306f2510$export$4282f70798064fe0(originalTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e3))&&state.target)triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target,e3),"keyboard");};addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e2.currentTarget),"keyup",$ff5963eb1fccf552$export$e08e3b67e392101e(pressUp,onKeyUp),true);}if(shouldStopPropagation)e2.stopPropagation();if(e2.metaKey&&$c87311424ea30a05$export$9ac100e40613ea10())(_state_metaKeyEvents=state.metaKeyEvents)===null||_state_metaKeyEvents===void 0?void 0:_state_metaKeyEvents.set(e2.key,e2.nativeEvent);}else if(e2.key==="Meta")state.metaKeyEvents=/* @__PURE__ */new Map();},onClick:function onClick(e2){if(e2&&!$d4ee10de306f2510$export$4282f70798064fe0(e2.currentTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)))return;if(e2&&e2.button===0&&!state.isTriggeringEvent&&!$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening){var shouldStopPropagation=true;if(isDisabled)e2.preventDefault();if(!state.ignoreEmulatedMouseEvents&&!state.isPressed&&(state.pointerType==="virtual"||$6a7db85432448f7f$export$60278871457622de(e2.nativeEvent))){var stopPressStart=triggerPressStart(e2,"virtual");var stopPressUp=triggerPressUp(e2,"virtual");var stopPressEnd=triggerPressEnd(e2,"virtual");triggerClick(e2);shouldStopPropagation=stopPressStart&&stopPressUp&&stopPressEnd;}else if(state.isPressed&&state.pointerType!=="keyboard"){var pointerType=state.pointerType||e2.nativeEvent.pointerType||"virtual";var _stopPressUp=triggerPressUp($f6c31cce2adf654f$var$createEvent(e2.currentTarget,e2),pointerType);var _stopPressEnd=triggerPressEnd($f6c31cce2adf654f$var$createEvent(e2.currentTarget,e2),pointerType,true);shouldStopPropagation=_stopPressUp&&_stopPressEnd;state.isOverTarget=false;triggerClick(e2);cancel(e2);}state.ignoreEmulatedMouseEvents=false;if(shouldStopPropagation)e2.stopPropagation();}}};var onKeyUp=function onKeyUp(e2){var _state_metaKeyEvents;if(state.isPressed&&state.target&&$f6c31cce2adf654f$var$isValidKeyboardEvent(e2,state.target)){var _state_metaKeyEvents1;if($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard($d4ee10de306f2510$export$e58f029f0fbfdb29(e2),e2.key))e2.preventDefault();var target=$d4ee10de306f2510$export$e58f029f0fbfdb29(e2);var wasPressed=$d4ee10de306f2510$export$4282f70798064fe0(state.target,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2));triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target,e2),"keyboard",wasPressed);if(wasPressed)triggerSyntheticClick(e2,state.target);removeAllGlobalListeners();if(e2.key!=="Enter"&&$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target)&&$d4ee10de306f2510$export$4282f70798064fe0(state.target,target)&&!e2[$f6c31cce2adf654f$var$LINK_CLICKED]){e2[$f6c31cce2adf654f$var$LINK_CLICKED]=true;$ea8dcbcb9ea1b556$export$95185d699e05d4d7(state.target,e2,false);}state.isPressed=false;(_state_metaKeyEvents1=state.metaKeyEvents)===null||_state_metaKeyEvents1===void 0?void 0:_state_metaKeyEvents1["delete"](e2.key);}else if(e2.key==="Meta"&&((_state_metaKeyEvents=state.metaKeyEvents)===null||_state_metaKeyEvents===void 0?void 0:_state_metaKeyEvents.size)){var _state_target;var events=state.metaKeyEvents;state.metaKeyEvents=void 0;var _iterator8=_createForOfIteratorHelper(events.values()),_step8;try{for(_iterator8.s();!(_step8=_iterator8.n()).done;){var event=_step8.value;(_state_target=state.target)===null||_state_target===void 0?void 0:_state_target.dispatchEvent(new KeyboardEvent("keyup",event));}}catch(err){_iterator8.e(err);}finally{_iterator8.f();}}};if(typeof PointerEvent!=="undefined"){pressProps2.onPointerDown=function(e2){if(e2.button!==0||!$d4ee10de306f2510$export$4282f70798064fe0(e2.currentTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)))return;if($6a7db85432448f7f$export$29bf1b5f2c56cf63(e2.nativeEvent)){state.pointerType="virtual";return;}state.pointerType=e2.pointerType;var shouldStopPropagation=true;if(!state.isPressed){state.isPressed=true;state.isOverTarget=true;state.activePointerId=e2.pointerId;state.target=e2.currentTarget;if(!allowTextSelectionOnPress)$14c0b72509d70225$export$16a4697467175487(state.target);shouldStopPropagation=triggerPressStart(e2,state.pointerType);var target=$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent);if("releasePointerCapture"in target)target.releasePointerCapture(e2.pointerId);addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e2.currentTarget),"pointerup",onPointerUp,false);addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e2.currentTarget),"pointercancel",onPointerCancel,false);}if(shouldStopPropagation)e2.stopPropagation();};pressProps2.onMouseDown=function(e2){if(!$d4ee10de306f2510$export$4282f70798064fe0(e2.currentTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)))return;if(e2.button===0){if(preventFocusOnPress){var dispose=$8a9cb279dc87e130$export$cabe61c495ee3649(e2.target);if(dispose)state.disposables.push(dispose);}e2.stopPropagation();}};pressProps2.onPointerUp=function(e2){if(!$d4ee10de306f2510$export$4282f70798064fe0(e2.currentTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent))||state.pointerType==="virtual")return;if(e2.button===0&&!state.isPressed)triggerPressUp(e2,state.pointerType||e2.pointerType);};pressProps2.onPointerEnter=function(e2){if(e2.pointerId===state.activePointerId&&state.target&&!state.isOverTarget&&state.pointerType!=null){state.isOverTarget=true;triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target,e2),state.pointerType);}};pressProps2.onPointerLeave=function(e2){if(e2.pointerId===state.activePointerId&&state.target&&state.isOverTarget&&state.pointerType!=null){state.isOverTarget=false;triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target,e2),state.pointerType,false);cancelOnPointerExit(e2);}};var onPointerUp=function onPointerUp(e2){if(e2.pointerId===state.activePointerId&&state.isPressed&&e2.button===0&&state.target){if($d4ee10de306f2510$export$4282f70798064fe0(state.target,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2))&&state.pointerType!=null){var clicked=false;var timeout=setTimeout(function(){if(state.isPressed&&state.target instanceof HTMLElement){if(clicked)cancel(e2);else{$7215afc6de606d6b$export$de79e2c695e052f3(state.target);state.target.click();}}},80);addGlobalListener(e2.currentTarget,"click",function(){return clicked=true;},true);state.disposables.push(function(){return clearTimeout(timeout);});}else cancel(e2);state.isOverTarget=false;}};var onPointerCancel=function onPointerCancel(e2){cancel(e2);};pressProps2.onDragStart=function(e2){if(!$d4ee10de306f2510$export$4282f70798064fe0(e2.currentTarget,$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)))return;cancel(e2);};}return pressProps2;},[addGlobalListener,isDisabled,preventFocusOnPress,removeAllGlobalListeners,allowTextSelectionOnPress,cancel,cancelOnPointerExit,triggerPressEnd,triggerPressStart,triggerPressUp,triggerClick,triggerSyntheticClick]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!domRef||false)return;var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(domRef.current);if(!ownerDocument||!ownerDocument.head||ownerDocument.getElementById($f6c31cce2adf654f$var$STYLE_ID))return;var style2=ownerDocument.createElement("style");style2.id=$f6c31cce2adf654f$var$STYLE_ID;style2.textContent="\n@layer {\n  [".concat($f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE,"] {\n    touch-action: pan-x pan-y pinch-zoom;\n  }\n}\n    ").trim();ownerDocument.head.prepend(style2);},[domRef]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var state=ref.current;return function(){var _state_target;if(!allowTextSelectionOnPress)$14c0b72509d70225$export$b0d6fa1ab32e3295((_state_target=state.target)!==null&&_state_target!==void 0?_state_target:void 0);var _iterator9=_createForOfIteratorHelper(state.disposables),_step9;try{for(_iterator9.s();!(_step9=_iterator9.n()).done;){var dispose=_step9.value;dispose();}}catch(err){_iterator9.e(err);}finally{_iterator9.f();}state.disposables=[];};},[allowTextSelectionOnPress]);return{isPressed:isPressedProp||isPressed,pressProps:$3ef42575df84b30b$export$9d1611c77c2fe928(domProps,pressProps,_defineProperty2({},$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE,true))};}function $f6c31cce2adf654f$var$isHTMLAnchorLink(target){return target.tagName==="A"&&target.hasAttribute("href");}function $f6c31cce2adf654f$var$isValidKeyboardEvent(event,currentTarget){var key2=event.key,code=event.code;var element=currentTarget;var role=element.getAttribute("role");return(key2==="Enter"||key2===" "||key2==="Spacebar"||code==="Space")&&!(element instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(element).HTMLInputElement&&!$f6c31cce2adf654f$var$isValidInputKey(element,key2)||element instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(element).HTMLTextAreaElement||element.isContentEditable)&&!((role==="link"||!role&&$f6c31cce2adf654f$var$isHTMLAnchorLink(element))&&key2!=="Enter");}function $f6c31cce2adf654f$var$createEvent(target,e2){var clientX=e2.clientX;var clientY=e2.clientY;return{currentTarget:target,shiftKey:e2.shiftKey,ctrlKey:e2.ctrlKey,metaKey:e2.metaKey,altKey:e2.altKey,clientX:clientX,clientY:clientY};}function $f6c31cce2adf654f$var$shouldPreventDefaultUp(target){if(target instanceof HTMLInputElement)return false;if(target instanceof HTMLButtonElement)return target.type!=="submit"&&target.type!=="reset";if($f6c31cce2adf654f$var$isHTMLAnchorLink(target))return false;return true;}function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target,key2){if(target instanceof HTMLInputElement)return!$f6c31cce2adf654f$var$isValidInputKey(target,key2);return $f6c31cce2adf654f$var$shouldPreventDefaultUp(target);}var $f6c31cce2adf654f$var$nonTextInputTypes=/* @__PURE__ */new Set(["checkbox","radio","range","color","file","image","button","submit","reset"]);function $f6c31cce2adf654f$var$isValidInputKey(target,key2){return target.type==="checkbox"||target.type==="radio"?key2===" ":$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);}var $507fabe10e71c6fb$var$currentModality=null;var $507fabe10e71c6fb$var$changeHandlers=/* @__PURE__ */new Set();var $507fabe10e71c6fb$export$d90243b58daecda7=/* @__PURE__ */new Map();var $507fabe10e71c6fb$var$hasEventBeforeFocus=false;var $507fabe10e71c6fb$var$hasBlurredWindowRecently=false;function $507fabe10e71c6fb$var$triggerChangeHandlers(modality,e2){var _iterator0=_createForOfIteratorHelper($507fabe10e71c6fb$var$changeHandlers),_step0;try{for(_iterator0.s();!(_step0=_iterator0.n()).done;){var handler=_step0.value;handler(modality,e2);}}catch(err){_iterator0.e(err);}finally{_iterator0.f();}}function $507fabe10e71c6fb$var$isValidKey(e2){return!(e2.metaKey||!$c87311424ea30a05$export$9ac100e40613ea10()&&e2.altKey||e2.ctrlKey||e2.key==="Control"||e2.key==="Shift"||e2.key==="Meta");}function $507fabe10e71c6fb$var$handleKeyboardEvent(e2){$507fabe10e71c6fb$var$hasEventBeforeFocus=true;if($507fabe10e71c6fb$var$isValidKey(e2)){$507fabe10e71c6fb$var$currentModality="keyboard";$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard",e2);}}function $507fabe10e71c6fb$var$handlePointerEvent(e2){$507fabe10e71c6fb$var$currentModality="pointer";if(e2.type==="mousedown"||e2.type==="pointerdown"){$507fabe10e71c6fb$var$hasEventBeforeFocus=true;$507fabe10e71c6fb$var$triggerChangeHandlers("pointer",e2);}}function $507fabe10e71c6fb$var$handleClickEvent(e2){if($6a7db85432448f7f$export$60278871457622de(e2)){$507fabe10e71c6fb$var$hasEventBeforeFocus=true;$507fabe10e71c6fb$var$currentModality="virtual";}}function $507fabe10e71c6fb$var$handleFocusEvent(e2){if(e2.target===window||e2.target===document||$8a9cb279dc87e130$export$fda7da73ab5d4c48||!e2.isTrusted)return;if(!$507fabe10e71c6fb$var$hasEventBeforeFocus&&!$507fabe10e71c6fb$var$hasBlurredWindowRecently){$507fabe10e71c6fb$var$currentModality="virtual";$507fabe10e71c6fb$var$triggerChangeHandlers("virtual",e2);}$507fabe10e71c6fb$var$hasEventBeforeFocus=false;$507fabe10e71c6fb$var$hasBlurredWindowRecently=false;}function $507fabe10e71c6fb$var$handleWindowBlur(){if($8a9cb279dc87e130$export$fda7da73ab5d4c48)return;$507fabe10e71c6fb$var$hasEventBeforeFocus=false;$507fabe10e71c6fb$var$hasBlurredWindowRecently=true;}function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element){if(typeof window==="undefined"||typeof document==="undefined"||$507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(element)))return;var windowObject=$431fbd86ca7dc216$export$f21a1ffae260145a(element);var documentObject=$431fbd86ca7dc216$export$b204af158042fbac(element);var focus=windowObject.HTMLElement.prototype.focus;windowObject.HTMLElement.prototype.focus=function(){$507fabe10e71c6fb$var$hasEventBeforeFocus=true;focus.apply(this,arguments);};documentObject.addEventListener("keydown",$507fabe10e71c6fb$var$handleKeyboardEvent,true);documentObject.addEventListener("keyup",$507fabe10e71c6fb$var$handleKeyboardEvent,true);documentObject.addEventListener("click",$507fabe10e71c6fb$var$handleClickEvent,true);windowObject.addEventListener("focus",$507fabe10e71c6fb$var$handleFocusEvent,true);windowObject.addEventListener("blur",$507fabe10e71c6fb$var$handleWindowBlur,false);if(typeof PointerEvent!=="undefined"){documentObject.addEventListener("pointerdown",$507fabe10e71c6fb$var$handlePointerEvent,true);documentObject.addEventListener("pointermove",$507fabe10e71c6fb$var$handlePointerEvent,true);documentObject.addEventListener("pointerup",$507fabe10e71c6fb$var$handlePointerEvent,true);}windowObject.addEventListener("beforeunload",function(){$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);},{once:true});$507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject,{focus:focus});}var $507fabe10e71c6fb$var$tearDownWindowFocusTracking=function $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element,loadListener){var windowObject=$431fbd86ca7dc216$export$f21a1ffae260145a(element);var documentObject=$431fbd86ca7dc216$export$b204af158042fbac(element);if(loadListener)documentObject.removeEventListener("DOMContentLoaded",loadListener);if(!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject))return;windowObject.HTMLElement.prototype.focus=$507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;documentObject.removeEventListener("keydown",$507fabe10e71c6fb$var$handleKeyboardEvent,true);documentObject.removeEventListener("keyup",$507fabe10e71c6fb$var$handleKeyboardEvent,true);documentObject.removeEventListener("click",$507fabe10e71c6fb$var$handleClickEvent,true);windowObject.removeEventListener("focus",$507fabe10e71c6fb$var$handleFocusEvent,true);windowObject.removeEventListener("blur",$507fabe10e71c6fb$var$handleWindowBlur,false);if(typeof PointerEvent!=="undefined"){documentObject.removeEventListener("pointerdown",$507fabe10e71c6fb$var$handlePointerEvent,true);documentObject.removeEventListener("pointermove",$507fabe10e71c6fb$var$handlePointerEvent,true);documentObject.removeEventListener("pointerup",$507fabe10e71c6fb$var$handlePointerEvent,true);}$507fabe10e71c6fb$export$d90243b58daecda7["delete"](windowObject);};function $507fabe10e71c6fb$export$2f1888112f558a7d(element){var documentObject=$431fbd86ca7dc216$export$b204af158042fbac(element);var loadListener;if(documentObject.readyState!=="loading")$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);else{loadListener=function loadListener(){$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);};documentObject.addEventListener("DOMContentLoaded",loadListener);}return function(){return $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element,loadListener);};}if(typeof document!=="undefined")$507fabe10e71c6fb$export$2f1888112f558a7d();function $507fabe10e71c6fb$export$630ff653c5ada6a9(){return $507fabe10e71c6fb$var$currentModality;}function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality){$507fabe10e71c6fb$var$currentModality=modality;$507fabe10e71c6fb$var$triggerChangeHandlers(modality,null);}function $3ad3f6e1647bc98d$export$80f3e147d781571c(element){var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(element);var activeElement=$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);if($507fabe10e71c6fb$export$630ff653c5ada6a9()==="virtual"){var lastFocusedElement=activeElement;$bbed8b41f857bcc0$export$24490316f764c430(function(){if($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument)===lastFocusedElement&&element.isConnected)$7215afc6de606d6b$export$de79e2c695e052f3(element);});}else $7215afc6de606d6b$export$de79e2c695e052f3(element);}function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props){var isDisabled=props.isDisabled,onFocusProp=props.onFocus,onBlurProp=props.onBlur,onFocusChange=props.onFocusChange;var onBlur=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e2){if(e2.target===e2.currentTarget){if(onBlurProp)onBlurProp(e2);if(onFocusChange)onFocusChange(false);return true;}},[onBlurProp,onFocusChange]);var onSyntheticFocus=$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);var onFocus=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e2){var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(e2.target);var activeElement=ownerDocument?$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument):$d4ee10de306f2510$export$cd4e5573fbe2b576();if(e2.target===e2.currentTarget&&activeElement===$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)){if(onFocusProp)onFocusProp(e2);if(onFocusChange)onFocusChange(true);onSyntheticFocus(e2);}},[onFocusChange,onFocusProp,onSyntheticFocus]);return{focusProps:{onFocus:!isDisabled&&(onFocusProp||onFocusChange||onBlurProp)?onFocus:void 0,onBlur:!isDisabled&&(onBlurProp||onFocusChange)?onBlur:void 0}};}function $93925083ecbb358c$export$48d1ea6320830260(handler){if(!handler)return void 0;var shouldStopPropagation=true;return function(e2){var event=__spreadProps(__spreadValues({},e2),{preventDefault:function preventDefault(){e2.preventDefault();},isDefaultPrevented:function isDefaultPrevented(){return e2.isDefaultPrevented();},stopPropagation:function stopPropagation(){if(shouldStopPropagation&&false)console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");else shouldStopPropagation=true;},continuePropagation:function continuePropagation(){shouldStopPropagation=false;},isPropagationStopped:function isPropagationStopped(){return shouldStopPropagation;}});handler(event);if(shouldStopPropagation)e2.stopPropagation();};}function $46d819fcbaf35654$export$8f71654801c2f7cd(props){return{keyboardProps:props.isDisabled?{}:{onKeyDown:$93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),onKeyUp:$93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)}};}var $f645667febf57a63$export$f9762fab77588ecb=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);function $f645667febf57a63$var$useFocusableContext(ref){var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($f645667febf57a63$export$f9762fab77588ecb)||{};$e7801be82b4b2a53$export$4debdb1a3f0fa79e(context,ref);var _a2=context,_=_a2.ref,otherProps=__objRest(_a2,["ref"]);return otherProps;}function $f645667febf57a63$export$4c014de7c8940b4c(props,domRef){var _$a1ea59d68270f0dd$ex=$a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props),focusProps=_$a1ea59d68270f0dd$ex.focusProps;var _$46d819fcbaf35654$ex=$46d819fcbaf35654$export$8f71654801c2f7cd(props),keyboardProps=_$46d819fcbaf35654$ex.keyboardProps;var interactions=$3ef42575df84b30b$export$9d1611c77c2fe928(focusProps,keyboardProps);var domProps=$f645667febf57a63$var$useFocusableContext(domRef);var interactionProps=props.isDisabled?{}:domProps;var autoFocusRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.autoFocus);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(autoFocusRef.current&&domRef.current)$3ad3f6e1647bc98d$export$80f3e147d781571c(domRef.current);autoFocusRef.current=false;},[domRef]);var tabIndex=props.excludeFromTabOrder?-1:0;if(props.isDisabled)tabIndex=void 0;return{focusableProps:$3ef42575df84b30b$export$9d1611c77c2fe928(__spreadProps(__spreadValues({},interactions),{tabIndex:tabIndex}),interactionProps)};}function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea(_ref236){var children=_ref236.children;var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{register:function register(){}};},[]);return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider,{value:context},children);}function $9ab94262bd0047c7$export$420e68273165f4ec(props){var isDisabled=props.isDisabled,onBlurWithin=props.onBlurWithin,onFocusWithin=props.onFocusWithin,onFocusWithinChange=props.onFocusWithinChange;var state=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({isFocusWithin:false});var _$03deb23ff14920c4$ex2=$03deb23ff14920c4$export$4eaf04e54aa8eed6(),addGlobalListener=_$03deb23ff14920c4$ex2.addGlobalListener,removeAllGlobalListeners=_$03deb23ff14920c4$ex2.removeAllGlobalListeners;var onBlur=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e2){if(!e2.currentTarget.contains(e2.target))return;if(state.current.isFocusWithin&&!e2.currentTarget.contains(e2.relatedTarget)){state.current.isFocusWithin=false;removeAllGlobalListeners();if(onBlurWithin)onBlurWithin(e2);if(onFocusWithinChange)onFocusWithinChange(false);}},[onBlurWithin,onFocusWithinChange,state,removeAllGlobalListeners]);var onSyntheticFocus=$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);var onFocus=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e2){if(!e2.currentTarget.contains(e2.target))return;var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(e2.target);var activeElement=$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);if(!state.current.isFocusWithin&&activeElement===$d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)){if(onFocusWithin)onFocusWithin(e2);if(onFocusWithinChange)onFocusWithinChange(true);state.current.isFocusWithin=true;onSyntheticFocus(e2);var currentTarget=e2.currentTarget;addGlobalListener(ownerDocument,"focus",function(e3){if(state.current.isFocusWithin&&!$d4ee10de306f2510$export$4282f70798064fe0(currentTarget,e3.target)){var nativeEvent=new ownerDocument.defaultView.FocusEvent("blur",{relatedTarget:e3.target});$8a9cb279dc87e130$export$c2b7abe5d61ec696(nativeEvent,currentTarget);var event=$8a9cb279dc87e130$export$525bc4921d56d4a(nativeEvent);onBlur(event);}},{capture:true});}},[onFocusWithin,onFocusWithinChange,onSyntheticFocus,addGlobalListener,onBlur]);if(isDisabled)return{focusWithinProps:{onFocus:void 0,onBlur:void 0}};return{focusWithinProps:{onFocus:onFocus,onBlur:onBlur}};}function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props){var ref=props.ref,onInteractOutside=props.onInteractOutside,isDisabled=props.isDisabled,onInteractOutsideStart=props.onInteractOutsideStart;var stateRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({isPointerDown:false,ignoreEmulatedMouseEvents:false});var onPointerDown=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){if(onInteractOutside&&$e0b6e0b68ec7f50f$var$isValidEvent(e2,ref)){if(onInteractOutsideStart)onInteractOutsideStart(e2);stateRef.current.isPointerDown=true;}});var triggerInteractOutside=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){if(onInteractOutside)onInteractOutside(e2);});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var state=stateRef.current;if(isDisabled)return;var element=ref.current;var documentObject=$431fbd86ca7dc216$export$b204af158042fbac(element);if(typeof PointerEvent!=="undefined"){var onClick=function onClick(e2){if(state.isPointerDown&&$e0b6e0b68ec7f50f$var$isValidEvent(e2,ref))triggerInteractOutside(e2);state.isPointerDown=false;};documentObject.addEventListener("pointerdown",onPointerDown,true);documentObject.addEventListener("click",onClick,true);return function(){documentObject.removeEventListener("pointerdown",onPointerDown,true);documentObject.removeEventListener("click",onClick,true);};}},[ref,isDisabled,onPointerDown,triggerInteractOutside]);}function $e0b6e0b68ec7f50f$var$isValidEvent(event,ref){if(event.button>0)return false;if(event.target){var ownerDocument=event.target.ownerDocument;if(!ownerDocument||!ownerDocument.documentElement.contains(event.target))return false;if(event.target.closest("[data-react-aria-top-layer]"))return false;}if(!ref.current)return false;return!event.composedPath().includes(ref.current);}var $148a7a147e38ea7f$var$RTL_SCRIPTS=/* @__PURE__ */new Set(["Arab","Syrc","Samr","Mand","Thaa","Mend","Nkoo","Adlm","Rohg","Hebr"]);var $148a7a147e38ea7f$var$RTL_LANGS=/* @__PURE__ */new Set(["ae","ar","arc","bcc","bqi","ckb","dv","fa","glk","he","ku","mzn","nqo","pnb","ps","sd","ug","ur","yi"]);function $148a7a147e38ea7f$export$702d680b21cbd764(localeString){if(Intl.Locale){var locale=new Intl.Locale(localeString).maximize();var textInfo=typeof locale.getTextInfo==="function"?locale.getTextInfo():locale.textInfo;if(textInfo)return textInfo.direction==="rtl";if(locale.script)return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);}var lang=localeString.split("-")[0];return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);}var $1e5a04cdaf7d1af8$var$localeSymbol=Symbol["for"]("react-aria.i18n.locale");function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5(){var locale=typeof window!=="undefined"&&window[$1e5a04cdaf7d1af8$var$localeSymbol]||typeof navigator!=="undefined"&&(navigator.language||navigator.userLanguage)||"en-US";try{Intl.DateTimeFormat.supportedLocalesOf([locale]);}catch(_unused2){locale="en-US";}return{locale:locale,direction:$148a7a147e38ea7f$export$702d680b21cbd764(locale)?"rtl":"ltr"};}var $1e5a04cdaf7d1af8$var$currentLocale=$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();var $1e5a04cdaf7d1af8$var$listeners=/* @__PURE__ */new Set();function $1e5a04cdaf7d1af8$var$updateLocale(){$1e5a04cdaf7d1af8$var$currentLocale=$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();var _iterator1=_createForOfIteratorHelper($1e5a04cdaf7d1af8$var$listeners),_step1;try{for(_iterator1.s();!(_step1=_iterator1.n()).done;){var listener=_step1.value;listener($1e5a04cdaf7d1af8$var$currentLocale);}}catch(err){_iterator1.e(err);}finally{_iterator1.f();}}function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a(){var isSSR=$b5e257d569688ac6$export$535bd6ca7f90a273();var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])($1e5a04cdaf7d1af8$var$currentLocale),_useState40=_slicedToArray(_useState39,2),defaultLocale=_useState40[0],setDefaultLocale=_useState40[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if($1e5a04cdaf7d1af8$var$listeners.size===0)window.addEventListener("languagechange",$1e5a04cdaf7d1af8$var$updateLocale);$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);return function(){$1e5a04cdaf7d1af8$var$listeners["delete"](setDefaultLocale);if($1e5a04cdaf7d1af8$var$listeners.size===0)window.removeEventListener("languagechange",$1e5a04cdaf7d1af8$var$updateLocale);};},[]);if(isSSR)return{locale:"en-US",direction:"ltr"};return defaultLocale;}var $18f2051aff69b9bf$var$I18nContext=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);function $18f2051aff69b9bf$var$I18nProviderWithLocale(props){var locale=props.locale,children=props.children;var value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function(){return{locale:locale,direction:$148a7a147e38ea7f$export$702d680b21cbd764(locale)?"rtl":"ltr"};},[locale]);return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($18f2051aff69b9bf$var$I18nContext.Provider,{value:value},children);}function $18f2051aff69b9bf$var$I18nProviderWithDefaultLocale(props){var children=props.children;var defaultLocale=$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($18f2051aff69b9bf$var$I18nContext.Provider,{value:defaultLocale},children);}function $18f2051aff69b9bf$export$a54013f0d02a8f82(props){var locale=props.locale,children=props.children;if(locale)return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($18f2051aff69b9bf$var$I18nProviderWithLocale,{locale:locale,children:children});return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($18f2051aff69b9bf$var$I18nProviderWithDefaultLocale,{children:children});}function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(){var defaultLocale=$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($18f2051aff69b9bf$var$I18nContext);return context||defaultLocale;}var $5b160d28a433310d$var$localeSymbol=Symbol["for"]("react-aria.i18n.locale");var $5b160d28a433310d$var$stringsSymbol=Symbol["for"]("react-aria.i18n.strings");var $5b160d28a433310d$var$cachedGlobalStrings=void 0;var $5b160d28a433310d$export$c17fa47878dc55b6=/*#__PURE__*/function(){function $5b160d28a433310d$export$c17fa47878dc55b6(messages){var defaultLocale=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"en-US";_classCallCheck3(this,$5b160d28a433310d$export$c17fa47878dc55b6);this.strings=Object.fromEntries(Object.entries(messages).filter(function(_ref237){var _ref238=_slicedToArray(_ref237,2),v2=_ref238[1];return v2;}));this.defaultLocale=defaultLocale;}return _createClass3($5b160d28a433310d$export$c17fa47878dc55b6,[{key:"getStringForLocale",value:function getStringForLocale(key2,locale){var strings=this.getStringsForLocale(locale);var string=strings[key2];if(!string)throw new Error("Could not find intl message ".concat(key2," in ").concat(locale," locale"));return string;}},{key:"getStringsForLocale",value:function getStringsForLocale(locale){var strings=this.strings[locale];if(!strings){strings=$5b160d28a433310d$var$getStringsForLocale(locale,this.strings,this.defaultLocale);this.strings[locale]=strings;}return strings;}}],[{key:"getGlobalDictionaryForPackage",value:function getGlobalDictionaryForPackage(packageName){if(typeof window==="undefined")return null;var locale=window[$5b160d28a433310d$var$localeSymbol];if($5b160d28a433310d$var$cachedGlobalStrings===void 0){var globalStrings=window[$5b160d28a433310d$var$stringsSymbol];if(!globalStrings)return null;$5b160d28a433310d$var$cachedGlobalStrings={};for(var pkg in globalStrings)$5b160d28a433310d$var$cachedGlobalStrings[pkg]=new $5b160d28a433310d$export$c17fa47878dc55b6(_defineProperty2({},locale,globalStrings[pkg]),locale);}var dictionary=$5b160d28a433310d$var$cachedGlobalStrings===null||$5b160d28a433310d$var$cachedGlobalStrings===void 0?void 0:$5b160d28a433310d$var$cachedGlobalStrings[packageName];if(!dictionary)throw new Error("Strings for package \"".concat(packageName,"\" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary."));return dictionary;}}]);}();function $5b160d28a433310d$var$getStringsForLocale(locale,strings){var defaultLocale=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"en-US";if(strings[locale])return strings[locale];var language=$5b160d28a433310d$var$getLanguage(locale);if(strings[language])return strings[language];for(var key2 in strings){if(key2.startsWith(language+"-"))return strings[key2];}return strings[defaultLocale];}function $5b160d28a433310d$var$getLanguage(locale){if(Intl.Locale)return new Intl.Locale(locale).language;return locale.split("-")[0];}var $6db58dc88e78b024$var$pluralRulesCache=/* @__PURE__ */new Map();var $6db58dc88e78b024$var$numberFormatCache=/* @__PURE__ */new Map();var $6db58dc88e78b024$export$2f817fcdc4b89ae0=/*#__PURE__*/function(){function $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale,strings){_classCallCheck3(this,$6db58dc88e78b024$export$2f817fcdc4b89ae0);this.locale=locale;this.strings=strings;}return _createClass3($6db58dc88e78b024$export$2f817fcdc4b89ae0,[{key:"format",value:function format(key2,variables){var message=this.strings.getStringForLocale(key2,this.locale);return typeof message==="function"?message(variables,this):message;}},{key:"plural",value:function plural(count,options){var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"cardinal";var opt=options["="+count];if(opt)return typeof opt==="function"?opt():opt;var key2=this.locale+":"+type;var pluralRules=$6db58dc88e78b024$var$pluralRulesCache.get(key2);if(!pluralRules){pluralRules=new Intl.PluralRules(this.locale,{type:type});$6db58dc88e78b024$var$pluralRulesCache.set(key2,pluralRules);}var selected=pluralRules.select(count);opt=options[selected]||options.other;return typeof opt==="function"?opt():opt;}},{key:"number",value:function number(value){var numberFormat=$6db58dc88e78b024$var$numberFormatCache.get(this.locale);if(!numberFormat){numberFormat=new Intl.NumberFormat(this.locale);$6db58dc88e78b024$var$numberFormatCache.set(this.locale,numberFormat);}return numberFormat.format(value);}},{key:"select",value:function select(options,value){var opt=options[value]||options.other;return typeof opt==="function"?opt():opt;}}]);}();var $fca6afa0e843324b$var$cache=/* @__PURE__ */new WeakMap();function $fca6afa0e843324b$var$getCachedDictionary(strings){var dictionary=$fca6afa0e843324b$var$cache.get(strings);if(!dictionary){dictionary=new $5b160d28a433310d$export$c17fa47878dc55b6(strings);$fca6afa0e843324b$var$cache.set(strings,dictionary);}return dictionary;}function $fca6afa0e843324b$export$87b761675e8eaa10(strings,packageName){return packageName&&$5b160d28a433310d$export$c17fa47878dc55b6.getGlobalDictionaryForPackage(packageName)||$fca6afa0e843324b$var$getCachedDictionary(strings);}function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings,packageName){var _$18f2051aff69b9bf$ex=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex.locale;var dictionary=$fca6afa0e843324b$export$87b761675e8eaa10(strings,packageName);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale,dictionary);},[locale,dictionary]);}function $2b4dce13dd5a17fa$export$842a2cf37af977e1(amount,numerator){return amount-numerator*Math.floor(amount/numerator);}var $3b62074eb05584b2$var$EPOCH=1721426;function $3b62074eb05584b2$export$f297eb839006d339(era,year,month,day){year=$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era,year);var y1=year-1;var monthOffset=-2;if(month<=2)monthOffset=0;else if($3b62074eb05584b2$export$553d7fa8e3805fc0(year))monthOffset=-1;return $3b62074eb05584b2$var$EPOCH-1+365*y1+Math.floor(y1/4)-Math.floor(y1/100)+Math.floor(y1/400)+Math.floor((367*month-362)/12+monthOffset+day);}function $3b62074eb05584b2$export$553d7fa8e3805fc0(year){return year%4===0&&(year%100!==0||year%400===0);}function $3b62074eb05584b2$export$c36e0ecb2d4fa69d(era,year){return era==="BC"?1-year:year;}function $3b62074eb05584b2$export$4475b7e617eb123c(year){var era="AD";if(year<=0){era="BC";year=1-year;}return[era,year];}var $3b62074eb05584b2$var$daysInMonth={standard:[31,28,31,30,31,30,31,31,30,31,30,31],leapyear:[31,29,31,30,31,30,31,31,30,31,30,31]};var $3b62074eb05584b2$export$80ee6245ec4f29ec=/*#__PURE__*/function(){function $3b62074eb05584b2$export$80ee6245ec4f29ec(){_classCallCheck3(this,$3b62074eb05584b2$export$80ee6245ec4f29ec);this.identifier="gregory";}return _createClass3($3b62074eb05584b2$export$80ee6245ec4f29ec,[{key:"fromJulianDay",value:function fromJulianDay(jd){var jd0=jd;var depoch=jd0-$3b62074eb05584b2$var$EPOCH;var quadricent=Math.floor(depoch/146097);var dqc=$2b4dce13dd5a17fa$export$842a2cf37af977e1(depoch,146097);var cent=Math.floor(dqc/36524);var dcent=$2b4dce13dd5a17fa$export$842a2cf37af977e1(dqc,36524);var quad=Math.floor(dcent/1461);var dquad=$2b4dce13dd5a17fa$export$842a2cf37af977e1(dcent,1461);var yindex=Math.floor(dquad/365);var extendedYear=quadricent*400+cent*100+quad*4+yindex+(cent!==4&&yindex!==4?1:0);var _$3b62074eb05584b2$ex=$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear),_$3b62074eb05584b2$ex2=_slicedToArray(_$3b62074eb05584b2$ex,2),era=_$3b62074eb05584b2$ex2[0],year=_$3b62074eb05584b2$ex2[1];var yearDay=jd0-$3b62074eb05584b2$export$f297eb839006d339(era,year,1,1);var leapAdj=2;if(jd0<$3b62074eb05584b2$export$f297eb839006d339(era,year,3,1))leapAdj=0;else if($3b62074eb05584b2$export$553d7fa8e3805fc0(year))leapAdj=1;var month=Math.floor(((yearDay+leapAdj)*12+373)/367);var day=jd0-$3b62074eb05584b2$export$f297eb839006d339(era,year,month,1)+1;return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(era,year,month,day);}},{key:"toJulianDay",value:function toJulianDay(date){return $3b62074eb05584b2$export$f297eb839006d339(date.era,date.year,date.month,date.day);}},{key:"getDaysInMonth",value:function getDaysInMonth(date){return $3b62074eb05584b2$var$daysInMonth[$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year)?"leapyear":"standard"][date.month-1];}},{key:"getMonthsInYear",value:function getMonthsInYear(date){return 12;}},{key:"getDaysInYear",value:function getDaysInYear(date){return $3b62074eb05584b2$export$553d7fa8e3805fc0(date.year)?366:365;}},{key:"getYearsInEra",value:function getYearsInEra(date){return 9999;}},{key:"getEras",value:function getEras(){return["BC","AD"];}},{key:"isInverseEra",value:function isInverseEra(date){return date.era==="BC";}},{key:"balanceDate",value:function balanceDate(date){if(date.year<=0){date.era=date.era==="BC"?"AD":"BC";date.year=1-date.year;}}}]);}();var $2fe286d2fb449abb$export$7a5acbd77d414bd9={"001":1,AD:1,AE:6,AF:6,AI:1,AL:1,AM:1,AN:1,AR:1,AT:1,AU:1,AX:1,AZ:1,BA:1,BE:1,BG:1,BH:6,BM:1,BN:1,BY:1,CH:1,CL:1,CM:1,CN:1,CR:1,CY:1,CZ:1,DE:1,DJ:6,DK:1,DZ:6,EC:1,EE:1,EG:6,ES:1,FI:1,FJ:1,FO:1,FR:1,GB:1,GE:1,GF:1,GP:1,GR:1,HR:1,HU:1,IE:1,IQ:6,IR:6,IS:1,IT:1,JO:6,KG:1,KW:6,KZ:1,LB:1,LI:1,LK:1,LT:1,LU:1,LV:1,LY:6,MC:1,MD:1,ME:1,MK:1,MN:1,MQ:1,MV:5,MY:1,NL:1,NO:1,NZ:1,OM:6,PL:1,QA:6,RE:1,RO:1,RS:1,RU:1,SD:6,SE:1,SI:1,SK:1,SM:1,SY:6,TJ:1,TM:1,TR:1,UA:1,UY:1,UZ:1,VA:1,VN:1,XK:1};function $14e0f24ef4ac5c92$export$ea39ec197993aef0(a,b2){b2=$11d87f3f76e88657$export$b4a036af3fc0b032(b2,a.calendar);return a.era===b2.era&&a.year===b2.year&&a.month===b2.month&&a.day===b2.day;}function $14e0f24ef4ac5c92$export$91b62ebf2ba703ee(a,b2){return $14e0f24ef4ac5c92$export$dbc69fd56b53d5e(a.calendar,b2.calendar)&&$14e0f24ef4ac5c92$export$ea39ec197993aef0(a,b2);}function $14e0f24ef4ac5c92$export$dbc69fd56b53d5e(a,b2){var _a_isEqual,_b_isEqual;var _a_isEqual1,_ref6;return(_ref6=(_a_isEqual1=(_a_isEqual=a.isEqual)===null||_a_isEqual===void 0?void 0:_a_isEqual.call(a,b2))!==null&&_a_isEqual1!==void 0?_a_isEqual1:(_b_isEqual=b2.isEqual)===null||_b_isEqual===void 0?void 0:_b_isEqual.call(b2,a))!==null&&_ref6!==void 0?_ref6:a.identifier===b2.identifier;}function $14e0f24ef4ac5c92$export$629b0a497aa65267(date,timeZone){return $14e0f24ef4ac5c92$export$ea39ec197993aef0(date,$14e0f24ef4ac5c92$export$d0bdf45af03a6ea3(timeZone));}var $14e0f24ef4ac5c92$var$DAY_MAP={sun:0,mon:1,tue:2,wed:3,thu:4,fri:5,sat:6};function $14e0f24ef4ac5c92$export$2061056d06d7cdf7(date,locale,firstDayOfWeek){var julian=date.calendar.toJulianDay(date);var weekStart=firstDayOfWeek?$14e0f24ef4ac5c92$var$DAY_MAP[firstDayOfWeek]:$14e0f24ef4ac5c92$var$getWeekStart(locale);var dayOfWeek=Math.ceil(julian+1-weekStart)%7;if(dayOfWeek<0)dayOfWeek+=7;return dayOfWeek;}function $14e0f24ef4ac5c92$export$461939dd4422153(timeZone){return $11d87f3f76e88657$export$1b96692a1ba042ac(Date.now(),timeZone);}function $14e0f24ef4ac5c92$export$d0bdf45af03a6ea3(timeZone){return $11d87f3f76e88657$export$93522d1a439f3617($14e0f24ef4ac5c92$export$461939dd4422153(timeZone));}function $14e0f24ef4ac5c92$export$68781ddf31c0090f(a,b2){return a.calendar.toJulianDay(a)-b2.calendar.toJulianDay(b2);}function $14e0f24ef4ac5c92$export$c19a80a9721b80f6(a,b2){return $14e0f24ef4ac5c92$var$timeToMs(a)-$14e0f24ef4ac5c92$var$timeToMs(b2);}function $14e0f24ef4ac5c92$var$timeToMs(a){return a.hour*36e5+a.minute*6e4+a.second*1e3+a.millisecond;}var $14e0f24ef4ac5c92$var$localTimeZone=null;function $14e0f24ef4ac5c92$export$aa8b41735afcabd2(){if($14e0f24ef4ac5c92$var$localTimeZone==null)$14e0f24ef4ac5c92$var$localTimeZone=new Intl.DateTimeFormat().resolvedOptions().timeZone;return $14e0f24ef4ac5c92$var$localTimeZone;}function $14e0f24ef4ac5c92$export$a5a3b454ada2268e(date){return date.subtract({days:date.day-1});}function $14e0f24ef4ac5c92$export$a2258d9c4118825c(date){return date.add({days:date.calendar.getDaysInMonth(date)-date.day});}function $14e0f24ef4ac5c92$export$f91e89d3d0406102(date){return $14e0f24ef4ac5c92$export$a5a3b454ada2268e(date.subtract({months:date.month-1}));}function $14e0f24ef4ac5c92$export$5412ac11713b72ad(date){if(date.calendar.getMinimumMonthInYear)return date.calendar.getMinimumMonthInYear(date);return 1;}function $14e0f24ef4ac5c92$export$b2f4953d301981d5(date){if(date.calendar.getMinimumDayInMonth)return date.calendar.getMinimumDayInMonth(date);return 1;}function $14e0f24ef4ac5c92$export$42c81a444fbfb5d4(date,locale,firstDayOfWeek){var dayOfWeek=$14e0f24ef4ac5c92$export$2061056d06d7cdf7(date,locale,firstDayOfWeek);return date.subtract({days:dayOfWeek});}function $14e0f24ef4ac5c92$export$ef8b6d9133084f4e(date,locale,firstDayOfWeek){return $14e0f24ef4ac5c92$export$42c81a444fbfb5d4(date,locale,firstDayOfWeek).add({days:6});}var $14e0f24ef4ac5c92$var$cachedRegions=/* @__PURE__ */new Map();var $14e0f24ef4ac5c92$var$cachedWeekInfo=/* @__PURE__ */new Map();function $14e0f24ef4ac5c92$var$getRegion(locale){if(Intl.Locale){var region=$14e0f24ef4ac5c92$var$cachedRegions.get(locale);if(!region){region=new Intl.Locale(locale).maximize().region;if(region)$14e0f24ef4ac5c92$var$cachedRegions.set(locale,region);}return region;}var part=locale.split("-")[1];return part==="u"?void 0:part;}function $14e0f24ef4ac5c92$var$getWeekStart(locale){var weekInfo=$14e0f24ef4ac5c92$var$cachedWeekInfo.get(locale);if(!weekInfo){if(Intl.Locale){var localeInst=new Intl.Locale(locale);if("getWeekInfo"in localeInst){weekInfo=localeInst.getWeekInfo();if(weekInfo){$14e0f24ef4ac5c92$var$cachedWeekInfo.set(locale,weekInfo);return weekInfo.firstDay;}}}var region=$14e0f24ef4ac5c92$var$getRegion(locale);if(locale.includes("-fw-")){var day=locale.split("-fw-")[1].split("-")[0];if(day==="mon")weekInfo={firstDay:1};else if(day==="tue")weekInfo={firstDay:2};else if(day==="wed")weekInfo={firstDay:3};else if(day==="thu")weekInfo={firstDay:4};else if(day==="fri")weekInfo={firstDay:5};else if(day==="sat")weekInfo={firstDay:6};else weekInfo={firstDay:0};}else if(locale.includes("-ca-iso8601"))weekInfo={firstDay:1};else weekInfo={firstDay:region?$2fe286d2fb449abb$export$7a5acbd77d414bd9[region]||0:0};$14e0f24ef4ac5c92$var$cachedWeekInfo.set(locale,weekInfo);}return weekInfo.firstDay;}function $14e0f24ef4ac5c92$export$ccc1b2479e7dd654(date,locale,firstDayOfWeek){var days=date.calendar.getDaysInMonth(date);return Math.ceil(($14e0f24ef4ac5c92$export$2061056d06d7cdf7($14e0f24ef4ac5c92$export$a5a3b454ada2268e(date),locale,firstDayOfWeek)+days)/7);}function $14e0f24ef4ac5c92$export$5c333a116e949cdd(a,b2){if(a&&b2)return a.compare(b2)<=0?a:b2;return a||b2;}function $14e0f24ef4ac5c92$export$a75f2bff57811055(a,b2){if(a&&b2)return a.compare(b2)>=0?a:b2;return a||b2;}function $11d87f3f76e88657$export$bd4fb2bc8bb06fb(date){date=$11d87f3f76e88657$export$b4a036af3fc0b032(date,new $3b62074eb05584b2$export$80ee6245ec4f29ec());var year=$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era,date.year);return $11d87f3f76e88657$var$epochFromParts(year,date.month,date.day,date.hour,date.minute,date.second,date.millisecond);}function $11d87f3f76e88657$var$epochFromParts(year,month,day,hour,minute,second,millisecond){var date=new Date();date.setUTCHours(hour,minute,second,millisecond);date.setUTCFullYear(year,month-1,day);return date.getTime();}function $11d87f3f76e88657$export$59c99f3515d3493f(ms,timeZone){if(timeZone==="UTC")return 0;if(ms>0&&timeZone===$14e0f24ef4ac5c92$export$aa8b41735afcabd2())return new Date(ms).getTimezoneOffset()*-6e4;var _$11d87f3f76e88657$va=$11d87f3f76e88657$var$getTimeZoneParts(ms,timeZone),year=_$11d87f3f76e88657$va.year,month=_$11d87f3f76e88657$va.month,day=_$11d87f3f76e88657$va.day,hour=_$11d87f3f76e88657$va.hour,minute=_$11d87f3f76e88657$va.minute,second=_$11d87f3f76e88657$va.second;var utc=$11d87f3f76e88657$var$epochFromParts(year,month,day,hour,minute,second,0);return utc-Math.floor(ms/1e3)*1e3;}var $11d87f3f76e88657$var$formattersByTimeZone=/* @__PURE__ */new Map();function $11d87f3f76e88657$var$getTimeZoneParts(ms,timeZone){var formatter=$11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);if(!formatter){formatter=new Intl.DateTimeFormat("en-US",{timeZone:timeZone,hour12:false,era:"short",year:"numeric",month:"numeric",day:"numeric",hour:"numeric",minute:"numeric",second:"numeric"});$11d87f3f76e88657$var$formattersByTimeZone.set(timeZone,formatter);}var parts=formatter.formatToParts(new Date(ms));var namedParts={};var _iterator10=_createForOfIteratorHelper(parts),_step10;try{for(_iterator10.s();!(_step10=_iterator10.n()).done;){var part=_step10.value;if(part.type!=="literal")namedParts[part.type]=part.value;}}catch(err){_iterator10.e(err);}finally{_iterator10.f();}return{year:namedParts.era==="BC"||namedParts.era==="B"?-namedParts.year+1:+namedParts.year,month:+namedParts.month,day:+namedParts.day,hour:namedParts.hour==="24"?0:+namedParts.hour,minute:+namedParts.minute,second:+namedParts.second};}var $11d87f3f76e88657$var$DAYMILLIS=864e5;function $11d87f3f76e88657$var$getValidWallTimes(date,timeZone,earlier,later){var found=earlier===later?[earlier]:[earlier,later];return found.filter(function(absolute){return $11d87f3f76e88657$var$isValidWallTime(date,timeZone,absolute);});}function $11d87f3f76e88657$var$isValidWallTime(date,timeZone,absolute){var parts=$11d87f3f76e88657$var$getTimeZoneParts(absolute,timeZone);return date.year===parts.year&&date.month===parts.month&&date.day===parts.day&&date.hour===parts.hour&&date.minute===parts.minute&&date.second===parts.second;}function $11d87f3f76e88657$export$5107c82f94518f5c(date,timeZone){var disambiguation=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"compatible";var dateTime=$11d87f3f76e88657$export$b21e0b124e224484(date);if(timeZone==="UTC")return $11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);if(timeZone===$14e0f24ef4ac5c92$export$aa8b41735afcabd2()&&disambiguation==="compatible"){dateTime=$11d87f3f76e88657$export$b4a036af3fc0b032(dateTime,new $3b62074eb05584b2$export$80ee6245ec4f29ec());var date2=new Date();var year=$3b62074eb05584b2$export$c36e0ecb2d4fa69d(dateTime.era,dateTime.year);date2.setFullYear(year,dateTime.month-1,dateTime.day);date2.setHours(dateTime.hour,dateTime.minute,dateTime.second,dateTime.millisecond);return date2.getTime();}var ms=$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);var offsetBefore=$11d87f3f76e88657$export$59c99f3515d3493f(ms-$11d87f3f76e88657$var$DAYMILLIS,timeZone);var offsetAfter=$11d87f3f76e88657$export$59c99f3515d3493f(ms+$11d87f3f76e88657$var$DAYMILLIS,timeZone);var valid2=$11d87f3f76e88657$var$getValidWallTimes(dateTime,timeZone,ms-offsetBefore,ms-offsetAfter);if(valid2.length===1)return valid2[0];if(valid2.length>1)switch(disambiguation){case"compatible":case"earlier":return valid2[0];case"later":return valid2[valid2.length-1];case"reject":throw new RangeError("Multiple possible absolute times found");}switch(disambiguation){case"earlier":return Math.min(ms-offsetBefore,ms-offsetAfter);case"compatible":case"later":return Math.max(ms-offsetBefore,ms-offsetAfter);case"reject":throw new RangeError("No such absolute time found");}}function $11d87f3f76e88657$export$e67a095c620b86fe(dateTime,timeZone){var disambiguation=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"compatible";return new Date($11d87f3f76e88657$export$5107c82f94518f5c(dateTime,timeZone,disambiguation));}function $11d87f3f76e88657$export$1b96692a1ba042ac(ms,timeZone){var offset2=$11d87f3f76e88657$export$59c99f3515d3493f(ms,timeZone);var date=new Date(ms+offset2);var year=date.getUTCFullYear();var month=date.getUTCMonth()+1;var day=date.getUTCDate();var hour=date.getUTCHours();var minute=date.getUTCMinutes();var second=date.getUTCSeconds();var millisecond=date.getUTCMilliseconds();return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(year<1?"BC":"AD",year<1?-year+1:year,month,day,timeZone,offset2,hour,minute,second,millisecond);}function $11d87f3f76e88657$export$93522d1a439f3617(dateTime){return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(dateTime.calendar,dateTime.era,dateTime.year,dateTime.month,dateTime.day);}function $11d87f3f76e88657$export$b21e0b124e224484(date,time){var hour=0,minute=0,second=0,millisecond=0;if("timeZone"in date){hour=date.hour;minute=date.minute;second=date.second;millisecond=date.millisecond;}else if("hour"in date&&!time)return date;if(time){hour=time.hour;minute=time.minute;second=time.second;millisecond=time.millisecond;}return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(date.calendar,date.era,date.year,date.month,date.day,hour,minute,second,millisecond);}function $11d87f3f76e88657$export$b4a036af3fc0b032(date,calendar){if($14e0f24ef4ac5c92$export$dbc69fd56b53d5e(date.calendar,calendar))return date;var calendarDate=calendar.fromJulianDay(date.calendar.toJulianDay(date));var copy=date.copy();copy.calendar=calendar;copy.era=calendarDate.era;copy.year=calendarDate.year;copy.month=calendarDate.month;copy.day=calendarDate.day;$735220c2d4774dd3$export$c4e2ecac49351ef2(copy);return copy;}function $11d87f3f76e88657$export$84c95a83c799e074(date,timeZone,disambiguation){if(date instanceof $35ea8db9cb2ccb90$export$d3b7288e7994edea){if(date.timeZone===timeZone)return date;return $11d87f3f76e88657$export$538b00033cc11c75(date,timeZone);}var ms=$11d87f3f76e88657$export$5107c82f94518f5c(date,timeZone,disambiguation);return $11d87f3f76e88657$export$1b96692a1ba042ac(ms,timeZone);}function $11d87f3f76e88657$export$83aac07b4c37b25(date){var ms=$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date)-date.offset;return new Date(ms);}function $11d87f3f76e88657$export$538b00033cc11c75(date,timeZone){var ms=$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date)-date.offset;return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms,timeZone),date.calendar);}var $735220c2d4774dd3$var$ONE_HOUR=36e5;function $735220c2d4774dd3$export$e16d8520af44a096(date,duration){var mutableDate=date.copy();var days="hour"in mutableDate?$735220c2d4774dd3$var$addTimeFields(mutableDate,duration):0;$735220c2d4774dd3$var$addYears(mutableDate,duration.years||0);if(mutableDate.calendar.balanceYearMonth)mutableDate.calendar.balanceYearMonth(mutableDate,date);mutableDate.month+=duration.months||0;$735220c2d4774dd3$var$balanceYearMonth(mutableDate);$735220c2d4774dd3$var$constrainMonthDay(mutableDate);mutableDate.day+=(duration.weeks||0)*7;mutableDate.day+=duration.days||0;mutableDate.day+=days;$735220c2d4774dd3$var$balanceDay(mutableDate);if(mutableDate.calendar.balanceDate)mutableDate.calendar.balanceDate(mutableDate);if(mutableDate.year<1){mutableDate.year=1;mutableDate.month=1;mutableDate.day=1;}var maxYear=mutableDate.calendar.getYearsInEra(mutableDate);if(mutableDate.year>maxYear){var _mutableDate_calendar_isInverseEra,_mutableDate_calendar;var isInverseEra=(_mutableDate_calendar_isInverseEra=(_mutableDate_calendar=mutableDate.calendar).isInverseEra)===null||_mutableDate_calendar_isInverseEra===void 0?void 0:_mutableDate_calendar_isInverseEra.call(_mutableDate_calendar,mutableDate);mutableDate.year=maxYear;mutableDate.month=isInverseEra?1:mutableDate.calendar.getMonthsInYear(mutableDate);mutableDate.day=isInverseEra?1:mutableDate.calendar.getDaysInMonth(mutableDate);}if(mutableDate.month<1){mutableDate.month=1;mutableDate.day=1;}var maxMonth=mutableDate.calendar.getMonthsInYear(mutableDate);if(mutableDate.month>maxMonth){mutableDate.month=maxMonth;mutableDate.day=mutableDate.calendar.getDaysInMonth(mutableDate);}mutableDate.day=Math.max(1,Math.min(mutableDate.calendar.getDaysInMonth(mutableDate),mutableDate.day));return mutableDate;}function $735220c2d4774dd3$var$addYears(date,years){var _date_calendar_isInverseEra,_date_calendar;if((_date_calendar_isInverseEra=(_date_calendar=date.calendar).isInverseEra)===null||_date_calendar_isInverseEra===void 0?void 0:_date_calendar_isInverseEra.call(_date_calendar,date))years=-years;date.year+=years;}function $735220c2d4774dd3$var$balanceYearMonth(date){while(date.month<1){$735220c2d4774dd3$var$addYears(date,-1);date.month+=date.calendar.getMonthsInYear(date);}var monthsInYear=0;while(date.month>(monthsInYear=date.calendar.getMonthsInYear(date))){date.month-=monthsInYear;$735220c2d4774dd3$var$addYears(date,1);}}function $735220c2d4774dd3$var$balanceDay(date){while(date.day<1){date.month--;$735220c2d4774dd3$var$balanceYearMonth(date);date.day+=date.calendar.getDaysInMonth(date);}while(date.day>date.calendar.getDaysInMonth(date)){date.day-=date.calendar.getDaysInMonth(date);date.month++;$735220c2d4774dd3$var$balanceYearMonth(date);}}function $735220c2d4774dd3$var$constrainMonthDay(date){date.month=Math.max(1,Math.min(date.calendar.getMonthsInYear(date),date.month));date.day=Math.max(1,Math.min(date.calendar.getDaysInMonth(date),date.day));}function $735220c2d4774dd3$export$c4e2ecac49351ef2(date){if(date.calendar.constrainDate)date.calendar.constrainDate(date);date.year=Math.max(1,Math.min(date.calendar.getYearsInEra(date),date.year));$735220c2d4774dd3$var$constrainMonthDay(date);}function $735220c2d4774dd3$export$3e2544e88a25bff8(duration){var inverseDuration={};for(var key2 in duration)if(typeof duration[key2]==="number")inverseDuration[key2]=-duration[key2];return inverseDuration;}function $735220c2d4774dd3$export$4e2d2ead65e5f7e3(date,duration){return $735220c2d4774dd3$export$e16d8520af44a096(date,$735220c2d4774dd3$export$3e2544e88a25bff8(duration));}function $735220c2d4774dd3$export$adaa4cf7ef1b65be(date,fields){var mutableDate=date.copy();if(fields.era!=null)mutableDate.era=fields.era;if(fields.year!=null)mutableDate.year=fields.year;if(fields.month!=null)mutableDate.month=fields.month;if(fields.day!=null)mutableDate.day=fields.day;$735220c2d4774dd3$export$c4e2ecac49351ef2(mutableDate);return mutableDate;}function $735220c2d4774dd3$export$e5d5e1c1822b6e56(value,fields){var mutableValue=value.copy();if(fields.hour!=null)mutableValue.hour=fields.hour;if(fields.minute!=null)mutableValue.minute=fields.minute;if(fields.second!=null)mutableValue.second=fields.second;if(fields.millisecond!=null)mutableValue.millisecond=fields.millisecond;$735220c2d4774dd3$export$7555de1e070510cb(mutableValue);return mutableValue;}function $735220c2d4774dd3$var$balanceTime(time){time.second+=Math.floor(time.millisecond/1e3);time.millisecond=$735220c2d4774dd3$var$nonNegativeMod(time.millisecond,1e3);time.minute+=Math.floor(time.second/60);time.second=$735220c2d4774dd3$var$nonNegativeMod(time.second,60);time.hour+=Math.floor(time.minute/60);time.minute=$735220c2d4774dd3$var$nonNegativeMod(time.minute,60);var days=Math.floor(time.hour/24);time.hour=$735220c2d4774dd3$var$nonNegativeMod(time.hour,24);return days;}function $735220c2d4774dd3$export$7555de1e070510cb(time){time.millisecond=Math.max(0,Math.min(time.millisecond,1e3));time.second=Math.max(0,Math.min(time.second,59));time.minute=Math.max(0,Math.min(time.minute,59));time.hour=Math.max(0,Math.min(time.hour,23));}function $735220c2d4774dd3$var$nonNegativeMod(a,b2){var result=a%b2;if(result<0)result+=b2;return result;}function $735220c2d4774dd3$var$addTimeFields(time,duration){time.hour+=duration.hours||0;time.minute+=duration.minutes||0;time.second+=duration.seconds||0;time.millisecond+=duration.milliseconds||0;return $735220c2d4774dd3$var$balanceTime(time);}function $735220c2d4774dd3$export$7ed87b6bc2506470(time,duration){var res=time.copy();$735220c2d4774dd3$var$addTimeFields(res,duration);return res;}function $735220c2d4774dd3$export$fe34d3a381cd7501(time,duration){return $735220c2d4774dd3$export$7ed87b6bc2506470(time,$735220c2d4774dd3$export$3e2544e88a25bff8(duration));}function $735220c2d4774dd3$export$d52ced6badfb9a4c(value,field,amount,options){var mutable=value.copy();switch(field){case"era":{var eras=value.calendar.getEras();var eraIndex=eras.indexOf(value.era);if(eraIndex<0)throw new Error("Invalid era: "+value.era);eraIndex=$735220c2d4774dd3$var$cycleValue(eraIndex,amount,0,eras.length-1,options===null||options===void 0?void 0:options.round);mutable.era=eras[eraIndex];$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);break;}case"year":var _mutable_calendar_isInverseEra,_mutable_calendar;if((_mutable_calendar_isInverseEra=(_mutable_calendar=mutable.calendar).isInverseEra)===null||_mutable_calendar_isInverseEra===void 0?void 0:_mutable_calendar_isInverseEra.call(_mutable_calendar,mutable))amount=-amount;mutable.year=$735220c2d4774dd3$var$cycleValue(value.year,amount,-Infinity,9999,options===null||options===void 0?void 0:options.round);if(mutable.year===-Infinity)mutable.year=1;if(mutable.calendar.balanceYearMonth)mutable.calendar.balanceYearMonth(mutable,value);break;case"month":mutable.month=$735220c2d4774dd3$var$cycleValue(value.month,amount,1,value.calendar.getMonthsInYear(value),options===null||options===void 0?void 0:options.round);break;case"day":mutable.day=$735220c2d4774dd3$var$cycleValue(value.day,amount,1,value.calendar.getDaysInMonth(value),options===null||options===void 0?void 0:options.round);break;default:throw new Error("Unsupported field "+field);}if(value.calendar.balanceDate)value.calendar.balanceDate(mutable);$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);return mutable;}function $735220c2d4774dd3$export$dd02b3e0007dfe28(value,field,amount,options){var mutable=value.copy();switch(field){case"hour":{var hours=value.hour;var min=0;var max=23;if((options===null||options===void 0?void 0:options.hourCycle)===12){var isPM=hours>=12;min=isPM?12:0;max=isPM?23:11;}mutable.hour=$735220c2d4774dd3$var$cycleValue(hours,amount,min,max,options===null||options===void 0?void 0:options.round);break;}case"minute":mutable.minute=$735220c2d4774dd3$var$cycleValue(value.minute,amount,0,59,options===null||options===void 0?void 0:options.round);break;case"second":mutable.second=$735220c2d4774dd3$var$cycleValue(value.second,amount,0,59,options===null||options===void 0?void 0:options.round);break;case"millisecond":mutable.millisecond=$735220c2d4774dd3$var$cycleValue(value.millisecond,amount,0,999,options===null||options===void 0?void 0:options.round);break;default:throw new Error("Unsupported field "+field);}return mutable;}function $735220c2d4774dd3$var$cycleValue(value,amount,min,max){var round=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;if(round){value+=Math.sign(amount);if(value<min)value=max;var div=Math.abs(amount);if(amount>0)value=Math.ceil(value/div)*div;else value=Math.floor(value/div)*div;if(value>max)value=min;}else{value+=amount;if(value<min)value=max-(min-value-1);else if(value>max)value=min+(value-max-1);}return value;}function $735220c2d4774dd3$export$96b1d28349274637(dateTime,duration){var ms;if(duration.years!=null&&duration.years!==0||duration.months!=null&&duration.months!==0||duration.weeks!=null&&duration.weeks!==0||duration.days!=null&&duration.days!==0){var res2=$735220c2d4774dd3$export$e16d8520af44a096($11d87f3f76e88657$export$b21e0b124e224484(dateTime),{years:duration.years,months:duration.months,weeks:duration.weeks,days:duration.days});ms=$11d87f3f76e88657$export$5107c82f94518f5c(res2,dateTime.timeZone);}else ms=$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime)-dateTime.offset;ms+=duration.milliseconds||0;ms+=(duration.seconds||0)*1e3;ms+=(duration.minutes||0)*6e4;ms+=(duration.hours||0)*36e5;var res=$11d87f3f76e88657$export$1b96692a1ba042ac(ms,dateTime.timeZone);return $11d87f3f76e88657$export$b4a036af3fc0b032(res,dateTime.calendar);}function $735220c2d4774dd3$export$6814caac34ca03c7(dateTime,duration){return $735220c2d4774dd3$export$96b1d28349274637(dateTime,$735220c2d4774dd3$export$3e2544e88a25bff8(duration));}function $735220c2d4774dd3$export$9a297d111fc86b79(dateTime,field,amount,options){switch(field){case"hour":{var min=0;var max=23;if((options===null||options===void 0?void 0:options.hourCycle)===12){var isPM=dateTime.hour>=12;min=isPM?12:0;max=isPM?23:11;}var plainDateTime=$11d87f3f76e88657$export$b21e0b124e224484(dateTime);var minDate=$11d87f3f76e88657$export$b4a036af3fc0b032($735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime,{hour:min}),new $3b62074eb05584b2$export$80ee6245ec4f29ec());var minAbsolute=[$11d87f3f76e88657$export$5107c82f94518f5c(minDate,dateTime.timeZone,"earlier"),$11d87f3f76e88657$export$5107c82f94518f5c(minDate,dateTime.timeZone,"later")].filter(function(ms2){return $11d87f3f76e88657$export$1b96692a1ba042ac(ms2,dateTime.timeZone).day===minDate.day;})[0];var maxDate=$11d87f3f76e88657$export$b4a036af3fc0b032($735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime,{hour:max}),new $3b62074eb05584b2$export$80ee6245ec4f29ec());var maxAbsolute=[$11d87f3f76e88657$export$5107c82f94518f5c(maxDate,dateTime.timeZone,"earlier"),$11d87f3f76e88657$export$5107c82f94518f5c(maxDate,dateTime.timeZone,"later")].filter(function(ms2){return $11d87f3f76e88657$export$1b96692a1ba042ac(ms2,dateTime.timeZone).day===maxDate.day;}).pop();var ms=$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime)-dateTime.offset;var hours=Math.floor(ms/$735220c2d4774dd3$var$ONE_HOUR);var remainder=ms%$735220c2d4774dd3$var$ONE_HOUR;ms=$735220c2d4774dd3$var$cycleValue(hours,amount,Math.floor(minAbsolute/$735220c2d4774dd3$var$ONE_HOUR),Math.floor(maxAbsolute/$735220c2d4774dd3$var$ONE_HOUR),options===null||options===void 0?void 0:options.round)*$735220c2d4774dd3$var$ONE_HOUR+remainder;return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms,dateTime.timeZone),dateTime.calendar);}case"minute":case"second":case"millisecond":return $735220c2d4774dd3$export$dd02b3e0007dfe28(dateTime,field,amount,options);case"era":case"year":case"month":case"day":{var res=$735220c2d4774dd3$export$d52ced6badfb9a4c($11d87f3f76e88657$export$b21e0b124e224484(dateTime),field,amount,options);var _ms=$11d87f3f76e88657$export$5107c82f94518f5c(res,dateTime.timeZone);return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(_ms,dateTime.timeZone),dateTime.calendar);}default:throw new Error("Unsupported field "+field);}}function $735220c2d4774dd3$export$31b5430eb18be4f8(dateTime,fields,disambiguation){var plainDateTime=$11d87f3f76e88657$export$b21e0b124e224484(dateTime);var res=$735220c2d4774dd3$export$e5d5e1c1822b6e56($735220c2d4774dd3$export$adaa4cf7ef1b65be(plainDateTime,fields),fields);if(res.compare(plainDateTime)===0)return dateTime;var ms=$11d87f3f76e88657$export$5107c82f94518f5c(res,dateTime.timeZone,disambiguation);return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms,dateTime.timeZone),dateTime.calendar);}var $fae977aafc393c5c$var$DATE_RE=/^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;function $fae977aafc393c5c$export$6b862160d295c8e(value){var m2=value.match($fae977aafc393c5c$var$DATE_RE);if(!m2)throw new Error("Invalid ISO 8601 date string: "+value);var date=new $35ea8db9cb2ccb90$export$99faa760c7908e4f($fae977aafc393c5c$var$parseNumber(m2[1],0,9999),$fae977aafc393c5c$var$parseNumber(m2[2],1,12),1);date.day=$fae977aafc393c5c$var$parseNumber(m2[3],1,date.calendar.getDaysInMonth(date));return date;}function $fae977aafc393c5c$var$parseNumber(value,min,max){var val=Number(value);if(val<min||val>max)throw new RangeError("Value out of range: ".concat(min," <= ").concat(val," <= ").concat(max));return val;}function $fae977aafc393c5c$export$f59dee82248f5ad4(time){return"".concat(String(time.hour).padStart(2,"0"),":").concat(String(time.minute).padStart(2,"0"),":").concat(String(time.second).padStart(2,"0")).concat(time.millisecond?String(time.millisecond/1e3).slice(1):"");}function $fae977aafc393c5c$export$60dfd74aa96791bd(date){var gregorianDate=$11d87f3f76e88657$export$b4a036af3fc0b032(date,new $3b62074eb05584b2$export$80ee6245ec4f29ec());var year;if(gregorianDate.era==="BC")year=gregorianDate.year===1?"0000":"-"+String(Math.abs(1-gregorianDate.year)).padStart(6,"00");else year=String(gregorianDate.year).padStart(4,"0");return"".concat(year,"-").concat(String(gregorianDate.month).padStart(2,"0"),"-").concat(String(gregorianDate.day).padStart(2,"0"));}function $fae977aafc393c5c$export$4223de14708adc63(date){return"".concat($fae977aafc393c5c$export$60dfd74aa96791bd(date),"T").concat($fae977aafc393c5c$export$f59dee82248f5ad4(date));}function $fae977aafc393c5c$var$offsetToString(offset2){var sign=Math.sign(offset2)<0?"-":"+";offset2=Math.abs(offset2);var offsetHours=Math.floor(offset2/36e5);var offsetMinutes=Math.floor(offset2%36e5/6e4);var offsetSeconds=Math.floor(offset2%36e5%6e4/1e3);var stringOffset="".concat(sign).concat(String(offsetHours).padStart(2,"0"),":").concat(String(offsetMinutes).padStart(2,"0"));if(offsetSeconds!==0)stringOffset+=":".concat(String(offsetSeconds).padStart(2,"0"));return stringOffset;}function $fae977aafc393c5c$export$bf79f1ebf4b18792(date){return"".concat($fae977aafc393c5c$export$4223de14708adc63(date)).concat($fae977aafc393c5c$var$offsetToString(date.offset),"[").concat(date.timeZone,"]");}function $35ea8db9cb2ccb90$var$shiftArgs(args){var calendar=_typeof2(args[0])==="object"?args.shift():new $3b62074eb05584b2$export$80ee6245ec4f29ec();var era;if(typeof args[0]==="string")era=args.shift();else{var eras=calendar.getEras();era=eras[eras.length-1];}var year=args.shift();var month=args.shift();var day=args.shift();return[calendar,era,year,month,day];}var $35ea8db9cb2ccb90$var$_type=/* @__PURE__ */new WeakMap();var $35ea8db9cb2ccb90$export$99faa760c7908e4f=/*#__PURE__*/function(){function $35ea8db9cb2ccb90$export$99faa760c7908e4f(){_classCallCheck3(this,$35ea8db9cb2ccb90$export$99faa760c7908e4f);_class_private_field_init(this,$35ea8db9cb2ccb90$var$_type,{writable:true,value:void 0});for(var _len14=arguments.length,args=new Array(_len14),_key14=0;_key14<_len14;_key14++){args[_key14]=arguments[_key14];}var _$35ea8db9cb2ccb90$va=$35ea8db9cb2ccb90$var$shiftArgs(args),_$35ea8db9cb2ccb90$va2=_slicedToArray(_$35ea8db9cb2ccb90$va,5),calendar=_$35ea8db9cb2ccb90$va2[0],era=_$35ea8db9cb2ccb90$va2[1],year=_$35ea8db9cb2ccb90$va2[2],month=_$35ea8db9cb2ccb90$va2[3],day=_$35ea8db9cb2ccb90$va2[4];this.calendar=calendar;this.era=era;this.year=year;this.month=month;this.day=day;$735220c2d4774dd3$export$c4e2ecac49351ef2(this);}return _createClass3($35ea8db9cb2ccb90$export$99faa760c7908e4f,[{key:"copy",value:function copy(){if(this.era)return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this.calendar,this.era,this.year,this.month,this.day);else return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this.calendar,this.year,this.month,this.day);}},{key:"add",value:function add(duration){return $735220c2d4774dd3$export$e16d8520af44a096(this,duration);}},{key:"subtract",value:function subtract(duration){return $735220c2d4774dd3$export$4e2d2ead65e5f7e3(this,duration);}},{key:"set",value:function set(fields){return $735220c2d4774dd3$export$adaa4cf7ef1b65be(this,fields);}},{key:"cycle",value:function cycle(field,amount,options){return $735220c2d4774dd3$export$d52ced6badfb9a4c(this,field,amount,options);}},{key:"toDate",value:function toDate(timeZone){return $11d87f3f76e88657$export$e67a095c620b86fe(this,timeZone);}},{key:"toString",value:function toString(){return $fae977aafc393c5c$export$60dfd74aa96791bd(this);}},{key:"compare",value:function compare(b2){return $14e0f24ef4ac5c92$export$68781ddf31c0090f(this,b2);}}]);}();var $35ea8db9cb2ccb90$var$_type1=/* @__PURE__ */new WeakMap();var $35ea8db9cb2ccb90$export$680ea196effce5f=/*#__PURE__*/function(){function $35ea8db9cb2ccb90$export$680ea196effce5f(){var hour=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var minute=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var second=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var millisecond=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;_classCallCheck3(this,$35ea8db9cb2ccb90$export$680ea196effce5f);_class_private_field_init(this,$35ea8db9cb2ccb90$var$_type1,{writable:true,value:void 0});this.hour=hour;this.minute=minute;this.second=second;this.millisecond=millisecond;$735220c2d4774dd3$export$7555de1e070510cb(this);}return _createClass3($35ea8db9cb2ccb90$export$680ea196effce5f,[{key:"copy",value:function copy(){return new $35ea8db9cb2ccb90$export$680ea196effce5f(this.hour,this.minute,this.second,this.millisecond);}},{key:"add",value:function add(duration){return $735220c2d4774dd3$export$7ed87b6bc2506470(this,duration);}},{key:"subtract",value:function subtract(duration){return $735220c2d4774dd3$export$fe34d3a381cd7501(this,duration);}},{key:"set",value:function set(fields){return $735220c2d4774dd3$export$e5d5e1c1822b6e56(this,fields);}},{key:"cycle",value:function cycle(field,amount,options){return $735220c2d4774dd3$export$dd02b3e0007dfe28(this,field,amount,options);}},{key:"toString",value:function toString(){return $fae977aafc393c5c$export$f59dee82248f5ad4(this);}},{key:"compare",value:function compare(b2){return $14e0f24ef4ac5c92$export$c19a80a9721b80f6(this,b2);}}]);}();var $35ea8db9cb2ccb90$var$_type2=/* @__PURE__ */new WeakMap();var $35ea8db9cb2ccb90$export$ca871e8dbb80966f=/*#__PURE__*/function(){function $35ea8db9cb2ccb90$export$ca871e8dbb80966f(){_classCallCheck3(this,$35ea8db9cb2ccb90$export$ca871e8dbb80966f);_class_private_field_init(this,$35ea8db9cb2ccb90$var$_type2,{writable:true,value:void 0});for(var _len15=arguments.length,args=new Array(_len15),_key15=0;_key15<_len15;_key15++){args[_key15]=arguments[_key15];}var _$35ea8db9cb2ccb90$va3=$35ea8db9cb2ccb90$var$shiftArgs(args),_$35ea8db9cb2ccb90$va4=_slicedToArray(_$35ea8db9cb2ccb90$va3,5),calendar=_$35ea8db9cb2ccb90$va4[0],era=_$35ea8db9cb2ccb90$va4[1],year=_$35ea8db9cb2ccb90$va4[2],month=_$35ea8db9cb2ccb90$va4[3],day=_$35ea8db9cb2ccb90$va4[4];this.calendar=calendar;this.era=era;this.year=year;this.month=month;this.day=day;this.hour=args.shift()||0;this.minute=args.shift()||0;this.second=args.shift()||0;this.millisecond=args.shift()||0;$735220c2d4774dd3$export$c4e2ecac49351ef2(this);}return _createClass3($35ea8db9cb2ccb90$export$ca871e8dbb80966f,[{key:"copy",value:function copy(){if(this.era)return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(this.calendar,this.era,this.year,this.month,this.day,this.hour,this.minute,this.second,this.millisecond);else return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(this.calendar,this.year,this.month,this.day,this.hour,this.minute,this.second,this.millisecond);}},{key:"add",value:function add(duration){return $735220c2d4774dd3$export$e16d8520af44a096(this,duration);}},{key:"subtract",value:function subtract(duration){return $735220c2d4774dd3$export$4e2d2ead65e5f7e3(this,duration);}},{key:"set",value:function set(fields){return $735220c2d4774dd3$export$adaa4cf7ef1b65be($735220c2d4774dd3$export$e5d5e1c1822b6e56(this,fields),fields);}},{key:"cycle",value:function cycle(field,amount,options){switch(field){case"era":case"year":case"month":case"day":return $735220c2d4774dd3$export$d52ced6badfb9a4c(this,field,amount,options);default:return $735220c2d4774dd3$export$dd02b3e0007dfe28(this,field,amount,options);}}},{key:"toDate",value:function toDate(timeZone,disambiguation){return $11d87f3f76e88657$export$e67a095c620b86fe(this,timeZone,disambiguation);}},{key:"toString",value:function toString(){return $fae977aafc393c5c$export$4223de14708adc63(this);}},{key:"compare",value:function compare(b2){var res=$14e0f24ef4ac5c92$export$68781ddf31c0090f(this,b2);if(res===0)return $14e0f24ef4ac5c92$export$c19a80a9721b80f6(this,$11d87f3f76e88657$export$b21e0b124e224484(b2));return res;}}]);}();var $35ea8db9cb2ccb90$var$_type3=/* @__PURE__ */new WeakMap();var $35ea8db9cb2ccb90$export$d3b7288e7994edea=/*#__PURE__*/function(){function $35ea8db9cb2ccb90$export$d3b7288e7994edea(){_classCallCheck3(this,$35ea8db9cb2ccb90$export$d3b7288e7994edea);_class_private_field_init(this,$35ea8db9cb2ccb90$var$_type3,{writable:true,value:void 0});for(var _len16=arguments.length,args=new Array(_len16),_key16=0;_key16<_len16;_key16++){args[_key16]=arguments[_key16];}var _$35ea8db9cb2ccb90$va5=$35ea8db9cb2ccb90$var$shiftArgs(args),_$35ea8db9cb2ccb90$va6=_slicedToArray(_$35ea8db9cb2ccb90$va5,5),calendar=_$35ea8db9cb2ccb90$va6[0],era=_$35ea8db9cb2ccb90$va6[1],year=_$35ea8db9cb2ccb90$va6[2],month=_$35ea8db9cb2ccb90$va6[3],day=_$35ea8db9cb2ccb90$va6[4];var timeZone=args.shift();var offset2=args.shift();this.calendar=calendar;this.era=era;this.year=year;this.month=month;this.day=day;this.timeZone=timeZone;this.offset=offset2;this.hour=args.shift()||0;this.minute=args.shift()||0;this.second=args.shift()||0;this.millisecond=args.shift()||0;$735220c2d4774dd3$export$c4e2ecac49351ef2(this);}return _createClass3($35ea8db9cb2ccb90$export$d3b7288e7994edea,[{key:"copy",value:function copy(){if(this.era)return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(this.calendar,this.era,this.year,this.month,this.day,this.timeZone,this.offset,this.hour,this.minute,this.second,this.millisecond);else return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(this.calendar,this.year,this.month,this.day,this.timeZone,this.offset,this.hour,this.minute,this.second,this.millisecond);}},{key:"add",value:function add(duration){return $735220c2d4774dd3$export$96b1d28349274637(this,duration);}},{key:"subtract",value:function subtract(duration){return $735220c2d4774dd3$export$6814caac34ca03c7(this,duration);}},{key:"set",value:function set(fields,disambiguation){return $735220c2d4774dd3$export$31b5430eb18be4f8(this,fields,disambiguation);}},{key:"cycle",value:function cycle(field,amount,options){return $735220c2d4774dd3$export$9a297d111fc86b79(this,field,amount,options);}},{key:"toDate",value:function toDate(){return $11d87f3f76e88657$export$83aac07b4c37b25(this);}},{key:"toString",value:function toString(){return $fae977aafc393c5c$export$bf79f1ebf4b18792(this);}},{key:"toAbsoluteString",value:function toAbsoluteString(){return this.toDate().toISOString();}},{key:"compare",value:function compare(b2){return this.toDate().getTime()-$11d87f3f76e88657$export$84c95a83c799e074(b2,this.timeZone).toDate().getTime();}}]);}();var $62225008020f0a13$var$ERA_START_DATES=[[1868,9,8],[1912,7,30],[1926,12,25],[1989,1,8],[2019,5,1]];var $62225008020f0a13$var$ERA_END_DATES=[[1912,7,29],[1926,12,24],[1989,1,7],[2019,4,30]];var $62225008020f0a13$var$ERA_ADDENDS=[1867,1911,1925,1988,2018];var $62225008020f0a13$var$ERA_NAMES=["meiji","taisho","showa","heisei","reiwa"];function $62225008020f0a13$var$findEraFromGregorianDate(date){var idx=$62225008020f0a13$var$ERA_START_DATES.findIndex(function(_ref239){var _ref240=_slicedToArray(_ref239,3),year=_ref240[0],month=_ref240[1],day=_ref240[2];if(date.year<year)return true;if(date.year===year&&date.month<month)return true;if(date.year===year&&date.month===month&&date.day<day)return true;return false;});if(idx===-1)return $62225008020f0a13$var$ERA_START_DATES.length-1;if(idx===0)return 0;return idx-1;}function $62225008020f0a13$var$toGregorian(date){var eraAddend=$62225008020f0a13$var$ERA_ADDENDS[$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];if(!eraAddend)throw new Error("Unknown era: "+date.era);return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(date.year+eraAddend,date.month,date.day);}var $62225008020f0a13$export$b746ab2b60cdffbf=/*#__PURE__*/function(_$3b62074eb05584b2$ex3){function $62225008020f0a13$export$b746ab2b60cdffbf(){var _this14;_classCallCheck3(this,$62225008020f0a13$export$b746ab2b60cdffbf);for(var _len17=arguments.length,args=new Array(_len17),_key17=0;_key17<_len17;_key17++){args[_key17]=arguments[_key17];}_this14=_callSuper(this,$62225008020f0a13$export$b746ab2b60cdffbf,[].concat(args)),_this14.identifier="japanese";return _this14;}_inherits3($62225008020f0a13$export$b746ab2b60cdffbf,_$3b62074eb05584b2$ex3);return _createClass3($62225008020f0a13$export$b746ab2b60cdffbf,[{key:"fromJulianDay",value:function fromJulianDay(jd){var date=_superPropGet($62225008020f0a13$export$b746ab2b60cdffbf,"fromJulianDay",this,3)([jd]);var era=$62225008020f0a13$var$findEraFromGregorianDate(date);return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,$62225008020f0a13$var$ERA_NAMES[era],date.year-$62225008020f0a13$var$ERA_ADDENDS[era],date.month,date.day);}},{key:"toJulianDay",value:function toJulianDay(date){return _superPropGet($62225008020f0a13$export$b746ab2b60cdffbf,"toJulianDay",this,3)([$62225008020f0a13$var$toGregorian(date)]);}},{key:"balanceDate",value:function balanceDate(date){var gregorianDate=$62225008020f0a13$var$toGregorian(date);var era=$62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);if($62225008020f0a13$var$ERA_NAMES[era]!==date.era){date.era=$62225008020f0a13$var$ERA_NAMES[era];date.year=gregorianDate.year-$62225008020f0a13$var$ERA_ADDENDS[era];}this.constrainDate(date);}},{key:"constrainDate",value:function constrainDate(date){var idx=$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);var end2=$62225008020f0a13$var$ERA_END_DATES[idx];if(end2!=null){var _end=_slicedToArray(end2,3),endYear=_end[0],endMonth=_end[1],endDay=_end[2];var maxYear=endYear-$62225008020f0a13$var$ERA_ADDENDS[idx];date.year=Math.max(1,Math.min(maxYear,date.year));if(date.year===maxYear){date.month=Math.min(endMonth,date.month);if(date.month===endMonth)date.day=Math.min(endDay,date.day);}}if(date.year===1&&idx>=0){var _$62225008020f0a13$va=_slicedToArray($62225008020f0a13$var$ERA_START_DATES[idx],3),startMonth=_$62225008020f0a13$va[1],startDay=_$62225008020f0a13$va[2];date.month=Math.max(startMonth,date.month);if(date.month===startMonth)date.day=Math.max(startDay,date.day);}}},{key:"getEras",value:function getEras(){return $62225008020f0a13$var$ERA_NAMES;}},{key:"getYearsInEra",value:function getYearsInEra(date){var era=$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);var cur=$62225008020f0a13$var$ERA_START_DATES[era];var next=$62225008020f0a13$var$ERA_START_DATES[era+1];if(next==null)return 9999-cur[0]+1;var years=next[0]-cur[0];if(date.month<next[1]||date.month===next[1]&&date.day<next[2])years++;return years;}},{key:"getDaysInMonth",value:function getDaysInMonth(date){return _superPropGet($62225008020f0a13$export$b746ab2b60cdffbf,"getDaysInMonth",this,3)([$62225008020f0a13$var$toGregorian(date)]);}},{key:"getMinimumMonthInYear",value:function getMinimumMonthInYear(date){var start2=$62225008020f0a13$var$getMinimums(date);return start2?start2[1]:1;}},{key:"getMinimumDayInMonth",value:function getMinimumDayInMonth(date){var start2=$62225008020f0a13$var$getMinimums(date);return start2&&date.month===start2[1]?start2[2]:1;}}]);}($3b62074eb05584b2$export$80ee6245ec4f29ec);function $62225008020f0a13$var$getMinimums(date){if(date.year===1){var idx=$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);return $62225008020f0a13$var$ERA_START_DATES[idx];}}var $8d73d47422ca7302$var$BUDDHIST_ERA_START=-543;var $8d73d47422ca7302$export$42d20a78301dee44=/*#__PURE__*/function(_$3b62074eb05584b2$ex4){function $8d73d47422ca7302$export$42d20a78301dee44(){var _this15;_classCallCheck3(this,$8d73d47422ca7302$export$42d20a78301dee44);for(var _len18=arguments.length,args=new Array(_len18),_key18=0;_key18<_len18;_key18++){args[_key18]=arguments[_key18];}_this15=_callSuper(this,$8d73d47422ca7302$export$42d20a78301dee44,[].concat(args)),_this15.identifier="buddhist";return _this15;}_inherits3($8d73d47422ca7302$export$42d20a78301dee44,_$3b62074eb05584b2$ex4);return _createClass3($8d73d47422ca7302$export$42d20a78301dee44,[{key:"fromJulianDay",value:function fromJulianDay(jd){var gregorianDate=_superPropGet($8d73d47422ca7302$export$42d20a78301dee44,"fromJulianDay",this,3)([jd]);var year=$3b62074eb05584b2$export$c36e0ecb2d4fa69d(gregorianDate.era,gregorianDate.year);return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,year-$8d73d47422ca7302$var$BUDDHIST_ERA_START,gregorianDate.month,gregorianDate.day);}},{key:"toJulianDay",value:function toJulianDay(date){return _superPropGet($8d73d47422ca7302$export$42d20a78301dee44,"toJulianDay",this,3)([$8d73d47422ca7302$var$toGregorian(date)]);}},{key:"getEras",value:function getEras(){return["BE"];}},{key:"getDaysInMonth",value:function getDaysInMonth(date){return _superPropGet($8d73d47422ca7302$export$42d20a78301dee44,"getDaysInMonth",this,3)([$8d73d47422ca7302$var$toGregorian(date)]);}},{key:"balanceDate",value:function balanceDate(){}}]);}($3b62074eb05584b2$export$80ee6245ec4f29ec);function $8d73d47422ca7302$var$toGregorian(date){var _$3b62074eb05584b2$ex5=$3b62074eb05584b2$export$4475b7e617eb123c(date.year+$8d73d47422ca7302$var$BUDDHIST_ERA_START),_$3b62074eb05584b2$ex6=_slicedToArray(_$3b62074eb05584b2$ex5,2),era=_$3b62074eb05584b2$ex6[0],year=_$3b62074eb05584b2$ex6[1];return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(era,year,date.month,date.day);}var $5f31bd6f0c8940b2$var$TAIWAN_ERA_START=1911;function $5f31bd6f0c8940b2$var$gregorianYear(date){return date.era==="minguo"?date.year+$5f31bd6f0c8940b2$var$TAIWAN_ERA_START:1-date.year+$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;}function $5f31bd6f0c8940b2$var$gregorianToTaiwan(year){var y2=year-$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;if(y2>0)return["minguo",y2];else return["before_minguo",1-y2];}var $5f31bd6f0c8940b2$export$65e01080afcb0799=/*#__PURE__*/function(_$3b62074eb05584b2$ex7){function $5f31bd6f0c8940b2$export$65e01080afcb0799(){var _this16;_classCallCheck3(this,$5f31bd6f0c8940b2$export$65e01080afcb0799);for(var _len19=arguments.length,args=new Array(_len19),_key19=0;_key19<_len19;_key19++){args[_key19]=arguments[_key19];}_this16=_callSuper(this,$5f31bd6f0c8940b2$export$65e01080afcb0799,[].concat(args)),_this16.identifier="roc";return _this16;}_inherits3($5f31bd6f0c8940b2$export$65e01080afcb0799,_$3b62074eb05584b2$ex7);return _createClass3($5f31bd6f0c8940b2$export$65e01080afcb0799,[{key:"fromJulianDay",value:function fromJulianDay(jd){var date=_superPropGet($5f31bd6f0c8940b2$export$65e01080afcb0799,"fromJulianDay",this,3)([jd]);var extendedYear=$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era,date.year);var _$5f31bd6f0c8940b2$va=$5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear),_$5f31bd6f0c8940b2$va2=_slicedToArray(_$5f31bd6f0c8940b2$va,2),era=_$5f31bd6f0c8940b2$va2[0],year=_$5f31bd6f0c8940b2$va2[1];return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,era,year,date.month,date.day);}},{key:"toJulianDay",value:function toJulianDay(date){return _superPropGet($5f31bd6f0c8940b2$export$65e01080afcb0799,"toJulianDay",this,3)([$5f31bd6f0c8940b2$var$toGregorian(date)]);}},{key:"getEras",value:function getEras(){return["before_minguo","minguo"];}},{key:"balanceDate",value:function balanceDate(date){var _$5f31bd6f0c8940b2$va3=$5f31bd6f0c8940b2$var$gregorianToTaiwan($5f31bd6f0c8940b2$var$gregorianYear(date)),_$5f31bd6f0c8940b2$va4=_slicedToArray(_$5f31bd6f0c8940b2$va3,2),era=_$5f31bd6f0c8940b2$va4[0],year=_$5f31bd6f0c8940b2$va4[1];date.era=era;date.year=year;}},{key:"isInverseEra",value:function isInverseEra(date){return date.era==="before_minguo";}},{key:"getDaysInMonth",value:function getDaysInMonth(date){return _superPropGet($5f31bd6f0c8940b2$export$65e01080afcb0799,"getDaysInMonth",this,3)([$5f31bd6f0c8940b2$var$toGregorian(date)]);}},{key:"getYearsInEra",value:function getYearsInEra(date){return date.era==="before_minguo"?9999:9999-$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;}}]);}($3b62074eb05584b2$export$80ee6245ec4f29ec);function $5f31bd6f0c8940b2$var$toGregorian(date){var _$3b62074eb05584b2$ex8=$3b62074eb05584b2$export$4475b7e617eb123c($5f31bd6f0c8940b2$var$gregorianYear(date)),_$3b62074eb05584b2$ex9=_slicedToArray(_$3b62074eb05584b2$ex8,2),era=_$3b62074eb05584b2$ex9[0],year=_$3b62074eb05584b2$ex9[1];return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(era,year,date.month,date.day);}var $f3ed2e4472ae7e25$var$PERSIAN_EPOCH=1948320;var $f3ed2e4472ae7e25$var$MONTH_START=[0,31,62,93,124,155,186,216,246,276,306,336];var $f3ed2e4472ae7e25$export$37fccdbfd14c5939=/*#__PURE__*/function(){function $f3ed2e4472ae7e25$export$37fccdbfd14c5939(){_classCallCheck3(this,$f3ed2e4472ae7e25$export$37fccdbfd14c5939);this.identifier="persian";}return _createClass3($f3ed2e4472ae7e25$export$37fccdbfd14c5939,[{key:"fromJulianDay",value:function fromJulianDay(jd){var daysSinceEpoch=jd-$f3ed2e4472ae7e25$var$PERSIAN_EPOCH;var year=1+Math.floor((33*daysSinceEpoch+3)/12053);var farvardin1=365*(year-1)+Math.floor((8*year+21)/33);var dayOfYear=daysSinceEpoch-farvardin1;var month=dayOfYear<216?Math.floor(dayOfYear/31):Math.floor((dayOfYear-6)/30);var day=dayOfYear-$f3ed2e4472ae7e25$var$MONTH_START[month]+1;return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,year,month+1,day);}},{key:"toJulianDay",value:function toJulianDay(date){var jd=$f3ed2e4472ae7e25$var$PERSIAN_EPOCH-1+365*(date.year-1)+Math.floor((8*date.year+21)/33);jd+=$f3ed2e4472ae7e25$var$MONTH_START[date.month-1];jd+=date.day;return jd;}},{key:"getMonthsInYear",value:function getMonthsInYear(){return 12;}},{key:"getDaysInMonth",value:function getDaysInMonth(date){if(date.month<=6)return 31;if(date.month<=11)return 30;var isLeapYear=$2b4dce13dd5a17fa$export$842a2cf37af977e1(25*date.year+11,33)<8;return isLeapYear?30:29;}},{key:"getEras",value:function getEras(){return["AP"];}},{key:"getYearsInEra",value:function getYearsInEra(){return 9377;}}]);}();var $82c358003bdda0a8$var$INDIAN_ERA_START=78;var $82c358003bdda0a8$var$INDIAN_YEAR_START=80;var $82c358003bdda0a8$export$39f31c639fa15726=/*#__PURE__*/function(_$3b62074eb05584b2$ex0){function $82c358003bdda0a8$export$39f31c639fa15726(){var _this17;_classCallCheck3(this,$82c358003bdda0a8$export$39f31c639fa15726);for(var _len20=arguments.length,args=new Array(_len20),_key20=0;_key20<_len20;_key20++){args[_key20]=arguments[_key20];}_this17=_callSuper(this,$82c358003bdda0a8$export$39f31c639fa15726,[].concat(args)),_this17.identifier="indian";return _this17;}_inherits3($82c358003bdda0a8$export$39f31c639fa15726,_$3b62074eb05584b2$ex0);return _createClass3($82c358003bdda0a8$export$39f31c639fa15726,[{key:"fromJulianDay",value:function fromJulianDay(jd){var date=_superPropGet($82c358003bdda0a8$export$39f31c639fa15726,"fromJulianDay",this,3)([jd]);var indianYear=date.year-$82c358003bdda0a8$var$INDIAN_ERA_START;var yDay=jd-$3b62074eb05584b2$export$f297eb839006d339(date.era,date.year,1,1);var leapMonth;if(yDay<$82c358003bdda0a8$var$INDIAN_YEAR_START){indianYear--;leapMonth=$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year-1)?31:30;yDay+=leapMonth+155+90+10;}else{leapMonth=$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year)?31:30;yDay-=$82c358003bdda0a8$var$INDIAN_YEAR_START;}var indianMonth;var indianDay;if(yDay<leapMonth){indianMonth=1;indianDay=yDay+1;}else{var mDay=yDay-leapMonth;if(mDay<155){indianMonth=Math.floor(mDay/31)+2;indianDay=mDay%31+1;}else{mDay-=155;indianMonth=Math.floor(mDay/30)+7;indianDay=mDay%30+1;}}return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,indianYear,indianMonth,indianDay);}},{key:"toJulianDay",value:function toJulianDay(date){var extendedYear=date.year+$82c358003bdda0a8$var$INDIAN_ERA_START;var _$3b62074eb05584b2$ex1=$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear),_$3b62074eb05584b2$ex10=_slicedToArray(_$3b62074eb05584b2$ex1,2),era=_$3b62074eb05584b2$ex10[0],year=_$3b62074eb05584b2$ex10[1];var leapMonth;var jd;if($3b62074eb05584b2$export$553d7fa8e3805fc0(year)){leapMonth=31;jd=$3b62074eb05584b2$export$f297eb839006d339(era,year,3,21);}else{leapMonth=30;jd=$3b62074eb05584b2$export$f297eb839006d339(era,year,3,22);}if(date.month===1)return jd+date.day-1;jd+=leapMonth+Math.min(date.month-2,5)*31;if(date.month>=8)jd+=(date.month-7)*30;jd+=date.day-1;return jd;}},{key:"getDaysInMonth",value:function getDaysInMonth(date){if(date.month===1&&$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year+$82c358003bdda0a8$var$INDIAN_ERA_START))return 31;if(date.month>=2&&date.month<=6)return 31;return 30;}},{key:"getYearsInEra",value:function getYearsInEra(){return 9919;}},{key:"getEras",value:function getEras(){return["saka"];}},{key:"balanceDate",value:function balanceDate(){}}]);}($3b62074eb05584b2$export$80ee6245ec4f29ec);var $f2f3e0e3a817edbd$var$CIVIL_EPOC=1948440;var $f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC=1948439;var $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START=1300;var $f2f3e0e3a817edbd$var$UMALQURA_YEAR_END=1600;var $f2f3e0e3a817edbd$var$UMALQURA_START_DAYS=460322;function $f2f3e0e3a817edbd$var$islamicToJulianDay(epoch,year,month,day){return day+Math.ceil(29.5*(month-1))+(year-1)*354+Math.floor((3+11*year)/30)+epoch-1;}function $f2f3e0e3a817edbd$var$julianDayToIslamic(calendar,epoch,jd){var year=Math.floor((30*(jd-epoch)+10646)/10631);var month=Math.min(12,Math.ceil((jd-(29+$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch,year,1,1)))/29.5)+1);var day=jd-$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch,year,month,1)+1;return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(calendar,year,month,day);}function $f2f3e0e3a817edbd$var$isLeapYear(year){return(14+11*year)%30<11;}var $f2f3e0e3a817edbd$export$2066795aadd37bfc=/*#__PURE__*/function(){function $f2f3e0e3a817edbd$export$2066795aadd37bfc(){_classCallCheck3(this,$f2f3e0e3a817edbd$export$2066795aadd37bfc);this.identifier="islamic-civil";}return _createClass3($f2f3e0e3a817edbd$export$2066795aadd37bfc,[{key:"fromJulianDay",value:function fromJulianDay(jd){return $f2f3e0e3a817edbd$var$julianDayToIslamic(this,$f2f3e0e3a817edbd$var$CIVIL_EPOC,jd);}},{key:"toJulianDay",value:function toJulianDay(date){return $f2f3e0e3a817edbd$var$islamicToJulianDay($f2f3e0e3a817edbd$var$CIVIL_EPOC,date.year,date.month,date.day);}},{key:"getDaysInMonth",value:function getDaysInMonth(date){var length=29+date.month%2;if(date.month===12&&$f2f3e0e3a817edbd$var$isLeapYear(date.year))length++;return length;}},{key:"getMonthsInYear",value:function getMonthsInYear(){return 12;}},{key:"getDaysInYear",value:function getDaysInYear(date){return $f2f3e0e3a817edbd$var$isLeapYear(date.year)?355:354;}},{key:"getYearsInEra",value:function getYearsInEra(){return 9665;}},{key:"getEras",value:function getEras(){return["AH"];}}]);}();var $f2f3e0e3a817edbd$export$37f0887f2f9d22f7=/*#__PURE__*/function(_$f2f3e0e3a817edbd$ex){function $f2f3e0e3a817edbd$export$37f0887f2f9d22f7(){var _this18;_classCallCheck3(this,$f2f3e0e3a817edbd$export$37f0887f2f9d22f7);for(var _len21=arguments.length,args=new Array(_len21),_key21=0;_key21<_len21;_key21++){args[_key21]=arguments[_key21];}_this18=_callSuper(this,$f2f3e0e3a817edbd$export$37f0887f2f9d22f7,[].concat(args)),_this18.identifier="islamic-tbla";return _this18;}_inherits3($f2f3e0e3a817edbd$export$37f0887f2f9d22f7,_$f2f3e0e3a817edbd$ex);return _createClass3($f2f3e0e3a817edbd$export$37f0887f2f9d22f7,[{key:"fromJulianDay",value:function fromJulianDay(jd){return $f2f3e0e3a817edbd$var$julianDayToIslamic(this,$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC,jd);}},{key:"toJulianDay",value:function toJulianDay(date){return $f2f3e0e3a817edbd$var$islamicToJulianDay($f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC,date.year,date.month,date.day);}}]);}($f2f3e0e3a817edbd$export$2066795aadd37bfc);var $f2f3e0e3a817edbd$var$UMALQURA_DATA="qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";var $f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;var $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;function $f2f3e0e3a817edbd$var$umalquraYearStart(year){return $f2f3e0e3a817edbd$var$UMALQURA_START_DAYS+$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];}function $f2f3e0e3a817edbd$var$umalquraMonthLength(year,month){var idx=year-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;var mask=1<<11-(month-1);if(($f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx]&mask)===0)return 29;else return 30;}function $f2f3e0e3a817edbd$var$umalquraMonthStart(year,month){var day=$f2f3e0e3a817edbd$var$umalquraYearStart(year);for(var _i6=1;_i6<month;_i6++)day+=$f2f3e0e3a817edbd$var$umalquraMonthLength(year,_i6);return day;}function $f2f3e0e3a817edbd$var$umalquraYearLength(year){return $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year+1-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START]-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];}var $f2f3e0e3a817edbd$export$5baab4758c231076=/*#__PURE__*/function(_$f2f3e0e3a817edbd$ex2){function $f2f3e0e3a817edbd$export$5baab4758c231076(){var _this19;_classCallCheck3(this,$f2f3e0e3a817edbd$export$5baab4758c231076);_this19=_callSuper(this,$f2f3e0e3a817edbd$export$5baab4758c231076),_this19.identifier="islamic-umalqura";if(!$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH)$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH=new Uint16Array(Uint8Array.from(atob($f2f3e0e3a817edbd$var$UMALQURA_DATA),function(c2){return c2.charCodeAt(0);}).buffer);if(!$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE){$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE=new Uint32Array($f2f3e0e3a817edbd$var$UMALQURA_YEAR_END-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START+1);var yearStart=0;for(var year=$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;year<=$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END;year++){$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year-$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START]=yearStart;for(var _i7=1;_i7<=12;_i7++)yearStart+=$f2f3e0e3a817edbd$var$umalquraMonthLength(year,_i7);}}return _this19;}_inherits3($f2f3e0e3a817edbd$export$5baab4758c231076,_$f2f3e0e3a817edbd$ex2);return _createClass3($f2f3e0e3a817edbd$export$5baab4758c231076,[{key:"fromJulianDay",value:function fromJulianDay(jd){var days=jd-$f2f3e0e3a817edbd$var$CIVIL_EPOC;var startDays=$f2f3e0e3a817edbd$var$umalquraYearStart($f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);var endDays=$f2f3e0e3a817edbd$var$umalquraYearStart($f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);if(days<startDays||days>endDays)return _superPropGet($f2f3e0e3a817edbd$export$5baab4758c231076,"fromJulianDay",this,3)([jd]);else{var y2=$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START-1;var m2=1;var d2=1;while(d2>0){y2++;d2=days-$f2f3e0e3a817edbd$var$umalquraYearStart(y2)+1;var yearLength=$f2f3e0e3a817edbd$var$umalquraYearLength(y2);if(d2===yearLength){m2=12;break;}else if(d2<yearLength){var monthLength=$f2f3e0e3a817edbd$var$umalquraMonthLength(y2,m2);m2=1;while(d2>monthLength){d2-=monthLength;m2++;monthLength=$f2f3e0e3a817edbd$var$umalquraMonthLength(y2,m2);}break;}}return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,y2,m2,days-$f2f3e0e3a817edbd$var$umalquraMonthStart(y2,m2)+1);}}},{key:"toJulianDay",value:function toJulianDay(date){if(date.year<$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START||date.year>$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END)return _superPropGet($f2f3e0e3a817edbd$export$5baab4758c231076,"toJulianDay",this,3)([date]);return $f2f3e0e3a817edbd$var$CIVIL_EPOC+$f2f3e0e3a817edbd$var$umalquraMonthStart(date.year,date.month)+(date.day-1);}},{key:"getDaysInMonth",value:function getDaysInMonth(date){if(date.year<$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START||date.year>$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END)return _superPropGet($f2f3e0e3a817edbd$export$5baab4758c231076,"getDaysInMonth",this,3)([date]);return $f2f3e0e3a817edbd$var$umalquraMonthLength(date.year,date.month);}},{key:"getDaysInYear",value:function getDaysInYear(date){if(date.year<$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START||date.year>$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END)return _superPropGet($f2f3e0e3a817edbd$export$5baab4758c231076,"getDaysInYear",this,3)([date]);return $f2f3e0e3a817edbd$var$umalquraYearLength(date.year);}}]);}($f2f3e0e3a817edbd$export$2066795aadd37bfc);var $7c5f6fbf42389787$var$HEBREW_EPOCH=347997;var $7c5f6fbf42389787$var$HOUR_PARTS=1080;var $7c5f6fbf42389787$var$DAY_PARTS=24*$7c5f6fbf42389787$var$HOUR_PARTS;var $7c5f6fbf42389787$var$MONTH_DAYS=29;var $7c5f6fbf42389787$var$MONTH_FRACT=12*$7c5f6fbf42389787$var$HOUR_PARTS+793;var $7c5f6fbf42389787$var$MONTH_PARTS=$7c5f6fbf42389787$var$MONTH_DAYS*$7c5f6fbf42389787$var$DAY_PARTS+$7c5f6fbf42389787$var$MONTH_FRACT;function $7c5f6fbf42389787$var$isLeapYear(year){return $2b4dce13dd5a17fa$export$842a2cf37af977e1(year*7+1,19)<7;}function $7c5f6fbf42389787$var$hebrewDelay1(year){var months=Math.floor((235*year-234)/19);var parts=12084+13753*months;var day=months*29+Math.floor(parts/25920);if($2b4dce13dd5a17fa$export$842a2cf37af977e1(3*(day+1),7)<3)day+=1;return day;}function $7c5f6fbf42389787$var$hebrewDelay2(year){var last=$7c5f6fbf42389787$var$hebrewDelay1(year-1);var present=$7c5f6fbf42389787$var$hebrewDelay1(year);var next=$7c5f6fbf42389787$var$hebrewDelay1(year+1);if(next-present===356)return 2;if(present-last===382)return 1;return 0;}function $7c5f6fbf42389787$var$startOfYear(year){return $7c5f6fbf42389787$var$hebrewDelay1(year)+$7c5f6fbf42389787$var$hebrewDelay2(year);}function $7c5f6fbf42389787$var$getDaysInYear(year){return $7c5f6fbf42389787$var$startOfYear(year+1)-$7c5f6fbf42389787$var$startOfYear(year);}function $7c5f6fbf42389787$var$getYearType(year){var yearLength=$7c5f6fbf42389787$var$getDaysInYear(year);if(yearLength>380)yearLength-=30;switch(yearLength){case 353:return 0;case 354:return 1;case 355:return 2;}}function $7c5f6fbf42389787$var$getDaysInMonth(year,month){if(month>=6&&!$7c5f6fbf42389787$var$isLeapYear(year))month++;if(month===4||month===7||month===9||month===11||month===13)return 29;var yearType=$7c5f6fbf42389787$var$getYearType(year);if(month===2)return yearType===2?30:29;if(month===3)return yearType===0?29:30;if(month===6)return $7c5f6fbf42389787$var$isLeapYear(year)?30:0;return 30;}var $7c5f6fbf42389787$export$ca405048b8fb5af=/*#__PURE__*/function(){function $7c5f6fbf42389787$export$ca405048b8fb5af(){_classCallCheck3(this,$7c5f6fbf42389787$export$ca405048b8fb5af);this.identifier="hebrew";}return _createClass3($7c5f6fbf42389787$export$ca405048b8fb5af,[{key:"fromJulianDay",value:function fromJulianDay(jd){var d2=jd-$7c5f6fbf42389787$var$HEBREW_EPOCH;var m2=d2*$7c5f6fbf42389787$var$DAY_PARTS/$7c5f6fbf42389787$var$MONTH_PARTS;var year=Math.floor((19*m2+234)/235)+1;var ys=$7c5f6fbf42389787$var$startOfYear(year);var dayOfYear=Math.floor(d2-ys);while(dayOfYear<1){year--;ys=$7c5f6fbf42389787$var$startOfYear(year);dayOfYear=Math.floor(d2-ys);}var month=1;var monthStart=0;while(monthStart<dayOfYear){monthStart+=$7c5f6fbf42389787$var$getDaysInMonth(year,month);month++;}month--;monthStart-=$7c5f6fbf42389787$var$getDaysInMonth(year,month);var day=dayOfYear-monthStart;return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,year,month,day);}},{key:"toJulianDay",value:function toJulianDay(date){var jd=$7c5f6fbf42389787$var$startOfYear(date.year);for(var month=1;month<date.month;month++)jd+=$7c5f6fbf42389787$var$getDaysInMonth(date.year,month);return jd+date.day+$7c5f6fbf42389787$var$HEBREW_EPOCH;}},{key:"getDaysInMonth",value:function getDaysInMonth(date){return $7c5f6fbf42389787$var$getDaysInMonth(date.year,date.month);}},{key:"getMonthsInYear",value:function getMonthsInYear(date){return $7c5f6fbf42389787$var$isLeapYear(date.year)?13:12;}},{key:"getDaysInYear",value:function getDaysInYear(date){return $7c5f6fbf42389787$var$getDaysInYear(date.year);}},{key:"getYearsInEra",value:function getYearsInEra(){return 9999;}},{key:"getEras",value:function getEras(){return["AM"];}},{key:"balanceYearMonth",value:function balanceYearMonth(date,previousDate){if(previousDate.year!==date.year){if($7c5f6fbf42389787$var$isLeapYear(previousDate.year)&&!$7c5f6fbf42389787$var$isLeapYear(date.year)&&previousDate.month>6)date.month--;else if(!$7c5f6fbf42389787$var$isLeapYear(previousDate.year)&&$7c5f6fbf42389787$var$isLeapYear(date.year)&&previousDate.month>6)date.month++;}}}]);}();var $b956b2d7a6cf451f$var$ETHIOPIC_EPOCH=1723856;var $b956b2d7a6cf451f$var$COPTIC_EPOCH=1824665;var $b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA=5500;function $b956b2d7a6cf451f$var$ceToJulianDay(epoch,year,month,day){return epoch+365*year+Math.floor(year/4)+30*(month-1)+day-1;}function $b956b2d7a6cf451f$var$julianDayToCE(epoch,jd){var year=Math.floor(4*(jd-epoch)/1461);var month=1+Math.floor((jd-$b956b2d7a6cf451f$var$ceToJulianDay(epoch,year,1,1))/30);var day=jd+1-$b956b2d7a6cf451f$var$ceToJulianDay(epoch,year,month,1);return[year,month,day];}function $b956b2d7a6cf451f$var$getLeapDay(year){return Math.floor(year%4/3);}function $b956b2d7a6cf451f$var$getDaysInMonth(year,month){if(month%13!==0)return 30;else return $b956b2d7a6cf451f$var$getLeapDay(year)+5;}var $b956b2d7a6cf451f$export$26ba6eab5e20cd7d=/*#__PURE__*/function(){function $b956b2d7a6cf451f$export$26ba6eab5e20cd7d(){_classCallCheck3(this,$b956b2d7a6cf451f$export$26ba6eab5e20cd7d);this.identifier="ethiopic";}return _createClass3($b956b2d7a6cf451f$export$26ba6eab5e20cd7d,[{key:"fromJulianDay",value:function fromJulianDay(jd){var _$b956b2d7a6cf451f$va=$b956b2d7a6cf451f$var$julianDayToCE($b956b2d7a6cf451f$var$ETHIOPIC_EPOCH,jd),_$b956b2d7a6cf451f$va2=_slicedToArray(_$b956b2d7a6cf451f$va,3),year=_$b956b2d7a6cf451f$va2[0],month=_$b956b2d7a6cf451f$va2[1],day=_$b956b2d7a6cf451f$va2[2];var era="AM";if(year<=0){era="AA";year+=$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;}return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,era,year,month,day);}},{key:"toJulianDay",value:function toJulianDay(date){var year=date.year;if(date.era==="AA")year-=$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;return $b956b2d7a6cf451f$var$ceToJulianDay($b956b2d7a6cf451f$var$ETHIOPIC_EPOCH,year,date.month,date.day);}},{key:"getDaysInMonth",value:function getDaysInMonth(date){return $b956b2d7a6cf451f$var$getDaysInMonth(date.year,date.month);}},{key:"getMonthsInYear",value:function getMonthsInYear(){return 13;}},{key:"getDaysInYear",value:function getDaysInYear(date){return 365+$b956b2d7a6cf451f$var$getLeapDay(date.year);}},{key:"getYearsInEra",value:function getYearsInEra(date){return date.era==="AA"?9999:9991;}},{key:"getEras",value:function getEras(){return["AA","AM"];}}]);}();var $b956b2d7a6cf451f$export$d72e0c37005a4914=/*#__PURE__*/function(_$b956b2d7a6cf451f$ex){function $b956b2d7a6cf451f$export$d72e0c37005a4914(){var _this20;_classCallCheck3(this,$b956b2d7a6cf451f$export$d72e0c37005a4914);for(var _len22=arguments.length,args=new Array(_len22),_key22=0;_key22<_len22;_key22++){args[_key22]=arguments[_key22];}_this20=_callSuper(this,$b956b2d7a6cf451f$export$d72e0c37005a4914,[].concat(args)),_this20.identifier="ethioaa";return _this20;}_inherits3($b956b2d7a6cf451f$export$d72e0c37005a4914,_$b956b2d7a6cf451f$ex);return _createClass3($b956b2d7a6cf451f$export$d72e0c37005a4914,[{key:"fromJulianDay",value:function fromJulianDay(jd){var _$b956b2d7a6cf451f$va3=$b956b2d7a6cf451f$var$julianDayToCE($b956b2d7a6cf451f$var$ETHIOPIC_EPOCH,jd),_$b956b2d7a6cf451f$va4=_slicedToArray(_$b956b2d7a6cf451f$va3,3),year=_$b956b2d7a6cf451f$va4[0],month=_$b956b2d7a6cf451f$va4[1],day=_$b956b2d7a6cf451f$va4[2];year+=$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,"AA",year,month,day);}},{key:"getEras",value:function getEras(){return["AA"];}},{key:"getYearsInEra",value:function getYearsInEra(){return 9999;}}]);}($b956b2d7a6cf451f$export$26ba6eab5e20cd7d);var $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1=/*#__PURE__*/function(_$b956b2d7a6cf451f$ex2){function $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1(){var _this21;_classCallCheck3(this,$b956b2d7a6cf451f$export$fe6243cbe1a4b7c1);for(var _len23=arguments.length,args=new Array(_len23),_key23=0;_key23<_len23;_key23++){args[_key23]=arguments[_key23];}_this21=_callSuper(this,$b956b2d7a6cf451f$export$fe6243cbe1a4b7c1,[].concat(args)),_this21.identifier="coptic";return _this21;}_inherits3($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1,_$b956b2d7a6cf451f$ex2);return _createClass3($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1,[{key:"fromJulianDay",value:function fromJulianDay(jd){var _$b956b2d7a6cf451f$va5=$b956b2d7a6cf451f$var$julianDayToCE($b956b2d7a6cf451f$var$COPTIC_EPOCH,jd),_$b956b2d7a6cf451f$va6=_slicedToArray(_$b956b2d7a6cf451f$va5,3),year=_$b956b2d7a6cf451f$va6[0],month=_$b956b2d7a6cf451f$va6[1],day=_$b956b2d7a6cf451f$va6[2];var era="CE";if(year<=0){era="BCE";year=1-year;}return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this,era,year,month,day);}},{key:"toJulianDay",value:function toJulianDay(date){var year=date.year;if(date.era==="BCE")year=1-year;return $b956b2d7a6cf451f$var$ceToJulianDay($b956b2d7a6cf451f$var$COPTIC_EPOCH,year,date.month,date.day);}},{key:"getDaysInMonth",value:function getDaysInMonth(date){var year=date.year;if(date.era==="BCE")year=1-year;return $b956b2d7a6cf451f$var$getDaysInMonth(year,date.month);}},{key:"isInverseEra",value:function isInverseEra(date){return date.era==="BCE";}},{key:"balanceDate",value:function balanceDate(date){if(date.year<=0){date.era=date.era==="BCE"?"CE":"BCE";date.year=1-date.year;}}},{key:"getEras",value:function getEras(){return["BCE","CE"];}},{key:"getYearsInEra",value:function getYearsInEra(date){return date.era==="BCE"?9999:9715;}}]);}($b956b2d7a6cf451f$export$26ba6eab5e20cd7d);function $64244302c3013299$export$dd0bbc9b26defe37(name){switch(name){case"buddhist":return new $8d73d47422ca7302$export$42d20a78301dee44();case"ethiopic":return new $b956b2d7a6cf451f$export$26ba6eab5e20cd7d();case"ethioaa":return new $b956b2d7a6cf451f$export$d72e0c37005a4914();case"coptic":return new $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1();case"hebrew":return new $7c5f6fbf42389787$export$ca405048b8fb5af();case"indian":return new $82c358003bdda0a8$export$39f31c639fa15726();case"islamic-civil":return new $f2f3e0e3a817edbd$export$2066795aadd37bfc();case"islamic-tbla":return new $f2f3e0e3a817edbd$export$37f0887f2f9d22f7();case"islamic-umalqura":return new $f2f3e0e3a817edbd$export$5baab4758c231076();case"japanese":return new $62225008020f0a13$export$b746ab2b60cdffbf();case"persian":return new $f3ed2e4472ae7e25$export$37fccdbfd14c5939();case"roc":return new $5f31bd6f0c8940b2$export$65e01080afcb0799();case"gregory":default:return new $3b62074eb05584b2$export$80ee6245ec4f29ec();}}var $fb18d541ea1ad717$var$formatterCache=/* @__PURE__ */new Map();var $fb18d541ea1ad717$export$ad991b66133851cf=/*#__PURE__*/function(){function $fb18d541ea1ad717$export$ad991b66133851cf(locale){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_classCallCheck3(this,$fb18d541ea1ad717$export$ad991b66133851cf);this.formatter=$fb18d541ea1ad717$var$getCachedDateFormatter(locale,options);this.options=options;}return _createClass3($fb18d541ea1ad717$export$ad991b66133851cf,[{key:"format",value:function format(value){return this.formatter.format(value);}},{key:"formatToParts",value:function formatToParts(value){return this.formatter.formatToParts(value);}},{key:"formatRange",value:function formatRange(start2,end2){if(typeof this.formatter.formatRange==="function")return this.formatter.formatRange(start2,end2);if(end2<start2)throw new RangeError("End date must be >= start date");return"".concat(this.formatter.format(start2)," \u2013 ").concat(this.formatter.format(end2));}},{key:"formatRangeToParts",value:function formatRangeToParts(start2,end2){if(typeof this.formatter.formatRangeToParts==="function")return this.formatter.formatRangeToParts(start2,end2);if(end2<start2)throw new RangeError("End date must be >= start date");var startParts=this.formatter.formatToParts(start2);var endParts=this.formatter.formatToParts(end2);return[].concat(_toConsumableArray(startParts.map(function(p2){return __spreadProps(__spreadValues({},p2),{source:"startRange"});})),[{type:"literal",value:" \u2013 ",source:"shared"}],_toConsumableArray(endParts.map(function(p2){return __spreadProps(__spreadValues({},p2),{source:"endRange"});})));}},{key:"resolvedOptions",value:function resolvedOptions(){var resolvedOptions=this.formatter.resolvedOptions();if($fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()){if(!this.resolvedHourCycle)this.resolvedHourCycle=$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale,this.options);resolvedOptions.hourCycle=this.resolvedHourCycle;resolvedOptions.hour12=this.resolvedHourCycle==="h11"||this.resolvedHourCycle==="h12";}if(resolvedOptions.calendar==="ethiopic-amete-alem")resolvedOptions.calendar="ethioaa";return resolvedOptions;}}]);}();var $fb18d541ea1ad717$var$hour12Preferences={"true":{ja:"h11"},"false":{}};function $fb18d541ea1ad717$var$getCachedDateFormatter(locale){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(typeof options.hour12==="boolean"&&$fb18d541ea1ad717$var$hasBuggyHour12Behavior()){options=__spreadValues({},options);var pref=$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];var defaultHourCycle=options.hour12?"h12":"h23";options.hourCycle=pref!==null&&pref!==void 0?pref:defaultHourCycle;delete options.hour12;}var cacheKey=locale+(options?Object.entries(options).sort(function(a,b2){return a[0]<b2[0]?-1:1;}).join():"");if($fb18d541ea1ad717$var$formatterCache.has(cacheKey))return $fb18d541ea1ad717$var$formatterCache.get(cacheKey);var numberFormatter=new Intl.DateTimeFormat(locale,options);$fb18d541ea1ad717$var$formatterCache.set(cacheKey,numberFormatter);return numberFormatter;}var $fb18d541ea1ad717$var$_hasBuggyHour12Behavior=null;function $fb18d541ea1ad717$var$hasBuggyHour12Behavior(){if($fb18d541ea1ad717$var$_hasBuggyHour12Behavior==null)$fb18d541ea1ad717$var$_hasBuggyHour12Behavior=new Intl.DateTimeFormat("en-US",{hour:"numeric",hour12:false}).format(new Date(2020,2,3,0))==="24";return $fb18d541ea1ad717$var$_hasBuggyHour12Behavior;}var $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle=null;function $fb18d541ea1ad717$var$hasBuggyResolvedHourCycle(){if($fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle==null)$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle=new Intl.DateTimeFormat("fr",{hour:"numeric",hour12:false}).resolvedOptions().hourCycle==="h12";return $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;}function $fb18d541ea1ad717$var$getResolvedHourCycle(locale,options){if(!options.timeStyle&&!options.hour)return void 0;locale=locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/,"");locale+=(locale.includes("-u-")?"":"-u")+"-nu-latn";var formatter=$fb18d541ea1ad717$var$getCachedDateFormatter(locale,__spreadProps(__spreadValues({},options),{timeZone:void 0}));var min=parseInt(formatter.formatToParts(new Date(2020,2,3,0)).find(function(p2){return p2.type==="hour";}).value,10);var max=parseInt(formatter.formatToParts(new Date(2020,2,3,23)).find(function(p2){return p2.type==="hour";}).value,10);if(min===0&&max===23)return"h23";if(min===24&&max===23)return"h24";if(min===0&&max===11)return"h11";if(min===12&&max===11)return"h12";throw new Error("Unexpected hour cycle result");}function $896ba0a80a8f4d36$export$85fd5fdf27bacc79(options){options=$5a387cc49350e6db$export$722debc0e56fea39(options!==null&&options!==void 0?options:{},$896ba0a80a8f4d36$var$isEqual);var _$18f2051aff69b9bf$ex2=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex2.locale;return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $fb18d541ea1ad717$export$ad991b66133851cf(locale,options);},[locale,options]);}function $896ba0a80a8f4d36$var$isEqual(a,b2){if(a===b2)return true;var aKeys=Object.keys(a);var bKeys=Object.keys(b2);if(aKeys.length!==bKeys.length)return false;for(var _i8=0,_aKeys=aKeys;_i8<_aKeys.length;_i8++){var key2=_aKeys[_i8];if(b2[key2]!==a[key2])return false;}return true;}var $488c6ddbf4ef74c2$var$formatterCache=/* @__PURE__ */new Map();var $488c6ddbf4ef74c2$var$supportsSignDisplay=false;try{$488c6ddbf4ef74c2$var$supportsSignDisplay=new Intl.NumberFormat("de-DE",{signDisplay:"exceptZero"}).resolvedOptions().signDisplay==="exceptZero";}catch(_unused3){}var $488c6ddbf4ef74c2$var$supportsUnit=false;try{$488c6ddbf4ef74c2$var$supportsUnit=new Intl.NumberFormat("de-DE",{style:"unit",unit:"degree"}).resolvedOptions().style==="unit";}catch(_unused4){}var $488c6ddbf4ef74c2$var$UNITS={degree:{narrow:{"default":"\xB0","ja-JP":" \u5EA6","zh-TW":"\u5EA6","sl-SI":" \xB0"}}};var $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5=/*#__PURE__*/function(){function $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(locale){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_classCallCheck3(this,$488c6ddbf4ef74c2$export$cc77c4ff7e8673c5);this.numberFormatter=$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale,options);this.options=options;}return _createClass3($488c6ddbf4ef74c2$export$cc77c4ff7e8673c5,[{key:"format",value:function format(value){var res="";if(!$488c6ddbf4ef74c2$var$supportsSignDisplay&&this.options.signDisplay!=null)res=$488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter,this.options.signDisplay,value);else res=this.numberFormatter.format(value);if(this.options.style==="unit"&&!$488c6ddbf4ef74c2$var$supportsUnit){var _UNITS_unit;var _this$resolvedOptions=this.resolvedOptions(),unit=_this$resolvedOptions.unit,_this$resolvedOptions2=_this$resolvedOptions.unitDisplay,unitDisplay=_this$resolvedOptions2===void 0?"short":_this$resolvedOptions2,locale=_this$resolvedOptions.locale;if(!unit)return res;var values=(_UNITS_unit=$488c6ddbf4ef74c2$var$UNITS[unit])===null||_UNITS_unit===void 0?void 0:_UNITS_unit[unitDisplay];res+=values[locale]||values["default"];}return res;}},{key:"formatToParts",value:function formatToParts(value){return this.numberFormatter.formatToParts(value);}},{key:"formatRange",value:function formatRange(start2,end2){if(typeof this.numberFormatter.formatRange==="function")return this.numberFormatter.formatRange(start2,end2);if(end2<start2)throw new RangeError("End date must be >= start date");return"".concat(this.format(start2)," \u2013 ").concat(this.format(end2));}},{key:"formatRangeToParts",value:function formatRangeToParts(start2,end2){if(typeof this.numberFormatter.formatRangeToParts==="function")return this.numberFormatter.formatRangeToParts(start2,end2);if(end2<start2)throw new RangeError("End date must be >= start date");var startParts=this.numberFormatter.formatToParts(start2);var endParts=this.numberFormatter.formatToParts(end2);return[].concat(_toConsumableArray(startParts.map(function(p2){return __spreadProps(__spreadValues({},p2),{source:"startRange"});})),[{type:"literal",value:" \u2013 ",source:"shared"}],_toConsumableArray(endParts.map(function(p2){return __spreadProps(__spreadValues({},p2),{source:"endRange"});})));}},{key:"resolvedOptions",value:function resolvedOptions(){var options=this.numberFormatter.resolvedOptions();if(!$488c6ddbf4ef74c2$var$supportsSignDisplay&&this.options.signDisplay!=null)options=__spreadProps(__spreadValues({},options),{signDisplay:this.options.signDisplay});if(!$488c6ddbf4ef74c2$var$supportsUnit&&this.options.style==="unit")options=__spreadProps(__spreadValues({},options),{style:"unit",unit:this.options.unit,unitDisplay:this.options.unitDisplay});return options;}}]);}();function $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _options2=options,numberingSystem=_options2.numberingSystem;if(numberingSystem&&locale.includes("-nu-")){if(!locale.includes("-u-"))locale+="-u-";locale+="-nu-".concat(numberingSystem);}if(options.style==="unit"&&!$488c6ddbf4ef74c2$var$supportsUnit){var _UNITS_unit;var _options3=options,unit=_options3.unit,_options3$unitDisplay=_options3.unitDisplay,unitDisplay=_options3$unitDisplay===void 0?"short":_options3$unitDisplay;if(!unit)throw new Error('unit option must be provided with style: "unit"');if(!((_UNITS_unit=$488c6ddbf4ef74c2$var$UNITS[unit])===null||_UNITS_unit===void 0?void 0:_UNITS_unit[unitDisplay]))throw new Error("Unsupported unit ".concat(unit," with unitDisplay = ").concat(unitDisplay));options=__spreadProps(__spreadValues({},options),{style:"decimal"});}var cacheKey=locale+(options?Object.entries(options).sort(function(a,b2){return a[0]<b2[0]?-1:1;}).join():"");if($488c6ddbf4ef74c2$var$formatterCache.has(cacheKey))return $488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);var numberFormatter=new Intl.NumberFormat(locale,options);$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey,numberFormatter);return numberFormatter;}function $488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat,signDisplay,num){if(signDisplay==="auto")return numberFormat.format(num);else if(signDisplay==="never")return numberFormat.format(Math.abs(num));else{var needsPositiveSign=false;if(signDisplay==="always")needsPositiveSign=num>0||Object.is(num,0);else if(signDisplay==="exceptZero"){if(Object.is(num,-0)||Object.is(num,0))num=Math.abs(num);else needsPositiveSign=num>0;}if(needsPositiveSign){var negative=numberFormat.format(-num);var noSign=numberFormat.format(num);var minus=negative.replace(noSign,"").replace(/\u200e|\u061C/,"");if(_toConsumableArray(minus).length!==1)console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");var positive=negative.replace(noSign,"!!!").replace(minus,"+").replace("!!!",noSign);return positive;}else return numberFormat.format(num);}}var $6c7bd7858deea686$var$CURRENCY_SIGN_REGEX=new RegExp("^.*\\(.*\\).*$");var $6c7bd7858deea686$var$NUMBERING_SYSTEMS=["latn","arab","hanidec","deva","beng","fullwide"];var $6c7bd7858deea686$export$cd11ab140839f11d=/*#__PURE__*/function(){function $6c7bd7858deea686$export$cd11ab140839f11d(locale){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_classCallCheck3(this,$6c7bd7858deea686$export$cd11ab140839f11d);this.locale=locale;this.options=options;}return _createClass3($6c7bd7858deea686$export$cd11ab140839f11d,[{key:"parse",value:function parse(value){return $6c7bd7858deea686$var$getNumberParserImpl(this.locale,this.options,value).parse(value);}},{key:"isValidPartialNumber",value:function isValidPartialNumber(value,minValue,maxValue){return $6c7bd7858deea686$var$getNumberParserImpl(this.locale,this.options,value).isValidPartialNumber(value,minValue,maxValue);}},{key:"getNumberingSystem",value:function getNumberingSystem(value){return $6c7bd7858deea686$var$getNumberParserImpl(this.locale,this.options,value).options.numberingSystem;}}]);}();var $6c7bd7858deea686$var$numberParserCache=/* @__PURE__ */new Map();function $6c7bd7858deea686$var$getNumberParserImpl(locale,options,value){var defaultParser=$6c7bd7858deea686$var$getCachedNumberParser(locale,options);if(!locale.includes("-nu-")&&!defaultParser.isValidPartialNumber(value)){for(var _i9=0,_$6c7bd7858deea686$va=$6c7bd7858deea686$var$NUMBERING_SYSTEMS;_i9<_$6c7bd7858deea686$va.length;_i9++){var numberingSystem=_$6c7bd7858deea686$va[_i9];if(numberingSystem!==defaultParser.options.numberingSystem){var parser=$6c7bd7858deea686$var$getCachedNumberParser(locale+(locale.includes("-u-")?"-nu-":"-u-nu-")+numberingSystem,options);if(parser.isValidPartialNumber(value))return parser;}}}return defaultParser;}function $6c7bd7858deea686$var$getCachedNumberParser(locale,options){var cacheKey=locale+(options?Object.entries(options).sort(function(a,b2){return a[0]<b2[0]?-1:1;}).join():"");var parser=$6c7bd7858deea686$var$numberParserCache.get(cacheKey);if(!parser){parser=new $6c7bd7858deea686$var$NumberParserImpl(locale,options);$6c7bd7858deea686$var$numberParserCache.set(cacheKey,parser);}return parser;}var $6c7bd7858deea686$var$NumberParserImpl=/*#__PURE__*/function(){function $6c7bd7858deea686$var$NumberParserImpl(locale){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_classCallCheck3(this,$6c7bd7858deea686$var$NumberParserImpl);this.locale=locale;if(options.roundingIncrement!==1&&options.roundingIncrement!=null){if(options.maximumFractionDigits==null&&options.minimumFractionDigits==null){options.maximumFractionDigits=0;options.minimumFractionDigits=0;}else if(options.maximumFractionDigits==null)options.maximumFractionDigits=options.minimumFractionDigits;else if(options.minimumFractionDigits==null)options.minimumFractionDigits=options.maximumFractionDigits;}this.formatter=new Intl.NumberFormat(locale,options);this.options=this.formatter.resolvedOptions();this.symbols=$6c7bd7858deea686$var$getSymbols(locale,this.formatter,this.options,options);var _this_options_minimumFractionDigits,_this_options_maximumFractionDigits;if(this.options.style==="percent"&&(((_this_options_minimumFractionDigits=this.options.minimumFractionDigits)!==null&&_this_options_minimumFractionDigits!==void 0?_this_options_minimumFractionDigits:0)>18||((_this_options_maximumFractionDigits=this.options.maximumFractionDigits)!==null&&_this_options_maximumFractionDigits!==void 0?_this_options_maximumFractionDigits:0)>18))console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");}return _createClass3($6c7bd7858deea686$var$NumberParserImpl,[{key:"parse",value:function parse(value){var fullySanitizedValue=this.sanitize(value);if(this.symbols.group)fullySanitizedValue=$6c7bd7858deea686$var$replaceAll(fullySanitizedValue,this.symbols.group,"");if(this.symbols.decimal)fullySanitizedValue=fullySanitizedValue.replace(this.symbols.decimal,".");if(this.symbols.minusSign)fullySanitizedValue=fullySanitizedValue.replace(this.symbols.minusSign,"-");fullySanitizedValue=fullySanitizedValue.replace(this.symbols.numeral,this.symbols.index);if(this.options.style==="percent"){var isNegative=fullySanitizedValue.indexOf("-");fullySanitizedValue=fullySanitizedValue.replace("-","");fullySanitizedValue=fullySanitizedValue.replace("+","");var index2=fullySanitizedValue.indexOf(".");if(index2===-1)index2=fullySanitizedValue.length;fullySanitizedValue=fullySanitizedValue.replace(".","");if(index2-2===0)fullySanitizedValue="0.".concat(fullySanitizedValue);else if(index2-2===-1)fullySanitizedValue="0.0".concat(fullySanitizedValue);else if(index2-2===-2)fullySanitizedValue="0.00";else fullySanitizedValue="".concat(fullySanitizedValue.slice(0,index2-2),".").concat(fullySanitizedValue.slice(index2-2));if(isNegative>-1)fullySanitizedValue="-".concat(fullySanitizedValue);}var newValue=fullySanitizedValue?+fullySanitizedValue:NaN;if(isNaN(newValue))return NaN;if(this.options.style==="percent"){var _this_options_minimumFractionDigits,_this_options_maximumFractionDigits;var options=__spreadProps(__spreadValues({},this.options),{style:"decimal",minimumFractionDigits:Math.min(((_this_options_minimumFractionDigits=this.options.minimumFractionDigits)!==null&&_this_options_minimumFractionDigits!==void 0?_this_options_minimumFractionDigits:0)+2,20),maximumFractionDigits:Math.min(((_this_options_maximumFractionDigits=this.options.maximumFractionDigits)!==null&&_this_options_maximumFractionDigits!==void 0?_this_options_maximumFractionDigits:0)+2,20)});return new $6c7bd7858deea686$export$cd11ab140839f11d(this.locale,options).parse(new $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(this.locale,options).format(newValue));}if(this.options.currencySign==="accounting"&&$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value))newValue=-1*newValue;return newValue;}},{key:"sanitize",value:function sanitize(value){value=value.replace(this.symbols.literals,"");if(this.symbols.minusSign)value=value.replace("-",this.symbols.minusSign);if(this.options.numberingSystem==="arab"){if(this.symbols.decimal){value=value.replace(",",this.symbols.decimal);value=value.replace(String.fromCharCode(1548),this.symbols.decimal);}if(this.symbols.group)value=$6c7bd7858deea686$var$replaceAll(value,".",this.symbols.group);}if(this.symbols.group==="\u2019"&&value.includes("'"))value=$6c7bd7858deea686$var$replaceAll(value,"'",this.symbols.group);if(this.options.locale==="fr-FR"&&this.symbols.group){value=$6c7bd7858deea686$var$replaceAll(value," ",this.symbols.group);value=$6c7bd7858deea686$var$replaceAll(value,/\u00A0/g,this.symbols.group);}return value;}},{key:"isValidPartialNumber",value:function isValidPartialNumber(value){var minValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:-Infinity;var maxValue=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Infinity;value=this.sanitize(value);if(this.symbols.minusSign&&value.startsWith(this.symbols.minusSign)&&minValue<0)value=value.slice(this.symbols.minusSign.length);else if(this.symbols.plusSign&&value.startsWith(this.symbols.plusSign)&&maxValue>0)value=value.slice(this.symbols.plusSign.length);if(this.symbols.group&&value.startsWith(this.symbols.group))return false;if(this.symbols.decimal&&value.indexOf(this.symbols.decimal)>-1&&this.options.maximumFractionDigits===0)return false;if(this.symbols.group)value=$6c7bd7858deea686$var$replaceAll(value,this.symbols.group,"");value=value.replace(this.symbols.numeral,"");if(this.symbols.decimal)value=value.replace(this.symbols.decimal,"");return value.length===0;}}]);}();var $6c7bd7858deea686$var$nonLiteralParts=/* @__PURE__ */new Set(["decimal","fraction","integer","minusSign","plusSign","group"]);var $6c7bd7858deea686$var$pluralNumbers=[0,4,2,1,11,20,3,7,100,21,0.1,1.1];function $6c7bd7858deea686$var$getSymbols(locale,formatter,intlOptions,originalOptions){var _allParts_find,_posAllParts_find,_decimalParts_find,_allParts_find1;var symbolFormatter=new Intl.NumberFormat(locale,__spreadProps(__spreadValues({},intlOptions),{minimumSignificantDigits:1,maximumSignificantDigits:21,roundingIncrement:1,roundingPriority:"auto",roundingMode:"halfExpand"}));var allParts=symbolFormatter.formatToParts(-10000.111);var posAllParts=symbolFormatter.formatToParts(10000.111);var pluralParts=$6c7bd7858deea686$var$pluralNumbers.map(function(n2){return symbolFormatter.formatToParts(n2);});var _allParts_find_value;var minusSign=(_allParts_find_value=(_allParts_find=allParts.find(function(p2){return p2.type==="minusSign";}))===null||_allParts_find===void 0?void 0:_allParts_find.value)!==null&&_allParts_find_value!==void 0?_allParts_find_value:"-";var plusSign=(_posAllParts_find=posAllParts.find(function(p2){return p2.type==="plusSign";}))===null||_posAllParts_find===void 0?void 0:_posAllParts_find.value;if(!plusSign&&((originalOptions===null||originalOptions===void 0?void 0:originalOptions.signDisplay)==="exceptZero"||(originalOptions===null||originalOptions===void 0?void 0:originalOptions.signDisplay)==="always"))plusSign="+";var decimalParts=new Intl.NumberFormat(locale,__spreadProps(__spreadValues({},intlOptions),{minimumFractionDigits:2,maximumFractionDigits:2})).formatToParts(1e-3);var decimal=(_decimalParts_find=decimalParts.find(function(p2){return p2.type==="decimal";}))===null||_decimalParts_find===void 0?void 0:_decimalParts_find.value;var group=(_allParts_find1=allParts.find(function(p2){return p2.type==="group";}))===null||_allParts_find1===void 0?void 0:_allParts_find1.value;var allPartsLiterals=allParts.filter(function(p2){return!$6c7bd7858deea686$var$nonLiteralParts.has(p2.type);}).map(function(p2){return $6c7bd7858deea686$var$escapeRegex(p2.value);});var pluralPartsLiterals=pluralParts.flatMap(function(p2){return p2.filter(function(p3){return!$6c7bd7858deea686$var$nonLiteralParts.has(p3.type);}).map(function(p3){return $6c7bd7858deea686$var$escapeRegex(p3.value);});});var sortedLiterals=_toConsumableArray(/* @__PURE__ */new Set([].concat(_toConsumableArray(allPartsLiterals),_toConsumableArray(pluralPartsLiterals)))).sort(function(a,b2){return b2.length-a.length;});var literals=sortedLiterals.length===0?new RegExp("[\\p{White_Space}]","gu"):new RegExp("".concat(sortedLiterals.join("|"),"|[\\p{White_Space}]"),"gu");var numerals=_toConsumableArray(new Intl.NumberFormat(intlOptions.locale,{useGrouping:false}).format(9876543210)).reverse();var indexes=new Map(numerals.map(function(d2,i){return[d2,i];}));var numeral=new RegExp("[".concat(numerals.join(""),"]"),"g");var index2=function index2(d2){return String(indexes.get(d2));};return{minusSign:minusSign,plusSign:plusSign,decimal:decimal,group:group,literals:literals,numeral:numeral,index:index2};}function $6c7bd7858deea686$var$replaceAll(str,find,replace2){if(str.replaceAll)return str.replaceAll(find,replace2);return str.split(find).join(replace2);}function $6c7bd7858deea686$var$escapeRegex(string){return string.replace(/[.*+?^${}()|[\]\\]/g,"\\$&");}var $325a3faab7a68acd$var$cache=/* @__PURE__ */new Map();function $325a3faab7a68acd$export$a16aca283550c30d(options){var _$18f2051aff69b9bf$ex3=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex3.locale;var cacheKey=locale+(options?Object.entries(options).sort(function(a,b2){return a[0]<b2[0]?-1:1;}).join():"");if($325a3faab7a68acd$var$cache.has(cacheKey))return $325a3faab7a68acd$var$cache.get(cacheKey);var formatter=new Intl.Collator(locale,options);$325a3faab7a68acd$var$cache.set(cacheKey,formatter);return formatter;}function $bb77f239b46e8c72$export$3274cf84b703fff(options){var collator=$325a3faab7a68acd$export$a16aca283550c30d(__spreadValues({usage:"search"},options));var startsWith=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(string,substring){if(substring.length===0)return true;string=string.normalize("NFC");substring=substring.normalize("NFC");return collator.compare(string.slice(0,substring.length),substring)===0;},[collator]);var endsWith2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(string,substring){if(substring.length===0)return true;string=string.normalize("NFC");substring=substring.normalize("NFC");return collator.compare(string.slice(-substring.length),substring)===0;},[collator]);var contains2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(string,substring){if(substring.length===0)return true;string=string.normalize("NFC");substring=substring.normalize("NFC");var scan=0;var sliceLen=substring.length;for(;scan+sliceLen<=string.length;scan++){var slice=string.slice(scan,scan+sliceLen);if(collator.compare(substring,slice)===0)return true;}return false;},[collator]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{startsWith:startsWith,endsWith:endsWith2,contains:contains2};},[startsWith,endsWith2,contains2]);}function $701a24aa0da5b062$export$ea18c227d4417cc3(props,ref){var _props$elementType=props.elementType,elementType=_props$elementType===void 0?"button":_props$elementType,isDisabled=props.isDisabled,onPress=props.onPress,onPressStart=props.onPressStart,onPressEnd=props.onPressEnd,onPressUp=props.onPressUp,onPressChange=props.onPressChange,preventFocusOnPress=props.preventFocusOnPress,allowFocusWhenDisabled=props.allowFocusWhenDisabled,onClick=props.onClick,href=props.href,target=props.target,rel=props.rel,_props$type=props.type,type=_props$type===void 0?"button":_props$type;var additionalProps;if(elementType==="button")additionalProps={type:type,disabled:isDisabled,form:props.form,formAction:props.formAction,formEncType:props.formEncType,formMethod:props.formMethod,formNoValidate:props.formNoValidate,formTarget:props.formTarget,name:props.name,value:props.value};else additionalProps={role:"button",href:elementType==="a"&&!isDisabled?href:void 0,target:elementType==="a"?target:void 0,type:elementType==="input"?type:void 0,disabled:elementType==="input"?isDisabled:void 0,"aria-disabled":!isDisabled||elementType==="input"?void 0:isDisabled,rel:elementType==="a"?rel:void 0};var _$f6c31cce2adf654f$ex=$f6c31cce2adf654f$export$45712eceda6fad21({onPressStart:onPressStart,onPressEnd:onPressEnd,onPressChange:onPressChange,onPress:onPress,onPressUp:onPressUp,onClick:onClick,isDisabled:isDisabled,preventFocusOnPress:preventFocusOnPress,ref:ref}),pressProps=_$f6c31cce2adf654f$ex.pressProps,isPressed=_$f6c31cce2adf654f$ex.isPressed;var _$f645667febf57a63$ex=$f645667febf57a63$export$4c014de7c8940b4c(props,ref),focusableProps=_$f645667febf57a63$ex.focusableProps;if(allowFocusWhenDisabled)focusableProps.tabIndex=isDisabled?-1:focusableProps.tabIndex;var buttonProps=$3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps,pressProps,$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props,{labelable:true}));return{isPressed:isPressed,buttonProps:$3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps,buttonProps,{"aria-haspopup":props["aria-haspopup"],"aria-expanded":props["aria-expanded"],"aria-controls":props["aria-controls"],"aria-pressed":props["aria-pressed"],"aria-current":props["aria-current"],"aria-disabled":props["aria-disabled"]})};}var $9bf71ea28793e738$var$FocusContext=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);var $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT="react-aria-focus-scope-restore";var $9bf71ea28793e738$var$activeScope=null;function $9bf71ea28793e738$export$20e40289641fbbb6(props){var children=props.children,contain=props.contain,restoreFocus=props.restoreFocus,autoFocus=props.autoFocus;var startRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var endRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var scopeRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var _ref241=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($9bf71ea28793e738$var$FocusContext)||{},parentNode=_ref241.parentNode;var node=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $9bf71ea28793e738$var$TreeNode({scopeRef:scopeRef});},[scopeRef]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var parent=parentNode||$9bf71ea28793e738$export$d06fae2ee68b101e.root;if($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef)&&$9bf71ea28793e738$var$activeScope&&!$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope,parent.scopeRef)){var activeNode=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);if(activeNode)parent=activeNode;}parent.addChild(node);$9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);},[node,parentNode]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var node2=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);if(node2)node2.contain=!!contain;},[contain]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var _startRef_current;var node2=(_startRef_current=startRef.current)===null||_startRef_current===void 0?void 0:_startRef_current.nextSibling;var nodes=[];var stopPropagation=function stopPropagation(e2){return e2.stopPropagation();};while(node2&&node2!==endRef.current){nodes.push(node2);node2.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT,stopPropagation);node2=node2.nextSibling;}scopeRef.current=nodes;return function(){for(var _i0=0,_nodes=nodes;_i0<_nodes.length;_i0++){var node3=_nodes[_i0];node3.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT,stopPropagation);}};},[children]);$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef,restoreFocus,contain);$9bf71ea28793e738$var$useFocusContainment(scopeRef,contain);$9bf71ea28793e738$var$useRestoreFocus(scopeRef,restoreFocus,contain);$9bf71ea28793e738$var$useAutoFocus(scopeRef,autoFocus);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var activeElement=$d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current?scopeRef.current[0]:void 0));var scope=null;if($9bf71ea28793e738$var$isElementInScope(activeElement,scopeRef.current)){var _iterator11=_createForOfIteratorHelper($9bf71ea28793e738$export$d06fae2ee68b101e.traverse()),_step11;try{for(_iterator11.s();!(_step11=_iterator11.n()).done;){var node2=_step11.value;if(node2.scopeRef&&$9bf71ea28793e738$var$isElementInScope(activeElement,node2.scopeRef.current))scope=node2;}}catch(err){_iterator11.e(err);}finally{_iterator11.f();}if(scope===$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef))$9bf71ea28793e738$var$activeScope=scope.scopeRef;}},[scopeRef]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){return function(){var _focusScopeTree_getTreeNode_parent,_focusScopeTree_getTreeNode;var _focusScopeTree_getTreeNode_parent_scopeRef;var parentScope=(_focusScopeTree_getTreeNode_parent_scopeRef=(_focusScopeTree_getTreeNode=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef))===null||_focusScopeTree_getTreeNode===void 0?void 0:(_focusScopeTree_getTreeNode_parent=_focusScopeTree_getTreeNode.parent)===null||_focusScopeTree_getTreeNode_parent===void 0?void 0:_focusScopeTree_getTreeNode_parent.scopeRef)!==null&&_focusScopeTree_getTreeNode_parent_scopeRef!==void 0?_focusScopeTree_getTreeNode_parent_scopeRef:null;if((scopeRef===$9bf71ea28793e738$var$activeScope||$9bf71ea28793e738$var$isAncestorScope(scopeRef,$9bf71ea28793e738$var$activeScope))&&(!parentScope||$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope)))$9bf71ea28793e738$var$activeScope=parentScope;$9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);};},[scopeRef]);var focusManager=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);},[]);var value=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{focusManager:focusManager,parentNode:node};},[node,focusManager]);return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($9bf71ea28793e738$var$FocusContext.Provider,{value:value},/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"data-focus-scope-start":true,hidden:true,ref:startRef}),children,/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"data-focus-scope-end":true,hidden:true,ref:endRef}));}function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef){return{focusNext:function focusNext(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var scope=scopeRef.current;var from=opts.from,tabbable=opts.tabbable,wrap=opts.wrap,accept=opts.accept;var _scope_;var node=from||$d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac((_scope_=scope[0])!==null&&_scope_!==void 0?_scope_:void 0));var sentinel=scope[0].previousElementSibling;var scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope);var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:tabbable,accept:accept},scope);walker.currentNode=$9bf71ea28793e738$var$isElementInScope(node,scope)?node:sentinel;var nextNode=walker.nextNode();if(!nextNode&&wrap){walker.currentNode=sentinel;nextNode=walker.nextNode();}if(nextNode)$9bf71ea28793e738$var$focusElement(nextNode,true);return nextNode;},focusPrevious:function focusPrevious(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var scope=scopeRef.current;var from=opts.from,tabbable=opts.tabbable,wrap=opts.wrap,accept=opts.accept;var _scope_;var node=from||$d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac((_scope_=scope[0])!==null&&_scope_!==void 0?_scope_:void 0));var sentinel=scope[scope.length-1].nextElementSibling;var scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope);var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:tabbable,accept:accept},scope);walker.currentNode=$9bf71ea28793e738$var$isElementInScope(node,scope)?node:sentinel;var previousNode=walker.previousNode();if(!previousNode&&wrap){walker.currentNode=sentinel;previousNode=walker.previousNode();}if(previousNode)$9bf71ea28793e738$var$focusElement(previousNode,true);return previousNode;},focusFirst:function focusFirst(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var scope=scopeRef.current;var tabbable=opts.tabbable,accept=opts.accept;var scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope);var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:tabbable,accept:accept},scope);walker.currentNode=scope[0].previousElementSibling;var nextNode=walker.nextNode();if(nextNode)$9bf71ea28793e738$var$focusElement(nextNode,true);return nextNode;},focusLast:function focusLast(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var scope=scopeRef.current;var tabbable=opts.tabbable,accept=opts.accept;var scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope);var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:tabbable,accept:accept},scope);walker.currentNode=scope[scope.length-1].nextElementSibling;var previousNode=walker.previousNode();if(previousNode)$9bf71ea28793e738$var$focusElement(previousNode,true);return previousNode;}};}function $9bf71ea28793e738$var$getScopeRoot(scope){return scope[0].parentElement;}function $9bf71ea28793e738$var$shouldContainFocus(scopeRef){var scope=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);while(scope&&scope.scopeRef!==scopeRef){if(scope.contain)return false;scope=scope.parent;}return true;}function $9bf71ea28793e738$var$isTabbableRadio(element){if(element.checked)return true;var radios=[];if(!element.form)radios=_toConsumableArray($431fbd86ca7dc216$export$b204af158042fbac(element).querySelectorAll("input[type=\"radio\"][name=\"".concat(CSS.escape(element.name),"\"]"))).filter(function(radio){return!radio.form;});else{var _element_form_elements,_element_form;var radioList=(_element_form=element.form)===null||_element_form===void 0?void 0:(_element_form_elements=_element_form.elements)===null||_element_form_elements===void 0?void 0:_element_form_elements.namedItem(element.name);radios=_toConsumableArray(radioList!==null&&radioList!==void 0?radioList:[]);}if(!radios)return false;var anyChecked=radios.some(function(radio){return radio.checked;});return!anyChecked;}function $9bf71ea28793e738$var$useFocusContainment(scopeRef,contain){var focusedNode=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(void 0);var raf2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(void 0);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var scope=scopeRef.current;if(!contain){if(raf2.current){cancelAnimationFrame(raf2.current);raf2.current=void 0;}return;}var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(scope?scope[0]:void 0);var onKeyDown=function onKeyDown(e2){if(e2.key!=="Tab"||e2.altKey||e2.ctrlKey||e2.metaKey||!$9bf71ea28793e738$var$shouldContainFocus(scopeRef)||e2.isComposing)return;var focusedElement=$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);var scope2=scopeRef.current;if(!scope2||!$9bf71ea28793e738$var$isElementInScope(focusedElement,scope2))return;var scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope2);var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:true},scope2);if(!focusedElement)return;walker.currentNode=focusedElement;var nextElement=e2.shiftKey?walker.previousNode():walker.nextNode();if(!nextElement){walker.currentNode=e2.shiftKey?scope2[scope2.length-1].nextElementSibling:scope2[0].previousElementSibling;nextElement=e2.shiftKey?walker.previousNode():walker.nextNode();}e2.preventDefault();if(nextElement)$9bf71ea28793e738$var$focusElement(nextElement,true);};var onFocus=function onFocus(e2){if((!$9bf71ea28793e738$var$activeScope||$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope,scopeRef))&&$9bf71ea28793e738$var$isElementInScope($d4ee10de306f2510$export$e58f029f0fbfdb29(e2),scopeRef.current)){$9bf71ea28793e738$var$activeScope=scopeRef;focusedNode.current=$d4ee10de306f2510$export$e58f029f0fbfdb29(e2);}else if($9bf71ea28793e738$var$shouldContainFocus(scopeRef)&&!$9bf71ea28793e738$var$isElementInChildScope($d4ee10de306f2510$export$e58f029f0fbfdb29(e2),scopeRef)){if(focusedNode.current)focusedNode.current.focus();else if($9bf71ea28793e738$var$activeScope&&$9bf71ea28793e738$var$activeScope.current)$9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);}else if($9bf71ea28793e738$var$shouldContainFocus(scopeRef))focusedNode.current=$d4ee10de306f2510$export$e58f029f0fbfdb29(e2);};var onBlur=function onBlur(e2){if(raf2.current)cancelAnimationFrame(raf2.current);raf2.current=requestAnimationFrame(function(){var modality=$507fabe10e71c6fb$export$630ff653c5ada6a9();var shouldSkipFocusRestore=(modality==="virtual"||modality===null)&&$c87311424ea30a05$export$a11b0059900ceec8()&&$c87311424ea30a05$export$6446a186d09e379e();var activeElement=$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);if(!shouldSkipFocusRestore&&activeElement&&$9bf71ea28793e738$var$shouldContainFocus(scopeRef)&&!$9bf71ea28793e738$var$isElementInChildScope(activeElement,scopeRef)){$9bf71ea28793e738$var$activeScope=scopeRef;var target=$d4ee10de306f2510$export$e58f029f0fbfdb29(e2);if(target&&target.isConnected){var _focusedNode_current;focusedNode.current=target;(_focusedNode_current=focusedNode.current)===null||_focusedNode_current===void 0?void 0:_focusedNode_current.focus();}else if($9bf71ea28793e738$var$activeScope.current)$9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);}});};ownerDocument.addEventListener("keydown",onKeyDown,false);ownerDocument.addEventListener("focusin",onFocus,false);scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.addEventListener("focusin",onFocus,false);});scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.addEventListener("focusout",onBlur,false);});return function(){ownerDocument.removeEventListener("keydown",onKeyDown,false);ownerDocument.removeEventListener("focusin",onFocus,false);scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.removeEventListener("focusin",onFocus,false);});scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.removeEventListener("focusout",onBlur,false);});};},[scopeRef,contain]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){return function(){if(raf2.current)cancelAnimationFrame(raf2.current);};},[raf2]);}function $9bf71ea28793e738$var$isElementInAnyScope(element){return $9bf71ea28793e738$var$isElementInChildScope(element);}function $9bf71ea28793e738$var$isElementInScope(element,scope){if(!element)return false;if(!scope)return false;return scope.some(function(node){return node.contains(element);});}function $9bf71ea28793e738$var$isElementInChildScope(element){var scope=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;if(element instanceof Element&&element.closest("[data-react-aria-top-layer]"))return true;var _iterator12=_createForOfIteratorHelper($9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))),_step12;try{for(_iterator12.s();!(_step12=_iterator12.n()).done;){var s=_step12.value.scopeRef;if(s&&$9bf71ea28793e738$var$isElementInScope(element,s.current))return true;}}catch(err){_iterator12.e(err);}finally{_iterator12.f();}return false;}function $9bf71ea28793e738$export$1258395f99bf9cbf(element){return $9bf71ea28793e738$var$isElementInChildScope(element,$9bf71ea28793e738$var$activeScope);}function $9bf71ea28793e738$var$isAncestorScope(ancestor,scope){var _focusScopeTree_getTreeNode;var parent=(_focusScopeTree_getTreeNode=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))===null||_focusScopeTree_getTreeNode===void 0?void 0:_focusScopeTree_getTreeNode.parent;while(parent){if(parent.scopeRef===ancestor)return true;parent=parent.parent;}return false;}function $9bf71ea28793e738$var$focusElement(element){var scroll=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(element!=null&&!scroll)try{(0,$3ad3f6e1647bc98d$export$80f3e147d781571c)(element);}catch(_unused5){}else if(element!=null)try{element.focus();}catch(_unused6){}}function $9bf71ea28793e738$var$getFirstInScope(scope){var tabbable=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var sentinel=scope[0].previousElementSibling;var scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope);var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:tabbable},scope);walker.currentNode=sentinel;var nextNode=walker.nextNode();if(tabbable&&!nextNode){scopeRoot=$9bf71ea28793e738$var$getScopeRoot(scope);walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot,{tabbable:false},scope);walker.currentNode=sentinel;nextNode=walker.nextNode();}return nextNode;}function $9bf71ea28793e738$var$focusFirstInScope(scope){var tabbable=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;$9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(scope,tabbable));}function $9bf71ea28793e738$var$useAutoFocus(scopeRef,autoFocus){var autoFocusRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(autoFocus);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(autoFocusRef.current){$9bf71ea28793e738$var$activeScope=scopeRef;var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current?scopeRef.current[0]:void 0);if(!$9bf71ea28793e738$var$isElementInScope($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument),$9bf71ea28793e738$var$activeScope.current)&&scopeRef.current)$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);}autoFocusRef.current=false;},[scopeRef]);}function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef,restore,contain){$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){if(restore||contain)return;var scope=scopeRef.current;var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(scope?scope[0]:void 0);var onFocus=function onFocus(e2){var target=$d4ee10de306f2510$export$e58f029f0fbfdb29(e2);if($9bf71ea28793e738$var$isElementInScope(target,scopeRef.current))$9bf71ea28793e738$var$activeScope=scopeRef;else if(!$9bf71ea28793e738$var$isElementInAnyScope(target))$9bf71ea28793e738$var$activeScope=null;};ownerDocument.addEventListener("focusin",onFocus,false);scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.addEventListener("focusin",onFocus,false);});return function(){ownerDocument.removeEventListener("focusin",onFocus,false);scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.removeEventListener("focusin",onFocus,false);});};},[scopeRef,restore,contain]);}function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef){var scope=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);while(scope&&scope.scopeRef!==scopeRef){if(scope.nodeToRestore)return false;scope=scope.parent;}return(scope===null||scope===void 0?void 0:scope.scopeRef)===scopeRef;}function $9bf71ea28793e738$var$useRestoreFocus(scopeRef,restoreFocus,contain){var nodeToRestoreRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(typeof document!=="undefined"?$d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current?scopeRef.current[0]:void 0)):null);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var scope=scopeRef.current;var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(scope?scope[0]:void 0);if(!restoreFocus||contain)return;var onFocus=function onFocus(){if((!$9bf71ea28793e738$var$activeScope||$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope,scopeRef))&&$9bf71ea28793e738$var$isElementInScope($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument),scopeRef.current))$9bf71ea28793e738$var$activeScope=scopeRef;};ownerDocument.addEventListener("focusin",onFocus,false);scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.addEventListener("focusin",onFocus,false);});return function(){ownerDocument.removeEventListener("focusin",onFocus,false);scope===null||scope===void 0?void 0:scope.forEach(function(element){return element.removeEventListener("focusin",onFocus,false);});};},[scopeRef,contain]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current?scopeRef.current[0]:void 0);if(!restoreFocus)return;var onKeyDown=function onKeyDown(e2){if(e2.key!=="Tab"||e2.altKey||e2.ctrlKey||e2.metaKey||!$9bf71ea28793e738$var$shouldContainFocus(scopeRef)||e2.isComposing)return;var focusedElement=ownerDocument.activeElement;if(!$9bf71ea28793e738$var$isElementInChildScope(focusedElement,scopeRef)||!$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))return;var treeNode=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);if(!treeNode)return;var nodeToRestore=treeNode.nodeToRestore;var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body,{tabbable:true});walker.currentNode=focusedElement;var nextElement=e2.shiftKey?walker.previousNode():walker.nextNode();if(!nodeToRestore||!nodeToRestore.isConnected||nodeToRestore===ownerDocument.body){nodeToRestore=void 0;treeNode.nodeToRestore=void 0;}if((!nextElement||!$9bf71ea28793e738$var$isElementInChildScope(nextElement,scopeRef))&&nodeToRestore){walker.currentNode=nodeToRestore;do nextElement=e2.shiftKey?walker.previousNode():walker.nextNode();while($9bf71ea28793e738$var$isElementInChildScope(nextElement,scopeRef));e2.preventDefault();e2.stopPropagation();if(nextElement)$9bf71ea28793e738$var$focusElement(nextElement,true);else if(!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore))focusedElement.blur();else $9bf71ea28793e738$var$focusElement(nodeToRestore,true);}};if(!contain)ownerDocument.addEventListener("keydown",onKeyDown,true);return function(){if(!contain)ownerDocument.removeEventListener("keydown",onKeyDown,true);};},[scopeRef,restoreFocus,contain]);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var ownerDocument=$431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current?scopeRef.current[0]:void 0);if(!restoreFocus)return;var treeNode=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);if(!treeNode)return;var _nodeToRestoreRef_current;treeNode.nodeToRestore=(_nodeToRestoreRef_current=nodeToRestoreRef.current)!==null&&_nodeToRestoreRef_current!==void 0?_nodeToRestoreRef_current:void 0;return function(){var treeNode2=$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);if(!treeNode2)return;var nodeToRestore=treeNode2.nodeToRestore;var activeElement=$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);if(restoreFocus&&nodeToRestore&&(activeElement&&$9bf71ea28793e738$var$isElementInChildScope(activeElement,scopeRef)||activeElement===ownerDocument.body&&$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))){var clonedTree=$9bf71ea28793e738$export$d06fae2ee68b101e.clone();requestAnimationFrame(function(){if(ownerDocument.activeElement===ownerDocument.body){var treeNode3=clonedTree.getTreeNode(scopeRef);while(treeNode3){if(treeNode3.nodeToRestore&&treeNode3.nodeToRestore.isConnected){$9bf71ea28793e738$var$restoreFocusToElement(treeNode3.nodeToRestore);return;}treeNode3=treeNode3.parent;}treeNode3=clonedTree.getTreeNode(scopeRef);while(treeNode3){if(treeNode3.scopeRef&&treeNode3.scopeRef.current&&$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode3.scopeRef)){var node=$9bf71ea28793e738$var$getFirstInScope(treeNode3.scopeRef.current,true);$9bf71ea28793e738$var$restoreFocusToElement(node);return;}treeNode3=treeNode3.parent;}}});}};},[scopeRef,restoreFocus]);}function $9bf71ea28793e738$var$restoreFocusToElement(node){if(node.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT,{bubbles:true,cancelable:true})))$9bf71ea28793e738$var$focusElement(node);}function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root2,opts,scope){var filter=(opts===null||opts===void 0?void 0:opts.tabbable)?$b4b717babfbb907b$export$bebd5a1431fec25d:$b4b717babfbb907b$export$4c063cf1350e6fed;var rootElement=(root2===null||root2===void 0?void 0:root2.nodeType)===Node.ELEMENT_NODE?root2:null;var doc=$431fbd86ca7dc216$export$b204af158042fbac(rootElement);var walker=$dfc540311bf7f109$export$4d0f8be8b12a7ef6(doc,root2||doc,NodeFilter.SHOW_ELEMENT,{acceptNode:function acceptNode(node){var _opts_from;if(opts===null||opts===void 0?void 0:(_opts_from=opts.from)===null||_opts_from===void 0?void 0:_opts_from.contains(node))return NodeFilter.FILTER_REJECT;if((opts===null||opts===void 0?void 0:opts.tabbable)&&node.tagName==="INPUT"&&node.getAttribute("type")==="radio"){if(!$9bf71ea28793e738$var$isTabbableRadio(node))return NodeFilter.FILTER_REJECT;if(walker.currentNode.tagName==="INPUT"&&walker.currentNode.type==="radio"&&walker.currentNode.name===node.name)return NodeFilter.FILTER_REJECT;}if(filter(node)&&(!scope||$9bf71ea28793e738$var$isElementInScope(node,scope))&&(!(opts===null||opts===void 0?void 0:opts.accept)||opts.accept(node)))return NodeFilter.FILTER_ACCEPT;return NodeFilter.FILTER_SKIP;}});if(opts===null||opts===void 0?void 0:opts.from)walker.currentNode=opts.from;return walker;}function $9bf71ea28793e738$export$c5251b9e124bf29(ref){var defaultOptions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return{focusNext:function focusNext(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var root2=ref.current;if(!root2)return null;var from=opts.from,_opts$tabbable=opts.tabbable,tabbable=_opts$tabbable===void 0?defaultOptions.tabbable:_opts$tabbable,_opts$wrap=opts.wrap,wrap=_opts$wrap===void 0?defaultOptions.wrap:_opts$wrap,_opts$accept=opts.accept,accept=_opts$accept===void 0?defaultOptions.accept:_opts$accept;var node=from||$d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac(root2));var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(root2,{tabbable:tabbable,accept:accept});if(root2.contains(node))walker.currentNode=node;var nextNode=walker.nextNode();if(!nextNode&&wrap){walker.currentNode=root2;nextNode=walker.nextNode();}if(nextNode)$9bf71ea28793e738$var$focusElement(nextNode,true);return nextNode;},focusPrevious:function focusPrevious(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultOptions;var root2=ref.current;if(!root2)return null;var from=opts.from,_opts$tabbable2=opts.tabbable,tabbable=_opts$tabbable2===void 0?defaultOptions.tabbable:_opts$tabbable2,_opts$wrap2=opts.wrap,wrap=_opts$wrap2===void 0?defaultOptions.wrap:_opts$wrap2,_opts$accept2=opts.accept,accept=_opts$accept2===void 0?defaultOptions.accept:_opts$accept2;var node=from||$d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac(root2));var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(root2,{tabbable:tabbable,accept:accept});if(root2.contains(node))walker.currentNode=node;else{var next=$9bf71ea28793e738$var$last(walker);if(next)$9bf71ea28793e738$var$focusElement(next,true);return next!==null&&next!==void 0?next:null;}var previousNode=walker.previousNode();if(!previousNode&&wrap){walker.currentNode=root2;var lastNode=$9bf71ea28793e738$var$last(walker);if(!lastNode)return null;previousNode=lastNode;}if(previousNode)$9bf71ea28793e738$var$focusElement(previousNode,true);return previousNode!==null&&previousNode!==void 0?previousNode:null;},focusFirst:function focusFirst(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultOptions;var root2=ref.current;if(!root2)return null;var _opts$tabbable3=opts.tabbable,tabbable=_opts$tabbable3===void 0?defaultOptions.tabbable:_opts$tabbable3,_opts$accept3=opts.accept,accept=_opts$accept3===void 0?defaultOptions.accept:_opts$accept3;var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(root2,{tabbable:tabbable,accept:accept});var nextNode=walker.nextNode();if(nextNode)$9bf71ea28793e738$var$focusElement(nextNode,true);return nextNode;},focusLast:function focusLast(){var opts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultOptions;var root2=ref.current;if(!root2)return null;var _opts$tabbable4=opts.tabbable,tabbable=_opts$tabbable4===void 0?defaultOptions.tabbable:_opts$tabbable4,_opts$accept4=opts.accept,accept=_opts$accept4===void 0?defaultOptions.accept:_opts$accept4;var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(root2,{tabbable:tabbable,accept:accept});var next=$9bf71ea28793e738$var$last(walker);if(next)$9bf71ea28793e738$var$focusElement(next,true);return next!==null&&next!==void 0?next:null;}};}function $9bf71ea28793e738$var$last(walker){var next=void 0;var last;do{last=walker.lastChild();if(last)next=last;}while(last);return next;}var $9bf71ea28793e738$var$Tree=/*#__PURE__*/function(){function $9bf71ea28793e738$var$Tree(){_classCallCheck3(this,$9bf71ea28793e738$var$Tree);this.fastMap=/* @__PURE__ */new Map();this.root=new $9bf71ea28793e738$var$TreeNode({scopeRef:null});this.fastMap.set(null,this.root);}return _createClass3($9bf71ea28793e738$var$Tree,[{key:"size",get:function get(){return this.fastMap.size;}},{key:"getTreeNode",value:function getTreeNode(data){return this.fastMap.get(data);}},{key:"addTreeNode",value:function addTreeNode(scopeRef,parent,nodeToRestore){var parentNode=this.fastMap.get(parent!==null&&parent!==void 0?parent:null);if(!parentNode)return;var node=new $9bf71ea28793e738$var$TreeNode({scopeRef:scopeRef});parentNode.addChild(node);node.parent=parentNode;this.fastMap.set(scopeRef,node);if(nodeToRestore)node.nodeToRestore=nodeToRestore;}},{key:"addNode",value:function addNode(node){this.fastMap.set(node.scopeRef,node);}},{key:"removeTreeNode",value:function removeTreeNode(scopeRef){if(scopeRef===null)return;var node=this.fastMap.get(scopeRef);if(!node)return;var parentNode=node.parent;var _iterator13=_createForOfIteratorHelper(this.traverse()),_step13;try{for(_iterator13.s();!(_step13=_iterator13.n()).done;){var current=_step13.value;if(current!==node&&node.nodeToRestore&&current.nodeToRestore&&node.scopeRef&&node.scopeRef.current&&$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore,node.scopeRef.current))current.nodeToRestore=node.nodeToRestore;}}catch(err){_iterator13.e(err);}finally{_iterator13.f();}var children=node.children;if(parentNode){parentNode.removeChild(node);if(children.size>0)children.forEach(function(child){return parentNode&&parentNode.addChild(child);});}this.fastMap["delete"](node.scopeRef);}},{key:"traverse",value:function traverse(){var _this22=this;var node=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.root;return/*#__PURE__*/_regenerator().m(function _callee2(){var _iterator14,_step14,child,_t2;return _regenerator().w(function(_context2){while(1)switch(_context2.p=_context2.n){case 0:if(!(node.scopeRef!=null)){_context2.n=1;break;}_context2.n=1;return node;case 1:if(!(node.children.size>0)){_context2.n=8;break;}_iterator14=_createForOfIteratorHelper(node.children);_context2.p=2;_iterator14.s();case 3:if((_step14=_iterator14.n()).done){_context2.n=5;break;}child=_step14.value;return _context2.d(_regeneratorValues(_this22.traverse(child)),4);case 4:_context2.n=3;break;case 5:_context2.n=7;break;case 6:_context2.p=6;_t2=_context2.v;_iterator14.e(_t2);case 7:_context2.p=7;_iterator14.f();return _context2.f(7);case 8:return _context2.a(2);}},_callee2,null,[[2,6,7,8]]);})();}},{key:"clone",value:function clone(){var _node_parent;var newTree=new $9bf71ea28793e738$var$Tree();var _node_parent_scopeRef;var _iterator15=_createForOfIteratorHelper(this.traverse()),_step15;try{for(_iterator15.s();!(_step15=_iterator15.n()).done;){var node=_step15.value;newTree.addTreeNode(node.scopeRef,(_node_parent_scopeRef=(_node_parent=node.parent)===null||_node_parent===void 0?void 0:_node_parent.scopeRef)!==null&&_node_parent_scopeRef!==void 0?_node_parent_scopeRef:null,node.nodeToRestore);}}catch(err){_iterator15.e(err);}finally{_iterator15.f();}return newTree;}}]);}();var $9bf71ea28793e738$var$TreeNode=/*#__PURE__*/function(){function $9bf71ea28793e738$var$TreeNode(props){_classCallCheck3(this,$9bf71ea28793e738$var$TreeNode);this.children=/* @__PURE__ */new Set();this.contain=false;this.scopeRef=props.scopeRef;}return _createClass3($9bf71ea28793e738$var$TreeNode,[{key:"addChild",value:function addChild(node){this.children.add(node);node.parent=this;}},{key:"removeChild",value:function removeChild(node){this.children["delete"](node);node.parent=void 0;}}]);}();var $9bf71ea28793e738$export$d06fae2ee68b101e=new $9bf71ea28793e738$var$Tree();var $39324ace0d945f59$exports={};$39324ace0d945f59$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u0625\u0644\u0649 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," \u0627\u0644\u0645\u062D\u062F\u062F");},"finishRangeSelectionPrompt":"\u0627\u0646\u0642\u0631 \u0644\u0625\u0646\u0647\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E","maximumDate":"\u0622\u062E\u0631 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D","minimumDate":"\u0623\u0648\u0644 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D","next":"\u0627\u0644\u062A\u0627\u0644\u064A","previous":"\u0627\u0644\u0633\u0627\u0628\u0642","selectedDateDescription":function selectedDateDescription(args){return"\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u0627\u0646\u0642\u0631 \u0644\u0628\u062F\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E","todayDate":function todayDate(args){return"\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date," \u0645\u062D\u062F\u062F");}};var $1830a539e98c7baf$exports={};$1830a539e98c7baf$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u0434\u043E ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0435 ".concat(args.date);},"finishRangeSelectionPrompt":"\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0434\u043E\u0432\u044A\u0440\u0448\u0438\u0442\u0435 \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B","maximumDate":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430","minimumDate":"\u041F\u044A\u0440\u0432\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430","next":"\u041D\u0430\u043F\u0440\u0435\u0434","previous":"\u041D\u0430\u0437\u0430\u0434","selectedDateDescription":function selectedDateDescription(args){return"\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0438\u0441\u0442\u044A\u043F\u0438\u0442\u0435 \u043A\u044A\u043C \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B","todayDate":function todayDate(args){return"\u0414\u043D\u0435\u0441, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u0414\u043D\u0435\u0441, ".concat(args.date," \u0441\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438");}};var $f4b92528965aab97$exports={};$f4b92528965aab97$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," a\u017E ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"Vybr\xE1no ".concat(args.date);},"finishRangeSelectionPrompt":"Kliknut\xEDm dokon\u010D\xEDte v\xFDb\u011Br rozsahu dat","maximumDate":"Posledn\xED dostupn\xE9 datum","minimumDate":"Prvn\xED dostupn\xE9 datum","next":"Dal\u0161\xED","previous":"P\u0159edchoz\xED","selectedDateDescription":function selectedDateDescription(args){return"Vybran\xE9 datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Vybran\xE9 obdob\xED: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kliknut\xEDm zah\xE1j\xEDte v\xFDb\u011Br rozsahu dat","todayDate":function todayDate(args){return"Dnes, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Dnes, vybr\xE1no ".concat(args.date);}};var $1cd578ef0547c8f1$exports={};$1cd578ef0547c8f1$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," til ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," valgt");},"finishRangeSelectionPrompt":"Klik for at fuldf\xF8re valg af datoomr\xE5de","maximumDate":"Sidste ledige dato","minimumDate":"F\xF8rste ledige dato","next":"N\xE6ste","previous":"Forrige","selectedDateDescription":function selectedDateDescription(args){return"Valgt dato: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valgt interval: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Klik for at starte valg af datoomr\xE5de","todayDate":function todayDate(args){return"I dag, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"I dag, ".concat(args.date," valgt");}};var $db55a8973925d619$exports={};$db55a8973925d619$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," bis ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," ausgew\xE4hlt");},"finishRangeSelectionPrompt":"Klicken, um die Auswahl des Datumsbereichs zu beenden","maximumDate":"Letztes verf\xFCgbares Datum","minimumDate":"Erstes verf\xFCgbares Datum","next":"Weiter","previous":"Zur\xFCck","selectedDateDescription":function selectedDateDescription(args){return"Ausgew\xE4hltes Datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Ausgew\xE4hlter Bereich: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Klicken, um die Auswahl des Datumsbereichs zu beginnen","todayDate":function todayDate(args){return"Heute, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Heute, ".concat(args.date," ausgew\xE4hlt");}};var $ec6937d58566d443$exports={};$ec6937d58566d443$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u03AD\u03C9\u03C2 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5 ".concat(args.date);},"finishRangeSelectionPrompt":"\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03CD\u03C1\u03BF\u03C5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD","maximumDate":"\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","minimumDate":"\u03A0\u03C1\u03CE\u03C4\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","next":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF","previous":"\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF","selectedDateDescription":function selectedDateDescription(args){return"\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03CD\u03C1\u03BF\u03C5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD","todayDate":function todayDate(args){return"\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1, \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03C4\u03B7\u03BA\u03B5 ".concat(args.date);}};var $1f5cea0742dc284a$exports={};$1f5cea0742dc284a$exports={"previous":"Previous","next":"Next","selectedDateDescription":function selectedDateDescription(args){return"Selected Date: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Selected Range: ".concat(args.dateRange);},"todayDate":function todayDate(args){return"Today, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Today, ".concat(args.date," selected");},"dateSelected":function dateSelected(args){return"".concat(args.date," selected");},"startRangeSelectionPrompt":"Click to start selecting date range","finishRangeSelectionPrompt":"Click to finish selecting date range","minimumDate":"First available date","maximumDate":"Last available date","dateRange":function dateRange(args){return"".concat(args.startDate," to ").concat(args.endDate);}};var $2ca7ea366384817b$exports={};$2ca7ea366384817b$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," a ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," seleccionado");},"finishRangeSelectionPrompt":"Haga clic para terminar de seleccionar rango de fechas","maximumDate":"\xDAltima fecha disponible","minimumDate":"Primera fecha disponible","next":"Siguiente","previous":"Anterior","selectedDateDescription":function selectedDateDescription(args){return"Fecha seleccionada: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervalo seleccionado: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Haga clic para comenzar a seleccionar un rango de fechas","todayDate":function todayDate(args){return"Hoy, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Hoy, ".concat(args.date," seleccionado");}};var $97874a7fe9cd091f$exports={};$97874a7fe9cd091f$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," kuni ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," valitud");},"finishRangeSelectionPrompt":"Kl\xF5psake kuup\xE4evavahemiku valimise l\xF5petamiseks","maximumDate":"Viimane saadaolev kuup\xE4ev","minimumDate":"Esimene saadaolev kuup\xE4ev","next":"J\xE4rgmine","previous":"Eelmine","selectedDateDescription":function selectedDateDescription(args){return"Valitud kuup\xE4ev: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valitud vahemik: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kl\xF5psake kuup\xE4evavahemiku valimiseks","todayDate":function todayDate(args){return"T\xE4na, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"T\xE4na, ".concat(args.date," valitud");}};var $5d376b7fce1a45b2$exports={};$5d376b7fce1a45b2$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u2013 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," valittu");},"finishRangeSelectionPrompt":"Lopeta p\xE4iv\xE4m\xE4\xE4r\xE4alueen valinta napsauttamalla t\xE4t\xE4.","maximumDate":"Viimeinen varattavissa oleva p\xE4iv\xE4m\xE4\xE4r\xE4","minimumDate":"Ensimm\xE4inen varattavissa oleva p\xE4iv\xE4m\xE4\xE4r\xE4","next":"Seuraava","previous":"Edellinen","selectedDateDescription":function selectedDateDescription(args){return"Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valittu aikav\xE4li: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Aloita p\xE4iv\xE4m\xE4\xE4r\xE4alueen valinta napsauttamalla t\xE4t\xE4.","todayDate":function todayDate(args){return"T\xE4n\xE4\xE4n, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"T\xE4n\xE4\xE4n, ".concat(args.date," valittu");}};var $3bf722b362aaf54d$exports={};$3bf722b362aaf54d$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \xE0 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," s\xE9lectionn\xE9");},"finishRangeSelectionPrompt":"Cliquer pour finir de s\xE9lectionner la plage de dates","maximumDate":"Derni\xE8re date disponible","minimumDate":"Premi\xE8re date disponible","next":"Suivant","previous":"Pr\xE9c\xE9dent","selectedDateDescription":function selectedDateDescription(args){return"Date s\xE9lectionn\xE9e\xA0: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Plage s\xE9lectionn\xE9e\xA0: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Cliquer pour commencer \xE0 s\xE9lectionner la plage de dates","todayDate":function todayDate(args){return"Aujourd'hui, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Aujourd\u2019hui, ".concat(args.date," s\xE9lectionn\xE9");}};var $38c43f8322316031$exports={};$38c43f8322316031$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u05E2\u05D3 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," \u05E0\u05D1\u05D7\u05E8");},"finishRangeSelectionPrompt":"\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D9\u05D9\u05DD \u05D0\u05EA \u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD","maximumDate":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05D0\u05D7\u05E8\u05D5\u05DF","minimumDate":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05E8\u05D0\u05E9\u05D5\u05DF","next":"\u05D4\u05D1\u05D0","previous":"\u05D4\u05E7\u05D5\u05D3\u05DD","selectedDateDescription":function selectedDateDescription(args){return"\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05D1\u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD","todayDate":function todayDate(args){return"\u05D4\u05D9\u05D5\u05DD, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u05D4\u05D9\u05D5\u05DD, ".concat(args.date," \u05E0\u05D1\u05D7\u05E8");}};var $c90e0f32b44630bf$exports={};$c90e0f32b44630bf$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," do ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," odabran");},"finishRangeSelectionPrompt":"Kliknite da dovr\u0161ite raspon odabranih datuma","maximumDate":"Posljednji raspolo\u017Eivi datum","minimumDate":"Prvi raspolo\u017Eivi datum","next":"Sljede\u0107i","previous":"Prethodni","selectedDateDescription":function selectedDateDescription(args){return"Odabrani datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Odabrani raspon: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kliknite da zapo\u010Dnete raspon odabranih datuma","todayDate":function todayDate(args){return"Danas, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Danas, odabran ".concat(args.date);}};var $715875e6e7a338f4$exports={};$715875e6e7a338f4$exports={"dateRange":function dateRange(args){return"".concat(args.startDate,"\u2013").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," kiv\xE1lasztva");},"finishRangeSelectionPrompt":"Kattintson a d\xE1tumtartom\xE1ny kijel\xF6l\xE9s\xE9nek befejez\xE9s\xE9hez","maximumDate":"Utols\xF3 el\xE9rhet\u0151 d\xE1tum","minimumDate":"Az els\u0151 el\xE9rhet\u0151 d\xE1tum","next":"K\xF6vetkez\u0151","previous":"El\u0151z\u0151","selectedDateDescription":function selectedDateDescription(args){return"Kijel\xF6lt d\xE1tum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Kijel\xF6lt tartom\xE1ny: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kattintson a d\xE1tumtartom\xE1ny kijel\xF6l\xE9s\xE9nek ind\xEDt\xE1s\xE1hoz","todayDate":function todayDate(args){return"Ma, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Ma, ".concat(args.date," kijel\xF6lve");}};var $37d77c66e34daccf$exports={};$37d77c66e34daccf$exports={"dateRange":function dateRange(args){return"Da ".concat(args.startDate," a ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," selezionata");},"finishRangeSelectionPrompt":"Fai clic per completare la selezione dell\u2019intervallo di date","maximumDate":"Ultima data disponibile","minimumDate":"Prima data disponibile","next":"Successivo","previous":"Precedente","selectedDateDescription":function selectedDateDescription(args){return"Data selezionata: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervallo selezionato: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Fai clic per selezionare l\u2019intervallo di date","todayDate":function todayDate(args){return"Oggi, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Oggi, ".concat(args.date," selezionata");}};var $542f39aee29303c3$exports={};$542f39aee29303c3$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u304B\u3089 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," \u3092\u9078\u629E");},"finishRangeSelectionPrompt":"\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u7D42\u4E86","maximumDate":"\u6700\u7D42\u5229\u7528\u53EF\u80FD\u65E5","minimumDate":"\u6700\u521D\u306E\u5229\u7528\u53EF\u80FD\u65E5","next":"\u6B21\u3078","previous":"\u524D\u3078","selectedDateDescription":function selectedDateDescription(args){return"\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u9078\u629E\u7BC4\u56F2 : ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u958B\u59CB","todayDate":function todayDate(args){return"\u672C\u65E5\u3001".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u672C\u65E5\u3001".concat(args.date," \u3092\u9078\u629E");}};var $22a5f0623ea73e4f$exports={};$22a5f0623ea73e4f$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," ~ ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," \uC120\uD0DD\uB428");},"finishRangeSelectionPrompt":"\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC644\uB8CC\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.","maximumDate":"\uB9C8\uC9C0\uB9C9\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790","minimumDate":"\uCC98\uC74C\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790","next":"\uB2E4\uC74C","previous":"\uC774\uC804","selectedDateDescription":function selectedDateDescription(args){return"\uC120\uD0DD \uC77C\uC790: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\uC120\uD0DD \uBC94\uC704: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC2DC\uC791\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.","todayDate":function todayDate(args){return"\uC624\uB298, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\uC624\uB298, ".concat(args.date," \uC120\uD0DD\uB428");}};var $522380d13d62cba0$exports={};$522380d13d62cba0$exports={"dateRange":function dateRange(args){return"Nuo ".concat(args.startDate," iki ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"Pasirinkta ".concat(args.date);},"finishRangeSelectionPrompt":"Spustel\u0117kite, kad baigtum\u0117te pasirinkti dat\u0173 interval\u0105","maximumDate":"Paskutin\u0117 galima data","minimumDate":"Pirmoji galima data","next":"Paskesnis","previous":"Ankstesnis","selectedDateDescription":function selectedDateDescription(args){return"Pasirinkta data: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Pasirinktas intervalas: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Spustel\u0117kite, kad prad\u0117tum\u0117te pasirinkti dat\u0173 interval\u0105","todayDate":function todayDate(args){return"\u0160iandien, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u0160iandien, pasirinkta ".concat(args.date);}};var $8a7bc830b2fe6485$exports={};$8a7bc830b2fe6485$exports={"dateRange":function dateRange(args){return"No ".concat(args.startDate," l\u012Bdz ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"Atlas\u012Bts: ".concat(args.date);},"finishRangeSelectionPrompt":"Noklik\u0161\u0137iniet, lai pabeigtu datumu diapazona atlasi","maximumDate":"P\u0113d\u0113jais pieejamais datums","minimumDate":"Pirmais pieejamais datums","next":"T\u0101l\u0101k","previous":"Atpaka\u013C","selectedDateDescription":function selectedDateDescription(args){return"Atlas\u012Btais datums: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Atlas\u012Btais diapazons: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Noklik\u0161\u0137iniet, lai s\u0101ktu datumu diapazona atlasi","todayDate":function todayDate(args){return"\u0160odien, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Atlas\u012Bta \u0161odiena, ".concat(args.date);}};var $9fac9c044470683b$exports={};$9fac9c044470683b$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," til ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," valgt");},"finishRangeSelectionPrompt":"Klikk for \xE5 fullf\xF8re valg av datoomr\xE5de","maximumDate":"Siste tilgjengelige dato","minimumDate":"F\xF8rste tilgjengelige dato","next":"Neste","previous":"Forrige","selectedDateDescription":function selectedDateDescription(args){return"Valgt dato: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valgt omr\xE5de: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Klikk for \xE5 starte valg av datoomr\xE5de","todayDate":function todayDate(args){return"I dag, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"I dag, ".concat(args.date," valgt");}};var $b127d3569efb1449$exports={};$b127d3569efb1449$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," tot ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," geselecteerd");},"finishRangeSelectionPrompt":"Klik om de selectie van het datumbereik te voltooien","maximumDate":"Laatste beschikbare datum","minimumDate":"Eerste beschikbare datum","next":"Volgende","previous":"Vorige","selectedDateDescription":function selectedDateDescription(args){return"Geselecteerde datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Geselecteerd bereik: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Klik om het datumbereik te selecteren","todayDate":function todayDate(args){return"Vandaag, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Vandaag, ".concat(args.date," geselecteerd");}};var $51404a4090633490$exports={};$51404a4090633490$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," do ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"Wybrano ".concat(args.date);},"finishRangeSelectionPrompt":"Kliknij, aby zako\u0144czy\u0107 wyb\xF3r zakresu dat","maximumDate":"Ostatnia dost\u0119pna data","minimumDate":"Pierwsza dost\u0119pna data","next":"Dalej","previous":"Wstecz","selectedDateDescription":function selectedDateDescription(args){return"Wybrana data: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Wybrany zakres: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kliknij, aby rozpocz\u0105\u0107 wyb\xF3r zakresu dat","todayDate":function todayDate(args){return"Dzisiaj, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Dzisiaj wybrano ".concat(args.date);}};var $e5e6a3fe3b4527df$exports={};$e5e6a3fe3b4527df$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," a ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," selecionado");},"finishRangeSelectionPrompt":"Clique para concluir a sele\xE7\xE3o do intervalo de datas","maximumDate":"\xDAltima data dispon\xEDvel","minimumDate":"Primeira data dispon\xEDvel","next":"Pr\xF3ximo","previous":"Anterior","selectedDateDescription":function selectedDateDescription(args){return"Data selecionada: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervalo selecionado: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Clique para iniciar a sele\xE7\xE3o do intervalo de datas","todayDate":function todayDate(args){return"Hoje, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Hoje, ".concat(args.date," selecionado");}};var $c519dcadcbb1ee47$exports={};$c519dcadcbb1ee47$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," a ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," selecionado");},"finishRangeSelectionPrompt":"Clique para terminar de selecionar o intervalo de datas","maximumDate":"\xDAltima data dispon\xEDvel","minimumDate":"Primeira data dispon\xEDvel","next":"Pr\xF3ximo","previous":"Anterior","selectedDateDescription":function selectedDateDescription(args){return"Data selecionada: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervalo selecionado: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Clique para come\xE7ar a selecionar o intervalo de datas","todayDate":function todayDate(args){return"Hoje, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Hoje, ".concat(args.date," selecionado");}};var $e5aa0186ca7889c6$exports={};$e5aa0186ca7889c6$exports={"dateRange":function dateRange(args){return"De la ".concat(args.startDate," p\xE2n\u0103 la ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," selectat\u0103");},"finishRangeSelectionPrompt":"Ap\u0103sa\u0163i pentru a finaliza selec\u0163ia razei pentru dat\u0103","maximumDate":"Ultima dat\u0103 disponibil\u0103","minimumDate":"Prima dat\u0103 disponibil\u0103","next":"Urm\u0103torul","previous":"\xCEnainte","selectedDateDescription":function selectedDateDescription(args){return"Dat\u0103 selectat\u0103: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Interval selectat: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Ap\u0103sa\u0163i pentru a \xEEncepe selec\u0163ia razei pentru dat\u0103","todayDate":function todayDate(args){return"Ast\u0103zi, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Azi, ".concat(args.date," selectat\u0103");}};var $5b907f5fa3eee652$exports={};$5b907f5fa3eee652$exports={"dateRange":function dateRange(args){return"\u0421 ".concat(args.startDate," \u043F\u043E ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"\u0412\u044B\u0431\u0440\u0430\u043D\u043E ".concat(args.date);},"finishRangeSelectionPrompt":"\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0434\u0430\u0442","maximumDate":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0434\u0430\u0442\u0430","minimumDate":"\u041F\u0435\u0440\u0432\u0430\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0434\u0430\u0442\u0430","next":"\u0414\u0430\u043B\u0435\u0435","previous":"\u041D\u0430\u0437\u0430\u0434","selectedDateDescription":function selectedDateDescription(args){return"\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0434\u0430\u0442","todayDate":function todayDate(args){return"\u0421\u0435\u0433\u043E\u0434\u043D\u044F, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432\u044B\u0431\u0440\u0430\u043D\u043E ".concat(args.date);}};var $1b4c51359c99cf79$exports={};$1b4c51359c99cf79$exports={"dateRange":function dateRange(args){return"Od ".concat(args.startDate," do ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"Vybrat\xFD d\xE1tum ".concat(args.date);},"finishRangeSelectionPrompt":"Kliknut\xEDm dokon\u010D\xEDte v\xFDber rozsahu d\xE1tumov","maximumDate":"Posledn\xFD dostupn\xFD d\xE1tum","minimumDate":"Prv\xFD dostupn\xFD d\xE1tum","next":"Nasleduj\xFAce","previous":"Predch\xE1dzaj\xFAce","selectedDateDescription":function selectedDateDescription(args){return"Vybrat\xFD d\xE1tum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Vybrat\xFD rozsah: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kliknut\xEDm spust\xEDte v\xFDber rozsahu d\xE1tumov","todayDate":function todayDate(args){return"Dnes ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Vybrat\xFD dne\u0161n\xFD d\xE1tum ".concat(args.date);}};var $02e4e6a4608cc6f3$exports={};$02e4e6a4608cc6f3$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," do ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," izbrano");},"finishRangeSelectionPrompt":"Kliknite za dokon\u010Danje izbire datumskega obsega","maximumDate":"Zadnji razpolo\u017Eljivi datum","minimumDate":"Prvi razpolo\u017Eljivi datum","next":"Naprej","previous":"Nazaj","selectedDateDescription":function selectedDateDescription(args){return"Izbrani datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Izbrano obmo\u010Dje: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kliknite za za\u010Detek izbire datumskega obsega","todayDate":function todayDate(args){return"Danes, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Danes, ".concat(args.date," izbrano");}};var $6dd2fbaad93b6878$exports={};$6dd2fbaad93b6878$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," do ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," izabran");},"finishRangeSelectionPrompt":"Kliknite da dovr\u0161ite opseg izabranih datuma","maximumDate":"Zadnji raspolo\u017Eivi datum","minimumDate":"Prvi raspolo\u017Eivi datum","next":"Slede\u0107i","previous":"Prethodni","selectedDateDescription":function selectedDateDescription(args){return"Izabrani datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Izabrani period: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Kliknite da zapo\u010Dnete opseg izabranih datuma","todayDate":function todayDate(args){return"Danas, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Danas, izabran ".concat(args.date);}};var $33ea59bfe6e804e0$exports={};$33ea59bfe6e804e0$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," till ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," har valts");},"finishRangeSelectionPrompt":"Klicka f\xF6r att avsluta val av datumintervall","maximumDate":"Sista tillg\xE4ngliga datum","minimumDate":"F\xF6rsta tillg\xE4ngliga datum","next":"N\xE4sta","previous":"F\xF6reg\xE5ende","selectedDateDescription":function selectedDateDescription(args){return"Valt datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valt intervall: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Klicka f\xF6r att v\xE4lja datumintervall","todayDate":function todayDate(args){return"Idag, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Idag, ".concat(args.date," har valts");}};var $4603b0d0246969b2$exports={};$4603b0d0246969b2$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," - ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"".concat(args.date," se\xE7ildi");},"finishRangeSelectionPrompt":"Tarih aral\u0131\u011F\u0131 se\xE7imini tamamlamak i\xE7in t\u0131klay\u0131n","maximumDate":"Son m\xFCsait tarih","minimumDate":"\u0130lk m\xFCsait tarih","next":"Sonraki","previous":"\xD6nceki","selectedDateDescription":function selectedDateDescription(args){return"Se\xE7ilen Tarih: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Se\xE7ilen Aral\u0131k: ".concat(args.dateRange);},"startRangeSelectionPrompt":"Tarih aral\u0131\u011F\u0131 se\xE7imini ba\u015Flatmak i\xE7in t\u0131klay\u0131n","todayDate":function todayDate(args){return"Bug\xFCn, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"Bug\xFCn, ".concat(args.date," se\xE7ildi");}};var $82649816f530bb1b$exports={};$82649816f530bb1b$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u2014 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"\u0412\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date);},"finishRangeSelectionPrompt":"\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442","maximumDate":"\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430","minimumDate":"\u041F\u0435\u0440\u0448\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430","next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439","previous":"\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439","selectedDateDescription":function selectedDateDescription(args){return"\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);},"startRangeSelectionPrompt":"\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442","todayDate":function todayDate(args){return"\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, \u0432\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date);}};var $628e140a43dfb330$exports={};$628e140a43dfb330$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u81F3 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"\u5DF2\u9009\u62E9 ".concat(args.date);},"finishRangeSelectionPrompt":"\u5355\u51FB\u4EE5\u5B8C\u6210\u9009\u62E9\u65E5\u671F\u8303\u56F4","maximumDate":"\u6700\u540E\u4E00\u4E2A\u53EF\u7528\u65E5\u671F","minimumDate":"\u7B2C\u4E00\u4E2A\u53EF\u7528\u65E5\u671F","next":"\u4E0B\u4E00\u9875","previous":"\u4E0A\u4E00\u9875","selectedDateDescription":function selectedDateDescription(args){return"\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.dateRange);},"startRangeSelectionPrompt":"\u5355\u51FB\u4EE5\u5F00\u59CB\u9009\u62E9\u65E5\u671F\u8303\u56F4","todayDate":function todayDate(args){return"\u4ECA\u5929\uFF0C\u5373 ".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u5DF2\u9009\u62E9\u4ECA\u5929\uFF0C\u5373 ".concat(args.date);}};var $745937250cd4679c$exports={};$745937250cd4679c$exports={"dateRange":function dateRange(args){return"".concat(args.startDate," \u81F3 ").concat(args.endDate);},"dateSelected":function dateSelected(args){return"\u5DF2\u9078\u53D6 ".concat(args.date);},"finishRangeSelectionPrompt":"\u6309\u4E00\u4E0B\u4EE5\u5B8C\u6210\u9078\u53D6\u65E5\u671F\u7BC4\u570D","maximumDate":"\u6700\u5F8C\u4E00\u500B\u53EF\u7528\u65E5\u671F","minimumDate":"\u7B2C\u4E00\u500B\u53EF\u7528\u65E5\u671F","next":"\u4E0B\u4E00\u9801","previous":"\u4E0A\u4E00\u9801","selectedDateDescription":function selectedDateDescription(args){return"\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.dateRange);},"startRangeSelectionPrompt":"\u6309\u4E00\u4E0B\u4EE5\u958B\u59CB\u9078\u53D6\u65E5\u671F\u7BC4\u570D","todayDate":function todayDate(args){return"\u4ECA\u5929\uFF0C".concat(args.date);},"todayDateSelected":function todayDateSelected(args){return"\u5DF2\u9078\u53D6\u4ECA\u5929\uFF0C".concat(args.date);}};var $3904726b442bd9b2$exports={};$3904726b442bd9b2$exports={"ar-AE":$39324ace0d945f59$exports,"bg-BG":$1830a539e98c7baf$exports,"cs-CZ":$f4b92528965aab97$exports,"da-DK":$1cd578ef0547c8f1$exports,"de-DE":$db55a8973925d619$exports,"el-GR":$ec6937d58566d443$exports,"en-US":$1f5cea0742dc284a$exports,"es-ES":$2ca7ea366384817b$exports,"et-EE":$97874a7fe9cd091f$exports,"fi-FI":$5d376b7fce1a45b2$exports,"fr-FR":$3bf722b362aaf54d$exports,"he-IL":$38c43f8322316031$exports,"hr-HR":$c90e0f32b44630bf$exports,"hu-HU":$715875e6e7a338f4$exports,"it-IT":$37d77c66e34daccf$exports,"ja-JP":$542f39aee29303c3$exports,"ko-KR":$22a5f0623ea73e4f$exports,"lt-LT":$522380d13d62cba0$exports,"lv-LV":$8a7bc830b2fe6485$exports,"nb-NO":$9fac9c044470683b$exports,"nl-NL":$b127d3569efb1449$exports,"pl-PL":$51404a4090633490$exports,"pt-BR":$e5e6a3fe3b4527df$exports,"pt-PT":$c519dcadcbb1ee47$exports,"ro-RO":$e5aa0186ca7889c6$exports,"ru-RU":$5b907f5fa3eee652$exports,"sk-SK":$1b4c51359c99cf79$exports,"sl-SI":$02e4e6a4608cc6f3$exports,"sr-SP":$6dd2fbaad93b6878$exports,"sv-SE":$33ea59bfe6e804e0$exports,"tr-TR":$4603b0d0246969b2$exports,"uk-UA":$82649816f530bb1b$exports,"zh-CN":$628e140a43dfb330$exports,"zh-TW":$745937250cd4679c$exports};function $parcel$interopDefault$8(a){return a&&a.__esModule?a["default"]:a;}var $a074e1e2d0f0a665$export$653eddfc964b0f8a=/* @__PURE__ */new WeakMap();function $a074e1e2d0f0a665$export$134cbb7fb09a9522(date){return(date===null||date===void 0?void 0:date.calendar.identifier)==="gregory"&&date.era==="BC"?"short":void 0;}function $a074e1e2d0f0a665$export$b6df97c887c38e1a(state){var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$8($3904726b442bd9b2$exports),"@react-aria/calendar");var start2,end2;var _state_value;if("highlightedRange"in state){var _ref242=state.highlightedRange||{};start2=_ref242.start;end2=_ref242.end;}else start2=end2=(_state_value=state.value)!==null&&_state_value!==void 0?_state_value:void 0;var dateFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({weekday:"long",month:"long",year:"numeric",day:"numeric",era:$a074e1e2d0f0a665$export$134cbb7fb09a9522(start2)||$a074e1e2d0f0a665$export$134cbb7fb09a9522(end2),timeZone:state.timeZone});var anchorDate="anchorDate"in state?state.anchorDate:null;return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!anchorDate&&start2&&end2){if($14e0f24ef4ac5c92$export$ea39ec197993aef0(start2,end2)){var date=dateFormatter.format(start2.toDate(state.timeZone));return stringFormatter.format("selectedDateDescription",{date:date});}else{var dateRange=$a074e1e2d0f0a665$var$formatRange(dateFormatter,stringFormatter,start2,end2,state.timeZone);return stringFormatter.format("selectedRangeDescription",{dateRange:dateRange});}}return"";},[start2,end2,anchorDate,state.timeZone,stringFormatter,dateFormatter]);}function $a074e1e2d0f0a665$export$31afe65d91ef6e8(startDate,endDate,timeZone,isAria){var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$8($3904726b442bd9b2$exports),"@react-aria/calendar");var era=$a074e1e2d0f0a665$export$134cbb7fb09a9522(startDate)||$a074e1e2d0f0a665$export$134cbb7fb09a9522(endDate);var monthFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({month:"long",year:"numeric",era:era,calendar:startDate.calendar.identifier,timeZone:timeZone});var dateFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({month:"long",year:"numeric",day:"numeric",era:era,calendar:startDate.calendar.identifier,timeZone:timeZone});return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if($14e0f24ef4ac5c92$export$ea39ec197993aef0(startDate,$14e0f24ef4ac5c92$export$a5a3b454ada2268e(startDate))){var startMonth=startDate;var endMonth=endDate;if(startDate.calendar.getFormattableMonth)startMonth=startDate.calendar.getFormattableMonth(startDate);if(endDate.calendar.getFormattableMonth)endMonth=endDate.calendar.getFormattableMonth(endDate);if($14e0f24ef4ac5c92$export$ea39ec197993aef0(endDate,$14e0f24ef4ac5c92$export$a2258d9c4118825c(startDate)))return monthFormatter.format(startMonth.toDate(timeZone));else if($14e0f24ef4ac5c92$export$ea39ec197993aef0(endDate,$14e0f24ef4ac5c92$export$a2258d9c4118825c(endDate)))return isAria?$a074e1e2d0f0a665$var$formatRange(monthFormatter,stringFormatter,startMonth,endMonth,timeZone):monthFormatter.formatRange(startMonth.toDate(timeZone),endMonth.toDate(timeZone));}return isAria?$a074e1e2d0f0a665$var$formatRange(dateFormatter,stringFormatter,startDate,endDate,timeZone):dateFormatter.formatRange(startDate.toDate(timeZone),endDate.toDate(timeZone));},[startDate,endDate,monthFormatter,dateFormatter,stringFormatter,timeZone,isAria]);}function $a074e1e2d0f0a665$var$formatRange(dateFormatter,stringFormatter,start2,end2,timeZone){var parts=dateFormatter.formatRangeToParts(start2.toDate(timeZone),end2.toDate(timeZone));var separatorIndex=-1;for(var _i1=0;_i1<parts.length;_i1++){var part=parts[_i1];if(part.source==="shared"&&part.type==="literal")separatorIndex=_i1;else if(part.source==="endRange")break;}var startValue="";var endValue="";for(var _i10=0;_i10<parts.length;_i10++){if(_i10<separatorIndex)startValue+=parts[_i10].value;else if(_i10>separatorIndex)endValue+=parts[_i10].value;}return stringFormatter.format("dateRange",{startDate:startValue,endDate:endValue});}var $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY=7e3;var $319e236875307eab$var$liveAnnouncer=null;function $319e236875307eab$export$a9b970dcc4ae71a9(message){var assertiveness=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"assertive";var timeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;if(!$319e236875307eab$var$liveAnnouncer){$319e236875307eab$var$liveAnnouncer=new $319e236875307eab$var$LiveAnnouncer();if(!(typeof IS_REACT_ACT_ENVIRONMENT==="boolean"?IS_REACT_ACT_ENVIRONMENT:typeof jest!=="undefined"))setTimeout(function(){if($319e236875307eab$var$liveAnnouncer===null||$319e236875307eab$var$liveAnnouncer===void 0?void 0:$319e236875307eab$var$liveAnnouncer.isAttached())$319e236875307eab$var$liveAnnouncer===null||$319e236875307eab$var$liveAnnouncer===void 0?void 0:$319e236875307eab$var$liveAnnouncer.announce(message,assertiveness,timeout);},100);else $319e236875307eab$var$liveAnnouncer.announce(message,assertiveness,timeout);}else $319e236875307eab$var$liveAnnouncer.announce(message,assertiveness,timeout);}function $319e236875307eab$export$d10ae4f68404609a(assertiveness){if($319e236875307eab$var$liveAnnouncer)$319e236875307eab$var$liveAnnouncer.clear(assertiveness);}var $319e236875307eab$var$LiveAnnouncer=/*#__PURE__*/function(){function $319e236875307eab$var$LiveAnnouncer(){_classCallCheck3(this,$319e236875307eab$var$LiveAnnouncer);this.node=null;this.assertiveLog=null;this.politeLog=null;if(typeof document!=="undefined"){this.node=document.createElement("div");this.node.dataset.liveAnnouncer="true";Object.assign(this.node.style,{border:0,clip:"rect(0 0 0 0)",clipPath:"inset(50%)",height:"1px",margin:"-1px",overflow:"hidden",padding:0,position:"absolute",width:"1px",whiteSpace:"nowrap"});this.assertiveLog=this.createLog("assertive");this.node.appendChild(this.assertiveLog);this.politeLog=this.createLog("polite");this.node.appendChild(this.politeLog);document.body.prepend(this.node);}}return _createClass3($319e236875307eab$var$LiveAnnouncer,[{key:"isAttached",value:function isAttached(){var _this_node;return(_this_node=this.node)===null||_this_node===void 0?void 0:_this_node.isConnected;}},{key:"createLog",value:function createLog(ariaLive){var node=document.createElement("div");node.setAttribute("role","log");node.setAttribute("aria-live",ariaLive);node.setAttribute("aria-relevant","additions");return node;}},{key:"destroy",value:function destroy(){if(!this.node)return;document.body.removeChild(this.node);this.node=null;}},{key:"announce",value:function announce(message){var assertiveness=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"assertive";var timeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;var _this_assertiveLog,_this_politeLog;if(!this.node)return;var node=document.createElement("div");if(_typeof2(message)==="object"){node.setAttribute("role","img");node.setAttribute("aria-labelledby",message["aria-labelledby"]);}else node.textContent=message;if(assertiveness==="assertive")(_this_assertiveLog=this.assertiveLog)===null||_this_assertiveLog===void 0?void 0:_this_assertiveLog.appendChild(node);else(_this_politeLog=this.politeLog)===null||_this_politeLog===void 0?void 0:_this_politeLog.appendChild(node);if(message!=="")setTimeout(function(){node.remove();},timeout);}},{key:"clear",value:function clear(assertiveness){if(!this.node)return;if((!assertiveness||assertiveness==="assertive")&&this.assertiveLog)this.assertiveLog.innerHTML="";if((!assertiveness||assertiveness==="polite")&&this.politeLog)this.politeLog.innerHTML="";}}]);}();function $parcel$interopDefault$7(a){return a&&a.__esModule?a["default"]:a;}function $c4acc1de3ab169cf$export$d652b3ea2d672d5b(props,state){var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$7($3904726b442bd9b2$exports),"@react-aria/calendar");var domProps=$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);var title=$a074e1e2d0f0a665$export$31afe65d91ef6e8(state.visibleRange.start,state.visibleRange.end,state.timeZone,false);var visibleRangeDescription=$a074e1e2d0f0a665$export$31afe65d91ef6e8(state.visibleRange.start,state.visibleRange.end,state.timeZone,true);$4f58c5f72bcf79f7$export$496315a1608d9602(function(){if(!state.isFocused)$319e236875307eab$export$a9b970dcc4ae71a9(visibleRangeDescription);},[visibleRangeDescription]);var selectedDateDescription=$a074e1e2d0f0a665$export$b6df97c887c38e1a(state);$4f58c5f72bcf79f7$export$496315a1608d9602(function(){if(selectedDateDescription)$319e236875307eab$export$a9b970dcc4ae71a9(selectedDateDescription,"polite",4e3);},[selectedDateDescription]);var errorMessageId=$bdb11010cef70236$export$b4cc09c592e8fdb8([Boolean(props.errorMessage),props.isInvalid,props.validationState]);$a074e1e2d0f0a665$export$653eddfc964b0f8a.set(state,{ariaLabel:props["aria-label"],ariaLabelledBy:props["aria-labelledby"],errorMessageId:errorMessageId,selectedDateDescription:selectedDateDescription});var _useState41=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState42=_slicedToArray(_useState41,2),nextFocused=_useState42[0],setNextFocused=_useState42[1];var nextDisabled=props.isDisabled||state.isNextVisibleRangeInvalid();if(nextDisabled&&nextFocused){setNextFocused(false);state.setFocused(true);}var _useState43=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState44=_slicedToArray(_useState43,2),previousFocused=_useState44[0],setPreviousFocused=_useState44[1];var previousDisabled=props.isDisabled||state.isPreviousVisibleRangeInvalid();if(previousDisabled&&previousFocused){setPreviousFocused(false);state.setFocused(true);}var labelProps=$313b98861ee5dd6c$export$d6875122194c7b44({id:props["id"],"aria-label":[props["aria-label"],visibleRangeDescription].filter(Boolean).join(", "),"aria-labelledby":props["aria-labelledby"]});return{calendarProps:$3ef42575df84b30b$export$9d1611c77c2fe928(domProps,labelProps,{role:"application","aria-details":props["aria-details"]||void 0,"aria-describedby":props["aria-describedby"]||void 0}),nextButtonProps:{onPress:function onPress(){return state.focusNextPage();},"aria-label":stringFormatter.format("next"),isDisabled:nextDisabled,onFocusChange:setNextFocused},prevButtonProps:{onPress:function onPress(){return state.focusPreviousPage();},"aria-label":stringFormatter.format("previous"),isDisabled:previousDisabled,onFocusChange:setPreviousFocused},errorMessageProps:{id:errorMessageId},title:title};}function $9942cad8a072a530$export$3ee915f8151bd4f1(props,state){return $c4acc1de3ab169cf$export$d652b3ea2d672d5b(props,state);}function $e3031d1f8c9d64eb$export$cb95147730a423f5(props,state){var _props$startDate=props.startDate,startDate=_props$startDate===void 0?state.visibleRange.start:_props$startDate,_props$endDate=props.endDate,endDate=_props$endDate===void 0?state.visibleRange.end:_props$endDate,firstDayOfWeek=props.firstDayOfWeek;var _$18f2051aff69b9bf$ex4=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),direction=_$18f2051aff69b9bf$ex4.direction;var onKeyDown=function onKeyDown(e2){switch(e2.key){case"Enter":case" ":e2.preventDefault();state.selectFocusedDate();break;case"PageUp":e2.preventDefault();e2.stopPropagation();state.focusPreviousSection(e2.shiftKey);break;case"PageDown":e2.preventDefault();e2.stopPropagation();state.focusNextSection(e2.shiftKey);break;case"End":e2.preventDefault();e2.stopPropagation();state.focusSectionEnd();break;case"Home":e2.preventDefault();e2.stopPropagation();state.focusSectionStart();break;case"ArrowLeft":e2.preventDefault();e2.stopPropagation();if(direction==="rtl")state.focusNextDay();else state.focusPreviousDay();break;case"ArrowUp":e2.preventDefault();e2.stopPropagation();state.focusPreviousRow();break;case"ArrowRight":e2.preventDefault();e2.stopPropagation();if(direction==="rtl")state.focusPreviousDay();else state.focusNextDay();break;case"ArrowDown":e2.preventDefault();e2.stopPropagation();state.focusNextRow();break;case"Escape":if("setAnchorDate"in state){e2.preventDefault();state.setAnchorDate(null);}break;}};var visibleRangeDescription=$a074e1e2d0f0a665$export$31afe65d91ef6e8(startDate,endDate,state.timeZone,true);var _$a074e1e2d0f0a665$ex=$a074e1e2d0f0a665$export$653eddfc964b0f8a.get(state),ariaLabel=_$a074e1e2d0f0a665$ex.ariaLabel,ariaLabelledBy=_$a074e1e2d0f0a665$ex.ariaLabelledBy;var labelProps=$313b98861ee5dd6c$export$d6875122194c7b44({"aria-label":[ariaLabel,visibleRangeDescription].filter(Boolean).join(", "),"aria-labelledby":ariaLabelledBy});var dayFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({weekday:props.weekdayStyle||"narrow",timeZone:state.timeZone});var _$18f2051aff69b9bf$ex5=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex5.locale;var weekDays=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var weekStart=$14e0f24ef4ac5c92$export$42c81a444fbfb5d4($14e0f24ef4ac5c92$export$d0bdf45af03a6ea3(state.timeZone),locale,firstDayOfWeek);return _toConsumableArray(new Array(7).keys()).map(function(index2){var date=weekStart.add({days:index2});var dateDay=date.toDate(state.timeZone);return dayFormatter.format(dateDay);});},[locale,state.timeZone,dayFormatter,firstDayOfWeek]);var weeksInMonth=$14e0f24ef4ac5c92$export$ccc1b2479e7dd654(startDate,locale,firstDayOfWeek);return{gridProps:$3ef42575df84b30b$export$9d1611c77c2fe928(labelProps,{role:"grid","aria-readonly":state.isReadOnly||void 0,"aria-disabled":state.isDisabled||void 0,"aria-multiselectable":"highlightedRange"in state||void 0,onKeyDown:onKeyDown,onFocus:function onFocus(){return state.setFocused(true);},onBlur:function onBlur(){return state.setFocused(false);}}),headerProps:{"aria-hidden":true},weekDays:weekDays,weeksInMonth:weeksInMonth};}function $parcel$interopDefault$6(a){return a&&a.__esModule?a["default"]:a;}function $36a0ac60f04457c5$export$136073280381448e(props,state,ref){var date=props.date,isDisabled=props.isDisabled;var _$a074e1e2d0f0a665$ex2=$a074e1e2d0f0a665$export$653eddfc964b0f8a.get(state),errorMessageId=_$a074e1e2d0f0a665$ex2.errorMessageId,selectedDateDescription=_$a074e1e2d0f0a665$ex2.selectedDateDescription;var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$6($3904726b442bd9b2$exports),"@react-aria/calendar");var dateFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({weekday:"long",day:"numeric",month:"long",year:"numeric",era:$a074e1e2d0f0a665$export$134cbb7fb09a9522(date),timeZone:state.timeZone});var isSelected=state.isSelected(date);var isFocused=state.isCellFocused(date)&&!props.isOutsideMonth;isDisabled=isDisabled||state.isCellDisabled(date);var isUnavailable=state.isCellUnavailable(date);var isSelectable=!isDisabled&&!isUnavailable;var isInvalid=state.isValueInvalid&&Boolean("highlightedRange"in state?!state.anchorDate&&state.highlightedRange&&date.compare(state.highlightedRange.start)>=0&&date.compare(state.highlightedRange.end)<=0:state.value&&$14e0f24ef4ac5c92$export$ea39ec197993aef0(state.value,date));if(isInvalid)isSelected=true;date=$5a387cc49350e6db$export$722debc0e56fea39(date,$14e0f24ef4ac5c92$export$91b62ebf2ba703ee);var nativeDate=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return date.toDate(state.timeZone);},[date,state.timeZone]);var isDateToday=$14e0f24ef4ac5c92$export$629b0a497aa65267(date,state.timeZone);var label=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var label2="";if("highlightedRange"in state&&state.value&&!state.anchorDate&&($14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.value.start)||$14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.value.end)))label2=selectedDateDescription+", ";label2+=dateFormatter.format(nativeDate);if(isDateToday)label2=stringFormatter.format(isSelected?"todayDateSelected":"todayDate",{date:label2});else if(isSelected)label2=stringFormatter.format("dateSelected",{date:label2});if(state.minValue&&$14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.minValue))label2+=", "+stringFormatter.format("minimumDate");else if(state.maxValue&&$14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.maxValue))label2+=", "+stringFormatter.format("maximumDate");return label2;},[dateFormatter,nativeDate,stringFormatter,isSelected,isDateToday,date,state,selectedDateDescription]);var rangeSelectionPrompt="";if("anchorDate"in state&&isFocused&&!state.isReadOnly&&isSelectable){if(state.anchorDate)rangeSelectionPrompt=stringFormatter.format("finishRangeSelectionPrompt");else rangeSelectionPrompt=stringFormatter.format("startRangeSelectionPrompt");}var descriptionProps=$ef06256079686ba0$export$f8aeda7b10753fa1(rangeSelectionPrompt);var isAnchorPressed=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);var isRangeBoundaryPressed=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);var touchDragTimerRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(void 0);var _$f6c31cce2adf654f$ex2=$f6c31cce2adf654f$export$45712eceda6fad21({shouldCancelOnPointerExit:"anchorDate"in state&&!!state.anchorDate,preventFocusOnPress:true,isDisabled:!isSelectable||state.isReadOnly,onPressStart:function onPressStart(e2){if(state.isReadOnly){state.setFocusedDate(date);return;}if("highlightedRange"in state&&!state.anchorDate&&(e2.pointerType==="mouse"||e2.pointerType==="touch")){if(state.highlightedRange&&!isInvalid){if($14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.highlightedRange.start)){state.setAnchorDate(state.highlightedRange.end);state.setFocusedDate(date);state.setDragging(true);isRangeBoundaryPressed.current=true;return;}else if($14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.highlightedRange.end)){state.setAnchorDate(state.highlightedRange.start);state.setFocusedDate(date);state.setDragging(true);isRangeBoundaryPressed.current=true;return;}}var startDragging=function startDragging(){state.setDragging(true);touchDragTimerRef.current=void 0;state.selectDate(date);state.setFocusedDate(date);isAnchorPressed.current=true;};if(e2.pointerType==="touch")touchDragTimerRef.current=setTimeout(startDragging,200);else startDragging();}},onPressEnd:function onPressEnd(){isRangeBoundaryPressed.current=false;isAnchorPressed.current=false;clearTimeout(touchDragTimerRef.current);touchDragTimerRef.current=void 0;},onPress:function onPress(){if(!("anchorDate"in state)&&!state.isReadOnly){state.selectDate(date);state.setFocusedDate(date);}},onPressUp:function onPressUp(e2){if(state.isReadOnly)return;if("anchorDate"in state&&touchDragTimerRef.current){state.selectDate(date);state.setFocusedDate(date);}if("anchorDate"in state){if(isRangeBoundaryPressed.current)state.setAnchorDate(date);else if(state.anchorDate&&!isAnchorPressed.current){state.selectDate(date);state.setFocusedDate(date);}else if(e2.pointerType==="keyboard"&&!state.anchorDate){state.selectDate(date);var nextDay=date.add({days:1});if(state.isInvalid(nextDay))nextDay=date.subtract({days:1});if(!state.isInvalid(nextDay))state.setFocusedDate(nextDay);}else if(e2.pointerType==="virtual"){state.selectDate(date);state.setFocusedDate(date);}}}}),pressProps=_$f6c31cce2adf654f$ex2.pressProps,isPressed=_$f6c31cce2adf654f$ex2.isPressed;var tabIndex=void 0;if(!isDisabled)tabIndex=$14e0f24ef4ac5c92$export$ea39ec197993aef0(date,state.focusedDate)?0:-1;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isFocused&&ref.current){$7215afc6de606d6b$export$de79e2c695e052f3(ref.current);if($507fabe10e71c6fb$export$630ff653c5ada6a9()!=="pointer"&&document.activeElement===ref.current)$2f04cbc44ee30ce0$export$c826860796309d1b(ref.current,{containingElement:$62d8ded9296f3872$export$cfa2225e87938781(ref.current)});}},[isFocused,ref]);var cellDateFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({day:"numeric",timeZone:state.timeZone,calendar:date.calendar.identifier});var formattedDate=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return cellDateFormatter.formatToParts(nativeDate).find(function(part){return part.type==="day";}).value;},[cellDateFormatter,nativeDate]);return{cellProps:{role:"gridcell","aria-disabled":!isSelectable||void 0,"aria-selected":isSelected||void 0,"aria-invalid":isInvalid||void 0},buttonProps:$3ef42575df84b30b$export$9d1611c77c2fe928(pressProps,{onFocus:function onFocus(){if(!isDisabled)state.setFocusedDate(date);},tabIndex:tabIndex,role:"button","aria-disabled":!isSelectable||void 0,"aria-label":label,"aria-invalid":isInvalid||void 0,"aria-describedby":[isInvalid?errorMessageId:void 0,descriptionProps["aria-describedby"]].filter(Boolean).join(" ")||void 0,onPointerEnter:function onPointerEnter(e2){if("highlightDate"in state&&(e2.pointerType!=="touch"||state.isDragging)&&isSelectable)state.highlightDate(date);},onPointerDown:function onPointerDown(e2){if("releasePointerCapture"in e2.target)e2.target.releasePointerCapture(e2.pointerId);},onContextMenu:function onContextMenu(e2){e2.preventDefault();}}),isPressed:isPressed,isFocused:isFocused,isSelected:isSelected,isDisabled:isDisabled,isUnavailable:isUnavailable,isOutsideVisibleRange:date.compare(state.visibleRange.start)<0||date.compare(state.visibleRange.end)>0,isInvalid:isInvalid,formattedDate:formattedDate};}var $e5be200c675c3b3a$export$aca958c65c314e6c={badInput:false,customError:false,patternMismatch:false,rangeOverflow:false,rangeUnderflow:false,stepMismatch:false,tooLong:false,tooShort:false,typeMismatch:false,valueMissing:false,valid:true};var $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE=__spreadProps(__spreadValues({},$e5be200c675c3b3a$export$aca958c65c314e6c),{customError:true,valid:false});var $e5be200c675c3b3a$export$dad6ae84456c676a={isInvalid:false,validationDetails:$e5be200c675c3b3a$export$aca958c65c314e6c,validationErrors:[]};var $e5be200c675c3b3a$export$571b5131b7e65c11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});var $e5be200c675c3b3a$export$a763b9476acd3eb="__formValidationState"+Date.now();function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(props){if(props[$e5be200c675c3b3a$export$a763b9476acd3eb]){var _props$$e5be200c675c=props[$e5be200c675c3b3a$export$a763b9476acd3eb],realtimeValidation=_props$$e5be200c675c.realtimeValidation,displayValidation=_props$$e5be200c675c.displayValidation,updateValidation=_props$$e5be200c675c.updateValidation,resetValidation=_props$$e5be200c675c.resetValidation,commitValidation=_props$$e5be200c675c.commitValidation;return{realtimeValidation:realtimeValidation,displayValidation:displayValidation,updateValidation:updateValidation,resetValidation:resetValidation,commitValidation:commitValidation};}return $e5be200c675c3b3a$var$useFormValidationStateImpl(props);}function $e5be200c675c3b3a$var$useFormValidationStateImpl(props){var isInvalid=props.isInvalid,validationState=props.validationState,name=props.name,value=props.value,builtinValidation=props.builtinValidation,validate=props.validate,_props$validationBeha=props.validationBehavior,validationBehavior=_props$validationBeha===void 0?"aria":_props$validationBeha;if(validationState)isInvalid||(isInvalid=validationState==="invalid");var controlledError=isInvalid!==void 0?{isInvalid:isInvalid,validationErrors:[],validationDetails:$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE}:null;var clientError=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!validate||value==null)return null;var validateErrors=$e5be200c675c3b3a$var$runValidate(validate,value);return $e5be200c675c3b3a$var$getValidationResult(validateErrors);},[validate,value]);if(builtinValidation===null||builtinValidation===void 0?void 0:builtinValidation.validationDetails.valid)builtinValidation=void 0;var serverErrors=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($e5be200c675c3b3a$export$571b5131b7e65c11);var serverErrorMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(name)return Array.isArray(name)?name.flatMap(function(name2){return $e5be200c675c3b3a$var$asArray(serverErrors[name2]);}):$e5be200c675c3b3a$var$asArray(serverErrors[name]);return[];},[serverErrors,name]);var _useState45=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(serverErrors),_useState46=_slicedToArray(_useState45,2),lastServerErrors=_useState46[0],setLastServerErrors=_useState46[1];var _useState47=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState48=_slicedToArray(_useState47,2),isServerErrorCleared=_useState48[0],setServerErrorCleared=_useState48[1];if(serverErrors!==lastServerErrors){setLastServerErrors(serverErrors);setServerErrorCleared(false);}var serverError=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared?[]:serverErrorMessages);},[isServerErrorCleared,serverErrorMessages]);var nextValidation=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])($e5be200c675c3b3a$export$dad6ae84456c676a);var _useState49=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])($e5be200c675c3b3a$export$dad6ae84456c676a),_useState50=_slicedToArray(_useState49,2),currentValidity=_useState50[0],setCurrentValidity=_useState50[1];var lastError=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])($e5be200c675c3b3a$export$dad6ae84456c676a);var commitValidation=function commitValidation(){if(!commitQueued)return;setCommitQueued(false);var error=clientError||builtinValidation||nextValidation.current;if(!$e5be200c675c3b3a$var$isEqualValidation(error,lastError.current)){lastError.current=error;setCurrentValidity(error);}};var _useState51=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState52=_slicedToArray(_useState51,2),commitQueued=_useState52[0],setCommitQueued=_useState52[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(commitValidation);var realtimeValidation=controlledError||serverError||clientError||builtinValidation||$e5be200c675c3b3a$export$dad6ae84456c676a;var displayValidation=validationBehavior==="native"?controlledError||serverError||currentValidity:controlledError||serverError||clientError||builtinValidation||currentValidity;return{realtimeValidation:realtimeValidation,displayValidation:displayValidation,updateValidation:function updateValidation(value2){if(validationBehavior==="aria"&&!$e5be200c675c3b3a$var$isEqualValidation(currentValidity,value2))setCurrentValidity(value2);else nextValidation.current=value2;},resetValidation:function resetValidation(){var error=$e5be200c675c3b3a$export$dad6ae84456c676a;if(!$e5be200c675c3b3a$var$isEqualValidation(error,lastError.current)){lastError.current=error;setCurrentValidity(error);}if(validationBehavior==="native")setCommitQueued(false);setServerErrorCleared(true);},commitValidation:function commitValidation(){if(validationBehavior==="native")setCommitQueued(true);setServerErrorCleared(true);}};}function $e5be200c675c3b3a$var$asArray(v2){if(!v2)return[];return Array.isArray(v2)?v2:[v2];}function $e5be200c675c3b3a$var$runValidate(validate,value){if(typeof validate==="function"){var e2=validate(value);if(e2&&typeof e2!=="boolean")return $e5be200c675c3b3a$var$asArray(e2);}return[];}function $e5be200c675c3b3a$var$getValidationResult(errors){return errors.length?{isInvalid:true,validationErrors:errors,validationDetails:$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE}:null;}function $e5be200c675c3b3a$var$isEqualValidation(a,b2){if(a===b2)return true;return!!a&&!!b2&&a.isInvalid===b2.isInvalid&&a.validationErrors.length===b2.validationErrors.length&&a.validationErrors.every(function(a2,i){return a2===b2.validationErrors[i];})&&Object.entries(a.validationDetails).every(function(_ref243){var _ref244=_slicedToArray(_ref243,2),k2=_ref244[0],v2=_ref244[1];return b2.validationDetails[k2]===v2;});}function $e93e671b31057976$export$b8473d3665f3a75a(props,state,ref){var validationBehavior=props.validationBehavior,focus=props.focus;$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){if(validationBehavior==="native"&&(ref===null||ref===void 0?void 0:ref.current)&&!ref.current.disabled){var errorMessage=state.realtimeValidation.isInvalid?state.realtimeValidation.validationErrors.join(" ")||"Invalid value.":"";ref.current.setCustomValidity(errorMessage);if(!ref.current.hasAttribute("title"))ref.current.title="";if(!state.realtimeValidation.isInvalid)state.updateValidation($e93e671b31057976$var$getNativeValidity(ref.current));}});var isIgnoredReset=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);var onReset=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(){if(!isIgnoredReset.current)state.resetValidation();});var onInvalid=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(e2){var _ref_current;if(!state.displayValidation.isInvalid)state.commitValidation();var form=ref===null||ref===void 0?void 0:(_ref_current=ref.current)===null||_ref_current===void 0?void 0:_ref_current.form;if(!e2.defaultPrevented&&ref&&form&&$e93e671b31057976$var$getFirstInvalidInput(form)===ref.current){var _ref_current1;if(focus)focus();else(_ref_current1=ref.current)===null||_ref_current1===void 0?void 0:_ref_current1.focus();$507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");}e2.preventDefault();});var onChange=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(){state.commitValidation();});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var input=ref===null||ref===void 0?void 0:ref.current;if(!input)return;var form=input.form;var reset=form===null||form===void 0?void 0:form.reset;if(form)form.reset=function(){isIgnoredReset.current=!window.event||window.event.type==="message"&&window.event.target instanceof MessagePort;reset===null||reset===void 0?void 0:reset.call(form);isIgnoredReset.current=false;};input.addEventListener("invalid",onInvalid);input.addEventListener("change",onChange);form===null||form===void 0?void 0:form.addEventListener("reset",onReset);return function(){input.removeEventListener("invalid",onInvalid);input.removeEventListener("change",onChange);form===null||form===void 0?void 0:form.removeEventListener("reset",onReset);if(form)form.reset=reset;};},[ref,onInvalid,onChange,onReset,validationBehavior]);}function $e93e671b31057976$var$getValidity(input){var validity=input.validity;return{badInput:validity.badInput,customError:validity.customError,patternMismatch:validity.patternMismatch,rangeOverflow:validity.rangeOverflow,rangeUnderflow:validity.rangeUnderflow,stepMismatch:validity.stepMismatch,tooLong:validity.tooLong,tooShort:validity.tooShort,typeMismatch:validity.typeMismatch,valueMissing:validity.valueMissing,valid:validity.valid};}function $e93e671b31057976$var$getNativeValidity(input){return{isInvalid:!input.validity.valid,validationDetails:$e93e671b31057976$var$getValidity(input),validationErrors:input.validationMessage?[input.validationMessage]:[]};}function $e93e671b31057976$var$getFirstInvalidInput(form){for(var _i11=0;_i11<form.elements.length;_i11++){var element=form.elements[_i11];if(!element.validity.valid)return element;}return null;}function $d191a55c9702f145$export$8467354a121f1b9f(props){var id=props.id,label=props.label,ariaLabelledby=props["aria-labelledby"],ariaLabel=props["aria-label"],_props$labelElementTy=props.labelElementType,labelElementType=_props$labelElementTy===void 0?"label":_props$labelElementTy;id=$bdb11010cef70236$export$f680877a34711e37(id);var labelId=$bdb11010cef70236$export$f680877a34711e37();var labelProps={};if(label){ariaLabelledby=ariaLabelledby?"".concat(labelId," ").concat(ariaLabelledby):labelId;labelProps={id:labelId,htmlFor:labelElementType==="label"?id:void 0};}else if(!ariaLabelledby&&!ariaLabel&&false)console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");var fieldProps=$313b98861ee5dd6c$export$d6875122194c7b44({id:id,"aria-label":ariaLabel,"aria-labelledby":ariaLabelledby});return{labelProps:labelProps,fieldProps:fieldProps};}function $2baaea4c71418dea$export$294aa081a6c6f55d(props){var description=props.description,errorMessage=props.errorMessage,isInvalid=props.isInvalid,validationState=props.validationState;var _$d191a55c9702f145$ex=$d191a55c9702f145$export$8467354a121f1b9f(props),labelProps=_$d191a55c9702f145$ex.labelProps,fieldProps=_$d191a55c9702f145$ex.fieldProps;var descriptionId=$bdb11010cef70236$export$b4cc09c592e8fdb8([Boolean(description),Boolean(errorMessage),isInvalid,validationState]);var errorMessageId=$bdb11010cef70236$export$b4cc09c592e8fdb8([Boolean(description),Boolean(errorMessage),isInvalid,validationState]);fieldProps=$3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps,{"aria-describedby":[descriptionId,errorMessageId,props["aria-describedby"]].filter(Boolean).join(" ")||void 0});return{labelProps:labelProps,fieldProps:fieldProps,descriptionProps:{id:descriptionId},errorMessageProps:{id:errorMessageId}};}var $5c3e21d68f1c4674$var$styles={border:0,clip:"rect(0 0 0 0)",clipPath:"inset(50%)",height:"1px",margin:"-1px",overflow:"hidden",padding:0,position:"absolute",width:"1px",whiteSpace:"nowrap"};function $5c3e21d68f1c4674$export$a966af930f325cab(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var style2=props.style,isFocusable=props.isFocusable;var _useState53=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState54=_slicedToArray(_useState53,2),isFocused=_useState54[0],setFocused=_useState54[1];var _$9ab94262bd0047c7$ex=$9ab94262bd0047c7$export$420e68273165f4ec({isDisabled:!isFocusable,onFocusWithinChange:function onFocusWithinChange(val){return setFocused(val);}}),focusWithinProps=_$9ab94262bd0047c7$ex.focusWithinProps;var combinedStyles=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(isFocused)return style2;else if(style2)return __spreadValues(__spreadValues({},$5c3e21d68f1c4674$var$styles),style2);else return $5c3e21d68f1c4674$var$styles;},[isFocused]);return{visuallyHiddenProps:__spreadProps(__spreadValues({},focusWithinProps),{style:combinedStyles})};}function $5c3e21d68f1c4674$export$439d29a4e110a164(props){var _a2=props,children=_a2.children,_a2$elementType=_a2.elementType,Element2=_a2$elementType===void 0?"div":_a2$elementType,isFocusable=_a2.isFocusable,style2=_a2.style,otherProps=__objRest(_a2,["children","elementType","isFocusable","style"]);var _$5c3e21d68f1c4674$ex=$5c3e21d68f1c4674$export$a966af930f325cab(props),visuallyHiddenProps=_$5c3e21d68f1c4674$ex.visuallyHiddenProps;return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element2,$3ef42575df84b30b$export$9d1611c77c2fe928(otherProps,visuallyHiddenProps),children);}var $ed6aae4e5f766f1e$exports={};$ed6aae4e5f766f1e$exports={"Empty":"\u0641\u0627\u0631\u063A"};var $38854e2b175151fa$exports={};$38854e2b175151fa$exports={"Empty":"\u0418\u0437\u043F\u0440\u0430\u0437\u043D\u0438"};var $15b25ab20f3945b2$exports={};$15b25ab20f3945b2$exports={"Empty":"Pr\xE1zdn\xE9"};var $692a4298b6b649a2$exports={};$692a4298b6b649a2$exports={"Empty":"Tom"};var $1c6e1539193f1243$exports={};$1c6e1539193f1243$exports={"Empty":"Leer"};var $1e8678632c464b6d$exports={};$1e8678632c464b6d$exports={"Empty":"\u0386\u03B4\u03B5\u03B9\u03BF"};var $4adc85d9bf5b9eed$exports={};$4adc85d9bf5b9eed$exports={"Empty":"Empty"};var $41c4b2bb61dafbca$exports={};$41c4b2bb61dafbca$exports={"Empty":"Vac\xEDo"};var $405f8b24f5dd2a60$exports={};$405f8b24f5dd2a60$exports={"Empty":"T\xFChjenda"};var $7efe3ed02b9b9dd4$exports={};$7efe3ed02b9b9dd4$exports={"Empty":"Tyhj\xE4"};var $99fc4c101d92daf3$exports={};$99fc4c101d92daf3$exports={"Empty":"Vide"};var $f9e155e6e8cacaa2$exports={};$f9e155e6e8cacaa2$exports={"Empty":"\u05E8\u05D9\u05E7"};var $c31b5e8e9a249fd5$exports={};$c31b5e8e9a249fd5$exports={"Empty":"Prazno"};var $9c5435bc17499bd9$exports={};$9c5435bc17499bd9$exports={"Empty":"\xDCres"};var $6d1fc8e84d8165e1$exports={};$6d1fc8e84d8165e1$exports={"Empty":"Vuoto"};var $46ea6b3641b83e71$exports={};$46ea6b3641b83e71$exports={"Empty":"\u7A7A"};var $0e3cc9a288289dc5$exports={};$0e3cc9a288289dc5$exports={"Empty":"\uBE44\uC5B4 \uC788\uC74C"};var $4ff2bb25c0089ffb$exports={};$4ff2bb25c0089ffb$exports={"Empty":"Tu\u0161\u010Dias"};var $6cf33cd4c010a2fb$exports={};$6cf33cd4c010a2fb$exports={"Empty":"Tuk\u0161s"};var $5a9f8486f8b8837e$exports={};$5a9f8486f8b8837e$exports={"Empty":"Tom"};var $583f94d807f6ecea$exports={};$583f94d807f6ecea$exports={"Empty":"Leeg"};var $cc4dcfeea2b4050d$exports={};$cc4dcfeea2b4050d$exports={"Empty":"Pusty"};var $68ac2954d56e12b4$exports={};$68ac2954d56e12b4$exports={"Empty":"Vazio"};var $fdb0616f309780b0$exports={};$fdb0616f309780b0$exports={"Empty":"Vazio"};var $fe1eccf4ee1d6f52$exports={};$fe1eccf4ee1d6f52$exports={"Empty":"Gol"};var $a38b6c4e18725976$exports={};$a38b6c4e18725976$exports={"Empty":"\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E"};var $6c14ae2b766b652c$exports={};$6c14ae2b766b652c$exports={"Empty":"Pr\xE1zdne"};var $8f1c9692e16dc5eb$exports={};$8f1c9692e16dc5eb$exports={"Empty":"Prazen"};var $d2aa7abea627cafa$exports={};$d2aa7abea627cafa$exports={"Empty":"Prazno"};var $676b82e4b56408e6$exports={};$676b82e4b56408e6$exports={"Empty":"Tomt"};var $14c9042552d7ce08$exports={};$14c9042552d7ce08$exports={"Empty":"Bo\u015F"};var $393254ebcb66c9f5$exports={};$393254ebcb66c9f5$exports={"Empty":"\u041F\u0443\u0441\u0442\u043E"};var $d49d621f310cf6ce$exports={};$d49d621f310cf6ce$exports={"Empty":"\u7A7A"};var $94b60c866ca5dfe6$exports={};$94b60c866ca5dfe6$exports={"Empty":"\u7A7A\u767D"};var $a99895ee3dc79e61$exports={};$a99895ee3dc79e61$exports={"ar-AE":$ed6aae4e5f766f1e$exports,"bg-BG":$38854e2b175151fa$exports,"cs-CZ":$15b25ab20f3945b2$exports,"da-DK":$692a4298b6b649a2$exports,"de-DE":$1c6e1539193f1243$exports,"el-GR":$1e8678632c464b6d$exports,"en-US":$4adc85d9bf5b9eed$exports,"es-ES":$41c4b2bb61dafbca$exports,"et-EE":$405f8b24f5dd2a60$exports,"fi-FI":$7efe3ed02b9b9dd4$exports,"fr-FR":$99fc4c101d92daf3$exports,"he-IL":$f9e155e6e8cacaa2$exports,"hr-HR":$c31b5e8e9a249fd5$exports,"hu-HU":$9c5435bc17499bd9$exports,"it-IT":$6d1fc8e84d8165e1$exports,"ja-JP":$46ea6b3641b83e71$exports,"ko-KR":$0e3cc9a288289dc5$exports,"lt-LT":$4ff2bb25c0089ffb$exports,"lv-LV":$6cf33cd4c010a2fb$exports,"nb-NO":$5a9f8486f8b8837e$exports,"nl-NL":$583f94d807f6ecea$exports,"pl-PL":$cc4dcfeea2b4050d$exports,"pt-BR":$68ac2954d56e12b4$exports,"pt-PT":$fdb0616f309780b0$exports,"ro-RO":$fe1eccf4ee1d6f52$exports,"ru-RU":$a38b6c4e18725976$exports,"sk-SK":$6c14ae2b766b652c$exports,"sl-SI":$8f1c9692e16dc5eb$exports,"sr-SP":$d2aa7abea627cafa$exports,"sv-SE":$676b82e4b56408e6$exports,"tr-TR":$14c9042552d7ce08$exports,"uk-UA":$393254ebcb66c9f5$exports,"zh-CN":$d49d621f310cf6ce$exports,"zh-TW":$94b60c866ca5dfe6$exports};function $parcel$interopDefault$5(a){return a&&a.__esModule?a["default"]:a;}function $d2e8511e6f209edf$export$e908e06f4b8e3402(props){var _async=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(void 0);var value=props.value,textValue=props.textValue,minValue=props.minValue,maxValue=props.maxValue,isDisabled=props.isDisabled,isReadOnly=props.isReadOnly,isRequired=props.isRequired,onIncrement=props.onIncrement,onIncrementPage=props.onIncrementPage,onDecrement=props.onDecrement,onDecrementPage=props.onDecrementPage,onDecrementToMin=props.onDecrementToMin,onIncrementToMax=props.onIncrementToMax;var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$5($a99895ee3dc79e61$exports),"@react-aria/spinbutton");var clearAsync=function clearAsync(){return clearTimeout(_async.current);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return function(){return clearAsync();};},[]);var onKeyDown=function onKeyDown(e2){if(e2.ctrlKey||e2.metaKey||e2.shiftKey||e2.altKey||isReadOnly||e2.nativeEvent.isComposing)return;switch(e2.key){case"PageUp":if(onIncrementPage){e2.preventDefault();onIncrementPage===null||onIncrementPage===void 0?void 0:onIncrementPage();break;}case"ArrowUp":case"Up":if(onIncrement){e2.preventDefault();onIncrement===null||onIncrement===void 0?void 0:onIncrement();}break;case"PageDown":if(onDecrementPage){e2.preventDefault();onDecrementPage===null||onDecrementPage===void 0?void 0:onDecrementPage();break;}case"ArrowDown":case"Down":if(onDecrement){e2.preventDefault();onDecrement===null||onDecrement===void 0?void 0:onDecrement();}break;case"Home":if(onDecrementToMin){e2.preventDefault();onDecrementToMin===null||onDecrementToMin===void 0?void 0:onDecrementToMin();}break;case"End":if(onIncrementToMax){e2.preventDefault();onIncrementToMax===null||onIncrementToMax===void 0?void 0:onIncrementToMax();}break;}};var isFocused=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);var onFocus=function onFocus(){isFocused.current=true;};var onBlur=function onBlur(){isFocused.current=false;};var ariaTextValue=textValue===""?stringFormatter.format("Empty"):(textValue||"".concat(value)).replace("-","\u2212");Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isFocused.current){$319e236875307eab$export$d10ae4f68404609a("assertive");$319e236875307eab$export$a9b970dcc4ae71a9(ariaTextValue,"assertive");}},[ariaTextValue]);var onIncrementPressStart=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(initialStepDelay){clearAsync();onIncrement===null||onIncrement===void 0?void 0:onIncrement();_async.current=window.setTimeout(function(){if(maxValue===void 0||isNaN(maxValue)||value===void 0||isNaN(value)||value<maxValue)onIncrementPressStart(60);},initialStepDelay);});var onDecrementPressStart=$8ae05eaa5c114e9c$export$7f54fc3180508a52(function(initialStepDelay){clearAsync();onDecrement===null||onDecrement===void 0?void 0:onDecrement();_async.current=window.setTimeout(function(){if(minValue===void 0||isNaN(minValue)||value===void 0||isNaN(value)||value>minValue)onDecrementPressStart(60);},initialStepDelay);});var cancelContextMenu=function cancelContextMenu(e2){e2.preventDefault();};var _$03deb23ff14920c4$ex3=$03deb23ff14920c4$export$4eaf04e54aa8eed6(),addGlobalListener=_$03deb23ff14920c4$ex3.addGlobalListener,removeAllGlobalListeners=_$03deb23ff14920c4$ex3.removeAllGlobalListeners;return{spinButtonProps:{role:"spinbutton","aria-valuenow":value!==void 0&&!isNaN(value)?value:void 0,"aria-valuetext":ariaTextValue,"aria-valuemin":minValue,"aria-valuemax":maxValue,"aria-disabled":isDisabled||void 0,"aria-readonly":isReadOnly||void 0,"aria-required":isRequired||void 0,onKeyDown:onKeyDown,onFocus:onFocus,onBlur:onBlur},incrementButtonProps:{onPressStart:function onPressStart(){onIncrementPressStart(400);addGlobalListener(window,"contextmenu",cancelContextMenu);},onPressEnd:function onPressEnd(){clearAsync();removeAllGlobalListeners();},onFocus:onFocus,onBlur:onBlur},decrementButtonProps:{onPressStart:function onPressStart(){onDecrementPressStart(400);addGlobalListener(window,"contextmenu",cancelContextMenu);},onPressEnd:function onPressEnd(){clearAsync();removeAllGlobalListeners();},onFocus:onFocus,onBlur:onBlur}};}var $edcf132a9284368a$var$AXIS={top:"top",bottom:"top",left:"left",right:"left"};var $edcf132a9284368a$var$FLIPPED_DIRECTION={top:"bottom",bottom:"top",left:"right",right:"left"};var $edcf132a9284368a$var$CROSS_AXIS={top:"left",left:"top"};var $edcf132a9284368a$var$AXIS_SIZE={top:"height",left:"width"};var $edcf132a9284368a$var$TOTAL_SIZE={width:"totalWidth",height:"totalHeight"};var $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE={};var $edcf132a9284368a$var$visualViewport=typeof document!=="undefined"?window.visualViewport:null;function $edcf132a9284368a$var$getContainerDimensions(containerNode){var width=0,height=0,totalWidth=0,totalHeight=0,top2=0,left2=0;var scroll={};var _visualViewport_scale;var isPinchZoomedIn=((_visualViewport_scale=$edcf132a9284368a$var$visualViewport===null||$edcf132a9284368a$var$visualViewport===void 0?void 0:$edcf132a9284368a$var$visualViewport.scale)!==null&&_visualViewport_scale!==void 0?_visualViewport_scale:1)>1;if(containerNode.tagName==="BODY"){var documentElement=document.documentElement;totalWidth=documentElement.clientWidth;totalHeight=documentElement.clientHeight;var _visualViewport_width;width=(_visualViewport_width=$edcf132a9284368a$var$visualViewport===null||$edcf132a9284368a$var$visualViewport===void 0?void 0:$edcf132a9284368a$var$visualViewport.width)!==null&&_visualViewport_width!==void 0?_visualViewport_width:totalWidth;var _visualViewport_height;height=(_visualViewport_height=$edcf132a9284368a$var$visualViewport===null||$edcf132a9284368a$var$visualViewport===void 0?void 0:$edcf132a9284368a$var$visualViewport.height)!==null&&_visualViewport_height!==void 0?_visualViewport_height:totalHeight;scroll.top=documentElement.scrollTop||containerNode.scrollTop;scroll.left=documentElement.scrollLeft||containerNode.scrollLeft;if($edcf132a9284368a$var$visualViewport){top2=$edcf132a9284368a$var$visualViewport.offsetTop;left2=$edcf132a9284368a$var$visualViewport.offsetLeft;}}else{var _$edcf132a9284368a$va=$edcf132a9284368a$var$getOffset(containerNode,false);width=_$edcf132a9284368a$va.width;height=_$edcf132a9284368a$va.height;top2=_$edcf132a9284368a$va.top;left2=_$edcf132a9284368a$va.left;scroll.top=containerNode.scrollTop;scroll.left=containerNode.scrollLeft;totalWidth=width;totalHeight=height;}if($c87311424ea30a05$export$78551043582a6a98()&&(containerNode.tagName==="BODY"||containerNode.tagName==="HTML")&&isPinchZoomedIn){scroll.top=0;scroll.left=0;var _visualViewport_pageTop;top2=(_visualViewport_pageTop=$edcf132a9284368a$var$visualViewport===null||$edcf132a9284368a$var$visualViewport===void 0?void 0:$edcf132a9284368a$var$visualViewport.pageTop)!==null&&_visualViewport_pageTop!==void 0?_visualViewport_pageTop:0;var _visualViewport_pageLeft;left2=(_visualViewport_pageLeft=$edcf132a9284368a$var$visualViewport===null||$edcf132a9284368a$var$visualViewport===void 0?void 0:$edcf132a9284368a$var$visualViewport.pageLeft)!==null&&_visualViewport_pageLeft!==void 0?_visualViewport_pageLeft:0;}return{width:width,height:height,totalWidth:totalWidth,totalHeight:totalHeight,scroll:scroll,top:top2,left:left2};}function $edcf132a9284368a$var$getScroll(node){return{top:node.scrollTop,left:node.scrollLeft,width:node.scrollWidth,height:node.scrollHeight};}function $edcf132a9284368a$var$getDelta(axis,offset2,size2,boundaryDimensions,containerDimensions,padding2,containerOffsetWithBoundary){var _containerDimensions_scroll_axis;var containerScroll=(_containerDimensions_scroll_axis=containerDimensions.scroll[axis])!==null&&_containerDimensions_scroll_axis!==void 0?_containerDimensions_scroll_axis:0;var boundarySize=boundaryDimensions[$edcf132a9284368a$var$AXIS_SIZE[axis]];var boundaryStartEdge=boundaryDimensions.scroll[$edcf132a9284368a$var$AXIS[axis]]+padding2;var boundaryEndEdge=boundarySize+boundaryDimensions.scroll[$edcf132a9284368a$var$AXIS[axis]]-padding2;var startEdgeOffset=offset2-containerScroll+containerOffsetWithBoundary[axis]-boundaryDimensions[$edcf132a9284368a$var$AXIS[axis]];var endEdgeOffset=offset2-containerScroll+size2+containerOffsetWithBoundary[axis]-boundaryDimensions[$edcf132a9284368a$var$AXIS[axis]];if(startEdgeOffset<boundaryStartEdge)return boundaryStartEdge-startEdgeOffset;else if(endEdgeOffset>boundaryEndEdge)return Math.max(boundaryEndEdge-endEdgeOffset,boundaryStartEdge-startEdgeOffset);else return 0;}function $edcf132a9284368a$var$getMargins(node){var style2=window.getComputedStyle(node);return{top:parseInt(style2.marginTop,10)||0,bottom:parseInt(style2.marginBottom,10)||0,left:parseInt(style2.marginLeft,10)||0,right:parseInt(style2.marginRight,10)||0};}function $edcf132a9284368a$var$parsePlacement(input){if($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input])return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];var _input$split=input.split(" "),_input$split2=_slicedToArray(_input$split,2),placement=_input$split2[0],crossPlacement=_input$split2[1];var axis=$edcf132a9284368a$var$AXIS[placement]||"right";var crossAxis=$edcf132a9284368a$var$CROSS_AXIS[axis];if(!$edcf132a9284368a$var$AXIS[crossPlacement])crossPlacement="center";var size2=$edcf132a9284368a$var$AXIS_SIZE[axis];var crossSize=$edcf132a9284368a$var$AXIS_SIZE[crossAxis];$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]={placement:placement,crossPlacement:crossPlacement,axis:axis,crossAxis:crossAxis,size:size2,crossSize:crossSize};return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];}function $edcf132a9284368a$var$computePosition(childOffset,boundaryDimensions,overlaySize,placementInfo,offset2,crossOffset,containerOffsetWithBoundary,isContainerPositioned,arrowSize,arrowBoundaryOffset){var placement=placementInfo.placement,crossPlacement=placementInfo.crossPlacement,axis=placementInfo.axis,crossAxis=placementInfo.crossAxis,size2=placementInfo.size,crossSize=placementInfo.crossSize;var position2={};var _childOffset_crossAxis;position2[crossAxis]=(_childOffset_crossAxis=childOffset[crossAxis])!==null&&_childOffset_crossAxis!==void 0?_childOffset_crossAxis:0;var _childOffset_crossSize,_overlaySize_crossSize,_childOffset_crossSize1,_overlaySize_crossSize1;if(crossPlacement==="center")position2[crossAxis]+=(((_childOffset_crossSize=childOffset[crossSize])!==null&&_childOffset_crossSize!==void 0?_childOffset_crossSize:0)-((_overlaySize_crossSize=overlaySize[crossSize])!==null&&_overlaySize_crossSize!==void 0?_overlaySize_crossSize:0))/2;else if(crossPlacement!==crossAxis)position2[crossAxis]+=((_childOffset_crossSize1=childOffset[crossSize])!==null&&_childOffset_crossSize1!==void 0?_childOffset_crossSize1:0)-((_overlaySize_crossSize1=overlaySize[crossSize])!==null&&_overlaySize_crossSize1!==void 0?_overlaySize_crossSize1:0);position2[crossAxis]+=crossOffset;var minPosition=childOffset[crossAxis]-overlaySize[crossSize]+arrowSize+arrowBoundaryOffset;var maxPosition=childOffset[crossAxis]+childOffset[crossSize]-arrowSize-arrowBoundaryOffset;position2[crossAxis]=$9446cca9a3875146$export$7d15b64cf5a3a4c4(position2[crossAxis],minPosition,maxPosition);if(placement===axis){var containerHeight=isContainerPositioned?containerOffsetWithBoundary[size2]:boundaryDimensions[$edcf132a9284368a$var$TOTAL_SIZE[size2]];position2[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]]=Math.floor(containerHeight-childOffset[axis]+offset2);}else position2[axis]=Math.floor(childOffset[axis]+childOffset[size2]+offset2);return position2;}function $edcf132a9284368a$var$getMaxHeight(position2,boundaryDimensions,containerOffsetWithBoundary,isContainerPositioned,margins,padding2,overlayHeight,heightGrowthDirection){var containerHeight=isContainerPositioned?containerOffsetWithBoundary.height:boundaryDimensions[$edcf132a9284368a$var$TOTAL_SIZE.height];var _position_bottom;var overlayTop=position2.top!=null?containerOffsetWithBoundary.top+position2.top:containerOffsetWithBoundary.top+(containerHeight-((_position_bottom=position2.bottom)!==null&&_position_bottom!==void 0?_position_bottom:0)-overlayHeight);var _boundaryDimensions_scroll_top,_margins_top,_margins_bottom,_boundaryDimensions_scroll_top1,_margins_top1,_margins_bottom1;var maxHeight=heightGrowthDirection!=="top"?Math.max(0,boundaryDimensions.height+boundaryDimensions.top+((_boundaryDimensions_scroll_top=boundaryDimensions.scroll.top)!==null&&_boundaryDimensions_scroll_top!==void 0?_boundaryDimensions_scroll_top:0)-overlayTop-(((_margins_top=margins.top)!==null&&_margins_top!==void 0?_margins_top:0)+((_margins_bottom=margins.bottom)!==null&&_margins_bottom!==void 0?_margins_bottom:0)+padding2)):Math.max(0,overlayTop+overlayHeight-(boundaryDimensions.top+((_boundaryDimensions_scroll_top1=boundaryDimensions.scroll.top)!==null&&_boundaryDimensions_scroll_top1!==void 0?_boundaryDimensions_scroll_top1:0))-(((_margins_top1=margins.top)!==null&&_margins_top1!==void 0?_margins_top1:0)+((_margins_bottom1=margins.bottom)!==null&&_margins_bottom1!==void 0?_margins_bottom1:0)+padding2));return Math.min(boundaryDimensions.height-padding2*2,maxHeight);}function $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions,containerOffsetWithBoundary,childOffset,margins,padding2,placementInfo){var placement=placementInfo.placement,axis=placementInfo.axis,size2=placementInfo.size;var _boundaryDimensions_scroll_axis,_margins_axis;if(placement===axis)return Math.max(0,childOffset[axis]-boundaryDimensions[axis]-((_boundaryDimensions_scroll_axis=boundaryDimensions.scroll[axis])!==null&&_boundaryDimensions_scroll_axis!==void 0?_boundaryDimensions_scroll_axis:0)+containerOffsetWithBoundary[axis]-((_margins_axis=margins[axis])!==null&&_margins_axis!==void 0?_margins_axis:0)-margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]]-padding2);var _margins_axis1;return Math.max(0,boundaryDimensions[size2]+boundaryDimensions[axis]+boundaryDimensions.scroll[axis]-containerOffsetWithBoundary[axis]-childOffset[axis]-childOffset[size2]-((_margins_axis1=margins[axis])!==null&&_margins_axis1!==void 0?_margins_axis1:0)-margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]]-padding2);}function $edcf132a9284368a$export$6839422d1f33cee9(placementInput,childOffset,overlaySize,scrollSize,margins,padding2,flip2,boundaryDimensions,containerDimensions,containerOffsetWithBoundary,offset2,crossOffset,isContainerPositioned,userSetMaxHeight,arrowSize,arrowBoundaryOffset){var placementInfo=$edcf132a9284368a$var$parsePlacement(placementInput);var _placementInfo=placementInfo,size2=_placementInfo.size,crossAxis=_placementInfo.crossAxis,crossSize=_placementInfo.crossSize,placement=_placementInfo.placement,crossPlacement=_placementInfo.crossPlacement;var position2=$edcf132a9284368a$var$computePosition(childOffset,boundaryDimensions,overlaySize,placementInfo,offset2,crossOffset,containerOffsetWithBoundary,isContainerPositioned,arrowSize,arrowBoundaryOffset);var normalizedOffset=offset2;var space=$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions,containerOffsetWithBoundary,childOffset,margins,padding2+offset2,placementInfo);if(flip2&&scrollSize[size2]>space){var flippedPlacementInfo=$edcf132a9284368a$var$parsePlacement("".concat($edcf132a9284368a$var$FLIPPED_DIRECTION[placement]," ").concat(crossPlacement));var flippedPosition=$edcf132a9284368a$var$computePosition(childOffset,boundaryDimensions,overlaySize,flippedPlacementInfo,offset2,crossOffset,containerOffsetWithBoundary,isContainerPositioned,arrowSize,arrowBoundaryOffset);var flippedSpace=$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions,containerOffsetWithBoundary,childOffset,margins,padding2+offset2,flippedPlacementInfo);if(flippedSpace>space){placementInfo=flippedPlacementInfo;position2=flippedPosition;normalizedOffset=offset2;}}var heightGrowthDirection="bottom";if(placementInfo.axis==="top"){if(placementInfo.placement==="top")heightGrowthDirection="top";else if(placementInfo.placement==="bottom")heightGrowthDirection="bottom";}else if(placementInfo.crossAxis==="top"){if(placementInfo.crossPlacement==="top")heightGrowthDirection="bottom";else if(placementInfo.crossPlacement==="bottom")heightGrowthDirection="top";}var delta=$edcf132a9284368a$var$getDelta(crossAxis,position2[crossAxis],overlaySize[crossSize],boundaryDimensions,containerDimensions,padding2,containerOffsetWithBoundary);position2[crossAxis]+=delta;var maxHeight=$edcf132a9284368a$var$getMaxHeight(position2,boundaryDimensions,containerOffsetWithBoundary,isContainerPositioned,margins,padding2,overlaySize.height,heightGrowthDirection);if(userSetMaxHeight&&userSetMaxHeight<maxHeight)maxHeight=userSetMaxHeight;overlaySize.height=Math.min(overlaySize.height,maxHeight);position2=$edcf132a9284368a$var$computePosition(childOffset,boundaryDimensions,overlaySize,placementInfo,normalizedOffset,crossOffset,containerOffsetWithBoundary,isContainerPositioned,arrowSize,arrowBoundaryOffset);delta=$edcf132a9284368a$var$getDelta(crossAxis,position2[crossAxis],overlaySize[crossSize],boundaryDimensions,containerDimensions,padding2,containerOffsetWithBoundary);position2[crossAxis]+=delta;var arrowPosition={};var origin=childOffset[crossAxis]-position2[crossAxis]-margins[$edcf132a9284368a$var$AXIS[crossAxis]];var preferredArrowPosition=origin+0.5*childOffset[crossSize];var arrowMinPosition=arrowSize/2+arrowBoundaryOffset;var _margins_left,_margins_right,_margins_top,_margins_bottom;var overlayMargin=$edcf132a9284368a$var$AXIS[crossAxis]==="left"?((_margins_left=margins.left)!==null&&_margins_left!==void 0?_margins_left:0)+((_margins_right=margins.right)!==null&&_margins_right!==void 0?_margins_right:0):((_margins_top=margins.top)!==null&&_margins_top!==void 0?_margins_top:0)+((_margins_bottom=margins.bottom)!==null&&_margins_bottom!==void 0?_margins_bottom:0);var arrowMaxPosition=overlaySize[crossSize]-overlayMargin-arrowSize/2-arrowBoundaryOffset;var arrowOverlappingChildMinEdge=childOffset[crossAxis]+arrowSize/2-(position2[crossAxis]+margins[$edcf132a9284368a$var$AXIS[crossAxis]]);var arrowOverlappingChildMaxEdge=childOffset[crossAxis]+childOffset[crossSize]-arrowSize/2-(position2[crossAxis]+margins[$edcf132a9284368a$var$AXIS[crossAxis]]);var arrowPositionOverlappingChild=$9446cca9a3875146$export$7d15b64cf5a3a4c4(preferredArrowPosition,arrowOverlappingChildMinEdge,arrowOverlappingChildMaxEdge);arrowPosition[crossAxis]=$9446cca9a3875146$export$7d15b64cf5a3a4c4(arrowPositionOverlappingChild,arrowMinPosition,arrowMaxPosition);var _placementInfo2=placementInfo;placement=_placementInfo2.placement;crossPlacement=_placementInfo2.crossPlacement;if(arrowSize)origin=arrowPosition[crossAxis];else if(crossPlacement==="right")origin+=childOffset[crossSize];else if(crossPlacement==="center")origin+=childOffset[crossSize]/2;var crossOrigin=placement==="left"||placement==="top"?overlaySize[size2]:0;var triggerAnchorPoint={x:placement==="top"||placement==="bottom"?origin:crossOrigin,y:placement==="left"||placement==="right"?origin:crossOrigin};return{position:position2,maxHeight:maxHeight,arrowOffsetLeft:arrowPosition.left,arrowOffsetTop:arrowPosition.top,placement:placement,triggerAnchorPoint:triggerAnchorPoint};}function $edcf132a9284368a$export$b3ceb0cbf1056d98(opts){var placement=opts.placement,targetNode=opts.targetNode,overlayNode=opts.overlayNode,scrollNode=opts.scrollNode,padding2=opts.padding,shouldFlip=opts.shouldFlip,boundaryElement=opts.boundaryElement,offset2=opts.offset,crossOffset=opts.crossOffset,maxHeight=opts.maxHeight,_opts$arrowSize=opts.arrowSize,arrowSize=_opts$arrowSize===void 0?0:_opts$arrowSize,_opts$arrowBoundaryOf=opts.arrowBoundaryOffset,arrowBoundaryOffset=_opts$arrowBoundaryOf===void 0?0:_opts$arrowBoundaryOf;var container=overlayNode instanceof HTMLElement?$edcf132a9284368a$var$getContainingBlock(overlayNode):document.documentElement;var isViewportContainer=container===document.documentElement;var containerPositionStyle=window.getComputedStyle(container).position;var isContainerPositioned=!!containerPositionStyle&&containerPositionStyle!=="static";var childOffset=isViewportContainer?$edcf132a9284368a$var$getOffset(targetNode,false):$edcf132a9284368a$var$getPosition(targetNode,container,false);if(!isViewportContainer){var _window$getComputedSt=window.getComputedStyle(targetNode),marginTop=_window$getComputedSt.marginTop,marginLeft=_window$getComputedSt.marginLeft;childOffset.top+=parseInt(marginTop,10)||0;childOffset.left+=parseInt(marginLeft,10)||0;}var overlaySize=$edcf132a9284368a$var$getOffset(overlayNode,true);var margins=$edcf132a9284368a$var$getMargins(overlayNode);var _margins_left,_margins_right;overlaySize.width+=((_margins_left=margins.left)!==null&&_margins_left!==void 0?_margins_left:0)+((_margins_right=margins.right)!==null&&_margins_right!==void 0?_margins_right:0);var _margins_top,_margins_bottom;overlaySize.height+=((_margins_top=margins.top)!==null&&_margins_top!==void 0?_margins_top:0)+((_margins_bottom=margins.bottom)!==null&&_margins_bottom!==void 0?_margins_bottom:0);var scrollSize=$edcf132a9284368a$var$getScroll(scrollNode);var boundaryDimensions=$edcf132a9284368a$var$getContainerDimensions(boundaryElement);var containerDimensions=$edcf132a9284368a$var$getContainerDimensions(container);var containerOffsetWithBoundary=boundaryElement.tagName==="BODY"?$edcf132a9284368a$var$getOffset(container,false):$edcf132a9284368a$var$getPosition(container,boundaryElement,false);if(container.tagName==="HTML"&&boundaryElement.tagName==="BODY"){containerDimensions.scroll.top=0;containerDimensions.scroll.left=0;}return $edcf132a9284368a$export$6839422d1f33cee9(placement,childOffset,overlaySize,scrollSize,margins,padding2,shouldFlip,boundaryDimensions,containerDimensions,containerOffsetWithBoundary,offset2,crossOffset,isContainerPositioned,maxHeight,arrowSize,arrowBoundaryOffset);}function $edcf132a9284368a$export$4b834cebd9e5cebe(node,ignoreScale){var _node$getBoundingClie=node.getBoundingClientRect(),top2=_node$getBoundingClie.top,left2=_node$getBoundingClie.left,width=_node$getBoundingClie.width,height=_node$getBoundingClie.height;if(ignoreScale&&node instanceof node.ownerDocument.defaultView.HTMLElement){width=node.offsetWidth;height=node.offsetHeight;}return{top:top2,left:left2,width:width,height:height};}function $edcf132a9284368a$var$getOffset(node,ignoreScale){var _$edcf132a9284368a$ex=$edcf132a9284368a$export$4b834cebd9e5cebe(node,ignoreScale),top2=_$edcf132a9284368a$ex.top,left2=_$edcf132a9284368a$ex.left,width=_$edcf132a9284368a$ex.width,height=_$edcf132a9284368a$ex.height;var _document$documentEle=document.documentElement,scrollTop=_document$documentEle.scrollTop,scrollLeft=_document$documentEle.scrollLeft,clientTop=_document$documentEle.clientTop,clientLeft=_document$documentEle.clientLeft;return{top:top2+scrollTop-clientTop,left:left2+scrollLeft-clientLeft,width:width,height:height};}function $edcf132a9284368a$var$getPosition(node,parent,ignoreScale){var style2=window.getComputedStyle(node);var offset2;if(style2.position==="fixed")offset2=$edcf132a9284368a$export$4b834cebd9e5cebe(node,ignoreScale);else{offset2=$edcf132a9284368a$var$getOffset(node,ignoreScale);var parentOffset=$edcf132a9284368a$var$getOffset(parent,ignoreScale);var parentStyle=window.getComputedStyle(parent);parentOffset.top+=(parseInt(parentStyle.borderTopWidth,10)||0)-parent.scrollTop;parentOffset.left+=(parseInt(parentStyle.borderLeftWidth,10)||0)-parent.scrollLeft;offset2.top-=parentOffset.top;offset2.left-=parentOffset.left;}offset2.top-=parseInt(style2.marginTop,10)||0;offset2.left-=parseInt(style2.marginLeft,10)||0;return offset2;}function $edcf132a9284368a$var$getContainingBlock(node){var offsetParent=node.offsetParent;if(offsetParent&&offsetParent===document.body&&window.getComputedStyle(offsetParent).position==="static"&&!$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent=document.documentElement;if(offsetParent==null){offsetParent=node.parentElement;while(offsetParent&&!$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent=offsetParent.parentElement;}return offsetParent||document.documentElement;}function $edcf132a9284368a$var$isContainingBlock(node){var style2=window.getComputedStyle(node);return style2.transform!=="none"||/transform|perspective/.test(style2.willChange)||style2.filter!=="none"||style2.contain==="paint"||"backdropFilter"in style2&&style2.backdropFilter!=="none"||"WebkitBackdropFilter"in style2&&style2.WebkitBackdropFilter!=="none";}var $dd149f63282afbbf$export$f6211563215e3b37=/* @__PURE__ */new WeakMap();function $dd149f63282afbbf$export$18fc8428861184da(opts){var triggerRef=opts.triggerRef,isOpen=opts.isOpen,onClose=opts.onClose;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!isOpen||onClose===null)return;var onScroll=function onScroll(e2){var target=e2.target;if(!triggerRef.current||target instanceof Node&&!target.contains(triggerRef.current))return;if(e2.target instanceof HTMLInputElement||e2.target instanceof HTMLTextAreaElement)return;var onCloseHandler=onClose||$dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);if(onCloseHandler)onCloseHandler();};window.addEventListener("scroll",onScroll,true);return function(){window.removeEventListener("scroll",onScroll,true);};},[isOpen,onClose,triggerRef]);}var $2a41e45df1593e64$var$visualViewport=typeof document!=="undefined"?window.visualViewport:null;function $2a41e45df1593e64$export$d39e1813b3bdd0e1(props){var _$18f2051aff69b9bf$ex6=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),direction=_$18f2051aff69b9bf$ex6.direction;var arrowSize=props.arrowSize,targetRef=props.targetRef,overlayRef=props.overlayRef,arrowRef=props.arrowRef,_props$scrollRef=props.scrollRef,scrollRef=_props$scrollRef===void 0?overlayRef:_props$scrollRef,_props$placement=props.placement,placement=_props$placement===void 0?"bottom":_props$placement,_props$containerPaddi=props.containerPadding,containerPadding=_props$containerPaddi===void 0?12:_props$containerPaddi,_props$shouldFlip=props.shouldFlip,shouldFlip=_props$shouldFlip===void 0?true:_props$shouldFlip,_props$boundaryElemen=props.boundaryElement,boundaryElement=_props$boundaryElemen===void 0?typeof document!=="undefined"?document.body:null:_props$boundaryElemen,_props$offset=props.offset,offset2=_props$offset===void 0?0:_props$offset,_props$crossOffset=props.crossOffset,crossOffset=_props$crossOffset===void 0?0:_props$crossOffset,_props$shouldUpdatePo=props.shouldUpdatePosition,shouldUpdatePosition=_props$shouldUpdatePo===void 0?true:_props$shouldUpdatePo,_props$isOpen=props.isOpen,isOpen=_props$isOpen===void 0?true:_props$isOpen,onClose=props.onClose,maxHeight=props.maxHeight,_props$arrowBoundaryO=props.arrowBoundaryOffset,arrowBoundaryOffset=_props$arrowBoundaryO===void 0?0:_props$arrowBoundaryO;var _useState55=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState56=_slicedToArray(_useState55,2),position2=_useState56[0],setPosition=_useState56[1];var deps=[shouldUpdatePosition,placement,overlayRef.current,targetRef.current,arrowRef===null||arrowRef===void 0?void 0:arrowRef.current,scrollRef.current,containerPadding,shouldFlip,boundaryElement,offset2,crossOffset,isOpen,direction,maxHeight,arrowBoundaryOffset,arrowSize];var lastScale=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])($2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.scale);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isOpen)lastScale.current=$2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.scale;},[isOpen]);var updatePosition=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(shouldUpdatePosition===false||!isOpen||!overlayRef.current||!targetRef.current||!boundaryElement)return;if(($2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.scale)!==lastScale.current)return;var anchor=null;if(scrollRef.current&&scrollRef.current.contains(document.activeElement)){var _document_activeElement;var anchorRect=(_document_activeElement=document.activeElement)===null||_document_activeElement===void 0?void 0:_document_activeElement.getBoundingClientRect();var scrollRect=scrollRef.current.getBoundingClientRect();var _anchorRect_top;anchor={type:"top",offset:((_anchorRect_top=anchorRect===null||anchorRect===void 0?void 0:anchorRect.top)!==null&&_anchorRect_top!==void 0?_anchorRect_top:0)-scrollRect.top};if(anchor.offset>scrollRect.height/2){anchor.type="bottom";var _anchorRect_bottom;anchor.offset=((_anchorRect_bottom=anchorRect===null||anchorRect===void 0?void 0:anchorRect.bottom)!==null&&_anchorRect_bottom!==void 0?_anchorRect_bottom:0)-scrollRect.bottom;}}var overlay=overlayRef.current;if(!maxHeight&&overlayRef.current){var _window_visualViewport;overlay.style.top="0px";overlay.style.bottom="";var _window_visualViewport_height;overlay.style.maxHeight=((_window_visualViewport_height=(_window_visualViewport=window.visualViewport)===null||_window_visualViewport===void 0?void 0:_window_visualViewport.height)!==null&&_window_visualViewport_height!==void 0?_window_visualViewport_height:window.innerHeight)+"px";}var position3=$edcf132a9284368a$export$b3ceb0cbf1056d98({placement:$2a41e45df1593e64$var$translateRTL(placement,direction),overlayNode:overlayRef.current,targetNode:targetRef.current,scrollNode:scrollRef.current||overlayRef.current,padding:containerPadding,shouldFlip:shouldFlip,boundaryElement:boundaryElement,offset:offset2,crossOffset:crossOffset,maxHeight:maxHeight,arrowSize:arrowSize!==null&&arrowSize!==void 0?arrowSize:(arrowRef===null||arrowRef===void 0?void 0:arrowRef.current)?$edcf132a9284368a$export$4b834cebd9e5cebe(arrowRef.current,true).width:0,arrowBoundaryOffset:arrowBoundaryOffset});if(!position3.position)return;overlay.style.top="";overlay.style.bottom="";overlay.style.left="";overlay.style.right="";Object.keys(position3.position).forEach(function(key2){return overlay.style[key2]=position3.position[key2]+"px";});overlay.style.maxHeight=position3.maxHeight!=null?position3.maxHeight+"px":"";if(anchor&&document.activeElement&&scrollRef.current){var _anchorRect=document.activeElement.getBoundingClientRect();var _scrollRect=scrollRef.current.getBoundingClientRect();var newOffset=_anchorRect[anchor.type]-_scrollRect[anchor.type];scrollRef.current.scrollTop+=newOffset-anchor.offset;}setPosition(position3);},deps);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updatePosition,deps);$2a41e45df1593e64$var$useResize(updatePosition);$9daab02d461809db$export$683480f191c0e3ea({ref:overlayRef,onResize:updatePosition});$9daab02d461809db$export$683480f191c0e3ea({ref:targetRef,onResize:updatePosition});var isResizing=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var timeout;var onResize=function onResize(){isResizing.current=true;clearTimeout(timeout);timeout=setTimeout(function(){isResizing.current=false;},500);updatePosition();};var onScroll=function onScroll(){if(isResizing.current)onResize();};$2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.addEventListener("resize",onResize);$2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.addEventListener("scroll",onScroll);return function(){$2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.removeEventListener("resize",onResize);$2a41e45df1593e64$var$visualViewport===null||$2a41e45df1593e64$var$visualViewport===void 0?void 0:$2a41e45df1593e64$var$visualViewport.removeEventListener("scroll",onScroll);};},[updatePosition]);var close=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(!isResizing.current)onClose===null||onClose===void 0?void 0:onClose();},[onClose,isResizing]);$dd149f63282afbbf$export$18fc8428861184da({triggerRef:targetRef,isOpen:isOpen,onClose:onClose&&close});var _position_maxHeight,_position_placement,_position_triggerAnchorPoint;return{overlayProps:{style:__spreadProps(__spreadValues({position:position2?"absolute":"fixed",top:!position2?0:void 0,left:!position2?0:void 0,zIndex:1e5},position2===null||position2===void 0?void 0:position2.position),{maxHeight:(_position_maxHeight=position2===null||position2===void 0?void 0:position2.maxHeight)!==null&&_position_maxHeight!==void 0?_position_maxHeight:"100vh"})},placement:(_position_placement=position2===null||position2===void 0?void 0:position2.placement)!==null&&_position_placement!==void 0?_position_placement:null,triggerAnchorPoint:(_position_triggerAnchorPoint=position2===null||position2===void 0?void 0:position2.triggerAnchorPoint)!==null&&_position_triggerAnchorPoint!==void 0?_position_triggerAnchorPoint:null,arrowProps:{"aria-hidden":"true",role:"presentation",style:{left:position2===null||position2===void 0?void 0:position2.arrowOffsetLeft,top:position2===null||position2===void 0?void 0:position2.arrowOffsetTop}},updatePosition:updatePosition};}function $2a41e45df1593e64$var$useResize(onResize){$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){window.addEventListener("resize",onResize,false);return function(){window.removeEventListener("resize",onResize,false);};},[onResize]);}function $2a41e45df1593e64$var$translateRTL(position2,direction){if(direction==="rtl")return position2.replace("start","right").replace("end","left");return position2.replace("start","left").replace("end","right");}var $a11501f3d1d39e6c$var$visibleOverlays=[];function $a11501f3d1d39e6c$export$ea8f71083e90600f(props,ref){var onClose=props.onClose,shouldCloseOnBlur=props.shouldCloseOnBlur,isOpen=props.isOpen,_props$isDismissable=props.isDismissable,isDismissable=_props$isDismissable===void 0?false:_props$isDismissable,_props$isKeyboardDism=props.isKeyboardDismissDisabled,isKeyboardDismissDisabled=_props$isKeyboardDism===void 0?false:_props$isKeyboardDism,shouldCloseOnInteractOutside=props.shouldCloseOnInteractOutside;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isOpen&&!$a11501f3d1d39e6c$var$visibleOverlays.includes(ref)){$a11501f3d1d39e6c$var$visibleOverlays.push(ref);return function(){var index2=$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);if(index2>=0)$a11501f3d1d39e6c$var$visibleOverlays.splice(index2,1);};}},[isOpen,ref]);var onHide=function onHide(){if($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length-1]===ref&&onClose)onClose();};var onInteractOutsideStart=function onInteractOutsideStart(e2){if(!shouldCloseOnInteractOutside||shouldCloseOnInteractOutside(e2.target)){if($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length-1]===ref){e2.stopPropagation();e2.preventDefault();}}};var onInteractOutside=function onInteractOutside(e2){if(!shouldCloseOnInteractOutside||shouldCloseOnInteractOutside(e2.target)){if($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length-1]===ref){e2.stopPropagation();e2.preventDefault();}onHide();}};var onKeyDown=function onKeyDown(e2){if(e2.key==="Escape"&&!isKeyboardDismissDisabled&&!e2.nativeEvent.isComposing){e2.stopPropagation();e2.preventDefault();onHide();}};$e0b6e0b68ec7f50f$export$872b660ac5a1ff98({ref:ref,onInteractOutside:isDismissable&&isOpen?onInteractOutside:void 0,onInteractOutsideStart:onInteractOutsideStart});var _$9ab94262bd0047c7$ex2=$9ab94262bd0047c7$export$420e68273165f4ec({isDisabled:!shouldCloseOnBlur,onBlurWithin:function onBlurWithin(e2){if(!e2.relatedTarget||$9bf71ea28793e738$export$1258395f99bf9cbf(e2.relatedTarget))return;if(!shouldCloseOnInteractOutside||shouldCloseOnInteractOutside(e2.relatedTarget))onClose===null||onClose===void 0?void 0:onClose();}}),focusWithinProps=_$9ab94262bd0047c7$ex2.focusWithinProps;var onPointerDownUnderlay=function onPointerDownUnderlay(e2){if(e2.target===e2.currentTarget)e2.preventDefault();};return{overlayProps:__spreadValues({onKeyDown:onKeyDown},focusWithinProps),underlayProps:{onPointerDown:onPointerDownUnderlay}};}var $49c51c25361d4cd2$var$visualViewport=typeof document!=="undefined"&&window.visualViewport;var $49c51c25361d4cd2$var$preventScrollCount=0;var $49c51c25361d4cd2$var$restore;function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var isDisabled=options.isDisabled;$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){if(isDisabled)return;$49c51c25361d4cd2$var$preventScrollCount++;if($49c51c25361d4cd2$var$preventScrollCount===1){if($c87311424ea30a05$export$fedb369cb70207f1())$49c51c25361d4cd2$var$restore=$49c51c25361d4cd2$var$preventScrollMobileSafari();else $49c51c25361d4cd2$var$restore=$49c51c25361d4cd2$var$preventScrollStandard();}return function(){$49c51c25361d4cd2$var$preventScrollCount--;if($49c51c25361d4cd2$var$preventScrollCount===0)$49c51c25361d4cd2$var$restore();};},[isDisabled]);}function $49c51c25361d4cd2$var$preventScrollStandard(){var scrollbarWidth=window.innerWidth-document.documentElement.clientWidth;return $ff5963eb1fccf552$export$e08e3b67e392101e(scrollbarWidth>0&&("scrollbarGutter"in document.documentElement.style?$49c51c25361d4cd2$var$setStyle(document.documentElement,"scrollbarGutter","stable"):$49c51c25361d4cd2$var$setStyle(document.documentElement,"paddingRight","".concat(scrollbarWidth,"px"))),$49c51c25361d4cd2$var$setStyle(document.documentElement,"overflow","hidden"));}function $49c51c25361d4cd2$var$preventScrollMobileSafari(){var scrollable;var allowTouchMove=false;var onTouchStart=function onTouchStart(e2){var target=e2.target;scrollable=$cc38e7bd3fc7b213$export$2bb74740c4e19def(target)?target:$62d8ded9296f3872$export$cfa2225e87938781(target,true);allowTouchMove=false;var selection=target.ownerDocument.defaultView.getSelection();if(selection&&!selection.isCollapsed&&selection.containsNode(target,true))allowTouchMove=true;if("selectionStart"in target&&"selectionEnd"in target&&target.selectionStart<target.selectionEnd&&target.ownerDocument.activeElement===target)allowTouchMove=true;};var style2=document.createElement("style");style2.textContent="\n@layer {\n  * {\n    overscroll-behavior: contain;\n  }\n}".trim();document.head.prepend(style2);var onTouchMove=function onTouchMove(e2){if(e2.touches.length===2||allowTouchMove)return;if(!scrollable||scrollable===document.documentElement||scrollable===document.body){e2.preventDefault();return;}if(scrollable.scrollHeight===scrollable.clientHeight&&scrollable.scrollWidth===scrollable.clientWidth)e2.preventDefault();};var onBlur=function onBlur(e2){var target=e2.target;var relatedTarget=e2.relatedTarget;if(relatedTarget&&$21f1aa98acb08317$export$c57958e35f31ed73(relatedTarget)){relatedTarget.focus({preventScroll:true});$49c51c25361d4cd2$var$scrollIntoViewWhenReady(relatedTarget,$21f1aa98acb08317$export$c57958e35f31ed73(target));}else if(!relatedTarget){var _target_parentElement;var focusable=(_target_parentElement=target.parentElement)===null||_target_parentElement===void 0?void 0:_target_parentElement.closest("[tabindex]");focusable===null||focusable===void 0?void 0:focusable.focus({preventScroll:true});}};var focus=HTMLElement.prototype.focus;HTMLElement.prototype.focus=function(opts){var wasKeyboardVisible=document.activeElement!=null&&$21f1aa98acb08317$export$c57958e35f31ed73(document.activeElement);focus.call(this,__spreadProps(__spreadValues({},opts),{preventScroll:true}));if(!opts||!opts.preventScroll)$49c51c25361d4cd2$var$scrollIntoViewWhenReady(this,wasKeyboardVisible);};var removeEvents=$ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(document,"touchstart",onTouchStart,{passive:false,capture:true}),$49c51c25361d4cd2$var$addEvent(document,"touchmove",onTouchMove,{passive:false,capture:true}),$49c51c25361d4cd2$var$addEvent(document,"blur",onBlur,true));return function(){removeEvents();style2.remove();HTMLElement.prototype.focus=focus;};}function $49c51c25361d4cd2$var$setStyle(element,style2,value){var cur=element.style[style2];element.style[style2]=value;return function(){element.style[style2]=cur;};}function $49c51c25361d4cd2$var$addEvent(target,event,handler,options){target.addEventListener(event,handler,options);return function(){target.removeEventListener(event,handler,options);};}function $49c51c25361d4cd2$var$scrollIntoViewWhenReady(target,wasKeyboardVisible){if(wasKeyboardVisible||!$49c51c25361d4cd2$var$visualViewport)$49c51c25361d4cd2$var$scrollIntoView(target);else $49c51c25361d4cd2$var$visualViewport.addEventListener("resize",function(){return $49c51c25361d4cd2$var$scrollIntoView(target);},{once:true});}function $49c51c25361d4cd2$var$scrollIntoView(target){var root2=document.scrollingElement||document.documentElement;var nextTarget=target;while(nextTarget&&nextTarget!==root2){var scrollable=$62d8ded9296f3872$export$cfa2225e87938781(nextTarget);if(scrollable!==document.documentElement&&scrollable!==document.body&&scrollable!==nextTarget){var scrollableRect=scrollable.getBoundingClientRect();var targetRect=nextTarget.getBoundingClientRect();if(targetRect.top<scrollableRect.top||targetRect.bottom>scrollableRect.top+nextTarget.clientHeight){var bottom2=scrollableRect.bottom;if($49c51c25361d4cd2$var$visualViewport)bottom2=Math.min(bottom2,$49c51c25361d4cd2$var$visualViewport.offsetTop+$49c51c25361d4cd2$var$visualViewport.height);var adjustment=targetRect.top-scrollableRect.top-((bottom2-scrollableRect.top)/2-targetRect.height/2);scrollable.scrollTo({top:Math.max(0,Math.min(scrollable.scrollHeight-scrollable.clientHeight,scrollable.scrollTop+adjustment)),behavior:"smooth"});}}nextTarget=scrollable.parentElement;}}var $96b38030c423d352$export$60d741e20e0aa309=/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});function $96b38030c423d352$export$9fc1347d4195ccb3(){var _useContext;return(_useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($96b38030c423d352$export$60d741e20e0aa309))!==null&&_useContext!==void 0?_useContext:{};}var $773d5888b972f1cf$exports={};$773d5888b972f1cf$exports={"dismiss":"\u062A\u062C\u0627\u0647\u0644"};var $d11f19852b941573$exports={};$d11f19852b941573$exports={"dismiss":"\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435"};var $b983974c2ee1efb3$exports={};$b983974c2ee1efb3$exports={"dismiss":"Odstranit"};var $5809cc9d4e92de73$exports={};$5809cc9d4e92de73$exports={"dismiss":"Luk"};var $c68c2e4fc74398d1$exports={};$c68c2e4fc74398d1$exports={"dismiss":"Schlie\xDFen"};var $0898b4c153db2b77$exports={};$0898b4c153db2b77$exports={"dismiss":"\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7"};var $6d74810286a15183$exports={};$6d74810286a15183$exports={"dismiss":"Dismiss"};var $309d73dc65f78055$exports={};$309d73dc65f78055$exports={"dismiss":"Descartar"};var $44ad94f7205cf593$exports={};$44ad94f7205cf593$exports={"dismiss":"L\xF5peta"};var $7c28f5687f0779a9$exports={};$7c28f5687f0779a9$exports={"dismiss":"Hylk\xE4\xE4"};var $e6d75df4b68bd73a$exports={};$e6d75df4b68bd73a$exports={"dismiss":"Rejeter"};var $87505c9dab186d0f$exports={};$87505c9dab186d0f$exports={"dismiss":"\u05D4\u05EA\u05E2\u05DC\u05DD"};var $553439c3ffb3e492$exports={};$553439c3ffb3e492$exports={"dismiss":"Odbaci"};var $74cf411061b983a2$exports={};$74cf411061b983a2$exports={"dismiss":"Elutas\xEDt\xE1s"};var $e933f298574dc435$exports={};$e933f298574dc435$exports={"dismiss":"Ignora"};var $ac91fc9fe02f71f6$exports={};$ac91fc9fe02f71f6$exports={"dismiss":"\u9589\u3058\u308B"};var $52b96f86422025af$exports={};$52b96f86422025af$exports={"dismiss":"\uBB34\uC2DC"};var $c0d724c3e51dafa6$exports={};$c0d724c3e51dafa6$exports={"dismiss":"Atmesti"};var $c92899672a3fe72e$exports={};$c92899672a3fe72e$exports={"dismiss":"Ner\u0101d\u012Bt"};var $9f576b39d8e7a9d6$exports={};$9f576b39d8e7a9d6$exports={"dismiss":"Lukk"};var $9d025808aeec81a7$exports={};$9d025808aeec81a7$exports={"dismiss":"Negeren"};var $fce709921e2c0fa6$exports={};$fce709921e2c0fa6$exports={"dismiss":"Zignoruj"};var $2599cf0c4ab37f59$exports={};$2599cf0c4ab37f59$exports={"dismiss":"Descartar"};var $3c220ae7ef8a35fd$exports={};$3c220ae7ef8a35fd$exports={"dismiss":"Dispensar"};var $93562b5094072f54$exports={};$93562b5094072f54$exports={"dismiss":"Revocare"};var $cd9e2abd0d06c7b4$exports={};$cd9e2abd0d06c7b4$exports={"dismiss":"\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C"};var $45375701f409adf1$exports={};$45375701f409adf1$exports={"dismiss":"Zru\u0161i\u0165"};var $27fab53a576de9dd$exports={};$27fab53a576de9dd$exports={"dismiss":"Opusti"};var $4438748d9952e7c7$exports={};$4438748d9952e7c7$exports={"dismiss":"Odbaci"};var $0936d7347ef4da4c$exports={};$0936d7347ef4da4c$exports={"dismiss":"Avvisa"};var $29700c92185d38f8$exports={};$29700c92185d38f8$exports={"dismiss":"Kapat"};var $662ccaf2be4c25b3$exports={};$662ccaf2be4c25b3$exports={"dismiss":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"};var $d80a27deda7cdb3c$exports={};$d80a27deda7cdb3c$exports={"dismiss":"\u53D6\u6D88"};var $2b2734393847c884$exports={};$2b2734393847c884$exports={"dismiss":"\u95DC\u9589"};var $a2f21f5f14f60553$exports={};$a2f21f5f14f60553$exports={"ar-AE":$773d5888b972f1cf$exports,"bg-BG":$d11f19852b941573$exports,"cs-CZ":$b983974c2ee1efb3$exports,"da-DK":$5809cc9d4e92de73$exports,"de-DE":$c68c2e4fc74398d1$exports,"el-GR":$0898b4c153db2b77$exports,"en-US":$6d74810286a15183$exports,"es-ES":$309d73dc65f78055$exports,"et-EE":$44ad94f7205cf593$exports,"fi-FI":$7c28f5687f0779a9$exports,"fr-FR":$e6d75df4b68bd73a$exports,"he-IL":$87505c9dab186d0f$exports,"hr-HR":$553439c3ffb3e492$exports,"hu-HU":$74cf411061b983a2$exports,"it-IT":$e933f298574dc435$exports,"ja-JP":$ac91fc9fe02f71f6$exports,"ko-KR":$52b96f86422025af$exports,"lt-LT":$c0d724c3e51dafa6$exports,"lv-LV":$c92899672a3fe72e$exports,"nb-NO":$9f576b39d8e7a9d6$exports,"nl-NL":$9d025808aeec81a7$exports,"pl-PL":$fce709921e2c0fa6$exports,"pt-BR":$2599cf0c4ab37f59$exports,"pt-PT":$3c220ae7ef8a35fd$exports,"ro-RO":$93562b5094072f54$exports,"ru-RU":$cd9e2abd0d06c7b4$exports,"sk-SK":$45375701f409adf1$exports,"sl-SI":$27fab53a576de9dd$exports,"sr-SP":$4438748d9952e7c7$exports,"sv-SE":$0936d7347ef4da4c$exports,"tr-TR":$29700c92185d38f8$exports,"uk-UA":$662ccaf2be4c25b3$exports,"zh-CN":$d80a27deda7cdb3c$exports,"zh-TW":$2b2734393847c884$exports};function $parcel$interopDefault$4(a){return a&&a.__esModule?a["default"]:a;}function $86ea4cb521eb2e37$export$2317d149ed6f78c4(props){var _a2=props,onDismiss=_a2.onDismiss,otherProps=__objRest(_a2,["onDismiss"]);var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$4($a2f21f5f14f60553$exports),"@react-aria/overlays");var labels=$313b98861ee5dd6c$export$d6875122194c7b44(otherProps,stringFormatter.format("dismiss"));var onClick=function onClick(){if(onDismiss)onDismiss();};return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($5c3e21d68f1c4674$export$439d29a4e110a164,null,/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",__spreadProps(__spreadValues({},labels),{tabIndex:-1,onClick:onClick,style:{width:1,height:1}})));}var $5e3802645cc19319$var$supportsInert=typeof HTMLElement!=="undefined"&&"inert"in HTMLElement.prototype;var $5e3802645cc19319$var$refCountMap=/* @__PURE__ */new WeakMap();var $5e3802645cc19319$var$observerStack=[];function $5e3802645cc19319$export$1c3ebcada18427bf(targets,options){var windowObj=$431fbd86ca7dc216$export$f21a1ffae260145a(targets===null||targets===void 0?void 0:targets[0]);var opts=options instanceof windowObj.Element?{root:options}:options;var _opts_root;var root2=(_opts_root=opts===null||opts===void 0?void 0:opts.root)!==null&&_opts_root!==void 0?_opts_root:document.body;var shouldUseInert=(opts===null||opts===void 0?void 0:opts.shouldUseInert)&&$5e3802645cc19319$var$supportsInert;var visibleNodes=new Set(targets);var hiddenNodes=/* @__PURE__ */new Set();var getHidden=function getHidden(element){return shouldUseInert&&element instanceof windowObj.HTMLElement?element.inert:element.getAttribute("aria-hidden")==="true";};var setHidden=function setHidden(element,hidden){if(shouldUseInert&&element instanceof windowObj.HTMLElement)element.inert=hidden;else if(hidden)element.setAttribute("aria-hidden","true");else{element.removeAttribute("aria-hidden");if(element instanceof windowObj.HTMLElement)element.inert=false;}};var walk=function walk(root3){var _iterator16=_createForOfIteratorHelper(root3.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")),_step16;try{for(_iterator16.s();!(_step16=_iterator16.n()).done;){var element=_step16.value;visibleNodes.add(element);}}catch(err){_iterator16.e(err);}finally{_iterator16.f();}var acceptNode=function acceptNode(node){if(hiddenNodes.has(node)||visibleNodes.has(node)||node.parentElement&&hiddenNodes.has(node.parentElement)&&node.parentElement.getAttribute("role")!=="row")return NodeFilter.FILTER_REJECT;var _iterator17=_createForOfIteratorHelper(visibleNodes),_step17;try{for(_iterator17.s();!(_step17=_iterator17.n()).done;){var target=_step17.value;if(node.contains(target))return NodeFilter.FILTER_SKIP;}}catch(err){_iterator17.e(err);}finally{_iterator17.f();}return NodeFilter.FILTER_ACCEPT;};var walker=document.createTreeWalker(root3,NodeFilter.SHOW_ELEMENT,{acceptNode:acceptNode});var acceptRoot=acceptNode(root3);if(acceptRoot===NodeFilter.FILTER_ACCEPT)hide2(root3);if(acceptRoot!==NodeFilter.FILTER_REJECT){var node=walker.nextNode();while(node!=null){hide2(node);node=walker.nextNode();}}};var hide2=function hide2(node){var _refCountMap_get;var refCount=(_refCountMap_get=$5e3802645cc19319$var$refCountMap.get(node))!==null&&_refCountMap_get!==void 0?_refCountMap_get:0;if(getHidden(node)&&refCount===0)return;if(refCount===0)setHidden(node,true);hiddenNodes.add(node);$5e3802645cc19319$var$refCountMap.set(node,refCount+1);};if($5e3802645cc19319$var$observerStack.length)$5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length-1].disconnect();walk(root2);var observer=new MutationObserver(function(changes){var _iterator18=_createForOfIteratorHelper(changes),_step18;try{var _loop4=function _loop4(){var change=_step18.value;if(change.type!=="childList")return 1;// continue
if(![].concat(_toConsumableArray(visibleNodes),_toConsumableArray(hiddenNodes)).some(function(node){return node.contains(change.target);})){var _iterator19=_createForOfIteratorHelper(change.addedNodes),_step19;try{for(_iterator19.s();!(_step19=_iterator19.n()).done;){var node=_step19.value;if((node instanceof HTMLElement||node instanceof SVGElement)&&(node.dataset.liveAnnouncer==="true"||node.dataset.reactAriaTopLayer==="true"))visibleNodes.add(node);else if(node instanceof Element)walk(node);}}catch(err){_iterator19.e(err);}finally{_iterator19.f();}}};for(_iterator18.s();!(_step18=_iterator18.n()).done;){if(_loop4())continue;}}catch(err){_iterator18.e(err);}finally{_iterator18.f();}});observer.observe(root2,{childList:true,subtree:true});var observerWrapper={visibleNodes:visibleNodes,hiddenNodes:hiddenNodes,observe:function observe(){observer.observe(root2,{childList:true,subtree:true});},disconnect:function disconnect(){observer.disconnect();}};$5e3802645cc19319$var$observerStack.push(observerWrapper);return function(){observer.disconnect();var _iterator20=_createForOfIteratorHelper(hiddenNodes),_step20;try{for(_iterator20.s();!(_step20=_iterator20.n()).done;){var node=_step20.value;var count=$5e3802645cc19319$var$refCountMap.get(node);if(count==null)continue;if(count===1){setHidden(node,false);$5e3802645cc19319$var$refCountMap["delete"](node);}else $5e3802645cc19319$var$refCountMap.set(node,count-1);}}catch(err){_iterator20.e(err);}finally{_iterator20.f();}if(observerWrapper===$5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length-1]){$5e3802645cc19319$var$observerStack.pop();if($5e3802645cc19319$var$observerStack.length)$5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length-1].observe();}else $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(observerWrapper),1);};}function $5e3802645cc19319$export$1020fa7f77e17884(element){var observer=$5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length-1];if(observer&&!observer.visibleNodes.has(element)){observer.visibleNodes.add(element);return function(){observer.visibleNodes["delete"](element);};}}function $f2f8a6077418541e$export$542a6fd13ac93354(props,state){var _a2=props,triggerRef=_a2.triggerRef,popoverRef=_a2.popoverRef,groupRef=_a2.groupRef,isNonModal=_a2.isNonModal,isKeyboardDismissDisabled=_a2.isKeyboardDismissDisabled,shouldCloseOnInteractOutside=_a2.shouldCloseOnInteractOutside,otherProps=__objRest(_a2,["triggerRef","popoverRef","groupRef","isNonModal","isKeyboardDismissDisabled","shouldCloseOnInteractOutside"]);var isSubmenu=otherProps["trigger"]==="SubmenuTrigger";var _$a11501f3d1d39e6c$ex=$a11501f3d1d39e6c$export$ea8f71083e90600f({isOpen:state.isOpen,onClose:state.close,shouldCloseOnBlur:true,isDismissable:!isNonModal||isSubmenu,isKeyboardDismissDisabled:isKeyboardDismissDisabled,shouldCloseOnInteractOutside:shouldCloseOnInteractOutside},groupRef!==null&&groupRef!==void 0?groupRef:popoverRef),overlayProps=_$a11501f3d1d39e6c$ex.overlayProps,underlayProps=_$a11501f3d1d39e6c$ex.underlayProps;var _$2a41e45df1593e64$ex=$2a41e45df1593e64$export$d39e1813b3bdd0e1(__spreadProps(__spreadValues({},otherProps),{targetRef:triggerRef,overlayRef:popoverRef,isOpen:state.isOpen,onClose:isNonModal&&!isSubmenu?state.close:null})),positionProps=_$2a41e45df1593e64$ex.overlayProps,arrowProps=_$2a41e45df1593e64$ex.arrowProps,placement=_$2a41e45df1593e64$ex.placement,origin=_$2a41e45df1593e64$ex.triggerAnchorPoint;$49c51c25361d4cd2$export$ee0f7cc6afcd1c18({isDisabled:isNonModal||!state.isOpen});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(state.isOpen&&popoverRef.current){var _groupRef_current,_groupRef_current1;if(isNonModal)return $5e3802645cc19319$export$1020fa7f77e17884((_groupRef_current=groupRef===null||groupRef===void 0?void 0:groupRef.current)!==null&&_groupRef_current!==void 0?_groupRef_current:popoverRef.current);else return $5e3802645cc19319$export$1c3ebcada18427bf([(_groupRef_current1=groupRef===null||groupRef===void 0?void 0:groupRef.current)!==null&&_groupRef_current1!==void 0?_groupRef_current1:popoverRef.current],{shouldUseInert:true});}},[isNonModal,state.isOpen,popoverRef,groupRef]);return{popoverProps:$3ef42575df84b30b$export$9d1611c77c2fe928(overlayProps,positionProps),arrowProps:arrowProps,underlayProps:underlayProps,placement:placement,triggerAnchorPoint:origin};}var $337b884510726a0d$export$a2200b96afd16271=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);function $337b884510726a0d$export$c6fdb837b070b4ff(props){var isSSR=$b5e257d569688ac6$export$535bd6ca7f90a273();var _props$portalContaine=props.portalContainer,portalContainer=_props$portalContaine===void 0?isSSR?null:document.body:_props$portalContaine,isExiting=props.isExiting;var _useState57=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState58=_slicedToArray(_useState57,2),contain=_useState58[0],setContain=_useState58[1];var contextValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{contain:contain,setContain:setContain};},[contain,setContain]);var _$96b38030c423d352$ex=$96b38030c423d352$export$9fc1347d4195ccb3(),getContainer=_$96b38030c423d352$ex.getContainer;if(!props.portalContainer&&getContainer)portalContainer=getContainer();if(!portalContainer)return null;var contents=props.children;if(!props.disableFocusManagement)contents=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($9bf71ea28793e738$export$20e40289641fbbb6,{restoreFocus:true,contain:(props.shouldContainFocus||contain)&&!isExiting},contents);contents=/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($337b884510726a0d$export$a2200b96afd16271.Provider,{value:contextValue},/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($f1ab8c75478c6f73$export$cf75428e0b9ed1ea,null,contents));return/* @__PURE__ */__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.createPortal(contents,portalContainer);}function $337b884510726a0d$export$14c98a7594375490(){var ctx=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])($337b884510726a0d$export$a2200b96afd16271);var setContain=ctx===null||ctx===void 0?void 0:ctx.setContain;$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){setContain===null||setContain===void 0?void 0:setContain(true);},[setContain]);}var $f23889fffbde9058$exports={};$f23889fffbde9058$exports={"calendar":"\u0627\u0644\u062A\u0642\u0648\u064A\u0645","day":"\u064A\u0648\u0645","dayPeriod":"\u0635/\u0645","endDate":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621","era":"\u0627\u0644\u0639\u0635\u0631","hour":"\u0627\u0644\u0633\u0627\u0639\u0627\u062A","minute":"\u0627\u0644\u062F\u0642\u0627\u0626\u0642","month":"\u0627\u0644\u0634\u0647\u0631","second":"\u0627\u0644\u062B\u0648\u0627\u0646\u064A","selectedDateDescription":function selectedDateDescription(args){return"\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.startDate," \u0625\u0644\u0649 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.time);},"startDate":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","timeZoneName":"\u0627\u0644\u062A\u0648\u0642\u064A\u062A","weekday":"\u0627\u0644\u064A\u0648\u0645","year":"\u0627\u0644\u0633\u0646\u0629"};var $09d9badaa8903929$exports={};$09d9badaa8903929$exports={"calendar":"\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440","day":"\u0434\u0435\u043D","dayPeriod":"\u043F\u0440.\u043E\u0431./\u0441\u043B.\u043E\u0431.","endDate":"\u041A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430","era":"\u0435\u0440\u0430","hour":"\u0447\u0430\u0441","minute":"\u043C\u0438\u043D\u0443\u0442\u0430","month":"\u043C\u0435\u0441\u0435\u0446","second":"\u0441\u0435\u043A\u0443\u043D\u0434\u0430","selectedDateDescription":function selectedDateDescription(args){return"\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate," \u0434\u043E ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0432\u0440\u0435\u043C\u0435: ".concat(args.time);},"startDate":"\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0434\u0430\u0442\u0430","timeZoneName":"\u0447\u0430\u0441\u043E\u0432\u0430 \u0437\u043E\u043D\u0430","weekday":"\u0434\u0435\u043D \u043E\u0442 \u0441\u0435\u0434\u043C\u0438\u0446\u0430\u0442\u0430","year":"\u0433\u043E\u0434\u0438\u043D\u0430"};var $151b77e0fd711730$exports={};$151b77e0fd711730$exports={"calendar":"Kalend\xE1\u0159","day":"den","dayPeriod":"\u010D\xE1st dne","endDate":"Kone\u010Dn\xE9 datum","era":"letopo\u010Det","hour":"hodina","minute":"minuta","month":"m\u011Bs\xEDc","second":"sekunda","selectedDateDescription":function selectedDateDescription(args){return"Vybran\xE9 datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Vybran\xE9 obdob\xED: ".concat(args.startDate," a\u017E ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Vybran\xFD \u010Das: ".concat(args.time);},"startDate":"Po\u010D\xE1te\u010Dn\xED datum","timeZoneName":"\u010Dasov\xE9 p\xE1smo","weekday":"den v t\xFDdnu","year":"rok"};var $61915aa8630b90a2$exports={};$61915aa8630b90a2$exports={"calendar":"Kalender","day":"dag","dayPeriod":"AM/PM","endDate":"Slutdato","era":"\xE6ra","hour":"time","minute":"minut","month":"m\xE5ned","second":"sekund","selectedDateDescription":function selectedDateDescription(args){return"Valgt dato: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valgt interval: ".concat(args.startDate," til ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Valgt tidspunkt: ".concat(args.time);},"startDate":"Startdato","timeZoneName":"tidszone","weekday":"ugedag","year":"\xE5r"};var $35cea00159787840$exports={};$35cea00159787840$exports={"calendar":"Kalender","day":"Tag","dayPeriod":"Tagesh\xE4lfte","endDate":"Enddatum","era":"Epoche","hour":"Stunde","minute":"Minute","month":"Monat","second":"Sekunde","selectedDateDescription":function selectedDateDescription(args){return"Ausgew\xE4hltes Datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Ausgew\xE4hlter Bereich: ".concat(args.startDate," bis ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Ausgew\xE4hlte Zeit: ".concat(args.time);},"startDate":"Startdatum","timeZoneName":"Zeitzone","weekday":"Wochentag","year":"Jahr"};var $518b4e82b9eacafd$exports={};$518b4e82b9eacafd$exports={"calendar":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF","day":"\u03B7\u03BC\u03AD\u03C1\u03B1","dayPeriod":"\u03C0.\u03BC./\u03BC.\u03BC.","endDate":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2","era":"\u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2","hour":"\u03CE\u03C1\u03B1","minute":"\u03BB\u03B5\u03C0\u03C4\u03CC","month":"\u03BC\u03AE\u03BD\u03B1\u03C2","second":"\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF","selectedDateDescription":function selectedDateDescription(args){return"\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.startDate," \u03AD\u03C9\u03C2 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03CE\u03C1\u03B1: ".concat(args.time);},"startDate":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","timeZoneName":"\u03B6\u03CE\u03BD\u03B7 \u03CE\u03C1\u03B1\u03C2","weekday":"\u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE","year":"\u03AD\u03C4\u03BF\u03C2"};var $1c2b297f7e2cf474$exports={};$1c2b297f7e2cf474$exports={"era":"era","year":"year","month":"month","day":"day","hour":"hour","minute":"minute","second":"second","dayPeriod":"AM/PM","calendar":"Calendar","startDate":"Start Date","endDate":"End Date","weekday":"day of the week","timeZoneName":"time zone","selectedDateDescription":function selectedDateDescription(args){return"Selected Date: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Selected Range: ".concat(args.startDate," to ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Selected Time: ".concat(args.time);}};var $07f628a707cf9b18$exports={};$07f628a707cf9b18$exports={"calendar":"Calendario","day":"d\xEDa","dayPeriod":"a.\xA0m./p.\xA0m.","endDate":"Fecha final","era":"era","hour":"hora","minute":"minuto","month":"mes","second":"segundo","selectedDateDescription":function selectedDateDescription(args){return"Fecha seleccionada: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Rango seleccionado: ".concat(args.startDate," a ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Hora seleccionada: ".concat(args.time);},"startDate":"Fecha de inicio","timeZoneName":"zona horaria","weekday":"d\xEDa de la semana","year":"a\xF1o"};var $db553ffe17c7f4db$exports={};$db553ffe17c7f4db$exports={"calendar":"Kalender","day":"p\xE4ev","dayPeriod":"enne/p\xE4rast l\xF5unat","endDate":"L\xF5ppkuup\xE4ev","era":"ajastu","hour":"tund","minute":"minut","month":"kuu","second":"sekund","selectedDateDescription":function selectedDateDescription(args){return"Valitud kuup\xE4ev: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valitud vahemik: ".concat(args.startDate," kuni ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Valitud aeg: ".concat(args.time);},"startDate":"Alguskuup\xE4ev","timeZoneName":"ajav\xF6\xF6nd","weekday":"n\xE4dalap\xE4ev","year":"aasta"};var $4afcfe00cd703f83$exports={};$4afcfe00cd703f83$exports={"calendar":"Kalenteri","day":"p\xE4iv\xE4","dayPeriod":"vuorokaudenaika","endDate":"P\xE4\xE4ttymisp\xE4iv\xE4","era":"aikakausi","hour":"tunti","minute":"minuutti","month":"kuukausi","second":"sekunti","selectedDateDescription":function selectedDateDescription(args){return"Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valittu aikav\xE4li: ".concat(args.startDate," \u2013 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Valittu aika: ".concat(args.time);},"startDate":"Alkamisp\xE4iv\xE4","timeZoneName":"aikavy\xF6hyke","weekday":"viikonp\xE4iv\xE4","year":"vuosi"};var $1d2645d18d4c5be0$exports={};$1d2645d18d4c5be0$exports={"calendar":"Calendrier","day":"jour","dayPeriod":"cadran","endDate":"Date de fin","era":"\xE8re","hour":"heure","minute":"minute","month":"mois","second":"seconde","selectedDateDescription":function selectedDateDescription(args){return"Date s\xE9lectionn\xE9e\xA0: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Plage s\xE9lectionn\xE9e\xA0: ".concat(args.startDate," au ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Heure choisie\xA0: ".concat(args.time);},"startDate":"Date de d\xE9but","timeZoneName":"fuseau horaire","weekday":"jour de la semaine","year":"ann\xE9e"};var $64cb6a9be1f6fa48$exports={};$64cb6a9be1f6fa48$exports={"calendar":"\u05DC\u05D5\u05D7 \u05E9\u05E0\u05D4","day":"\u05D9\u05D5\u05DD","dayPeriod":"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6/\u05D0\u05D7\u05D4\u05F4\u05E6","endDate":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05E1\u05D9\u05D5\u05DD","era":"\u05EA\u05E7\u05D5\u05E4\u05D4","hour":"\u05E9\u05E2\u05D4","minute":"\u05D3\u05E7\u05D4","month":"\u05D7\u05D5\u05D3\u05E9","second":"\u05E9\u05E0\u05D9\u05D9\u05D4","selectedDateDescription":function selectedDateDescription(args){return"\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.startDate," \u05E2\u05D3 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u05D6\u05DE\u05DF \u05E0\u05D1\u05D7\u05E8: ".concat(args.time);},"startDate":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05EA\u05D7\u05DC\u05D4","timeZoneName":"\u05D0\u05D6\u05D5\u05E8 \u05D6\u05DE\u05DF","weekday":"\u05D9\u05D5\u05DD \u05D1\u05E9\u05D1\u05D5\u05E2","year":"\u05E9\u05E0\u05D4"};var $2a1ef2e8050be27a$exports={};$2a1ef2e8050be27a$exports={"calendar":"Kalendar","day":"dan","dayPeriod":"AM/PM","endDate":"Datum zavr\u0161etka","era":"era","hour":"sat","minute":"minuta","month":"mjesec","second":"sekunda","selectedDateDescription":function selectedDateDescription(args){return"Odabrani datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Odabrani raspon: ".concat(args.startDate," do ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Odabrano vrijeme: ".concat(args.time);},"startDate":"Datum po\u010Detka","timeZoneName":"vremenska zona","weekday":"dan u tjednu","year":"godina"};var $ad429dca102acd0e$exports={};$ad429dca102acd0e$exports={"calendar":"Napt\xE1r","day":"nap","dayPeriod":"napszak","endDate":"Befejez\u0151 d\xE1tum","era":"\xE9ra","hour":"\xF3ra","minute":"perc","month":"h\xF3nap","second":"m\xE1sodperc","selectedDateDescription":function selectedDateDescription(args){return"Kijel\xF6lt d\xE1tum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Kijel\xF6lt tartom\xE1ny: ".concat(args.startDate,"\u2013").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Kijel\xF6lt id\u0151: ".concat(args.time);},"startDate":"Kezd\u0151 d\xE1tum","timeZoneName":"id\u0151z\xF3na","weekday":"h\xE9t napja","year":"\xE9v"};var $6e68cb5d1cb97bd2$exports={};$6e68cb5d1cb97bd2$exports={"calendar":"Calendario","day":"giorno","dayPeriod":"AM/PM","endDate":"Data finale","era":"era","hour":"ora","minute":"minuto","month":"mese","second":"secondo","selectedDateDescription":function selectedDateDescription(args){return"Data selezionata: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervallo selezionato: da ".concat(args.startDate," a ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Ora selezionata: ".concat(args.time);},"startDate":"Data iniziale","timeZoneName":"fuso orario","weekday":"giorno della settimana","year":"anno"};var $a82ee9af063ee069$exports={};$a82ee9af063ee069$exports={"calendar":"\u30AB\u30EC\u30F3\u30C0\u30FC","day":"\u65E5","dayPeriod":"\u5348\u524D/\u5348\u5F8C","endDate":"\u7D42\u4E86\u65E5","era":"\u6642\u4EE3","hour":"\u6642","minute":"\u5206","month":"\u6708","second":"\u79D2","selectedDateDescription":function selectedDateDescription(args){return"\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u9078\u629E\u7BC4\u56F2 : ".concat(args.startDate," \u304B\u3089 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u9078\u629E\u3057\u305F\u6642\u9593 : ".concat(args.time);},"startDate":"\u958B\u59CB\u65E5","timeZoneName":"\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3","weekday":"\u66DC\u65E5","year":"\u5E74"};var $67e9091dbf37d4eb$exports={};$67e9091dbf37d4eb$exports={"calendar":"\uB2EC\uB825","day":"\uC77C","dayPeriod":"\uC624\uC804/\uC624\uD6C4","endDate":"\uC885\uB8CC\uC77C","era":"\uC5F0\uD638","hour":"\uC2DC","minute":"\uBD84","month":"\uC6D4","second":"\uCD08","selectedDateDescription":function selectedDateDescription(args){return"\uC120\uD0DD \uC77C\uC790: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\uC120\uD0DD \uBC94\uC704: ".concat(args.startDate," ~ ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\uC120\uD0DD \uC2DC\uAC04: ".concat(args.time);},"startDate":"\uC2DC\uC791\uC77C","timeZoneName":"\uC2DC\uAC04\uB300","weekday":"\uC694\uC77C","year":"\uB144"};var $75834f9729f653d1$exports={};$75834f9729f653d1$exports={"calendar":"Kalendorius","day":"diena","dayPeriod":"iki piet\u0173 / po piet\u0173","endDate":"Pabaigos data","era":"era","hour":"valanda","minute":"minut\u0117","month":"m\u0117nuo","second":"sekund\u0117","selectedDateDescription":function selectedDateDescription(args){return"Pasirinkta data: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Pasirinktas intervalas: nuo ".concat(args.startDate," iki ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Pasirinktas laikas: ".concat(args.time);},"startDate":"Prad\u017Eios data","timeZoneName":"laiko juosta","weekday":"savait\u0117s diena","year":"metai"};var $a2df2c2520b4a7f0$exports={};$a2df2c2520b4a7f0$exports={"calendar":"Kalend\u0101rs","day":"diena","dayPeriod":"priek\u0161pusdien\u0101/p\u0113cpusdien\u0101","endDate":"Beigu datums","era":"\u0113ra","hour":"stundas","minute":"min\u016Btes","month":"m\u0113nesis","second":"sekundes","selectedDateDescription":function selectedDateDescription(args){return"Atlas\u012Btais datums: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Atlas\u012Btais diapazons: no ".concat(args.startDate," l\u012Bdz ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Atlas\u012Btais laiks: ".concat(args.time);},"startDate":"S\u0101kuma datums","timeZoneName":"laika josla","weekday":"ned\u0113\u013Cas diena","year":"gads"};var $aedcd71db4933ed5$exports={};$aedcd71db4933ed5$exports={"calendar":"Kalender","day":"dag","dayPeriod":"a.m./p.m.","endDate":"Sluttdato","era":"tidsalder","hour":"time","minute":"minutt","month":"m\xE5ned","second":"sekund","selectedDateDescription":function selectedDateDescription(args){return"Valgt dato: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valgt omr\xE5de: ".concat(args.startDate," til ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Valgt tid: ".concat(args.time);},"startDate":"Startdato","timeZoneName":"tidssone","weekday":"ukedag","year":"\xE5r"};var $3b2df9e54353046c$exports={};$3b2df9e54353046c$exports={"calendar":"Kalender","day":"dag","dayPeriod":"a.m./p.m.","endDate":"Einddatum","era":"tijdperk","hour":"uur","minute":"minuut","month":"maand","second":"seconde","selectedDateDescription":function selectedDateDescription(args){return"Geselecteerde datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Geselecteerd bereik: ".concat(args.startDate," tot ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Geselecteerde tijd: ".concat(args.time);},"startDate":"Startdatum","timeZoneName":"tijdzone","weekday":"dag van de week","year":"jaar"};var $c03fe977fcfafe93$exports={};$c03fe977fcfafe93$exports={"calendar":"Kalendarz","day":"dzie\u0144","dayPeriod":"rano / po po\u0142udniu / wieczorem","endDate":"Data ko\u0144cowa","era":"era","hour":"godzina","minute":"minuta","month":"miesi\u0105c","second":"sekunda","selectedDateDescription":function selectedDateDescription(args){return"Wybrana data: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Wybrany zakres: ".concat(args.startDate," do ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Wybrany czas: ".concat(args.time);},"startDate":"Data pocz\u0105tkowa","timeZoneName":"strefa czasowa","weekday":"dzie\u0144 tygodnia","year":"rok"};var $569f006fc292345f$exports={};$569f006fc292345f$exports={"calendar":"Calend\xE1rio","day":"dia","dayPeriod":"AM/PM","endDate":"Data final","era":"era","hour":"hora","minute":"minuto","month":"m\xEAs","second":"segundo","selectedDateDescription":function selectedDateDescription(args){return"Data selecionada: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervalo selecionado: ".concat(args.startDate," a ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Hora selecionada: ".concat(args.time);},"startDate":"Data inicial","timeZoneName":"fuso hor\xE1rio","weekday":"dia da semana","year":"ano"};var $7c2494e14452f2dd$exports={};$7c2494e14452f2dd$exports={"calendar":"Calend\xE1rio","day":"dia","dayPeriod":"am/pm","endDate":"Data de T\xE9rmino","era":"era","hour":"hora","minute":"minuto","month":"m\xEAs","second":"segundo","selectedDateDescription":function selectedDateDescription(args){return"Data selecionada: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Intervalo selecionado: ".concat(args.startDate," a ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Hora selecionada: ".concat(args.time);},"startDate":"Data de In\xEDcio","timeZoneName":"fuso hor\xE1rio","weekday":"dia da semana","year":"ano"};var $eb82ef981b5592bf$exports={};$eb82ef981b5592bf$exports={"calendar":"Calendar","day":"zi","dayPeriod":"a.m/p.m.","endDate":"Dat\u0103 final","era":"er\u0103","hour":"or\u0103","minute":"minut","month":"lun\u0103","second":"secund\u0103","selectedDateDescription":function selectedDateDescription(args){return"Dat\u0103 selectat\u0103: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Interval selectat: de la ".concat(args.startDate," p\xE2n\u0103 la ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Ora selectat\u0103: ".concat(args.time);},"startDate":"Dat\u0103 \xEEnceput","timeZoneName":"fus orar","weekday":"ziua din s\u0103pt\u0103m\xE2n\u0103","year":"an"};var $6efa0e119f396950$exports={};$6efa0e119f396950$exports={"calendar":"\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C","day":"\u0434\u0435\u043D\u044C","dayPeriod":"AM/PM","endDate":"\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F","era":"\u044D\u0440\u0430","hour":"\u0447\u0430\u0441","minute":"\u043C\u0438\u043D\u0443\u0442\u0430","month":"\u043C\u0435\u0441\u044F\u0446","second":"\u0441\u0435\u043A\u0443\u043D\u0434\u0430","selectedDateDescription":function selectedDateDescription(args){return"\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: \u0441 ".concat(args.startDate," \u043F\u043E ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F: ".concat(args.time);},"startDate":"\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430","timeZoneName":"\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441","weekday":"\u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438","year":"\u0433\u043E\u0434"};var $7f5e57085d7f5049$exports={};$7f5e57085d7f5049$exports={"calendar":"Kalend\xE1r","day":"de\u0148","dayPeriod":"AM/PM","endDate":"D\xE1tum ukon\u010Denia","era":"letopo\u010Det","hour":"hodina","minute":"min\xFAta","month":"mesiac","second":"sekunda","selectedDateDescription":function selectedDateDescription(args){return"Vybrat\xFD d\xE1tum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Vybrat\xFD rozsah: od ".concat(args.startDate," do ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Vybrat\xFD \u010Das: ".concat(args.time);},"startDate":"D\xE1tum za\u010Datia","timeZoneName":"\u010Dasov\xE9 p\xE1smo","weekday":"de\u0148 t\xFD\u017Ed\u0148a","year":"rok"};var $578ee7c11dcdde7a$exports={};$578ee7c11dcdde7a$exports={"calendar":"Koledar","day":"dan","dayPeriod":"dop/pop","endDate":"Datum konca","era":"doba","hour":"ura","minute":"minuta","month":"mesec","second":"sekunda","selectedDateDescription":function selectedDateDescription(args){return"Izbrani datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Izbrano obmo\u010Dje: ".concat(args.startDate," do ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Izbrani \u010Das: ".concat(args.time);},"startDate":"Datum za\u010Detka","timeZoneName":"\u010Dasovni pas","weekday":"dan v tednu","year":"leto"};var $bbc3fd6cd0bc9d50$exports={};$bbc3fd6cd0bc9d50$exports={"calendar":"Kalendar","day":"\u0434\u0430\u043D","dayPeriod":"\u043F\u0440\u0435 \u043F\u043E\u0434\u043D\u0435/\u043F\u043E \u043F\u043E\u0434\u043D\u0435","endDate":"Datum zavr\u0161etka","era":"\u0435\u0440\u0430","hour":"\u0441\u0430\u0442","minute":"\u043C\u0438\u043D\u0443\u0442","month":"\u043C\u0435\u0441\u0435\u0446","second":"\u0441\u0435\u043A\u0443\u043D\u0434","selectedDateDescription":function selectedDateDescription(args){return"Izabrani datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Izabrani opseg: od ".concat(args.startDate," do ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Izabrano vreme: ".concat(args.time);},"startDate":"Datum po\u010Detka","timeZoneName":"\u0432\u0440\u0435\u043C\u0435\u043D\u0441\u043A\u0430 \u0437\u043E\u043D\u0430","weekday":"\u0434\u0430\u043D \u0443 \u043D\u0435\u0434\u0435\u0459\u0438","year":"\u0433\u043E\u0434\u0438\u043D\u0430"};var $0b04512118591d2a$exports={};$0b04512118591d2a$exports={"calendar":"Kalender","day":"dag","dayPeriod":"fm/em","endDate":"Slutdatum","era":"era","hour":"timme","minute":"minut","month":"m\xE5nad","second":"sekund","selectedDateDescription":function selectedDateDescription(args){return"Valt datum: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Valt intervall: ".concat(args.startDate," till ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Vald tid: ".concat(args.time);},"startDate":"Startdatum","timeZoneName":"tidszon","weekday":"veckodag","year":"\xE5r"};var $3a49d121fe4c9e1d$exports={};$3a49d121fe4c9e1d$exports={"calendar":"Takvim","day":"g\xFCn","dayPeriod":"\xD6\xD6/\xD6S","endDate":"Biti\u015F Tarihi","era":"\xE7a\u011F","hour":"saat","minute":"dakika","month":"ay","second":"saniye","selectedDateDescription":function selectedDateDescription(args){return"Se\xE7ilen Tarih: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"Se\xE7ilen Aral\u0131k: ".concat(args.startDate," - ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"Se\xE7ilen Zaman: ".concat(args.time);},"startDate":"Ba\u015Flang\u0131\xE7 Tarihi","timeZoneName":"saat dilimi","weekday":"haftan\u0131n g\xFCn\xFC","year":"y\u0131l"};var $5ba21dbb8914919d$exports={};$5ba21dbb8914919d$exports={"calendar":"\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440","day":"\u0434\u0435\u043D\u044C","dayPeriod":"\u0434\u043F/\u043F\u043F","endDate":"\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F","era":"\u0435\u0440\u0430","hour":"\u0433\u043E\u0434\u0438\u043D\u0430","minute":"\u0445\u0432\u0438\u043B\u0438\u043D\u0430","month":"\u043C\u0456\u0441\u044F\u0446\u044C","second":"\u0441\u0435\u043A\u0443\u043D\u0434\u0430","selectedDateDescription":function selectedDateDescription(args){return"\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate," \u2014 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0447\u0430\u0441: ".concat(args.time);},"startDate":"\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443","timeZoneName":"\u0447\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441","weekday":"\u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F","year":"\u0440\u0456\u043A"};var $51078838e1b16cd7$exports={};$51078838e1b16cd7$exports={"calendar":"\u65E5\u5386","day":"\u65E5","dayPeriod":"\u4E0A\u5348/\u4E0B\u5348","endDate":"\u7ED3\u675F\u65E5\u671F","era":"\u7EAA\u5143","hour":"\u5C0F\u65F6","minute":"\u5206\u949F","month":"\u6708","second":"\u79D2","selectedDateDescription":function selectedDateDescription(args){return"\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.startDate," \u81F3 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u9009\u5B9A\u7684\u65F6\u95F4\uFF1A".concat(args.time);},"startDate":"\u5F00\u59CB\u65E5\u671F","timeZoneName":"\u65F6\u533A","weekday":"\u5DE5\u4F5C\u65E5","year":"\u5E74"};var $33fab8219207655a$exports={};$33fab8219207655a$exports={"calendar":"\u65E5\u66C6","day":"\u65E5","dayPeriod":"\u4E0A\u5348/\u4E0B\u5348","endDate":"\u7D50\u675F\u65E5\u671F","era":"\u7EAA\u5143","hour":"\u5C0F\u65F6","minute":"\u5206\u949F","month":"\u6708","second":"\u79D2","selectedDateDescription":function selectedDateDescription(args){return"\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);},"selectedRangeDescription":function selectedRangeDescription(args){return"\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.startDate," \u81F3 ").concat(args.endDate);},"selectedTimeDescription":function selectedTimeDescription(args){return"\u9078\u5B9A\u7684\u6642\u9593\uFF1A".concat(args.time);},"startDate":"\u958B\u59CB\u65E5\u671F","timeZoneName":"\u65F6\u533A","weekday":"\u5DE5\u4F5C\u65E5","year":"\u5E74"};var $dfb4eba373ed9493$exports={};$dfb4eba373ed9493$exports={"ar-AE":$f23889fffbde9058$exports,"bg-BG":$09d9badaa8903929$exports,"cs-CZ":$151b77e0fd711730$exports,"da-DK":$61915aa8630b90a2$exports,"de-DE":$35cea00159787840$exports,"el-GR":$518b4e82b9eacafd$exports,"en-US":$1c2b297f7e2cf474$exports,"es-ES":$07f628a707cf9b18$exports,"et-EE":$db553ffe17c7f4db$exports,"fi-FI":$4afcfe00cd703f83$exports,"fr-FR":$1d2645d18d4c5be0$exports,"he-IL":$64cb6a9be1f6fa48$exports,"hr-HR":$2a1ef2e8050be27a$exports,"hu-HU":$ad429dca102acd0e$exports,"it-IT":$6e68cb5d1cb97bd2$exports,"ja-JP":$a82ee9af063ee069$exports,"ko-KR":$67e9091dbf37d4eb$exports,"lt-LT":$75834f9729f653d1$exports,"lv-LV":$a2df2c2520b4a7f0$exports,"nb-NO":$aedcd71db4933ed5$exports,"nl-NL":$3b2df9e54353046c$exports,"pl-PL":$c03fe977fcfafe93$exports,"pt-BR":$569f006fc292345f$exports,"pt-PT":$7c2494e14452f2dd$exports,"ro-RO":$eb82ef981b5592bf$exports,"ru-RU":$6efa0e119f396950$exports,"sk-SK":$7f5e57085d7f5049$exports,"sl-SI":$578ee7c11dcdde7a$exports,"sr-SP":$bbc3fd6cd0bc9d50$exports,"sv-SE":$0b04512118591d2a$exports,"tr-TR":$3a49d121fe4c9e1d$exports,"uk-UA":$5ba21dbb8914919d$exports,"zh-CN":$51078838e1b16cd7$exports,"zh-TW":$33fab8219207655a$exports};function $3dfb0f96be0d6a08$export$4a931266a3838b86(state,ref,disableArrowNavigation){var _$18f2051aff69b9bf$ex7=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),direction=_$18f2051aff69b9bf$ex7.direction;var focusManager=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $9bf71ea28793e738$export$c5251b9e124bf29(ref);},[ref]);var onKeyDown=function onKeyDown(e2){if(!e2.currentTarget.contains(e2.target))return;if(e2.altKey&&(e2.key==="ArrowDown"||e2.key==="ArrowUp")&&"setOpen"in state){e2.preventDefault();e2.stopPropagation();state.setOpen(true);}if(disableArrowNavigation)return;switch(e2.key){case"ArrowLeft":e2.preventDefault();e2.stopPropagation();if(direction==="rtl"){if(ref.current){var target=e2.target;var prev=$3dfb0f96be0d6a08$var$findNextSegment(ref.current,target.getBoundingClientRect().left,-1);if(prev)prev.focus();}}else focusManager.focusPrevious();break;case"ArrowRight":e2.preventDefault();e2.stopPropagation();if(direction==="rtl"){if(ref.current){var _target=e2.target;var next=$3dfb0f96be0d6a08$var$findNextSegment(ref.current,_target.getBoundingClientRect().left,1);if(next)next.focus();}}else focusManager.focusNext();break;}};var focusLast=function focusLast(){var _window_event;if(!ref.current)return;var target=(_window_event=window.event)===null||_window_event===void 0?void 0:_window_event.target;var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current,{tabbable:true});if(target){walker.currentNode=target;target=walker.previousNode();}if(!target){var _last;do{_last=walker.lastChild();if(_last)target=_last;}while(_last);}while(target===null||target===void 0?void 0:target.hasAttribute("data-placeholder")){var prev=walker.previousNode();if(prev&&prev.hasAttribute("data-placeholder"))target=prev;else break;}if(target)target.focus();};var _$f6c31cce2adf654f$ex3=$f6c31cce2adf654f$export$45712eceda6fad21({preventFocusOnPress:true,allowTextSelectionOnPress:true,onPressStart:function onPressStart(e2){if(e2.pointerType==="mouse")focusLast();},onPress:function onPress(e2){if(e2.pointerType==="touch"||e2.pointerType==="pen")focusLast();}}),pressProps=_$f6c31cce2adf654f$ex3.pressProps;return $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps,{onKeyDown:onKeyDown});}function $3dfb0f96be0d6a08$var$findNextSegment(group,fromX,direction){var walker=$9bf71ea28793e738$export$2d6ec8fc375ceafa(group,{tabbable:true});var node=walker.nextNode();var closest=null;var closestDistance=Infinity;while(node){var _x2=node.getBoundingClientRect().left;var distance=_x2-fromX;var absoluteDistance=Math.abs(distance);if(Math.sign(distance)===direction&&absoluteDistance<closestDistance){closest=node;closestDistance=absoluteDistance;}node=walker.nextNode();}return closest;}function $parcel$interopDefault$3(a){return a&&a.__esModule?a["default"]:a;}var $16f0b7bb276bc17e$export$653eddfc964b0f8a=/* @__PURE__ */new WeakMap();var $16f0b7bb276bc17e$export$300019f83c56d282="__role_"+Date.now();var $16f0b7bb276bc17e$export$7b3062cd49e80452="__focusManager_"+Date.now();function $16f0b7bb276bc17e$export$5591b0b878c1a989(props,state,ref){var _state_value;var _state$displayValidat=state.displayValidation,isInvalid=_state$displayValidat.isInvalid,validationErrors=_state$displayValidat.validationErrors,validationDetails=_state$displayValidat.validationDetails;var _$2baaea4c71418dea$ex=$2baaea4c71418dea$export$294aa081a6c6f55d(__spreadProps(__spreadValues({},props),{labelElementType:"span",isInvalid:isInvalid,errorMessage:props.errorMessage||validationErrors})),labelProps=_$2baaea4c71418dea$ex.labelProps,fieldProps=_$2baaea4c71418dea$ex.fieldProps,descriptionProps=_$2baaea4c71418dea$ex.descriptionProps,errorMessageProps=_$2baaea4c71418dea$ex.errorMessageProps;var valueOnFocus=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$9ab94262bd0047c7$ex3=$9ab94262bd0047c7$export$420e68273165f4ec(__spreadProps(__spreadValues({},props),{onFocusWithin:function onFocusWithin(e2){var _props_onFocus;valueOnFocus.current=state.value;(_props_onFocus=props.onFocus)===null||_props_onFocus===void 0?void 0:_props_onFocus.call(props,e2);},onBlurWithin:function onBlurWithin(e2){var _props_onBlur;state.confirmPlaceholder();if(state.value!==valueOnFocus.current)state.commitValidation();(_props_onBlur=props.onBlur)===null||_props_onBlur===void 0?void 0:_props_onBlur.call(props,e2);},onFocusWithinChange:props.onFocusChange})),focusWithinProps=_$9ab94262bd0047c7$ex3.focusWithinProps;var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$3($dfb4eba373ed9493$exports),"@react-aria/datepicker");var message=state.maxGranularity==="hour"?"selectedTimeDescription":"selectedDateDescription";var field=state.maxGranularity==="hour"?"time":"date";var description=state.value?stringFormatter.format(message,_defineProperty2({},field,state.formatValue({month:"long"}))):"";var descProps=$ef06256079686ba0$export$f8aeda7b10753fa1(description);var describedBy=props[$16f0b7bb276bc17e$export$300019f83c56d282]==="presentation"?fieldProps["aria-describedby"]:[descProps["aria-describedby"],fieldProps["aria-describedby"]].filter(Boolean).join(" ")||void 0;var propsFocusManager=props[$16f0b7bb276bc17e$export$7b3062cd49e80452];var focusManager=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return propsFocusManager||$9bf71ea28793e738$export$c5251b9e124bf29(ref);},[propsFocusManager,ref]);var groupProps=$3dfb0f96be0d6a08$export$4a931266a3838b86(state,ref,props[$16f0b7bb276bc17e$export$300019f83c56d282]==="presentation");$16f0b7bb276bc17e$export$653eddfc964b0f8a.set(state,{ariaLabel:props["aria-label"],ariaLabelledBy:[labelProps.id,props["aria-labelledby"]].filter(Boolean).join(" ")||void 0,ariaDescribedBy:describedBy,focusManager:focusManager});var autoFocusRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.autoFocus);var fieldDOMProps;if(props[$16f0b7bb276bc17e$export$300019f83c56d282]==="presentation")fieldDOMProps={role:"presentation"};else fieldDOMProps=$3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps,{role:"group","aria-disabled":props.isDisabled||void 0,"aria-describedby":describedBy});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(autoFocusRef.current)focusManager.focusFirst();autoFocusRef.current=false;},[focusManager]);$99facab73266f662$export$5add1d006293d136(props.inputRef,state.defaultValue,state.setValue);$e93e671b31057976$export$b8473d3665f3a75a(__spreadProps(__spreadValues({},props),{focus:function focus(){focusManager.focusFirst();}}),state,props.inputRef);var inputProps={type:"hidden",name:props.name,form:props.form,value:((_state_value=state.value)===null||_state_value===void 0?void 0:_state_value.toString())||"",disabled:props.isDisabled};if(props.validationBehavior==="native"){inputProps.type="text";inputProps.hidden=true;inputProps.required=props.isRequired;inputProps.onChange=function(){};}var domProps=$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);return{labelProps:__spreadProps(__spreadValues({},labelProps),{onClick:function onClick(){focusManager.focusFirst();}}),fieldProps:$3ef42575df84b30b$export$9d1611c77c2fe928(domProps,fieldDOMProps,groupProps,focusWithinProps,{onKeyDown:function onKeyDown(e2){if(props.onKeyDown)props.onKeyDown(e2);},onKeyUp:function onKeyUp(e2){if(props.onKeyUp)props.onKeyUp(e2);},style:{unicodeBidi:"isolate"}}),inputProps:inputProps,descriptionProps:descriptionProps,errorMessageProps:errorMessageProps,isInvalid:isInvalid,validationErrors:validationErrors,validationDetails:validationDetails};}function $parcel$interopDefault$2(a){return a&&a.__esModule?a["default"]:a;}function $6057a3d2a53a12fd$export$42df105a73306d51(props,state,ref){var _spreadProps;var buttonId=$bdb11010cef70236$export$f680877a34711e37();var dialogId=$bdb11010cef70236$export$f680877a34711e37();var fieldId=$bdb11010cef70236$export$f680877a34711e37();var stringFormatter=$fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$2($dfb4eba373ed9493$exports),"@react-aria/datepicker");var _state$displayValidat2=state.displayValidation,isInvalid=_state$displayValidat2.isInvalid,validationErrors=_state$displayValidat2.validationErrors,validationDetails=_state$displayValidat2.validationDetails;var _$2baaea4c71418dea$ex2=$2baaea4c71418dea$export$294aa081a6c6f55d(__spreadProps(__spreadValues({},props),{labelElementType:"span",isInvalid:isInvalid,errorMessage:props.errorMessage||validationErrors})),labelProps=_$2baaea4c71418dea$ex2.labelProps,fieldProps=_$2baaea4c71418dea$ex2.fieldProps,descriptionProps=_$2baaea4c71418dea$ex2.descriptionProps,errorMessageProps=_$2baaea4c71418dea$ex2.errorMessageProps;var groupProps=$3dfb0f96be0d6a08$export$4a931266a3838b86(state,ref);var labelledBy=fieldProps["aria-labelledby"]||fieldProps.id;var _$18f2051aff69b9bf$ex8=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex8.locale;var date=state.formatValue(locale,{month:"long"});var description=date?stringFormatter.format("selectedDateDescription",{date:date}):"";var descProps=$ef06256079686ba0$export$f8aeda7b10753fa1(description);var ariaDescribedBy=[descProps["aria-describedby"],fieldProps["aria-describedby"]].filter(Boolean).join(" ")||void 0;var domProps=$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);var focusManager=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $9bf71ea28793e738$export$c5251b9e124bf29(ref);},[ref]);var isFocused=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);var _$9ab94262bd0047c7$ex4=$9ab94262bd0047c7$export$420e68273165f4ec(__spreadProps(__spreadValues({},props),{isDisabled:state.isOpen,onBlurWithin:function onBlurWithin(e2){var dialog=document.getElementById(dialogId);if(!(dialog===null||dialog===void 0?void 0:dialog.contains(e2.relatedTarget))){var _props_onBlur,_props_onFocusChange;isFocused.current=false;(_props_onBlur=props.onBlur)===null||_props_onBlur===void 0?void 0:_props_onBlur.call(props,e2);(_props_onFocusChange=props.onFocusChange)===null||_props_onFocusChange===void 0?void 0:_props_onFocusChange.call(props,false);}},onFocusWithin:function onFocusWithin(e2){if(!isFocused.current){var _props_onFocus,_props_onFocusChange;isFocused.current=true;(_props_onFocus=props.onFocus)===null||_props_onFocus===void 0?void 0:_props_onFocus.call(props,e2);(_props_onFocusChange=props.onFocusChange)===null||_props_onFocusChange===void 0?void 0:_props_onFocusChange.call(props,true);}}})),focusWithinProps=_$9ab94262bd0047c7$ex4.focusWithinProps;return{groupProps:$3ef42575df84b30b$export$9d1611c77c2fe928(domProps,groupProps,fieldProps,descProps,focusWithinProps,{role:"group","aria-disabled":props.isDisabled||null,"aria-labelledby":labelledBy,"aria-describedby":ariaDescribedBy,onKeyDown:function onKeyDown(e2){if(state.isOpen)return;if(props.onKeyDown)props.onKeyDown(e2);},onKeyUp:function onKeyUp(e2){if(state.isOpen)return;if(props.onKeyUp)props.onKeyUp(e2);}}),labelProps:__spreadProps(__spreadValues({},labelProps),{onClick:function onClick(){focusManager.focusFirst();}}),fieldProps:__spreadProps(__spreadValues({},fieldProps),(_spreadProps={id:fieldId},_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_spreadProps,$16f0b7bb276bc17e$export$300019f83c56d282,"presentation"),"aria-describedby",ariaDescribedBy),"value",state.value),"defaultValue",state.defaultValue),"onChange",state.setValue),"placeholderValue",props.placeholderValue),"hideTimeZone",props.hideTimeZone),"hourCycle",props.hourCycle),"shouldForceLeadingZeros",props.shouldForceLeadingZeros),"granularity",props.granularity),_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_spreadProps,"isDisabled",props.isDisabled),"isReadOnly",props.isReadOnly),"isRequired",props.isRequired),"validationBehavior",props.validationBehavior),$e5be200c675c3b3a$export$a763b9476acd3eb,state),"autoFocus",props.autoFocus),"name",props.name),"form",props.form))),descriptionProps:descriptionProps,errorMessageProps:errorMessageProps,buttonProps:__spreadProps(__spreadValues({},descProps),{id:buttonId,"aria-haspopup":"dialog","aria-label":stringFormatter.format("calendar"),"aria-labelledby":"".concat(buttonId," ").concat(labelledBy),"aria-describedby":ariaDescribedBy,"aria-expanded":state.isOpen,isDisabled:props.isDisabled||props.isReadOnly,onPress:function onPress(){return state.setOpen(true);}}),dialogProps:{id:dialogId,"aria-labelledby":"".concat(buttonId," ").concat(labelledBy)},calendarProps:{autoFocus:true,value:state.dateValue,onChange:state.setDateValue,minValue:props.minValue,maxValue:props.maxValue,isDisabled:props.isDisabled,isReadOnly:props.isReadOnly,isDateUnavailable:props.isDateUnavailable,defaultFocusedValue:state.dateValue?void 0:props.placeholderValue,isInvalid:state.isInvalid,errorMessage:typeof props.errorMessage==="function"?props.errorMessage(state.displayValidation):props.errorMessage||state.displayValidation.validationErrors.join(" "),firstDayOfWeek:props.firstDayOfWeek,pageBehavior:props.pageBehavior},isInvalid:isInvalid,validationErrors:validationErrors,validationDetails:validationDetails};}function $parcel$interopDefault$1(a){return a&&a.__esModule?a["default"]:a;}function $3aeceb3a64eb8358$export$d42c60378c8168f8(){var _$18f2051aff69b9bf$ex9=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex9.locale;var dictionary=$fca6afa0e843324b$export$87b761675e8eaa10($parcel$interopDefault$1($dfb4eba373ed9493$exports),"@react-aria/datepicker");return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){try{return new Intl.DisplayNames(locale,{type:"dateTimeField"});}catch(_unused7){return new $3aeceb3a64eb8358$var$DisplayNamesPolyfill(locale,dictionary);}},[locale,dictionary]);}var $3aeceb3a64eb8358$var$DisplayNamesPolyfill=/*#__PURE__*/function(){function $3aeceb3a64eb8358$var$DisplayNamesPolyfill(locale,dictionary){_classCallCheck3(this,$3aeceb3a64eb8358$var$DisplayNamesPolyfill);this.locale=locale;this.dictionary=dictionary;}return _createClass3($3aeceb3a64eb8358$var$DisplayNamesPolyfill,[{key:"of",value:function of(field){return this.dictionary.getStringForLocale(field,this.locale);}}]);}();function $32489daedd52963e$export$1315d136e6f7581(segment,state,ref){var enteredKeys=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])("");var _$18f2051aff69b9bf$ex0=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex0.locale,direction=_$18f2051aff69b9bf$ex0.direction;var displayNames=$3aeceb3a64eb8358$export$d42c60378c8168f8();var _$16f0b7bb276bc17e$ex=$16f0b7bb276bc17e$export$653eddfc964b0f8a.get(state),ariaLabel=_$16f0b7bb276bc17e$ex.ariaLabel,ariaLabelledBy=_$16f0b7bb276bc17e$ex.ariaLabelledBy,ariaDescribedBy=_$16f0b7bb276bc17e$ex.ariaDescribedBy,focusManager=_$16f0b7bb276bc17e$ex.focusManager;var textValue=segment.isPlaceholder?"":segment.text;var options=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return state.dateFormatter.resolvedOptions();},[state.dateFormatter]);var monthDateFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({month:"long",timeZone:options.timeZone});var hourDateFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({hour:"numeric",hour12:options.hour12,timeZone:options.timeZone});if(segment.type==="month"&&!segment.isPlaceholder){var monthTextValue=monthDateFormatter.format(state.dateValue);textValue=monthTextValue!==textValue?"".concat(textValue," \u2013 ").concat(monthTextValue):monthTextValue;}else if(segment.type==="hour"&&!segment.isPlaceholder)textValue=hourDateFormatter.format(state.dateValue);var _$d2e8511e6f209edf$ex=$d2e8511e6f209edf$export$e908e06f4b8e3402({value:segment.value,textValue:textValue,minValue:segment.minValue,maxValue:segment.maxValue,isDisabled:state.isDisabled,isReadOnly:state.isReadOnly||!segment.isEditable,isRequired:state.isRequired,onIncrement:function onIncrement(){enteredKeys.current="";state.increment(segment.type);},onDecrement:function onDecrement(){enteredKeys.current="";state.decrement(segment.type);},onIncrementPage:function onIncrementPage(){enteredKeys.current="";state.incrementPage(segment.type);},onDecrementPage:function onDecrementPage(){enteredKeys.current="";state.decrementPage(segment.type);},onIncrementToMax:function onIncrementToMax(){enteredKeys.current="";if(segment.maxValue!==void 0)state.setSegment(segment.type,segment.maxValue);},onDecrementToMin:function onDecrementToMin(){enteredKeys.current="";if(segment.minValue!==void 0)state.setSegment(segment.type,segment.minValue);}}),spinButtonProps=_$d2e8511e6f209edf$ex.spinButtonProps;var parser=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $6c7bd7858deea686$export$cd11ab140839f11d(locale,{maximumFractionDigits:0});},[locale]);var backspace=function backspace(){if(segment.text===segment.placeholder)focusManager.focusPrevious();if(parser.isValidPartialNumber(segment.text)&&!state.isReadOnly&&!segment.isPlaceholder){var newValue=segment.text.slice(0,-1);var parsed=parser.parse(newValue);newValue=parsed===0?"":newValue;if(newValue.length===0||parsed===0)state.clearSegment(segment.type);else state.setSegment(segment.type,parsed);enteredKeys.current=newValue;}else if(segment.type==="dayPeriod")state.clearSegment(segment.type);};var onKeyDown=function onKeyDown(e2){if(e2.key==="a"&&($c87311424ea30a05$export$9ac100e40613ea10()?e2.metaKey:e2.ctrlKey))e2.preventDefault();if(e2.ctrlKey||e2.metaKey||e2.shiftKey||e2.altKey)return;switch(e2.key){case"Backspace":case"Delete":e2.preventDefault();e2.stopPropagation();backspace();break;}};var _$bb77f239b46e8c72$ex=$bb77f239b46e8c72$export$3274cf84b703fff({sensitivity:"base"}),startsWith=_$bb77f239b46e8c72$ex.startsWith;var amPmFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({hour:"numeric",hour12:true});var am=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var date=new Date();date.setHours(0);return amPmFormatter.formatToParts(date).find(function(part){return part.type==="dayPeriod";}).value;},[amPmFormatter]);var pm=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var date=new Date();date.setHours(12);return amPmFormatter.formatToParts(date).find(function(part){return part.type==="dayPeriod";}).value;},[amPmFormatter]);var eraFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({year:"numeric",era:"narrow",timeZone:"UTC"});var eras=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(segment.type!=="era")return[];var date=$11d87f3f76e88657$export$b4a036af3fc0b032(new $35ea8db9cb2ccb90$export$99faa760c7908e4f(1,1,1),state.calendar);var eras2=state.calendar.getEras().map(function(era){var eraDate=date.set({year:1,month:1,day:1,era:era}).toDate("UTC");var parts=eraFormatter.formatToParts(eraDate);var formatted=parts.find(function(p2){return p2.type==="era";}).value;return{era:era,formatted:formatted};});var prefixLength=$32489daedd52963e$var$commonPrefixLength(eras2.map(function(era){return era.formatted;}));if(prefixLength){var _iterator21=_createForOfIteratorHelper(eras2),_step21;try{for(_iterator21.s();!(_step21=_iterator21.n()).done;){var era=_step21.value;era.formatted=era.formatted.slice(prefixLength);}}catch(err){_iterator21.e(err);}finally{_iterator21.f();}}return eras2;},[eraFormatter,state.calendar,segment.type]);var onInput=function onInput(key2){if(state.isDisabled||state.isReadOnly)return;var newValue=enteredKeys.current+key2;switch(segment.type){case"dayPeriod":if(startsWith(am,key2))state.setSegment("dayPeriod",0);else if(startsWith(pm,key2))state.setSegment("dayPeriod",12);else break;focusManager.focusNext();break;case"era":{var matched=eras.find(function(e2){return startsWith(e2.formatted,key2);});if(matched){state.setSegment("era",matched.era);focusManager.focusNext();}break;}case"day":case"hour":case"minute":case"second":case"month":case"year":{if(!parser.isValidPartialNumber(newValue))return;var numberValue=parser.parse(newValue);var segmentValue=numberValue;var allowsZero=segment.minValue===0;if(segment.type==="hour"&&state.dateFormatter.resolvedOptions().hour12){switch(state.dateFormatter.resolvedOptions().hourCycle){case"h11":if(numberValue>11)segmentValue=parser.parse(key2);break;case"h12":allowsZero=false;if(numberValue>12)segmentValue=parser.parse(key2);break;}if(segment.value!==void 0&&segment.value>=12&&numberValue>1)numberValue+=12;}else if(segment.maxValue!==void 0&&numberValue>segment.maxValue)segmentValue=parser.parse(key2);if(isNaN(numberValue))return;var shouldSetValue=segmentValue!==0||allowsZero;if(shouldSetValue)state.setSegment(segment.type,segmentValue);if(segment.maxValue!==void 0&&(Number(numberValue+"0")>segment.maxValue||newValue.length>=String(segment.maxValue).length)){enteredKeys.current="";if(shouldSetValue)focusManager.focusNext();}else enteredKeys.current=newValue;break;}}};var onFocus=function onFocus(){enteredKeys.current="";if(ref.current)$2f04cbc44ee30ce0$export$c826860796309d1b(ref.current,{containingElement:$62d8ded9296f3872$export$cfa2225e87938781(ref.current)});var selection=window.getSelection();selection===null||selection===void 0?void 0:selection.collapse(ref.current);};var documentRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(typeof document!=="undefined"?document:null);$e9faafb641e167db$export$90fc3a17d93f704c(documentRef,"selectionchange",function(){var _ref_current;var selection=window.getSelection();if((selection===null||selection===void 0?void 0:selection.anchorNode)&&((_ref_current=ref.current)===null||_ref_current===void 0?void 0:_ref_current.contains(selection===null||selection===void 0?void 0:selection.anchorNode)))selection.collapse(ref.current);});var compositionRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])("");$e9faafb641e167db$export$90fc3a17d93f704c(ref,"beforeinput",function(e2){if(!ref.current)return;e2.preventDefault();switch(e2.inputType){case"deleteContentBackward":case"deleteContentForward":if(parser.isValidPartialNumber(segment.text)&&!state.isReadOnly)backspace();break;case"insertCompositionText":compositionRef.current=ref.current.textContent;ref.current.textContent=ref.current.textContent;break;default:if(e2.data!=null)onInput(e2.data);break;}});$e9faafb641e167db$export$90fc3a17d93f704c(ref,"input",function(e2){var inputType=e2.inputType,data=e2.data;switch(inputType){case"insertCompositionText":if(ref.current)ref.current.textContent=compositionRef.current;if(data!=null&&(startsWith(am,data)||startsWith(pm,data)))onInput(data);break;}});$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function(){var element=ref.current;return function(){if(document.activeElement===element){var prev=focusManager.focusPrevious();if(!prev)focusManager.focusNext();}};},[ref,focusManager]);var touchPropOverrides=$c87311424ea30a05$export$fedb369cb70207f1()||segment.type==="timeZoneName"?{role:"textbox","aria-valuemax":null,"aria-valuemin":null,"aria-valuetext":null,"aria-valuenow":null}:{};var firstSegment=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return state.segments.find(function(s){return s.isEditable;});},[state.segments]);if(segment!==firstSegment&&!state.isInvalid)ariaDescribedBy=void 0;var id=$bdb11010cef70236$export$f680877a34711e37();var isEditable=!state.isDisabled&&!state.isReadOnly&&segment.isEditable;var name=segment.type==="literal"?"":displayNames.of(segment.type);var labelProps=$313b98861ee5dd6c$export$d6875122194c7b44({"aria-label":"".concat(name).concat(ariaLabel?", ".concat(ariaLabel):"").concat(ariaLabelledBy?", ":""),"aria-labelledby":ariaLabelledBy});if(segment.type==="literal")return{segmentProps:{"aria-hidden":true}};var segmentStyle={caretColor:"transparent"};if(direction==="rtl"){segmentStyle.unicodeBidi="embed";var format=options[segment.type];if(format==="numeric"||format==="2-digit")segmentStyle.direction="ltr";}return{segmentProps:$3ef42575df84b30b$export$9d1611c77c2fe928(spinButtonProps,labelProps,__spreadProps(__spreadValues({id:id},touchPropOverrides),_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({"aria-invalid":state.isInvalid?"true":void 0,"aria-describedby":ariaDescribedBy,"aria-readonly":state.isReadOnly||!segment.isEditable?"true":void 0,"data-placeholder":segment.isPlaceholder||void 0,contentEditable:isEditable,suppressContentEditableWarning:isEditable,spellCheck:isEditable?"false":void 0,autoCorrect:isEditable?"off":void 0},parseInt(__WEBPACK_IMPORTED_MODULE_0_react___default.a.version,10)>=17?"enterKeyHint":"enterkeyhint",isEditable?"next":void 0),"inputMode",state.isDisabled||segment.type==="dayPeriod"||segment.type==="era"||!isEditable?void 0:"numeric"),"tabIndex",state.isDisabled?void 0:0),"onKeyDown",onKeyDown),"onFocus",onFocus),"style",segmentStyle),"onPointerDown",function onPointerDown(e2){e2.stopPropagation();}),"onMouseDown",function onMouseDown(e2){e2.stopPropagation();})))};}function $32489daedd52963e$var$commonPrefixLength(strings){strings.sort();var first=strings[0];var last=strings[strings.length-1];for(var _i12=0;_i12<first.length;_i12++){if(first[_i12]!==last[_i12])return _i12;}return 0;}function $40df3f8667284809$export$d55e7ee900f34e93(props,ref){var _props$role=props.role,role=_props$role===void 0?"dialog":_props$role;var titleId=$bdb11010cef70236$export$b4cc09c592e8fdb8();titleId=props["aria-label"]?void 0:titleId;var isRefocusing=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(ref.current&&!ref.current.contains(document.activeElement)){$3ad3f6e1647bc98d$export$80f3e147d781571c(ref.current);var timeout=setTimeout(function(){if(document.activeElement===ref.current||document.activeElement===document.body){isRefocusing.current=true;if(ref.current){ref.current.blur();$3ad3f6e1647bc98d$export$80f3e147d781571c(ref.current);}isRefocusing.current=false;}},500);return function(){clearTimeout(timeout);};}},[ref]);$337b884510726a0d$export$14c98a7594375490();return{dialogProps:__spreadProps(__spreadValues({},$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props,{labelable:true})),{role:role,tabIndex:-1,"aria-labelledby":props["aria-labelledby"]||titleId,onBlur:function onBlur(e2){if(isRefocusing.current)e2.stopPropagation();}}),titleProps:{id:titleId}};}function $f62d864046160412$export$eac50920cf2fd59a(date,minValue,maxValue){return minValue!=null&&date.compare(minValue)<0||maxValue!=null&&date.compare(maxValue)>0;}function $f62d864046160412$export$f4a51ff076cc9a09(date,duration,locale,minValue,maxValue){var halfDuration={};for(var key2 in duration){halfDuration[key2]=Math.floor(duration[key2]/2);if(halfDuration[key2]>0&&duration[key2]%2===0)halfDuration[key2]--;}var aligned=$f62d864046160412$export$144a00ba6044eb9(date,duration,locale).subtract(halfDuration);return $f62d864046160412$export$5bb865b12696a77d(date,aligned,duration,locale,minValue,maxValue);}function $f62d864046160412$export$144a00ba6044eb9(date,duration,locale,minValue,maxValue){var aligned=date;if(duration.years)aligned=$14e0f24ef4ac5c92$export$f91e89d3d0406102(date);else if(duration.months)aligned=$14e0f24ef4ac5c92$export$a5a3b454ada2268e(date);else if(duration.weeks)aligned=$14e0f24ef4ac5c92$export$42c81a444fbfb5d4(date,locale);return $f62d864046160412$export$5bb865b12696a77d(date,aligned,duration,locale,minValue,maxValue);}function $f62d864046160412$export$530edbfc915b2b04(date,duration,locale,minValue,maxValue){var d2=__spreadValues({},duration);if(d2.days)d2.days--;else if(d2.weeks)d2.weeks--;else if(d2.months)d2.months--;else if(d2.years)d2.years--;var aligned=$f62d864046160412$export$144a00ba6044eb9(date,duration,locale).subtract(d2);return $f62d864046160412$export$5bb865b12696a77d(date,aligned,duration,locale,minValue,maxValue);}function $f62d864046160412$export$5bb865b12696a77d(date,aligned,duration,locale,minValue,maxValue){if(minValue&&date.compare(minValue)>=0){var newDate=$14e0f24ef4ac5c92$export$a75f2bff57811055(aligned,$f62d864046160412$export$144a00ba6044eb9($11d87f3f76e88657$export$93522d1a439f3617(minValue),duration,locale));if(newDate)aligned=newDate;}if(maxValue&&date.compare(maxValue)<=0){var _newDate=$14e0f24ef4ac5c92$export$5c333a116e949cdd(aligned,$f62d864046160412$export$530edbfc915b2b04($11d87f3f76e88657$export$93522d1a439f3617(maxValue),duration,locale));if(_newDate)aligned=_newDate;}return aligned;}function $f62d864046160412$export$4f5203c0d889109e(date,minValue,maxValue){if(minValue){var newDate=$14e0f24ef4ac5c92$export$a75f2bff57811055(date,$11d87f3f76e88657$export$93522d1a439f3617(minValue));if(newDate)date=newDate;}if(maxValue){var _newDate2=$14e0f24ef4ac5c92$export$5c333a116e949cdd(date,$11d87f3f76e88657$export$93522d1a439f3617(maxValue));if(_newDate2)date=_newDate2;}return date;}function $f62d864046160412$export$a1d3911297b952d7(date,minValue,isDateUnavailable){if(!isDateUnavailable)return date;while(date.compare(minValue)>=0&&isDateUnavailable(date))date=date.subtract({days:1});if(date.compare(minValue)>=0)return date;return null;}function $131cf43a05231e1e$export$6d095e787d2b5e1f(props){var defaultFormatter=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $fb18d541ea1ad717$export$ad991b66133851cf(props.locale);},[props.locale]);var resolvedOptions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return defaultFormatter.resolvedOptions();},[defaultFormatter]);var locale=props.locale,createCalendar=props.createCalendar,_props$visibleDuratio=props.visibleDuration,visibleDuration=_props$visibleDuratio===void 0?{months:1}:_props$visibleDuratio,minValue=props.minValue,maxValue=props.maxValue,selectionAlignment=props.selectionAlignment,isDateUnavailable=props.isDateUnavailable,_props$pageBehavior=props.pageBehavior,pageBehavior=_props$pageBehavior===void 0?"visible":_props$pageBehavior,firstDayOfWeek=props.firstDayOfWeek;var calendar=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return createCalendar(resolvedOptions.calendar);},[createCalendar,resolvedOptions.calendar]);var _props_defaultValue;var _$458b0a5536c1a7cf$ex=$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value,(_props_defaultValue=props.defaultValue)!==null&&_props_defaultValue!==void 0?_props_defaultValue:null,props.onChange),_$458b0a5536c1a7cf$ex2=_slicedToArray(_$458b0a5536c1a7cf$ex,2),value=_$458b0a5536c1a7cf$ex2[0],setControlledValue=_$458b0a5536c1a7cf$ex2[1];var calendarDateValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return value?$11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$93522d1a439f3617(value),calendar):null;},[value,calendar]);var timeZone=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return value&&"timeZone"in value?value.timeZone:resolvedOptions.timeZone;},[value,resolvedOptions.timeZone]);var focusedCalendarDate=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return props.focusedValue?$f62d864046160412$export$4f5203c0d889109e($11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$93522d1a439f3617(props.focusedValue),calendar),minValue,maxValue):void 0;},[props.focusedValue,calendar,minValue,maxValue]);var defaultFocusedCalendarDate=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $f62d864046160412$export$4f5203c0d889109e(props.defaultFocusedValue?$11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$93522d1a439f3617(props.defaultFocusedValue),calendar):calendarDateValue||$11d87f3f76e88657$export$b4a036af3fc0b032($14e0f24ef4ac5c92$export$d0bdf45af03a6ea3(timeZone),calendar),minValue,maxValue);},[props.defaultFocusedValue,calendarDateValue,timeZone,calendar,minValue,maxValue]);var _$458b0a5536c1a7cf$ex3=$458b0a5536c1a7cf$export$40bfa8c7b0832715(focusedCalendarDate,defaultFocusedCalendarDate,props.onFocusChange),_$458b0a5536c1a7cf$ex4=_slicedToArray(_$458b0a5536c1a7cf$ex3,2),focusedDate=_$458b0a5536c1a7cf$ex4[0],setFocusedDate=_$458b0a5536c1a7cf$ex4[1];var _useState59=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){switch(selectionAlignment){case"start":return $f62d864046160412$export$144a00ba6044eb9(focusedDate,visibleDuration,locale,minValue,maxValue);case"end":return $f62d864046160412$export$530edbfc915b2b04(focusedDate,visibleDuration,locale,minValue,maxValue);case"center":default:return $f62d864046160412$export$f4a51ff076cc9a09(focusedDate,visibleDuration,locale,minValue,maxValue);}}),_useState60=_slicedToArray(_useState59,2),startDate=_useState60[0],setStartDate=_useState60[1];var _useState61=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.autoFocus||false),_useState62=_slicedToArray(_useState61,2),isFocused=_useState62[0],setFocused=_useState62[1];var endDate=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var duration=__spreadValues({},visibleDuration);if(duration.days)duration.days--;else duration.days=-1;return startDate.add(duration);},[startDate,visibleDuration]);var _useState63=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(calendar),_useState64=_slicedToArray(_useState63,2),lastCalendar=_useState64[0],setLastCalendar=_useState64[1];if(!$14e0f24ef4ac5c92$export$dbc69fd56b53d5e(calendar,lastCalendar)){var newFocusedDate=$11d87f3f76e88657$export$b4a036af3fc0b032(focusedDate,calendar);setStartDate($f62d864046160412$export$f4a51ff076cc9a09(newFocusedDate,visibleDuration,locale,minValue,maxValue));setFocusedDate(newFocusedDate);setLastCalendar(calendar);}if($f62d864046160412$export$eac50920cf2fd59a(focusedDate,minValue,maxValue))setFocusedDate($f62d864046160412$export$4f5203c0d889109e(focusedDate,minValue,maxValue));else if(focusedDate.compare(startDate)<0)setStartDate($f62d864046160412$export$530edbfc915b2b04(focusedDate,visibleDuration,locale,minValue,maxValue));else if(focusedDate.compare(endDate)>0)setStartDate($f62d864046160412$export$144a00ba6044eb9(focusedDate,visibleDuration,locale,minValue,maxValue));function focusCell(date){date=$f62d864046160412$export$4f5203c0d889109e(date,minValue,maxValue);setFocusedDate(date);}function setValue(newValue){if(!props.isDisabled&&!props.isReadOnly){var localValue=newValue;if(localValue===null){setControlledValue(null);return;}localValue=$f62d864046160412$export$4f5203c0d889109e(localValue,minValue,maxValue);localValue=$f62d864046160412$export$a1d3911297b952d7(localValue,startDate,isDateUnavailable);if(!localValue)return;localValue=$11d87f3f76e88657$export$b4a036af3fc0b032(localValue,(value===null||value===void 0?void 0:value.calendar)||new $3b62074eb05584b2$export$80ee6245ec4f29ec());if(value&&"hour"in value)setControlledValue(value.set(localValue));else setControlledValue(localValue);}}var isUnavailable=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(!calendarDateValue)return false;if(isDateUnavailable&&isDateUnavailable(calendarDateValue))return true;return $f62d864046160412$export$eac50920cf2fd59a(calendarDateValue,minValue,maxValue);},[calendarDateValue,isDateUnavailable,minValue,maxValue]);var isValueInvalid=props.isInvalid||props.validationState==="invalid"||isUnavailable;var validationState=isValueInvalid?"invalid":null;var pageDuration=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){if(pageBehavior==="visible")return visibleDuration;return $131cf43a05231e1e$var$unitDuration(visibleDuration);},[pageBehavior,visibleDuration]);var _props_isDisabled,_props_isReadOnly;return{isDisabled:(_props_isDisabled=props.isDisabled)!==null&&_props_isDisabled!==void 0?_props_isDisabled:false,isReadOnly:(_props_isReadOnly=props.isReadOnly)!==null&&_props_isReadOnly!==void 0?_props_isReadOnly:false,value:calendarDateValue,setValue:setValue,visibleRange:{start:startDate,end:endDate},minValue:minValue,maxValue:maxValue,focusedDate:focusedDate,timeZone:timeZone,validationState:validationState,isValueInvalid:isValueInvalid,setFocusedDate:function setFocusedDate(date){focusCell(date);setFocused(true);},focusNextDay:function focusNextDay(){focusCell(focusedDate.add({days:1}));},focusPreviousDay:function focusPreviousDay(){focusCell(focusedDate.subtract({days:1}));},focusNextRow:function focusNextRow(){if(visibleDuration.days)this.focusNextPage();else if(visibleDuration.weeks||visibleDuration.months||visibleDuration.years)focusCell(focusedDate.add({weeks:1}));},focusPreviousRow:function focusPreviousRow(){if(visibleDuration.days)this.focusPreviousPage();else if(visibleDuration.weeks||visibleDuration.months||visibleDuration.years)focusCell(focusedDate.subtract({weeks:1}));},focusNextPage:function focusNextPage(){var start2=startDate.add(pageDuration);setFocusedDate($f62d864046160412$export$4f5203c0d889109e(focusedDate.add(pageDuration),minValue,maxValue));setStartDate($f62d864046160412$export$144a00ba6044eb9($f62d864046160412$export$5bb865b12696a77d(focusedDate,start2,pageDuration,locale,minValue,maxValue),pageDuration,locale));},focusPreviousPage:function focusPreviousPage(){var start2=startDate.subtract(pageDuration);setFocusedDate($f62d864046160412$export$4f5203c0d889109e(focusedDate.subtract(pageDuration),minValue,maxValue));setStartDate($f62d864046160412$export$144a00ba6044eb9($f62d864046160412$export$5bb865b12696a77d(focusedDate,start2,pageDuration,locale,minValue,maxValue),pageDuration,locale));},focusSectionStart:function focusSectionStart(){if(visibleDuration.days)focusCell(startDate);else if(visibleDuration.weeks)focusCell($14e0f24ef4ac5c92$export$42c81a444fbfb5d4(focusedDate,locale));else if(visibleDuration.months||visibleDuration.years)focusCell($14e0f24ef4ac5c92$export$a5a3b454ada2268e(focusedDate));},focusSectionEnd:function focusSectionEnd(){if(visibleDuration.days)focusCell(endDate);else if(visibleDuration.weeks)focusCell($14e0f24ef4ac5c92$export$ef8b6d9133084f4e(focusedDate,locale));else if(visibleDuration.months||visibleDuration.years)focusCell($14e0f24ef4ac5c92$export$a2258d9c4118825c(focusedDate));},focusNextSection:function focusNextSection(larger){if(!larger&&!visibleDuration.days){focusCell(focusedDate.add($131cf43a05231e1e$var$unitDuration(visibleDuration)));return;}if(visibleDuration.days)this.focusNextPage();else if(visibleDuration.weeks)focusCell(focusedDate.add({months:1}));else if(visibleDuration.months||visibleDuration.years)focusCell(focusedDate.add({years:1}));},focusPreviousSection:function focusPreviousSection(larger){if(!larger&&!visibleDuration.days){focusCell(focusedDate.subtract($131cf43a05231e1e$var$unitDuration(visibleDuration)));return;}if(visibleDuration.days)this.focusPreviousPage();else if(visibleDuration.weeks)focusCell(focusedDate.subtract({months:1}));else if(visibleDuration.months||visibleDuration.years)focusCell(focusedDate.subtract({years:1}));},selectFocusedDate:function selectFocusedDate(){if(!(isDateUnavailable&&isDateUnavailable(focusedDate)))setValue(focusedDate);},selectDate:function selectDate(date){setValue(date);},isFocused:isFocused,setFocused:setFocused,isInvalid:function isInvalid(date){return $f62d864046160412$export$eac50920cf2fd59a(date,minValue,maxValue);},isSelected:function isSelected(date){return calendarDateValue!=null&&$14e0f24ef4ac5c92$export$ea39ec197993aef0(date,calendarDateValue)&&!this.isCellDisabled(date)&&!this.isCellUnavailable(date);},isCellFocused:function isCellFocused(date){return isFocused&&focusedDate&&$14e0f24ef4ac5c92$export$ea39ec197993aef0(date,focusedDate);},isCellDisabled:function isCellDisabled(date){return props.isDisabled||date.compare(startDate)<0||date.compare(endDate)>0||this.isInvalid(date);},isCellUnavailable:function isCellUnavailable(date){return props.isDateUnavailable?props.isDateUnavailable(date):false;},isPreviousVisibleRangeInvalid:function isPreviousVisibleRangeInvalid(){var prev=startDate.subtract({days:1});return $14e0f24ef4ac5c92$export$ea39ec197993aef0(prev,startDate)||this.isInvalid(prev);},isNextVisibleRangeInvalid:function isNextVisibleRangeInvalid(){var next=endDate.add({days:1});return $14e0f24ef4ac5c92$export$ea39ec197993aef0(next,endDate)||this.isInvalid(next);},getDatesInWeek:function getDatesInWeek(weekIndex){var from=arguments.length>1&&arguments[1]!==undefined?arguments[1]:startDate;var date=from.add({weeks:weekIndex});var dates=[];date=$14e0f24ef4ac5c92$export$42c81a444fbfb5d4(date,locale,firstDayOfWeek);var dayOfWeek=$14e0f24ef4ac5c92$export$2061056d06d7cdf7(date,locale,firstDayOfWeek);for(var _i13=0;_i13<dayOfWeek;_i13++)dates.push(null);while(dates.length<7){dates.push(date);var nextDate=date.add({days:1});if($14e0f24ef4ac5c92$export$ea39ec197993aef0(date,nextDate))break;date=nextDate;}while(dates.length<7)dates.push(null);return dates;}};}function $131cf43a05231e1e$var$unitDuration(duration){var unit=__spreadValues({},duration);for(var key2 in duration)unit[key2]=1;return unit;}function $fc909762b330b746$export$61c6a8c84e605fb6(props){var _$458b0a5536c1a7cf$ex5=$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isOpen,props.defaultOpen||false,props.onOpenChange),_$458b0a5536c1a7cf$ex6=_slicedToArray(_$458b0a5536c1a7cf$ex5,2),isOpen=_$458b0a5536c1a7cf$ex6[0],setOpen=_$458b0a5536c1a7cf$ex6[1];var open=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){setOpen(true);},[setOpen]);var close=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){setOpen(false);},[setOpen]);var toggle=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){setOpen(!isOpen);},[setOpen,isOpen]);return{isOpen:isOpen,setOpen:setOpen,open:open,close:close,toggle:toggle};}var $b3427c06585c22a0$exports={};$b3427c06585c22a0$exports={"rangeOverflow":function rangeOverflow(args){return"\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u064A\u0645\u0629 ".concat(args.maxValue," \u0623\u0648 \u0642\u0628\u0644 \u0630\u0644\u0643.");},"rangeReversed":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621 \u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0642\u0628\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621.","rangeUnderflow":function rangeUnderflow(args){return"\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u064A\u0645\u0629 ".concat(args.minValue," \u0623\u0648 \u0628\u0639\u062F \u0630\u0644\u0643.");},"unavailableDate":"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629."};var $d282528f459122b9$exports={};$d282528f459122b9$exports={"rangeOverflow":function rangeOverflow(args){return"\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 ".concat(args.maxValue," \u0438\u043B\u0438 \u043F\u043E-\u0440\u0430\u043D\u043D\u0430.");},"rangeReversed":"\u041D\u0430\u0447\u0430\u043B\u043D\u0430\u0442\u0430 \u0434\u0430\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u043F\u0440\u0435\u0434\u0438 \u043A\u0440\u0430\u0439\u043D\u0430\u0442\u0430.","rangeUnderflow":function rangeUnderflow(args){return"\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 ".concat(args.minValue," \u0438\u043B\u0438 \u043F\u043E-\u043A\u044A\u0441\u043D\u043E.");},"unavailableDate":"\u0418\u0437\u0431\u0440\u0430\u043D\u0430\u0442\u0430 \u0434\u0430\u0442\u0430 \u043D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430."};var $2d5eecd634a9ca45$exports={};$2d5eecd634a9ca45$exports={"rangeOverflow":function rangeOverflow(args){return"Hodnota mus\xED b\xFDt ".concat(args.maxValue," nebo d\u0159\xEDv\u011Bj\u0161\xED.");},"rangeReversed":"Datum zah\xE1jen\xED mus\xED p\u0159edch\xE1zet datu ukon\u010Den\xED.","rangeUnderflow":function rangeUnderflow(args){return"Hodnota mus\xED b\xFDt ".concat(args.minValue," nebo pozd\u011Bj\u0161\xED.");},"unavailableDate":"Vybran\xE9 datum nen\xED k dispozici."};var $c8e2288226c24a67$exports={};$c8e2288226c24a67$exports={"rangeOverflow":function rangeOverflow(args){return"V\xE6rdien skal v\xE6re ".concat(args.maxValue," eller tidligere.");},"rangeReversed":"Startdatoen skal v\xE6re f\xF8r slutdatoen.","rangeUnderflow":function rangeUnderflow(args){return"V\xE6rdien skal v\xE6re ".concat(args.minValue," eller nyere.");},"unavailableDate":"Den valgte dato er ikke tilg\xE6ngelig."};var $6f5745e389c346d7$exports={};$6f5745e389c346d7$exports={"rangeOverflow":function rangeOverflow(args){return"Der Wert muss ".concat(args.maxValue," oder fr\xFCher sein.");},"rangeReversed":"Das Startdatum muss vor dem Enddatum liegen.","rangeUnderflow":function rangeUnderflow(args){return"Der Wert muss ".concat(args.minValue," oder sp\xE4ter sein.");},"unavailableDate":"Das ausgew\xE4hlte Datum ist nicht verf\xFCgbar."};var $8c882ccf4300d1da$exports={};$8c882ccf4300d1da$exports={"rangeOverflow":function rangeOverflow(args){return"\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 ".concat(args.maxValue," \u03AE \u03C0\u03B1\u03BB\u03B1\u03B9\u03CC\u03C4\u03B5\u03C1\u03B7.");},"rangeReversed":"\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2.","rangeUnderflow":function rangeUnderflow(args){return"\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 ".concat(args.minValue," \u03AE \u03BC\u03B5\u03C4\u03B1\u03B3\u03B5\u03BD\u03AD\u03C3\u03C4\u03B5\u03C1\u03B7.");},"unavailableDate":"\u0397 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7."};var $22195056771860be$exports={};$22195056771860be$exports={"rangeUnderflow":function rangeUnderflow(args){return"Value must be ".concat(args.minValue," or later.");},"rangeOverflow":function rangeOverflow(args){return"Value must be ".concat(args.maxValue," or earlier.");},"rangeReversed":"Start date must be before end date.","unavailableDate":"Selected date unavailable."};var $cedfa43b4e2a5906$exports={};$cedfa43b4e2a5906$exports={"rangeOverflow":function rangeOverflow(args){return"El valor debe ser ".concat(args.maxValue," o anterior.");},"rangeReversed":"La fecha de inicio debe ser anterior a la fecha de finalizaci\xF3n.","rangeUnderflow":function rangeUnderflow(args){return"El valor debe ser ".concat(args.minValue," o posterior.");},"unavailableDate":"Fecha seleccionada no disponible."};var $eeeaa8daee3601c7$exports={};$eeeaa8daee3601c7$exports={"rangeOverflow":function rangeOverflow(args){return"V\xE4\xE4rtus peab olema ".concat(args.maxValue," v\xF5i varasem.");},"rangeReversed":"Alguskuup\xE4ev peab olema enne l\xF5ppkuup\xE4eva.","rangeUnderflow":function rangeUnderflow(args){return"V\xE4\xE4rtus peab olema ".concat(args.minValue," v\xF5i hilisem.");},"unavailableDate":"Valitud kuup\xE4ev pole saadaval."};var $35e0614a49b3bb40$exports={};$35e0614a49b3bb40$exports={"rangeOverflow":function rangeOverflow(args){return"Arvon on oltava ".concat(args.maxValue," tai sit\xE4 aikaisempi.");},"rangeReversed":"Aloitusp\xE4iv\xE4n on oltava ennen lopetusp\xE4iv\xE4\xE4.","rangeUnderflow":function rangeUnderflow(args){return"Arvon on oltava ".concat(args.minValue," tai sit\xE4 my\xF6h\xE4isempi.");},"unavailableDate":"Valittu p\xE4iv\xE4m\xE4\xE4r\xE4 ei ole k\xE4ytett\xE4viss\xE4."};var $929bc63f7705a78f$exports={};$929bc63f7705a78f$exports={"rangeOverflow":function rangeOverflow(args){return"La valeur doit \xEAtre ".concat(args.maxValue," ou ant\xE9rieure.");},"rangeReversed":"La date de d\xE9but doit \xEAtre ant\xE9rieure \xE0 la date de fin.","rangeUnderflow":function rangeUnderflow(args){return"La valeur doit \xEAtre ".concat(args.minValue," ou ult\xE9rieure.");},"unavailableDate":"La date s\xE9lectionn\xE9e n\u2019est pas disponible."};var $9a28d073b034d183$exports={};$9a28d073b034d183$exports={"rangeOverflow":function rangeOverflow(args){return"\u05D4\u05E2\u05E8\u05DA \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA ".concat(args.maxValue," \u05D0\u05D5 \u05DE\u05D5\u05E7\u05D3\u05DD \u05D9\u05D5\u05EA\u05E8.");},"rangeReversed":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05D4\u05EA\u05D7\u05DC\u05D4 \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DC\u05E4\u05E0\u05D9 \u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E1\u05D9\u05D5\u05DD.","rangeUnderflow":function rangeUnderflow(args){return"\u05D4\u05E2\u05E8\u05DA \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA ".concat(args.minValue," \u05D0\u05D5 \u05DE\u05D0\u05D5\u05D7\u05E8 \u05D9\u05D5\u05EA\u05E8.");},"unavailableDate":"\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E0\u05D1\u05D7\u05E8 \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF."};var $7743e79780ebcca3$exports={};$7743e79780ebcca3$exports={"rangeOverflow":function rangeOverflow(args){return"Vrijednost mora biti ".concat(args.maxValue," ili ranije.");},"rangeReversed":"Datum po\u010Detka mora biti prije datuma zavr\u0161etka.","rangeUnderflow":function rangeUnderflow(args){return"Vrijednost mora biti ".concat(args.minValue," ili kasnije.");},"unavailableDate":"Odabrani datum nije dostupan."};var $3351817a04898858$exports={};$3351817a04898858$exports={"rangeOverflow":function rangeOverflow(args){return"Az \xE9rt\xE9knek ".concat(args.maxValue," vagy kor\xE1bbinak kell lennie.");},"rangeReversed":"A kezd\u0151 d\xE1tumnak a befejez\u0151 d\xE1tumn\xE1l kor\xE1bbinak kell lennie.","rangeUnderflow":function rangeUnderflow(args){return"Az \xE9rt\xE9knek ".concat(args.minValue," vagy k\xE9s\u0151bbinek kell lennie.");},"unavailableDate":"A kiv\xE1lasztott d\xE1tum nem \xE9rhet\u0151 el."};var $4120bdb1d03484db$exports={};$4120bdb1d03484db$exports={"rangeOverflow":function rangeOverflow(args){return"Il valore deve essere ".concat(args.maxValue," o precedente.");},"rangeReversed":"La data di inizio deve essere antecedente alla data di fine.","rangeUnderflow":function rangeUnderflow(args){return"Il valore deve essere ".concat(args.minValue," o successivo.");},"unavailableDate":"Data selezionata non disponibile."};var $65e5e1569f34ea4f$exports={};$65e5e1569f34ea4f$exports={"rangeOverflow":function rangeOverflow(args){return"\u5024\u306F ".concat(args.maxValue," \u4EE5\u4E0B\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002");},"rangeReversed":"\u958B\u59CB\u65E5\u306F\u7D42\u4E86\u65E5\u3088\u308A\u524D\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","rangeUnderflow":function rangeUnderflow(args){return"\u5024\u306F ".concat(args.minValue," \u4EE5\u4E0A\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002");},"unavailableDate":"\u9078\u629E\u3057\u305F\u65E5\u4ED8\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002"};var $d34552a7550967e7$exports={};$d34552a7550967e7$exports={"rangeOverflow":function rangeOverflow(args){return"\uAC12\uC740 ".concat(args.maxValue," \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.");},"rangeReversed":"\uC2DC\uC791\uC77C\uC740 \uC885\uB8CC\uC77C \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.","rangeUnderflow":function rangeUnderflow(args){return"\uAC12\uC740 ".concat(args.minValue," \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.");},"unavailableDate":"\uC120\uD0DD\uD55C \uB0A0\uC9DC\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."};var $8f855bffe63f6eca$exports={};$8f855bffe63f6eca$exports={"rangeOverflow":function rangeOverflow(args){return"Reik\u0161m\u0117 turi b\u016Bti ".concat(args.maxValue," arba ankstesn\u0117.");},"rangeReversed":"Prad\u017Eios data turi b\u016Bti ankstesn\u0117 nei pabaigos data.","rangeUnderflow":function rangeUnderflow(args){return"Reik\u0161m\u0117 turi b\u016Bti ".concat(args.minValue," arba naujesn\u0117.");},"unavailableDate":"Pasirinkta data nepasiekiama."};var $ce40f46d09034645$exports={};$ce40f46d09034645$exports={"rangeOverflow":function rangeOverflow(args){return"V\u0113rt\u012Bbai ir j\u0101b\u016Bt ".concat(args.maxValue," vai agr\u0101kai.");},"rangeReversed":"S\u0101kuma datumam ir j\u0101b\u016Bt pirms beigu datuma.","rangeUnderflow":function rangeUnderflow(args){return"V\u0113rt\u012Bbai ir j\u0101b\u016Bt ".concat(args.minValue," vai v\u0113l\u0101kai.");},"unavailableDate":"Atlas\u012Btais datums nav pieejams."};var $dd1a9a73340c793e$exports={};$dd1a9a73340c793e$exports={"rangeOverflow":function rangeOverflow(args){return"Verdien m\xE5 v\xE6re ".concat(args.maxValue," eller tidligere.");},"rangeReversed":"Startdatoen m\xE5 v\xE6re f\xF8r sluttdatoen.","rangeUnderflow":function rangeUnderflow(args){return"Verdien m\xE5 v\xE6re ".concat(args.minValue," eller senere.");},"unavailableDate":"Valgt dato utilgjengelig."};var $4ee1fb3f0cbe6f59$exports={};$4ee1fb3f0cbe6f59$exports={"rangeOverflow":function rangeOverflow(args){return"Waarde moet ".concat(args.maxValue," of eerder zijn.");},"rangeReversed":"De startdatum moet voor de einddatum liggen.","rangeUnderflow":function rangeUnderflow(args){return"Waarde moet ".concat(args.minValue," of later zijn.");},"unavailableDate":"Geselecteerde datum niet beschikbaar."};var $c85829aebb0bc94b$exports={};$c85829aebb0bc94b$exports={"rangeOverflow":function rangeOverflow(args){return"Warto\u015B\u0107 musi mie\u0107 warto\u015B\u0107 ".concat(args.maxValue," lub wcze\u015Bniejsz\u0105.");},"rangeReversed":"Data rozpocz\u0119cia musi by\u0107 wcze\u015Bniejsza ni\u017C data zako\u0144czenia.","rangeUnderflow":function rangeUnderflow(args){return"Warto\u015B\u0107 musi mie\u0107 warto\u015B\u0107 ".concat(args.minValue," lub p\xF3\u017Aniejsz\u0105.");},"unavailableDate":"Wybrana data jest niedost\u0119pna."};var $27f5cd2291ca8a02$exports={};$27f5cd2291ca8a02$exports={"rangeOverflow":function rangeOverflow(args){return"O valor deve ser ".concat(args.maxValue," ou anterior.");},"rangeReversed":"A data inicial deve ser anterior \xE0 data final.","rangeUnderflow":function rangeUnderflow(args){return"O valor deve ser ".concat(args.minValue," ou posterior.");},"unavailableDate":"Data selecionada indispon\xEDvel."};var $e046fdccd69bea8e$exports={};$e046fdccd69bea8e$exports={"rangeOverflow":function rangeOverflow(args){return"O valor tem de ser ".concat(args.maxValue," ou anterior.");},"rangeReversed":"A data de in\xEDcio deve ser anterior \xE0 data de fim.","rangeUnderflow":function rangeUnderflow(args){return"O valor tem de ser ".concat(args.minValue," ou posterior.");},"unavailableDate":"Data selecionada indispon\xEDvel."};var $fa5f88e804986547$exports={};$fa5f88e804986547$exports={"rangeOverflow":function rangeOverflow(args){return"Valoarea trebuie s\u0103 fie ".concat(args.maxValue," sau anterioar\u0103.");},"rangeReversed":"Data de \xEEnceput trebuie s\u0103 fie anterioar\u0103 datei de sf\xE2r\u0219it.","rangeUnderflow":function rangeUnderflow(args){return"Valoarea trebuie s\u0103 fie ".concat(args.minValue," sau ulterioar\u0103.");},"unavailableDate":"Data selectat\u0103 nu este disponibil\u0103."};var $28e4714602d1b568$exports={};$28e4714602d1b568$exports={"rangeOverflow":function rangeOverflow(args){return"\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u043F\u043E\u0437\u0436\u0435 ".concat(args.maxValue,".");},"rangeReversed":"\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0448\u0435\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u0442\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F.","rangeUnderflow":function rangeUnderflow(args){return"\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u0440\u0430\u043D\u044C\u0448\u0435 ".concat(args.minValue,".");},"unavailableDate":"\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430."};var $4e3bc8cf783ad569$exports={};$4e3bc8cf783ad569$exports={"rangeOverflow":function rangeOverflow(args){return"Hodnota mus\xED by\u0165 ".concat(args.maxValue," alebo skor\u0161ia.");},"rangeReversed":"D\xE1tum za\u010Diatku mus\xED by\u0165 skor\u0161\xED ako d\xE1tum konca.","rangeUnderflow":function rangeUnderflow(args){return"Hodnota mus\xED by\u0165 ".concat(args.minValue," alebo neskor\u0161ia.");},"unavailableDate":"Vybrat\xFD d\xE1tum je nedostupn\xFD."};var $bee07513333bdc15$exports={};$bee07513333bdc15$exports={"rangeOverflow":function rangeOverflow(args){return"Vrednost mora biti ".concat(args.maxValue," ali starej\u0161a.");},"rangeReversed":"Za\u010Detni datum mora biti pred kon\u010Dnim datumom.","rangeUnderflow":function rangeUnderflow(args){return"Vrednost mora biti ".concat(args.minValue," ali novej\u0161a.");},"unavailableDate":"Izbrani datum ni na voljo."};var $7ed9c6fad16a15ec$exports={};$7ed9c6fad16a15ec$exports={"rangeOverflow":function rangeOverflow(args){return"Vrednost mora da bude ".concat(args.maxValue," ili starija.");},"rangeReversed":"Datum po\u010Detka mora biti pre datuma zavr\u0161etka.","rangeUnderflow":function rangeUnderflow(args){return"Vrednost mora da bude ".concat(args.minValue," ili novija.");},"unavailableDate":"Izabrani datum nije dostupan."};var $8bef6d5a236de86c$exports={};$8bef6d5a236de86c$exports={"rangeOverflow":function rangeOverflow(args){return"V\xE4rdet m\xE5ste vara ".concat(args.maxValue," eller tidigare.");},"rangeReversed":"Startdatumet m\xE5ste vara f\xF6re slutdatumet.","rangeUnderflow":function rangeUnderflow(args){return"V\xE4rdet m\xE5ste vara ".concat(args.minValue," eller senare.");},"unavailableDate":"Det valda datumet \xE4r inte tillg\xE4ngligt."};var $098b9a2d2340cfc5$exports={};$098b9a2d2340cfc5$exports={"rangeOverflow":function rangeOverflow(args){return"De\u011Fer, ".concat(args.maxValue," veya \xF6ncesi olmal\u0131d\u0131r.");},"rangeReversed":"Ba\u015Flang\u0131\xE7 tarihi biti\u015F tarihinden \xF6nce olmal\u0131d\u0131r.","rangeUnderflow":function rangeUnderflow(args){return"De\u011Fer, ".concat(args.minValue," veya sonras\u0131 olmal\u0131d\u0131r.");},"unavailableDate":"Se\xE7ilen tarih kullan\u0131lam\u0131yor."};var $54a862ea7fad7419$exports={};$54a862ea7fad7419$exports={"rangeOverflow":function rangeOverflow(args){return"\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043D\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435 ".concat(args.maxValue,".");},"rangeReversed":"\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043C\u0430\u0454 \u043F\u0435\u0440\u0435\u0434\u0443\u0432\u0430\u0442\u0438 \u0434\u0430\u0442\u0456 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F.","rangeUnderflow":function rangeUnderflow(args){return"\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043D\u0435 \u0440\u0430\u043D\u0456\u0448\u0435 ".concat(args.minValue,".");},"unavailableDate":"\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430."};var $e6cc491d590dfda5$exports={};$e6cc491d590dfda5$exports={"rangeOverflow":function rangeOverflow(args){return"\u503C\u5FC5\u987B\u662F ".concat(args.maxValue," \u6216\u66F4\u65E9\u65E5\u671F\u3002");},"rangeReversed":"\u5F00\u59CB\u65E5\u671F\u5FC5\u987B\u65E9\u4E8E\u7ED3\u675F\u65E5\u671F\u3002","rangeUnderflow":function rangeUnderflow(args){return"\u503C\u5FC5\u987B\u662F ".concat(args.minValue," \u6216\u66F4\u665A\u65E5\u671F\u3002");},"unavailableDate":"\u6240\u9009\u65E5\u671F\u4E0D\u53EF\u7528\u3002"};var $9aebf53181a474bd$exports={};$9aebf53181a474bd$exports={"rangeOverflow":function rangeOverflow(args){return"\u503C\u5FC5\u9808\u662F ".concat(args.maxValue," \u6216\u66F4\u65E9\u3002");},"rangeReversed":"\u958B\u59CB\u65E5\u671F\u5FC5\u9808\u5728\u7D50\u675F\u65E5\u671F\u4E4B\u524D\u3002","rangeUnderflow":function rangeUnderflow(args){return"\u503C\u5FC5\u9808\u662F ".concat(args.minValue," \u6216\u66F4\u665A\u3002");},"unavailableDate":"\u6240\u9078\u65E5\u671F\u7121\u6CD5\u4F7F\u7528\u3002"};var $452ac34de8c2444e$exports={};$452ac34de8c2444e$exports={"ar-AE":$b3427c06585c22a0$exports,"bg-BG":$d282528f459122b9$exports,"cs-CZ":$2d5eecd634a9ca45$exports,"da-DK":$c8e2288226c24a67$exports,"de-DE":$6f5745e389c346d7$exports,"el-GR":$8c882ccf4300d1da$exports,"en-US":$22195056771860be$exports,"es-ES":$cedfa43b4e2a5906$exports,"et-EE":$eeeaa8daee3601c7$exports,"fi-FI":$35e0614a49b3bb40$exports,"fr-FR":$929bc63f7705a78f$exports,"he-IL":$9a28d073b034d183$exports,"hr-HR":$7743e79780ebcca3$exports,"hu-HU":$3351817a04898858$exports,"it-IT":$4120bdb1d03484db$exports,"ja-JP":$65e5e1569f34ea4f$exports,"ko-KR":$d34552a7550967e7$exports,"lt-LT":$8f855bffe63f6eca$exports,"lv-LV":$ce40f46d09034645$exports,"nb-NO":$dd1a9a73340c793e$exports,"nl-NL":$4ee1fb3f0cbe6f59$exports,"pl-PL":$c85829aebb0bc94b$exports,"pt-BR":$27f5cd2291ca8a02$exports,"pt-PT":$e046fdccd69bea8e$exports,"ro-RO":$fa5f88e804986547$exports,"ru-RU":$28e4714602d1b568$exports,"sk-SK":$4e3bc8cf783ad569$exports,"sl-SI":$bee07513333bdc15$exports,"sr-SP":$7ed9c6fad16a15ec$exports,"sv-SE":$8bef6d5a236de86c$exports,"tr-TR":$098b9a2d2340cfc5$exports,"uk-UA":$54a862ea7fad7419$exports,"zh-CN":$e6cc491d590dfda5$exports,"zh-TW":$9aebf53181a474bd$exports};function $parcel$interopDefault(a){return a&&a.__esModule?a["default"]:a;}var $35a22f14a1f04b11$var$dictionary=new $5b160d28a433310d$export$c17fa47878dc55b6($parcel$interopDefault($452ac34de8c2444e$exports));function $35a22f14a1f04b11$var$getLocale(){var locale=typeof navigator!=="undefined"&&(navigator.language||navigator.userLanguage)||"en-US";try{Intl.DateTimeFormat.supportedLocalesOf([locale]);}catch(_unused8){locale="en-US";}return locale;}function $35a22f14a1f04b11$export$f18627323ab57ac0(value,minValue,maxValue,isDateUnavailable,options){var rangeOverflow=value!=null&&maxValue!=null&&value.compare(maxValue)>0;var rangeUnderflow=value!=null&&minValue!=null&&value.compare(minValue)<0;var isUnavailable=value!=null&&(isDateUnavailable===null||isDateUnavailable===void 0?void 0:isDateUnavailable(value))||false;var isInvalid=rangeOverflow||rangeUnderflow||isUnavailable;var errors=[];if(isInvalid){var locale=$35a22f14a1f04b11$var$getLocale();var strings=$5b160d28a433310d$export$c17fa47878dc55b6.getGlobalDictionaryForPackage("@react-stately/datepicker")||$35a22f14a1f04b11$var$dictionary;var formatter=new $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale,strings);var dateFormatter=new $fb18d541ea1ad717$export$ad991b66133851cf(locale,$35a22f14a1f04b11$export$7e319ea407e63bc0({},options));var timeZone=dateFormatter.resolvedOptions().timeZone;if(rangeUnderflow&&minValue!=null)errors.push(formatter.format("rangeUnderflow",{minValue:dateFormatter.format(minValue.toDate(timeZone))}));if(rangeOverflow&&maxValue!=null)errors.push(formatter.format("rangeOverflow",{maxValue:dateFormatter.format(maxValue.toDate(timeZone))}));if(isUnavailable)errors.push(formatter.format("unavailableDate"));}return{isInvalid:isInvalid,validationErrors:errors,validationDetails:{badInput:isUnavailable,customError:false,patternMismatch:false,rangeOverflow:rangeOverflow,rangeUnderflow:rangeUnderflow,stepMismatch:false,tooLong:false,tooShort:false,typeMismatch:false,valueMissing:false,valid:!isInvalid}};}var $35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS={year:"numeric",month:"numeric",day:"numeric",hour:"numeric",minute:"2-digit",second:"2-digit"};var $35a22f14a1f04b11$var$TWO_DIGIT_FIELD_OPTIONS={year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit"};function $35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions,options){var defaultFieldOptions=options.shouldForceLeadingZeros?$35a22f14a1f04b11$var$TWO_DIGIT_FIELD_OPTIONS:$35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS;fieldOptions=__spreadValues(__spreadValues({},defaultFieldOptions),fieldOptions);var granularity=options.granularity||"minute";var keys=Object.keys(fieldOptions);var _options_maxGranularity;var startIdx=keys.indexOf((_options_maxGranularity=options.maxGranularity)!==null&&_options_maxGranularity!==void 0?_options_maxGranularity:"year");if(startIdx<0)startIdx=0;var endIdx=keys.indexOf(granularity);if(endIdx<0)endIdx=2;if(startIdx>endIdx)throw new Error("maxGranularity must be greater than granularity");var opts=keys.slice(startIdx,endIdx+1).reduce(function(opts2,key2){opts2[key2]=fieldOptions[key2];return opts2;},{});if(options.hourCycle!=null)opts.hour12=options.hourCycle===12;opts.timeZone=options.timeZone||"UTC";var hasTime=granularity==="hour"||granularity==="minute"||granularity==="second";if(hasTime&&options.timeZone&&!options.hideTimeZone)opts.timeZoneName="short";if(options.showEra&&startIdx===0)opts.era="short";return opts;}function $35a22f14a1f04b11$export$c5221a78ef73c5e9(placeholderValue){if(placeholderValue&&"hour"in placeholderValue)return placeholderValue;return new $35ea8db9cb2ccb90$export$680ea196effce5f();}function $35a22f14a1f04b11$export$61a490a80c552550(value,calendar){if(value===null)return null;if(!value)return void 0;return $11d87f3f76e88657$export$b4a036af3fc0b032(value,calendar);}function $35a22f14a1f04b11$export$66aa2b09de4b1ea5(placeholderValue,granularity,calendar,timeZone){if(placeholderValue)return $35a22f14a1f04b11$export$61a490a80c552550(placeholderValue,calendar);var date=$11d87f3f76e88657$export$b4a036af3fc0b032($14e0f24ef4ac5c92$export$461939dd4422153(timeZone!==null&&timeZone!==void 0?timeZone:$14e0f24ef4ac5c92$export$aa8b41735afcabd2()).set({hour:0,minute:0,second:0,millisecond:0}),calendar);if(granularity==="year"||granularity==="month"||granularity==="day")return $11d87f3f76e88657$export$93522d1a439f3617(date);if(!timeZone)return $11d87f3f76e88657$export$b21e0b124e224484(date);return date;}function $35a22f14a1f04b11$export$2440da353cedad43(v2,granularity){var defaultTimeZone=v2&&"timeZone"in v2?v2.timeZone:void 0;var defaultGranularity=v2&&"minute"in v2?"minute":"day";if(v2&&granularity&&!(granularity in v2))throw new Error("Invalid granularity "+granularity+" for value "+v2.toString());var _useState65=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([defaultGranularity,defaultTimeZone]),_useState66=_slicedToArray(_useState65,2),lastValue=_useState66[0],setLastValue=_useState66[1];if(v2&&(lastValue[0]!==defaultGranularity||lastValue[1]!==defaultTimeZone))setLastValue([defaultGranularity,defaultTimeZone]);if(!granularity)granularity=v2?defaultGranularity:lastValue[0];var timeZone=v2?defaultTimeZone:lastValue[1];return[granularity,timeZone];}function $ab5bf3f618090389$export$87194bb378cc3ac2(props){var overlayState=$fc909762b330b746$export$61c6a8c84e605fb6(props);var _$458b0a5536c1a7cf$ex7=$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value,props.defaultValue||null,props.onChange),_$458b0a5536c1a7cf$ex8=_slicedToArray(_$458b0a5536c1a7cf$ex7,2),value=_$458b0a5536c1a7cf$ex8[0],setValue=_$458b0a5536c1a7cf$ex8[1];var _useState67=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(value),_useState68=_slicedToArray(_useState67,1),initialValue=_useState68[0];var v2=value||props.placeholderValue||null;var _$35a22f14a1f04b11$ex=$35a22f14a1f04b11$export$2440da353cedad43(v2,props.granularity),_$35a22f14a1f04b11$ex2=_slicedToArray(_$35a22f14a1f04b11$ex,2),granularity=_$35a22f14a1f04b11$ex2[0],defaultTimeZone=_$35a22f14a1f04b11$ex2[1];var dateValue=value!=null?value.toDate(defaultTimeZone!==null&&defaultTimeZone!==void 0?defaultTimeZone:"UTC"):null;var hasTime=granularity==="hour"||granularity==="minute"||granularity==="second";var _props_shouldCloseOnSelect;var shouldCloseOnSelect=(_props_shouldCloseOnSelect=props.shouldCloseOnSelect)!==null&&_props_shouldCloseOnSelect!==void 0?_props_shouldCloseOnSelect:true;var _useState69=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState70=_slicedToArray(_useState69,2),selectedDate=_useState70[0],setSelectedDate=_useState70[1];var _useState71=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState72=_slicedToArray(_useState71,2),selectedTime=_useState72[0],setSelectedTime=_useState72[1];if(value){selectedDate=value;if("hour"in value)selectedTime=value;}if(v2&&!(granularity in v2))throw new Error("Invalid granularity "+granularity+" for value "+v2.toString());var showEra=(value===null||value===void 0?void 0:value.calendar.identifier)==="gregory"&&value.era==="BC";var formatOpts=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{granularity:granularity,timeZone:defaultTimeZone,hideTimeZone:props.hideTimeZone,hourCycle:props.hourCycle,shouldForceLeadingZeros:props.shouldForceLeadingZeros,showEra:showEra};},[granularity,props.hourCycle,props.shouldForceLeadingZeros,defaultTimeZone,props.hideTimeZone,showEra]);var minValue=props.minValue,maxValue=props.maxValue,isDateUnavailable=props.isDateUnavailable;var builtinValidation=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $35a22f14a1f04b11$export$f18627323ab57ac0(value,minValue,maxValue,isDateUnavailable,formatOpts);},[value,minValue,maxValue,isDateUnavailable,formatOpts]);var validation=$e5be200c675c3b3a$export$fc1a364ae1f3ff10(__spreadProps(__spreadValues({},props),{value:value,builtinValidation:builtinValidation}));var isValueInvalid=validation.displayValidation.isInvalid;var validationState=props.validationState||(isValueInvalid?"invalid":null);var commitValue=function commitValue(date,time){setValue("timeZone"in time?time.set($11d87f3f76e88657$export$93522d1a439f3617(date)):$11d87f3f76e88657$export$b21e0b124e224484(date,time));setSelectedDate(null);setSelectedTime(null);validation.commitValidation();};var selectDate=function selectDate(newValue){var shouldClose=typeof shouldCloseOnSelect==="function"?shouldCloseOnSelect():shouldCloseOnSelect;if(hasTime){if(selectedTime||shouldClose)commitValue(newValue,selectedTime||$35a22f14a1f04b11$export$c5221a78ef73c5e9(props.defaultValue||props.placeholderValue));else setSelectedDate(newValue);}else{setValue(newValue);validation.commitValidation();}if(shouldClose)overlayState.setOpen(false);};var selectTime=function selectTime(newValue){if(selectedDate&&newValue)commitValue(selectedDate,newValue);else setSelectedTime(newValue);};var _props_defaultValue;return __spreadProps(__spreadValues(__spreadProps(__spreadValues({},validation),{value:value,defaultValue:(_props_defaultValue=props.defaultValue)!==null&&_props_defaultValue!==void 0?_props_defaultValue:initialValue,setValue:setValue,dateValue:selectedDate,timeValue:selectedTime,setDateValue:selectDate,setTimeValue:selectTime,granularity:granularity,hasTime:hasTime}),overlayState),{setOpen:function setOpen(isOpen){if(!isOpen&&!value&&selectedDate&&hasTime)commitValue(selectedDate,selectedTime||$35a22f14a1f04b11$export$c5221a78ef73c5e9(props.defaultValue||props.placeholderValue));overlayState.setOpen(isOpen);},validationState:validationState,isInvalid:isValueInvalid,formatValue:function formatValue(locale,fieldOptions){if(!dateValue)return"";var formatOptions=$35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions,formatOpts);var formatter=new $fb18d541ea1ad717$export$ad991b66133851cf(locale,formatOptions);return formatter.format(dateValue);},getDateFormatter:function getDateFormatter(locale,formatOptions){var newOptions=__spreadValues(__spreadValues({},formatOpts),formatOptions);var newFormatOptions=$35a22f14a1f04b11$export$7e319ea407e63bc0({},newOptions);return new $fb18d541ea1ad717$export$ad991b66133851cf(locale,newFormatOptions);}});}var $3e3ed55ab2966714$var$placeholders=new $5b160d28a433310d$export$c17fa47878dc55b6({ach:{year:"mwaka",month:"dwe",day:"nino"},af:{year:"jjjj",month:"mm",day:"dd"},am:{year:"\u12D3\u12D3\u12D3\u12D3",month:"\u121A\u121C",day:"\u1240\u1240"},an:{year:"aaaa",month:"mm",day:"dd"},ar:{year:"\u0633\u0646\u0629",month:"\u0634\u0647\u0631",day:"\u064A\u0648\u0645"},ast:{year:"aaaa",month:"mm",day:"dd"},az:{year:"iiii",month:"aa",day:"gg"},be:{year:"\u0433\u0433\u0433\u0433",month:"\u043C\u043C",day:"\u0434\u0434"},bg:{year:"\u0433\u0433\u0433\u0433",month:"\u043C\u043C",day:"\u0434\u0434"},bn:{year:"yyyy",month:"\u09AE\u09BF\u09AE\u09BF",day:"dd"},br:{year:"bbbb",month:"mm",day:"dd"},bs:{year:"gggg",month:"mm",day:"dd"},ca:{year:"aaaa",month:"mm",day:"dd"},cak:{year:"jjjj",month:"ii",day:"q'q'"},ckb:{year:"\u0633\u0627\u06B5",month:"\u0645\u0627\u0646\u06AF",day:"\u0695\u06C6\u0698"},cs:{year:"rrrr",month:"mm",day:"dd"},cy:{year:"bbbb",month:"mm",day:"dd"},da:{year:"\xE5\xE5\xE5\xE5",month:"mm",day:"dd"},de:{year:"jjjj",month:"mm",day:"tt"},dsb:{year:"llll",month:"mm",day:"\u017A\u017A"},el:{year:"\u03B5\u03B5\u03B5\u03B5",month:"\u03BC\u03BC",day:"\u03B7\u03B7"},en:{year:"yyyy",month:"mm",day:"dd"},eo:{year:"jjjj",month:"mm",day:"tt"},es:{year:"aaaa",month:"mm",day:"dd"},et:{year:"aaaa",month:"kk",day:"pp"},eu:{year:"uuuu",month:"hh",day:"ee"},fa:{year:"\u0633\u0627\u0644",month:"\u0645\u0627\u0647",day:"\u0631\u0648\u0632"},ff:{year:"hhhh",month:"ll",day:"\xF1\xF1"},fi:{year:"vvvv",month:"kk",day:"pp"},fr:{year:"aaaa",month:"mm",day:"jj"},fy:{year:"jjjj",month:"mm",day:"dd"},ga:{year:"bbbb",month:"mm",day:"ll"},gd:{year:"bbbb",month:"mm",day:"ll"},gl:{year:"aaaa",month:"mm",day:"dd"},he:{year:"\u05E9\u05E0\u05D4",month:"\u05D7\u05D5\u05D3\u05E9",day:"\u05D9\u05D5\u05DD"},hr:{year:"gggg",month:"mm",day:"dd"},hsb:{year:"llll",month:"mm",day:"dd"},hu:{year:"\xE9\xE9\xE9\xE9",month:"hh",day:"nn"},ia:{year:"aaaa",month:"mm",day:"dd"},id:{year:"tttt",month:"bb",day:"hh"},it:{year:"aaaa",month:"mm",day:"gg"},ja:{year:"\u5E74",month:"\u6708",day:"\u65E5"},ka:{year:"\u10EC\u10EC\u10EC\u10EC",month:"\u10D7\u10D7",day:"\u10E0\u10E0"},kk:{year:"\u0436\u0436\u0436\u0436",month:"\u0430\u0430",day:"\u043A\u043A"},kn:{year:"\u0CB5\u0CB5\u0CB5\u0CB5",month:"\u0CAE\u0CBF\u0CAE\u0CC0",day:"\u0CA6\u0CBF\u0CA6\u0CBF"},ko:{year:"\uC5F0\uB3C4",month:"\uC6D4",day:"\uC77C"},lb:{year:"jjjj",month:"mm",day:"dd"},lo:{year:"\u0E9B\u0E9B\u0E9B\u0E9B",month:"\u0E94\u0E94",day:"\u0EA7\u0EA7"},lt:{year:"mmmm",month:"mm",day:"dd"},lv:{year:"gggg",month:"mm",day:"dd"},meh:{year:"aaaa",month:"mm",day:"dd"},ml:{year:"\u0D35\u0D7C\u0D37\u0D02",month:"\u0D2E\u0D3E\u0D38\u0D02",day:"\u0D24\u0D40\u0D2F\u0D24\u0D3F"},ms:{year:"tttt",month:"mm",day:"hh"},nb:{year:"\xE5\xE5\xE5\xE5",month:"mm",day:"dd"},nl:{year:"jjjj",month:"mm",day:"dd"},nn:{year:"\xE5\xE5\xE5\xE5",month:"mm",day:"dd"},no:{year:"\xE5\xE5\xE5\xE5",month:"mm",day:"dd"},oc:{year:"aaaa",month:"mm",day:"jj"},pl:{year:"rrrr",month:"mm",day:"dd"},pt:{year:"aaaa",month:"mm",day:"dd"},rm:{year:"oooo",month:"mm",day:"dd"},ro:{year:"aaaa",month:"ll",day:"zz"},ru:{year:"\u0433\u0433\u0433\u0433",month:"\u043C\u043C",day:"\u0434\u0434"},sc:{year:"aaaa",month:"mm",day:"dd"},scn:{year:"aaaa",month:"mm",day:"jj"},sk:{year:"rrrr",month:"mm",day:"dd"},sl:{year:"llll",month:"mm",day:"dd"},sr:{year:"\u0433\u0433\u0433\u0433",month:"\u043C\u043C",day:"\u0434\u0434"},sv:{year:"\xE5\xE5\xE5\xE5",month:"mm",day:"dd"},szl:{year:"rrrr",month:"mm",day:"dd"},tg:{year:"\u0441\u0441\u0441\u0441",month:"\u043C\u043C",day:"\u0440\u0440"},th:{year:"\u0E1B\u0E1B\u0E1B\u0E1B",month:"\u0E14\u0E14",day:"\u0E27\u0E27"},tr:{year:"yyyy",month:"aa",day:"gg"},uk:{year:"\u0440\u0440\u0440\u0440",month:"\u043C\u043C",day:"\u0434\u0434"},"zh-CN":{year:"\u5E74",month:"\u6708",day:"\u65E5"},"zh-TW":{year:"\u5E74",month:"\u6708",day:"\u65E5"}},"en");function $3e3ed55ab2966714$export$d3f5c5e0a5023fa0(field,value,locale){if(field==="era"||field==="dayPeriod")return value;if(field==="year"||field==="month"||field==="day")return $3e3ed55ab2966714$var$placeholders.getStringForLocale(field,locale);return"\u2013\u2013";}var $3c0fc76039f1c516$var$EDITABLE_SEGMENTS={year:true,month:true,day:true,hour:true,minute:true,second:true,dayPeriod:true,era:true};var $3c0fc76039f1c516$var$PAGE_STEP={year:5,month:2,day:7,hour:2,minute:15,second:15};var $3c0fc76039f1c516$var$TYPE_MAPPING={dayperiod:"dayPeriod",relatedYear:"year",yearName:"literal",unknown:"literal"};function $3c0fc76039f1c516$export$60e84778edff6d26(props){var locale=props.locale,createCalendar=props.createCalendar,hideTimeZone=props.hideTimeZone,_props$isDisabled=props.isDisabled,isDisabled=_props$isDisabled===void 0?false:_props$isDisabled,_props$isReadOnly=props.isReadOnly,isReadOnly=_props$isReadOnly===void 0?false:_props$isReadOnly,_props$isRequired=props.isRequired,isRequired=_props$isRequired===void 0?false:_props$isRequired,minValue=props.minValue,maxValue=props.maxValue,isDateUnavailable=props.isDateUnavailable;var v2=props.value||props.defaultValue||props.placeholderValue||null;var _$35a22f14a1f04b11$ex3=$35a22f14a1f04b11$export$2440da353cedad43(v2,props.granularity),_$35a22f14a1f04b11$ex4=_slicedToArray(_$35a22f14a1f04b11$ex3,2),granularity=_$35a22f14a1f04b11$ex4[0],defaultTimeZone=_$35a22f14a1f04b11$ex4[1];var timeZone=defaultTimeZone||"UTC";if(v2&&!(granularity in v2))throw new Error("Invalid granularity "+granularity+" for value "+v2.toString());var defaultFormatter=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $fb18d541ea1ad717$export$ad991b66133851cf(locale);},[locale]);var calendar=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return createCalendar(defaultFormatter.resolvedOptions().calendar);},[createCalendar,defaultFormatter]);var _props_defaultValue;var _$458b0a5536c1a7cf$ex9=$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value,(_props_defaultValue=props.defaultValue)!==null&&_props_defaultValue!==void 0?_props_defaultValue:null,props.onChange),_$458b0a5536c1a7cf$ex0=_slicedToArray(_$458b0a5536c1a7cf$ex9,2),value=_$458b0a5536c1a7cf$ex0[0],setDate=_$458b0a5536c1a7cf$ex0[1];var _useState73=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(value),_useState74=_slicedToArray(_useState73,1),initialValue=_useState74[0];var calendarValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var _convertValue;return(_convertValue=$35a22f14a1f04b11$export$61a490a80c552550(value,calendar))!==null&&_convertValue!==void 0?_convertValue:null;},[value,calendar]);var _useState75=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return $35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue,granularity,calendar,defaultTimeZone);}),_useState76=_slicedToArray(_useState75,2),placeholderDate=_useState76[0],setPlaceholderDate=_useState76[1];var val=calendarValue||placeholderDate;var showEra=calendar.identifier==="gregory"&&val.era==="BC";var formatOpts=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var _props_maxGranularity2;return{granularity:granularity,maxGranularity:(_props_maxGranularity2=props.maxGranularity)!==null&&_props_maxGranularity2!==void 0?_props_maxGranularity2:"year",timeZone:defaultTimeZone,hideTimeZone:hideTimeZone,hourCycle:props.hourCycle,showEra:showEra,shouldForceLeadingZeros:props.shouldForceLeadingZeros};},[props.maxGranularity,granularity,props.hourCycle,props.shouldForceLeadingZeros,defaultTimeZone,hideTimeZone,showEra]);var opts=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $35a22f14a1f04b11$export$7e319ea407e63bc0({},formatOpts);},[formatOpts]);var dateFormatter=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return new $fb18d541ea1ad717$export$ad991b66133851cf(locale,opts);},[locale,opts]);var resolvedOptions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return dateFormatter.resolvedOptions();},[dateFormatter]);var allSegments=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return dateFormatter.formatToParts(new Date()).filter(function(seg){return $3c0fc76039f1c516$var$EDITABLE_SEGMENTS[seg.type];}).reduce(function(p2,seg){return p2[$3c0fc76039f1c516$var$TYPE_MAPPING[seg.type]||seg.type]=true,p2;},{});},[dateFormatter]);var _useState77=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return props.value||props.defaultValue?__spreadValues({},allSegments):{};}),_useState78=_slicedToArray(_useState77,2),validSegments=_useState78[0],setValidSegments=_useState78[1];var clearedSegment=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var lastCalendar=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(calendar);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!$14e0f24ef4ac5c92$export$dbc69fd56b53d5e(calendar,lastCalendar.current)){lastCalendar.current=calendar;setPlaceholderDate(function(placeholder){return Object.keys(validSegments).length>0?$11d87f3f76e88657$export$b4a036af3fc0b032(placeholder,calendar):$35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue,granularity,calendar,defaultTimeZone);});}},[calendar,granularity,validSegments,defaultTimeZone,props.placeholderValue]);if(value&&Object.keys(validSegments).length<Object.keys(allSegments).length){validSegments=__spreadValues({},allSegments);setValidSegments(validSegments);}if(value==null&&Object.keys(validSegments).length===Object.keys(allSegments).length){validSegments={};setValidSegments(validSegments);setPlaceholderDate($35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue,granularity,calendar,defaultTimeZone));}var displayValue=calendarValue&&Object.keys(validSegments).length>=Object.keys(allSegments).length?calendarValue:placeholderDate;var setValue=function setValue(newValue){if(props.isDisabled||props.isReadOnly)return;var validKeys=Object.keys(validSegments);var allKeys=Object.keys(allSegments);if(newValue==null){setDate(null);setPlaceholderDate($35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue,granularity,calendar,defaultTimeZone));setValidSegments({});}else if(validKeys.length===0&&clearedSegment.current==null||validKeys.length>=allKeys.length||validKeys.length===allKeys.length-1&&allSegments.dayPeriod&&!validSegments.dayPeriod&&clearedSegment.current!=="dayPeriod"){if(validKeys.length===0){validSegments=__spreadValues({},allSegments);setValidSegments(validSegments);}newValue=$11d87f3f76e88657$export$b4a036af3fc0b032(newValue,(v2===null||v2===void 0?void 0:v2.calendar)||new $3b62074eb05584b2$export$80ee6245ec4f29ec());setDate(newValue);}else setPlaceholderDate(newValue);clearedSegment.current=null;};var dateValue=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return displayValue.toDate(timeZone);},[displayValue,timeZone]);var segments=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $3c0fc76039f1c516$var$processSegments(dateValue,validSegments,dateFormatter,resolvedOptions,displayValue,calendar,locale,granularity);},[dateValue,validSegments,dateFormatter,resolvedOptions,displayValue,calendar,locale,granularity]);if(allSegments.era&&validSegments.year&&!validSegments.era){validSegments.era=true;setValidSegments(__spreadValues({},validSegments));}else if(!allSegments.era&&validSegments.era){delete validSegments.era;setValidSegments(__spreadValues({},validSegments));}var markValid=function markValid(part){validSegments[part]=true;if(part==="year"&&allSegments.era)validSegments.era=true;setValidSegments(__spreadValues({},validSegments));};var adjustSegment=function adjustSegment(type,amount){if(!validSegments[type]){markValid(type);var validKeys=Object.keys(validSegments);var allKeys=Object.keys(allSegments);if(validKeys.length>=allKeys.length||validKeys.length===allKeys.length-1&&allSegments.dayPeriod&&!validSegments.dayPeriod)setValue(displayValue);}else setValue($3c0fc76039f1c516$var$addSegment(displayValue,type,amount,resolvedOptions));};var builtinValidation=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return $35a22f14a1f04b11$export$f18627323ab57ac0(value,minValue,maxValue,isDateUnavailable,formatOpts);},[value,minValue,maxValue,isDateUnavailable,formatOpts]);var validation=$e5be200c675c3b3a$export$fc1a364ae1f3ff10(__spreadProps(__spreadValues({},props),{value:value,builtinValidation:builtinValidation}));var isValueInvalid=validation.displayValidation.isInvalid;var validationState=props.validationState||(isValueInvalid?"invalid":null);var _props_defaultValue1,_props_maxGranularity;return __spreadProps(__spreadValues({},validation),{value:calendarValue,defaultValue:(_props_defaultValue1=props.defaultValue)!==null&&_props_defaultValue1!==void 0?_props_defaultValue1:initialValue,dateValue:dateValue,calendar:calendar,setValue:setValue,segments:segments,dateFormatter:dateFormatter,validationState:validationState,isInvalid:isValueInvalid,granularity:granularity,maxGranularity:(_props_maxGranularity=props.maxGranularity)!==null&&_props_maxGranularity!==void 0?_props_maxGranularity:"year",isDisabled:isDisabled,isReadOnly:isReadOnly,isRequired:isRequired,increment:function increment(part){adjustSegment(part,1);},decrement:function decrement(part){adjustSegment(part,-1);},incrementPage:function incrementPage(part){adjustSegment(part,$3c0fc76039f1c516$var$PAGE_STEP[part]||1);},decrementPage:function decrementPage(part){adjustSegment(part,-($3c0fc76039f1c516$var$PAGE_STEP[part]||1));},setSegment:function setSegment(part,v3){markValid(part);setValue($3c0fc76039f1c516$var$setSegment(displayValue,part,v3,resolvedOptions));},confirmPlaceholder:function confirmPlaceholder(){if(props.isDisabled||props.isReadOnly)return;var validKeys=Object.keys(validSegments);var allKeys=Object.keys(allSegments);if(validKeys.length===allKeys.length-1&&allSegments.dayPeriod&&!validSegments.dayPeriod){validSegments=__spreadValues({},allSegments);setValidSegments(validSegments);setValue(displayValue.copy());}},clearSegment:function clearSegment(part){delete validSegments[part];clearedSegment.current=part;setValidSegments(__spreadValues({},validSegments));var placeholder=$35a22f14a1f04b11$export$66aa2b09de4b1ea5(props.placeholderValue,granularity,calendar,defaultTimeZone);var value2=displayValue;if(part==="dayPeriod"&&"hour"in displayValue&&"hour"in placeholder){var isPM=displayValue.hour>=12;var shouldBePM=placeholder.hour>=12;if(isPM&&!shouldBePM)value2=displayValue.set({hour:displayValue.hour-12});else if(!isPM&&shouldBePM)value2=displayValue.set({hour:displayValue.hour+12});}else if(part==="hour"&&"hour"in displayValue&&displayValue.hour>=12&&validSegments.dayPeriod)value2=displayValue.set({hour:placeholder["hour"]+12});else if(part in displayValue)value2=displayValue.set(_defineProperty2({},part,placeholder[part]));setDate(null);setValue(value2);},formatValue:function formatValue(fieldOptions){if(!calendarValue)return"";var formatOptions=$35a22f14a1f04b11$export$7e319ea407e63bc0(fieldOptions,formatOpts);var formatter=new $fb18d541ea1ad717$export$ad991b66133851cf(locale,formatOptions);return formatter.format(dateValue);},getDateFormatter:function getDateFormatter(locale2,formatOptions){var newOptions=__spreadValues(__spreadValues({},formatOpts),formatOptions);var newFormatOptions=$35a22f14a1f04b11$export$7e319ea407e63bc0({},newOptions);return new $fb18d541ea1ad717$export$ad991b66133851cf(locale2,newFormatOptions);}});}function $3c0fc76039f1c516$var$processSegments(dateValue,validSegments,dateFormatter,resolvedOptions,displayValue,calendar,locale,granularity){var timeValue=["hour","minute","second"];var segments=dateFormatter.formatToParts(dateValue);var processedSegments=[];var _iterator22=_createForOfIteratorHelper(segments),_step22;try{for(_iterator22.s();!(_step22=_iterator22.n()).done;){var segment=_step22.value;var type=$3c0fc76039f1c516$var$TYPE_MAPPING[segment.type]||segment.type;var isEditable=$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type];if(type==="era"&&calendar.getEras().length===1)isEditable=false;var isPlaceholder=$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type]&&!validSegments[type];var placeholder=$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type]?$3e3ed55ab2966714$export$d3f5c5e0a5023fa0(type,segment.value,locale):null;var dateSegment=__spreadProps(__spreadValues({type:type,text:isPlaceholder?placeholder:segment.value},$3c0fc76039f1c516$var$getSegmentLimits(displayValue,type,resolvedOptions)),{isPlaceholder:isPlaceholder,placeholder:placeholder,isEditable:isEditable});if(type==="hour"){processedSegments.push(__spreadProps(__spreadValues({type:"literal",text:"\u2066"},$3c0fc76039f1c516$var$getSegmentLimits(displayValue,"literal",resolvedOptions)),{isPlaceholder:false,placeholder:"",isEditable:false}));processedSegments.push(dateSegment);if(type===granularity)processedSegments.push(__spreadProps(__spreadValues({type:"literal",text:"\u2069"},$3c0fc76039f1c516$var$getSegmentLimits(displayValue,"literal",resolvedOptions)),{isPlaceholder:false,placeholder:"",isEditable:false}));}else if(timeValue.includes(type)&&type===granularity){processedSegments.push(dateSegment);processedSegments.push(__spreadProps(__spreadValues({type:"literal",text:"\u2069"},$3c0fc76039f1c516$var$getSegmentLimits(displayValue,"literal",resolvedOptions)),{isPlaceholder:false,placeholder:"",isEditable:false}));}else processedSegments.push(dateSegment);}}catch(err){_iterator22.e(err);}finally{_iterator22.f();}return processedSegments;}function $3c0fc76039f1c516$var$getSegmentLimits(date,type,options){switch(type){case"era":{var eras=date.calendar.getEras();return{value:eras.indexOf(date.era),minValue:0,maxValue:eras.length-1};}case"year":return{value:date.year,minValue:1,maxValue:date.calendar.getYearsInEra(date)};case"month":return{value:date.month,minValue:$14e0f24ef4ac5c92$export$5412ac11713b72ad(date),maxValue:date.calendar.getMonthsInYear(date)};case"day":return{value:date.day,minValue:$14e0f24ef4ac5c92$export$b2f4953d301981d5(date),maxValue:date.calendar.getDaysInMonth(date)};}if("hour"in date)switch(type){case"dayPeriod":return{value:date.hour>=12?12:0,minValue:0,maxValue:12};case"hour":if(options.hour12){var isPM=date.hour>=12;return{value:date.hour,minValue:isPM?12:0,maxValue:isPM?23:11};}return{value:date.hour,minValue:0,maxValue:23};case"minute":return{value:date.minute,minValue:0,maxValue:59};case"second":return{value:date.second,minValue:0,maxValue:59};}return{};}function $3c0fc76039f1c516$var$addSegment(value,part,amount,options){switch(part){case"era":case"year":case"month":case"day":return value.cycle(part,amount,{round:part==="year"});}if("hour"in value)switch(part){case"dayPeriod":{var hours=value.hour;var isPM=hours>=12;return value.set({hour:isPM?hours-12:hours+12});}case"hour":case"minute":case"second":return value.cycle(part,amount,{round:part!=="hour",hourCycle:options.hour12?12:24});}throw new Error("Unknown segment: "+part);}function $3c0fc76039f1c516$var$setSegment(value,part,segmentValue,options){switch(part){case"day":case"month":case"year":case"era":return value.set(_defineProperty2({},part,segmentValue));}if("hour"in value&&typeof segmentValue==="number")switch(part){case"dayPeriod":{var hours=value.hour;var wasPM=hours>=12;var isPM=segmentValue>=12;if(isPM===wasPM)return value;return value.set({hour:wasPM?hours-12:hours+12});}case"hour":if(options.hour12){var _hours=value.hour;var _wasPM=_hours>=12;if(!_wasPM&&segmentValue===12)segmentValue=0;if(_wasPM&&segmentValue<12)segmentValue+=12;}case"minute":case"second":return value.set(_defineProperty2({},part,segmentValue));}throw new Error("Unknown segment: "+part);}var Cell=createStyled("td",{target:"epw5z1z0"})("padding:0;border:1px solid ",color("paleGrey"),";width:40px;height:40px;&&.enabled:hover{background-color:",color("lightBlue"),";}&&.enabled:focus-within{background-color:",color("lightBlue"),";outline:2px solid ",color("darkOcean"),";}&&.selected{background-color:",color("darkOcean"),";&:hover,&:focus-within{background-color:",color("darkOcean"),";}}&&.selected .day{color:",color("white"),";}&&.hide{border:none;}&&.disabled.show{background-color:",color("offWhite"),";color:",color("slate"),";opacity:1;}&&.disabled.show .day{cursor:not-allowed;color:",color("slate"),";}");var Data=createStyled("div",{target:"epw5z1z1"})("color:",color("ink"),";background:none;text-align:center;border:0;line-height:1.42;cursor:pointer;padding:",spacer(2),";",fontSize("xs"),"");var CalendarCell=function CalendarCell(_ref245){var state=_ref245.state,date=_ref245.date;var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$36a0ac60f04457c5$ex=$36a0ac60f04457c5$export$136073280381448e({date:date},state,ref),cellProps=_$36a0ac60f04457c5$ex.cellProps,buttonProps=_$36a0ac60f04457c5$ex.buttonProps,isSelected=_$36a0ac60f04457c5$ex.isSelected,isOutsideVisibleRange=_$36a0ac60f04457c5$ex.isOutsideVisibleRange,isDisabled=_$36a0ac60f04457c5$ex.isDisabled,isUnavailable=_$36a0ac60f04457c5$ex.isUnavailable,formattedDate=_$36a0ac60f04457c5$ex.formattedDate;return/* @__PURE__ */jsx(Cell,__spreadProps(__spreadValues({},cellProps),{className:"calendar-cell ".concat(isSelected?"selected":""," ").concat(isDisabled?"disabled":"enabled"," ").concat(isUnavailable?"unavailable":""," ").concat(isOutsideVisibleRange?"hide":"show"),children:/* @__PURE__ */jsx(Data,__spreadProps(__spreadValues({},buttonProps),{ref:ref,hidden:isOutsideVisibleRange,className:"day",children:formattedDate}))}));};var Table=createStyled("table",{target:"exbxngi0"})({name:"15dn4s8",styles:"width:100%;border-collapse:collapse;"});var Body=createStyled("tbody",{target:"exbxngi1"})({name:"xlp0ej",styles:"&:before{line-height:1em;}"});var Head=createStyled("th",{target:"exbxngi2"})("padding:",spacer(3),";");var CalendarGrid=function CalendarGrid(_Pb){var _Qb=_Pb,state=_Qb.state,languageDict=_Qb.languageDict,startDay=_Qb.startDay,label=_Qb.label,id=_Qb.id,props=__objRest(_Qb,["state","languageDict","startDay","label","id"]);var _$18f2051aff69b9bf$ex1=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex1.locale;var _$e3031d1f8c9d64eb$ex=$e3031d1f8c9d64eb$export$cb95147730a423f5(props,state),gridProps=_$e3031d1f8c9d64eb$ex.gridProps,headerProps=_$e3031d1f8c9d64eb$ex.headerProps;var weekDays=languageDict.dayNamesMin;gridProps["aria-label"]=label;if(startDay==="Monday"){var _weekDays=weekDays,_weekDays2=_toArray(_weekDays),first=_weekDays2[0],rest=_arrayLikeToArray(_weekDays2).slice(1);weekDays=[].concat(_toConsumableArray(rest),[first]);}var weeksInMonth=$14e0f24ef4ac5c92$export$ccc1b2479e7dd654(state.visibleRange.start,locale);return/* @__PURE__ */jsxs(Table,__spreadProps(__spreadValues({},gridProps),{id:id?"".concat(id,"-datepicker-calendar-grid"):"datepicker-calendar-grid",children:[/* @__PURE__ */jsx("thead",__spreadProps(__spreadValues({},headerProps),{id:id?"".concat(id,"-datepicker-calendar-head"):"datepicker-calendar-head",children:/* @__PURE__ */jsx("tr",{className:"datepicker-calendar-header",children:weekDays.map(function(day,index2){return/* @__PURE__ */jsx(Head,{children:day},index2);})})})),/* @__PURE__ */jsx(Body,{id:id?"".concat(id,"-datepicker-calendar-body"):"datepicker-calendar-body",children:_toConsumableArray(new Array(weeksInMonth).keys()).map(function(weekIndex){return/* @__PURE__ */jsx("tr",{className:"datepicker-calendar-week",children:state.getDatesInWeek(weekIndex).map(function(date,i){return date?/* @__PURE__ */jsx(CalendarCell,{state:state,date:date},i):/* @__PURE__ */jsx("td",{},i);})},weekIndex);})})]}));};var DatePickerButton=function DatePickerButton(_Rb){var _Sb=_Rb,hasError=_Sb.hasError,icon=_Sb.icon,props=__objRest(_Sb,["hasError","icon"]);var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$701a24aa0da5b062$ex=$701a24aa0da5b062$export$ea18c227d4417cc3(props,ref),buttonProps=_$701a24aa0da5b062$ex.buttonProps;return/* @__PURE__ */jsx(Button$1,__spreadProps(__spreadValues({},buttonProps),{ref:ref,kind:hasError?"danger":"utility",size:"sm",className:"datepicker-button",children:icon}));};var Header=/* @__PURE__ */createStyled("div",{target:"e1wzu5cj0"})({name:"7hsixs",styles:"display:flex;align-items:center;justify-content:space-between;margin-bottom:0.5rem;"});var Title=/* @__PURE__ */createStyled("h3",{target:"e1wzu5cj1"})("margin:0;color:",color("slate"),";font-size:1.5rem;font-weight:500;");var oddMonthMap={M01:"January",M02:"February",M03:"March",M04:"April",M05:"May",M06:"June",M07:"July",M08:"August",M09:"September",M10:"October",M11:"November",M12:"December"};var changeTitleToShort=function changeTitleToShort(state,langDict,props){var formatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({month:"short",year:"numeric",timeZone:state.timeZone});var fullMonthFormatter=$896ba0a80a8f4d36$export$85fd5fdf27bacc79({month:"long",timeZone:state.timeZone});var date=state.focusedDate;var formattedDate=formatter.format(date.toDate(state.timeZone));var month=fullMonthFormatter.format(date.toDate(state.timeZone));if(Object.keys(langDict.monthNamesShort).includes(month)&&langDict.code!=="en"){var _formattedDate$split=formattedDate.split(" "),_formattedDate$split2=_slicedToArray(_formattedDate$split,2),m2=_formattedDate$split2[0],_y=_formattedDate$split2[1];formattedDate=formattedDate.replace(m2,langDict.monthNamesShort[month]);props["aria-label"]=formattedDate;}var re=/M[0-1][0-9]/g;var match=re.exec(formattedDate);if(match){formattedDate=formattedDate.replace(match[0],langDict.monthNamesShort[oddMonthMap[match[0]]]);props["aria-label"]=formattedDate;}return[formattedDate,props["aria-label"],props];};var Calendar=function Calendar(_Tb){var _Ub=_Tb,languageDict=_Ub.languageDict,startDay=_Ub.startDay,id=_Ub.id,props=__objRest(_Ub,["languageDict","startDay","id"]);var _$18f2051aff69b9bf$ex10=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex10.locale;var state=$131cf43a05231e1e$export$6d095e787d2b5e1f(__spreadProps(__spreadValues({},props),{locale:locale,createCalendar:$64244302c3013299$export$dd0bbc9b26defe37}));var _$9942cad8a072a530$ex=$9942cad8a072a530$export$3ee915f8151bd4f1(props,state),calendarProps=_$9942cad8a072a530$ex.calendarProps,prevButtonProps=_$9942cad8a072a530$ex.prevButtonProps,nextButtonProps=_$9942cad8a072a530$ex.nextButtonProps,title=_$9942cad8a072a530$ex.title;var label;var _changeTitleToShort=changeTitleToShort(state,languageDict,calendarProps);var _changeTitleToShort2=_slicedToArray(_changeTitleToShort,3);title=_changeTitleToShort2[0];label=_changeTitleToShort2[1];calendarProps=_changeTitleToShort2[2];return/* @__PURE__ */jsxs("div",__spreadProps(__spreadValues({},calendarProps),{className:"calendar",id:id?"".concat(id,"-datepicker-calendar"):"datepicker-calendar",children:[/* @__PURE__ */jsxs(Header,{className:"header",children:[/* @__PURE__ */jsx(DatePickerButton,__spreadProps(__spreadValues({},prevButtonProps),{icon:/* @__PURE__ */jsx(Arrow,{direction:"left",size:"xl"}),className:"direction-button",hasError:false})),/* @__PURE__ */jsx(Title,{children:title}),/* @__PURE__ */jsx(DatePickerButton,__spreadProps(__spreadValues({},nextButtonProps),{icon:/* @__PURE__ */jsx(Arrow,{direction:"right",size:"xl"}),className:"direction-button",hasError:false}))]}),/* @__PURE__ */jsx(CalendarGrid,{state:state,languageDict:languageDict,startDay:startDay,label:label,id:id})]}));};var Segment=createStyled("div",{target:"enen56t0"})({name:"3bsic2",styles:"&:focus-visible{background:#e3e3e3;outline:none;border-radius:3px;}"});var DateSegment=function DateSegment(_ref246){var segment=_ref246.segment,state=_ref246.state;var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$32489daedd52963e$ex=$32489daedd52963e$export$1315d136e6f7581(segment,state,ref),segmentProps=_$32489daedd52963e$ex.segmentProps;return/* @__PURE__ */jsx(Segment,__spreadProps(__spreadValues({},segmentProps),{ref:ref,className:"date-segment ".concat(segment.isPlaceholder?"placeholder":""),children:segment.text}));};var size=function size(_ref247){var size2=_ref247.size,theme=_ref247.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])(padding("xxs",{theme:theme}),";",fontSize("s",{theme:theme}),";","width: calc(8rem + ".concat(size2/4,"rem)"),";");};var DateInput=createStyled("div",{target:"er52pg20"})("display:inline-flex;flex-direction:row;align-items:center;background-clip:padding-box;transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;color:",color("slate"),";background-color:",color("white"),";margin-right:",spacer(1),";",borderRadius$1("default"),";",size,";",function(_ref248){var valid2=_ref248.valid,theme=_ref248.theme;return/* @__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_core__["d" /* css */])("border:1px solid ",style("input.".concat(valid2?"valid":"invalid",".border"),{theme:theme}),";");},";");var formatDateField=function formatDateField(segments,dateFormat,delimiter2){var newSegmentArray=[null,null,null];var formatArray=dateFormat.split(delimiter2);var segmentDelimiter=segments[1];segmentDelimiter.text=delimiter2;var _iterator23=_createForOfIteratorHelper(segments),_step23;try{for(_iterator23.s();!(_step23=_iterator23.n()).done;){var segment=_step23.value;switch(segment.type){case"year":newSegmentArray[formatArray.indexOf("yyyy")]=segment;break;case"month":newSegmentArray[formatArray.indexOf("mm")]=segment;break;case"day":newSegmentArray[formatArray.indexOf("dd")]=segment;break;}}}catch(err){_iterator23.e(err);}finally{_iterator23.f();}newSegmentArray.splice(1,0,segmentDelimiter);newSegmentArray.splice(3,0,segmentDelimiter);return newSegmentArray;};var DateField=function DateField(_Vb){var _Wb=_Vb,valid2=_Wb.valid,size2=_Wb.size,dateFormat=_Wb.dateFormat,delimiter2=_Wb.delimiter,id=_Wb.id,props=__objRest(_Wb,["valid","size","dateFormat","delimiter","id"]);var _$18f2051aff69b9bf$ex11=$18f2051aff69b9bf$export$43bb16f9c6d9e3f7(),locale=_$18f2051aff69b9bf$ex11.locale;var state=$3c0fc76039f1c516$export$60e84778edff6d26(__spreadProps(__spreadValues({},props),{locale:locale,createCalendar:$64244302c3013299$export$dd0bbc9b26defe37}));var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$16f0b7bb276bc17e$ex2=$16f0b7bb276bc17e$export$5591b0b878c1a989(props,state,ref),labelProps=_$16f0b7bb276bc17e$ex2.labelProps,fieldProps=_$16f0b7bb276bc17e$ex2.fieldProps;state.segments=formatDateField(state.segments,dateFormat,delimiter2);return/* @__PURE__ */jsx("div",{className:"wrapper input text-input",children:/* @__PURE__ */jsxs(Fragment,{children:[/* @__PURE__ */jsx("span",__spreadProps(__spreadValues({},labelProps),{id:id?"".concat(id,"-datepicker-label"):"datepicker-label",children:props.label})),/* @__PURE__ */jsx(DateInput,__spreadProps(__spreadValues({valid:valid2},fieldProps),{ref:ref,id:id?"".concat(id,"-datepicker-input"):"datepicker-input",size:size2,className:props.isDisabled?"disabled":"enabled",children:state.segments.map(function(segment,i){return/* @__PURE__ */jsx(DateSegment,{segment:segment,state:state},i);})}))]})});};DateInput.defaultProps={valid:true};var DialogContainer=createStyled("div",{target:"e4mli8z0"})("padding:",spacer(4),";");var Dialog=function Dialog(_Xb){var _Yb=_Xb,title=_Yb.title,children=_Yb.children,id=_Yb.id,props=__objRest(_Yb,["title","children","id"]);var ref=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);var _$40df3f8667284809$ex=$40df3f8667284809$export$d55e7ee900f34e93(props,ref),dialogProps=_$40df3f8667284809$ex.dialogProps,titleProps=_$40df3f8667284809$ex.titleProps;return/* @__PURE__ */jsxs(DialogContainer,__spreadProps(__spreadValues({},dialogProps),{ref:ref,id:id?"".concat(id,"-datepicker-dialog"):"datepicker-dialog",children:[title&&/* @__PURE__ */jsx("h3",__spreadProps(__spreadValues({},titleProps),{style:{marginTop:0},children:title})),children]}));};var PopoverContainer=createStyled("div",{target:"euannhc0"})("background:",color("white"),";margin-top:",spacer(1),";max-height:375px !important;",borderRadius$1("default"),";",shadow$1("distant"),";");var Popover=function Popover(_Zb){var __b=_Zb,children=__b.children,state=__b.state,id=__b.id,props=__objRest(__b,["children","state","id"]);var popoverRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$f2f8a6077418541e$ex=$f2f8a6077418541e$export$542a6fd13ac93354(__spreadProps(__spreadValues({},props),{popoverRef:popoverRef}),state),popoverProps=_$f2f8a6077418541e$ex.popoverProps,underlayProps=_$f2f8a6077418541e$ex.underlayProps;return/* @__PURE__ */jsxs($337b884510726a0d$export$c6fdb837b070b4ff,{children:[/* @__PURE__ */jsx("div",__spreadProps(__spreadValues({},underlayProps),{style:{position:"fixed",inset:0}})),/* @__PURE__ */jsxs(PopoverContainer,__spreadProps(__spreadValues({id:id?"".concat(id,"-datepicker-popover"):"datepicker-popover"},popoverProps),{ref:popoverRef,children:[/* @__PURE__ */jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4,{onDismiss:state.close}),children,/* @__PURE__ */jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4,{onDismiss:state.close})]}))]});};var Main=createStyled("div",{target:"eracfx80"})({name:"asocq5",styles:"display:inline-flex;flex-direction:column;width:100%;"});var DatePickerContainer=createStyled("div",{target:"eracfx81"})({name:"u4p24i",styles:"display:flex;flex-direction:row;align-items:center;"});var DatePicker=function DatePicker(_$b){var _ac=_$b,id=_ac.id,value=_ac.value,onChange=_ac.onChange,focusedDate=_ac.focusedDate,onFocusChange=_ac.onFocusChange,label=_ac.label,size2=_ac.size,hasError=_ac.hasError,shouldForceLeadingZeros=_ac.shouldForceLeadingZeros,startDay=_ac.startDay,delimiter2=_ac.delimiter,dateFormat=_ac.dateFormat,fromDate=_ac.fromDate,toDate=_ac.toDate,languageDict=_ac.languageDict,disabled=_ac.disabled,props=__objRest(_ac,["id","value","onChange","focusedDate","onFocusChange","label","size","hasError","shouldForceLeadingZeros","startDay","delimiter","dateFormat","fromDate","toDate","languageDict","disabled"]);var datePickerProps=__spreadValues({value:value,onChange:onChange,label:label,shouldForceLeadingZeros:shouldForceLeadingZeros},props);var state=$ab5bf3f618090389$export$87194bb378cc3ac2(datePickerProps);var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _$6057a3d2a53a12fd$ex=$6057a3d2a53a12fd$export$42df105a73306d51(datePickerProps,state,ref),groupProps=_$6057a3d2a53a12fd$ex.groupProps,labelProps=_$6057a3d2a53a12fd$ex.labelProps,fieldProps=_$6057a3d2a53a12fd$ex.fieldProps,buttonProps=_$6057a3d2a53a12fd$ex.buttonProps,dialogProps=_$6057a3d2a53a12fd$ex.dialogProps,calendarProps=_$6057a3d2a53a12fd$ex.calendarProps;if(disabled){fieldProps.isDisabled=true;fieldProps.value=null;buttonProps.isDisabled=true;}var dateFieldLocale="".concat(languageDict.code,"-US");return/* @__PURE__ */jsxs(Main,{id:id,className:hasError?"datepicker hasError":"datepicker",children:[/* @__PURE__ */jsx("label",__spreadProps(__spreadValues({},labelProps),{hidden:true,children:label})),/* @__PURE__ */jsxs(DatePickerContainer,__spreadProps(__spreadValues({},groupProps),{ref:ref,children:[/* @__PURE__ */jsx($18f2051aff69b9bf$export$a54013f0d02a8f82,{locale:dateFieldLocale,children:/* @__PURE__ */jsx(DateField,__spreadProps(__spreadValues({},fieldProps),{size:size2,valid:!hasError,dateFormat:dateFormat,delimiter:delimiter2,id:id}))}),/* @__PURE__ */jsx(DatePickerButton,__spreadProps(__spreadValues({},buttonProps),{icon:/* @__PURE__ */jsx(Calendar$1,{size:"xl"}),id:id?"".concat(id,"-datepicker-button"):"datepicker-button",hasError:hasError}))]})),state.isOpen&&/* @__PURE__ */jsx(Popover,{state:state,triggerRef:ref,placement:"bottom start",id:id,children:/* @__PURE__ */jsx(Dialog,__spreadProps(__spreadValues({},dialogProps),{id:id,children:/* @__PURE__ */jsx(Calendar,__spreadProps(__spreadValues({},calendarProps),{firstDayOfWeek:startDay==="Monday"?"mon":"sun",focusedValue:focusedDate,onFocusChange:onFocusChange,minValue:$fae977aafc393c5c$export$6b862160d295c8e(fromDate),maxValue:$fae977aafc393c5c$export$6b862160d295c8e(toDate),languageDict:languageDict,startDay:startDay,id:id}))}))})]});};var required=function required(prop2){throw new Error("Missing required prop `".concat(prop2,"`"));};var createStaticDataSource=function createStaticDataSource(_ref249){var _ref249$items=_ref249.items,items=_ref249$items===void 0?required("items"):_ref249$items,_ref249$filter=_ref249.filter,filter=_ref249$filter===void 0?required("filter"):_ref249$filter;return function(_ref250){var children=_ref250.children,inputValue=_ref250.inputValue;return children({loading:false,items:items.filter(function(item){return!inputValue||filter(item,inputValue);})});};};var useNotifications=function useNotifications(){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(NotificationsContext);};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(190)(module), __webpack_require__(104)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_is_prop_valid__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_utils__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_serialize__ = __webpack_require__(138);







var testOmitPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_2__emotion_is_prop_valid__["a" /* default */];

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var createStyled = function createStyled(tag, options) {
  if (false) {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["f" /* withEmotionCache */])(function (props, context, ref) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["c" /* ThemeContext */].Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["a" /* getRegisteredStyles */])(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (false) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(finalTag, newProps);

        return ele;
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createStyled);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(700);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(702);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(708);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(710);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(196);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(716);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(720);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["d"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["f"] = __values;
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* harmony export (immutable) */ __webpack_exports__["e"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(1008);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(255);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(94);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(256);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(113);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(408);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(1010);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(1011);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(257);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(410);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(409);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instrument__ = __webpack_require__(1012);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dsn__ = __webpack_require__(1013);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_13__dsn__["a"]; });














//# sourceMappingURL=index.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(96)('wks');
var uid = __webpack_require__(63);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(37);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(276);
var toPrimitive = __webpack_require__(43);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(44);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(0), __webpack_require__(20), __webpack_require__(240)) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'apollo-client'], factory) :
    (factory((global['react-apollo'] = {}),global.React,global.PropTypes,global.apolloClient));
}(this, (function (exports,React,PropTypes,apolloClient) { 'use strict';

    function getProps(element) {
        return element.props || element.attributes;
    }
    function isReactElement(element) {
        return !!element.type;
    }
    function isComponentClass(Comp) {
        return Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent);
    }
    function providesChildContext(instance) {
        return !!instance.getChildContext;
    }
    function walkTree(element, context, visitor) {
        if (Array.isArray(element)) {
            element.forEach(function (item) { return walkTree(item, context, visitor); });
            return;
        }
        if (!element) {
            return;
        }
        if (isReactElement(element)) {
            if (typeof element.type === 'function') {
                var Comp = element.type;
                var props = Object.assign({}, Comp.defaultProps, getProps(element));
                var childContext_1 = context;
                var child = void 0;
                if (isComponentClass(Comp)) {
                    var instance_1 = new Comp(props, context);
                    instance_1.props = instance_1.props || props;
                    instance_1.context = instance_1.context || context;
                    instance_1.state = instance_1.state || null;
                    instance_1.setState = function (newState) {
                        if (typeof newState === 'function') {
                            newState = newState(instance_1.state, instance_1.props, instance_1.context);
                        }
                        instance_1.state = Object.assign({}, instance_1.state, newState);
                    };
                    if (instance_1.componentWillMount) {
                        instance_1.componentWillMount();
                    }
                    if (providesChildContext(instance_1)) {
                        childContext_1 = Object.assign({}, context, instance_1.getChildContext());
                    }
                    if (visitor(element, instance_1, context, childContext_1) === false) {
                        return;
                    }
                    child = instance_1.render();
                }
                else {
                    if (visitor(element, null, context) === false) {
                        return;
                    }
                    child = Comp(props, context);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, childContext_1, visitor); });
                    }
                    else {
                        walkTree(child, childContext_1, visitor);
                    }
                }
            }
            else {
                if (visitor(element, null, context) === false) {
                    return;
                }
                if (element.props && element.props.children) {
                    React.Children.forEach(element.props.children, function (child) {
                        if (child) {
                            walkTree(child, context, visitor);
                        }
                    });
                }
            }
        }
        else if (typeof element === 'string' || typeof element === 'number') {
            visitor(element, null, context);
        }
    }
    function hasFetchDataFunction(instance) {
        return typeof instance.fetchData === 'function';
    }
    function isPromise(promise) {
        return typeof promise.then === 'function';
    }
    function getPromisesFromTree(_a) {
        var rootElement = _a.rootElement, _b = _a.rootContext, rootContext = _b === void 0 ? {} : _b;
        var promises = [];
        walkTree(rootElement, rootContext, function (_, instance, context, childContext) {
            if (instance && hasFetchDataFunction(instance)) {
                var promise = instance.fetchData();
                if (isPromise(promise)) {
                    promises.push({ promise: promise, context: childContext || context, instance: instance });
                    return false;
                }
            }
        });
        return promises;
    }
    function getDataFromTree(rootElement, rootContext) {
        if (rootContext === void 0) { rootContext = {}; }
        var promises = getPromisesFromTree({ rootElement: rootElement, rootContext: rootContext });
        if (!promises.length) {
            return Promise.resolve();
        }
        var errors = [];
        var mappedPromises = promises.map(function (_a) {
            var promise = _a.promise, context = _a.context, instance = _a.instance;
            return promise
                .then(function (_) { return getDataFromTree(instance.render(), context); })
                .catch(function (e) { return errors.push(e); });
        });
        return Promise.all(mappedPromises).then(function (_) {
            if (errors.length > 0) {
                var error = errors.length === 1
                    ? errors[0]
                    : new Error(errors.length + " errors were thrown when executing your fetchData functions.");
                error.queryErrors = errors;
                throw error;
            }
        });
    }

    var invariant = __webpack_require__(16);
    var ApolloConsumer = function (props, context) {
        invariant(!!context.client, "Could not find \"client\" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>");
        return props.children(context.client);
    };
    ApolloConsumer.contextTypes = {
        client: PropTypes.object.isRequired,
    };
    ApolloConsumer.propTypes = {
        children: PropTypes.func.isRequired,
    };

    var __extends = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$1 = __webpack_require__(16);
    var ApolloProvider = (function (_super) {
        __extends(ApolloProvider, _super);
        function ApolloProvider(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.operations = new Map();
            invariant$1(props.client, 'ApolloClient was not passed a client instance. Make ' +
                'sure you pass in your client via the "client" prop.');
            if (!props.client.__operations_cache__) {
                props.client.__operations_cache__ = _this.operations;
            }
            return _this;
        }
        ApolloProvider.prototype.getChildContext = function () {
            return {
                client: this.props.client,
                operations: this.props.client.__operations_cache__,
            };
        };
        ApolloProvider.prototype.render = function () {
            return this.props.children;
        };
        ApolloProvider.propTypes = {
            client: PropTypes.object.isRequired,
            children: PropTypes.element.isRequired,
        };
        ApolloProvider.childContextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        return ApolloProvider;
    }(React.Component));

    var invariant$2 = __webpack_require__(16);
    var DocumentType;
    (function (DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })(DocumentType || (DocumentType = {}));
    var cache = new Map();
    function parser(document) {
        var cached = cache.get(document);
        if (cached)
            return cached;
        var variables, type, name;
        invariant$2(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " +
            "DocumentNode. You may need to use 'graphql-tag' or another method " +
            "to convert your operation into a document");
        var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
        var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
        var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
        var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
        invariant$2(!fragments.length || (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
            "You must include a query, subscription or mutation as well");
        invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
            (document + " had " + queries.length + " queries, " + subscriptions.length + " ") +
            ("subscriptions and " + mutations.length + " mutations. ") +
            "You can use 'compose' to join multiple operation types to a component");
        type = queries.length ? DocumentType.Query : DocumentType.Mutation;
        if (!queries.length && !mutations.length)
            type = DocumentType.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        invariant$2(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " +
            (definitions.length + " definitions. ") +
            "You can use 'compose' to join multiple operation types to a component");
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') {
            name = definition.name.value;
        }
        else {
            name = 'data';
        }
        var payload = { name: name, type: type, variables: variables };
        cache.set(document, payload);
        return payload;
    }

    var __extends$1 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var shallowEqual = __webpack_require__(251);
    var invariant$3 = __webpack_require__(16);
    function compact(obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            if (obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    function observableQueryFields(observable) {
        var fields = {
            variables: observable.variables,
            refetch: observable.refetch.bind(observable),
            fetchMore: observable.fetchMore.bind(observable),
            updateQuery: observable.updateQuery.bind(observable),
            startPolling: observable.startPolling.bind(observable),
            stopPolling: observable.stopPolling.bind(observable),
            subscribeToMore: observable.subscribeToMore.bind(observable),
        };
        return fields;
    }
    var Query = (function (_super) {
        __extends$1(Query, _super);
        function Query(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.previousData = {};
            _this.startQuerySubscription = function () {
                if (_this.querySubscription)
                    return;
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: _this.updateCurrentData,
                    error: function (error) {
                        _this.resubscribeToQuery();
                        if (!error.hasOwnProperty('graphQLErrors'))
                            throw error;
                        _this.updateCurrentData();
                    },
                });
            };
            _this.removeQuerySubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            _this.updateCurrentData = function () {
                if (_this.hasMounted)
                    _this.forceUpdate();
            };
            _this.getQueryResult = function () {
                var data = { data: Object.create(null) };
                Object.assign(data, observableQueryFields(_this.queryObservable));
                var currentResult = _this.queryObservable.currentResult();
                var loading = currentResult.loading, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) {
                    error = new apolloClient.ApolloError({ graphQLErrors: errors });
                }
                Object.assign(data, { loading: loading, networkStatus: networkStatus, error: error });
                if (loading) {
                    Object.assign(data.data, _this.previousData, currentResult.data);
                }
                else if (error) {
                    Object.assign(data, {
                        data: (_this.queryObservable.getLastResult() || {}).data,
                    });
                }
                else {
                    Object.assign(data.data, currentResult.data);
                    _this.previousData = currentResult.data;
                }
                if (!_this.querySubscription) {
                    data.refetch = function (args) {
                        return new Promise(function (r, f) {
                            _this.refetcherQueue = { resolve: r, reject: f, args: args };
                        });
                    };
                }
                data.client = _this.client;
                return data;
            };
            _this.client = props.client || context.client;
            invariant$3(!!_this.client, "Could not find \"client\" in the context of Query or as passed props. Wrap the root component in an <ApolloProvider>");
            _this.initializeQueryObservable(props);
            return _this;
        }
        Query.prototype.fetchData = function () {
            if (this.props.skip)
                return false;
            var _a = this.props, children = _a.children, ssr = _a.ssr, displayName = _a.displayName, skip = _a.skip, client = _a.client, opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client"]);
            var fetchPolicy = opts.fetchPolicy;
            if (ssr === false)
                return false;
            if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
                fetchPolicy = 'cache-first';
            }
            var observable = this.client.watchQuery(__assign({}, opts, { fetchPolicy: fetchPolicy }));
            var result = this.queryObservable.currentResult();
            return result.loading ? observable.result() : false;
        };
        Query.prototype.componentDidMount = function () {
            this.hasMounted = true;
            if (this.props.skip)
                return;
            this.startQuerySubscription();
            if (this.refetcherQueue) {
                var _a = this.refetcherQueue, args = _a.args, resolve = _a.resolve, reject = _a.reject;
                this.queryObservable.refetch(args)
                    .then(resolve)
                    .catch(reject);
            }
        };
        Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (nextProps.skip && !this.props.skip) {
                this.removeQuerySubscription();
                return;
            }
            var client = nextProps.client;
            if (shallowEqual(this.props, nextProps) &&
                (this.client === client || this.client === nextContext.client)) {
                return;
            }
            if (this.client !== client && this.client !== nextContext.client) {
                if (client) {
                    this.client = client;
                }
                else {
                    this.client = nextContext.client;
                }
                this.removeQuerySubscription();
                this.queryObservable = null;
                this.previousData = {};
                this.updateQuery(nextProps);
            }
            if (this.props.query !== nextProps.query) {
                this.removeQuerySubscription();
            }
            this.updateQuery(nextProps);
            if (nextProps.skip)
                return;
            this.startQuerySubscription();
        };
        Query.prototype.componentWillUnmount = function () {
            this.removeQuerySubscription();
            this.hasMounted = false;
        };
        Query.prototype.render = function () {
            var children = this.props.children;
            var queryResult = this.getQueryResult();
            return children(queryResult);
        };
        Query.prototype.extractOptsFromProps = function (props) {
            var variables = props.variables, pollInterval = props.pollInterval, fetchPolicy = props.fetchPolicy, errorPolicy = props.errorPolicy, notifyOnNetworkStatusChange = props.notifyOnNetworkStatusChange, query = props.query, _a = props.displayName, displayName = _a === void 0 ? 'Query' : _a, _b = props.context, context = _b === void 0 ? {} : _b;
            this.operation = parser(query);
            invariant$3(this.operation.type === DocumentType.Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === DocumentType.Mutation ? 'mutation' : 'subscription') + ".");
            return compact({
                variables: variables,
                pollInterval: pollInterval,
                query: query,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
                notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
                metadata: { reactComponent: { displayName: displayName } },
                context: context,
            });
        };
        Query.prototype.initializeQueryObservable = function (props) {
            var opts = this.extractOptsFromProps(props);
            if (this.context.operations) {
                this.context.operations.set(this.operation.name, {
                    query: opts.query,
                    variables: opts.variables,
                });
            }
            this.queryObservable = this.client.watchQuery(opts);
        };
        Query.prototype.updateQuery = function (props) {
            if (!this.queryObservable)
                this.initializeQueryObservable(props);
            this.queryObservable.setOptions(this.extractOptsFromProps(props))
                .catch(function () { return null; });
        };
        Query.prototype.resubscribeToQuery = function () {
            this.removeQuerySubscription();
            var lastError = this.queryObservable.getLastError();
            var lastResult = this.queryObservable.getLastResult();
            this.queryObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.queryObservable, { lastError: lastError, lastResult: lastResult });
        };
        Query.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Query.propTypes = {
            children: PropTypes.func.isRequired,
            fetchPolicy: PropTypes.string,
            notifyOnNetworkStatusChange: PropTypes.bool,
            pollInterval: PropTypes.number,
            query: PropTypes.object.isRequired,
            variables: PropTypes.object,
            ssr: PropTypes.bool,
        };
        return Query;
    }(React.Component));

    var __extends$2 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$4 = __webpack_require__(16);
    var shallowEqual$1 = __webpack_require__(251);
    var initialState = {
        loading: false,
        called: false,
        error: undefined,
        data: undefined,
    };
    var Mutation = (function (_super) {
        __extends$2(Mutation, _super);
        function Mutation(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.runMutation = function (options) {
                if (options === void 0) { options = {}; }
                _this.onStartMutation();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(options)
                    .then(function (response) {
                    _this.onCompletedMutation(response, mutationId);
                    return response;
                })
                    .catch(function (e) {
                    _this.onMutationError(e, mutationId);
                    if (!_this.props.onError)
                        throw e;
                });
            };
            _this.mutate = function (options) {
                var _a = _this.props, mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, context = _b === void 0 ? {} : _b;
                var refetchQueries = options.refetchQueries || _this.props.refetchQueries;
                if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
                    refetchQueries = refetchQueries.map(function (x) {
                        if (typeof x === 'string' && _this.context.operations)
                            return _this.context.operations.get(x) || x;
                        return x;
                    });
                    delete options.refetchQueries;
                }
                return _this.client.mutate(__assign$1({ mutation: mutation,
                    variables: variables,
                    optimisticResponse: optimisticResponse,
                    refetchQueries: refetchQueries,
                    update: update,
                    context: context }, options));
            };
            _this.onStartMutation = function () {
                if (!_this.state.loading && !_this.props.ignoreResults) {
                    _this.setState({
                        loading: true,
                        error: undefined,
                        data: undefined,
                        called: true,
                    });
                }
            };
            _this.onCompletedMutation = function (response, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var _a = _this.props, onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
                var data = response.data;
                var callOncomplete = function () { return (onCompleted ? onCompleted(data) : null); };
                if (_this.isMostRecentMutation(mutationId) && !ignoreResults) {
                    _this.setState({ loading: false, data: data }, callOncomplete);
                }
                else {
                    callOncomplete();
                }
            };
            _this.onMutationError = function (error, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var onError = _this.props.onError;
                var callOnError = function () { return (onError ? onError(error) : null); };
                if (_this.isMostRecentMutation(mutationId)) {
                    _this.setState({ loading: false, error: error }, callOnError);
                }
                else {
                    callOnError();
                }
            };
            _this.generateNewMutationId = function () {
                _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
                return _this.mostRecentMutationId;
            };
            _this.isMostRecentMutation = function (mutationId) {
                return _this.mostRecentMutationId === mutationId;
            };
            _this.verifyDocumentIsMutation = function (mutation) {
                var operation = parser(mutation);
                invariant$4(operation.type === DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === DocumentType.Query ? 'query' : 'subscription') + ".");
            };
            _this.verifyContext = function (context) {
                invariant$4(!!context.client, "Could not find \"client\" in the context of Mutation. Wrap the root component in an <ApolloProvider>");
            };
            _this.verifyContext(context);
            _this.client = context.client;
            _this.verifyDocumentIsMutation(props.mutation);
            _this.mostRecentMutationId = 0;
            _this.state = initialState;
            return _this;
        }
        Mutation.prototype.componentDidMount = function () {
            this.hasMounted = true;
        };
        Mutation.prototype.componentWillUnmount = function () {
            this.hasMounted = false;
        };
        Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (shallowEqual$1(this.props, nextProps) && this.client === nextContext.client) {
                return;
            }
            if (this.props.mutation !== nextProps.mutation) {
                this.verifyDocumentIsMutation(nextProps.mutation);
            }
            if (this.client !== nextContext.client) {
                this.client = nextContext.client;
                this.setState(initialState);
            }
        };
        Mutation.prototype.render = function () {
            var children = this.props.children;
            var _a = this.state, loading = _a.loading, data = _a.data, error = _a.error, called = _a.called;
            var result = {
                called: called,
                loading: loading,
                data: data,
                error: error,
            };
            return children(this.runMutation, result);
        };
        Mutation.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Mutation.propTypes = {
            mutation: PropTypes.object.isRequired,
            variables: PropTypes.object,
            optimisticResponse: PropTypes.object,
            refetchQueries: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.string),
                PropTypes.arrayOf(PropTypes.object),
                PropTypes.func,
            ]),
            update: PropTypes.func,
            children: PropTypes.func.isRequired,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
        };
        return Mutation;
    }(React.Component));

    var __extends$3 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var shallowEqual$2 = __webpack_require__(251);
    var invariant$5 = __webpack_require__(16);
    var Subscription = (function (_super) {
        __extends$3(Subscription, _super);
        function Subscription(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.initialize = function (props) {
                if (_this.queryObservable)
                    return;
                _this.queryObservable = _this.client.subscribe({
                    query: props.subscription,
                    variables: props.variables,
                });
            };
            _this.startSubscription = function () {
                if (_this.querySubscription)
                    return;
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: _this.updateCurrentData,
                    error: _this.updateError,
                });
            };
            _this.getInitialState = function () { return ({
                loading: true,
                error: undefined,
                data: undefined,
            }); };
            _this.updateCurrentData = function (result) {
                _this.setState({
                    data: result.data,
                    loading: false,
                    error: undefined,
                });
            };
            _this.updateError = function (error) {
                _this.setState({
                    error: error,
                    loading: false,
                });
            };
            _this.endSubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            invariant$5(!!context.client, "Could not find \"client\" in the context of Subscription. Wrap the root component in an <ApolloProvider>");
            _this.client = context.client;
            _this.initialize(props);
            _this.state = _this.getInitialState();
            return _this;
        }
        Subscription.prototype.componentDidMount = function () {
            this.startSubscription();
        };
        Subscription.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (shallowEqual$2(this.props, nextProps) && this.client === nextContext.client) {
                return;
            }
            var shouldNotResubscribe = this.props.shouldResubscribe === false;
            if (this.client !== nextContext.client) {
                this.client = nextContext.client;
            }
            if (!shouldNotResubscribe) {
                this.endSubscription();
                delete this.queryObservable;
                this.initialize(nextProps);
                this.startSubscription();
                this.setState(this.getInitialState());
                return;
            }
            this.initialize(nextProps);
            this.startSubscription();
        };
        Subscription.prototype.componentWillUnmount = function () {
            this.endSubscription();
        };
        Subscription.prototype.render = function () {
            var result = Object.assign({}, this.state, {
                variables: this.props.variables,
            });
            return this.props.children(result);
        };
        Subscription.contextTypes = {
            client: PropTypes.object.isRequired,
        };
        Subscription.propTypes = {
            subscription: PropTypes.object.isRequired,
            variables: PropTypes.object,
            children: PropTypes.func.isRequired,
        };
        return Subscription;
    }(React.Component));

    var __extends$4 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$6 = __webpack_require__(16);
    var defaultMapPropsToOptions = function () { return ({}); };
    var defaultMapPropsToSkip = function () { return false; };
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function calculateVariablesFromProps(operation, props, graphQLDisplayName, wrapperName) {
        var variables = {};
        for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
            var _b = _a[_i], variable = _b.variable, type = _b.type;
            if (!variable.name || !variable.name.value)
                continue;
            var variableName = variable.name.value;
            var variableProp = props[variableName];
            if (typeof variableProp !== 'undefined') {
                variables[variableName] = variableProp;
                continue;
            }
            if (type.kind !== 'NonNullType') {
                variables[variableName] = null;
                continue;
            }
            if (operation.type === DocumentType.Mutation)
                return;
            invariant$6(typeof variableProp !== 'undefined', "The operation '" + operation.name + "' wrapping '" + wrapperName + "' " +
                ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") +
                ("passed to '" + graphQLDisplayName + "'"));
        }
        return variables;
    }
    var GraphQLBase = (function (_super) {
        __extends$4(GraphQLBase, _super);
        function GraphQLBase(props) {
            var _this = _super.call(this, props) || this;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        GraphQLBase.prototype.getWrappedInstance = function () {
            invariant$6(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
            return this.wrappedInstance;
        };
        GraphQLBase.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        return GraphQLBase;
    }(React.Component));

    var __extends$5 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$2 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics = __webpack_require__(59);
    function query(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$5(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Query, __assign$2({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document, warnUnhandledError: true }), function (_a) {
                        var _ = _a.client, data = _a.data, r = __rest$1(_a, ["client", "data"]);
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$2({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$2({}, props, childProps));
                        var _b, _c;
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$6 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$3 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var hoistNonReactStatics$1 = __webpack_require__(59);
    function mutation(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$6(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var props = this.props;
                    var opts = mapPropsToOptions(props);
                    if (operationOptions.withRef) {
                        this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: this.setWrappedInstance,
                        });
                    }
                    if (!opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Mutation, __assign$3({}, opts, { mutation: document, ignoreResults: true }), function (mutate, _result) {
                        var name = operationOptions.name || 'mutate';
                        var childProps = (_a = {}, _a[name] = mutate, _a);
                        if (operationOptions.props) {
                            var newResult = (_b = {}, _b[name] = mutate, _b.ownProps = props, _b);
                            childProps = operationOptions.props(newResult);
                        }
                        return React.createElement(WrappedComponent, __assign$3({}, props, childProps));
                        var _a, _b;
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$1(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$7 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$4 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics$2 = __webpack_require__(59);
    function subscribe(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$7(GraphQL, _super);
                function GraphQL(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = { resubscribe: false };
                    return _this;
                }
                GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
                    if (!shouldResubscribe)
                        return;
                    this.setState({
                        resubscribe: shouldResubscribe(this.props, nextProps),
                    });
                };
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Subscription, __assign$4({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                        var data = _a.data, r = __rest$2(_a, ["data"]);
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$4({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$4({}, props, childProps));
                        var _b, _c;
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$2(GraphQL, WrappedComponent, {});
        };
    }

    function graphql(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        switch (parser(document).type) {
            case DocumentType.Mutation:
                return mutation(document, operationOptions);
            case DocumentType.Subscription:
                return subscribe(document, operationOptions);
            case DocumentType.Query:
            default:
                return query(document, operationOptions);
        }
    }

    var __extends$8 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$5 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$7 = __webpack_require__(16);
    var hoistNonReactStatics$3 = __webpack_require__(59);
    function getDisplayName$1(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function withApollo(WrappedComponent, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
        var WithApollo = (function (_super) {
            __extends$8(WithApollo, _super);
            function WithApollo(props) {
                var _this = _super.call(this, props) || this;
                _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
                return _this;
            }
            WithApollo.prototype.getWrappedInstance = function () {
                invariant$7(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
                return this.wrappedInstance;
            };
            WithApollo.prototype.setWrappedInstance = function (ref) {
                this.wrappedInstance = ref;
            };
            WithApollo.prototype.render = function () {
                var _this = this;
                return (React.createElement(ApolloConsumer, null, function (client) {
                    var props = Object.assign({}, _this.props, {
                        client: client,
                        ref: operationOptions.withRef ? _this.setWrappedInstance : undefined,
                    });
                    return React.createElement(WrappedComponent, __assign$5({}, props));
                }));
            };
            WithApollo.displayName = withDisplayName;
            WithApollo.WrappedComponent = WrappedComponent;
            return WithApollo;
        }(React.Component));
        return hoistNonReactStatics$3(WithApollo, WrappedComponent, {});
    }

    var compose = __webpack_require__(995);

    exports.compose = compose;
    exports.getDataFromTree = getDataFromTree;
    exports.ApolloConsumer = ApolloConsumer;
    exports.ApolloProvider = ApolloProvider;
    exports.Query = Query;
    exports.Mutation = Mutation;
    exports.Subscription = Subscription;
    exports.graphql = graphql;
    exports.withApollo = withApollo;
    exports.walkTree = walkTree;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-apollo.browser.umd.js.map


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(697)();
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_relay__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_findValue__ = __webpack_require__(265);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var optionsDefaults={fetchPolicy:'cache-and-network'};var withConnectionQuery=function withConnectionQuery(_ref){var graphqlQuery=_ref.graphqlQuery,paginated=_ref.paginated,namespace=_ref.namespace,_ref$perPage=_ref.perPage,perPage=_ref$perPage===undefined?25:_ref$perPage;return Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */],__WEBPACK_IMPORTED_MODULE_1_components_withQueryParams__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_react_apollo__["graphql"])(graphqlQuery,{options:function options(_ref2){var query=_ref2.query,variables=_ref2.variables;return Object.assign({},optionsDefaults,{variables:paginated?Object.assign({first:perPage,q:query.get('q')||''},variables):variables});},props:function props(_ref3){var ownProps=_ref3.ownProps,data=_ref3.data;var loading=data.loading,fetchMore=data.fetchMore;var connection=Object(__WEBPACK_IMPORTED_MODULE_5_utils_findValue__["a" /* default */])(data,namespace);var baseProps=Object.assign({loading:loading,connection:connection},ownProps);if(!paginated){return baseProps;}return Object.assign({},baseProps,{loadMoreEntries:function loadMoreEntries(direction){var _Object$assign;if(Object(__WEBPACK_IMPORTED_MODULE_4_utils_relay__["a" /* isConnectionEnd */])(connection,direction)){return;}var edges=connection.edges;var forward=direction==='forward';var lastNode=forward?edges[edges.length-1]:edges[0];var cursorKey=forward?'after':'before';var variables=Object.assign((_Object$assign={first:forward?perPage:null,last:forward?null:perPage},_defineProperty(_Object$assign,cursorKey,lastNode.cursor),_defineProperty(_Object$assign,'q',ownProps.query.get('q')||''),_Object$assign),ownProps.variables);return fetchMore({graphqlQuery:graphqlQuery,variables:variables,updateQuery:function updateQuery(previousResult,_ref4){var fetchMoreResult=_ref4.fetchMoreResult;var connectionQuery=Object(__WEBPACK_IMPORTED_MODULE_5_utils_findValue__["a" /* default */])(fetchMoreResult,namespace)||{};var edges=connectionQuery.edges;return edges&&edges.length?fetchMoreResult:previousResult;}});}});}}));};/* harmony default export */ __webpack_exports__["a"] = (withConnectionQuery);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ConnectionTable__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Pagination__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_relay__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableToolbar=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e6mym910',label:'TableToolbar'})('display:flex;justify-content:space-between;margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_4_stylist__["V" /* spacer */])(4),';');var PaginatedConnectionTable=function(_Component){_inherits(PaginatedConnectionTable,_Component);function PaginatedConnectionTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaginatedConnectionTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaginatedConnectionTable.__proto__||Object.getPrototypeOf(PaginatedConnectionTable)).call.apply(_ref,[this].concat(args))),_this),_this.state={q:_this.props.query.get('q')||''},_this.handleChange=function(e){return _this.setState({q:e.target.value},_this.notifyChange);},_this.notifyChange=__WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(function(){return _this.props.history.replace('?q='+_this.state.q);},250),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaginatedConnectionTable,[{key:'render',value:function render(){var _props=this.props,connection=_props.connection,loadMoreEntries=_props.loadMoreEntries,query=_props.query,showNew=_props.showNew,showManage=_props.showManage,manage=_props.manage,history=_props.history,rest=_objectWithoutProperties(_props,['connection','loadMoreEntries','query','showNew','showManage','manage','history']);var q=this.state.q;var url=rest.match.url;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TableToolbar,{role:'toolbar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["t" /* Input */],{onChange:this.handleChange,value:q,placeholder:'Search',inline:true}),showNew&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["d" /* ButtonLink */],{marginLeft:true,kind:'standard',to:url+'/new'},'New'),showManage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["d" /* ButtonLink */],{marginLeft:true,kind:'standard',to:url+'/manage'},'Add/Remove'),manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["c" /* Button */],{marginLeft:true,kind:'standard',onClick:history.goBack},'Back')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Pagination__["a" /* default */],{hasPreviousPage:!Object(__WEBPACK_IMPORTED_MODULE_5_utils_relay__["a" /* isConnectionEnd */])(connection,'backward'),onPrevClick:function onPrevClick(){return loadMoreEntries('backward');},hasNextPage:!Object(__WEBPACK_IMPORTED_MODULE_5_utils_relay__["a" /* isConnectionEnd */])(connection,'forward'),onNextClick:function onNextClick(){return loadMoreEntries('forward');}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ConnectionTable__["a" /* default */],Object.assign({history:history,connection:connection,manage:manage},rest)));}}]);return PaginatedConnectionTable;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PaginatedConnectionTable);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var createDesc = __webpack_require__(62);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(25);
var has = __webpack_require__(29);
var SRC = __webpack_require__(63)('src');
var $toString = __webpack_require__(455);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(34).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(6);
var defined = __webpack_require__(44);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(405);
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* unused harmony reexport configureScope */
/* unused harmony reexport startTransaction */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport Scope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(1015);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(1016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(1018);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__(1019);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__request__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(1020);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(411);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations__ = __webpack_require__(1021);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__integrations__; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(97);
var defined = __webpack_require__(44);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(98);
var createDesc = __webpack_require__(62);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(43);
var has = __webpack_require__(29);
var IE8_DOM_DEFINE = __webpack_require__(276);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(29);
var toObject = __webpack_require__(15);
var IE_PROTO = __webpack_require__(161)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Broadcast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$1 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = "production";

var invariant$3 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$2 = invariant$3;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function createBroadcast(initialValue) {
  var currentValue = initialValue;
  var subscribers = [];

  var getValue = function getValue() {
    return currentValue;
  };

  var publish = function publish(state) {
    currentValue = state;
    subscribers.forEach(function (s) {
      return s(currentValue);
    });
  };

  var subscribe = function subscribe(subscriber) {
    subscribers.push(subscriber);

    return function () {
      subscribers = subscribers.filter(function (s) {
        return s !== subscriber;
      });
    };
  };

  return {
    getValue: getValue,
    publish: publish,
    subscribe: subscribe
  };
}

/**
 * A <Broadcast> provides a generic way for descendants to "subscribe"
 * to some value that changes over time, bypassing any intermediate
 * shouldComponentUpdate's in the hierarchy. It puts all subscription
 * functions on context.broadcasts, keyed by "channel".
 *
 * To use it, a subscriber must opt-in to context.broadcasts. See the
 * <Subscriber> component for a reference implementation.
 */

var Broadcast = function (_React$Component) {
  inherits(Broadcast, _React$Component);

  function Broadcast() {
    var _temp, _this, _ret;

    classCallCheck(this, Broadcast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.value), _temp), possibleConstructorReturn(_this, _ret);
  }

  Broadcast.prototype.getChildContext = function getChildContext() {
    var _babelHelpers$extends;

    return {
      broadcasts: _extends({}, this.context.broadcasts, (_babelHelpers$extends = {}, _babelHelpers$extends[this.props.channel] = this.broadcast, _babelHelpers$extends))
    };
  };

  Broadcast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    invariant_1$2(this.props.channel === nextProps.channel, "You cannot change <Broadcast channel>");

    if (!this.props.compareValues(this.props.value, nextProps.value)) {
      this.broadcast.publish(nextProps.value);
    }
  };

  Broadcast.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
  };

  return Broadcast;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Broadcast.propTypes = {
  channel: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  compareValues: propTypes.func,
  value: propTypes.any
};
Broadcast.defaultProps = {
  compareValues: function compareValues(prevValue, nextValue) {
    return prevValue === nextValue;
  }
};
Broadcast.contextTypes = {
  broadcasts: propTypes.object
};
Broadcast.childContextTypes = {
  broadcasts: propTypes.object.isRequired
};

/**
 * A <Subscriber> pulls the value for a channel off of context.broadcasts
 * and passes it to its children function.
 */

var Subscriber = function (_React$Component) {
  inherits(Subscriber, _React$Component);

  function Subscriber() {
    var _temp, _this, _ret;

    classCallCheck(this, Subscriber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      value: undefined
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Subscriber.prototype.getBroadcast = function getBroadcast() {
    var broadcasts = this.context.broadcasts || {};
    var broadcast = broadcasts[this.props.channel];

    invariant_1$2(this.props.quiet || broadcast, '<Subscriber channel="%s"> must be rendered in the context of a <Broadcast channel="%s">', this.props.channel, this.props.channel);

    return broadcast;
  };

  Subscriber.prototype.componentWillMount = function componentWillMount() {
    var broadcast = this.getBroadcast();

    if (broadcast) {
      this.setState({
        value: broadcast.getValue()
      });
    }
  };

  Subscriber.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var broadcast = this.getBroadcast();

    if (broadcast) {
      this.unsubscribe = broadcast.subscribe(function (value) {
        _this2.setState({ value: value });
      });
    }
  };

  Subscriber.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  };

  Subscriber.prototype.render = function render() {
    var children = this.props.children;

    return children ? children(this.state.value) : null;
  };

  return Subscriber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Subscriber.propTypes = {
  channel: propTypes.string.isRequired,
  children: propTypes.func,
  quiet: propTypes.bool
};
Subscriber.defaultProps = {
  quiet: false
};
Subscriber.contextTypes = {
  broadcasts: propTypes.object
};




/***/ }),
/* 34 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = exports.getHasFailedAuth = exports.getLastError = exports.getIsRestored = exports.getAuthenticator = exports.getIsAuthenticated = exports.getSessionData = exports.oauth2BearerAuthorizer = exports.createCredentialsAuthenticator = exports.createOauth2ImplicitGrantAuthenticator = exports.storage = exports.getInitialAuthState = exports.createCookieStore = exports.createSessionStorageStore = exports.createLocalStorageStore = exports.createAdaptiveStore = exports.updateSession = exports.invalidateSession = exports.fetch = exports.clearError = exports.authenticate = exports.createAuthenticator = exports.reducer = exports.createAuthMiddleware = undefined;

var _middleware = __webpack_require__(686);

Object.defineProperty(exports, 'createAuthMiddleware', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_middleware).default;
  }
});

var _reducer = __webpack_require__(192);

Object.defineProperty(exports, 'reducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer).default;
  }
});

var _createAuthenticator = __webpack_require__(193);

Object.defineProperty(exports, 'createAuthenticator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createAuthenticator).default;
  }
});

var _actions = __webpack_require__(191);

Object.defineProperty(exports, 'authenticate', {
  enumerable: true,
  get: function get() {
    return _actions.authenticate;
  }
});
Object.defineProperty(exports, 'clearError', {
  enumerable: true,
  get: function get() {
    return _actions.clearError;
  }
});
Object.defineProperty(exports, 'fetch', {
  enumerable: true,
  get: function get() {
    return _actions.fetch;
  }
});
Object.defineProperty(exports, 'invalidateSession', {
  enumerable: true,
  get: function get() {
    return _actions.invalidateSession;
  }
});
Object.defineProperty(exports, 'updateSession', {
  enumerable: true,
  get: function get() {
    return _actions.updateSession;
  }
});

var _adaptive = __webpack_require__(322);

Object.defineProperty(exports, 'createAdaptiveStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adaptive).default;
  }
});

var _localStorage = __webpack_require__(324);

Object.defineProperty(exports, 'createLocalStorageStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_localStorage).default;
  }
});

var _sessionStorage = __webpack_require__(690);

Object.defineProperty(exports, 'createSessionStorageStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sessionStorage).default;
  }
});

var _cookie = __webpack_require__(323);

Object.defineProperty(exports, 'createCookieStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cookie).default;
  }
});

var _enhancer = __webpack_require__(691);

Object.defineProperty(exports, 'getInitialAuthState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_enhancer).default;
  }
});

var _default = __webpack_require__(321);

Object.defineProperty(exports, 'storage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_default).default;
  }
});

var _oauth2ImplicitGrant = __webpack_require__(692);

Object.defineProperty(exports, 'createOauth2ImplicitGrantAuthenticator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_oauth2ImplicitGrant).default;
  }
});

var _credentials = __webpack_require__(693);

Object.defineProperty(exports, 'createCredentialsAuthenticator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_credentials).default;
  }
});

var _oauth2Bearer = __webpack_require__(695);

Object.defineProperty(exports, 'oauth2BearerAuthorizer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_oauth2Bearer).default;
  }
});

var _selectors = __webpack_require__(326);

Object.defineProperty(exports, 'getSessionData', {
  enumerable: true,
  get: function get() {
    return _selectors.getSessionData;
  }
});
Object.defineProperty(exports, 'getIsAuthenticated', {
  enumerable: true,
  get: function get() {
    return _selectors.getIsAuthenticated;
  }
});
Object.defineProperty(exports, 'getAuthenticator', {
  enumerable: true,
  get: function get() {
    return _selectors.getAuthenticator;
  }
});
Object.defineProperty(exports, 'getIsRestored', {
  enumerable: true,
  get: function get() {
    return _selectors.getIsRestored;
  }
});
Object.defineProperty(exports, 'getLastError', {
  enumerable: true,
  get: function get() {
    return _selectors.getLastError;
  }
});
Object.defineProperty(exports, 'getHasFailedAuth', {
  enumerable: true,
  get: function get() {
    return _selectors.getHasFailedAuth;
  }
});

var _actionTypes2 = __webpack_require__(134);

var _actionTypes = _interopRequireWildcard(_actionTypes2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionTypes = exports.actionTypes = _actionTypes;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(349);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(960);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments__ = __webpack_require__(961);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__fragments__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFromAST__ = __webpack_require__(389);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform__ = __webpack_require__(962);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storeUtils__ = __webpack_require__(242);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_assign__ = __webpack_require__(390);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__util_assign__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_environment__ = __webpack_require__(243);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__ = __webpack_require__(963);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isEqual__ = __webpack_require__(964);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__util_isEqual__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__ = __webpack_require__(965);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__ = __webpack_require__(966);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__["a"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_serializeErrorMessages__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_fields__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_withMutate__ = __webpack_require__(1082);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var SpacedButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["c" /* Button */],{target:'e136v3d50',label:'SpacedButton'})('margin-left:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(2),';');var fieldValue=function fieldValue(field){return field.value||(field.type==='boolean'?false:'');};var buildInitialValues=function buildInitialValues(record,fields){return fields.reduce(function(acc,field){return Object.assign({},acc,_defineProperty({},field.name,record?record[field.name]||fieldValue(field):fieldValue(field)));},{});};var FormForRecordForm=function FormForRecordForm(_ref){var record=_ref.record,fields=_ref.fields,schema=_ref.schema,backPath=_ref.backPath,variables=_ref.variables,mutationArgs=_ref.mutationArgs,notify=_ref.notify,onSuccess=_ref.onSuccess,history=_ref.history,title=_ref.title,onCancel=_ref.onCancel,mutate=_ref.mutate,_ref$afterMutate=_ref.afterMutate,afterMutate=_ref$afterMutate===undefined?null:_ref$afterMutate,_ref$runQueryAfterMut=_ref.runQueryAfterMutate,runQueryAfterMutate=_ref$runQueryAfterMut===undefined?false:_ref$runQueryAfterMut;// *** START
//This is gonna work if there is the need to
//work with dropdowns
var generateDropdowns=function generateDropdowns(){return fields.filter(function(f){return f.type==='dropdown';}).map(function(f){return Object.assign({},f,{value:record?record[f.name].includes('HRS')?record[f.name].split(' ')[0]:record[f.name]:'24'});});};var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(generateDropdowns()),_useState2=_slicedToArray(_useState,2),dropdowns=_useState2[0],setDropdowns=_useState2[1];// *** END
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["b" /* Box */].Item,{pad:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */],{initialValues:buildInitialValues(record,fields),validationSchema:schema,redirect:backPath,onSubmit:function onSubmit(props){var id=record&&record.id;var data=fields.reduce(function(acc,field){return field.type==='immutable'?acc:Object.assign({},acc,_defineProperty({},field.name,field.type==='dropdown'?dropdowns.find(function(d){return d.name===field.name;}).value:props[field.name]));},{});return mutate(Object.assign({variables:Object.assign({id:id},variables,{data:Object.assign({},data,variables?variables.data:{})})},mutationArgs)).then(function(){notify('success','Saved');if(runQueryAfterMutate){afterMutate();}}).then(onSuccess).catch(function(e){return Promise.reject(Object(__WEBPACK_IMPORTED_MODULE_3_utils_serializeErrorMessages__["a" /* default */])(e));});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Errors,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Title,null,title),fields.map(function(field,key){if(field.type==='dropdown'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_fields__["a" /* default */],{twoFAEnabled:record?record.otp_required_for_login:true,field:field,key:key,options:field.options,setValue:setDropdowns,values:dropdowns,value:dropdowns.find(function(f){return f.name===field.name;}).value});}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_fields__["a" /* default */],{field:field,key:key});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,{buttons:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].SubmitButton,null,'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SpacedButton,{onClick:function onClick(e){e.preventDefault();if(onCancel){onCancel();}else if(backPath){history.replace(backPath);}}},'Cancel')))));};var FormForRecord=function FormForRecord(props){if(!props.mutate&&!props.mutation){throw new Error('You must send either a mutation or a mutate function');}var Component=props.mutate?FormForRecordForm:Object(__WEBPACK_IMPORTED_MODULE_5_components_withMutate__["a" /* default */])(props.mutation)(FormForRecordForm);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,props);};FormForRecord.defaultProps={mutationArgs:{},onSuccess:function onSuccess(){}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["Y" /* withNotifier */])(FormForRecord));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(34);
var fails = __webpack_require__(6);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(35);
var IObject = __webpack_require__(97);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(12);
var asc = __webpack_require__(177);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapProps */
/* unused harmony export withProps */
/* unused harmony export withPropsOnChange */
/* unused harmony export withHandlers */
/* unused harmony export defaultProps */
/* unused harmony export renameProp */
/* unused harmony export renameProps */
/* unused harmony export flattenProp */
/* unused harmony export withState */
/* unused harmony export withStateHandlers */
/* unused harmony export withReducer */
/* unused harmony export branch */
/* unused harmony export renderComponent */
/* unused harmony export renderNothing */
/* unused harmony export shouldUpdate */
/* unused harmony export pure */
/* unused harmony export onlyUpdateForKeys */
/* unused harmony export onlyUpdateForPropTypes */
/* unused harmony export withContext */
/* unused harmony export getContext */
/* unused harmony export lifecycle */
/* unused harmony export toClass */
/* unused harmony export setStatic */
/* unused harmony export setPropTypes */
/* unused harmony export setDisplayName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compose; });
/* unused harmony export getDisplayName */
/* unused harmony export wrapDisplayName */
/* unused harmony export isClassComponent */
/* unused harmony export createSink */
/* unused harmony export componentFromProp */
/* unused harmony export nest */
/* unused harmony export hoistStatics */
/* unused harmony export componentFromStream */
/* unused harmony export componentFromStreamWithConfig */
/* unused harmony export mapPropsStream */
/* unused harmony export mapPropsStreamWithConfig */
/* unused harmony export createEventHandler */
/* unused harmony export createEventHandlerWithConfig */
/* unused harmony export setObservableConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(189);
/* unused harmony reexport shallowEqual */






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var withQueryParams=function withQueryParams(Component){return function(_ref){var location=_ref.location,rest=_objectWithoutProperties(_ref,['location']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({query:new URLSearchParams(location.search),location:location},rest));};};/* harmony default export */ __webpack_exports__["a"] = (withQueryParams);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ValidationError = exports.addMethod = exports.isSchema = exports.reach = exports.lazy = exports.ref = exports.array = exports.object = exports.date = exports.boolean = exports.bool = exports.number = exports.string = exports.mixed = undefined;

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

var _boolean = __webpack_require__(868);

var _boolean2 = _interopRequireDefault(_boolean);

var _string = __webpack_require__(869);

var _string2 = _interopRequireDefault(_string);

var _number = __webpack_require__(870);

var _number2 = _interopRequireDefault(_number);

var _date = __webpack_require__(871);

var _date2 = _interopRequireDefault(_date);

var _object = __webpack_require__(873);

var _object2 = _interopRequireDefault(_object);

var _array = __webpack_require__(908);

var _array2 = _interopRequireDefault(_array);

var _Reference = __webpack_require__(111);

var _Reference2 = _interopRequireDefault(_Reference);

var _Lazy = __webpack_require__(910);

var _Lazy2 = _interopRequireDefault(_Lazy);

var _ValidationError = __webpack_require__(228);

var _ValidationError2 = _interopRequireDefault(_ValidationError);

var _reach = __webpack_require__(911);

var _reach2 = _interopRequireDefault(_reach);

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boolean = _boolean2.default;
var ref = function ref(key, options) {
  return new _Reference2.default(key, options);
};

var lazy = function lazy(fn) {
  return new _Lazy2.default(fn);
};

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema2.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');

  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');

  schemaType.prototype[name] = fn;
}

exports.mixed = _mixed2.default;
exports.string = _string2.default;
exports.number = _number2.default;
exports.bool = _boolean2.default;
exports.boolean = boolean;
exports.date = _date2.default;
exports.object = _object2.default;
exports.array = _array2.default;
exports.ref = ref;
exports.lazy = lazy;
exports.reach = _reach2.default;
exports.isSchema = _isSchema2.default;
exports.addMethod = addMethod;
exports.ValidationError = _ValidationError2.default;
exports.default = {
  mixed: _mixed2.default,
  string: _string2.default,
  number: _number2.default,
  bool: _boolean2.default,
  boolean: boolean,
  date: _date2.default,
  object: _object2.default,
  array: _array2.default,
  ref: ref,
  lazy: lazy,
  reach: _reach2.default,
  isSchema: _isSchema2.default,
  addMethod: addMethod,
  ValidationError: _ValidationError2.default
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'id',label:'ID',type:'immutable'},{name:'first_name',label:'First Name'},{name:'last_name',label:'Last Name'},{name:'email',label:'Email'},{name:'two_factor_hours',label:'Authentication Timeframe for 2FA',type:'dropdown',options:[{value:'6',text:'6 Hours'},{value:'12',text:'12 Hours'},{value:'24',text:'24 Hours (Default)'},{value:'48',text:'48 Hours'},{value:'72',text:'72 Hours'}]},{name:'is_admin',label:'Admin',type:'boolean'},{name:'otp_required_for_login',label:'2FA',type:'boolean'}]);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(13)) {
  var LIBRARY = __webpack_require__(56);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(6);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(130);
  var $buffer = __webpack_require__(185);
  var ctx = __webpack_require__(35);
  var anInstance = __webpack_require__(69);
  var propertyDesc = __webpack_require__(62);
  var hide = __webpack_require__(25);
  var redefineAll = __webpack_require__(71);
  var toInteger = __webpack_require__(37);
  var toLength = __webpack_require__(12);
  var toIndex = __webpack_require__(304);
  var toAbsoluteIndex = __webpack_require__(65);
  var toPrimitive = __webpack_require__(43);
  var has = __webpack_require__(29);
  var classof = __webpack_require__(82);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(15);
  var isArrayIter = __webpack_require__(174);
  var create = __webpack_require__(66);
  var getPrototypeOf = __webpack_require__(32);
  var gOPN = __webpack_require__(67).f;
  var getIterFn = __webpack_require__(176);
  var uid = __webpack_require__(63);
  var wks = __webpack_require__(11);
  var createArrayMethod = __webpack_require__(46);
  var createArrayIncludes = __webpack_require__(120);
  var speciesConstructor = __webpack_require__(100);
  var ArrayIterators = __webpack_require__(179);
  var Iterators = __webpack_require__(84);
  var $iterDetect = __webpack_require__(125);
  var setSpecies = __webpack_require__(68);
  var arrayFill = __webpack_require__(178);
  var arrayCopyWithin = __webpack_require__(293);
  var $DP = __webpack_require__(14);
  var $GOPD = __webpack_require__(31);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(299);
var $export = __webpack_require__(1);
var shared = __webpack_require__(96)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(302))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Global; });
/* unused harmony export createElement */
/* unused harmony export jsx */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keyframes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__ = __webpack_require__(338);
/* unused harmony reexport CacheProvider */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_utils__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_serialize__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_sheet__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_css__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__emotion_css__["a"]; });











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !__WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["d" /* h */].call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = __WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["a" /* E */];
  createElementArgArray[1] = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["c"])(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["e" /* w */])(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["b" /* T */].Consumer, null, function (theme) {
      var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])([styles(theme)]);
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])([styles]);
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new __WEBPACK_IMPORTED_MODULE_6__emotion_sheet__["a" /* StyleSheet */]({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var keyframes = function keyframes() {
  var insertable = __WEBPACK_IMPORTED_MODULE_7__emotion_css__["a" /* default */].apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["e" /* w */])(function (props, context) {
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_element_57a3a7a3_browser_esm_js__["b" /* T */].Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])(args, context.registered);

      {
        Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(63)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(29);
var setDesc = __webpack_require__(14).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(6)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(11)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(25)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findPlatform; });
var platforms=[{id:'booking',homeUrl:"https://book-qa.focusvision.com",displayOnHomepage:false},{id:'decipher',title:'Decipher',displayOnHomepage:true,loginUrl:'https://selfserve.decipherinc.com/login',signupUrl:'/sign-up?client_id=decipher&confirmation_uri=/login/confirmation&hostname='+"cyberiad.decipherinc.com"+'&redirect_uri='+encodeURIComponent("https://cyberiad.decipherinc.com/login?provider=ul"),homeUrl:'/',homeUrlFn:function homeUrlFn(hostname){return'https://'+hostname+'/login?provider=ul';},supportEmail:'de-support@focusvision.com'},{id:'revelation',title:'Digital Diaries',displayOnHomepage:true,loginUrl:'/login?client_id=revelation',loginUrlFn:function loginUrlFn(hostname){return hostname.match(/studyspace|fvdev\.net/)?'https://researcher.'+hostname:'https://researcher.'+hostname+'/revelation';},homeUrl:'https://researcher.studyspace.net/',homeUrlFn:function homeUrlFn(hostname){return hostname.match(/studyspace|fvdev\.net/)?'https://researcher.'+hostname:'https://researcher.'+hostname+'/revelation';},zendeskHost:'revelation.zendesk.com',supportEmail:'re-support@focusvision.com'},{id:'vi',title:'Video Insights',displayOnHomepage:true,loginUrl:"https://vi.dev.focusvision.com/login",signupUrl:function signupUrl(baseQueryString){return'/sign-up'+baseQueryString;},homeUrl:"https://vi.dev.focusvision.com",loginUrlFn:function loginUrlFn(hostname){return'https://'+hostname+'/login';},homeUrlFn:function homeUrlFn(hostname){return'https://'+hostname;},confirmationUri:'/login/confirmation',zendeskHost:'focusvision.zendesk.com',supportEmail:'vi-support@focusvision.com',ssoSignUp:true},{id:'kinesis',title:'Panel Management',displayOnHomepage:true,loginUrl:'/login?client_id=kinesis',homeUrl:'/',homeUrlFn:function homeUrlFn(hostname){return( false?'http':'https')+'://'+hostname+'/auth.pro';},supportEmail:'kp-support@focusvision.com'},{id:'VideoStreaming',title:'Forsta Vision & InterVu',displayOnHomepage:true,loginUrl:"https://uatonline.focusvision.com/account",signupUrl:'/sign-up?client_id=VideoStreaming&confirmation_uri=/login/confirmation&hostname='+"uatonline.focusvision.com",homeUrl:'/',confirmationUri:'/login/confirmation',supportEmail:'support@forsta.com',ssoSignUp:true},{id:'intervu',title:'Digital Interviews',displayOnHomepage:false,loginUrl:'https://iv.focusvision.com/',homeUrl:'/',supportEmail:'support@focusvision.com'},{id:'intervunow',homeUrl:"https://qa.intervu-fv.com",homeUrlFn:function homeUrlFn(){return "https://qa.intervu-fv.com";},confirmationUri:'/login/confirmation',displayOnHomepage:false},{id:'explore',title:'Explore Forsta Discussions',displayOnHomepage:true,loginUrl:'https://demo.forsta.com/discussions'}];var findPlatform=function findPlatform(platformId){return platforms.find(function(platform){return platform.id===platformId;});};/* harmony default export */ __webpack_exports__["a"] = (platforms);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(1005);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(1006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status__ = __webpack_require__(1007);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__status__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(278);
var enumBugKeys = __webpack_require__(162);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4);
var dPs = __webpack_require__(279);
var enumBugKeys = __webpack_require__(162);
var IE_PROTO = __webpack_require__(161)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(159)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(163).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(278);
var hiddenKeys = __webpack_require__(162).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(13);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var call = __webpack_require__(291);
var isArrayIter = __webpack_require__(174);
var anObject = __webpack_require__(4);
var toLength = __webpack_require__(12);
var getIterFn = __webpack_require__(176);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(26);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Location=function(_Component){_inherits(Location,_Component);function Location(){_classCallCheck(this,Location);return _possibleConstructorReturn(this,(Location.__proto__||Object.getPrototypeOf(Location)).apply(this,arguments));}_createClass(Location,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,to=_props.to,replace=_props.replace;if(replace){return window.location.replace(to);}window.location.href=to;}},{key:'render',value:function render(){return null;}}]);return Location;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Location);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = SchemaType;

var _has = __webpack_require__(87);

var _has2 = _interopRequireDefault(_has);

var _cloneDeepWith = __webpack_require__(804);

var _cloneDeepWith2 = _interopRequireDefault(_cloneDeepWith);

var _toArray2 = __webpack_require__(837);

var _toArray3 = _interopRequireDefault(_toArray2);

var _locale = __webpack_require__(90);

var _Condition = __webpack_require__(844);

var _Condition2 = _interopRequireDefault(_Condition);

var _runValidations = __webpack_require__(227);

var _runValidations2 = _interopRequireDefault(_runValidations);

var _merge = __webpack_require__(845);

var _merge2 = _interopRequireDefault(_merge);

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

var _isAbsent = __webpack_require__(110);

var _isAbsent2 = _interopRequireDefault(_isAbsent);

var _createValidation = __webpack_require__(846);

var _createValidation2 = _interopRequireDefault(_createValidation);

var _printValue = __webpack_require__(226);

var _printValue2 = _interopRequireDefault(_printValue);

var _Reference = __webpack_require__(111);

var _Reference2 = _interopRequireDefault(_Reference);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var notEmpty = function notEmpty(value) {
  return !(0, _isAbsent2.default)(value);
};

function extractTestParams(name, message, test) {
  var opts = name;

  if (typeof message === 'function') {
    test = message;
    message = _locale.mixed.default;
    name = null;
  }

  if (typeof name === 'function') {
    test = name;
    message = _locale.mixed.default;
    name = null;
  }

  if (typeof name === 'string' || name === null) opts = { name: name, test: test, message: message, exclusive: false };

  if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');

  return opts;
}

var RefSet = function () {
  function RefSet() {
    _classCallCheck(this, RefSet);

    this.list = new Set();
    this.refs = new Map();
  }

  RefSet.prototype.toArray = function toArray() {
    return (0, _toArray3.default)(this.list).concat((0, _toArray3.default)(this.refs.values()));
  };

  RefSet.prototype.add = function add(value) {
    _Reference2.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  RefSet.prototype.delete = function _delete(value) {
    _Reference2.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  RefSet.prototype.has = function has(value, resolve) {
    if (this.list.has(value)) return true;

    var item = void 0,
        values = this.refs.values();
    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }return false;
  };

  return RefSet;
}();

function SchemaType() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(this instanceof SchemaType)) return new SchemaType();

  this._deps = [];
  this._conditions = [];
  this._options = { abortEarly: true, recursive: true };
  this._exclusive = Object.create(null);

  this._whitelist = new RefSet();
  this._blacklist = new RefSet();

  this.tests = [];
  this.transforms = [];

  this.withMutation(function () {
    _this.typeError(_locale.mixed.notType);
  });

  if ((0, _has2.default)(options, 'default')) this._defaultDefault = options.default;

  this._type = options.type || 'mixed';
}

SchemaType.prototype = {
  __isYupSchema__: true,

  constructor: SchemaType,

  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this;

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    return (0, _cloneDeepWith2.default)(this, function (value) {
      if ((0, _isSchema2.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;

    var next = this.clone();
    next._meta = _extends(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    this._mutate = true;
    var result = fn(this);
    this._mutate = false;
    return result;
  },
  concat: function concat(schema) {
    if (!schema) return this;

    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError('You cannot `concat()` schema\'s of different types: ' + this._type + ' and ' + schema._type);
    var cloned = this.clone();
    var next = (0, _merge2.default)(this.clone(), schema.clone());

    // undefined isn't merged over, but is a valid value for default
    if ((0, _has2.default)(schema, '_default')) next._default = schema._default;

    next.tests = cloned.tests;
    next._exclusive = cloned._exclusive;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    schema.tests.forEach(function (fn) {
      next = next.test(fn.TEST);
    });

    next._type = schema._type;

    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(_ref) {
    var context = _ref.context,
        parent = _ref.parent;

    if (this._conditions.length) {
      return this._conditions.reduce(function (schema, match) {
        return match.resolve(schema, match.getValue(parent, context));
      }, this);
    }

    return this;
  },
  cast: function cast(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var resolvedSchema = this.resolve(options);
    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue2.default)(value);
      var formattedResult = (0, _printValue2.default)(result);
      throw new TypeError('The value of ' + (options.path || 'field') + ' could not be cast to a value ' + ('that satisfies the schema type: "' + resolvedSchema._type + '". \n\n') + ('attempted value: ' + formattedValue + ' \n') + (formattedResult !== formattedValue ? 'result of cast: ' + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has2.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);
    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, _extends({ assert: false }, options));
    }
    // value is cast, we can check if it meets type requirements
    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];

    if (this._typeError) initialTests.push(this._typeError(validationParams));

    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));

    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));

    return (0, _runValidations2.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations2.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var schema = this.resolve(options);
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var schema = this.resolve(options);
    var result = void 0,
        err = void 0;

    schema._validate(value, _extends({}, options, { sync: true })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;

      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, _extends({}, options));
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(_ref2) {
    var context = _ref2.context,
        parent = _ref2.parent;

    return this._resolve(context, parent).default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has2.default)(this, '_default') ? this._default : this._defaultDefault;

      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith2.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict() {
    var next = this.clone();
    next._options.strict = true;
    return next;
  },
  required: function required(msg) {
    return this.test('required', msg || _locale.mixed.required, notEmpty);
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.TEST_NAME !== 'required';
    });
    return next;
  },
  nullable: function nullable(value) {
    var next = this.clone();
    next._nullable = value === false ? false : true;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },


  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test(name, message, _test) {
    var opts = extractTestParams(name, message, _test),
        next = this.clone();

    var validate = (0, _createValidation2.default)(opts);

    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;

    next.tests = next.tests.filter(function (fn) {
      if (fn.TEST_NAME === opts.name) {
        if (isExclusive) return false;
        if (fn.TEST.test === validate.TEST.test) return false;
      }
      return true;
    });

    next.tests.push(validate);

    return next;
  },
  when: function when(keys, options) {
    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference2.default(key);
    });

    deps.forEach(function (dep) {
      if (!dep.isContext) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition2.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();

    next._typeError = (0, _createValidation2.default)({
      name: 'typeError',
      message: message,
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.mixed.oneOf;

    var next = this.clone();

    enums.forEach(function (val) {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });

    next._whitelistError = (0, _createValidation2.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;

        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });

    return next;
  },
  notOneOf: function notOneOf(enums) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.mixed.notOneOf;

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });

    next._blacklistError = (0, _createValidation2.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });

    return next;
  },
  strip: function strip() {
    var strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var next = this.clone();
    next._strip = strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has2.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();

    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return fn.TEST_NAME;
      }, {})
    };
  }
};

var aliases = {
  oneOf: ['equals', 'is'],
  notOneOf: ['not', 'nope']
};

Object.keys(aliases).forEach(function (method) {
  aliases[method].forEach(function (alias) {
    return SchemaType.prototype[alias] = SchemaType.prototype[method];
  });
});
module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76),
    getRawTag = __webpack_require__(776),
    objectToString = __webpack_require__(777);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(784),
    getValue = __webpack_require__(787);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj) {
  return obj && obj.__isYupSchema__;
};

module.exports = exports["default"];

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'id',label:'ID',type:'immutable'},{name:'name',label:'Name'},{name:'salesforce_id',label:'Salesforce ID'},{name:'two_factor_authentication',label:'2FA for all users',type:'boolean'}]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'id',label:'ID',type:'immutable'},{name:'hostname',label:'Hostname'},{name:'name',label:'Name'},{name:'product.name',label:'Product',type:'immutable'}]);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(14).f;
var has = __webpack_require__(29);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(36);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(44);
var fails = __webpack_require__(6);
var spaces = __webpack_require__(165);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Session=function Session(_ref){var render=_ref.render,session=_objectWithoutProperties(_ref,['render']);return render(session);};var mapStateToProps=function mapStateToProps(state){return{authenticator:Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["getAuthenticator"])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["getSessionData"])(state),hasFailedAuth:Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["getHasFailedAuth"])(state),lastError:Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["getLastError"])(state),isAuthenticated:Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["getIsAuthenticated"])(state),isRestored:Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["getIsRestored"])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(Session));

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(775),
    hasPath = __webpack_require__(348);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(356),
    baseKeys = __webpack_require__(814),
    isArrayLike = __webpack_require__(221);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = undefined;

var _printValue = __webpack_require__(226);

var _printValue2 = _interopRequireDefault(_printValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixed = exports.mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;

    var isCast = originalValue != null && originalValue !== value;
    var msg = path + ' must be a `' + type + '` type, ' + ('but the final value was: `' + (0, _printValue2.default)(value, true) + '`') + (isCast ? ' (cast from the value `' + (0, _printValue2.default)(originalValue, true) + '`).' : '.');

    if (value === null) {
      msg += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`';
    }

    return msg;
  }
};

var string = exports.string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};

var number = exports.number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  less: '${path} must be less than ${less}',
  more: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};

var date = exports.date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};

var boolean = exports.boolean = {};

var object = exports.object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};

var array = exports.array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};

exports.default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = inherits;
function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  _extends(ctor.prototype, spec);
}
module.exports = exports["default"];

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = print;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visitor__ = __webpack_require__(959);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__visitor__["a" /* visit */])(ast, { leave: printDocASTReducer });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },

  // Document

  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },

  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet;
    // Anonymous queries with no directives or variable definitions can use
    // the query short form.
    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },


  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue;
    return variable + ': ' + type + wrap(' = ', defaultValue);
  },

  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },

  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },

  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },

  // Fragments

  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },

  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },

  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      'fragment ' + name + wrap('(', join(variableDefinitions, ', '), ')') + ' ' + ('on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },

  // Value

  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },

  // Directive

  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },

  // Type

  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },

  // Type System Definitions

  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },

  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },

  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),

  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),

  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
  }),

  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),

  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),

  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),

  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),

  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),

  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),

  ScalarTypeExtension: function ScalarTypeExtension(_ref31) {
    var name = _ref31.name,
        directives = _ref31.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },

  ObjectTypeExtension: function ObjectTypeExtension(_ref32) {
    var name = _ref32.name,
        interfaces = _ref32.interfaces,
        directives = _ref32.directives,
        fields = _ref32.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },

  InterfaceTypeExtension: function InterfaceTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives,
        fields = _ref33.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },

  UnionTypeExtension: function UnionTypeExtension(_ref34) {
    var name = _ref34.name,
        directives = _ref34.directives,
        types = _ref34.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },

  EnumTypeExtension: function EnumTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        values = _ref35.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },

  InputObjectTypeExtension: function InputObjectTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        fields = _ref36.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  },

  DirectiveDefinition: addDescription(function (_ref37) {
    var name = _ref37.name,
        args = _ref37.arguments,
        locations = _ref37.locations;
    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
  })
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}

/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */
function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}

/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */
function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}

/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */
function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */
function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? '"""' + escaped.replace(/"$/, '"\n') + '"""' : '"""\n' + (isDescription ? escaped : indent(escaped)) + '\n"""';
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(1014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["a"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getMainCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */


//# sourceMappingURL=index.js.map

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isError;
/* harmony export (immutable) */ __webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["k"] = isString;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isInstanceOf;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(34);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(56) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(36);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(19);
var SPECIES = __webpack_require__(11)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(75),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(802);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(105);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(354),
    baseAssignValue = __webpack_require__(147);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(823),
    Map = __webpack_require__(212),
    Promise = __webpack_require__(824),
    Set = __webpack_require__(825),
    WeakMap = __webpack_require__(364),
    baseGetTag = __webpack_require__(75),
    toSource = __webpack_require__(350);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (value) {
  return value == null;
};

module.exports = exports["default"];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propertyExpr = __webpack_require__(151);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var validateName = function validateName(d) {
  if (typeof d !== 'string') throw new TypeError("ref's must be strings, got: " + d);
};

var Reference = function () {
  Reference.isRef = function isRef(value) {
    return !!(value && (value.__isYupRef || value instanceof Reference));
  };

  Reference.prototype.toString = function toString() {
    return 'Ref(' + this.key + ')';
  };

  function Reference(key, mapFn) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Reference);

    validateName(key);
    var prefix = options.contextPrefix || '$';

    if (typeof key === 'function') {
      key = '.';
    }

    this.key = key.trim();
    this.prefix = prefix;
    this.isContext = this.key.indexOf(prefix) === 0;
    this.isSelf = this.key === '.';

    this.path = this.isContext ? this.key.slice(this.prefix.length) : this.key;
    this._get = (0, _propertyExpr.getter)(this.path, true);
    this.map = mapFn || function (value) {
      return value;
    };
  }

  Reference.prototype.resolve = function resolve() {
    return this;
  };

  Reference.prototype.cast = function cast(value, _ref) {
    var parent = _ref.parent,
        context = _ref.context;

    return this.getValue(parent, context);
  };

  Reference.prototype.getValue = function getValue(parent, context) {
    var isContext = this.isContext;
    var value = this._get(isContext ? context : parent || context || {});
    return this.map(value);
  };

  return Reference;
}();

exports.default = Reference;


Reference.prototype.__isYupRef = true;
module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetworkStatus; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isNetworkRequestInFlight;
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global, module) {/* unused harmony export dynamicRequire */
/* harmony export (immutable) */ __webpack_exports__["i"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["f"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["m"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["k"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["c"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["b"] = addExceptionTypeValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionMechanism;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLocationHref;
/* harmony export (immutable) */ __webpack_exports__["h"] = htmlTreeAsString;
/* unused harmony export crossPlatformPerformance */
/* harmony export (immutable) */ __webpack_exports__["l"] = timestampWithMs;
/* unused harmony export parseSemver */
/* harmony export (immutable) */ __webpack_exports__["j"] = parseRetryAfterHeader;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFunctionName;
/* unused harmony export addContextToFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string__ = __webpack_require__(257);


/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
var INITIAL_TIME = Date.now();
var prevNow = 0;
var performanceFallback = {
    now: function () {
        var now = Date.now() - INITIAL_TIME;
        if (now < prevNow) {
            now = prevNow;
        }
        prevNow = now;
        return now;
    },
    timeOrigin: INITIAL_TIME,
};
var crossPlatformPerformance = (function () {
    if (isNodeEnv()) {
        try {
            var perfHooks = dynamicRequire(module, 'perf_hooks');
            return perfHooks.performance;
        }
        catch (_) {
            return performanceFallback;
        }
    }
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) {
        return performanceFallback;
    }
    // Polyfill for performance.timeOrigin.
    //
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    if (performance.timeOrigin === undefined) {
        // As of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always a
        // valid fallback. In the absence of a initial time provided by the browser, fallback to INITIAL_TIME.
        // @ts-ignore ignored because timeOrigin is a readonly property but we want to override
        // eslint-disable-next-line deprecation/deprecation
        performance.timeOrigin = (performance.timing && performance.timing.navigationStart) || INITIAL_TIME;
    }
    return performance;
})();
/**
 * Returns a timestamp in seconds with milliseconds precision since the UNIX epoch calculated with the monotonic clock.
 */
function timestampWithMs() {
    return (crossPlatformPerformance.timeOrigin + crossPlatformPerformance.now()) / 1000;
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
    frame.context_line = Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(104), __webpack_require__(22), __webpack_require__(190)(module)))

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["c"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["a"] = injectReportDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);



var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, processedEvent.extra), { arguments: args });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = document.createElement('script');
    script.async = true;
    script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    (document.head || document.body).appendChild(script);
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var InfoGroup=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ed07x0b0',label:'InfoGroup'})(Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["U" /* padding */])('xxs'),';');/* harmony default export */ __webpack_exports__["a"] = (InfoGroup);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var Subheader=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('span',{target:'exnlby90',label:'Subheader'})(Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["X" /* typography */])('subheading3'),';margin-right:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(3),';');/* harmony default export */ __webpack_exports__["a"] = (Subheader);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(name){return(name.charAt(0).toUpperCase()+name.slice(1)).replace(/_/g,' ');});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value){return typeof value==='boolean'?value.toString():value;});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var Header=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('header',{target:'e1k935hl0',label:'Header'})('display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(5),';');/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(30);
var toLength = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(65);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(36);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var defined = __webpack_require__(44);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(36);
var MATCH = __webpack_require__(11)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(82);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(295);
var redefine = __webpack_require__(26);
var hide = __webpack_require__(25);
var fails = __webpack_require__(6);
var defined = __webpack_require__(44);
var wks = __webpack_require__(11);
var regexpExec = __webpack_require__(180);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(26);
var redefineAll = __webpack_require__(71);
var meta = __webpack_require__(57);
var forOf = __webpack_require__(70);
var anInstance = __webpack_require__(69);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(6);
var $iterDetect = __webpack_require__(125);
var setToStringTag = __webpack_require__(81);
var inheritIfRequired = __webpack_require__(166);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(25);
var uid = __webpack_require__(63);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(56) || !__webpack_require__(6)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var ctx = __webpack_require__(35);
var forOf = __webpack_require__(70);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '@@redux-simple-auth';

var AUTHENTICATE = exports.AUTHENTICATE = prefix + '/AUTHENTICATE';
var AUTHENTICATE_FAILED = exports.AUTHENTICATE_FAILED = prefix + '/AUTHENTICATE_FAILED';
var AUTHENTICATE_SUCCEEDED = exports.AUTHENTICATE_SUCCEEDED = prefix + '/AUTHENTICATE_SUCCEEDED';
var FETCH = exports.FETCH = prefix + '/FETCH';
var INITIALIZE = exports.INITIALIZE = prefix + '/INITIALIZE';
var INVALIDATE_SESSION = exports.INVALIDATE_SESSION = prefix + '/INVALIDATE_SESSION';
var INVALIDATE_SESSION_FAILED = exports.INVALIDATE_SESSION_FAILED = prefix + '/INVALIDATE_SESSION_FAILED';
var UPDATE_SESSION = exports.UPDATE_SESSION = prefix + '/UPDATE_SESSION';
var CLEAR_ERROR = exports.CLEAR_ERROR = prefix + '/CLEAR_ERROR';
var RESTORE = exports.RESTORE = prefix + '/RESTORE';
var RESTORE_FAILED = exports.RESTORE_FAILED = prefix + '/RESTORE_FAILED';
var SYNC_TAB = exports.SYNC_TAB = prefix + '/SYNC_TAB';

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(339);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CurrentUser__ = __webpack_require__(204);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CurrentUser__["a" /* default */],{render:function render(_ref){var viewer=_ref.viewer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({currentUser:viewer},props));}});};});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mapProviderToPathSegment=function mapProviderToPathSegment(provider){return provider==='google'&&"production"==='development'?'gitlab':provider;};/* harmony default export */ __webpack_exports__["a"] = (function(provider){var queryParams=new URLSearchParams();var currentQueryString=window.location.search.substring(1);var providerSegment=mapProviderToPathSegment(provider);queryParams.set('client_id',"unified-login");queryParams.set('redirect_uri',"https://home-qa.focusvision.com/login/set-token");if(currentQueryString){queryParams.set('passthrough_params',JSON.stringify(currentQueryString));}return "https://api-qa.focusvision.com"+'/sso/'+providerSegment+'/init?'+queryParams;});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23),
    isKey = __webpack_require__(209),
    stringToPath = __webpack_require__(778),
    toString = __webpack_require__(106);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(75),
    isObject = __webpack_require__(55);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(792),
    listCacheDelete = __webpack_require__(793),
    listCacheGet = __webpack_require__(794),
    listCacheHas = __webpack_require__(795),
    listCacheSet = __webpack_require__(796);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(211);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(798);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(355);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40),
    stubFalse = __webpack_require__(812);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(357);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @license
 * expr 1.0.0
 * Copyright 2014 Jason Quense
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 * Copyright :copyright: 2014 Telerik
 * Available under MIT license <https://github.com/theporchrat/expr/blob/master/LICENSE.txt>
 */

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g

var setCache = {},
  getCache = {}

module.exports = {
  expr: expr,

  setter: function(path) {
    return (
      setCache[path] ||
      (setCache[path] = new Function(
        'data, value',
        expr(path, 'data') + ' = value'
      ))
    )
  },

  getter: function(path, safe) {
    var k = path + '_' + safe
    return (
      getCache[k] ||
      (getCache[k] = new Function('data', 'return ' + expr(path, safe, 'data')))
    )
  },

  split: function(path) {
    return path.match(SPLIT_REGEX)
  },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach(path.match(SPLIT_REGEX), cb, thisArg)
  }
}

function expr(expression, safe, param) {
  expression = expression || ''

  if (typeof safe === 'string') {
    param = safe
    safe = false
  }

  param = param || 'data'

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = path.match(SPLIT_REGEX),
    isLast

  forEach(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1

    part = isBracket || isArray ? '[' + part + ']' : '.' + part

    result += part + (!isLast ? ' || {})' : ')')
  })

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSSOForEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUriForEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return verifyValid2FA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_store__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_simple_auth__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var request=function request(path){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_1_config_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_simple_auth__["fetch"])("https://api-qa.focusvision.com"+path,Object.assign({credentials:'include'},options))).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status===204)){_context.next=4;break;}return _context.abrupt('return','');case 4:if(response.ok){_context.next=10;break;}_context.t0=Promise;_context.next=8;return response.json();case 8:_context.t1=_context.sent;return _context.abrupt('return',_context.t0.reject.call(_context.t0,_context.t1));case 10:return _context.abrupt('return',response.json());case 11:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2){return _ref.apply(this,arguments);};}());};var post=function post(path){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return request(path,Object.assign({method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},credentials:'include',body:options.payload?JSON.stringify(options.payload):undefined},options));};var get=function get(path){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return request(path,Object.assign({method:'GET',headers:{Accept:'application/json'}},options));};var getSSOForEmail=function getSSOForEmail(email){return get('/sso_checks?email='+encodeURIComponent(email));};var getUriForEmail=function getUriForEmail(email){return get('/two_factor/uri?email='+encodeURIComponent(email));};var verifyValid2FA=function verifyValid2FA(email,password){return post('/two_factor/verify_valid_user',{payload:{email:email,password:password}});};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(968).Observable;


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchType; });
var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(981);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(398);
/* unused harmony reexport createOperation */
/* unused harmony reexport makePromise */
/* unused harmony reexport toPromise */
/* unused harmony reexport fromPromise */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Integrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports__ = __webpack_require__(1004);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(414);
/* unused harmony reexport Transports */






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, windowIntegrations), __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d" /* Integrations */]), __WEBPACK_IMPORTED_MODULE_4__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_yup__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_yup___default.a.object().shape({email:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required("Email can't be blank")}));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1074)();
}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(34);
var LIBRARY = __webpack_require__(56);
var wksExt = __webpack_require__(277);
var defineProperty = __webpack_require__(14).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(96)('keys');
var uid = __webpack_require__(63);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(35)(Function.call, __webpack_require__(31).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(164).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(37);
var defined = __webpack_require__(44);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(26);
var hide = __webpack_require__(25);
var Iterators = __webpack_require__(84);
var $iterCreate = __webpack_require__(171);
var setToStringTag = __webpack_require__(81);
var getPrototypeOf = __webpack_require__(32);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(66);
var descriptor = __webpack_require__(62);
var setToStringTag = __webpack_require__(81);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(25)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(124);
var defined = __webpack_require__(44);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(11)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(84);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(14);
var createDesc = __webpack_require__(62);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(82);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(84);
module.exports = __webpack_require__(34).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(544);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(12);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(58);
var step = __webpack_require__(294);
var Iterators = __webpack_require__(84);
var toIObject = __webpack_require__(30);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(170)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(99);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(123)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var invoke = __webpack_require__(284);
var html = __webpack_require__(163);
var cel = __webpack_require__(159);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(36)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(182).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(36)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(19);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(13);
var LIBRARY = __webpack_require__(56);
var $typed = __webpack_require__(130);
var hide = __webpack_require__(25);
var redefineAll = __webpack_require__(71);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(69);
var toInteger = __webpack_require__(37);
var toLength = __webpack_require__(12);
var toIndex = __webpack_require__(304);
var gOPN = __webpack_require__(67).f;
var dP = __webpack_require__(14).f;
var arrayFill = __webpack_require__(178);
var setToStringTag = __webpack_require__(81);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(656);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(677);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(678);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(190)(module)))

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncTab = exports.initialize = exports.restoreFailed = exports.restore = exports.updateSession = exports.invalidateSessionFailed = exports.invalidateSession = exports.clearError = exports.fetch = exports.authenticateFailed = exports.authenticateSucceeded = exports.authenticate = undefined;

var _actionTypes = __webpack_require__(134);

var authenticate = exports.authenticate = function authenticate(authenticator, payload) {
  return {
    type: _actionTypes.AUTHENTICATE,
    meta: { authenticator: authenticator },
    payload: payload
  };
};

var authenticateSucceeded = exports.authenticateSucceeded = function authenticateSucceeded(authenticator, payload) {
  return {
    type: _actionTypes.AUTHENTICATE_SUCCEEDED,
    meta: { authenticator: authenticator },
    payload: payload
  };
};

var authenticateFailed = exports.authenticateFailed = function authenticateFailed(payload) {
  return {
    type: _actionTypes.AUTHENTICATE_FAILED,
    payload: payload
  };
};

var fetch = exports.fetch = function fetch(url, options) {
  return {
    type: _actionTypes.FETCH,
    payload: { url: url, options: options }
  };
};

var clearError = exports.clearError = function clearError() {
  return {
    type: _actionTypes.CLEAR_ERROR
  };
};

var invalidateSession = exports.invalidateSession = function invalidateSession() {
  return {
    type: _actionTypes.INVALIDATE_SESSION
  };
};

var invalidateSessionFailed = exports.invalidateSessionFailed = function invalidateSessionFailed() {
  return {
    type: _actionTypes.INVALIDATE_SESSION_FAILED
  };
};

var updateSession = exports.updateSession = function updateSession(payload) {
  return {
    type: _actionTypes.UPDATE_SESSION,
    payload: payload
  };
};

var restore = exports.restore = function restore(payload) {
  return {
    type: _actionTypes.RESTORE,
    payload: payload
  };
};

var restoreFailed = exports.restoreFailed = function restoreFailed() {
  return {
    type: _actionTypes.RESTORE_FAILED
  };
};

var initialize = exports.initialize = function initialize(payload) {
  return {
    type: _actionTypes.INITIALIZE,
    payload: payload
  };
};

var syncTab = exports.syncTab = function syncTab(payload) {
  return {
    type: _actionTypes.SYNC_TAB,
    payload: payload
  };
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasFailedAuth = exports.getLastError = exports.getIsRestored = exports.getAuthenticator = exports.getIsAuthenticated = exports.getData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(134);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  authenticator: null,
  hasFailedAuth: false,
  isAuthenticated: false,
  isRestored: false,
  lastError: null,
  data: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.INITIALIZE:
      var _action$payload$authe = action.payload.authenticated;
      _action$payload$authe = _action$payload$authe === undefined ? {} : _action$payload$authe;

      var authenticator = _action$payload$authe.authenticator,
          data = _objectWithoutProperties(_action$payload$authe, ['authenticator']);

      return _extends({}, initialState, {
        authenticator: authenticator,
        data: data
      });
    case _actionTypes.AUTHENTICATE_SUCCEEDED:
      return _extends({}, state, {
        hasFailedAuth: false,
        authenticator: action.meta.authenticator,
        isAuthenticated: true,
        data: action.payload,
        lastError: null
      });
    case _actionTypes.AUTHENTICATE_FAILED:
      return _extends({}, state, {
        authenticator: null,
        hasFailedAuth: true,
        isAuthenticated: false,
        isRestored: true,
        lastError: action.payload,
        data: {}
      });
    case _actionTypes.CLEAR_ERROR:
      return _extends({}, state, {
        hasFailedAuth: false,
        lastError: null
      });
    case _actionTypes.INVALIDATE_SESSION:
    case _actionTypes.RESTORE_FAILED:
      return _extends({}, state, {
        authenticator: null,
        isAuthenticated: false,
        isRestored: true,
        lastError: null,
        data: {}
      });
    case _actionTypes.RESTORE:
      {
        var _action$payload = action.payload,
            _authenticator = _action$payload.authenticator,
            _data = _objectWithoutProperties(_action$payload, ['authenticator']);

        return _extends({}, state, {
          authenticator: _authenticator,
          data: _data,
          isAuthenticated: true,
          isRestored: true,
          lastError: null
        });
      }
    case _actionTypes.UPDATE_SESSION:
      return _extends({}, state, {
        data: action.payload
      });
    case _actionTypes.SYNC_TAB:
      {
        var _action$payload2 = action.payload,
            isAuthenticated = _action$payload2.isAuthenticated,
            _action$payload2$auth = _action$payload2.authenticated,
            _authenticator2 = _action$payload2$auth.authenticator,
            _data2 = _objectWithoutProperties(_action$payload2$auth, ['authenticator']);

        return _extends({}, state, {
          isAuthenticated: isAuthenticated,
          authenticator: _authenticator2,
          data: _data2
        });
      }
    default:
      return state;
  }
};

exports.default = reducer;
var getData = exports.getData = function getData(state) {
  return state.data;
};
var getIsAuthenticated = exports.getIsAuthenticated = function getIsAuthenticated(state) {
  return state.isAuthenticated;
};
var getAuthenticator = exports.getAuthenticator = function getAuthenticator(state) {
  return state.authenticator;
};
var getIsRestored = exports.getIsRestored = function getIsRestored(state) {
  return state.isRestored;
};
var getLastError = exports.getLastError = function getLastError(state) {
  return state.lastError;
};
var getHasFailedAuth = exports.getHasFailedAuth = function getHasFailedAuth(state) {
  return state.hasFailedAuth;
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      _ref$restore = _ref.restore,
      restore = _ref$restore === undefined ? function () {
    return Promise.reject();
  } : _ref$restore,
      _ref$authenticate = _ref.authenticate,
      authenticate = _ref$authenticate === undefined ? function () {
    return Promise.reject();
  } : _ref$authenticate,
      _ref$invalidate = _ref.invalidate,
      invalidate = _ref$invalidate === undefined ? function (data) {
    return Promise.resolve(data);
  } : _ref$invalidate;

  (0, _invariant2.default)(name != null, 'Authenticators must define a `name` property');

  (0, _invariant2.default)(typeof name === 'string', 'Expected the `name` property of the authenticator to be a string');

  return {
    name: name,
    restore: restore,
    authenticate: authenticate,
    invalidate: invalidate
  };
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(328);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(329);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(197);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DesktopMenu__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MobileMenu__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_withSession__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_withCurrentUser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(47);
var Menu=function Menu(_ref){var session=_ref.session,currentUser=_ref.currentUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_stylist__["A" /* MediaQuery */],{below:'md'},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MobileMenu__["a" /* default */],{isAuthenticated:session.isAuthenticated}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DesktopMenu__["a" /* default */],{isAuthenticated:session.isAuthenticated,currentUser:currentUser});});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_4_components_withSession__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5_components_withCurrentUser__["a" /* default */])(Menu));

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Component = (_temp2 = _class = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _temp, _this, _ret;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Component.prototype.getArgs = function getArgs() {
    var state = this.state,
        props = this.props,
        setState = this._setState,
        forceUpdate = this._forceUpdate;

    return {
      state: state,
      props: props,
      setState: setState,
      forceUpdate: forceUpdate
    };
  };

  Component.prototype.componentDidMount = function componentDidMount() {
    if (this.props.didMount) this.props.didMount(this.getArgs());
  };

  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.shouldUpdate) return this.props.shouldUpdate({
      props: this.props,
      state: this.state,
      nextProps: nextProps,
      nextState: nextState
    });else return true;
  };

  Component.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.willUnmount) this.props.willUnmount({
      state: this.state,
      props: this.props
    });
  };

  Component.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.didUpdate) this.props.didUpdate(_extends({}, this.getArgs(), {
      prevProps: prevProps,
      prevState: prevState
    }));
  };

  Component.prototype.render = function render() {
    if (this.props.children) {
      return this.props.children(this.getArgs());
    } else if (this.props.render) {
      return this.props.render(this.getArgs());
    } else {
      return null;
    }
  };

  // Fiber collateral damage starts here...

  Component.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(!this.props.willMount, "<Component> Please use `didMount` instead of `willMount`.");
  };

  Component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(!this.props.willReceiveProps, "<Component> Please use `didUpdate` instead of `willReceiveProps`.");
  };

  Component.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(!this.props.willUpdate, "<Component> Please use `didUpdate` instead of `willReceiveProps`.");
  };

  return Component;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = this.props.initialState;

  this._setState = function () {
    return _this2.setState.apply(_this2, arguments);
  };

  this._forceUpdate = function () {
    return _this2.forceUpdate.apply(_this2, arguments);
  };
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Session__ = __webpack_require__(85);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Session__["a" /* default */],{render:function render(sessionProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({session:sessionProps},props));}});};});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
var CurrentUser=function CurrentUser(_ref){var render=_ref.render;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */],{channel:'currentUser'},render);};/* harmony default export */ __webpack_exports__["a"] = (CurrentUser);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platformLinkStyles__ = __webpack_require__(206);
var PlatformLink=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('a',{target:'eflieci0',label:'PlatformLink'})(__WEBPACK_IMPORTED_MODULE_1__platformLinkStyles__["b" /* link */],';',__WEBPACK_IMPORTED_MODULE_1__platformLinkStyles__["a" /* container */],';');/* harmony default export */ __webpack_exports__["a"] = (PlatformLink);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var container=function container(_ref){var theme=_ref.theme;return(/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_core__["d" /* css */])('margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(4,{theme:theme}),';max-width:32%;flex-basis:32%;',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["S" /* mediaDn */])('lg'),'{flex-basis:48%;max-width:48%;}',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["S" /* mediaDn */])('sm'),'{flex-basis:100%;max-width:none;}@supports (display:grid){&{margin-bottom:0;max-width:none;}}'));};var link=function link(_ref2){var theme=_ref2.theme;return(/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_core__["d" /* css */])('color:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])('ink',{theme:theme}),';background:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])('white',{theme:theme}),';display:flex;justify-content:space-between;align-items:center;height:6rem;',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["X" /* typography */])('body4Medium',{theme:theme}),';',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["U" /* padding */])('xs',{theme:theme}),';'));};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_platforms__ = __webpack_require__(60);
var defaultNormalizer=function defaultNormalizer(hostname){return /^https?:\/\//.test(hostname)?hostname:'https://'+hostname;};/* harmony default export */ __webpack_exports__["a"] = (function(hostname,clientId){var platform=__WEBPACK_IMPORTED_MODULE_0_config_platforms__["a" /* default */].find(function(platform){return platform.id===clientId;});var normalizer=platform&&platform.homeUrlFn||defaultNormalizer;return normalizer(hostname);});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CookieAcceptance_Context__ = __webpack_require__(347);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CookieAcceptance_Context__["a" /* Consumer */],null,function(consumerProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,consumerProps));});};});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23),
    isSymbol = __webpack_require__(105);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(781),
    mapCacheDelete = __webpack_require__(797),
    mapCacheGet = __webpack_require__(799),
    mapCacheHas = __webpack_require__(800),
    mapCacheSet = __webpack_require__(801);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(803),
    isObjectLike = __webpack_require__(50);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(144),
    stackClear = __webpack_require__(805),
    stackDelete = __webpack_require__(806),
    stackGet = __webpack_require__(807),
    stackHas = __webpack_require__(808),
    stackSet = __webpack_require__(809);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(813),
    baseUnary = __webpack_require__(218),
    nodeUtil = __webpack_require__(219);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(349);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 220 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(143),
    isLength = __webpack_require__(215);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(821),
    stubArray = __webpack_require__(359);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(365);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = printValue;

var _isFunction = __webpack_require__(143);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isSymbol = __webpack_require__(105);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toString = Object.prototype.toString;
var toISOString = Date.prototype.toISOString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};

var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printFunction(val) {
  return '[Function ' + (val.name || 'anonymous') + ']';
}

function printSymbol(val) {
  return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
}

function printError(val) {
  return '[' + errorToString.call(val) + ']';
}

function printSimpleValue(val) {
  var quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (val === true || val === false) return '' + val;
  if (val === undefined) return 'undefined';
  if (val === null) return 'null';

  var typeOf = typeof val === 'undefined' ? 'undefined' : _typeof(val);

  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? '"' + val + '"' : val;
  if ((0, _isFunction2.default)(val)) return printFunction(val);
  if ((0, _isSymbol2.default)(val)) return printSymbol(val);

  var tag = toString.call(val);
  if (tag === '[object Date]') return isNaN(val.getTime()) ? String(val) : toISOString.call(val);
  if (tag === '[object Error]' || val instanceof Error) return printError(val);
  if (tag === '[object RegExp]') return regExpToString.call(val);

  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;

  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _synchronousPromise = __webpack_require__(370);

var _ValidationError = __webpack_require__(228);

var _ValidationError2 = _interopRequireDefault(_ValidationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var promise = function promise(sync) {
  return sync ? _synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises);

  //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  });
  //console.log('scopeToValue c', b)
  var c = b.then(function () {
    return value;
  });
  //console.log('scopeToValue d', c)
  return c;
}

/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */
function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var settle = function settle(promise) {
    return promise.then(function (value) {
      return { fulfilled: true, value: value };
    }, function (value) {
      return { fulfilled: false, value: value };
    });
  };

  return promise(sync).all(promises.map(settle));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;

  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError2.default.isError(error)) {
        throw error;
      }
      return arr.concat(error);
    }, []);

    if (sort) nestedErrors.sort(sort);

    //show parent errors after the nested ones: name.first, name
    errors = nestedErrors.concat(errors);

    if (errors.length) throw new _ValidationError2.default(errors, value, path);

    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = _objectWithoutProperties(_ref3, ['endEarly']);

  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);

  return collectErrors(options);
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ValidationError;

var _printValue = __webpack_require__(226);

var _printValue2 = _interopRequireDefault(_printValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue2.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];

  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);

    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });

  this.message = this.errors.length > 1 ? this.errors.length + ' errors occurred' : this.errors[0];

  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(_ref) {
    var path = _ref.path,
        label = _ref.label,
        params = _objectWithoutProperties(_ref, ['path', 'label']);

    params.path = label || path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(848),
    keys = __webpack_require__(88);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(850),
    baseMatchesProperty = __webpack_require__(861),
    identity = __webpack_require__(375),
    isArray = __webpack_require__(23),
    property = __webpack_require__(865);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(141),
    toKey = __webpack_require__(107);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(914);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(915);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var FormLinks=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ew9jvqd0',label:'FormLinks'})('display:flex;justify-content:center;>:not(:last-child){margin-right:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(3),';}@supports (display:grid){display:grid;grid-gap:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(3),';grid-auto-flow:column;justify-content:center;>:not(:last-child){margin-right:0;}}');/* harmony default export */ __webpack_exports__["a"] = (FormLinks);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSSOForEmailInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUriForEmailInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_api__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
var emailSchema=__WEBPACK_IMPORTED_MODULE_1_yup___default.a.string().email();var getSSOForEmailInput=__WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function(value,callback){return emailSchema.isValid(value).then(function(isEmail){return isEmail&&Object(__WEBPACK_IMPORTED_MODULE_0_utils_api__["b" /* getSSOForEmail */])(value).then(callback);});},300);var getUriForEmailInput=__WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function(value,callback,rejectCallback){return emailSchema.isValid(value).then(function(isEmail){return isEmail&&Object(__WEBPACK_IMPORTED_MODULE_0_utils_api__["c" /* getUriForEmail */])(value).then(callback).catch(rejectCallback);});},300);

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(934);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authenticators_oauth2ImplicitGrant__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authenticators_oauth2PasswordGrant__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension_logOnlyInProduction__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension_logOnlyInProduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension_logOnlyInProduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__(941);
var authMiddleware=Object(__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__["createAuthMiddleware"])({authenticators:[__WEBPACK_IMPORTED_MODULE_1__authenticators_oauth2ImplicitGrant__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__authenticators_oauth2PasswordGrant__["a" /* default */]],authorize:__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__["oauth2BearerAuthorizer"],syncTabs:true,refresh:function refresh(response){var token=response.headers.get('x-access-token');return token?{token:token}:null;}});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension_logOnlyInProduction__["composeWithDevTools"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(authMiddleware),Object(__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__["getInitialAuthState"])({storage:__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__["storage"]}))));

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55),
    now = __webpack_require__(942),
    toNumber = __webpack_require__(943);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(951)();
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "printAST", function() { return __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_types__ = __webpack_require__(154);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FetchType", function() { return __WEBPACK_IMPORTED_MODULE_3__core_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_ApolloError__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloError", function() { return __WEBPACK_IMPORTED_MODULE_4__errors_ApolloError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApolloClient__ = __webpack_require__(977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return __WEBPACK_IMPORTED_MODULE_5__ApolloClient__["a"]; });







/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_5__ApolloClient__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObservableQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__networkStatus__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Observable__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_ApolloError__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(154);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue &&
        ((storeValue.graphQLErrors &&
            storeValue.graphQLErrors.length > 0 &&
            policy === 'none') ||
            storeValue.networkError);
};
var ObservableQuery = (function (_super) {
    __extends(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var scheduler = _a.scheduler, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.isCurrentlyPolling = false;
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = scheduler.queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        _this.scheduler = scheduler;
        _this.queryManager = scheduler.queryManager;
        _this.observers = [];
        _this.subscriptionHandles = [];
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            var subscription;
            var observer = {
                next: function (result) {
                    resolve(result);
                    if (!that.observers.some(function (obs) { return obs !== observer; })) {
                        that.queryManager.removeQuery(that.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: function (error) {
                    reject(error);
                },
            };
            subscription = that.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        if (this.isTornDown) {
            return {
                data: this.lastError ? {} : this.lastResult ? this.lastResult.data : {},
                error: this.lastError,
                loading: false,
                networkStatus: __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].error,
            };
        }
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        if (hasError(queryStoreValue, this.options.errorPolicy)) {
            return {
                data: {},
                loading: false,
                networkStatus: queryStoreValue.networkStatus,
                error: new __WEBPACK_IMPORTED_MODULE_3__errors_ApolloError__["a" /* ApolloError */]({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }),
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryLoading = !queryStoreValue ||
            queryStoreValue.networkStatus === __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].loading;
        var loading = (this.options.fetchPolicy === 'network-only' && queryLoading) ||
            (partial && this.options.fetchPolicy !== 'cache-only');
        var networkStatus;
        if (queryStoreValue) {
            networkStatus = queryStoreValue.networkStatus;
        }
        else {
            networkStatus = loading ? __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].loading : __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].ready;
        }
        var result = {
            data: data,
            loading: Object(__WEBPACK_IMPORTED_MODULE_1__networkStatus__["b" /* isNetworkRequestInFlight */])(networkStatus),
            networkStatus: networkStatus,
        };
        if (queryStoreValue &&
            queryStoreValue.graphQLErrors &&
            this.options.errorPolicy === 'all') {
            result.errors = queryStoreValue.graphQLErrors;
        }
        if (!partial) {
            var stale = false;
            this.lastResult = __assign({}, result, { stale: stale });
        }
        return __assign({}, result, { partial: partial });
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.refetch = function (variables) {
        if (this.options.fetchPolicy === 'cache-only') {
            return Promise.reject(new Error('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["q" /* isEqual */])(this.variables, variables)) {
            this.variables = __assign({}, this.variables, variables);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["q" /* isEqual */])(this.options.variables, this.variables)) {
            this.options.variables = __assign({}, this.options.variables, this.variables);
        }
        var combinedOptions = __assign({}, this.options, { fetchPolicy: 'network-only' });
        return this.queryManager
            .fetchQuery(this.queryId, combinedOptions, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* FetchType */].refetch)
            .then(function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["x" /* maybeDeepFreeze */])(result); });
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        if (!fetchMoreOptions.updateQuery) {
            throw new Error('updateQuery option is required. This function defines how to update the query data with the new results.');
        }
        return Promise.resolve()
            .then(function () {
            var qid = _this.queryManager.generateQueryId();
            var combinedOptions;
            if (fetchMoreOptions.query) {
                combinedOptions = fetchMoreOptions;
            }
            else {
                combinedOptions = __assign({}, _this.options, fetchMoreOptions, { variables: __assign({}, _this.variables, fetchMoreOptions.variables) });
            }
            combinedOptions.fetchPolicy = 'network-only';
            return _this.queryManager.fetchQuery(qid, combinedOptions, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* FetchType */].normal, _this.queryId);
        })
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult, _a) {
                var variables = _a.variables;
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: variables,
                });
            });
            return fetchMoreResult;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (data) {
                if (options.updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return options.updateQuery(previous, {
                            subscriptionData: data,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                console.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptionHandles.push(subscription);
        return function () {
            var i = _this.subscriptionHandles.indexOf(subscription);
            if (i >= 0) {
                _this.subscriptionHandles.splice(i, 1);
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldOptions = this.options;
        this.options = __assign({}, this.options, opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var tryFetch = (oldOptions.fetchPolicy !== 'network-only' &&
            opts.fetchPolicy === 'network-only') ||
            (oldOptions.fetchPolicy === 'cache-only' &&
                opts.fetchPolicy !== 'cache-only') ||
            (oldOptions.fetchPolicy === 'standby' &&
                opts.fetchPolicy !== 'standby') ||
            false;
        return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        var newVariables = __assign({}, this.variables, variables);
        if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["q" /* isEqual */])(newVariables, this.variables) && !tryFetch) {
            if (this.observers.length === 0 || !fetchResults) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.result();
        }
        else {
            this.lastVariables = this.variables;
            this.variables = newVariables;
            this.options.variables = newVariables;
            if (this.observers.length === 0) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.queryManager
                .fetchQuery(this.queryId, __assign({}, this.options, { variables: this.variables }))
                .then(function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["x" /* maybeDeepFreeze */])(result); });
        }
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var _a = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["D" /* tryFunctionOrLogError */])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            this.queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            this.queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
            this.isCurrentlyPolling = false;
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        if (this.options.fetchPolicy === 'cache-first' ||
            this.options.fetchPolicy === 'cache-only') {
            throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
        }
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        this.options.pollInterval = pollInterval;
        this.isCurrentlyPolling = true;
        this.scheduler.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        if (observer._subscription &&
            observer._subscription._observer &&
            !observer._subscription._observer.error) {
            observer._subscription._observer.error = function (error) {
                console.error('Unhandled error', error.message, error.stack);
            };
        }
        this.observers.push(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (this.observers.length === 1)
            this.setUpQuery();
        return function () {
            _this.observers = _this.observers.filter(function (obs) { return obs !== observer; });
            if (_this.observers.length === 0) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        if (this.shouldSubscribe) {
            this.queryManager.addObservableQuery(this.queryId, this);
        }
        if (!!this.options.pollInterval) {
            if (this.options.fetchPolicy === 'cache-first' ||
                this.options.fetchPolicy === 'cache-only') {
                throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
            }
            this.isCurrentlyPolling = true;
            this.scheduler.startPollingQuery(this.options, this.queryId);
        }
        var observer = {
            next: function (result) {
                _this.lastResult = result;
                _this.observers.forEach(function (obs) { return obs.next && obs.next(result); });
            },
            error: function (error) {
                _this.lastError = error;
                _this.observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
        };
        this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        this.isTornDown = true;
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        this.subscriptionHandles.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptionHandles = [];
        this.queryManager.removeObservableQuery(this.queryId);
        this.queryManager.stopQuery(this.queryId);
        this.observers = [];
    };
    return ObservableQuery;
}(__WEBPACK_IMPORTED_MODULE_2__util_Observable__["a" /* Observable */]));

//# sourceMappingURL=ObservableQuery.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isScalarValue */
/* unused harmony export isNumberValue */
/* harmony export (immutable) */ __webpack_exports__["j"] = valueToObjectRepresentation;
/* harmony export (immutable) */ __webpack_exports__["h"] = storeKeyNameFromField;
/* harmony export (immutable) */ __webpack_exports__["b"] = getStoreKeyName;
/* harmony export (immutable) */ __webpack_exports__["a"] = argumentsObjectFromField;
/* harmony export (immutable) */ __webpack_exports__["g"] = resultKeyNameFromField;
/* harmony export (immutable) */ __webpack_exports__["c"] = isField;
/* harmony export (immutable) */ __webpack_exports__["e"] = isInlineFragment;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIdValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = toIdValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = isJsonValue;
/* unused harmony export valueFromNode */
function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.");
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = JSON.stringify(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject && idObject.type === 'id';
}
function toIdValue(id, generated) {
    if (generated === void 0) { generated = false; }
    return {
        type: 'id',
        id: id,
        generated: generated,
    };
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw new Error("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getEnv */
/* unused harmony export isEnv */
/* harmony export (immutable) */ __webpack_exports__["b"] = isProduction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDevelopment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTest;
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(104)))

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(967);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(393);
/* unused harmony reexport createOperation */
/* unused harmony reexport makePromise */
/* unused harmony reexport toPromise */
/* unused harmony reexport fromPromise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zen_observable__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_zen_observable__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_zen_observable__; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isScalarValue */
/* unused harmony export isNumberValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = valueToObjectRepresentation;
/* unused harmony export storeKeyNameFromField */
/* unused harmony export getStoreKeyName */
/* harmony export (immutable) */ __webpack_exports__["a"] = argumentsObjectFromField;
/* unused harmony export resultKeyNameFromField */
/* unused harmony export isField */
/* unused harmony export isInlineFragment */
/* unused harmony export isIdValue */
/* unused harmony export toIdValue */
/* unused harmony export isJsonValue */
/* unused harmony export valueFromNode */
function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else {
        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.");
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = JSON.stringify(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject && idObject.type === 'id';
}
function toIdValue(id, generated) {
    if (generated === void 0) { generated = false; }
    return {
        type: 'id',
        id: id,
        generated: generated,
    };
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw new Error("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getEnv */
/* unused harmony export isEnv */
/* harmony export (immutable) */ __webpack_exports__["b"] = isProduction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDevelopment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTest;
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(104)))

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isApolloError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloError; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    __extends(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=ApolloError.js.map

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zenObservable__ = __webpack_require__(397);
/* unused harmony namespace reexport */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__zenObservable__["a" /* Observable */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isScalarValue */
/* unused harmony export isNumberValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = valueToObjectRepresentation;
/* unused harmony export storeKeyNameFromField */
/* unused harmony export getStoreKeyName */
/* harmony export (immutable) */ __webpack_exports__["a"] = argumentsObjectFromField;
/* unused harmony export resultKeyNameFromField */
/* unused harmony export isField */
/* unused harmony export isInlineFragment */
/* unused harmony export isIdValue */
/* unused harmony export toIdValue */
/* unused harmony export isJsonValue */
/* unused harmony export valueFromNode */
function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else {
        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.");
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = JSON.stringify(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject && idObject.type === 'id';
}
function toIdValue(id, generated) {
    if (generated === void 0) { generated = false; }
    return {
        type: 'id',
        id: id,
        generated: generated,
    };
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw new Error("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getEnv */
/* unused harmony export isEnv */
/* harmony export (immutable) */ __webpack_exports__["b"] = isProduction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDevelopment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTest;
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(104)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(150),
    baseLodash = __webpack_require__(253);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(150),
    baseLodash = __webpack_require__(253);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(1009);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(113);
/* eslint-disable @typescript-eslint/no-explicit-any */

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["f" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["c"] = snipLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(94);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        // eslint-disable-next-line no-param-reassign
        colno = ll;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(value)) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromException;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = eventFromUnknownInput;
/* unused harmony export eventFromString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracekit__ = __webpack_require__(259);




/**
 * Builds and Event from a Exception
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        handled: true,
        type: 'generic',
    });
    event.level = __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* Severity */].Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* Severity */].Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["s" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["q" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* addExceptionTypeValue */])(event, message);
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["x" /* isPlainObject */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["a" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function computeStackTrace(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            popSize = ex.framesToPop;
        }
        else if (reactMinifiedRegexp.test(ex.message)) {
            popSize = 1;
        }
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function computeStackTraceFromStackProp(ex) {
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);


/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* PromiseBuffer */](30);
        this._api = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* API */](this.options.dsn);
        // eslint-disable-next-line deprecation/deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(1028);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(1029);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(1030);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(1031);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(343);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1041), __webpack_require__(20));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.initialize = initialize;
exports.ga = ga;
exports.set = set;
exports.send = send;
exports.pageview = pageview;
exports.modalview = modalview;
exports.timing = timing;
exports.event = event;
exports.exception = exception;
exports.outboundLink = outboundLink;

var _format2 = __webpack_require__(3);

var _format3 = _interopRequireDefault(_format2);

var _removeLeadingSlash = __webpack_require__(6);

var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

var _loadGA = __webpack_require__(7);

var _loadGA2 = _interopRequireDefault(_loadGA);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

var _log = __webpack_require__(8);

var _log2 = _interopRequireDefault(_log);

var _testModeAPI = __webpack_require__(9);

var _testModeAPI2 = _interopRequireDefault(_testModeAPI);

var _OutboundLink = __webpack_require__(10);

var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * React Google Analytics Module
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @package react-ga
                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
                                                                                                                                                                                                     */

/**
 * Utilities
 */


var _debug = false;
var _titleCase = true;
var _testMode = false;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return (0, _format3.default)(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];
  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      (0, _warn2.default)('ga command must be a string');
      return;
    }

    internalGa.apply(undefined, args);
    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    (0, _warn2.default)('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (typeof window === 'undefined') {
      return false;
    }

    (0, _loadGA2.default)(options);
  }

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
        (0, _warn2.default)('All configs must be an object');
        return;
      }
      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }
  return true;
}

/**
 * ga:
 * Returns the original GA object.
 */
function ga() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(undefined, args);
    if (_debug) {
      (0, _log2.default)('called ga(\'arguments\');');
      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
    }
  }

  return window.ga;
}

/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    (0, _warn2.default)('`fieldsObject` is required in .set()');
    return;
  }

  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    (0, _warn2.default)('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    (0, _log2.default)('called ga(\'set\', fieldsObject);');
    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
  }
}

/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);
  if (_debug) {
    (0, _log2.default)('called ga(\'send\', fieldObject);');
    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
  }
}

/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */
function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    (0, _warn2.default)('path is required in .pageview()');
    return;
  }

  var path = (0, _trim2.default)(rawPath);
  if (path === '') {
    (0, _warn2.default)('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};
  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _extends({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';
      if (title) {
        extraLog = ' and title: ' + title;
      }
      (0, _log2.default)('with path: ' + path + extraLog);
    }
  }
}

/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    (0, _warn2.default)('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

  if (modalName === '') {
    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = '/modal/' + modalName;
    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      (0, _log2.default)('with path: ' + path);
    }
  }
}

/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments[1];

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}

/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var trackerNames = arguments[1];

  var category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      (0, _warn2.default)('args.category AND args.action are required in event()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    };

    // Optional Fields
    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        (0, _warn2.default)('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    };

    // Optional Fields
    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        (0, _warn2.default)('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    }

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

var plugin = exports.plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        (0, _warn2.default)('`name` is required in .require()');
        return;
      }

      var name = (0, _trim2.default)(rawName);
      if (name === '') {
        (0, _warn2.default)('`name` cannot be an empty string in .require()');
        return;
      }

      // Optional Fields
      if (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
          (0, _warn2.default)('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          (0, _warn2.default)('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
        }
      } else {
        ga('require', name);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload = void 0;
    var actionType = void 0;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        (0, _warn2.default)('Expected `action` arg to be a String.');
      } else {
        var command = pluginName + ':' + action;
        payload = payload || null;
        if (actionType && payload) {
          ga(command, actionType, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
          }
        } else if (payload) {
          ga(command, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
          }
        } else {
          ga(command);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
          }
        }
      }
    }
  }
};

/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */
function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    (0, _warn2.default)('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      (0, _warn2.default)('args.label is required in outboundLink()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };

    var safetyCallbackCalled = false;
    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;

      hitCallback();
    };

    // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data

    // register safety net timeout:
    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);
      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA;

    // Send to GA
    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}

_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
_OutboundLink2.default.trackLink = outboundLink;
var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
var testModeAPI = exports.testModeAPI = _testModeAPI2.default;

exports.default = {
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  OutboundLink: OutboundLink,
  testModeAPI: _testModeAPI2.default
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _mightBeEmail = __webpack_require__(4);

var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

var _toTitleCase = __webpack_require__(5);

var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var redacted = 'REDACTED (Potential Email Address)';

function format(s, titleCase) {
  if ((0, _mightBeEmail2.default)(s)) {
    (0, _warn2.default)('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return (0, _toTitleCase2.default)(s);
  }

  return s;
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/.test(s)
  );
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toTitleCase;

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                * https://github.com/gouch/to-title-case
                                                                                                */

function toTitleCase(string) {
  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (options) {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var gaCalls = exports.gaCalls = [];

exports.default = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;

      var eventMeta = { label: eventLabel };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutboundLink, [{
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        href: this.props.to,
        onClick: this.handleClick
      });
      delete props.eventLabel;
      return _react2.default.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(_react.Component);

OutboundLink.propTypes = {
  eventLabel: _propTypes2.default.string.isRequired,
  target: _propTypes2.default.string,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null
};

OutboundLink.trackLink = function () {
  (0, _warn2.default)('ga tracking not enabled');
};

exports.default = OutboundLink;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ })
/******/ ]);
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isConnectionEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluckNodes; });
var isConnectionEnd=function isConnectionEnd(connection){var direction=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'forward';if(!connection||!connection.pageInfo){return true;}var _connection$pageInfo=connection.pageInfo,hasNextPage=_connection$pageInfo.hasNextPage,hasPreviousPage=_connection$pageInfo.hasPreviousPage;return direction==='forward'?!hasNextPage:!hasPreviousPage;};var pluckNodes=function pluckNodes(connection){return!connection||!connection.edges?[]:connection.edges.map(function(edge){return edge.node;});};

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(data,namespace){return namespace.split('.').reduce(function(acc,key){return acc&&acc[key];},data);});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var RelationshipContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1ne47lb0',label:'RelationshipContainer'})('margin:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(3),' 0;');/* harmony default export */ __webpack_exports__["a"] = (RelationshipContainer);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_serializeErrorMessages__ = __webpack_require__(268);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StyledSwitch=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["J" /* SwitchInput */],{target:'e1qbax6k0',label:'StyledSwitch'})({name:'1pg8bi',styles:'height:20px;'});var SwitchWithMutation=function(_Component){_inherits(SwitchWithMutation,_Component);function SwitchWithMutation(props){_classCallCheck(this,SwitchWithMutation);var _this=_possibleConstructorReturn(this,(SwitchWithMutation.__proto__||Object.getPrototypeOf(SwitchWithMutation)).call(this,props));_this.state={active:false};_this.performSave=function(value){var _this$props=_this.props,mutate=_this$props.mutate,buildMutationOptions=_this$props.buildMutationOptions;mutate(buildMutationOptions(_this.state.active)).catch(function(e){return Promise.reject(Object(__WEBPACK_IMPORTED_MODULE_4_utils_serializeErrorMessages__["a" /* default */])(e));});};_this.state.active=props.initialValue;_this.save=__WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(_this.performSave,500);return _this;}_createClass(SwitchWithMutation,[{key:'toggle',value:function toggle(e){var value=e.target.checked;this.setState({active:value},this.save);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledSwitch,Object.assign({id:this.props.id,checked:this.state.active,onChange:function onChange(e){return _this2.toggle(e);}},this.props));}}]);return SwitchWithMutation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SwitchWithMutation);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var VALIDATION_ERROR=/Validation failed:/;var serializeErrorMessages=function serializeErrorMessages(_ref){var graphQLErrors=_ref.graphQLErrors,networkError=_ref.networkError;if(networkError){return'An error has occurred. Please try again.';}var validationErrors=graphQLErrors.filter(function(_ref2){var message=_ref2.message;return VALIDATION_ERROR.test(message);}).map(function(_ref3){var message=_ref3.message;return message.replace(VALIDATION_ERROR,'').trim();});return validationErrors.length?validationErrors:'An error has occurred.';};/* harmony default export */ __webpack_exports__["a"] = (serializeErrorMessages);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectCache; });
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultNormalizedCacheFactory;
var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = undefined;
    };
    ObjectCache.prototype.clear = function () {
        this.data = {};
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || {};
    };
    return ObjectCache;
}());

function defaultNormalizedCacheFactory(seed) {
    return new ObjectCache(seed);
}
//# sourceMappingURL=objectCache.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_yup__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_yup___default.a.object().shape({name:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required("Name can't be blank"),salesforce_id:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required("Salesforce ID can't be blank")}));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'id',label:'ID',type:'immutable'},{name:'name',label:'Name'}]);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'id',label:'ID',type:'immutable'},{name:'name',label:'Name',type:'immutable'},{name:'active_for_global',label:'Active for Global',type:'boolean'},{name:'active_for_user',label:'Active for Me',type:'boolean'}]);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GraphQLError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__printError__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_location__ = __webpack_require__(441);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */


function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined;

  // Compute locations in the source for the given nodes/positions.
  var _source = source;
  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;
  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }
      return list;
    }, []);
  }
  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations = void 0;
  if (positions && source) {
    _locations = positions.map(function (pos) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start));
      }
      return list;
    }, []);
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      value: extensions || originalError && originalError.extensions
    }
  });

  // Include (non-enumerable) stack trace.
  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: { value: GraphQLError },
  name: { value: 'GraphQLError' },
  toString: {
    value: function toString() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__printError__["a" /* printError */])(this);
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(1167);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(447);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(6)(function () {
  return Object.defineProperty(__webpack_require__(159)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(11);


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(29);
var toIObject = __webpack_require__(30);
var arrayIndexOf = __webpack_require__(120)(false);
var IE_PROTO = __webpack_require__(161)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var anObject = __webpack_require__(4);
var getKeys = __webpack_require__(64);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(30);
var gOPN = __webpack_require__(67).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(13);
var getKeys = __webpack_require__(64);
var gOPS = __webpack_require__(121);
var pIE = __webpack_require__(98);
var toObject = __webpack_require__(15);
var IObject = __webpack_require__(97);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(19);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(284);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 284 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(83).trim;
var ws = __webpack_require__(165);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(83).trim;

module.exports = 1 / $parseFloat(__webpack_require__(165) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(36);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(168);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(15);
var IObject = __webpack_require__(97);
var toLength = __webpack_require__(12);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(12);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(180);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(13) && /./g.flags != 'g') __webpack_require__(14).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(99)
});


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(184);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(300);
var validate = __webpack_require__(72);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(129)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(14).f;
var create = __webpack_require__(66);
var redefineAll = __webpack_require__(71);
var ctx = __webpack_require__(35);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var $iterDefine = __webpack_require__(170);
var step = __webpack_require__(294);
var setSpecies = __webpack_require__(68);
var DESCRIPTORS = __webpack_require__(13);
var fastKey = __webpack_require__(57).fastKey;
var validate = __webpack_require__(72);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(300);
var validate = __webpack_require__(72);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(129)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var each = __webpack_require__(46)(0);
var redefine = __webpack_require__(26);
var meta = __webpack_require__(57);
var assign = __webpack_require__(281);
var weak = __webpack_require__(303);
var isObject = __webpack_require__(8);
var validate = __webpack_require__(72);
var NATIVE_WEAK_MAP = __webpack_require__(72);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(129)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(71);
var getWeak = __webpack_require__(57).getWeak;
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var createArrayMethod = __webpack_require__(46);
var $has = __webpack_require__(29);
var validate = __webpack_require__(72);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(37);
var toLength = __webpack_require__(12);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(67);
var gOPS = __webpack_require__(121);
var anObject = __webpack_require__(4);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(122);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(12);
var ctx = __webpack_require__(35);
var IS_CONCAT_SPREADABLE = __webpack_require__(11)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(12);
var repeat = __webpack_require__(167);
var defined = __webpack_require__(44);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var getKeys = __webpack_require__(64);
var toIObject = __webpack_require__(30);
var isEnum = __webpack_require__(98).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(82);
var from = __webpack_require__(310);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(70);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(663)();
}


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(313);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(189);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(671);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(320);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(187);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adaptive = __webpack_require__(322);

var _adaptive2 = _interopRequireDefault(_adaptive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _adaptive2.default)();

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookie = __webpack_require__(323);

var _cookie2 = _interopRequireDefault(_cookie);

var _localStorage = __webpack_require__(324);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _localStorage3 = __webpack_require__(688);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      key = _ref.localStorageKey,
      name = _ref.cookieName,
      domain = _ref.cookieDomain,
      expires = _ref.cookieExpires,
      secure = _ref.cookieSecure;

  return (0, _localStorage3.isLocalStorageAvailable)() ? (0, _localStorage2.default)({ key: key }) : (0, _cookie2.default)({ name: name, domain: domain, expires: expires, secure: secure });
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = __webpack_require__(687);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_COOKIE_NAME = 'redux-simple-auth-session';
var secondsFromNow = function secondsFromNow(seconds) {
  return new Date(Date.now() + seconds * 1000);
};

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$name = _ref.name,
      name = _ref$name === undefined ? DEFAULT_COOKIE_NAME : _ref$name,
      _ref$path = _ref.path,
      path = _ref$path === undefined ? '/' : _ref$path,
      _ref$domain = _ref.domain,
      domain = _ref$domain === undefined ? null : _ref$domain,
      _ref$secure = _ref.secure,
      secure = _ref$secure === undefined ? false : _ref$secure,
      _ref$expires = _ref.expires,
      expires = _ref$expires === undefined ? null : _ref$expires;

  return {
    persist: function persist(data) {
      _jsCookie2.default.set(name, data, {
        domain: domain,
        path: path,
        secure: secure,
        expires: expires && secondsFromNow(expires)
      });
    },
    restore: function restore() {
      return _jsCookie2.default.getJSON(name) || {};
    }
  };
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_KEY = 'redux-simple-auth-session';

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$key = _ref.key,
      key = _ref$key === undefined ? DEFAULT_KEY : _ref$key;

  return {
    persist: function persist(data) {
      localStorage.setItem(key, JSON.stringify(data || {}));
    },
    restore: function restore() {
      return JSON.parse(localStorage.getItem(key)) || {};
    },
    __key: key,
    __syncsAcrossTabs: true
  };
};

/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasFailedAuth = exports.getLastError = exports.getIsRestored = exports.getAuthenticator = exports.getIsAuthenticated = exports.getSessionData = undefined;

var _reducer = __webpack_require__(192);

var fromSession = _interopRequireWildcard(_reducer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getSessionData = exports.getSessionData = function getSessionData(state) {
  return fromSession.getData(state.session);
};

var getIsAuthenticated = exports.getIsAuthenticated = function getIsAuthenticated(state) {
  return fromSession.getIsAuthenticated(state.session);
};

var getAuthenticator = exports.getAuthenticator = function getAuthenticator(state) {
  return fromSession.getAuthenticator(state.session);
};

var getIsRestored = exports.getIsRestored = function getIsRestored(state) {
  return fromSession.getIsRestored(state.session);
};

var getLastError = exports.getLastError = function getLastError(state) {
  return fromSession.getLastError(state.session);
};

var getHasFailedAuth = exports.getHasFailedAuth = function getHasFailedAuth(state) {
  return fromSession.getHasFailedAuth(state.session);
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(333);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(337);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (weakMemoize);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export C */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Emotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createEmotionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return withEmotionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_utils__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_serialize__ = __webpack_require__(138);






var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? Object(__WEBPACK_IMPORTED_MODULE_2__emotion_cache__["a" /* default */])() : null);
var ThemeContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(registeredStyles);

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(type, newProps);

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
}




/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_serialize__ = __webpack_require__(138);


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__emotion_serialize__["a" /* serializeStyles */])(args);
}

/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (false) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return _objectSpread({}, outerTheme, {}, theme);
};

var createCacheWithTheme = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (outerTheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (theme) {
    return getTheme(outerTheme, theme);
  });
});

var ThemeProvider = function ThemeProvider(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["c" /* ThemeContext */].Consumer, null, function (theme) {
    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["c" /* ThemeContext */].Provider, {
      value: theme
    }, props.children);
  });
};

// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["c" /* ThemeContext */].Consumer, null, function (theme) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Component, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends___default()({
        theme: theme,
        ref: ref
      }, props));
    });
  }; // $FlowFixMe


  var WithTheme = Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component);
}

function useTheme() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["c" /* ThemeContext */]);
}




/***/ }),
/* 342 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(732);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry__ = __webpack_require__(767);
var prop=Object(__WEBPACK_IMPORTED_MODULE_0__curry__["a" /* default */])(function(key,obj){return obj[key];});var defaultTo=Object(__WEBPACK_IMPORTED_MODULE_0__curry__["a" /* default */])(function(defaultValue,value){return value==null?defaultValue:value;});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterLink__ = __webpack_require__(768);
var Container=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('section',{target:'eaktjgo0',label:'Container'})('padding-top:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(6),';padding-bottom:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(6),';display:flex;justify-content:center;',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["S" /* mediaDn */])('sm'),'{flex-direction:column;}@supports (display:grid){display:grid;grid-template-columns:repeat(3,auto);justify-content:center;',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["S" /* mediaDn */])('sm'),'{grid-template-columns:1fr;}}');var HomeFooter=function HomeFooter(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FooterLink__["a" /* default */],{href:'https://help.focusvision.com/'},'Support'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FooterLink__["a" /* default */],{href:'https://legal.forsta.com/legal/privacy-notice/'},'Privacy policy'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FooterLink__["a" /* default */],{href:'https://legal.forsta.com/legal/forsta-acceptable-use-policy/'},'Acceptable use policy'));};/* harmony default export */ __webpack_exports__["a"] = (HomeFooter);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppLink__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppLogo__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylist__ = __webpack_require__(2);
var StyledAppLogo=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_components_AppLogo__["a" /* default */],{target:'e15pyug50',label:'StyledAppLogo'})('margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_4_stylist__["V" /* spacer */])(4),';');var AppLogoLink=function AppLogoLink(_ref){var clientId=_ref.clientId;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppLink__["a" /* default */],{clientId:clientId},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledAppLogo,{clientId:clientId}));};/* harmony default export */ __webpack_exports__["a"] = (AppLogoLink);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({cookiesAccepted:false,setCookieAcceptance:function setCookieAcceptance(){}}),Provider=_createContext.Provider,Consumer=_createContext.Consumer;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(141),
    isArguments = __webpack_require__(214),
    isArray = __webpack_require__(23),
    isIndex = __webpack_require__(351),
    isLength = __webpack_require__(215),
    toKey = __webpack_require__(107);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 350 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(216),
    arrayEach = __webpack_require__(353),
    assignValue = __webpack_require__(354),
    baseAssign = __webpack_require__(810),
    baseAssignIn = __webpack_require__(816),
    cloneBuffer = __webpack_require__(819),
    copyArray = __webpack_require__(222),
    copySymbols = __webpack_require__(820),
    copySymbolsIn = __webpack_require__(822),
    getAllKeys = __webpack_require__(361),
    getAllKeysIn = __webpack_require__(363),
    getTag = __webpack_require__(109),
    initCloneArray = __webpack_require__(826),
    initCloneByTag = __webpack_require__(827),
    initCloneObject = __webpack_require__(832),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(148),
    isMap = __webpack_require__(833),
    isObject = __webpack_require__(55),
    isSet = __webpack_require__(835),
    keys = __webpack_require__(88);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(147),
    eq = __webpack_require__(211);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(811),
    isArguments = __webpack_require__(214),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(148),
    isIndex = __webpack_require__(351),
    isTypedArray = __webpack_require__(217);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(356),
    baseKeysIn = __webpack_require__(817),
    isArrayLike = __webpack_require__(221);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(224),
    getPrototype = __webpack_require__(149),
    getSymbols = __webpack_require__(223),
    stubArray = __webpack_require__(359);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(362),
    getSymbols = __webpack_require__(223),
    keys = __webpack_require__(88);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(224),
    isArray = __webpack_require__(23);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(362),
    getSymbolsIn = __webpack_require__(360),
    keysIn = __webpack_require__(358);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(840),
    hasUnicode = __webpack_require__(369),
    unicodeToArray = __webpack_require__(841);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function argumentsToArray(args) {
  return Array.prototype.slice.apply(args);
}

function looksLikePromise(thing) {
  return thing &&
    thing.then &&
    typeof (thing.then) === "function" &&
    typeof (thing.catch) === "function";
}

function SynchronousPromise(ctorFunction) {
  this.status = "pending";
  this._paused = false;
  this._next = [];
  this._data = [];
  this._runConstructorFunction(ctorFunction);
}

SynchronousPromise.prototype = {
  then: function (next, fail) {
    this._next.push([next, fail]);

    if (this._isPendingResolutionOrRejection()) {
      return this;
    }

    return this._applyNext();
  },
  catch: function (fn) {
    this._next.push([undefined, fn]);

    if (this._isPendingResolutionOrRejection()) {
      return this;
    }

    return this._applyNext();
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    this._paused = false;
    return this._applyNext();
  },
  _runConstructorFunction: function (ctorFunction) {
    var self = this;

    this._next.push([
      function (r) { return r; },
      function (err) { throw err; }
    ]);

    var isRun = false;
    ctorFunction(function (result) {
      if (isRun) {
        return;
      }

      isRun = true;
      self._setResolved();
      self._data = [result];
      self._applyNext();
    }, function (err) {
      if (isRun) {
        return;
      }

      isRun = true;
      self._setRejected();
      self._data = [err];
      self._applyNext();
    });
  },
  _setRejected: function () {
    this.status = "rejected";
  },
  _setResolved: function () {
    this.status = "resolved";
  },
  _setPending: function () {
    this.status = "pending";
  },
  _applyNext: function () {
    if (this._next.length === 0 || this._paused) {
      return this;
    }

    var next = this._findNext();
    if (!next) {
      return this;
    }
    return this._applyNextHandler(next);
  },
  _applyNextHandler: function (handler) {
    try {
      var data = handler.apply(null, this._data);

      if (looksLikePromise(data)) {
        this._handleNestedPromise(data);
        return this;
      }

      this._setResolved();
      this._data = [data];
      return this._applyNext();
    } catch (e) {
      this._setRejected();
      this._data = [e];
      return this._applyNext();
    }
  },
  _findNext: function () {
    if (this._isPendingResolutionOrRejection()) {
      return undefined;
    }
    var handler = this.status === "resolved"
          ? this._findFirstResolutionHandler
          : this._findFirstRejectionHandler;
    return handler ? handler.apply(this) : undefined;
  },
  _handleNestedPromise: function (promise) {
    this._setPending();
    var self = this;
    promise.then(function (d) {
      self._setResolved();
      self._data = [d];
      self._applyNext();
    }).catch(function (e) {
      self._setRejected();
      self._data = [e];
      self._applyNext();
    });
  },
  _isPendingResolutionOrRejection: function () {
    return this.status === "pending";
  },
  _findFirstResolutionHandler: function () {
    var next;
    while (!next && this._next.length > 0) {
      next = this._next.shift()[0];
    }

    return next;
  },
  _findFirstRejectionHandler: function () {
    var next;
    while (!next && this._next.length > 0) {
      next = this._next.shift()[1];
    }

    return next;
  }
};
SynchronousPromise.resolve = function (data) {
  if (looksLikePromise(data)) {
    return data;
  }

  return new SynchronousPromise(function (resolve) {
    resolve(data);
  });
};
SynchronousPromise.reject = function (error) {
  if (looksLikePromise(error)) {
    return error;
  }

  return new SynchronousPromise(function (resolve, reject) {
    reject(error);
  });
};
SynchronousPromise.all = function () {
  var args = argumentsToArray(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};
SynchronousPromise.unresolved = function () {
  var stash = {};
  var result = new SynchronousPromise(function (resolve, reject) {
    stash.resolve = resolve;
    stash.reject = reject;
  });
  result.resolve = stash.resolve;
  result.reject = stash.reject;
  return result;
};

module.exports = {
  SynchronousPromise: SynchronousPromise
};



/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(852),
    isObjectLike = __webpack_require__(50);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(853),
    arraySome = __webpack_require__(856),
    cacheHas = __webpack_require__(857);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(880),
    overRest = __webpack_require__(883),
    setToString = __webpack_require__(885);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(890),
    deburr = __webpack_require__(891),
    words = __webpack_require__(894);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = makePath;
function makePath(strings) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });

  return path.replace(/^\./, '');
}
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_GoogleButton__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_MicrosoftButton__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylist__ = __webpack_require__(2);
var ButtonBox=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1r11tz50',label:'ButtonBox'})('display:flex;flex-direction:row;justify-content:center;align-items:center;> *{margin-right:',Object(__WEBPACK_IMPORTED_MODULE_4_stylist__["V" /* spacer */])(3),';}');var Label=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('span',{target:'e1r11tz51',label:'Label'})(Object(__WEBPACK_IMPORTED_MODULE_4_stylist__["Q" /* fontWeight */])('bold'),';');var SSOProviderButtons=function SSOProviderButtons(_ref){var cookiesAccepted=_ref.cookiesAccepted,cookieError=_ref.cookieError,isSignUp=_ref.isSignUp;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].Field,{render:function render(_ref2){var setFieldError=_ref2.setFieldError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ButtonBox,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Sign ',isSignUp?'up':'in',' with:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GoogleButton__["a" /* default */],{valid:cookiesAccepted,onError:function onError(){return setFieldError('cookiesAccepted',cookieError);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_MicrosoftButton__["a" /* default */],{valid:cookiesAccepted,onError:function onError(){return setFieldError('cookiesAccepted',cookieError);}}));}});};/* harmony default export */ __webpack_exports__["a"] = (SSOProviderButtons);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(232);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(233);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wrapDisplayName = __webpack_require__(233);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__(232);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__(917);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return revoke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isValid; });
var revoke=function revoke(token){return fetch("https://api-qa.focusvision.com"+'/oauth/revoke',{method:'POST',credentials:'include',body:'token='+encodeURIComponent(token)+'}',headers:{'Content-Type':'application/x-www-form-urlencoded'}});};var isValid=function isValid(payload){return Boolean(payload)&&Boolean(payload.access_token)&&!isExpired(payload);};// `created_at` is seconds since epoch.
var isExpired=function isExpired(_ref){var created_at=_ref.created_at,expires_in=_ref.expires_in;return created_at+expires_in<Date.now()/1000;};

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(387);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var TwoFAForm=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1u7mi7f0',label:'TwoFAForm'})({name:'8atqhb',styles:'width:100%;'});var Input=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Input,{target:'e1u7mi7f1',label:'Input'})({name:'1qm1lh',styles:'margin-bottom:16px;'});var StyledSubmitButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].SubmitButton,{target:'e1u7mi7f2',label:'StyledSubmitButton'})({name:'1xm0deg',styles:'margin-bottom:24px !important;'});var TwoFactorForm=function TwoFactorForm(_ref){var notify=_ref.notify,authenticate=_ref.authenticate;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TwoFAForm,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */],{initialValues:{authenticationCode:''},onSubmit:function onSubmit(_ref2){var authenticationCode=_ref2.authenticationCode;authenticate('oauth2-password-grant',{otp_attempt:authenticationCode}).catch(function(_ref3){var error=_ref3.payload.error;if(error==='two_fa_error'){notify('warning','Authentication code incorrect / expired.');}else if(error==='password_expired'){notify('info','Your password is expired, please reset.');}});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'authenticationCode'},'Authentication code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{type:'text',id:'authenticationCode',name:'authenticationCode',autoComplete:'off',placeholder:'Enter the code from Google Authenticator app'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledSubmitButton,{block:true},'Verify'))));};/* harmony default export */ __webpack_exports__["a"] = (TwoFactorForm);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getMutationDefinition;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDocument;
/* harmony export (immutable) */ __webpack_exports__["g"] = getOperationDefinition;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOperationDefinitionOrDie;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOperationName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFragmentDefinitions;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQueryDefinition;
/* unused harmony export getFragmentDefinition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMainDefinition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createFragmentMap;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDefaultValues;
/* unused harmony export variablesInOperation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_assign__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storeUtils__ = __webpack_require__(242);


function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
    if (!mutationDef) {
        throw new Error('Must contain a mutation definition.');
    }
    return mutationDef;
}
function checkDocument(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    if (operations.length > 1) {
        throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    if (!def) {
        throw new Error("GraphQL document is missing an operation");
    }
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== 'query') {
        throw new Error('Must contain a query definition.');
    }
    return queryDef;
}
function getFragmentDefinition(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    if (doc.definitions.length > 1) {
        throw new Error('Fragment must have exactly one definition.');
    }
    var fragmentDef = doc.definitions[0];
    if (fragmentDef.kind !== 'FragmentDefinition') {
        throw new Error('Must be a fragment definition.');
    }
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            Object(__WEBPACK_IMPORTED_MODULE_1__storeUtils__["j" /* valueToObjectRepresentation */])(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return __WEBPACK_IMPORTED_MODULE_0__util_assign__["a" /* assign */].apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
//# sourceMappingURL=assign.js.map

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneDeep;
function cloneDeep(value) {
    if (Array.isArray(value)) {
        return value.map(function (item) { return cloneDeep(item); });
    }
    if (value !== null && typeof value === 'object') {
        var nextValue = {};
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                nextValue[key] = cloneDeep(value[key]);
            }
        }
        return nextValue;
    }
    return value;
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(189);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Observable = (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
        return this;
    };
    return Observable;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["b" /* Observable */]));

//# sourceMappingURL=Observable.js.map

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = validateOperation;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkError; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isTerminating;
/* unused harmony export toPromise */
/* unused harmony export makePromise */
/* unused harmony export fromPromise */
/* harmony export (immutable) */ __webpack_exports__["d"] = transformOperation;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOperation;
/* unused harmony export getKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zen_observable__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_zen_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__ = __webpack_require__(92);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new Error("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));

function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    console.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable__(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["a" /* getOperationName */])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign({}, context, next(context));
        }
        else {
            context = __assign({}, context, next);
        }
    };
    var getContext = function () { return (__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__["a" /* print */])(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}
//# sourceMappingURL=linkUtils.js.map

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMutationDefinition */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDocument;
/* unused harmony export getOperationDefinition */
/* harmony export (immutable) */ __webpack_exports__["d"] = getOperationDefinitionOrDie;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOperationName;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFragmentDefinitions;
/* unused harmony export getQueryDefinition */
/* unused harmony export getFragmentDefinition */
/* unused harmony export getMainDefinition */
/* harmony export (immutable) */ __webpack_exports__["b"] = createFragmentMap;
/* unused harmony export getDefaultValues */
/* unused harmony export variablesInOperation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_assign__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storeUtils__ = __webpack_require__(245);


function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
    if (!mutationDef) {
        throw new Error('Must contain a mutation definition.');
    }
    return mutationDef;
}
function checkDocument(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    if (operations.length > 1) {
        throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    if (!def) {
        throw new Error("GraphQL document is missing an operation");
    }
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== 'query') {
        throw new Error('Must contain a query definition.');
    }
    return queryDef;
}
function getFragmentDefinition(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    if (doc.definitions.length > 1) {
        throw new Error('Fragment must have exactly one definition.');
    }
    var fragmentDef = doc.definitions[0];
    if (fragmentDef.kind !== 'FragmentDefinition') {
        throw new Error('Must be a fragment definition.');
    }
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            Object(__WEBPACK_IMPORTED_MODULE_1__storeUtils__["b" /* valueToObjectRepresentation */])(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return __WEBPACK_IMPORTED_MODULE_0__util_assign__["a" /* assign */].apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
//# sourceMappingURL=assign.js.map

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneDeep;
function cloneDeep(value) {
    if (Array.isArray(value)) {
        return value.map(function (item) { return cloneDeep(item); });
    }
    if (value !== null && typeof value === 'object') {
        var nextValue = {};
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                nextValue[key] = cloneDeep(value[key]);
            }
        }
        return nextValue;
    }
    return value;
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
var Observable = __webpack_require__(153);
//# sourceMappingURL=zenObservable.js.map

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = validateOperation;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkError; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isTerminating;
/* unused harmony export toPromise */
/* unused harmony export makePromise */
/* unused harmony export fromPromise */
/* harmony export (immutable) */ __webpack_exports__["c"] = fromError;
/* harmony export (immutable) */ __webpack_exports__["e"] = transformOperation;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOperation;
/* unused harmony export getKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__ = __webpack_require__(92);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new Error("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));

function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    console.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["a" /* getOperationName */])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign({}, context, next(context));
        }
        else {
            context = __assign({}, context, next);
        }
    };
    var getContext = function () { return (__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__["a" /* print */])(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}
//# sourceMappingURL=linkUtils.js.map

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMutationDefinition */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDocument;
/* unused harmony export getOperationDefinition */
/* harmony export (immutable) */ __webpack_exports__["d"] = getOperationDefinitionOrDie;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOperationName;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFragmentDefinitions;
/* unused harmony export getQueryDefinition */
/* unused harmony export getFragmentDefinition */
/* unused harmony export getMainDefinition */
/* harmony export (immutable) */ __webpack_exports__["b"] = createFragmentMap;
/* unused harmony export getDefaultValues */
/* unused harmony export variablesInOperation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_assign__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storeUtils__ = __webpack_require__(249);


function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
    if (!mutationDef) {
        throw new Error('Must contain a mutation definition.');
    }
    return mutationDef;
}
function checkDocument(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    if (operations.length > 1) {
        throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    if (!def) {
        throw new Error("GraphQL document is missing an operation");
    }
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== 'query') {
        throw new Error('Must contain a query definition.');
    }
    return queryDef;
}
function getFragmentDefinition(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    if (doc.definitions.length > 1) {
        throw new Error('Fragment must have exactly one definition.');
    }
    var fragmentDef = doc.definitions[0];
    if (fragmentDef.kind !== 'FragmentDefinition') {
        throw new Error('Must be a fragment definition.');
    }
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            Object(__WEBPACK_IMPORTED_MODULE_1__storeUtils__["b" /* valueToObjectRepresentation */])(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return __WEBPACK_IMPORTED_MODULE_0__util_assign__["a" /* assign */].apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
//# sourceMappingURL=assign.js.map

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneDeep;
function cloneDeep(value) {
    if (Array.isArray(value)) {
        return value.map(function (item) { return cloneDeep(item); });
    }
    if (value !== null && typeof value === 'object') {
        var nextValue = {};
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                nextValue[key] = cloneDeep(value[key]);
            }
        }
        return nextValue;
    }
    return value;
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(997),
    noop = __webpack_require__(998);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(999);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(156);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profiler__ = __webpack_require__(1033);
/* unused harmony reexport Profiler */
/* unused harmony reexport withProfiler */
/* unused harmony reexport useProfiler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errorboundary__ = __webpack_require__(1034);
/* unused harmony reexport ErrorBoundary */
/* unused harmony reexport withErrorBoundary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux__ = __webpack_require__(1035);
/* unused harmony reexport createReduxEnhancer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactrouterv3__ = __webpack_require__(1036);
/* unused harmony reexport reactRouterV3Instrumentation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reactrouter__ = __webpack_require__(1037);
/* unused harmony reexport reactRouterV4Instrumentation */
/* unused harmony reexport reactRouterV5Instrumentation */
/* unused harmony reexport withSentryRouting */


/**
 * A global side effect that makes sure Sentry events that user
 * `@sentry/react` will correctly have Sentry events associated
 * with it.
 */
function createReactEventProcessor() {
    if (__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["b" /* addGlobalEventProcessor */]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["b" /* addGlobalEventProcessor */])(function (event) {
            event.sdk = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.sdk), { name: 'sentry.javascript.react', packages: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(((event.sdk && event.sdk.packages) || []), [
                    {
                        name: 'npm:@sentry/react',
                        version: __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["a" /* SDK_VERSION */],
                    },
                ]), version: __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["a" /* SDK_VERSION */] });
            return event;
        });
    }
}






createReactEventProcessor();
//# sourceMappingURL=index.js.map

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = captureException;
/* unused harmony export captureMessage */
/* unused harmony export captureEvent */
/* harmony export (immutable) */ __webpack_exports__["b"] = configureScope;
/* unused harmony export addBreadcrumb */
/* unused harmony export setContext */
/* unused harmony export setExtras */
/* unused harmony export setTags */
/* unused harmony export setExtra */
/* unused harmony export setTag */
/* unused harmony export setUser */
/* harmony export (immutable) */ __webpack_exports__["c"] = withScope;
/* unused harmony export _callOnClient */
/* unused harmony export startTransaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(93);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arrity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual
 * tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and
 * child spans to other spans. To start a new child span within the transaction
 * or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished,
 * otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at
 * which point the transaction with all its finished child spans will be sent to
 * Sentry.
 *
 * @param context Properties of the new `Transaction`.
 */
function startTransaction(context) {
    return callOnHub('startTransaction', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);


/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._extra = {};
        /** Contexts */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(scope._breadcrumbs);
            newScope._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._tags);
            newScope._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._extra);
            newScope._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Scope.prototype.setContext = function (key, context) {
        var _a;
        this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        var span = this.getSpan();
        if (span && span.spanRecorder && span.spanRecorder.spans[0]) {
            return span.spanRecorder.spans[0];
        }
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), captureContext._tags);
            this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), captureContext._extra);
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), captureContext._contexts);
            if (captureContext._user) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["x" /* isPlainObject */])(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), captureContext.tags);
            this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), captureContext.extra);
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timestamp: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["J" /* timestampWithMs */])() }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
                : Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ trace: this._span.getTraceContext() }, event.contexts);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["A" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["b"] = fill;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["c"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractExceptionKeysForMessage;
/* unused harmony export dropUndefinedKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__memo__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__string__ = __webpack_require__(257);





/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */
function getWalkSource(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["d" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["f" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = Object(__WEBPACK_IMPORTED_MODULE_1__is__["c" /* isElement */])(event_1.target)
                ? Object(__WEBPACK_IMPORTED_MODULE_3__misc__["h" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_1__is__["c" /* isElement */])(event_1.currentTarget)
                ? Object(__WEBPACK_IMPORTED_MODULE_3__misc__["h" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_1__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["l" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_3__misc__["e" /* getFunctionName */])(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_2__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["i" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__string__["d" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_4__string__["d" /* truncate */])(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["h" /* isPlainObject */])(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(94);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["m" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler.done) {
                    return;
                }
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler.onfulfilled(_this._value);
                    }
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(113);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);


/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integrations__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__version__ = __webpack_require__(415);







/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* injectReportDialog */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.sdk), { name: __WEBPACK_IMPORTED_MODULE_6__version__["a" /* SDK_NAME */], packages: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_6__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_6__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(__WEBPACK_IMPORTED_MODULE_5__integrations__["Breadcrumbs"]);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(259);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(260);
/* unused harmony reexport BaseTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(1025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(1026);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.21.1';
//# sourceMappingURL=version.js.map

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasAuthorizationParams; });
var hasAuthorizationParams=function hasAuthorizationParams(query){return['response_type','client_id','redirect_uri','state'].every(function(key){return query.has(key);});};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var FormDescription=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('p',{target:'ehwub7z0',label:'FormDescription'})('margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(5),';');/* harmony default export */ __webpack_exports__["a"] = (FormDescription);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return password; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return passwordConfirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_yup__);
var email=__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().email('Email must be a valid email address').required("Email can't be blank");var password=__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required("Password can't be blank").min(12,'Password is too short (minimum is 12 characters)').matches(/\d/,'Password must contain a digit').matches(/[A-Z]/,'Password must contain an uppercase character').matches(/[a-z]/,'Password must contain a lowercase character').matches(/[^a-zA-Z\d]/,'Password must contain a special character');var passwordConfirmation=__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().when('password',function(password,schema){return schema.test('passwordMatches',"Password confirmation doesn't match password",function(passwordConfirmation){return passwordConfirmation===password;});});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Company__ = __webpack_require__(420);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Company__["a" /* default */],{render:function render(_ref){var company=_ref.company;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({company:company},props));}});};});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
var Company=function Company(_ref){var render=_ref.render;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */],{channel:'company'},render);};/* harmony default export */ __webpack_exports__["a"] = (Company);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decamelizeLink__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__httpLink__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_client__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__ = __webpack_require__(424);
var client=new __WEBPACK_IMPORTED_MODULE_2_apollo_client__["ApolloClient"]({link:__WEBPACK_IMPORTED_MODULE_3_apollo_link__["a" /* ApolloLink */].from([__WEBPACK_IMPORTED_MODULE_0__decamelizeLink__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__httpLink__["a" /* default */]]),cache:new __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__["a" /* InMemoryCache */]()});/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpLink__ = __webpack_require__(1091);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__httpLink__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__["a"]; });
/* unused harmony reexport defaultDataIdFromObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__readFromStore__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__writeToStore__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objectCache__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recordingCache__ = __webpack_require__(429);
/* unused harmony namespace reexport */






//# sourceMappingURL=index.js.map

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeuristicFragmentMatcher; });
/* unused harmony export IntrospectionFragmentMatcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(41);

var haveWarned = false;
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            if (!haveWarned) {
                console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                console.warn('Could not find __typename on Fragment ', typeCondition, obj);
                console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
                if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["w" /* isTest */])()) {
                    haveWarned = true;
                }
            }
            context.returnPartialData = true;
            return true;
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["E" /* warnOnceInDevelopment */])("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types.\n     Apollo Client will not be able to able to accurately map fragments." +
            "To make this error go away, use the IntrospectionFragmentMatcher as described in the docs: " +
            "https://www.apollographql.com/docs/react/recipes/fragment-matching.html", 'error');
        context.returnPartialData = true;
        return true;
    };
    return HeuristicFragmentMatcher;
}());

var IntrospectionFragmentMatcher = (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        if (!this.isReady) {
            throw new Error('FragmentMatcher.match() was called before FragmentMatcher.init()');
        }
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

//# sourceMappingURL=fragmentMatcher.js.map

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WriteError */
/* unused harmony export enhanceErrorWithDocument */
/* unused harmony export writeQueryToStore */
/* harmony export (immutable) */ __webpack_exports__["a"] = writeResultToStore;
/* unused harmony export writeSelectionSetToStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectCache__ = __webpack_require__(269);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var WriteError = (function (_super) {
    __extends(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));

function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
function writeQueryToStore(_a) {
    var result = _a.result, query = _a.query, _b = _a.storeFactory, storeFactory = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__objectCache__["b" /* defaultNormalizedCacheFactory */] : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, _d = _a.fragmentMap, fragmentMap = _d === void 0 ? {} : _d, fragmentMatcherFunction = _a.fragmentMatcherFunction;
    var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* getQueryDefinition */])(query);
    variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["e" /* getDefaultValues */])(queryDefinition), variables);
    try {
        return writeSelectionSetToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            selectionSet: queryDefinition.selectionSet,
            context: {
                store: store,
                storeFactory: storeFactory,
                processedData: {},
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMap: fragmentMap,
                fragmentMatcherFunction: fragmentMatcherFunction,
            },
        });
    }
    catch (e) {
        throw enhanceErrorWithDocument(e, query);
    }
}
function writeResultToStore(_a) {
    var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.storeFactory, storeFactory = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__objectCache__["b" /* defaultNormalizedCacheFactory */] : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
    var operationDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["k" /* getOperationDefinition */])(document);
    var selectionSet = operationDefinition.selectionSet;
    var fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["d" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["g" /* getFragmentDefinitions */])(document));
    variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["e" /* getDefaultValues */])(operationDefinition), variables);
    try {
        return writeSelectionSetToStore({
            result: result,
            dataId: dataId,
            selectionSet: selectionSet,
            context: {
                store: store,
                storeFactory: storeFactory,
                processedData: {},
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMap: fragmentMap,
                fragmentMatcherFunction: fragmentMatcherFunction,
            },
        });
    }
    catch (e) {
        throw enhanceErrorWithDocument(e, document);
    }
}
function writeSelectionSetToStore(_a) {
    var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
    var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
    selectionSet.selections.forEach(function (selection) {
        var included = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["A" /* shouldInclude */])(selection, variables);
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* isField */])(selection)) {
            var resultFieldKey = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["z" /* resultKeyNameFromField */])(selection);
            var value = result[resultFieldKey];
            if (included) {
                if (typeof value !== 'undefined') {
                    writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = selection.directives &&
                        selection.directives.length &&
                        selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                    if (!isDefered && context.fragmentMatcherFunction) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["v" /* isProduction */])()) {
                            console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                        }
                    }
                }
            }
        }
        else {
            var fragment = void 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isInlineFragment */])(selection)) {
                fragment = selection;
            }
            else {
                fragment = (fragmentMap || {})[selection.name.value];
                if (!fragment) {
                    throw new Error("No fragment named " + selection.name.value + ".");
                }
            }
            var matches = true;
            if (context.fragmentMatcherFunction && fragment.typeCondition) {
                var idValue = { type: 'id', id: 'self', generated: false };
                var fakeContext = {
                    store: new __WEBPACK_IMPORTED_MODULE_2__objectCache__["a" /* ObjectCache */]({ self: result }),
                    returnPartialData: false,
                    hasMissingField: false,
                    cacheRedirects: {},
                };
                matches = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["v" /* isProduction */])() && fakeContext.returnPartialData) {
                    console.error('WARNING: heuristic fragment matching going on!');
                }
            }
            if (included && matches) {
                writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context,
                });
            }
        }
    });
    return store;
}
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(value) && isGeneratedId(value.id) && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(realValue)) {
            mergeWithGenerated(value.id, realValue.id, cache);
        }
        cache.delete(generatedKey);
        cache.set(realKey, __assign({}, generated, real));
    });
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}
function writeFieldToStore(_a) {
    var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
    var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
    var storeValue;
    var storeObject;
    var storeFieldName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["B" /* storeKeyNameFromField */])(field, variables);
    var shouldMerge = false;
    var generatedKey = '';
    if (!field.selectionSet || value === null) {
        storeValue =
            value != null && typeof value === 'object'
                ?
                    { type: 'json', json: value }
                :
                    value;
    }
    else if (Array.isArray(value)) {
        var generatedId = dataId + "." + storeFieldName;
        storeValue = processArrayValue(value, generatedId, field.selectionSet, context);
    }
    else {
        var valueDataId = dataId + "." + storeFieldName;
        var generated = true;
        if (!isGeneratedId(valueDataId)) {
            valueDataId = '$' + valueDataId;
        }
        if (dataIdFromObject) {
            var semanticId = dataIdFromObject(value);
            if (semanticId && isGeneratedId(semanticId)) {
                throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
            }
            if (semanticId) {
                valueDataId = semanticId;
                generated = false;
            }
        }
        if (!isDataProcessed(valueDataId, field, context.processedData)) {
            writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context,
            });
        }
        storeValue = {
            type: 'id',
            id: valueDataId,
            generated: generated,
        };
        storeObject = store.get(dataId);
        if (storeObject && storeObject[storeFieldName] !== storeValue) {
            var escapedId = storeObject[storeFieldName];
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(storeValue) &&
                storeValue.generated &&
                Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(escapedId) &&
                !escapedId.generated) {
                throw new Error("Store error: the application attempted to write an object with no provided id" +
                    (" but the store already contains an id of " + escapedId.id + " for this object. The selectionSet") +
                    " that was trying to be written is:\n" +
                    Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(field));
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(escapedId) && escapedId.generated) {
                generatedKey = escapedId.id;
                shouldMerge = true;
            }
        }
    }
    var newStoreObj = __assign({}, store.get(dataId), (_b = {}, _b[storeFieldName] = storeValue, _b));
    if (shouldMerge) {
        mergeWithGenerated(generatedKey, storeValue.id, store);
    }
    storeObject = store.get(dataId);
    if (!storeObject || storeValue !== storeObject[storeFieldName]) {
        store.set(dataId, newStoreObj);
    }
    var _b;
}
function processArrayValue(value, generatedId, selectionSet, context) {
    return value.map(function (item, index) {
        if (item === null) {
            return null;
        }
        var itemDataId = generatedId + "." + index;
        if (Array.isArray(item)) {
            return processArrayValue(item, itemDataId, selectionSet, context);
        }
        var generated = true;
        if (context.dataIdFromObject) {
            var semanticId = context.dataIdFromObject(item);
            if (semanticId) {
                itemDataId = semanticId;
                generated = false;
            }
        }
        if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
            writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context,
            });
        }
        var idStoreValue = {
            type: 'id',
            id: itemDataId,
            generated: generated,
        };
        return idStoreValue;
    });
}
//# sourceMappingURL=writeToStore.js.map

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ID_KEY */
/* harmony export (immutable) */ __webpack_exports__["b"] = readQueryFromStore;
/* harmony export (immutable) */ __webpack_exports__["a"] = diffQueryAgainstStore;
/* unused harmony export assertIdValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_anywhere__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(41);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var ID_KEY = typeof Symbol !== 'undefined' ? Symbol('id') : '@@id';
function readQueryFromStore(options) {
    var optsPatch = { returnPartialData: false };
    return diffQueryAgainstStore(__assign({}, options, optsPatch)).result;
}
var readStoreResolver = function (fieldName, idValue, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    assertIdValue(idValue);
    var objId = idValue.id;
    var obj = context.store.get(objId);
    var storeKeyName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["n" /* getStoreKeyName */])(fieldName, args, directives);
    var fieldValue = (obj || {})[storeKeyName];
    if (typeof fieldValue === 'undefined') {
        if (context.cacheRedirects &&
            obj &&
            (obj.__typename || objId === 'ROOT_QUERY')) {
            var typename = obj.__typename || 'Query';
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(obj, args, {
                        getCacheKey: function (obj) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["C" /* toIdValue */])(context.dataIdFromObject(obj));
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        if (!context.returnPartialData) {
            throw new Error("Can't find field " + storeKeyName + " on object (" + objId + ") " + JSON.stringify(obj, null, 2) + ".");
        }
        context.hasMissingField = true;
        return fieldValue;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["u" /* isJsonValue */])(fieldValue)) {
        if (idValue.previousResult &&
            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* isEqual */])(idValue.previousResult[resultKey], fieldValue.json)) {
            return idValue.previousResult[resultKey];
        }
        return fieldValue.json;
    }
    if (idValue.previousResult) {
        fieldValue = addPreviousResultToIdValues(fieldValue, idValue.previousResult[resultKey]);
    }
    return fieldValue;
};
function diffQueryAgainstStore(_a) {
    var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
    var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* getQueryDefinition */])(query);
    variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["e" /* getDefaultValues */])(queryDefinition), variables);
    var context = {
        store: store,
        returnPartialData: returnPartialData,
        dataIdFromObject: (config && config.dataIdFromObject) || null,
        cacheRedirects: (config && config.cacheRedirects) || {},
        hasMissingField: false,
    };
    var rootIdValue = {
        type: 'id',
        id: rootId,
        previousResult: previousResult,
    };
    var result = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_anywhere__["a" /* default */])(readStoreResolver, query, rootIdValue, context, variables, {
        fragmentMatcher: fragmentMatcherFunction,
        resultMapper: resultMapper,
    });
    return {
        result: result,
        complete: !context.hasMissingField,
    };
}
function assertIdValue(idValue) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(idValue)) {
        throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
    }
}
function addPreviousResultToIdValues(value, previousResult) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(value)) {
        return __assign({}, value, { previousResult: previousResult });
    }
    else if (Array.isArray(value)) {
        var idToPreviousResult_1 = new Map();
        if (Array.isArray(previousResult)) {
            previousResult.forEach(function (item) {
                if (item && item[ID_KEY]) {
                    idToPreviousResult_1.set(item[ID_KEY], item);
                }
            });
        }
        return value.map(function (item, i) {
            var itemPreviousResult = previousResult && previousResult[i];
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isIdValue */])(item)) {
                itemPreviousResult =
                    idToPreviousResult_1.get(item.id) || itemPreviousResult;
            }
            return addPreviousResultToIdValues(item, itemPreviousResult);
        });
    }
    return value;
}
function resultMapper(resultFields, idValue) {
    if (idValue.previousResult) {
        var currentResultKeys_1 = Object.keys(resultFields);
        var sameAsPreviousResult = Object.keys(idValue.previousResult).reduce(function (sameKeys, key) { return sameKeys && currentResultKeys_1.indexOf(key) > -1; }, true) &&
            currentResultKeys_1.every(function (key) {
                return areNestedArrayItemsStrictlyEqual(resultFields[key], idValue.previousResult[key]);
            });
        if (sameAsPreviousResult) {
            return idValue.previousResult;
        }
    }
    Object.defineProperty(resultFields, ID_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: idValue.id,
    });
    return resultFields;
}
function areNestedArrayItemsStrictlyEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
        return false;
    }
    return a.every(function (item, i) { return areNestedArrayItemsStrictlyEqual(item, b[i]); });
}
//# sourceMappingURL=readFromStore.js.map

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graphql;
/* unused harmony export merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(41);

function graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) { execOptions = {}; }
    var mainDefinition = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["i" /* getMainDefinition */])(document);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["g" /* getFragmentDefinitions */])(document);
    var fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["d" /* createFragmentMap */])(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher,
    };
    return executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
function executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function (selection) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["A" /* shouldInclude */])(selection, variables)) {
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["r" /* isField */])(selection)) {
            var fieldResult = executeField(selection, rootValue, execContext);
            var resultFieldKey = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["z" /* resultKeyNameFromField */])(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) {
                    result[resultFieldKey] = fieldResult;
                }
                else {
                    merge(result[resultFieldKey], fieldResult);
                }
            }
        }
        else {
            var fragment = void 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["t" /* isInlineFragment */])(selection)) {
                fragment = selection;
            }
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) {
                    throw new Error("No fragment named " + selection.name.value);
                }
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) {
        return execContext.resultMapper(result, rootValue);
    }
    return result;
}
function executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["b" /* argumentsObjectFromField */])(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["z" /* resultKeyNameFromField */])(field),
        directives: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["f" /* getDirectiveInfoFromField */])(field, variables),
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) {
        return result;
    }
    if (result == null) {
        return result;
    }
    if (Array.isArray(result)) {
        return executeSubSelectedArray(field, result, execContext);
    }
    return executeSelectionSet(field.selectionSet, result, execContext);
}
function executeSubSelectedArray(field, result, execContext) {
    return result.map(function (item) {
        if (item === null) {
            return null;
        }
        if (Array.isArray(item)) {
            return executeSubSelectedArray(field, item, execContext);
        }
        return executeSelectionSet(field.selectionSet, item, execContext);
    });
}
function merge(dest, src) {
    if (src === null || typeof src !== 'object') {
        return src;
    }
    Object.keys(dest).forEach(function (destKey) {
        if (src.hasOwnProperty(destKey)) {
            merge(dest[destKey], src[destKey]);
        }
    });
    Object.keys(src).forEach(function (srcKey) {
        if (!dest.hasOwnProperty(srcKey)) {
            dest[srcKey] = src[srcKey];
        }
    });
}
//# sourceMappingURL=graphql.js.map

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecordingCache */
/* harmony export (immutable) */ __webpack_exports__["a"] = record;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var RecordingCache = (function () {
    function RecordingCache(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
        this.recordedData = {};
    }
    RecordingCache.prototype.record = function (transaction) {
        transaction(this);
        var recordedData = this.recordedData;
        this.recordedData = {};
        return recordedData;
    };
    RecordingCache.prototype.toObject = function () {
        return __assign({}, this.data, this.recordedData);
    };
    RecordingCache.prototype.get = function (dataId) {
        if (this.recordedData.hasOwnProperty(dataId)) {
            return this.recordedData[dataId];
        }
        return this.data[dataId];
    };
    RecordingCache.prototype.set = function (dataId, value) {
        if (this.get(dataId) !== value) {
            this.recordedData[dataId] = value;
        }
    };
    RecordingCache.prototype.delete = function (dataId) {
        this.recordedData[dataId] = undefined;
    };
    RecordingCache.prototype.clear = function () {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) { return _this.delete(dataId); });
        this.recordedData = {};
    };
    RecordingCache.prototype.replace = function (newData) {
        this.clear();
        this.recordedData = __assign({}, newData);
    };
    return RecordingCache;
}());

function record(startingState, transaction) {
    var recordingCache = new RecordingCache(startingState);
    return recordingCache.record(transaction);
}
//# sourceMappingURL=recordingCache.js.map

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_User__ = __webpack_require__(431);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_User__["a" /* default */],{render:function render(_ref){var user=_ref.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({user:user},props));}});};});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
var User=function User(_ref){var render=_ref.render;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */],{channel:'user'},render);};/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
var Product=function Product(_ref){var render=_ref.render;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */],{channel:'product'},render);};/* harmony default export */ __webpack_exports__["a"] = (Product);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_yup__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_yup___default.a.object().shape({hostname:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required("hostname can't be blank")}));

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Feature__ = __webpack_require__(435);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Feature__["a" /* default */],{render:function render(_ref){var feature=_ref.feature;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({feature:feature},props));}});};});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
var Feature=function Feature(_ref){var render=_ref.render;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */],{channel:'feature'},render);};/* harmony default export */ __webpack_exports__["a"] = (Feature);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Server__ = __webpack_require__(437);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Server__["a" /* default */],{render:function render(_ref){var server=_ref.server;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({server:server},props));}});};});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
var Server=function Server(_ref){var render=_ref.render;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */],{channel:'server'},render);};/* harmony default export */ __webpack_exports__["a"] = (Server);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(273);
/* unused harmony reexport GraphQLError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syntaxError__ = __webpack_require__(1153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__syntaxError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locatedError__ = __webpack_require__(1154);
/* unused harmony reexport locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__printError__ = __webpack_require__(440);
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatError__ = __webpack_require__(1155);
/* unused harmony reexport formatError */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_location__ = __webpack_require__(441);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];
  if (error.nodes) {
    error.nodes.forEach(function (node) {
      if (node.loc) {
        printedLocations.push(highlightSourceAtLocation(node.loc.source, Object(__WEBPACK_IMPORTED_MODULE_0__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start)));
      }
    });
  } else if (error.source && error.locations) {
    var source = error.source;
    error.locations.forEach(function (location) {
      printedLocations.push(highlightSourceAtLocation(source, location));
    });
  }
  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}

/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */
function highlightSourceAtLocation(source, location) {
  var line = location.line;
  var lineOffset = source.locationOffset.line - 1;
  var columnOffset = getColumnOffset(source, location);
  var contextLine = line + lineOffset;
  var contextColumn = location.column + columnOffset;
  var prevLineNum = (contextLine - 1).toString();
  var lineNum = contextLine.toString();
  var nextLineNum = (contextLine + 1).toString();
  var padLen = nextLineNum.length;
  var lines = source.body.split(/\r\n|[\n\r]/g);
  lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
  var outputLines = [source.name + ' (' + contextLine + ':' + contextColumn + ')', line >= 2 && lpad(padLen, prevLineNum) + ': ' + lines[line - 2], lpad(padLen, lineNum) + ': ' + lines[line - 1], whitespace(2 + padLen + contextColumn - 1) + '^', line < lines.length && lpad(padLen, nextLineNum) + ': ' + lines[line]];
  return outputLines.filter(Boolean).join('\n');
}

function getColumnOffset(source, location) {
  return location.line === 1 ? source.locationOffset.column - 1 : 0;
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocation;


/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match = void 0;
  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }
  return { line: line, column: column };
}

/**
 * Represents a location in a Source.
 */

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(1166);

Object.defineProperty(exports, 'Cookies', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cookies).default;
  }
});

var _CookiesProvider = __webpack_require__(1170);

Object.defineProperty(exports, 'CookiesProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CookiesProvider).default;
  }
});

var _withCookies = __webpack_require__(1173);

Object.defineProperty(exports, 'withCookies', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withCookies).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1171)();
}


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(445);
module.exports = __webpack_require__(450);


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(446).enable();
  window.Promise = __webpack_require__(448);
}

// fetch() polyfill for making API calls.
__webpack_require__(449);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(95);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(275);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(275);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_polyfills__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_store__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_cookie__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_CookieAcceptance__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_apollo_client__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_normalize_css__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_global__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_sentry__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_zendesk__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_zendesk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__config_zendesk__);
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloProvider"],{client:__WEBPACK_IMPORTED_MODULE_12__config_apollo_client__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_cookie__["CookiesProvider"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_5__config_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["M" /* Theme */],{theme:'forsta'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_global__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CookieAcceptance__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]}))))))),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_search_params__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_search_params__);
if(!('URLSearchParams'in window)){window.URLSearchParams=__WEBPACK_IMPORTED_MODULE_1_url_search_params___default.a;}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(453);

__webpack_require__(650);

__webpack_require__(651);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(454);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(179);
__webpack_require__(558);
__webpack_require__(295);
__webpack_require__(559);
__webpack_require__(296);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(299);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
module.exports = __webpack_require__(34);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(13);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(26);
var META = __webpack_require__(57).KEY;
var $fails = __webpack_require__(6);
var shared = __webpack_require__(96);
var setToStringTag = __webpack_require__(81);
var uid = __webpack_require__(63);
var wks = __webpack_require__(11);
var wksExt = __webpack_require__(277);
var wksDefine = __webpack_require__(160);
var enumKeys = __webpack_require__(456);
var isArray = __webpack_require__(122);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var toObject = __webpack_require__(15);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(43);
var createDesc = __webpack_require__(62);
var _create = __webpack_require__(66);
var gOPNExt = __webpack_require__(280);
var $GOPD = __webpack_require__(31);
var $GOPS = __webpack_require__(121);
var $DP = __webpack_require__(14);
var $keys = __webpack_require__(64);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(98).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(56)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(25)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(96)('native-function-to-string', Function.toString);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(64);
var gOPS = __webpack_require__(121);
var pIE = __webpack_require__(98);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(66) });


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperty: __webpack_require__(14).f });


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperties: __webpack_require__(279) });


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(30);
var $getOwnPropertyDescriptor = __webpack_require__(31).f;

__webpack_require__(45)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(15);
var $getPrototypeOf = __webpack_require__(32);

__webpack_require__(45)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(15);
var $keys = __webpack_require__(64);

__webpack_require__(45)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(45)('getOwnPropertyNames', function () {
  return __webpack_require__(280).f;
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(57).onFreeze;

__webpack_require__(45)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(57).onFreeze;

__webpack_require__(45)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(57).onFreeze;

__webpack_require__(45)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(45)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(45)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(45)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(281) });


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(282) });


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(164).set });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(82);
var test = {};
test[__webpack_require__(11)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(26)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(283) });


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(13) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(32);
var HAS_INSTANCE = __webpack_require__(11)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(14).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(285);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(286);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(29);
var cof = __webpack_require__(36);
var inheritIfRequired = __webpack_require__(166);
var toPrimitive = __webpack_require__(43);
var fails = __webpack_require__(6);
var gOPN = __webpack_require__(67).f;
var gOPD = __webpack_require__(31).f;
var dP = __webpack_require__(14).f;
var $trim = __webpack_require__(83).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(66)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(13) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(26)(global, NUMBER, $Number);
}


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(37);
var aNumberValue = __webpack_require__(287);
var repeat = __webpack_require__(167);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(6)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(6);
var aNumberValue = __webpack_require__(287);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(288) });


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(288);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(286);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(285);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(289);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(168);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(169);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(290) });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(289) });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(168) });


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(169);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(169);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(65);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(30);
var toLength = __webpack_require__(12);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(83)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(123)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(170)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(123)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(12);
var context = __webpack_require__(172);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(173)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(172);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(173)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(167)
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(12);
var context = __webpack_require__(172);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(173)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(27)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(27)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(27)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(27)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(27)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(27)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(27)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(27)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(27)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(27)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(27)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(27)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(27)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(43);

$export($export.P + $export.F * __webpack_require__(6)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(533);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(6);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(26)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(11)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(25)(proto, TO_PRIMITIVE, __webpack_require__(536));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(43);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(122) });


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(35);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var call = __webpack_require__(291);
var isArrayIter = __webpack_require__(174);
var toLength = __webpack_require__(12);
var createProperty = __webpack_require__(175);
var getIterFn = __webpack_require__(176);

$export($export.S + $export.F * !__webpack_require__(125)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(175);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(6)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(30);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(97) != Object || !__webpack_require__(38)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(163);
var cof = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(12);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(6)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(15);
var fails = __webpack_require__(6);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(38)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(46)(0);
var STRICT = __webpack_require__(38)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(122);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(46)(1);

$export($export.P + $export.F * !__webpack_require__(38)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(46)(2);

$export($export.P + $export.F * !__webpack_require__(38)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(46)(3);

$export($export.P + $export.F * !__webpack_require__(38)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(46)(4);

$export($export.P + $export.F * !__webpack_require__(38)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(292);

$export($export.P + $export.F * !__webpack_require__(38)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(292);

$export($export.P + $export.F * !__webpack_require__(38)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(120)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(30);
var toInteger = __webpack_require__(37);
var toLength = __webpack_require__(12);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(293) });

__webpack_require__(58)('copyWithin');


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(178) });

__webpack_require__(58)('fill');


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(46)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(46)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Array');


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(166);
var dP = __webpack_require__(14).f;
var gOPN = __webpack_require__(67).f;
var isRegExp = __webpack_require__(124);
var $flags = __webpack_require__(99);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(13) && (!CORRECT_NEW || __webpack_require__(6)(function () {
  re2[__webpack_require__(11)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(26)(global, 'RegExp', $RegExp);
}

__webpack_require__(68)('RegExp');


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(296);
var anObject = __webpack_require__(4);
var $flags = __webpack_require__(99);
var DESCRIPTORS = __webpack_require__(13);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(26)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var toLength = __webpack_require__(12);
var advanceStringIndex = __webpack_require__(181);
var regExpExec = __webpack_require__(126);

// @@match logic
__webpack_require__(127)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(12);
var toInteger = __webpack_require__(37);
var advanceStringIndex = __webpack_require__(181);
var regExpExec = __webpack_require__(126);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(127)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var sameValue = __webpack_require__(282);
var regExpExec = __webpack_require__(126);

// @@search logic
__webpack_require__(127)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(124);
var anObject = __webpack_require__(4);
var speciesConstructor = __webpack_require__(100);
var advanceStringIndex = __webpack_require__(181);
var toLength = __webpack_require__(12);
var callRegExpExec = __webpack_require__(126);
var regexpExec = __webpack_require__(180);
var fails = __webpack_require__(6);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(127)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var global = __webpack_require__(5);
var ctx = __webpack_require__(35);
var classof = __webpack_require__(82);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var speciesConstructor = __webpack_require__(100);
var task = __webpack_require__(182).set;
var microtask = __webpack_require__(183)();
var newPromiseCapabilityModule = __webpack_require__(184);
var perform = __webpack_require__(297);
var userAgent = __webpack_require__(128);
var promiseResolve = __webpack_require__(298);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(71)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(81)($Promise, PROMISE);
__webpack_require__(68)(PROMISE);
Wrapper = __webpack_require__(34)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(125)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(303);
var validate = __webpack_require__(72);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(129)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(130);
var buffer = __webpack_require__(185);
var anObject = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(12);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(100);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(68)(ARRAY_BUFFER);


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(130).ABV, {
  DataView: __webpack_require__(185).DataView
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(4);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(6)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(66);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(6);
var bind = __webpack_require__(283);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(14);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(43);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(6)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(31).f;
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(4);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(171)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(32);
var has = __webpack_require__(29);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(31);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(32);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(4);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(305) });


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(4);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(14);
var gOPD = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(32);
var has = __webpack_require__(29);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(62);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(164);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(120)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(58)('includes');


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(306);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(12);
var aFunction = __webpack_require__(19);
var arraySpeciesCreate = __webpack_require__(177);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(58)('flatMap');


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(306);
var toObject = __webpack_require__(15);
var toLength = __webpack_require__(12);
var toInteger = __webpack_require__(37);
var arraySpeciesCreate = __webpack_require__(177);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(58)('flatten');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(123)(true);
var $fails = __webpack_require__(6);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(307);
var userAgent = __webpack_require__(128);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(307);
var userAgent = __webpack_require__(128);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(83)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(83)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(44);
var toLength = __webpack_require__(12);
var isRegExp = __webpack_require__(124);
var getFlags = __webpack_require__(99);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(171)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160)('asyncIterator');


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160)('observable');


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(305);
var toIObject = __webpack_require__(30);
var gOPD = __webpack_require__(31);
var createProperty = __webpack_require__(175);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(308)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(308)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(14);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(13) && $export($export.P + __webpack_require__(131), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(14);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(13) && $export($export.P + __webpack_require__(131), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(43);
var getPrototypeOf = __webpack_require__(32);
var getOwnPropertyDescriptor = __webpack_require__(31).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(13) && $export($export.P + __webpack_require__(131), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(43);
var getPrototypeOf = __webpack_require__(32);
var getOwnPropertyDescriptor = __webpack_require__(31).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(13) && $export($export.P + __webpack_require__(131), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(309)('Map') });


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(309)('Set') });


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(132)('Map');


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(132)('Set');


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(132)('WeakMap');


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(132)('WeakSet');


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(133)('Map');


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(133)('Set');


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(133)('WeakMap');


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(133)('WeakSet');


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(36);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(311);
var fround = __webpack_require__(290);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(311) });


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(34);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(100);
var promiseResolve = __webpack_require__(298);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(184);
var perform = __webpack_require__(297);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(32);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(301);
var from = __webpack_require__(310);
var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(32);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(32);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(53);
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(19);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(183)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(36)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(5);
var core = __webpack_require__(34);
var microtask = __webpack_require__(183)();
var OBSERVABLE = __webpack_require__(11)('observable');
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(4);
var anInstance = __webpack_require__(69);
var redefineAll = __webpack_require__(71);
var hide = __webpack_require__(25);
var forOf = __webpack_require__(70);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(68)('Observable');


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(128);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(182);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(179);
var getKeys = __webpack_require__(64);
var redefine = __webpack_require__(26);
var global = __webpack_require__(5);
var hide = __webpack_require__(25);
var Iterators = __webpack_require__(84);
var wks = __webpack_require__(11);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(652);
module.exports = __webpack_require__(34).RegExp.escape;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(653)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function appendTo(dict, name, value) {
  if (name in dict) {
    dict[name].push('' + value);
  } else {
    dict[name] = isArray(value) ? value : ['' + value];
  }
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(95),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(95),q=__webpack_require__(657);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(658);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RouteUnlessAuthenticated__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_WhenRestored__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_home__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_login__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_logout__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_admin__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_errors__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_sign_up__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_RouteIfAdmin__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_GoogleAnalytics__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CurrentUser_Provider__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_NullComponent__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_stylist__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_WhenRestored__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_GoogleAnalytics__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_stylist__["E" /* NotificationsProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_stylist__["D" /* Notifications */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/logout',component:__WEBPACK_IMPORTED_MODULE_6__routes_logout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CurrentUser_Provider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/',exact:true,component:__WEBPACK_IMPORTED_MODULE_4__routes_home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/my-focusvision',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/'});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/login',component:__WEBPACK_IMPORTED_MODULE_5__routes_login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/logout',component:__WEBPACK_IMPORTED_MODULE_13_components_NullComponent__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_RouteIfAdmin__["a" /* default */],{path:'/admin',failRedirect:'/',component:__WEBPACK_IMPORTED_MODULE_7__routes_admin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_RouteUnlessAuthenticated__["a" /* default */],{to:'/',path:'/sign-up',component:__WEBPACK_IMPORTED_MODULE_9__routes_sign_up__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/*',component:__WEBPACK_IMPORTED_MODULE_8__routes_errors__["a" /* default */]})))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reactions_component__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Session__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylist__ = __webpack_require__(2);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var RouteUnlessAuthenticated=function RouteUnlessAuthenticated(_ref){var Comp=_ref.component,to=_ref.to,notify=_ref.notify,rest=_objectWithoutProperties(_ref,['component','to','notify']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],Object.assign({},rest,{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Session__["a" /* default */],{render:function render(_ref2){var isAuthenticated=_ref2.isAuthenticated;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__reactions_component__["a" /* default */],{didMount:function didMount(){return isAuthenticated&&notify('warning','You are already signed in.');},render:function render(){return isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{to:to}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comp,props);}});}});}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_stylist__["Y" /* withNotifier */])(RouteUnlessAuthenticated));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Component = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _temp, _this, _ret;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Component.prototype.getArgs = function getArgs() {
    var state = this.state,
        props = this.props,
        setState = this._setState,
        forceUpdate = this._forceUpdate;

    return {
      state: state,
      props: props,
      setState: setState,
      forceUpdate: forceUpdate
    };
  };

  Component.prototype.componentDidMount = function componentDidMount() {
    if (this.props.didMount) this.props.didMount(this.getArgs());
  };

  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.shouldUpdate) return this.props.shouldUpdate({
      props: this.props,
      state: this.state,
      nextProps: nextProps,
      nextState: nextState
    });else return true;
  };

  Component.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.willUnmount) this.props.willUnmount({
      state: this.state,
      props: this.props
    });
  };

  Component.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.didUpdate) this.props.didUpdate(Object.assign(this.getArgs(), {
      prevProps: prevProps,
      prevState: prevState
    }));
  };

  Component.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;

    return children ? typeof children === 'function' ? children(this.getArgs()) : children : render ? render(this.getArgs()) : null;
  };

  return Component;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = this.props.initialState;

  this._setState = function () {
    return _this2.setState.apply(_this2, arguments);
  };

  this._forceUpdate = function () {
    return _this2.forceUpdate.apply(_this2, arguments);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(187);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(664);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(684);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(319);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(674);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(672);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(316);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(676);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(317);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(318);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(319);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(320);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(685);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(187);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _default = __webpack_require__(321);

var _default2 = _interopRequireDefault(_default);

var _lodash = __webpack_require__(325);

var _lodash2 = _interopRequireDefault(_lodash);

var _actionTypes = __webpack_require__(134);

var _actions = __webpack_require__(191);

var _selectors = __webpack_require__(326);

var _subscribeToStorageEvents = __webpack_require__(689);

var _subscribeToStorageEvents2 = _interopRequireDefault(_subscribeToStorageEvents);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var validateAuthenticatorsPresence = function validateAuthenticatorsPresence(_ref) {
  var authenticator = _ref.authenticator,
      authenticators = _ref.authenticators;

  (0, _invariant2.default)(authenticator != null || authenticators != null, 'No authenticator was given. Be sure to configure an authenticator ' + 'by using the `authenticator` option for a single authenticator or ' + 'using the `authenticators` option to allow multiple authenticators');
};

var validateAuthenticatorsIsArray = function validateAuthenticatorsIsArray(authenticators) {
  (0, _invariant2.default)(Array.isArray(authenticators), 'Expected `authenticators` to be an array. If you only need a single ' + 'authenticator, consider using the `authenticator` option.');
};

var validateAuthenticatorIsObject = function validateAuthenticatorIsObject(authenticator) {
  (0, _invariant2.default)((0, _lodash2.default)(authenticator), 'Expected `authenticator` to be an object. If you need multiple ' + 'authenticators, consider using the `authenticators` option.');
};

var validateConfig = function validateConfig(config) {
  var authenticator = config.authenticator,
      authenticators = config.authenticators;


  validateAuthenticatorsPresence(config);
  authenticator == null && validateAuthenticatorsIsArray(authenticators);
  authenticators == null && validateAuthenticatorIsObject(authenticator);
};

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  validateConfig(config);

  var authenticator = config.authenticator,
      authenticators = config.authenticators,
      authorize = config.authorize,
      refresh = config.refresh,
      _config$syncTabs = config.syncTabs,
      syncTabs = _config$syncTabs === undefined ? false : _config$syncTabs,
      _config$storage = config.storage,
      storage = _config$storage === undefined ? _default2.default : _config$storage;


  var findAuthenticator = authenticator ? function () {
    return authenticator;
  } : function (name) {
    return authenticators.find(function (authenticator) {
      return authenticator.name === name;
    });
  };

  var restoreWithStorageData = function restoreWithStorageData(_ref2) {
    var _ref2$authenticated = _ref2.authenticated,
        authenticated = _ref2$authenticated === undefined ? {} : _ref2$authenticated;

    var authenticatorName = authenticated.authenticator,
        data = _objectWithoutProperties(authenticated, ['authenticator']);

    var authenticator = findAuthenticator(authenticatorName);

    if (!authenticator) {
      return Promise.reject(authenticated);
    }

    return authenticator.restore(data).then(function () {
      return authenticated;
    });
  };

  return function (_ref3) {
    var dispatch = _ref3.dispatch,
        getState = _ref3.getState;

    restoreWithStorageData(storage.restore() || {}).then(function (authenticated) {
      return dispatch((0, _actions.restore)(authenticated));
    }).catch(function () {
      return dispatch((0, _actions.restoreFailed)());
    });

    if (syncTabs) {
      (0, _subscribeToStorageEvents2.default)(storage, function (storageData) {
        restoreWithStorageData(storageData).then(function (authenticated) {
          return dispatch((0, _actions.syncTab)({ isAuthenticated: true, authenticated: authenticated }));
        }).catch(function (authenticated) {
          return dispatch((0, _actions.syncTab)({ isAuthenticated: false, authenticated: authenticated }));
        });
      });
    }

    return function (next) {
      return function (action) {
        var sync = function sync() {
          var _getState = getState(),
              prevSession = _getState.session;

          var result = next(action);

          var _getState2 = getState(),
              session = _getState2.session;

          if (session.data !== prevSession.data) {
            var _authenticator = session.authenticator,
                data = session.data;


            storage.persist({ authenticated: _extends({}, data, { authenticator: _authenticator }) });
          }

          return result;
        };

        switch (action.type) {
          case _actionTypes.AUTHENTICATE:
            {
              var _authenticator2 = findAuthenticator(action.meta.authenticator);

              (0, _invariant2.default)(_authenticator2, 'No authenticator with name `' + action.meta.authenticator + '` ' + 'was found. Be sure you have defined it in the authenticators ' + 'config.');

              return _authenticator2.authenticate(action.payload).then(function (data) {
                return dispatch((0, _actions.authenticateSucceeded)(_authenticator2.name, data));
              }, function (error) {
                return Promise.reject(dispatch((0, _actions.authenticateFailed)(error)));
              });
            }
          case _actionTypes.FETCH:
            {
              var state = getState();
              var _action$payload = action.payload,
                  url = _action$payload.url,
                  _action$payload$optio = _action$payload.options,
                  options = _action$payload$optio === undefined ? {} : _action$payload$optio;
              var _options$headers = options.headers,
                  headers = _options$headers === undefined ? {} : _options$headers;


              if (authorize) {
                authorize((0, _selectors.getSessionData)(state), function (name, value) {
                  headers[name] = value;
                });
              }

              return fetch(url, _extends({}, options, { headers: headers })).then(function (response) {
                if (response.status === 401 && (0, _selectors.getIsAuthenticated)(state)) {
                  dispatch((0, _actions.invalidateSession)());
                } else if (refresh) {
                  var result = refresh(response);

                  result !== null && dispatch((0, _actions.updateSession)(result));
                }

                return response;
              });
            }
          case _actionTypes.INVALIDATE_SESSION:
            {
              var _state = getState();
              var authenticatorName = (0, _selectors.getAuthenticator)(_state);
              var _authenticator3 = findAuthenticator(authenticatorName);

              if (!(0, _selectors.getIsAuthenticated)(_state)) {
                (0, _warning2.default)(false, 'You are trying to invalidate a session that is not authenticated.');
                return Promise.reject(dispatch((0, _actions.invalidateSessionFailed)()));
              }

              (0, _invariant2.default)(_authenticator3, 'No authenticator with name `' + authenticatorName + '` ' + 'was found. Be sure you have defined it in the authenticators ' + 'config.');

              return _authenticator3.invalidate((0, _selectors.getSessionData)(_state)).then(sync, function () {
                return Promise.reject(dispatch((0, _actions.invalidateSessionFailed)()));
              });
            }
          default:
            {
              return sync();
            }
        }
      };
    };
  };
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOCAL_STORAGE_TEST_KEY = '_redux-simple-auth-test';

var isLocalStorageAvailable = exports.isLocalStorageAvailable = function isLocalStorageAvailable() {
  try {
    localStorage.setItem(LOCAL_STORAGE_TEST_KEY, true);
    localStorage.removeItem(LOCAL_STORAGE_TEST_KEY);
    return true;
  } catch (e) {
    return false;
  }
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (storage, fn) {
  if (!storage.__syncsAcrossTabs) {
    (0, _warning2.default)(false, 'You are trying to use a storage device that does not emit storage ' + 'events. Please use the localStorage store or the sessionStorage store.');
    return;
  }

  window.addEventListener('storage', function (e) {
    if (!e.isTrusted || e.key !== storage.__key || e.newValue === e.oldValue) {
      return;
    }

    try {
      fn(JSON.parse(e.newValue));
    } catch (e) {
      fn({});
    }
  });
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_KEY = 'redux-simple-auth-session';

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$key = _ref.key,
      key = _ref$key === undefined ? DEFAULT_KEY : _ref$key;

  return {
    persist: function persist(data) {
      sessionStorage.setItem(key, JSON.stringify(data || {}));
    },
    restore: function restore() {
      return JSON.parse(sessionStorage.getItem(key)) || {};
    },
    __key: key,
    __syncsAcrossTabs: true
  };
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(325);

var _lodash2 = _interopRequireDefault(_lodash);

var _actions = __webpack_require__(191);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _reducer = __webpack_require__(192);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateStorage = function validateStorage(storage) {
  (0, _invariant2.default)((0, _lodash2.default)(storage) && storage.restore != null, 'Expected `storage` to be a valid storage. You either forgot to ' + 'include it or you passed an invalid storage object');
};

var enhancer = function enhancer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      storage = _ref.storage;

  validateStorage(storage);

  return function (createStore) {
    return function (rootReducer, preloadedState, enhancer) {
      var initialState = _extends({
        session: (0, _reducer2.default)(null, (0, _actions.initialize)(storage.restore()))
      }, preloadedState);

      return createStore(rootReducer, initialState, enhancer);
    };
  };
};

exports.default = enhancer;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createAuthenticator = __webpack_require__(193);

var _createAuthenticator2 = _interopRequireDefault(_createAuthenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _createAuthenticator2.default)({
    name: 'oauth2-implicit-grant',
    restore: function restore(data) {
      return new Promise(function (resolve, reject) {
        if (!data || !data.access_token) {
          return reject('Could not restore session - "access_token" missing.');
        }

        return resolve(data);
      });
    },
    authenticate: function authenticate(hash) {
      return new Promise(function (resolve, reject) {
        if (hash.error) {
          reject(hash.error);
        } else if (!hash || !hash.access_token) {
          reject('Invalid auth params - "access_token" missing.');
        } else {
          resolve(hash);
        }
      });
    }
  });
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createAuthenticator = __webpack_require__(193);

var _createAuthenticator2 = _interopRequireDefault(_createAuthenticator);

var _identity = __webpack_require__(694);

var _identity2 = _interopRequireDefault(_identity);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var defaultRestore = function defaultRestore(data) {
  if (Object.keys(data).length > 0) {
    return Promise.resolve(data);
  }

  return Promise.reject();
};

var defaultInvalidate = function defaultInvalidate(data) {
  return Promise.resolve(data);
};

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endpoint = _ref.endpoint,
      _ref$contentType = _ref.contentType,
      contentType = _ref$contentType === undefined ? 'application/json' : _ref$contentType,
      _ref$headers = _ref.headers,
      headers = _ref$headers === undefined ? {} : _ref$headers,
      _ref$invalidate = _ref.invalidate,
      invalidate = _ref$invalidate === undefined ? defaultInvalidate : _ref$invalidate,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'POST' : _ref$method,
      _ref$restore = _ref.restore,
      restore = _ref$restore === undefined ? defaultRestore : _ref$restore,
      _ref$transformRequest = _ref.transformRequest,
      transformRequest = _ref$transformRequest === undefined ? JSON.stringify : _ref$transformRequest,
      _ref$transformRespons = _ref.transformResponse,
      transformResponse = _ref$transformRespons === undefined ? _identity2.default : _ref$transformRespons;

  (0, _invariant2.default)(endpoint, 'You must provide an endpoint for the `credentials` authenticator');

  return (0, _createAuthenticator2.default)({
    name: 'credentials',
    authenticate: function authenticate(credentials) {
      return fetch(endpoint, {
        method: method,
        headers: _extends({
          'Content-Type': contentType
        }, headers),
        body: transformRequest(credentials)
      }).then(function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(response) {
          var json;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return response.json();

                case 2:
                  json = _context.sent;

                  if (response.ok) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt('return', Promise.reject(json));

                case 5:
                  return _context.abrupt('return', transformResponse(json));

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    restore: restore,
    invalidate: invalidate
  });
};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value;
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref, header) {
  var accessToken = _ref.access_token;

  if (accessToken) {
    header('Authorization', 'Bearer ' + accessToken);
  }
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(196);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(135);
var invariant = __webpack_require__(327);
var ReactPropTypesSecret = __webpack_require__(698);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(136);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(194);

var _PathUtils = __webpack_require__(102);

var _createTransitionManager = __webpack_require__(195);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(330);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(196);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(136);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(194);

var _PathUtils = __webpack_require__(102);

var _createTransitionManager = __webpack_require__(195);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(330);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(703);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(197);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(102);

var _LocationUtils = __webpack_require__(194);

var _createTransitionManager = __webpack_require__(195);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(331);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(707)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(709);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(711);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(712);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(713);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(714);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(715);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(103);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(334);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(334);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(199);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(717);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(719);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(198);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(198);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(722);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(333);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(724);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(727);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 727 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 730 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(343);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(739);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(735)();
}


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(736);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Session__ = __webpack_require__(85);
var WhenRestored=function WhenRestored(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Session__["a" /* default */],{render:function render(_ref2){var isRestored=_ref2.isRestored;return isRestored?children:null;}});};/* harmony default export */ __webpack_exports__["a"] = (WhenRestored);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_routes_home_index__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterHome__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stylist__ = __webpack_require__(2);
var RouteHome=function RouteHome(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_stylist__["w" /* LayoutWithStandardHeader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_stylist__["w" /* LayoutWithStandardHeader */].Header,{homeRoute:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_stylist__["w" /* LayoutWithStandardHeader */].Main,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_3_routes_home_index__["a" /* default */],exact:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_stylist__["w" /* LayoutWithStandardHeader */].Footer,{dark:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_FooterHome__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (RouteHome);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookFVButton__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
var PullDownHeader=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ety2avz0',label:'PullDownHeader'})('margin:',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(2),' ',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(3),';',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["X" /* typography */])('title1'),';');var HeaderAvatarContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ety2avz1',label:'HeaderAvatarContainer'})('display:flex;margin-left:',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(4),';align-items:center;');var StyledMenuItem=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_stylist__["s" /* HeaderAvatar */].MenuItem,{target:'ety2avz2',label:'StyledMenuItem'})({name:'17aau39',styles:'&:hover{background:#d7ebff !important;}'});var AvatarMenu=function AvatarMenu(_ref){var first_name=_ref.first_name,last_name=_ref.last_name,email=_ref.email,is_admin=_ref.is_admin;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(HeaderAvatarContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_stylist__["s" /* HeaderAvatar */],{align:'right',hideUserName:true,firstName:first_name,lastName:last_name,email:email},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_stylist__["s" /* HeaderAvatar */].MenuSection,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PullDownHeader,null,email),is_admin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledMenuItem,{to:'/admin'},'Admin'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledMenuItem,{to:'/logout'},'Sign Out'))));};AvatarMenu.defaultProps={first_name:'',last_name:'',email:'',is_admin:false};var DesktopMenu=function DesktopMenu(_ref2){var isAuthenticated=_ref2.isAuthenticated,currentUser=_ref2.currentUser;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,isAuthenticated?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BookFVButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AvatarMenu,currentUser)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_stylist__["d" /* ButtonLink */],{to:'/login',kind:'ghost'},'Sign In'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BookFVButton__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (DesktopMenu);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(339);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var StyledExtBtnLink=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["n" /* ExternalButtonLink */],{target:'ewb19ld0',label:'StyledExtBtnLink'})({name:'f53ddv',styles:'margin-left:1rem;color:white !important;'});var BookFVButton=function BookFVButton(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledExtBtnLink,{kind:'primary',href:'https://book.focusvision.com'},'Book Project');};/* harmony default export */ __webpack_exports__["a"] = (BookFVButton);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_component_component__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HamburgerMenu__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
var MobileMenu=function MobileMenu(_ref){var isAuthenticated=_ref.isAuthenticated;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_component_component__["a" /* default */],{initialState:{open:false},render:function render(_ref2){var state=_ref2.state,setState=_ref2.setState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_stylist__["r" /* HamburgerIcon */],{fill:'lightBrandGreen',width:15,onClick:function onClick(){return setState({open:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HamburgerMenu__["a" /* default */],{onClose:function onClose(){return setState({open:false});},open:state.open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HamburgerMenu__["a" /* default */].Item,{href:'https://book.focusvision.com'},'Book Project'),isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HamburgerMenu__["a" /* default */].Item,{to:'/logout'},'Logout'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HamburgerMenu__["a" /* default */].Item,{to:'/login'},'Sign in'))));}});};/* harmony default export */ __webpack_exports__["a"] = (MobileMenu);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var ANIMATION_STAGGER_DELAY=50;var MenuBackdrop=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ev7jnyo0',label:'MenuBackdrop'})('position:fixed;top:0;right:0;left:0;bottom:0;overflow:hidden;background:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["O" /* color */])('white'),';max-height:',function(props){return props.open?'100%':'0';},';transition:max-height 350ms ease;z-index:3;');var MenuHeader=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('header',{target:'ev7jnyo1',label:'MenuHeader'})({name:'a0f667',styles:'display:flex;align-items:center;justify-content:space-between;height:70px;@supports (display:grid){display:grid;grid-template-columns:repeat(2,1fr);grid-template-rows:70px;height:auto;}'});var Dismiss=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["e" /* CancelIcon */],{target:'ev7jnyo2',label:'Dismiss'})({name:'fkkcpq',styles:'display:flex;justify-content:flex-end;transform:translateX(0.5rem);@supports (display:grid){display:block;justify-self:end;}'});var MenuLinkContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('ul',{target:'ev7jnyo3',label:'MenuLinkContainer'})('list-style:none;padding:0;margin:0;li{transform:',function(_ref){var open=_ref.open;return open?'none':'scale(1.1) translateY(-1.5rem)';},';transition:all 0.5s;opacity:',function(_ref2){var open=_ref2.open;return open?1:0;},';',function(_ref3){var children=_ref3.children;return[].concat(_toConsumableArray(Array(__WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children)).keys())).map(function(n){return'&:nth-child('+(n+1)+') {\n              transition-delay: '+(n+1)*ANIMATION_STAGGER_DELAY+'ms;\n            }';}).join('\n');},';}');var ItemContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('li',{target:'ev7jnyo4',label:'ItemContainer'})('border-bottom:1px solid ',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["O" /* color */])('silver'),';');var StyledA=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('a',{target:'ev7jnyo5',label:'StyledA'})('display:block;width:100%;padding:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(3),' 0;');var StyledLink=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{target:'ev7jnyo6',label:'StyledLink'})('display:block;width:100%;padding:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(3),' 0;');var Item=Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["Z" /* withTheme */])(function(_ref4){var children=_ref4.children,href=_ref4.href,theme=_ref4.theme,to=_ref4.to;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ItemContainer,null,href?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledA,{href:href},children):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLink,{to:to},children));});var HamburgerMenu=function HamburgerMenu(_ref5){var children=_ref5.children,onClose=_ref5.onClose,open=_ref5.open;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MenuBackdrop,{open:open},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["G" /* Row */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["g" /* Container */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MenuHeader,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{onClick:onClose,to:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["p" /* ForstaLogo */],{size:'sm'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Dismiss,{cursor:'pointer',width:30,height:30,onClick:onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MenuLinkContainer,{open:open},children))));};HamburgerMenu.Item=Item;/* harmony default export */ __webpack_exports__["a"] = (HamburgerMenu);

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PlatformSectionTitle__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PlatformNavLink__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_NavGrid__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Section__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StyledSection__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SectionByline__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SectionHeadline__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SectionIntro__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_fp__ = __webpack_require__(344);
var LearnMoreButtonContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'egyhd7i0',label:'LearnMoreButtonContainer'})('display:flex;justify-content:center;margin-top:',Object(__WEBPACK_IMPORTED_MODULE_10_stylist__["V" /* spacer */])(8),';',__WEBPACK_IMPORTED_MODULE_10_stylist__["H" /* SecondaryLink */],'{',Object(__WEBPACK_IMPORTED_MODULE_10_stylist__["X" /* typography */])('body3Medium'),';}');var RouteHomeIndex=function RouteHomeIndex(_ref){var path=_ref.match.path,theme=_ref.theme;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Section__["a" /* default */],{background:'ink'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_stylist__["g" /* Container */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_NavGrid__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_PlatformSectionTitle__["a" /* default */],null,'My Forsta'),__WEBPACK_IMPORTED_MODULE_11_config_platforms__["a" /* default */].filter(Object(__WEBPACK_IMPORTED_MODULE_12_utils_fp__["b" /* prop */])('displayOnHomepage')).map(function(platform){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_PlatformNavLink__["a" /* default */],{key:platform.id,platform:platform});})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_StyledSection__["a" /* default */],{background:'white'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_stylist__["g" /* Container */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_SectionIntro__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SectionHeadline__["a" /* default */],null,'Every challenge has a solution.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'It depends on your question.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SectionByline__["a" /* default */],null,'No matter your role, research can help your business.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LearnMoreButtonContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_stylist__["H" /* SecondaryLink */],{external:true,href:'https://www.forsta.com/solutions/'},'Explore Forsta solutions'))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_stylist__["Z" /* withTheme */])(RouteHomeIndex));

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var PlatformSectionTitle=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('h5',{target:'ezu54w80',label:'PlatformSectionTitle'})('flex-basis:100%;margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(4),';color:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])('white'),';text-transform:uppercase;@supports (display:grid){&{margin-bottom:0;grid-column:1 / -1;}}');/* harmony default export */ __webpack_exports__["a"] = (PlatformSectionTitle);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlatformLink__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icons_RightArrow__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultiServerPlatformNavLink__ = __webpack_require__(753);
var multiServerPlatforms=['revelation','vi','kinesis','decipher'];var Content=function Content(_ref){var platform=_ref.platform;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,platform.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icons_RightArrow__["a" /* default */],{stroke:'ink',width:21,height:14}));};var PlatformNavLink=function PlatformNavLink(_ref2){var platform=_ref2.platform;if(multiServerPlatforms.includes(platform.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MultiServerPlatformNavLink__["a" /* default */],{platform:platform},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{platform:platform}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PlatformLink__["a" /* default */],{href:platform.loginUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{platform:platform}));};/* harmony default export */ __webpack_exports__["a"] = (PlatformNavLink);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var SVG=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('svg',{target:'ef07nqp0',label:'SVG'})('stroke:',function(_ref){var stroke=_ref.stroke,theme=_ref.theme;return stroke&&Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["O" /* color */])(stroke,{theme:theme});},';fill:none;stroke-width:2;stroke-miterlimit:10;');var RightArrow=function RightArrow(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SVG,Object.assign({role:'img',viewBox:'0 0 63.2 37.4',width:'100%',height:'100%'},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('title',null,'arrow-right'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M49.3 36.8L62 18.1 49.3.6M62 18.1H0'}));};/* harmony default export */ __webpack_exports__["a"] = (RightArrow);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withSession__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_withCurrentUser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuthenticatedNavLink__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Container__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlatformLink__ = __webpack_require__(205);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var MultiServerPlatformNavLink=function MultiServerPlatformNavLink(_ref){var isAuthenticated=_ref.session.isAuthenticated,platform=_ref.platform,currentUser=_ref.currentUser,children=_ref.children,rest=_objectWithoutProperties(_ref,['session','platform','currentUser','children']);var servers=currentUser&&currentUser.userServers(platform.id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Container__["a" /* default */],null,isAuthenticated&&servers?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AuthenticatedNavLink__["a" /* default */],Object.assign({servers:servers,platform:platform,children:children},rest)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PlatformLink__["a" /* default */],{href:platform.loginUrl},children));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_components_withSession__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3_components_withCurrentUser__["a" /* default */])(MultiServerPlatformNavLink));

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlatformLink__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_normalizeHostname__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavLinkWithDropdown__ = __webpack_require__(755);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var buildLinkHref=function buildLinkHref(servers,platform){return servers.length===0?platform.homeUrl:Object(__WEBPACK_IMPORTED_MODULE_2_utils_normalizeHostname__["a" /* default */])(servers[0].hostname,platform.id);};var AuthenticatedNavLink=function AuthenticatedNavLink(_ref){var servers=_ref.servers,platform=_ref.platform,children=_ref.children,rest=_objectWithoutProperties(_ref,['servers','platform','children']);if(servers.length<2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PlatformLink__["a" /* default */],{href:buildLinkHref(servers,platform)},children);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NavLinkWithDropdown__["a" /* default */],Object.assign({children:children,platform:platform,servers:servers},rest));};/* harmony default export */ __webpack_exports__["a"] = (AuthenticatedNavLink);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_component_component__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServersDropdown__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Link__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputContainer__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LabelContainer__ = __webpack_require__(759);
var NavLinkWithDropdown=function NavLinkWithDropdown(_ref){var platform=_ref.platform,children=_ref.children,servers=_ref.servers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_component_component__["a" /* default */],{initialState:{showInput:false},render:function render(_ref2){var _ref2$state=_ref2.state,showInput=_ref2$state.showInput,redirectTo=_ref2$state.redirectTo,setState=_ref2.setState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Link__["a" /* default */],{showInput:showInput,onClick:function onClick(){return setState({showInput:true});}},children),redirectTo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Location__["a" /* default */],{to:redirectTo}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputContainer__["a" /* default */],{showInput:showInput},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LabelContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Server'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["e" /* CancelIcon */],{cursor:'pointer',onClick:function onClick(){return setState({showInput:false});},width:20,height:20})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ServersDropdown__["a" /* default */],{servers:servers,platform:platform,setState:setState})));}});};/* harmony default export */ __webpack_exports__["a"] = (NavLinkWithDropdown);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_normalizeHostname__ = __webpack_require__(207);
var ServersDropdown=function ServersDropdown(_ref){var servers=_ref.servers,platform=_ref.platform,setState=_ref.setState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,servers.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["m" /* Dropdown */],{name:platform.id,onChange:function onChange(redirectTo){return setState({redirectTo:redirectTo,showInput:false});}},servers.map(function(server){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["m" /* Dropdown */].Option,{key:server.hostname,value:Object(__WEBPACK_IMPORTED_MODULE_2_utils_normalizeHostname__["a" /* default */])(server.hostname,platform.id)},server.name||server.hostname);})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["m" /* Dropdown */],{name:platform.id,onChange:function onChange(redirectTo){return setState({redirectTo:redirectTo,showInput:false});}},platform.homeUrls.map(function(_ref2){var name=_ref2.name,url=_ref2.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["m" /* Dropdown */].Option,{key:url,value:url},name||url);})));};/* harmony default export */ __webpack_exports__["a"] = (ServersDropdown);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platformLinkStyles__ = __webpack_require__(206);
var _ref={name:'6lbx3u-Link',styles:'transform:rotateX(180deg);opacity:0;position:absolute;z-index:0;;label:Link;'};var Link=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1hl3yq00',label:'Link'})('cursor:pointer;transition:transform 0.15s;',__WEBPACK_IMPORTED_MODULE_2__platformLinkStyles__["b" /* link */],';',function(_ref2){var showInput=_ref2.showInput;return showInput&&_ref;},';');/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var _ref={name:'1cjspo5-InputContainer',styles:'opacity:0;position:absolute;transform:rotateX(180deg);z-index:-1;;label:InputContainer;'};var InputContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1oguf740',label:'InputContainer'})('display:flex;flex-direction:column;justify-content:space-between;width:100%;background:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["O" /* color */])('offWhite'),';transition:transform 0.15s;height:6rem;',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["U" /* padding */])('xs'),';',function(_ref2){var showInput=_ref2.showInput;return!showInput&&_ref;},';');/* harmony default export */ __webpack_exports__["a"] = (InputContainer);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
var LabelContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eg7xctf0',label:'LabelContainer'})({name:'1lx7vl3',styles:'display:flex;justify-content:space-between;align-items:center;label{margin-bottom:0;}'});/* harmony default export */ __webpack_exports__["a"] = (LabelContainer);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platformLinkStyles__ = __webpack_require__(206);
var Container=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1gyxqz00',label:'Container'})(__WEBPACK_IMPORTED_MODULE_1__platformLinkStyles__["a" /* container */],';');/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var NavGrid=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('nav',{target:'e1grxzhu0',label:'NavGrid'})('display:flex;flex-wrap:wrap;justify-content:space-between;@supports (display:grid){display:grid;grid-template-columns:repeat(3,1fr);grid-gap:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(4),' ',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(6),';',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["S" /* mediaDn */])('lg'),'{grid-template-columns:repeat(2,1fr);}',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["S" /* mediaDn */])('sm'),'{grid-template-columns:1fr;}}');/* harmony default export */ __webpack_exports__["a"] = (NavGrid);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var Section=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_stylist__["G" /* Row */],{target:'eggd6ls0',label:'Section'})('padding-top:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(7),';padding-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(7),';background:',function(_ref){var background=_ref.background,theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])(background,{theme:theme});},';');/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var StyledSection=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_stylist__["G" /* Row */],{target:'e1orrn7a0',label:'StyledSection'})('padding-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(7),';background:',function(_ref){var background=_ref.background,theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])(background,{theme:theme});},';');/* harmony default export */ __webpack_exports__["a"] = (StyledSection);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var SectionByline=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('h2',{target:'e1mc8rph0',label:'SectionByline'})('text-align:center;',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["P" /* fontSize */])('l'),';');/* harmony default export */ __webpack_exports__["a"] = (SectionByline);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var SectionHeadline=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('h1',{target:'e5uknxq0',label:'SectionHeadline'})('max-width:780px;margin-left:auto;margin-right:auto;margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["V" /* spacer */])(4),';text-align:center;',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["Q" /* fontWeight */])('bold'),';');/* harmony default export */ __webpack_exports__["a"] = (SectionHeadline);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
var SectionIntro=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eezrhn40',label:'SectionIntro'})({name:'1h2oojo',styles:'margin:7rem 0;'});/* harmony default export */ __webpack_exports__["a"] = (SectionIntro);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(fn){var curried=function curried(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}if(args.length>=fn.length){return fn.apply(undefined,args);}return function(){for(var _len2=arguments.length,args2=Array(_len2),_key2=0;_key2<_len2;_key2++){args2[_key2]=arguments[_key2];}return curried.apply(undefined,_toConsumableArray(args.concat(args2)));};};return curried;});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var FooterLink=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_stylist__["n" /* ExternalButtonLink */],{target:'e14a889j0',label:'FooterLink'})('color:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])('white'),';border-color:transparent;background-color:transparent;',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["X" /* typography */])('body1Medium'),';&:hover{color:',Object(__WEBPACK_IMPORTED_MODULE_1_stylist__["O" /* color */])('silver'),';}');/* harmony default export */ __webpack_exports__["a"] = (FooterLink);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppLogoLink__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_login_index__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_confirmation__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login_reset_password__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_routes_login_forgot_password__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login_redirecting__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_routes_login_set_token__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_withQueryParams__ = __webpack_require__(48);
var Main=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('main',{target:'e148k6v50',label:'Main'})({name:'twbtbs',styles:'display:flex;height:100vh;width:100%;justify-content:center;align-items:center;'});var Container=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e148k6v51',label:'Container'})({name:'1iw1s5d',styles:'width:30%;@media only screen and (max-width:820px){width:50%;}@media only screen and (max-width:620px){width:75%;}@media only screen and (max-width:450px){width:90%;}'});var RouteLogin=function RouteLogin(_ref){var path=_ref.match.path,search=_ref.location.search,query=_ref.query;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Main,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppLogoLink__["a" /* default */],{clientId:query.get('client_id')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path,component:__WEBPACK_IMPORTED_MODULE_4_routes_login_index__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/set-password',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{to:path+'/reset-password'});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/forgot-password',component:__WEBPACK_IMPORTED_MODULE_7_routes_login_forgot_password__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/confirmation',component:__WEBPACK_IMPORTED_MODULE_5__login_confirmation__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/reset-password',component:__WEBPACK_IMPORTED_MODULE_6__login_reset_password__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/set-password',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{to:{pathname:path+'/reset-password',search:search}});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/set-token',component:__WEBPACK_IMPORTED_MODULE_9_routes_login_set_token__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path+'/redirecting',component:__WEBPACK_IMPORTED_MODULE_8__login_redirecting__["a" /* default */]}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_components_withQueryParams__["a" /* default */])(RouteLogin));

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_fp__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_url__ = __webpack_require__(771);
var urlFor=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_utils_fp__["a" /* defaultTo */])('/'),Object(__WEBPACK_IMPORTED_MODULE_4_utils_fp__["b" /* prop */])('homeUrl'),Object(__WEBPACK_IMPORTED_MODULE_4_utils_fp__["a" /* defaultTo */])({}),__WEBPACK_IMPORTED_MODULE_3_config_platforms__["b" /* findPlatform */]);var AppLink=function AppLink(_ref){var clientId=_ref.clientId,children=_ref.children;var url=urlFor(clientId);return Object(__WEBPACK_IMPORTED_MODULE_5_utils_url__["a" /* isAbsoluteUrl */])(url)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url},children):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url},children);};/* harmony default export */ __webpack_exports__["a"] = (AppLink);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAbsoluteUrl; });
var ABSOLUTE_LINK=/^https?:\/\//;var isAbsoluteUrl=function isAbsoluteUrl(url){return ABSOLUTE_LINK.test(url);};

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var AppLogo=function AppLogo(_ref){var clientId=_ref.clientId,rest=_objectWithoutProperties(_ref,['clientId']);switch(clientId){case'decipher':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["I" /* SurveysLogo */],rest);case'kinesis':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["F" /* PanelManagementLogo */],rest);case'intervunow':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["l" /* DigitalInterviewsLogo */],rest);case'revelation':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["k" /* DigitalDiariesLogo */],rest);case'vi':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["N" /* VideoInsightsLogo */],rest);case'intervu2':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["l" /* DigitalInterviewsLogo */],rest);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["p" /* ForstaLogo */],rest);}};/* harmony default export */ __webpack_exports__["a"] = (AppLogo);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_component_component__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Session__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_urlForProvider__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_withCookieAcceptance__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LoginForm__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_AuthenticatedRedirect__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_auth__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(7);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var RouteLoginIndex=function RouteLoginIndex(_ref){var cookiesAccepted=_ref.cookiesAccepted,clearError=_ref.clearError,query=_ref.query,theme=_ref.theme,path=_ref.match.path,rest=_objectWithoutProperties(_ref,['cookiesAccepted','clearError','query','theme','match']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_component_component__["a" /* default */],{initialState:{matchedSsoProvider:null,uri2FA:null,redirectToSsoProvider:false},willUnmount:clearError,render:function render(_ref2){var _ref2$state=_ref2.state,matchedSsoProvider=_ref2$state.matchedSsoProvider,redirectToSsoProvider=_ref2$state.redirectToSsoProvider,_ref2$state$twoFAEnab=_ref2$state.twoFAEnabled,twoFAEnabled=_ref2$state$twoFAEnab===undefined?false:_ref2$state$twoFAEnab,uri2FA=_ref2$state.uri2FA,code=_ref2$state.code,setState=_ref2.setState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Session__["a" /* default */],{render:function render(_ref3){var hasFailedAuth=_ref3.hasFailedAuth,lastError=_ref3.lastError,isAuthenticated=_ref3.isAuthenticated;return matchedSsoProvider&&redirectToSsoProvider&&cookiesAccepted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Location__["a" /* default */],{to:Object(__WEBPACK_IMPORTED_MODULE_4_utils_urlForProvider__["a" /* default */])(matchedSsoProvider.id),replace:true}):isAuthenticated&&Object(__WEBPACK_IMPORTED_MODULE_13_utils_auth__["a" /* hasAuthorizationParams */])(query)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Location__["a" /* default */],{to:"https://api-qa.focusvision.com"+'/oauth/authorize?'+query,replace:true}):isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_AuthenticatedRedirect__["a" /* default */],{query:query}):hasFailedAuth&&lastError&&lastError.error==='unconfirmed_user'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["d" /* Redirect */],{to:path+'/confirmation',push:true}):hasFailedAuth&&lastError&&lastError.error==='password_expired'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["d" /* Redirect */],{to:path+'/reset-password?reset_password_token='+encodeURIComponent(lastError.reset_password_token)+'&email='+encodeURIComponent(lastError.email),push:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_LoginForm__["a" /* default */],Object.assign({query:query,matchedSsoProvider:matchedSsoProvider,uri2FA:uri2FA,setState:setState,code:code,path:path,twoFAEnabled:twoFAEnabled,cookiesAccepted:cookiesAccepted},rest));}});}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(null,{authenticate:__WEBPACK_IMPORTED_MODULE_10_redux_simple_auth__["authenticate"],clearError:__WEBPACK_IMPORTED_MODULE_10_redux_simple_auth__["clearError"]}),__WEBPACK_IMPORTED_MODULE_9_stylist__["Y" /* withNotifier */],__WEBPACK_IMPORTED_MODULE_5_components_withQueryParams__["a" /* default */],__WEBPACK_IMPORTED_MODULE_6_components_withCookieAcceptance__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9_stylist__["Z" /* withTheme */])(RouteLoginIndex)));

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SSOProviderButtons__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_FormLinks__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formik__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_sso__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_api__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TwoFactorSetup__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TwoFactorCode__ = __webpack_require__(955);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var StyledFormLinks=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6_components_FormLinks__["a" /* default */],{target:'e1y7itpg0',label:'StyledFormLinks'})('justify-content:left !important;margin-top:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(1),';');var _ref={name:'1ri5suz-GreyedFormGroup',styles:'opacity:0.5;filter:grayscale(100%);pointer-events:none;;label:GreyedFormGroup;'};var GreyedFormGroup=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,{target:'e1y7itpg1',label:'GreyedFormGroup'})(function(_ref2){var cookiesAccepted=_ref2.cookiesAccepted,matchedSsoProvider=_ref2.matchedSsoProvider;return cookiesAccepted&&matchedSsoProvider&&_ref;},';');var SSOFormGroup=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,{target:'e1y7itpg2',label:'SSOFormGroup'})('display:flex;flex-direction:row;align-items:center;justify-content:center;color:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["O" /* color */])('cadet'),';span{margin-left:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(2),';}');var ActionFormGroup=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,{target:'e1y7itpg3',label:'ActionFormGroup'})({name:'1a8j8t3',styles:'> div{margin-top:0;}'});/**
 * For the 2FA modal
 */var modalRoot=document.createElement('div');modalRoot.setAttribute('id','modal-root');document.body.appendChild(modalRoot);var ModalButton=function ModalButton(_ref3){var show=_ref3.show,rest=_objectWithoutProperties(_ref3,['show']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',Object.assign({onClick:function onClick(){return show();}},rest,{style:{color:'#a3cf62',display:'none'},id:'trigger-modal'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-pencil'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Edit'));};var StyledModalButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(ModalButton,{target:'e1y7itpg4',label:'StyledModalButton'})('cursor:pointer;margin-top:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["V" /* spacer */])(2),';padding:0;display:block;white-space:nowrap;');var ModalDialog=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["j" /* Dialog */],{target:'e1y7itpg5',label:'ModalDialog'})('width:50%;max-height:800px;padding:20px;',function(_ref4){var firstTime2FA=_ref4.firstTime2FA;return firstTime2FA&&'\n    @media only screen and (max-width: 1000px) {\n      max-height: 1500px;\n      margin: auto;\n    }\n  ';},' ',function(_ref5){var firstTime2FA=_ref5.firstTime2FA;return!firstTime2FA&&'\n    width: 35% !important;\n    @media only screen and (max-width: 900px) {\n      width: 55% !important;\n    }\n  ';},' @media only screen and (max-width:790px){width:100% !important;}');var ModalTitle=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["j" /* Dialog */].Title,{target:'e1y7itpg6',label:'ModalTitle'})('text-overflow:ellipsis;overflow:hidden;border-bottom:1px solid #f0eceb;',function(_ref6){var firstTime2FA=_ref6.firstTime2FA;return!firstTime2FA&&'\n    font-size: 1.2rem !important;\n  ';},' @media only screen and (max-width:1000px){font-size:0.8rem !important;}');var cookieError='Cookie policy must be accepted';var schema=__WEBPACK_IMPORTED_MODULE_3_yup___default.a.object().shape({email:__WEBPACK_IMPORTED_MODULE_3_yup___default.a.string().ensure().email('Email must be a valid email address').required("Email can't be blank"),password:__WEBPACK_IMPORTED_MODULE_3_yup___default.a.string().required("Password can't be blank"),cookiesAccepted:__WEBPACK_IMPORTED_MODULE_3_yup___default.a.boolean().test('is-accepted',cookieError,function(value){return value;})});var LoginForm=function LoginForm(_ref7){var query=_ref7.query,notify=_ref7.notify,matchedSsoProvider=_ref7.matchedSsoProvider,setState=_ref7.setState,authenticate=_ref7.authenticate,cookiesAccepted=_ref7.cookiesAccepted,highlightAcceptCookiesButton=_ref7.highlightAcceptCookiesButton,uri2FA=_ref7.uri2FA,twoFAEnabled=_ref7.twoFAEnabled,code=_ref7.code,history=_ref7.history,path=_ref7.path;var platform=Object(__WEBPACK_IMPORTED_MODULE_7_config_platforms__["b" /* findPlatform */])(query.get('client_id'))||{};var isVideoStreaming=platform.id==='VideoStreaming';var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),firstTime2FA=_useState2[0],setFirstTime2FA=_useState2[1];var mounted=true;var signupUrl='';// When a user signs up for Video Streaming product persist the state in the redirect_url param
if(platform.id==='VideoStreaming'){var redirectUriFromUrl=query.get('redirect_uri')||'';var stateFromUrl=query.get('state')||'';var fullRedirectUri=new URL(redirectUriFromUrl);fullRedirectUri.searchParams.set('state',stateFromUrl);signupUrl=platform.signupUrl+'&redirect_uri='+encodeURIComponent(fullRedirectUri.toString());}else{signupUrl=Object(__WEBPACK_IMPORTED_MODULE_9_utils__["a" /* isFunction */])(platform.signupUrl)&&platform.ssoSignUp?platform.signupUrl(window.location.search):platform.signupUrl;}Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(query.get('email')){check2FASecret(query.get('email'));}return function(){mounted=false;};},[]);var checkEmail=function checkEmail(value){checkSSOMatch(value);check2FASecret(value);};var checkSSOMatch=function checkSSOMatch(value){return Object(__WEBPACK_IMPORTED_MODULE_10_utils_sso__["a" /* getSSOForEmailInput */])(value,function(match){return mounted&&setState({matchedSsoProvider:match});});};var check2FASecret=function check2FASecret(value){Object(__WEBPACK_IMPORTED_MODULE_10_utils_sso__["b" /* getUriForEmailInput */])(value,function(responseBody){return mounted&&setState({twoFAEnabled:responseBody.two_fa_enabled});},function(){return mounted&&setState({twoFAEnabled:false});});};var twoFaLogin=function twoFaLogin(email,password,notify){Object(__WEBPACK_IMPORTED_MODULE_11_utils_api__["e" /* verifyValid2FA */])(email,password).then(function(res){var uri=res.uri,code=res.code,first_time_2fa=res.first_time_2fa;setState({uri2FA:uri,code:code});setFirstTime2FA(first_time_2fa);document.querySelector('#trigger-modal').click();}).catch(function(_ref8){var error=_ref8.error;if(error==='invalid_grant'){notify('warning','Email or password is incorrect');}else if(error==='unconfirmed_user'){notify('info','Account confirmation required');history.push(path+'/confirmation');}else if(error==='password_expired'){notify('info','Your password is expired, please reset.');history.push(path+'/reset-password?reset_password_token='+encodeURIComponent(error.reset_password_token)+'&email='+encodeURIComponent(error.email));}setState({uri2FA:'',code:''});});};var ModalTwoFA=function ModalTwoFA(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["C" /* ModalV2 */],{lazyRender:true,render:function render(_ref9){var hide=_ref9.hide;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ModalDialog,{firstTime2FA:firstTime2FA},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["j" /* Dialog */].Header,{onClose:function onClose(){return hide();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ModalTitle,{firstTime2FA:firstTime2FA},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["y" /* Lock */],{size:'xl',fill:'blue'}),' Two Factor Authentication Setup')),firstTime2FA?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TwoFactorSetup__["a" /* default */],{uri2FA:uri2FA,code:code,notify:notify,authenticate:authenticate,product:query.get('client_id')||'Forsta'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__TwoFactorCode__["a" /* default */],{notify:notify,authenticate:authenticate}));}},function(_ref10){var show=_ref10.show;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledModalButton,{show:show});});};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ModalTwoFA,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */],{initialValues:{email:query.get('email')||'',password:''},validate:function validate(values){var allValues=Object.assign({},values,{cookiesAccepted:cookiesAccepted});return schema.validate(allValues,{abortEarly:false}).then(function(){return{};}).catch(function(error){error.errors.find(function(a){return a===cookieError;})&&highlightAcceptCookiesButton(true);throw Object(__WEBPACK_IMPORTED_MODULE_8_formik__["a" /* yupToFormErrors */])(error);});},onSubmit:function onSubmit(_ref11){var email=_ref11.email,password=_ref11.password;if(!twoFAEnabled){authenticate('oauth2-password-grant',{email:email,password:password}).catch(function(_ref12){var error=_ref12.payload.error;if(error==='invalid_grant'){notify('warning','Email or password is incorrect');}else if(error==='unconfirmed_user'){notify('info','Account confirmation required');}else if(error==='password_expired'){notify('info','Your password is expired, please reset.');}});}else{twoFaLogin(email,password,notify);}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["f" /* Col */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Errors,null),isVideoStreaming&&platform.signupUrl&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{paddingBottom:'36px'}},'You will need an account to log in and view the session. If you do not have an account,',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["H" /* SecondaryLink */],{to:signupUrl},'create one here')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'email'},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Input,{id:'email',type:'email',name:'email',autoComplete:'off',onBlur:function onBlur(){return setState({redirectToSsoProvider:Boolean(matchedSsoProvider)});},onChange:function onChange(e){return checkEmail(e.target.value);}})),matchedSsoProvider?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSOFormGroup,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["z" /* LockIcon */],{size:'.8rem'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Single sign-on enabled')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'password'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Input,{id:'password',type:'password',name:'password',autoComplete:'off'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledFormLinks,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["H" /* SecondaryLink */],{to:'/login/forgot-password'},'Forgot Password'))),twoFAEnabled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ActionFormGroup,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].SubmitButton,{block:true},'Two-Factor Authentication')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ActionFormGroup,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].Errors,{name:'cookiesAccepted'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["o" /* Form */].SubmitButton,{block:true},matchedSsoProvider?'Continue':'Sign In')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GreyedFormGroup,{matchedSsoProvider:matchedSsoProvider,cookiesAccepted:cookiesAccepted},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SSOProviderButtons__["a" /* default */],{cookiesAccepted:cookiesAccepted,cookieError:cookieError}))),!isVideoStreaming&&platform.signupUrl&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Don\'t have an account?',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["H" /* SecondaryLink */],{to:signupUrl},'Sign Up')))));};/* harmony default export */ __webpack_exports__["a"] = (LoginForm);

/***/ }),
/* 775 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(779);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(780);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(210);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(782),
    ListCache = __webpack_require__(144),
    Map = __webpack_require__(212);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(783),
    hashDelete = __webpack_require__(788),
    hashGet = __webpack_require__(789),
    hashHas = __webpack_require__(790),
    hashSet = __webpack_require__(791);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(142);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(143),
    isMasked = __webpack_require__(785),
    isObject = __webpack_require__(55),
    toSource = __webpack_require__(350);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(786);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 787 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 788 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(142);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(142);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(142);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(145);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(145);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(145);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(145);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(146);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(146);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(146);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(146);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76),
    arrayMap = __webpack_require__(213),
    isArray = __webpack_require__(23),
    isSymbol = __webpack_require__(105);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(75),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(352);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(144);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 806 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 807 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(144),
    Map = __webpack_require__(212),
    MapCache = __webpack_require__(210);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keys = __webpack_require__(88);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 811 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(75),
    isLength = __webpack_require__(215),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(220),
    nativeKeys = __webpack_require__(815);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(357);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keysIn = __webpack_require__(358);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55),
    isPrototype = __webpack_require__(220),
    nativeKeysIn = __webpack_require__(818);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    getSymbols = __webpack_require__(223);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 821 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    getSymbolsIn = __webpack_require__(360);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(225),
    cloneDataView = __webpack_require__(828),
    cloneRegExp = __webpack_require__(829),
    cloneSymbol = __webpack_require__(830),
    cloneTypedArray = __webpack_require__(831);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(225);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 829 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(225);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(150),
    getPrototype = __webpack_require__(149),
    isPrototype = __webpack_require__(220);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(834),
    baseUnary = __webpack_require__(218),
    nodeUtil = __webpack_require__(219);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(109),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(836),
    baseUnary = __webpack_require__(218),
    nodeUtil = __webpack_require__(219);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(109),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76),
    copyArray = __webpack_require__(222),
    getTag = __webpack_require__(109),
    isArrayLike = __webpack_require__(221),
    isString = __webpack_require__(838),
    iteratorToArray = __webpack_require__(839),
    mapToArray = __webpack_require__(366),
    setToArray = __webpack_require__(367),
    stringToArray = __webpack_require__(368),
    values = __webpack_require__(842);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(75),
    isArray = __webpack_require__(23),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 840 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 841 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(843),
    keys = __webpack_require__(88);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(213);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _has = __webpack_require__(87);

var _has2 = _interopRequireDefault(_has);

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function callOrConcat(schema) {
  if (typeof schema === 'function') return schema;

  return function (base) {
    return base.concat(schema);
  };
}

var Conditional = function () {
  function Conditional(refs, options) {
    _classCallCheck(this, Conditional);

    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;


    this.refs = [].concat(refs);

    then = callOrConcat(then);
    otherwise = callOrConcat(otherwise);

    if (typeof options === 'function') this.fn = options;else {
      if (!(0, _has2.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');

      if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');

      var isFn = typeof is === 'function' ? is : function () {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }

        return values.every(function (value) {
          return value === is;
        });
      };

      this.fn = function () {
        for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          values[_key2] = arguments[_key2];
        }

        var currentSchema = values.pop();
        var option = isFn.apply(undefined, values) ? then : otherwise;

        return option(currentSchema);
      };
    }
  }

  Conditional.prototype.getValue = function getValue(parent, context) {
    var values = this.refs.map(function (r) {
      return r.getValue(parent, context);
    });

    return values;
  };

  Conditional.prototype.resolve = function resolve(ctx, values) {
    var schema = this.fn.apply(ctx, values.concat(ctx));

    if (schema !== undefined && !(0, _isSchema2.default)(schema)) throw new TypeError('conditions must return a schema object');

    return schema || ctx;
  };

  return Conditional;
}();

exports.default = Conditional;
module.exports = exports['default'];

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = merge;

var _has = __webpack_require__(87);

var _has2 = _interopRequireDefault(_has);

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function merge(target, source) {
  for (var key in source) {
    if ((0, _has2.default)(source, key)) {
      var targetVal = target[key],
          sourceVal = source[key];

      if (sourceVal === undefined) continue;

      if ((0, _isSchema2.default)(sourceVal)) {
        target[key] = (0, _isSchema2.default)(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
      } else if (isObject(sourceVal)) {
        target[key] = isObject(targetVal) ? merge(targetVal, sourceVal) : sourceVal;
      } else if (Array.isArray(sourceVal)) {
        target[key] = Array.isArray(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
      } else target[key] = source[key];
    }
  }return target;
}
module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createValidation;

var _mapValues = __webpack_require__(847);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _ValidationError = __webpack_require__(228);

var _ValidationError2 = _interopRequireDefault(_ValidationError);

var _Reference = __webpack_require__(111);

var _Reference2 = _interopRequireDefault(_Reference);

var _synchronousPromise = __webpack_require__(370);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var formatError = _ValidationError2.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error('Validation test of type: "' + ctx.type + '" returned a Promise during a synchronous validate. ' + 'This test will finish after the validate call has returned');
  }
  return _synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues2.default)(_extends({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = _objectWithoutProperties(_ref, ['value', 'label', 'resolve', 'originalValue']);

  return function createError() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$path = _ref2.path,
        path = _ref2$path === undefined ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === undefined ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? opts.name : _ref2$type,
        params = _ref2.params;

    params = _extends({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));

    return _extends(new _ValidationError2.default(formatError(message, params), value, path, type), { params: params });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;


  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = _objectWithoutProperties(_ref3, ['value', 'path', 'label', 'options', 'originalValue', 'sync']);

    var parent = options.parent;
    var resolve = function resolve(value) {
      return _Reference2.default.isRef(value) ? value.getValue(parent, options.context) : value;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });

    var ctx = _extends({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);

    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError2.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.TEST_NAME = name;
  validate.TEST_FN = test;
  validate.TEST = options;

  return validate;
}

module.exports.createErrorFactory = createErrorFactory;
module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(147),
    baseForOwn = __webpack_require__(229),
    baseIteratee = __webpack_require__(230);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(849);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 849 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(851),
    getMatchData = __webpack_require__(860),
    matchesStrictComparable = __webpack_require__(374);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(216),
    baseIsEqual = __webpack_require__(371);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(216),
    equalArrays = __webpack_require__(372),
    equalByTag = __webpack_require__(858),
    equalObjects = __webpack_require__(859),
    getTag = __webpack_require__(109),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(148),
    isTypedArray = __webpack_require__(217);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(210),
    setCacheAdd = __webpack_require__(854),
    setCacheHas = __webpack_require__(855);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 855 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 856 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 857 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76),
    Uint8Array = __webpack_require__(365),
    eq = __webpack_require__(211),
    equalArrays = __webpack_require__(372),
    mapToArray = __webpack_require__(366),
    setToArray = __webpack_require__(367);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(361);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(373),
    keys = __webpack_require__(88);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(371),
    get = __webpack_require__(862),
    hasIn = __webpack_require__(863),
    isKey = __webpack_require__(209),
    isStrictComparable = __webpack_require__(373),
    matchesStrictComparable = __webpack_require__(374),
    toKey = __webpack_require__(107);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(231);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(864),
    hasPath = __webpack_require__(348);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(866),
    basePropertyDeep = __webpack_require__(867),
    isKey = __webpack_require__(209),
    toKey = __webpack_require__(107);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(231);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _inherits = __webpack_require__(91);

var _inherits2 = _interopRequireDefault(_inherits);

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = BooleanSchema;


function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed2.default.call(this, { type: 'boolean' });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }
      return value;
    });
  });
}

(0, _inherits2.default)(BooleanSchema, _mixed2.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();

    return typeof v === 'boolean';
  }
});
module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = StringSchema;

var _inherits = __webpack_require__(91);

var _inherits2 = _interopRequireDefault(_inherits);

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

var _locale = __webpack_require__(90);

var _isAbsent = __webpack_require__(110);

var _isAbsent2 = _interopRequireDefault(_isAbsent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
var rUrl = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var hasLength = function hasLength(value) {
  return (0, _isAbsent2.default)(value) || value.length > 0;
};
var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent2.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed2.default.call(this, { type: 'string' });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits2.default)(StringSchema, _mixed2.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();

    return typeof value === 'string';
  },
  required: function required(msg) {
    var next = _mixed2.default.prototype.required.call(this, msg || _locale.mixed.required);

    return next.test('required', msg || _locale.mixed.required, hasLength);
  },
  length: function length(_length, msg) {
    return this.test({
      name: 'length',
      exclusive: true,
      message: msg || _locale.string.length,
      params: { length: _length },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, msg) {
    return this.test({
      name: 'min',
      exclusive: true,
      message: msg || _locale.string.min,
      params: { min: _min },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, msg) {
    return this.test({
      name: 'max',
      exclusive: true,
      message: msg || _locale.string.max,
      params: { max: _max },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var excludeEmptyString = false,
        message = void 0;

    if (options.message || options.hasOwnProperty('excludeEmptyString')) {
      excludeEmptyString = options.excludeEmptyString;
      message = options.message;
    } else message = options;

    return this.test({
      message: message || _locale.string.matches,
      params: { regex: regex },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(msg) {
    return this.matches(rEmail, {
      message: msg || _locale.string.email,
      excludeEmptyString: true
    });
  },
  url: function url(msg) {
    return this.matches(rUrl, {
      message: msg || _locale.string.url,
      excludeEmptyString: true
    });
  },


  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(msg) {
    msg = msg || _locale.string.trim;

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test('trim', msg, isTrimmed);
  },
  lowercase: function lowercase(msg) {
    return this.transform(function (value) {
      return !(0, _isAbsent2.default)(value) ? value.toLowerCase() : value;
    }).test({
      name: 'string_case',
      exclusive: true,
      message: msg || _locale.string.lowercase,
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(msg) {
    return this.transform(function (value) {
      return !(0, _isAbsent2.default)(value) ? value.toUpperCase() : value;
    }).test({
      name: 'string_case',
      exclusive: true,
      message: msg || _locale.string.uppercase,
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = __webpack_require__(91);

var _inherits2 = _interopRequireDefault(_inherits);

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

var _locale = __webpack_require__(90);

var _isAbsent = __webpack_require__(110);

var _isAbsent2 = _interopRequireDefault(_isAbsent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent2.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed2.default.call(this, { type: 'number' });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;

      var parsed = parseFloat(value);
      if (this.isType(parsed)) return parsed;

      return NaN;
    });
  });
}

(0, _inherits2.default)(NumberSchema, _mixed2.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();

    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, msg) {
    return this.test({
      name: 'min',
      exclusive: true,
      params: { min: _min },
      message: msg || _locale.number.min,
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, msg) {
    return this.test({
      name: 'max',
      exclusive: true,
      params: { max: _max },
      message: msg || _locale.number.max,
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, msg) {
    return this.test({
      name: 'max',
      exclusive: true,
      params: { less: less },
      message: msg || _locale.number.less,
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, msg) {
    return this.test({
      name: 'min',
      exclusive: true,
      params: { more: more },
      message: msg || _locale.number.more,
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    return this.min(0, msg || _locale.number.positive);
  },
  negative: function negative(msg) {
    return this.max(0, msg || _locale.number.negative);
  },
  integer: function integer(msg) {
    msg = msg || _locale.number.integer;

    return this.test('integer', msg, isInteger);
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent2.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round';

    // this exists for symemtry with the new Math.trunc
    if (method === 'trunc') return this.truncate();

    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));

    return this.transform(function (value) {
      return !(0, _isAbsent2.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

var _inherits = __webpack_require__(91);

var _inherits2 = _interopRequireDefault(_inherits);

var _isodate = __webpack_require__(872);

var _isodate2 = _interopRequireDefault(_isodate);

var _locale = __webpack_require__(90);

var _isAbsent = __webpack_require__(110);

var _isAbsent2 = _interopRequireDefault(_isAbsent);

var _Reference = __webpack_require__(111);

var _Reference2 = _interopRequireDefault(_Reference);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

exports.default = DateSchema;


function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed2.default.call(this, { type: 'date' });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return isDate(value) ? new Date(value) : value;

      value = (0, _isodate2.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits2.default)(DateSchema, _mixed2.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, msg) {
    var limit = _min;

    if (!_Reference2.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      name: 'min',
      exclusive: true,
      message: msg || _locale.date.min,
      params: { min: _min },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, msg) {
    var limit = _max;

    if (!_Reference2.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: msg || _locale.date.max,
      params: { max: _max },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports['default'];

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = parseIsoDate;
/**
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months
    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1;

    // allow arbitrary sub-second precision beyond milliseconds
    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0;

    // timestamps without timezone identifiers should be considered local time
    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];

        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}
module.exports = exports['default'];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['', '.', ''], ['', '.', '']);

exports.default = ObjectSchema;

var _has = __webpack_require__(87);

var _has2 = _interopRequireDefault(_has);

var _omit = __webpack_require__(874);

var _omit2 = _interopRequireDefault(_omit);

var _snakeCase2 = __webpack_require__(889);

var _snakeCase3 = _interopRequireDefault(_snakeCase2);

var _camelCase2 = __webpack_require__(898);

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _mapKeys = __webpack_require__(903);

var _mapKeys2 = _interopRequireDefault(_mapKeys);

var _transform = __webpack_require__(904);

var _transform2 = _interopRequireDefault(_transform);

var _propertyExpr = __webpack_require__(151);

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

var _locale = __webpack_require__(90);

var _sortFields = __webpack_require__(905);

var _sortFields2 = _interopRequireDefault(_sortFields);

var _sortByKeyOrder = __webpack_require__(907);

var _sortByKeyOrder2 = _interopRequireDefault(_sortByKeyOrder);

var _inherits = __webpack_require__(91);

var _inherits2 = _interopRequireDefault(_inherits);

var _makePath = __webpack_require__(379);

var _makePath2 = _interopRequireDefault(_makePath);

var _runValidations = __webpack_require__(227);

var _runValidations2 = _interopRequireDefault(_runValidations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed2.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      var dft = (0, _transform2.default)(this._nodes, function (obj, key) {
        obj[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      }, {});

      return Object.keys(dft).length === 0 ? undefined : dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];

  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }
      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits2.default)(ObjectSchema, _mixed2.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var value = _mixed2.default.prototype._cast.call(this, _value, options);

    //should ignore nulls here
    if (value === undefined) return this.default();

    if (!this._typeCheck(value)) return value;

    var fields = this.fields,
        strip = this._option('stripUnknown', options) === true,
        extra = Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }),
        props = this._nodes.concat(extra);

    var innerOptions = _extends({}, options, {
      parent: {}, // is filled during the transform below
      __validating: false
    });

    value = (0, _transform2.default)(props, function (obj, prop) {
      var field = fields[prop];
      var exists = (0, _has2.default)(value, prop);

      if (field) {
        var fieldValue = void 0;
        var strict = field._options && field._options.strict;

        // safe to mutate since this is fired in sequence
        innerOptions.path = (0, _makePath2.default)(_templateObject, options.path, prop);
        innerOptions.value = value[prop];

        field = field.resolve(innerOptions);

        if (field._strip === true) return;

        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) obj[prop] = fieldValue;
      } else if (exists && !strip) obj[prop] = value[prop];
    }, innerOptions.parent);

    return value;
  },
  _validate: function _validate(_value) {
    var _this4 = this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var endEarly = void 0,
        recursive = void 0;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;

    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);

    opts = _extends({}, opts, { __validating: true, originalValue: originalValue });

    return _mixed2.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath2.default)(_templateObject, opts.path, key);
        var field = _this4.fields[key];

        var innerOptions = _extends({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;

          if (field.validate) return field.validate(value[key], innerOptions);
        }

        return true;
      });

      return (0, _runValidations2.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder2.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed2.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields2.default)(next.fields, next._excludedEdges);

    return next;
  },
  shape: function shape(schema) {
    var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var next = this.clone(),
        fields = _extends(next.fields, schema);

    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];

      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + '-' + second;
      });

      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields2.default)(fields, next._excludedEdges);

    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, _propertyExpr.getter)(_from, true);

    return this.transform(function (obj) {
      var newObj = obj;

      if (obj == null) return obj;

      if ((0, _has2.default)(obj, _from)) {
        newObj = alias ? _extends({}, obj) : (0, _omit2.default)(obj, _from);
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown() {
    var noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.object.noUnknown;

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });

    if (noAllow) next._options.stripUnknown = true;

    return next;
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys2.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase3.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase3.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase3.default)(key).toUpperCase();
    });
  }
});
module.exports = exports['default'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(213),
    baseClone = __webpack_require__(352),
    baseUnset = __webpack_require__(875),
    castPath = __webpack_require__(141),
    copyObject = __webpack_require__(108),
    customOmitClone = __webpack_require__(878),
    flatRest = __webpack_require__(377),
    getAllKeysIn = __webpack_require__(363);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(141),
    last = __webpack_require__(876),
    parent = __webpack_require__(877),
    toKey = __webpack_require__(107);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 876 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(231),
    baseSlice = __webpack_require__(376);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(879);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(75),
    getPrototype = __webpack_require__(149),
    isObjectLike = __webpack_require__(50);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(881);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(224),
    isFlattenable = __webpack_require__(882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(76),
    isArguments = __webpack_require__(214),
    isArray = __webpack_require__(23);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(884);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 884 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(886),
    shortOut = __webpack_require__(888);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(887),
    defineProperty = __webpack_require__(355),
    identity = __webpack_require__(375);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 887 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(378);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),
/* 890 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(892),
    toString = __webpack_require__(106);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(893);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 893 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(895),
    hasUnicodeWord = __webpack_require__(896),
    toString = __webpack_require__(106),
    unicodeWords = __webpack_require__(897);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 895 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 896 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 897 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(899),
    createCompounder = __webpack_require__(378);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(106),
    upperFirst = __webpack_require__(900);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(901);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(902),
    hasUnicode = __webpack_require__(369),
    stringToArray = __webpack_require__(368),
    toString = __webpack_require__(106);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(376);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(147),
    baseForOwn = __webpack_require__(229),
    baseIteratee = __webpack_require__(230);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(353),
    baseCreate = __webpack_require__(150),
    baseForOwn = __webpack_require__(229),
    baseIteratee = __webpack_require__(230),
    getPrototype = __webpack_require__(149),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(148),
    isFunction = __webpack_require__(143),
    isObject = __webpack_require__(55),
    isTypedArray = __webpack_require__(217);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sortFields;

var _has = __webpack_require__(87);

var _has2 = _interopRequireDefault(_has);

var _toposort = __webpack_require__(906);

var _toposort2 = _interopRequireDefault(_toposort);

var _propertyExpr = __webpack_require__(151);

var _Reference = __webpack_require__(111);

var _Reference2 = _interopRequireDefault(_Reference);

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sortFields(fields) {
  var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, _propertyExpr.split)(depPath)[0];

    if (!~nodes.indexOf(node)) nodes.push(node);

    if (!~excludes.indexOf(key + '-' + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has2.default)(fields, key)) {
      var value = fields[key];

      if (!~nodes.indexOf(key)) nodes.push(key);

      if (_Reference2.default.isRef(value) && !value.isContext) addNode(value.path, key);else if ((0, _isSchema2.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }return _toposort2.default.array(nodes, edges).reverse();
}
module.exports = exports['default'];

/***/ }),
/* 906 */
/***/ (function(module, exports) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = exports = function(edges){
  return toposort(uniqueNodes(edges), edges)
}

exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, [])
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.indexOf(node) >= 0) {
      throw new Error('Cyclic dependency: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    // outgoing edges
    var outgoing = edges.filter(function(edge){
      return edge[0] === node
    })
    if (i = outgoing.length) {
      var preds = predecessors.concat(node)
      do {
        var child = outgoing[--i][1]
        visit(child, nodes.indexOf(child), preds)
      } while (i)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = []
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (res.indexOf(edge[0]) < 0) res.push(edge[0])
    if (res.indexOf(edge[1]) < 0) res.push(edge[1])
  }
  return res
}


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sortByKeyOrder;
function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });

  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
module.exports = exports["default"];

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['', '[', ']'], ['', '[', ']']);

var _typeName = __webpack_require__(909);

var _typeName2 = _interopRequireDefault(_typeName);

var _inherits = __webpack_require__(91);

var _inherits2 = _interopRequireDefault(_inherits);

var _isAbsent = __webpack_require__(110);

var _isAbsent2 = _interopRequireDefault(_isAbsent);

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

var _makePath = __webpack_require__(379);

var _makePath2 = _interopRequireDefault(_makePath);

var _mixed = __webpack_require__(74);

var _mixed2 = _interopRequireDefault(_mixed);

var _locale = __webpack_require__(90);

var _runValidations = __webpack_require__(227);

var _runValidations2 = _interopRequireDefault(_runValidations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var hasLength = function hasLength(value) {
  return !(0, _isAbsent2.default)(value) && value.length > 0;
};

exports.default = ArraySchema;


function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed2.default.call(this, { type: 'array' });

  // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"
  this._subType = undefined;

  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }

      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits2.default)(ArraySchema, _mixed2.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed2.default.prototype._cast.call(this, _value, _opts);

    //should ignore nulls here
    if (!this._typeCheck(value) || !this._subType) return value;

    return value.map(function (v) {
      return _this2._subType.cast(v, _opts);
    });
  },
  _validate: function _validate(_value) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;
    var endEarly = this._option('abortEarly', options);
    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;

    return _mixed2.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = value.map(function (item, idx) {
        var path = (0, _makePath2.default)(_templateObject, options.path, idx);

        // object._validate note for isStrict explanation
        var innerOptions = _extends({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });

        if (subType.validate) return subType.validate(item, innerOptions);

        return true;
      });

      return (0, _runValidations2.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  of: function of(schema) {
    var next = this.clone();

    if (schema !== false && !(0, _isSchema2.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _typeName2.default)(schema));

    next._subType = schema;

    return next;
  },
  required: function required(msg) {
    var next = _mixed2.default.prototype.required.call(this, msg || _locale.mixed.required);

    return next.test('required', msg || _locale.mixed.required, hasLength);
  },
  min: function min(_min, message) {
    message = message || _locale.array.min;

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: { min: _min },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || _locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: { max: _max },
      test: function test(value) {
        return (0, _isAbsent2.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    return this.default(function () {
      return [];
    }).transform(function (val) {
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };

    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  }
});
module.exports = exports['default'];

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * type-name - Just a reasonable typeof
 *
 * https://github.com/twada/type-name
 *
 * Copyright (c) 2014-2016 Takuto Wada
 * Licensed under the MIT license.
 *   https://github.com/twada/type-name/blob/master/LICENSE
 */


var toStr = Object.prototype.toString;

function funcName (f) {
    if (f.name) {
        return f.name;
    }
    var match = /^\s*function\s*([^\(]*)/im.exec(f.toString());
    return match ? match[1] : '';
}

function ctorName (obj) {
    var strName = toStr.call(obj).slice(8, -1);
    if ((strName === 'Object' || strName === 'Error') && obj.constructor) {
        return funcName(obj.constructor);
    }
    return strName;
}

function typeName (val) {
    var type;
    if (val === null) {
        return 'null';
    }
    type = typeof val;
    if (type === 'object') {
        return ctorName(val);
    }
    return type;
}

module.exports = typeName;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSchema = __webpack_require__(78);

var _isSchema2 = _interopRequireDefault(_isSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Lazy = function () {
  function Lazy(mapFn) {
    _classCallCheck(this, Lazy);

    this._resolve = function () {
      var schema = mapFn.apply(undefined, arguments);
      if (!(0, _isSchema2.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');

      return schema;
    };
  }

  Lazy.prototype.resolve = function resolve(_ref) {
    var value = _ref.value,
        rest = _objectWithoutProperties(_ref, ['value']);

    return this._resolve(value, rest);
  };

  Lazy.prototype.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  Lazy.prototype.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;

exports.default = Lazy;
module.exports = exports['default'];

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = reach;

var _propertyExpr = __webpack_require__(151);

var _has = __webpack_require__(87);

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function reach(obj, path, value, context) {
  var parent = void 0,
      lastPart = void 0;

  // if only one "value" arg then use it for both
  context = context || value;

  (0, _propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has2.default)(obj, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;

      obj = obj.resolve({ context: context, parent: parent, value: value })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error('Yup.reach cannot resolve an array item at index: ' + _part + ', in the path: ' + path + '. ' + 'because there is no value at that index. ');
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      obj = obj.resolve({ context: context, parent: parent, value: value });

      if (!(0, _has2.default)(obj, 'fields') || !(0, _has2.default)(obj.fields, part)) throw new Error('The schema does not contain the path: ' + path + '. ' + ('(failed at: ' + lastPart + ' which is a type: "' + obj._type + '") '));

      obj = obj.fields[part];

      parent = value;
      value = value && value[part];
      lastPart = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });

  if (obj) {
    obj = obj.resolve({ context: context, parent: parent, value: value });
  }

  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_GoogleLogo__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_GitLabLogo__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_urlForProvider__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stylist__ = __webpack_require__(2);
var GoogleButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6_stylist__["c" /* Button */],{target:'e1quls2h0',label:'GoogleButton'})('border:0 none;padding:0;background:',Object(__WEBPACK_IMPORTED_MODULE_6_stylist__["O" /* color */])('white'),';');/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function(_ref){var label=_ref.label,onError=_ref.onError,valid=_ref.valid;return{children: false?React.createElement(GitLabLogo,{width:'1.75rem'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_images_GoogleLogo__["a" /* default */],{alt:'Google'}),onClick:function onClick(e){e.preventDefault();if(valid){window.location.replace(Object(__WEBPACK_IMPORTED_MODULE_5__utils_urlForProvider__["a" /* default */])('google'));}else{onError();}}};})(GoogleButton));

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
var GoogleLogoSVG=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('svg',{target:'e1xbx6e60',label:'GoogleLogoSVG'})('height:',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(5),';width:',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(5),';');var GoogleLogo=function GoogleLogo(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GoogleLogoSVG,{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 48 48'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('title',null,'Google'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{fill:'#EA4335',d:'M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{fill:'#4285F4',d:'M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{fill:'#FBBC05',d:'M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{fill:'#34A853',d:'M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{fill:'none',d:'M0 0h48v48H0z'}));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default()(function(){return false;})(GoogleLogo));

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var GitLabLogo=function GitLabLogo(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 380 380"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title",null,"GitLab"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#e24329",d:"M282.83 170.73l-.27-.69-26.14-68.22a6.81 6.81 0 0 0-2.69-3.24 7 7 0 0 0-8 .43 7 7 0 0 0-2.32 3.52l-17.65 54H154.29l-17.65-54A6.86 6.86 0 0 0 134.32 99a7 7 0 0 0-8-.43 6.87 6.87 0 0 0-2.69 3.24L97.44 170l-.26.69a48.54 48.54 0 0 0 16.1 56.1l.09.07.24.17 39.82 29.82 19.7 14.91 12 9.06a8.07 8.07 0 0 0 9.76 0l12-9.06 19.7-14.91 40.06-30 .1-.08A48.56 48.56 0 0 0 282.83 170.73Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc6d26",d:"M282.83 170.73l-.27-.69a88.3 88.3 0 0 0-35.15 15.8L190 229.25c19.55 14.79 36.57 27.64 36.57 27.64l40.06-30 .1-.08A48.56 48.56 0 0 0 282.83 170.73Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc6d26",d:"M153.43 256.89l19.7 14.91 12 9.06a8.07 8.07 0 0 0 9.76 0l12-9.06 19.7-14.91S209.55 244 190 229.25C170.45 244 153.43 256.89 153.43 256.89Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc6d26",d:"M132.58 185.84A88.19 88.19 0 0 0 97.44 170l-.26.69a48.54 48.54 0 0 0 16.1 56.1l.09.07.24.17 39.82 29.82s17-12.85 36.57-27.64Z"}));};/* unused harmony default export */ var _unused_webpack_default_export = (GitLabLogo);

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(232);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(233);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_MicrosoftLogo__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_urlForProvider__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stylist__ = __webpack_require__(2);
var MicrosoftButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_stylist__["c" /* Button */],{target:'edc77qa0',label:'MicrosoftButton'})('border:0 none;padding:0;background:',Object(__WEBPACK_IMPORTED_MODULE_5_stylist__["O" /* color */])('white'),';');/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default()(function(_ref){var label=_ref.label,onError=_ref.onError,valid=_ref.valid;return{children:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_images_MicrosoftLogo__["a" /* default */],{alt:'Microsoft'}),onClick:function onClick(e){e.preventDefault();if(valid){window.location.replace(Object(__WEBPACK_IMPORTED_MODULE_4__utils_urlForProvider__["a" /* default */])('azure'));}else{onError();}}};})(MicrosoftButton));

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
var MicrosoftLogoSVG=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('svg',{target:'ejo2x7x0',label:'MicrosoftLogoSVG'})('height:',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(5),';width:',Object(__WEBPACK_IMPORTED_MODULE_3_stylist__["V" /* spacer */])(5),';');var MicrosoftLogo=function MicrosoftLogo(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MicrosoftLogoSVG,{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 440 440'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('title',null,'Microsoft'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{fill:'#F3F3F3',width:'439',height:'439'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{fill:'#F35325',x:'17',y:'17',width:'194',height:'194'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{fill:'#81BC06',x:'228',y:'17',width:'194',height:'194'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{fill:'#05A6F0',x:'17',y:'228',width:'194',height:'194'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{fill:'#FFBA08',x:'228',y:'228',width:'194',height:'194'}));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default()(function(){return false;})(MicrosoftLogo));

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Formik */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return yupToFormErrors; });
/* unused harmony export validateYupSchema */
/* unused harmony export Field */
/* unused harmony export Form */
/* unused harmony export withFormik */
/* unused harmony export move */
/* unused harmony export swap */
/* unused harmony export insert */
/* unused harmony export replace */
/* unused harmony export FieldArray */
/* unused harmony export getIn */
/* unused harmony export setIn */
/* unused harmony export setNestedObjectValues */
/* unused harmony export isFunction */
/* unused harmony export isObject */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isNaN */
/* unused harmony export isEmptyChildren */
/* unused harmony export isPromise */
/* unused harmony export getActiveElement */
/* unused harmony export FastField */
/* unused harmony export FormikProvider */
/* unused harmony export FormikConsumer */
/* unused harmony export connect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_context__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_topath__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_topath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_topath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_fast_compare__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_deepmerge__ = __webpack_require__(932);










var _a;
var FormikProvider = (_a = __WEBPACK_IMPORTED_MODULE_3_create_react_context___default()({}), _a.Provider), FormikConsumer = _a.Consumer;
function connect(Comp) {
    var C = function (props) { return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(FormikConsumer, null, function (formik) { return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Comp, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { formik: formik })); })); };
    C.WrappedComponent = Comp;
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Comp);
}

function getIn(obj, key, def, p) {
    if (p === void 0) { p = 0; }
    var path = __WEBPACK_IMPORTED_MODULE_5_lodash_topath___default()(key);
    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
    var res = {};
    var resVal = res;
    var i = 0;
    var pathArray = __WEBPACK_IMPORTED_MODULE_5_lodash_topath___default()(path);
    for (; i < pathArray.length - 1; i++) {
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (resVal[currentPath]) {
            resVal = resVal[currentPath];
        }
        else if (currentObj) {
            resVal = resVal[currentPath] = __WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep___default()(currentObj);
        }
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] =
                isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    }
    resVal[pathArray[i]] = value;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj, res);
}
function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) { visited = new WeakMap(); }
    if (response === void 0) { response = {}; }
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var k = _a[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true);
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        }
        else {
            response[k] = value;
        }
    }
    return response;
}
var isFunction = function (obj) {
    return typeof obj === 'function';
};
var isObject = function (obj) {
    return obj !== null && typeof obj === 'object';
};
var isInteger = function (obj) {
    return String(Math.floor(Number(obj))) === obj;
};
var isString = function (obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
var isNaN = function (obj) { return obj !== obj; };
var isEmptyChildren = function (children) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children) === 0;
};
var isPromise = function (value) {
    return isObject(value) && isFunction(value.then);
};
function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') {
        return null;
    }
    try {
        return doc.activeElement || doc.body;
    }
    catch (e) {
        return doc.body;
    }
}

var Formik = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Formik, _super);
    function Formik(props) {
        var _this = _super.call(this, props) || this;
        _this.hcCache = {};
        _this.hbCache = {};
        _this.registerField = function (name, fns) {
            _this.fields[name] = fns;
        };
        _this.unregisterField = function (name) {
            delete _this.fields[name];
        };
        _this.setErrors = function (errors) {
            _this.setState({ errors: errors });
        };
        _this.setTouched = function (touched) {
            _this.setState({ touched: touched }, function () {
                if (_this.props.validateOnBlur) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setValues = function (values) {
            _this.setState({ values: values }, function () {
                if (_this.props.validateOnChange) {
                    _this.runValidations(values);
                }
            });
        };
        _this.setStatus = function (status) {
            _this.setState({ status: status });
        };
        _this.setError = function (error) {
            if (false) {
                console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
            }
            _this.setState({ error: error });
        };
        _this.setSubmitting = function (isSubmitting) {
            _this.setState({ isSubmitting: isSubmitting });
        };
        _this.validateField = function (field) {
            _this.setState({ isValidating: true });
            _this.runSingleFieldLevelValidation(field, getIn(_this.state.values, field)).then(function (error) {
                if (!!error && _this.didMount) {
                    _this.setState({
                        errors: setIn(_this.state.errors, field, error),
                        isValidating: false,
                    });
                }
            });
        };
        _this.runSingleFieldLevelValidation = function (field, value) {
            return new Promise(function (resolve) { return resolve(_this.fields[field].validate(value)); });
        };
        _this.runValidationSchema = function (values) {
            return new Promise(function (resolve) {
                var validationSchema = _this.props.validationSchema;
                var schema = isFunction(validationSchema)
                    ? validationSchema()
                    : validationSchema;
                validateYupSchema(values, schema).then(function () {
                    resolve({});
                }, function (err) {
                    resolve(yupToFormErrors(err));
                });
            });
        };
        _this.runValidations = function (values) {
            if (values === void 0) { values = _this.state.values; }
            _this.setState({ isValidating: true });
            return Promise.all([
                _this.runFieldLevelValidations(values),
                _this.props.validationSchema ? _this.runValidationSchema(values) : {},
                _this.props.validate ? _this.runValidateHandler(values) : {},
            ]).then(function (_a) {
                var fieldErrors = _a[0], schemaErrors = _a[1], handlerErrors = _a[2];
                var combinedErrors = __WEBPACK_IMPORTED_MODULE_8_deepmerge__["a" /* default */].all([
                    fieldErrors,
                    schemaErrors,
                    handlerErrors,
                ]);
                if (_this.didMount) {
                    _this.setState({ isValidating: false, errors: combinedErrors });
                }
                return combinedErrors;
            });
        };
        _this.handleChange = function (eventOrPath) {
            var executeChange = function (eventOrTextValue, maybePath) {
                var field = maybePath;
                var val = eventOrTextValue;
                var parsed;
                if (!isString(eventOrTextValue)) {
                    if (eventOrTextValue.persist) {
                        eventOrTextValue.persist();
                    }
                    var _a = eventOrTextValue.target, type = _a.type, name_1 = _a.name, id = _a.id, value = _a.value, checked = _a.checked, outerHTML = _a.outerHTML;
                    field = maybePath ? maybePath : name_1 ? name_1 : id;
                    if (!field && "production" !== 'production') {
                        warnAboutMissingIdentifier({
                            htmlContent: outerHTML,
                            documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
                            handlerName: 'handleChange',
                        });
                    }
                    val = /number|range/.test(type)
                        ? ((parsed = parseFloat(value)), isNaN(parsed) ? '' : parsed)
                        : /checkbox/.test(type) ? checked : value;
                }
                if (field) {
                    _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { values: setIn(prevState.values, field, val) })); });
                    if (_this.props.validateOnChange) {
                        _this.runValidations(setIn(_this.state.values, field, val));
                    }
                }
            };
            if (isString(eventOrPath)) {
                return isFunction(_this.hcCache[eventOrPath])
                    ? _this.hcCache[eventOrPath]
                    : (_this.hcCache[eventOrPath] = function (event) {
                        return executeChange(event, eventOrPath);
                    });
            }
            else {
                executeChange(eventOrPath);
            }
        };
        _this.setFieldValue = function (field, value, shouldValidate) {
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { values: setIn(prevState.values, field, value) })); }, function () {
                if (_this.props.validateOnChange && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.handleSubmit = function (e) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            if (false) {
                var activeElement = getActiveElement();
                if (activeElement !== null &&
                    activeElement instanceof HTMLButtonElement) {
                    warning(!!(activeElement.attributes &&
                        activeElement.attributes.getNamedItem('type')), 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.');
                }
            }
            _this.submitForm();
        };
        _this.submitForm = function () {
            _this.setState(function (prevState) { return ({
                touched: setNestedObjectValues(prevState.values, true),
                isSubmitting: true,
                submitCount: prevState.submitCount + 1,
            }); });
            return _this.runValidations().then(function (combinedErrors) {
                var isValid = Object.keys(combinedErrors).length === 0;
                if (isValid) {
                    _this.executeSubmit();
                }
                else {
                    _this.setState({ isSubmitting: false });
                }
            });
        };
        _this.executeSubmit = function () {
            _this.props.onSubmit(_this.state.values, _this.getFormikActions());
        };
        _this.handleBlur = function (eventOrString) {
            var executeBlur = function (e, path) {
                if (e.persist) {
                    e.persist();
                }
                var _a = e.target, name = _a.name, id = _a.id, outerHTML = _a.outerHTML;
                var field = path ? path : name ? name : id;
                if (!field && "production" !== 'production') {
                    warnAboutMissingIdentifier({
                        htmlContent: outerHTML,
                        documentationAnchorLink: 'handleblur-e-any--void',
                        handlerName: 'handleBlur',
                    });
                }
                _this.setState(function (prevState) { return ({
                    touched: setIn(prevState.touched, field, true),
                }); });
                if (_this.props.validateOnBlur) {
                    _this.runValidations(_this.state.values);
                }
            };
            if (isString(eventOrString)) {
                return isFunction(_this.hbCache[eventOrString])
                    ? _this.hbCache[eventOrString]
                    : (_this.hbCache[eventOrString] = function (event) {
                        return executeBlur(event, eventOrString);
                    });
            }
            else {
                executeBlur(eventOrString);
            }
        };
        _this.setFieldTouched = function (field, touched, shouldValidate) {
            if (touched === void 0) { touched = true; }
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { touched: setIn(prevState.touched, field, touched) })); }, function () {
                if (_this.props.validateOnBlur && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setFieldError = function (field, message) {
            _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { errors: setIn(prevState.errors, field, message) })); });
        };
        _this.resetForm = function (nextValues) {
            var values = nextValues ? nextValues : _this.props.initialValues;
            _this.initialValues = values;
            _this.setState({
                isSubmitting: false,
                isValidating: false,
                errors: {},
                touched: {},
                error: undefined,
                status: undefined,
                values: values,
                submitCount: 0,
            });
        };
        _this.handleReset = function () {
            if (_this.props.onReset) {
                var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());
                if (isPromise(maybePromisedOnReset)) {
                    maybePromisedOnReset.then(_this.resetForm);
                }
                else {
                    _this.resetForm();
                }
            }
            else {
                _this.resetForm();
            }
        };
        _this.setFormikState = function (s, callback) {
            return _this.setState(s, callback);
        };
        _this.getFormikActions = function () {
            return {
                resetForm: _this.resetForm,
                submitForm: _this.submitForm,
                validateForm: _this.runValidations,
                validateField: _this.validateField,
                setError: _this.setError,
                setErrors: _this.setErrors,
                setFieldError: _this.setFieldError,
                setFieldTouched: _this.setFieldTouched,
                setFieldValue: _this.setFieldValue,
                setStatus: _this.setStatus,
                setSubmitting: _this.setSubmitting,
                setTouched: _this.setTouched,
                setValues: _this.setValues,
                setFormikState: _this.setFormikState,
            };
        };
        _this.getFormikComputedProps = function () {
            var isInitialValid = _this.props.isInitialValid;
            var dirty = !__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(_this.initialValues, _this.state.values);
            return {
                dirty: dirty,
                isValid: dirty
                    ? _this.state.errors && Object.keys(_this.state.errors).length === 0
                    : isInitialValid !== false && isFunction(isInitialValid)
                        ? isInitialValid(_this.props)
                        : isInitialValid,
                initialValues: _this.initialValues,
            };
        };
        _this.getFormikBag = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), { registerField: _this.registerField, unregisterField: _this.unregisterField, handleBlur: _this.handleBlur, handleChange: _this.handleChange, handleReset: _this.handleReset, handleSubmit: _this.handleSubmit, validateOnChange: _this.props.validateOnChange, validateOnBlur: _this.props.validateOnBlur });
        };
        _this.getFormikContext = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.getFormikBag(), { validationSchema: _this.props.validationSchema, validate: _this.props.validate });
        };
        _this.state = {
            values: props.initialValues || {},
            errors: {},
            touched: {},
            isSubmitting: false,
            isValidating: false,
            submitCount: 0,
        };
        _this.didMount = false;
        _this.fields = {};
        _this.initialValues = props.initialValues || {};
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.component && props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.component && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.render && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
        return _this;
    }
    Formik.prototype.componentDidMount = function () {
        this.didMount = true;
    };
    Formik.prototype.componentWillUnmount = function () {
        this.didMount = false;
    };
    Formik.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.enableReinitialize &&
            !__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(prevProps.initialValues, this.props.initialValues)) {
            this.initialValues = this.props.initialValues;
            this.resetForm(this.props.initialValues);
        }
    };
    Formik.prototype.runFieldLevelValidations = function (values) {
        var _this = this;
        var fieldKeysWithValidation = Object.keys(this.fields).filter(function (f) {
            return _this.fields &&
                _this.fields[f] &&
                _this.fields[f].validate &&
                isFunction(_this.fields[f].validate);
        });
        var fieldValidations = fieldKeysWithValidation.length > 0
            ? fieldKeysWithValidation.map(function (f) {
                return _this.runSingleFieldLevelValidation(f, getIn(values, f)).then(function (x) { return x; }, function (e) { return e; });
            })
            : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')];
        return Promise.all(fieldValidations).then(function (fieldErrorsList) {
            return fieldErrorsList.reduce(function (prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
                    return prev;
                }
                if (!!curr) {
                    prev = setIn(prev, fieldKeysWithValidation[index], curr);
                }
                return prev;
            }, {});
        });
    };
    Formik.prototype.runValidateHandler = function (values) {
        var _this = this;
        return new Promise(function (resolve) {
            var maybePromisedErrors = _this.props.validate(values);
            if (maybePromisedErrors === undefined) {
                resolve({});
            }
            else if (isPromise(maybePromisedErrors)) {
                maybePromisedErrors.then(function () {
                    resolve({});
                }, function (errors) {
                    resolve(errors);
                });
            }
            else {
                resolve(maybePromisedErrors);
            }
        });
    };
    Formik.prototype.render = function () {
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children;
        var props = this.getFormikBag();
        var ctx = this.getFormikContext();
        return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(FormikProvider, { value: ctx }, component
            ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children)
                            ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children)
                            : null
                    : null));
    };
    Formik.defaultProps = {
        validateOnChange: true,
        validateOnBlur: true,
        isInitialValid: false,
        enableReinitialize: false,
    };
    return Formik;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
function warnAboutMissingIdentifier(_a) {
    var htmlContent = _a.htmlContent, documentationAnchorLink = _a.documentationAnchorLink, handlerName = _a.handlerName;
    console.error("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
    var errors = {};
    for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
        var err = _a[_i];
        if (!errors[err.path]) {
            errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) { sync = false; }
    if (context === void 0) { context = {}; }
    var validateData = {};
    for (var k in values) {
        if (values.hasOwnProperty(k)) {
            var key = String(k);
            validateData[key] = values[key] !== '' ? values[key] : undefined;
        }
    }
    return schema[sync ? 'validateSync' : 'validate'](validateData, {
        abortEarly: false,
        context: context,
    });
}

var FieldInner = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FieldInner, _super);
    function FieldInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var _a = _this.props.formik, handleChange = _a.handleChange, validateOnChange = _a.validateOnChange;
            handleChange(e);
            if (!!validateOnChange && !!_this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.handleBlur = function (e) {
            var _a = _this.props.formik, handleBlur = _a.handleBlur, validateOnBlur = _a.validateOnBlur;
            handleBlur(e);
            if (!!validateOnBlur && !!_this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.runFieldValidations = function (value) {
            var setFieldError = _this.props.formik.setFieldError;
            var _a = _this.props, name = _a.name, validate = _a.validate;
            var maybePromise = validate(value);
            if (isPromise(maybePromise)) {
                maybePromise.then(function () { return setFieldError(name, undefined); }, function (error) { return setFieldError(name, error); });
            }
            else {
                setFieldError(name, maybePromise);
            }
        };
        var render = props.render, children = props.children, component = props.component, formik = props.formik;
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(component && children && isFunction(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored');
        formik.registerField(props.name, {
            validate: props.validate,
        });
        return _this;
    }
    FieldInner.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
        if (this.props.validate !== prevProps.validate) {
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
    };
    FieldInner.prototype.componentWillUnmount = function () {
        this.props.formik.unregisterField(this.props.name);
    };
    FieldInner.prototype.render = function () {
        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, formik = _a.formik, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(_a, ["validate", "name", "render", "children", "component", "formik"]);
        var _validate = formik.validate, _validationSchema = formik.validationSchema, restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(formik, ["validate", "validationSchema"]);
        var field = {
            value: props.type === 'radio' || props.type === 'checkbox'
                ? props.value
                : getIn(formik.values, name),
            name: name,
            onChange: validate ? this.handleChange : formik.handleChange,
            onBlur: validate ? this.handleBlur : formik.handleBlur,
        };
        var bag = { field: field, form: restOfFormik };
        if (render) {
            return render(bag);
        }
        if (isFunction(children)) {
            return children(bag);
        }
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(props, ["innerRef"]);
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: innerRef }, field, rest, { children: children }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, bag, props, { children: children }));
    };
    return FieldInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var Field = connect(FieldInner);

var Form = connect(function (_a) {
    var handleSubmit = _a.formik.handleSubmit, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(_a, ["formik"]);
    return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("form", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ onSubmit: handleSubmit }, props)));
});
Form.displayName = 'Form';

function withFormik(_a) {
    var _b = _a.mapPropsToValues, mapPropsToValues = _b === void 0 ? function (vanillaProps) {
        var val = {};
        for (var k in vanillaProps) {
            if (vanillaProps.hasOwnProperty(k) &&
                typeof vanillaProps[k] !== 'function') {
                val[k] = vanillaProps[k];
            }
        }
        return val;
    } : _b, config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(_a, ["mapPropsToValues"]);
    return function createFormik(Component$$1) {
        var componentDisplayName = Component$$1.displayName ||
            Component$$1.name ||
            (Component$$1.constructor && Component$$1.constructor.name) ||
            'Component';
        var C = (function (_super) {
            Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(C, _super);
            function C() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.validate = function (values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function () {
                    return isFunction(config.validationSchema)
                        ? config.validationSchema(_this.props)
                        : config.validationSchema;
                };
                _this.handleSubmit = function (values, actions) {
                    return config.handleSubmit(values, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, actions, { props: _this.props }));
                };
                _this.renderFormComponent = function (formikProps) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Component$$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props, formikProps));
                };
                return _this;
            }
            C.prototype.render = function () {
                return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Formik, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, config, { validate: config.validate && this.validate, validationSchema: config.validationSchema && this.validationSchema, initialValues: mapPropsToValues(this.props), onSubmit: this.handleSubmit, render: this.renderFormComponent })));
            };
            C.displayName = "WithFormik(" + componentDisplayName + ")";
            return C;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
        return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component$$1);
    };
}

var move = function (array, from, to) {
    var copy = (array || []).slice();
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function (array, indexA, indexB) {
    var copy = (array || []).slice();
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function (array, index, value) {
    var copy = (array || []).slice();
    copy.splice(index, 0, value);
    return copy;
};
var replace = function (array, index, value) {
    var copy = (array || []).slice();
    copy[index] = value;
    return copy;
};
var FieldArrayInner = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FieldArrayInner, _super);
    function FieldArrayInner(props) {
        var _this = _super.call(this, props) || this;
        _this.updateArrayField = function (fn, alterTouched, alterErrors) {
            var _a = _this.props, name = _a.name, validateOnChange = _a.validateOnChange, _b = _a.formik, setFormikState = _b.setFormikState, validateForm = _b.validateForm, values = _b.values, touched = _b.touched, errors = _b.errors;
            setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { values: setIn(prevState.values, name, fn(getIn(values, name))), errors: alterErrors
                    ? setIn(prevState.errors, name, fn(getIn(errors, name)))
                    : prevState.errors, touched: alterTouched
                    ? setIn(prevState.touched, name, fn(getIn(touched, name)))
                    : prevState.touched })); }, function () {
                if (validateOnChange) {
                    validateForm();
                }
            });
        };
        _this.push = function (value) {
            return _this.updateArrayField(function (array) { return (array || []).concat([value]); }, false, false);
        };
        _this.handlePush = function (value) { return function () { return _this.push(value); }; };
        _this.swap = function (indexA, indexB) {
            return _this.updateArrayField(function (array) { return swap(array, indexA, indexB); }, false, false);
        };
        _this.handleSwap = function (indexA, indexB) { return function () {
            return _this.swap(indexA, indexB);
        }; };
        _this.move = function (from, to) {
            return _this.updateArrayField(function (array) { return move(array, from, to); }, false, false);
        };
        _this.handleMove = function (from, to) { return function () { return _this.move(from, to); }; };
        _this.insert = function (index, value) {
            return _this.updateArrayField(function (array) { return insert(array, index, value); }, false, false);
        };
        _this.handleInsert = function (index, value) { return function () { return _this.insert(index, value); }; };
        _this.replace = function (index, value) {
            return _this.updateArrayField(function (array) { return replace(array, index, value); }, false, false);
        };
        _this.handleReplace = function (index, value) { return function () {
            return _this.replace(index, value);
        }; };
        _this.unshift = function (value) {
            var arr = [];
            _this.updateArrayField(function (array) {
                arr = array ? [value].concat(array) : [value];
                return arr;
            }, false, false);
            return arr.length;
        };
        _this.handleUnshift = function (value) { return function () { return _this.unshift(value); }; };
        _this.handleRemove = function (index) { return function () { return _this.remove(index); }; };
        _this.handlePop = function () { return function () { return _this.pop(); }; };
        _this.remove = _this.remove.bind(_this);
        _this.pop = _this.pop.bind(_this);
        return _this;
    }
    FieldArrayInner.prototype.remove = function (index) {
        var result;
        this.updateArrayField(function (array) {
            var copy = array ? array.slice() : [];
            if (!result) {
                result = copy[index];
            }
            if (isFunction(copy.splice)) {
                copy.splice(index, 1);
            }
            return copy;
        }, true, true);
        return result;
    };
    FieldArrayInner.prototype.pop = function () {
        var result;
        this.updateArrayField(function (array) {
            var tmp = array;
            if (!result) {
                result = tmp && tmp.pop && tmp.pop();
            }
            return tmp;
        }, true, true);
        return result;
    };
    FieldArrayInner.prototype.render = function () {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove,
        };
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children, name = _a.name, _b = _a.formik, _validate = _b.validate, _validationSchema = _b.validationSchema, restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(_b, ["validate", "validationSchema"]);
        var props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, arrayHelpers, { form: restOfFormik, name: name });
        return component
            ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children) : null
                    : null;
    };
    FieldArrayInner.defaultProps = {
        validateOnChange: true,
    };
    return FieldArrayInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var FieldArray = connect(FieldArrayInner);

function isEqualExceptForKey(a, b, path) {
    return __WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(setIn(a, path, undefined), setIn(b, path, undefined));
}
var FastFieldInner = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FastFieldInner, _super);
    function FastFieldInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            e.persist();
            var _a = _this.props.formik, validateOnChange = _a.validateOnChange, validate = _a.validate, values = _a.values, validationSchema = _a.validationSchema, errors = _a.errors, setFormikState = _a.setFormikState;
            var _b = e.target, type = _b.type, value = _b.value, checked = _b.checked;
            var val = /number|range/.test(type)
                ? parseFloat(value)
                : /checkbox/.test(type) ? checked : value;
            if (validateOnChange) {
                if (_this.props.validate) {
                    var maybePromise = _this.props.validate(value);
                    if (isPromise(maybePromise)) {
                        _this.setState({ value: val });
                        maybePromise.then(function () { return _this.setState({ error: undefined }); }, function (error) { return _this.setState({ error: error }); });
                    }
                    else {
                        _this.setState({ value: val, error: maybePromise });
                    }
                }
                else if (validate) {
                    var maybePromise_1 = validate(setIn(values, _this.props.name, val));
                    if (isPromise(maybePromise_1)) {
                        _this.setState({ value: val });
                        maybePromise_1.then(function () { return _this.setState({ error: undefined }); }, function (error) {
                            if (isEqualExceptForKey(maybePromise_1, errors, _this.props.name)) {
                                _this.setState({ error: getIn(error, _this.props.name) });
                            }
                            else {
                                setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { errors: error })); });
                            }
                        });
                    }
                    else {
                        if (isEqualExceptForKey(maybePromise_1, errors, _this.props.name)) {
                            _this.setState({
                                value: val,
                                error: getIn(maybePromise_1, _this.props.name),
                            });
                        }
                        else {
                            _this.setState({
                                value: val,
                            });
                            setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { errors: maybePromise_1 })); });
                        }
                    }
                }
                else if (validationSchema) {
                    var schema = isFunction(validationSchema)
                        ? validationSchema()
                        : validationSchema;
                    var mergedValues = setIn(values, _this.props.name, val);
                    try {
                        validateYupSchema(mergedValues, schema, true);
                        _this.setState({
                            value: val,
                            error: undefined,
                        });
                    }
                    catch (e) {
                        if (e.name === 'ValidationError') {
                            _this.setState({
                                value: val,
                                error: getIn(yupToFormErrors(e), _this.props.name),
                            });
                        }
                        else {
                            _this.setState({
                                value: val,
                            });
                            validateYupSchema(mergedValues, schema).then(function () { return _this.setState({ error: undefined }); }, function (err) {
                                return _this.setState(function (s) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, s, { error: getIn(yupToFormErrors(err), _this.props.name) })); });
                            });
                        }
                    }
                }
                else {
                    _this.setState({ value: val });
                }
            }
            else {
                _this.setState({ value: val });
            }
        };
        _this.handleBlur = function () {
            var _a = _this.props.formik, validateOnBlur = _a.validateOnBlur, setFormikState = _a.setFormikState;
            var _b = _this.props, name = _b.name, validate = _b.validate;
            if (validateOnBlur && validate) {
                var maybePromise_2 = validate(_this.state.value);
                if (isPromise(maybePromise_2)) {
                    maybePromise_2.then(function () {
                        return setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, undefined), touched: setIn(prevState.touched, name, true) })); });
                    }, function (error) {
                        return setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, error), touched: setIn(prevState.touched, name, true) })); });
                    });
                }
                else {
                    setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, maybePromise_2), touched: setIn(prevState.touched, name, true) })); });
                }
            }
            else {
                setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState, { errors: setIn(prevState.errors, name, _this.state.error), values: setIn(prevState.values, name, _this.state.value), touched: setIn(prevState.touched, name, true) })); });
            }
        };
        _this.state = {
            value: getIn(props.formik.values, props.name),
            error: getIn(props.formik.errors, props.name),
        };
        var render = props.render, children = props.children, component = props.component, formik = props.formik;
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(component && render), 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.component && children && isFunction(children)), 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(render && children && !isEmptyChildren(children)), 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored');
        formik.registerField(props.name, {
            validate: props.validate,
        });
        return _this;
    }
    FastFieldInner.prototype.componentDidUpdate = function (prevProps, _state) {
        var nextFieldValue = getIn(this.props.formik.values, this.props.name);
        var nextFieldError = getIn(this.props.formik.errors, this.props.name);
        var prevFieldValue = getIn(prevProps.formik.values, prevProps.name);
        var prevFieldError = getIn(prevProps.formik.errors, prevProps.name);
        if (!__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(nextFieldValue, prevFieldValue)) {
            this.setState({ value: nextFieldValue });
        }
        if (!__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(nextFieldError, prevFieldError)) {
            this.setState({ error: nextFieldError });
        }
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
        if (this.props.validate !== prevProps.validate) {
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
    };
    FastFieldInner.prototype.componentWillUnmount = function () {
        this.props.formik.unregisterField(this.props.name);
    };
    FastFieldInner.prototype.render = function () {
        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, formik = _a.formik, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(_a, ["validate", "name", "render", "children", "component", "formik"]);
        var _validate = formik.validate, _validationSchema = formik.validationSchema, restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(formik, ["validate", "validationSchema"]);
        var field = {
            value: props.type === 'radio' || props.type === 'checkbox'
                ? props.value
                : this.state.value,
            name: name,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
        };
        var bag = {
            field: field,
            form: restOfFormik,
            meta: { touched: getIn(formik.touched, name), error: this.state.error },
        };
        if (render) {
            return render(bag);
        }
        if (isFunction(children)) {
            return children(bag);
        }
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(props, ["innerRef"]);
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: innerRef }, field, rest, { children: children }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, bag, props, { children: children }));
    };
    return FastFieldInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var FastField = connect(FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(923);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(924);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(927);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(928);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(925)();
}


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(926);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(135);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(89)(module)))

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
}

module.exports = toPath;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  if (a === b) return true;

  var arrA = isArray(a)
    , arrB = isArray(b)
    , i
    , length
    , key;

  if (arrA && arrB) {
    length = a.length;
    if (length != b.length) return false;
    for (i = 0; i < length; i++)
      if (!equal(a[i], b[i])) return false;
    return true;
  }

  if (arrA != arrB) return false;

  var dateA = a instanceof Date
    , dateB = b instanceof Date;
  if (dateA != dateB) return false;
  if (dateA && dateB) return a.getTime() == b.getTime();

  var regexpA = a instanceof RegExp
    , regexpB = b instanceof RegExp;
  if (regexpA != regexpB) return false;
  if (regexpA && regexpB) return a.toString() == b.toString();

  if (a instanceof Object && b instanceof Object) {
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = 0; i < length; i++)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = 0; i < length; i++) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof && a._store) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }

    return true;
  }

  return false;
}

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFunction; });
var isFunction=function isFunction(functionToCheck){return functionToCheck&&{}.toString.call(functionToCheck)==='[object Function]';};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(935);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 935 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_token__ = __webpack_require__(383);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_simple_auth__["createAuthenticator"])({name:'oauth2-implicit-grant',restore:function restore(data){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_token__["a" /* isValid */])(data)?Promise.resolve(data):Promise.reject();},authenticate:function authenticate(data){return new Promise(function(resolve,reject){if(!data||!data.access_token){reject('Invalid auth params - "access_token" missing.');}else{resolve(data);}});},invalidate:function invalidate(_ref){var access_token=_ref.access_token;return Object(__WEBPACK_IMPORTED_MODULE_1_utils_token__["b" /* revoke */])(access_token);}}));

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_token__ = __webpack_require__(383);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["createAuthenticator"])({name:'oauth2-password-grant',restore:function restore(data){return Object(__WEBPACK_IMPORTED_MODULE_2_utils_token__["a" /* isValid */])(data)?Promise.resolve(data):Promise.reject();},authenticate:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref){var email=_ref.email,password=_ref.password,otp_attempt=_ref.otp_attempt;var data,response,json;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data={grant_type:'password',username:email,password:password,otp_attempt:otp_attempt};_context.next=3;return fetch("https://api-qa.focusvision.com"+'/oauth/token',{method:'POST',credentials:'include',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:Object.keys(data).map(function(key){return encodeURIComponent(key)+'='+encodeURIComponent(data[key]);}).join('&')});case 3:response=_context.sent;_context.next=6;return response.json();case 6:json=_context.sent;if(response.ok){_context.next=9;break;}return _context.abrupt('return',Promise.reject(json));case 9:return _context.abrupt('return',json);case 10:case'end':return _context.stop();}}},_callee,_this);}));function authenticate(_x){return _ref2.apply(this,arguments);}return authenticate;}(),invalidate:function invalidate(_ref3){var access_token=_ref3.access_token;return Object(__WEBPACK_IMPORTED_MODULE_2_utils_token__["b" /* revoke */])(access_token);}}));

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(101).compose;
var logOnly = __webpack_require__(939);

exports.__esModule = true;
exports.composeWithDevTools = (
   true ? logOnly.composeWithDevTools :
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
      function() {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      }
);

exports.devToolsEnhancer = (
   true ? logOnly.devToolsEnhancer :
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION__ ?
      window.__REDUX_DEVTOOLS_EXTENSION__ :
      function() { return function(noop) { return noop; } }
);


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(940);
var compose = __webpack_require__(101).compose;

function enhancer() {
  var config = arguments[0] || {};
  config.features = { pause: true, export: true, test: true };
  config.type = 'redux';
  if (config.autoPause === undefined) config.autoPause = true;
  if (config.latency === undefined) config.latency = 500;

  return function(createStore) {
    return function(reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var origDispatch = store.dispatch;

      var devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(config);
      devTools.init(store.getState());

      var dispatch = function(action) {
        var r = origDispatch(action);
        devTools.send(action, store.getState());
        return r;
      };

      if (Object.assign) return Object.assign(store, { dispatch: dispatch });
      return assign(store, 'dispatch', dispatch);
    }
  }
}

function composeWithEnhancer(config) {
  return function () {
    return compose(compose.apply(null, arguments), enhancer(config));
  }
}

exports.__esModule = true;
exports.composeWithDevTools = function() {
  if (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    if (arguments.length === 0) return enhancer();
    if (typeof arguments[0] === 'object') return composeWithEnhancer(arguments[0]);
    return composeWithEnhancer().apply(null, arguments);
  }

  if (arguments.length === 0) return undefined;
  if (typeof arguments[0] === 'object') return compose;
  return compose.apply(null, arguments);
};

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    enhancer :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 940 */
/***/ (function(module, exports) {

var objectKeys = Object.keys || function (obj) {
    var keys = [];
    for (var key in obj) {
      if ({}.hasOwnProperty.call(obj, key)) keys.push(key);
    }
    return keys;
  };

function assign(obj, newKey, newValue) {
  var keys = objectKeys(obj);
  var copy = {};

  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    copy[key] = obj[key];
  }

  copy[newKey] = newValue;
  return copy;
}

module.exports = assign;


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({session:__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["reducer"]}));

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55),
    isSymbol = __webpack_require__(105);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_qr_code__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_qr_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_qr_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TwoFactorForm__ = __webpack_require__(388);
var TwoFAContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e0',label:'TwoFAContainer'})({name:'17lwes3',styles:'width:100% !important;'});var TwoFAInstructionsContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e1',label:'TwoFAInstructionsContainer'})({name:'uayx60',styles:'width:100%;display:flex;justify-content:space-between;@media only screen and (max-width:1000px){flex-direction:column;}'});var TwoFAInstructions=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e2',label:'TwoFAInstructions'})({name:'15luehs',styles:'width:50%;@media only screen and (max-width:1000px){width:100%;}'});var TwoFACodes=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e3',label:'TwoFACodes'})({name:'3lvw0x',styles:'width:40%;@media only screen and (max-width:1000px){width:100%;margin-bottom:20px;}'});var BoldText=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('p',{target:'e3vkt3e4',label:'BoldText'})({name:'in3yi3',styles:'font-weight:bold;'});var Text=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e5',label:'Text'})({name:'uewl2b',styles:'margin-bottom:20px;'});var Paragraph=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('p',{target:'e3vkt3e6',label:'Paragraph'})({name:'1upilqn',styles:'margin-bottom:12px;'});var StyledFormContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e7',label:'StyledFormContainer'})({name:'15luehs',styles:'width:50%;@media only screen and (max-width:1000px){width:100%;}'});var StyledQRCode=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e8',label:'StyledQRCode'})({name:'xi606m',styles:'text-align:center;'});var CodeContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e9',label:'CodeContainer'})({name:'skqcft',styles:'padding:12px;background:#f0eceb;display:flex;width:75%;justify-content:space-between;margin:auto;@media only screen and (max-width:1000px){width:50%;}'});var StyledIcon=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["u" /* Key */],{target:'e3vkt3e10',label:'StyledIcon'})({name:'1cqyh61',styles:'width:20%;@media only screen and (max-width:1000px){width:12%;}'});var Code=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e3vkt3e11',label:'Code'})({name:'1y2w9gc',styles:'width:70%;word-wrap:break-word;text-align:justify;@media only screen and (max-width:1000px){width:80%;}'});var TwoFactorSetup=function TwoFactorSetup(_ref){var uri2FA=_ref.uri2FA,code=_ref.code,notify=_ref.notify,authenticate=_ref.authenticate,product=_ref.product;var switchToNewName=function switchToNewName(){if(product.toLowerCase()==='revelation'){return'Digital Diaries';}else if(product.toLowerCase()==='kinesis'){return'Panel Management';}else if(product.toLowerCase()==='vi'){return'VideoInsights';}return product;};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TwoFAContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sign into ',switchToNewName(),' requires two-factor authentication (2FA) for enhanced security.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TwoFAInstructionsContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TwoFAInstructions,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BoldText,null,'Step 1. Configure your 2FA app'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Paragraph,null,'To configure 2FA, you\'ll need to have a Google Authenticator app installed on your phone or tablet.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Paragraph,null,'Once you\'ve installed it, open the app and scan the QR code or manually enter the key on the right.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BoldText,null,'Step 2. Enter a 2FA code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Paragraph,null,'Generate a code from your newly-activated Google Authenticator app to confirm that the account was properly set up and enter it in the field below.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TwoFACodes,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledQRCode,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_qr_code___default.a,{size:200,value:uri2FA}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CodeContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledIcon,{size:'sm'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Code,null,code))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledFormContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TwoFactorForm__["a" /* default */],{notify:notify,authenticate:authenticate})));};/* harmony default export */ __webpack_exports__["a"] = (TwoFactorSetup);

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _QRCode = __webpack_require__(946);

var _QRCode2 = _interopRequireDefault(_QRCode);

var _ErrorCorrectLevel = __webpack_require__(385);

var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);

var _propTypes = __webpack_require__(239);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _QRCodeCell = __webpack_require__(953);

var _QRCodeCell2 = _interopRequireDefault(_QRCodeCell);

var _QRCodeSurface = __webpack_require__(954);

var _QRCodeSurface2 = _interopRequireDefault(_QRCodeSurface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


var propTypes = {
  bgColor: _propTypes2.default.string,
  fgColor: _propTypes2.default.string,
  level: _propTypes2.default.oneOf(["L", "M", "Q", "H"]),
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var defaultProps = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
};

var QRCode = function QRCode(_ref) {
  var bgColor = _ref.bgColor,
      fgColor = _ref.fgColor,
      level = _ref.level,
      size = _ref.size,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  // We'll use type === -1 to force QRCode to automatically pick the best type.
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  var tileSize = size / cells.length;
  return _react2.default.createElement(
    _QRCodeSurface2.default,
    _extends({}, props, { size: size, style: { height: size, width: size } }),
    cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        var fill = cell ? fgColor : bgColor;
        var transformX = Math.round(cellIndex * tileSize);
        var transformY = Math.round(rowIndex * tileSize);
        var qrItemWidth = Math.round((cellIndex + 1) * tileSize) - transformX;
        var qrItemHeight = Math.round((rowIndex + 1) * tileSize) - transformY;
        var d = "M 0 0 L " + qrItemWidth + " 0 L " + qrItemWidth + " " + qrItemHeight + " L 0 " + qrItemHeight + " Z";
        return _react2.default.createElement(_QRCodeCell2.default
        /* eslint-disable react/no-array-index-key */
        , { key: "rectangle-" + rowIndex + "-" + cellIndex
          /* eslint-enable react/no-array-index-key */
          , d: d,
          fill: fill,
          transformX: transformX,
          transformY: transformY
        });
      });
    })
  );
};

QRCode.propTypes = propTypes;
QRCode.defaultProps = defaultProps;

exports.default = (0, _react.memo)(QRCode);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(947);
var RSBlock = __webpack_require__(948);
var BitBuffer = __webpack_require__(949);
var util = __webpack_require__(950);
var Polynomial = __webpack_require__(386);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(384);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(385);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(384);
var Polynomial = __webpack_require__(386);
var math = __webpack_require__(387);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(952);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(239);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  d: _propTypes2.default.string.isRequired,
  fill: _propTypes2.default.string.isRequired,
  transformX: _propTypes2.default.number.isRequired,
  transformY: _propTypes2.default.number.isRequired
};

var defaultProps = {};

var QRCodeCell = function QRCodeCell(_ref) {
  var d = _ref.d,
      fill = _ref.fill,
      transformX = _ref.transformX,
      transformY = _ref.transformY;
  return _react2.default.createElement("path", { d: d, fill: fill, transform: "matrix(" + [1, 0, 0, 1, transformX, transformY] + ")" });
};

QRCodeCell.propTypes = propTypes;
QRCodeCell.defaultProps = defaultProps;

exports.default = QRCodeCell;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(239);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _propTypes2.default.array.isRequired,
  size: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.object,
  xmlns: _propTypes2.default.string
};

var defaultProps = {
  style: undefined,
  xmlns: "http://www.w3.org/2000/svg"
};

var QRCodeSurface = function QRCodeSurface(_ref) {
  var children = _ref.children,
      size = _ref.size,
      style = _ref.style,
      xmlns = _ref.xmlns,
      props = _objectWithoutProperties(_ref, ["children", "size", "style", "xmlns"]);

  return _react2.default.createElement(
    "svg",
    _extends({}, props, { height: size, style: style, width: size, xmlns: xmlns }),
    children
  );
};

QRCodeSurface.propTypes = propTypes;
QRCodeSurface.defaultProps = defaultProps;

exports.default = QRCodeSurface;

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TwoFactorForm__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
var TwoFACodeContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eomfczs0',label:'TwoFACodeContainer'})({name:'yghjuq',styles:'width:80% !important;margin:auto;'});var TextContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eomfczs1',label:'TextContainer'})({name:'npegex',styles:'margin:0 0 20px;display:flex;width:100%;'});var Text=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eomfczs2',label:'Text'})({name:'7822g1',styles:'width:90%;'});var StyledIcon=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_stylist__["B" /* MobileFriendly */],{target:'eomfczs3',label:'StyledIcon'})({name:'qd3ol1',styles:'width:10%;'});var InstructionsContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eomfczs4',label:'InstructionsContainer'})({name:'1sm872l',styles:'font-size:10px !important;line-height:initial;'});var Link=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('a',{target:'eomfczs5',label:'Link'})({name:'e4d0bk',styles:'text-decoration:underline;cursor:pointer;'});var Divider=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'eomfczs6',label:'Divider'})({name:'1yzham5',styles:'border-bottom:1px solid #f0eceb;margin-bottom:19px;'});var TwoFactorCode=function TwoFactorCode(_ref){var notify=_ref.notify,authenticate=_ref.authenticate;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TwoFACodeContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TextContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledIcon,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,'Enter the 6-digit code generated by Google Authenticator App.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TwoFactorForm__["a" /* default */],{notify:notify,authenticate:authenticate}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Divider,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InstructionsContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'To change your authentication device and set up Google Authenticator on a new device, follow',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link,{href:'https://support.google.com/accounts/answer/1066447?hl=EN',target:'_blank'},'Authenticator setup instructions')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'If you\'ve lost your device or can\'t use your app, please contact',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link,null,'support@forsta.com'),'.')));};/* harmony default export */ __webpack_exports__["a"] = (TwoFactorCode);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuthenticatedProductServerRedirect__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ValidateRedirectUri__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_sentry__ = __webpack_require__(1003);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CaptureRedirectLocation=function CaptureRedirectLocation(_ref){var uri=_ref.uri,props=_objectWithoutProperties(_ref,['uri']);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_5_utils_sentry__["a" /* captureInsecureRedirect */])(uri);},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Location__["a" /* default */],props);};var AuthenticatedRedirect=function AuthenticatedRedirect(_ref2){var query=_ref2.query;var redirectUri=query.get('redirect_uri');return redirectUri?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ValidateRedirectUri__["a" /* default */],{redirectUri:redirectUri},function(valid){return valid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Location__["a" /* default */],{to:redirectUri,replace:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CaptureRedirectLocation,{uri:redirectUri,to:'/error?error='+window.encodeURIComponent('invalid redirect_uri')});}):query.get('client_id')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuthenticatedProductServerRedirect__["a" /* default */],{clientId:query.get('client_id')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:'/'});};/* harmony default export */ __webpack_exports__["a"] = (AuthenticatedRedirect);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CurrentUser__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_normalizeHostname__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(7);
var AuthenticatedProductServerRedirect=function AuthenticatedProductServerRedirect(_ref){var clientId=_ref.clientId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CurrentUser__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,viewer=_ref2.viewer;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'lg',centered:true});}var servers=viewer&&viewer.userServers&&viewer.userServers(clientId);if(servers&&servers.length===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Location__["a" /* default */],{to:Object(__WEBPACK_IMPORTED_MODULE_3_utils_normalizeHostname__["a" /* default */])(servers[0].hostname,clientId)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:'/'});}});};/* harmony default export */ __webpack_exports__["a"] = (AuthenticatedProductServerRedirect);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
var validateRedirectUriQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'validateRedirectUriQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'uri'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'validate_redirect_uri'},arguments:[{kind:'Argument',name:{kind:'Name',value:'uri'},value:{kind:'Variable',name:{kind:'Name',value:'uri'}}}],directives:[]}]}}],loc:{start:0,end:85,source:{body:'query validateRedirectUriQuery($uri: String!) {\n  validate_redirect_uri(uri: $uri)\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var ValidateRedirectUri=function ValidateRedirectUri(_ref){var children=_ref.children,redirectUri=_ref.redirectUri;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{variables:{uri:redirectUri},query:validateRedirectUriQuery},function(_ref2){var loading=_ref2.loading,validate_redirect_uri=_ref2.data.validate_redirect_uri;return loading?null:children(validate_redirect_uri);});};/* harmony default export */ __webpack_exports__["a"] = (ValidateRedirectUri);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QueryDocumentKeys */
/* unused harmony export BREAK */
/* harmony export (immutable) */ __webpack_exports__["a"] = visit;
/* unused harmony export visitInParallel */
/* unused harmony export visitWithTypeInfo */
/* unused harmony export getVisitFn */


/**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var QueryDocumentKeys = {
  Name: [],

  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],

  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name',
  // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],

  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],

  Directive: ['name', 'arguments'],

  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],

  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],

  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],

  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],

  DirectiveDefinition: ['description', 'name', 'arguments', 'locations']
};

/**
 * A KeyMap describes each the traversable properties of each kind of node.
 */


var BREAK = {};

/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */
function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;
    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();
      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};
          for (var k in node) {
            if (node.hasOwnProperty(k)) {
              clone[k] = node[k];
            }
          }
          node = clone;
        }
        var editOffset = 0;
        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];
          if (inArray) {
            editKey -= editOffset;
          }
          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }
      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;
      if (node === null || node === undefined) {
        continue;
      }
      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;
    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
      }
      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);
          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];
      if (parent) {
        ancestors.push(parent);
      }
      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}

/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */
function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);

  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}

/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */
function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
      if (fn) {
        var result = fn.apply(visitor, arguments);
        if (result !== undefined) {
          typeInfo.leave(node);
          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }
        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
      var result = void 0;
      if (fn) {
        result = fn.apply(visitor, arguments);
      }
      typeInfo.leave(node);
      return result;
    }
  };
}

/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */
function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];
  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }
    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }
      var specificKindVisitor = specificVisitor[kind];
      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDirectiveInfoFromField;
/* harmony export (immutable) */ __webpack_exports__["c"] = shouldInclude;
/* unused harmony export flattenSelections */
/* unused harmony export getDirectiveNames */
/* harmony export (immutable) */ __webpack_exports__["b"] = hasDirectives;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storeUtils__ = __webpack_require__(242);

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = Object(__WEBPACK_IMPORTED_MODULE_0__storeUtils__["a" /* argumentsObjectFromField */])(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
        }
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
        if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
        }
        var ifArgument = directiveArguments[0];
        if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
        }
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
            if (ifValue.kind !== 'Variable') {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            }
            else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === undefined) {
                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
            }
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function flattenSelections(selection) {
    if (!selection.selectionSet ||
        !(selection.selectionSet.selections.length > 0))
        return [selection];
    return [selection].concat(selection.selectionSet.selections
        .map(function (selectionNode) {
        return [selectionNode].concat(flattenSelections(selectionNode));
    })
        .reduce(function (selections, selected) { return selections.concat(selected); }, []));
}
var added = new Map();
function getDirectiveNames(doc) {
    var cached = added.get(doc);
    if (cached)
        return cached;
    var directives = doc.definitions
        .filter(function (definition) {
        return definition.selectionSet && definition.selectionSet.selections;
    })
        .map(function (x) { return flattenSelections(x); })
        .reduce(function (selections, selected) { return selections.concat(selected); }, [])
        .filter(function (selection) {
        return selection.directives && selection.directives.length > 0;
    })
        .map(function (selection) { return selection.directives; })
        .reduce(function (directives, directive) { return directives.concat(directive); }, [])
        .map(function (directive) { return directive.name.value; });
    added.set(doc, directives);
    return directives;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
//# sourceMappingURL=directives.js.map

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFragmentQueryDocument;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        }
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}
//# sourceMappingURL=fragments.js.map

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDirectivesFromDocument */
/* harmony export (immutable) */ __webpack_exports__["a"] = addTypenameToDocument;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeConnectionDirectiveFromDocument;
/* unused harmony export getDirectivesFromDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFromAST__ = __webpack_require__(389);


var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isNotEmpty(op, fragments) {
    return (op.selectionSet.selections.filter(function (selectionSet) {
        return !(selectionSet &&
            selectionSet.kind === 'FragmentSpread' &&
            !isNotEmpty(fragments[selectionSet.name.value], fragments));
    }).length > 0);
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            if (dir.name && dir.name === directive.name.value)
                return true;
            if (dir.test && dir.test(directive))
                return true;
            return false;
        });
    };
}
function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    if (selectionSet.selections) {
        if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
                return (selection.kind === 'Field' &&
                    selection.name.value === '__typename');
            });
            if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD);
            }
        }
        selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field') {
                if (selection.name.value.lastIndexOf('__', 0) !== 0 &&
                    selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
            else if (selection.kind === 'InlineFragment') {
                if (selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
        });
    }
}
function removeDirectivesFromSelectionSet(directives, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    var agressiveRemove = directives.some(function (dir) { return dir.remove; });
    selectionSet.selections = selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.directives)
            return selection;
        var directiveMatcher = getDirectiveMatcher(directives);
        var remove;
        selection.directives = selection.directives.filter(function (directive) {
            var shouldKeep = !directiveMatcher(directive);
            if (!remove && !shouldKeep && agressiveRemove)
                remove = true;
            return shouldKeep;
        });
        return remove ? null : selection;
    })
        .filter(function (x) { return !!x; });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
    });
    return selectionSet;
}
function removeDirectivesFromDocument(directives, doc) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        removeDirectivesFromSelectionSet(directives, definition.selectionSet);
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["h" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
var added = new Map();
function addTypenameToDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var cached = added.get(doc);
    if (cached)
        return cached;
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        var isRoot = definition.kind === 'OperationDefinition';
        addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    added.set(doc, docClone);
    return docClone;
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
var removed = new Map();
function removeConnectionDirectiveFromDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var cached = removed.get(doc);
    if (cached)
        return cached;
    var docClone = removeDirectivesFromDocument([connectionRemoveConfig], doc);
    removed.set(doc, docClone);
    return docClone;
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!(selectionSet && selectionSet.selections)) {
        return false;
    }
    var matchedSelections = selectionSet.selections.filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, nestedCheck);
    });
    return matchedSelections.length > 0;
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (selection.kind !== 'Field' || !selection) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var matchedDirectives = selection.directives.filter(directiveMatcher);
    return (matchedDirectives.length > 0 ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromSelectionSet(directives, selectionSet) {
    selectionSet.selections = selectionSet.selections
        .filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, true);
    })
        .map(function (selection) {
        if (hasDirectivesInSelection(directives, selection, false)) {
            return selection;
        }
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            selection.selectionSet = getDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
        return selection;
    });
    return selectionSet;
}
function getDirectivesFromDocument(directives, doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions = docClone.definitions.map(function (definition) {
        if ((definition.kind === 'OperationDefinition' ||
            definition.kind === 'FragmentDefinition') &&
            definition.selectionSet) {
            definition.selectionSet = getDirectivesFromSelectionSet(directives, definition.selectionSet);
        }
        return definition;
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["h" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tryFunctionOrLogError;
/* harmony export (immutable) */ __webpack_exports__["a"] = graphQLResultHasError;
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        for (var key in b) {
            if (!Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=isEqual.js.map

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maybeDeepFreeze;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(243);

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["a" /* isDevelopment */])() || Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
        return deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warnOnceInDevelopment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(243);

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["b" /* isProduction */])()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}
//# sourceMappingURL=warnOnce.js.map

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export empty */
/* unused harmony export from */
/* unused harmony export split */
/* unused harmony export concat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* harmony export (immutable) */ __webpack_exports__["b"] = execute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zen_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(393);


var passthrough = function (op, forward) { return (forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]()); };
var toLink = function (handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
};
var empty = function () {
    return new ApolloLink(function (op, forward) { return __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"](); });
};
var from = function (links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
};
var split = function (test, left, right) {
    if (right === void 0) { right = new ApolloLink(passthrough); }
    var leftLink = toLink(left);
    var rightLink = toLink(right);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["c" /* isTerminating */])(leftLink) && Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["c" /* isTerminating */])(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]();
        });
    }
};
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["c" /* isTerminating */])(firstLink)) {
        console.warn(new __WEBPACK_IMPORTED_MODULE_1__linkUtils__["a" /* LinkError */]("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["c" /* isTerminating */])(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"](); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        if (right === void 0) { right = new ApolloLink(passthrough); }
        return this.concat(split(test, left, right));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw new Error('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());

function execute(link, operation) {
    return (link.request(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["b" /* createOperation */])(operation.context, Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["d" /* transformOperation */])(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* validateOperation */])(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable__["of"]());
}
//# sourceMappingURL=link.js.map

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) { (function(fn, name) { if (true) { fn(exports, module); } else if (typeof self !== "undefined") { var e = name === "*" ? self : (name ? self[name] = {} : {}); fn(e, { exports: e }); } })(function(exports, module) { // === Symbol Support ===

function hasSymbol(name) {
  return typeof Symbol === "function" && Boolean(Symbol[name]);
}

function getSymbol(name) {
  return hasSymbol(name) ? Symbol[name] : "@@" + name;
}

// Ponyfill Symbol.observable for interoperability with other libraries
if (typeof Symbol === "function" && !Symbol.observable) {
  Symbol.observable = Symbol("observable");
}

// === Abstract Operations ===

function hostReportError(e) {
  setTimeout(function() { throw e });
}

function getMethod(obj, key) {
  var value = obj[key];

  if (value == null)
    return undefined;

  if (typeof value !== "function")
    throw new TypeError(value + " is not a function");

  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;
  if (ctor !== undefined) {
    ctor = ctor[getSymbol("species")];
    if (ctor === null) {
      ctor = undefined;
    }
  }
  return ctor !== undefined ? ctor : Observable;
}

function addMethods(target, methods) {
  Object.keys(methods).forEach(function(k) {
    var desc = Object.getOwnPropertyDescriptor(methods, k);
    desc.enumerable = false;
    Object.defineProperty(target, k, desc);
  });
}

function cleanupSubscription(subscription) {
  // Assert:  observer._observer is undefined

  var cleanup = subscription._cleanup;

  if (!cleanup)
    return;

  // Drop the reference to the cleanup function so that we won't call it
  // more than once
  subscription._cleanup = undefined;

  // Call the cleanup function
  try { cleanup() }
  catch (e) { hostReportError(e) }
}

function subscriptionClosed(subscription) {
  return subscription._observer === undefined;
}

function closeSubscription(subscription) {
  if (subscriptionClosed(subscription))
    return;

  subscription._observer = undefined;
  cleanupSubscription(subscription);
}

function cleanupFromSubscription(subscription) {
  return function() { subscription.unsubscribe() };
}

function Subscription(observer, subscriber) {
  // Assert: subscriber is callable

  // The observer must be an object
  if (Object(observer) !== observer)
    throw new TypeError("Observer must be an object");

  this._cleanup = undefined;
  this._observer = observer;

  try {
    var start$0 = getMethod(observer, "start");
    if (start$0) start$0.call(observer, this);
  } catch (e) {
    hostReportError(e);
  }

  if (subscriptionClosed(this))
    return;

  observer = new SubscriptionObserver(this);

  try {
    // Call the subscriber function
    var cleanup$0 = subscriber.call(undefined, observer);

    // The return value must be undefined, null, a subscription object, or a function
    if (cleanup$0 != null) {
      if (typeof cleanup$0.unsubscribe === "function")
        cleanup$0 = cleanupFromSubscription(cleanup$0);
      else if (typeof cleanup$0 !== "function")
        throw new TypeError(cleanup$0 + " is not a function");

      this._cleanup = cleanup$0;
    }
  } catch (e) {
    // If an error occurs during startup, then attempt to send the error
    // to the observer
    observer.error(e);
    return;
  }

  // If the stream is already finished, then perform cleanup
  if (subscriptionClosed(this))
    cleanupSubscription(this);
}

addMethods(Subscription.prototype = {}, {
  get closed() { return subscriptionClosed(this) },
  unsubscribe: function() { closeSubscription(this) },
});

function SubscriptionObserver(subscription) {
  this._subscription = subscription;
}

addMethods(SubscriptionObserver.prototype = {}, {

  get closed() { return subscriptionClosed(this._subscription) },

  next: function(value) {
    var subscription = this._subscription;

    // If the stream is closed, then return undefined
    if (subscriptionClosed(subscription))
      return;

    var observer = subscription._observer;

    try {
      // If the observer has a "next" method, send the next value
      var m$0 = getMethod(observer, "next");
      if (m$0) m$0.call(observer, value);
    } catch (e) {
      hostReportError(e);
    }
  },

  error: function(value) {
    var subscription = this._subscription;

    // If the stream is closed, throw the error to the caller
    if (subscriptionClosed(subscription)) {
      hostReportError(value);
      return;
    }

    var observer = subscription._observer;
    subscription._observer = undefined;

    try {
      var m$1 = getMethod(observer, "error");
      if (m$1) m$1.call(observer, value);
      else throw value;
    } catch (e) {
      hostReportError(e);
    }

    cleanupSubscription(subscription);
  },

  complete: function() {
    var subscription = this._subscription;

    if (subscriptionClosed(subscription))
      return;

    var observer = subscription._observer;
    subscription._observer = undefined;

    try {
      var m$2 = getMethod(observer, "complete");
      if (m$2) m$2.call(observer);
    } catch (e) {
      hostReportError(e);
    }

    cleanupSubscription(subscription);
  },

});

function Observable(subscriber) {
  // Constructor cannot be called as a function
  if (!(this instanceof Observable))
    throw new TypeError("Observable cannot be called as a function");

  // The stream subscriber must be a function
  if (typeof subscriber !== "function")
    throw new TypeError("Observable initializer must be a function");

  this._subscriber = subscriber;
}

addMethods(Observable.prototype, {

  subscribe: function(observer) { for (var args = [], __$0 = 1; __$0 < arguments.length; ++__$0) args.push(arguments[__$0]); 
    if (typeof observer === 'function') {
      observer = {
        next: observer,
        error: args[0],
        complete: args[1],
      };
    } else if (typeof observer !== 'object' || observer === null) {
      observer = {};
    }

    return new Subscription(observer, this._subscriber);
  },

  forEach: function(fn) { var __this = this; 
    return new Promise(function(resolve, reject) {
      if (typeof fn !== "function")
        return Promise.reject(new TypeError(fn + " is not a function"));

      __this.subscribe({
        _subscription: null,

        start: function(subscription) {
          if (Object(subscription) !== subscription)
            throw new TypeError(subscription + " is not an object");

          this._subscription = subscription;
        },

        next: function(value) {
          var subscription = this._subscription;

          if (subscription.closed)
            return;

          try {
            fn(value);
          } catch (err) {
            reject(err);
            subscription.unsubscribe();
          }
        },

        error: reject,
        complete: resolve,
      });
    });
  },

  map: function(fn) { var __this = this; 
    if (typeof fn !== "function")
      throw new TypeError(fn + " is not a function");

    var C = getSpecies(this);

    return new C(function(observer) { return __this.subscribe({
      next: function(value) {
        if (observer.closed)
          return;

        try { value = fn(value) }
        catch (e) { return observer.error(e) }

        observer.next(value);
      },

      error: function(e) { observer.error(e) },
      complete: function() { observer.complete() },
    }); });
  },

  filter: function(fn) { var __this = this; 
    if (typeof fn !== "function")
      throw new TypeError(fn + " is not a function");

    var C = getSpecies(this);

    return new C(function(observer) { return __this.subscribe({
      next: function(value) {
        if (observer.closed)
          return;

        try { if (!fn(value)) return }
        catch (e) { return observer.error(e) }

        observer.next(value);
      },

      error: function(e) { observer.error(e) },
      complete: function() { observer.complete() },
    }); });
  },

  reduce: function(fn) { var __this = this; 
    if (typeof fn !== "function")
      throw new TypeError(fn + " is not a function");

    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;

    return new C(function(observer) { return __this.subscribe({

      next: function(value) {
        if (observer.closed)
          return;

        var first = !hasValue;
        hasValue = true;

        if (!first || hasSeed) {
          try { acc = fn(acc, value) }
          catch (e) { return observer.error(e) }
        } else {
          acc = value;
        }
      },

      error: function(e) { observer.error(e) },

      complete: function() {
        if (!hasValue && !hasSeed) {
          return observer.error(new TypeError("Cannot reduce an empty sequence"));
        }

        observer.next(acc);
        observer.complete();
      },

    }); });
  },

});

Object.defineProperty(Observable.prototype, getSymbol("observable"), {
  value: function() { return this },
  writable: true,
  configurable: true,
});

addMethods(Observable, {

  from: function(x) {
    var C = typeof this === "function" ? this : Observable;

    if (x == null)
      throw new TypeError(x + " is not an object");

    var method = getMethod(x, getSymbol("observable"));

    if (method) {
      var observable$0 = method.call(x);

      if (Object(observable$0) !== observable$0)
        throw new TypeError(observable$0 + " is not an object");

      if (observable$0.constructor === C)
        return observable$0;

      return new C(function(observer) { return observable$0.subscribe(observer); });
    }

    if (hasSymbol("iterator") && (method = getMethod(x, getSymbol("iterator")))) {
      return new C(function(observer) {
        for (var __$0 = (method.call(x))[Symbol.iterator](), __$1; __$1 = __$0.next(), !__$1.done;) { var item$0 = __$1.value; 
          observer.next(item$0);
          if (observer.closed)
            return;
        }

        observer.complete();
      });
    }

    if (Array.isArray(x)) {
      return new C(function(observer) {
        for (var i$0 = 0; i$0 < x.length; ++i$0) {
          observer.next(x[i$0]);
          if (observer.closed)
            return;
        }

        observer.complete();
      });
    }

    throw new TypeError(x + " is not observable");
  },

  of: function() { for (var items = [], __$0 = 0; __$0 < arguments.length; ++__$0) items.push(arguments[__$0]); 
    var C = typeof this === "function" ? this : Observable;

    return new C(function(observer) {
      for (var i$1 = 0; i$1 < items.length; ++i$1) {
        observer.next(items[i$1]);
        if (observer.closed)
          return;
      }

      observer.complete();
    });
  },

});

Object.defineProperty(Observable, getSymbol("species"), {
  get: function() { return this },
  configurable: true,
});

Object.defineProperty(Observable, "extensions", {
  value: {
    observableSymbol: getSymbol("observable"),
    setHostReportError: function(fn) { hostReportError = fn },
  },
});

exports.Observable = Observable;


}, "*");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(970);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments__ = __webpack_require__(971);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFromAST__ = __webpack_require__(394);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform__ = __webpack_require__(972);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storeUtils__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_assign__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_environment__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__ = __webpack_require__(973);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isEqual__ = __webpack_require__(974);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__ = __webpack_require__(975);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__ = __webpack_require__(976);
/* unused harmony namespace reexport */












//# sourceMappingURL=index.js.map

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDirectiveInfoFromField */
/* unused harmony export shouldInclude */
/* unused harmony export flattenSelections */
/* unused harmony export getDirectiveNames */
/* unused harmony export hasDirectives */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storeUtils__ = __webpack_require__(245);

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = Object(__WEBPACK_IMPORTED_MODULE_0__storeUtils__["a" /* argumentsObjectFromField */])(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
        }
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
        if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
        }
        var ifArgument = directiveArguments[0];
        if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
        }
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
            if (ifValue.kind !== 'Variable') {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            }
            else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === undefined) {
                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
            }
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function flattenSelections(selection) {
    if (!selection.selectionSet ||
        !(selection.selectionSet.selections.length > 0))
        return [selection];
    return [selection].concat(selection.selectionSet.selections
        .map(function (selectionNode) {
        return [selectionNode].concat(flattenSelections(selectionNode));
    })
        .reduce(function (selections, selected) { return selections.concat(selected); }, []));
}
var added = new Map();
function getDirectiveNames(doc) {
    var cached = added.get(doc);
    if (cached)
        return cached;
    var directives = doc.definitions
        .filter(function (definition) {
        return definition.selectionSet && definition.selectionSet.selections;
    })
        .map(function (x) { return flattenSelections(x); })
        .reduce(function (selections, selected) { return selections.concat(selected); }, [])
        .filter(function (selection) {
        return selection.directives && selection.directives.length > 0;
    })
        .map(function (selection) { return selection.directives; })
        .reduce(function (directives, directive) { return directives.concat(directive); }, [])
        .map(function (directive) { return directive.name.value; });
    added.set(doc, directives);
    return directives;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
//# sourceMappingURL=directives.js.map

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFragmentQueryDocument */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        }
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}
//# sourceMappingURL=fragments.js.map

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDirectivesFromDocument */
/* unused harmony export addTypenameToDocument */
/* unused harmony export removeConnectionDirectiveFromDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFromAST__ = __webpack_require__(394);


var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    if (selectionSet.selections) {
        if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
                return (selection.kind === 'Field' &&
                    selection.name.value === '__typename');
            });
            if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD);
            }
        }
        selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field') {
                if (selection.name.value.lastIndexOf('__', 0) !== 0 &&
                    selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
            else if (selection.kind === 'InlineFragment') {
                if (selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
        });
    }
}
function removeDirectivesFromSelectionSet(directives, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    var agressiveRemove = directives.some(function (dir) { return dir.remove; });
    selectionSet.selections = selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.directives)
            return selection;
        var remove;
        selection.directives = selection.directives.filter(function (directive) {
            var shouldKeep = !directives.some(function (dir) {
                if (dir.name && dir.name === directive.name.value)
                    return true;
                if (dir.test && dir.test(directive))
                    return true;
                return false;
            });
            if (!remove && !shouldKeep && agressiveRemove)
                remove = true;
            return shouldKeep;
        });
        return remove ? null : selection;
    })
        .filter(function (x) { return !!x; });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
    });
    return selectionSet;
}
function removeDirectivesFromDocument(directives, doc) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        removeDirectivesFromSelectionSet(directives, definition.selectionSet);
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["c" /* getFragmentDefinitions */])(docClone));
    var isNotEmpty = function (op) {
        return op.selectionSet.selections.filter(function (selectionSet) {
            return !(selectionSet &&
                selectionSet.kind === 'FragmentSpread' &&
                !isNotEmpty(fragments[selectionSet.name.value]));
        }).length > 0;
    };
    return isNotEmpty(operation) ? docClone : null;
}
var added = new Map();
function addTypenameToDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var cached = added.get(doc);
    if (cached)
        return cached;
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        var isRoot = definition.kind === 'OperationDefinition';
        addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    added.set(doc, docClone);
    return docClone;
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
var removed = new Map();
function removeConnectionDirectiveFromDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var cached = removed.get(doc);
    if (cached)
        return cached;
    var docClone = removeDirectivesFromDocument([connectionRemoveConfig], doc);
    removed.set(doc, docClone);
    return docClone;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tryFunctionOrLogError */
/* unused harmony export graphQLResultHasError */
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEqual */
function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        for (var key in b) {
            if (!Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=isEqual.js.map

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export maybeDeepFreeze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(246);

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["a" /* isDevelopment */])() || Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
        return deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warnOnceInDevelopment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(246);

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["b" /* isProduction */])()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}
//# sourceMappingURL=warnOnce.js.map

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_QueryManager__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_store__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__version__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var hasSuggestedDevtools = false;
var supportedDirectives = new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
    operation.query = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["y" /* removeConnectionDirectiveFromDocument */])(operation.query);
    return forward(operation);
});
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        var link = options.link, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions;
        if (!link || !cache) {
            throw new Error("\n        In order to initialize Apollo Client, you must specify link & cache properties on the config object.\n        This is part of the required upgrade when migrating from Apollo Client 1.0 to Apollo Client 2.0.\n        For more information, please visit:\n          https://www.apollographql.com/docs/react/basics/setup.html\n        to help you get started.\n      ");
        }
        this.link = supportedDirectives.concat(link);
        this.cache = cache;
        this.store = new __WEBPACK_IMPORTED_MODULE_3__data_store__["a" /* DataStore */](cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.ssrMode = ssrMode;
        this.defaultOptions = defaultOptions || {};
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["v" /* isProduction */])() &&
            typeof window !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["v" /* isProduction */])()) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    if (navigator.userAgent.indexOf('Chrome') > -1) {
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = __WEBPACK_IMPORTED_MODULE_4__version__["version"];
    }
    ApolloClient.prototype.watchQuery = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.watchQuery) {
            options = __assign({}, this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = __assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.query) {
            options = __assign({}, this.defaultOptions.query, options);
        }
        if (options.fetchPolicy === 'cache-and-network') {
            throw new Error('cache-and-network fetchPolicy can only be used with watchQuery');
        }
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = __assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.mutate) {
            options = __assign({}, this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        this.initQueryManager();
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options) {
        return this.initProxy().readQuery(options);
    };
    ApolloClient.prototype.readFragment = function (options) {
        return this.initProxy().readFragment(options);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.initProxy().writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.initProxy().writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.initProxy().writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* execute */])(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
        var _this = this;
        if (this.queryManager)
            return;
        this.queryManager = new __WEBPACK_IMPORTED_MODULE_2__core_QueryManager__["a" /* QueryManager */]({
            link: this.link,
            store: this.store,
            queryDeduplication: this.queryDeduplication,
            ssrMode: this.ssrMode,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            _this.queryManager
                ? _this.queryManager.resetStore()
                : Promise.resolve(null);
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager
            ? this.queryManager.reFetchObservableQueries(includeStandby)
            : Promise.resolve(null);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.initProxy().extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.initProxy().restore(serializedState);
    };
    ApolloClient.prototype.initProxy = function () {
        if (!this.proxy) {
            this.initQueryManager();
            this.proxy = this.cache;
        }
        return this.proxy;
    };
    return ApolloClient;
}());
/* harmony default export */ __webpack_exports__["a"] = (ApolloClient);
//# sourceMappingURL=ApolloClient.js.map

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_dedup__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduler_scheduler__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Observable__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_mutations__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_queries__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ObservableQuery__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__networkStatus__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(154);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var defaultQueryInfo = {
    listeners: [],
    invalidated: false,
    document: null,
    newData: null,
    lastRequestId: null,
    observableQuery: null,
    subscriptions: [],
};
var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d;
        this.mutationStore = new __WEBPACK_IMPORTED_MODULE_7__data_mutations__["a" /* MutationStore */]();
        this.queryStore = new __WEBPACK_IMPORTED_MODULE_8__data_queries__["a" /* QueryStore */]();
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryPromises = new Map();
        this.queryIdsByName = {};
        this.link = link;
        this.deduplicator = __WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */].from([new __WEBPACK_IMPORTED_MODULE_2_apollo_link_dedup__["a" /* DedupLink */](), link]);
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.scheduler = new __WEBPACK_IMPORTED_MODULE_4__scheduler_scheduler__["a" /* QueryScheduler */]({ queryManager: this, ssrMode: ssrMode });
    }
    QueryManager.prototype.mutate = function (_a) {
        var _this = this;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, updateWithProxyFn = _a.update, _c = _a.errorPolicy, errorPolicy = _c === void 0 ? 'none' : _c, fetchPolicy = _a.fetchPolicy, _d = _a.context, context = _d === void 0 ? {} : _d;
        if (!mutation) {
            throw new Error('mutation option is required. You must specify your GraphQL document in the mutation option.');
        }
        if (fetchPolicy && fetchPolicy !== 'no-cache') {
            throw new Error("fetchPolicy for mutations currently only supports the 'no-cache' policy");
        }
        var mutationId = this.generateQueryId();
        var cache = this.dataStore.getCache();
        (mutation = cache.transformDocument(mutation)),
            (variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["e" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["j" /* getMutationDefinition */])(mutation)), variables));
        var mutationString = Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(mutation);
        this.setQuery(mutationId, function () { return ({ document: mutation }); });
        var generateUpdateQueriesInfo = function () {
            var ret = {};
            if (updateQueriesByName) {
                Object.keys(updateQueriesByName).forEach(function (queryName) {
                    return (_this.queryIdsByName[queryName] || []).forEach(function (queryId) {
                        ret[queryId] = {
                            updater: updateQueriesByName[queryName],
                            query: _this.queryStore.get(queryId),
                        };
                    });
                });
            }
            return ret;
        };
        this.mutationStore.initMutation(mutationId, mutationString, variables);
        this.dataStore.markMutationInit({
            mutationId: mutationId,
            document: mutation,
            variables: variables || {},
            updateQueries: generateUpdateQueriesInfo(),
            update: updateWithProxyFn,
            optimisticResponse: optimisticResponse,
        });
        this.broadcastQueries();
        return new Promise(function (resolve, reject) {
            var storeResult;
            var error;
            var operation = _this.buildOperationForLink(mutation, variables, __assign({}, context, { optimisticResponse: optimisticResponse }));
            Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* execute */])(_this.link, operation).subscribe({
                next: function (result) {
                    if (result.errors && errorPolicy === 'none') {
                        error = new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                            graphQLErrors: result.errors,
                        });
                        return;
                    }
                    _this.mutationStore.markMutationResult(mutationId);
                    if (fetchPolicy !== 'no-cache') {
                        _this.dataStore.markMutationResult({
                            mutationId: mutationId,
                            result: result,
                            document: mutation,
                            variables: variables || {},
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                        });
                    }
                    storeResult = result;
                },
                error: function (err) {
                    _this.mutationStore.markMutationError(mutationId, err);
                    _this.dataStore.markMutationComplete({
                        mutationId: mutationId,
                        optimisticResponse: optimisticResponse,
                    });
                    _this.broadcastQueries();
                    _this.setQuery(mutationId, function () { return ({ document: undefined }); });
                    reject(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                        networkError: err,
                    }));
                },
                complete: function () {
                    if (error) {
                        _this.mutationStore.markMutationError(mutationId, error);
                    }
                    _this.dataStore.markMutationComplete({
                        mutationId: mutationId,
                        optimisticResponse: optimisticResponse,
                    });
                    _this.broadcastQueries();
                    if (error) {
                        reject(error);
                        return;
                    }
                    if (typeof refetchQueries === 'function')
                        refetchQueries = refetchQueries(storeResult);
                    refetchQueries.forEach(function (refetchQuery) {
                        if (typeof refetchQuery === 'string') {
                            _this.refetchQueryByName(refetchQuery);
                            return;
                        }
                        _this.query({
                            query: refetchQuery.query,
                            variables: refetchQuery.variables,
                            fetchPolicy: 'network-only',
                        });
                    });
                    _this.setQuery(mutationId, function () { return ({ document: undefined }); });
                    if (errorPolicy === 'ignore' && storeResult && storeResult.errors) {
                        delete storeResult.errors;
                    }
                    resolve(storeResult);
                },
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        var _this = this;
        var _a = options.variables, variables = _a === void 0 ? {} : _a, _b = options.metadata, metadata = _b === void 0 ? null : _b, _c = options.fetchPolicy, fetchPolicy = _c === void 0 ? 'cache-first' : _c;
        var cache = this.dataStore.getCache();
        var query = cache.transformDocument(options.query);
        var storeResult;
        var needToFetch = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (fetchType !== __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].refetch &&
            fetchPolicy !== 'network-only' &&
            fetchPolicy !== 'no-cache') {
            var _d = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                returnPartialData: true,
                optimistic: false,
            }), complete = _d.complete, result = _d.result;
            needToFetch = !complete || fetchPolicy === 'cache-and-network';
            storeResult = result;
        }
        var shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
        if (Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["p" /* hasDirectives */])(['live'], query))
            shouldFetch = true;
        var requestId = this.generateRequestId();
        var cancel = this.updateQueryWatch(queryId, query, options);
        this.setQuery(queryId, function () { return ({
            document: query,
            lastRequestId: requestId,
            invalidated: true,
            cancel: cancel,
        }); });
        this.invalidate(true, fetchMoreForQueryId);
        this.queryStore.initQuery({
            queryId: queryId,
            queryString: Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(query),
            document: query,
            storePreviousVariables: shouldFetch,
            variables: variables,
            isPoll: fetchType === __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].poll,
            isRefetch: fetchType === __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].refetch,
            metadata: metadata,
            fetchMoreForQueryId: fetchMoreForQueryId,
        });
        this.broadcastQueries();
        var shouldDispatchClientResult = !shouldFetch || fetchPolicy === 'cache-and-network';
        if (shouldDispatchClientResult) {
            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
            this.invalidate(true, queryId, fetchMoreForQueryId);
            this.broadcastQueries();
        }
        if (shouldFetch) {
            var networkResult = this.fetchRequest({
                requestId: requestId,
                queryId: queryId,
                document: query,
                options: options,
                fetchMoreForQueryId: fetchMoreForQueryId,
            }).catch(function (error) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["b" /* isApolloError */])(error)) {
                    throw error;
                }
                else {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    _this.removeFetchQueryPromise(requestId);
                    throw new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({ networkError: error });
                }
            });
            if (fetchPolicy !== 'cache-and-network') {
                return networkResult;
            }
            else {
                networkResult.catch(function () { });
            }
        }
        return Promise.resolve({ data: storeResult });
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        var previouslyHadError = false;
        return function (queryStoreValue, newData) {
            _this.invalidate(false, queryId);
            if (!queryStoreValue)
                return;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            if (fetchPolicy === 'standby')
                return;
            var errorPolicy = observableQuery
                ? observableQuery.options.errorPolicy
                : options.errorPolicy;
            var lastResult = observableQuery
                ? observableQuery.getLastResult()
                : null;
            var lastError = observableQuery ? observableQuery.getLastError() : null;
            var shouldNotifyIfLoading = (!newData && queryStoreValue.previousVariables != null) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            var networkStatusChanged = Boolean(lastResult &&
                queryStoreValue.networkStatus !== lastResult.networkStatus);
            var errorStatusChanged = errorPolicy &&
                (lastError && lastError.graphQLErrors) !==
                    queryStoreValue.graphQLErrors &&
                errorPolicy !== 'none';
            if (!Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                shouldNotifyIfLoading) {
                if (((!errorPolicy || errorPolicy === 'none') &&
                    queryStoreValue.graphQLErrors &&
                    queryStoreValue.graphQLErrors.length > 0) ||
                    queryStoreValue.networkError) {
                    var apolloError_1 = new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    });
                    previouslyHadError = true;
                    if (observer.error) {
                        try {
                            observer.error(apolloError_1);
                        }
                        catch (e) {
                            setTimeout(function () {
                                throw e;
                            }, 0);
                        }
                    }
                    else {
                        setTimeout(function () {
                            throw apolloError_1;
                        }, 0);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["v" /* isProduction */])()) {
                            console.info('An unhandled error was thrown because no error handler is registered ' +
                                'for the query ' +
                                queryStoreValue.queryString);
                        }
                    }
                    return;
                }
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                        data = newData.result;
                        isMissing = !newData.complete ? !newData.complete : false;
                    }
                    else {
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        }
                        else {
                            var document_1 = _this.getQuery(queryId).document;
                            var readResult = _this.dataStore.getCache().diff({
                                query: document_1,
                                variables: queryStoreValue.previousVariables ||
                                    queryStoreValue.variables,
                                optimistic: true,
                            });
                            data = readResult.result;
                            isMissing = !readResult.complete;
                        }
                    }
                    var resultFromStore = void 0;
                    if (isMissing && fetchPolicy !== 'cache-only') {
                        resultFromStore = {
                            data: lastResult && lastResult.data,
                            loading: Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: true,
                        };
                    }
                    else {
                        resultFromStore = {
                            data: data,
                            loading: Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: false,
                        };
                    }
                    if (errorPolicy === 'all' &&
                        queryStoreValue.graphQLErrors &&
                        queryStoreValue.graphQLErrors.length > 0) {
                        resultFromStore.errors = queryStoreValue.graphQLErrors;
                    }
                    if (observer.next) {
                        var isDifferentResult = !(lastResult &&
                            resultFromStore &&
                            lastResult.networkStatus === resultFromStore.networkStatus &&
                            lastResult.stale === resultFromStore.stale &&
                            lastResult.data === resultFromStore.data);
                        if (isDifferentResult || previouslyHadError) {
                            try {
                                observer.next(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["x" /* maybeDeepFreeze */])(resultFromStore));
                            }
                            catch (e) {
                                setTimeout(function () {
                                    throw e;
                                }, 0);
                            }
                        }
                    }
                    previouslyHadError = false;
                }
                catch (error) {
                    previouslyHadError = true;
                    if (observer.error)
                        observer.error(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({ networkError: error }));
                    return;
                }
            }
        };
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
        if (options.fetchPolicy === 'standby') {
            throw new Error('client.watchQuery cannot be called with fetchPolicy set to "standby"');
        }
        var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["m" /* getQueryDefinition */])(options.query);
        if (queryDefinition.variableDefinitions &&
            queryDefinition.variableDefinitions.length) {
            var defaultValues = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["e" /* getDefaultValues */])(queryDefinition);
            options.variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["c" /* assign */])({}, defaultValues, options.variables);
        }
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = __assign({}, options);
        return new __WEBPACK_IMPORTED_MODULE_9__ObservableQuery__["a" /* ObservableQuery */]({
            scheduler: this.scheduler,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
        if (!options.query) {
            throw new Error('query option is required. You must specify your GraphQL document in the query option.');
        }
        if (options.query.kind !== 'Document') {
            throw new Error('You must wrap the query string in a "gql" tag.');
        }
        if (options.returnPartialData) {
            throw new Error('returnPartialData option only supported on watchQuery.');
        }
        if (options.pollInterval) {
            throw new Error('pollInterval option only supported on watchQuery.');
        }
        if (typeof options.notifyOnNetworkStatusChange !== 'undefined') {
            throw new Error('Cannot call "query" with "notifyOnNetworkStatusChange" option. Only "watchQuery" has that option.');
        }
        options.notifyOnNetworkStatusChange = false;
        var requestId = this.idCounter;
        var resPromise = new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resPromise, resolve, reject);
            return _this.watchQuery(options, false)
                .result()
                .then(function (result) {
                _this.removeFetchQueryPromise(requestId);
                resolve(result);
            })
                .catch(function (error) {
                _this.removeFetchQueryPromise(requestId);
                reject(error);
            });
        });
        return resPromise;
    };
    QueryManager.prototype.generateQueryId = function () {
        var queryId = this.idCounter.toString();
        this.idCounter++;
        return queryId;
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.queryStore.stopQuery(queryId);
        this.invalidate(true, queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var _b = _a.listeners, listeners = _b === void 0 ? [] : _b;
            return ({
                listeners: listeners.concat([listener]),
                invalidate: false,
            });
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addFetchQueryPromise = function (requestId, promise, resolve, reject) {
        this.fetchQueryPromises.set(requestId.toString(), {
            promise: promise,
            resolve: resolve,
            reject: reject,
        });
    };
    QueryManager.prototype.removeFetchQueryPromise = function (requestId) {
        this.fetchQueryPromises.delete(requestId.toString());
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
        var queryDef = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["m" /* getQueryDefinition */])(observableQuery.options.query);
        if (queryDef.name && queryDef.name.value) {
            var queryName = queryDef.name.value;
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
            this.queryIdsByName[queryName].push(observableQuery.queryId);
        }
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var _a = this.getQuery(queryId), observableQuery = _a.observableQuery, cancel = _a.cancel;
        if (cancel)
            cancel();
        if (!observableQuery)
            return;
        var definition = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["m" /* getQueryDefinition */])(observableQuery.options.query);
        var queryName = definition.name ? definition.name.value : null;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (queryName) {
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
                return !(observableQuery.queryId === val);
            });
        }
    };
    QueryManager.prototype.resetStore = function () {
        this.fetchQueryPromises.forEach(function (_a) {
            var reject = _a.reject;
            reject(new Error('Store reset while query was in flight.'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        var dataStoreReset = this.dataStore.reset();
        var observableQueryPromises = this.getObservableQueryPromises();
        this.broadcastQueries();
        return dataStoreReset.then(function () { return Promise.all(observableQueryPromises); });
    };
    QueryManager.prototype.getObservableQueryPromises = function (includeStandby) {
        var _this = this;
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (!observableQuery)
                return;
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (fetchPolicy !== 'cache-only' &&
                (includeStandby || fetchPolicy !== 'standby')) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.setQuery(queryId, function () { return ({ newData: null }); });
            _this.invalidate(true, queryId);
        });
        return observableQueryPromises;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var observableQueryPromises = this.getObservableQueryPromises(includeStandby);
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (options) {
        var _this = this;
        var query = options.query;
        var cache = this.dataStore.getCache();
        var transformedDoc = cache.transformDocument(query);
        var variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["e" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["k" /* getOperationDefinition */])(query)), options.variables);
        var sub;
        var observers = [];
        return new __WEBPACK_IMPORTED_MODULE_6__util_Observable__["a" /* Observable */](function (observer) {
            observers.push(observer);
            if (observers.length === 1) {
                var handler = {
                    next: function (result) {
                        _this.dataStore.markSubscriptionResult(result, transformedDoc, variables);
                        _this.broadcastQueries();
                        observers.forEach(function (obs) {
                            if (obs.next)
                                obs.next(result);
                        });
                    },
                    error: function (error) {
                        observers.forEach(function (obs) {
                            if (obs.error)
                                obs.error(error);
                        });
                    },
                };
                var operation = _this.buildOperationForLink(transformedDoc, variables);
                sub = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* execute */])(_this.link, operation).subscribe(handler);
            }
            return function () {
                observers = observers.filter(function (obs) { return obs !== observer; });
                if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                }
            };
        });
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.removeQuery(queryId);
        this.stopQueryInStore(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        var subscriptions = this.getQuery(queryId).subscriptions;
        subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery) {
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["x" /* maybeDeepFreeze */])({ data: newData.result, partial: false });
        }
        else {
            try {
                var data = this.dataStore.getCache().read({
                    query: query,
                    variables: variables,
                    previousResult: lastResult ? lastResult.data : undefined,
                    optimistic: true,
                });
                return Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["x" /* maybeDeepFreeze */])({ data: data, partial: false });
            }
            catch (e) {
                return Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["x" /* maybeDeepFreeze */])({ data: {}, partial: true });
            }
        }
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            if (!foundObserveableQuery) {
                throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            }
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var data = this.getCurrentQueryResult(observableQuery).data;
        return {
            previousResult: data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (!info.invalidated || !info.listeners)
                return;
            info.listeners
                .filter(function (x) { return !!x; })
                .forEach(function (listener) {
                listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, context = options.context, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var operation = this.buildOperationForLink(document, variables, __assign({}, context, { forceFetch: !this.queryDeduplication }));
        var resultFromStore;
        var errorsFromStore;
        var retPromise = new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, retPromise, resolve, reject);
            var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* execute */])(_this.deduplicator, operation).subscribe({
                next: function (result) {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        if (fetchPolicy !== 'no-cache') {
                            try {
                                _this.dataStore.markQueryResult(result, document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        }
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (result.errors && errorPolicy === 'none') {
                        reject(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                            graphQLErrors: result.errors,
                        }));
                        return;
                    }
                    else if (errorPolicy === 'all') {
                        errorsFromStore = result.errors;
                    }
                    if (fetchMoreForQueryId) {
                        resultFromStore = result.data;
                    }
                    else {
                        try {
                            resultFromStore = _this.dataStore.getCache().read({
                                variables: variables,
                                query: document,
                                optimistic: false,
                            });
                        }
                        catch (e) { }
                    }
                },
                error: function (error) {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    reject(error);
                },
                complete: function () {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: __WEBPACK_IMPORTED_MODULE_10__networkStatus__["a" /* NetworkStatus */].ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                return ({
                    subscriptions: subscriptions.concat([subscription]),
                });
            });
        });
        return retPromise;
    };
    QueryManager.prototype.refetchQueryByName = function (queryName) {
        var _this = this;
        var refetchedQueries = this.queryIdsByName[queryName];
        if (refetchedQueries === undefined)
            return;
        return Promise.all(refetchedQueries
            .map(function (id) { return _this.getQuery(id).observableQuery; })
            .filter(function (x) { return !!x; })
            .map(function (x) { return x.refetch(); }));
    };
    QueryManager.prototype.generateRequestId = function () {
        var requestId = this.idCounter;
        this.idCounter++;
        return requestId;
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return this.queries.get(queryId) || __assign({}, defaultQueryInfo);
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = __assign({}, prev, updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (invalidated, queryId, fetchMoreForQueryId) {
        if (queryId)
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        if (fetchMoreForQueryId) {
            this.setQuery(fetchMoreForQueryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.buildOperationForLink = function (document, variables, extraContext) {
        var cache = this.dataStore.getCache();
        return {
            query: cache.transformForLink
                ? cache.transformForLink(document)
                : document,
            variables: variables,
            operationName: Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["l" /* getOperationName */])(document) || undefined,
            context: __assign({}, extraContext, { cache: cache, getCacheKey: function (obj) {
                    if (cache.config) {
                        return cache.config.dataIdFromObject(obj);
                    }
                    else {
                        throw new Error('To use context.getCacheKey, you need to use a cache that has a configurable dataIdFromObject, like apollo-cache-inmemory.');
                    }
                } }),
        };
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dedupLink__ = __webpack_require__(980);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dedupLink__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DedupLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(155);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DedupLink = (function (_super) {
    __extends(DedupLink, _super);
    function DedupLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFlightRequestObservables = new Map();
        _this.subscribers = new Map();
        return _this;
    }
    DedupLink.prototype.request = function (operation, forward) {
        var _this = this;
        if (operation.getContext().forceFetch) {
            return forward(operation);
        }
        var key = operation.toKey();
        var cleanup = function (key) {
            _this.inFlightRequestObservables.delete(key);
            var prev = _this.subscribers.get(key);
            return prev;
        };
        if (!this.inFlightRequestObservables.get(key)) {
            var singleObserver_1 = forward(operation);
            var subscription_1;
            var sharedObserver = new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["b" /* Observable */](function (observer) {
                var prev = _this.subscribers.get(key);
                if (!prev)
                    prev = { next: [], error: [], complete: [] };
                _this.subscribers.set(key, {
                    next: prev.next.concat([observer.next.bind(observer)]),
                    error: prev.error.concat([observer.error.bind(observer)]),
                    complete: prev.complete.concat([observer.complete.bind(observer)]),
                });
                if (!subscription_1) {
                    subscription_1 = singleObserver_1.subscribe({
                        next: function (result) {
                            var prev = cleanup(key);
                            _this.subscribers.delete(key);
                            if (prev) {
                                prev.next.forEach(function (next) { return next(result); });
                                prev.complete.forEach(function (complete) { return complete(); });
                            }
                        },
                        error: function (error) {
                            var prev = cleanup(key);
                            _this.subscribers.delete(key);
                            if (prev)
                                prev.error.forEach(function (err) { return err(error); });
                        },
                    });
                }
                return function () {
                    if (subscription_1)
                        subscription_1.unsubscribe();
                    _this.inFlightRequestObservables.delete(key);
                };
            });
            this.inFlightRequestObservables.set(key, sharedObserver);
        }
        return this.inFlightRequestObservables.get(key);
    };
    return DedupLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */]));

//# sourceMappingURL=dedupLink.js.map

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export empty */
/* unused harmony export from */
/* unused harmony export split */
/* unused harmony export concat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* unused harmony export execute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(398);


var passthrough = function (op, forward) { return (forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()); };
var toLink = function (handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
};
var empty = function () {
    return new ApolloLink(function (op, forward) { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); });
};
var from = function (links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
};
var split = function (test, left, right) {
    if (right === void 0) { right = new ApolloLink(passthrough); }
    var leftLink = toLink(left);
    var rightLink = toLink(right);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["d" /* isTerminating */])(leftLink) && Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["d" /* isTerminating */])(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
};
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["d" /* isTerminating */])(firstLink)) {
        console.warn(new __WEBPACK_IMPORTED_MODULE_1__linkUtils__["a" /* LinkError */]("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["d" /* isTerminating */])(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        if (right === void 0) { right = new ApolloLink(passthrough); }
        return this.concat(split(test, left, right));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw new Error('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());

function execute(link, operation) {
    return (link.request(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["b" /* createOperation */])(operation.context, Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* transformOperation */])(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["f" /* validateOperation */])(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
}
//# sourceMappingURL=link.js.map

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(983);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments__ = __webpack_require__(984);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFromAST__ = __webpack_require__(399);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform__ = __webpack_require__(985);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storeUtils__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_assign__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_environment__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__ = __webpack_require__(986);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isEqual__ = __webpack_require__(987);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__ = __webpack_require__(988);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__ = __webpack_require__(989);
/* unused harmony namespace reexport */












//# sourceMappingURL=index.js.map

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDirectiveInfoFromField */
/* unused harmony export shouldInclude */
/* unused harmony export flattenSelections */
/* unused harmony export getDirectiveNames */
/* unused harmony export hasDirectives */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storeUtils__ = __webpack_require__(249);

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = Object(__WEBPACK_IMPORTED_MODULE_0__storeUtils__["a" /* argumentsObjectFromField */])(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
        }
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
        if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
        }
        var ifArgument = directiveArguments[0];
        if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
        }
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
            if (ifValue.kind !== 'Variable') {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            }
            else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === undefined) {
                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
            }
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function flattenSelections(selection) {
    if (!selection.selectionSet ||
        !(selection.selectionSet.selections.length > 0))
        return [selection];
    return [selection].concat(selection.selectionSet.selections
        .map(function (selectionNode) {
        return [selectionNode].concat(flattenSelections(selectionNode));
    })
        .reduce(function (selections, selected) { return selections.concat(selected); }, []));
}
var added = new Map();
function getDirectiveNames(doc) {
    var cached = added.get(doc);
    if (cached)
        return cached;
    var directives = doc.definitions
        .filter(function (definition) {
        return definition.selectionSet && definition.selectionSet.selections;
    })
        .map(function (x) { return flattenSelections(x); })
        .reduce(function (selections, selected) { return selections.concat(selected); }, [])
        .filter(function (selection) {
        return selection.directives && selection.directives.length > 0;
    })
        .map(function (selection) { return selection.directives; })
        .reduce(function (directives, directive) { return directives.concat(directive); }, [])
        .map(function (directive) { return directive.name.value; });
    added.set(doc, directives);
    return directives;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
//# sourceMappingURL=directives.js.map

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFragmentQueryDocument */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        }
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}
//# sourceMappingURL=fragments.js.map

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDirectivesFromDocument */
/* unused harmony export addTypenameToDocument */
/* unused harmony export removeConnectionDirectiveFromDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFromAST__ = __webpack_require__(399);


var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    if (selectionSet.selections) {
        if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
                return (selection.kind === 'Field' &&
                    selection.name.value === '__typename');
            });
            if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD);
            }
        }
        selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field') {
                if (selection.name.value.lastIndexOf('__', 0) !== 0 &&
                    selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
            else if (selection.kind === 'InlineFragment') {
                if (selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
        });
    }
}
function removeDirectivesFromSelectionSet(directives, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    var agressiveRemove = directives.some(function (dir) { return dir.remove; });
    selectionSet.selections = selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.directives)
            return selection;
        var remove;
        selection.directives = selection.directives.filter(function (directive) {
            var shouldKeep = !directives.some(function (dir) {
                if (dir.name && dir.name === directive.name.value)
                    return true;
                if (dir.test && dir.test(directive))
                    return true;
                return false;
            });
            if (!remove && !shouldKeep && agressiveRemove)
                remove = true;
            return shouldKeep;
        });
        return remove ? null : selection;
    })
        .filter(function (x) { return !!x; });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
    });
    return selectionSet;
}
function removeDirectivesFromDocument(directives, doc) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        removeDirectivesFromSelectionSet(directives, definition.selectionSet);
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["c" /* getFragmentDefinitions */])(docClone));
    var isNotEmpty = function (op) {
        return op.selectionSet.selections.filter(function (selectionSet) {
            return !(selectionSet &&
                selectionSet.kind === 'FragmentSpread' &&
                !isNotEmpty(fragments[selectionSet.name.value]));
        }).length > 0;
    };
    return isNotEmpty(operation) ? docClone : null;
}
var added = new Map();
function addTypenameToDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var cached = added.get(doc);
    if (cached)
        return cached;
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        var isRoot = definition.kind === 'OperationDefinition';
        addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    added.set(doc, docClone);
    return docClone;
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
var removed = new Map();
function removeConnectionDirectiveFromDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var cached = removed.get(doc);
    if (cached)
        return cached;
    var docClone = removeDirectivesFromDocument([connectionRemoveConfig], doc);
    removed.set(doc, docClone);
    return docClone;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tryFunctionOrLogError */
/* unused harmony export graphQLResultHasError */
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEqual */
function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        for (var key in b) {
            if (!Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=isEqual.js.map

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export maybeDeepFreeze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(250);

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["a" /* isDevelopment */])() || Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
        return deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warnOnceInDevelopment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(250);

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["b" /* isProduction */])()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}
//# sourceMappingURL=warnOnce.js.map

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_types__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(112);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var QueryScheduler = (function () {
    function QueryScheduler(_a) {
        var queryManager = _a.queryManager, ssrMode = _a.ssrMode;
        this.inFlightQueries = {};
        this.registeredQueries = {};
        this.intervalQueries = {};
        this.pollingTimers = {};
        this.ssrMode = false;
        this.queryManager = queryManager;
        this.ssrMode = ssrMode || false;
    }
    QueryScheduler.prototype.checkInFlight = function (queryId) {
        var query = this.queryManager.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready &&
            query.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].error);
    };
    QueryScheduler.prototype.fetchQuery = function (queryId, options, fetchType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queryManager
                .fetchQuery(queryId, options, fetchType)
                .then(function (result) {
                resolve(result);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    QueryScheduler.prototype.startPollingQuery = function (options, queryId, listener) {
        if (!options.pollInterval) {
            throw new Error('Attempted to start a polling query without a polling interval.');
        }
        if (this.ssrMode)
            return queryId;
        this.registeredQueries[queryId] = options;
        if (listener) {
            this.queryManager.addQueryListener(queryId, listener);
        }
        this.addQueryOnInterval(queryId, options);
        return queryId;
    };
    QueryScheduler.prototype.stopPollingQuery = function (queryId) {
        delete this.registeredQueries[queryId];
    };
    QueryScheduler.prototype.fetchQueriesOnInterval = function (interval) {
        var _this = this;
        this.intervalQueries[interval] = this.intervalQueries[interval].filter(function (queryId) {
            if (!(_this.registeredQueries.hasOwnProperty(queryId) &&
                _this.registeredQueries[queryId].pollInterval === interval)) {
                return false;
            }
            if (_this.checkInFlight(queryId)) {
                return true;
            }
            var queryOptions = _this.registeredQueries[queryId];
            var pollingOptions = __assign({}, queryOptions);
            pollingOptions.fetchPolicy = 'network-only';
            _this.fetchQuery(queryId, pollingOptions, __WEBPACK_IMPORTED_MODULE_0__core_types__["a" /* FetchType */].poll).catch(function () { });
            return true;
        });
        if (this.intervalQueries[interval].length === 0) {
            clearInterval(this.pollingTimers[interval]);
            delete this.intervalQueries[interval];
        }
    };
    QueryScheduler.prototype.addQueryOnInterval = function (queryId, queryOptions) {
        var _this = this;
        var interval = queryOptions.pollInterval;
        if (!interval) {
            throw new Error("A poll interval is required to start polling query with id '" + queryId + "'.");
        }
        if (this.intervalQueries.hasOwnProperty(interval.toString()) &&
            this.intervalQueries[interval].length > 0) {
            this.intervalQueries[interval].push(queryId);
        }
        else {
            this.intervalQueries[interval] = [queryId];
            this.pollingTimers[interval] = setInterval(function () {
                _this.fetchQueriesOnInterval(interval);
            }, interval);
        }
    };
    QueryScheduler.prototype.registerPollingQuery = function (queryOptions) {
        if (!queryOptions.pollInterval) {
            throw new Error('Attempted to register a non-polling query with the scheduler.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__["a" /* ObservableQuery */]({
            scheduler: this,
            options: queryOptions,
        });
    };
    return QueryScheduler;
}());

//# sourceMappingURL=scheduler.js.map

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationStore; });
var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutationString, variables) {
        this.store[mutationId] = {
            mutationString: mutationString,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = error;
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = null;
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

//# sourceMappingURL=mutations.js.map

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__ = __webpack_require__(112);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
        if (previousQuery && previousQuery.queryString !== query.queryString) {
            throw new Error('Internal Error: may not update existing query string in store');
        }
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].loading) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["q" /* isEqual */])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].setVariables;
        }
        else if (query.isPoll) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].poll;
        }
        else if (query.isRefetch) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].refetch;
        }
        else {
            networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            queryString: query.queryString,
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string') {
            this.store[query.fetchMoreForQueryId].networkStatus =
                __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors =
            result.errors && result.errors.length ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].ready;
        if (typeof fetchMoreForQueryId === 'string') {
            this.store[fetchMoreForQueryId].networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryError(fetchMoreForQueryId, error, undefined);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = complete
            ? __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].ready
            : __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].loading;
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        this.store = Object.keys(this.store)
            .filter(function (queryId) {
            return observableQueryIds.indexOf(queryId) > -1;
        })
            .reduce(function (res, key) {
            res[key] = __assign({}, _this.store[key], { networkStatus: __WEBPACK_IMPORTED_MODULE_1__core_networkStatus__["a" /* NetworkStatus */].loading });
            return res;
        }, {});
    };
    return QueryStore;
}());

//# sourceMappingURL=queries.js.map

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(41);

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["o" /* graphQLResultHasError */])(result);
        if (ignoreErrors && Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["o" /* graphQLResultHasError */])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["o" /* graphQLResultHasError */])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            var changeFn_1 = function () {
                _this.markMutationResult({
                    mutationId: mutation.mutationId,
                    result: { data: optimistic_1 },
                    document: mutation.document,
                    variables: mutation.variables,
                    updateQueries: mutation.updateQueries,
                    update: mutation.update,
                });
            };
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    changeFn_1();
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["o" /* graphQLResultHasError */])(mutation.result)) {
            var cacheWrites_1 = [];
            cacheWrites_1.push({
                result: mutation.result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            if (mutation.updateQueries) {
                Object.keys(mutation.updateQueries)
                    .filter(function (id) { return mutation.updateQueries[id]; })
                    .forEach(function (queryId) {
                    var _a = mutation.updateQueries[queryId], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (!complete) {
                        return;
                    }
                    var nextQueryResult = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["D" /* tryFunctionOrLogError */])(function () {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["l" /* getOperationName */])(query.document) || undefined,
                            queryVariables: query.variables,
                        });
                    });
                    if (nextQueryResult) {
                        cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables,
                        });
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
            });
            var update_1 = mutation.update;
            if (update_1) {
                this.cache.performTransaction(function (c) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["D" /* tryFunctionOrLogError */])(function () { return update_1(c, mutation.result); });
                });
            }
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (!optimisticResponse)
            return;
        this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

//# sourceMappingURL=store.js.map

/***/ }),
/* 994 */
/***/ (function(module, exports) {

exports.version = "2.2.6"

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(996);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(252),
    flatRest = __webpack_require__(377),
    getData = __webpack_require__(402),
    getFuncName = __webpack_require__(403),
    isArray = __webpack_require__(23),
    isLaziable = __webpack_require__(1000);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(364);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 999 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(254),
    getData = __webpack_require__(402),
    getFuncName = __webpack_require__(403),
    lodash = __webpack_require__(1001);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(254),
    LodashWrapper = __webpack_require__(252),
    baseLodash = __webpack_require__(253),
    isArray = __webpack_require__(23),
    isObjectLike = __webpack_require__(50),
    wrapperClone = __webpack_require__(1002);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(254),
    LodashWrapper = __webpack_require__(252),
    copyArray = __webpack_require__(222);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return captureInsecureRedirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_react__ = __webpack_require__(404);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InsecureRedirectError=function(_Error){_inherits(InsecureRedirectError,_Error);function InsecureRedirectError(){var _ref;_classCallCheck(this,InsecureRedirectError);for(var _len=arguments.length,params=Array(_len),_key=0;_key<_len;_key++){params[_key]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=InsecureRedirectError.__proto__||Object.getPrototypeOf(InsecureRedirectError)).call.apply(_ref,[this].concat(params)));_this.name='InsecureRedirectError';return _this;}return InsecureRedirectError;}(Error);var captureInsecureRedirect=function captureInsecureRedirect(uri){return __WEBPACK_IMPORTED_MODULE_0__sentry_react__["a" /* captureException */](new InsecureRedirectError('Insecure redirect attempt to '+uri));};

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(61);
/* unused harmony reexport Severity */
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["e"]; });
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["f"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* unused harmony reexport configureScope */
/* unused harmony reexport getHubFromCarrier */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["h"]; });
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport Scope */
/* unused harmony reexport startTransaction */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(412);
/* unused harmony reexport BrowserClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(114);
/* unused harmony reexport injectReportDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(258);
/* unused harmony reexport eventFromException */
/* unused harmony reexport eventFromMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sdk__ = __webpack_require__(1032);
/* unused harmony reexport defaultIntegrations */
/* unused harmony reexport forceLoad */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["a"]; });
/* unused harmony reexport lastEventId */
/* unused harmony reexport onLoad */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["b"]; });
/* unused harmony reexport flush */
/* unused harmony reexport close */
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__version__ = __webpack_require__(415);
/* unused harmony reexport SDK_NAME */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__version__["b"]; });







//# sourceMappingURL=exports.js.map

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
// eslint-disable-next-line import/export
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
// eslint-disable-next-line import/export
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        // eslint-disable-next-line no-plusplus
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    /* eslint-disable no-param-reassign */
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    /* eslint-enable no-param-reassign */
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(409);


/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addInstrumentationHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__object__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__supports__ = __webpack_require__(410);






var global = Object(__WEBPACK_IMPORTED_MODULE_3__misc__["f" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(__WEBPACK_IMPORTED_MODULE_3__misc__["e" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["c" /* supportsNativeFetch */])()) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var commonHandlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, commonHandlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, commonHandlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, commonHandlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["b" /* supportsHistory */])()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'pushState', historyReplacementFunction);
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    ['EventTarget', 'Node'].forEach(function (target) {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === 'click') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                    if (eventName === 'keypress') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                }
                else {
                    if (eventName === 'click') {
                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
                    }
                    if (eventName === 'keypress') {
                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
                    }
                }
                return original.call(this, eventName, fn, options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(function () {
                handler({ event: event, name: name });
            });
        }
        else {
            handler({ event: event, name: name });
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            domEventHandler('input', handler)(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(255);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */])(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) {
                projectId = projectMatch[0];
            }
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": " + component + " missing");
            }
        });
        if (!this.projectId.match(/^\d+$/)) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid port " + this.port);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_VERSION */
/* unused harmony export Hub */
/* unused harmony export getMainCarrier */
/* unused harmony export makeMain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentHub;
/* unused harmony export getHubFromCarrier */
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(406);



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [];
        this._stack.push({ client: client, scope: scope });
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["M" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["M" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["M" /* uuid4 */])());
        this._invokeClient('captureEvent', event, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["J" /* timestampWithMs */])();
        var mergedBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["h" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            callback(top.scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client) {
            return null;
        }
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context) {
        return this._callExtensionMethod('startTransaction', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = top.client)[method].apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args, [top.scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* logger */].warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["w" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var property = 'domain';
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (!sentry || !sentry.extensions || !sentry.extensions[property]) {
            return getHubFromCarrier(registry);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var domain = sentry.extensions[property];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    return false;
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(10);

var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return this._getIngestEndpoint('store');
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */
    API.prototype._getEnvelopeEndpoint = function () {
        return this._getIngestEndpoint('envelope');
    };
    /** Returns the ingest API endpoint for target. */
    API.prototype._getIngestEndpoint = function (target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */
    API.prototype._encodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["L" /* urlEncode */])(auth);
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integration__ = __webpack_require__(1017);

/* eslint-disable max-lines */



/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["a" /* Dsn */](options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) {
            eventId = _this.captureEvent(event, hint, scope);
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["y" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promisedEvent.then(function (event) {
            eventId = _this.captureEvent(event, hint, scope);
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope)
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return status.ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_3__integration__["a" /* setupIntegrations */])(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true,
                    });
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false,
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["M" /* uuid4 */])()), timestamp: event.timestamp || Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* timestampWithMs */])() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* Scope */].clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, b), (b.data && {
                data: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(b.data, depth),
            }))); }),
        })), (event.user && {
            user: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(event.user, depth),
        })), (event.contexts && {
            contexts: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(event.contexts, depth),
        })), (event.extra && {
            extra: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        if (event.environment === undefined && environment !== undefined) {
            event.environment = environment;
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* truncate */])(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* truncate */])(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* truncate */])(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint)
                .then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                // We skip beforeSend in case of transactions
                if (isInternalException || !beforeSend || isTransaction) {
                    _this._sendEvent(finalEvent);
                    resolve(finalEvent);
                    return;
                }
                var beforeSendResult = beforeSend(prepared, hint);
                if (typeof beforeSendResult === 'undefined') {
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["A" /* isThenable */])(beforeSendResult)) {
                    _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                }
                else {
                    finalEvent = beforeSendResult;
                    if (finalEvent === null) {
                        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                        resolve(null);
                        return;
                    }
                    // From here on we are really async
                    _this._sendEvent(finalEvent);
                    resolve(finalEvent);
                }
            })
                .then(null, function (reason) {
                _this.captureException(reason, {
                    data: {
                        __sentry__: true,
                    },
                    originalException: reason,
                });
                reject("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend
            .then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._sendEvent(processedEvent);
            resolve(processedEvent);
        })
            .then(null, function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(411);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventToSentryRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(10);

/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var useEnvelope = event.type === 'transaction';
    var req = {
        body: JSON.stringify(event),
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify({
            event_id: event.event_id,
            // We need to add * 1000 since we divide it by 1000 by default but JS works with ms precision
            // The reason we use timestampWithMs here is that all clocks across the SDK use the same clock
            sent_at: new Date(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* timestampWithMs */])() * 1000).toISOString(),
        });
        var itemHeaders = JSON.stringify({
            type: event.type,
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
//# sourceMappingURL=request.js.map

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* logger */].enable();
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["c" /* getCurrentHub */])();
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(1022);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(1023);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry_original__ || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(414);






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromException */])(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info; }
        return Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromMessage */])(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._options.transportOptions), { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["a" /* FetchTransport */](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["b" /* XHRTransport */](transportOptions);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(260);





var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FetchTransport, _super);
    function FetchTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        var sentryReq = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* eventToSentryRequest */])(event, this._api);
        var options = {
            body: sentryReq.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            global
                .fetch(sentryReq.url, options)
                .then(function (response) {
                var status = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].fromHttpCode(response.status);
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    /**
                     * "The name is case-insensitive."
                     * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
                     */
                    var retryAfterHeader = response.headers.get('Retry-After');
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* parseRetryAfterHeader */])(now, retryAfterHeader));
                    __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(response);
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(260);





/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        var sentryReq = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* eventToSentryRequest */])(event, this._api);
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                var status = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].fromHttpCode(request.status);
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    /**
                     * "The search for the header name is case-insensitive."
                     * https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getResponseHeader
                     */
                    var retryAfterHeader = request.getResponseHeader('Retry-After');
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* parseRetryAfterHeader */])(now, retryAfterHeader));
                    __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(request);
            };
            request.open('POST', sentryReq.url);
            for (var header in _this.options.headers) {
                if (_this.options.headers.hasOwnProperty(header)) {
                    request.setRequestHeader(header, _this.options.headers[header]);
                }
            }
            request.send(sentryReq.body);
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(114);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */





/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        var _this = this;
        if (this._onErrorHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (data) {
                var error = data.error;
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
                    : _this._enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["c" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: false,
                    }), data.url, data.line, data.column);
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onerror',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
            },
            type: 'error',
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ('reason' in e) {
                        error = e.reason;
                    }
                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                    // https://github.com/getsentry/sentry-javascript/issues/2380
                    else if ('detail' in e && 'reason' in e.detail) {
                        error = e.detail.reason;
                    }
                }
                catch (_oO) {
                    // no-empty
                }
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return true;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteRejection(error)
                    : Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["c" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: true,
                    });
                event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onunhandledrejection',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
                return;
            },
            type: 'unhandledrejection',
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["s" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (error) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with value: " + error,
                    },
                ],
            },
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isString */])(url) && url.length > 0 ? url : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(114);



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
        if (this._options.setTimeout) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        }
        if (this._options.setInterval) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        }
        if (this._options.requestAnimationFrame) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in xhr && typeof xhr[prop] === 'function') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(xhr, prop, function (original) {
                        var wrapOptions = {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        };
                        // If Instrument integration has been called before TryCatch, get the name of original function
                        if (original.__sentry_original__) {
                            wrapOptions.mechanism.data.handler = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original.__sentry_original__);
                        }
                        // Otherwise wrap directly
                        return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(original, wrapOptions);
                    });
                }
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(10);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["k" /* getEventDescription */])(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'history',
            });
        }
    };
    /**
     * Creates breadcrumbs from console API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console',
            },
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(handlerData.level),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* safeJoin */])(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* htmlTreeAsString */])(handlerData.event.target)
                : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* htmlTreeAsString */])(handlerData.event);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: 'xhr',
                data: handlerData.xhr.__sentry_xhr__,
                type: 'http',
            }, {
                xhr: handlerData.xhr,
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: handlerData.fetchData,
                level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData.fetchData), { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* parseUrl */])(global.location.href);
        var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* parseUrl */])(from);
        var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* parseUrl */])(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(259);





var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultIntegrations */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony export (immutable) */ __webpack_exports__["b"] = showReportDialog;
/* unused harmony export lastEventId */
/* unused harmony export forceLoad */
/* unused harmony export onLoad */
/* unused harmony export flush */
/* unused harmony export close */
/* unused harmony export wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(261);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* wrap */])(fn)();
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNKNOWN_COMPONENT */
/* unused harmony export withProfiler */
/* unused harmony export Profiler */
/* unused harmony export useProfiler */
/* unused harmony export getActiveTransaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);

/* eslint-disable @typescript-eslint/no-explicit-any */




var UNKNOWN_COMPONENT = 'unknown';
var TRACING_GETTER = {
    id: 'Tracing',
};
var globalTracingIntegration = null;
/** @deprecated remove when @sentry/apm no longer used */
var getTracingIntegration = function () {
    if (globalTracingIntegration) {
        return globalTracingIntegration;
    }
    globalTracingIntegration = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["d" /* getCurrentHub */])().getIntegration(TRACING_GETTER);
    return globalTracingIntegration;
};
/**
 * pushActivity creates an new react activity.
 * Is a no-op if Tracing integration is not valid
 * @param name displayName of component that started activity
 * @deprecated remove when @sentry/apm no longer used
 */
function pushActivity(name, op) {
    if (globalTracingIntegration === null) {
        return null;
    }
    return globalTracingIntegration.constructor.pushActivity(name, {
        description: "<" + name + ">",
        op: "react." + op,
    });
}
/**
 * popActivity removes a React activity.
 * Is a no-op if Tracing integration is not valid.
 * @param activity id of activity that is being popped
 * @deprecated remove when @sentry/apm no longer used
 */
function popActivity(activity) {
    if (activity === null || globalTracingIntegration === null) {
        return;
    }
    globalTracingIntegration.constructor.popActivity(activity);
}
/**
 * Obtain a span given an activity id.
 * Is a no-op if Tracing integration is not valid.
 * @param activity activity id associated with obtained span
 * @deprecated remove when @sentry/apm no longer used
 */
function getActivitySpan(activity) {
    if (activity === null || globalTracingIntegration === null) {
        return undefined;
    }
    return globalTracingIntegration.constructor.getActivitySpan(activity);
}
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
var Profiler = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Profiler, _super);
    function Profiler(props) {
        var _this = _super.call(this, props) || this;
        // The activity representing how long it takes to mount a component.
        _this._mountActivity = null;
        // The span of the mount activity
        _this._mountSpan = undefined;
        var _a = _this.props, name = _a.name, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
        if (disabled) {
            return _this;
        }
        // If they are using @sentry/apm, we need to push/pop activities
        // eslint-disable-next-line deprecation/deprecation
        if (getTracingIntegration()) {
            // eslint-disable-next-line deprecation/deprecation
            _this._mountActivity = pushActivity(name, 'mount');
        }
        else {
            var activeTransaction = getActiveTransaction();
            if (activeTransaction) {
                _this._mountSpan = activeTransaction.startChild({
                    description: "<" + name + ">",
                    op: 'react.mount',
                });
            }
        }
        return _this;
    }
    // If a component mounted, we can finish the mount activity.
    Profiler.prototype.componentDidMount = function () {
        if (this._mountSpan) {
            this._mountSpan.finish();
        }
        else {
            // eslint-disable-next-line deprecation/deprecation
            this._mountSpan = getActivitySpan(this._mountActivity);
            // eslint-disable-next-line deprecation/deprecation
            popActivity(this._mountActivity);
            this._mountActivity = null;
        }
    };
    Profiler.prototype.componentDidUpdate = function (_a) {
        var _this = this;
        var updateProps = _a.updateProps, _b = _a.includeUpdates, includeUpdates = _b === void 0 ? true : _b;
        // Only generate an update span if hasUpdateSpan is true, if there is a valid mountSpan,
        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
        // We are just trying to give baseline clues for further investigation.
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            // See what props haved changed between the previous props, and the current props. This is
            // set as data on the span. We just store the prop keys as the values could be potenially very large.
            var changedProps = Object.keys(updateProps).filter(function (k) { return updateProps[k] !== _this.props.updateProps[k]; });
            if (changedProps.length > 0) {
                // The update span is a point in time span with 0 duration, just signifying that the component
                // has been updated.
                var now = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* timestampWithMs */])();
                this._mountSpan.startChild({
                    data: {
                        changedProps: changedProps,
                    },
                    description: "<" + this.props.name + ">",
                    endTimestamp: now,
                    op: "react.update",
                    startTimestamp: now,
                });
            }
        }
    };
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    Profiler.prototype.componentWillUnmount = function () {
        var _a = this.props, name = _a.name, _b = _a.includeRender, includeRender = _b === void 0 ? true : _b;
        if (this._mountSpan && includeRender) {
            // If we were able to obtain the spanId of the mount activity, we should set the
            // next activity as a child to the component mount activity.
            this._mountSpan.startChild({
                description: "<" + name + ">",
                endTimestamp: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* timestampWithMs */])(),
                op: "react.render",
                startTimestamp: this._mountSpan.endTimestamp,
            });
        }
    };
    Profiler.prototype.render = function () {
        return this.props.children;
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    Profiler.defaultProps = {
        disabled: false,
        includeRender: true,
        includeUpdates: true,
    };
    return Profiler;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]));
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
function withProfiler(WrappedComponent, 
// We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    var componentDisplayName = (options && options.name) || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function (props) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Profiler, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options, { name: componentDisplayName, updateProps: props }),
        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props)))); };
    Wrapped.displayName = "profiler(" + componentDisplayName + ")";
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(name, options) {
    if (options === void 0) { options = {
        disabled: false,
        hasRenderSpan: true,
    }; }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */])(__WEBPACK_IMPORTED_MODULE_4_react__["useState"](function () {
        if (options && options.disabled) {
            return undefined;
        }
        var activeTransaction = getActiveTransaction();
        if (activeTransaction) {
            return activeTransaction.startChild({
                description: "<" + name + ">",
                op: 'react.mount',
            });
        }
        return undefined;
    }), 1), mountSpan = _a[0];
    __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
        if (mountSpan) {
            mountSpan.finish();
        }
        return function () {
            if (mountSpan && options.hasRenderSpan) {
                mountSpan.startChild({
                    description: "<" + name + ">",
                    endTimestamp: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* timestampWithMs */])(),
                    op: "react.render",
                    startTimestamp: mountSpan.endTimestamp,
                });
            }
        };
        // We only want this to run once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

/** Grabs active transaction off scope */
function getActiveTransaction(hub) {
    if (hub === void 0) { hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["d" /* getCurrentHub */])(); }
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            return scope.getTransaction();
        }
    }
    return undefined;
}
//# sourceMappingURL=profiler.js.map

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNKNOWN_COMPONENT */
/* unused harmony export ErrorBoundary */
/* unused harmony export withErrorBoundary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null,
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * Requires React >= 16
 */
var ErrorBoundary = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = INITIAL_STATE;
        _this.resetErrorBoundary = function () {
            var onReset = _this.props.onReset;
            var _a = _this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
            if (onReset) {
                onReset(error, componentStack, eventId);
            }
            _this.setState(INITIAL_STATE);
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, _a) {
        var _this = this;
        var componentStack = _a.componentStack;
        var _b = this.props, beforeCapture = _b.beforeCapture, onError = _b.onError, showDialog = _b.showDialog, dialogOptions = _b.dialogOptions;
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["g" /* withScope */])(function (scope) {
            if (beforeCapture) {
                beforeCapture(scope, error, componentStack);
            }
            var eventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["c" /* captureException */])(error, { contexts: { react: { componentStack: componentStack } } });
            if (onError) {
                onError(error, componentStack, eventId);
            }
            if (showDialog) {
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["f" /* showReportDialog */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, dialogOptions), { eventId: eventId }));
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            _this.setState({ error: error, componentStack: componentStack, eventId: eventId });
        });
    };
    ErrorBoundary.prototype.componentDidMount = function () {
        var onMount = this.props.onMount;
        if (onMount) {
            onMount();
        }
    };
    ErrorBoundary.prototype.componentWillUnmount = function () {
        var _a = this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
        var onUnmount = this.props.onUnmount;
        if (onUnmount) {
            onUnmount(error, componentStack, eventId);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var fallback = this.props.fallback;
        var _a = this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
        if (error) {
            if (__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](fallback)) {
                return fallback;
            }
            if (typeof fallback === 'function') {
                return fallback({ error: error, componentStack: componentStack, resetError: this.resetErrorBoundary, eventId: eventId });
            }
            // Fail gracefully if no fallback provided
            return null;
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function (props) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ErrorBoundary, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, errorBoundaryOptions),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props)))); };
    Wrapped.displayName = "errorBoundary(" + componentDisplayName + ")";
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Wrapped, WrappedComponent);
    return Wrapped;
}

//# sourceMappingURL=errorboundary.js.map

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createReduxEnhancer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_minimal__ = __webpack_require__(405);

/* eslint-disable @typescript-eslint/no-explicit-any */

var ACTION_BREADCRUMB_CATEGORY = 'redux.action';
var ACTION_BREADCRUMB_TYPE = 'info';
var STATE_CONTEXT_KEY = 'redux.state';
var defaultOptions = {
    actionTransformer: function (action) { return action; },
    stateTransformer: function (state) { return state || null; },
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */
function createReduxEnhancer(enhancerOptions) {
    var options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, defaultOptions), enhancerOptions);
    return function (next) { return function (reducer, initialState) {
        var sentryReducer = function (state, action) {
            var newState = reducer(state, action);
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_minimal__["b" /* configureScope */])(function (scope) {
                /* Action breadcrumbs */
                var transformedAction = options.actionTransformer(action);
                if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
                    scope.addBreadcrumb({
                        category: ACTION_BREADCRUMB_CATEGORY,
                        data: transformedAction,
                        type: ACTION_BREADCRUMB_TYPE,
                    });
                }
                /* Set latest state to scope */
                var transformedState = options.stateTransformer(newState);
                if (typeof transformedState !== 'undefined' && transformedState !== null) {
                    scope.setContext(STATE_CONTEXT_KEY, transformedState);
                }
                else {
                    scope.setContext(STATE_CONTEXT_KEY, null);
                }
                /* Allow user to configure scope with latest state */
                // eslint-disable-next-line @typescript-eslint/unbound-method
                var configureScopeWithState = options.configureScopeWithState;
                if (typeof configureScopeWithState === 'function') {
                    configureScopeWithState(scope, newState);
                }
            });
            return newState;
        };
        return next(sentryReducer, initialState);
    }; };
}

//# sourceMappingURL=redux.js.map

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reactRouterV3Instrumentation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(10);

var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getGlobalObject */])();
/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 */
function reactRouterV3Instrumentation(history, routes, match) {
    return function (startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
        var activeTransaction;
        var prevName;
        // Have to use global.location because history.location might not be defined.
        if (startTransactionOnPageLoad && global && global.location) {
            prevName = normalizeTransactionName(routes, global.location, match);
            activeTransaction = startTransaction({
                name: prevName,
                op: 'pageload',
                tags: {
                    'routing.instrumentation': 'react-router-v3',
                },
            });
        }
        if (startTransactionOnLocationChange && history.listen) {
            history.listen(function (location) {
                if (location.action === 'PUSH' || location.action === 'POP') {
                    if (activeTransaction) {
                        activeTransaction.finish();
                    }
                    var tags = { 'routing.instrumentation': 'react-router-v3' };
                    if (prevName) {
                        tags.from = prevName;
                    }
                    prevName = normalizeTransactionName(routes, location, match);
                    activeTransaction = startTransaction({
                        name: prevName,
                        op: 'navigation',
                        tags: tags,
                    });
                }
            });
        }
    };
}
/**
 * Normalize transaction names using `Router.match`
 */
function normalizeTransactionName(appRoutes, location, match) {
    var name = location.pathname;
    match({
        location: location,
        routes: appRoutes,
    }, function (error, _redirectLocation, renderProps) {
        if (error || !renderProps) {
            return name;
        }
        var routePath = getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === '/*') {
            return name;
        }
        name = routePath;
        return name;
    });
    return name;
}
/**
 * Generate route name from array of routes
 */
function getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) {
        return '';
    }
    var routesWithPaths = routes.filter(function (route) { return !!route.path; });
    var index = -1;
    for (var x = routesWithPaths.length - 1; x >= 0; x--) {
        var route = routesWithPaths[x];
        if (route.path && route.path.startsWith('/')) {
            index = x;
            break;
        }
    }
    return routesWithPaths
        .slice(index)
        .filter(function (_a) {
        var path = _a.path;
        return !!path;
    })
        .map(function (_a) {
        var path = _a.path;
        return path;
    })
        .join('');
}
//# sourceMappingURL=reactrouterv3.js.map

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reactRouterV4Instrumentation */
/* unused harmony export reactRouterV5Instrumentation */
/* unused harmony export withSentryRouting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




/* eslint-enable @typescript-eslint/no-explicit-any */
var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
var activeTransaction;
function reactRouterV4Instrumentation(history, routes, matchPath) {
    return reactRouterInstrumentation(history, 'react-router-v4', routes, matchPath);
}
function reactRouterV5Instrumentation(history, routes, matchPath) {
    return reactRouterInstrumentation(history, 'react-router-v5', routes, matchPath);
}
function reactRouterInstrumentation(history, name, allRoutes, matchPath) {
    if (allRoutes === void 0) { allRoutes = []; }
    function getName(pathname) {
        if (allRoutes === [] || !matchPath) {
            return pathname;
        }
        var branches = matchRoutes(allRoutes, pathname, matchPath);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var x = 0; x < branches.length; x++) {
            if (branches[x].match.isExact) {
                return branches[x].match.path;
            }
        }
        return pathname;
    }
    return function (startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
        if (startTransactionOnPageLoad && global && global.location) {
            activeTransaction = startTransaction({
                name: getName(global.location.pathname),
                op: 'pageload',
                tags: {
                    'routing.instrumentation': name,
                },
            });
        }
        if (startTransactionOnLocationChange && history.listen) {
            history.listen(function (location, action) {
                if (action && (action === 'PUSH' || action === 'POP')) {
                    if (activeTransaction) {
                        activeTransaction.finish();
                    }
                    var tags = {
                        'routing.instrumentation': name,
                    };
                    activeTransaction = startTransaction({
                        name: getName(location.pathname),
                        op: 'navigation',
                        tags: tags,
                    });
                }
            });
        }
    };
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */
function matchRoutes(routes, pathname, matchPath, branch) {
    if (branch === void 0) { branch = []; }
    routes.some(function (route) {
        var match = route.path
            ? matchPath(pathname, route)
            : branch.length
                ? branch[branch.length - 1].match // use parent match
                : computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({ route: route, match: match });
            if (route.routes) {
                matchRoutes(route.routes, pathname, matchPath, branch);
            }
        }
        return !!match;
    });
    return branch;
}
function computeRootMatch(pathname) {
    return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryRouting(Route) {
    var componentDisplayName = Route.displayName || Route.name;
    var WrappedRoute = function (props) {
        if (activeTransaction && props && props.computedMatch && props.computedMatch.isExact) {
            activeTransaction.setName(props.computedMatch.path);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Route, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props));
    };
    WrappedRoute.displayName = "sentryRoute(" + componentDisplayName + ")";
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(WrappedRoute, Route);
    return WrappedRoute;
}
//# sourceMappingURL=reactrouter.js.map

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var RouteLoginConfirmation=function RouteLoginConfirmation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Account confirmation required'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It looks like this is your first time signing in with FocusVision! We\'ve sent instructions to your email to confirm your account.'));};/* harmony default export */ __webpack_exports__["a"] = (RouteLoginConfirmation);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormDescription__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_FormLinks__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_validations__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_analytics__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_sso__ = __webpack_require__(235);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var defaultError='An error has occurred';var resetErrors={reset_password_token:{'has expired, please request a new one':'Your password reset token has expired. Please request a new one','is invalid':'Your password reset token is invalid. Please request a new one'},password:{'was already taken in the past!':'Please select a password you have not used in the previous 4 updates','must be different to the current password!':'Please select a password that is different than your current password'}};var serializeErrorMessages=function serializeErrorMessages(_ref){var errors=_ref.errors;var messages=Object.keys(errors).reduce(function(messages,errorKey){return[].concat(_toConsumableArray(messages),[Object.keys(resetErrors[errorKey]).filter(function(key){return(errors[errorKey]||[]).includes(key);}).map(function(key){return resetErrors[errorKey][key];})]);},[]);return messages.length?messages:defaultError;};var redirectQueryParams=function redirectQueryParams(query){var params=new URLSearchParams();params.set('email',query.get('email'));if(query.get('redirect_uri')){params.set('redirect_uri',query.get('redirect_uri'));}return params;};var schema=__WEBPACK_IMPORTED_MODULE_5_yup___default.a.object().shape({password:__WEBPACK_IMPORTED_MODULE_9_utils_validations__["b" /* password */],passwordConfirmation:__WEBPACK_IMPORTED_MODULE_9_utils_validations__["c" /* passwordConfirmation */]});var RouteLoginResetPassword=function RouteLoginResetPassword(_ref2){var authenticate=_ref2.authenticate,notify=_ref2.notify,query=_ref2.query;var mounted=true;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState2=_slicedToArray(_useState,2),redirectUrl=_useState2[0],setRedirectUrl=_useState2[1];var redirectUri=query.get('redirect_uri')||'';var isVideoStreaming=redirectUri.includes("https://uatonline.focusvision.com/fvclip/oauth/authenticate");var check2FASecret=function check2FASecret(value){Object(__WEBPACK_IMPORTED_MODULE_12_utils_sso__["b" /* getUriForEmailInput */])(value,function(){return mounted&&setRedirectUrl('/login?'+query.toString());},function(){return mounted&&setRedirectUrl(query.get('hostname')?'/login/redirecting?'+query.toString():query.get('returnTo')?'/login/redirecting':'/login?'+redirectQueryParams(query));});};Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(query.get('email')){check2FASecret(query.get('email'));}return function(){mounted=false;};},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */],{initialValues:{password:'',passwordConfirmation:''},redirect:!isVideoStreaming?redirectUrl:undefined// Avoid the default redirect
,onSubmit:function onSubmit(_ref3){var password=_ref3.password,passwordConfirmation=_ref3.passwordConfirmation;if(Object(__WEBPACK_IMPORTED_MODULE_10__utils_analytics__["a" /* isIntervuRedirect */])(query)){Object(__WEBPACK_IMPORTED_MODULE_10__utils_analytics__["b" /* sendIntervuAnalyticsEvent */])('intervu-sign-up','password-chosen');}return fetch("https://api-qa.focusvision.com"+'/users/password',{headers:{Accept:'application/json','Content-Type':'application/json'},credentials:'include',method:'PATCH',body:JSON.stringify({user:{password:password,password_confirmation:passwordConfirmation,reset_password_token:query.get('reset_password_token')}})}).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.ok){_context.next=8;break;}_context.t0=Promise;_context.t1=serializeErrorMessages;_context.next=5;return response.json();case 5:_context.t2=_context.sent;_context.t3=(0,_context.t1)(_context.t2);return _context.abrupt('return',_context.t0.reject.call(_context.t0,_context.t3));case 8:notify('success','Password set successfully');return _context.abrupt('return',response.json());case 10:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref4.apply(this,arguments);};}(),function(){return Promise.reject('An error has occurred');}).then(function(response){if(!response.otp_required_for_login){authenticate('oauth2-password-grant',{email:query.get('email'),password:password}).then(function(){if(isVideoStreaming){var authorizeUrl='/login?response_type=code&client_id=VideoStreaming&redirect_uri='+query.get('redirect_uri');window.location.replace(authorizeUrl);}});}});},validationSchema:schema},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Title,null,'Set new password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormDescription__["a" /* default */],null,'Passwords must be a minimum of 12 characters long and contain a capital, lowercase, number, and special character.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Errors,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'password'},'New Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Input,{id:'password',type:'password',name:'password'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'passwordConfirmation'},'Confirm Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Input,{id:'passwordConfirmation',type:'password',name:'passwordConfirmation'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Group,{buttons:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].SubmitButton,{block:true},'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FormLinks__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["H" /* SecondaryLink */],{to:'/login'},'Sign in'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["H" /* SecondaryLink */],{to:'/login/forgot-password'},'Forgot password'))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null,{authenticate:__WEBPACK_IMPORTED_MODULE_11_redux_simple_auth__["authenticate"]}),__WEBPACK_IMPORTED_MODULE_4_components_withQueryParams__["a" /* default */],__WEBPACK_IMPORTED_MODULE_8_stylist__["Y" /* withNotifier */])(RouteLoginResetPassword));

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIntervuRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendIntervuAnalyticsEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_ga__);
var isIntervuRedirect=function isIntervuRedirect(query){return query.get('redirect_uri')&&query.get('redirect_uri').includes('intervu');};var sendIntervuAnalyticsEvent=function sendIntervuAnalyticsEvent(category,action){return __WEBPACK_IMPORTED_MODULE_0_react_ga__["ga"]('intervu.send','event',category,action);};

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1042);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(95),n=__webpack_require__(1043),p=__webpack_require__(135),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forgot_password_index__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forgot_password_confirmation__ = __webpack_require__(1046);
var RouteLoginForgotPassword=function RouteLoginForgotPassword(_ref){var path=_ref.match.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path,exact:true,component:__WEBPACK_IMPORTED_MODULE_2__forgot_password_index__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/confirmation',component:__WEBPACK_IMPORTED_MODULE_3__forgot_password_confirmation__["a" /* default */]}));};/* harmony default export */ __webpack_exports__["a"] = (RouteLoginForgotPassword);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_FormDescription__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormLinks__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_api__ = __webpack_require__(152);
var schema=__WEBPACK_IMPORTED_MODULE_3_yup___default.a.object().shape({email:__WEBPACK_IMPORTED_MODULE_3_yup___default.a.string().email('Email must be a valid email address').required("Email can't be blank")});var RouteLoginForgotPasswordIndex=function RouteLoginForgotPasswordIndex(_ref){var path=_ref.match.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */],{redirect:path+'/confirmation',validationSchema:schema,initialValues:{email:''},onSubmit:function onSubmit(_ref2){var email=_ref2.email;return Object(__WEBPACK_IMPORTED_MODULE_5_utils_api__["d" /* post */])('/users/password',{payload:{user:{email:email}}}).catch(function(){return Promise.reject('An error has occurred');});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].Title,null,'Forgot password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_FormDescription__["a" /* default */],null,'Please enter your email address below to reset your password.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].Errors,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].Input,{id:'email',name:'email',type:'email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].Group,{buttons:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["o" /* Form */].SubmitButton,{block:true},'Submit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormLinks__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["H" /* SecondaryLink */],{to:'/login'},'Sign in ')));};/* harmony default export */ __webpack_exports__["a"] = (RouteLoginForgotPasswordIndex);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var RouteLoginForgotPasswordConfirmation=function RouteLoginForgotPasswordConfirmation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Password reset email sent!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We\'ve sent you an email with instructions to reset your password.'));};/* harmony default export */ __webpack_exports__["a"] = (RouteLoginForgotPasswordConfirmation);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_withCurrentUser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_withSession__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stylist__ = __webpack_require__(2);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Container=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ecvz7aw0',label:'Container'})({name:'wkpw2c',styles:'display:flex;flex-direction:column;justify-content:center;align-items:center;'});var RouteRedirecting=function RouteRedirecting(_ref){var query=_ref.query,currentUser=_ref.currentUser,props=_objectWithoutProperties(_ref,['query','currentUser']);var platform=Object(__WEBPACK_IMPORTED_MODULE_6_config_platforms__["b" /* findPlatform */])(query.get('platformId')||query.get('client_id'));var hostname=query.get('hostname');if(hostname&&currentUser&&currentUser.isHostnameFoundInUserServers(hostname)&&platform&&platform.loginUrl){window.location.href=platform.loginUrlFn(hostname);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'You are being redirected ',platform&&'to '+platform.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_stylist__["x" /* Loader */],null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_3_components_withQueryParams__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5_components_withSession__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4_components_withCurrentUser__["a" /* default */])(RouteRedirecting));

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Session__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_auth__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_withQueryParams__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Container=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e15h5yxg0',label:'Container'})({name:'1n2mv2k',styles:'display:flex;justify-content:center;align-items:center;'});var RouteLoginSetToken=function(_Component){_inherits(RouteLoginSetToken,_Component);function RouteLoginSetToken(){_classCallCheck(this,RouteLoginSetToken);return _possibleConstructorReturn(this,(RouteLoginSetToken.__proto__||Object.getPrototypeOf(RouteLoginSetToken)).apply(this,arguments));}_createClass(RouteLoginSetToken,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,authenticate=_props.authenticate,query=_props.query;var token=JSON.parse(query.get('token'));authenticate('oauth2-implicit-grant',token);}},{key:'render',value:function render(){var query=this.props.query;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Session__["a" /* default */],{render:function render(_ref){var isAuthenticated=_ref.isAuthenticated,hasFailedAuth=_ref.hasFailedAuth;return hasFailedAuth?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Redirect */],{to:'/login'}):isAuthenticated&&Object(__WEBPACK_IMPORTED_MODULE_7_utils_auth__["a" /* hasAuthorizationParams */])(query)?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["x" /* Loader */],{size:'lg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Location__["a" /* default */],{to:"https://api-qa.focusvision.com"+'/oauth/authorize?'+query,replace:true})):isAuthenticated?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Redirect */],{to:'/'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_stylist__["x" /* Loader */],{size:'lg'}));}});}}]);return RouteLoginSetToken;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,{authenticate:__WEBPACK_IMPORTED_MODULE_4_redux_simple_auth__["authenticate"]}),__WEBPACK_IMPORTED_MODULE_10_components_withQueryParams__["a" /* default */])(RouteLoginSetToken));

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RouteLogout=function(_Component){_inherits(RouteLogout,_Component);function RouteLogout(){_classCallCheck(this,RouteLogout);return _possibleConstructorReturn(this,(RouteLogout.__proto__||Object.getPrototypeOf(RouteLogout)).apply(this,arguments));}_createClass(RouteLogout,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,invalidateSession=_props.invalidateSession,isAuthenticated=_props.isAuthenticated;if(isAuthenticated){this.props.client.resetStore();invalidateSession();}}},{key:'render',value:function render(){var _props2=this.props,isAuthenticated=_props2.isAuthenticated,query=_props2.query;var clientId=query.get('client_id');var platform=Object(__WEBPACK_IMPORTED_MODULE_7_config_platforms__["b" /* findPlatform */])(clientId);if(isAuthenticated){return null;}if(platform&&platform.homeUrl){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Location__["a" /* default */],{to:platform.homeUrl,replace:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:'/'});}}]);return RouteLogout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isAuthenticated:Object(__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__["getIsAuthenticated"])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["g" /* withRouter */],__WEBPACK_IMPORTED_MODULE_2_components_withQueryParams__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,{invalidateSession:__WEBPACK_IMPORTED_MODULE_3_redux_simple_auth__["invalidateSession"]}))(Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["withApollo"])(RouteLogout)));

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StyledLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterHome__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_routes_admin_companies__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_routes_admin_companies_company__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_routes_admin_companies_new__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_routes_admin_users__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_routes_admin_users_user__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_routes_admin_users_new__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_routes_admin_products__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes_admin_products_product__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_routes_admin_features__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_routes_admin_features_feature__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_routes_admin_servers__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_routes_admin_servers_new__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_routes_admin_servers_server__ = __webpack_require__(1137);
var StyledLink=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["c" /* NavLink */],{target:'e1bmas7f0',label:'StyledLink'})('&.',function(props){return props.activeClassName;},'{font-weight:bold;}');var Content=__WEBPACK_IMPORTED_MODULE_4_stylist__["v" /* LayoutSidebar */].Content,Sidebar=__WEBPACK_IMPORTED_MODULE_4_stylist__["v" /* LayoutSidebar */].Sidebar;var Item=__WEBPACK_IMPORTED_MODULE_4_stylist__["b" /* Box */].Item;var RouteAdmin=function RouteAdmin(_ref){var _ref$match=_ref.match,path=_ref$match.path,url=_ref$match.url;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["w" /* LayoutWithStandardHeader */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["w" /* LayoutWithStandardHeader */].Header,{homeRoute:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["w" /* LayoutWithStandardHeader */].Main,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["v" /* LayoutSidebar */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Sidebar,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["b" /* Box */],{ghost:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLink,{to:url+'/companies'},'Companies')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLink,{to:url+'/users'},'Users')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLink,{to:url+'/products'},'Products')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLink,{to:url+'/servers'},'Servers')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLink,{to:url+'/features'},'Feature Flags')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path,exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:{pathname:url+'/companies'}});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/companies',exact:true,component:__WEBPACK_IMPORTED_MODULE_6_routes_admin_companies__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/companies/new',component:__WEBPACK_IMPORTED_MODULE_8_routes_admin_companies_new__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/companies/:id',component:__WEBPACK_IMPORTED_MODULE_7_routes_admin_companies_company__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/users',exact:true,component:__WEBPACK_IMPORTED_MODULE_9_routes_admin_users__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/users/new',component:__WEBPACK_IMPORTED_MODULE_11_routes_admin_users_new__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/users/:id',component:__WEBPACK_IMPORTED_MODULE_10_routes_admin_users_user__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/products',exact:true,component:__WEBPACK_IMPORTED_MODULE_12_routes_admin_products__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/products/:id',component:__WEBPACK_IMPORTED_MODULE_13_routes_admin_products_product__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/features',exact:true,component:__WEBPACK_IMPORTED_MODULE_14_routes_admin_features__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/features/:name',component:__WEBPACK_IMPORTED_MODULE_15_routes_admin_features_feature__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/servers',exact:true,component:__WEBPACK_IMPORTED_MODULE_16_routes_admin_servers__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/servers/new',exact:true,component:__WEBPACK_IMPORTED_MODULE_17_routes_admin_servers_new__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Route */],{path:path+'/servers/:id',component:__WEBPACK_IMPORTED_MODULE_18_routes_admin_servers_server__["a" /* default */]}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_stylist__["w" /* LayoutWithStandardHeader */].Footer,{dark:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_FooterHome__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (RouteAdmin);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_companies__ = __webpack_require__(79);
var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companiesQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'companies'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'companies',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'CompanyConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:365,source:{body:'#import \'../fragments/CompanyConnection.graphql\'\n\nquery companiesQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  companies(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "companies", filter: ["q"]) {\n    ...CompanyConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompanies=function RouteCompanies(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Companies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:__WEBPACK_IMPORTED_MODULE_3_fields_companies__["a" /* default */],showNew:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'companies'})(RouteCompanies));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_relay__ = __webpack_require__(264);
var renderData=function renderData(data,key){return key.name.split('.').reduce(function(data,name){return typeof data[name]==='boolean'?data[name].toString():data[name];},data);};var ConnectionTable=function ConnectionTable(_ref){var connection=_ref.connection,linkKey=_ref.linkKey,fields=_ref.fields,history=_ref.history,url=_ref.match.url,_ref$onRowClick=_ref.onRowClick,onRowClick=_ref$onRowClick===undefined?function(e,row){return history.push(url+'/'+row[linkKey]);}:_ref$onRowClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["K" /* Table */],{data:Object(__WEBPACK_IMPORTED_MODULE_2_utils_relay__["b" /* pluckNodes */])(connection)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["K" /* Table */].Row,{onClick:onRowClick},fields.map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["K" /* Table */].Column,Object.assign({dataKey:field.name,label:field.label||field.name,key:field.name,render:function render(data){return renderData(data,field);}},field.props));})));};ConnectionTable.defaultProps={linkKey:'id',fields:[]};/* harmony default export */ __webpack_exports__["a"] = (ConnectionTable);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var NextButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["c" /* Button */],{target:'ewpm5oa0',label:'NextButton'})('border-top-left-radius:0;border-bottom-left-radius:0;border-left:0;&:disabled{border-color:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["W" /* transparentize */])('slate',0.1),';}');var PrevButton=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["c" /* Button */],{target:'ewpm5oa1',label:'PrevButton'})('border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;&:disabled{border-color:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["W" /* transparentize */])('slate',0.1),';}');var Pagination=function Pagination(_ref){var hasNextPage=_ref.hasNextPage,hasPreviousPage=_ref.hasPreviousPage,onNextClick=_ref.onNextClick,onPrevClick=_ref.onPrevClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PrevButton,{onClick:onPrevClick,kind:'standard',disabled:!hasPreviousPage},'\u25C0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NextButton,{onClick:onNextClick,kind:'standard',disabled:!hasNextPage},'\u25B6'));};/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__show__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__edit__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Company__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Company_Provider__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header__ = __webpack_require__(119);
var RouteCompany=function RouteCompany(_ref){var _ref$match=_ref.match,url=_ref$match.url,path=_ref$match.path,params=_ref$match.params,goBack=_ref.history.goBack,location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Company_Provider__["a" /* default */],{variables:params},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Company__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,company=_ref2.company;return loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'lg',centered:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["c" /* Button */],{marginBottom:true,onClick:goBack,size:'sm'},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,company.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!/\/edit\/?$/.test(location.pathname)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{to:url+'/edit'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:path+'/edit',component:__WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:url,component:__WEBPACK_IMPORTED_MODULE_3__show__["a" /* default */]}))));}}));};/* harmony default export */ __webpack_exports__["a"] = (RouteCompany);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withCompany__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_FeatureFlag__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_InfoGroup__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Subheader__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_RelationshipContainer__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fields_companies__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_manage__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__primary_user_manage__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_routes_admin_companies_users_new__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes_admin_companies_primary_user_new__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_routes_admin_companies_plans__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_routes_admin_companies_plans_new__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__primary_user__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_renderValue__ = __webpack_require__(118);
var RouteShow=function RouteShow(_ref){var company=_ref.company,path=_ref.match.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Company Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */].Item,{pad:true},__WEBPACK_IMPORTED_MODULE_7_fields_companies__["a" /* default */].map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_InfoGroup__["a" /* default */],{key:field.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Subheader__["a" /* default */],null,field.label||field.name,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_17_utils_renderValue__["a" /* default */])(company[field.name])));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["L" /* Tabs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["L" /* Tabs */].Item,{to:path+'/users'},'Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["L" /* Tabs */].Item,{to:path+'/primary_user'},'Primary User'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FeatureFlag__["a" /* default */],{name:'admin_plan_create',active:function active(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["L" /* Tabs */].Item,{to:path+'/plans'},'Plans');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_RelationshipContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/users',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__users__["a" /* default */],Object.assign({variables:{company_id:company.id}},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/users/new',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_routes_admin_companies_users_new__["a" /* default */],Object.assign({company:company},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/users/manage',exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__users_manage__["a" /* default */],{company:company,variables:{company_id:company.id,show_has_company:true}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/primary_user/manage',exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__primary_user_manage__["a" /* default */],{company:company,variables:{company_id:company.id}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/primary_user',exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__primary_user__["a" /* default */],{company:company});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/primary_user/new',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_routes_admin_companies_primary_user_new__["a" /* default */],Object.assign({company:company},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FeatureFlag__["a" /* default */],{name:'admin_plan_create',active:function active(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/plans',exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_routes_admin_companies_plans__["a" /* default */],{company:company});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Route */],{path:path+'/plans/new',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_routes_admin_companies_plans_new__["a" /* default */],Object.assign({company:company},routeProps));}}));}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withCompany__["a" /* default */])(RouteShow));

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_withCurrentUser__ = __webpack_require__(139);
var FeatureFlag=function FeatureFlag(_ref){var _ref$active=_ref.active,active=_ref$active===undefined?function(){return null;}:_ref$active,_ref$inactive=_ref.inactive,inactive=_ref$inactive===undefined?function(){return null;}:_ref$inactive,name=_ref.name,currentUser=_ref.currentUser;return currentUser&&currentUser.flags[name]?active():inactive();};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_components_withCurrentUser__["a" /* default */])(FeatureFlag));

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companyUsers'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'users'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'users',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserConnection'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'UserConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:400,source:{body:'#import \'../fragments/UserConnection.graphql\'\n\nquery companyUsers(\n  $company_id: ID!\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $show_has_company: Boolean = false\n) {\n  company(id: $company_id) {\n    id\n    users(q: $q, first: $first, last: $last, before: $before, after: $after)\n      @connection(key: "users", filter: ["q"]) {\n      ...UserConnection\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompanyUsers=function RouteCompanyUsers(_ref){var company=_ref.company,history=_ref.history,props=_objectWithoutProperties(_ref,['company','history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{history:history,fields:__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */],onRowClick:function onRowClick(e,row){return history.push('/admin/users/'+row.id);},showNew:true,showManage:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'company.users'})(RouteCompanyUsers));

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SwitchWithMutation__ = __webpack_require__(267);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'usersQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'users'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'users',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'UserConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:353,source:{body:'#import \'../fragments/UserConnection.graphql\'\n\nquery usersQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $company_id: ID = 0\n  $show_has_company: Boolean = false\n) {\n  users(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "users", filter: ["q"]) {\n    ...UserConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var toggleUserCompany={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'toggleUserCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'input'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ToggleUserCompanyInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'toggleUserCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'input'},value:{kind:'Variable',name:{kind:'Name',value:'input'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'user'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'company'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:379,source:{body:'#import \'../fragments/UserFields.graphql\'\n#import \'../fragments/CompanyFields.graphql\'\n\nmutation toggleUserCompany(\n  $input: ToggleUserCompanyInput!\n  $company_id: ID\n  $user_id: ID\n  $show_has_company: Boolean = true\n  $show_has_user: Boolean = true\n) {\n  toggleUserCompany(input: $input) {\n    user {\n      ...UserFields\n    }\n    company {\n      ...CompanyFields\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var UserFragment={kind:'Document',definitions:[{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:196,source:{body:'fragment UserFields on User {\n  id\n  first_name\n  last_name\n  email\n  is_admin\n  otp_required_for_login\n  two_factor_hours\n  has_company(company_id: $company_id) @include(if: $show_has_company)\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteUsers=function RouteUsers(_ref){var variables=_ref.variables,props=_objectWithoutProperties(_ref,['variables']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Mutation"],{mutation:toggleUserCompany},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:[{props:{dataKey:'manage',key:'manage',render:function render(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SwitchWithMutation__["a" /* default */],Object.assign({initialValue:data.has_company,id:'row-'+data.id,mutate:mutate,buildMutationOptions:function buildMutationOptions(value){return{variables:{input:{user_id:data.id,company_id:variables.company_id,value:value},company_id:variables.company_id},update:function update(store,_ref2){var toggle_user_company=_ref2.data.toggle_user_company;store.writeFragment({id:data.id,fragment:UserFragment,variables:variables,data:toggle_user_company});}};}},props));}}}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */])),manage:true,onRowClick:function onRowClick(){}})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'users'})(RouteUsers));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fields_users__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_BelongsTo_Select__ = __webpack_require__(1060);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'usersQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'users'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'users',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'UserConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:353,source:{body:'#import \'../fragments/UserConnection.graphql\'\n\nquery usersQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $company_id: ID = 0\n  $show_has_company: Boolean = false\n) {\n  users(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "users", filter: ["q"]) {\n    ...UserConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var companyUpdateMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'updateCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'CompanyInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'updateCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}},{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:224,source:{body:'#import \'../fragments/CompanyFields.graphql\'\n\nmutation updateCompany(\n  $id: ID!\n  $data: CompanyInput!\n  $user_id: ID\n  $show_has_user: Boolean = false\n) {\n  updateCompany(id: $id, data: $data) {\n    ...CompanyFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var CompanyPrimaryUser={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companyPrimaryUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'primary_user'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:211,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nquery companyPrimaryUser($company_id: ID!, $show_has_company: Boolean = false) {\n  company(id: $company_id) {\n    id\n    primary_user {\n      ...UserFields\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RoutePrimaryUserManage=function RoutePrimaryUserManage(_ref){var company=_ref.company,path=_ref.match.path,match=_ref.match,history=_ref.history,props=_objectWithoutProperties(_ref,['company','match','match','history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_BelongsTo_Select__["a" /* default */],Object.assign({history:history,match:match,fields:__WEBPACK_IMPORTED_MODULE_2_fields_users__["a" /* default */],mutation:companyUpdateMutation,buildMutationOptions:function buildMutationOptions(row){return{variables:{id:company.id,data:{primary_user_id:row.id}},update:function update(store,_ref2){var data=_ref2.data;return store.writeQuery({query:CompanyPrimaryUser,variables:{company_id:company.id},data:{company:Object.assign({},company,{primary_user:row})}});}};},afterMutate:function afterMutate(){return history.push(''+path.replace(/\/manage$/g,''));}},props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'users'})(RoutePrimaryUserManage));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var SelectBelongsTo=function SelectBelongsTo(_ref){var mutation=_ref.mutation,afterMutate=_ref.afterMutate,_ref$buildMutationOpt=_ref.buildMutationOptions,buildMutationOptions=_ref$buildMutationOpt===undefined?function(){return{};}:_ref$buildMutationOpt,props=_objectWithoutProperties(_ref,['mutation','afterMutate','buildMutationOptions']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:mutation},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Select one'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({manage:true,onRowClick:function onRowClick(e,row){mutate(buildMutationOptions(row));afterMutate();}},props)));});};/* harmony default export */ __webpack_exports__["a"] = (SelectBelongsTo);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_user__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createUserInCompanyMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createUserInCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'UserInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createUserInCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}},{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:239,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nmutation createUserInCompany(\n  $data: UserInput!\n  $company_id: ID!\n  $show_has_company: Boolean = false\n) {\n  createUserInCompany(data: $data, company_id: $company_id) {\n    ...UserFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompaniesUsersNew=function RouteCompaniesUsersNew(_ref){var goBack=_ref.history.goBack,company=_ref.company,rest=_objectWithoutProperties(_ref,['history','company']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],Object.assign({mutation:createUserInCompanyMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */],variables:{company_id:company.id},schema:__WEBPACK_IMPORTED_MODULE_1_validations_user__["a" /* default */],title:'Create A User for '+company.name},rest));};/* harmony default export */ __webpack_exports__["a"] = (RouteCompaniesUsersNew);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hidden__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Boolean__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Text__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Immutable__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductSelect__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateTime__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(1081);
var fields={boolean:__WEBPACK_IMPORTED_MODULE_2__Boolean__["a" /* default */],hidden:__WEBPACK_IMPORTED_MODULE_1__Hidden__["a" /* default */],immutable:__WEBPACK_IMPORTED_MODULE_4__Immutable__["a" /* default */],text:__WEBPACK_IMPORTED_MODULE_3__Text__["a" /* default */],product:__WEBPACK_IMPORTED_MODULE_5__ProductSelect__["a" /* default */],datetime:__WEBPACK_IMPORTED_MODULE_6__DateTime__["a" /* default */],dropdown:__WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */]};var Field=function Field(props){var Component=fields[props.field.type]||__WEBPACK_IMPORTED_MODULE_3__Text__["a" /* default */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props);};/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var Hidden=function Hidden(_ref){var field=_ref.field;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Input,{key:field.name,type:'hidden',name:field.name,value:field.value});};/* harmony default export */ __webpack_exports__["a"] = (Hidden);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_displayName__ = __webpack_require__(117);
var Boolean=function Boolean(_ref){var field=_ref.field,key=_ref.key;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Group,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].SwitchInput,{name:field.name,label:field.label||''+Object(__WEBPACK_IMPORTED_MODULE_2_utils_displayName__["a" /* default */])(field.name)}));};/* harmony default export */ __webpack_exports__["a"] = (Boolean);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_displayName__ = __webpack_require__(117);
var Text=function Text(_ref){var field=_ref.field,key=_ref.key;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Group,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,field.label||Object(__WEBPACK_IMPORTED_MODULE_2_utils_displayName__["a" /* default */])(field.name),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Input,{type:field.type,name:field.name}));};/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){return null;});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_displayName__ = __webpack_require__(117);
var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'productsQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'products'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'products',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ProductConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Product'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'client_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:358,source:{body:'#import \'../fragments/ProductConnection.graphql\'\n\nquery productsQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID\n  $show_has_user: Boolean = false\n) {\n  products(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "products", filter: ["q"]) {\n    ...ProductConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var Group=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Group,Label=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Label,Select=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Select,Option=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Select.Option;var ProductSelect=function ProductSelect(_ref){var field=_ref.field,key=_ref.key,connection=_ref.connection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,null,field.label||Object(__WEBPACK_IMPORTED_MODULE_3_utils_displayName__["a" /* default */])(field.name),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select,{name:field.name},connection?connection.edges.map(function(_ref2,key){var node=_ref2.node;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option,{value:node.client_id,key:key},node.name);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option,{value:'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'sm'}),' Loading...')));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:false,namespace:'products'})(ProductSelect));

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_displayName__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datepicker_dist_react_datepicker_css__);
var Group=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Group,Label=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Label,Field=__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Field;var Text=function Text(_ref){var field=_ref.field,key=_ref.key;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,null,field.label||Object(__WEBPACK_IMPORTED_MODULE_2_utils_displayName__["a" /* default */])(field.name),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field,{name:field.name,render:function render(_ref2){var renderError=_ref2.renderError,setValue=_ref2.setValue,valid=_ref2.valid,value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["c" /* Button */],{type:'button'},value?value.format('L'):'Choose a Date'),utcOffset:0,selected:typeof value!=='string'?value:null,onChange:setValue,minDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()(),maxDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()().add(2,'years'),todayButton:'Today',placeholderText:'Select A Date'}),renderError());}}));};/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(1072);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(point);
}

function newDateWithOffset(utcOffset) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, dateFormat, locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date);
}

function isDate(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref5) {
  var minTime = _ref5.minTime,
      maxTime = _ref5.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = __WEBPACK_IMPORTED_MODULE_4_moment___default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref6.minDate,
      includeDates = _ref6.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref7.maxDate,
      includeDates = _ref7.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref8) {
  var minDate = _ref8.minDate,
      includeDates = _ref8.includeDates;

  if (includeDates && minDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref9) {
  var maxDate = _ref9.maxDate,
      includeDates = _ref9.includeDates;

  if (includeDates && maxDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdownOptions.propTypes = {
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  monthNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      getDate(this.props.day)
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Day.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WeekNumber.propTypes = {
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Week.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox"
      },
      this.renderWeeks()
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Month.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM)
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    var multiplier = 60 / this.props.intervals;
    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
    this.list.scrollTop = 30 * (multiplier * currH);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef) {
      height = this.props.monthRef.clientHeight - 39;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__header react-datepicker__header--time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Time.propTypes = {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  intervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  monthRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "react-datepicker__triangle" }),
    children
  );
}

CalendarContainer.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      var _ref;

      return _ref = {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month"
      }, _ref["previousMonthButtonLabel"] = "Next Month", _ref;
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "react-datepicker__header" },
            _this.renderCurrentMonth(monthDate),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
                onFocus: _this.handleDropdownFocus
              },
              _this.renderMonthDropdown(i !== 0),
              _this.renderMonthYearDropdown(i !== 0),
              _this.renderYearDropdown(i !== 0)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "react-datepicker__day-names" },
              _this.header(monthDate)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: _this.monthContainer
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Container,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]),
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDropdownFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker-popper", className);
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */],
        {
          className: classes,
          modifiers: popperModifiers,
          placement: popperPlacement
        },
        popperComponent
      );
    }

    if (this.props.popperContainer) {
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Target */],
        { className: "react-datepicker-wrapper" },
        targetComponent
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidePopper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  popperComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <datepicker/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  targetComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month"
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setOpen = function (open) {
      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      });
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      _this.setOpen(false);
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if ((isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();
        _this.setOpen(false);
      } else if (eventKey === "Tab") {
        _this.setOpen(false);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) return; // Let the input component handle this keydown
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && (!_this.state.open || _this.props.disabled || _this.props.readOnly)) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.state.open || this.props.disabled || this.props.readOnly,
      popperModifiers: this.props.popperModifiers,
      targetComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement
    });
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowSameDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  calendarContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  customInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  dateFormatCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isClearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeRaw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // <PopperComponent/> props
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <PopperComponent/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  preventOpenOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  startOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  shouldCloseOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearButtonTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(1073);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(1076);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(1077);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(1079);
/* unused harmony reexport Arrow */





/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1075);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(1078);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* unused harmony default export */ var _unused_webpack_default_export = (Arrow);

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_displayName__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_core__ = __webpack_require__(54);
var globalStyles={name:'1leckyj-globalStyles',styles:'ul[id^=\'downshift-\']{z-index:99999 !important;};label:globalStyles;'};var DropdownField=function DropdownField(_ref){var field=_ref.field,key=_ref.key,twoFAEnabled=_ref.twoFAEnabled,value=_ref.value,setValue=_ref.setValue,values=_ref.values,options=_ref.options;if(!twoFAEnabled)return null;var changeValue=function changeValue(value){var currentValues=values.filter(function(v){return v.name!==field.name;});currentValues.push({name:field.name,value:value});setValue(currentValues);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["b" /* Global */],{styles:globalStyles}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,field.label||Object(__WEBPACK_IMPORTED_MODULE_2_utils_displayName__["a" /* default */])(field.name),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["m" /* Dropdown */],{key:key,name:field.name,value:value,onChange:function onChange(v){return changeValue(v);}},options.map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["m" /* Dropdown */].Option,{key:index,value:o.value},o.text);}))));};/* harmony default export */ __webpack_exports__["a"] = (DropdownField);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
var withMutate=function withMutate(mutation){return function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Mutation"],{mutation:mutation},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,{mutate:mutate}));});};};};/* harmony default export */ __webpack_exports__["a"] = (withMutate);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_user__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createPrimaryUserInCompanyMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createPrimaryUserInCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'UserInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createPrimaryUserInCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}},{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:253,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nmutation createPrimaryUserInCompany(\n  $data: UserInput!\n  $company_id: ID!\n  $show_has_company: Boolean = false\n) {\n  createPrimaryUserInCompany(data: $data, company_id: $company_id) {\n    ...UserFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var CompanyPrimaryUser={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companyPrimaryUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'primary_user'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:211,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nquery companyPrimaryUser($company_id: ID!, $show_has_company: Boolean = false) {\n  company(id: $company_id) {\n    id\n    primary_user {\n      ...UserFields\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompaniesUsersNew=function RouteCompaniesUsersNew(_ref){var url=_ref.match.url,goBack=_ref.history.goBack,company=_ref.company,rest=_objectWithoutProperties(_ref,['match','history','company']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],Object.assign({mutation:createPrimaryUserInCompanyMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */],variables:{company_id:company.id},schema:__WEBPACK_IMPORTED_MODULE_1_validations_user__["a" /* default */],title:'Create A Primary User for '+company.name,mutationArgs:{update:function update(store,_ref2){var data=_ref2.data;try{var result=store.readQuery({query:CompanyPrimaryUser,variables:{company_id:company.id}});result.company.primary_user=data.createPrimaryUserInCompany;store.writeQuery({query:CompanyPrimaryUser,variables:{company_id:company.id},data:result});}catch(e){}// readQuery throws if no record
}}},rest));};/* harmony default export */ __webpack_exports__["a"] = (RouteCompaniesUsersNew);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var RouteCompanyUsers=function RouteCompanyUsers(_ref){var company=_ref.company,history=_ref.history,path=_ref.match.path,props=_objectWithoutProperties(_ref,['company','history','match']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{marginLeft:true,kind:'standard',to:path+'/new'},'New');};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(RouteCompanyUsers));

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_plan__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LedgerClient__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fields_plans__ = __webpack_require__(1102);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createPlanMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createPlan'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'companyId'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'productCode'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'name'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'startDate'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'endDate'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createPlan'},arguments:[{kind:'Argument',name:{kind:'Name',value:'input'},value:{kind:'ObjectValue',fields:[{kind:'ObjectField',name:{kind:'Name',value:'companyId'},value:{kind:'Variable',name:{kind:'Name',value:'companyId'}}},{kind:'ObjectField',name:{kind:'Name',value:'productCode'},value:{kind:'Variable',name:{kind:'Name',value:'productCode'}}},{kind:'ObjectField',name:{kind:'Name',value:'name'},value:{kind:'Variable',name:{kind:'Name',value:'name'}}},{kind:'ObjectField',name:{kind:'Name',value:'startDate'},value:{kind:'Variable',name:{kind:'Name',value:'startDate'}}},{kind:'ObjectField',name:{kind:'Name',value:'endDate'},value:{kind:'Variable',name:{kind:'Name',value:'endDate'}}}]}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'plan'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'companyId'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'productCode'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'startDate'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'endDate'},arguments:[],directives:[]}]}}]}}]}}],loc:{start:0,end:398,source:{body:'mutation createPlan(\n  $companyId: ID!\n  $productCode: ID!\n  $name: String!\n  $startDate: String!\n  $endDate: String!\n) {\n  createPlan(\n    input: {\n      companyId: $companyId\n      productCode: $productCode\n      name: $name\n      startDate: $startDate\n      endDate: $endDate\n    }\n  ) {\n    plan {\n      id\n      name\n      companyId\n      productCode\n      startDate\n      endDate\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompaniesUsersNew=function RouteCompaniesUsersNew(_ref){var goBack=_ref.history.goBack,company=_ref.company,rest=_objectWithoutProperties(_ref,['history','company']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LedgerClient__["a" /* default */],null,function(_ref2){var _mutate=_ref2.mutate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FormForRecord__["a" /* default */],Object.assign({onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_4_fields_plans__["a" /* default */],schema:__WEBPACK_IMPORTED_MODULE_1_validations_plan__["a" /* default */],title:'Create a Plan for '+company.name,mutate:function mutate(_ref3){var variables=_ref3.variables;return _mutate({mutation:createPlanMutation,variables:Object.assign({companyId:company.id},variables.data)});}},rest));});};/* harmony default export */ __webpack_exports__["a"] = (RouteCompaniesUsersNew);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_yup__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_yup___default.a.object().shape({name:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required("Name can't be blank"),productCode:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required('You must choose a product'),startDate:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required('You must select a start date'),endDate:__WEBPACK_IMPORTED_MODULE_0_yup___default.a.string().required('You must select an end date')}));

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_apollo_client__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_apollo_ledgerClient__ = __webpack_require__(1101);
var LedgerJwtQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'LedgerJwtQuery'},variableDefinitions:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'ledger_token'},arguments:[],directives:[]}]}}],loc:{start:0,end:40,source:{body:'query LedgerJwtQuery {\n  ledger_token\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var loadJwt=function loadJwt(){return __WEBPACK_IMPORTED_MODULE_0_config_apollo_client__["a" /* default */].query({query:LedgerJwtQuery,fetchPolicy:'network-only'}).then(function(result){return result.data.ledger_token;});};var mutate=function mutate(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return loadJwt().then(function(token){return __WEBPACK_IMPORTED_MODULE_1_config_apollo_ledgerClient__["a" /* default */].mutate(Object.assign({},options,{context:{headers:{Authorization:'Bearer '+token}}}));});};var Ledger=function Ledger(_ref){var children=_ref.children;return children({mutate:mutate});};/* harmony default export */ __webpack_exports__["a"] = (Ledger);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humps__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humps__);
var decamelizeLink=new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */](function(operation,forward){var _operation$getContext=operation.getContext(),decamelizeVariables=_operation$getContext.decamelizeVariables;if(decamelizeVariables==null||decamelizeVariables){operation.variables=Object(__WEBPACK_IMPORTED_MODULE_1_humps__["decamelizeKeys"])(operation.variables);}return forward(operation);});/* harmony default export */ __webpack_exports__["a"] = (decamelizeLink);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys

// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.


;(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (humps),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(this);


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_simple_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(423);
var httpLink=new __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* HttpLink */]({uri:"https://api-qa.focusvision.com"+'/graphql',fetch:function fetch(uri,options){return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_simple_auth__["fetch"])(uri,options));}});/* harmony default export */ __webpack_exports__["a"] = (httpLink);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createHttpLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__ = __webpack_require__(1092);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["a" /* checkFetcher */])(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */](function (operation) {
        var chosenURI = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["f" /* selectURI */])(operation, uri);
        var context = operation.getContext();
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: context.headers,
        };
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["e" /* selectHttpOptionsAndBody */])(operation, __WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["c" /* fallbackHttpConfig */], linkConfig, contextConfig), options = _a.options, body = _a.body;
        var _b = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["b" /* createSignalIfSupported */])(), controller = _b.controller, signal = _b.signal;
        if (controller)
            options.signal = signal;
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _c = rewriteURIForGET(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* fromError */])(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["g" /* serializeFetchParameter */])(body, 'Payload');
            }
            catch (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["c" /* fromError */])(parseError);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["b" /* Observable */](function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["d" /* parseAndCheckHttpResponse */])(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["g" /* serializeFetchParameter */])(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["g" /* serializeFetchParameter */])(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */]));

//# sourceMappingURL=httpLink.js.map

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fallbackHttpConfig; });
/* unused harmony export throwServerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseAndCheckHttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSignalIfSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectHttpOptionsAndBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serializeFetchParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectURI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(92);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw new Error("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = __assign({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = new Error("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultDataIdFromObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InMemoryCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_cache__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fragmentMatcher__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__writeToStore__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__readFromStore__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objectCache__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__recordingCache__ = __webpack_require__(429);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var defaultConfig = {
    fragmentMatcher: new __WEBPACK_IMPORTED_MODULE_2__fragmentMatcher__["a" /* HeuristicFragmentMatcher */](),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    storeFactory: __WEBPACK_IMPORTED_MODULE_5__objectCache__["b" /* defaultNormalizedCacheFactory */],
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var InMemoryCache = (function (_super) {
    __extends(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.optimistic = [];
        _this.watches = [];
        _this.silenceBroadcast = false;
        _this.config = __assign({}, defaultConfig, config);
        if (_this.config.customResolvers) {
            console.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            console.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = _this.config.addTypename;
        _this.data = _this.config.storeFactory();
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        if (optimistic && this.optimistic.length > 0) {
            var patches = this.optimistic.map(function (opt) { return opt.data; });
            return Object.assign.apply(Object, [{}, this.data.toObject()].concat(patches));
        }
        return this.data.toObject();
    };
    InMemoryCache.prototype.read = function (query) {
        if (query.rootId && this.data.get(query.rootId) === undefined) {
            return null;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_4__readFromStore__["b" /* readQueryFromStore */])({
            store: this.config.storeFactory(this.extract(query.optimistic)),
            query: this.transformDocument(query.query),
            variables: query.variables,
            rootId: query.rootId,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            previousResult: query.previousResult,
            config: this.config,
        });
    };
    InMemoryCache.prototype.write = function (write) {
        Object(__WEBPACK_IMPORTED_MODULE_3__writeToStore__["a" /* writeResultToStore */])({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__readFromStore__["a" /* diffQueryAgainstStore */])({
            store: this.config.storeFactory(this.extract(query.optimistic)),
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.push(watch);
        return function () {
            _this.watches = _this.watches.filter(function (c) { return c !== watch; });
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw new Error("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (id) {
        var _this = this;
        var toPerform = this.optimistic.filter(function (item) { return item.id !== id; });
        this.optimistic = [];
        toPerform.forEach(function (change) {
            _this.recordOptimisticTransaction(change.transaction, change.id);
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.performTransaction = function (transaction) {
        var alreadySilenced = this.silenceBroadcast;
        this.silenceBroadcast = true;
        transaction(this);
        if (!alreadySilenced) {
            this.silenceBroadcast = false;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        var _this = this;
        this.silenceBroadcast = true;
        var patch = Object(__WEBPACK_IMPORTED_MODULE_6__recordingCache__["a" /* record */])(this.extract(true), function (recordingCache) {
            var dataCache = _this.data;
            _this.data = recordingCache;
            _this.performTransaction(transaction);
            _this.data = dataCache;
        });
        this.optimistic.push({
            id: id,
            transaction: transaction,
            data: patch,
        });
        this.silenceBroadcast = false;
        this.broadcastWatches();
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename)
            return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["a" /* addTypenameToDocument */])(document);
        return document;
    };
    InMemoryCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: this.transformDocument(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName)),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            query: this.transformDocument(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName)),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (this.silenceBroadcast)
            return;
        this.watches.forEach(function (c) {
            var newData = _this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic,
            });
            c.callback(newData);
        });
    };
    return InMemoryCache;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_cache__["a" /* ApolloCache */]));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cache__ = __webpack_require__(1095);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__cache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(1097);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1096);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["h" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (id) {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* justTypenameQuery */],
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = __assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* fragmentFromPojo */])(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* queryFromPojo */])(data), data: data });
        }
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = queryFromPojo;
/* harmony export (immutable) */ __webpack_exports__["a"] = fragmentFromPojo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return justTypenameQuery; });
function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
        };
        var nestedSelSet = selectionSetFromObj(obj[key]);
        if (nestedSelSet) {
            field.selectionSet = nestedSelSet;
        }
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cache__ = __webpack_require__(1098);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cache */
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(1100);
/* unused harmony reexport filter */
/* unused harmony reexport check */
/* unused harmony reexport propType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(428);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* graphql */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filter */
/* unused harmony export check */
/* unused harmony export propType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(428);

function filter(doc, data) {
    var resolver = function (fieldName, root, args, context, info) {
        return root[info.resultKey];
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__graphql__["a" /* graphql */])(resolver, doc, data);
}
function check(doc, data) {
    var resolver = function (fieldName, root, args, context, info) {
        if (!{}.hasOwnProperty.call(root, info.resultKey)) {
            throw new Error(info.resultKey + " missing on " + root);
        }
        return root[info.resultKey];
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__graphql__["a" /* graphql */])(resolver, doc, data, {}, {}, {
        fragmentMatcher: function () { return false; },
    });
}
var ANONYMOUS = '<<anonymous>>';
function PropTypeError(message) {
    this.message = message;
    this.stack = '';
}
PropTypeError.prototype = Error.prototype;
var reactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context',
};
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (props[propName] == null) {
            var locationName = reactPropTypeLocationNames[location];
            if (isRequired) {
                if (props[propName] === null) {
                    return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required " +
                        ("in `" + componentName + "`, but its value is `null`."));
                }
                return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required in " +
                    ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
        }
        else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
function propType(doc) {
    return createChainableTypeChecker(function (props, propName) {
        var prop = props[propName];
        try {
            check(doc, prop);
            return null;
        }
        catch (e) {
            return e;
        }
    });
}
//# sourceMappingURL=utilities.js.map

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(423);
var client=new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["ApolloClient"]({link:new __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* HttpLink */]({uri:"https://ledger-qa.aws.focusvision.com"+'/graphql',fetch:fetch}),cache:new __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__["a" /* InMemoryCache */]()});/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'id',label:'ID',type:'immutable'},{name:'companyId',label:'Company',type:'immutable'},{name:'productCode',label:'Product',type:'product'},{name:'name',label:'Name'},{name:'startDate',label:'Start Date',type:'datetime'},{name:'endDate',label:'End Date',type:'datetime'}]);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fields_users__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_BelongsTo__ = __webpack_require__(1104);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CompanyPrimaryUser={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companyPrimaryUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'primary_user'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:211,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nquery companyPrimaryUser($company_id: ID!, $show_has_company: Boolean = false) {\n  company(id: $company_id) {\n    id\n    primary_user {\n      ...UserFields\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var companyRemovePrimaryUser={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'companyRemovePrimaryUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'companyRemovePrimaryUser'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]},{kind:'Field',name:{kind:'Name',value:'primary_user'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:248,source:{body:'#import \'../fragments/CompanyFields.graphql\'\n\nmutation companyRemovePrimaryUser(\n  $id: ID!\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  companyRemovePrimaryUser(id: $id) {\n    ...CompanyFields\n    primary_user {\n      id\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompanyPrimaryUser=function RouteCompanyPrimaryUser(_ref){var company=_ref.company,history=_ref.history,props=_objectWithoutProperties(_ref,['company','history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_BelongsTo__["a" /* default */],Object.assign({query:CompanyPrimaryUser,variables:{company_id:company.id},namespace:'company.primary_user',removeMutation:companyRemovePrimaryUser,removeMutationArgs:{variables:{id:company.id}},fields:__WEBPACK_IMPORTED_MODULE_1_fields_users__["a" /* default */],onRowClick:function onRowClick(e,row){return history.push('/admin/users/'+row.id);}},props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(RouteCompanyPrimaryUser));

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Show__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_findValue__ = __webpack_require__(265);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var BelongsTo=function BelongsTo(_ref){var variables=_ref.variables,query=_ref.query,history=_ref.history,removeMutation=_ref.removeMutation,_ref$removeMutationAr=_ref.removeMutationArgs,removeMutationArgs=_ref$removeMutationAr===undefined?{}:_ref$removeMutationAr,namespace=_ref.namespace,props=_objectWithoutProperties(_ref,['variables','query','history','removeMutation','removeMutationArgs','namespace']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{query:query,variables:variables},function(_ref2){var loading=_ref2.loading,data=_ref2.data;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["x" /* Loader */],{size:'lg',centered:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Mutation"],{mutation:removeMutation},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Show__["a" /* default */],Object.assign({data:Object(__WEBPACK_IMPORTED_MODULE_4_utils_findValue__["a" /* default */])(data,namespace),onRemove:function onRemove(e,row){return mutate(removeMutationArgs);}},props));});});};/* harmony default export */ __webpack_exports__["a"] = (BelongsTo);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu__ = __webpack_require__(1106);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Show=function Show(_ref){var data=_ref.data,fields=_ref.fields,onRowClick=_ref.onRowClick,path=_ref.match.path,match=_ref.match,props=_objectWithoutProperties(_ref,['data','fields','onRowClick','match','match']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Menu__["a" /* default */],Object.assign({data:data,match:match},props)),data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["K" /* Table */],{data:[data]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["K" /* Table */].Row,{onClick:onRowClick},fields.map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["K" /* Table */].Column,{dataKey:field.name,label:field.label||field.name,key:field.name});}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Show));

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var BUTTON_KIND='standard';var CombinedButtonRight=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["d" /* ButtonLink */],{target:'eq6uk0w0',label:'CombinedButtonRight'})('border-top-left-radius:0;border-bottom-left-radius:0;border-left:0;&:disabled{border-color:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["W" /* transparentize */])('slate',0.1),';}');var CombinedButtonLeft=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_stylist__["d" /* ButtonLink */],{target:'eq6uk0w1',label:'CombinedButtonLeft'})('border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;&:disabled{border-color:',Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["W" /* transparentize */])('slate',0.1),';}');var Menu=function Menu(_ref){var data=_ref.data,path=_ref.match.path,onRemove=_ref.onRemove;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,data?'Replace:':'Add:',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CombinedButtonLeft,{marginLeft:true,marginTop:true,marginBottom:true,to:path+'/new',kind:BUTTON_KIND},'New'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CombinedButtonRight,{marginRight:true,marginTop:true,marginBottom:true,to:path+'/manage',kind:BUTTON_KIND},'Existing'),data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["c" /* Button */],{marginRight:true,marginTop:true,marginBottom:true,kind:BUTTON_KIND,onClick:onRemove},'Remove'));};/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_withCompany__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validations_company__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fields_companies__ = __webpack_require__(79);
var updateCompanyMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'updateCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'CompanyInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'updateCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}},{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:224,source:{body:'#import \'../fragments/CompanyFields.graphql\'\n\nmutation updateCompany(\n  $id: ID!\n  $data: CompanyInput!\n  $user_id: ID\n  $show_has_user: Boolean = false\n) {\n  updateCompany(id: $id, data: $data) {\n    ...CompanyFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteEdit=function RouteEdit(_ref){var company=_ref.company,goBack=_ref.history.goBack;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FormForRecord__["a" /* default */],{record:company,mutation:updateCompanyMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_4_fields_companies__["a" /* default */],variables:{id:company.id},schema:__WEBPACK_IMPORTED_MODULE_2_validations_company__["a" /* default */],title:'Edit Company Information'});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_components_withCompany__["a" /* default */])(RouteEdit));

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companyQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:172,source:{body:'#import \'../fragments/CompanyFields.graphql\'\n\nquery companyQuery($id: ID!, $user_id: ID, $show_has_user: Boolean = false) {\n  company(id: $id) {\n    ...CompanyFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var CompanyProvider=function CompanyProvider(_ref){var children=_ref.children,rest=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],Object.assign({query:graphqlQuery},rest),function(_ref2){var loading=_ref2.loading,company=_ref2.data.company;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["a" /* Broadcast */],{channel:'company',value:{loading:loading,company:company}},children);});};/* harmony default export */ __webpack_exports__["a"] = (CompanyProvider);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_company__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_companies__ = __webpack_require__(79);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createCompanyMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'CompanyInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:204,source:{body:'#import \'../fragments/CompanyFields.graphql\'\n\nmutation createCompany(\n  $data: CompanyInput!\n  $user_id: ID\n  $show_has_user: Boolean = false\n) {\n  createCompany(data: $data) {\n    ...CompanyFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteNew=function RouteNew(_ref){var goBack=_ref.history.goBack,rest=_objectWithoutProperties(_ref,['history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],{mutation:createCompanyMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_companies__["a" /* default */],schema:__WEBPACK_IMPORTED_MODULE_1_validations_company__["a" /* default */],title:'Create A Company'});};/* harmony default export */ __webpack_exports__["a"] = (RouteNew);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'usersQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'users'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'users',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'UserConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:353,source:{body:'#import \'../fragments/UserConnection.graphql\'\n\nquery usersQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $company_id: ID = 0\n  $show_has_company: Boolean = false\n) {\n  users(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "users", filter: ["q"]) {\n    ...UserConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteUsers=function RouteUsers(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */],showNew:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'users'})(RouteUsers));

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__show__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__edit__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_User__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_User_Provider__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_user__ = __webpack_require__(1121);
var RouteUser=function RouteUser(_ref){var _ref$match=_ref.match,url=_ref$match.url,params=_ref$match.params,goBack=_ref.history.goBack,location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_User_Provider__["a" /* default */],{variables:params},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_User__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,user=_ref2.user,refetch=_ref2.refetch;return loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'lg',centered:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["c" /* Button */],{marginBottom:true,onClick:goBack,size:'sm'},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_8_utils_user__["a" /* userDisplayName */])(user))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!/\/edit\/?$/.test(location.pathname)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{to:url+'/edit'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:url+'/edit',component:__WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:url,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__show__["a" /* default */],Object.assign({refetch:refetch},props));}}))));}}));};/* harmony default export */ __webpack_exports__["a"] = (RouteUser);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_withUser__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_InfoGroup__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Subheader__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_RelationshipContainer__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fields_users__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_api__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_routes_admin_users_companies__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_routes_admin_users_companies_new__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_routes_admin_users_companies_manage__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_routes_admin_users_products__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes_admin_users_servers__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_routes_admin_users_servers_manage__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_renderValue__ = __webpack_require__(118);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var RouteShow=function RouteShow(_ref){var user=_ref.user,path=_ref.match.path,refetch=_ref.refetch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({set_link:null,reset_link:null}),_useState2=_slicedToArray(_useState,2),generatedLinks=_useState2[0],setGeneratedLinks=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_8_utils_api__["a" /* get */])('/users/'+user.id+'/reset-password').then(setGeneratedLinks);},[user.id]);var fieldsForDisplay=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var emailIndex=__WEBPACK_IMPORTED_MODULE_7_fields_users__["a" /* default */].findIndex(function(field){return field.name==='email';});if(emailIndex===-1)return __WEBPACK_IMPORTED_MODULE_7_fields_users__["a" /* default */];var left=__WEBPACK_IMPORTED_MODULE_7_fields_users__["a" /* default */].slice(0,emailIndex+1);var right=__WEBPACK_IMPORTED_MODULE_7_fields_users__["a" /* default */].slice(emailIndex+1);return[].concat(_toConsumableArray(left),[{name:'set_link',label:'Registration Link'},{name:'reset_link',label:'Reset Password Link'}],_toConsumableArray(right));},[]);var userDetails=Object.assign({},user,{set_link:generatedLinks.set_link,reset_link:generatedLinks.reset_link});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'User Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["b" /* Box */].Item,{pad:true},fieldsForDisplay.map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_InfoGroup__["a" /* default */],{key:field.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Subheader__["a" /* default */],null,field.label||field.name,':'),['set_link','reset_link'].includes(field.name)&&userDetails[field.name]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:userDetails[field.name],target:'_blank',rel:'noopener noreferrer'},userDetails[field.name]):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_15_utils_renderValue__["a" /* default */])(userDetails[field.name])));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["L" /* Tabs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["L" /* Tabs */].Item,{to:path+'/companies'},'Companies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["L" /* Tabs */].Item,{to:path+'/servers'},'Servers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_stylist__["L" /* Tabs */].Item,{to:path+'/products'},'Products')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_RelationshipContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/companies',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_routes_admin_users_companies__["a" /* default */],Object.assign({variables:{user_id:user.id}},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/companies/new',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_routes_admin_users_companies_new__["a" /* default */],Object.assign({user:user,refetch:refetch},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/companies/manage',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_routes_admin_users_companies_manage__["a" /* default */],{user:user,variables:{user_id:user.id,show_has_user:true}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/servers',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_routes_admin_users_servers__["a" /* default */],Object.assign({variables:{user_id:user.id}},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/servers/manage',exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_routes_admin_users_servers_manage__["a" /* default */],{user:user,variables:{user_id:user.id,show_has_user:true}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:path+'/products',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_routes_admin_users_products__["a" /* default */],Object.assign({variables:{user_id:user.id}},routeProps));}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_components_withUser__["a" /* default */])(RouteShow));

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_companies__ = __webpack_require__(79);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'userCompanies'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'companies'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'companies',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyConnection'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'CompanyConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:428,source:{body:'#import \'../fragments/CompanyConnection.graphql\'\n\nquery userCompanies(\n  $user_id: ID!\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $show_has_user: Boolean = true\n) {\n  user(id: $user_id) {\n    id\n    companies(\n      q: $q\n      first: $first\n      last: $last\n      before: $before\n      after: $after\n    ) @connection(key: "companies", filter: ["q"]) {\n      ...CompanyConnection\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteUserCompanies=function RouteUserCompanies(_ref){var history=_ref.history,props=_objectWithoutProperties(_ref,['history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{history:history,fields:__WEBPACK_IMPORTED_MODULE_3_fields_companies__["a" /* default */],onRowClick:function onRowClick(e,row){return history.push('/admin/companies/'+row.id);},showNew:true,showManage:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'user.companies'})(RouteUserCompanies));

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_company__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_companies__ = __webpack_require__(79);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createCompanyInUserMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createCompanyInUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'CompanyInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createCompanyInUser'},arguments:[{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}},{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:236,source:{body:'#import \'../fragments/CompanyFields.graphql\'\n\nmutation createCompanyInUser(\n  $data: CompanyInput!\n  $user_id: ID!\n  $show_has_user: Boolean = false\n) {\n  createCompanyInUser(data: $data, user_id: $user_id) {\n    ...CompanyFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};// import { withApollo } from 'react-apollo'
// import userQuery from 'graphs/queries/User.graphql'
var RouteUsersCompaniesNew=function RouteUsersCompaniesNew(_ref){var goBack=_ref.history.goBack,user=_ref.user,client=_ref.client,refetch=_ref.refetch,rest=_objectWithoutProperties(_ref,['history','user','client','refetch']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],Object.assign({mutation:createCompanyInUserMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_companies__["a" /* default */],variables:{user_id:user.id},schema:__WEBPACK_IMPORTED_MODULE_1_validations_company__["a" /* default */],title:'Create A Company for '+user.email,afterMutate:function afterMutate(){return refetch();},runQueryAfterMutate:true},rest));};/* harmony default export */ __webpack_exports__["a"] = (RouteUsersCompaniesNew);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_companies__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SwitchWithMutation__ = __webpack_require__(267);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'companiesQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'companies'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'companies',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'CompanyConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:365,source:{body:'#import \'../fragments/CompanyConnection.graphql\'\n\nquery companiesQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  companies(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "companies", filter: ["q"]) {\n    ...CompanyConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var toggleUserCompany={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'toggleUserCompany'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'input'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ToggleUserCompanyInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'toggleUserCompany'},arguments:[{kind:'Argument',name:{kind:'Name',value:'input'},value:{kind:'Variable',name:{kind:'Name',value:'input'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'user'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'company'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'CompanyFields'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:379,source:{body:'#import \'../fragments/UserFields.graphql\'\n#import \'../fragments/CompanyFields.graphql\'\n\nmutation toggleUserCompany(\n  $input: ToggleUserCompanyInput!\n  $company_id: ID\n  $user_id: ID\n  $show_has_company: Boolean = true\n  $show_has_user: Boolean = true\n) {\n  toggleUserCompany(input: $input) {\n    user {\n      ...UserFields\n    }\n    company {\n      ...CompanyFields\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var CompanyFragment={kind:'Document',definitions:[{kind:'FragmentDefinition',name:{kind:'Name',value:'CompanyFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Company'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'salesforce_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_authentication'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:153,source:{body:'fragment CompanyFields on Company {\n  id\n  name\n  salesforce_id\n  two_factor_authentication\n  has_user(user_id: $user_id) @include(if: $show_has_user)\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteUsers=function RouteUsers(_ref){var variables=_ref.variables,props=_objectWithoutProperties(_ref,['variables']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Mutation"],{mutation:toggleUserCompany},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Companies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:[{props:{dataKey:'manage',key:'manage',render:function render(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SwitchWithMutation__["a" /* default */],Object.assign({initialValue:data.has_user,id:'row-'+data.id,mutate:mutate,buildMutationOptions:function buildMutationOptions(value){return{variables:{input:{company_id:data.id,user_id:variables.user_id,value:value},user_id:variables.user_id},update:function update(store,_ref2){var toggle_user_company=_ref2.data.toggle_user_company;store.writeFragment({id:data.id,fragment:CompanyFragment,variables:variables,data:toggle_user_company});}};}},props));}}}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_fields_companies__["a" /* default */])),manage:true,onRowClick:function onRowClick(){}})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'companies'})(RouteUsers));

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_products__ = __webpack_require__(271);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'UserProducts'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'products'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'products',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductConnection'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ProductConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Product'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'client_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:399,source:{body:'#import \'../fragments/ProductConnection.graphql\'\n\nquery UserProducts(\n  $user_id: ID!\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $show_has_user: Boolean = true\n) {\n  user(id: $user_id) {\n    id\n    products(q: $q, first: $first, last: $last, before: $before, after: $after)\n      @connection(key: "products", filter: ["q"]) {\n      ...ProductConnection\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteUserProducts=function RouteUserProducts(_ref){var user=_ref.user,history=_ref.history,props=_objectWithoutProperties(_ref,['user','history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{history:history,fields:__WEBPACK_IMPORTED_MODULE_3_fields_products__["a" /* default */],onRowClick:function onRowClick(e,row){return history.push('/admin/products/'+row.id);}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'user.products'})(RouteUserProducts));

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_servers__ = __webpack_require__(80);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'UserServers'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'servers'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'servers',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerConnection'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ServerConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:395,source:{body:'#import \'../fragments/ServerConnection.graphql\'\n\nquery UserServers(\n  $user_id: ID!\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $show_has_user: Boolean = false\n) {\n  user(id: $user_id) {\n    id\n    servers(q: $q, first: $first, last: $last, before: $before, after: $after)\n      @connection(key: "servers", filter: ["q"]) {\n      ...ServerConnection\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteUserServers=function RouteUserServers(_ref){var user=_ref.user,history=_ref.history,props=_objectWithoutProperties(_ref,['user','history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{history:history,fields:__WEBPACK_IMPORTED_MODULE_3_fields_servers__["a" /* default */],onRowClick:function onRowClick(e,row){return history.push('/admin/servers/'+row.id);},showManage:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'user.servers'})(RouteUserServers));

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_servers__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SwitchWithMutation__ = __webpack_require__(267);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'serversQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'servers'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'servers',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ServerConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:357,source:{body:'#import \'../fragments/ServerConnection.graphql\'\n\nquery serversQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  servers(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "servers", filter: ["q"]) {\n    ...ServerConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var toggleUserServer={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'toggleUserServer'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'input'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ToggleUserServerInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:true}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'toggleUserServer'},arguments:[{kind:'Argument',name:{kind:'Name',value:'input'},value:{kind:'Variable',name:{kind:'Name',value:'input'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'server'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:241,source:{body:'#import \'../fragments/ServerFields.graphql\'\n\nmutation toggleUserServer(\n  $input: ToggleUserServerInput!\n  $user_id: ID!\n  $show_has_user: Boolean = true\n) {\n  toggleUserServer(input: $input) {\n    server {\n      ...ServerFields\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var ServerFragment={kind:'Document',definitions:[{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:150,source:{body:'fragment ServerFields on Server {\n  id\n  hostname\n  name\n  product {\n    id\n    name\n  }\n  has_user(user_id: $user_id) @include(if: $show_has_user)\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteServersManage=function RouteServersManage(_ref){var variables=_ref.variables,props=_objectWithoutProperties(_ref,['variables']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Mutation"],{mutation:toggleUserServer},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Servers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:[{props:{dataKey:'manage',key:'manage',render:function render(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SwitchWithMutation__["a" /* default */],Object.assign({initialValue:data.has_user,id:'row-'+data.id,mutate:mutate,buildMutationOptions:function buildMutationOptions(value){return{variables:{input:{server_id:data.id,user_id:variables.user_id,value:value},user_id:variables.user_id},update:function update(store,_ref2){var toggle_user_server=_ref2.data.toggle_user_server;store.writeFragment({id:data.id,fragment:ServerFragment,variables:variables,data:toggle_user_server});}};}},props));}}}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_fields_servers__["a" /* default */])),manage:true,onRowClick:function onRowClick(){}})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'servers'})(RouteServersManage));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_withUser__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_validations_user__ = __webpack_require__(157);
var updateUserMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'updateUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'UserInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'updateUser'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}},{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:219,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nmutation updateUser(\n  $id: ID!\n  $data: UserInput!\n  $company_id: ID = 0\n  $show_has_company: Boolean = false\n) {\n  updateUser(id: $id, data: $data) {\n    ...UserFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteEdit=function RouteEdit(_ref){var user=_ref.user,goBack=_ref.history.goBack;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],{record:user,mutation:updateUserMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */],variables:{id:user.id},schema:__WEBPACK_IMPORTED_MODULE_4_validations_user__["a" /* default */],title:'Edit User Information'});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_components_withUser__["a" /* default */])(RouteEdit));

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'userQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:176,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nquery userQuery(\n  $id: ID!\n  $company_id: ID = 0\n  $show_has_company: Boolean = false\n) {\n  user(id: $id) {\n    ...UserFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var UserProvider=function UserProvider(_ref){var children=_ref.children,rest=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],Object.assign({query:graphqlQuery},rest),function(_ref2){var loading=_ref2.loading,user=_ref2.data.user,refetch=_ref2.refetch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["a" /* Broadcast */],{channel:'user',value:{loading:loading,user:user,refetch:refetch}},children);});};/* harmony default export */ __webpack_exports__["a"] = (UserProvider);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userDisplayName; });
var userDisplayName=function userDisplayName(user){return user.first_name?user.last_name?user.first_name+" "+user.last_name:user.first_name:user.email;};

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_user__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_users__ = __webpack_require__(51);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createUserMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createUser'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'UserInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'company_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createUser'},arguments:[{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'UserFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'UserFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'User'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'otp_required_for_login'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'two_factor_hours'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_company'},arguments:[{kind:'Argument',name:{kind:'Name',value:'company_id'},value:{kind:'Variable',name:{kind:'Name',value:'company_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_company'}}}]}]}]}}],loc:{start:0,end:199,source:{body:'#import \'../fragments/UserFields.graphql\'\n\nmutation createUser(\n  $data: UserInput!\n  $company_id: ID = 0\n  $show_has_company: Boolean = false\n) {\n  createUser(data: $data) {\n    ...UserFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteNew=function RouteNew(_ref){var goBack=_ref.history.goBack,rest=_objectWithoutProperties(_ref,['history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],Object.assign({mutation:createUserMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_users__["a" /* default */],schema:__WEBPACK_IMPORTED_MODULE_1_validations_user__["a" /* default */],title:'Create A User'},rest));};/* harmony default export */ __webpack_exports__["a"] = (RouteNew);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_products__ = __webpack_require__(271);
var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'productsQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'products'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'products',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ProductConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Product'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'client_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:358,source:{body:'#import \'../fragments/ProductConnection.graphql\'\n\nquery productsQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID\n  $show_has_user: Boolean = false\n) {\n  products(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "products", filter: ["q"]) {\n    ...ProductConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteProducts=function RouteProducts(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Products'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:__WEBPACK_IMPORTED_MODULE_3_fields_products__["a" /* default */]})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'products'})(RouteProducts));

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__show__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Product__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Product_Provider__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Header__ = __webpack_require__(119);
var RouteProduct=function RouteProduct(_ref){var _ref$match=_ref.match,url=_ref$match.url,params=_ref$match.params,location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Product_Provider__["a" /* default */],{variables:params},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Product__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,product=_ref2.product;return loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'lg',centered:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{marginBottom:true,to:'/admin/products',size:'sm'},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Header__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,product.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:url,component:__WEBPACK_IMPORTED_MODULE_3__show__["a" /* default */]}))));}}));};/* harmony default export */ __webpack_exports__["a"] = (RouteProduct);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withProduct__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_InfoGroup__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Subheader__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RelationshipContainer__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_routes_admin_products_servers__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_routes_admin_products_servers_new__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_renderValue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fields_products__ = __webpack_require__(271);
var RouteShow=function RouteShow(_ref){var product=_ref.product,path=_ref.match.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Product Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */].Item,{pad:true},__WEBPACK_IMPORTED_MODULE_10_fields_products__["a" /* default */].map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_InfoGroup__["a" /* default */],{key:field.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Subheader__["a" /* default */],null,field.label||field.name,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_9_utils_renderValue__["a" /* default */])(product[field.name])));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["L" /* Tabs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["L" /* Tabs */].Item,{to:path+'/servers'},'Servers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_RelationshipContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* Route */],{path:path+'/servers',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_routes_admin_products_servers__["a" /* default */],Object.assign({variables:{product_id:product.id}},routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* Route */],{path:path+'/servers/new',exact:true,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_routes_admin_products_servers_new__["a" /* default */],Object.assign({product:product},routeProps));}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withProduct__["a" /* default */])(RouteShow));

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Product__ = __webpack_require__(432);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Product__["a" /* default */],{render:function render(_ref){var product=_ref.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({product:product},props));}});};});

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_servers__ = __webpack_require__(80);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'productServers'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'product_id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'product'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'product_id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'servers'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'servers',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerConnection'},directives:[]}]}}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ServerConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:426,source:{body:'#import \'../fragments/ServerConnection.graphql\'\n\nquery productServers(\n  $product_id: ID!\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  product(id: $product_id) {\n    id\n    servers(q: $q, first: $first, last: $last, before: $before, after: $after)\n      @connection(key: "servers", filter: ["q"]) {\n      ...ServerConnection\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteCompanyUsers=function RouteCompanyUsers(_ref){var company=_ref.company,history=_ref.history,props=_objectWithoutProperties(_ref,['company','history']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{history:history,fields:__WEBPACK_IMPORTED_MODULE_3_fields_servers__["a" /* default */],onRowClick:function onRowClick(e,row){return history.push('/admin/servers/'+row.id);},showNew:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'product.servers'})(RouteCompanyUsers));

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validations_server__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_servers__ = __webpack_require__(80);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var createServerMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'createServer'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ServerInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'createServer'},arguments:[{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:203,source:{body:'#import \'../fragments/ServerFields.graphql\'\n\nmutation createServer(\n  $data: ServerInput!\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  createServer(data: $data) {\n    ...ServerFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteProductServersNew=function RouteProductServersNew(_ref){var goBack=_ref.history.goBack,product=_ref.product,rest=_objectWithoutProperties(_ref,['history','product']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],Object.assign({mutation:createServerMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_servers__["a" /* default */],variables:{data:{product_id:product.id}},schema:__WEBPACK_IMPORTED_MODULE_1_validations_server__["a" /* default */],title:'Create A Server for '+product.name},rest));};/* harmony default export */ __webpack_exports__["a"] = (RouteProductServersNew);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'productQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'product'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ProductFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ProductFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Product'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'client_id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:182,source:{body:'#import \'../fragments/ProductFields.graphql\'\n\nquery productQuery(\n  $id: ID!\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  product(id: $id) {\n    ...ProductFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var ProductProvider=function ProductProvider(_ref){var children=_ref.children,rest=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],Object.assign({query:graphqlQuery},rest),function(_ref2){var loading=_ref2.loading,product=_ref2.data.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["a" /* Broadcast */],{channel:'product',value:{loading:loading,product:product}},children);});};/* harmony default export */ __webpack_exports__["a"] = (ProductProvider);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_features__ = __webpack_require__(272);
var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'featuresQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'features'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'features',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'FeatureConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'FeatureConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'FeatureConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'FeatureFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'FeatureFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Feature'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'active_for_global'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'active_for_user'},arguments:[],directives:[]}]}}],loc:{start:0,end:309,source:{body:'#import \'../fragments/FeatureConnection.graphql\'\n\nquery featuresQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n) {\n  features(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "features", filter: ["q"]) {\n    ...FeatureConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteFeatures=function RouteFeatures(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Feature Flags'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:__WEBPACK_IMPORTED_MODULE_3_fields_features__["a" /* default */]})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'features'})(RouteFeatures));

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__show__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__edit__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Feature__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Feature_Provider__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header__ = __webpack_require__(119);
var RouteFeature=function RouteFeature(_ref){var _ref$match=_ref.match,url=_ref$match.url,params=_ref$match.params,path=_ref$match.path,location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Feature_Provider__["a" /* default */],{variables:params},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Feature__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,feature=_ref2.feature;return loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'lg',centered:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{marginBottom:true,to:'/admin/features',size:'sm'},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,feature.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!/\/edit\/?$/.test(location.pathname)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{to:url+'/edit'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:path+'/edit',component:__WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:url,component:__WEBPACK_IMPORTED_MODULE_3__show__["a" /* default */]}))));}}));};/* harmony default export */ __webpack_exports__["a"] = (RouteFeature);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withFeature__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_InfoGroup__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Subheader__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_renderValue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fields_features__ = __webpack_require__(272);
var RouteShow=function RouteShow(_ref){var feature=_ref.feature;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Feature Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */].Item,{pad:true},__WEBPACK_IMPORTED_MODULE_6_fields_features__["a" /* default */].map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_InfoGroup__["a" /* default */],{key:field.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Subheader__["a" /* default */],null,field.label||field.name,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_utils_renderValue__["a" /* default */])(feature[field.name])));}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withFeature__["a" /* default */])(RouteShow));

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_withFeature__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_features__ = __webpack_require__(272);
var updateFeatureMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'updateFeature'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'FeatureInput'}}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'updateFeature'},arguments:[{kind:'Argument',name:{kind:'Name',value:'name'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}},{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'FeatureFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'FeatureFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Feature'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'active_for_global'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'active_for_user'},arguments:[],directives:[]}]}}],loc:{start:0,end:176,source:{body:'#import \'../fragments/FeatureFields.graphql\'\n\nmutation updateFeature($id: String!, $data: FeatureInput!) {\n  updateFeature(name: $id, data: $data) {\n    ...FeatureFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var CurrentUserQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'currentUserQuery'},variableDefinitions:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'viewer'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'servers'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'client_id'},arguments:[],directives:[]}]}}]}}]}}]}},{kind:'Field',name:{kind:'Name',value:'flags'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'admin_plan_create'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'tier_upgrade'},arguments:[],directives:[]}]}}]}}]}}],loc:{start:0,end:310,source:{body:'query currentUserQuery {\n  viewer {\n    first_name\n    last_name\n    email\n    is_admin\n    servers {\n      edges {\n        node {\n          hostname\n          name\n          product {\n            client_id\n          }\n        }\n      }\n    }\n    flags {\n      admin_plan_create\n      tier_upgrade\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteEdit=function RouteEdit(_ref){var feature=_ref.feature,goBack=_ref.history.goBack;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FormForRecord__["a" /* default */],{record:feature,mutation:updateFeatureMutation,mutationArgs:{refetchQueries:[{query:CurrentUserQuery}]},onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_3_fields_features__["a" /* default */],variables:{id:feature.id},title:'Edit Feature Flag '+feature.id});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_components_withFeature__["a" /* default */])(RouteEdit));

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'featureQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'name'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'String'}}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'feature'},arguments:[{kind:'Argument',name:{kind:'Name',value:'name'},value:{kind:'Variable',name:{kind:'Name',value:'name'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'FeatureFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'FeatureFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Feature'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'active_for_global'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'active_for_user'},arguments:[],directives:[]}]}}],loc:{start:0,end:135,source:{body:'#import \'../fragments/FeatureFields.graphql\'\n\nquery featureQuery($name: String!) {\n  feature(name: $name) {\n    ...FeatureFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var FeatureProvider=function FeatureProvider(_ref){var children=_ref.children,rest=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],Object.assign({query:graphqlQuery},rest),function(_ref2){var loading=_ref2.loading,feature=_ref2.data.feature;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["a" /* Broadcast */],{channel:'feature',value:{loading:loading,feature:feature}},children);});};/* harmony default export */ __webpack_exports__["a"] = (FeatureProvider);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fields_servers__ = __webpack_require__(80);
var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'serversQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'q'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'first'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'last'}},type:{kind:'NamedType',name:{kind:'Name',value:'Int'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'before'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'after'}},type:{kind:'NamedType',name:{kind:'Name',value:'String'}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'servers'},arguments:[{kind:'Argument',name:{kind:'Name',value:'q'},value:{kind:'Variable',name:{kind:'Name',value:'q'}}},{kind:'Argument',name:{kind:'Name',value:'first'},value:{kind:'Variable',name:{kind:'Name',value:'first'}}},{kind:'Argument',name:{kind:'Name',value:'last'},value:{kind:'Variable',name:{kind:'Name',value:'last'}}},{kind:'Argument',name:{kind:'Name',value:'before'},value:{kind:'Variable',name:{kind:'Name',value:'before'}}},{kind:'Argument',name:{kind:'Name',value:'after'},value:{kind:'Variable',name:{kind:'Name',value:'after'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'connection'},arguments:[{kind:'Argument',name:{kind:'Name',value:'key'},value:{kind:'StringValue',value:'servers',block:false}},{kind:'Argument',name:{kind:'Name',value:'filter'},value:{kind:'ListValue',values:[{kind:'StringValue',value:'q',block:false}]}}]}],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerConnection'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerConnection'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'ServerConnection'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'cursor'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'Field',name:{kind:'Name',value:'pageInfo'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hasNextPage'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hasPreviousPage'},arguments:[],directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:357,source:{body:'#import \'../fragments/ServerConnection.graphql\'\n\nquery serversQuery(\n  $q: String\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  servers(q: $q, first: $first, last: $last, before: $before, after: $after)\n    @connection(key: "servers", filter: ["q"]) {\n    ...ServerConnection\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteServers=function RouteServers(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Servers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_PaginatedConnectionTable__["a" /* default */],Object.assign({},props,{fields:__WEBPACK_IMPORTED_MODULE_3_fields_servers__["a" /* default */],showNew:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withConnectionQuery__["a" /* default */])({graphqlQuery:graphqlQuery,paginated:true,namespace:'servers'})(RouteServers));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylist__ = __webpack_require__(2);
var RouteServersNew=function RouteServersNew(_ref){var notify=_ref.notify;notify('info','In order to add a Server, choose a product, click Servers -> New',{timeout:5000});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:'/admin/products'});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_stylist__["Y" /* withNotifier */])(RouteServersNew));

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__show__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__edit__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Server__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Server_Provider__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header__ = __webpack_require__(119);
var RouteServer=function RouteServer(_ref){var _ref$match=_ref.match,url=_ref$match.url,params=_ref$match.params,path=_ref$match.path,location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Server_Provider__["a" /* default */],{variables:params},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Server__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,server=_ref2.server;return loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["x" /* Loader */],{size:'lg',centered:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{marginBottom:true,to:'/admin/servers',size:'sm'},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,server&&server.hostname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!/\/edit\/?$/.test(location.pathname)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["d" /* ButtonLink */],{to:url+'/edit'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:path+'/edit',component:__WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:url,component:__WEBPACK_IMPORTED_MODULE_3__show__["a" /* default */]}))));}}));};/* harmony default export */ __webpack_exports__["a"] = (RouteServer);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withServer__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_InfoGroup__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Subheader__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_renderValue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_findValue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fields_servers__ = __webpack_require__(80);
var RouteShow=function RouteShow(_ref){var server=_ref.server;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Server Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["b" /* Box */].Item,{pad:true},__WEBPACK_IMPORTED_MODULE_7_fields_servers__["a" /* default */].map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_InfoGroup__["a" /* default */],{key:field.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Subheader__["a" /* default */],null,field.label||field.name,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_utils_renderValue__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6_utils_findValue__["a" /* default */])(server,field.name))));}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withServer__["a" /* default */])(RouteShow));

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_withServer__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validations_server__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_FormForRecord__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fields_servers__ = __webpack_require__(80);
var updateServerMutation={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'mutation',name:{kind:'Name',value:'updateServer'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'data'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ServerInput'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'updateServer'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}},{kind:'Argument',name:{kind:'Name',value:'data'},value:{kind:'Variable',name:{kind:'Name',value:'data'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:223,source:{body:'#import \'../fragments/ServerFields.graphql\'\n\nmutation updateServer(\n  $id: ID!\n  $data: ServerInput!\n  $user_id: ID = 0\n  $show_has_user: Boolean = false\n) {\n  updateServer(id: $id, data: $data) {\n    ...ServerFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var RouteEdit=function RouteEdit(_ref){var server=_ref.server,goBack=_ref.history.goBack;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_FormForRecord__["a" /* default */],{record:server,mutation:updateServerMutation,onSuccess:goBack,onCancel:goBack,fields:__WEBPACK_IMPORTED_MODULE_4_fields_servers__["a" /* default */],variables:{id:server.id},schema:__WEBPACK_IMPORTED_MODULE_2_validations_server__["a" /* default */],title:'Edit Server Information'});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_components_withServer__["a" /* default */])(RouteEdit));

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var graphqlQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'serverQuery'},variableDefinitions:[{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'id'}},type:{kind:'NonNullType',type:{kind:'NamedType',name:{kind:'Name',value:'ID'}}}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'user_id'}},type:{kind:'NamedType',name:{kind:'Name',value:'ID'}},defaultValue:{kind:'IntValue',value:'0'}},{kind:'VariableDefinition',variable:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}},type:{kind:'NamedType',name:{kind:'Name',value:'Boolean'}},defaultValue:{kind:'BooleanValue',value:false}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'server'},arguments:[{kind:'Argument',name:{kind:'Name',value:'id'},value:{kind:'Variable',name:{kind:'Name',value:'id'}}}],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'FragmentSpread',name:{kind:'Name',value:'ServerFields'},directives:[]}]}}]}},{kind:'FragmentDefinition',name:{kind:'Name',value:'ServerFields'},typeCondition:{kind:'NamedType',name:{kind:'Name',value:'Server'}},directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'id'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]}]}},{kind:'Field',name:{kind:'Name',value:'has_user'},arguments:[{kind:'Argument',name:{kind:'Name',value:'user_id'},value:{kind:'Variable',name:{kind:'Name',value:'user_id'}}}],directives:[{kind:'Directive',name:{kind:'Name',value:'include'},arguments:[{kind:'Argument',name:{kind:'Name',value:'if'},value:{kind:'Variable',name:{kind:'Name',value:'show_has_user'}}}]}]}]}}],loc:{start:0,end:172,source:{body:'#import \'../fragments/ServerFields.graphql\'\n\nquery serverQuery($id: ID!, $user_id: ID = 0, $show_has_user: Boolean = false) {\n  server(id: $id) {\n    ...ServerFields\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var ServerProvider=function ServerProvider(_ref){var children=_ref.children,rest=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],Object.assign({query:graphqlQuery},rest),function(_ref2){var loading=_ref2.loading,server=_ref2.data.server;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["a" /* Broadcast */],{channel:'server',value:{loading:loading,server:server}},children);});};/* harmony default export */ __webpack_exports__["a"] = (ServerProvider);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_routes_errors_404__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_errors_maintenance__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_routes_errors_dynamic__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stylist__ = __webpack_require__(2);
var RouteErrors=function RouteErrors(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_stylist__["w" /* LayoutWithStandardHeader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_stylist__["w" /* LayoutWithStandardHeader */].Header,{homeRoute:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_stylist__["w" /* LayoutWithStandardHeader */].Main,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/maintenance',component:__WEBPACK_IMPORTED_MODULE_4_routes_errors_maintenance__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/error',component:__WEBPACK_IMPORTED_MODULE_5_routes_errors_dynamic__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/*',component:__WEBPACK_IMPORTED_MODULE_3_routes_errors_404__["a" /* default */]}))));};/* harmony default export */ __webpack_exports__["a"] = (RouteErrors);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var Center=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'ew19st60',label:'Center'})({name:'148awcp',styles:'display:flex;justify-content:center;flex-direction:column;align-items:center;height:75vh;padding:0 1rem;'});var RouteErrorsNotFound=function RouteErrorsNotFound(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Center,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'404'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'The route you are trying to access is not found'));};/* harmony default export */ __webpack_exports__["a"] = (RouteErrorsNotFound);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var RouteErrorsMaintenance=function RouteErrorsMaintenance(){return'Maintenance';};/* harmony default export */ __webpack_exports__["a"] = (RouteErrorsMaintenance);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SupportButton__ = __webpack_require__(1145);
var Center=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1xkyngu0',label:'Center'})({name:'148awcp',styles:'display:flex;justify-content:center;flex-direction:column;align-items:center;height:75vh;padding:0 1rem;'});var Prompt=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('h6',{target:'e1xkyngu1',label:'Prompt'})({name:'xqqg40',styles:'margin:2rem 0;'});var RouteErrorsDynamic=function RouteErrorsDynamic(_ref){var query=_ref.query;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Center,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Looks like we\'re experiencing an issue. Let\'s solve that!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Prompt,null,'Please reach out to us by clicking below:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_SupportButton__["a" /* default */],{kind:'standard',platformId:query.get('platformId'),error:query.get('error')||'Unknown Error'}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withQueryParams__["a" /* default */])(RouteErrorsDynamic));

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ZendeskSupportButton__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailSupportButton__ = __webpack_require__(1147);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var FALLBACK_PLATFORM={title:'FocusVision',supportEmail:'support@focusvision.com'};var FormatPlatformErrorMessage=function FormatPlatformErrorMessage(platformName,error){return'Hi,\n\nI am unable to log in to '+platformName+' with my FV login.\n\nMy error was: '+error;};/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var platformId=_ref.platformId,error=_ref.error,rest=_objectWithoutProperties(_ref,['platformId','error']);var platform=Object(__WEBPACK_IMPORTED_MODULE_1_config_platforms__["b" /* findPlatform */])(platformId)||FALLBACK_PLATFORM;var errorMessage=FormatPlatformErrorMessage(platform.title,error);return platform.zendeskHost?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ZendeskSupportButton__["a" /* default */],Object.assign({zendeskHost:platform.zendeskHost,message:errorMessage},rest)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EmailSupportButton__["a" /* default */],Object.assign({email:platform.supportEmail,message:errorMessage},rest));});

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ZendeskSupportButton=function(_Component){_inherits(ZendeskSupportButton,_Component);function ZendeskSupportButton(){_classCallCheck(this,ZendeskSupportButton);return _possibleConstructorReturn(this,(ZendeskSupportButton.__proto__||Object.getPrototypeOf(ZendeskSupportButton)).apply(this,arguments));}_createClass(ZendeskSupportButton,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,zendeskHost=_props.zendeskHost,message=_props.message;window.initZe(zendeskHost,message);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["c" /* Button */],Object.assign({onClick:function onClick(){return window.zE(function(){return window.zE.activate();});}},this.props),'Contact Helpdesk');}}]);return ZendeskSupportButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ZendeskSupportButton);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var SUBJECT='FV Login Issue';/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var email=_ref.email,message=_ref.message,rest=_objectWithoutProperties(_ref,['email','message']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["n" /* ExternalButtonLink */],Object.assign({href:'mailto:'+email+'?subject='+SUBJECT+'&body='+window.encodeURIComponent(message)},rest),'Contact Helpdesk');});

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sign_up_index__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AppLogoLink__ = __webpack_require__(346);
var Main=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('main',{target:'e1v28rfz0',label:'Main'})({name:'1ddvngl',styles:'display:flex;min-height:100vh;width:100%;justify-content:center;align-items:center;'});var Container=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1v28rfz1',label:'Container'})({name:'1rc1eaw',styles:'width:30%;padding:70px 0px;@media only screen and (max-width:820px){width:50%;}@media only screen and (max-width:620px){width:75%;}@media only screen and (max-width:450px){width:90%;}'});var RouteSignUp=function RouteSignUp(_ref){var path=_ref.match.path,query=_ref.query;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Main,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AppLogoLink__["a" /* default */],{clientId:query.get('client_id')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{path:path,exact:true,component:__WEBPACK_IMPORTED_MODULE_4__sign_up_index__["a" /* default */]}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withQueryParams__["a" /* default */])(RouteSignUp));

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_core__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_withQueryParams__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_withCookieAcceptance__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yup__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_validations__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stylist__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_SSOProviderButtons__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Location__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_serializeErrorMessages__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_config_platforms__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_urlForProvider__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_sso__ = __webpack_require__(235);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['\n        mutation SignUpMutation($input: SignUpInput!) {\n          signUp(input: $input) {\n            user {\n              id\n            }\n          }\n        }\n      '],['\n        mutation SignUpMutation($input: SignUpInput!) {\n          signUp(input: $input) {\n            user {\n              id\n            }\n          }\n        }\n      ']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var schema=__WEBPACK_IMPORTED_MODULE_7_yup___default.a.object().shape({email:__WEBPACK_IMPORTED_MODULE_8_utils_validations__["a" /* email */],firstName:__WEBPACK_IMPORTED_MODULE_7_yup___default.a.string().required("First name can't be blank"),lastName:__WEBPACK_IMPORTED_MODULE_7_yup___default.a.string().required("Last name can't be blank"),phoneNumber:__WEBPACK_IMPORTED_MODULE_7_yup___default.a.string().required("Phone number can't be blank").test('phoneNumber','Phone number must be at least 7 digits',function(value){return value&&value.replace(/\D/g,'').length>=7;}),consent:__WEBPACK_IMPORTED_MODULE_7_yup___default.a.boolean().test('is-accepted','You must agree to the Terms and Conditions',function(value){return value;})});var AlertContainer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1uf04jg0',label:'AlertContainer'})('min-height:',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["V" /* spacer */])(10),';margin-bottom:',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["V" /* spacer */])(4),';',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["T" /* mediaUp */])('lg'),'{margin-left:-',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["V" /* spacer */])(8),';margin-right:-',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["V" /* spacer */])(8),';}');var _ref={name:'1148twk-GreyedFormGroup',styles:'opacity:0.5;filter:grayscale(100%);;label:GreyedFormGroup;'};var GreyedFormGroup=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Group,{target:'e1uf04jg1',label:'GreyedFormGroup'})(function(_ref2){var consentAccepted=_ref2.consentAccepted,matchedSsoProvider=_ref2.matchedSsoProvider;return consentAccepted&&matchedSsoProvider&&_ref;},';');var StyledGrid=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_stylist__["q" /* Grid */],{target:'e1uf04jg2',label:'StyledGrid'})({name:'10klw3m',styles:'height:100%;'});var SmallSecondaryLink=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_stylist__["H" /* SecondaryLink */],{target:'e1uf04jg3',label:'SmallSecondaryLink'})(Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["X" /* typography */])('body1Medium'),';');var Disclaimer=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1uf04jg4',label:'Disclaimer'})('margin-top:',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["V" /* spacer */])(5),';');var FinePrint=Object(__WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */])('div',{target:'e1uf04jg5',label:'FinePrint'})('color:',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["O" /* color */])('slate'),';margin-top:',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["V" /* spacer */])(3),';',Object(__WEBPACK_IMPORTED_MODULE_11_stylist__["X" /* typography */])('body1Medium'),';');var RouteSignUpIndex=function RouteSignUpIndex(_ref3){var path=_ref3.match.path,query=_ref3.query,setCookieAcceptance=_ref3.setCookieAcceptance,cookiesAccepted=_ref3.cookiesAccepted;var platform=Object(__WEBPACK_IMPORTED_MODULE_15_config_platforms__["b" /* findPlatform */])(query.get('client_id'))||{};var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),matchedSsoProvider=_useState2[0],setMatchedSsoProvider=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),redirectToSsoProvider=_useState4[0],setRedirectToSsoProvider=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),consentAccepted=_useState6[0],setConsentAccepted=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),redirectToConfirmationUri=_useState8[0],setRedirectToConfirmationUri=_useState8[1];var mounted=true;Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){return function(){mounted=false;};},[]);var getAndSetMatchedSsoProvider=function getAndSetMatchedSsoProvider(value){return Object(__WEBPACK_IMPORTED_MODULE_17_utils_sso__["a" /* getSSOForEmailInput */])(value,function(match){return mounted&&setMatchedSsoProvider(match);});};var setMatchedSsoProviderIfSSOEnabled=function setMatchedSsoProviderIfSSOEnabled(value){if(platform.ssoSignUp){getAndSetMatchedSsoProvider(value);}};if(matchedSsoProvider&&redirectToSsoProvider&&consentAccepted){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Location__["a" /* default */],{to:Object(__WEBPACK_IMPORTED_MODULE_16_utils_urlForProvider__["a" /* default */])(matchedSsoProvider.id),replace:true});}if(redirectToConfirmationUri){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Location__["a" /* default */],{to:platform.confirmationUri||'/login/confirmation',replace:true});}return query.get('client_id')&&query.get('hostname')?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Mutation"],{context:{decamelizeVariables:false},mutation:__WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject)},function(signUp){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledGrid,{gridTemplateRows:'auto',justifyContent:'center',alignContent:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */],{initialValues:{consent:false,email:'',firstName:'',lastName:'',phoneNumber:''},validationSchema:schema,onSubmit:function onSubmit(_ref4){var consent=_ref4.consent,attributes=_objectWithoutProperties(_ref4,['consent']);return signUp({variables:{input:Object.assign({},attributes,{hostname:query.get('hostname'),redirectUri:query.get('redirect_uri')})}}).then(function(){setRedirectToConfirmationUri(true);}).catch(function(e){return Promise.reject(Object(__WEBPACK_IMPORTED_MODULE_14_utils_serializeErrorMessages__["a" /* default */])(e));});}},matchedSsoProvider&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AlertContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["a" /* Alert */],{kind:'info',message:consentAccepted?'You will be redirected to '+matchedSsoProvider.name+' for authentication':'Please accept privacy policy and terms and conditions to be redirected to '+matchedSsoProvider.name+' for authentication'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Errors,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Label,{htmlFor:'email'},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Input,{id:'email',type:'email',name:'email',onChange:function onChange(e){return setMatchedSsoProviderIfSSOEnabled(e.target.value);},onBlur:function onBlur(){return setRedirectToSsoProvider(Boolean(matchedSsoProvider));}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GreyedFormGroup,{matchedSsoProvider:matchedSsoProvider,consentAccepted:consentAccepted},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Label,{htmlFor:'firstName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Input,{id:'firstName',type:'text',name:'firstName'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GreyedFormGroup,{matchedSsoProvider:matchedSsoProvider,consentAccepted:consentAccepted},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Label,{htmlFor:'lastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Input,{id:'lastName',type:'text',name:'lastName'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GreyedFormGroup,{matchedSsoProvider:matchedSsoProvider,consentAccepted:consentAccepted},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Label,{htmlFor:'phoneNumber'},'Phone Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Input,{id:'phoneNumber',type:'tel',name:'phoneNumber',formatValue:function formatValue(value){return value.replace(/(^\+?(?:[\d()\- ]+)?)(.*)/,'$1');}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Input,{type:'checkbox',name:'consent',label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,'By signing up, you agree to our',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SmallSecondaryLink,{external:true,target:'_blank',href:'https://legal.forsta.com/legal/privacy-notice/'},'Privacy Policy'),' ','and our',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SmallSecondaryLink,{external:true,target:'_blank',href:'https://legal.forsta.com/legal/tos/'},'Terms and Conditions')),onChange:function onChange(e){setConsentAccepted(e.target.checked);setCookieAcceptance(e.target.checked);},checked:consentAccepted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Group,{buttons:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].SubmitButton,{block:true,kind:'primary'},'Sign Up')),platform.ssoSignUp&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["o" /* Form */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_SSOProviderButtons__["a" /* default */],{cookiesAccepted:cookiesAccepted,isSignUp:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Disclaimer,null,'Already have an account?',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_stylist__["H" /* SecondaryLink */],{to:'/login'+window.location.search},'Sign in')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FinePrint,null,'We collect this information to send you free content, offers, and product updates. Visit our recently updated',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SmallSecondaryLink,{external:true,target:'_blank',href:'https://legal.forsta.com/legal/privacy-notice/'},'Privacy Policy'),' ','for details on how we protect and manage your submitted data.'));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Redirect */],{to:'/'});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_5_components_withCookieAcceptance__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4_components_withQueryParams__["a" /* default */])(RouteSignUpIndex));

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__(1151);

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc);
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;

module.exports = gql;


/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["parseValue"] = parseValue;
/* harmony export (immutable) */ __webpack_exports__["parseType"] = parseType;
/* harmony export (immutable) */ __webpack_exports__["parseConstValue"] = parseConstValue;
/* harmony export (immutable) */ __webpack_exports__["parseTypeReference"] = parseTypeReference;
/* harmony export (immutable) */ __webpack_exports__["parseNamedType"] = parseNamedType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__source__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lexer__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kinds__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directiveLocation__ = __webpack_require__(1159);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */










/**
 * Configuration options to control parser behavior
 */


/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  if (!(sourceObj instanceof __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */])) {
    throw new TypeError('Must provide Source. Received: ' + String(sourceObj));
  }
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  return parseDocument(lexer);
}

/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */
function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return value;
}

/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */
function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return type;
}

/**
 * Converts a name lex token into a name parse node.
 */
function parseName(lexer) {
  var token = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
}

// Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */
function parseDocument(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var definitions = [];
  do {
    definitions.push(parseDefinition(lexer));
  } while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF));

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DOCUMENT,
    definitions: definitions,
    loc: loc(lexer, start)
  };
}

/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 */
function parseDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);
      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'extend':
      case 'directive':
        // Note: The schema definition language is an experimental addition.
        return parseTypeSystemDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    // Note: The schema definition language is an experimental addition.
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}

/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */
function parseExecutableDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
}

// Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */
function parseOperationDefinition(lexer) {
  var start = lexer.token;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  var operation = parseOperationType(lexer);
  var name = void 0;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    name = parseName(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * OperationType : one of query mutation subscription
 */
function parseOperationType(lexer) {
  var operationToken = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  switch (operationToken.value) {
    case 'query':
      return 'query';
    case 'mutation':
      return 'mutation';
    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}

/**
 * VariableDefinitions : ( VariableDefinition+ )
 */
function parseVariableDefinitions(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseVariableDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * VariableDefinition : Variable : Type DefaultValue?
 */
function parseVariableDefinition(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Variable : $ Name
 */
function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * SelectionSet : { Selection+ }
 */
function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SELECTION_SET,
    selections: many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseSelection, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R),
    loc: loc(lexer, start)
  };
}

/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */
function parseSelection(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD) ? parseFragment(lexer) : parseField(lexer);
}

/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */
function parseField(lexer) {
  var start = lexer.token;

  var nameOrAlias = parseName(lexer);
  var alias = void 0;
  var name = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */
function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * Argument[Const] : Name : Value[?Const]
 */
function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */
function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD);
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) && lexer.token.value !== 'on') {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }
  var typeCondition = void 0;
  if (lexer.token.value === 'on') {
    lexer.advance();
    typeCondition = parseNamedType(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INLINE_FRAGMENT,
    typeCondition: typeCondition,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */
function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment');
  // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentName : Name but not `on`
 */
function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }
  return parseName(lexer);
}

// Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */
function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;
  switch (token.kind) {
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L:
      return parseList(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L:
      return parseObject(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].INT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].FLOAT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING:
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING:
      return parseStringLiteral(lexer);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NULL,
          loc: loc(lexer, token)
        };
      }
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }
      break;
  }
  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].STRING,
    value: token.value,
    block: token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}

/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */
function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST,
    values: any(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R),
    loc: loc(lexer, start)
  };
}

/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */
function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L);
  var fields = [];
  while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectField[Const] : Name : Value[?Const]
 */
function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */
function parseDirectives(lexer, isConst) {
  var directives = [];
  while (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT)) {
    directives.push(parseDirective(lexer, isConst));
  }
  return directives;
}

/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */
function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */
function parseTypeReference(lexer) {
  var start = lexer.token;
  var type = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R);
    type = {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BANG)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }
  return type;
}

/**
 * NamedType : Name
 */
function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - TypeExtension
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */
function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);
      case 'scalar':
        return parseScalarTypeDefinition(lexer);
      case 'type':
        return parseObjectTypeDefinition(lexer);
      case 'interface':
        return parseInterfaceTypeDefinition(lexer);
      case 'union':
        return parseUnionTypeDefinition(lexer);
      case 'enum':
        return parseEnumTypeDefinition(lexer);
      case 'input':
        return parseInputObjectTypeDefinition(lexer);
      case 'extend':
        return parseTypeExtension(lexer);
      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING) || peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING);
}

/**
 * Description : StringValue
 */
function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}

/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */
function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseOperationTypeDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}

/**
 * OperationTypeDefinition : OperationType : NamedType
 */
function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseNamedType(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}

/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */
function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */
function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */
function parseImplementsInterfaces(lexer) {
  var types = [];
  if (lexer.token.value === 'implements') {
    lexer.advance();
    // Optional leading ampersand
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP) ||
    // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME));
  }
  return types;
}

/**
 * FieldsDefinition : { FieldDefinition+ }
 */
function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) && lexer.lookahead().kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseFieldDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */
function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */
function parseArgumentDefs(lexer) {
  if (!peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L)) {
    return [];
  }
  return many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R);
}

/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */
function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var defaultValue = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */
function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */
function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */
function parseUnionMemberTypes(lexer) {
  var types = [];
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    // Optional leading pipe
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  }
  return types;
}

/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */
function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */
function parseEnumValuesDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseEnumValueDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */
function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */
function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */
function parseInputFieldsDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */
function parseTypeExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'scalar':
        return parseScalarTypeExtension(lexer);
      case 'type':
        return parseObjectTypeExtension(lexer);
      case 'interface':
        return parseInterfaceTypeExtension(lexer);
      case 'union':
        return parseUnionTypeExtension(lexer);
      case 'enum':
        return parseEnumTypeExtension(lexer);
      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */
function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  if (directives.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */
function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */
function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */
function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */
function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */
function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */
function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */
function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
  var locations = [];
  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  return locations;
}

/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */
function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);
  if (__WEBPACK_IMPORTED_MODULE_4__directiveLocation__["a" /* DirectiveLocation */].hasOwnProperty(name.value)) {
    return name;
  }
  throw unexpected(lexer, start);
}

// Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */
function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
}

// Print a simplified form when appearing in JSON/util.inspect.
Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
  return { start: this.start, end: this.end };
};

/**
 * Determines if the next token is of a given kind
 */
function peek(lexer, kind) {
  return lexer.token.kind === kind;
}

/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */
function skip(lexer, kind) {
  var match = lexer.token.kind === kind;
  if (match) {
    lexer.advance();
  }
  return match;
}

/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */
function expect(lexer, kind) {
  var token = lexer.token;
  if (token.kind === kind) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Expected ' + kind + ', found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */
function expectKeyword(lexer, value) {
  var token = lexer.token;
  if (token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME && token.value === value) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Expected "' + value + '", found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */
function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Unexpected ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(438);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  _classCallCheck(this, Source);

  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || { line: 1, column: 1 };
  !(this.locationOffset.line > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
};

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = syntaxError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(273);



/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function syntaxError(source, position, description) {
  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */]('Syntax Error: ' + description, undefined, source, [position]);
}

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(273);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  // $FlowFixMe(>=0.68.0)
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */](originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(438);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Received null or undefined error.') : void 0;
  return _extends({}, error.extensions, {
    message: error.message || 'An unknown error occurred.',
    locations: error.locations,
    path: error.path
  });
}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createLexer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenKind; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getTokenDesc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockStringValue__ = __webpack_require__(1157);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;
  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }
  return token;
}

/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});

/**
 * The enum type representing the token kinds values.
 */


/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? token.kind + ' "' + value + '"' : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;

/**
 * Helper function for constructing the Token object.
 */
function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
}

// Print a simplified form when appearing in JSON/util.inspect.
Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
};

function printCharCode(code) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
  );
}

/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */
function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;

  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos);

  // SourceCharacter
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, pos, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
  }

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #
    case 35:
      return readComment(source, pos, line, col, prev);
    // $
    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &
    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (
    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )
    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .
    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }
      break;
    // :
    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =
    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @
    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [
    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]
    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {
    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |
    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }
    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z
    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9
    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "
    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev);
      }
      return readString(source, pos, line, col, prev);
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, pos, unexpectedCharacterMessage(code));
}

/**
 * Report a message that an unexpected character was encountered.
 */
function unexpectedCharacterMessage(code) {
  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
}

/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */
function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;
  while (position < bodyLength) {
    var code = charCodeAt.call(body, position);
    // tab | space | comma | BOM
    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }
      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }
  return position;
}

/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */
function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code = void 0;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && (
  // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}

/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */
function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);
    if (code >= 48 && code <= 57) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }
    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}

/**
 * Returns the new position in the source after reading digits.
 */
function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;
  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9
    return position;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
}

/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */
function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
  // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    ++position;
    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);
      switch (code) {
        case 34:
          value += '"';
          break;
        case 47:
          value += '/';
          break;
        case 92:
          value += '\\';
          break;
        case 98:
          value += '\b';
          break;
        case 102:
          value += '\f';
          break;
        case 110:
          value += '\n';
          break;
        case 114:
          value += '\r';
          break;
        case 116:
          value += '\t';
          break;
        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
          if (charCode < 0) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
          }
          value += String.fromCharCode(charCode);
          position += 4;
          break;
        default:
          throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
      }
      ++position;
      chunkStart = position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */
function readBlockString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, Object(__WEBPACK_IMPORTED_MODULE_1__blockStringValue__["a" /* default */])(rawValue));
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    // Escape Triple-Quote (\""")
    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */
function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}

/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */
function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}

/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */
function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;
  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }
  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blockStringValue;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g);

  // Remove common indentation from all lines but first.
  var commonIndent = null;
  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);
    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;
      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  }

  // Remove leading and trailing blank lines.
  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }
  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  }

  // Return a string of the lines joined with U+000A.
  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;
  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }
  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Kind; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',

  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  VARIABLE: 'Variable',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',

  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',

  // Values
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',

  // Directives
  DIRECTIVE: 'Directive',

  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',

  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',

  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',

  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension',

  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition'
});

/**
 * The enum type representing the possible kind values of AST nodes.
 */

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectiveLocation; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});

/**
 * The enum type representing the directive location values.
 */

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrentUser__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylist__ = __webpack_require__(2);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var RouteIfAdmin=function RouteIfAdmin(_ref){var Component=_ref.component,failRedirect=_ref.failRedirect,rest=_objectWithoutProperties(_ref,['component','failRedirect']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],Object.assign({},rest,{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CurrentUser__["a" /* default */],{render:function render(_ref2){var loading=_ref2.loading,viewer=_ref2.viewer;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_stylist__["x" /* Loader */],{size:'lg',centered:true});}else if(viewer&&viewer.is_admin){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:failRedirect});}});}}));};/* harmony default export */ __webpack_exports__["a"] = (RouteIfAdmin);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withCookieAcceptance__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config_analytics__ = __webpack_require__(1162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleAnalytics=function(_Component){_inherits(GoogleAnalytics,_Component);function GoogleAnalytics(){_classCallCheck(this,GoogleAnalytics);return _possibleConstructorReturn(this,(GoogleAnalytics.__proto__||Object.getPrototypeOf(GoogleAnalytics)).apply(this,arguments));}_createClass(GoogleAnalytics,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,pathname=_props.location.pathname,cookiesAccepted=_props.cookiesAccepted;if(cookiesAccepted){Object(__WEBPACK_IMPORTED_MODULE_3_config_analytics__["a" /* default */])();this.trackPage(pathname);}}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var location=_ref.location,oldAccepted=_ref.cookiesAccepted;var _props2=this.props,newPage=_props2.location.pathname,newAccepted=_props2.cookiesAccepted;var oldPage=location.pathname;if(newAccepted&&newAccepted!==oldAccepted){Object(__WEBPACK_IMPORTED_MODULE_3_config_analytics__["a" /* default */])();}if(newAccepted&&(oldPage!==newPage||newAccepted!==oldAccepted)){this.trackPage(newPage);}}},{key:'trackPage',value:function trackPage(page){__WEBPACK_IMPORTED_MODULE_1_react_ga___default.a.set({page:page});__WEBPACK_IMPORTED_MODULE_1_react_ga___default.a.pageview(page);}},{key:'render',value:function render(){return null;}}]);return GoogleAnalytics;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_withCookieAcceptance__["a" /* default */])(GoogleAnalytics));

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_ga__);
/* harmony default export */ __webpack_exports__["a"] = (function(){__WEBPACK_IMPORTED_MODULE_0_react_ga___default.a.initialize('UA-97191132-1',{debug:false,trace:false,testMode:"production"==='test'});__WEBPACK_IMPORTED_MODULE_0_react_ga___default.a.ga('create','UA-97191132-10','auto',{name:'intervu'});if(false){ReactGA.ga('set','sendHitTask',null);}});

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Session__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_broadcast__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var CurrentUserQuery={kind:'Document',definitions:[{kind:'OperationDefinition',operation:'query',name:{kind:'Name',value:'currentUserQuery'},variableDefinitions:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'viewer'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'first_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'last_name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'email'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'is_admin'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'servers'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'edges'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'node'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'hostname'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'name'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'product'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'client_id'},arguments:[],directives:[]}]}}]}}]}}]}},{kind:'Field',name:{kind:'Name',value:'flags'},arguments:[],directives:[],selectionSet:{kind:'SelectionSet',selections:[{kind:'Field',name:{kind:'Name',value:'admin_plan_create'},arguments:[],directives:[]},{kind:'Field',name:{kind:'Name',value:'tier_upgrade'},arguments:[],directives:[]}]}}]}}]}}],loc:{start:0,end:310,source:{body:'query currentUserQuery {\n  viewer {\n    first_name\n    last_name\n    email\n    is_admin\n    servers {\n      edges {\n        node {\n          hostname\n          name\n          product {\n            client_id\n          }\n        }\n      }\n    }\n    flags {\n      admin_plan_create\n      tier_upgrade\n    }\n  }\n}\n',name:'GraphQL request',locationOffset:{line:1,column:1}}}};var CurrentUserProvider=function CurrentUserProvider(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Session__["a" /* default */],{render:function render(_ref2){var isAuthenticated=_ref2.isAuthenticated;return isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:CurrentUserQuery},function(_ref3){var loading=_ref3.loading,data=_ref3.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_broadcast__["a" /* Broadcast */],{channel:'currentUser',value:{loading:loading,viewer:!loading&&data&&Object.assign({userServers:function userServers(clientId){return data.viewer&&data.viewer.servers.edges.reduce(function(acc,_ref4){var server=_ref4.node;if(!clientId||server.product.client_id===clientId){return[].concat(_toConsumableArray(acc),[server]);}return acc;},[]);},isHostnameFoundInUserServers:function isHostnameFoundInUserServers(hostname){return data.viewer&&data.viewer.servers.edges.some(function(server){return server.node.hostname===hostname;});}},data.viewer)}},children);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_broadcast__["a" /* Broadcast */],{channel:'currentUser',value:{loading:false}},children);}});};/* harmony default export */ __webpack_exports__["a"] = (CurrentUserProvider);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NullComponent=function NullComponent(){return null;};/* harmony default export */ __webpack_exports__["a"] = (NullComponent);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname.includes('localhost')||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _universalCookie = __webpack_require__(274);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _universalCookie2.default;
module.exports = exports['default'];

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(1168);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(95);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__(1169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;


function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(443);

var _universalCookie = __webpack_require__(274);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookiesProvider = function (_Component) {
  _inherits(CookiesProvider, _Component);

  function CookiesProvider(props) {
    _classCallCheck(this, CookiesProvider);

    var _this = _possibleConstructorReturn(this, (CookiesProvider.__proto__ || Object.getPrototypeOf(CookiesProvider)).call(this, props));

    if (props.cookies) {
      _this.cookies = props.cookies;
    } else {
      _this.cookies = new _universalCookie2.default();
    }
    return _this;
  }

  _createClass(CookiesProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        cookies: this.cookies
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return CookiesProvider;
}(_react.Component);

CookiesProvider.propTypes = {
  children: _propTypes.node,
  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default)
};
CookiesProvider.childContextTypes = {
  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
};
exports.default = CookiesProvider;
module.exports = exports['default'];

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(135);
var invariant = __webpack_require__(327);
var ReactPropTypesSecret = __webpack_require__(1172);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withCookies;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(443);

var _universalCookie = __webpack_require__(274);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _hoistNonReactStatics = __webpack_require__(59);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function withCookies(Component) {
  function Wrapper(props, _ref) {
    var cookies = _ref.cookies;

    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return _react2.default.createElement(Component, _extends({}, remainingProps, {
      cookies: cookies,
      ref: wrappedComponentRef
    }));
  }

  Wrapper.displayName = 'withCookies(' + (Component.displayName || Component.name) + ')';
  Wrapper.WrappedComponent = Component;

  Wrapper.propTypes = {
    wrappedComponentRef: _propTypes.func
  };

  Wrapper.contextTypes = {
    cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
  };

  return (0, _hoistNonReactStatics2.default)(Wrapper, Component);
}
module.exports = exports['default'];

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_cookie__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CookieBanner__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Context__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constant__ = __webpack_require__(1176);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CookieAcceptance=function(_Component){_inherits(CookieAcceptance,_Component);function CookieAcceptance(props){_classCallCheck(this,CookieAcceptance);var _this=_possibleConstructorReturn(this,(CookieAcceptance.__proto__||Object.getPrototypeOf(CookieAcceptance)).call(this,props));_this.handleAccept=function(e){_this.setCookiesAccepted(true);e.preventDefault();};_this.setCookiesAccepted=function(value){if(value){_this.props.cookies.set('cookiesAccepted',value,{path:'/',maxAge:30*__WEBPACK_IMPORTED_MODULE_4_constant__["a" /* DAY_IN_SECONDS */],secure:true});}else{_this.resetCookies();}_this.setState({cookiesAccepted:value});};_this.highlightAcceptCookiesButton=function(){var acceptHightlighted=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;return _this.setState({acceptHightlighted:acceptHightlighted});};_this.state={cookiesAccepted:props.cookies.get('cookiesAccepted')==='true',acceptHightlighted:false};return _this;}_createClass(CookieAcceptance,[{key:'resetCookies',value:function resetCookies(){var cookies=this.props.cookies;Object.keys(cookies.getAll()).forEach(function(key){return cookies.remove(key);});}},{key:'render',value:function render(){var _state=this.state,cookiesAccepted=_state.cookiesAccepted,acceptHightlighted=_state.acceptHightlighted;var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Context__["b" /* Provider */],{value:{cookiesAccepted:cookiesAccepted,setCookieAcceptance:this.setCookiesAccepted,highlightAcceptCookiesButton:this.highlightAcceptCookiesButton}},!cookiesAccepted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CookieBanner__["a" /* default */],{onAccept:this.handleAccept,highlighted:acceptHightlighted}),children);}}]);return CookieAcceptance;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CookieAcceptance.Provider=__WEBPACK_IMPORTED_MODULE_3__Context__["b" /* Provider */];CookieAcceptance.Consumer=__WEBPACK_IMPORTED_MODULE_3__Context__["a" /* Consumer */];/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_cookie__["withCookies"])(CookieAcceptance));

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylist__ = __webpack_require__(2);
var CookieBanner=function CookieBanner(_ref){var onAccept=_ref.onAccept,highlighted=_ref.highlighted;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["h" /* CookieBanner */],{onAccept:onAccept,highlighted:highlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_stylist__["i" /* DefaultCookiePolicy */],null)));};/* harmony default export */ __webpack_exports__["a"] = (CookieBanner);

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAY_IN_SECONDS; });
var DAY_IN_SECONDS=24*60*60;

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylist__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(){return Object(__WEBPACK_IMPORTED_MODULE_0_stylist__["R" /* global */])();});

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_react__ = __webpack_require__(404);
__WEBPACK_IMPORTED_MODULE_0__sentry_react__["b" /* init */]({dsn:'https://25dc37e4288b4d63a065981d7444bbe6@sentry.io/300639',debug:"staging"==='development',beforeSend:function beforeSend(event){return  true?event:null;},environment:"staging"});

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

/*
 * A wrapper for the Zendesk snippet to allow us to use Zendesk for multiple
 * platforms from within the Unified Login app.
 */window.initZe=function(zendeskHost,description){/* Normalize widget placement regardless of Zendesk settings. */window.zESettings={webWidget:{position:{horizontal:'left',vertical:'bottom'},contactForm:{fields:[{id:'description',prefill:{'*':description}}]}}/* Zendesk-provided snippet *//* eslint-disable */};window.zEmbed||function(e,t){var n,o,d,i,s,a=[],r=document.createElement("iframe");window.zEmbed=function(){a.push(arguments);},window.zE=window.zE||window.zEmbed,r.src="javascript:false",r.title="",r.role="presentation",(r.frameElement||r).style.cssText="display: none",d=document.getElementsByTagName("script"),d=d[d.length-1],d.parentNode.insertBefore(r,d),i=r.contentWindow,s=i.document;try{o=s;}catch(e){n=document.domain,r.src='javascript:var d=document.open();d.domain="'+n+'";void(0);',o=s;}o.open()._l=function(){var e=this.createElement("script");n&&(this.domain=n),e.id="js-iframe-async",e.src="https://assets.zendesk.com/embeddable_framework/main.js",this.t=+new Date(),this.zendeskHost=zendeskHost,this.zEQueue=a,this.body.appendChild(e);},o.write('<body onload="document._l();">'),o.close();}();/* eslint-enable *//* Prevent the "Help" button from being visible after load */window.zE(function(){window.zE.hide();});};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.9f3cf418.js